
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea588"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea588"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("37w0r", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.23';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            var index = -1, length = path.length;
            if (!length) return true;
            var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
            while(++index < length){
                var key = path[index];
                // skip non-string keys (e.g., Symbols, numbers)
                if (typeof key !== 'string') continue;
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block "constructor.prototype" chains
                if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
                    // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
                    if (isRootPrimitive && index === 0) continue;
                    return false;
                }
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("aZ9ZN", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $7a7670de1aa0be68$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "normalizeExtensionPriority", () => $7a7670de1aa0be68$export$ba4241979983e013);
$parcel$export(module.exports, "extensions", () => $7a7670de1aa0be68$export$cc3e2d3244e01b7f);
"use strict";
var $7a7670de1aa0be68$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($7a7670de1aa0be68$export$4f037c6ec2da4eeb || {});
const $7a7670de1aa0be68$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $7a7670de1aa0be68$export$ba4241979983e013 = (ext, defaultPriority)=>$7a7670de1aa0be68$var$normalizeExtension(ext).priority ?? defaultPriority;
const $7a7670de1aa0be68$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */ remove (...extensions2) {
        extensions2.map($7a7670de1aa0be68$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */ add (...extensions2) {
        extensions2.map($7a7670de1aa0be68$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$7a7670de1aa0be68$export$ba4241979983e013(b.value, defaultPriority) - $7a7670de1aa0be68$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$7a7670de1aa0be68$export$ba4241979983e013(b, defaultPriority) - $7a7670de1aa0be68$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    },
    /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */ mixin (Target, ...sources) {
        for (const source of sources)Object.defineProperties(Target.prototype, Object.getOwnPropertyDescriptors(source));
    }
};

});

parcelRegister("2ruNw", function(module, exports) {
module.exports = import("aqvyU").then(()=>parcelRequire('5Lqzz'));

});

parcelRegister("d9Psw", function(module, exports) {
module.exports = import("futH6").then(()=>parcelRequire('2KJpr'));

});

parcelRegister("ib6XS", function(module, exports) {

var $aZ9ZN = parcelRequire("aZ9ZN");

var $28ThD = parcelRequire("28ThD");

var $4DqO3 = parcelRequire("4DqO3");

var $issq5 = parcelRequire("issq5");

var $hk1vi = parcelRequire("hk1vi");

var $egYi0 = parcelRequire("egYi0");

var $cVYNB = parcelRequire("cVYNB");

var $dvpBJ = parcelRequire("dvpBJ");
parcelRequire("hlucP");

"use strict";
(0, $aZ9ZN.extensions).add((0, $28ThD.AlphaMask), (0, $4DqO3.ColorMask), (0, $issq5.StencilMask), (0, $dvpBJ.VideoSource), (0, $cVYNB.ImageSource), (0, $egYi0.CanvasSource), (0, $hk1vi.BufferImageSource));

});
parcelRegister("28ThD", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $8c7e204210e2059c$export$3c32667be409917c);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $7ScuH = parcelRequire("7ScuH");

var $PVSNp = parcelRequire("PVSNp");

var $25uEm = parcelRequire("25uEm");
"use strict";
class $8c7e204210e2059c$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.inverse = false;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $7ScuH.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        if (!this.inverse) (0, $PVSNp.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $25uEm.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $7ScuH.Sprite);
    }
}
$8c7e204210e2059c$export$3c32667be409917c.extension = (0, $aZ9ZN.ExtensionType).MaskEffect;

});
parcelRegister("7ScuH", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $61b1dd515c502d31$export$3075603db8e6204c);

var $jZ66T = parcelRequire("jZ66T");

var $4iNSL = parcelRequire("4iNSL");

var $4ZJmt = parcelRequire("4ZJmt");

var $6LhOA = parcelRequire("6LhOA");

var $9FmI1 = parcelRequire("9FmI1");
"use strict";
class $61b1dd515c502d31$export$3075603db8e6204c extends (0, $9FmI1.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $4iNSL.Texture).EMPTY){
        if (options instanceof (0, $4iNSL.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $4iNSL.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "sprite";
        /** @internal */ this.batched = true;
        this._visualBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._anchor = new (0, $jZ66T.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $4iNSL.Texture)) return new $61b1dd515c502d31$export$3075603db8e6204c(source);
        return new $61b1dd515c502d31$export$3075603db8e6204c((0, $4iNSL.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $4iNSL.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */ get texture() {
        return this._texture;
    }
    /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */ get visualBounds() {
        (0, $4ZJmt.updateQuadBounds)(this._visualBounds, this._anchor, this._texture);
        return this._visualBounds;
    }
    /**
   * @deprecated
   * @ignore
   */ get sourceBounds() {
        (0, $6LhOA.deprecation)("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
        return this.visualBounds;
    }
    /** @private */ updateBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const bounds = this._bounds;
        const { width: width, height: height } = texture.orig;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._visualBounds = null;
        this._bounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("jZ66T", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $c15fc81da9eefc45$export$3755aaad3fd42e52);
"use strict";
class $c15fc81da9eefc45$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */ clone(observer) {
        return new $c15fc81da9eefc45$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
    }
    /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("4iNSL", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $7e6dfd0ba886df8f$export$5431306cf43de24a);

var $6AQ4q = parcelRequire("6AQ4q");

var $lHrjL = parcelRequire("lHrjL");

var $ar2Ly = parcelRequire("ar2Ly");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $cH88K = parcelRequire("cH88K");

var $hk1vi = parcelRequire("hk1vi");

var $gmQ4R = parcelRequire("gmQ4R");

var $eVE7u = parcelRequire("eVE7u");
"use strict";
class $7e6dfd0ba886df8f$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param {TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $1bMtF.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $ar2Ly.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $gmQ4R.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $eVE7u.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $lHrjL.groupD8).add(rotate, (0, $lHrjL.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            this._source.off("resize", this.update, this);
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$7e6dfd0ba886df8f$export$5431306cf43de24a.EMPTY = new $7e6dfd0ba886df8f$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $gmQ4R.TextureSource)({
        label: "EMPTY"
    })
});
$7e6dfd0ba886df8f$export$5431306cf43de24a.EMPTY.destroy = (0, $cH88K.NOOP);
$7e6dfd0ba886df8f$export$5431306cf43de24a.WHITE = new $7e6dfd0ba886df8f$export$5431306cf43de24a({
    source: new (0, $hk1vi.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$7e6dfd0ba886df8f$export$5431306cf43de24a.WHITE.destroy = (0, $cH88K.NOOP);

});
parcelRegister("6AQ4q", function(module, exports) {
'use strict';
var $4cce7efc07365608$var$has = Object.prototype.hasOwnProperty, $4cce7efc07365608$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4cce7efc07365608$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4cce7efc07365608$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4cce7efc07365608$var$Events().__proto__) $4cce7efc07365608$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4cce7efc07365608$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4cce7efc07365608$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4cce7efc07365608$var$EE(fn, context || emitter, once), evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4cce7efc07365608$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4cce7efc07365608$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4cce7efc07365608$var$EventEmitter() {
    this._events = new $4cce7efc07365608$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4cce7efc07365608$var$has.call(events, name)) names.push($4cce7efc07365608$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4cce7efc07365608$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4cce7efc07365608$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4cce7efc07365608$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4cce7efc07365608$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4cce7efc07365608$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
        if (this._events[evt]) $4cce7efc07365608$var$clearEvent(this, evt);
    } else {
        this._events = new $4cce7efc07365608$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4cce7efc07365608$var$EventEmitter.prototype.off = $4cce7efc07365608$var$EventEmitter.prototype.removeListener;
$4cce7efc07365608$var$EventEmitter.prototype.addListener = $4cce7efc07365608$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4cce7efc07365608$var$EventEmitter.prefixed = $4cce7efc07365608$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4cce7efc07365608$var$EventEmitter.EventEmitter = $4cce7efc07365608$var$EventEmitter;
module.exports = $4cce7efc07365608$var$EventEmitter;

});

parcelRegister("lHrjL", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $3d946edb238e0e7f$export$b7bb6a2a8d203102);

var $5xi4h = parcelRequire("5xi4h");
"use strict";
const $3d946edb238e0e7f$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $3d946edb238e0e7f$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $3d946edb238e0e7f$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $3d946edb238e0e7f$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $3d946edb238e0e7f$var$rotationCayley = [];
const $3d946edb238e0e7f$var$rotationMatrices = [];
const $3d946edb238e0e7f$var$signum = Math.sign;
function $3d946edb238e0e7f$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $3d946edb238e0e7f$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $3d946edb238e0e7f$var$signum($3d946edb238e0e7f$var$ux[i] * $3d946edb238e0e7f$var$ux[j] + $3d946edb238e0e7f$var$vx[i] * $3d946edb238e0e7f$var$uy[j]);
            const _uy = $3d946edb238e0e7f$var$signum($3d946edb238e0e7f$var$uy[i] * $3d946edb238e0e7f$var$ux[j] + $3d946edb238e0e7f$var$vy[i] * $3d946edb238e0e7f$var$uy[j]);
            const _vx = $3d946edb238e0e7f$var$signum($3d946edb238e0e7f$var$ux[i] * $3d946edb238e0e7f$var$vx[j] + $3d946edb238e0e7f$var$vx[i] * $3d946edb238e0e7f$var$vy[j]);
            const _vy = $3d946edb238e0e7f$var$signum($3d946edb238e0e7f$var$uy[i] * $3d946edb238e0e7f$var$vx[j] + $3d946edb238e0e7f$var$vy[i] * $3d946edb238e0e7f$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($3d946edb238e0e7f$var$ux[k] === _ux && $3d946edb238e0e7f$var$uy[k] === _uy && $3d946edb238e0e7f$var$vx[k] === _vx && $3d946edb238e0e7f$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $5xi4h.Matrix)();
        mat.set($3d946edb238e0e7f$var$ux[i], $3d946edb238e0e7f$var$uy[i], $3d946edb238e0e7f$var$vx[i], $3d946edb238e0e7f$var$vy[i], 0, 0);
        $3d946edb238e0e7f$var$rotationMatrices.push(mat);
    }
}
$3d946edb238e0e7f$var$init();
const $3d946edb238e0e7f$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$3d946edb238e0e7f$var$ux[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$3d946edb238e0e7f$var$uy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$3d946edb238e0e7f$var$vx[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$3d946edb238e0e7f$var$vy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$3d946edb238e0e7f$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$3d946edb238e0e7f$var$rotationCayley[rotationSecond][$3d946edb238e0e7f$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $3d946edb238e0e7f$export$b7bb6a2a8d203102.S;
            return $3d946edb238e0e7f$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $3d946edb238e0e7f$export$b7bb6a2a8d203102.E;
            return $3d946edb238e0e7f$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $3d946edb238e0e7f$export$b7bb6a2a8d203102.SE;
            return $3d946edb238e0e7f$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $3d946edb238e0e7f$export$b7bb6a2a8d203102.NE;
        return $3d946edb238e0e7f$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0, dw = 0, dh = 0)=>{
        const mat = $3d946edb238e0e7f$var$rotationMatrices[$3d946edb238e0e7f$export$b7bb6a2a8d203102.inv(rotation)];
        const a = mat.a;
        const b = mat.b;
        const c = mat.c;
        const d = mat.d;
        const finalTx = tx - Math.min(0, a * dw, c * dh, a * dw + c * dh);
        const finalTy = ty - Math.min(0, b * dw, d * dh, b * dw + d * dh);
        const a1 = matrix.a;
        const b1 = matrix.b;
        const c1 = matrix.c;
        const d1 = matrix.d;
        matrix.a = a * a1 + b * c1;
        matrix.b = a * b1 + b * d1;
        matrix.c = c * a1 + d * c1;
        matrix.d = c * b1 + d * d1;
        matrix.tx = finalTx * a1 + finalTy * c1 + matrix.tx;
        matrix.ty = finalTx * b1 + finalTy * d1 + matrix.ty;
    },
    /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */ transformRectCoords: (rect, sourceFrame, rotation, out)=>{
        const { x: x, y: y, width: width, height: height } = rect;
        const { x: frameX, y: frameY, width: frameWidth, height: frameHeight } = sourceFrame;
        if (rotation === $3d946edb238e0e7f$export$b7bb6a2a8d203102.E) {
            out.set(x + frameX, y + frameY, width, height);
            return out;
        } else if (rotation === $3d946edb238e0e7f$export$b7bb6a2a8d203102.S) return out.set(frameWidth - y - height + frameX, x + frameY, height, width);
        else if (rotation === $3d946edb238e0e7f$export$b7bb6a2a8d203102.W) return out.set(frameWidth - x - width + frameX, frameHeight - y - height + frameY, width, height);
        else if (rotation === $3d946edb238e0e7f$export$b7bb6a2a8d203102.N) return out.set(y + frameX, frameHeight - x - width + frameY, height, width);
        return out.set(x + frameX, y + frameY, width, height);
    }
};

});
parcelRegister("5xi4h", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $d9355af0aa45a75f$export$5b12bf1653c0dd85);

var $hEz4p = parcelRequire("hEz4p");

var $ds7Xo = parcelRequire("ds7Xo");
"use strict";
class $d9355af0aa45a75f$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /**
     * Array representation of the matrix.
     * Only populated when `toArray()` is called.
     * @default null
     * @see {@link Matrix.toArray} For filling this array
     */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $ds7Xo.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $ds7Xo.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $hEz4p.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $d9355af0aa45a75f$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */ static get IDENTITY() {
        return $d9355af0aa45a75f$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */ static get shared() {
        return $d9355af0aa45a75f$var$tempMatrix.identity();
    }
}
const $d9355af0aa45a75f$var$tempMatrix = new $d9355af0aa45a75f$export$5b12bf1653c0dd85();
const $d9355af0aa45a75f$var$identityMatrix = new $d9355af0aa45a75f$export$5b12bf1653c0dd85();

});
parcelRegister("hEz4p", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $c9ff4fcb691a153d$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $c9ff4fcb691a153d$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $c9ff4fcb691a153d$export$870617f62e3187f1);
"use strict";
const $c9ff4fcb691a153d$export$59ed0a0a5de1084b = Math.PI * 2;
const $c9ff4fcb691a153d$export$3f91627dc85c5d57 = 180 / Math.PI;
const $c9ff4fcb691a153d$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("ds7Xo", function(module, exports) {

$parcel$export(module.exports, "Point", () => $2cf13c4a08e25cfb$export$baf26146a414f24a);
"use strict";
class $2cf13c4a08e25cfb$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /**
     * Position of the point on the x axis
     * @example
     * ```ts
     * // Set x position
     * const point = new Point();
     * point.x = 100;
     *
     * // Use in calculations
     * const width = rightPoint.x - leftPoint.x;
     * ```
     */ this.x = 0;
        /**
     * Position of the point on the y axis
     * @example
     * ```ts
     * // Set y position
     * const point = new Point();
     * point.y = 200;
     *
     * // Use in calculations
     * const height = bottomPoint.y - topPoint.y;
     * ```
     */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */ clone() {
        return new $2cf13c4a08e25cfb$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */ static get shared() {
        $2cf13c4a08e25cfb$var$tempPoint.x = 0;
        $2cf13c4a08e25cfb$var$tempPoint.y = 0;
        return $2cf13c4a08e25cfb$var$tempPoint;
    }
}
const $2cf13c4a08e25cfb$var$tempPoint = new $2cf13c4a08e25cfb$export$baf26146a414f24a();

});



parcelRegister("ar2Ly", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $224920e13878dcc6$export$4617fb02663045ef);

var $ds7Xo = parcelRequire("ds7Xo");
"use strict";
const $224920e13878dcc6$var$tempPoints = [
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)()
];
class $224920e13878dcc6$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Rectangle(0, 0, 100, 100);
     * console.log(shape.type); // 'rectangle'
     *
     * // Use in type guards
     * if (shape.type === 'rectangle') {
     *     console.log(shape.width, shape.height);
     * }
     * ```
     * @readonly
     * @default 'rectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */ get left() {
        return this.x;
    }
    /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */ get right() {
        return this.x + this.width;
    }
    /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */ get top() {
        return this.y;
    }
    /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */ get bottom() {
        return this.y + this.height;
    }
    /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */ static get EMPTY() {
        return new $224920e13878dcc6$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $224920e13878dcc6$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const outerLeft = _x - strokeWidthOuter;
        const outerRight = _x + width + strokeWidthOuter;
        const outerTop = _y - strokeWidthOuter;
        const outerBottom = _y + height + strokeWidthOuter;
        const innerLeft = _x + strokeWidthInner;
        const innerRight = _x + width - strokeWidthInner;
        const innerTop = _y + strokeWidthInner;
        const innerBottom = _y + height - strokeWidthInner;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $224920e13878dcc6$var$tempPoints[0].set(other.left, other.top);
        const lb = $224920e13878dcc6$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $224920e13878dcc6$var$tempPoints[2].set(other.right, other.top);
        const rb = $224920e13878dcc6$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */ scale(x, y = x) {
        this.x *= x;
        this.y *= y;
        this.width *= x;
        this.height *= y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */ getBounds(out) {
        out || (out = new $224920e13878dcc6$export$4617fb02663045ef());
        out.copyFrom(this);
        return out;
    }
    /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */ containsRect(other) {
        if (this.width <= 0 || this.height <= 0) return false;
        const x1 = other.x;
        const y1 = other.y;
        const x2 = other.x + other.width;
        const y2 = other.y + other.height;
        return x1 >= this.x && x1 < this.x + this.width && y1 >= this.y && y1 < this.y + this.height && x2 >= this.x && x2 < this.x + this.width && y2 >= this.y && y2 < this.y + this.height;
    }
    /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */ set(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("1bMtF", function(module, exports) {

$parcel$export(module.exports, "uid", () => $06ee2e3bfa049ef6$export$e2a22331486dcca0);
$parcel$export(module.exports, "resetUids", () => $06ee2e3bfa049ef6$export$220409b686c277d0);
"use strict";
const $06ee2e3bfa049ef6$var$uidCache = {
    default: -1
};
function $06ee2e3bfa049ef6$export$e2a22331486dcca0(name = "default") {
    if ($06ee2e3bfa049ef6$var$uidCache[name] === void 0) $06ee2e3bfa049ef6$var$uidCache[name] = -1;
    return ++$06ee2e3bfa049ef6$var$uidCache[name];
}
function $06ee2e3bfa049ef6$export$220409b686c277d0() {
    for(const key in $06ee2e3bfa049ef6$var$uidCache)delete $06ee2e3bfa049ef6$var$uidCache[key];
}

});

parcelRegister("6LhOA", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $8254034e9c8148b2$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $8254034e9c8148b2$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $8254034e9c8148b2$export$afd31d834b512e89);
"use strict";
const $8254034e9c8148b2$var$warnings = /* @__PURE__ */ new Set();
const $8254034e9c8148b2$export$dc79da96439604f0 = "8.0.0";
const $8254034e9c8148b2$export$e88af00f5d3e8bcc = "8.3.4";
const $8254034e9c8148b2$var$deprecationState = {
    quiet: false,
    noColor: false
};
const $8254034e9c8148b2$export$afd31d834b512e89 = (version, message, ignoreDepth = 3)=>{
    if ($8254034e9c8148b2$var$deprecationState.quiet || $8254034e9c8148b2$var$warnings.has(message)) return;
    let stack = new Error().stack;
    const deprecationMessage = `${message}
Deprecated since v${version}`;
    const useGroup = typeof console.groupCollapsed === "function" && !$8254034e9c8148b2$var$deprecationState.noColor;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (useGroup) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", deprecationMessage);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
            console.warn(stack);
        }
    }
    $8254034e9c8148b2$var$warnings.add(message);
};
Object.defineProperties($8254034e9c8148b2$export$afd31d834b512e89, {
    quiet: {
        get: ()=>$8254034e9c8148b2$var$deprecationState.quiet,
        set: (value)=>{
            $8254034e9c8148b2$var$deprecationState.quiet = value;
        },
        enumerable: true,
        configurable: false
    },
    noColor: {
        get: ()=>$8254034e9c8148b2$var$deprecationState.noColor,
        set: (value)=>{
            $8254034e9c8148b2$var$deprecationState.noColor = value;
        },
        enumerable: true,
        configurable: false
    }
});

});

parcelRegister("cH88K", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $daf4dac16f21d14f$export$5702a91a6f42969f);
"use strict";
const $daf4dac16f21d14f$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("hk1vi", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $374e38f057b87526$export$1872462350fcb7cd);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
class $374e38f057b87526$export$1872462350fcb7cd extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$374e38f057b87526$export$1872462350fcb7cd.extension = (0, $aZ9ZN.ExtensionType).TextureSource;

});
parcelRegister("gmQ4R", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $812132ae4d383474$export$8498e6a2e655d3d8);

var $6AQ4q = parcelRequire("6AQ4q");

var $fSIhN = parcelRequire("fSIhN");

var $cebhF = parcelRequire("cebhF");

var $1bMtF = parcelRequire("1bMtF");

var $c8piJ = parcelRequire("c8piJ");
"use strict";
const $812132ae4d383474$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** unique id for this Texture source */ this.uid = (0, $1bMtF.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     * @internal
     */ this._resourceId = (0, $1bMtF.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @internal
     */ this.uploadMethodId = "unknown";
        /** @internal */ this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     */ this.sampleCount = 1;
        /**
     * The number of mip levels to generate for this texture.
     * this is overridden if autoGenerateMipmaps is true. it is read only!
     */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /** how this texture is viewed/sampled by shaders (WebGPU view dimension) */ this.viewDimension = "2d";
        /** how many array layers this texture has (WebGPU depthOrArrayLayers) */ this.arrayLayerCount = 1;
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.viewDimension = options.viewDimension ?? options.dimensions;
        this.arrayLayerCount = options.arrayLayerCount;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $c8piJ.TextureStyle)((0, $cebhF.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._style.maxAnisotropy = value;
    }
    get maxAnisotropy() {
        return this._style.maxAnisotropy;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $1bMtF.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy?.();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution || (resolution = this._resolution);
        width || (width = this.width);
        height || (height = this.height);
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $1bMtF.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $fSIhN.isPow2)(this.pixelWidth) && (0, $fSIhN.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $812132ae4d383474$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    viewDimension: "2d",
    arrayLayerCount: 1,
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $812132ae4d383474$export$8498e6a2e655d3d8 = $812132ae4d383474$var$_TextureSource;

});
parcelRegister("fSIhN", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $349a90928128c983$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $349a90928128c983$export$eb50b9c078eb6ae7);
$parcel$export(module.exports, "log2", () => $349a90928128c983$export$b9fae0bba9d9094d);
"use strict";
function $349a90928128c983$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $349a90928128c983$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $349a90928128c983$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("cebhF", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $f30ba121e2745e50$export$801feaffb936a09d);
"use strict";
function $f30ba121e2745e50$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("c8piJ", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $6aec408a476a0d20$export$1ce1d0c10d3de5d5);

var $6AQ4q = parcelRequire("6AQ4q");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $6aec408a476a0d20$var$idHash = /* @__PURE__ */ Object.create(null);
function $6aec408a476a0d20$var$createResourceIdFromString(value) {
    const id = $6aec408a476a0d20$var$idHash[value];
    if (id === void 0) $6aec408a476a0d20$var$idHash[value] = (0, $1bMtF.uid)("resource");
    return id;
}
const $6aec408a476a0d20$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        /** @internal */ this._resourceType = "textureSampler";
        /** @internal */ this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link TextureStyle#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link TextureStyle#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this._sharedResourceId = null;
        this.emit("change", this);
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $6aec408a476a0d20$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $6aec408a476a0d20$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $6aec408a476a0d20$export$1ce1d0c10d3de5d5 = $6aec408a476a0d20$var$_TextureStyle;

});



parcelRegister("eVE7u", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $696fb9690e4a9a67$export$dbea3135e9da48cb);

var $5xi4h = parcelRequire("5xi4h");
"use strict";
const $696fb9690e4a9a67$var$tempMat = new (0, $5xi4h.Matrix)();
class $696fb9690e4a9a67$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $5xi4h.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $696fb9690e4a9a67$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($696fb9690e4a9a67$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("4ZJmt", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $2f7bbfe529847614$export$558ce66aa5723f1d);
"use strict";
function $2f7bbfe529847614$export$558ce66aa5723f1d(bounds, anchor, texture) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});

parcelRegister("9FmI1", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $0a1667a8aad47232$export$19fb617b96998849);

var $esrbs = parcelRequire("esrbs");

var $2vcTO = parcelRequire("2vcTO");
"use strict";
class $0a1667a8aad47232$export$19fb617b96998849 extends (0, $2vcTO.Container) {
    constructor(options){
        super(options);
        /** @internal */ this.canBundle = true;
        /** @internal */ this.allowChildren = false;
        /** @internal */ this._roundPixels = 0;
        /** @internal */ this._lastUsed = -1;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        this._bounds = new (0, $esrbs.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
        this.autoGarbageCollect = options.autoGarbageCollect ?? true;
    }
    /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this.updateBounds();
        this._boundsDirty = false;
        return this._bounds;
    }
    /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    /** @private */ onViewUpdate() {
        this._didViewChangeTick++;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    /** Unloads the GPU data from the view. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
        this.onViewUpdate();
    }
    destroy(options) {
        this.unload();
        super.destroy(options);
        this._bounds = null;
    }
    /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */ collectRenderablesSimple(instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        renderPipes.blendMode.pushBlendMode(this, this.groupBlendMode, instructionSet);
        const rp = renderPipes;
        const pipe = rp[this.renderPipeId];
        if (pipe?.addRenderable) pipe.addRenderable(this, instructionSet);
        this.didViewUpdate = false;
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
        renderPipes.blendMode.popBlendMode(instructionSet);
    }
}

});
parcelRegister("esrbs", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $b2b7c83f24752788$export$c4e9d269599ab4b4);

var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
const $b2b7c83f24752788$var$defaultMatrix = new (0, $5xi4h.Matrix)();
class $b2b7c83f24752788$export$c4e9d269599ab4b4 {
    /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */ constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X coordinate of the bounds.
     * Represents the leftmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set left edge
     * bounds.minX = 100;
     * ```
     * @default Infinity
     */ this.minX = Infinity;
        /**
     * The minimum Y coordinate of the bounds.
     * Represents the topmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set top edge
     * bounds.minY = 100;
     * ```
     * @default Infinity
     */ this.minY = Infinity;
        /**
     * The maximum X coordinate of the bounds.
     * Represents the rightmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set right edge
     * bounds.maxX = 200;
     * // Get width
     * const width = bounds.maxX - bounds.minX;
     * ```
     * @default -Infinity
     */ this.maxX = -Infinity;
        /**
     * The maximum Y coordinate of the bounds.
     * Represents the bottommost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set bottom edge
     * bounds.maxY = 200;
     * // Get height
     * const height = bounds.maxY - bounds.minY;
     * ```
     * @default -Infinity
     */ this.maxY = -Infinity;
        /**
     * The transformation matrix applied to this bounds object.
     * Used when calculating bounds with transforms.
     * @example
     * ```ts
     * const bounds = new Bounds();
     *
     * // Apply translation matrix
     * bounds.matrix = new Matrix()
     *     .translate(100, 100);
     *
     * // Combine transformations
     * bounds.matrix = new Matrix()
     *     .translate(50, 50)
     *     .rotate(Math.PI / 4)
     *     .scale(2, 2);
     *
     * // Use in bounds calculations
     * bounds.addFrame(0, 0, 100, 100); // Uses current matrix
     * bounds.addFrame(0, 0, 100, 100, customMatrix); // Override matrix
     * ```
     * @advanced
     */ this.matrix = $b2b7c83f24752788$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $ar2Ly.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $b2b7c83f24752788$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */ clone() {
        return new $b2b7c83f24752788$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */ get left() {
        return this.minX;
    }
    /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */ get right() {
        return this.maxX;
    }
    /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */ get top() {
        return this.minY;
    }
    /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */ get bottom() {
        return this.maxY;
    }
    /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */ get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */ toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
    /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */ copyFrom(bounds) {
        this.minX = bounds.minX;
        this.minY = bounds.minY;
        this.maxX = bounds.maxX;
        this.maxY = bounds.maxY;
        return this;
    }
}

});

parcelRegister("2vcTO", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $d2446b0ac0453512$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $d2446b0ac0453512$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $d2446b0ac0453512$export$83db162b74637ea);
$parcel$export(module.exports, "UPDATE_TRANSFORM", () => $d2446b0ac0453512$export$8363b5079568fbee);
$parcel$export(module.exports, "Container", () => $d2446b0ac0453512$export$42a852a2b6b56249);

var $6AQ4q = parcelRequire("6AQ4q");

var $dKHyW = parcelRequire("dKHyW");

var $cunnl = parcelRequire("cunnl");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $hEz4p = parcelRequire("hEz4p");

var $jZ66T = parcelRequire("jZ66T");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $1RpxL = parcelRequire("1RpxL");

var $dokhj = parcelRequire("dokhj");

var $b68Xy = parcelRequire("b68Xy");

var $cSba6 = parcelRequire("cSba6");

var $iKlbs = parcelRequire("iKlbs");

var $R6gKP = parcelRequire("R6gKP");

var $6BXvq = parcelRequire("6BXvq");

var $7sEYV = parcelRequire("7sEYV");

var $3qOui = parcelRequire("3qOui");

var $lDlzV = parcelRequire("lDlzV");

var $cN0Qi = parcelRequire("cN0Qi");

var $1ylTw = parcelRequire("1ylTw");

var $5yHc8 = parcelRequire("5yHc8");

var $k0xIU = parcelRequire("k0xIU");

var $7lfy2 = parcelRequire("7lfy2");
"use strict";
const $d2446b0ac0453512$var$defaultSkew = new (0, $jZ66T.ObservablePoint)(null);
const $d2446b0ac0453512$var$defaultPivot = new (0, $jZ66T.ObservablePoint)(null);
const $d2446b0ac0453512$var$defaultScale = new (0, $jZ66T.ObservablePoint)(null, 1, 1);
const $d2446b0ac0453512$var$defaultOrigin = new (0, $jZ66T.ObservablePoint)(null);
const $d2446b0ac0453512$export$f8ede8d8bf091ab5 = 1;
const $d2446b0ac0453512$export$e4801e7edc7582f = 2;
const $d2446b0ac0453512$export$83db162b74637ea = 4;
const $d2446b0ac0453512$export$8363b5079568fbee = 8;
class $d2446b0ac0453512$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(options = {}){
        super();
        /**
     * unique id for this container
     * @internal
     */ this.uid = (0, $1bMtF.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container. Each child must be a Container or extend from it.
     *
     * The array is read-only, but its contents can be modified using Container methods.
     * @example
     * ```ts
     * // Access children
     * const firstChild = container.children[0];
     * const lastChild = container.children[container.children.length - 1];
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding children
     * @see {@link Container#removeChild} For removing children
     */ this.children = [];
        /**
     * The display object container that contains this display object.
     * This represents the parent-child relationship in the display tree.
     * @example
     * ```ts
     * // Basic parent access
     * const parent = sprite.parent;
     *
     * // Walk up the tree
     * let current = sprite;
     * while (current.parent) {
     *     console.log('Level up:', current.parent.constructor.name);
     *     current = current.parent;
     * }
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding to a parent
     * @see {@link Container#removeChild} For removing from parent
     */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        /**
     * The RenderLayer this container belongs to, if any.
     * If it belongs to a RenderLayer, it will be rendered from the RenderLayer's position in the scene.
     * @readonly
     * @advanced
     */ this.parentRenderLayer = null;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /** @internal */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * This matrix represents the local transformation without any parent influence.
     * @example
     * ```ts
     * // Basic transform access
     * const localMatrix = sprite.localTransform;
     * console.log(localMatrix.toString());
     * ```
     * @readonly
     * @see {@link Container#worldTransform} For global transform
     * @see {@link Container#groupTransform} For render group transform
     */ this.localTransform = new (0, $5xi4h.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     * @advanced
     */ this.relativeGroupTransform = new (0, $5xi4h.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     * @advanced
     */ this.groupTransform = this.relativeGroupTransform;
        /**
     * Whether this object has been destroyed. If true, the object should no longer be used.
     * After an object is destroyed, all of its functionality is disabled and references are removed.
     * @example
     * ```ts
     * // Cleanup with destroy
     * sprite.destroy();
     * console.log(sprite.destroyed); // true
     * ```
     * @default false
     * @see {@link Container#destroy} For destroying objects
     */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     */ this._position = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     */ this._scale = $d2446b0ac0453512$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     */ this._pivot = $d2446b0ac0453512$var$defaultPivot;
        /**
     * The origin point around which the container rotates and scales.
     * Unlike pivot, changing origin will not move the container's position.
     * @private
     */ this._origin = $d2446b0ac0453512$var$defaultOrigin;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     */ this._skew = $d2446b0ac0453512$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        /** @internal */ this.localColor = 16777215;
        /** @internal */ this.localAlpha = 1;
        /** @internal */ this.groupAlpha = 1;
        // A
        /** @internal */ this.groupColor = 16777215;
        // BGR
        /** @internal */ this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /** @internal */ this.localBlendMode = "inherit";
        /** @internal */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /** @internal */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $7lfy2.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */ static mixin(source) {
        (0, $6LhOA.deprecation)("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead.");
        (0, $aZ9ZN.extensions).mixin($d2446b0ac0453512$export$42a852a2b6b56249, source);
    }
    // = 'default';
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    /** @ignore */ get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */ addChild(...children) {
        if (!this.allowChildren) (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (renderGroup) renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            if (child.parentRenderLayer) child.parentRenderLayer.detach(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $dokhj.BigPool).get((0, $k0xIU.RenderGroup), this);
        this.groupTransform = (0, $5xi4h.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /**
   * This will disable the render group for this container.
   * @advanced
   */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $dokhj.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $5xi4h.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */ get angle() {
        return this.rotation * (0, $hEz4p.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $hEz4p.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $d2446b0ac0453512$var$defaultPivot) this._pivot = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $d2446b0ac0453512$var$defaultPivot) {
            this._pivot = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
            if (this._origin !== $d2446b0ac0453512$var$defaultOrigin) (0, $1RpxL.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */ get skew() {
        if (this._skew === $d2446b0ac0453512$var$defaultSkew) this._skew = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $d2446b0ac0453512$var$defaultSkew) this._skew = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $d2446b0ac0453512$var$defaultScale) this._scale = new (0, $jZ66T.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $d2446b0ac0453512$var$defaultScale) this._scale = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        if (typeof value === "string") value = parseFloat(value);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */ get origin() {
        if (this._origin === $d2446b0ac0453512$var$defaultOrigin) this._origin = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        return this._origin;
    }
    set origin(value) {
        if (this._origin === $d2446b0ac0453512$var$defaultOrigin) {
            this._origin = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
            if (this._pivot !== $d2446b0ac0453512$var$defaultPivot) (0, $1RpxL.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._origin.set(value) : this._origin.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        this.origin.set(typeof opts.originX === "number" ? opts.originX : this.origin.x, typeof opts.originY === "number" ? opts.originY : this.origin.y);
        return this;
    }
    /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const origin = this._origin;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        const ox = -origin._x;
        const oy = -origin._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c) + (ox * lt.a + oy * lt.c) - ox;
        lt.ty = position._y - (px * lt.b + py * lt.d) + (ox * lt.b + oy * lt.d) - oy;
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $d2446b0ac0453512$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $dKHyW.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $d2446b0ac0453512$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */ get tint() {
        return (0, $3qOui.bgr2rgb)(this.localColor);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $d2446b0ac0453512$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $d2446b0ac0453512$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $d2446b0ac0453512$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $d2446b0ac0453512$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /**
   * Whether or not the object should be rendered.
   * @advanced
   */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        let oldChildren;
        if (this.children.length) oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._origin = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren && oldChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
(0, $aZ9ZN.extensions).mixin($d2446b0ac0453512$export$42a852a2b6b56249, (0, $cSba6.childrenHelperMixin), (0, $7sEYV.getFastGlobalBoundsMixin), (0, $5yHc8.toLocalGlobalMixin), (0, $cN0Qi.onRenderMixin), (0, $lDlzV.measureMixin), (0, $R6gKP.effectsMixin), (0, $6BXvq.findMixin), (0, $1ylTw.sortMixin), (0, $cunnl.cullingMixin), (0, $b68Xy.cacheAsTextureMixin), (0, $3qOui.getGlobalMixin), (0, $iKlbs.collectRenderablesMixin));

});
parcelRegister("dKHyW", function(module, exports) {

$parcel$export(module.exports, "Color", () => $2ed51b8f5e8b2f0e$export$892596cec99bc70e);

var $jyvmC = parcelRequire("jyvmC");

var $flk9m = parcelRequire("flk9m");
"use strict";
(0, $jyvmC.extend)([
    (0, $flk9m.default)
]);
const $2ed51b8f5e8b2f0e$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */ get red() {
        return this._components[0];
    }
    /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */ get green() {
        return this._components[1];
    }
    /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */ get blue() {
        return this._components[2];
    }
    /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */ get alpha() {
        return this._components[3];
    }
    /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */ toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */ toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out || (out = this._arrayRgba);
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */ toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $jyvmC.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Static shared Color instance used for utility operations. This is a singleton color object
 * that can be reused to avoid creating unnecessary Color instances.
 * > [!IMPORTANT] You should be careful when using this shared instance, as it is mutable and can be
 * > changed by any code that uses it.
 * >
 * > It is best used for one-off color operations or temporary transformations.
 * > For persistent colors, create your own Color instance instead.
 * @example
 * ```ts
 * import { Color } from 'pixi.js';
 *
 * // Use shared instance for one-off color operations
 * Color.shared.setValue(0xff0000);
 * const redHex = Color.shared.toHex();     // "#ff0000"
 * const redRgb = Color.shared.toRgbArray(); // [1, 0, 0]
 *
 * // Temporary color transformations
 * const colorNumber = Color.shared
 *     .setValue('#ff0000')     // Set to red
 *     .setAlpha(0.5)          // Make semi-transparent
 *     .premultiply(0.8)       // Apply premultiplication
 *     .toNumber();            // Convert to number
 *
 * // Chain multiple operations
 * const result = Color.shared
 *     .setValue(someColor)
 *     .multiply(tintColor)
 *     .toPremultiplied(alpha);
 * ```
 * @remarks
 * - This is a shared instance - be careful about multiple code paths using it simultaneously
 * - Use for temporary color operations to avoid allocating new Color instances
 * - The value is preserved between operations, so reset if needed
 * - For persistent colors, create your own Color instance instead
 */ $2ed51b8f5e8b2f0e$var$_Color.shared = new $2ed51b8f5e8b2f0e$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $2ed51b8f5e8b2f0e$var$_Color._temp = new $2ed51b8f5e8b2f0e$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$2ed51b8f5e8b2f0e$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $2ed51b8f5e8b2f0e$export$892596cec99bc70e = $2ed51b8f5e8b2f0e$var$_Color;

});
parcelRegister("jyvmC", function(module, exports) {

$parcel$export(module.exports, "colord", () => $34b99b961acc9a90$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $34b99b961acc9a90$export$8b58be045bf06082);
var $34b99b961acc9a90$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $34b99b961acc9a90$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $34b99b961acc9a90$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $34b99b961acc9a90$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $34b99b961acc9a90$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $34b99b961acc9a90$var$a = function(r) {
    return {
        r: $34b99b961acc9a90$var$e(r.r, 0, 255),
        g: $34b99b961acc9a90$var$e(r.g, 0, 255),
        b: $34b99b961acc9a90$var$e(r.b, 0, 255),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$o = function(r) {
    return {
        r: $34b99b961acc9a90$var$n(r.r),
        g: $34b99b961acc9a90$var$n(r.g),
        b: $34b99b961acc9a90$var$n(r.b),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$i = /^#([0-9a-f]{3,8})$/i, $34b99b961acc9a90$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $34b99b961acc9a90$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $34b99b961acc9a90$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $34b99b961acc9a90$var$g = function(r) {
    return {
        h: $34b99b961acc9a90$var$u(r.h),
        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
        l: $34b99b961acc9a90$var$e(r.l, 0, 100),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$d = function(r) {
    return {
        h: $34b99b961acc9a90$var$n(r.h),
        s: $34b99b961acc9a90$var$n(r.s),
        l: $34b99b961acc9a90$var$n(r.l),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$f = function(r) {
    var t, n, e;
    return $34b99b961acc9a90$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $34b99b961acc9a90$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $34b99b961acc9a90$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $34b99b961acc9a90$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$y = {
    string: [
        [
            function(r) {
                var t = $34b99b961acc9a90$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $34b99b961acc9a90$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $34b99b961acc9a90$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $34b99b961acc9a90$var$v.exec(r) || $34b99b961acc9a90$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $34b99b961acc9a90$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $34b99b961acc9a90$var$l.exec(t) || $34b99b961acc9a90$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $34b99b961acc9a90$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($34b99b961acc9a90$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $34b99b961acc9a90$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $34b99b961acc9a90$var$t(n) && $34b99b961acc9a90$var$t(e) && $34b99b961acc9a90$var$t(u) ? $34b99b961acc9a90$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(e) || !$34b99b961acc9a90$var$t(u)) return null;
                var i = $34b99b961acc9a90$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $34b99b961acc9a90$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(a) || !$34b99b961acc9a90$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $34b99b961acc9a90$var$u(r.h),
                        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
                        v: $34b99b961acc9a90$var$e(r.v, 0, 100),
                        a: $34b99b961acc9a90$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $34b99b961acc9a90$var$b(h);
            },
            "hsv"
        ]
    ]
}, $34b99b961acc9a90$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $34b99b961acc9a90$var$x = function(r) {
    return "string" == typeof r ? $34b99b961acc9a90$var$N(r.trim(), $34b99b961acc9a90$var$y.string) : "object" == typeof r && null !== r ? $34b99b961acc9a90$var$N(r, $34b99b961acc9a90$var$y.object) : [
        null,
        void 0
    ];
}, $34b99b961acc9a90$export$f61ac8b6f1f46202 = function(r) {
    return $34b99b961acc9a90$var$x(r)[1];
}, $34b99b961acc9a90$var$M = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: $34b99b961acc9a90$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $34b99b961acc9a90$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $34b99b961acc9a90$var$$ = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $34b99b961acc9a90$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $34b99b961acc9a90$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $34b99b961acc9a90$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $34b99b961acc9a90$var$n($34b99b961acc9a90$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $34b99b961acc9a90$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $34b99b961acc9a90$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $34b99b961acc9a90$var$s($34b99b961acc9a90$var$n(255 * a)) : "", "#" + $34b99b961acc9a90$var$s(t) + $34b99b961acc9a90$var$s(e) + $34b99b961acc9a90$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $34b99b961acc9a90$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $34b99b961acc9a90$var$h(this.rgba), {
            h: $34b99b961acc9a90$var$n(r.h),
            s: $34b99b961acc9a90$var$n(r.s),
            v: $34b99b961acc9a90$var$n(r.v),
            a: $34b99b961acc9a90$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $34b99b961acc9a90$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $34b99b961acc9a90$var$c(this.rgba);
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $34b99b961acc9a90$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $34b99b961acc9a90$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $34b99b961acc9a90$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $34b99b961acc9a90$export$4d30ed660ff08d0 ? r : new $34b99b961acc9a90$export$4d30ed660ff08d0(r);
}, $34b99b961acc9a90$var$S = [], $34b99b961acc9a90$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $34b99b961acc9a90$var$S.indexOf(r) < 0 && (r($34b99b961acc9a90$export$4d30ed660ff08d0, $34b99b961acc9a90$var$y), $34b99b961acc9a90$var$S.push(r));
    });
}, $34b99b961acc9a90$export$4385e60b38654f68 = function() {
    return new $34b99b961acc9a90$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("flk9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d738a730be80407$export$2e2bcd8739ae039);
function $6d738a730be80407$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("cunnl", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $d9ff9c68b2d6ec07$export$dce76d4f0fd249ed);
"use strict";
const $d9ff9c68b2d6ec07$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("1RpxL", function(module, exports) {

$parcel$export(module.exports, "warn", () => $8f3a102a893be265$export$c106dd0671a0fc2d);
"use strict";
let $8f3a102a893be265$var$warnCount = 0;
const $8f3a102a893be265$var$maxWarnings = 500;
function $8f3a102a893be265$export$c106dd0671a0fc2d(...args) {
    if ($8f3a102a893be265$var$warnCount === $8f3a102a893be265$var$maxWarnings) return;
    $8f3a102a893be265$var$warnCount++;
    if ($8f3a102a893be265$var$warnCount === $8f3a102a893be265$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});

parcelRegister("dokhj", function(module, exports) {

$parcel$export(module.exports, "PoolGroupClass", () => $392936a22468889b$export$866836a21808b71c);
$parcel$export(module.exports, "BigPool", () => $392936a22468889b$export$8249372279066210);

var $fpmqC = parcelRequire("fpmqC");

var $jsdyy = parcelRequire("jsdyy");
"use strict";
class $392936a22468889b$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $jsdyy.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
    /** Clears all pools in the group. This will reset all pools and free their resources. */ clear() {
        this._poolsByClass.forEach((pool)=>pool.clear());
        this._poolsByClass.clear();
    }
}
const $392936a22468889b$export$8249372279066210 = new $392936a22468889b$export$866836a21808b71c();
(0, $fpmqC.GlobalResourceRegistry).register($392936a22468889b$export$8249372279066210);

});
parcelRegister("fpmqC", function(module, exports) {

$parcel$export(module.exports, "GlobalResourceRegistry", () => $90d54a10fcc50767$export$b2525f5e8e38902b);
"use strict";
const $90d54a10fcc50767$export$b2525f5e8e38902b = {
    /**
   * Set of registered pools and cleanable objects.
   * @private
   */ _registeredResources: /* @__PURE__ */ new Set(),
    /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */ register (pool) {
        this._registeredResources.add(pool);
    },
    /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */ unregister (pool) {
        this._registeredResources.delete(pool);
    },
    /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */ release () {
        this._registeredResources.forEach((pool)=>pool.clear());
    },
    /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */ get registeredCount () {
        return this._registeredResources.size;
    },
    /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */ isRegistered (pool) {
        return this._registeredResources.has(pool);
    },
    /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */ reset () {
        this._registeredResources.clear();
    }
};

});

parcelRegister("jsdyy", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $c1bbbbd7a70e359d$export$14963ee5c8637e11);
"use strict";
class $c1bbbbd7a70e359d$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else {
            item = new this._classType();
            this._count++;
        }
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool */ clear() {
        if (this._pool.length > 0 && this._pool[0].destroy) for(let i = 0; i < this._index; i++)this._pool[i].destroy();
        this._pool.length = 0;
        this._count = 0;
        this._index = 0;
    }
}

});


parcelRegister("b68Xy", function(module, exports) {

$parcel$export(module.exports, "cacheAsTextureMixin", () => $8e1e037e48c023e6$export$9660f593b1298e75);

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $8e1e037e48c023e6$export$9660f593b1298e75 = {
    get isCachedAsTexture () {
        return !!this.renderGroup?.isCachedAsTexture;
    },
    cacheAsTexture (val1) {
        if (typeof val1 === "boolean" && val1 === false) this.disableRenderGroup();
        else {
            this.enableRenderGroup();
            this.renderGroup.enableCacheAsTexture(val1 === true ? {} : val1);
        }
    },
    updateCacheTexture () {
        this.renderGroup?.updateCacheTexture();
    },
    get cacheAsBitmap () {
        return this.isCachedAsTexture;
    },
    set cacheAsBitmap (val){
        (0, $6LhOA.deprecation)("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
        this.cacheAsTexture(val);
    }
};

});

parcelRegister("cSba6", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $84c84ff19367e28f$export$64cca9f0c2df174a);

var $02QFP = parcelRequire("02QFP");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $84c84ff19367e28f$export$64cca9f0c2df174a = {
    allowChildren: true,
    removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $02QFP.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                const child = removed[i];
                child.parentRenderLayer?.detach(child);
                this.emit("childRemoved", child, this, i);
                removed[i].emit("removed", this);
            }
            if (removed.length > 0) this._didViewChangeTick++;
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    addChildAt (child, index) {
        if (!this.allowChildren) (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    removeFromParent () {
        this.parent?.removeChild(this);
    },
    reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    },
    replaceChild (oldChild, newChild) {
        oldChild.updateLocalTransform();
        this.addChildAt(newChild, this.getChildIndex(oldChild));
        newChild.setFromMatrix(oldChild.localTransform);
        newChild.updateLocalTransform();
        this.removeChild(oldChild);
    }
};

});
parcelRegister("02QFP", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $1870d17923d8106c$export$8d47c0e1ce445404);
"use strict";
function $1870d17923d8106c$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("iKlbs", function(module, exports) {

$parcel$export(module.exports, "collectRenderablesMixin", () => $7d672101230228fb$export$e50be97f8cd670d0);
"use strict";
const $7d672101230228fb$export$e50be97f8cd670d0 = {
    collectRenderables (instructionSet, renderer, currentLayer) {
        if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild) return;
        if (this.sortableChildren) this.sortChildren();
        if (this.isSimple) this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        else if (this.renderGroup) renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
        else this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    },
    collectRenderablesSimple (instructionSet, renderer, currentLayer) {
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    },
    collectRenderablesWithEffects (instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        for(let i = 0; i < this.effects.length; i++){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.push(effect, this, instructionSet);
        }
        this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        for(let i = this.effects.length - 1; i >= 0; i--){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.pop(effect, this, instructionSet);
        }
    }
};

});

parcelRegister("R6gKP", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $b9c444b489c7fd0e$export$eec5e288a9d02a7c);

var $jMFz3 = parcelRequire("jMFz3");

var $gzffs = parcelRequire("gzffs");
"use strict";
const $b9c444b489c7fd0e$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _maskOptions: {
        inverse: false
    },
    _filterEffect: null,
    effects: [],
    _markStructureAsChanged () {
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
    },
    addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $gzffs.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $gzffs.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    get mask () {
        return this._maskEffect?.mask;
    },
    setMask (options) {
        this._maskOptions = {
            ...this._maskOptions,
            ...options
        };
        if (options.mask) this.mask = options.mask;
        this._markStructureAsChanged();
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $jMFz3.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $jMFz3.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("jMFz3", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $5b273ebb6b934c1f$export$d66c06ffe23037ab);
"use strict";
class $5b273ebb6b934c1f$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("gzffs", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManagerClass", () => $9e4c78e9b7ffea99$export$3b0749bf144d4b29);
$parcel$export(module.exports, "MaskEffectManager", () => $9e4c78e9b7ffea99$export$1eb319167fe02d04);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $dokhj = parcelRequire("dokhj");
"use strict";
class $9e4c78e9b7ffea99$export$3b0749bf144d4b29 {
    constructor(){
        /** @private */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $dokhj.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $dokhj.BigPool).return(effect);
    }
}
const $9e4c78e9b7ffea99$export$1eb319167fe02d04 = new $9e4c78e9b7ffea99$export$3b0749bf144d4b29();
(0, $aZ9ZN.extensions).handleByList((0, $aZ9ZN.ExtensionType).MaskEffect, $9e4c78e9b7ffea99$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("6BXvq", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $06b405345b38a906$export$468b0762e1bfbd64);

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $06b405345b38a906$export$468b0762e1bfbd64 = {
    label: null,
    get name () {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("7sEYV", function(module, exports) {

$parcel$export(module.exports, "getFastGlobalBoundsMixin", () => $9a31c0ecd5f0cbe6$export$993f17c9646405e3);

var $5xi4h = parcelRequire("5xi4h");

var $esrbs = parcelRequire("esrbs");

var $gMrCM = parcelRequire("gMrCM");
"use strict";
const $9a31c0ecd5f0cbe6$var$tempMatrix = new (0, $5xi4h.Matrix)();
const $9a31c0ecd5f0cbe6$export$993f17c9646405e3 = {
    getFastGlobalBounds (factorRenderLayers, bounds) {
        bounds || (bounds = new (0, $esrbs.Bounds)());
        bounds.clear();
        this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        bounds.applyMatrix(renderGroup.worldTransform);
        return bounds;
    },
    _getGlobalBoundsRecursive (factorRenderLayers, bounds, currentLayer) {
        let localBounds = bounds;
        if (factorRenderLayers && this.parentRenderLayer && this.parentRenderLayer !== currentLayer) return;
        if (this.localDisplayStatus !== 7 || !this.measurable) return;
        const manageEffects = !!this.effects.length;
        if (this.renderGroup || manageEffects) localBounds = (0, $gMrCM.boundsPool).get().clear();
        if (this.boundsArea) bounds.addRect(this.boundsArea, this.worldTransform);
        else {
            if (this.renderPipeId) {
                const viewBounds = this.bounds;
                localBounds.addFrame(viewBounds.minX, viewBounds.minY, viewBounds.maxX, viewBounds.maxY, this.groupTransform);
            }
            const children = this.children;
            for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
        }
        if (manageEffects) {
            let advanced = false;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            for(let i = 0; i < this.effects.length; i++)if (this.effects[i].addBounds) {
                if (!advanced) {
                    advanced = true;
                    localBounds.applyMatrix(renderGroup.worldTransform);
                }
                this.effects[i].addBounds(localBounds, true);
            }
            if (advanced) localBounds.applyMatrix(renderGroup.worldTransform.copyTo($9a31c0ecd5f0cbe6$var$tempMatrix).invert());
            bounds.addBounds(localBounds);
            (0, $gMrCM.boundsPool).return(localBounds);
        } else if (this.renderGroup) {
            bounds.addBounds(localBounds, this.relativeGroupTransform);
            (0, $gMrCM.boundsPool).return(localBounds);
        }
    }
};

});
parcelRegister("gMrCM", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $0545fb7ca45b6e65$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $0545fb7ca45b6e65$export$9194656040c1dc42);

var $5xi4h = parcelRequire("5xi4h");

var $dokhj = parcelRequire("dokhj");

var $esrbs = parcelRequire("esrbs");
"use strict";
const $0545fb7ca45b6e65$export$3849005ba4dacf72 = (0, $dokhj.BigPool).getPool((0, $5xi4h.Matrix));
const $0545fb7ca45b6e65$export$9194656040c1dc42 = (0, $dokhj.BigPool).getPool((0, $esrbs.Bounds));

});


parcelRegister("3qOui", function(module, exports) {

$parcel$export(module.exports, "bgr2rgb", () => $312b768f2c419c47$export$110f9f26b10ddb4a);
$parcel$export(module.exports, "getGlobalMixin", () => $312b768f2c419c47$export$c7c22dc0c465d95a);

var $5xi4h = parcelRequire("5xi4h");

var $dJAmK = parcelRequire("dJAmK");

var $gMrCM = parcelRequire("gMrCM");

var $25Amh = parcelRequire("25Amh");
"use strict";
function $312b768f2c419c47$export$110f9f26b10ddb4a(color) {
    return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const $312b768f2c419c47$export$c7c22dc0c465d95a = {
    getGlobalAlpha (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return this.renderGroup.worldAlpha;
            if (this.parentRenderGroup) return this.parentRenderGroup.worldAlpha * this.alpha;
            return this.alpha;
        }
        let alpha = this.alpha;
        let current = this.parent;
        while(current){
            alpha *= current.alpha;
            current = current.parent;
        }
        return alpha;
    },
    getGlobalTransform (matrix = new (0, $5xi4h.Matrix)(), skipUpdate) {
        if (skipUpdate) return matrix.copyFrom(this.worldTransform);
        this.updateLocalTransform();
        const parentTransform = (0, $dJAmK.updateTransformBackwards)(this, (0, $gMrCM.matrixPool).get().identity());
        matrix.appendFrom(this.localTransform, parentTransform);
        (0, $gMrCM.matrixPool).return(parentTransform);
        return matrix;
    },
    getGlobalTint (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return $312b768f2c419c47$export$110f9f26b10ddb4a(this.renderGroup.worldColor);
            if (this.parentRenderGroup) return $312b768f2c419c47$export$110f9f26b10ddb4a((0, $25Amh.multiplyColors)(this.localColor, this.parentRenderGroup.worldColor));
            return this.tint;
        }
        let color = this.localColor;
        let parent = this.parent;
        while(parent){
            color = (0, $25Amh.multiplyColors)(color, parent.localColor);
            parent = parent.parent;
        }
        return $312b768f2c419c47$export$110f9f26b10ddb4a(color);
    }
};

});
parcelRegister("dJAmK", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $bc900c2b583648cc$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $bc900c2b583648cc$export$2022bc48a49dd6d2);

var $5xi4h = parcelRequire("5xi4h");

var $gMrCM = parcelRequire("gMrCM");
"use strict";
function $bc900c2b583648cc$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $gMrCM.matrixPool).get().identity();
            parentTransform = $bc900c2b583648cc$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $5xi4h.Matrix).IDENTITY;
    $bc900c2b583648cc$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $gMrCM.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $bc900c2b583648cc$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $gMrCM.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $gMrCM.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        const renderableBounds = target.bounds;
        if (renderableBounds && !renderableBounds.isEmpty()) {
            bounds.matrix = worldTransform;
            bounds.addBounds(renderableBounds);
        }
        for(let i = 0; i < target.children.length; i++)$bc900c2b583648cc$var$_getGlobalBounds(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $5xi4h.Matrix).IDENTITY);
        (0, $gMrCM.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $gMrCM.matrixPool).return(worldTransform);
}
function $bc900c2b583648cc$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $bc900c2b583648cc$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});

parcelRegister("25Amh", function(module, exports) {

$parcel$export(module.exports, "multiplyColors", () => $ff7d1b74d53d5779$export$a82a3ae2e3118160);

var $5nS5O = parcelRequire("5nS5O");
"use strict";
const $ff7d1b74d53d5779$var$WHITE_BGR = 16777215;
function $ff7d1b74d53d5779$export$a82a3ae2e3118160(localBGRColor, parentBGRColor) {
    if (localBGRColor === $ff7d1b74d53d5779$var$WHITE_BGR) return parentBGRColor;
    if (parentBGRColor === $ff7d1b74d53d5779$var$WHITE_BGR) return localBGRColor;
    return (0, $5nS5O.multiplyHexColors)(localBGRColor, parentBGRColor);
}

});
parcelRegister("5nS5O", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $65a349d3e4e54464$export$815d7ea0395de72c);
"use strict";
function $65a349d3e4e54464$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255 | 0;
    const g = g1 * g2 / 255 | 0;
    const b = b1 * b2 / 255 | 0;
    return (r << 16) + (g << 8) + b;
}

});



parcelRegister("lDlzV", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $d5b7c561cfce16ae$export$285e6e72e8e62f0);

var $5xi4h = parcelRequire("5xi4h");

var $esrbs = parcelRequire("esrbs");

var $dJAmK = parcelRequire("dJAmK");

var $7pBMy = parcelRequire("7pBMy");

var $6h57y = parcelRequire("6h57y");
"use strict";
const $d5b7c561cfce16ae$var$tempMatrix = new (0, $5xi4h.Matrix)();
const $d5b7c561cfce16ae$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $esrbs.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $6h57y.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $7pBMy.getLocalBounds)(this, localBoundsCacheData.localBounds, $d5b7c561cfce16ae$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    getBounds (skipUpdate, bounds) {
        return (0, $dJAmK.getGlobalBounds)(this, skipUpdate, bounds || new (0, $esrbs.Bounds)());
    }
};

});
parcelRegister("7pBMy", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $cdfb59a3511febfe$export$ffaf4f504c4c5c9c);

var $5xi4h = parcelRequire("5xi4h");

var $gMrCM = parcelRequire("gMrCM");
"use strict";
function $cdfb59a3511febfe$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $5xi4h.Matrix).IDENTITY);
    $cdfb59a3511febfe$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $cdfb59a3511febfe$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $gMrCM.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $gMrCM.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $gMrCM.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            bounds.addBounds(target.bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$cdfb59a3511febfe$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $5xi4h.Matrix).IDENTITY);
        (0, $gMrCM.boundsPool).return(bounds);
    }
    (0, $gMrCM.matrixPool).return(relativeTransform);
}

});

parcelRegister("6h57y", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $d142739f5ccd06f1$export$fd5aadbd3827bcf1);
"use strict";
function $d142739f5ccd06f1$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $d142739f5ccd06f1$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("cN0Qi", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $661deeb56e036b2a$export$2a5246d1114cb81d);
"use strict";
const $661deeb56e036b2a$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("1ylTw", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $b6d8d8b1afba7cb1$export$eb4acdd9f4781aed);
"use strict";
const $b6d8d8b1afba7cb1$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    sortDirty: false,
    sortableChildren: false,
    get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($b6d8d8b1afba7cb1$var$sortChildren);
    }
};
function $b6d8d8b1afba7cb1$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("5yHc8", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $704cf4eb15a83438$export$38fa7a987602e8dd);

var $ds7Xo = parcelRequire("ds7Xo");

var $gMrCM = parcelRequire("gMrCM");
"use strict";
const $704cf4eb15a83438$export$38fa7a987602e8dd = {
    getGlobalPosition (point = new (0, $ds7Xo.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    toGlobal (position, point, skipUpdate = false) {
        const globalMatrix = this.getGlobalTransform((0, $gMrCM.matrixPool).get(), skipUpdate);
        point = globalMatrix.apply(position, point);
        (0, $gMrCM.matrixPool).return(globalMatrix);
        return point;
    },
    toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        const globalMatrix = this.getGlobalTransform((0, $gMrCM.matrixPool).get(), skipUpdate);
        point = globalMatrix.applyInverse(position, point);
        (0, $gMrCM.matrixPool).return(globalMatrix);
        return point;
    }
};

});

parcelRegister("k0xIU", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $a6d9fb43e4e2725e$export$94d273f8d74f2a5);

var $5xi4h = parcelRequire("5xi4h");

var $1oPFv = parcelRequire("1oPFv");

var $5NyEC = parcelRequire("5NyEC");
"use strict";
class $a6d9fb43e4e2725e$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $5xi4h.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        this.gcTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $1oPFv.InstructionSet)();
        this._onRenderContainers = [];
        /**
     * Indicates if the cached texture needs to be updated.
     * @default true
     */ this.textureNeedsUpdate = true;
        /**
     * Indicates if the container should be cached as a texture.
     * @default false
     */ this.isCachedAsTexture = false;
        this._matrixDirty = 7;
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child._updateFlags = 15;
            this.addChild(child);
        }
    }
    enableCacheAsTexture(options = {}) {
        this.textureOptions = options;
        this.isCachedAsTexture = true;
        this.textureNeedsUpdate = true;
    }
    disableCacheAsTexture() {
        this.isCachedAsTexture = false;
        if (this.texture) {
            (0, $5NyEC.TexturePool).returnTexture(this.texture, true);
            this.texture = null;
        }
    }
    updateCacheTexture() {
        this.textureNeedsUpdate = true;
        const cachedParent = this._parentCacheAsTextureRenderGroup;
        if (cachedParent && !cachedParent.textureNeedsUpdate) cachedParent.updateCacheTexture();
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
        this.disableCacheAsTexture();
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    updateRenderable(renderable) {
        if (renderable.globalDisplayStatus < 7) return;
        this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
        renderable.didViewUpdate = false;
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender(renderer) {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender(renderer);
    }
    destroy() {
        this.disableCacheAsTexture();
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    invalidateMatrices() {
        this._matrixDirty = 7;
    }
    /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */ get inverseWorldTransform() {
        if ((this._matrixDirty & 1) === 0) return this._inverseWorldTransform;
        this._matrixDirty &= -2;
        this._inverseWorldTransform || (this._inverseWorldTransform = new (0, $5xi4h.Matrix)());
        return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
    }
    /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */ get textureOffsetInverseTransform() {
        if ((this._matrixDirty & 2) === 0) return this._textureOffsetInverseTransform;
        this._matrixDirty &= -3;
        this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new (0, $5xi4h.Matrix)());
        return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(-this._textureBounds.x, -this._textureBounds.y);
    }
    /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */ get inverseParentTextureTransform() {
        if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
        this._matrixDirty &= -5;
        const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
        if (parentCacheAsTexture) {
            this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new (0, $5xi4h.Matrix)());
            return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(-parentCacheAsTexture._textureBounds.x, -parentCacheAsTexture._textureBounds.y);
        }
        return this.worldTransform;
    }
    /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */ get cacheToLocalTransform() {
        if (this.isCachedAsTexture) return this.textureOffsetInverseTransform;
        if (!this._parentCacheAsTextureRenderGroup) return null;
        return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
    }
}

});
parcelRegister("1oPFv", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $ffc0201f419d20a4$export$2946bd01f10dd922);

var $1bMtF = parcelRequire("1bMtF");
"use strict";
class $ffc0201f419d20a4$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $1bMtF.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        /** used by the garbage collector to track when the instruction set was last used */ this.gcTick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Destroy the instruction set, clearing the instructions and renderables.
   * @internal
   */ destroy() {
        this.instructions.length = 0;
        this.renderables.length = 0;
        this.renderPipes = null;
        this.gcTick = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});

parcelRegister("5NyEC", function(module, exports) {

$parcel$export(module.exports, "TexturePoolClass", () => $4c0e47f8d7ab81ca$export$f5c6a2d8ed21d1d);
$parcel$export(module.exports, "TexturePool", () => $4c0e47f8d7ab81ca$export$686d8ddcd5ee6cd2);

var $fSIhN = parcelRequire("fSIhN");

var $fpmqC = parcelRequire("fpmqC");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");

var $c8piJ = parcelRequire("c8piJ");
"use strict";
let $4c0e47f8d7ab81ca$var$count = 0;
class $4c0e47f8d7ab81ca$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this.textureStyle = new (0, $c8piJ.TextureStyle)(this.textureOptions);
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */ createTexture(pixelWidth, pixelHeight, antialias) {
        const textureSource = new (0, $gmQ4R.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: false
        });
        return new (0, $4iNSL.Texture)({
            source: textureSource,
            label: `texturePool_${$4c0e47f8d7ab81ca$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $fSIhN.nextPow2)(po2Width);
        po2Height = (0, $fSIhN.nextPow2)(po2Height);
        const key = (po2Width << 17) + (po2Height << 1) + (antialias ? 1 : 0);
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Place a render texture back into the pool. Optionally reset the style of the texture to the default texture style.
   * useful if you modified the style of the texture after getting it from the pool.
   * @param renderTexture - The renderTexture to free
   * @param resetStyle - Whether to reset the style of the texture to the default texture style
   */ returnTexture(renderTexture, resetStyle = false) {
        const key = this._poolKeyHash[renderTexture.uid];
        if (resetStyle) renderTexture.source.style = this.textureStyle;
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $4c0e47f8d7ab81ca$export$686d8ddcd5ee6cd2 = new $4c0e47f8d7ab81ca$export$f5c6a2d8ed21d1d();
(0, $fpmqC.GlobalResourceRegistry).register($4c0e47f8d7ab81ca$export$686d8ddcd5ee6cd2);

});


parcelRegister("7lfy2", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $62406dc566b639c6$export$59d0441a278e5935);
"use strict";
function $62406dc566b639c6$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("PVSNp", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $e7b25a4b9ee98412$export$12af48852c6ac574);

var $esrbs = parcelRequire("esrbs");

var $dJAmK = parcelRequire("dJAmK");
"use strict";
const $e7b25a4b9ee98412$var$tempBounds = new (0, $esrbs.Bounds)();
function $e7b25a4b9ee98412$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $e7b25a4b9ee98412$var$tempBounds;
    mask.measurable = true;
    (0, $dJAmK.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("25uEm", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $7a841f3815e8a5d5$export$7416ac774b1f1a33);

var $7pBMy = parcelRequire("7pBMy");

var $gMrCM = parcelRequire("gMrCM");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
function $7a841f3815e8a5d5$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $gMrCM.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $gMrCM.matrixPool).get().identity();
    const relativeMask = $7a841f3815e8a5d5$var$getMatrixRelativeToParent(mask, localRoot, tempMatrix);
    (0, $7pBMy.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $gMrCM.matrixPool).return(tempMatrix);
    (0, $gMrCM.boundsPool).return(boundsToMask);
}
function $7a841f3815e8a5d5$var$getMatrixRelativeToParent(target, root, matrix) {
    if (!target) {
        (0, $1RpxL.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $7a841f3815e8a5d5$var$getMatrixRelativeToParent(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("4DqO3", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $b23b5567c87f842f$export$1e2a2c76374c2542);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $b23b5567c87f842f$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$b23b5567c87f842f$export$1e2a2c76374c2542.extension = (0, $aZ9ZN.ExtensionType).MaskEffect;

});

parcelRegister("issq5", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $a24eacee1201ac28$export$abd85894695764cb);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2vcTO = parcelRequire("2vcTO");

var $PVSNp = parcelRequire("PVSNp");

var $25uEm = parcelRequire("25uEm");
"use strict";
class $a24eacee1201ac28$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $PVSNp.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $25uEm.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $2vcTO.Container);
    }
}
$a24eacee1201ac28$export$abd85894695764cb.extension = (0, $aZ9ZN.ExtensionType).MaskEffect;

});

parcelRegister("egYi0", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $dc594dd768173b8f$export$ca65ccf5708c6a0c);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
class $dc594dd768173b8f$export$ca65ccf5708c6a0c extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $gLw46.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity && "style" in this.resource) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$dc594dd768173b8f$export$ca65ccf5708c6a0c.extension = (0, $aZ9ZN.ExtensionType).TextureSource;

});
parcelRegister("gLw46", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $cc1419da62e5e96a$export$d988306fa84f7b44);

var $6OcRC = parcelRequire("6OcRC");
"use strict";
let $cc1419da62e5e96a$var$currentAdapter = (0, $6OcRC.BrowserAdapter);
const $cc1419da62e5e96a$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $cc1419da62e5e96a$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $cc1419da62e5e96a$var$currentAdapter = adapter;
    }
};

});
parcelRegister("6OcRC", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $04a7024748b9235b$export$e467cc3399500025);
"use strict";
const $04a7024748b9235b$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    createImage: ()=>new Image(),
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("cVYNB", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $7996ad805d3bc684$export$280e9a68c3ffd919);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
class $7996ad805d3bc684$export$280e9a68c3ffd919 extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$7996ad805d3bc684$export$280e9a68c3ffd919.extension = (0, $aZ9ZN.ExtensionType).TextureSource;

});

parcelRegister("dvpBJ", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $07ba4d7f126f8e60$export$f3a17123d80000c5);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jM8Go = parcelRequire("jM8Go");

var $7X2qc = parcelRequire("7X2qc");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
const $07ba4d7f126f8e60$var$_VideoSource = class _VideoSource extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $jM8Go.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $7X2qc.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $jM8Go.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $jM8Go.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $jM8Go.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$07ba4d7f126f8e60$var$_VideoSource.extension = (0, $aZ9ZN.ExtensionType).TextureSource;
/** The default options for video sources. */ $07ba4d7f126f8e60$var$_VideoSource.defaultOptions = {
    ...(0, $gmQ4R.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $07ba4d7f126f8e60$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $07ba4d7f126f8e60$export$f3a17123d80000c5 = $07ba4d7f126f8e60$var$_VideoSource;

});
parcelRegister("jM8Go", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $039136b84aaa3e00$export$39c54bcc89dcee11);

var $2HyEq = parcelRequire("2HyEq");

var $92Lva = parcelRequire("92Lva");
"use strict";
const $039136b84aaa3e00$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method {@link Ticker#start|start}
     * automatically when a listener is added.
     * @example
     * ```ts
     * // Default behavior (manual start)
     * const ticker = new Ticker();
     * ticker.autoStart = false;
     * ticker.add(() => {
     *     // Won't run until ticker.start() is called
     * });
     *
     * // Auto-start behavior
     * const autoTicker = new Ticker();
     * autoTicker.autoStart = true;
     * autoTicker.add(() => {
     *     // Runs immediately when added
     * });
     * ```
     * @default false
     * @see {@link Ticker#start} For manually starting the ticker
     * @see {@link Ticker#stop} For manually stopping the ticker
     */ this.autoStart = false;
        /**
     * Scalar representing the delta time factor.
     * This is a dimensionless value representing the fraction of a frame at the target framerate.
     * At 60 FPS, this value is typically around 1.0.
     *
     * This is NOT in milliseconds - it's a scalar multiplier for frame-independent animations.
     * For actual milliseconds, use {@link Ticker#deltaMS}.
     * @example
     * ```ts
     * // Frame-independent animation using deltaTime scalar
     * ticker.add((ticker) => {
     *     // Rotate sprite by 0.1 radians per frame, scaled by deltaTime
     *     sprite.rotation += 0.1 * ticker.deltaTime;
     * });
     * ```
     */ this.deltaTime = 1;
        /**
     * The last time update was invoked, in milliseconds since epoch.
     * Similar to performance.now() timestamp format.
     *
     * Used internally for calculating time deltas between frames.
     * @example
     * ```ts
     * ticker.add((ticker) => {
     *     const currentTime = performance.now();
     *     const timeSinceLastFrame = currentTime - ticker.lastTime;
     *     console.log(`Time since last frame: ${timeSinceLastFrame}ms`);
     * });
     * ```
     */ this.lastTime = -1;
        /**
     * Factor of current {@link Ticker#deltaTime|deltaTime}.
     * Used to scale time for slow motion or fast-forward effects.
     * @example
     * ```ts
     * // Basic speed adjustment
     * ticker.speed = 0.5; // Half speed (slow motion)
     * ticker.speed = 2.0; // Double speed (fast forward)
     *
     * // Temporary speed changes
     * function slowMotion() {
     *     const normalSpeed = ticker.speed;
     *     ticker.speed = 0.2;
     *     setTimeout(() => {
     *         ticker.speed = normalSpeed;
     *     }, 1000);
     * }
     * ```
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     *
     * `true` if {@link Ticker#start|start} has been called.
     * `false` if {@link Ticker#stop|Stop} has been called.
     *
     * While `false`, this value may change to `true` in the
     * event of {@link Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     * @example
     * ```ts
     * // Check ticker state
     * const ticker = new Ticker();
     * console.log(ticker.started); // false
     *
     * // Start and verify
     * ticker.start();
     * console.log(ticker.started); // true
     * ```
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $92Lva.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /** Conditionally cancels a pending animation frame. */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */ add(fn, context, priority = (0, $2HyEq.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $92Lva.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */ addOnce(fn, context, priority = (0, $2HyEq.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $92Lva.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on minFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // Monitor delta capping
   * ticker.add(() => {
   *     // Delta time will be capped based on maxFPS
   *     console.log(`Delta time: ${ticker.deltaTime}`);
   * });
   * ```
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frame rate in frames per millisecond.
 * Used for converting deltaTime to a scalar time delta.
 * @example
 * ```ts
 * // Default is 0.06 (60 FPS)
 * console.log(Ticker.targetFPMS); // 0.06
 *
 * // Calculate target frame duration
 * const frameDuration = 1 / Ticker.targetFPMS; // ≈ 16.67ms
 *
 * // Use in custom timing calculations
 * const deltaTime = elapsedMS * Ticker.targetFPMS;
 * ```
 * @remarks
 * - Default is 0.06 (equivalent to 60 FPS)
 * - Used in deltaTime calculations
 * - Affects all ticker instances
 * @default 0.06
 * @see {@link Ticker#deltaTime} For time scaling
 * @see {@link Ticker#FPS} For actual frame rate
 */ $039136b84aaa3e00$var$_Ticker.targetFPMS = 0.06;
let $039136b84aaa3e00$export$39c54bcc89dcee11 = $039136b84aaa3e00$var$_Ticker;

});
parcelRegister("2HyEq", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $935863c2eb9aa933$export$688aaf132ba9b379);
"use strict";
var $935863c2eb9aa933$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($935863c2eb9aa933$export$688aaf132ba9b379 || {});

});

parcelRegister("92Lva", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $8e55f8845ecef67a$export$579021a5759a260f);
"use strict";
class $8e55f8845ecef67a$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("7X2qc", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $d3ec6f251a80c104$export$8df68d58aae31877);

var $gLw46 = parcelRequire("gLw46");
"use strict";
let $d3ec6f251a80c104$var$promise;
async function $d3ec6f251a80c104$export$8df68d58aae31877() {
    $d3ec6f251a80c104$var$promise ?? ($d3ec6f251a80c104$var$promise = (async ()=>{
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(1, 1);
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $d3ec6f251a80c104$var$promise;
}

});


parcelRegister("hlucP", function(module, exports) {

$parcel$export(module.exports, "autoDetectSource", () => $f459c6f6ccabe5f2$export$688bcf31fbf7eb15);
$parcel$export(module.exports, "resourceToTexture", () => $f459c6f6ccabe5f2$export$3b748ed6327ec85b);
$parcel$export(module.exports, "textureFrom", () => $f459c6f6ccabe5f2$export$4266177d9730bb1);

var $h3cT0 = parcelRequire("h3cT0");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $f459c6f6ccabe5f2$var$sources = [];
(0, $aZ9ZN.extensions).handleByList((0, $aZ9ZN.ExtensionType).TextureSource, $f459c6f6ccabe5f2$var$sources);
function $f459c6f6ccabe5f2$export$688bcf31fbf7eb15(options = {}) {
    return $f459c6f6ccabe5f2$var$textureSourceFrom(options);
}
function $f459c6f6ccabe5f2$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $f459c6f6ccabe5f2$var$sources.length; i++){
        const Source = $f459c6f6ccabe5f2$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $f459c6f6ccabe5f2$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $h3cT0.Cache).has(resource)) return (0, $h3cT0.Cache).get(resource);
    const texture = new (0, $4iNSL.Texture)({
        source: $f459c6f6ccabe5f2$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $h3cT0.Cache).has(resource)) (0, $h3cT0.Cache).remove(resource);
    });
    if (!skipCache) (0, $h3cT0.Cache).set(resource, texture);
    return texture;
}
function $f459c6f6ccabe5f2$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $h3cT0.Cache).get(id);
    else if (id instanceof (0, $gmQ4R.TextureSource)) return new (0, $4iNSL.Texture)({
        source: id
    });
    return $f459c6f6ccabe5f2$export$3b748ed6327ec85b(id, skipCache);
}
(0, $4iNSL.Texture).from = $f459c6f6ccabe5f2$export$4266177d9730bb1;
(0, $gmQ4R.TextureSource).from = $f459c6f6ccabe5f2$var$textureSourceFrom;

});
parcelRegister("h3cT0", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $9643c0d24410da62$export$94affb487e701bf2);

var $1RpxL = parcelRequire("1RpxL");

var $bkziv = parcelRequire("bkziv");
"use strict";
class $9643c0d24410da62$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $1RpxL.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $bkziv.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $1RpxL.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $1RpxL.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /**
   * All loader parsers registered
   * @advanced
   */ get parsers() {
        return this._parsers;
    }
}
const $9643c0d24410da62$export$94affb487e701bf2 = new $9643c0d24410da62$var$CacheClass();

});
parcelRegister("bkziv", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $9cccbc816519514c$export$b01be8e180bf3d9b);
"use strict";
const $9cccbc816519514c$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("kDNfq", function(module, exports) {

var $aZ9ZN = parcelRequire("aZ9ZN");

var $7oygg = parcelRequire("7oygg");
"use strict";
(0, $aZ9ZN.extensions).add((0, $7oygg.spritesheetAsset));

});
parcelRegister("7oygg", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $f0da44554db1b248$export$46dcda4f1cdd80fe);

var $8nmJS = parcelRequire("8nmJS");

var $eFUj8 = parcelRequire("eFUj8");

var $h8sEz = parcelRequire("h8sEz");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $4iNSL = parcelRequire("4iNSL");

var $208Yz = parcelRequire("208Yz");

var $bbFev = parcelRequire("bbFev");
"use strict";
const $f0da44554db1b248$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $f0da44554db1b248$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $208Yz.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $f0da44554db1b248$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $f0da44554db1b248$export$46dcda4f1cdd80fe = {
    extension: (0, $aZ9ZN.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $bbFev.Spritesheet),
        getCacheableAssets: (keys, asset)=>$f0da44554db1b248$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $aZ9ZN.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $f0da44554db1b248$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $eFUj8.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        /** used for deprecation purposes */ name: "spritesheetLoader",
        id: "spritesheet",
        extension: {
            type: (0, $aZ9ZN.ExtensionType).LoadParser,
            priority: (0, $8nmJS.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $208Yz.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, textureOptions: // if user need to use custom filename (not from jsonFile.meta.image)
            textureOptions, cachePrefix: // if user need to set texture options on texture
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $208Yz.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $4iNSL.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $h8sEz.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    {
                        src: imagePath,
                        data: textureOptions
                    }
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $bbFev.Spritesheet)({
                texture: texture.source,
                data: asset,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $h8sEz.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            textureOptions: textureOptions,
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("8nmJS", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $4c770677e3f27f9c$export$820ed6348c4f2750);
"use strict";
var $4c770677e3f27f9c$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($4c770677e3f27f9c$export$820ed6348c4f2750 || {});

});

parcelRegister("eFUj8", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $66becad9cfb9b10f$export$8b4c839865b08288);
$parcel$export(module.exports, "getUrlExtension", () => $66becad9cfb9b10f$export$4bb0ea38086a2ed5);

var $1RpxL = parcelRequire("1RpxL");

var $208Yz = parcelRequire("208Yz");

var $bkziv = parcelRequire("bkziv");

var $25zMj = parcelRequire("25zMj");

var $4Kkng = parcelRequire("4Kkng");
"use strict";
class $66becad9cfb9b10f$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $bkziv.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $1RpxL.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $1RpxL.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $bkziv.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: userDefinedLoadParser, parser: userDefinedParser } = asset;
            const srcsToUse = (0, $bkziv.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $25zMj.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            const parseUrl = (url)=>{
                const parser = this._parsers.find((p)=>p.test(url));
                return {
                    src: url,
                    ...parser?.parse(url)
                };
            };
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") formattedAsset = parseUrl(src2);
                    else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        if (src2.loadParser || src2.parser) {
                            userDefinedLoadParser = src2.loadParser ?? userDefinedLoadParser;
                            userDefinedParser = src2.parser ?? userDefinedParser;
                        }
                        formattedAsset = {
                            ...parseUrl(src2.src),
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: userDefinedLoadParser,
                        parser: userDefinedParser,
                        progressSize: asset.progressSize
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $4Kkng.isSingleItem)(bundleIds);
        bundleIds = (0, $bkziv.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $4Kkng.isSingleItem)(keys);
        keys = (0, $bkziv.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[i];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, parser: parser, format: format, progressSize: progressSize } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $208Yz.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.parser = parser ?? formattedAsset.parser;
        formattedAsset.format = format ?? formattedAsset.format ?? $66becad9cfb9b10f$export$4bb0ea38086a2ed5(formattedAsset.src);
        if (progressSize !== void 0) formattedAsset.progressSize = progressSize;
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $66becad9cfb9b10f$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $66becad9cfb9b10f$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("208Yz", function(module, exports) {

$parcel$export(module.exports, "path", () => $4a84753320400574$export$bb654e07daaf8c3a);

var $gLw46 = parcelRequire("gLw46");
"use strict";
function $4a84753320400574$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $4a84753320400574$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $4a84753320400574$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $4a84753320400574$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($4a84753320400574$var$escapeRegExp(find), "g"), replace);
}
function $4a84753320400574$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $4a84753320400574$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */ toPosix (path2) {
        return $4a84753320400574$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ getProtocol (path2) {
        $4a84753320400574$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $4a84753320400574$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $4a84753320400574$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $gLw46.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $4a84753320400574$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $4a84753320400574$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */ normalize (path2) {
        $4a84753320400574$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $4a84753320400574$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ isAbsolute (path2) {
        $4a84753320400574$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $4a84753320400574$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */ dirname (path2) {
        $4a84753320400574$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ rootname (path2) {
        $4a84753320400574$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */ basename (path2, ext) {
        $4a84753320400574$var$assertPath(path2);
        if (ext) $4a84753320400574$var$assertPath(ext);
        path2 = $4a84753320400574$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */ extname (path2) {
        $4a84753320400574$var$assertPath(path2);
        path2 = $4a84753320400574$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */ parse (path2) {
        $4a84753320400574$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $4a84753320400574$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("25zMj", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $d3dbcab4008b152f$export$738117acc6638004);
"use strict";
function $d3dbcab4008b152f$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $d3dbcab4008b152f$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $d3dbcab4008b152f$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $d3dbcab4008b152f$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("4Kkng", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $817e907c0216cac0$export$16a80d27953452d4);
"use strict";
const $817e907c0216cac0$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("h8sEz", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $09443bbd16656593$export$f57b97ef8be10dda);
"use strict";
const $09443bbd16656593$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("bbFev", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $008b0a71988a4001$export$674d2eb4debbef0c);

var $ar2Ly = parcelRequire("ar2Ly");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $008b0a71988a4001$var$_Spritesheet = class _Spritesheet {
    constructor(optionsOrTexture, arg1){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        let options = optionsOrTexture;
        if (optionsOrTexture?.source instanceof (0, $gmQ4R.TextureSource)) options = {
            texture: optionsOrTexture,
            data: arg1
        };
        const { texture: texture, data: data, cachePrefix: cachePrefix = "" } = options;
        this.cachePrefix = cachePrefix;
        this._texture = texture instanceof (0, $4iNSL.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */ parseSync() {
        this._processFrames(0, true);
        this._processAnimations();
        return this.textures;
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */ _processFrames(initialFrameIndex, processAll = false) {
        let frameIndex = initialFrameIndex;
        const maxFrames = processAll ? Infinity : _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $ar2Ly.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $ar2Ly.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $ar2Ly.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $ar2Ly.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $4iNSL.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/**
 * The maximum number of Textures to build per process.
 * @advanced
 */ $008b0a71988a4001$var$_Spritesheet.BATCH_SIZE = 1e3;
let $008b0a71988a4001$export$674d2eb4debbef0c = $008b0a71988a4001$var$_Spritesheet;

});



parcelRegister("gpiLJ", function(module, exports) {

$parcel$export(module.exports, "AccessibilitySystem", () => $8a41d99398cbdf4f$export$982526b2aa4fb64c);

var $g3seW = parcelRequire("g3seW");

var $bG9BA = parcelRequire("bG9BA");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $c6cSg = parcelRequire("c6cSg");

var $02QFP = parcelRequire("02QFP");
"use strict";
const $8a41d99398cbdf4f$var$KEY_CODE_TAB = 9;
const $8a41d99398cbdf4f$var$DIV_TOUCH_SIZE = 100;
const $8a41d99398cbdf4f$var$DIV_TOUCH_POS_X = 0;
const $8a41d99398cbdf4f$var$DIV_TOUCH_POS_Y = 0;
const $8a41d99398cbdf4f$var$DIV_TOUCH_ZINDEX = 2;
const $8a41d99398cbdf4f$var$DIV_HOOK_SIZE = 1;
const $8a41d99398cbdf4f$var$DIV_HOOK_POS_X = -1000;
const $8a41d99398cbdf4f$var$DIV_HOOK_POS_Y = -1000;
const $8a41d99398cbdf4f$var$DIV_HOOK_ZINDEX = 2;
const $8a41d99398cbdf4f$var$_AccessibilitySystem = class _AccessibilitySystem {
    // eslint-disable-next-line jsdoc/require-param
    /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */ constructor(renderer, _mobileInfo = (0, $c6cSg.isMobile)){
        this._mobileInfo = _mobileInfo;
        /** Whether accessibility divs are visible for debugging */ this.debug = false;
        /** Whether to activate on tab key press */ this._activateOnTab = true;
        /** Whether to deactivate accessibility when mouse moves */ this._deactivateOnMouseMove = true;
        /** Internal variable, see isActive getter. */ this._isActive = false;
        /** Internal variable, see isMobileAccessibility getter. */ this._isMobileAccessibility = false;
        /** This is the dom element that will sit over the PixiJS element. This is where the div overlays will go. */ this._div = null;
        /** A simple pool for storing divs. */ this._pools = {};
        /** This is a tick used to check if an object is no longer being rendered. */ this._renderId = 0;
        /** The array of currently active accessible items. */ this._children = [];
        /** Count to throttle div updates on android devices. */ this._androidUpdateCount = 0;
        /**  The frequency to update the div elements. */ this._androidUpdateFrequency = 500;
        // eslint-disable-next-line @typescript-eslint/prefer-readonly
        this._isRunningTests = false;
        /** Bound function references for proper event listener removal */ this._boundOnKeyDown = this._onKeyDown.bind(this);
        this._boundOnMouseMove = this._onMouseMove.bind(this);
        this._hookDiv = null;
        if (_mobileInfo.tablet || _mobileInfo.phone) this._createTouchHook();
        this._renderer = renderer;
    }
    /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @type {boolean}
   * @readonly
   */ get isActive() {
        return this._isActive;
    }
    /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @type {boolean}
   * @readonly
   */ get isMobileAccessibility() {
        return this._isMobileAccessibility;
    }
    /**
   * Button element for handling touch hooks.
   * @readonly
   */ get hookDiv() {
        return this._hookDiv;
    }
    /**
   * The DOM element that will sit over the PixiJS element. This is where the div overlays will go.
   * @readonly
   */ get div() {
        return this._div;
    }
    /**
   * Creates the touch hooks.
   * @private
   */ _createTouchHook() {
        const hookDiv = document.createElement("button");
        hookDiv.style.width = `${$8a41d99398cbdf4f$var$DIV_HOOK_SIZE}px`;
        hookDiv.style.height = `${$8a41d99398cbdf4f$var$DIV_HOOK_SIZE}px`;
        hookDiv.style.position = "absolute";
        hookDiv.style.top = `${$8a41d99398cbdf4f$var$DIV_HOOK_POS_X}px`;
        hookDiv.style.left = `${$8a41d99398cbdf4f$var$DIV_HOOK_POS_Y}px`;
        hookDiv.style.zIndex = $8a41d99398cbdf4f$var$DIV_HOOK_ZINDEX.toString();
        hookDiv.style.backgroundColor = "#FF0000";
        hookDiv.title = "select to enable accessibility for this content";
        hookDiv.addEventListener("focus", ()=>{
            this._isMobileAccessibility = true;
            this._activate();
            this._destroyTouchHook();
        });
        document.body.appendChild(hookDiv);
        this._hookDiv = hookDiv;
    }
    /**
   * Destroys the touch hooks.
   * @private
   */ _destroyTouchHook() {
        if (!this._hookDiv) return;
        document.body.removeChild(this._hookDiv);
        this._hookDiv = null;
    }
    /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */ _activate() {
        if (this._isActive) return;
        this._isActive = true;
        if (!this._div) {
            this._div = document.createElement("div");
            this._div.style.position = "absolute";
            this._div.style.top = `${$8a41d99398cbdf4f$var$DIV_TOUCH_POS_X}px`;
            this._div.style.left = `${$8a41d99398cbdf4f$var$DIV_TOUCH_POS_Y}px`;
            this._div.style.pointerEvents = "none";
            this._div.style.zIndex = $8a41d99398cbdf4f$var$DIV_TOUCH_ZINDEX.toString();
            this._canvasObserver = new (0, $g3seW.CanvasObserver)({
                domElement: this._div,
                renderer: this._renderer
            });
        }
        if (this._activateOnTab) globalThis.addEventListener("keydown", this._boundOnKeyDown, false);
        if (this._deactivateOnMouseMove) globalThis.document.addEventListener("mousemove", this._boundOnMouseMove, true);
        const canvas = this._renderer.view.canvas;
        if (!canvas.parentNode) {
            const observer = new MutationObserver(()=>{
                if (canvas.parentNode) {
                    observer.disconnect();
                    this._canvasObserver.ensureAttached();
                    this._initAccessibilitySetup();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            this._canvasObserver.ensureAttached();
            this._initAccessibilitySetup();
        }
    }
    // New method to handle initialization after div is ready
    _initAccessibilitySetup() {
        this._renderer.runners.postrender.add(this);
        if (this._renderer.lastObjectRendered) this._updateAccessibleObjects(this._renderer.lastObjectRendered);
    }
    /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */ _deactivate() {
        if (!this._isActive || this._isMobileAccessibility) return;
        this._isActive = false;
        globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, true);
        if (this._activateOnTab) globalThis.addEventListener("keydown", this._boundOnKeyDown, false);
        this._renderer.runners.postrender.remove(this);
        for (const child of this._children){
            if (child._accessibleDiv?.parentNode) {
                child._accessibleDiv.parentNode.removeChild(child._accessibleDiv);
                child._accessibleDiv = null;
            }
            child._accessibleActive = false;
        }
        for(const accessibleType in this._pools){
            const pool = this._pools[accessibleType];
            pool.forEach((div)=>{
                if (div.parentNode) div.parentNode.removeChild(div);
            });
            delete this._pools[accessibleType];
        }
        if (this._div?.parentNode) this._div.parentNode.removeChild(this._div);
        this._pools = {};
        this._children = [];
    }
    /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */ _updateAccessibleObjects(container) {
        if (!container.visible || !container.accessibleChildren) return;
        if (container.accessible) {
            if (!container._accessibleActive) this._addChild(container);
            container._renderId = this._renderId;
        }
        const children = container.children;
        if (children) for(let i = 0; i < children.length; i++)this._updateAccessibleObjects(children[i]);
    }
    /**
   * Runner init called, view is available at this point.
   * @ignore
   */ init(options) {
        const defaultOpts = _AccessibilitySystem.defaultOptions;
        const mergedOptions = {
            accessibilityOptions: {
                ...defaultOpts,
                ...options?.accessibilityOptions || {}
            }
        };
        this.debug = mergedOptions.accessibilityOptions.debug;
        this._activateOnTab = mergedOptions.accessibilityOptions.activateOnTab;
        this._deactivateOnMouseMove = mergedOptions.accessibilityOptions.deactivateOnMouseMove;
        if (mergedOptions.accessibilityOptions.enabledByDefault) this._activate();
        this._renderer.runners.postrender.remove(this);
    }
    /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */ postrender() {
        const now = performance.now();
        if (this._mobileInfo.android.device && now < this._androidUpdateCount) return;
        this._androidUpdateCount = now + this._androidUpdateFrequency;
        if ((!this._renderer.renderingToScreen || !this._renderer.view.canvas) && !this._isRunningTests) return;
        const activeIds = /* @__PURE__ */ new Set();
        if (this._renderer.lastObjectRendered) {
            this._updateAccessibleObjects(this._renderer.lastObjectRendered);
            for (const child of this._children)if (child._renderId === this._renderId) activeIds.add(this._children.indexOf(child));
        }
        for(let i = this._children.length - 1; i >= 0; i--){
            const child = this._children[i];
            if (!activeIds.has(i)) {
                if (child._accessibleDiv && child._accessibleDiv.parentNode) {
                    child._accessibleDiv.parentNode.removeChild(child._accessibleDiv);
                    const pool = this._getPool(child.accessibleType);
                    pool.push(child._accessibleDiv);
                    child._accessibleDiv = null;
                }
                child._accessibleActive = false;
                (0, $02QFP.removeItems)(this._children, i, 1);
            }
        }
        if (this._renderer.renderingToScreen) this._canvasObserver.ensureAttached();
        for(let i = 0; i < this._children.length; i++){
            const child = this._children[i];
            if (!child._accessibleActive || !child._accessibleDiv) continue;
            const div = child._accessibleDiv;
            const hitArea = child.hitArea || child.getBounds().rectangle;
            if (child.hitArea) {
                const wt = child.worldTransform;
                div.style.left = `${wt.tx + hitArea.x * wt.a}px`;
                div.style.top = `${wt.ty + hitArea.y * wt.d}px`;
                div.style.width = `${hitArea.width * wt.a}px`;
                div.style.height = `${hitArea.height * wt.d}px`;
            } else {
                this._capHitArea(hitArea);
                div.style.left = `${hitArea.x}px`;
                div.style.top = `${hitArea.y}px`;
                div.style.width = `${hitArea.width}px`;
                div.style.height = `${hitArea.height}px`;
            }
        }
        this._renderId++;
    }
    /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */ _updateDebugHTML(div) {
        div.innerHTML = `type: ${div.type}</br> title : ${div.title}</br> tabIndex: ${div.tabIndex}`;
    }
    /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */ _capHitArea(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }
        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }
        const { width: viewWidth, height: viewHeight } = this._renderer;
        if (hitArea.x + hitArea.width > viewWidth) hitArea.width = viewWidth - hitArea.x;
        if (hitArea.y + hitArea.height > viewHeight) hitArea.height = viewHeight - hitArea.y;
    }
    /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */ _addChild(container) {
        const pool = this._getPool(container.accessibleType);
        let div = pool.pop();
        if (div) {
            div.innerHTML = "";
            div.removeAttribute("title");
            div.removeAttribute("aria-label");
            div.tabIndex = 0;
        } else {
            if (container.accessibleType === "button") div = document.createElement("button");
            else {
                div = document.createElement(container.accessibleType);
                div.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `;
                if (container.accessibleText) div.innerText = container.accessibleText;
            }
            div.style.width = `${$8a41d99398cbdf4f$var$DIV_TOUCH_SIZE}px`;
            div.style.height = `${$8a41d99398cbdf4f$var$DIV_TOUCH_SIZE}px`;
            div.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent";
            div.style.position = "absolute";
            div.style.zIndex = $8a41d99398cbdf4f$var$DIV_TOUCH_ZINDEX.toString();
            div.style.borderStyle = "none";
            if (navigator.userAgent.toLowerCase().includes("chrome")) div.setAttribute("aria-live", "off");
            else div.setAttribute("aria-live", "polite");
            if (navigator.userAgent.match(/rv:.*Gecko\//)) div.setAttribute("aria-relevant", "additions");
            else div.setAttribute("aria-relevant", "text");
            div.addEventListener("click", this._onClick.bind(this));
            div.addEventListener("focus", this._onFocus.bind(this));
            div.addEventListener("focusout", this._onFocusOut.bind(this));
        }
        div.style.pointerEvents = container.accessiblePointerEvents;
        div.type = container.accessibleType;
        if (container.accessibleTitle && container.accessibleTitle !== null) div.title = container.accessibleTitle;
        else if (!container.accessibleHint || container.accessibleHint === null) div.title = `container ${container.tabIndex}`;
        if (container.accessibleHint && container.accessibleHint !== null) div.setAttribute("aria-label", container.accessibleHint);
        if (container.interactive) div.tabIndex = container.tabIndex;
        else div.tabIndex = 0;
        if (this.debug) this._updateDebugHTML(div);
        container._accessibleActive = true;
        container._accessibleDiv = div;
        div.container = container;
        this._children.push(container);
        this._div.appendChild(container._accessibleDiv);
    }
    /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */ _dispatchEvent(e, type) {
        const { container: target } = e.target;
        const boundary = this._renderer.events.rootBoundary;
        const event = Object.assign(new (0, $bG9BA.FederatedEvent)(boundary), {
            target: target
        });
        boundary.rootTarget = this._renderer.lastObjectRendered;
        type.forEach((type2)=>boundary.dispatchEvent(event, type2));
    }
    /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */ _onClick(e) {
        this._dispatchEvent(e, [
            "click",
            "pointertap",
            "tap"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */ _onFocus(e) {
        if (!e.target.getAttribute("aria-live")) e.target.setAttribute("aria-live", "assertive");
        this._dispatchEvent(e, [
            "mouseover"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */ _onFocusOut(e) {
        if (!e.target.getAttribute("aria-live")) e.target.setAttribute("aria-live", "polite");
        this._dispatchEvent(e, [
            "mouseout"
        ]);
    }
    /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */ _onKeyDown(e) {
        if (e.keyCode !== $8a41d99398cbdf4f$var$KEY_CODE_TAB || !this._activateOnTab) return;
        this._activate();
    }
    /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */ _onMouseMove(e) {
        if (e.movementX === 0 && e.movementY === 0) return;
        this._deactivate();
    }
    /**
   * Destroys the accessibility system. Removes all elements and listeners.
   * > [!IMPORTANT] This is typically called automatically when the {@link Application} is destroyed.
   * > A typically user should not need to call this method directly.
   */ destroy() {
        this._deactivate();
        this._destroyTouchHook();
        this._canvasObserver?.destroy();
        this._canvasObserver = null;
        this._div = null;
        this._pools = null;
        this._children = null;
        this._renderer = null;
        this._hookDiv = null;
        globalThis.removeEventListener("keydown", this._boundOnKeyDown);
        this._boundOnKeyDown = null;
        globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, true);
        this._boundOnMouseMove = null;
    }
    /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   * @example
   * ```js
   * app.renderer.accessibility.setAccessibilityEnabled(true); // Enable accessibility
   * app.renderer.accessibility.setAccessibilityEnabled(false); // Disable accessibility
   * ```
   */ setAccessibilityEnabled(enabled) {
        if (enabled) this._activate();
        else this._deactivate();
    }
    _getPool(accessibleType) {
        if (!this._pools[accessibleType]) this._pools[accessibleType] = [];
        return this._pools[accessibleType];
    }
};
/** @ignore */ $8a41d99398cbdf4f$var$_AccessibilitySystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "accessibility"
};
/**
 * The default options used by the system.
 * You can set these before initializing the {@link Application} to change the default behavior.
 * @example
 * ```js
 * import { AccessibilitySystem } from 'pixi.js';
 *
 * AccessibilitySystem.defaultOptions.enabledByDefault = true;
 *
 * const app = new Application()
 * app.init()
 * ```
 */ $8a41d99398cbdf4f$var$_AccessibilitySystem.defaultOptions = {
    /**
   * Whether to enable accessibility features on initialization
   * @default false
   */ enabledByDefault: false,
    /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */ debug: false,
    /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */ activateOnTab: true,
    /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */ deactivateOnMouseMove: true
};
let $8a41d99398cbdf4f$export$982526b2aa4fb64c = $8a41d99398cbdf4f$var$_AccessibilitySystem;

});
parcelRegister("g3seW", function(module, exports) {

$parcel$export(module.exports, "CanvasObserver", () => $e2def100d0c1bf1b$export$df26181feaa256a);

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");
"use strict";
class $e2def100d0c1bf1b$export$df26181feaa256a {
    constructor(options){
        /** A cached value of the last transform applied to the DOM element. */ this._lastTransform = "";
        /** A ResizeObserver instance to observe changes in the canvas size. */ this._observer = null;
        /** A flag to indicate whether the observer is attached to the Ticker for continuous updates. */ this._tickerAttached = false;
        /**
     * Updates the transform of the DOM element based on the canvas size and position.
     * This method calculates the scale and translation needed to keep the DOM element in sync with the canvas.
     */ this.updateTranslation = ()=>{
            if (!this._canvas) return;
            const rect = this._canvas.getBoundingClientRect();
            const contentWidth = this._canvas.width;
            const contentHeight = this._canvas.height;
            const sx = rect.width / contentWidth * this._renderer.resolution;
            const sy = rect.height / contentHeight * this._renderer.resolution;
            const tx = rect.left;
            const ty = rect.top;
            const newTransform = `translate(${tx}px, ${ty}px) scale(${sx}, ${sy})`;
            if (newTransform !== this._lastTransform) {
                this._domElement.style.transform = newTransform;
                this._lastTransform = newTransform;
            }
        };
        this._domElement = options.domElement;
        this._renderer = options.renderer;
        if (globalThis.OffscreenCanvas && this._renderer.canvas instanceof OffscreenCanvas) return;
        this._canvas = this._renderer.canvas;
        this._attachObserver();
    }
    /** The canvas element that this CanvasObserver is associated with. */ get canvas() {
        return this._canvas;
    }
    /** Attaches the DOM element to the canvas parent if it is not already attached. */ ensureAttached() {
        if (!this._domElement.parentNode && this._canvas.parentNode) {
            this._canvas.parentNode.appendChild(this._domElement);
            this.updateTranslation();
        }
    }
    /** Sets up a ResizeObserver if available. This ensures that the DOM element is kept in sync with the canvas size . */ _attachObserver() {
        if ("ResizeObserver" in globalThis) {
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this._observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    if (entry.target !== this._canvas) continue;
                    const contentWidth = this.canvas.width;
                    const contentHeight = this.canvas.height;
                    const sx = entry.contentRect.width / contentWidth * this._renderer.resolution;
                    const sy = entry.contentRect.height / contentHeight * this._renderer.resolution;
                    const needsUpdate = this._lastScaleX !== sx || this._lastScaleY !== sy;
                    if (needsUpdate) {
                        this.updateTranslation();
                        this._lastScaleX = sx;
                        this._lastScaleY = sy;
                    }
                }
            });
            this._observer.observe(this._canvas);
        } else if (!this._tickerAttached) (0, $jM8Go.Ticker).shared.add(this.updateTranslation, this, (0, $2HyEq.UPDATE_PRIORITY).HIGH);
    }
    /** Destroys the CanvasObserver instance, cleaning up observers and Ticker. */ destroy() {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        } else if (this._tickerAttached) (0, $jM8Go.Ticker).shared.remove(this.updateTranslation);
        this._domElement = null;
        this._renderer = null;
        this._canvas = null;
        this._tickerAttached = false;
        this._lastTransform = "";
        this._lastScaleX = null;
        this._lastScaleY = null;
    }
}

});

parcelRegister("bG9BA", function(module, exports) {

$parcel$export(module.exports, "FederatedEvent", () => $5f33ef5135a1b100$export$5d10db92bb959d8a);

var $ds7Xo = parcelRequire("ds7Xo");
"use strict";
class $5f33ef5135a1b100$export$5d10db92bb959d8a {
    /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */ constructor(manager){
        /** Flags whether this event bubbles. This will take effect only if it is set before propagation. */ this.bubbles = true;
        /** @deprecated since 7.0.0 */ this.cancelBubble = true;
        /**
     * Flags whether this event can be canceled using {@link FederatedEvent.preventDefault}. This is always
     * false (for now).
     */ this.cancelable = false;
        /**
     * Flag added for compatibility with DOM `Event`. It is not used in the Federated Events
     * API.
     * @see https://dom.spec.whatwg.org/#dom-event-composed
     * @ignore
     */ this.composed = false;
        /** Flags whether the default response of the user agent was prevent through this event. */ this.defaultPrevented = false;
        /**
     * The propagation phase.
     * @default {@link FederatedEvent.NONE}
     */ this.eventPhase = $5f33ef5135a1b100$export$5d10db92bb959d8a.prototype.NONE;
        /** Flags whether propagation was stopped. */ this.propagationStopped = false;
        /** Flags whether propagation was immediately stopped. */ this.propagationImmediatelyStopped = false;
        /** The coordinates of the event relative to the nearest DOM layer. This is a non-standard property. */ this.layer = new (0, $ds7Xo.Point)();
        /** The coordinates of the event relative to the DOM document. This is a non-standard property. */ this.page = new (0, $ds7Xo.Point)();
        /**
     * The event propagation phase NONE that indicates that the event is not in any phase.
     * @default 0
     * @advanced
     */ this.NONE = 0;
        /**
     * The event propagation phase CAPTURING_PHASE that indicates that the event is in the capturing phase.
     * @default 1
     * @advanced
     */ this.CAPTURING_PHASE = 1;
        /**
     * The event propagation phase AT_TARGET that indicates that the event is at the target.
     * @default 2
     * @advanced
     */ this.AT_TARGET = 2;
        /**
     * The event propagation phase BUBBLING_PHASE that indicates that the event is in the bubbling phase.
     * @default 3
     * @advanced
     */ this.BUBBLING_PHASE = 3;
        this.manager = manager;
    }
    /** @readonly */ get layerX() {
        return this.layer.x;
    }
    /** @readonly */ get layerY() {
        return this.layer.y;
    }
    /** @readonly */ get pageX() {
        return this.page.x;
    }
    /** @readonly */ get pageY() {
        return this.page.y;
    }
    /**
   * Fallback for the deprecated `InteractionEvent.data`.
   * @deprecated since 7.0.0
   */ get data() {
        return this;
    }
    /**
   * The propagation path for this event. Alias for {@link EventBoundary.propagationPath}.
   * @advanced
   */ composedPath() {
        if (this.manager && (!this.path || this.path[this.path.length - 1] !== this.target)) this.path = this.target ? this.manager.propagationPath(this.target) : [];
        return this.path;
    }
    /**
   * Unimplemented method included for implementing the DOM interface `Event`. It will throw an `Error`.
   * @deprecated
   * @ignore
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */ initEvent(_type, _bubbles, _cancelable) {
        throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /**
   * Unimplemented method included for implementing the DOM interface `UIEvent`. It will throw an `Error`.
   * @ignore
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */ initUIEvent(_typeArg, _bubblesArg, _cancelableArg, _viewArg, _detailArg) {
        throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /**
   * Prevent default behavior of both PixiJS and the user agent.
   * @example
   * ```ts
   * sprite.on('click', (event) => {
   *     // Prevent both browser's default click behavior
   *     // and PixiJS's default handling
   *     event.preventDefault();
   *
   *     // Custom handling
   *     customClickHandler();
   * });
   * ```
   * @remarks
   * - Only works if the native event is cancelable
   * - Does not stop event propagation
   */ preventDefault() {
        if (this.nativeEvent instanceof Event && this.nativeEvent.cancelable) this.nativeEvent.preventDefault();
        this.defaultPrevented = true;
    }
    /**
   * Stop this event from propagating to any additional listeners, including those
   * on the current target and any following targets in the propagation path.
   * @example
   * ```ts
   * container.on('pointerdown', (event) => {
   *     // Stop all further event handling
   *     event.stopImmediatePropagation();
   *
   *     // These handlers won't be called:
   *     // - Other pointerdown listeners on this container
   *     // - Any pointerdown listeners on parent containers
   * });
   * ```
   * @remarks
   * - Immediately stops all event propagation
   * - Prevents other listeners on same target from being called
   * - More aggressive than stopPropagation()
   */ stopImmediatePropagation() {
        this.propagationImmediatelyStopped = true;
    }
    /**
   * Stop this event from propagating to the next target in the propagation path.
   * The rest of the listeners on the current target will still be notified.
   * @example
   * ```ts
   * child.on('pointermove', (event) => {
   *     // Handle event on child
   *     updateChild();
   *
   *     // Prevent parent handlers from being called
   *     event.stopPropagation();
   * });
   *
   * // This won't be called if child handles the event
   * parent.on('pointermove', (event) => {
   *     updateParent();
   * });
   * ```
   * @remarks
   * - Stops event bubbling to parent containers
   * - Does not prevent other listeners on same target
   * - Less aggressive than stopImmediatePropagation()
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}

});

parcelRegister("c6cSg", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $aac8a0650b1d4d76$export$d0a8044dce8ff2fc);
parcelRequire("3FAem");
var $kOAor = parcelRequire("kOAor");
"use strict";
const $aac8a0650b1d4d76$var$isMobileCall = (0, $kOAor.default).default ?? (0, $kOAor.default);
const $aac8a0650b1d4d76$export$d0a8044dce8ff2fc = $aac8a0650b1d4d76$var$isMobileCall(globalThis.navigator);

});
parcelRegister("3FAem", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("kOAor")).default);

var $kOAor = parcelRequire("kOAor");

});
parcelRegister("kOAor", function(module, exports) {

$parcel$export(module.exports, "default", () => $f274b51b862d63d3$export$2e2bcd8739ae039);
var $f274b51b862d63d3$var$appleIphone = /iPhone/i;
var $f274b51b862d63d3$var$appleIpod = /iPod/i;
var $f274b51b862d63d3$var$appleTablet = /iPad/i;
var $f274b51b862d63d3$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $f274b51b862d63d3$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $f274b51b862d63d3$var$androidTablet = /Android/i;
var $f274b51b862d63d3$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $f274b51b862d63d3$var$amazonTablet = /Silk/i;
var $f274b51b862d63d3$var$windowsPhone = /Windows Phone/i;
var $f274b51b862d63d3$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $f274b51b862d63d3$var$otherBlackBerry = /BlackBerry/i;
var $f274b51b862d63d3$var$otherBlackBerry10 = /BB10/i;
var $f274b51b862d63d3$var$otherOpera = /Opera Mini/i;
var $f274b51b862d63d3$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $f274b51b862d63d3$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $f274b51b862d63d3$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== 'undefined' && navigator1.platform === 'MacIntel' && typeof navigator1.maxTouchPoints === 'number' && navigator1.maxTouchPoints > 1 && typeof MSStream === 'undefined';
};
function $f274b51b862d63d3$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $f274b51b862d63d3$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === 'string') nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    var match = $f274b51b862d63d3$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($f274b51b862d63d3$var$appleIphone) && !match($f274b51b862d63d3$var$windowsPhone),
            ipod: match($f274b51b862d63d3$var$appleIpod),
            tablet: !match($f274b51b862d63d3$var$appleIphone) && (match($f274b51b862d63d3$var$appleTablet) || $f274b51b862d63d3$var$isAppleTabletOnIos13(nav)) && !match($f274b51b862d63d3$var$windowsPhone),
            universal: match($f274b51b862d63d3$var$appleUniversal),
            device: (match($f274b51b862d63d3$var$appleIphone) || match($f274b51b862d63d3$var$appleIpod) || match($f274b51b862d63d3$var$appleTablet) || match($f274b51b862d63d3$var$appleUniversal) || $f274b51b862d63d3$var$isAppleTabletOnIos13(nav)) && !match($f274b51b862d63d3$var$windowsPhone)
        },
        amazon: {
            phone: match($f274b51b862d63d3$var$amazonPhone),
            tablet: !match($f274b51b862d63d3$var$amazonPhone) && match($f274b51b862d63d3$var$amazonTablet),
            device: match($f274b51b862d63d3$var$amazonPhone) || match($f274b51b862d63d3$var$amazonTablet)
        },
        android: {
            phone: !match($f274b51b862d63d3$var$windowsPhone) && match($f274b51b862d63d3$var$amazonPhone) || !match($f274b51b862d63d3$var$windowsPhone) && match($f274b51b862d63d3$var$androidPhone),
            tablet: !match($f274b51b862d63d3$var$windowsPhone) && !match($f274b51b862d63d3$var$amazonPhone) && !match($f274b51b862d63d3$var$androidPhone) && (match($f274b51b862d63d3$var$amazonTablet) || match($f274b51b862d63d3$var$androidTablet)),
            device: !match($f274b51b862d63d3$var$windowsPhone) && (match($f274b51b862d63d3$var$amazonPhone) || match($f274b51b862d63d3$var$amazonTablet) || match($f274b51b862d63d3$var$androidPhone) || match($f274b51b862d63d3$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($f274b51b862d63d3$var$windowsPhone),
            tablet: match($f274b51b862d63d3$var$windowsTablet),
            device: match($f274b51b862d63d3$var$windowsPhone) || match($f274b51b862d63d3$var$windowsTablet)
        },
        other: {
            blackberry: match($f274b51b862d63d3$var$otherBlackBerry),
            blackberry10: match($f274b51b862d63d3$var$otherBlackBerry10),
            opera: match($f274b51b862d63d3$var$otherOpera),
            firefox: match($f274b51b862d63d3$var$otherFirefox),
            chrome: match($f274b51b862d63d3$var$otherChrome),
            device: match($f274b51b862d63d3$var$otherBlackBerry) || match($f274b51b862d63d3$var$otherBlackBerry10) || match($f274b51b862d63d3$var$otherOpera) || match($f274b51b862d63d3$var$otherFirefox) || match($f274b51b862d63d3$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}

});




parcelRegister("2ibqd", function(module, exports) {

$parcel$export(module.exports, "accessibilityTarget", () => $ca4382fee5616a6d$export$fd4b6e2c3e09104f);
"use strict";
const $ca4382fee5616a6d$export$fd4b6e2c3e09104f = {
    accessible: false,
    accessibleTitle: null,
    accessibleHint: null,
    tabIndex: 0,
    accessibleType: "button",
    accessibleText: null,
    accessiblePointerEvents: "auto",
    accessibleChildren: true,
    _accessibleActive: false,
    _accessibleDiv: null,
    _renderId: -1
};

});

parcelRegister("hSVNL", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $d0545101b15d4201$export$1059c6e7d2ce5669, (v) => $d0545101b15d4201$export$1059c6e7d2ce5669 = v);
var $d0545101b15d4201$export$181392475aa39887;
var $d0545101b15d4201$export$ba13e0e2f19e61a1;
var $d0545101b15d4201$export$1059c6e7d2ce5669;

var $cDZUo = parcelRequire("cDZUo");

var $agg8Z = parcelRequire("agg8Z");

var $l0mWv = parcelRequire("l0mWv");

var $1tomy = parcelRequire("1tomy");
var $d0545101b15d4201$var$DOMImplementation = $agg8Z.DOMImplementation;
var $d0545101b15d4201$var$NAMESPACE = $cDZUo.NAMESPACE;
var $d0545101b15d4201$var$ParseError = $1tomy.ParseError;
var $d0545101b15d4201$var$XMLReader = $1tomy.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $d0545101b15d4201$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $d0545101b15d4201$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$d0545101b15d4201$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $d0545101b15d4201$var$XMLReader();
    var domBuilder = options.domBuilder || new $d0545101b15d4201$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $l0mWv.HTML_ENTITIES : $l0mWv.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $d0545101b15d4201$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $d0545101b15d4201$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $d0545101b15d4201$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $d0545101b15d4201$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $d0545101b15d4201$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $d0545101b15d4201$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $d0545101b15d4201$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $d0545101b15d4201$var$DOMHandler() {
    this.cdata = false;
}
function $d0545101b15d4201$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $d0545101b15d4201$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $d0545101b15d4201$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $d0545101b15d4201$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $d0545101b15d4201$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $d0545101b15d4201$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $d0545101b15d4201$var$position(this.locator, ins);
        $d0545101b15d4201$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $d0545101b15d4201$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $d0545101b15d4201$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $d0545101b15d4201$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $d0545101b15d4201$var$position(this.locator, comm);
        $d0545101b15d4201$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $d0545101b15d4201$var$position(this.locator, dt);
            $d0545101b15d4201$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $d0545101b15d4201$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $d0545101b15d4201$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $d0545101b15d4201$var$ParseError(error, this.locator);
    }
};
function $d0545101b15d4201$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $d0545101b15d4201$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $d0545101b15d4201$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $d0545101b15d4201$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$d0545101b15d4201$export$181392475aa39887 = $d0545101b15d4201$var$DOMHandler;
$d0545101b15d4201$export$ba13e0e2f19e61a1 = $d0545101b15d4201$var$normalizeLineEndings;
$d0545101b15d4201$export$1059c6e7d2ce5669 = $d0545101b15d4201$var$DOMParser;

});
parcelRegister("cDZUo", function(module, exports) {

$parcel$export(module.exports, "find", () => $9349264c29c1c854$export$71aa6c912b956294, (v) => $9349264c29c1c854$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $9349264c29c1c854$export$792f3d81ea979f55, (v) => $9349264c29c1c854$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $9349264c29c1c854$export$6aad947bda0f3f46, (v) => $9349264c29c1c854$export$6aad947bda0f3f46 = v);
var $9349264c29c1c854$export$e6e34fd1f2686227;
var $9349264c29c1c854$export$71aa6c912b956294;
var $9349264c29c1c854$export$792f3d81ea979f55;
var $9349264c29c1c854$export$c6cb9dd1e3ada1aa;
var $9349264c29c1c854$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $9349264c29c1c854$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $9349264c29c1c854$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $9349264c29c1c854$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $9349264c29c1c854$var$MIME_TYPE = $9349264c29c1c854$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $9349264c29c1c854$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $9349264c29c1c854$var$NAMESPACE = $9349264c29c1c854$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $9349264c29c1c854$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$9349264c29c1c854$export$e6e34fd1f2686227 = $9349264c29c1c854$var$assign;
$9349264c29c1c854$export$71aa6c912b956294 = $9349264c29c1c854$var$find;
$9349264c29c1c854$export$792f3d81ea979f55 = $9349264c29c1c854$var$freeze;
$9349264c29c1c854$export$c6cb9dd1e3ada1aa = $9349264c29c1c854$var$MIME_TYPE;
$9349264c29c1c854$export$6aad947bda0f3f46 = $9349264c29c1c854$var$NAMESPACE;

});

parcelRegister("agg8Z", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $7787ebd92f89dcbd$export$455426655eab1d48, (v) => $7787ebd92f89dcbd$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $7787ebd92f89dcbd$export$64f0bed4ae6f0f24, (v) => $7787ebd92f89dcbd$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $7787ebd92f89dcbd$export$d1d99cf900472499;
var $7787ebd92f89dcbd$export$fe58bcf938607f6a;
var $7787ebd92f89dcbd$export$455426655eab1d48;
var $7787ebd92f89dcbd$export$db77ccec0bb4ccac;
var $7787ebd92f89dcbd$export$85c928794f8d04d4;
var $7787ebd92f89dcbd$export$79b41aa5d56abdff;
var $7787ebd92f89dcbd$export$64f0bed4ae6f0f24;

var $cDZUo = parcelRequire("cDZUo");
var $7787ebd92f89dcbd$var$find = $cDZUo.find;
var $7787ebd92f89dcbd$var$NAMESPACE = $cDZUo.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $7787ebd92f89dcbd$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($7787ebd92f89dcbd$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $7787ebd92f89dcbd$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $7787ebd92f89dcbd$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $7787ebd92f89dcbd$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($7787ebd92f89dcbd$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $7787ebd92f89dcbd$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $7787ebd92f89dcbd$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $7787ebd92f89dcbd$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $7787ebd92f89dcbd$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $7787ebd92f89dcbd$var$NodeType = {};
var $7787ebd92f89dcbd$var$ELEMENT_NODE = $7787ebd92f89dcbd$var$NodeType.ELEMENT_NODE = 1;
var $7787ebd92f89dcbd$var$ATTRIBUTE_NODE = $7787ebd92f89dcbd$var$NodeType.ATTRIBUTE_NODE = 2;
var $7787ebd92f89dcbd$var$TEXT_NODE = $7787ebd92f89dcbd$var$NodeType.TEXT_NODE = 3;
var $7787ebd92f89dcbd$var$CDATA_SECTION_NODE = $7787ebd92f89dcbd$var$NodeType.CDATA_SECTION_NODE = 4;
var $7787ebd92f89dcbd$var$ENTITY_REFERENCE_NODE = $7787ebd92f89dcbd$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $7787ebd92f89dcbd$var$ENTITY_NODE = $7787ebd92f89dcbd$var$NodeType.ENTITY_NODE = 6;
var $7787ebd92f89dcbd$var$PROCESSING_INSTRUCTION_NODE = $7787ebd92f89dcbd$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $7787ebd92f89dcbd$var$COMMENT_NODE = $7787ebd92f89dcbd$var$NodeType.COMMENT_NODE = 8;
var $7787ebd92f89dcbd$var$DOCUMENT_NODE = $7787ebd92f89dcbd$var$NodeType.DOCUMENT_NODE = 9;
var $7787ebd92f89dcbd$var$DOCUMENT_TYPE_NODE = $7787ebd92f89dcbd$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE = $7787ebd92f89dcbd$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $7787ebd92f89dcbd$var$NOTATION_NODE = $7787ebd92f89dcbd$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $7787ebd92f89dcbd$var$ExceptionCode = {};
var $7787ebd92f89dcbd$var$ExceptionMessage = {};
var $7787ebd92f89dcbd$var$INDEX_SIZE_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INDEX_SIZE_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[1] = "Index size error", 1);
var $7787ebd92f89dcbd$var$DOMSTRING_SIZE_ERR = $7787ebd92f89dcbd$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[2] = "DOMString size error", 2);
var $7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR = $7787ebd92f89dcbd$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $7787ebd92f89dcbd$var$WRONG_DOCUMENT_ERR = $7787ebd92f89dcbd$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[4] = "Wrong document", 4);
var $7787ebd92f89dcbd$var$INVALID_CHARACTER_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INVALID_CHARACTER_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[5] = "Invalid character", 5);
var $7787ebd92f89dcbd$var$NO_DATA_ALLOWED_ERR = $7787ebd92f89dcbd$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[6] = "No data allowed", 6);
var $7787ebd92f89dcbd$var$NO_MODIFICATION_ALLOWED_ERR = $7787ebd92f89dcbd$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[7] = "No modification allowed", 7);
var $7787ebd92f89dcbd$var$NOT_FOUND_ERR = $7787ebd92f89dcbd$var$ExceptionCode.NOT_FOUND_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[8] = "Not found", 8);
var $7787ebd92f89dcbd$var$NOT_SUPPORTED_ERR = $7787ebd92f89dcbd$var$ExceptionCode.NOT_SUPPORTED_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[9] = "Not supported", 9);
var $7787ebd92f89dcbd$var$INUSE_ATTRIBUTE_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $7787ebd92f89dcbd$var$INVALID_STATE_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INVALID_STATE_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[11] = "Invalid state", 11);
var $7787ebd92f89dcbd$var$SYNTAX_ERR = $7787ebd92f89dcbd$var$ExceptionCode.SYNTAX_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[12] = "Syntax error", 12);
var $7787ebd92f89dcbd$var$INVALID_MODIFICATION_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[13] = "Invalid modification", 13);
var $7787ebd92f89dcbd$var$NAMESPACE_ERR = $7787ebd92f89dcbd$var$ExceptionCode.NAMESPACE_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $7787ebd92f89dcbd$var$INVALID_ACCESS_ERR = $7787ebd92f89dcbd$var$ExceptionCode.INVALID_ACCESS_ERR = ($7787ebd92f89dcbd$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $7787ebd92f89dcbd$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $7787ebd92f89dcbd$var$ExceptionMessage[code]);
        this.message = $7787ebd92f89dcbd$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7787ebd92f89dcbd$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$7787ebd92f89dcbd$var$DOMException.prototype = Error.prototype;
$7787ebd92f89dcbd$var$copy($7787ebd92f89dcbd$var$ExceptionCode, $7787ebd92f89dcbd$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $7787ebd92f89dcbd$var$NodeList() {}
$7787ebd92f89dcbd$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter) {
        for(var buf = [], i = 0; i < this.length; i++)$7787ebd92f89dcbd$var$serializeToString(this[i], buf, isHTML, nodeFilter);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $7787ebd92f89dcbd$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $7787ebd92f89dcbd$var$_updateLiveList(this);
}
function $7787ebd92f89dcbd$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $7787ebd92f89dcbd$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $7787ebd92f89dcbd$var$copy(ls, list);
        list._inc = inc;
    }
}
$7787ebd92f89dcbd$var$LiveNodeList.prototype.item = function(i) {
    $7787ebd92f89dcbd$var$_updateLiveList(this);
    return this[i] || null;
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$LiveNodeList, $7787ebd92f89dcbd$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $7787ebd92f89dcbd$var$NamedNodeMap() {}
function $7787ebd92f89dcbd$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $7787ebd92f89dcbd$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$7787ebd92f89dcbd$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $7787ebd92f89dcbd$var$_onRemoveAttribute(doc, el, oldAttr);
            $7787ebd92f89dcbd$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $7787ebd92f89dcbd$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $7787ebd92f89dcbd$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $7787ebd92f89dcbd$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$7787ebd92f89dcbd$var$NamedNodeMap.prototype = {
    length: 0,
    item: $7787ebd92f89dcbd$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $7787ebd92f89dcbd$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $7787ebd92f89dcbd$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $7787ebd92f89dcbd$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $7787ebd92f89dcbd$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $7787ebd92f89dcbd$var$DOMImplementation() {}
$7787ebd92f89dcbd$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $7787ebd92f89dcbd$var$Document();
        doc.implementation = this;
        doc.childNodes = new $7787ebd92f89dcbd$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $7787ebd92f89dcbd$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $7787ebd92f89dcbd$var$Node() {}
$7787ebd92f89dcbd$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $7787ebd92f89dcbd$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $7787ebd92f89dcbd$var$_insertBefore(this, newChild, oldChild, $7787ebd92f89dcbd$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $7787ebd92f89dcbd$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $7787ebd92f89dcbd$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    normalize: function() {
        var child = this.firstChild;
        while(child){
            var next = child.nextSibling;
            if (next && next.nodeType == $7787ebd92f89dcbd$var$TEXT_NODE && child.nodeType == $7787ebd92f89dcbd$var$TEXT_NODE) {
                this.removeChild(next);
                child.appendData(next.data);
            } else {
                child.normalize();
                child = next;
            }
        }
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $7787ebd92f89dcbd$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $7787ebd92f89dcbd$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $7787ebd92f89dcbd$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$7787ebd92f89dcbd$var$copy($7787ebd92f89dcbd$var$NodeType, $7787ebd92f89dcbd$var$Node);
$7787ebd92f89dcbd$var$copy($7787ebd92f89dcbd$var$NodeType, $7787ebd92f89dcbd$var$Node.prototype);
/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */ function $7787ebd92f89dcbd$var$_visitNode(node, callback) {
    if (callback(node)) return true;
    if (node = node.firstChild) do {
        if ($7787ebd92f89dcbd$var$_visitNode(node, callback)) return true;
    }while (node = node.nextSibling);
}
function $7787ebd92f89dcbd$var$Document() {
    this.ownerDocument = this;
}
function $7787ebd92f89dcbd$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $7787ebd92f89dcbd$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $7787ebd92f89dcbd$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $7787ebd92f89dcbd$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $7787ebd92f89dcbd$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $7787ebd92f89dcbd$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $7787ebd92f89dcbd$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_NODE || node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $7787ebd92f89dcbd$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$hasInsertableNodeType(node) {
    return node && ($7787ebd92f89dcbd$var$isElementNode(node) || $7787ebd92f89dcbd$var$isTextNode(node) || $7787ebd92f89dcbd$var$isDocTypeNode(node) || node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $7787ebd92f89dcbd$var$Node.COMMENT_NODE || node.nodeType === $7787ebd92f89dcbd$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$isDocTypeNode(node) {
    return node && node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$isElementNode(node) {
    return node && node.nodeType === $7787ebd92f89dcbd$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $7787ebd92f89dcbd$var$isTextNode(node) {
    return node && node.nodeType === $7787ebd92f89dcbd$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $7787ebd92f89dcbd$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isElementNode) || $7787ebd92f89dcbd$var$isDocTypeNode(child)) return false;
    var docTypeNode = $7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $7787ebd92f89dcbd$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $7787ebd92f89dcbd$var$isElementNode(node) && node !== child;
    }
    if ($7787ebd92f89dcbd$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $7787ebd92f89dcbd$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$7787ebd92f89dcbd$var$hasValidParentNodeType(parent)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$7787ebd92f89dcbd$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $7787ebd92f89dcbd$var$isDocTypeNode(node) && parent.nodeType !== $7787ebd92f89dcbd$var$Node.DOCUMENT_NODE) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $7787ebd92f89dcbd$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($7787ebd92f89dcbd$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $7787ebd92f89dcbd$var$find(nodeChildNodes, $7787ebd92f89dcbd$var$isTextNode)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$7787ebd92f89dcbd$var$isElementInsertionPossible(parent, child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($7787ebd92f89dcbd$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$7787ebd92f89dcbd$var$isElementInsertionPossible(parent, child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($7787ebd92f89dcbd$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isDocTypeNode)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $7787ebd92f89dcbd$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($7787ebd92f89dcbd$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $7787ebd92f89dcbd$var$find(nodeChildNodes, $7787ebd92f89dcbd$var$isTextNode)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$7787ebd92f89dcbd$var$isElementReplacementPossible(parent, child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($7787ebd92f89dcbd$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$7787ebd92f89dcbd$var$isElementReplacementPossible(parent, child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($7787ebd92f89dcbd$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $7787ebd92f89dcbd$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($7787ebd92f89dcbd$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $7787ebd92f89dcbd$var$find(parentChildNodes, $7787ebd92f89dcbd$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $7787ebd92f89dcbd$var$DOMException($7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $7787ebd92f89dcbd$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $7787ebd92f89dcbd$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $7787ebd92f89dcbd$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $7787ebd92f89dcbd$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $7787ebd92f89dcbd$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $7787ebd92f89dcbd$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $7787ebd92f89dcbd$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $7787ebd92f89dcbd$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $7787ebd92f89dcbd$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $7787ebd92f89dcbd$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $7787ebd92f89dcbd$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $7787ebd92f89dcbd$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$7787ebd92f89dcbd$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $7787ebd92f89dcbd$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $7787ebd92f89dcbd$var$_insertBefore(this, newChild, refChild);
        $7787ebd92f89dcbd$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $7787ebd92f89dcbd$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $7787ebd92f89dcbd$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $7787ebd92f89dcbd$var$_insertBefore(this, newChild, oldChild, $7787ebd92f89dcbd$var$assertPreReplacementValidityInDocument);
        $7787ebd92f89dcbd$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($7787ebd92f89dcbd$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $7787ebd92f89dcbd$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $7787ebd92f89dcbd$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $7787ebd92f89dcbd$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $7787ebd92f89dcbd$var$toOrderedSet(classNames);
        return new $7787ebd92f89dcbd$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $7787ebd92f89dcbd$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $7787ebd92f89dcbd$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $7787ebd92f89dcbd$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($7787ebd92f89dcbd$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $7787ebd92f89dcbd$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $7787ebd92f89dcbd$var$NodeList();
        var attrs = node.attributes = new $7787ebd92f89dcbd$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $7787ebd92f89dcbd$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $7787ebd92f89dcbd$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $7787ebd92f89dcbd$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $7787ebd92f89dcbd$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createCDATASection: function(data) {
        var node = new $7787ebd92f89dcbd$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createProcessingInstruction: function(target, data) {
        var node = new $7787ebd92f89dcbd$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $7787ebd92f89dcbd$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $7787ebd92f89dcbd$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $7787ebd92f89dcbd$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $7787ebd92f89dcbd$var$NamedNodeMap();
        node.childNodes = new $7787ebd92f89dcbd$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $7787ebd92f89dcbd$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Document, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$Element() {
    this._nsMap = {};
}
$7787ebd92f89dcbd$var$Element.prototype = {
    nodeType: $7787ebd92f89dcbd$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $7787ebd92f89dcbd$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $7787ebd92f89dcbd$var$LiveNodeList(this, function(base) {
            var ls = [];
            $7787ebd92f89dcbd$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $7787ebd92f89dcbd$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $7787ebd92f89dcbd$var$LiveNodeList(this, function(base) {
            var ls = [];
            $7787ebd92f89dcbd$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $7787ebd92f89dcbd$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$7787ebd92f89dcbd$var$Document.prototype.getElementsByTagName = $7787ebd92f89dcbd$var$Element.prototype.getElementsByTagName;
$7787ebd92f89dcbd$var$Document.prototype.getElementsByTagNameNS = $7787ebd92f89dcbd$var$Element.prototype.getElementsByTagNameNS;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Element, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$Attr() {}
$7787ebd92f89dcbd$var$Attr.prototype.nodeType = $7787ebd92f89dcbd$var$ATTRIBUTE_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Attr, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$CharacterData() {}
$7787ebd92f89dcbd$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($7787ebd92f89dcbd$var$ExceptionMessage[$7787ebd92f89dcbd$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$CharacterData, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$Text() {}
$7787ebd92f89dcbd$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $7787ebd92f89dcbd$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Text, $7787ebd92f89dcbd$var$CharacterData);
function $7787ebd92f89dcbd$var$Comment() {}
$7787ebd92f89dcbd$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $7787ebd92f89dcbd$var$COMMENT_NODE
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Comment, $7787ebd92f89dcbd$var$CharacterData);
function $7787ebd92f89dcbd$var$CDATASection() {}
$7787ebd92f89dcbd$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $7787ebd92f89dcbd$var$CDATA_SECTION_NODE
};
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$CDATASection, $7787ebd92f89dcbd$var$CharacterData);
function $7787ebd92f89dcbd$var$DocumentType() {}
$7787ebd92f89dcbd$var$DocumentType.prototype.nodeType = $7787ebd92f89dcbd$var$DOCUMENT_TYPE_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$DocumentType, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$Notation() {}
$7787ebd92f89dcbd$var$Notation.prototype.nodeType = $7787ebd92f89dcbd$var$NOTATION_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Notation, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$Entity() {}
$7787ebd92f89dcbd$var$Entity.prototype.nodeType = $7787ebd92f89dcbd$var$ENTITY_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$Entity, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$EntityReference() {}
$7787ebd92f89dcbd$var$EntityReference.prototype.nodeType = $7787ebd92f89dcbd$var$ENTITY_REFERENCE_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$EntityReference, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$DocumentFragment() {}
$7787ebd92f89dcbd$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$7787ebd92f89dcbd$var$DocumentFragment.prototype.nodeType = $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$DocumentFragment, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$ProcessingInstruction() {}
$7787ebd92f89dcbd$var$ProcessingInstruction.prototype.nodeType = $7787ebd92f89dcbd$var$PROCESSING_INSTRUCTION_NODE;
$7787ebd92f89dcbd$var$_extends($7787ebd92f89dcbd$var$ProcessingInstruction, $7787ebd92f89dcbd$var$Node);
function $7787ebd92f89dcbd$var$XMLSerializer() {}
$7787ebd92f89dcbd$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
    return $7787ebd92f89dcbd$var$nodeSerializeToString.call(node, isHtml, nodeFilter);
};
$7787ebd92f89dcbd$var$Node.prototype.toString = $7787ebd92f89dcbd$var$nodeSerializeToString;
function $7787ebd92f89dcbd$var$nodeSerializeToString(isHtml, nodeFilter) {
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $7787ebd92f89dcbd$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $7787ebd92f89dcbd$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $7787ebd92f89dcbd$var$NAMESPACE.XML || uri === $7787ebd92f89dcbd$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $7787ebd92f89dcbd$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $7787ebd92f89dcbd$var$_xmlEncoder), '"');
}
function $7787ebd92f89dcbd$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
    if (!visibleNamespaces) visibleNamespaces = [];
    if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
            if (typeof node == 'string') {
                buf.push(node);
                return;
            }
        } else return;
    //buf.sort.apply(attrs, attributeSorter);
    }
    switch(node.nodeType){
        case $7787ebd92f89dcbd$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var len = attrs.length;
            var child = node.firstChild;
            var nodeName = node.tagName;
            isHTML = $7787ebd92f89dcbd$var$NAMESPACE.isHTML(node.namespaceURI) || isHTML;
            var prefixedNodeName = nodeName;
            if (!isHTML && !node.prefix && node.namespaceURI) {
                var defaultNS;
                // lookup current default ns from `xmlns` attribute
                for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                    defaultNS = attrs.item(ai).value;
                    break;
                }
                if (!defaultNS) // lookup current default ns in visibleNamespaces
                for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
                        defaultNS = namespace.namespace;
                        break;
                    }
                }
                if (defaultNS !== node.namespaceURI) for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.namespace === node.namespaceURI) {
                        if (namespace.prefix) prefixedNodeName = namespace.prefix + ':' + nodeName;
                        break;
                    }
                }
            }
            buf.push('<', prefixedNodeName);
            for(var i = 0; i < len; i++){
                // add namespaces for attributes
                var attr = attrs.item(i);
                if (attr.prefix == 'xmlns') visibleNamespaces.push({
                    prefix: attr.localName,
                    namespace: attr.value
                });
                else if (attr.nodeName == 'xmlns') visibleNamespaces.push({
                    prefix: '',
                    namespace: attr.value
                });
            }
            for(var i = 0; i < len; i++){
                var attr = attrs.item(i);
                if ($7787ebd92f89dcbd$var$needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || '';
                    var uri = attr.namespaceURI;
                    $7787ebd92f89dcbd$var$addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
                    visibleNamespaces.push({
                        prefix: prefix,
                        namespace: uri
                    });
                }
                $7787ebd92f89dcbd$var$serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
            }
            // add namespace for current node
            if (nodeName === prefixedNodeName && $7787ebd92f89dcbd$var$needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                var prefix = node.prefix || '';
                var uri = node.namespaceURI;
                $7787ebd92f89dcbd$var$addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
                visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                });
            }
            if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                buf.push('>');
                //if is cdata child node
                if (isHTML && /^script$/i.test(nodeName)) while(child){
                    if (child.data) buf.push(child.data);
                    else $7787ebd92f89dcbd$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                else while(child){
                    $7787ebd92f89dcbd$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                buf.push('</', prefixedNodeName, '>');
            } else buf.push('/>');
            // remove added visible namespaces
            //visibleNamespaces.length = startVisibleNamespaces;
            return;
        case $7787ebd92f89dcbd$var$DOCUMENT_NODE:
        case $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE:
            var child = node.firstChild;
            while(child){
                $7787ebd92f89dcbd$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
            }
            return;
        case $7787ebd92f89dcbd$var$ATTRIBUTE_NODE:
            return $7787ebd92f89dcbd$var$addSerializedAttribute(buf, node.name, node.value);
        case $7787ebd92f89dcbd$var$TEXT_NODE:
            /**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */ return buf.push(node.data.replace(/[<&>]/g, $7787ebd92f89dcbd$var$_xmlEncoder));
        case $7787ebd92f89dcbd$var$CDATA_SECTION_NODE:
            return buf.push('<![CDATA[', node.data, ']]>');
        case $7787ebd92f89dcbd$var$COMMENT_NODE:
            return buf.push("<!--", node.data, "-->");
        case $7787ebd92f89dcbd$var$DOCUMENT_TYPE_NODE:
            var pubid = node.publicId;
            var sysid = node.systemId;
            buf.push('<!DOCTYPE ', node.name);
            if (pubid) {
                buf.push(' PUBLIC ', pubid);
                if (sysid && sysid != '.') buf.push(' ', sysid);
                buf.push('>');
            } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
            else {
                var sub = node.internalSubset;
                if (sub) buf.push(" [", sub, "]");
                buf.push(">");
            }
            return;
        case $7787ebd92f89dcbd$var$PROCESSING_INSTRUCTION_NODE:
            return buf.push("<?", node.target, " ", node.data, "?>");
        case $7787ebd92f89dcbd$var$ENTITY_REFERENCE_NODE:
            return buf.push('&', node.nodeName, ';');
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
            buf.push('??', node.nodeName);
    }
}
function $7787ebd92f89dcbd$var$importNode(doc, node, deep) {
    var node2;
    switch(node.nodeType){
        case $7787ebd92f89dcbd$var$ELEMENT_NODE:
            node2 = node.cloneNode(false);
            node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE:
            break;
        case $7787ebd92f89dcbd$var$ATTRIBUTE_NODE:
            deep = true;
            break;
    }
    if (!node2) node2 = node.cloneNode(false); //false
    node2.ownerDocument = doc;
    node2.parentNode = null;
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($7787ebd92f89dcbd$var$importNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $7787ebd92f89dcbd$var$cloneNode(doc, node, deep) {
    var node2 = new node.constructor();
    for(var n in node)if (Object.prototype.hasOwnProperty.call(node, n)) {
        var v = node[n];
        if (typeof v != "object") {
            if (v != node2[n]) node2[n] = v;
        }
    }
    if (node.childNodes) node2.childNodes = new $7787ebd92f89dcbd$var$NodeList();
    node2.ownerDocument = doc;
    switch(node2.nodeType){
        case $7787ebd92f89dcbd$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var attrs2 = node2.attributes = new $7787ebd92f89dcbd$var$NamedNodeMap();
            var len = attrs.length;
            attrs2._ownerElement = node2;
            for(var i = 0; i < len; i++)node2.setAttributeNode($7787ebd92f89dcbd$var$cloneNode(doc, attrs.item(i), true));
            break;
        case $7787ebd92f89dcbd$var$ATTRIBUTE_NODE:
            deep = true;
    }
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($7787ebd92f89dcbd$var$cloneNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
function $7787ebd92f89dcbd$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($7787ebd92f89dcbd$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $7787ebd92f89dcbd$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        Object.defineProperty($7787ebd92f89dcbd$var$Node.prototype, 'textContent', {
            get: function() {
                return getTextContent(this);
            },
            set: function(data) {
                switch(this.nodeType){
                    case $7787ebd92f89dcbd$var$ELEMENT_NODE:
                    case $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        function getTextContent(node) {
            switch(node.nodeType){
                case $7787ebd92f89dcbd$var$ELEMENT_NODE:
                case $7787ebd92f89dcbd$var$DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while(node){
                        if (node.nodeType !== 7 && node.nodeType !== 8) buf.push(getTextContent(node));
                        node = node.nextSibling;
                    }
                    return buf.join('');
                default:
                    return node.nodeValue;
            }
        }
        $7787ebd92f89dcbd$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$7787ebd92f89dcbd$export$d1d99cf900472499 = $7787ebd92f89dcbd$var$DocumentType;
$7787ebd92f89dcbd$export$fe58bcf938607f6a = $7787ebd92f89dcbd$var$DOMException;
$7787ebd92f89dcbd$export$455426655eab1d48 = $7787ebd92f89dcbd$var$DOMImplementation;
$7787ebd92f89dcbd$export$db77ccec0bb4ccac = $7787ebd92f89dcbd$var$Element;
$7787ebd92f89dcbd$export$85c928794f8d04d4 = $7787ebd92f89dcbd$var$Node;
$7787ebd92f89dcbd$export$79b41aa5d56abdff = $7787ebd92f89dcbd$var$NodeList;
$7787ebd92f89dcbd$export$64f0bed4ae6f0f24 = $7787ebd92f89dcbd$var$XMLSerializer; //}

});

parcelRegister("l0mWv", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $f4ab64ff85e10a3c$export$91f0e5ff03dc84f, (v) => $f4ab64ff85e10a3c$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $f4ab64ff85e10a3c$export$b7e4d4631df36afa, (v) => $f4ab64ff85e10a3c$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $f4ab64ff85e10a3c$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $f4ab64ff85e10a3c$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $f4ab64ff85e10a3c$export$79451380caed3f98;
'use strict';

var $cDZUo = parcelRequire("cDZUo");
var $f4ab64ff85e10a3c$require$freeze = $cDZUo.freeze;
$f4ab64ff85e10a3c$export$91f0e5ff03dc84f = $f4ab64ff85e10a3c$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$f4ab64ff85e10a3c$export$b7e4d4631df36afa = $f4ab64ff85e10a3c$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$f4ab64ff85e10a3c$export$79451380caed3f98 = $f4ab64ff85e10a3c$export$b7e4d4631df36afa;

});

parcelRegister("1tomy", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $112b65d2e3349bd3$export$ccbc9f9f018333e9, (v) => $112b65d2e3349bd3$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $112b65d2e3349bd3$export$f9c837a54db411d, (v) => $112b65d2e3349bd3$export$f9c837a54db411d = v);
var $112b65d2e3349bd3$export$ccbc9f9f018333e9;
var $112b65d2e3349bd3$export$f9c837a54db411d;

var $cDZUo = parcelRequire("cDZUo");
var $112b65d2e3349bd3$require$NAMESPACE = $cDZUo.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $112b65d2e3349bd3$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $112b65d2e3349bd3$var$nameChar = new RegExp("[\\-\\.0-9" + $112b65d2e3349bd3$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $112b65d2e3349bd3$var$tagNamePattern = new RegExp('^' + $112b65d2e3349bd3$var$nameStartChar.source + $112b65d2e3349bd3$var$nameChar.source + '*(?:\:' + $112b65d2e3349bd3$var$nameStartChar.source + $112b65d2e3349bd3$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $112b65d2e3349bd3$var$S_TAG = 0; //tag name offerring
var $112b65d2e3349bd3$var$S_ATTR = 1; //attr name offerring
var $112b65d2e3349bd3$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $112b65d2e3349bd3$var$S_EQ = 3; //=space?
var $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $112b65d2e3349bd3$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $112b65d2e3349bd3$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $112b65d2e3349bd3$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $112b65d2e3349bd3$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $112b65d2e3349bd3$var$ParseError);
}
$112b65d2e3349bd3$var$ParseError.prototype = new Error();
$112b65d2e3349bd3$var$ParseError.prototype.name = $112b65d2e3349bd3$var$ParseError.name;
function $112b65d2e3349bd3$var$XMLReader() {}
$112b65d2e3349bd3$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $112b65d2e3349bd3$var$_copy(defaultNSMap, defaultNSMap = {});
        $112b65d2e3349bd3$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $112b65d2e3349bd3$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $112b65d2e3349bd3$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $112b65d2e3349bd3$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $112b65d2e3349bd3$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $112b65d2e3349bd3$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $112b65d2e3349bd3$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $112b65d2e3349bd3$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $112b65d2e3349bd3$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($112b65d2e3349bd3$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($112b65d2e3349bd3$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($112b65d2e3349bd3$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $112b65d2e3349bd3$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $112b65d2e3349bd3$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $112b65d2e3349bd3$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $112b65d2e3349bd3$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $112b65d2e3349bd3$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $112b65d2e3349bd3$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $112b65d2e3349bd3$var$S_EQ;
                } else if (s === $112b65d2e3349bd3$var$S_ATTR_SPACE) s = $112b65d2e3349bd3$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $112b65d2e3349bd3$var$S_EQ || s === $112b65d2e3349bd3$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $112b65d2e3349bd3$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $112b65d2e3349bd3$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $112b65d2e3349bd3$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $112b65d2e3349bd3$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $112b65d2e3349bd3$var$S_ATTR_END:
                    case $112b65d2e3349bd3$var$S_TAG_SPACE:
                    case $112b65d2e3349bd3$var$S_TAG_CLOSE:
                        s = $112b65d2e3349bd3$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE:
                    case $112b65d2e3349bd3$var$S_ATTR:
                        break;
                    case $112b65d2e3349bd3$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $112b65d2e3349bd3$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $112b65d2e3349bd3$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $112b65d2e3349bd3$var$S_ATTR_END:
                    case $112b65d2e3349bd3$var$S_TAG_SPACE:
                    case $112b65d2e3349bd3$var$S_TAG_CLOSE:
                        break; //normal
                    case $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE:
                    case $112b65d2e3349bd3$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $112b65d2e3349bd3$var$S_ATTR_SPACE:
                        if (s === $112b65d2e3349bd3$var$S_ATTR_SPACE) value = attrName;
                        if (s == $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$112b65d2e3349bd3$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $112b65d2e3349bd3$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $112b65d2e3349bd3$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $112b65d2e3349bd3$var$S_TAG_SPACE;
                        break;
                    case $112b65d2e3349bd3$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $112b65d2e3349bd3$var$S_ATTR_SPACE;
                        break;
                    case $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $112b65d2e3349bd3$var$S_ATTR_END:
                        s = $112b65d2e3349bd3$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $112b65d2e3349bd3$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$112b65d2e3349bd3$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $112b65d2e3349bd3$var$S_ATTR;
                        break;
                    case $112b65d2e3349bd3$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $112b65d2e3349bd3$var$S_TAG_SPACE:
                        s = $112b65d2e3349bd3$var$S_ATTR;
                        start = p;
                        break;
                    case $112b65d2e3349bd3$var$S_EQ:
                        s = $112b65d2e3349bd3$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $112b65d2e3349bd3$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $112b65d2e3349bd3$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $112b65d2e3349bd3$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $112b65d2e3349bd3$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $112b65d2e3349bd3$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $112b65d2e3349bd3$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $112b65d2e3349bd3$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $112b65d2e3349bd3$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $112b65d2e3349bd3$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $112b65d2e3349bd3$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $112b65d2e3349bd3$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $112b65d2e3349bd3$var$ElementAttributes() {
    this.attributeNames = {};
}
$112b65d2e3349bd3$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$112b65d2e3349bd3$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$112b65d2e3349bd3$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $112b65d2e3349bd3$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$112b65d2e3349bd3$export$ccbc9f9f018333e9 = $112b65d2e3349bd3$var$XMLReader;
$112b65d2e3349bd3$export$f9c837a54db411d = $112b65d2e3349bd3$var$ParseError;

});


parcelRegister("jzHBA", function(module, exports) {

$parcel$export(module.exports, "EventSystem", () => $1244f7b22953290d$export$bf477d624b56bf15);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fit0D = parcelRequire("fit0D");

var $jpWqm = parcelRequire("jpWqm");

var $3QWP0 = parcelRequire("3QWP0");

var $a4OU2 = parcelRequire("a4OU2");
"use strict";
const $1244f7b22953290d$var$MOUSE_POINTER_ID = 1;
const $1244f7b22953290d$var$TOUCH_TO_POINTER = {
    touchstart: "pointerdown",
    touchend: "pointerup",
    touchendoutside: "pointerupoutside",
    touchmove: "pointermove",
    touchcancel: "pointercancel"
};
const $1244f7b22953290d$var$_EventSystem = class _EventSystem {
    /**
   * @param {Renderer} renderer
   */ constructor(renderer){
        /**
     * Indicates whether the current device supports touch events according to the W3C Touch Events spec.
     * This is used to determine the appropriate event handling strategy.
     * @see {@link https://www.w3.org/TR/touch-events/} W3C Touch Events Specification
     * @readonly
     * @default 'ontouchstart' in globalThis
     */ this.supportsTouchEvents = "ontouchstart" in globalThis;
        /**
     * Indicates whether the current device supports pointer events according to the W3C Pointer Events spec.
     * Used to optimize event handling and provide more consistent cross-device interaction.
     * @see {@link https://www.w3.org/TR/pointerevents/} W3C Pointer Events Specification
     * @readonly
     * @default !!globalThis.PointerEvent
     */ this.supportsPointerEvents = !!globalThis.PointerEvent;
        /**
     * The DOM element to which the root event listeners are bound. This is automatically set to
     * the renderer's {@link Renderer#view view}.
     */ this.domElement = null;
        /** The resolution used to convert between the DOM client space into world space. */ this.resolution = 1;
        this.renderer = renderer;
        this.rootBoundary = new (0, $fit0D.EventBoundary)(null);
        (0, $jpWqm.EventsTicker).init(this);
        this.autoPreventDefault = true;
        this._eventsAdded = false;
        this._rootPointerEvent = new (0, $3QWP0.FederatedPointerEvent)(null);
        this._rootWheelEvent = new (0, $a4OU2.FederatedWheelEvent)(null);
        this.cursorStyles = {
            default: "inherit",
            pointer: "pointer"
        };
        this.features = new Proxy({
            ..._EventSystem.defaultEventFeatures
        }, {
            set: (target, key, value)=>{
                if (key === "globalMove") this.rootBoundary.enableGlobalMoveEvents = value;
                target[key] = value;
                return true;
            }
        });
        this._onPointerDown = this._onPointerDown.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onPointerUp = this._onPointerUp.bind(this);
        this._onPointerOverOut = this._onPointerOverOut.bind(this);
        this.onWheel = this.onWheel.bind(this);
    }
    /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */ static get defaultEventMode() {
        return this._defaultEventMode;
    }
    /**
   * Runner init called, view is available at this point.
   * @ignore
   */ init(options) {
        const { canvas: canvas, resolution: resolution } = this.renderer;
        this.setTargetElement(canvas);
        this.resolution = resolution;
        _EventSystem._defaultEventMode = options.eventMode ?? "passive";
        Object.assign(this.features, options.eventFeatures ?? {});
        this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
    }
    /**
   * Handle changing resolution.
   * @ignore
   */ resolutionChange(resolution) {
        this.resolution = resolution;
    }
    /** Destroys all event listeners and detaches the renderer. */ destroy() {
        (0, $jpWqm.EventsTicker).destroy();
        this.setTargetElement(null);
        this.renderer = null;
        this._currentCursor = null;
    }
    /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * The cursor can be a CSS cursor string, a custom callback function, or a key from the cursorStyles dictionary.
   * @param mode - Cursor mode to set. Can be:
   * - A CSS cursor string (e.g., 'pointer', 'grab')
   * - A key from the cursorStyles dictionary
   * - null/undefined to reset to default
   * @example
   * ```ts
   * // Using predefined cursor styles
   * app.renderer.events.setCursor('pointer');    // Set standard pointer cursor
   * app.renderer.events.setCursor('grab');       // Set grab cursor
   * app.renderer.events.setCursor(null);         // Reset to default
   *
   * // Using custom cursor styles
   * app.renderer.events.cursorStyles.custom = 'url("cursor.png"), auto';
   * app.renderer.events.setCursor('custom');     // Apply custom cursor
   *
   * // Using callback-based cursor
   * app.renderer.events.cursorStyles.dynamic = (mode) => {
   *     document.body.style.cursor = mode === 'hover' ? 'pointer' : 'default';
   * };
   * app.renderer.events.setCursor('dynamic');    // Trigger cursor callback
   * ```
   * @remarks
   * - Has no effect on OffscreenCanvas except for callback-based cursors
   * - Caches current cursor to avoid unnecessary DOM updates
   * - Supports CSS cursor values, style objects, and callback functions
   * @see {@link EventSystem.cursorStyles} For defining custom cursor styles
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor} MDN Cursor Reference
   */ setCursor(mode) {
        mode || (mode = "default");
        let applyStyles = true;
        if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas) applyStyles = false;
        if (this._currentCursor === mode) return;
        this._currentCursor = mode;
        const style = this.cursorStyles[mode];
        if (style) switch(typeof style){
            case "string":
                if (applyStyles) this.domElement.style.cursor = style;
                break;
            case "function":
                style(mode);
                break;
            case "object":
                if (applyStyles) Object.assign(this.domElement.style, style);
                break;
        }
        else if (applyStyles && typeof mode === "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) this.domElement.style.cursor = mode;
    }
    /**
   * The global pointer event instance containing the most recent pointer state.
   * This is useful for accessing pointer information without listening to events.
   * @example
   * ```ts
   * // Access current pointer position at any time
   * const eventSystem = app.renderer.events;
   * const pointer = eventSystem.pointer;
   *
   * // Get global coordinates
   * console.log('Position:', pointer.global.x, pointer.global.y);
   *
   * // Check button state
   * console.log('Buttons pressed:', pointer.buttons);
   *
   * // Get pointer type and pressure
   * console.log('Type:', pointer.pointerType);
   * console.log('Pressure:', pointer.pressure);
   * ```
   * @readonly
   * @since 7.2.0
   * @see {@link FederatedPointerEvent} For all available pointer properties
   */ get pointer() {
        return this._rootPointerEvent;
    }
    /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ _onPointerDown(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const events = this._normalizeToPointerData(nativeEvent);
        if (this.autoPreventDefault && events[0].isNormalized) {
            const cancelable = nativeEvent.cancelable || !("cancelable" in nativeEvent);
            if (cancelable) nativeEvent.preventDefault();
        }
        for(let i = 0, j = events.length; i < j; i++){
            const nativeEvent2 = events[i];
            const federatedEvent = this._bootstrapEvent(this._rootPointerEvent, nativeEvent2);
            this.rootBoundary.mapEvent(federatedEvent);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */ _onPointerMove(nativeEvent) {
        if (!this.features.move) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        (0, $jpWqm.EventsTicker).pointerMoved();
        const normalizedEvents = this._normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this._bootstrapEvent(this._rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ _onPointerUp(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        let target = nativeEvent.target;
        if (nativeEvent.composedPath && nativeEvent.composedPath().length > 0) target = nativeEvent.composedPath()[0];
        const outside = target !== this.domElement ? "outside" : "";
        const normalizedEvents = this._normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this._bootstrapEvent(this._rootPointerEvent, normalizedEvents[i]);
            event.type += outside;
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ _onPointerOverOut(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const normalizedEvents = this._normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this._bootstrapEvent(this._rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */ onWheel(nativeEvent) {
        if (!this.features.wheel) return;
        const wheelEvent = this.normalizeWheelEvent(nativeEvent);
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        this.rootBoundary.mapEvent(wheelEvent);
    }
    /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   * This method manages the DOM event bindings for the event system, allowing you to
   * change or remove the target element that receives input events.
   * > [!IMPORTANT] This will default to the canvas element of the renderer, so you
   * > should not need to call this unless you are using a custom element.
   * @param element - The new DOM element to bind events to, or null to remove all event bindings
   * @example
   * ```ts
   * // Set a new canvas element as the target
   * const canvas = document.createElement('canvas');
   * app.renderer.events.setTargetElement(canvas);
   *
   * // Remove all event bindings
   * app.renderer.events.setTargetElement(null);
   *
   * // Switch to a different canvas
   * const newCanvas = document.querySelector('#game-canvas');
   * app.renderer.events.setTargetElement(newCanvas);
   * ```
   * @remarks
   * - Automatically removes event listeners from previous element
   * - Required for the event system to function
   * - Safe to call multiple times
   * @see {@link EventSystem#domElement} The current DOM element
   * @see {@link EventsTicker} For the ticker system that tracks pointer movement
   */ setTargetElement(element) {
        this._removeEvents();
        this.domElement = element;
        (0, $jpWqm.EventsTicker).domElement = element;
        this._addEvents();
    }
    /** Register event listeners on {@link Renderer#domElement this.domElement}. */ _addEvents() {
        if (this._eventsAdded || !this.domElement) return;
        (0, $jpWqm.EventsTicker).addTickerListener();
        const style = this.domElement.style;
        if (style) {
            if (globalThis.navigator.msPointerEnabled) {
                style.msContentZooming = "none";
                style.msTouchAction = "none";
            } else if (this.supportsPointerEvents) style.touchAction = "none";
        }
        if (this.supportsPointerEvents) {
            globalThis.document.addEventListener("pointermove", this._onPointerMove, true);
            this.domElement.addEventListener("pointerdown", this._onPointerDown, true);
            this.domElement.addEventListener("pointerleave", this._onPointerOverOut, true);
            this.domElement.addEventListener("pointerover", this._onPointerOverOut, true);
            globalThis.addEventListener("pointerup", this._onPointerUp, true);
        } else {
            globalThis.document.addEventListener("mousemove", this._onPointerMove, true);
            this.domElement.addEventListener("mousedown", this._onPointerDown, true);
            this.domElement.addEventListener("mouseout", this._onPointerOverOut, true);
            this.domElement.addEventListener("mouseover", this._onPointerOverOut, true);
            globalThis.addEventListener("mouseup", this._onPointerUp, true);
            if (this.supportsTouchEvents) {
                this.domElement.addEventListener("touchstart", this._onPointerDown, true);
                this.domElement.addEventListener("touchend", this._onPointerUp, true);
                this.domElement.addEventListener("touchmove", this._onPointerMove, true);
            }
        }
        this.domElement.addEventListener("wheel", this.onWheel, {
            passive: true,
            capture: true
        });
        this._eventsAdded = true;
    }
    /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */ _removeEvents() {
        if (!this._eventsAdded || !this.domElement) return;
        (0, $jpWqm.EventsTicker).removeTickerListener();
        const style = this.domElement.style;
        if (style) {
            if (globalThis.navigator.msPointerEnabled) {
                style.msContentZooming = "";
                style.msTouchAction = "";
            } else if (this.supportsPointerEvents) style.touchAction = "";
        }
        if (this.supportsPointerEvents) {
            globalThis.document.removeEventListener("pointermove", this._onPointerMove, true);
            this.domElement.removeEventListener("pointerdown", this._onPointerDown, true);
            this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, true);
            this.domElement.removeEventListener("pointerover", this._onPointerOverOut, true);
            globalThis.removeEventListener("pointerup", this._onPointerUp, true);
        } else {
            globalThis.document.removeEventListener("mousemove", this._onPointerMove, true);
            this.domElement.removeEventListener("mousedown", this._onPointerDown, true);
            this.domElement.removeEventListener("mouseout", this._onPointerOverOut, true);
            this.domElement.removeEventListener("mouseover", this._onPointerOverOut, true);
            globalThis.removeEventListener("mouseup", this._onPointerUp, true);
            if (this.supportsTouchEvents) {
                this.domElement.removeEventListener("touchstart", this._onPointerDown, true);
                this.domElement.removeEventListener("touchend", this._onPointerUp, true);
                this.domElement.removeEventListener("touchmove", this._onPointerMove, true);
            }
        }
        this.domElement.removeEventListener("wheel", this.onWheel, true);
        this.domElement = null;
        this._eventsAdded = false;
    }
    /**
   * Maps coordinates from DOM/screen space into PixiJS normalized coordinates.
   * This takes into account the current scale, position, and resolution of the DOM element.
   * @param point - The point to store the mapped coordinates in
   * @param x - The x coordinate in DOM/client space
   * @param y - The y coordinate in DOM/client space
   * @example
   * ```ts
   * // Map mouse coordinates to PixiJS space
   * const point = new Point();
   * app.renderer.events.mapPositionToPoint(
   *     point,
   *     event.clientX,
   *     event.clientY
   * );
   * console.log('Mapped position:', point.x, point.y);
   *
   * // Using with pointer events
   * sprite.on('pointermove', (event) => {
   *     // event.global already contains mapped coordinates
   *     console.log('Global:', event.global.x, event.global.y);
   *
   *     // Map to local coordinates
   *     const local = event.getLocalPosition(sprite);
   *     console.log('Local:', local.x, local.y);
   * });
   * ```
   * @remarks
   * - Accounts for element scaling and positioning
   * - Adjusts for device pixel ratio/resolution
   */ mapPositionToPoint(point, x, y) {
        const rect = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
            x: 0,
            y: 0,
            width: this.domElement.width,
            height: this.domElement.height,
            left: 0,
            top: 0
        };
        const resolutionMultiplier = 1 / this.resolution;
        point.x = (x - rect.left) * (this.domElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.domElement.height / rect.height) * resolutionMultiplier;
    }
    /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */ _normalizeToPointerData(event) {
        const normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(let i = 0, li = event.changedTouches.length; i < li; i++){
            const touch = event.changedTouches[i];
            if (typeof touch.button === "undefined") touch.button = 0;
            if (typeof touch.buttons === "undefined") touch.buttons = 1;
            if (typeof touch.isPrimary === "undefined") touch.isPrimary = event.touches.length === 1 && event.type === "touchstart";
            if (typeof touch.width === "undefined") touch.width = touch.radiusX || 1;
            if (typeof touch.height === "undefined") touch.height = touch.radiusY || 1;
            if (typeof touch.tiltX === "undefined") touch.tiltX = 0;
            if (typeof touch.tiltY === "undefined") touch.tiltY = 0;
            if (typeof touch.pointerType === "undefined") touch.pointerType = "touch";
            if (typeof touch.pointerId === "undefined") touch.pointerId = touch.identifier || 0;
            if (typeof touch.pressure === "undefined") touch.pressure = touch.force || 0.5;
            if (typeof touch.twist === "undefined") touch.twist = 0;
            if (typeof touch.tangentialPressure === "undefined") touch.tangentialPressure = 0;
            if (typeof touch.layerX === "undefined") touch.layerX = touch.offsetX = touch.clientX;
            if (typeof touch.layerY === "undefined") touch.layerY = touch.offsetY = touch.clientY;
            touch.isNormalized = true;
            touch.type = event.type;
            normalizedEvents.push(touch);
        }
        else if (!globalThis.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof globalThis.PointerEvent))) {
            const tempEvent = event;
            if (typeof tempEvent.isPrimary === "undefined") tempEvent.isPrimary = true;
            if (typeof tempEvent.width === "undefined") tempEvent.width = 1;
            if (typeof tempEvent.height === "undefined") tempEvent.height = 1;
            if (typeof tempEvent.tiltX === "undefined") tempEvent.tiltX = 0;
            if (typeof tempEvent.tiltY === "undefined") tempEvent.tiltY = 0;
            if (typeof tempEvent.pointerType === "undefined") tempEvent.pointerType = "mouse";
            if (typeof tempEvent.pointerId === "undefined") tempEvent.pointerId = $1244f7b22953290d$var$MOUSE_POINTER_ID;
            if (typeof tempEvent.pressure === "undefined") tempEvent.pressure = 0.5;
            if (typeof tempEvent.twist === "undefined") tempEvent.twist = 0;
            if (typeof tempEvent.tangentialPressure === "undefined") tempEvent.tangentialPressure = 0;
            tempEvent.isNormalized = true;
            normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */ normalizeWheelEvent(nativeEvent) {
        const event = this._rootWheelEvent;
        this._transferMouseData(event, nativeEvent);
        event.deltaX = nativeEvent.deltaX;
        event.deltaY = nativeEvent.deltaY;
        event.deltaZ = nativeEvent.deltaZ;
        event.deltaMode = nativeEvent.deltaMode;
        this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY);
        event.global.copyFrom(event.screen);
        event.offset.copyFrom(event.screen);
        event.nativeEvent = nativeEvent;
        event.type = nativeEvent.type;
        return event;
    }
    /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */ _bootstrapEvent(event, nativeEvent) {
        event.originalEvent = null;
        event.nativeEvent = nativeEvent;
        event.pointerId = nativeEvent.pointerId;
        event.width = nativeEvent.width;
        event.height = nativeEvent.height;
        event.isPrimary = nativeEvent.isPrimary;
        event.pointerType = nativeEvent.pointerType;
        event.pressure = nativeEvent.pressure;
        event.tangentialPressure = nativeEvent.tangentialPressure;
        event.tiltX = nativeEvent.tiltX;
        event.tiltY = nativeEvent.tiltY;
        event.twist = nativeEvent.twist;
        this._transferMouseData(event, nativeEvent);
        this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY);
        event.global.copyFrom(event.screen);
        event.offset.copyFrom(event.screen);
        event.isTrusted = nativeEvent.isTrusted;
        if (event.type === "pointerleave") event.type = "pointerout";
        if (event.type.startsWith("mouse")) event.type = event.type.replace("mouse", "pointer");
        if (event.type.startsWith("touch")) event.type = $1244f7b22953290d$var$TOUCH_TO_POINTER[event.type] || event.type;
        return event;
    }
    /**
   * Transfers base & mouse event data from the `nativeEvent` to the federated event.
   * @param event
   * @param nativeEvent
   */ _transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted;
        event.srcElement = nativeEvent.srcElement;
        event.timeStamp = performance.now();
        event.type = nativeEvent.type;
        event.altKey = nativeEvent.altKey;
        event.button = nativeEvent.button;
        event.buttons = nativeEvent.buttons;
        event.client.x = nativeEvent.clientX;
        event.client.y = nativeEvent.clientY;
        event.ctrlKey = nativeEvent.ctrlKey;
        event.metaKey = nativeEvent.metaKey;
        event.movement.x = nativeEvent.movementX;
        event.movement.y = nativeEvent.movementY;
        event.page.x = nativeEvent.pageX;
        event.page.y = nativeEvent.pageY;
        event.relatedTarget = null;
        event.shiftKey = nativeEvent.shiftKey;
    }
};
/** @ignore */ $1244f7b22953290d$var$_EventSystem.extension = {
    name: "events",
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    priority: -1
};
/**
 * The event features that are enabled by the EventSystem
 * @since 7.2.0
 * @example
 * ```ts
 * import { EventSystem, EventSystemFeatures } from 'pixi.js';
 * // Access the default event features
 * EventSystem.defaultEventFeatures = {
 *     // Enable pointer movement events
 *     move: true,
 *     // Enable global pointer move events
 *     globalMove: true,
 *     // Enable click events
 *     click: true,
 *     // Enable wheel events
 *     wheel: true,
 * };
 * ```
 */ $1244f7b22953290d$var$_EventSystem.defaultEventFeatures = {
    /** Enables pointer events associated with pointer movement. */ move: true,
    /** Enables global pointer move events. */ globalMove: true,
    /** Enables pointer events associated with clicking. */ click: true,
    /** Enables wheel events. */ wheel: true
};
let $1244f7b22953290d$export$bf477d624b56bf15 = $1244f7b22953290d$var$_EventSystem;

});
parcelRegister("fit0D", function(module, exports) {

$parcel$export(module.exports, "EventBoundary", () => $65251e3f8c7608ab$export$532e8c243078d2cd);

var $6AQ4q = parcelRequire("6AQ4q");

var $ds7Xo = parcelRequire("ds7Xo");

var $1RpxL = parcelRequire("1RpxL");

var $jpWqm = parcelRequire("jpWqm");

var $ZTBXt = parcelRequire("ZTBXt");

var $3QWP0 = parcelRequire("3QWP0");

var $a4OU2 = parcelRequire("a4OU2");
"use strict";
const $65251e3f8c7608ab$var$PROPAGATION_LIMIT = 2048;
const $65251e3f8c7608ab$var$tempHitLocation = new (0, $ds7Xo.Point)();
const $65251e3f8c7608ab$var$tempLocalMapping = new (0, $ds7Xo.Point)();
class $65251e3f8c7608ab$export$532e8c243078d2cd {
    /**
   * @param rootTarget - The holder of the event boundary.
   */ constructor(rootTarget){
        /**
     * Emits events after they were dispatched into the scene graph.
     *
     * This can be used for global events listening, regardless of the scene graph being used. It should
     * not be used by interactive libraries for normal use.
     *
     * Special events that do not bubble all the way to the root target are not emitted from here,
     * e.g. pointerenter, pointerleave, click.
     */ this.dispatch = new (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q)))();
        /**
     * This flag would emit `pointermove`, `touchmove`, and `mousemove` events on all Containers.
     *
     * The `moveOnAll` semantics mirror those of earlier versions of PixiJS. This was disabled in favor of
     * the Pointer Event API's approach.
     */ this.moveOnAll = false;
        /** Enables the global move events. `globalpointermove`, `globaltouchmove`, and `globalmousemove` */ this.enableGlobalMoveEvents = true;
        /**
     * State object for mapping methods.
     * @see EventBoundary#trackingData
     */ this.mappingState = {
            trackingData: {}
        };
        /**
     * The event pool maps event constructors to an free pool of instances of those specific events.
     * @see EventBoundary#allocateEvent
     * @see EventBoundary#freeEvent
     */ this.eventPool = /* @__PURE__ */ new Map();
        /** Every interactive element gathered from the scene. Only used in `pointermove` */ this._allInteractiveElements = [];
        /** Every element that passed the hit test. Only used in `pointermove` */ this._hitElements = [];
        /** Whether or not to collect all the interactive elements from the scene. Enabled in `pointermove` */ this._isPointerMoveEvent = false;
        this.rootTarget = rootTarget;
        this.hitPruneFn = this.hitPruneFn.bind(this);
        this.hitTestFn = this.hitTestFn.bind(this);
        this.mapPointerDown = this.mapPointerDown.bind(this);
        this.mapPointerMove = this.mapPointerMove.bind(this);
        this.mapPointerOut = this.mapPointerOut.bind(this);
        this.mapPointerOver = this.mapPointerOver.bind(this);
        this.mapPointerUp = this.mapPointerUp.bind(this);
        this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this);
        this.mapWheel = this.mapWheel.bind(this);
        this.mappingTable = {};
        this.addEventMapping("pointerdown", this.mapPointerDown);
        this.addEventMapping("pointermove", this.mapPointerMove);
        this.addEventMapping("pointerout", this.mapPointerOut);
        this.addEventMapping("pointerleave", this.mapPointerOut);
        this.addEventMapping("pointerover", this.mapPointerOver);
        this.addEventMapping("pointerup", this.mapPointerUp);
        this.addEventMapping("pointerupoutside", this.mapPointerUpOutside);
        this.addEventMapping("wheel", this.mapWheel);
    }
    /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */ addEventMapping(type, fn) {
        if (!this.mappingTable[type]) this.mappingTable[type] = [];
        this.mappingTable[type].push({
            fn: fn,
            priority: 0
        });
        this.mappingTable[type].sort((a, b)=>a.priority - b.priority);
    }
    /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */ dispatchEvent(e, type) {
        e.propagationStopped = false;
        e.propagationImmediatelyStopped = false;
        this.propagate(e, type);
        this.dispatch.emit(type || e.type, e);
    }
    /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */ mapEvent(e) {
        if (!this.rootTarget) return;
        const mappers = this.mappingTable[e.type];
        if (mappers) for(let i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
        else (0, $1RpxL.warn)(`[EventBoundary]: Event mapping not defined for ${e.type}`);
    }
    /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */ hitTest(x, y) {
        (0, $jpWqm.EventsTicker).pauseUpdate = true;
        const useMove = this._isPointerMoveEvent && this.enableGlobalMoveEvents;
        const fn = useMove ? "hitTestMoveRecursive" : "hitTestRecursive";
        const invertedPath = this[fn](this.rootTarget, this.rootTarget.eventMode, $65251e3f8c7608ab$var$tempHitLocation.set(x, y), this.hitTestFn, this.hitPruneFn);
        return invertedPath && invertedPath[0];
    }
    /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target `e.target`.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */ propagate(e, type) {
        if (!e.target) return;
        const composedPath = e.composedPath();
        e.eventPhase = e.CAPTURING_PHASE;
        for(let i = 0, j = composedPath.length - 1; i < j; i++){
            e.currentTarget = composedPath[i];
            this.notifyTarget(e, type);
            if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
        e.eventPhase = e.AT_TARGET;
        e.currentTarget = e.target;
        this.notifyTarget(e, type);
        if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        e.eventPhase = e.BUBBLING_PHASE;
        for(let i = composedPath.length - 2; i >= 0; i--){
            e.currentTarget = composedPath[i];
            this.notifyTarget(e, type);
            if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
    }
    /**
   * Emits the event `e` to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */ all(e, type, targets = this._allInteractiveElements) {
        if (targets.length === 0) return;
        e.eventPhase = e.BUBBLING_PHASE;
        const events = Array.isArray(type) ? type : [
            type
        ];
        for(let i = targets.length - 1; i >= 0; i--)events.forEach((event)=>{
            e.currentTarget = targets[i];
            this.notifyTarget(e, event);
        });
    }
    /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * `target`. The last element in the path is `target`.
   * @param target - The target to find the propagation path to.
   */ propagationPath(target) {
        const propagationPath = [
            target
        ];
        for(let i = 0; i < $65251e3f8c7608ab$var$PROPAGATION_LIMIT && target !== this.rootTarget && target.parent; i++){
            if (!target.parent) throw new Error("Cannot find propagation path to disconnected target");
            propagationPath.push(target.parent);
            target = target.parent;
        }
        propagationPath.reverse();
        return propagationPath;
    }
    hitTestMoveRecursive(currentTarget, eventMode, location, testFn, pruneFn, ignore = false) {
        let shouldReturn = false;
        if (this._interactivePrune(currentTarget)) return null;
        if (currentTarget.eventMode === "dynamic" || eventMode === "dynamic") (0, $jpWqm.EventsTicker).pauseUpdate = false;
        if (currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i];
                const nestedHit = this.hitTestMoveRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn, ignore || pruneFn(currentTarget, location));
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    if (nestedHit.length > 0 || isInteractive) {
                        if (isInteractive) this._allInteractiveElements.push(currentTarget);
                        nestedHit.push(currentTarget);
                    }
                    if (this._hitElements.length === 0) this._hitElements = nestedHit;
                    shouldReturn = true;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode);
        const isInteractiveTarget = currentTarget.isInteractive();
        if (isInteractiveTarget && isInteractiveTarget) this._allInteractiveElements.push(currentTarget);
        if (ignore || this._hitElements.length > 0) return null;
        if (shouldReturn) return this._hitElements;
        if (isInteractiveMode && !pruneFn(currentTarget, location) && testFn(currentTarget, location)) return isInteractiveTarget ? [
            currentTarget
        ] : [];
        return null;
    }
    /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */ hitTestRecursive(currentTarget, eventMode, location, testFn, pruneFn) {
        if (this._interactivePrune(currentTarget) || pruneFn(currentTarget, location)) return null;
        if (currentTarget.eventMode === "dynamic" || eventMode === "dynamic") (0, $jpWqm.EventsTicker).pauseUpdate = false;
        if (currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            const relativeLocation = location;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i];
                const nestedHit = this.hitTestRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, relativeLocation, testFn, pruneFn);
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    if (nestedHit.length > 0 || isInteractive) nestedHit.push(currentTarget);
                    return nestedHit;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode);
        const isInteractiveTarget = currentTarget.isInteractive();
        if (isInteractiveMode && testFn(currentTarget, location)) return isInteractiveTarget ? [
            currentTarget
        ] : [];
        return null;
    }
    _isInteractive(int) {
        return int === "static" || int === "dynamic";
    }
    _interactivePrune(container) {
        if (!container || !container.visible || !container.renderable || !container.measurable) return true;
        if (container.eventMode === "none") return true;
        if (container.eventMode === "passive" && !container.interactiveChildren) return true;
        return false;
    }
    /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */ hitPruneFn(container, location) {
        if (container.hitArea) {
            container.worldTransform.applyInverse(location, $65251e3f8c7608ab$var$tempLocalMapping);
            if (!container.hitArea.contains($65251e3f8c7608ab$var$tempLocalMapping.x, $65251e3f8c7608ab$var$tempLocalMapping.y)) return true;
        }
        if (container.effects && container.effects.length) for(let i = 0; i < container.effects.length; i++){
            const effect = container.effects[i];
            if (effect.containsPoint) {
                const effectContainsPoint = effect.containsPoint(location, this.hitTestFn);
                if (!effectContainsPoint) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */ hitTestFn(container, location) {
        if (container.hitArea) return true;
        if (container?.containsPoint) {
            container.worldTransform.applyInverse(location, $65251e3f8c7608ab$var$tempLocalMapping);
            return container.containsPoint($65251e3f8c7608ab$var$tempLocalMapping);
        }
        return false;
    }
    /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */ notifyTarget(e, type) {
        if (!e.currentTarget.isInteractive()) return;
        type ?? (type = e.type);
        const handlerKey = `on${type}`;
        e.currentTarget[handlerKey]?.(e);
        const key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${type}capture` : type;
        this._notifyListeners(e, key);
        if (e.eventPhase === e.AT_TARGET) this._notifyListeners(e, type);
    }
    /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */ mapPointerDown(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const e = this.createPointerEvent(from);
        this.dispatchEvent(e, "pointerdown");
        if (e.pointerType === "touch") this.dispatchEvent(e, "touchstart");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightdown" : "mousedown");
        }
        const trackingData = this.trackingData(from.pointerId);
        trackingData.pressTargetsByButton[from.button] = e.composedPath();
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */ mapPointerMove(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        this._allInteractiveElements.length = 0;
        this._hitElements.length = 0;
        this._isPointerMoveEvent = true;
        const e = this.createPointerEvent(from);
        this._isPointerMoveEvent = false;
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        const trackingData = this.trackingData(from.pointerId);
        const outTarget = this.findMountedTarget(trackingData.overTargets);
        if (trackingData.overTargets?.length > 0 && outTarget !== e.target) {
            const outType = from.type === "mousemove" ? "mouseout" : "pointerout";
            const outEvent = this.createPointerEvent(from, outType, outTarget);
            this.dispatchEvent(outEvent, "pointerout");
            if (isMouse) this.dispatchEvent(outEvent, "mouseout");
            if (!e.composedPath().includes(outTarget)) {
                const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
                leaveEvent.eventPhase = leaveEvent.AT_TARGET;
                while(leaveEvent.target && !e.composedPath().includes(leaveEvent.target)){
                    leaveEvent.currentTarget = leaveEvent.target;
                    this.notifyTarget(leaveEvent);
                    if (isMouse) this.notifyTarget(leaveEvent, "mouseleave");
                    leaveEvent.target = leaveEvent.target.parent;
                }
                this.freeEvent(leaveEvent);
            }
            this.freeEvent(outEvent);
        }
        if (outTarget !== e.target) {
            const overType = from.type === "mousemove" ? "mouseover" : "pointerover";
            const overEvent = this.clonePointerEvent(e, overType);
            this.dispatchEvent(overEvent, "pointerover");
            if (isMouse) this.dispatchEvent(overEvent, "mouseover");
            let overTargetAncestor = outTarget?.parent;
            while(overTargetAncestor && overTargetAncestor !== this.rootTarget.parent){
                if (overTargetAncestor === e.target) break;
                overTargetAncestor = overTargetAncestor.parent;
            }
            const didPointerEnter = !overTargetAncestor || overTargetAncestor === this.rootTarget.parent;
            if (didPointerEnter) {
                const enterEvent = this.clonePointerEvent(e, "pointerenter");
                enterEvent.eventPhase = enterEvent.AT_TARGET;
                while(enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== this.rootTarget.parent){
                    enterEvent.currentTarget = enterEvent.target;
                    this.notifyTarget(enterEvent);
                    if (isMouse) this.notifyTarget(enterEvent, "mouseenter");
                    enterEvent.target = enterEvent.target.parent;
                }
                this.freeEvent(enterEvent);
            }
            this.freeEvent(overEvent);
        }
        const allMethods = [];
        const allowGlobalPointerEvents = this.enableGlobalMoveEvents ?? true;
        this.moveOnAll ? allMethods.push("pointermove") : this.dispatchEvent(e, "pointermove");
        allowGlobalPointerEvents && allMethods.push("globalpointermove");
        if (e.pointerType === "touch") {
            this.moveOnAll ? allMethods.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove");
            allowGlobalPointerEvents && allMethods.push("globaltouchmove");
        }
        if (isMouse) {
            this.moveOnAll ? allMethods.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove");
            allowGlobalPointerEvents && allMethods.push("globalmousemove");
            this.cursor = e.target?.cursor;
        }
        if (allMethods.length > 0) this.all(e, allMethods);
        this._allInteractiveElements.length = 0;
        this._hitElements.length = 0;
        trackingData.overTargets = e.composedPath();
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */ mapPointerOver(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        const e = this.createPointerEvent(from);
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        this.dispatchEvent(e, "pointerover");
        if (isMouse) this.dispatchEvent(e, "mouseover");
        if (e.pointerType === "mouse") this.cursor = e.target?.cursor;
        const enterEvent = this.clonePointerEvent(e, "pointerenter");
        enterEvent.eventPhase = enterEvent.AT_TARGET;
        while(enterEvent.target && enterEvent.target !== this.rootTarget.parent){
            enterEvent.currentTarget = enterEvent.target;
            this.notifyTarget(enterEvent);
            if (isMouse) this.notifyTarget(enterEvent, "mouseenter");
            enterEvent.target = enterEvent.target.parent;
        }
        trackingData.overTargets = e.composedPath();
        this.freeEvent(e);
        this.freeEvent(enterEvent);
    }
    /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */ mapPointerOut(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        if (trackingData.overTargets) {
            const isMouse = from.pointerType === "mouse" || from.pointerType === "pen";
            const outTarget = this.findMountedTarget(trackingData.overTargets);
            const outEvent = this.createPointerEvent(from, "pointerout", outTarget);
            this.dispatchEvent(outEvent);
            if (isMouse) this.dispatchEvent(outEvent, "mouseout");
            const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
            leaveEvent.eventPhase = leaveEvent.AT_TARGET;
            while(leaveEvent.target && leaveEvent.target !== this.rootTarget.parent){
                leaveEvent.currentTarget = leaveEvent.target;
                this.notifyTarget(leaveEvent);
                if (isMouse) this.notifyTarget(leaveEvent, "mouseleave");
                leaveEvent.target = leaveEvent.target.parent;
            }
            trackingData.overTargets = null;
            this.freeEvent(outEvent);
            this.freeEvent(leaveEvent);
        }
        this.cursor = null;
    }
    /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */ mapPointerUp(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const now = performance.now();
        const e = this.createPointerEvent(from);
        this.dispatchEvent(e, "pointerup");
        if (e.pointerType === "touch") this.dispatchEvent(e, "touchend");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightup" : "mouseup");
        }
        const trackingData = this.trackingData(from.pointerId);
        const pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        let clickTarget = pressTarget;
        if (pressTarget && !e.composedPath().includes(pressTarget)) {
            let currentTarget = pressTarget;
            while(currentTarget && !e.composedPath().includes(currentTarget)){
                e.currentTarget = currentTarget;
                this.notifyTarget(e, "pointerupoutside");
                if (e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") {
                    const isRightButton = e.button === 2;
                    this.notifyTarget(e, isRightButton ? "rightupoutside" : "mouseupoutside");
                }
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button];
            clickTarget = currentTarget;
        }
        if (clickTarget) {
            const clickEvent = this.clonePointerEvent(e, "click");
            clickEvent.target = clickTarget;
            clickEvent.path = null;
            if (!trackingData.clicksByButton[from.button]) trackingData.clicksByButton[from.button] = {
                clickCount: 0,
                target: clickEvent.target,
                timeStamp: now
            };
            const clickHistory = trackingData.clicksByButton[from.button];
            if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < 200) ++clickHistory.clickCount;
            else clickHistory.clickCount = 1;
            clickHistory.target = clickEvent.target;
            clickHistory.timeStamp = now;
            clickEvent.detail = clickHistory.clickCount;
            if (clickEvent.pointerType === "mouse") {
                const isRightButton = clickEvent.button === 2;
                this.dispatchEvent(clickEvent, isRightButton ? "rightclick" : "click");
            } else if (clickEvent.pointerType === "touch") this.dispatchEvent(clickEvent, "tap");
            this.dispatchEvent(clickEvent, "pointertap");
            this.freeEvent(clickEvent);
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */ mapPointerUpOutside(from) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        const pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        const e = this.createPointerEvent(from);
        if (pressTarget) {
            let currentTarget = pressTarget;
            while(currentTarget){
                e.currentTarget = currentTarget;
                this.notifyTarget(e, "pointerupoutside");
                if (e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") this.notifyTarget(e, e.button === 2 ? "rightupoutside" : "mouseupoutside");
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button];
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */ mapWheel(from) {
        if (!(from instanceof (0, $a4OU2.FederatedWheelEvent))) {
            (0, $1RpxL.warn)("EventBoundary cannot map a non-wheel event as a wheel event");
            return;
        }
        const wheelEvent = this.createWheelEvent(from);
        this.dispatchEvent(wheelEvent);
        this.freeEvent(wheelEvent);
    }
    /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */ findMountedTarget(propagationPath) {
        if (!propagationPath) return null;
        let currentTarget = propagationPath[0];
        for(let i = 1; i < propagationPath.length; i++){
            if (propagationPath[i].parent === currentTarget) currentTarget = propagationPath[i];
            else break;
        }
        return currentTarget;
    }
    /**
   * Creates an event whose `originalEvent` is `from`, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The `originalEvent` for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */ createPointerEvent(from, type, target) {
        const event = this.allocateEvent((0, $3QWP0.FederatedPointerEvent));
        this.copyPointerData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from;
        event.target = target ?? this.hitTest(event.global.x, event.global.y) ?? this._hitElements[0];
        if (typeof type === "string") event.type = type;
        return event;
    }
    /**
   * Creates a wheel event whose `originalEvent` is `from`.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */ createWheelEvent(from) {
        const event = this.allocateEvent((0, $a4OU2.FederatedWheelEvent));
        this.copyWheelData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from;
        event.target = this.hitTest(event.global.x, event.global.y);
        return event;
    }
    /**
   * Clones the event `from`, with an optional `type` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */ clonePointerEvent(from, type) {
        const event = this.allocateEvent((0, $3QWP0.FederatedPointerEvent));
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from.originalEvent;
        this.copyPointerData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.target = from.target;
        event.path = from.composedPath().slice();
        event.type = type ?? event.type;
        return event;
    }
    /**
   * Copies wheel {@link FederatedWheelEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyWheelData(from, to) {
        to.deltaMode = from.deltaMode;
        to.deltaX = from.deltaX;
        to.deltaY = from.deltaY;
        to.deltaZ = from.deltaZ;
    }
    /**
   * Copies pointer {@link FederatedPointerEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyPointerData(from, to) {
        if (!(from instanceof (0, $3QWP0.FederatedPointerEvent) && to instanceof (0, $3QWP0.FederatedPointerEvent))) return;
        to.pointerId = from.pointerId;
        to.width = from.width;
        to.height = from.height;
        to.isPrimary = from.isPrimary;
        to.pointerType = from.pointerType;
        to.pressure = from.pressure;
        to.tangentialPressure = from.tangentialPressure;
        to.tiltX = from.tiltX;
        to.tiltY = from.tiltY;
        to.twist = from.twist;
    }
    /**
   * Copies mouse {@link FederatedMouseEvent} data from `from` to `to`.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyMouseData(from, to) {
        if (!(from instanceof (0, $ZTBXt.FederatedMouseEvent) && to instanceof (0, $ZTBXt.FederatedMouseEvent))) return;
        to.altKey = from.altKey;
        to.button = from.button;
        to.buttons = from.buttons;
        to.client.copyFrom(from.client);
        to.ctrlKey = from.ctrlKey;
        to.metaKey = from.metaKey;
        to.movement.copyFrom(from.movement);
        to.screen.copyFrom(from.screen);
        to.shiftKey = from.shiftKey;
        to.global.copyFrom(from.global);
    }
    /**
   * Copies base {@link FederatedEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyData(from, to) {
        to.isTrusted = from.isTrusted;
        to.srcElement = from.srcElement;
        to.timeStamp = performance.now();
        to.type = from.type;
        to.detail = from.detail;
        to.view = from.view;
        to.which = from.which;
        to.layer.copyFrom(from.layer);
        to.page.copyFrom(from.page);
    }
    /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */ trackingData(id) {
        if (!this.mappingState.trackingData[id]) this.mappingState.trackingData[id] = {
            pressTargetsByButton: {},
            clicksByButton: {},
            overTarget: null
        };
        return this.mappingState.trackingData[id];
    }
    /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   * @returns An event of the given type.
   */ allocateEvent(constructor) {
        if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
        const event = this.eventPool.get(constructor).pop() || new constructor(this);
        event.eventPhase = event.NONE;
        event.currentTarget = null;
        event.defaultPrevented = false;
        event.path = null;
        event.target = null;
        return event;
    }
    /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */ freeEvent(event) {
        if (event.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
        const constructor = event.constructor;
        if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
        this.eventPool.get(constructor).push(event);
    }
    /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */ _notifyListeners(e, type) {
        const listeners = e.currentTarget._events[type];
        if (!listeners) return;
        if ("fn" in listeners) {
            if (listeners.once) e.currentTarget.removeListener(type, listeners.fn, void 0, true);
            listeners.fn.call(listeners.context, e);
        } else for(let i = 0, j = listeners.length; i < j && !e.propagationImmediatelyStopped; i++){
            if (listeners[i].once) e.currentTarget.removeListener(type, listeners[i].fn, void 0, true);
            listeners[i].fn.call(listeners[i].context, e);
        }
    }
}

});
parcelRegister("jpWqm", function(module, exports) {

$parcel$export(module.exports, "EventsTicker", () => $7e57665e7399e00b$export$57a493ed609e53ea);

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");
"use strict";
class $7e57665e7399e00b$var$EventsTickerClass {
    constructor(){
        /** The frequency that fake events will be fired. */ this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this._tickerAdded = false;
        this._pauseUpdate = true;
    }
    /**
   * Initializes the event ticker.
   * @param events - The event system.
   */ init(events) {
        this.removeTickerListener();
        this.events = events;
        this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this._tickerAdded = false;
        this._pauseUpdate = true;
    }
    /** Whether to pause the update checks or not. */ get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    /** Adds the ticker listener. */ addTickerListener() {
        if (this._tickerAdded || !this.domElement) return;
        (0, $jM8Go.Ticker).system.add(this._tickerUpdate, this, (0, $2HyEq.UPDATE_PRIORITY).INTERACTION);
        this._tickerAdded = true;
    }
    /** Removes the ticker listener. */ removeTickerListener() {
        if (!this._tickerAdded) return;
        (0, $jM8Go.Ticker).system.remove(this._tickerUpdate, this);
        this._tickerAdded = false;
    }
    /** Sets flag to not fire extra events when the user has already moved there mouse */ pointerMoved() {
        this._didMove = true;
    }
    /** Updates the state of interactive objects. */ _update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = false;
            return;
        }
        const rootPointerEvent = this.events["_rootPointerEvent"];
        if (this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch") return;
        globalThis.document.dispatchEvent(this.events.supportsPointerEvents ? new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY,
            pointerType: rootPointerEvent.pointerType,
            pointerId: rootPointerEvent.pointerId
        }) : new MouseEvent("mousemove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */ _tickerUpdate(ticker) {
        this._deltaTime += ticker.deltaTime;
        if (this._deltaTime < this.interactionFrequency) return;
        this._deltaTime = 0;
        this._update();
    }
    /** Destroys the event ticker. */ destroy() {
        this.removeTickerListener();
        this.events = null;
        this.domElement = null;
        this._deltaTime = 0;
        this._didMove = false;
        this._tickerAdded = false;
        this._pauseUpdate = true;
    }
}
const $7e57665e7399e00b$export$57a493ed609e53ea = new $7e57665e7399e00b$var$EventsTickerClass();

});

parcelRegister("ZTBXt", function(module, exports) {

$parcel$export(module.exports, "FederatedMouseEvent", () => $304c571aa6f98948$export$aeb79caab92d155a);

var $ds7Xo = parcelRequire("ds7Xo");

var $bG9BA = parcelRequire("bG9BA");
"use strict";
class $304c571aa6f98948$export$aeb79caab92d155a extends (0, $bG9BA.FederatedEvent) {
    constructor(){
        super(...arguments);
        /** The coordinates of the mouse event relative to the canvas. */ this.client = new (0, $ds7Xo.Point)();
        /** The movement in this pointer relative to the last `mousemove` event. */ this.movement = new (0, $ds7Xo.Point)();
        /** The offset of the pointer coordinates w.r.t. target Container in world space. This is not supported at the moment. */ this.offset = new (0, $ds7Xo.Point)();
        /** The pointer coordinates in world space. */ this.global = new (0, $ds7Xo.Point)();
        /**
     * The pointer coordinates in the renderer's {@link AbstractRenderer.screen screen}. This has slightly
     * different semantics than native PointerEvent screenX/screenY.
     */ this.screen = new (0, $ds7Xo.Point)();
    }
    /** @readonly */ get clientX() {
        return this.client.x;
    }
    /** @readonly */ get clientY() {
        return this.client.y;
    }
    /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */ get x() {
        return this.clientX;
    }
    /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */ get y() {
        return this.clientY;
    }
    /** @readonly */ get movementX() {
        return this.movement.x;
    }
    /** @readonly */ get movementY() {
        return this.movement.y;
    }
    /** @readonly */ get offsetX() {
        return this.offset.x;
    }
    /** @readonly */ get offsetY() {
        return this.offset.y;
    }
    /** @readonly */ get globalX() {
        return this.global.x;
    }
    /** @readonly */ get globalY() {
        return this.global.y;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.x`.
   * @readonly
   */ get screenX() {
        return this.screen.x;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.y`.
   * @readonly
   */ get screenY() {
        return this.screen.y;
    }
    /**
   * Converts global coordinates into container-local coordinates.
   *
   * This method transforms coordinates from world space to a container's local space,
   * useful for precise positioning and hit testing.
   * @param container - The Container to get local coordinates for
   * @param point - Optional Point object to store the result. If not provided, a new Point will be created
   * @param globalPos - Optional custom global coordinates. If not provided, the event's global position is used
   * @returns The local coordinates as a Point object
   * @example
   * ```ts
   * // Basic usage - get local coordinates relative to a container
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Get position relative to the sprite
   *     const localPos = event.getLocalPosition(sprite);
   *     console.log('Local position:', localPos.x, localPos.y);
   * });
   * // Using custom global coordinates
   * const customGlobal = new Point(100, 100);
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Transform custom coordinates
   *     const localPos = event.getLocalPosition(sprite, undefined, customGlobal);
   *     console.log('Custom local position:', localPos.x, localPos.y);
   * });
   * ```
   * @see {@link Container.worldTransform} For the transformation matrix
   * @see {@link Point} For the point class used to store coordinates
   */ getLocalPosition(container, point, globalPos) {
        return container.worldTransform.applyInverse(globalPos || this.global, point);
    }
    /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */ getModifierState(key) {
        return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(key);
    }
    /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   * @ignore
   */ // eslint-disable-next-line max-params
    initMouseEvent(_typeArg, _canBubbleArg, _cancelableArg, _viewArg, _detailArg, _screenXArg, _screenYArg, _clientXArg, _clientYArg, _ctrlKeyArg, _altKeyArg, _shiftKeyArg, _metaKeyArg, _buttonArg, _relatedTargetArg) {
        throw new Error("Method not implemented.");
    }
}

});

parcelRegister("3QWP0", function(module, exports) {

$parcel$export(module.exports, "FederatedPointerEvent", () => $dcecd4fcd1db1c40$export$44ac16aa0ab81db6);

var $ZTBXt = parcelRequire("ZTBXt");
"use strict";
class $dcecd4fcd1db1c40$export$44ac16aa0ab81db6 extends (0, $ZTBXt.FederatedMouseEvent) {
    constructor(){
        super(...arguments);
        /**
     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
     * radiusX of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
     */ this.width = 0;
        /**
     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
     * radiusY of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
     */ this.height = 0;
        /**
     * Indicates whether or not the pointer device that created the event is the primary pointer.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
     */ this.isPrimary = false;
    }
    /**
   * Only included for completeness for now
   * @ignore
   */ getCoalescedEvents() {
        if (this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove") return [
            this
        ];
        return [];
    }
    /**
   * Only included for completeness for now
   * @ignore
   */ getPredictedEvents() {
        throw new Error("getPredictedEvents is not supported!");
    }
}

});

parcelRegister("a4OU2", function(module, exports) {

$parcel$export(module.exports, "FederatedWheelEvent", () => $bec88fa93dd8f9b3$export$1fd8b94eb532974d);

var $ZTBXt = parcelRequire("ZTBXt");
"use strict";
class $bec88fa93dd8f9b3$export$1fd8b94eb532974d extends (0, $ZTBXt.FederatedMouseEvent) {
    constructor(){
        super(...arguments);
        /**
     * Units specified in pixels.
     * @ignore
     */ this.DOM_DELTA_PIXEL = 0;
        /**
     * Units specified in lines.
     * @ignore
     */ this.DOM_DELTA_LINE = 1;
        /**
     * Units specified in pages.
     * @ignore
     */ this.DOM_DELTA_PAGE = 2;
    }
}
/**
 * Units specified in pixels.
 * @ignore
 */ $bec88fa93dd8f9b3$export$1fd8b94eb532974d.DOM_DELTA_PIXEL = 0;
/**
 * Units specified in lines.
 * @ignore
 */ $bec88fa93dd8f9b3$export$1fd8b94eb532974d.DOM_DELTA_LINE = 1;
/**
 * Units specified in pages.
 * @ignore
 */ $bec88fa93dd8f9b3$export$1fd8b94eb532974d.DOM_DELTA_PAGE = 2;

});



parcelRegister("5vwBy", function(module, exports) {

$parcel$export(module.exports, "FederatedContainer", () => $e8d4cd2c8fc1f343$export$403593d9e6c7baa6);

var $jzHBA = parcelRequire("jzHBA");

var $bG9BA = parcelRequire("bG9BA");
"use strict";
const $e8d4cd2c8fc1f343$export$403593d9e6c7baa6 = {
    onclick: null,
    onmousedown: null,
    onmouseenter: null,
    onmouseleave: null,
    onmousemove: null,
    onglobalmousemove: null,
    onmouseout: null,
    onmouseover: null,
    onmouseup: null,
    onmouseupoutside: null,
    onpointercancel: null,
    onpointerdown: null,
    onpointerenter: null,
    onpointerleave: null,
    onpointermove: null,
    onglobalpointermove: null,
    onpointerout: null,
    onpointerover: null,
    onpointertap: null,
    onpointerup: null,
    onpointerupoutside: null,
    onrightclick: null,
    onrightdown: null,
    onrightup: null,
    onrightupoutside: null,
    ontap: null,
    ontouchcancel: null,
    ontouchend: null,
    ontouchendoutside: null,
    ontouchmove: null,
    onglobaltouchmove: null,
    ontouchstart: null,
    onwheel: null,
    get interactive () {
        return this.eventMode === "dynamic" || this.eventMode === "static";
    },
    set interactive (value){
        this.eventMode = value ? "static" : "passive";
    },
    _internalEventMode: void 0,
    get eventMode () {
        return this._internalEventMode ?? (0, $jzHBA.EventSystem).defaultEventMode;
    },
    set eventMode (value){
        this._internalEventMode = value;
    },
    isInteractive () {
        return this.eventMode === "static" || this.eventMode === "dynamic";
    },
    interactiveChildren: true,
    hitArea: null,
    addEventListener (type, listener, options) {
        const capture = typeof options === "boolean" && options || typeof options === "object" && options.capture;
        const signal = typeof options === "object" ? options.signal : void 0;
        const once = typeof options === "object" ? options.once === true : false;
        const context = typeof listener === "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type;
        const listenerFn = typeof listener === "function" ? listener : listener.handleEvent;
        const emitter = this;
        if (signal) signal.addEventListener("abort", ()=>{
            emitter.off(type, listenerFn, context);
        });
        if (once) emitter.once(type, listenerFn, context);
        else emitter.on(type, listenerFn, context);
    },
    removeEventListener (type, listener, options) {
        const capture = typeof options === "boolean" && options || typeof options === "object" && options.capture;
        const context = typeof listener === "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type;
        listener = typeof listener === "function" ? listener : listener.handleEvent;
        this.off(type, listener, context);
    },
    dispatchEvent (e) {
        if (!(e instanceof (0, $bG9BA.FederatedEvent))) throw new Error("Container cannot propagate events outside of the Federated Events API");
        e.defaultPrevented = false;
        e.path = null;
        e.target = this;
        e.manager.dispatchEvent(e);
        return !e.defaultPrevented;
    }
};

});

parcelRegister("2mfWS", function(module, exports) {

$parcel$export(module.exports, "FilterPipe", () => $cd18e1c04db411ee$export$26a654548ff780c7);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $cd18e1c04db411ee$export$26a654548ff780c7 {
    constructor(renderer){
        this._renderer = renderer;
    }
    push(filterEffect, container, instructionSet) {
        const renderPipes = this._renderer.renderPipes;
        renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "filter",
            canBundle: false,
            action: "pushFilter",
            container: container,
            filterEffect: filterEffect
        });
    }
    pop(_filterEffect, _container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "filter",
            action: "popFilter",
            canBundle: false
        });
    }
    execute(instruction) {
        if (instruction.action === "pushFilter") this._renderer.filter.push(instruction);
        else if (instruction.action === "popFilter") this._renderer.filter.pop();
    }
    destroy() {
        this._renderer = null;
    }
}
$cd18e1c04db411ee$export$26a654548ff780c7.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "filter"
};

});

parcelRegister("dPCQ1", function(module, exports) {

$parcel$export(module.exports, "FilterSystem", () => $11056bddad691e41$export$e94225c0dfac29cf);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $Rua5B = parcelRequire("Rua5B");

var $5xi4h = parcelRequire("5xi4h");

var $eK2sB = parcelRequire("eK2sB");

var $1T4Gr = parcelRequire("1T4Gr");

var $aUxJK = parcelRequire("aUxJK");

var $4iNSL = parcelRequire("4iNSL");

var $5NyEC = parcelRequire("5NyEC");

var $bfcaK = parcelRequire("bfcaK");

var $esrbs = parcelRequire("esrbs");

var $iqHv9 = parcelRequire("iqHv9");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
const $11056bddad691e41$var$quadGeometry = new (0, $1T4Gr.Geometry)({
    attributes: {
        aPosition: {
            buffer: new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]),
            format: "float32x2",
            stride: 8,
            offset: 0
        }
    },
    indexBuffer: new Uint32Array([
        0,
        1,
        2,
        0,
        2,
        3
    ])
});
class $11056bddad691e41$var$FilterData {
    constructor(){
        /**
     * Indicates whether the filter should be skipped.
     * @type {boolean}
     */ this.skip = false;
        /**
     * The texture to which the filter is applied.
     * @type {Texture}
     */ this.inputTexture = null;
        /**
     * The back texture used for blending, if required.
     * @type {Texture | null}
     */ this.backTexture = null;
        /**
     * The list of filters to be applied.
     * @type {Filter[]}
     */ this.filters = null;
        /**
     * The bounds of the filter area.
     * @type {Bounds}
     */ this.bounds = new (0, $esrbs.Bounds)();
        /**
     * The container to which the filter is applied.
     * @type {Container}
     */ this.container = null;
        /**
     * Indicates whether blending is required for the filter.
     * @type {boolean}
     */ this.blendRequired = false;
        /**
     * The render surface where the output of the filter is rendered.
     * @type {RenderSurface}
     */ this.outputRenderSurface = null;
        /**
     * The global frame of the filter area.
     * @type {{ x: number, y: number, width: number, height: number }}
     */ this.globalFrame = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        /** The first enabled filter index in the current filter list. */ this.firstEnabledIndex = -1;
        /** The last enabled filter index in the current filter list. */ this.lastEnabledIndex = -1;
    }
}
class $11056bddad691e41$export$e94225c0dfac29cf {
    constructor(renderer){
        this._filterStackIndex = 0;
        this._filterStack = [];
        this._filterGlobalUniforms = new (0, $aUxJK.UniformGroup)({
            uInputSize: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uInputPixel: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uInputClamp: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uOutputFrame: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uGlobalFrame: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uOutputTexture: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            }
        });
        this._globalFilterBindGroup = new (0, $eK2sB.BindGroup)({});
        this.renderer = renderer;
    }
    /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */ get activeBackTexture() {
        return this._activeFilterData?.backTexture;
    }
    /**
   * Pushes a filter instruction onto the filter stack.
   * @param instruction - The instruction containing the filter effect and container.
   * @internal
   */ push(instruction) {
        const renderer = this.renderer;
        const filters = instruction.filterEffect.filters;
        const filterData = this._pushFilterData();
        filterData.skip = false;
        filterData.filters = filters;
        filterData.container = instruction.container;
        filterData.outputRenderSurface = renderer.renderTarget.renderSurface;
        const colorTextureSource = renderer.renderTarget.renderTarget.colorTexture.source;
        const rootResolution = colorTextureSource.resolution;
        const rootAntialias = colorTextureSource.antialias;
        if (filters.every((filter)=>!filter.enabled)) {
            filterData.skip = true;
            return;
        }
        const bounds = filterData.bounds;
        this._calculateFilterArea(instruction, bounds);
        this._calculateFilterBounds(filterData, renderer.renderTarget.rootViewPort, rootAntialias, rootResolution, 1);
        if (filterData.skip) return;
        const previousFilterData = this._getPreviousFilterData();
        const globalResolution = this._findFilterResolution(rootResolution);
        let offsetX = 0;
        let offsetY = 0;
        if (previousFilterData) {
            offsetX = previousFilterData.bounds.minX;
            offsetY = previousFilterData.bounds.minY;
        }
        this._calculateGlobalFrame(filterData, offsetX, offsetY, globalResolution, colorTextureSource.width, colorTextureSource.height);
        this._setupFilterTextures(filterData, bounds, renderer, previousFilterData);
    }
    /**
   * Applies filters to a texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture.
   * @param {object} params - The parameters for applying filters.
   * @param {Texture} params.texture - The texture to apply filters to.
   * @param {Filter[]} params.filters - The filters to apply.
   * @returns {Texture} The resulting texture after all filters have been applied.
   * @example
   *
   * ```ts
   * // Create a texture and a list of filters
   * const texture = new Texture(...);
   * const filters = [new BlurFilter(), new ColorMatrixFilter()];
   *
   * // Apply the filters to the texture
   * const resultTexture = filterSystem.applyToTexture({ texture, filters });
   *
   * // Use the resulting texture
   * sprite.texture = resultTexture;
   * ```
   *
   * Key Points:
   * 1. padding is not currently supported here - so clipping may occur with filters that use padding.
   * 2. If all filters are disabled or skipped, the original texture is returned.
   */ generateFilteredTexture({ texture: texture, filters: filters }) {
        const filterData = this._pushFilterData();
        this._activeFilterData = filterData;
        filterData.skip = false;
        filterData.filters = filters;
        const colorTextureSource = texture.source;
        const rootResolution = colorTextureSource.resolution;
        const rootAntialias = colorTextureSource.antialias;
        if (filters.every((filter)=>!filter.enabled)) {
            filterData.skip = true;
            return texture;
        }
        const bounds = filterData.bounds;
        bounds.addRect(texture.frame);
        this._calculateFilterBounds(filterData, bounds.rectangle, rootAntialias, rootResolution, 0);
        if (filterData.skip) return texture;
        const globalResolution = rootResolution;
        const offsetX = 0;
        const offsetY = 0;
        this._calculateGlobalFrame(filterData, offsetX, offsetY, globalResolution, colorTextureSource.width, colorTextureSource.height);
        filterData.outputRenderSurface = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, filterData.resolution, filterData.antialias);
        filterData.backTexture = (0, $4iNSL.Texture).EMPTY;
        filterData.inputTexture = texture;
        const renderer = this.renderer;
        renderer.renderTarget.finishRenderPass();
        this._applyFiltersToTexture(filterData, true);
        const outputTexture = filterData.outputRenderSurface;
        outputTexture.source.alphaMode = "premultiplied-alpha";
        return outputTexture;
    }
    /** @internal */ pop() {
        const renderer = this.renderer;
        const filterData = this._popFilterData();
        if (filterData.skip) return;
        renderer.globalUniforms.pop();
        renderer.renderTarget.finishRenderPass();
        this._activeFilterData = filterData;
        this._applyFiltersToTexture(filterData, false);
        if (filterData.blendRequired) (0, $5NyEC.TexturePool).returnTexture(filterData.backTexture);
        (0, $5NyEC.TexturePool).returnTexture(filterData.inputTexture);
    }
    /**
   * Copies the last render surface to a texture.
   * @param lastRenderSurface - The last render surface to copy from.
   * @param bounds - The bounds of the area to copy.
   * @param previousBounds - The previous bounds to use for offsetting the copy.
   */ getBackTexture(lastRenderSurface, bounds, previousBounds) {
        const backgroundResolution = lastRenderSurface.colorTexture.source._resolution;
        const backTexture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, backgroundResolution, false);
        let x = bounds.minX;
        let y = bounds.minY;
        if (previousBounds) {
            x -= previousBounds.minX;
            y -= previousBounds.minY;
        }
        x = Math.floor(x * backgroundResolution);
        y = Math.floor(y * backgroundResolution);
        const width = Math.ceil(bounds.width * backgroundResolution);
        const height = Math.ceil(bounds.height * backgroundResolution);
        this.renderer.renderTarget.copyToTexture(lastRenderSurface, backTexture, {
            x: x,
            y: y
        }, {
            width: width,
            height: height
        }, {
            x: 0,
            y: 0
        });
        return backTexture;
    }
    /**
   * Applies a filter to a texture.
   * @param filter - The filter to apply.
   * @param input - The input texture.
   * @param output - The output render surface.
   * @param clear - Whether to clear the output surface before applying the filter.
   */ applyFilter(filter, input, output, clear) {
        const renderer = this.renderer;
        const filterData = this._activeFilterData;
        const outputRenderSurface = filterData.outputRenderSurface;
        const isFinalTarget = outputRenderSurface === output;
        const rootResolution = renderer.renderTarget.rootRenderTarget.colorTexture.source._resolution;
        const resolution = this._findFilterResolution(rootResolution);
        let offsetX = 0;
        let offsetY = 0;
        if (isFinalTarget) {
            const offset = this._findPreviousFilterOffset();
            offsetX = offset.x;
            offsetY = offset.y;
        }
        this._updateFilterUniforms(input, output, filterData, offsetX, offsetY, resolution, isFinalTarget, clear);
        const filterToApply = filter.enabled ? filter : this._getPassthroughFilter();
        this._setupBindGroupsAndRender(filterToApply, input, renderer);
    }
    /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */ calculateSpriteMatrix(outputMatrix, sprite) {
        const data = this._activeFilterData;
        const mappedMatrix = outputMatrix.set(data.inputTexture._source.width, 0, 0, data.inputTexture._source.height, data.bounds.minX, data.bounds.minY);
        const worldTransform = sprite.worldTransform.copyTo((0, $5xi4h.Matrix).shared);
        const renderGroup = sprite.renderGroup || sprite.parentRenderGroup;
        if (renderGroup && renderGroup.cacheToLocalTransform) worldTransform.prepend(renderGroup.cacheToLocalTransform);
        worldTransform.invert();
        mappedMatrix.prepend(worldTransform);
        mappedMatrix.scale(1 / sprite.texture.orig.width, 1 / sprite.texture.orig.height);
        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
        return mappedMatrix;
    }
    destroy() {
        this._passthroughFilter?.destroy(true);
        this._passthroughFilter = null;
    }
    _getPassthroughFilter() {
        this._passthroughFilter ?? (this._passthroughFilter = new (0, $Rua5B.PassthroughFilter)());
        return this._passthroughFilter;
    }
    /**
   * Sets up the bind groups and renders the filter.
   * @param filter - The filter to apply
   * @param input - The input texture
   * @param renderer - The renderer instance
   */ _setupBindGroupsAndRender(filter, input, renderer) {
        if (renderer.renderPipes.uniformBatch) {
            const batchUniforms = renderer.renderPipes.uniformBatch.getUboResource(this._filterGlobalUniforms);
            this._globalFilterBindGroup.setResource(batchUniforms, 0);
        } else this._globalFilterBindGroup.setResource(this._filterGlobalUniforms, 0);
        this._globalFilterBindGroup.setResource(input.source, 1);
        this._globalFilterBindGroup.setResource(input.source.style, 2);
        filter.groups[0] = this._globalFilterBindGroup;
        renderer.encoder.draw({
            geometry: $11056bddad691e41$var$quadGeometry,
            shader: filter,
            state: filter._state,
            topology: "triangle-list"
        });
        if (renderer.type === (0, $bfcaK.RendererType).WEBGL) renderer.renderTarget.finishRenderPass();
    }
    /**
   * Sets up the filter textures including input texture and back texture if needed.
   * @param filterData - The filter data to update
   * @param bounds - The bounds for the texture
   * @param renderer - The renderer instance
   * @param previousFilterData - The previous filter data for back texture calculation
   */ _setupFilterTextures(filterData, bounds, renderer, previousFilterData) {
        filterData.backTexture = (0, $4iNSL.Texture).EMPTY;
        filterData.inputTexture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, filterData.resolution, filterData.antialias);
        if (filterData.blendRequired) {
            renderer.renderTarget.finishRenderPass();
            const renderTarget = renderer.renderTarget.getRenderTarget(filterData.outputRenderSurface);
            filterData.backTexture = this.getBackTexture(renderTarget, bounds, previousFilterData?.bounds);
        }
        renderer.renderTarget.bind(filterData.inputTexture, true);
        renderer.globalUniforms.push({
            offset: bounds
        });
    }
    /**
   * Calculates and sets the global frame for the filter.
   * @param filterData - The filter data to update
   * @param offsetX - The X offset
   * @param offsetY - The Y offset
   * @param globalResolution - The global resolution
   * @param sourceWidth - The source texture width
   * @param sourceHeight - The source texture height
   */ _calculateGlobalFrame(filterData, offsetX, offsetY, globalResolution, sourceWidth, sourceHeight) {
        const globalFrame = filterData.globalFrame;
        globalFrame.x = offsetX * globalResolution;
        globalFrame.y = offsetY * globalResolution;
        globalFrame.width = sourceWidth * globalResolution;
        globalFrame.height = sourceHeight * globalResolution;
    }
    /**
   * Updates the filter uniforms with the current filter state.
   * @param input - The input texture
   * @param output - The output render surface
   * @param filterData - The current filter data
   * @param offsetX - The X offset for positioning
   * @param offsetY - The Y offset for positioning
   * @param resolution - The current resolution
   * @param isFinalTarget - Whether this is the final render target
   * @param clear - Whether to clear the output surface
   */ _updateFilterUniforms(input, output, filterData, offsetX, offsetY, resolution, isFinalTarget, clear) {
        const uniforms = this._filterGlobalUniforms.uniforms;
        const outputFrame = uniforms.uOutputFrame;
        const inputSize = uniforms.uInputSize;
        const inputPixel = uniforms.uInputPixel;
        const inputClamp = uniforms.uInputClamp;
        const globalFrame = uniforms.uGlobalFrame;
        const outputTexture = uniforms.uOutputTexture;
        if (isFinalTarget) {
            outputFrame[0] = filterData.bounds.minX - offsetX;
            outputFrame[1] = filterData.bounds.minY - offsetY;
        } else {
            outputFrame[0] = 0;
            outputFrame[1] = 0;
        }
        outputFrame[2] = input.frame.width;
        outputFrame[3] = input.frame.height;
        inputSize[0] = input.source.width;
        inputSize[1] = input.source.height;
        inputSize[2] = 1 / inputSize[0];
        inputSize[3] = 1 / inputSize[1];
        inputPixel[0] = input.source.pixelWidth;
        inputPixel[1] = input.source.pixelHeight;
        inputPixel[2] = 1 / inputPixel[0];
        inputPixel[3] = 1 / inputPixel[1];
        inputClamp[0] = 0.5 * inputPixel[2];
        inputClamp[1] = 0.5 * inputPixel[3];
        inputClamp[2] = input.frame.width * inputSize[2] - 0.5 * inputPixel[2];
        inputClamp[3] = input.frame.height * inputSize[3] - 0.5 * inputPixel[3];
        const rootTexture = this.renderer.renderTarget.rootRenderTarget.colorTexture;
        globalFrame[0] = offsetX * resolution;
        globalFrame[1] = offsetY * resolution;
        globalFrame[2] = rootTexture.source.width * resolution;
        globalFrame[3] = rootTexture.source.height * resolution;
        if (output instanceof (0, $4iNSL.Texture)) output.source.resource = null;
        const renderTarget = this.renderer.renderTarget.getRenderTarget(output);
        this.renderer.renderTarget.bind(output, !!clear);
        if (output instanceof (0, $4iNSL.Texture)) {
            outputTexture[0] = output.frame.width;
            outputTexture[1] = output.frame.height;
        } else {
            outputTexture[0] = renderTarget.width;
            outputTexture[1] = renderTarget.height;
        }
        outputTexture[2] = renderTarget.isRoot ? -1 : 1;
        this._filterGlobalUniforms.update();
    }
    /**
   * Finds the correct resolution by looking back through the filter stack.
   * @param rootResolution - The fallback root resolution to use
   * @returns The resolution from the previous filter or root resolution
   */ _findFilterResolution(rootResolution) {
        let currentIndex = this._filterStackIndex - 1;
        while(currentIndex > 0 && this._filterStack[currentIndex].skip)--currentIndex;
        return currentIndex > 0 && this._filterStack[currentIndex].inputTexture ? this._filterStack[currentIndex].inputTexture.source._resolution : rootResolution;
    }
    /**
   * Finds the offset from the previous non-skipped filter in the stack.
   * @returns The offset coordinates from the previous filter
   */ _findPreviousFilterOffset() {
        let offsetX = 0;
        let offsetY = 0;
        let lastIndex = this._filterStackIndex;
        while(lastIndex > 0){
            lastIndex--;
            const prevFilterData = this._filterStack[lastIndex];
            if (!prevFilterData.skip) {
                offsetX = prevFilterData.bounds.minX;
                offsetY = prevFilterData.bounds.minY;
                break;
            }
        }
        return {
            x: offsetX,
            y: offsetY
        };
    }
    /**
   * Calculates the filter area bounds based on the instruction type.
   * @param instruction - The filter instruction
   * @param bounds - The bounds object to populate
   */ _calculateFilterArea(instruction, bounds) {
        if (instruction.renderables) (0, $iqHv9.getGlobalRenderableBounds)(instruction.renderables, bounds);
        else if (instruction.filterEffect.filterArea) {
            bounds.clear();
            bounds.addRect(instruction.filterEffect.filterArea);
            bounds.applyMatrix(instruction.container.worldTransform);
        } else instruction.container.getFastGlobalBounds(true, bounds);
        if (instruction.container) {
            const renderGroup = instruction.container.renderGroup || instruction.container.parentRenderGroup;
            const filterFrameTransform = renderGroup.cacheToLocalTransform;
            if (filterFrameTransform) bounds.applyMatrix(filterFrameTransform);
        }
    }
    _applyFiltersToTexture(filterData, clear) {
        const inputTexture = filterData.inputTexture;
        const bounds = filterData.bounds;
        const filters = filterData.filters;
        const firstEnabled = filterData.firstEnabledIndex;
        const lastEnabled = filterData.lastEnabledIndex;
        this._globalFilterBindGroup.setResource(inputTexture.source.style, 2);
        this._globalFilterBindGroup.setResource(filterData.backTexture.source, 3);
        if (firstEnabled === lastEnabled) filters[firstEnabled].apply(this, inputTexture, filterData.outputRenderSurface, clear);
        else {
            let flip = filterData.inputTexture;
            const tempTexture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, flip.source._resolution, false);
            let flop = tempTexture;
            for(let i = firstEnabled; i < lastEnabled; i++){
                const filter = filters[i];
                if (!filter.enabled) continue;
                filter.apply(this, flip, flop, true);
                const t = flip;
                flip = flop;
                flop = t;
            }
            filters[lastEnabled].apply(this, flip, filterData.outputRenderSurface, clear);
            (0, $5NyEC.TexturePool).returnTexture(tempTexture);
        }
    }
    _calculateFilterBounds(filterData, viewPort, rootAntialias, rootResolution, paddingMultiplier) {
        const renderer = this.renderer;
        const bounds = filterData.bounds;
        const filters = filterData.filters;
        let resolution = Infinity;
        let padding = 0;
        let antialias = true;
        let blendRequired = false;
        let enabled = false;
        let clipToViewport = true;
        let firstEnabledIndex = -1;
        let lastEnabledIndex = -1;
        for(let i = 0; i < filters.length; i++){
            const filter = filters[i];
            if (!filter.enabled) continue;
            if (firstEnabledIndex === -1) firstEnabledIndex = i;
            lastEnabledIndex = i;
            resolution = Math.min(resolution, filter.resolution === "inherit" ? rootResolution : filter.resolution);
            padding += filter.padding;
            if (filter.antialias === "off") antialias = false;
            else if (filter.antialias === "inherit") antialias && (antialias = rootAntialias);
            if (!filter.clipToViewport) clipToViewport = false;
            const isCompatible = !!(filter.compatibleRenderers & renderer.type);
            if (!isCompatible) {
                enabled = false;
                break;
            }
            if (filter.blendRequired && !(renderer.backBuffer?.useBackBuffer ?? true)) {
                (0, $1RpxL.warn)("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options.");
                enabled = false;
                break;
            }
            enabled = true;
            blendRequired || (blendRequired = filter.blendRequired);
        }
        if (!enabled) {
            filterData.skip = true;
            return;
        }
        if (clipToViewport) bounds.fitBounds(0, viewPort.width / rootResolution, 0, viewPort.height / rootResolution);
        bounds.scale(resolution).ceil().scale(1 / resolution).pad((padding | 0) * paddingMultiplier);
        if (!bounds.isPositive) {
            filterData.skip = true;
            return;
        }
        filterData.antialias = antialias;
        filterData.resolution = resolution;
        filterData.blendRequired = blendRequired;
        filterData.firstEnabledIndex = firstEnabledIndex;
        filterData.lastEnabledIndex = lastEnabledIndex;
    }
    _popFilterData() {
        this._filterStackIndex--;
        return this._filterStack[this._filterStackIndex];
    }
    _getPreviousFilterData() {
        let previousFilterData;
        let index = this._filterStackIndex - 1;
        while(index > 0){
            index--;
            previousFilterData = this._filterStack[index];
            if (!previousFilterData.skip) break;
        }
        return previousFilterData;
    }
    _pushFilterData() {
        let filterData = this._filterStack[this._filterStackIndex];
        if (!filterData) filterData = this._filterStack[this._filterStackIndex] = new $11056bddad691e41$var$FilterData();
        this._filterStackIndex++;
        return filterData;
    }
}
/** @ignore */ $11056bddad691e41$export$e94225c0dfac29cf.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "filter"
};

});
parcelRegister("Rua5B", function(module, exports) {

$parcel$export(module.exports, "PassthroughFilter", () => $69ff9dae729cad88$export$c1fa6b559647e5b5);

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $lWXRl = parcelRequire("lWXRl");

var $hK31P = parcelRequire("hK31P");

var $ejyqD = parcelRequire("ejyqD");

var $dm63u = parcelRequire("dm63u");
"use strict";
class $69ff9dae729cad88$export$c1fa6b559647e5b5 extends (0, $lWXRl.Filter) {
    constructor(){
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $dm63u.default,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $dm63u.default,
                entryPoint: "mainFragment"
            },
            name: "passthrough-filter"
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $hK31P.default,
            fragment: $ejyqD.default,
            name: "passthrough-filter"
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram
        });
    }
}

});
parcelRegister("4kU4M", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $4fbd2272ba254a8c$export$64881d9ea0a969d7);

var $jpjFn = parcelRequire("jpjFn");

var $PoGJg = parcelRequire("PoGJg");

var $hAD1m = parcelRequire("hAD1m");

var $1ZdMF = parcelRequire("1ZdMF");

var $1EMZg = parcelRequire("1EMZg");

var $4IUGf = parcelRequire("4IUGf");

var $kQYzC = parcelRequire("kQYzC");
"use strict";
const $4fbd2272ba254a8c$var$processes = {
    stripVersion: // strips any version headers..
    $kQYzC.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $1ZdMF.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $hAD1m.addProgramDefines,
    setProgramName: // add the program name to the shader
    $4IUGf.setProgramName,
    insertVersion: // add the version string to the shader header
    $1EMZg.insertVersion
};
const $4fbd2272ba254a8c$var$programCache = /* @__PURE__ */ Object.create(null);
const $4fbd2272ba254a8c$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $PoGJg.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($4fbd2272ba254a8c$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $4fbd2272ba254a8c$var$processes[processKey](fragment, processOptions, true);
            vertex = $4fbd2272ba254a8c$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this.transformFeedbackVaryings = options.transformFeedbackVaryings;
        this._key = (0, $jpjFn.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
        $4fbd2272ba254a8c$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$4fbd2272ba254a8c$var$programCache[key]) {
            $4fbd2272ba254a8c$var$programCache[key] = new _GlProgram(options);
            $4fbd2272ba254a8c$var$programCache[key]._cacheKey = key;
        }
        return $4fbd2272ba254a8c$var$programCache[key];
    }
};
/** The default options used by the program. */ $4fbd2272ba254a8c$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $4fbd2272ba254a8c$export$64881d9ea0a969d7 = $4fbd2272ba254a8c$var$_GlProgram;

});
parcelRegister("jpjFn", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $29fd7d09de62ceb3$export$1e452c36dfe36a93);
"use strict";
const $29fd7d09de62ceb3$var$idCounts = /* @__PURE__ */ Object.create(null);
const $29fd7d09de62ceb3$var$idHash = /* @__PURE__ */ Object.create(null);
function $29fd7d09de62ceb3$export$1e452c36dfe36a93(value, groupId) {
    let id = $29fd7d09de62ceb3$var$idHash[value];
    if (id === void 0) {
        if ($29fd7d09de62ceb3$var$idCounts[groupId] === void 0) $29fd7d09de62ceb3$var$idCounts[groupId] = 1;
        $29fd7d09de62ceb3$var$idHash[value] = id = $29fd7d09de62ceb3$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("PoGJg", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $8ab5eb5253ba5055$export$428c38e64838140);

var $2sz3b = parcelRequire("2sz3b");
"use strict";
let $8ab5eb5253ba5055$var$maxFragmentPrecision;
function $8ab5eb5253ba5055$export$428c38e64838140() {
    if (!$8ab5eb5253ba5055$var$maxFragmentPrecision) {
        $8ab5eb5253ba5055$var$maxFragmentPrecision = "mediump";
        const gl = (0, $2sz3b.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $8ab5eb5253ba5055$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $8ab5eb5253ba5055$var$maxFragmentPrecision;
}

});
parcelRegister("2sz3b", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $7963abaf7723732c$export$f034b2d55f8df08b);

var $gLw46 = parcelRequire("gLw46");
"use strict";
let $7963abaf7723732c$var$context;
function $7963abaf7723732c$export$f034b2d55f8df08b() {
    if (!$7963abaf7723732c$var$context || $7963abaf7723732c$var$context?.isContextLost()) {
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        $7963abaf7723732c$var$context = canvas.getContext("webgl", {});
    }
    return $7963abaf7723732c$var$context;
}

});


parcelRegister("hAD1m", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $eb17965c74ba5d4e$export$fba00ea8bc676dd1);
"use strict";
function $eb17965c74ba5d4e$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("1ZdMF", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $07c05540c4b951fe$export$899bdffb1b617f8b);
"use strict";
function $07c05540c4b951fe$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("1EMZg", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $13ece8c9aaad81f9$export$df5409633d2e06a0);
"use strict";
function $13ece8c9aaad81f9$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("4IUGf", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $e8f1a3aed60f3f70$export$fcd35f5a80d5e29b);
"use strict";
const $e8f1a3aed60f3f70$var$fragmentNameCache = {};
const $e8f1a3aed60f3f70$var$VertexNameCache = {};
function $e8f1a3aed60f3f70$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $e8f1a3aed60f3f70$var$fragmentNameCache : $e8f1a3aed60f3f70$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("kQYzC", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $7ee1fafb8eb0055d$export$f71406e7a553e9e5);
"use strict";
function $7ee1fafb8eb0055d$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("bEdxc", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $685f50faf26c4aa7$export$b7a31a3cdd61870);

var $jpjFn = parcelRequire("jpjFn");

var $jqzau = parcelRequire("jqzau");

var $gKvt3 = parcelRequire("gKvt3");

var $5UqCH = parcelRequire("5UqCH");

var $8RSuU = parcelRequire("8RSuU");

var $5WpII = parcelRequire("5WpII");
"use strict";
const $685f50faf26c4aa7$var$programCache = /* @__PURE__ */ Object.create(null);
class $685f50faf26c4aa7$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /** @internal */ this._layoutKey = 0;
        /** @internal */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $gKvt3.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $gKvt3.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $gKvt3.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $5WpII.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $8RSuU.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $5UqCH.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $jpjFn.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $jqzau.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
        $685f50faf26c4aa7$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$685f50faf26c4aa7$var$programCache[key]) {
            $685f50faf26c4aa7$var$programCache[key] = new $685f50faf26c4aa7$export$b7a31a3cdd61870(options);
            $685f50faf26c4aa7$var$programCache[key]._cacheKey = key;
        }
        return $685f50faf26c4aa7$var$programCache[key];
    }
}

});
parcelRegister("jqzau", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $414333a78e95db22$export$b0efe5f01c53f69f);

var $eDWUK = parcelRequire("eDWUK");
"use strict";
const $414333a78e95db22$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    vec2i: "sint32x2",
    vec3i: "sint32x3",
    vec4i: "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    vec2u: "uint32x2",
    vec3u: "uint32x3",
    vec4u: "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
const $414333a78e95db22$var$LOCATION_REGEX = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function $414333a78e95db22$var$parseLocations(str, results) {
    let match;
    while((match = $414333a78e95db22$var$LOCATION_REGEX.exec(str)) !== null){
        const format = $414333a78e95db22$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
        results[match[2]] = {
            location: parseInt(match[1], 10),
            format: format,
            stride: (0, $eDWUK.getAttributeInfoFromFormat)(format).stride,
            offset: 0,
            instance: false,
            start: 0
        };
    }
    $414333a78e95db22$var$LOCATION_REGEX.lastIndex = 0;
}
function $414333a78e95db22$var$stripComments(source) {
    return source.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function $414333a78e95db22$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const cleanSource = $414333a78e95db22$var$stripComments(source);
    const mainVertStart = cleanSource.indexOf(`fn ${entryPoint}(`);
    if (mainVertStart === -1) return results;
    const arrowFunctionStart = cleanSource.indexOf("->", mainVertStart);
    if (arrowFunctionStart === -1) return results;
    const functionArgsSubstring = cleanSource.substring(mainVertStart, arrowFunctionStart);
    $414333a78e95db22$var$parseLocations(functionArgsSubstring, results);
    if (Object.keys(results).length === 0) {
        const structMatch = functionArgsSubstring.match(/\(\s*\w+\s*:\s*(\w+)/);
        if (structMatch) {
            const structName = structMatch[1];
            const structRegex = new RegExp(`struct\\s+${structName}\\s*\\{([^}]+)\\}`, "s");
            const structBody = cleanSource.match(structRegex);
            if (structBody) $414333a78e95db22$var$parseLocations(structBody[1], results);
        }
    }
    return results;
}

});
parcelRegister("eDWUK", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $7b2d0d2cc212fce2$export$4da509c30cc6be33);
"use strict";
const $7b2d0d2cc212fce2$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $7b2d0d2cc212fce2$export$4da509c30cc6be33(format) {
    return $7b2d0d2cc212fce2$var$attributeFormatData[format] ?? $7b2d0d2cc212fce2$var$attributeFormatData.float32;
}

});


parcelRegister("gKvt3", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $8b222257d47a11b7$export$368e99a200562975);
"use strict";
function $8b222257d47a11b7$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*([\w<>]+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>// Handle both direct type matches and generic types like array<StructName>
            group.type === name || group.type.includes(`<${name}>`))) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("5UqCH", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $46f7f90ef26cbfc6$export$950011c0dc347495);

var $kqAKw = parcelRequire("kqAKw");
"use strict";
function $46f7f90ef26cbfc6$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $kqAKw.ShaderStage).VERTEX | (0, $kqAKw.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $kqAKw.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d" || group.type.startsWith("texture_2d<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $kqAKw.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
        else if (group.type === "texture_2d_array" || group.type.startsWith("texture_2d_array<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $kqAKw.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d-array",
                multisampled: false
            }
        });
        else if (group.type === "texture_cube" || group.type.startsWith("texture_cube<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $kqAKw.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "cube",
                multisampled: false
            }
        });
    }
    for(let i = 0; i < layout.length; i++)layout[i] || (layout[i] = []);
    return layout;
}

});
parcelRegister("kqAKw", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $a055cd8d92222fe5$export$34a0cafc5a97ef31);
"use strict";
var $a055cd8d92222fe5$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($a055cd8d92222fe5$export$34a0cafc5a97ef31 || {});

});


parcelRegister("8RSuU", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $11bc5db2c332695b$export$6a0f9650f9d4f875);
"use strict";
function $11bc5db2c332695b$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("5WpII", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $6f064cc0481eb476$export$5f344e20ddfaa2d6);
"use strict";
function $6f064cc0481eb476$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("lWXRl", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $dc4b924f506f2d06$export$ec91da630f36d5ea);

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $7LCXQ = parcelRequire("7LCXQ");

var $fx0Zy = parcelRequire("fx0Zy");
"use strict";
const $dc4b924f506f2d06$var$_Filter = class _Filter extends (0, $7LCXQ.Shader) {
    /**
   * @param options - The optional parameters of this filter.
   */ constructor(options){
        options = {
            ..._Filter.defaultOptions,
            ...options
        };
        super(options);
        /** If enabled is true the filter is applied, if false it will not. */ this.enabled = true;
        /**
     * The gpu state the filter requires to render.
     * @internal
     */ this._state = (0, $fx0Zy.State).for2d();
        this.blendMode = options.blendMode;
        this.padding = options.padding;
        if (typeof options.antialias === "boolean") this.antialias = options.antialias ? "on" : "off";
        else this.antialias = options.antialias;
        this.resolution = options.resolution;
        this.blendRequired = options.blendRequired;
        this.clipToViewport = options.clipToViewport;
        this.addResource("uTexture", 0, 1);
        if (options.blendRequired) this.addResource("uBackTexture", 0, 3);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ apply(filterManager, input, output, clearMode) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Get the blend mode of the filter.
   * @default "normal"
   */ get blendMode() {
        return this._state.blendMode;
    }
    /** Sets the blend mode of the filter. */ set blendMode(value) {
        this._state.blendMode = value;
    }
    /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */ static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $bEdxc.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $4kU4M.GlProgram).from(gl);
        return new _Filter({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
};
/** The default filter settings */ $dc4b924f506f2d06$var$_Filter.defaultOptions = {
    blendMode: "normal",
    resolution: 1,
    padding: 0,
    antialias: "off",
    blendRequired: false,
    clipToViewport: true
};
let $dc4b924f506f2d06$export$ec91da630f36d5ea = $dc4b924f506f2d06$var$_Filter;

});
parcelRegister("7LCXQ", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $3651eee6bf7bf9e3$export$462bb059fed9d9e5);

var $6AQ4q = parcelRequire("6AQ4q");

var $1bMtF = parcelRequire("1bMtF");

var $4kU4M = parcelRequire("4kU4M");

var $eK2sB = parcelRequire("eK2sB");

var $bEdxc = parcelRequire("bEdxc");

var $bfcaK = parcelRequire("bfcaK");

var $aUxJK = parcelRequire("aUxJK");
"use strict";
class $3651eee6bf7bf9e3$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(options){
        super();
        /** A unique identifier for the shader */ this.uid = (0, $1bMtF.uid)("shader");
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        /** @internal */ this._destroyed = false;
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $bfcaK.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $bfcaK.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $eK2sB.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $aUxJK.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $eK2sB.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $eK2sB.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        if (this._destroyed) return;
        this._destroyed = true;
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $bEdxc.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $4kU4M.GlProgram).from(gl);
        return new $3651eee6bf7bf9e3$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("eK2sB", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $44e4efc430a6c69e$export$6f452ee382def63c);
"use strict";
class $44e4efc430a6c69e$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @param tick - The current tick.
   * @internal
   */ _touch(now, tick) {
        const resources = this.resources;
        for(const i in resources){
            resources[i]._gcLastUsed = now;
            resources[i]._touched = tick;
        }
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource?.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) {
            const resources = this.resources;
            for(const i in resources)if (resources[i] === resource) resources[i] = null;
        } else this._updateKey();
    }
}

});

parcelRegister("bfcaK", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $7892415b293b8e83$export$2ca8315eebe81c3d);
"use strict";
var $7892415b293b8e83$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["CANVAS"] = 4] = "CANVAS";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($7892415b293b8e83$export$2ca8315eebe81c3d || {});

});

parcelRegister("aUxJK", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $c7f4366d09514980$export$6601a7a2dcf79bf5);

var $1bMtF = parcelRequire("1bMtF");

var $jpjFn = parcelRequire("jpjFn");

var $fC2kJ = parcelRequire("fC2kJ");

var $9wfqV = parcelRequire("9wfqV");
"use strict";
const $c7f4366d09514980$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $1bMtF.uid)("uniform");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "uniformGroup";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $1bMtF.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $fC2kJ.UNIFORM_TYPES_MAP)[uniformData.type]) {
                const arrayMatch = uniformData.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
                if (arrayMatch) {
                    const [, innerType, size] = arrayMatch;
                    throw new Error(`Uniform type ${uniformData.type} is not supported. Use type: '${innerType}', size: ${size} instead.`);
                }
                throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $fC2kJ.UNIFORM_TYPES_VALUES).join(", ")}`);
            }
            uniformData.value ?? (uniformData.value = (0, $9wfqV.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $jpjFn.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $c7f4366d09514980$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $c7f4366d09514980$export$6601a7a2dcf79bf5 = $c7f4366d09514980$var$_UniformGroup;

});
parcelRegister("fC2kJ", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $84ba54e3e8572ea0$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $84ba54e3e8572ea0$export$97ddd6675231876e);
"use strict";
const $84ba54e3e8572ea0$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>",
    "vec2<i32>",
    "vec3<i32>",
    "vec4<i32>"
];
const $84ba54e3e8572ea0$export$97ddd6675231876e = $84ba54e3e8572ea0$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("9wfqV", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $f3e5805f24968b13$export$7febdb6905805c3d);
"use strict";
function $f3e5805f24968b13$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("fx0Zy", function(module, exports) {

$parcel$export(module.exports, "State", () => $6e3876429744eeff$export$7254cc27399e90bd);
"use strict";
const $6e3876429744eeff$var$blendModeIds = {
    normal: 0,
    add: 1,
    multiply: 2,
    screen: 3,
    overlay: 4,
    erase: 5,
    "normal-npm": 6,
    "add-npm": 7,
    "screen-npm": 8,
    min: 9,
    max: 10
};
const $6e3876429744eeff$var$BLEND = 0;
const $6e3876429744eeff$var$OFFSET = 1;
const $6e3876429744eeff$var$CULLING = 2;
const $6e3876429744eeff$var$DEPTH_TEST = 3;
const $6e3876429744eeff$var$WINDING = 4;
const $6e3876429744eeff$var$DEPTH_MASK = 5;
const $6e3876429744eeff$var$_State = class _State {
    constructor(){
        this.data = 0;
        this.blendMode = "normal";
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $6e3876429744eeff$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$BLEND) !== value) this.data ^= 1 << $6e3876429744eeff$var$BLEND;
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $6e3876429744eeff$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$OFFSET) !== value) this.data ^= 1 << $6e3876429744eeff$var$OFFSET;
    }
    /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */ set cullMode(value) {
        if (value === "none") {
            this.culling = false;
            return;
        }
        this.culling = true;
        this.clockwiseFrontFace = value === "front";
    }
    get cullMode() {
        if (!this.culling) return "none";
        return this.clockwiseFrontFace ? "front" : "back";
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $6e3876429744eeff$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$CULLING) !== value) this.data ^= 1 << $6e3876429744eeff$var$CULLING;
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $6e3876429744eeff$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$DEPTH_TEST) !== value) this.data ^= 1 << $6e3876429744eeff$var$DEPTH_TEST;
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $6e3876429744eeff$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$DEPTH_MASK) !== value) this.data ^= 1 << $6e3876429744eeff$var$DEPTH_MASK;
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $6e3876429744eeff$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $6e3876429744eeff$var$WINDING) !== value) this.data ^= 1 << $6e3876429744eeff$var$WINDING;
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== "none";
        this._blendMode = value;
        this._blendModeId = $6e3876429744eeff$var$blendModeIds[value] || 0;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */ static for2d() {
        const state = new _State();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
};
$6e3876429744eeff$var$_State.default2d = $6e3876429744eeff$var$_State.for2d();
let $6e3876429744eeff$export$7254cc27399e90bd = $6e3876429744eeff$var$_State;

});


parcelRegister("hK31P", function(module, exports) {

$parcel$export(module.exports, "default", () => $844a8ea233c3bf8e$export$2e2bcd8739ae039);
var $844a8ea233c3bf8e$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";

});

parcelRegister("ejyqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5cbca6a37253ee9$export$2e2bcd8739ae039);
var $f5cbca6a37253ee9$export$2e2bcd8739ae039 = "in vec2 vTextureCoord;\nout vec4 finalColor;\nuniform sampler2D uTexture;\nvoid main() {\n    finalColor = texture(uTexture, vTextureCoord);\n}\n";

});

parcelRegister("dm63u", function(module, exports) {

$parcel$export(module.exports, "default", () => $316031769ed2ca37$export$2e2bcd8739ae039);
var $316031769ed2ca37$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize: vec4<f32>,\n  uInputPixel: vec4<f32>,\n  uInputClamp: vec4<f32>,\n  uOutputFrame: vec4<f32>,\n  uGlobalFrame: vec4<f32>,\n  uOutputTexture: vec4<f32>,\n};\n\n@group(0) @binding(0) var <uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler: sampler;\n\nstruct VSOutput {\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv: vec2<f32>\n};\n\nfn filterVertexPosition(aPosition: vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0 * gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord(aPosition: vec2<f32>) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition: vec2<f32>,\n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n) -> @location(0) vec4<f32> {\n    return textureSample(uTexture, uSampler, uv);\n}\n";

});


parcelRegister("1T4Gr", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $f30e3464cad0ff90$export$2db6c17465f94a2);

var $6AQ4q = parcelRequire("6AQ4q");

var $esrbs = parcelRequire("esrbs");

var $1bMtF = parcelRequire("1bMtF");

var $2bJdA = parcelRequire("2bJdA");

var $nCv4H = parcelRequire("nCv4H");

var $bzZoS = parcelRequire("bzZoS");
"use strict";
function $f30e3464cad0ff90$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $2bJdA.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $nCv4H.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $f30e3464cad0ff90$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options = {}){
        super();
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /** The unique id of the geometry. */ this.uid = (0, $1bMtF.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $esrbs.Bounds)();
        this._boundsDirty = true;
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        this.buffers = [];
        this.attributes = {};
        if (attributes) for(const i in attributes)this.addAttribute(i, attributes[i]);
        this.instanceCount = options.instanceCount ?? 1;
        if (indexBuffer) this.addIndex(indexBuffer);
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */ addAttribute(name, attributeOption) {
        const attribute = $f30e3464cad0ff90$var$ensureIsAttribute(attributeOption);
        const bufferIndex = this.buffers.indexOf(attribute.buffer);
        if (bufferIndex === -1) {
            this.buffers.push(attribute.buffer);
            attribute.buffer.on("update", this.onBufferUpdate, this);
            attribute.buffer.on("change", this.onBufferUpdate, this);
        }
        this.attributes[name] = attribute;
    }
    /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */ addIndex(indexBuffer) {
        this.indexBuffer = (0, $nCv4H.ensureIsBuffer)(indexBuffer, true);
        this.buffers.push(this.indexBuffer);
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $bzZoS.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /** Unloads the geometry from the GPU. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.unload();
        this.indexBuffer?.destroy();
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("2bJdA", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $fbb5486b772f5d65$export$a143d493d941bafc);

var $6AQ4q = parcelRequire("6AQ4q");

var $1bMtF = parcelRequire("1bMtF");

var $1T7Iy = parcelRequire("1T7Iy");
"use strict";
class $fbb5486b772f5d65$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** If set to true, the buffer will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $1bMtF.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $1bMtF.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** @internal */ this._updateID = 1;
        this._dataInt32 = null;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size ?? (size = data?.byteLength);
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    get dataInt32() {
        if (!this._dataInt32) this._dataInt32 = new Int32Array(this.data.buffer);
        return this._dataInt32;
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $1T7Iy.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $1T7Iy.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $1T7Iy.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        this._dataInt32 = null;
        if (!oldData || oldData.length !== value.length) {
            if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $1bMtF.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Unloads the buffer from the GPU */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("1T7Iy", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $dae8dc92109b666e$export$f8deb2be8632fd10);
"use strict";
var $dae8dc92109b666e$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($dae8dc92109b666e$export$f8deb2be8632fd10 || {});

});


parcelRegister("nCv4H", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $46142ac757ac88e3$export$e02adcb3cf335e03);

var $2bJdA = parcelRequire("2bJdA");

var $1T7Iy = parcelRequire("1T7Iy");
"use strict";
function $46142ac757ac88e3$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $2bJdA.Buffer))) {
        let usage = index ? (0, $1T7Iy.BufferUsage).INDEX : (0, $1T7Iy.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $1T7Iy.BufferUsage).INDEX | (0, $1T7Iy.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $2bJdA.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("bzZoS", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $a3ce13c56fa87a94$export$ca8be28ec6402f29);
"use strict";
function $a3ce13c56fa87a94$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});


parcelRegister("iqHv9", function(module, exports) {

$parcel$export(module.exports, "getGlobalRenderableBounds", () => $5fbcc85374d5dc31$export$11abb8ef28048394);


var $5xi4h = parcelRequire("5xi4h");
"use strict";
const $5fbcc85374d5dc31$var$tempProjectionMatrix = new (0, $5xi4h.Matrix)();
function $5fbcc85374d5dc31$export$11abb8ef28048394(renderables, bounds) {
    bounds.clear();
    const actualMatrix = bounds.matrix;
    for(let i = 0; i < renderables.length; i++){
        const renderable = renderables[i];
        if (renderable.globalDisplayStatus < 7) continue;
        const renderGroup = renderable.renderGroup ?? renderable.parentRenderGroup;
        if (renderGroup?.isCachedAsTexture) bounds.matrix = $5fbcc85374d5dc31$var$tempProjectionMatrix.copyFrom(renderGroup.textureOffsetInverseTransform).append(renderable.worldTransform);
        else if (renderGroup?._parentCacheAsTextureRenderGroup) bounds.matrix = $5fbcc85374d5dc31$var$tempProjectionMatrix.copyFrom(renderGroup._parentCacheAsTextureRenderGroup.inverseWorldTransform).append(renderable.groupTransform);
        else bounds.matrix = renderable.worldTransform;
        bounds.addBounds(renderable.bounds);
    }
    bounds.matrix = actualMatrix;
    return bounds;
}

});


parcelRegister("lFL21", function(module, exports) {

$parcel$export(module.exports, "CanvasRenderer", () => $72d551da646dbaa4$export$7adc20298958481a);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1SYU5 = parcelRequire("1SYU5");

var $lGOq2 = parcelRequire("lGOq2");

var $1sJn2 = parcelRequire("1sJn2");

var $hzr7O = parcelRequire("hzr7O");

var $928ng = parcelRequire("928ng");

var $jDoUt = parcelRequire("jDoUt");

var $gNCRL = parcelRequire("gNCRL");

var $kF9p5 = parcelRequire("kF9p5");

var $8uCJE = parcelRequire("8uCJE");

var $4PjrR = parcelRequire("4PjrR");

var $7velr = parcelRequire("7velr");

var $g2d25 = parcelRequire("g2d25");

var $bfcaK = parcelRequire("bfcaK");

var $gBwOb = parcelRequire("gBwOb");

var $iZQJj = parcelRequire("iZQJj");

var $f4cmq = parcelRequire("f4cmq");

var $dV9kF = parcelRequire("dV9kF");
"use strict";
const $72d551da646dbaa4$var$DefaultCanvasSystems = [
    ...(0, $g2d25.SharedSystems),
    (0, $gBwOb.CanvasContextSystem),
    (0, $iZQJj.CanvasLimitsSystem),
    (0, $dV9kF.CanvasTextureSystem),
    (0, $f4cmq.CanvasRenderTargetSystem)
];
const $72d551da646dbaa4$var$DefaultCanvasPipes = [
    (0, $4PjrR.BlendModePipe),
    (0, $jDoUt.BatcherPipe),
    (0, $hzr7O.SpritePipe),
    (0, $lGOq2.RenderGroupPipe),
    (0, $gNCRL.AlphaMaskPipe),
    (0, $8uCJE.CanvasStencilMaskPipe),
    (0, $kF9p5.CanvasColorMaskPipe),
    (0, $1SYU5.CustomRenderPipe)
];
const $72d551da646dbaa4$var$DefaultCanvasAdapters = [
    (0, $928ng.CanvasBatchAdaptor),
    (0, $1sJn2.CanvasGraphicsAdaptor)
];
const $72d551da646dbaa4$var$systems = [];
const $72d551da646dbaa4$var$renderPipes = [];
const $72d551da646dbaa4$var$renderPipeAdaptors = [];
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).CanvasSystem, $72d551da646dbaa4$var$systems);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).CanvasPipes, $72d551da646dbaa4$var$renderPipes);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).CanvasPipesAdaptor, $72d551da646dbaa4$var$renderPipeAdaptors);
(0, $aZ9ZN.extensions).add(...$72d551da646dbaa4$var$DefaultCanvasSystems, ...$72d551da646dbaa4$var$DefaultCanvasPipes, ...$72d551da646dbaa4$var$DefaultCanvasAdapters);
class $72d551da646dbaa4$export$7adc20298958481a extends (0, $7velr.AbstractRenderer) {
    constructor(){
        const systemConfig = {
            name: "canvas",
            type: (0, $bfcaK.RendererType).CANVAS,
            systems: $72d551da646dbaa4$var$systems,
            renderPipes: $72d551da646dbaa4$var$renderPipes,
            renderPipeAdaptors: $72d551da646dbaa4$var$renderPipeAdaptors
        };
        super(systemConfig);
    }
}

});
parcelRegister("1SYU5", function(module, exports) {

$parcel$export(module.exports, "CustomRenderPipe", () => $365d9c5683fc42e9$export$e576ade34298fbbb);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $365d9c5683fc42e9$export$e576ade34298fbbb {
    constructor(renderer){
        this._renderer = renderer;
    }
    updateRenderable() {}
    destroyRenderable() {}
    validateRenderable() {
        return false;
    }
    addRenderable(container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(container);
    }
    execute(container) {
        if (!container.isRenderable) return;
        container.render(this._renderer);
    }
    destroy() {
        this._renderer = null;
    }
}
$365d9c5683fc42e9$export$e576ade34298fbbb.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "customRender"
};

});

parcelRegister("lGOq2", function(module, exports) {

$parcel$export(module.exports, "RenderGroupPipe", () => $7a31c6f97549fadc$export$9d1db8757b18c590);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $dokhj = parcelRequire("dokhj");

var $hAzG5 = parcelRequire("hAzG5");

var $7QtNh = parcelRequire("7QtNh");
"use strict";
class $7a31c6f97549fadc$export$9d1db8757b18c590 {
    constructor(renderer){
        this._renderer = renderer;
    }
    addRenderGroup(renderGroup, instructionSet) {
        if (renderGroup.isCachedAsTexture) this._addRenderableCacheAsTexture(renderGroup, instructionSet);
        else this._addRenderableDirect(renderGroup, instructionSet);
    }
    execute(renderGroup) {
        if (!renderGroup.isRenderable) return;
        if (renderGroup.isCachedAsTexture) this._executeCacheAsTexture(renderGroup);
        else this._executeDirect(renderGroup);
    }
    destroy() {
        this._renderer = null;
    }
    _addRenderableDirect(renderGroup, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        if (renderGroup._batchableRenderGroup) {
            (0, $dokhj.BigPool).return(renderGroup._batchableRenderGroup);
            renderGroup._batchableRenderGroup = null;
        }
        instructionSet.add(renderGroup);
    }
    _addRenderableCacheAsTexture(renderGroup, instructionSet) {
        const batchableRenderGroup = renderGroup._batchableRenderGroup ?? (renderGroup._batchableRenderGroup = (0, $dokhj.BigPool).get((0, $hAzG5.BatchableSprite)));
        batchableRenderGroup.renderable = renderGroup.root;
        batchableRenderGroup.transform = renderGroup.root.relativeGroupTransform;
        batchableRenderGroup.texture = renderGroup.texture;
        batchableRenderGroup.bounds = renderGroup._textureBounds;
        instructionSet.add(renderGroup);
        this._renderer.renderPipes.blendMode.pushBlendMode(renderGroup, renderGroup.root.groupBlendMode, instructionSet);
        this._renderer.renderPipes.batch.addToBatch(batchableRenderGroup, instructionSet);
        this._renderer.renderPipes.blendMode.popBlendMode(instructionSet);
    }
    _executeCacheAsTexture(renderGroup) {
        if (renderGroup.textureNeedsUpdate) {
            renderGroup.textureNeedsUpdate = false;
            const worldTransformMatrix = new (0, $5xi4h.Matrix)().translate(-renderGroup._textureBounds.x, -renderGroup._textureBounds.y);
            this._renderer.renderTarget.push(renderGroup.texture, true, null, renderGroup.texture.frame);
            this._renderer.globalUniforms.push({
                worldTransformMatrix: worldTransformMatrix,
                worldColor: 4294967295,
                offset: {
                    x: 0,
                    y: 0
                }
            });
            (0, $7QtNh.executeInstructions)(renderGroup, this._renderer.renderPipes);
            this._renderer.renderTarget.finishRenderPass();
            this._renderer.renderTarget.pop();
            this._renderer.globalUniforms.pop();
        }
        renderGroup._batchableRenderGroup._batcher.updateElement(renderGroup._batchableRenderGroup);
        renderGroup._batchableRenderGroup._batcher.geometry.buffers[0].update();
    }
    _executeDirect(renderGroup) {
        this._renderer.globalUniforms.push({
            worldTransformMatrix: renderGroup.inverseParentTextureTransform,
            worldColor: renderGroup.worldColorAlpha
        });
        (0, $7QtNh.executeInstructions)(renderGroup, this._renderer.renderPipes);
        this._renderer.globalUniforms.pop();
    }
}
$7a31c6f97549fadc$export$9d1db8757b18c590.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "renderGroup"
};

});
parcelRegister("hAzG5", function(module, exports) {

$parcel$export(module.exports, "BatchableSprite", () => $a8912270f3344b3e$export$fe4bdc7069ee0b9c);
"use strict";
class $a8912270f3344b3e$export$fe4bdc7069ee0b9c {
    constructor(){
        this.batcherName = "default";
        this.topology = "triangle-list";
        // batch specific..
        this.attributeSize = 4;
        this.indexSize = 6;
        this.packAsQuad = true;
        this.roundPixels = 0;
        this._attributeStart = 0;
        // location in the buffer
        this._batcher = null;
        this._batch = null;
    }
    get blendMode() {
        return this.renderable.groupBlendMode;
    }
    get color() {
        return this.renderable.groupColorAlpha;
    }
    reset() {
        this.renderable = null;
        this.texture = null;
        this._batcher = null;
        this._batch = null;
        this.bounds = null;
    }
    destroy() {
        this.reset();
    }
}

});

parcelRegister("7QtNh", function(module, exports) {

$parcel$export(module.exports, "executeInstructions", () => $be07b9c3e598bf76$export$de87bf58cb76142c);
"use strict";
function $be07b9c3e598bf76$export$de87bf58cb76142c(renderGroup, renderer) {
    const instructionSet = renderGroup.instructionSet;
    const instructions = instructionSet.instructions;
    for(let i = 0; i < instructionSet.instructionSize; i++){
        const instruction = instructions[i];
        renderer[instruction.renderPipeId].execute(instruction);
    }
}

});


parcelRegister("1sJn2", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsAdaptor", () => $bc9071d496d5e1b4$export$ed48ce6fd08930aa);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $lHrjL = parcelRequire("lHrjL");

var $5xi4h = parcelRequire("5xi4h");

var $2IIjX = parcelRequire("2IIjX");

var $4iNSL = parcelRequire("4iNSL");

var $3qOui = parcelRequire("3qOui");

var $5nS5O = parcelRequire("5nS5O");

var $9kFG0 = parcelRequire("9kFG0");

var $hkzHY = parcelRequire("hkzHY");

var $bySfk = parcelRequire("bySfk");

var $j9D8w = parcelRequire("j9D8w");

var $kOp0T = parcelRequire("kOp0T");
"use strict";
const $bc9071d496d5e1b4$var$emptyCanvasStyle = "#808080";
const $bc9071d496d5e1b4$var$tempMatrix = new (0, $5xi4h.Matrix)();
const $bc9071d496d5e1b4$var$tempTextureMatrix = new (0, $5xi4h.Matrix)();
const $bc9071d496d5e1b4$var$tempGradientMatrix = new (0, $5xi4h.Matrix)();
const $bc9071d496d5e1b4$var$tempPatternMatrix = new (0, $5xi4h.Matrix)();
function $bc9071d496d5e1b4$var$fillTriangles(context, vertices, indices) {
    context.beginPath();
    for(let i = 0; i < indices.length; i += 3){
        const i0 = indices[i] * 2;
        const i1 = indices[i + 1] * 2;
        const i2 = indices[i + 2] * 2;
        context.moveTo(vertices[i0], vertices[i0 + 1]);
        context.lineTo(vertices[i1], vertices[i1 + 1]);
        context.lineTo(vertices[i2], vertices[i2 + 1]);
        context.closePath();
    }
    context.fill();
}
function $bc9071d496d5e1b4$var$colorToHex(color) {
    const clamped = color & 16777215;
    return `#${clamped.toString(16).padStart(6, "0")}`;
}
function $bc9071d496d5e1b4$var$buildRoundedRectPath(context, x, y, width, height, radius) {
    radius = Math.max(0, Math.min(radius, Math.min(width, height) / 2));
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
}
function $bc9071d496d5e1b4$var$buildShapePath(context, shape) {
    switch(shape.type){
        case "rectangle":
            {
                const rect = shape;
                context.rect(rect.x, rect.y, rect.width, rect.height);
                break;
            }
        case "roundedRectangle":
            {
                const rect = shape;
                $bc9071d496d5e1b4$var$buildRoundedRectPath(context, rect.x, rect.y, rect.width, rect.height, rect.radius);
                break;
            }
        case "circle":
            {
                const circle = shape;
                context.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2);
                break;
            }
        case "ellipse":
            {
                const ellipse = shape;
                if (context.ellipse) context.ellipse(ellipse.x, ellipse.y, ellipse.halfWidth, ellipse.halfHeight, 0, 0, Math.PI * 2);
                else {
                    context.save();
                    context.translate(ellipse.x, ellipse.y);
                    context.scale(ellipse.halfWidth, ellipse.halfHeight);
                    context.arc(0, 0, 1, 0, Math.PI * 2);
                    context.restore();
                }
                break;
            }
        case "triangle":
            {
                const tri = shape;
                context.moveTo(tri.x, tri.y);
                context.lineTo(tri.x2, tri.y2);
                context.lineTo(tri.x3, tri.y3);
                context.closePath();
                break;
            }
        case "polygon":
        default:
            {
                const poly = shape;
                const points = poly.points;
                if (!points?.length) break;
                context.moveTo(points[0], points[1]);
                for(let i = 2; i < points.length; i += 2)context.lineTo(points[i], points[i + 1]);
                if (poly.closePath) context.closePath();
                break;
            }
    }
}
function $bc9071d496d5e1b4$var$addHolePaths(context, holes) {
    if (!holes?.length) return false;
    for(let i = 0; i < holes.length; i++){
        const hole = holes[i];
        if (!hole?.shape) continue;
        const transform = hole.transform;
        const hasTransform = transform && !transform.isIdentity();
        if (hasTransform) {
            context.save();
            context.transform(transform.a, transform.b, transform.c, transform.d, transform.tx, transform.ty);
        }
        $bc9071d496d5e1b4$var$buildShapePath(context, hole.shape);
        if (hasTransform) context.restore();
    }
    return true;
}
function $bc9071d496d5e1b4$var$getCanvasStyle(style, tint, textureMatrix, currentTransform) {
    const fill = style.fill;
    if (fill instanceof (0, $hkzHY.FillGradient)) {
        fill.buildGradient();
        const gradientTexture = fill.texture;
        if (gradientTexture) {
            const pattern = (0, $2IIjX.canvasUtils).getTintedPattern(gradientTexture, tint);
            const patternMatrix = textureMatrix ? $bc9071d496d5e1b4$var$tempPatternMatrix.copyFrom(textureMatrix).scale(gradientTexture.source.pixelWidth, gradientTexture.source.pixelHeight) : $bc9071d496d5e1b4$var$tempPatternMatrix.copyFrom(fill.transform);
            if (currentTransform && !style.textureSpace) patternMatrix.append(currentTransform);
            (0, $2IIjX.canvasUtils).applyPatternTransform(pattern, patternMatrix);
            return pattern;
        }
    }
    if (fill instanceof (0, $bySfk.FillPattern)) {
        const pattern = (0, $2IIjX.canvasUtils).getTintedPattern(fill.texture, tint);
        (0, $2IIjX.canvasUtils).applyPatternTransform(pattern, fill.transform);
        return pattern;
    }
    const texture = style.texture;
    if (texture && texture !== (0, $4iNSL.Texture).WHITE) {
        if (!texture.source.resource) return $bc9071d496d5e1b4$var$emptyCanvasStyle;
        const pattern = (0, $2IIjX.canvasUtils).getTintedPattern(texture, tint);
        const patternMatrix = textureMatrix ? $bc9071d496d5e1b4$var$tempPatternMatrix.copyFrom(textureMatrix).scale(texture.source.pixelWidth, texture.source.pixelHeight) : style.matrix;
        (0, $2IIjX.canvasUtils).applyPatternTransform(pattern, patternMatrix);
        return pattern;
    }
    return $bc9071d496d5e1b4$var$colorToHex(tint);
}
class $bc9071d496d5e1b4$export$ed48ce6fd08930aa {
    constructor(){
        this.shader = null;
    }
    contextChange(renderer) {}
    execute(graphicsPipe, renderable) {
        const renderer = graphicsPipe.renderer;
        const contextSystem = renderer.canvasContext;
        const context = contextSystem.activeContext;
        const baseTransform = renderable.groupTransform;
        const globalColor = renderer.globalUniforms.globalUniformData?.worldColor ?? 4294967295;
        const groupColorAlpha = renderable.groupColorAlpha;
        const globalAlpha = (globalColor >>> 24 & 255) / 255;
        const groupAlphaValue = (groupColorAlpha >>> 24 & 255) / 255;
        const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
        const groupAlpha = globalAlpha * groupAlphaValue * filterAlpha;
        if (groupAlpha <= 0) return;
        const globalTint = globalColor & 16777215;
        const groupTintBGR = groupColorAlpha & 16777215;
        const groupTint = (0, $3qOui.bgr2rgb)((0, $5nS5O.multiplyHexColors)(groupTintBGR, globalTint));
        const roundPixels = renderer._roundPixels | renderable._roundPixels;
        context.save();
        contextSystem.setContextTransform(baseTransform, roundPixels === 1);
        contextSystem.setBlendMode(renderable.groupBlendMode);
        const instructions = renderable.context.instructions;
        for(let i = 0; i < instructions.length; i++){
            const instruction = instructions[i];
            if (instruction.action === "texture") {
                const data2 = instruction.data;
                const texture = data2.image;
                const source = texture ? (0, $2IIjX.canvasUtils).getCanvasSource(texture) : null;
                if (!source) continue;
                const alpha2 = data2.alpha * groupAlpha;
                if (alpha2 <= 0) continue;
                const tint2 = (0, $5nS5O.multiplyHexColors)(data2.style, groupTint);
                context.globalAlpha = alpha2;
                let drawSource = source;
                if (tint2 !== 16777215) drawSource = (0, $2IIjX.canvasUtils).getTintedCanvas({
                    texture: texture
                }, tint2);
                const frame = texture.frame;
                const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
                let sx = frame.x * resolution;
                let sy = frame.y * resolution;
                const sw = frame.width * resolution;
                const sh = frame.height * resolution;
                if (drawSource !== source) {
                    sx = 0;
                    sy = 0;
                }
                const transform = data2.transform;
                const hasTransform = transform && !transform.isIdentity();
                const rotate = texture.rotate;
                if (hasTransform || rotate) {
                    $bc9071d496d5e1b4$var$tempMatrix.copyFrom(baseTransform);
                    if (hasTransform) $bc9071d496d5e1b4$var$tempMatrix.append(transform);
                    if (rotate) (0, $lHrjL.groupD8).matrixAppendRotationInv($bc9071d496d5e1b4$var$tempMatrix, rotate, data2.dx, data2.dy, data2.dw, data2.dh);
                    contextSystem.setContextTransform($bc9071d496d5e1b4$var$tempMatrix, roundPixels === 1);
                } else contextSystem.setContextTransform(baseTransform, roundPixels === 1);
                context.drawImage(drawSource, sx, sy, drawSource === source ? sw : drawSource.width, drawSource === source ? sh : drawSource.height, rotate ? 0 : data2.dx, rotate ? 0 : data2.dy, data2.dw, data2.dh);
                if (hasTransform || rotate) contextSystem.setContextTransform(baseTransform, roundPixels === 1);
                continue;
            }
            const data = instruction.data;
            const shapePath = data?.path?.shapePath;
            if (!shapePath?.shapePrimitives?.length) continue;
            const style = data.style;
            const tint = (0, $5nS5O.multiplyHexColors)(style.color, groupTint);
            const alpha = style.alpha * groupAlpha;
            if (alpha <= 0) continue;
            const isStroke = instruction.action === "stroke";
            context.globalAlpha = alpha;
            if (isStroke) {
                const strokeStyle = style;
                context.lineWidth = strokeStyle.width;
                context.lineCap = strokeStyle.cap;
                context.lineJoin = strokeStyle.join;
                context.miterLimit = strokeStyle.miterLimit;
            }
            const shapePrimitives = shapePath.shapePrimitives;
            if (!isStroke && data.hole?.shapePath?.shapePrimitives?.length) {
                const lastShape = shapePrimitives[shapePrimitives.length - 1];
                lastShape.holes = data.hole.shapePath.shapePrimitives;
            }
            for(let j = 0; j < shapePrimitives.length; j++){
                const primitive = shapePrimitives[j];
                if (!primitive?.shape) continue;
                const transform = primitive.transform;
                const hasTransform = transform && !transform.isIdentity();
                const hasTexture = style.texture && style.texture !== (0, $4iNSL.Texture).WHITE;
                const textureTransform = style.textureSpace === "global" ? transform : null;
                const textureMatrix = hasTexture ? (0, $kOp0T.generateTextureMatrix)($bc9071d496d5e1b4$var$tempTextureMatrix, style, primitive.shape, textureTransform) : null;
                const currentTransform = hasTransform ? $bc9071d496d5e1b4$var$tempGradientMatrix.copyFrom(baseTransform).append(transform) : baseTransform;
                const canvasStyle = $bc9071d496d5e1b4$var$getCanvasStyle(style, tint, textureMatrix, currentTransform);
                if (hasTransform) {
                    context.save();
                    context.transform(transform.a, transform.b, transform.c, transform.d, transform.tx, transform.ty);
                }
                if (isStroke) {
                    const strokeStyle = style;
                    const useStrokeGeometry = strokeStyle.alignment !== 0.5 && !strokeStyle.pixelLine;
                    if (useStrokeGeometry) {
                        const points = [];
                        const vertices = [];
                        const indices = [];
                        const shapeBuilder = (0, $j9D8w.shapeBuilders)[primitive.shape.type];
                        if (shapeBuilder?.build(primitive.shape, points)) {
                            const close = primitive.shape.closePath ?? true;
                            (0, $9kFG0.buildLine)(points, strokeStyle, false, close, vertices, indices);
                            context.fillStyle = canvasStyle;
                            $bc9071d496d5e1b4$var$fillTriangles(context, vertices, indices);
                        } else {
                            context.strokeStyle = canvasStyle;
                            context.beginPath();
                            $bc9071d496d5e1b4$var$buildShapePath(context, primitive.shape);
                            context.stroke();
                        }
                    } else {
                        context.strokeStyle = canvasStyle;
                        context.beginPath();
                        $bc9071d496d5e1b4$var$buildShapePath(context, primitive.shape);
                        context.stroke();
                    }
                } else {
                    context.fillStyle = canvasStyle;
                    context.beginPath();
                    $bc9071d496d5e1b4$var$buildShapePath(context, primitive.shape);
                    const hasHoles = $bc9071d496d5e1b4$var$addHolePaths(context, primitive.holes);
                    if (hasHoles) context.fill("evenodd");
                    else context.fill();
                }
                if (hasTransform) context.restore();
            }
        }
        context.restore();
    }
    destroy() {
        this.shader = null;
    }
}
/** @ignore */ $bc9071d496d5e1b4$export$ed48ce6fd08930aa.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipesAdaptor
    ],
    name: "graphics"
};

});
parcelRegister("2IIjX", function(module, exports) {

$parcel$export(module.exports, "canvasUtils", () => $365c06116b971b5a$export$fc1aa66eb2d10b9e);

var $dKHyW = parcelRequire("dKHyW");

var $gLw46 = parcelRequire("gLw46");

var $lHrjL = parcelRequire("lHrjL");

var $gfzpv = parcelRequire("gfzpv");
"use strict";
const $365c06116b971b5a$export$fc1aa66eb2d10b9e = {
    canvas: null,
    convertTintToImage: false,
    cacheStepsPerColorChannel: 8,
    canUseMultiply: (0, $gfzpv.canUseNewCanvasBlendModes)(),
    tintMethod: null,
    _canvasSourceCache: /* @__PURE__ */ new WeakMap(),
    _unpremultipliedCache: /* @__PURE__ */ new WeakMap(),
    getCanvasSource: (texture)=>{
        const source = texture.source;
        const resource = source?.resource;
        if (!resource) return null;
        const isPMA = source.alphaMode === "premultiplied-alpha";
        const resourceWidth = source.resourceWidth ?? source.pixelWidth;
        const resourceHeight = source.resourceHeight ?? source.pixelHeight;
        const needsResize = resourceWidth !== source.pixelWidth || resourceHeight !== source.pixelHeight;
        if (isPMA) {
            if (resource instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && resource instanceof OffscreenCanvas) {
                if (!needsResize) return resource;
            }
            const cached = $365c06116b971b5a$export$fc1aa66eb2d10b9e._unpremultipliedCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
        }
        if (resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int8Array || resource instanceof Uint16Array || resource instanceof Int16Array || resource instanceof Uint32Array || resource instanceof Int32Array || resource instanceof Float32Array || resource instanceof ArrayBuffer) {
            const cached = $365c06116b971b5a$export$fc1aa66eb2d10b9e._canvasSourceCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
            const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d");
            const imageData = context.createImageData(source.pixelWidth, source.pixelHeight);
            const data = imageData.data;
            const bytes = resource instanceof ArrayBuffer ? new Uint8Array(resource) : new Uint8Array(resource.buffer, resource.byteOffset, resource.byteLength);
            if (source.format === "bgra8unorm") for(let i = 0; i < data.length && i + 3 < bytes.length; i += 4){
                data[i] = bytes[i + 2];
                data[i + 1] = bytes[i + 1];
                data[i + 2] = bytes[i];
                data[i + 3] = bytes[i + 3];
            }
            else data.set(bytes.subarray(0, data.length));
            context.putImageData(imageData, 0, 0);
            $365c06116b971b5a$export$fc1aa66eb2d10b9e._canvasSourceCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        if (isPMA) {
            const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d", {
                willReadFrequently: true
            });
            canvas.width = source.pixelWidth;
            canvas.height = source.pixelHeight;
            context.drawImage(resource, 0, 0);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i += 4){
                const a = data[i + 3];
                if (a > 0) {
                    const alphaInv = 255 / a;
                    data[i] = Math.min(255, data[i] * alphaInv + 0.5);
                    data[i + 1] = Math.min(255, data[i + 1] * alphaInv + 0.5);
                    data[i + 2] = Math.min(255, data[i + 2] * alphaInv + 0.5);
                }
            }
            context.putImageData(imageData, 0, 0);
            $365c06116b971b5a$export$fc1aa66eb2d10b9e._unpremultipliedCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        if (needsResize) {
            const cached = $365c06116b971b5a$export$fc1aa66eb2d10b9e._canvasSourceCache.get(source);
            if (cached?.resourceId === source._resourceId) return cached.canvas;
            const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            const context = canvas.getContext("2d");
            canvas.width = source.pixelWidth;
            canvas.height = source.pixelHeight;
            context.drawImage(resource, 0, 0);
            $365c06116b971b5a$export$fc1aa66eb2d10b9e._canvasSourceCache.set(source, {
                canvas: canvas,
                resourceId: source._resourceId
            });
            return canvas;
        }
        return resource;
    },
    getTintedCanvas: (sprite, color)=>{
        const texture = sprite.texture;
        const stringColor = (0, $dKHyW.Color).shared.setValue(color).toHex();
        const cache = texture.tintCache || (texture.tintCache = {});
        const cachedCanvas = cache[stringColor];
        const resourceId = texture.source._resourceId;
        if (cachedCanvas?.tintId === resourceId) return cachedCanvas;
        const canvas = cachedCanvas && "getContext" in cachedCanvas ? cachedCanvas : (0, $gLw46.DOMAdapter).get().createCanvas();
        $365c06116b971b5a$export$fc1aa66eb2d10b9e.tintMethod(texture, color, canvas);
        canvas.tintId = resourceId;
        if ($365c06116b971b5a$export$fc1aa66eb2d10b9e.convertTintToImage && canvas.toDataURL !== void 0) {
            const tintImage = (0, $gLw46.DOMAdapter).get().createImage();
            tintImage.src = canvas.toDataURL();
            tintImage.tintId = resourceId;
            cache[stringColor] = tintImage;
        } else cache[stringColor] = canvas;
        return cache[stringColor];
    },
    getTintedPattern: (texture, color)=>{
        const stringColor = (0, $dKHyW.Color).shared.setValue(color).toHex();
        const cache = texture.patternCache || (texture.patternCache = {});
        const resourceId = texture.source._resourceId;
        let pattern = cache[stringColor];
        if (pattern?.tintId === resourceId) return pattern;
        if (!$365c06116b971b5a$export$fc1aa66eb2d10b9e.canvas) $365c06116b971b5a$export$fc1aa66eb2d10b9e.canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        $365c06116b971b5a$export$fc1aa66eb2d10b9e.tintMethod(texture, color, $365c06116b971b5a$export$fc1aa66eb2d10b9e.canvas);
        const context = $365c06116b971b5a$export$fc1aa66eb2d10b9e.canvas.getContext("2d");
        pattern = context.createPattern($365c06116b971b5a$export$fc1aa66eb2d10b9e.canvas, "repeat");
        pattern.tintId = resourceId;
        cache[stringColor] = pattern;
        return pattern;
    },
    /**
   * Applies a transform to a CanvasPattern.
   * @param pattern - The pattern to apply the transform to.
   * @param matrix - The matrix to apply.
   * @param matrix.a
   * @param matrix.b
   * @param matrix.c
   * @param matrix.d
   * @param matrix.tx
   * @param matrix.ty
   * @param invert
   */ applyPatternTransform: (pattern, matrix, invert = true)=>{
        if (!matrix) return;
        const patternAny = pattern;
        if (!patternAny.setTransform) return;
        const DOMMatrixCtor = globalThis.DOMMatrix;
        if (!DOMMatrixCtor) return;
        const domMatrix = new DOMMatrixCtor([
            matrix.a,
            matrix.b,
            matrix.c,
            matrix.d,
            matrix.tx,
            matrix.ty
        ]);
        patternAny.setTransform(invert ? domMatrix.inverse() : domMatrix);
    },
    tintWithMultiply: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $lHrjL.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.fillStyle = (0, $dKHyW.Color).shared.setValue(color).toHex();
        context.fillRect(0, 0, outWidth, outHeight);
        context.globalCompositeOperation = "multiply";
        const source = $365c06116b971b5a$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $365c06116b971b5a$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.globalCompositeOperation = "destination-atop";
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },
    tintWithOverlay: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $lHrjL.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.globalCompositeOperation = "copy";
        context.fillStyle = (0, $dKHyW.Color).shared.setValue(color).toHex();
        context.fillRect(0, 0, outWidth, outHeight);
        context.globalCompositeOperation = "destination-atop";
        const source = $365c06116b971b5a$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $365c06116b971b5a$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },
    tintWithPerPixel: (texture, color, canvas)=>{
        const context = canvas.getContext("2d");
        const crop = texture.frame.clone();
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const rotate = texture.rotate;
        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;
        const isVertical = (0, $lHrjL.groupD8).isVertical(rotate);
        const outWidth = isVertical ? crop.height : crop.width;
        const outHeight = isVertical ? crop.width : crop.height;
        canvas.width = Math.ceil(outWidth);
        canvas.height = Math.ceil(outHeight);
        context.save();
        context.globalCompositeOperation = "copy";
        const source = $365c06116b971b5a$export$fc1aa66eb2d10b9e.getCanvasSource(texture);
        if (!source) {
            context.restore();
            return;
        }
        if (rotate) $365c06116b971b5a$export$fc1aa66eb2d10b9e._applyInverseRotation(context, rotate, crop.width, crop.height);
        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
        const r = color >> 16 & 255;
        const g = color >> 8 & 255;
        const b = color & 255;
        const imageData = context.getImageData(0, 0, outWidth, outHeight);
        const data = imageData.data;
        for(let i = 0; i < data.length; i += 4){
            data[i] = data[i] * r / 255;
            data[i + 1] = data[i + 1] * g / 255;
            data[i + 2] = data[i + 2] * b / 255;
        }
        context.putImageData(imageData, 0, 0);
    },
    /**
   * Applies inverse rotation transform to context for texture packer rotation compensation.
   * Supports all 16 groupD8 symmetries (rotations and reflections).
   * @param context - Canvas 2D context
   * @param rotate - The groupD8 rotation value
   * @param srcWidth - Source crop width (before rotation)
   * @param srcHeight - Source crop height (before rotation)
   */ _applyInverseRotation: (context, rotate, srcWidth, srcHeight)=>{
        const inv = (0, $lHrjL.groupD8).inv(rotate);
        const a = (0, $lHrjL.groupD8).uX(inv);
        const b = (0, $lHrjL.groupD8).uY(inv);
        const c = (0, $lHrjL.groupD8).vX(inv);
        const d = (0, $lHrjL.groupD8).vY(inv);
        const tx = -Math.min(0, a * srcWidth, c * srcHeight, a * srcWidth + c * srcHeight);
        const ty = -Math.min(0, b * srcWidth, d * srcHeight, b * srcWidth + d * srcHeight);
        context.transform(a, b, c, d, tx, ty);
    }
};
$365c06116b971b5a$export$fc1aa66eb2d10b9e.tintMethod = $365c06116b971b5a$export$fc1aa66eb2d10b9e.canUseMultiply ? $365c06116b971b5a$export$fc1aa66eb2d10b9e.tintWithMultiply : $365c06116b971b5a$export$fc1aa66eb2d10b9e.tintWithPerPixel;

});
parcelRegister("gfzpv", function(module, exports) {

$parcel$export(module.exports, "canUseNewCanvasBlendModes", () => $024b78e6d51999b4$export$888398ad8627cefd);

var $gLw46 = parcelRequire("gLw46");
"use strict";
let $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue;
function $024b78e6d51999b4$var$createColoredCanvas(color) {
    const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(6, 1);
    const context = canvas.getContext("2d");
    context.fillStyle = color;
    context.fillRect(0, 0, 6, 1);
    return canvas;
}
function $024b78e6d51999b4$export$888398ad8627cefd() {
    if ($024b78e6d51999b4$var$canUseNewCanvasBlendModesValue !== void 0) return $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue;
    try {
        const magenta = $024b78e6d51999b4$var$createColoredCanvas("#ff00ff");
        const yellow = $024b78e6d51999b4$var$createColoredCanvas("#ffff00");
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(6, 1);
        const context = canvas.getContext("2d");
        context.globalCompositeOperation = "multiply";
        context.drawImage(magenta, 0, 0);
        context.drawImage(yellow, 2, 0);
        const imageData = context.getImageData(2, 0, 1, 1);
        if (!imageData) $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue = false;
        else {
            const data = imageData.data;
            $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue = data[0] === 255 && data[1] === 0 && data[2] === 0;
        }
    } catch (_error) {
        $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue = false;
    }
    return $024b78e6d51999b4$var$canUseNewCanvasBlendModesValue;
}

});


parcelRegister("9kFG0", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $cf048a7a6cf33846$export$45986ccf08e93b0b);

var $ds7Xo = parcelRequire("ds7Xo");

var $6yC9w = parcelRequire("6yC9w");

var $1g5QY = parcelRequire("1g5QY");
"use strict";
function $cf048a7a6cf33846$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $cf048a7a6cf33846$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $cf048a7a6cf33846$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, indices) {
    const eps = (0, $6yC9w.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $1g5QY.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $ds7Xo.Point)(points[0], points[1]);
    const lastPoint = new (0, $ds7Xo.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $cf048a7a6cf33846$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $cf048a7a6cf33846$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $cf048a7a6cf33846$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $cf048a7a6cf33846$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $cf048a7a6cf33846$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $cf048a7a6cf33846$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $cf048a7a6cf33846$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $cf048a7a6cf33846$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $cf048a7a6cf33846$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $6yC9w.curveEps) * (0, $6yC9w.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("6yC9w", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $94e5675268392839$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $94e5675268392839$export$51a946149243709);
"use strict";
const $94e5675268392839$export$7159a7c43f12984 = 1e-4;
const $94e5675268392839$export$51a946149243709 = 1e-4;

});

parcelRegister("1g5QY", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $56d011a9956203eb$export$38856eae80d480e1);
"use strict";
function $56d011a9956203eb$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("hkzHY", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $486a3a38f01d6c3f$export$722a6ea8c60ca86);

var $dKHyW = parcelRequire("dKHyW");

var $gLw46 = parcelRequire("gLw46");

var $5xi4h = parcelRequire("5xi4h");

var $cVYNB = parcelRequire("cVYNB");

var $4iNSL = parcelRequire("4iNSL");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $cebhF = parcelRequire("cebhF");
"use strict";
const $486a3a38f01d6c3f$var$emptyColorStops = [
    {
        offset: 0,
        color: "white"
    },
    {
        offset: 1,
        color: "black"
    }
];
const $486a3a38f01d6c3f$var$_FillGradient = class _FillGradient {
    constructor(...args){
        /**
     * Unique identifier for this gradient instance
     * @internal
     */ this.uid = (0, $1bMtF.uid)("fillGradient");
        /**
     * Internal tick counter to track changes in the gradient.
     * This is used to invalidate the gradient when the texture changes.
     * @internal
     */ this._tick = 0;
        /** Type of gradient - currently only supports 'linear' */ this.type = "linear";
        /** Array of color stops defining the gradient */ this.colorStops = [];
        let options = $486a3a38f01d6c3f$var$ensureGradientOptions(args);
        const defaults = options.type === "radial" ? _FillGradient.defaultRadialOptions : _FillGradient.defaultLinearOptions;
        options = {
            ...defaults,
            ...(0, $cebhF.definedProps)(options)
        };
        this._textureSize = options.textureSize;
        this._wrapMode = options.wrapMode;
        if (options.type === "radial") {
            this.center = options.center;
            this.outerCenter = options.outerCenter ?? this.center;
            this.innerRadius = options.innerRadius;
            this.outerRadius = options.outerRadius;
            this.scale = options.scale;
            this.rotation = options.rotation;
        } else {
            this.start = options.start;
            this.end = options.end;
        }
        this.textureSpace = options.textureSpace;
        this.type = options.type;
        options.colorStops.forEach((stop)=>{
            this.addColorStop(stop.offset, stop.color);
        });
    }
    /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */ addColorStop(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: (0, $dKHyW.Color).shared.setValue(color).toHexa()
        });
        return this;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildLinearGradient() {
        if (this.texture) return;
        let { x: x0, y: y0 } = this.start;
        let { x: x1, y: y1 } = this.end;
        let dx = x1 - x0;
        let dy = y1 - y0;
        const flip = dx < 0 || dy < 0;
        if (this._wrapMode === "clamp-to-edge") {
            if (dx < 0) {
                const temp = x0;
                x0 = x1;
                x1 = temp;
                dx *= -1;
            }
            if (dy < 0) {
                const temp = y0;
                y0 = y1;
                y1 = temp;
                dy *= -1;
            }
        }
        const colorStops = this.colorStops.length ? this.colorStops : $486a3a38f01d6c3f$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $486a3a38f01d6c3f$var$getCanvas(defaultSize, 1);
        const gradient = !flip ? context.createLinearGradient(0, 0, this._textureSize, 0) : context.createLinearGradient(this._textureSize, 0, 0, 0);
        $486a3a38f01d6c3f$var$addColorStops(gradient, colorStops);
        context.fillStyle = gradient;
        context.fillRect(0, 0, defaultSize, 1);
        this.texture = new (0, $4iNSL.Texture)({
            source: new (0, $cVYNB.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        const m = new (0, $5xi4h.Matrix)();
        m.scale(dist / defaultSize, 1);
        m.rotate(angle);
        m.translate(x0, y0);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildGradient() {
        if (!this.texture) this._tick++;
        if (this.type === "linear") this.buildLinearGradient();
        else this.buildRadialGradient();
    }
    /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildRadialGradient() {
        if (this.texture) return;
        const colorStops = this.colorStops.length ? this.colorStops : $486a3a38f01d6c3f$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $486a3a38f01d6c3f$var$getCanvas(defaultSize, defaultSize);
        const { x: x0, y: y0 } = this.center;
        const { x: x1, y: y1 } = this.outerCenter;
        const r0 = this.innerRadius;
        const r1 = this.outerRadius;
        const ox = x1 - r1;
        const oy = y1 - r1;
        const scale = defaultSize / (r1 * 2);
        const cx = (x0 - ox) * scale;
        const cy = (y0 - oy) * scale;
        const gradient = context.createRadialGradient(cx, cy, r0 * scale, (x1 - ox) * scale, (y1 - oy) * scale, r1 * scale);
        $486a3a38f01d6c3f$var$addColorStops(gradient, colorStops);
        context.fillStyle = colorStops[colorStops.length - 1].color;
        context.fillRect(0, 0, defaultSize, defaultSize);
        context.fillStyle = gradient;
        context.translate(cx, cy);
        context.rotate(this.rotation);
        context.scale(1, this.scale);
        context.translate(-cx, -cy);
        context.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $4iNSL.Texture)({
            source: new (0, $cVYNB.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const m = new (0, $5xi4h.Matrix)();
        m.scale(1 / scale, 1 / scale);
        m.translate(ox, oy);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture?.destroy(true);
        this.texture = null;
        this.transform = null;
        this.colorStops = [];
        this.start = null;
        this.end = null;
        this.center = null;
        this.outerCenter = null;
    }
    /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */ get styleKey() {
        return `fill-gradient-${this.uid}-${this._tick}`;
    }
};
/** Default options for creating a gradient fill */ $486a3a38f01d6c3f$var$_FillGradient.defaultLinearOptions = {
    start: {
        x: 0,
        y: 0
    },
    end: {
        x: 0,
        y: 1
    },
    colorStops: [],
    textureSpace: "local",
    type: "linear",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
/** Default options for creating a radial gradient fill */ $486a3a38f01d6c3f$var$_FillGradient.defaultRadialOptions = {
    center: {
        x: 0.5,
        y: 0.5
    },
    innerRadius: 0,
    outerRadius: 0.5,
    colorStops: [],
    scale: 1,
    textureSpace: "local",
    type: "radial",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
let $486a3a38f01d6c3f$export$722a6ea8c60ca86 = $486a3a38f01d6c3f$var$_FillGradient;
function $486a3a38f01d6c3f$var$addColorStops(gradient, colorStops) {
    for(let i = 0; i < colorStops.length; i++){
        const stop = colorStops[i];
        gradient.addColorStop(stop.offset, stop.color);
    }
}
function $486a3a38f01d6c3f$var$getCanvas(width, height) {
    const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(width, height);
    const context = canvas.getContext("2d");
    return {
        canvas: canvas,
        context: context
    };
}
function $486a3a38f01d6c3f$var$ensureGradientOptions(args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || args[1]) {
        (0, $6LhOA.deprecation)("8.5.2", `use options object instead`);
        options = {
            type: "linear",
            start: {
                x: args[0],
                y: args[1]
            },
            end: {
                x: args[2],
                y: args[3]
            },
            textureSpace: args[4],
            textureSize: args[5] ?? $486a3a38f01d6c3f$export$722a6ea8c60ca86.defaultLinearOptions.textureSize
        };
    }
    return options;
}

});

parcelRegister("bySfk", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $98003d12d671068a$export$3d1378c7410cd8e);

var $5xi4h = parcelRequire("5xi4h");

var $1bMtF = parcelRequire("1bMtF");
"use strict";
const $98003d12d671068a$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $98003d12d671068a$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /**
     * unique id for this fill pattern
     * @internal
     */ this.uid = (0, $1bMtF.uid)("fillPattern");
        /**
     * Internal tick counter to track changes in the pattern.
     * This is used to invalidate the pattern when the texture or transform changes.
     * @internal
     */ this._tick = 0;
        /** The transform matrix applied to the pattern */ this.transform = new (0, $5xi4h.Matrix)();
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $98003d12d671068a$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $98003d12d671068a$var$repetitionMap[repetition].addressModeV;
        }
    }
    /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */ setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._tick++;
    }
    /** Internal texture used to render the gradient */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this._texture === value) return;
        this._texture = value;
        this._tick++;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `fill-pattern-${this.uid}-${this._tick}`;
    }
    /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture.destroy(true);
        this.texture = null;
    }
}

});

parcelRegister("j9D8w", function(module, exports) {

$parcel$export(module.exports, "shapeBuilders", () => $4f40ba86415dbbfc$export$ab760b0d495e92a1);
$parcel$export(module.exports, "buildContextBatches", () => $4f40ba86415dbbfc$export$e3c00f31a053d231);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");

var $6WSe9 = parcelRequire("6WSe9");

var $iWOpI = parcelRequire("iWOpI");

var $4iNSL = parcelRequire("4iNSL");

var $dokhj = parcelRequire("dokhj");

var $arDaU = parcelRequire("arDaU");

var $7p3VJ = parcelRequire("7p3VJ");

var $9kFG0 = parcelRequire("9kFG0");

var $iS417 = parcelRequire("iS417");

var $ctmiq = parcelRequire("ctmiq");

var $6F4Y7 = parcelRequire("6F4Y7");

var $dWsyQ = parcelRequire("dWsyQ");

var $kOp0T = parcelRequire("kOp0T");

var $lToNE = parcelRequire("lToNE");
"use strict";
const $4f40ba86415dbbfc$export$ab760b0d495e92a1 = {};
(0, $aZ9ZN.extensions).handleByMap((0, $aZ9ZN.ExtensionType).ShapeBuilder, $4f40ba86415dbbfc$export$ab760b0d495e92a1);
(0, $aZ9ZN.extensions).add((0, $6F4Y7.buildRectangle), (0, $ctmiq.buildPolygon), (0, $dWsyQ.buildTriangle), (0, $7p3VJ.buildCircle), (0, $7p3VJ.buildEllipse), (0, $7p3VJ.buildRoundedRectangle));
const $4f40ba86415dbbfc$var$tempRect = new (0, $ar2Ly.Rectangle)();
const $4f40ba86415dbbfc$var$tempTextureMatrix = new (0, $5xi4h.Matrix)();
function $4f40ba86415dbbfc$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $4f40ba86415dbbfc$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $4f40ba86415dbbfc$var$addShapePathToGeometryData(hole.shapePath, style, true, batches, geometryData);
            if (hole) shapePath.shapePrimitives[shapePath.shapePrimitives.length - 1].holes = hole.shapePath.shapePrimitives;
            $4f40ba86415dbbfc$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData);
        }
    }
}
function $4f40ba86415dbbfc$var$addTextureToGeometryData(data, batches, geometryData) {
    const points = [];
    const build = $4f40ba86415dbbfc$export$ab760b0d495e92a1.rectangle;
    const rect = $4f40ba86415dbbfc$var$tempRect;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    if (!build.build(rect, points)) return;
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    if (matrix) (0, $iWOpI.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const texture = data.image;
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $dokhj.BigPool).get((0, $arDaU.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $4f40ba86415dbbfc$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix, holes: holes })=>{
        const points = [];
        const build = $4f40ba86415dbbfc$export$ab760b0d495e92a1[shape.type];
        if (!build.build(shape, points)) return;
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        let topology = "triangle-list";
        if (matrix) (0, $iWOpI.transformVertices)(points, matrix);
        if (!isStroke) {
            if (holes) {
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $4f40ba86415dbbfc$var$getHoleArrays(holes);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $lToNE.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            if (!lineStyle.pixelLine) (0, $9kFG0.buildLine)(points, lineStyle, false, close, vertices, indices);
            else {
                (0, $iS417.buildPixelLine)(points, close, vertices, indices);
                topology = "line-list";
            }
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $4iNSL.Texture).WHITE) {
            const textureMatrix = (0, $kOp0T.generateTextureMatrix)($4f40ba86415dbbfc$var$tempTextureMatrix, style, shape, matrix);
            (0, $6WSe9.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $6WSe9.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $dokhj.BigPool).get((0, $arDaU.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        graphicsBatch.topology = topology;
        batches.push(graphicsBatch);
    });
}
function $4f40ba86415dbbfc$var$getHoleArrays(holePrimitives) {
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $4f40ba86415dbbfc$export$ab760b0d495e92a1[holePrimitive.type];
        if (holeBuilder.build(holePrimitive, holePoints)) holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("6WSe9", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $5fda3170ee1b20de$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $5fda3170ee1b20de$export$580e3d8462b9fe52);
"use strict";
function $5fda3170ee1b20de$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $5fda3170ee1b20de$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("iWOpI", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $ba9dcf5366e8369d$export$cbe36b8a8d6e3d3);
"use strict";
function $ba9dcf5366e8369d$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset || (offset = 0);
    stride || (stride = 2);
    size || (size = vertices.length / stride - offset);
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("arDaU", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $e96221a5d98ea530$export$91d2a08bbf21546b);

var $5xi4h = parcelRequire("5xi4h");

var $5nS5O = parcelRequire("5nS5O");
"use strict";
const $e96221a5d98ea530$var$identityMatrix = new (0, $5xi4h.Matrix)();
class $e96221a5d98ea530$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.topology = "triangle-list";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.renderable && this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $5nS5O.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $e96221a5d98ea530$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
        gpuBuffer.topology = this.topology;
    }
    reset() {
        this.applyTransform = true;
        this.renderable = null;
        this.topology = "triangle-list";
    }
    destroy() {
        this.renderable = null;
        this.texture = null;
        this.geometryData = null;
        this._batcher = null;
        this._batch = null;
    }
}

});

parcelRegister("7p3VJ", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $7efcbc9d4c1958a9$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $7efcbc9d4c1958a9$export$4b54fce47d2ae7f4);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            rx = ry = circle.radius;
            if (rx <= 0) return false;
            x = circle.x;
            y = circle.y;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            if (rx <= 0 || ry <= 0) return false;
            x = ellipse.x;
            y = ellipse.y;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (dx < 0 || dy < 0) return false;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return false;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return true;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $7efcbc9d4c1958a9$export$d35b00c6ec9534ca = {
    ...$7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2,
    extension: {
        ...$7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $7efcbc9d4c1958a9$export$4b54fce47d2ae7f4 = {
    ...$7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2,
    extension: {
        ...$7efcbc9d4c1958a9$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("iS417", function(module, exports) {

$parcel$export(module.exports, "buildPixelLine", () => $6304f1bfabc0fe62$export$44c058937667e9f0);

var $6yC9w = parcelRequire("6yC9w");
"use strict";
function $6304f1bfabc0fe62$export$44c058937667e9f0(points, closed, vertices, indices) {
    const eps = (0, $6yC9w.closePointEps);
    if (points.length === 0) return;
    const fx = points[0];
    const fy = points[1];
    const lx = points[points.length - 2];
    const ly = points[points.length - 1];
    const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
    const verts = vertices;
    const length = points.length / 2;
    const indexStart = verts.length / 2;
    for(let i = 0; i < length; i++){
        verts.push(points[i * 2]);
        verts.push(points[i * 2 + 1]);
    }
    for(let i = 0; i < length - 1; i++)indices.push(indexStart + i, indexStart + i + 1);
    if (closePath) indices.push(indexStart + length - 1, indexStart);
}

});

parcelRegister("ctmiq", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $0bf334ffcb6837b7$export$4c2d12f7b210f357);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $lToNE = parcelRequire("lToNE");
"use strict";
const $0bf334ffcb6837b7$var$emptyArray = [];
const $0bf334ffcb6837b7$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $lToNE.triangulateWithHoles)(points, $0bf334ffcb6837b7$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("lToNE", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $9469cd6ace5aaf92$export$5a241bf9c2c3d94b);

var $eyVYu = parcelRequire("eyVYu");
"use strict";
function $9469cd6ace5aaf92$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, $eyVYu.earcut)(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("eyVYu", function(module, exports) {

$parcel$export(module.exports, "earcut", () => $3a035676a6f5cce5$export$71a1409458eaaf0d);

var $49m7e = parcelRequire("49m7e");

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $3a035676a6f5cce5$export$71a1409458eaaf0d = (0, $49m7e.default).default || (0, $49m7e.default);

});
parcelRegister("49m7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $30592864694c3355$export$2e2bcd8739ae039);
function $30592864694c3355$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $30592864694c3355$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $30592864694c3355$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $30592864694c3355$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $30592864694c3355$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $30592864694c3355$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $30592864694c3355$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $30592864694c3355$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $30592864694c3355$var$equals(last, last.next)) {
        $30592864694c3355$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $30592864694c3355$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($30592864694c3355$var$equals(p, p.next) || $30592864694c3355$var$area(p.prev, p, p.next) === 0)) {
            $30592864694c3355$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $30592864694c3355$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $30592864694c3355$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $30592864694c3355$var$isEarHashed(ear, minX, minY, invSize) : $30592864694c3355$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $30592864694c3355$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $30592864694c3355$var$earcutLinked($30592864694c3355$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $30592864694c3355$var$cureLocalIntersections($30592864694c3355$var$filterPoints(ear), triangles);
                $30592864694c3355$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $30592864694c3355$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $30592864694c3355$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($30592864694c3355$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $30592864694c3355$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($30592864694c3355$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $30592864694c3355$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $30592864694c3355$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $30592864694c3355$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $30592864694c3355$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $30592864694c3355$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$30592864694c3355$var$equals(a, b) && $30592864694c3355$var$intersects(a, p, p.next, b) && $30592864694c3355$var$locallyInside(a, b) && $30592864694c3355$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $30592864694c3355$var$removeNode(p);
            $30592864694c3355$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $30592864694c3355$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $30592864694c3355$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $30592864694c3355$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $30592864694c3355$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $30592864694c3355$var$filterPoints(a, a.next);
                c = $30592864694c3355$var$filterPoints(c, c.next);
                // run earcut on each half
                $30592864694c3355$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $30592864694c3355$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $30592864694c3355$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $30592864694c3355$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($30592864694c3355$var$getLeftmost(list));
    }
    queue.sort($30592864694c3355$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $30592864694c3355$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $30592864694c3355$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $30592864694c3355$var$eliminateHole(hole, outerNode) {
    const bridge = $30592864694c3355$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $30592864694c3355$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $30592864694c3355$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $30592864694c3355$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $30592864694c3355$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($30592864694c3355$var$equals(hole, p)) return p;
    do {
        if ($30592864694c3355$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $30592864694c3355$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($30592864694c3355$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $30592864694c3355$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $30592864694c3355$var$sectorContainsSector(m, p) {
    return $30592864694c3355$var$area(m.prev, m, p.prev) < 0 && $30592864694c3355$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $30592864694c3355$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $30592864694c3355$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $30592864694c3355$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $30592864694c3355$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $30592864694c3355$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $30592864694c3355$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $30592864694c3355$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $30592864694c3355$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $30592864694c3355$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$30592864694c3355$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($30592864694c3355$var$locallyInside(a, b) && $30592864694c3355$var$locallyInside(b, a) && $30592864694c3355$var$middleInside(a, b) && // locally visible
    ($30592864694c3355$var$area(a.prev, a, b.prev) || $30592864694c3355$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $30592864694c3355$var$equals(a, b) && $30592864694c3355$var$area(a.prev, a, a.next) > 0 && $30592864694c3355$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $30592864694c3355$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $30592864694c3355$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $30592864694c3355$var$intersects(p1, q1, p2, q2) {
    const o1 = $30592864694c3355$var$sign($30592864694c3355$var$area(p1, q1, p2));
    const o2 = $30592864694c3355$var$sign($30592864694c3355$var$area(p1, q1, q2));
    const o3 = $30592864694c3355$var$sign($30592864694c3355$var$area(p2, q2, p1));
    const o4 = $30592864694c3355$var$sign($30592864694c3355$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $30592864694c3355$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $30592864694c3355$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $30592864694c3355$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $30592864694c3355$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $30592864694c3355$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $30592864694c3355$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $30592864694c3355$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $30592864694c3355$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $30592864694c3355$var$locallyInside(a, b) {
    return $30592864694c3355$var$area(a.prev, a, a.next) < 0 ? $30592864694c3355$var$area(a, b, a.next) >= 0 && $30592864694c3355$var$area(a, a.prev, b) >= 0 : $30592864694c3355$var$area(a, b, a.prev) < 0 || $30592864694c3355$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $30592864694c3355$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $30592864694c3355$var$splitPolygon(a, b) {
    const a2 = $30592864694c3355$var$createNode(a.i, a.x, a.y), b2 = $30592864694c3355$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $30592864694c3355$var$insertNode(i, x, y, last) {
    const p = $30592864694c3355$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $30592864694c3355$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $30592864694c3355$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $30592864694c3355$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($30592864694c3355$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($30592864694c3355$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $30592864694c3355$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $30592864694c3355$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}

});




parcelRegister("6F4Y7", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $05316efbf3a73477$export$cbe813d11f2192b2);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $05316efbf3a73477$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width > 0 && height > 0)) return false;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("dWsyQ", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $66128cb2b19ed417$export$8eb75cb9f614d270);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $66128cb2b19ed417$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("kOp0T", function(module, exports) {

$parcel$export(module.exports, "generateTextureMatrix", () => $5a8d041774a6b22c$export$1e9b9e463121b388);

var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");

var $hkzHY = parcelRequire("hkzHY");
"use strict";
const $5a8d041774a6b22c$var$tempTextureMatrix = new (0, $5xi4h.Matrix)();
const $5a8d041774a6b22c$var$tempRect = new (0, $ar2Ly.Rectangle)();
function $5a8d041774a6b22c$export$1e9b9e463121b388(out, style, shape, matrix) {
    const textureMatrix = style.matrix ? out.copyFrom(style.matrix).invert() : out.identity();
    if (style.textureSpace === "local") {
        const bounds = shape.getBounds($5a8d041774a6b22c$var$tempRect);
        if (style.width) bounds.pad(style.width);
        const { x: tx, y: ty } = bounds;
        const sx = 1 / bounds.width;
        const sy = 1 / bounds.height;
        const mTx = -tx * sx;
        const mTy = -ty * sy;
        const a1 = textureMatrix.a;
        const b1 = textureMatrix.b;
        const c1 = textureMatrix.c;
        const d1 = textureMatrix.d;
        textureMatrix.a *= sx;
        textureMatrix.b *= sx;
        textureMatrix.c *= sy;
        textureMatrix.d *= sy;
        textureMatrix.tx = mTx * a1 + mTy * c1 + textureMatrix.tx;
        textureMatrix.ty = mTx * b1 + mTy * d1 + textureMatrix.ty;
    } else {
        textureMatrix.translate(style.texture.frame.x, style.texture.frame.y);
        textureMatrix.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
    }
    const sourceStyle = style.texture.source.style;
    if (!(style.fill instanceof (0, $hkzHY.FillGradient)) && sourceStyle.addressMode === "clamp-to-edge") {
        sourceStyle.addressMode = "repeat";
        sourceStyle.update();
    }
    if (matrix) textureMatrix.append($5a8d041774a6b22c$var$tempTextureMatrix.copyFrom(matrix).invert());
    return textureMatrix;
}

});



parcelRegister("hzr7O", function(module, exports) {

$parcel$export(module.exports, "SpritePipe", () => $a434b0910e52c47b$export$ffb847f6753f2536);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $hAzG5 = parcelRequire("hAzG5");
"use strict";
class $a434b0910e52c47b$export$ffb847f6753f2536 {
    constructor(renderer){
        this._renderer = renderer;
    }
    addRenderable(sprite, instructionSet) {
        const gpuSprite = this._getGpuSprite(sprite);
        if (sprite.didViewUpdate) this._updateBatchableSprite(sprite, gpuSprite);
        this._renderer.renderPipes.batch.addToBatch(gpuSprite, instructionSet);
    }
    updateRenderable(sprite) {
        const gpuSprite = this._getGpuSprite(sprite);
        if (sprite.didViewUpdate) this._updateBatchableSprite(sprite, gpuSprite);
        gpuSprite._batcher.updateElement(gpuSprite);
    }
    validateRenderable(sprite) {
        const gpuSprite = this._getGpuSprite(sprite);
        return !gpuSprite._batcher.checkAndUpdateTexture(gpuSprite, sprite._texture);
    }
    _updateBatchableSprite(sprite, batchableSprite) {
        batchableSprite.bounds = sprite.visualBounds;
        batchableSprite.texture = sprite._texture;
    }
    _getGpuSprite(sprite) {
        return sprite._gpuData[this._renderer.uid] || this._initGPUSprite(sprite);
    }
    _initGPUSprite(sprite) {
        const batchableSprite = new (0, $hAzG5.BatchableSprite)();
        batchableSprite.renderable = sprite;
        batchableSprite.transform = sprite.groupTransform;
        batchableSprite.texture = sprite._texture;
        batchableSprite.bounds = sprite.visualBounds;
        batchableSprite.roundPixels = this._renderer._roundPixels | sprite._roundPixels;
        sprite._gpuData[this._renderer.uid] = batchableSprite;
        return batchableSprite;
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $a434b0910e52c47b$export$ffb847f6753f2536.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "sprite"
};

});

parcelRegister("928ng", function(module, exports) {

$parcel$export(module.exports, "CanvasBatchAdaptor", () => $6e916101417294d0$export$ec2ef38346665594);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $lHrjL = parcelRequire("lHrjL");

var $5xi4h = parcelRequire("5xi4h");

var $3qOui = parcelRequire("3qOui");

var $5nS5O = parcelRequire("5nS5O");

var $2IIjX = parcelRequire("2IIjX");
"use strict";
const $6e916101417294d0$var$_CanvasBatchAdaptor = class _CanvasBatchAdaptor {
    static _getPatternRepeat(addressModeU, addressModeV) {
        const repeatU = addressModeU && addressModeU !== "clamp-to-edge";
        const repeatV = addressModeV && addressModeV !== "clamp-to-edge";
        if (repeatU && repeatV) return "repeat";
        if (repeatU) return "repeat-x";
        if (repeatV) return "repeat-y";
        return "no-repeat";
    }
    start(batchPipe, geometry, shader) {}
    execute(batchPipe, batch) {
        const elements = batch.elements;
        if (!elements || !elements.length) return;
        const renderer = batchPipe.renderer;
        const contextSystem = renderer.canvasContext;
        const context = contextSystem.activeContext;
        for(let i = 0; i < elements.length; i++){
            const element = elements[i];
            if (!element.packAsQuad) continue;
            const quad = element;
            const texture = quad.texture;
            const source = texture ? (0, $2IIjX.canvasUtils).getCanvasSource(texture) : null;
            if (!source) continue;
            const textureStyle = texture.source.style;
            const smoothProperty = contextSystem.smoothProperty;
            const shouldSmooth = textureStyle.scaleMode !== "nearest";
            if (context[smoothProperty] !== shouldSmooth) context[smoothProperty] = shouldSmooth;
            contextSystem.setBlendMode(batch.blendMode);
            const globalColor = renderer.globalUniforms.globalUniformData?.worldColor ?? 4294967295;
            const argb = quad.color;
            const globalAlpha = (globalColor >>> 24 & 255) / 255;
            const quadAlpha = (argb >>> 24 & 255) / 255;
            const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
            const alpha = globalAlpha * quadAlpha * filterAlpha;
            if (alpha <= 0) continue;
            context.globalAlpha = alpha;
            const globalTint = globalColor & 16777215;
            const quadTint = argb & 16777215;
            const tint = (0, $3qOui.bgr2rgb)((0, $5nS5O.multiplyHexColors)(quadTint, globalTint));
            const frame = texture.frame;
            const repeatU = textureStyle.addressModeU ?? textureStyle.addressMode;
            const repeatV = textureStyle.addressModeV ?? textureStyle.addressMode;
            const repeat = _CanvasBatchAdaptor._getPatternRepeat(repeatU, repeatV);
            const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
            const isFromCachedRenderGroup = quad.renderable?.renderGroup?.isCachedAsTexture;
            const sx = frame.x * resolution;
            const sy = frame.y * resolution;
            const sw = frame.width * resolution;
            const sh = frame.height * resolution;
            const bounds = quad.bounds;
            const isRootTarget = renderer.renderTarget.renderTarget.isRoot;
            const dx = bounds.minX;
            const dy = bounds.minY;
            const dw = bounds.maxX - bounds.minX;
            const dh = bounds.maxY - bounds.minY;
            const rotate = texture.rotate;
            const uvs = texture.uvs;
            const uvMin = Math.min(uvs.x0, uvs.x1, uvs.x2, uvs.x3, uvs.y0, uvs.y1, uvs.y2, uvs.y3);
            const uvMax = Math.max(uvs.x0, uvs.x1, uvs.x2, uvs.x3, uvs.y0, uvs.y1, uvs.y2, uvs.y3);
            const needsRepeat = repeat !== "no-repeat" && (uvMin < 0 || uvMax > 1);
            const willUseProcessedCanvas = !needsRepeat && (tint !== 16777215 || rotate);
            const applyRotateTransform = rotate && !willUseProcessedCanvas;
            if (applyRotateTransform) {
                _CanvasBatchAdaptor._tempPatternMatrix.copyFrom(quad.transform);
                (0, $lHrjL.groupD8).matrixAppendRotationInv(_CanvasBatchAdaptor._tempPatternMatrix, rotate, dx, dy, dw, dh);
                contextSystem.setContextTransform(_CanvasBatchAdaptor._tempPatternMatrix, quad.roundPixels === 1, void 0, isFromCachedRenderGroup && isRootTarget);
            } else contextSystem.setContextTransform(quad.transform, quad.roundPixels === 1, void 0, isFromCachedRenderGroup && isRootTarget);
            const drawX = applyRotateTransform ? 0 : dx;
            const drawY = applyRotateTransform ? 0 : dy;
            const drawW = dw;
            const drawH = dh;
            if (needsRepeat) {
                let patternSource = source;
                const canTint = tint !== 16777215 && !rotate;
                const fitsFrame = frame.width <= texture.source.width && frame.height <= texture.source.height;
                if (canTint && fitsFrame) patternSource = (0, $2IIjX.canvasUtils).getTintedCanvas({
                    texture: texture
                }, tint);
                const pattern = context.createPattern(patternSource, repeat);
                if (!pattern) continue;
                const denomX = drawW;
                const denomY = drawH;
                if (denomX === 0 || denomY === 0) continue;
                const invDx = 1 / denomX;
                const invDy = 1 / denomY;
                const a = (uvs.x1 - uvs.x0) * invDx;
                const b = (uvs.y1 - uvs.y0) * invDx;
                const c = (uvs.x3 - uvs.x0) * invDy;
                const d = (uvs.y3 - uvs.y0) * invDy;
                const tx = uvs.x0 - a * drawX - c * drawY;
                const ty = uvs.y0 - b * drawX - d * drawY;
                const pixelWidth = texture.source.pixelWidth;
                const pixelHeight = texture.source.pixelHeight;
                _CanvasBatchAdaptor._tempPatternMatrix.set(a * pixelWidth, b * pixelHeight, c * pixelWidth, d * pixelHeight, tx * pixelWidth, ty * pixelHeight);
                (0, $2IIjX.canvasUtils).applyPatternTransform(pattern, _CanvasBatchAdaptor._tempPatternMatrix);
                context.fillStyle = pattern;
                context.fillRect(drawX, drawY, drawW, drawH);
            } else {
                const needsProcessing = tint !== 16777215 || rotate;
                const processedSource = needsProcessing ? (0, $2IIjX.canvasUtils).getTintedCanvas({
                    texture: texture
                }, tint) : source;
                const isProcessed = processedSource !== source;
                context.drawImage(processedSource, isProcessed ? 0 : sx, isProcessed ? 0 : sy, isProcessed ? processedSource.width : sw, isProcessed ? processedSource.height : sh, drawX, drawY, drawW, drawH);
            }
        }
    }
};
$6e916101417294d0$var$_CanvasBatchAdaptor._tempPatternMatrix = new (0, $5xi4h.Matrix)();
/** @ignore */ $6e916101417294d0$var$_CanvasBatchAdaptor.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipesAdaptor
    ],
    name: "batch"
};
let $6e916101417294d0$export$ec2ef38346665594 = $6e916101417294d0$var$_CanvasBatchAdaptor;

});

parcelRegister("jDoUt", function(module, exports) {

$parcel$export(module.exports, "BatcherPipe", () => $195100d456f45b25$export$3cdd191b816b3f8a);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $gjENK = parcelRequire("gjENK");
"use strict";
const $195100d456f45b25$var$_BatcherPipe = class _BatcherPipe {
    constructor(renderer, adaptor){
        this.state = (0, $fx0Zy.State).for2d();
        this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null);
        /** A record of all active batchers, keyed by their names */ this._activeBatches = /* @__PURE__ */ Object.create(null);
        this.renderer = renderer;
        this._adaptor = adaptor;
        this._adaptor.init?.(this);
    }
    static getBatcher(name) {
        return new this._availableBatchers[name]();
    }
    buildStart(instructionSet) {
        let batchers = this._batchersByInstructionSet[instructionSet.uid];
        if (!batchers) {
            batchers = this._batchersByInstructionSet[instructionSet.uid] = /* @__PURE__ */ Object.create(null);
            batchers.default || (batchers.default = new (0, $gjENK.DefaultBatcher)({
                maxTextures: this.renderer.limits.maxBatchableTextures
            }));
        }
        this._activeBatches = batchers;
        this._activeBatch = this._activeBatches.default;
        for(const i in this._activeBatches)this._activeBatches[i].begin();
    }
    addToBatch(batchableObject, instructionSet) {
        if (this._activeBatch.name !== batchableObject.batcherName) {
            this._activeBatch.break(instructionSet);
            let batch = this._activeBatches[batchableObject.batcherName];
            if (!batch) {
                batch = this._activeBatches[batchableObject.batcherName] = _BatcherPipe.getBatcher(batchableObject.batcherName);
                batch.begin();
            }
            this._activeBatch = batch;
        }
        this._activeBatch.add(batchableObject);
    }
    break(instructionSet) {
        this._activeBatch.break(instructionSet);
    }
    buildEnd(instructionSet) {
        this._activeBatch.break(instructionSet);
        const batches = this._activeBatches;
        for(const i in batches){
            const batch = batches[i];
            const geometry = batch.geometry;
            geometry.indexBuffer.setDataWithSize(batch.indexBuffer, batch.indexSize, true);
            geometry.buffers[0].setDataWithSize(batch.attributeBuffer.float32View, batch.attributeSize, false);
        }
    }
    upload(instructionSet) {
        const batchers = this._batchersByInstructionSet[instructionSet.uid];
        for(const i in batchers){
            const batcher = batchers[i];
            const geometry = batcher.geometry;
            if (batcher.dirty) {
                batcher.dirty = false;
                geometry.buffers[0].update(batcher.attributeSize * 4);
            }
        }
    }
    execute(batch) {
        if (batch.action === "startBatch") {
            const batcher = batch.batcher;
            const geometry = batcher.geometry;
            const shader = batcher.shader;
            this._adaptor.start(this, geometry, shader);
        }
        this._adaptor.execute(this, batch);
    }
    destroy() {
        this.state = null;
        this.renderer = null;
        this._adaptor = null;
        for(const i in this._activeBatches)this._activeBatches[i].destroy();
        this._activeBatches = null;
    }
};
/** @ignore */ $195100d456f45b25$var$_BatcherPipe.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "batch"
};
$195100d456f45b25$var$_BatcherPipe._availableBatchers = /* @__PURE__ */ Object.create(null);
let $195100d456f45b25$export$3cdd191b816b3f8a = $195100d456f45b25$var$_BatcherPipe;
(0, $aZ9ZN.extensions).handleByMap((0, $aZ9ZN.ExtensionType).Batcher, $195100d456f45b25$export$3cdd191b816b3f8a._availableBatchers);
(0, $aZ9ZN.extensions).add((0, $gjENK.DefaultBatcher));

});
parcelRegister("gjENK", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $f95735344284688f$export$34bf80542893bcb);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $J0JR5 = parcelRequire("J0JR5");

var $2RTgk = parcelRequire("2RTgk");

var $4Af3A = parcelRequire("4Af3A");
"use strict";
let $f95735344284688f$var$defaultShader = null;
const $f95735344284688f$var$_DefaultBatcher = class _DefaultBatcher extends (0, $J0JR5.Batcher) {
    constructor(options){
        super(options);
        this.geometry = new (0, $2RTgk.BatchGeometry)();
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
        $f95735344284688f$var$defaultShader ?? ($f95735344284688f$var$defaultShader = new (0, $4Af3A.DefaultShader)(options.maxTextures));
        this.shader = $f95735344284688f$var$defaultShader;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
    /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */ _updateMaxTextures(maxTextures) {
        if (this.shader.maxTextures === maxTextures) return;
        $f95735344284688f$var$defaultShader = new (0, $4Af3A.DefaultShader)(maxTextures);
        this.shader = $f95735344284688f$var$defaultShader;
    }
    destroy() {
        this.shader = null;
        super.destroy();
    }
};
/** @ignore */ $f95735344284688f$var$_DefaultBatcher.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).Batcher
    ],
    name: "default"
};
let $f95735344284688f$export$34bf80542893bcb = $f95735344284688f$var$_DefaultBatcher;

});
parcelRegister("J0JR5", function(module, exports) {

$parcel$export(module.exports, "Batch", () => $9e10b8262a5ccdfd$export$33b107562567fc47);
$parcel$export(module.exports, "Batcher", () => $9e10b8262a5ccdfd$export$704b12ddc1dacdd2);

var $1bMtF = parcelRequire("1bMtF");

var $4SZYy = parcelRequire("4SZYy");

var $6LhOA = parcelRequire("6LhOA");

var $fpmqC = parcelRequire("fpmqC");

var $3hvSu = parcelRequire("3hvSu");

var $fy1Tx = parcelRequire("fy1Tx");

var $kqE0J = parcelRequire("kqE0J");

var $bc7uw = parcelRequire("bc7uw");
"use strict";
class $9e10b8262a5ccdfd$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $bc7uw.BatchTextureArray)();
        this.blendMode = "normal";
        this.topology = "triangle-strip";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
        this.elements = null;
    }
}
const $9e10b8262a5ccdfd$var$batchPool = [];
let $9e10b8262a5ccdfd$var$batchPoolIndex = 0;
(0, $fpmqC.GlobalResourceRegistry).register({
    clear: ()=>{
        if ($9e10b8262a5ccdfd$var$batchPool.length > 0) {
            for (const item of $9e10b8262a5ccdfd$var$batchPool)if (item) item.destroy();
        }
        $9e10b8262a5ccdfd$var$batchPool.length = 0;
        $9e10b8262a5ccdfd$var$batchPoolIndex = 0;
    }
});
function $9e10b8262a5ccdfd$var$getBatchFromPool() {
    return $9e10b8262a5ccdfd$var$batchPoolIndex > 0 ? $9e10b8262a5ccdfd$var$batchPool[--$9e10b8262a5ccdfd$var$batchPoolIndex] : new $9e10b8262a5ccdfd$export$33b107562567fc47();
}
function $9e10b8262a5ccdfd$var$returnBatchToPool(batch) {
    batch.elements = null;
    $9e10b8262a5ccdfd$var$batchPool[$9e10b8262a5ccdfd$var$batchPoolIndex++] = batch;
}
let $9e10b8262a5ccdfd$var$BATCH_TICK = 0;
const $9e10b8262a5ccdfd$var$_Batcher = class _Batcher {
    constructor(options){
        /** unique id for this batcher */ this.uid = (0, $1bMtF.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        if (!options.maxTextures) {
            (0, $6LhOA.deprecation)("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options");
            options.maxTextures = (0, $kqE0J.getMaxTexturesPerBatch)();
        }
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $4SZYy.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$9e10b8262a5ccdfd$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $9e10b8262a5ccdfd$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $fy1Tx.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        let topology = firstElement.topology;
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        let batchElements = [];
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $fy1Tx.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
            if (source._batchTick === $9e10b8262a5ccdfd$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                batchElements.push(element);
                continue;
            }
            source._batchTick = $9e10b8262a5ccdfd$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                topology = element.topology;
                batch = $9e10b8262a5ccdfd$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                batchElements = [];
                ++$9e10b8262a5ccdfd$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            batchElements.push(element);
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
            start = size;
            ++$9e10b8262a5ccdfd$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action, elements) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.topology = topology;
        batch.start = indexStart;
        batch.size = indexSize;
        batch.elements = elements;
        ++$9e10b8262a5ccdfd$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $4SZYy.ViewableBuffer)(newSize);
        (0, $3hvSu.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $3hvSu.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */ destroy(options = {}) {
        if (this.batches === null) return;
        for(let i = 0; i < this.batchIndex; i++)$9e10b8262a5ccdfd$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        this.geometry.destroy(true);
        this.geometry = null;
        if (options.shader) {
            this.shader?.destroy();
            this.shader = null;
        }
        for(let i = 0; i < this._elements.length; i++)if (this._elements[i]) this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$9e10b8262a5ccdfd$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $9e10b8262a5ccdfd$export$704b12ddc1dacdd2 = $9e10b8262a5ccdfd$var$_Batcher;

});
parcelRegister("4SZYy", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $7bcf55f648740681$export$4fdbf0662aa3047a);
"use strict";
class $7bcf55f648740681$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this.uint32View = null;
        this.float32View = null;
        this.uint16View = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._int32View = null;
        this._float64Array = null;
        this._bigUint64Array = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("3hvSu", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $6f525e2f9c7e8023$export$c691b0c42debe682);
"use strict";
function $6f525e2f9c7e8023$export$c691b0c42debe682(sourceBuffer, destinationBuffer, sourceOffset, byteLength) {
    sourceOffset ?? (sourceOffset = 0);
    byteLength ?? (byteLength = Math.min(sourceBuffer.byteLength - sourceOffset, destinationBuffer.byteLength));
    if (!(sourceOffset & 7) && !(byteLength & 7)) {
        const len = byteLength / 8;
        new Float64Array(destinationBuffer, 0, len).set(new Float64Array(sourceBuffer, sourceOffset, len));
    } else if (!(sourceOffset & 3) && !(byteLength & 3)) {
        const len = byteLength / 4;
        new Float32Array(destinationBuffer, 0, len).set(new Float32Array(sourceBuffer, sourceOffset, len));
    } else new Uint8Array(destinationBuffer).set(new Uint8Array(sourceBuffer, sourceOffset, byteLength));
}

});

parcelRegister("fy1Tx", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $5b20def0ec6a7c37$export$ab2fc5cf3fe899fe);

var $fYoss = parcelRequire("fYoss");
"use strict";
function $5b20def0ec6a7c37$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $fYoss.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("fYoss", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $de57db26180ab44f$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $de57db26180ab44f$export$c250b85d73a91bdf);
"use strict";
const $de57db26180ab44f$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $de57db26180ab44f$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
    return STENCIL_MODES2;
})($de57db26180ab44f$export$c250b85d73a91bdf || {});

});


parcelRegister("kqE0J", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $a59b9a9c03e17ccf$export$313b92466c30ee73);

var $2sz3b = parcelRequire("2sz3b");

var $igOXQ = parcelRequire("igOXQ");
"use strict";
let $a59b9a9c03e17ccf$var$maxTexturesPerBatchCache = null;
function $a59b9a9c03e17ccf$export$313b92466c30ee73() {
    if ($a59b9a9c03e17ccf$var$maxTexturesPerBatchCache) return $a59b9a9c03e17ccf$var$maxTexturesPerBatchCache;
    const gl = (0, $2sz3b.getTestContext)();
    $a59b9a9c03e17ccf$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $a59b9a9c03e17ccf$var$maxTexturesPerBatchCache = (0, $igOXQ.checkMaxIfStatementsInShader)($a59b9a9c03e17ccf$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $a59b9a9c03e17ccf$var$maxTexturesPerBatchCache;
}

});
parcelRegister("igOXQ", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $8525848d219bcef9$export$fb6ad4e758d74cc0);
"use strict";
const $8525848d219bcef9$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $8525848d219bcef9$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $8525848d219bcef9$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $8525848d219bcef9$var$fragTemplate.replace(/%forloop%/gi, $8525848d219bcef9$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});


parcelRegister("bc7uw", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $7f5f0f9dade1d525$export$aa760e0febf1a758);
"use strict";
class $7f5f0f9dade1d525$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("2RTgk", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $56369b344a8e8c32$export$449e8d355fd68e43);

var $2bJdA = parcelRequire("2bJdA");

var $1T7Iy = parcelRequire("1T7Iy");

var $1T4Gr = parcelRequire("1T4Gr");
"use strict";
const $56369b344a8e8c32$var$placeHolderBufferData = new Float32Array(1);
const $56369b344a8e8c32$var$placeHolderIndexData = new Uint32Array(1);
class $56369b344a8e8c32$export$449e8d355fd68e43 extends (0, $1T4Gr.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $2bJdA.Buffer)({
            data: $56369b344a8e8c32$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $2bJdA.Buffer)({
            data: $56369b344a8e8c32$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1T7Iy.BufferUsage).INDEX | (0, $1T7Iy.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});

parcelRegister("4Af3A", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $0bf28469fbaf2345$export$5ee16216350ebcbc);

var $aYOxl = parcelRequire("aYOxl");

var $eGbby = parcelRequire("eGbby");

var $1I0Ex = parcelRequire("1I0Ex");

var $gnlmr = parcelRequire("gnlmr");

var $foUHO = parcelRequire("foUHO");

var $7LCXQ = parcelRequire("7LCXQ");
"use strict";
class $0bf28469fbaf2345$export$5ee16216350ebcbc extends (0, $7LCXQ.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $aYOxl.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $eGbby.colorBitGl),
                (0, $1I0Ex.generateTextureBatchBitGl)(maxTextures),
                (0, $gnlmr.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $aYOxl.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $eGbby.colorBit),
                (0, $1I0Ex.generateTextureBatchBit)(maxTextures),
                (0, $gnlmr.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $foUHO.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
        this.maxTextures = maxTextures;
    }
}

});
parcelRegister("aYOxl", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $ff6281b51788bcb5$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $ff6281b51788bcb5$export$477b8252c7ecdf2);

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $bhlBQ = parcelRequire("bhlBQ");

var $a8QIF = parcelRequire("a8QIF");

var $bxcOr = parcelRequire("bxcOr");
"use strict";
function $ff6281b51788bcb5$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $bhlBQ.compileHighShader)({
        template: {
            fragment: (0, $a8QIF.fragmentGPUTemplate),
            vertex: (0, $a8QIF.vertexGPUTemplate)
        },
        bits: [
            (0, $bxcOr.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $bEdxc.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $ff6281b51788bcb5$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $4kU4M.GlProgram)({
        name: name,
        ...(0, $bhlBQ.compileHighShaderGl)({
            template: {
                vertex: (0, $a8QIF.vertexGlTemplate),
                fragment: (0, $a8QIF.fragmentGlTemplate)
            },
            bits: [
                (0, $bxcOr.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("bhlBQ", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $4b369c55157823b5$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $4b369c55157823b5$export$ff7039b165d48f97);

var $iioxo = parcelRequire("iioxo");

var $CEJ1P = parcelRequire("CEJ1P");

var $6iet8 = parcelRequire("6iet8");

var $8cyng = parcelRequire("8cyng");

var $4gc0T = parcelRequire("4gc0T");
"use strict";
const $4b369c55157823b5$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $4b369c55157823b5$var$bitCacheMap = /* @__PURE__ */ new Map();
let $4b369c55157823b5$var$CACHE_UID = 0;
function $4b369c55157823b5$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $4b369c55157823b5$var$generateCacheId(template, bits);
    if ($4b369c55157823b5$var$cacheMap[cacheId]) return $4b369c55157823b5$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $4b369c55157823b5$var$compileInputsAndOutputs(template, bits);
    $4b369c55157823b5$var$cacheMap[cacheId] = $4b369c55157823b5$var$compileBits(vertex, fragment, bits);
    return $4b369c55157823b5$var$cacheMap[cacheId];
}
function $4b369c55157823b5$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $4b369c55157823b5$var$generateCacheId(template, bits);
    if ($4b369c55157823b5$var$cacheMap[cacheId]) return $4b369c55157823b5$var$cacheMap[cacheId];
    $4b369c55157823b5$var$cacheMap[cacheId] = $4b369c55157823b5$var$compileBits(template.vertex, template.fragment, bits);
    return $4b369c55157823b5$var$cacheMap[cacheId];
}
function $4b369c55157823b5$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $6iet8.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $8cyng.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $6iet8.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $4b369c55157823b5$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$4b369c55157823b5$var$bitCacheMap.has(highFragment)) $4b369c55157823b5$var$bitCacheMap.set(highFragment, $4b369c55157823b5$var$CACHE_UID++);
        return $4b369c55157823b5$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $4b369c55157823b5$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $CEJ1P.compileHooks)(vertex);
    const fragmentParts = (0, $CEJ1P.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $iioxo.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $iioxo.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $4gc0T.injectBits)(vertex, vertexParts),
        fragment: (0, $4gc0T.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("iioxo", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $118394972d91608d$export$38c21fb192fe3d9);

var $1RpxL = parcelRequire("1RpxL");
"use strict";
function $118394972d91608d$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $1RpxL.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("CEJ1P", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $da01aeb13d6c9d87$export$17705ba43ca63936);
"use strict";
const $da01aeb13d6c9d87$var$findHooksRx = /\{\{(.*?)\}\}/g;
function $da01aeb13d6c9d87$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($da01aeb13d6c9d87$var$findHooksRx)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("6iet8", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $e5013aa4070da194$export$aa47df9391ef0455);
"use strict";
function $e5013aa4070da194$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $e5013aa4070da194$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $e5013aa4070da194$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $e5013aa4070da194$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("8cyng", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $6d3f181aeed1e428$export$ae19cc473c7ab18);
"use strict";
function $6d3f181aeed1e428$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $6d3f181aeed1e428$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $6d3f181aeed1e428$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $6d3f181aeed1e428$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $6d3f181aeed1e428$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $6d3f181aeed1e428$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$6d3f181aeed1e428$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
            ${results.sort().map((inValue)=>` ${$6d3f181aeed1e428$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("4gc0T", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $d7bf12a32e263193$export$83c47c7340456c75);
"use strict";
function $d7bf12a32e263193$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("a8QIF", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $2ed64f2a47f1d462$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $2ed64f2a47f1d462$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $2ed64f2a47f1d462$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $2ed64f2a47f1d462$export$3f7784dd6a13ff5a);
"use strict";
const $2ed64f2a47f1d462$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $2ed64f2a47f1d462$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $2ed64f2a47f1d462$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $2ed64f2a47f1d462$export$3f7784dd6a13ff5a = /* glsl */ `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`;

});

parcelRegister("bxcOr", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $6f227014b38d54e0$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsUBOBitGl", () => $6f227014b38d54e0$export$320b7a2ae65b2f3a);
$parcel$export(module.exports, "globalUniformsBitGl", () => $6f227014b38d54e0$export$38608853d4735d51);
"use strict";
const $6f227014b38d54e0$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $6f227014b38d54e0$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $6f227014b38d54e0$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("eGbby", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $6b2c9145f1dd664c$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $6b2c9145f1dd664c$export$93189e9821cf4459);
"use strict";
const $6b2c9145f1dd664c$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $6b2c9145f1dd664c$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("1I0Ex", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $acf4df262a8f2998$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $acf4df262a8f2998$export$204e46d9a7a4f835);
"use strict";
const $acf4df262a8f2998$var$textureBatchBitGpuCache = {};
function $acf4df262a8f2998$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $acf4df262a8f2998$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $acf4df262a8f2998$export$aff2d36945cda647(maxTextures) {
    if (!$acf4df262a8f2998$var$textureBatchBitGpuCache[maxTextures]) $acf4df262a8f2998$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$acf4df262a8f2998$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$acf4df262a8f2998$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $acf4df262a8f2998$var$textureBatchBitGpuCache[maxTextures];
}
const $acf4df262a8f2998$var$textureBatchBitGlCache = {};
function $acf4df262a8f2998$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $acf4df262a8f2998$export$204e46d9a7a4f835(maxTextures) {
    if (!$acf4df262a8f2998$var$textureBatchBitGlCache[maxTextures]) $acf4df262a8f2998$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$acf4df262a8f2998$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $acf4df262a8f2998$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("gnlmr", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $3a103fbb320a359a$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $3a103fbb320a359a$export$222909710f39cc5);
"use strict";
const $3a103fbb320a359a$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $3a103fbb320a359a$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("foUHO", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $b204781711385af1$export$5fc8295c6cba6ffe);

var $aUxJK = parcelRequire("aUxJK");
"use strict";
const $b204781711385af1$var$batchSamplersUniformGroupHash = {};
function $b204781711385af1$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $b204781711385af1$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $b204781711385af1$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $aUxJK.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});




parcelRegister("gNCRL", function(module, exports) {

$parcel$export(module.exports, "AlphaMaskPipe", () => $c85f5730a76032c6$export$cf1e9fa5acb94ac4);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jMFz3 = parcelRequire("jMFz3");

var $dyeaT = parcelRequire("dyeaT");

var $esrbs = parcelRequire("esrbs");

var $dJAmK = parcelRequire("dJAmK");

var $7ScuH = parcelRequire("7ScuH");

var $dokhj = parcelRequire("dokhj");

var $4iNSL = parcelRequire("4iNSL");

var $5NyEC = parcelRequire("5NyEC");

var $bfcaK = parcelRequire("bfcaK");
"use strict";
const $c85f5730a76032c6$var$tempBounds = new (0, $esrbs.Bounds)();
class $c85f5730a76032c6$var$AlphaMaskEffect extends (0, $jMFz3.FilterEffect) {
    constructor(){
        super();
        this.filters = [
            new (0, $dyeaT.MaskFilter)({
                sprite: new (0, $7ScuH.Sprite)((0, $4iNSL.Texture).EMPTY),
                inverse: false,
                resolution: "inherit",
                antialias: "inherit"
            })
        ];
    }
    get sprite() {
        return this.filters[0].sprite;
    }
    set sprite(value) {
        this.filters[0].sprite = value;
    }
    get inverse() {
        return this.filters[0].inverse;
    }
    set inverse(value) {
        this.filters[0].inverse = value;
    }
}
class $c85f5730a76032c6$export$cf1e9fa5acb94ac4 {
    constructor(renderer){
        this._activeMaskStage = [];
        this._renderer = renderer;
    }
    push(mask, maskedContainer, instructionSet) {
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "alphaMask",
            action: "pushMaskBegin",
            mask: mask,
            inverse: maskedContainer._maskOptions.inverse,
            canBundle: false,
            maskedContainer: maskedContainer
        });
        mask.inverse = maskedContainer._maskOptions.inverse;
        if (mask.renderMaskToTexture) {
            const maskContainer = mask.mask;
            maskContainer.includeInBuild = true;
            maskContainer.collectRenderables(instructionSet, renderer, null);
            maskContainer.includeInBuild = false;
        }
        renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "alphaMask",
            action: "pushMaskEnd",
            mask: mask,
            maskedContainer: maskedContainer,
            inverse: maskedContainer._maskOptions.inverse,
            canBundle: false
        });
    }
    pop(mask, _maskedContainer, instructionSet) {
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "alphaMask",
            action: "popMaskEnd",
            mask: mask,
            inverse: _maskedContainer._maskOptions.inverse,
            canBundle: false
        });
    }
    execute(instruction) {
        const renderer = this._renderer;
        const renderMask = instruction.mask.renderMaskToTexture;
        if (instruction.action === "pushMaskBegin") {
            const filterEffect = (0, $dokhj.BigPool).get($c85f5730a76032c6$var$AlphaMaskEffect);
            filterEffect.inverse = instruction.inverse;
            if (renderMask) {
                instruction.mask.mask.measurable = true;
                const bounds = (0, $dJAmK.getGlobalBounds)(instruction.mask.mask, true, $c85f5730a76032c6$var$tempBounds);
                instruction.mask.mask.measurable = false;
                bounds.ceil();
                const colorTextureSource = renderer.renderTarget.renderTarget.colorTexture.source;
                const filterTexture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, colorTextureSource._resolution, colorTextureSource.antialias);
                renderer.renderTarget.push(filterTexture, true);
                renderer.globalUniforms.push({
                    offset: bounds,
                    worldColor: 4294967295
                });
                const sprite = filterEffect.sprite;
                sprite.texture = filterTexture;
                sprite.worldTransform.tx = bounds.minX;
                sprite.worldTransform.ty = bounds.minY;
                this._activeMaskStage.push({
                    filterEffect: filterEffect,
                    maskedContainer: instruction.maskedContainer,
                    filterTexture: filterTexture
                });
            } else {
                filterEffect.sprite = instruction.mask.mask;
                this._activeMaskStage.push({
                    filterEffect: filterEffect,
                    maskedContainer: instruction.maskedContainer
                });
            }
        } else if (instruction.action === "pushMaskEnd") {
            const maskData = this._activeMaskStage[this._activeMaskStage.length - 1];
            if (renderMask) {
                if (renderer.type === (0, $bfcaK.RendererType).WEBGL) renderer.renderTarget.finishRenderPass();
                renderer.renderTarget.pop();
                renderer.globalUniforms.pop();
            }
            renderer.filter.push({
                renderPipeId: "filter",
                action: "pushFilter",
                container: maskData.maskedContainer,
                filterEffect: maskData.filterEffect,
                canBundle: false
            });
        } else if (instruction.action === "popMaskEnd") {
            renderer.filter.pop();
            const maskData = this._activeMaskStage.pop();
            if (renderMask) (0, $5NyEC.TexturePool).returnTexture(maskData.filterTexture);
            (0, $dokhj.BigPool).return(maskData.filterEffect);
        }
    }
    destroy() {
        this._renderer = null;
        this._activeMaskStage = null;
    }
}
/** @ignore */ $c85f5730a76032c6$export$cf1e9fa5acb94ac4.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "alphaMask"
};

});
parcelRegister("dyeaT", function(module, exports) {

$parcel$export(module.exports, "MaskFilter", () => $b1e1b745176eb317$export$6d9155deae913447);

var $5xi4h = parcelRequire("5xi4h");

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $eVE7u = parcelRequire("eVE7u");

var $lWXRl = parcelRequire("lWXRl");

var $7DmEj = parcelRequire("7DmEj");

var $7EiHV = parcelRequire("7EiHV");

var $3Go5s = parcelRequire("3Go5s");
"use strict";
class $b1e1b745176eb317$export$6d9155deae913447 extends (0, $lWXRl.Filter) {
    constructor(options){
        const { sprite: sprite, ...rest } = options;
        const textureMatrix = new (0, $eVE7u.TextureMatrix)(sprite.texture);
        const filterUniforms = new (0, $aUxJK.UniformGroup)({
            uFilterMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uMaskClamp: {
                value: textureMatrix.uClampFrame,
                type: "vec4<f32>"
            },
            uAlpha: {
                value: 1,
                type: "f32"
            },
            uInverse: {
                value: options.inverse ? 1 : 0,
                type: "f32"
            }
        });
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $3Go5s.default,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $3Go5s.default,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $7EiHV.default,
            fragment: $7DmEj.default,
            name: "mask-filter"
        });
        super({
            ...rest,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            clipToViewport: false,
            resources: {
                filterUniforms: filterUniforms,
                uMaskTexture: sprite.texture.source
            }
        });
        this.sprite = sprite;
        this._textureMatrix = textureMatrix;
    }
    set inverse(value) {
        this.resources.filterUniforms.uniforms.uInverse = value ? 1 : 0;
    }
    get inverse() {
        return this.resources.filterUniforms.uniforms.uInverse === 1;
    }
    apply(filterManager, input, output, clearMode) {
        this._textureMatrix.texture = this.sprite.texture;
        filterManager.calculateSpriteMatrix(this.resources.filterUniforms.uniforms.uFilterMatrix, this.sprite).prepend(this._textureMatrix.mapCoord);
        this.resources.uMaskTexture = this.sprite.texture.source;
        filterManager.applyFilter(this, input, output, clearMode);
    }
}

});
parcelRegister("7DmEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4dd5422c8bbbf3$export$2e2bcd8739ae039);
var $7d4dd5422c8bbbf3$export$2e2bcd8739ae039 = "in vec2 vMaskCoord;\nin vec2 vTextureCoord;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMaskTexture;\n\nuniform float uAlpha;\nuniform vec4 uMaskClamp;\nuniform float uInverse;\n\nout vec4 finalColor;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(uMaskClamp.x, vMaskCoord.x) +\n        step(uMaskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, uMaskClamp.z) +\n        step(vMaskCoord.y, uMaskClamp.w));\n\n    // TODO look into why this is needed\n    float npmAlpha = uAlpha;\n    vec4 original = texture(uTexture, vTextureCoord);\n    vec4 masky = texture(uMaskTexture, vMaskCoord);\n    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);\n\n    float a = alphaMul * masky.r * npmAlpha * clip;\n\n    if (uInverse == 1.0) {\n        a = 1.0 - a;\n    }\n\n    finalColor = original * a;\n}\n";

});

parcelRegister("7EiHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a86e25beeffe29c$export$2e2bcd8739ae039);
var $9a86e25beeffe29c$export$2e2bcd8739ae039 = "in vec2 aPosition;\n\nout vec2 vTextureCoord;\nout vec2 vMaskCoord;\n\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\nuniform mat3 uFilterMatrix;\n\nvec4 filterVertexPosition(  vec2 aPosition )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n       \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord(  vec2 aPosition )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvec2 getFilterCoord( vec2 aPosition )\n{\n    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;\n}   \n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition(aPosition);\n    vTextureCoord = filterTextureCoord(aPosition);\n    vMaskCoord = getFilterCoord(aPosition);\n}\n";

});

parcelRegister("3Go5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ca64141128b227$export$2e2bcd8739ae039);
var $11ca64141128b227$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct MaskUniforms {\n  uFilterMatrix:mat3x3<f32>,\n  uMaskClamp:vec4<f32>,\n  uAlpha:f32,\n  uInverse:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;\n@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n    @location(1) filterUv : vec2<f32>,\n};\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);\n}\n\nfn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;\n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>,\n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition),\n   getFilterCoord(aPosition)\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @location(1) filterUv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n\n    var maskClamp = filterUniforms.uMaskClamp;\n    var uAlpha = filterUniforms.uAlpha;\n\n    var clip = step(3.5,\n      step(maskClamp.x, filterUv.x) +\n      step(maskClamp.y, filterUv.y) +\n      step(filterUv.x, maskClamp.z) +\n      step(filterUv.y, maskClamp.w));\n\n    var mask = textureSample(uMaskTexture, uSampler, filterUv);\n    var source = textureSample(uTexture, uSampler, uv);\n    var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);\n\n    var a: f32 = alphaMul * mask.r * uAlpha * clip;\n\n    if (filterUniforms.uInverse == 1.0) {\n        a = 1.0 - a;\n    }\n\n    return source * a;\n}\n";

});



parcelRegister("kF9p5", function(module, exports) {

$parcel$export(module.exports, "CanvasColorMaskPipe", () => $c82fe8901558c8d2$export$49243f8b9fcdc83d);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $c82fe8901558c8d2$export$49243f8b9fcdc83d {
    constructor(renderer){
        this._colorStack = [];
        this._colorStackIndex = 0;
        this._currentColor = 0;
        this._renderer = renderer;
    }
    buildStart() {
        this._colorStack[0] = 15;
        this._colorStackIndex = 1;
        this._currentColor = 15;
    }
    push(mask, _container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        const colorStack = this._colorStack;
        colorStack[this._colorStackIndex] = colorStack[this._colorStackIndex - 1] & mask.mask;
        const currentColor = this._colorStack[this._colorStackIndex];
        if (currentColor !== this._currentColor) {
            this._currentColor = currentColor;
            instructionSet.add({
                renderPipeId: "colorMask",
                colorMask: currentColor,
                canBundle: false
            });
        }
        this._colorStackIndex++;
    }
    pop(_mask, _container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        const colorStack = this._colorStack;
        this._colorStackIndex--;
        const currentColor = colorStack[this._colorStackIndex - 1];
        if (currentColor !== this._currentColor) {
            this._currentColor = currentColor;
            instructionSet.add({
                renderPipeId: "colorMask",
                colorMask: currentColor,
                canBundle: false
            });
        }
    }
    execute(_instruction) {}
    destroy() {
        this._renderer = null;
        this._colorStack = null;
    }
}
/** @ignore */ $c82fe8901558c8d2$export$49243f8b9fcdc83d.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "colorMask"
};

});

parcelRegister("8uCJE", function(module, exports) {

$parcel$export(module.exports, "CanvasStencilMaskPipe", () => $226f4c2d08b0f257$export$fb204d8484c65a0d);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $iNnKd = parcelRequire("iNnKd");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
function $226f4c2d08b0f257$var$buildRoundedRectPath(context, x, y, width, height, radius) {
    radius = Math.max(0, Math.min(radius, Math.min(width, height) / 2));
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
}
function $226f4c2d08b0f257$var$buildShapePath(context, shape) {
    switch(shape.type){
        case "rectangle":
            {
                const rect = shape;
                context.rect(rect.x, rect.y, rect.width, rect.height);
                break;
            }
        case "roundedRectangle":
            {
                const rect = shape;
                $226f4c2d08b0f257$var$buildRoundedRectPath(context, rect.x, rect.y, rect.width, rect.height, rect.radius);
                break;
            }
        case "circle":
            {
                const circle = shape;
                context.moveTo(circle.x + circle.radius, circle.y);
                context.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2);
                break;
            }
        case "ellipse":
            {
                const ellipse = shape;
                if (context.ellipse) {
                    context.moveTo(ellipse.x + ellipse.halfWidth, ellipse.y);
                    context.ellipse(ellipse.x, ellipse.y, ellipse.halfWidth, ellipse.halfHeight, 0, 0, Math.PI * 2);
                } else {
                    context.save();
                    context.translate(ellipse.x, ellipse.y);
                    context.scale(ellipse.halfWidth, ellipse.halfHeight);
                    context.moveTo(1, 0);
                    context.arc(0, 0, 1, 0, Math.PI * 2);
                    context.restore();
                }
                break;
            }
        case "triangle":
            {
                const tri = shape;
                context.moveTo(tri.x, tri.y);
                context.lineTo(tri.x2, tri.y2);
                context.lineTo(tri.x3, tri.y3);
                context.closePath();
                break;
            }
        case "polygon":
        default:
            {
                const poly = shape;
                const points = poly.points;
                if (!points?.length) break;
                context.moveTo(points[0], points[1]);
                for(let i = 2; i < points.length; i += 2)context.lineTo(points[i], points[i + 1]);
                if (poly.closePath) context.closePath();
                break;
            }
    }
}
function $226f4c2d08b0f257$var$addHolePaths(context, holes) {
    if (!holes?.length) return false;
    for(let i = 0; i < holes.length; i++){
        const hole = holes[i];
        if (!hole?.shape) continue;
        const transform = hole.transform;
        const hasTransform = transform && !transform.isIdentity();
        if (hasTransform) {
            context.save();
            context.transform(transform.a, transform.b, transform.c, transform.d, transform.tx, transform.ty);
        }
        $226f4c2d08b0f257$var$buildShapePath(context, hole.shape);
        if (hasTransform) context.restore();
    }
    return true;
}
class $226f4c2d08b0f257$export$fb204d8484c65a0d {
    constructor(renderer){
        this._warnedMaskTypes = /* @__PURE__ */ new Set();
        this._canvasMaskStack = [];
        this._renderer = renderer;
    }
    push(mask, _container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "pushMaskBegin",
            mask: mask,
            inverse: _container._maskOptions.inverse,
            canBundle: false
        });
    }
    pop(_mask, _container, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "popMaskEnd",
            mask: _mask,
            inverse: _container._maskOptions.inverse,
            canBundle: false
        });
    }
    execute(instruction) {
        if (instruction.action !== "pushMaskBegin" && instruction.action !== "popMaskEnd") return;
        const canvasRenderer = this._renderer;
        const contextSystem = canvasRenderer.canvasContext;
        const context = contextSystem?.activeContext;
        if (!context) return;
        if (instruction.action === "popMaskEnd") {
            const didClip = this._canvasMaskStack.pop();
            if (didClip) context.restore();
            return;
        }
        if (instruction.inverse) this._warnOnce("inverse", "CanvasRenderer: inverse masks are not supported on Canvas2D; ignoring inverse flag.");
        const maskContainer = instruction.mask.mask;
        if (!(maskContainer instanceof (0, $iNnKd.Graphics))) {
            this._warnOnce("nonGraphics", "CanvasRenderer: only Graphics masks are supported in Canvas2D; skipping mask.");
            this._canvasMaskStack.push(false);
            return;
        }
        const graphics = maskContainer;
        const instructions = graphics.context?.instructions;
        if (!instructions?.length) {
            this._canvasMaskStack.push(false);
            return;
        }
        context.save();
        contextSystem.setContextTransform(graphics.groupTransform, (canvasRenderer._roundPixels | graphics._roundPixels) === 1);
        context.beginPath();
        let drewPath = false;
        let hasHoles = false;
        for(let i = 0; i < instructions.length; i++){
            const instructionData = instructions[i];
            const action = instructionData.action;
            if (action !== "fill" && action !== "stroke") continue;
            const data = instructionData.data;
            const shapePath = data?.path?.shapePath;
            if (!shapePath?.shapePrimitives?.length) continue;
            const shapePrimitives = shapePath.shapePrimitives;
            for(let j = 0; j < shapePrimitives.length; j++){
                const primitive = shapePrimitives[j];
                if (!primitive?.shape) continue;
                const transform = primitive.transform;
                const hasTransform = transform && !transform.isIdentity();
                if (hasTransform) {
                    context.save();
                    context.transform(transform.a, transform.b, transform.c, transform.d, transform.tx, transform.ty);
                }
                $226f4c2d08b0f257$var$buildShapePath(context, primitive.shape);
                hasHoles = $226f4c2d08b0f257$var$addHolePaths(context, primitive.holes) || hasHoles;
                drewPath = true;
                if (hasTransform) context.restore();
            }
        }
        if (!drewPath) {
            context.restore();
            this._canvasMaskStack.push(false);
            return;
        }
        if (hasHoles) context.clip("evenodd");
        else context.clip();
        this._canvasMaskStack.push(true);
    }
    destroy() {
        this._renderer = null;
        this._warnedMaskTypes = null;
        this._canvasMaskStack = null;
    }
    _warnOnce(key, message) {
        if (this._warnedMaskTypes.has(key)) return;
        this._warnedMaskTypes.add(key);
        (0, $1RpxL.warn)(message);
    }
}
$226f4c2d08b0f257$export$fb204d8484c65a0d.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "stencilMask"
};

});
parcelRegister("iNnKd", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $5c8e1eaf08715b95$export$29d3e417456abdad);

var $6LhOA = parcelRequire("6LhOA");

var $9FmI1 = parcelRequire("9FmI1");

var $7kRkZ = parcelRequire("7kRkZ");
parcelRequire("hJR2o");
"use strict";
class $5c8e1eaf08715b95$export$29d3e417456abdad extends (0, $9FmI1.ViewContainer) {
    /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $7kRkZ.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        /** @internal */ this.renderPipeId = "graphics";
        if (!context) {
            this.context = this._ownedContext = new (0, $7kRkZ.GraphicsContext)();
            this.context.autoGarbageCollect = this.autoGarbageCollect;
        } else this.context = context;
        this.didViewUpdate = true;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        if (this._context) {
            this._context.off("update", this.onViewUpdate, this);
            this._context.off("unload", this.unload, this);
        }
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this._context.on("unload", this.unload, this);
        this.onViewUpdate();
    }
    /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */ get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */ updateBounds() {}
    /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    /**
   * @param now - The current time in milliseconds.
   * @internal
   */ _onTouch(now) {
        this._gcLastUsed = now;
        this._context._gcLastUsed = now;
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */ clone(deep = false) {
        if (deep) return new $5c8e1eaf08715b95$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $5c8e1eaf08715b95$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        if (color !== void 0) fillStyle.color = color;
        if (alpha !== void 0) fillStyle.alpha = alpha;
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $7kRkZ.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $7kRkZ.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $7kRkZ.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});
parcelRegister("7kRkZ", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $65de51afc02a20ad$export$cde35afe8b5f985);

var $6AQ4q = parcelRequire("6AQ4q");

var $dKHyW = parcelRequire("dKHyW");

var $5xi4h = parcelRequire("5xi4h");

var $ds7Xo = parcelRequire("ds7Xo");

var $4iNSL = parcelRequire("4iNSL");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $esrbs = parcelRequire("esrbs");

var $1roql = parcelRequire("1roql");

var $dfSnn = parcelRequire("dfSnn");

var $bapDA = parcelRequire("bapDA");
"use strict";
const $65de51afc02a20ad$var$tmpPoint = new (0, $ds7Xo.Point)();
const $65de51afc02a20ad$var$tempMatrix = new (0, $5xi4h.Matrix)();
const $65de51afc02a20ad$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(){
        super(...arguments);
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /**
     * unique id for this graphics context
     * @internal
     */ this.uid = (0, $1bMtF.uid)("graphicsContext");
        /**
     * Indicates whether content is updated and have to be re-rendered.
     * @internal
     */ this.dirty = true;
        /** The batch mode for this graphics context. It can be 'auto', 'batch', or 'no-batch'. */ this.batchMode = "auto";
        /** @internal */ this.instructions = [];
        /** Whether the graphics context has been destroyed. */ this.destroyed = false;
        this._activePath = new (0, $1roql.GraphicsPath)();
        this._transform = new (0, $5xi4h.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $esrbs.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $bapDA.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $bapDA.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $bapDA.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $bapDA.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint || tint === 0 ? (0, $dKHyW.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $1roql.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $bapDA.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $ds7Xo.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $bapDA.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $dfSnn.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $5xi4h.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $5xi4h.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $65de51afc02a20ad$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($65de51afc02a20ad$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        this._boundsDirty = true;
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const alignment = data.style.alignment;
                const outerPadding = data.style.width * (1 - alignment);
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - outerPadding, _bounds.minY - outerPadding, _bounds.maxX + outerPadding, _bounds.maxY + outerPadding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $65de51afc02a20ad$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else {
                    const strokeStyle = style;
                    hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
                }
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /** Unloads the GPU data from the graphics context. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        this._stateStack.length = 0;
        this._transform = null;
        this.unload();
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $65de51afc02a20ad$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $4iNSL.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local"
};
/** The default stroke style to use when none is provided. */ $65de51afc02a20ad$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $4iNSL.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local",
    /** If the stroke is a pixel line. */ pixelLine: false
};
let $65de51afc02a20ad$export$cde35afe8b5f985 = $65de51afc02a20ad$var$_GraphicsContext;

});
parcelRegister("1roql", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $824cadf124c2b0ba$export$7e54506375634c19);

var $ds7Xo = parcelRequire("ds7Xo");

var $1bMtF = parcelRequire("1bMtF");

var $1RpxL = parcelRequire("1RpxL");

var $2eMBY = parcelRequire("2eMBY");

var $4uUVY = parcelRequire("4uUVY");
"use strict";
class $824cadf124c2b0ba$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */ constructor(instructions, signed = false){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $1bMtF.uid)("graphicsPath");
        this._dirty = true;
        this.checkForHoles = signed;
        if (typeof instructions === "string") (0, $2eMBY.parseSVGPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $4uUVY.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $ds7Xo.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $ds7Xo.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius || (innerRadius = radius / 2);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $824cadf124c2b0ba$export$7e54506375634c19();
        newGraphicsPath2D.checkForHoles = this.checkForHoles;
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $824cadf124c2b0ba$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $824cadf124c2b0ba$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $824cadf124c2b0ba$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $824cadf124c2b0ba$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $824cadf124c2b0ba$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $1RpxL.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $824cadf124c2b0ba$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("2eMBY", function(module, exports) {

$parcel$export(module.exports, "parseSVGPath", () => $a3106dd981ba1cd2$export$33813e954ab16e32);

var $eJJJX = parcelRequire("eJJJX");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
function $a3106dd981ba1cd2$export$33813e954ab16e32(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($eJJJX)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], // First control point
                data[3], data[4], // Second control point
                lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], // First control point
                lastX + data[3], lastY + data[4], // Second control point
                lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "Z":
            // Close Path
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $1RpxL.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("eJJJX", function(module, exports) {
module.exports = $aba8bfb3df0db863$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $aba8bfb3df0db863$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $aba8bfb3df0db863$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $aba8bfb3df0db863$var$parse(path) {
    var data = [];
    path.replace($aba8bfb3df0db863$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $aba8bfb3df0db863$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $aba8bfb3df0db863$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $aba8bfb3df0db863$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $aba8bfb3df0db863$var$length[type])));
        }
    });
    return data;
}
var $aba8bfb3df0db863$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $aba8bfb3df0db863$var$parseValues(args) {
    var numbers = args.match($aba8bfb3df0db863$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("4uUVY", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $ece0501b6ecf6a37$export$148534a3c727230b);

var $1lNph = parcelRequire("1lNph");

var $8UvIh = parcelRequire("8UvIh");

var $7r8vL = parcelRequire("7r8vL");

var $ar2Ly = parcelRequire("ar2Ly");

var $fVN7W = parcelRequire("fVN7W");

var $esrbs = parcelRequire("esrbs");

var $kpMZU = parcelRequire("kpMZU");

var $bB0KA = parcelRequire("bB0KA");

var $dP0DE = parcelRequire("dP0DE");

var $ipEz7 = parcelRequire("ipEz7");

var $4VZYJ = parcelRequire("4VZYJ");

var $2NHgj = parcelRequire("2NHgj");
"use strict";
const $ece0501b6ecf6a37$var$tempRectangle = new (0, $ar2Ly.Rectangle)();
class $ece0501b6ecf6a37$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $esrbs.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
        this.signed = graphicsPath2D.checkForHoles;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $dP0DE.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $ipEz7.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $4VZYJ.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $kpMZU.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $bB0KA.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        const shapePrimitives = this.shapePrimitives;
        const start = shapePrimitives.length;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        if (path.checkForHoles && shapePrimitives.length - start > 1) {
            let mainShape = null;
            for(let i = start; i < shapePrimitives.length; i++){
                const shapePrimitive = shapePrimitives[i];
                if (shapePrimitive.shape.type === "polygon") {
                    const polygon = shapePrimitive.shape;
                    const mainPolygon = mainShape?.shape;
                    if (mainPolygon && mainPolygon.containsPolygon(polygon)) {
                        mainShape.holes || (mainShape.holes = []);
                        mainShape.holes.push(shapePrimitive);
                        shapePrimitives.copyWithin(i, i + 1);
                        shapePrimitives.length--;
                        i--;
                    } else mainShape = shapePrimitive;
                }
            }
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $ar2Ly.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $1lNph.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $7r8vL.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = startAngle - i * delta;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $2NHgj.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $2NHgj.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $8UvIh.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $fVN7W.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $7r8vL.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $7r8vL.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($ece0501b6ecf6a37$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("1lNph", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $56d8cd5f45245119$export$c89a927ffc67e6fa);

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
class $56d8cd5f45245119$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks.
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Circle(0, 0, 50);
     * console.log(shape.type); // 'circle'
     *
     * // Use in type guards
     * if (shape.type === 'circle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @remarks
     * - Used for shape type checking
     * - More efficient than instanceof
     * - Read-only property
     * @readonly
     * @default 'circle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     * @see {@link ShapePrimitive} For shape interface
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */ clone() {
        return new $56d8cd5f45245119$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, width, alignment = 0.5) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const radius = this.radius;
        const outerWidth = (1 - alignment) * width;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */ getBounds(out) {
        out || (out = new (0, $ar2Ly.Rectangle)());
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("8UvIh", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $ff79fd00b31cf6f0$export$80b0269ab108fa11);

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
class $ff79fd00b31cf6f0$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Ellipse(0, 0, 50, 25);
     * console.log(shape.type); // 'ellipse'
     *
     * // Use in type guards
     * if (shape.type === 'ellipse') {
     *     console.log(shape.halfWidth, shape.halfHeight);
     * }
     * ```
     * @readonly
     * @default 'ellipse'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */ clone() {
        return new $ff79fd00b31cf6f0$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const strokeOuterWidth = strokeWidth * (1 - alignment);
        const strokeInnerWidth = strokeWidth - strokeOuterWidth;
        const innerHorizontal = halfWidth - strokeInnerWidth;
        const innerVertical = halfHeight - strokeInnerWidth;
        const outerHorizontal = halfWidth + strokeOuterWidth;
        const outerVertical = halfHeight + strokeOuterWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
        const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $ar2Ly.Rectangle)());
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("7r8vL", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $1372588079239f4f$export$7d31b617c820d435);

var $6LhOA = parcelRequire("6LhOA");

var $hASMp = parcelRequire("hASMp");

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
let $1372588079239f4f$var$tempRect;
let $1372588079239f4f$var$tempRect2;
class $1372588079239f4f$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Polygon([0, 0, 100, 0, 50, 100]);
     * console.log(shape.type); // 'polygon'
     *
     * // Use in type guards
     * if (shape.type === 'polygon') {
     *     // TypeScript knows this is a Polygon
     *     console.log(shape.points.length);
     * }
     * ```
     * @readonly
     * @default 'polygon'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */ isClockwise() {
        let area = 0;
        const points = this.points;
        const length = points.length;
        for(let i = 0; i < length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % length];
            const y2 = points[(i + 3) % length];
            area += (x2 - x1) * (y2 + y1);
        }
        return area < 0;
    }
    /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */ containsPolygon(polygon) {
        const thisBounds = this.getBounds($1372588079239f4f$var$tempRect);
        const otherBounds = polygon.getBounds($1372588079239f4f$var$tempRect2);
        if (!thisBounds.containsRect(otherBounds)) return false;
        const points = polygon.points;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!this.contains(x, y)) return false;
        }
        return true;
    }
    /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */ clone() {
        const points = this.points.slice();
        const polygon = new $1372588079239f4f$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const strokeWidthSquared = strokeWidth * strokeWidth;
        const rightWidthSquared = strokeWidthSquared * (1 - alignment);
        const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSquared = (0, $hASMp.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            const sign = Math.sign((x2 - x1) * (y - y1) - (y2 - y1) * (x - x1));
            if (distanceSquared <= (sign < 0 ? leftWidthSquared : rightWidthSquared)) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $ar2Ly.Rectangle)());
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */ get x() {
        (0, $6LhOA.deprecation)("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead.");
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */ get y() {
        (0, $6LhOA.deprecation)("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead.");
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startX() {
        return this.points[0];
    }
    /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startY() {
        return this.points[1];
    }
}

});
parcelRegister("hASMp", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $e324ce842099cd6c$export$db32ff20ff695a);
"use strict";
function $e324ce842099cd6c$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("fVN7W", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $ad87dcedefbc27a8$export$d55ab2e3dc5a4263);

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
const $ad87dcedefbc27a8$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class $ad87dcedefbc27a8$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new RoundedRectangle(0, 0, 100, 100, 20);
     * console.log(shape.type); // 'roundedRectangle'
     *
     * // Use in type guards
     * if (shape.type === 'roundedRectangle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @readonly
     * @default 'roundedRectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $ar2Ly.Rectangle)());
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $ad87dcedefbc27a8$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */ strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - strokeWidthOuter && pX <= x + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - strokeWidthOuter && pY <= y + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $ad87dcedefbc27a8$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY < innerY && $ad87dcedefbc27a8$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY > bottomBound - radius && $ad87dcedefbc27a8$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter) || pX < innerX && pY > bottomBound - radius && $ad87dcedefbc27a8$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("kpMZU", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $11ae19f429338219$export$7dab5eac414ecba2);

var $aDQkb = parcelRequire("aDQkb");
"use strict";
const $11ae19f429338219$var$RECURSION_LIMIT = 8;
const $11ae19f429338219$var$FLT_EPSILON = 11920929e-14;
const $11ae19f429338219$var$PATH_DISTANCE_EPSILON = 1;
const $11ae19f429338219$var$curveAngleToleranceEpsilon = 0.01;
const $11ae19f429338219$var$mAngleTolerance = 0;
const $11ae19f429338219$var$mCuspLimit = 0;
function $11ae19f429338219$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $aDQkb.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($11ae19f429338219$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $11ae19f429338219$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $11ae19f429338219$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $11ae19f429338219$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $11ae19f429338219$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $11ae19f429338219$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $11ae19f429338219$var$FLT_EPSILON && d3 > $11ae19f429338219$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($11ae19f429338219$var$mAngleTolerance < $11ae19f429338219$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $11ae19f429338219$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($11ae19f429338219$var$mCuspLimit !== 0) {
                    if (da1 > $11ae19f429338219$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $11ae19f429338219$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $11ae19f429338219$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($11ae19f429338219$var$mAngleTolerance < $11ae19f429338219$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $11ae19f429338219$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($11ae19f429338219$var$mCuspLimit !== 0) {
                    if (da1 > $11ae19f429338219$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $11ae19f429338219$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($11ae19f429338219$var$mAngleTolerance < $11ae19f429338219$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $11ae19f429338219$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($11ae19f429338219$var$mCuspLimit !== 0) {
                    if (da1 > $11ae19f429338219$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $11ae19f429338219$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $11ae19f429338219$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("aDQkb", function(module, exports) {

$parcel$export(module.exports, "GpuGraphicsContext", () => $4f4c04c137417501$export$e3e348c254036d55);
$parcel$export(module.exports, "GraphicsContextRenderData", () => $4f4c04c137417501$export$9b6a6c5b37fc8f49);
$parcel$export(module.exports, "GraphicsContextSystem", () => $4f4c04c137417501$export$f2f3ca33e4c65172);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $dGUqy = parcelRequire("dGUqy");

var $gjENK = parcelRequire("gjENK");

var $1oPFv = parcelRequire("1oPFv");

var $6tS7R = parcelRequire("6tS7R");

var $6LhOA = parcelRequire("6LhOA");

var $dokhj = parcelRequire("dokhj");

var $j9D8w = parcelRequire("j9D8w");
"use strict";
class $4f4c04c137417501$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
    reset() {
        if (this.batches) this.batches.forEach((batch)=>{
            (0, $dokhj.BigPool).return(batch);
        });
        if (this.graphicsData) (0, $dokhj.BigPool).return(this.graphicsData);
        this.isBatchable = false;
        this.context = null;
        this.batches.length = 0;
        this.geometryData.indices.length = 0;
        this.geometryData.vertices.length = 0;
        this.geometryData.uvs.length = 0;
        this.graphicsData = null;
    }
    destroy() {
        this.reset();
        this.batches = null;
        this.geometryData = null;
    }
}
class $4f4c04c137417501$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.instructions = new (0, $1oPFv.InstructionSet)();
    }
    init(options) {
        const maxTextures = options.maxTextures;
        this.batcher ? this.batcher._updateMaxTextures(maxTextures) : this.batcher = new (0, $gjENK.DefaultBatcher)({
            maxTextures: maxTextures
        });
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
    destroy() {
        this.batcher.destroy();
        this.instructions.destroy();
        this.batcher = null;
        this.instructions = null;
    }
}
const $4f4c04c137417501$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        return context._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const hasContext = !!context._gpuData[this._renderer.uid];
        const gpuContext = context._gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            (0, $j9D8w.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            else gpuContext.isBatchable = true;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        return context._gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $dokhj.BigPool).get($4f4c04c137417501$export$9b6a6c5b37fc8f49, {
            maxTextures: this._renderer.limits.maxBatchableTextures
        });
        const gpuContext = context._gpuData[this._renderer.uid];
        const { batches: batches, geometryData: geometryData } = gpuContext;
        gpuContext.graphicsData = graphicsData;
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $dGUqy.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count, this._renderer.limits.maxBatchableTextures);
        }
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $4f4c04c137417501$export$e3e348c254036d55();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $4f4c04c137417501$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $4f4c04c137417501$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $4f4c04c137417501$export$f2f3ca33e4c65172 = $4f4c04c137417501$var$_GraphicsContextSystem;

});
parcelRegister("dGUqy", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $af5e80b36578f5ef$export$84c26df82650dc9b);

var $eK2sB = parcelRequire("eK2sB");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $af5e80b36578f5ef$var$cachedGroups = {};
function $af5e80b36578f5ef$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $af5e80b36578f5ef$var$cachedGroups[uid] || $af5e80b36578f5ef$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $af5e80b36578f5ef$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $4iNSL.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $eK2sB.BindGroup)(bindGroupResources);
    $af5e80b36578f5ef$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6tS7R", function(module, exports) {

$parcel$export(module.exports, "GCManagedHash", () => $6253767dd6934caa$export$632d6e63cd4488df);
"use strict";
class $6253767dd6934caa$export$632d6e63cd4488df {
    constructor(options){
        // Exposed directly for GC system access
        this.items = /* @__PURE__ */ Object.create(null);
        const { renderer: renderer, type: type, onUnload: onUnload, priority: priority, name: name } = options;
        this._renderer = renderer;
        renderer.gc.addResourceHash(this, "items", type, priority ?? 0);
        this._onUnload = onUnload;
        this.name = name;
    }
    /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */ add(item) {
        if (this.items[item.uid]) return false;
        this.items[item.uid] = item;
        item.once("unload", this.remove, this);
        item._gcLastUsed = this._renderer.gc.now;
        return true;
    }
    remove(item, ...args) {
        if (!this.items[item.uid]) return;
        const gpuData = item._gpuData[this._renderer.uid];
        if (!gpuData) return;
        this._onUnload?.(item, ...args);
        gpuData.destroy();
        item._gpuData[this._renderer.uid] = null;
        this.items[item.uid] = null;
    }
    removeAll(...args) {
        Object.values(this.items).forEach((item)=>item && this.remove(item, ...args));
    }
    destroy(...args) {
        this.removeAll(...args);
        this.items = /* @__PURE__ */ Object.create(null);
        this._renderer = null;
        this._onUnload = null;
    }
}

});



parcelRegister("bB0KA", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $ce468feebee2c14a$export$d53ce9debfe7a6c2);

var $aDQkb = parcelRequire("aDQkb");
"use strict";
const $ce468feebee2c14a$var$RECURSION_LIMIT = 8;
const $ce468feebee2c14a$var$FLT_EPSILON = 11920929e-14;
const $ce468feebee2c14a$var$PATH_DISTANCE_EPSILON = 1;
const $ce468feebee2c14a$var$curveAngleToleranceEpsilon = 0.01;
const $ce468feebee2c14a$var$mAngleTolerance = 0;
function $ce468feebee2c14a$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $aDQkb.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($ce468feebee2c14a$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $ce468feebee2c14a$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $ce468feebee2c14a$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $ce468feebee2c14a$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $ce468feebee2c14a$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $ce468feebee2c14a$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $ce468feebee2c14a$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($ce468feebee2c14a$var$mAngleTolerance < $ce468feebee2c14a$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $ce468feebee2c14a$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $ce468feebee2c14a$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $ce468feebee2c14a$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("dP0DE", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $376fb0526cb4248d$export$ed8eebdc6998f0f6);
"use strict";
function $376fb0526cb4248d$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("ipEz7", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $2661c77c928e7595$export$d46b7933b415e02f);

var $dP0DE = parcelRequire("dP0DE");
"use strict";
function $2661c77c928e7595$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $dP0DE.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("4VZYJ", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $1f520cd78e3f23e5$export$71ccaa6dca53075e);

var $kpMZU = parcelRequire("kpMZU");
"use strict";
const $1f520cd78e3f23e5$var$TAU = Math.PI * 2;
const $1f520cd78e3f23e5$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $1f520cd78e3f23e5$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $1f520cd78e3f23e5$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $1f520cd78e3f23e5$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $1f520cd78e3f23e5$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $1f520cd78e3f23e5$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $1f520cd78e3f23e5$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $1f520cd78e3f23e5$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $1f520cd78e3f23e5$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $1f520cd78e3f23e5$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $1f520cd78e3f23e5$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $1f520cd78e3f23e5$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $1f520cd78e3f23e5$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $1f520cd78e3f23e5$var$out);
    let { ang1: ang1, ang2: ang2 } = $1f520cd78e3f23e5$var$out;
    const { centerX: centerX, centerY: centerY } = $1f520cd78e3f23e5$var$out;
    let ratio = Math.abs(ang2) / ($1f520cd78e3f23e5$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $1f520cd78e3f23e5$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $1f520cd78e3f23e5$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $1f520cd78e3f23e5$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $1f520cd78e3f23e5$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $kpMZU.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("2NHgj", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $324cce5d2b628b5e$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $324cce5d2b628b5e$export$cf503f371c53af9e);
"use strict";
function $324cce5d2b628b5e$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $324cce5d2b628b5e$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("dfSnn", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $ae3eda5ffc68438a$export$2cc2aaca18109aab);

var $1RpxL = parcelRequire("1RpxL");

var $1roql = parcelRequire("1roql");

var $5QkPm = parcelRequire("5QkPm");

var $fUc8w = parcelRequire("fUc8w");

var $1crrD = parcelRequire("1crrD");

var $2gf0f = parcelRequire("2gf0f");

var $9IHrN = parcelRequire("9IHrN");
"use strict";
function $ae3eda5ffc68438a$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        defs: {},
        path: new (0, $1roql.GraphicsPath)()
    };
    (0, $5QkPm.parseSVGDefinitions)(svg, session);
    const children = svg.children;
    const { fillStyle: fillStyle, strokeStyle: strokeStyle } = (0, $1crrD.parseSVGStyle)(svg, session);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.nodeName.toLowerCase() === "defs") continue;
        $ae3eda5ffc68438a$var$renderChildren(child, session, fillStyle, strokeStyle);
    }
    return graphicsContext;
}
function $ae3eda5ffc68438a$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = (0, $1crrD.parseSVGStyle)(svg, session);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    const noStyle = !fillStyle && !strokeStyle;
    if (noStyle) fillStyle = {
        color: 0
    };
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            {
                d = svg.getAttribute("d");
                const fillRule = svg.getAttribute("fill-rule");
                const subpaths = (0, $9IHrN.extractSubpaths)(d);
                const hasExplicitEvenodd = fillRule === "evenodd";
                const hasMultipleSubpaths = subpaths.length > 1;
                const shouldProcessHoles = hasExplicitEvenodd && hasMultipleSubpaths;
                if (shouldProcessHoles) {
                    const subpathsWithArea = subpaths.map((subpath)=>({
                            path: subpath,
                            area: (0, $9IHrN.calculatePathArea)(subpath)
                        }));
                    subpathsWithArea.sort((a, b)=>b.area - a.area);
                    const useMultipleHolesApproach = subpaths.length > 3 || !(0, $2gf0f.checkForNestedPattern)(subpathsWithArea);
                    if (useMultipleHolesApproach) for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isMainShape = i === 0;
                        session.context.beginPath();
                        const newPath = new (0, $1roql.GraphicsPath)(void 0, true);
                        (0, $9IHrN.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isMainShape) {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        } else session.context.cut();
                    }
                    else for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isHole = i % 2 === 1;
                        session.context.beginPath();
                        const newPath = new (0, $1roql.GraphicsPath)(void 0, true);
                        (0, $9IHrN.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isHole) session.context.cut();
                        else {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        }
                    }
                } else {
                    const useEvenoddForGraphicsPath = fillRule ? fillRule === "evenodd" : true;
                    graphicsPath = new (0, $1roql.GraphicsPath)(d, useEvenoddForGraphicsPath);
                    session.context.path(graphicsPath);
                    if (fillStyle) session.context.fill(fillStyle);
                    if (strokeStyle) session.context.stroke(strokeStyle);
                }
                break;
            }
        case "circle":
            cx = (0, $fUc8w.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $fUc8w.parseSVGFloatAttribute)(svg, "cy", 0);
            r = (0, $fUc8w.parseSVGFloatAttribute)(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "rect":
            x = (0, $fUc8w.parseSVGFloatAttribute)(svg, "x", 0);
            y = (0, $fUc8w.parseSVGFloatAttribute)(svg, "y", 0);
            width = (0, $fUc8w.parseSVGFloatAttribute)(svg, "width", 0);
            height = (0, $fUc8w.parseSVGFloatAttribute)(svg, "height", 0);
            rx = (0, $fUc8w.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $fUc8w.parseSVGFloatAttribute)(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "ellipse":
            cx = (0, $fUc8w.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $fUc8w.parseSVGFloatAttribute)(svg, "cy", 0);
            rx = (0, $fUc8w.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $fUc8w.parseSVGFloatAttribute)(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "line":
            x1 = (0, $fUc8w.parseSVGFloatAttribute)(svg, "x1", 0);
            y1 = (0, $fUc8w.parseSVGFloatAttribute)(svg, "y1", 0);
            x2 = (0, $fUc8w.parseSVGFloatAttribute)(svg, "x2", 0);
            y2 = (0, $fUc8w.parseSVGFloatAttribute)(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        // Group elements - just process children
        case "g":
        case "svg":
            break;
        default:
            (0, $1RpxL.warn)(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    if (noStyle) fillStyle = null;
    for(let i = 0; i < children.length; i++)$ae3eda5ffc68438a$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}

});
parcelRegister("5QkPm", function(module, exports) {

$parcel$export(module.exports, "parseSVGDefinitions", () => $12de2df48de4c37e$export$d578aced17ea3023);

var $dKHyW = parcelRequire("dKHyW");

var $1RpxL = parcelRequire("1RpxL");

var $hkzHY = parcelRequire("hkzHY");

var $fUc8w = parcelRequire("fUc8w");
"use strict";
function $12de2df48de4c37e$export$d578aced17ea3023(svg, session) {
    const definitions = svg.querySelectorAll("defs");
    for(let i = 0; i < definitions.length; i++){
        const definition = definitions[i];
        for(let j = 0; j < definition.children.length; j++){
            const child = definition.children[j];
            switch(child.nodeName.toLowerCase()){
                case "lineargradient":
                    session.defs[child.id] = $12de2df48de4c37e$var$parseLinearGradient(child);
                    break;
                case "radialgradient":
                    session.defs[child.id] = $12de2df48de4c37e$var$parseRadialGradient(child);
                    break;
                default:
                    break;
            }
        }
    }
}
function $12de2df48de4c37e$var$parseLinearGradient(child) {
    const x0 = (0, $fUc8w.parseSVGFloatAttribute)(child, "x1", 0);
    const y0 = (0, $fUc8w.parseSVGFloatAttribute)(child, "y1", 0);
    const x1 = (0, $fUc8w.parseSVGFloatAttribute)(child, "x2", 1);
    const y1 = (0, $fUc8w.parseSVGFloatAttribute)(child, "y2", 0);
    const gradientUnit = child.getAttribute("gradientUnits") || "objectBoundingBox";
    const gradient = new (0, $hkzHY.FillGradient)(x0, y0, x1, y1, gradientUnit === "objectBoundingBox" ? "local" : "global");
    for(let k = 0; k < child.children.length; k++){
        const stop = child.children[k];
        const offset = (0, $fUc8w.parseSVGFloatAttribute)(stop, "offset", 0);
        const color = (0, $dKHyW.Color).shared.setValue(stop.getAttribute("stop-color")).toNumber();
        gradient.addColorStop(offset, color);
    }
    return gradient;
}
function $12de2df48de4c37e$var$parseRadialGradient(_child) {
    (0, $1RpxL.warn)("[SVG Parser] Radial gradients are not yet supported");
    return new (0, $hkzHY.FillGradient)(0, 0, 1, 0);
}

});
parcelRegister("fUc8w", function(module, exports) {

$parcel$export(module.exports, "parseSVGFloatAttribute", () => $141e77e8765488b9$export$dd264bbf059b1af7);
"use strict";
function $141e77e8765488b9$export$dd264bbf059b1af7(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}

});


parcelRegister("1crrD", function(module, exports) {

$parcel$export(module.exports, "styleAttributes", () => $d30fedccb9321946$export$d1c537faaad576dd);
$parcel$export(module.exports, "parseSVGStyle", () => $d30fedccb9321946$export$394301fd4b48c7bc);

var $dKHyW = parcelRequire("dKHyW");

var $5dXd8 = parcelRequire("5dXd8");
"use strict";
const $d30fedccb9321946$export$d1c537faaad576dd = {
    // Fill properties
    fill: {
        type: "paint",
        default: 0
    },
    // Fill color/gradient
    "fill-opacity": {
        type: "number",
        default: 1
    },
    // Fill transparency
    // Stroke properties
    stroke: {
        type: "paint",
        default: 0
    },
    // Stroke color/gradient
    "stroke-width": {
        type: "number",
        default: 1
    },
    // Width of stroke
    "stroke-opacity": {
        type: "number",
        default: 1
    },
    // Stroke transparency
    "stroke-linecap": {
        type: "string",
        default: "butt"
    },
    // End cap style: butt, round, square
    "stroke-linejoin": {
        type: "string",
        default: "miter"
    },
    // Join style: miter, round, bevel
    "stroke-miterlimit": {
        type: "number",
        default: 10
    },
    // Limit on miter join sharpness
    "stroke-dasharray": {
        type: "string",
        default: "none"
    },
    // Dash pattern
    "stroke-dashoffset": {
        type: "number",
        default: 0
    },
    // Offset for dash pattern
    // Global properties
    opacity: {
        type: "number",
        default: 1
    }
};
function $d30fedccb9321946$export$394301fd4b48c7bc(svg, session) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    const result = {
        strokeStyle: strokeStyle,
        fillStyle: fillStyle,
        useFill: false,
        useStroke: false
    };
    for(const key in $d30fedccb9321946$export$d1c537faaad576dd){
        const attribute = svg.getAttribute(key);
        if (attribute) $d30fedccb9321946$var$parseAttribute(session, result, key, attribute.trim());
    }
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i].trim();
            const [key, value] = stylePart.split(":");
            if ($d30fedccb9321946$export$d1c537faaad576dd[key]) $d30fedccb9321946$var$parseAttribute(session, result, key, value.trim());
        }
    }
    return {
        strokeStyle: result.useStroke ? strokeStyle : null,
        fillStyle: result.useFill ? fillStyle : null,
        useFill: result.useFill,
        useStroke: result.useStroke
    };
}
function $d30fedccb9321946$var$parseAttribute(session, result, id, value) {
    switch(id){
        case "stroke":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $5dXd8.extractSvgUrlId)(value);
                    result.strokeStyle.fill = session.defs[id2];
                } else result.strokeStyle.color = (0, $dKHyW.Color).shared.setValue(value).toNumber();
                result.useStroke = true;
            }
            break;
        case "stroke-width":
            result.strokeStyle.width = Number(value);
            break;
        case "fill":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $5dXd8.extractSvgUrlId)(value);
                    result.fillStyle.fill = session.defs[id2];
                } else result.fillStyle.color = (0, $dKHyW.Color).shared.setValue(value).toNumber();
                result.useFill = true;
            }
            break;
        case "fill-opacity":
            result.fillStyle.alpha = Number(value);
            break;
        case "stroke-opacity":
            result.strokeStyle.alpha = Number(value);
            break;
        case "opacity":
            result.fillStyle.alpha = Number(value);
            result.strokeStyle.alpha = Number(value);
            break;
    }
}

});
parcelRegister("5dXd8", function(module, exports) {

$parcel$export(module.exports, "extractSvgUrlId", () => $41213026952a0730$export$c7c899a4a04107c);
"use strict";
function $41213026952a0730$export$c7c899a4a04107c(url) {
    const match = url.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
    return match ? match[1] : "";
}

});


parcelRegister("2gf0f", function(module, exports) {

$parcel$export(module.exports, "checkForNestedPattern", () => $6d485cf915eebc4a$export$ed0d227537169c54);
$parcel$export(module.exports, "getFillInstructionData", () => $6d485cf915eebc4a$export$610d4ffdd1dde411);
"use strict";
function $6d485cf915eebc4a$export$ed0d227537169c54(subpathsWithArea) {
    if (subpathsWithArea.length <= 2) return true;
    const areas = subpathsWithArea.map((s)=>s.area).sort((a, b)=>b - a);
    const [largestArea, secondArea] = areas;
    const smallestArea = areas[areas.length - 1];
    const largestToSecondRatio = largestArea / secondArea;
    const secondToSmallestRatio = secondArea / smallestArea;
    if (largestToSecondRatio > 3 && secondToSmallestRatio < 2) return false;
    return true;
}
function $6d485cf915eebc4a$export$610d4ffdd1dde411(context, index = 0) {
    const instruction = context.instructions[index];
    if (!instruction || instruction.action !== "fill") throw new Error(`Expected fill instruction at index ${index}, got ${instruction?.action || "undefined"}`);
    return instruction.data;
}

});

parcelRegister("9IHrN", function(module, exports) {

$parcel$export(module.exports, "extractSubpaths", () => $32cdb7d2baf77ee8$export$af504e8f7eac5195);
$parcel$export(module.exports, "calculatePathArea", () => $32cdb7d2baf77ee8$export$c5f82a6ddca6e166);
$parcel$export(module.exports, "appendSVGPath", () => $32cdb7d2baf77ee8$export$29a5b7b41692ef3);

var $1roql = parcelRequire("1roql");
"use strict";
function $32cdb7d2baf77ee8$export$af504e8f7eac5195(pathData) {
    const parts = pathData.split(/(?=[Mm])/);
    const subpaths = parts.filter((part)=>part.trim().length > 0);
    return subpaths;
}
function $32cdb7d2baf77ee8$export$c5f82a6ddca6e166(pathData) {
    const coords = pathData.match(/[-+]?[0-9]*\.?[0-9]+/g);
    if (!coords || coords.length < 4) return 0;
    const numbers = coords.map(Number);
    const xs = [];
    const ys = [];
    for(let i = 0; i < numbers.length; i += 2)if (i + 1 < numbers.length) {
        xs.push(numbers[i]);
        ys.push(numbers[i + 1]);
    }
    if (xs.length === 0 || ys.length === 0) return 0;
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const area = (maxX - minX) * (maxY - minY);
    return area;
}
function $32cdb7d2baf77ee8$export$29a5b7b41692ef3(pathData, graphicsPath) {
    const tempPath = new (0, $1roql.GraphicsPath)(pathData, false);
    for (const instruction of tempPath.instructions)graphicsPath.instructions.push(instruction);
}

});


parcelRegister("bapDA", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $beaf61fb0344c26c$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $beaf61fb0344c26c$export$64975ed44b74a62b);

var $dKHyW = parcelRequire("dKHyW");

var $4iNSL = parcelRequire("4iNSL");

var $hkzHY = parcelRequire("hkzHY");

var $bySfk = parcelRequire("bySfk");
"use strict";
function $beaf61fb0344c26c$var$isColorLike(value) {
    return (0, $dKHyW.Color).isColorLike(value);
}
function $beaf61fb0344c26c$var$isFillPattern(value) {
    return value instanceof (0, $bySfk.FillPattern);
}
function $beaf61fb0344c26c$var$isFillGradient(value) {
    return value instanceof (0, $hkzHY.FillGradient);
}
function $beaf61fb0344c26c$var$isTexture(value) {
    return value instanceof (0, $4iNSL.Texture);
}
function $beaf61fb0344c26c$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $dKHyW.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $4iNSL.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $beaf61fb0344c26c$var$handleTexture(fill, value, defaultStyle) {
    fill.texture = value;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $beaf61fb0344c26c$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $beaf61fb0344c26c$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    fill.textureSpace = value.textureSpace;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $beaf61fb0344c26c$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    const color = (0, $dKHyW.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    return style;
}
function $beaf61fb0344c26c$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($beaf61fb0344c26c$var$isColorLike(value)) return $beaf61fb0344c26c$var$handleColorLike(fill, value, defaultStyle);
    else if ($beaf61fb0344c26c$var$isTexture(value)) return $beaf61fb0344c26c$var$handleTexture(fill, value, defaultStyle);
    else if ($beaf61fb0344c26c$var$isFillPattern(value)) return $beaf61fb0344c26c$var$handleFillPattern(fill, value, defaultStyle);
    else if ($beaf61fb0344c26c$var$isFillGradient(value)) return $beaf61fb0344c26c$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $beaf61fb0344c26c$var$isFillPattern(objectStyle.fill)) return $beaf61fb0344c26c$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $beaf61fb0344c26c$var$isFillGradient(objectStyle.fill)) return $beaf61fb0344c26c$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $beaf61fb0344c26c$var$handleFillObject(objectStyle, defaultStyle);
}
function $beaf61fb0344c26c$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, pixelLine: pixelLine, ...rest } = defaultStyle;
    const fill = $beaf61fb0344c26c$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        pixelLine: pixelLine,
        ...fill
    };
}

});


parcelRegister("hJR2o", function(module, exports) {

var $aZ9ZN = parcelRequire("aZ9ZN");

var $761XJ = parcelRequire("761XJ");

var $2gsFh = parcelRequire("2gsFh");

var $aDQkb = parcelRequire("aDQkb");

var $cFO33 = parcelRequire("cFO33");
"use strict";
(0, $aZ9ZN.extensions).add((0, $2gsFh.CanvasGraphicsPipe));
(0, $aZ9ZN.extensions).add((0, $cFO33.GraphicsPipe));
(0, $aZ9ZN.extensions).add((0, $761XJ.CanvasGraphicsContextSystem));
(0, $aZ9ZN.extensions).add((0, $aDQkb.GraphicsContextSystem));

});
parcelRegister("761XJ", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsContextSystem", () => $c99f4b2b979304d8$export$ecb840d1abeff74b);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1oPFv = parcelRequire("1oPFv");

var $6tS7R = parcelRequire("6tS7R");
"use strict";
class $c99f4b2b979304d8$var$CanvasGraphicsContext {
    constructor(){
        /**
     * Whether this context can be batched.
     * @advanced
     */ this.isBatchable = false;
    }
    /**
   * Reset cached canvas data.
   * @advanced
   */ reset() {
        this.isBatchable = false;
        this.context = null;
        if (this.graphicsData) {
            this.graphicsData.destroy();
            this.graphicsData = null;
        }
    }
    /**
   * Destroy the cached data.
   * @advanced
   */ destroy() {
        this.reset();
    }
}
class $c99f4b2b979304d8$var$CanvasGraphicsContextRenderData {
    constructor(){
        /**
     * Instructions for canvas rendering.
     * @advanced
     */ this.instructions = new (0, $1oPFv.InstructionSet)();
    }
    /**
   * Initialize render data.
   * @advanced
   */ init() {
        this.instructions.reset();
    }
    /**
   * Destroy render data.
   * @advanced
   */ destroy() {
        this.instructions.destroy();
        this.instructions = null;
    }
}
const $c99f4b2b979304d8$var$_CanvasGraphicsContextSystem = class _CanvasGraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        const gpuContext = this.getGpuContext(context);
        return gpuContext.graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const gpuData = context._gpuData;
        const hasContext = !!gpuData[this._renderer.uid];
        const gpuContext = gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            gpuContext.isBatchable = false;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        const gpuData = context._gpuData;
        return gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const renderData = new $c99f4b2b979304d8$var$CanvasGraphicsContextRenderData();
        const gpuContext = this.getGpuContext(context);
        gpuContext.graphicsData = renderData;
        renderData.init();
        return renderData;
    }
    _initContext(context) {
        const gpuContext = new $c99f4b2b979304d8$var$CanvasGraphicsContext();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $c99f4b2b979304d8$var$_CanvasGraphicsContextSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $c99f4b2b979304d8$var$_CanvasGraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $c99f4b2b979304d8$export$ecb840d1abeff74b = $c99f4b2b979304d8$var$_CanvasGraphicsContextSystem;

});

parcelRegister("2gsFh", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsPipe", () => $41dac9eed860c2d7$export$26ad1716c6143fba);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $6tS7R = parcelRequire("6tS7R");
"use strict";
class $41dac9eed860c2d7$export$26ad1716c6143fba {
    constructor(renderer, adaptor){
        this.state = (0, $fx0Zy.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(_graphics) {
        return false;
    }
    addRenderable(graphics, instructionSet) {
        this._managedGraphics.add(graphics);
        this.renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(graphics);
    }
    updateRenderable(_graphics) {}
    execute(graphics) {
        if (!graphics.isRenderable) return;
        this._adaptor.execute(this, graphics);
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
    }
}
/** @ignore */ $41dac9eed860c2d7$export$26ad1716c6143fba.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "graphics"
};

});

parcelRegister("cFO33", function(module, exports) {

$parcel$export(module.exports, "GraphicsGpuData", () => $ca05041d7f5eab16$export$2a885cf99f131046);
$parcel$export(module.exports, "GraphicsPipe", () => $ca05041d7f5eab16$export$56171ef5563dc803);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $6tS7R = parcelRequire("6tS7R");

var $dokhj = parcelRequire("dokhj");

var $id0ju = parcelRequire("id0ju");

var $arDaU = parcelRequire("arDaU");
"use strict";
class $ca05041d7f5eab16$export$2a885cf99f131046 {
    constructor(){
        this.batches = [];
        this.batched = false;
    }
    destroy() {
        this.batches.forEach((batch)=>{
            (0, $dokhj.BigPool).return(batch);
        });
        this.batches.length = 0;
    }
}
class $ca05041d7f5eab16$export$56171ef5563dc803 {
    constructor(renderer, adaptor){
        this.state = (0, $fx0Zy.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(graphics) {
        const context = graphics.context;
        const wasBatched = !!graphics._gpuData;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(context);
        if (gpuContext.isBatchable || wasBatched !== gpuContext.isBatchable) return true;
        return false;
    }
    addRenderable(graphics, instructionSet) {
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        if (graphics.didViewUpdate) this._rebuild(graphics);
        if (gpuContext.isBatchable) this._addToBatcher(graphics, instructionSet);
        else {
            this.renderer.renderPipes.batch.break(instructionSet);
            instructionSet.add(graphics);
        }
    }
    updateRenderable(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const batches = gpuData.batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batch._batcher.updateElement(batch);
        }
    }
    execute(graphics) {
        if (!graphics.isRenderable) return;
        const renderer = this.renderer;
        const context = graphics.context;
        const contextSystem = renderer.graphicsContext;
        if (!contextSystem.getGpuContext(context).batches.length) return;
        const shader = context.customShader || this._adaptor.shader;
        this.state.blendMode = graphics.groupBlendMode;
        const localUniforms = shader.resources.localUniforms.uniforms;
        localUniforms.uTransformMatrix = graphics.groupTransform;
        localUniforms.uRound = renderer._roundPixels | graphics._roundPixels;
        (0, $id0ju.color32BitToUniform)(graphics.groupColorAlpha, localUniforms.uColor, 0);
        this._adaptor.execute(this, graphics);
    }
    _rebuild(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        gpuData.destroy();
        if (gpuContext.isBatchable) this._updateBatchesForRenderable(graphics, gpuData);
    }
    _addToBatcher(graphics, instructionSet) {
        const batchPipe = this.renderer.renderPipes.batch;
        const batches = this._getGpuDataForRenderable(graphics).batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batchPipe.addToBatch(batch, instructionSet);
        }
    }
    _getGpuDataForRenderable(graphics) {
        return graphics._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(graphics);
    }
    _initGpuDataForRenderable(graphics) {
        const gpuData = new $ca05041d7f5eab16$export$2a885cf99f131046();
        graphics._gpuData[this.renderer.uid] = gpuData;
        this._managedGraphics.add(graphics);
        return gpuData;
    }
    _updateBatchesForRenderable(graphics, gpuData) {
        const context = graphics.context;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.getGpuContext(context);
        const roundPixels = this.renderer._roundPixels | graphics._roundPixels;
        gpuData.batches = gpuContext.batches.map((batch)=>{
            const batchClone = (0, $dokhj.BigPool).get((0, $arDaU.BatchableGraphics));
            batch.copyTo(batchClone);
            batchClone.renderable = graphics;
            batchClone.roundPixels = roundPixels;
            return batchClone;
        });
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
        this.state = null;
    }
}
/** @ignore */ $ca05041d7f5eab16$export$56171ef5563dc803.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "graphics"
};

});
parcelRegister("id0ju", function(module, exports) {

$parcel$export(module.exports, "colorToUniform", () => $60b07ebbce1f287f$export$d13a52631f102a23);
$parcel$export(module.exports, "color32BitToUniform", () => $60b07ebbce1f287f$export$2c68e848c5b81f5);
"use strict";
function $60b07ebbce1f287f$export$d13a52631f102a23(rgb, alpha, out, offset) {
    out[offset++] = (rgb >> 16 & 255) / 255;
    out[offset++] = (rgb >> 8 & 255) / 255;
    out[offset++] = (rgb & 255) / 255;
    out[offset++] = alpha;
}
function $60b07ebbce1f287f$export$2c68e848c5b81f5(abgr, out, offset) {
    const alpha = (abgr >> 24 & 255) / 255;
    out[offset++] = (abgr & 255) / 255 * alpha;
    out[offset++] = (abgr >> 8 & 255) / 255 * alpha;
    out[offset++] = (abgr >> 16 & 255) / 255 * alpha;
    out[offset++] = alpha;
}

});





parcelRegister("4PjrR", function(module, exports) {

$parcel$export(module.exports, "BlendModePipe", () => $4738de590b6b20b1$export$fee7195ef0d08bcf);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jMFz3 = parcelRequire("jMFz3");

var $k0xIU = parcelRequire("k0xIU");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
const $4738de590b6b20b1$var$BLEND_MODE_FILTERS = {};
(0, $aZ9ZN.extensions).handle((0, $aZ9ZN.ExtensionType).BlendMode, (value)=>{
    if (!value.name) throw new Error("BlendMode extension must have a name property");
    $4738de590b6b20b1$var$BLEND_MODE_FILTERS[value.name] = value.ref;
}, (value)=>{
    delete $4738de590b6b20b1$var$BLEND_MODE_FILTERS[value.name];
});
class $4738de590b6b20b1$export$fee7195ef0d08bcf {
    constructor(renderer){
        this._blendModeStack = [];
        this._isAdvanced = false;
        this._filterHash = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
        this._renderer.runners.prerender.add(this);
    }
    prerender() {
        this._activeBlendMode = "normal";
        this._isAdvanced = false;
    }
    /**
   * Push a blend mode onto the internal stack and apply it to the instruction set if needed.
   * @param renderable - The renderable or {@link RenderGroup} associated with the change.
   * @param blendMode - The blend mode to activate.
   * @param instructionSet - The instruction set being built.
   */ pushBlendMode(renderable, blendMode, instructionSet) {
        this._blendModeStack.push(blendMode);
        this.setBlendMode(renderable, blendMode, instructionSet);
    }
    /**
   * Pop the last blend mode from the stack and apply the new top-of-stack mode.
   * @param instructionSet - The instruction set being built.
   */ popBlendMode(instructionSet) {
        this._blendModeStack.pop();
        const blendMode = this._blendModeStack[this._activeBlendMode.length - 1] ?? "normal";
        this.setBlendMode(null, blendMode, instructionSet);
    }
    /**
   * Ensure a blend mode switch is added to the instruction set when the mode changes.
   * If an advanced blend mode is active, subsequent renderables will be collected so they can be
   * rendered within a single filter pass.
   * @param renderable - The renderable or {@link RenderGroup} to associate with the change, or null when unwinding.
   * @param blendMode - The target blend mode.
   * @param instructionSet - The instruction set being built.
   */ setBlendMode(renderable, blendMode, instructionSet) {
        const isRenderGroup = renderable instanceof (0, $k0xIU.RenderGroup);
        if (this._activeBlendMode === blendMode) {
            if (this._isAdvanced && renderable && !isRenderGroup) this._renderableList?.push(renderable);
            return;
        }
        if (this._isAdvanced) this._endAdvancedBlendMode(instructionSet);
        this._activeBlendMode = blendMode;
        if (!renderable) return;
        this._isAdvanced = !!$4738de590b6b20b1$var$BLEND_MODE_FILTERS[blendMode];
        if (this._isAdvanced) this._beginAdvancedBlendMode(renderable, instructionSet);
    }
    _beginAdvancedBlendMode(renderable, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        const blendMode = this._activeBlendMode;
        if (!$4738de590b6b20b1$var$BLEND_MODE_FILTERS[blendMode]) {
            (0, $1RpxL.warn)(`Unable to assign BlendMode: '${blendMode}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
            return;
        }
        const filterEffect = this._ensureFilterEffect(blendMode);
        const isRenderGroup = renderable instanceof (0, $k0xIU.RenderGroup);
        const instruction = {
            renderPipeId: "filter",
            action: "pushFilter",
            filterEffect: filterEffect,
            renderables: isRenderGroup ? null : [
                renderable
            ],
            container: isRenderGroup ? renderable.root : null,
            canBundle: false
        };
        this._renderableList = instruction.renderables;
        instructionSet.add(instruction);
    }
    _ensureFilterEffect(blendMode) {
        let filterEffect = this._filterHash[blendMode];
        if (!filterEffect) {
            filterEffect = this._filterHash[blendMode] = new (0, $jMFz3.FilterEffect)();
            filterEffect.filters = [
                new $4738de590b6b20b1$var$BLEND_MODE_FILTERS[blendMode]()
            ];
        }
        return filterEffect;
    }
    _endAdvancedBlendMode(instructionSet) {
        this._isAdvanced = false;
        this._renderableList = null;
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "filter",
            action: "popFilter",
            canBundle: false
        });
    }
    /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   */ buildStart() {
        this._isAdvanced = false;
    }
    /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   */ buildEnd(instructionSet) {
        if (!this._isAdvanced) return;
        this._endAdvancedBlendMode(instructionSet);
    }
    /** @internal */ destroy() {
        this._renderer = null;
        this._renderableList = null;
        for(const i in this._filterHash)this._filterHash[i].destroy();
        this._filterHash = null;
    }
}
/** @ignore */ $4738de590b6b20b1$export$fee7195ef0d08bcf.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "blendMode"
};

});

parcelRegister("7velr", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $958315c56c3c96bc$export$58ab3ed211eed562);

var $dKHyW = parcelRequire("dKHyW");

var $l8aZL = parcelRequire("l8aZL");

var $2vcTO = parcelRequire("2vcTO");

var $p4165 = parcelRequire("p4165");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $fpmqC = parcelRequire("fpmqC");


var $5Ac7T = parcelRequire("5Ac7T");

var $ljtep = parcelRequire("ljtep");

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $958315c56c3c96bc$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $958315c56c3c96bc$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** The current tick of the renderer. */ this.tick = 0;
        /** @internal */ this.uid = (0, $1bMtF.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$958315c56c3c96bc$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $l8aZL.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        this.tick++;
        let options = args;
        if (options instanceof (0, $2vcTO.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $dKHyW.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        if (!options.container.visible) return;
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $5Ac7T.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target, mipLevel: mipLevel, layer: layer } = options;
        (0, $dKHyW.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $dKHyW.Color).shared.toArray(), mipLevel ?? 0, layer ?? 0);
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $ljtep.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
            this.runners.destroy.add(this.renderPipes[name]);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        if (options === true || typeof options === "object" && options.releaseGlobalResources) (0, $fpmqC.GlobalResourceRegistry).release();
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $p4165.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $958315c56c3c96bc$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $958315c56c3c96bc$export$58ab3ed211eed562 = $958315c56c3c96bc$var$_AbstractRenderer;

});
parcelRegister("l8aZL", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $c6535e55e6c700e8$export$3b30260a318c769f);
$parcel$export(module.exports, "autoDetectEnvironment", () => $c6535e55e6c700e8$export$72225172dd907279);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $c6535e55e6c700e8$var$environments = [];
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).Environment, $c6535e55e6c700e8$var$environments);
async function $c6535e55e6c700e8$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $c6535e55e6c700e8$var$environments.length; i++){
        const env = $c6535e55e6c700e8$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $c6535e55e6c700e8$export$72225172dd907279(add) {
    return $c6535e55e6c700e8$export$3b30260a318c769f(!add);
}

});

parcelRegister("p4165", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $52886ceb0d51ede1$export$70c0711f29adc5cf);
"use strict";
let $52886ceb0d51ede1$var$unsafeEval;
function $52886ceb0d51ede1$export$70c0711f29adc5cf() {
    if (typeof $52886ceb0d51ede1$var$unsafeEval === "boolean") return $52886ceb0d51ede1$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $52886ceb0d51ede1$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $52886ceb0d51ede1$var$unsafeEval = false;
    }
    return $52886ceb0d51ede1$var$unsafeEval;
}

});

parcelRegister("5Ac7T", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $1dd08a191236d84a$export$6c4d37c7f376a1de);
"use strict";
var $1dd08a191236d84a$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($1dd08a191236d84a$export$6c4d37c7f376a1de || {});

});

parcelRegister("ljtep", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $22fba102052ea47d$export$ff5f2fe687fe3979);
"use strict";
class $22fba102052ea47d$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("g2d25", function(module, exports) {

$parcel$export(module.exports, "SharedSystems", () => $0c0664ead003c921$export$556f4f9086226a47);
$parcel$export(module.exports, "SharedRenderPipes", () => $0c0664ead003c921$export$4804359c3f750499);

var $1SYU5 = parcelRequire("1SYU5");

var $lGOq2 = parcelRequire("lGOq2");

var $kixfr = parcelRequire("kixfr");

var $hzr7O = parcelRequire("hzr7O");

var $2xyZ0 = parcelRequire("2xyZ0");

var $jDoUt = parcelRequire("jDoUt");

var $gNCRL = parcelRequire("gNCRL");

var $lNC5O = parcelRequire("lNC5O");

var $yJ7KI = parcelRequire("yJ7KI");

var $9UEzW = parcelRequire("9UEzW");

var $4PjrR = parcelRequire("4PjrR");

var $57WMt = parcelRequire("57WMt");

var $7fOUA = parcelRequire("7fOUA");

var $7bRdE = parcelRequire("7bRdE");

var $cVsmc = parcelRequire("cVsmc");

var $iifuN = parcelRequire("iifuN");

var $eHpUP = parcelRequire("eHpUP");

var $9JGFp = parcelRequire("9JGFp");

var $715l6 = parcelRequire("715l6");

var $9QtIe = parcelRequire("9QtIe");
"use strict";
const $0c0664ead003c921$export$556f4f9086226a47 = [
    (0, $9UEzW.BackgroundSystem),
    (0, $cVsmc.GlobalUniformSystem),
    (0, $eHpUP.HelloSystem),
    (0, $9QtIe.ViewSystem),
    (0, $kixfr.RenderGroupSystem),
    (0, $7bRdE.GCSystem),
    (0, $715l6.TextureGCSystem),
    (0, $7fOUA.GenerateTextureSystem),
    (0, $57WMt.ExtractSystem),
    (0, $2xyZ0.RendererInitHook),
    (0, $9JGFp.RenderableGCSystem),
    (0, $iifuN.SchedulerSystem)
];
const $0c0664ead003c921$export$4804359c3f750499 = [
    (0, $4PjrR.BlendModePipe),
    (0, $jDoUt.BatcherPipe),
    (0, $hzr7O.SpritePipe),
    (0, $lGOq2.RenderGroupPipe),
    (0, $gNCRL.AlphaMaskPipe),
    (0, $yJ7KI.StencilMaskPipe),
    (0, $lNC5O.ColorMaskPipe),
    (0, $1SYU5.CustomRenderPipe)
];

});
parcelRegister("kixfr", function(module, exports) {

$parcel$export(module.exports, "RenderGroupSystem", () => $fc9c9467d3d21e9e$export$e48941ab3223d0e5);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $5NyEC = parcelRequire("5NyEC");

var $c8piJ = parcelRequire("c8piJ");

var $esrbs = parcelRequire("esrbs");

var $6IFWH = parcelRequire("6IFWH");

var $7QtNh = parcelRequire("7QtNh");

var $eDAcM = parcelRequire("eDAcM");

var $38HAG = parcelRequire("38HAG");
"use strict";
const $fc9c9467d3d21e9e$var$tempMatrix = new (0, $5xi4h.Matrix)();
class $fc9c9467d3d21e9e$export$e48941ab3223d0e5 {
    constructor(renderer){
        this._renderer = renderer;
    }
    render({ container: container, transform: transform }) {
        const parent = container.parent;
        const renderGroupParent = container.renderGroup.renderGroupParent;
        container.parent = null;
        container.renderGroup.renderGroupParent = null;
        const renderer = this._renderer;
        const originalLocalTransform = $fc9c9467d3d21e9e$var$tempMatrix;
        if (transform) {
            originalLocalTransform.copyFrom(container.renderGroup.localTransform);
            container.renderGroup.localTransform.copyFrom(transform);
        }
        const renderPipes = renderer.renderPipes;
        this._updateCachedRenderGroups(container.renderGroup, null);
        this._updateRenderGroups(container.renderGroup);
        renderer.globalUniforms.start({
            worldTransformMatrix: transform ? container.renderGroup.localTransform : container.renderGroup.worldTransform,
            worldColor: container.renderGroup.worldColorAlpha
        });
        (0, $7QtNh.executeInstructions)(container.renderGroup, renderPipes);
        if (renderPipes.uniformBatch) renderPipes.uniformBatch.renderEnd();
        if (transform) container.renderGroup.localTransform.copyFrom(originalLocalTransform);
        container.parent = parent;
        container.renderGroup.renderGroupParent = renderGroupParent;
    }
    destroy() {
        this._renderer = null;
    }
    _updateCachedRenderGroups(renderGroup, closestCacheAsTexture) {
        renderGroup._parentCacheAsTextureRenderGroup = closestCacheAsTexture;
        if (renderGroup.isCachedAsTexture) {
            if (!renderGroup.textureNeedsUpdate) return;
            closestCacheAsTexture = renderGroup;
        }
        for(let i = renderGroup.renderGroupChildren.length - 1; i >= 0; i--)this._updateCachedRenderGroups(renderGroup.renderGroupChildren[i], closestCacheAsTexture);
        renderGroup.invalidateMatrices();
        if (renderGroup.isCachedAsTexture) {
            if (renderGroup.textureNeedsUpdate) {
                const bounds = renderGroup.root.getLocalBounds();
                const renderer = this._renderer;
                const resolution = renderGroup.textureOptions.resolution || renderer.view.resolution;
                const antialias = renderGroup.textureOptions.antialias ?? renderer.view.antialias;
                const scaleMode = renderGroup.textureOptions.scaleMode ?? "linear";
                const lastTexture = renderGroup.texture;
                bounds.ceil();
                if (renderGroup.texture) (0, $5NyEC.TexturePool).returnTexture(renderGroup.texture, true);
                const texture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, resolution, antialias);
                texture._source.style = new (0, $c8piJ.TextureStyle)({
                    scaleMode: scaleMode
                });
                renderGroup.texture = texture;
                renderGroup._textureBounds || (renderGroup._textureBounds = new (0, $esrbs.Bounds)());
                renderGroup._textureBounds.copyFrom(bounds);
                if (lastTexture !== renderGroup.texture) {
                    if (renderGroup.renderGroupParent) renderGroup.renderGroupParent.structureDidChange = true;
                }
            }
        } else if (renderGroup.texture) {
            (0, $5NyEC.TexturePool).returnTexture(renderGroup.texture, true);
            renderGroup.texture = null;
        }
    }
    _updateRenderGroups(renderGroup) {
        const renderer = this._renderer;
        const renderPipes = renderer.renderPipes;
        renderGroup.runOnRender(renderer);
        renderGroup.instructionSet.renderPipes = renderPipes;
        if (!renderGroup.structureDidChange) (0, $38HAG.validateRenderables)(renderGroup, renderPipes);
        else (0, $6IFWH.clearList)(renderGroup.childrenRenderablesToUpdate.list, 0);
        (0, $eDAcM.updateRenderGroupTransforms)(renderGroup);
        if (renderGroup.structureDidChange) {
            renderGroup.structureDidChange = false;
            this._buildInstructions(renderGroup, renderer);
        } else this._updateRenderables(renderGroup);
        renderGroup.childrenRenderablesToUpdate.index = 0;
        renderer.renderPipes.batch.upload(renderGroup.instructionSet);
        if (renderGroup.isCachedAsTexture && !renderGroup.textureNeedsUpdate) return;
        for(let i = 0; i < renderGroup.renderGroupChildren.length; i++)this._updateRenderGroups(renderGroup.renderGroupChildren[i]);
    }
    _updateRenderables(renderGroup) {
        const { list: list, index: index } = renderGroup.childrenRenderablesToUpdate;
        for(let i = 0; i < index; i++){
            const container = list[i];
            if (container.didViewUpdate) renderGroup.updateRenderable(container);
        }
        (0, $6IFWH.clearList)(list, index);
    }
    _buildInstructions(renderGroup, rendererOrPipes) {
        const root = renderGroup.root;
        const instructionSet = renderGroup.instructionSet;
        instructionSet.reset();
        const renderer = rendererOrPipes.renderPipes ? rendererOrPipes : rendererOrPipes.batch.renderer;
        const renderPipes = renderer.renderPipes;
        renderPipes.batch.buildStart(instructionSet);
        renderPipes.blendMode.buildStart();
        renderPipes.colorMask.buildStart();
        if (root.sortableChildren) root.sortChildren();
        root.collectRenderablesWithEffects(instructionSet, renderer, null);
        renderPipes.batch.buildEnd(instructionSet);
        renderPipes.blendMode.buildEnd(instructionSet);
    }
}
/** @ignore */ $fc9c9467d3d21e9e$export$e48941ab3223d0e5.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "renderGroup"
};

});
parcelRegister("6IFWH", function(module, exports) {

$parcel$export(module.exports, "clearList", () => $1a743ba992747a28$export$ff1832761d063f24);
"use strict";
function $1a743ba992747a28$export$ff1832761d063f24(list, index) {
    index || (index = 0);
    for(let j = index; j < list.length; j++){
        if (list[j]) list[j] = null;
        else break;
    }
}

});

parcelRegister("eDAcM", function(module, exports) {

$parcel$export(module.exports, "updateRenderGroupTransforms", () => $f71b380b5158a995$export$1c1e67f49974a5b5);
$parcel$export(module.exports, "updateRenderGroupTransform", () => $f71b380b5158a995$export$50ad8695661e3665);
$parcel$export(module.exports, "updateTransformAndChildren", () => $f71b380b5158a995$export$cf7b65c878eb783a);

var $2vcTO = parcelRequire("2vcTO");

var $6IFWH = parcelRequire("6IFWH");

var $25Amh = parcelRequire("25Amh");
"use strict";
const $f71b380b5158a995$var$tempContainer = new (0, $2vcTO.Container)();
const $f71b380b5158a995$var$UPDATE_BLEND_COLOR_VISIBLE = (0, $2vcTO.UPDATE_VISIBLE) | (0, $2vcTO.UPDATE_COLOR) | (0, $2vcTO.UPDATE_BLEND);
function $f71b380b5158a995$export$1c1e67f49974a5b5(renderGroup, updateChildRenderGroups = false) {
    $f71b380b5158a995$export$50ad8695661e3665(renderGroup);
    const childrenToUpdate = renderGroup.childrenToUpdate;
    const updateTick = renderGroup.updateTick++;
    for(const j in childrenToUpdate){
        const renderGroupDepth = Number(j);
        const childrenAtDepth = childrenToUpdate[j];
        const list = childrenAtDepth.list;
        const index = childrenAtDepth.index;
        for(let i = 0; i < index; i++){
            const child = list[i];
            if (child.parentRenderGroup === renderGroup && child.relativeRenderGroupDepth === renderGroupDepth) $f71b380b5158a995$export$cf7b65c878eb783a(child, updateTick, 0);
        }
        (0, $6IFWH.clearList)(list, index);
        childrenAtDepth.index = 0;
    }
    if (updateChildRenderGroups) for(let i = 0; i < renderGroup.renderGroupChildren.length; i++)$f71b380b5158a995$export$1c1e67f49974a5b5(renderGroup.renderGroupChildren[i], updateChildRenderGroups);
}
function $f71b380b5158a995$export$50ad8695661e3665(renderGroup) {
    const root = renderGroup.root;
    let worldAlpha;
    if (renderGroup.renderGroupParent) {
        const renderGroupParent = renderGroup.renderGroupParent;
        renderGroup.worldTransform.appendFrom(root.relativeGroupTransform, renderGroupParent.worldTransform);
        renderGroup.worldColor = (0, $25Amh.multiplyColors)(root.groupColor, renderGroupParent.worldColor);
        worldAlpha = root.groupAlpha * renderGroupParent.worldAlpha;
    } else {
        renderGroup.worldTransform.copyFrom(root.localTransform);
        renderGroup.worldColor = root.localColor;
        worldAlpha = root.localAlpha;
    }
    worldAlpha = worldAlpha < 0 ? 0 : worldAlpha > 1 ? 1 : worldAlpha;
    renderGroup.worldAlpha = worldAlpha;
    renderGroup.worldColorAlpha = renderGroup.worldColor + ((worldAlpha * 255 | 0) << 24);
}
function $f71b380b5158a995$export$cf7b65c878eb783a(container, updateTick, updateFlags) {
    if (updateTick === container.updateTick) return;
    container.updateTick = updateTick;
    container.didChange = false;
    const localTransform = container.localTransform;
    container.updateLocalTransform();
    const parent = container.parent;
    if (parent && !parent.renderGroup) {
        updateFlags |= container._updateFlags;
        container.relativeGroupTransform.appendFrom(localTransform, parent.relativeGroupTransform);
        if (updateFlags & $f71b380b5158a995$var$UPDATE_BLEND_COLOR_VISIBLE) $f71b380b5158a995$var$updateColorBlendVisibility(container, parent, updateFlags);
    } else {
        updateFlags = container._updateFlags;
        container.relativeGroupTransform.copyFrom(localTransform);
        if (updateFlags & $f71b380b5158a995$var$UPDATE_BLEND_COLOR_VISIBLE) $f71b380b5158a995$var$updateColorBlendVisibility(container, $f71b380b5158a995$var$tempContainer, updateFlags);
    }
    if (!container.renderGroup) {
        const children = container.children;
        const length = children.length;
        for(let i = 0; i < length; i++)$f71b380b5158a995$export$cf7b65c878eb783a(children[i], updateTick, updateFlags);
        const renderGroup = container.parentRenderGroup;
        const renderable = container;
        if (renderable.renderPipeId && !renderGroup.structureDidChange) renderGroup.updateRenderable(renderable);
    }
}
function $f71b380b5158a995$var$updateColorBlendVisibility(container, parent, updateFlags) {
    if (updateFlags & (0, $2vcTO.UPDATE_COLOR)) {
        container.groupColor = (0, $25Amh.multiplyColors)(container.localColor, parent.groupColor);
        let groupAlpha = container.localAlpha * parent.groupAlpha;
        groupAlpha = groupAlpha < 0 ? 0 : groupAlpha > 1 ? 1 : groupAlpha;
        container.groupAlpha = groupAlpha;
        container.groupColorAlpha = container.groupColor + ((groupAlpha * 255 | 0) << 24);
    }
    if (updateFlags & (0, $2vcTO.UPDATE_BLEND)) container.groupBlendMode = container.localBlendMode === "inherit" ? parent.groupBlendMode : container.localBlendMode;
    if (updateFlags & (0, $2vcTO.UPDATE_VISIBLE)) container.globalDisplayStatus = container.localDisplayStatus & parent.globalDisplayStatus;
    container._updateFlags = 0;
}

});

parcelRegister("38HAG", function(module, exports) {

$parcel$export(module.exports, "validateRenderables", () => $bae06afb5c06d5f2$export$40044447708e4acc);
"use strict";
function $bae06afb5c06d5f2$export$40044447708e4acc(renderGroup, renderPipes) {
    const { list: list } = renderGroup.childrenRenderablesToUpdate;
    let rebuildRequired = false;
    for(let i = 0; i < renderGroup.childrenRenderablesToUpdate.index; i++){
        const container = list[i];
        const renderable = container;
        const pipe = renderPipes[renderable.renderPipeId];
        rebuildRequired = pipe.validateRenderable(container);
        if (rebuildRequired) break;
    }
    renderGroup.structureDidChange = rebuildRequired;
    return rebuildRequired;
}

});


parcelRegister("2xyZ0", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $ec6caac7a5bbb106$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $ec6caac7a5bbb106$export$5fba6e443d2fb64);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $7UNC6 = parcelRequire("7UNC6");
"use strict";
class $ec6caac7a5bbb106$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $7UNC6.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $ec6caac7a5bbb106$export$918f3e4d2b801859.extension = (0, $aZ9ZN.ExtensionType).Application;
class $ec6caac7a5bbb106$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $7UNC6.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $ec6caac7a5bbb106$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("7UNC6", function(module, exports) {

$parcel$export(module.exports, "DATA_URI", () => $329fd78ea5747db3$export$dbafa72958753fce);
$parcel$export(module.exports, "VERSION", () => $329fd78ea5747db3$export$a4ad2735b021c132);

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $329fd78ea5747db3$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $329fd78ea5747db3$export$a4ad2735b021c132 = "8.16.0";

});


parcelRegister("lNC5O", function(module, exports) {

$parcel$export(module.exports, "ColorMaskPipe", () => $1ff656d408e1f510$export$d4c3af11a9f163be);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $1ff656d408e1f510$export$d4c3af11a9f163be {
    constructor(renderer){
        this._colorStack = [];
        this._colorStackIndex = 0;
        this._currentColor = 0;
        this._renderer = renderer;
    }
    buildStart() {
        this._colorStack[0] = 15;
        this._colorStackIndex = 1;
        this._currentColor = 15;
    }
    push(mask, _container, instructionSet) {
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        const colorStack = this._colorStack;
        colorStack[this._colorStackIndex] = colorStack[this._colorStackIndex - 1] & mask.mask;
        const currentColor = this._colorStack[this._colorStackIndex];
        if (currentColor !== this._currentColor) {
            this._currentColor = currentColor;
            instructionSet.add({
                renderPipeId: "colorMask",
                colorMask: currentColor,
                canBundle: false
            });
        }
        this._colorStackIndex++;
    }
    pop(_mask, _container, instructionSet) {
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        const colorStack = this._colorStack;
        this._colorStackIndex--;
        const currentColor = colorStack[this._colorStackIndex - 1];
        if (currentColor !== this._currentColor) {
            this._currentColor = currentColor;
            instructionSet.add({
                renderPipeId: "colorMask",
                colorMask: currentColor,
                canBundle: false
            });
        }
    }
    execute(instruction) {
        const renderer = this._renderer;
        renderer.colorMask.setMask(instruction.colorMask);
    }
    destroy() {
        this._renderer = null;
        this._colorStack = null;
    }
}
/** @ignore */ $1ff656d408e1f510$export$d4c3af11a9f163be.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "colorMask"
};

});

parcelRegister("yJ7KI", function(module, exports) {

$parcel$export(module.exports, "StencilMaskPipe", () => $41c84886c0e72beb$export$6875bb6e3a32089e);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5Ac7T = parcelRequire("5Ac7T");

var $fYoss = parcelRequire("fYoss");
"use strict";
class $41c84886c0e72beb$export$6875bb6e3a32089e {
    constructor(renderer){
        // used when building and also when executing..
        this._maskStackHash = {};
        this._maskHash = /* @__PURE__ */ new WeakMap();
        this._renderer = renderer;
    }
    push(mask, _container, instructionSet) {
        var _a;
        const effect = mask;
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        renderer.renderPipes.blendMode.setBlendMode(effect.mask, "none", instructionSet);
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "pushMaskBegin",
            mask: mask,
            inverse: _container._maskOptions.inverse,
            canBundle: false
        });
        const maskContainer = effect.mask;
        maskContainer.includeInBuild = true;
        if (!this._maskHash.has(effect)) this._maskHash.set(effect, {
            instructionsStart: 0,
            instructionsLength: 0
        });
        const maskData = this._maskHash.get(effect);
        maskData.instructionsStart = instructionSet.instructionSize;
        maskContainer.collectRenderables(instructionSet, renderer, null);
        maskContainer.includeInBuild = false;
        renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "pushMaskEnd",
            mask: mask,
            inverse: _container._maskOptions.inverse,
            canBundle: false
        });
        const instructionsLength = instructionSet.instructionSize - maskData.instructionsStart - 1;
        maskData.instructionsLength = instructionsLength;
        const renderTargetUid = renderer.renderTarget.renderTarget.uid;
        (_a = this._maskStackHash)[renderTargetUid] ?? (_a[renderTargetUid] = 0);
    }
    pop(mask, _container, instructionSet) {
        const effect = mask;
        const renderer = this._renderer;
        renderer.renderPipes.batch.break(instructionSet);
        renderer.renderPipes.blendMode.setBlendMode(effect.mask, "none", instructionSet);
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "popMaskBegin",
            inverse: _container._maskOptions.inverse,
            canBundle: false
        });
        const maskData = this._maskHash.get(mask);
        for(let i = 0; i < maskData.instructionsLength; i++)instructionSet.instructions[instructionSet.instructionSize++] = instructionSet.instructions[maskData.instructionsStart++];
        instructionSet.add({
            renderPipeId: "stencilMask",
            action: "popMaskEnd",
            canBundle: false
        });
    }
    execute(instruction) {
        var _a;
        const renderer = this._renderer;
        const gpuRenderer = renderer;
        const renderTargetUid = renderer.renderTarget.renderTarget.uid;
        let maskStackIndex = (_a = this._maskStackHash)[renderTargetUid] ?? (_a[renderTargetUid] = 0);
        if (instruction.action === "pushMaskBegin") {
            gpuRenderer.renderTarget.ensureDepthStencil();
            gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).RENDERING_MASK_ADD, maskStackIndex);
            maskStackIndex++;
            gpuRenderer.colorMask.setMask(0);
        } else if (instruction.action === "pushMaskEnd") {
            if (instruction.inverse) gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).INVERSE_MASK_ACTIVE, maskStackIndex);
            else gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).MASK_ACTIVE, maskStackIndex);
            gpuRenderer.colorMask.setMask(15);
        } else if (instruction.action === "popMaskBegin") {
            gpuRenderer.colorMask.setMask(0);
            if (maskStackIndex !== 0) gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).RENDERING_MASK_REMOVE, maskStackIndex);
            else {
                gpuRenderer.renderTarget.clear(null, (0, $5Ac7T.CLEAR).STENCIL);
                gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).DISABLED, maskStackIndex);
            }
            maskStackIndex--;
        } else if (instruction.action === "popMaskEnd") {
            if (instruction.inverse) gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).INVERSE_MASK_ACTIVE, maskStackIndex);
            else gpuRenderer.stencil.setStencilMode((0, $fYoss.STENCIL_MODES).MASK_ACTIVE, maskStackIndex);
            gpuRenderer.colorMask.setMask(15);
        }
        this._maskStackHash[renderTargetUid] = maskStackIndex;
    }
    destroy() {
        this._renderer = null;
        this._maskStackHash = null;
        this._maskHash = null;
    }
}
$41c84886c0e72beb$export$6875bb6e3a32089e.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "stencilMask"
};

});

parcelRegister("9UEzW", function(module, exports) {

$parcel$export(module.exports, "BackgroundSystem", () => $2767ca90f028d9fc$export$c69cd65c8827ac23);

var $dKHyW = parcelRequire("dKHyW");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
const $2767ca90f028d9fc$var$_BackgroundSystem = class _BackgroundSystem {
    constructor(){
        this.clearBeforeRender = true;
        this._backgroundColor = new (0, $dKHyW.Color)(0);
        this.color = this._backgroundColor;
        this.alpha = 1;
    }
    /**
   * initiates the background system
   * @param options - the options for the background colors
   */ init(options) {
        options = {
            ..._BackgroundSystem.defaultOptions,
            ...options
        };
        this.clearBeforeRender = options.clearBeforeRender;
        this.color = options.background || options.backgroundColor || this._backgroundColor;
        this.alpha = options.backgroundAlpha;
        this._backgroundColor.setAlpha(options.backgroundAlpha);
    }
    /** The background color to fill if not transparent */ get color() {
        return this._backgroundColor;
    }
    set color(value) {
        const incoming = (0, $dKHyW.Color).shared.setValue(value);
        if (incoming.alpha < 1 && this._backgroundColor.alpha === 1) (0, $1RpxL.warn)("Cannot set a transparent background on an opaque canvas. To enable transparency, set backgroundAlpha < 1 when initializing your Application.");
        this._backgroundColor.setValue(value);
    }
    /** The background color alpha. Setting this to 0 will make the canvas transparent. */ get alpha() {
        return this._backgroundColor.alpha;
    }
    set alpha(value) {
        this._backgroundColor.setAlpha(value);
    }
    /** The background color as an [R, G, B, A] array. */ get colorRgba() {
        return this._backgroundColor.toArray();
    }
    /**
   * destroys the background system
   * @internal
   */ destroy() {}
};
/** @ignore */ $2767ca90f028d9fc$var$_BackgroundSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "background",
    priority: 0
};
/** default options used by the system */ $2767ca90f028d9fc$var$_BackgroundSystem.defaultOptions = {
    /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */ backgroundAlpha: 1,
    /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */ backgroundColor: 0,
    /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */ clearBeforeRender: true
};
let $2767ca90f028d9fc$export$c69cd65c8827ac23 = $2767ca90f028d9fc$var$_BackgroundSystem;

});

parcelRegister("57WMt", function(module, exports) {

$parcel$export(module.exports, "ExtractSystem", () => $3ed9dd88cd214e74$export$14c75b573db98096);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2vcTO = parcelRequire("2vcTO");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $3ed9dd88cd214e74$var$imageTypes = {
    png: "image/png",
    jpg: "image/jpeg",
    webp: "image/webp"
};
const $3ed9dd88cd214e74$var$_ExtractSystem = class _ExtractSystem {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this._renderer = renderer;
    }
    _normalizeOptions(options, defaults = {}) {
        if (options instanceof (0, $2vcTO.Container) || options instanceof (0, $4iNSL.Texture)) return {
            target: options,
            ...defaults
        };
        return {
            ...defaults,
            ...options
        };
    }
    /**
   * Creates an IImage from a display object or texture.
   * @param options - Options for creating the image, or the target to extract
   * @returns Promise that resolves with the generated IImage
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const image = await renderer.extract.image(sprite);
   * document.body.appendChild(image);
   *
   * // Advanced usage with options
   * const image = await renderer.extract.image({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2,
   *     clearColor: '#ff0000',
   *     antialias: true
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const image = await renderer.extract.image(texture);
   * ```
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.base64} For base64 string output
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ImageLike} For the image interface
   * @category rendering
   */ async image(options) {
        const image = (0, $gLw46.DOMAdapter).get().createImage();
        image.src = await this.base64(options);
        return image;
    }
    /**
   * Converts the target into a base64 encoded string.
   *
   * This method works by first creating
   * a canvas using `Extract.canvas` and then converting it to a base64 string.
   * @param options - The options for creating the base64 string, or the target to extract
   * @returns Promise that resolves with the base64 encoded string
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const base64 = await renderer.extract.base64(sprite);
   * console.log(base64); // data:image/png;base64,...
   *
   * // Advanced usage with options
   * const base64 = await renderer.extract.base64({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2
   * });
   * ```
   * @throws Will throw an error if the platform doesn't support any of:
   * - ICanvas.toDataURL
   * - ICanvas.toBlob
   * - ICanvas.convertToBlob
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @category rendering
   */ async base64(options) {
        options = this._normalizeOptions(options, _ExtractSystem.defaultImageOptions);
        const { format: format, quality: quality } = options;
        const canvas = this.canvas(options);
        if (canvas.toBlob !== void 0) return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject(new Error("ICanvas.toBlob failed!"));
                    return;
                }
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }, $3ed9dd88cd214e74$var$imageTypes[format], quality);
        });
        if (canvas.toDataURL !== void 0) return canvas.toDataURL($3ed9dd88cd214e74$var$imageTypes[format], quality);
        if (canvas.convertToBlob !== void 0) {
            const blob = await canvas.convertToBlob({
                type: $3ed9dd88cd214e74$var$imageTypes[format],
                quality: quality
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        }
        throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
    }
    /**
   * Creates a Canvas element, renders the target to it and returns it.
   * This method is useful for creating static images or when you need direct canvas access.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns A Canvas element with the texture rendered on
   * @example
   * ```ts
   * // Basic canvas extraction from a sprite
   * const sprite = new Sprite(texture);
   * const canvas = renderer.extract.canvas(sprite);
   * document.body.appendChild(canvas);
   *
   * // Extract with custom region
   * const canvas = renderer.extract.canvas({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const canvas = renderer.extract.canvas({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const canvas = renderer.extract.canvas(texture);
   *
   * // Extract with anti-aliasing
   * const canvas = renderer.extract.canvas({
   *     target: graphics,
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   */ canvas(options) {
        options = this._normalizeOptions(options);
        const target = options.target;
        const renderer = this._renderer;
        if (target instanceof (0, $4iNSL.Texture)) return renderer.texture.generateCanvas(target);
        const texture = renderer.textureGenerator.generateTexture(options);
        const canvas = renderer.texture.generateCanvas(texture);
        texture.destroy(true);
        return canvas;
    }
    /**
   * Returns a one-dimensional array containing the pixel data of the entire texture in RGBA order,
   * with integer values between 0 and 255 (inclusive).
   * > [!NOE] The returned array is a flat Uint8Array where every 4 values represent RGBA
   * @param options - The options for extracting the image, or the target to extract
   * @returns One-dimensional Uint8Array containing the pixel data in RGBA format
   * @example
   * ```ts
   * // Basic pixel extraction
   * const sprite = new Sprite(texture);
   * const pixels = renderer.extract.pixels(sprite);
   * console.log(pixels[0], pixels[1], pixels[2], pixels[3]); // R,G,B,A values
   *
   * // Extract with custom region
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     resolution: 2
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For image output
   * @category rendering
   */ pixels(options) {
        options = this._normalizeOptions(options);
        const target = options.target;
        const renderer = this._renderer;
        const texture = target instanceof (0, $4iNSL.Texture) ? target : renderer.textureGenerator.generateTexture(options);
        const pixelInfo = renderer.texture.getPixels(texture);
        if (target instanceof (0, $2vcTO.Container)) texture.destroy(true);
        return pixelInfo;
    }
    /**
   * Creates a texture from a display object or existing texture.
   *
   * This is useful for creating
   * reusable textures from rendered content or making copies of existing textures.
   * > [!NOTE] The returned texture should be destroyed when no longer needed
   * @param options - The options for creating the texture, or the target to extract
   * @returns A new texture containing the extracted content
   * @example
   * ```ts
   * // Basic texture extraction from a sprite
   * const sprite = new Sprite(texture);
   * const extractedTexture = renderer.extract.texture(sprite);
   *
   * // Extract with custom region
   * const regionTexture = renderer.extract.texture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const hiResTexture = renderer.extract.texture({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Create a new sprite from extracted texture
   * const newSprite = new Sprite(
   *     renderer.extract.texture({
   *         target: graphics,
   *         antialias: true
   *     })
   * );
   *
   * // Clean up when done
   * extractedTexture.destroy(true);
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link Texture} For texture management
   * @see {@link GenerateTextureSystem} For texture generation
   * @category rendering
   */ texture(options) {
        options = this._normalizeOptions(options);
        if (options.target instanceof (0, $4iNSL.Texture)) return options.target;
        return this._renderer.textureGenerator.generateTexture(options);
    }
    /**
   * Extracts and downloads content from the renderer as an image file.
   * This is a convenient way to save screenshots or export rendered content.
   * > [!NOTE] The download will use PNG format regardless of the filename extension
   * @param options - The options for downloading and extracting the image, or the target to extract
   * @example
   * ```ts
   * // Basic download with default filename
   * const sprite = new Sprite(texture);
   * renderer.extract.download(sprite); // Downloads as 'image.png'
   *
   * // Download with custom filename
   * renderer.extract.download({
   *     target: sprite,
   *     filename: 'screenshot.png'
   * });
   *
   * // Download with custom region
   * renderer.extract.download({
   *     target: container,
   *     filename: 'region.png',
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Download with high resolution and background
   * renderer.extract.download({
   *     target: stage,
   *     filename: 'hd-screenshot.png',
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Download with anti-aliasing
   * renderer.extract.download({
   *     target: graphics,
   *     filename: 'smooth.png',
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractDownloadOptions} For detailed options
   * @see {@link ExtractSystem.image} For creating images without download
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */ download(options) {
        options = this._normalizeOptions(options);
        const canvas = this.canvas(options);
        const link = document.createElement("a");
        link.download = options.filename ?? "image.png";
        link.href = canvas.toDataURL("image/png");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * The image will be displayed in the browser's console using CSS background images.
   * @param options - The options for logging the image, or the target to log
   * @param options.width - The width of the logged image preview in the console (in pixels)
   * @example
   * ```ts
   * // Basic usage
   * const sprite = new Sprite(texture);
   * renderer.extract.log(sprite);
   * ```
   * @see {@link ExtractSystem.canvas} For getting raw canvas output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   * @advanced
   */ log(options) {
        const width = options.width ?? 200;
        options = this._normalizeOptions(options);
        const canvas = this.canvas(options);
        const base64 = canvas.toDataURL();
        console.log(`[Pixi Texture] ${canvas.width}px ${canvas.height}px`);
        const style = [
            "font-size: 1px;",
            `padding: ${width}px ${300}px;`,
            `background: url(${base64}) no-repeat;`,
            "background-size: contain;"
        ].join(" ");
        console.log("%c ", style);
    }
    destroy() {
        this._renderer = null;
    }
};
/** @ignore */ $3ed9dd88cd214e74$var$_ExtractSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "extract"
};
/**
 * Default options for image extraction.
 * @example
 * ```ts
 * // Customize default options
 * ExtractSystem.defaultImageOptions.format = 'webp';
 * ExtractSystem.defaultImageOptions.quality = 0.8;
 *
 * // Use defaults
 * const image = await renderer.extract.image(sprite);
 * ```
 */ $3ed9dd88cd214e74$var$_ExtractSystem.defaultImageOptions = {
    format: "png",
    quality: 1
};
let $3ed9dd88cd214e74$export$14c75b573db98096 = $3ed9dd88cd214e74$var$_ExtractSystem;

});

parcelRegister("7fOUA", function(module, exports) {

$parcel$export(module.exports, "GenerateTextureSystem", () => $9a24fd613bd33b81$export$690776504ee197a6);

var $dKHyW = parcelRequire("dKHyW");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");

var $esrbs = parcelRequire("esrbs");

var $7pBMy = parcelRequire("7pBMy");

var $2vcTO = parcelRequire("2vcTO");

var $jH853 = parcelRequire("jH853");
"use strict";
const $9a24fd613bd33b81$var$tempRect = new (0, $ar2Ly.Rectangle)();
const $9a24fd613bd33b81$var$tempBounds = new (0, $esrbs.Bounds)();
const $9a24fd613bd33b81$var$noColor = [
    0,
    0,
    0,
    0
];
class $9a24fd613bd33b81$export$690776504ee197a6 {
    constructor(renderer){
        this._renderer = renderer;
    }
    /**
   * Creates a texture from a display object that can be used for creating sprites and other textures.
   * This is particularly useful for optimizing performance when a complex container needs to be reused.
   * @param options - Generate texture options or a container to convert to texture
   * @returns A new RenderTexture containing the rendered display object
   * @example
   * ```ts
   * // Basic usage with a container
   * const container = new Container();
   * container.addChild(
   *     new Graphics()
   *         .circle(0, 0, 50)
   *         .fill('red')
   * );
   *
   * const texture = renderer.textureGenerator.generateTexture(container);
   *
   * // Advanced usage with options
   * const texture = renderer.textureGenerator.generateTexture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100), // Specific region
   *     resolution: 2,                        // High DPI
   *     clearColor: '#ff0000',               // Red background
   *     antialias: true                      // Smooth edges
   * });
   *
   * // Create a sprite from the generated texture
   * const sprite = new Sprite(texture);
   *
   * // Clean up when done
   * texture.destroy(true);
   * ```
   * @see {@link GenerateTextureOptions} For detailed texture generation options
   * @see {@link RenderTexture} For the type of texture created
   * @category rendering
   */ generateTexture(options) {
        if (options instanceof (0, $2vcTO.Container)) options = {
            target: options,
            frame: void 0,
            textureSourceOptions: {},
            resolution: void 0
        };
        const resolution = options.resolution || this._renderer.resolution;
        const antialias = options.antialias || this._renderer.view.antialias;
        const container = options.target;
        let clearColor = options.clearColor;
        if (clearColor) {
            const isRGBAArray = Array.isArray(clearColor) && clearColor.length === 4;
            clearColor = isRGBAArray ? clearColor : (0, $dKHyW.Color).shared.setValue(clearColor).toArray();
        } else clearColor = $9a24fd613bd33b81$var$noColor;
        const region = options.frame?.copyTo($9a24fd613bd33b81$var$tempRect) || (0, $7pBMy.getLocalBounds)(container, $9a24fd613bd33b81$var$tempBounds).rectangle;
        region.width = Math.max(region.width, 1 / resolution) | 0;
        region.height = Math.max(region.height, 1 / resolution) | 0;
        const target = (0, $jH853.RenderTexture).create({
            ...options.textureSourceOptions,
            width: region.width,
            height: region.height,
            resolution: resolution,
            antialias: antialias
        });
        const transform = (0, $5xi4h.Matrix).shared.translate(-region.x, -region.y);
        this._renderer.render({
            container: container,
            transform: transform,
            target: target,
            clearColor: clearColor
        });
        target.source.updateMipmaps();
        return target;
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $9a24fd613bd33b81$export$690776504ee197a6.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "textureGenerator"
};

});
parcelRegister("jH853", function(module, exports) {

$parcel$export(module.exports, "RenderTexture", () => $54b8283f19cfaa80$export$813984f7330b4d72);

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
class $54b8283f19cfaa80$export$813984f7330b4d72 extends (0, $4iNSL.Texture) {
    /**
   * Creates a RenderTexture. Pass `dynamic: true` in options to allow resizing after creation.
   * @param options - Options for the RenderTexture, including width, height, and dynamic.
   * @returns A new RenderTexture instance.
   * @example
   * const rt = RenderTexture.create({ width: 100, height: 100, dynamic: true });
   * rt.resize(500, 500);
   */ static create(options) {
        const { dynamic: dynamic, ...rest } = options;
        return new $54b8283f19cfaa80$export$813984f7330b4d72({
            source: new (0, $gmQ4R.TextureSource)(rest),
            dynamic: dynamic ?? false
        });
    }
    /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */ resize(width, height, resolution) {
        this.source.resize(width, height, resolution);
        return this;
    }
}

});


parcelRegister("7bRdE", function(module, exports) {

$parcel$export(module.exports, "GCSystem", () => $9eb45a731bab5d4b$export$1196ef58beb9548e);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2H4Cq = parcelRequire("2H4Cq");
"use strict";
const $9eb45a731bab5d4b$var$_GCSystem = class _GCSystem {
    /**
   * Creates a new GCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */ constructor(renderer){
        /** Array of resources being tracked for garbage collection */ this._managedResources = [];
        this._managedResourceHashes = [];
        this._managedCollections = [];
        this._ready = false;
        this._renderer = renderer;
    }
    /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options
   */ init(options) {
        options = {
            ..._GCSystem.defaultOptions,
            ...options
        };
        this.maxUnusedTime = options.gcMaxUnusedTime;
        this._frequency = options.gcFrequency;
        this.enabled = options.gcActive;
        this.now = performance.now();
    }
    /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */ get enabled() {
        return !!this._handler;
    }
    /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */ set enabled(value) {
        if (this.enabled === value) return;
        if (value) {
            this._handler = this._renderer.scheduler.repeat(()=>{
                this._ready = true;
            }, this._frequency, false);
            this._collectionsHandler = this._renderer.scheduler.repeat(()=>{
                for (const hash of this._managedCollections){
                    const { context: context, collection: collection, type: type } = hash;
                    if (type === "hash") context[collection] = (0, $2H4Cq.cleanHash)(context[collection]);
                    else context[collection] = (0, $2H4Cq.cleanArray)(context[collection]);
                }
            }, this._frequency);
        } else {
            this._renderer.scheduler.cancel(this._handler);
            this._renderer.scheduler.cancel(this._collectionsHandler);
            this._handler = 0;
            this._collectionsHandler = 0;
        }
    }
    /**
   * Called before rendering. Updates the current timestamp.
   * @param options - The render options
   * @param options.container - The container to render
   */ prerender({ container: container }) {
        this.now = performance.now();
        container.renderGroup.gcTick = this._renderer.tick++;
        this._updateInstructionGCTick(container.renderGroup, container.renderGroup.gcTick);
    }
    /** Performs garbage collection after rendering. */ postrender() {
        if (!this._ready || !this.enabled) return;
        this.run();
        this._ready = false;
    }
    /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */ _updateInstructionGCTick(renderGroup, gcTick) {
        renderGroup.instructionSet.gcTick = gcTick;
        renderGroup.gcTick = gcTick;
        for (const child of renderGroup.renderGroupChildren)this._updateInstructionGCTick(child, gcTick);
    }
    /**
   * Registers a collection for garbage collection tracking.
   * @param context - The object containing the collection
   * @param collection - The property name on context that holds the collection
   * @param type - The type of collection to track ('hash' or 'array')
   */ addCollection(context, collection, type) {
        this._managedCollections.push({
            context: context,
            collection: collection,
            type: type
        });
    }
    /**
   * Registers a resource for garbage collection tracking.
   * @param resource - The resource to track
   * @param type - The type of resource to track
   */ addResource(resource, type) {
        if (resource._gcLastUsed !== -1) {
            resource._gcLastUsed = this.now;
            resource._onTouch?.(this.now);
            return;
        }
        const index = this._managedResources.length;
        resource._gcData = {
            index: index,
            type: type
        };
        resource._gcLastUsed = this.now;
        resource._onTouch?.(this.now);
        resource.once("unload", this.removeResource, this);
        this._managedResources.push(resource);
    }
    /**
   * Removes a resource from garbage collection tracking.
   * Call this when manually destroying a resource.
   * @param resource - The resource to stop tracking
   */ removeResource(resource) {
        const gcData = resource._gcData;
        if (!gcData) return;
        const index = gcData.index;
        const last = this._managedResources.length - 1;
        if (index !== last) {
            const lastResource = this._managedResources[last];
            this._managedResources[index] = lastResource;
            lastResource._gcData.index = index;
        }
        this._managedResources.length--;
        resource._gcData = null;
        resource._gcLastUsed = -1;
    }
    /**
   * Registers a hash-based resource collection for garbage collection tracking.
   * Resources in the hash will be automatically tracked and cleaned up when unused.
   * @param context - The object containing the hash property
   * @param hash - The property name on context that holds the resource hash
   * @param type - The type of resources in the hash ('resource' or 'renderable')
   * @param priority - Processing priority (lower values are processed first)
   */ addResourceHash(context, hash, type, priority = 0) {
        this._managedResourceHashes.push({
            context: context,
            hash: hash,
            type: type,
            priority: priority
        });
        this._managedResourceHashes.sort((a, b)=>a.priority - b.priority);
    }
    /**
   * Performs garbage collection by cleaning up unused resources.
   * Removes resources that haven't been used for longer than maxUnusedTime.
   */ run() {
        const now = performance.now();
        const managedResourceHashes = this._managedResourceHashes;
        for (const hashEntry of managedResourceHashes)this.runOnHash(hashEntry, now);
        let writeIndex = 0;
        for(let i = 0; i < this._managedResources.length; i++){
            const resource = this._managedResources[i];
            writeIndex = this.runOnResource(resource, now, writeIndex);
        }
        this._managedResources.length = writeIndex;
    }
    updateRenderableGCTick(renderable, now) {
        const renderGroup = renderable.renderGroup ?? renderable.parentRenderGroup;
        const currentTick = renderGroup?.instructionSet?.gcTick ?? -1;
        if ((renderGroup?.gcTick ?? 0) === currentTick) {
            renderable._gcLastUsed = now;
            renderable._onTouch?.(now);
        }
    }
    runOnResource(resource, now, writeIndex) {
        const gcData = resource._gcData;
        if (gcData.type === "renderable") this.updateRenderableGCTick(resource, now);
        const isRecentlyUsed = now - resource._gcLastUsed < this.maxUnusedTime;
        if (isRecentlyUsed || !resource.autoGarbageCollect) {
            this._managedResources[writeIndex] = resource;
            gcData.index = writeIndex;
            writeIndex++;
        } else {
            resource.unload();
            resource._gcData = null;
            resource._gcLastUsed = -1;
            resource.off("unload", this.removeResource, this);
        }
        return writeIndex;
    }
    /**
   * Creates a clone of the hash, copying all non-null entries up to (but not including) the stop key.
   * @param hashValue - The original hash to clone from
   * @param stopKey - The key to stop at (exclusive)
   * @returns A new hash object with copied entries
   */ _createHashClone(hashValue, stopKey) {
        const hashClone = /* @__PURE__ */ Object.create(null);
        for(const k in hashValue){
            if (k === stopKey) break;
            if (hashValue[k] !== null) hashClone[k] = hashValue[k];
        }
        return hashClone;
    }
    runOnHash(hashEntry, now) {
        const { context: context, hash: hash, type: type } = hashEntry;
        const hashValue = context[hash];
        let hashClone = null;
        let nullCount = 0;
        for(const key in hashValue){
            const resource = hashValue[key];
            if (resource === null) {
                nullCount++;
                if (nullCount === 1e4 && !hashClone) hashClone = this._createHashClone(hashValue, key);
                continue;
            }
            if (resource._gcLastUsed === -1) {
                resource._gcLastUsed = now;
                resource._onTouch?.(now);
                if (hashClone) hashClone[key] = resource;
                continue;
            }
            if (type === "renderable") this.updateRenderableGCTick(resource, now);
            const isRecentlyUsed = now - resource._gcLastUsed < this.maxUnusedTime;
            if (!isRecentlyUsed && resource.autoGarbageCollect) {
                if (!hashClone) {
                    if (nullCount + 1 !== 1e4) {
                        hashValue[key] = null;
                        nullCount++;
                    } else hashClone = this._createHashClone(hashValue, key);
                }
                if (type === "renderable") {
                    const res = resource;
                    const renderGroup = res.renderGroup ?? res.parentRenderGroup;
                    if (renderGroup) renderGroup.structureDidChange = true;
                }
                resource.unload();
                resource._gcData = null;
                resource._gcLastUsed = -1;
            } else if (hashClone) hashClone[key] = resource;
        }
        if (hashClone) context[hash] = hashClone;
    }
    /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */ destroy() {
        this.enabled = false;
        this._managedResources.forEach((resource)=>{
            resource.off("unload", this.removeResource, this);
        });
        this._managedResources.length = 0;
        this._managedResourceHashes.length = 0;
        this._managedCollections.length = 0;
        this._renderer = null;
    }
};
/** @ignore */ $9eb45a731bab5d4b$var$_GCSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "gc",
    priority: 0
};
/** Default options for the GCSystem */ $9eb45a731bab5d4b$var$_GCSystem.defaultOptions = {
    /** Enable/disable the garbage collector */ gcActive: true,
    /** Time in ms before an unused resource is collected (default 1 minute) */ gcMaxUnusedTime: 6e4,
    /** How often to run garbage collection in ms (default 30 seconds) */ gcFrequency: 3e4
};
let $9eb45a731bab5d4b$export$1196ef58beb9548e = $9eb45a731bab5d4b$var$_GCSystem;

});
parcelRegister("2H4Cq", function(module, exports) {

$parcel$export(module.exports, "cleanHash", () => $e9357f38ab142542$export$e315d661f2bb796);
$parcel$export(module.exports, "cleanArray", () => $e9357f38ab142542$export$c39b210f955bc1b8);
"use strict";
function $e9357f38ab142542$export$e315d661f2bb796(hash) {
    let clean = false;
    for(const i in hash)if (hash[i] == void 0) {
        clean = true;
        break;
    }
    if (!clean) return hash;
    const cleanHash2 = /* @__PURE__ */ Object.create(null);
    for(const i in hash){
        const value = hash[i];
        if (value) cleanHash2[i] = value;
    }
    return cleanHash2;
}
function $e9357f38ab142542$export$c39b210f955bc1b8(arr) {
    let offset = 0;
    for(let i = 0; i < arr.length; i++)if (arr[i] == void 0) offset++;
    else arr[i - offset] = arr[i];
    arr.length -= offset;
    return arr;
}

});


parcelRegister("cVsmc", function(module, exports) {

$parcel$export(module.exports, "GlobalUniformSystem", () => $86447f841d241cb7$export$b9b6391a4528dd78);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $ds7Xo = parcelRequire("ds7Xo");

var $id0ju = parcelRequire("id0ju");

var $eK2sB = parcelRequire("eK2sB");

var $bfcaK = parcelRequire("bfcaK");

var $aUxJK = parcelRequire("aUxJK");
"use strict";
class $86447f841d241cb7$export$b9b6391a4528dd78 {
    constructor(renderer){
        this._stackIndex = 0;
        this._globalUniformDataStack = [];
        this._uniformsPool = [];
        this._activeUniforms = [];
        this._bindGroupPool = [];
        this._activeBindGroups = [];
        this._renderer = renderer;
    }
    reset() {
        this._stackIndex = 0;
        for(let i = 0; i < this._activeUniforms.length; i++)this._uniformsPool.push(this._activeUniforms[i]);
        for(let i = 0; i < this._activeBindGroups.length; i++)this._bindGroupPool.push(this._activeBindGroups[i]);
        this._activeUniforms.length = 0;
        this._activeBindGroups.length = 0;
    }
    start(options) {
        this.reset();
        this.push(options);
    }
    bind({ size: size, projectionMatrix: projectionMatrix, worldTransformMatrix: worldTransformMatrix, worldColor: worldColor, offset: offset }) {
        const renderTarget = this._renderer.renderTarget.renderTarget;
        const currentGlobalUniformData = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
            projectionData: renderTarget,
            worldTransformMatrix: new (0, $5xi4h.Matrix)(),
            worldColor: 4294967295,
            offset: new (0, $ds7Xo.Point)()
        };
        const globalUniformData = {
            projectionMatrix: projectionMatrix || this._renderer.renderTarget.projectionMatrix,
            resolution: size || renderTarget.size,
            worldTransformMatrix: worldTransformMatrix || currentGlobalUniformData.worldTransformMatrix,
            worldColor: worldColor || currentGlobalUniformData.worldColor,
            offset: offset || currentGlobalUniformData.offset,
            bindGroup: null
        };
        const uniformGroup = this._uniformsPool.pop() || this._createUniforms();
        this._activeUniforms.push(uniformGroup);
        const uniforms = uniformGroup.uniforms;
        uniforms.uProjectionMatrix = globalUniformData.projectionMatrix;
        uniforms.uResolution = globalUniformData.resolution;
        uniforms.uWorldTransformMatrix.copyFrom(globalUniformData.worldTransformMatrix);
        uniforms.uWorldTransformMatrix.tx -= globalUniformData.offset.x;
        uniforms.uWorldTransformMatrix.ty -= globalUniformData.offset.y;
        (0, $id0ju.color32BitToUniform)(globalUniformData.worldColor, uniforms.uWorldColorAlpha, 0);
        uniformGroup.update();
        let bindGroup;
        if (this._renderer.renderPipes.uniformBatch) bindGroup = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(uniformGroup, false);
        else {
            bindGroup = this._bindGroupPool.pop() || new (0, $eK2sB.BindGroup)();
            this._activeBindGroups.push(bindGroup);
            bindGroup.setResource(uniformGroup, 0);
        }
        globalUniformData.bindGroup = bindGroup;
        this._currentGlobalUniformData = globalUniformData;
    }
    push(options) {
        this.bind(options);
        this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
    }
    pop() {
        this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1];
        if (this._renderer.type === (0, $bfcaK.RendererType).WEBGL) this._currentGlobalUniformData.bindGroup.resources[0].update();
    }
    get bindGroup() {
        return this._currentGlobalUniformData.bindGroup;
    }
    get globalUniformData() {
        return this._currentGlobalUniformData;
    }
    get uniformGroup() {
        return this._currentGlobalUniformData.bindGroup.resources[0];
    }
    _createUniforms() {
        const globalUniforms = new (0, $aUxJK.UniformGroup)({
            uProjectionMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uWorldTransformMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
            uWorldColorAlpha: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uResolution: {
                value: [
                    0,
                    0
                ],
                type: "vec2<f32>"
            }
        }, {
            isStatic: true
        });
        return globalUniforms;
    }
    destroy() {
        this._renderer = null;
        this._globalUniformDataStack.length = 0;
        this._uniformsPool.length = 0;
        this._activeUniforms.length = 0;
        this._bindGroupPool.length = 0;
        this._activeBindGroups.length = 0;
        this._currentGlobalUniformData = null;
    }
}
/** @ignore */ $86447f841d241cb7$export$b9b6391a4528dd78.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "globalUniforms"
};

});

parcelRegister("iifuN", function(module, exports) {

$parcel$export(module.exports, "SchedulerSystem", () => $6146041bd0649357$export$b11154c55e5f16dd);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jM8Go = parcelRequire("jM8Go");
"use strict";
let $6146041bd0649357$var$uid = 1;
class $6146041bd0649357$export$b11154c55e5f16dd {
    constructor(){
        this._tasks = [];
        /** a small off set to apply to the repeat schedules. This is just to make sure they run at slightly different times */ this._offset = 0;
    }
    /** Initializes the scheduler system and starts the ticker. */ init() {
        (0, $jM8Go.Ticker).system.add(this._update, this);
    }
    /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */ repeat(func, duration, useOffset = true) {
        const id = $6146041bd0649357$var$uid++;
        let offset = 0;
        if (useOffset) {
            this._offset += 1e3;
            offset = this._offset;
        }
        this._tasks.push({
            func: func,
            duration: duration,
            start: performance.now(),
            offset: offset,
            last: performance.now(),
            repeat: true,
            id: id
        });
        return id;
    }
    /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */ cancel(id) {
        for(let i = 0; i < this._tasks.length; i++)if (this._tasks[i].id === id) {
            this._tasks.splice(i, 1);
            return;
        }
    }
    /**
   * Updates and executes the scheduled tasks.
   * @private
   */ _update() {
        const now = performance.now();
        for(let i = 0; i < this._tasks.length; i++){
            const task = this._tasks[i];
            if (now - task.offset - task.last >= task.duration) {
                const elapsed = now - task.start;
                task.func(elapsed);
                task.last = now;
            }
        }
    }
    /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   */ destroy() {
        (0, $jM8Go.Ticker).system.remove(this._update, this);
        this._tasks.length = 0;
    }
}
/** @ignore */ $6146041bd0649357$export$b11154c55e5f16dd.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "scheduler",
    priority: 0
};

});

parcelRegister("eHpUP", function(module, exports) {

$parcel$export(module.exports, "HelloSystem", () => $79dfbc7c86ab7704$export$63ce3e62fccb6f39);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $kbFTd = parcelRequire("kbFTd");

var $bfcaK = parcelRequire("bfcaK");
"use strict";
class $79dfbc7c86ab7704$export$63ce3e62fccb6f39 {
    constructor(renderer){
        this._renderer = renderer;
    }
    /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */ init(options) {
        if (options.hello) {
            let name = this._renderer.name;
            if (this._renderer.type === (0, $bfcaK.RendererType).WEBGL) name += ` ${this._renderer.context.webGLVersion}`;
            (0, $kbFTd.sayHello)(name);
        }
    }
}
/** @ignore */ $79dfbc7c86ab7704$export$63ce3e62fccb6f39.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "hello",
    priority: -2
};
/** The default options for the system. */ $79dfbc7c86ab7704$export$63ce3e62fccb6f39.defaultOptions = {
    /** {@link WebGLOptions.hello} */ hello: false
};

});
parcelRegister("kbFTd", function(module, exports) {

$parcel$export(module.exports, "sayHello", () => $a40d0f8a4ce3961e$export$2c6a96c059a06e7c);

var $gLw46 = parcelRequire("gLw46");

var $7UNC6 = parcelRequire("7UNC6");
"use strict";
let $a40d0f8a4ce3961e$var$saidHello = false;
function $a40d0f8a4ce3961e$export$2c6a96c059a06e7c(type) {
    if ($a40d0f8a4ce3961e$var$saidHello) return;
    if ((0, $gLw46.DOMAdapter).get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
        const args = [
            `%c  %c  %c  %c  %c PixiJS %c v${(0, $7UNC6.VERSION)} (${type}) http://www.pixijs.com/

`,
            "background: #E72264; padding:5px 0;",
            "background: #6CA2EA; padding:5px 0;",
            "background: #B5D33D; padding:5px 0;",
            "background: #FED23F; padding:5px 0;",
            "color: #FFFFFF; background: #E72264; padding:5px 0;",
            "color: #E72264; background: #FFFFFF; padding:5px 0;"
        ];
        globalThis.console.log(...args);
    } else if (globalThis.console) globalThis.console.log(`PixiJS ${(0, $7UNC6.VERSION)} - ${type} - http://www.pixijs.com/`);
    $a40d0f8a4ce3961e$var$saidHello = true;
}

});


parcelRegister("9JGFp", function(module, exports) {

$parcel$export(module.exports, "RenderableGCSystem", () => $da1fc8bf86beb4d0$export$a2204aeb1cc3b5ea);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $da1fc8bf86beb4d0$var$_RenderableGCSystem = class _RenderableGCSystem {
    /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */ constructor(renderer){
        this._renderer = renderer;
    }
    /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */ init(options) {
        options = {
            ..._RenderableGCSystem.defaultOptions,
            ...options
        };
        this.maxUnusedTime = options.renderableGCMaxUnusedTime;
    }
    /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */ get enabled() {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead.");
        return this._renderer.gc.enabled;
    }
    /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */ set enabled(value) {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead.");
        this._renderer.gc.enabled = value;
    }
    /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */ addManagedHash(context, hash) {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.addManagedHash is deprecated, please use the GCSystem.addCollection instead.");
        this._renderer.gc.addCollection(context, hash, "hash");
    }
    /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */ addManagedArray(context, hash) {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.addManagedArray is deprecated, please use the GCSystem.addCollection instead.");
        this._renderer.gc.addCollection(context, hash, "array");
    }
    /**
   * Starts tracking a renderable for garbage collection.
   * @param _renderable - The renderable to track
   * @deprecated since 8.15.0
   */ addRenderable(_renderable) {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.addRenderable is deprecated, please use the GCSystem instead.");
        this._renderer.gc.addResource(_renderable, "renderable");
    }
    /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */ run() {
        (0, $6LhOA.deprecation)("8.15.0", "RenderableGCSystem.run is deprecated, please use the GCSystem instead.");
        this._renderer.gc.run();
    }
    /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */ destroy() {
        this._renderer = null;
    }
};
/**
 * Extension metadata for registering this system with the renderer.
 * @ignore
 */ $da1fc8bf86beb4d0$var$_RenderableGCSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "renderableGC",
    priority: 0
};
/**
 * Default configuration options for the garbage collection system.
 * These can be overridden when initializing the renderer.
 * @deprecated since 8.15.0
 */ $da1fc8bf86beb4d0$var$_RenderableGCSystem.defaultOptions = {
    /** Enable/disable the garbage collector */ renderableGCActive: true,
    /** Time in ms before an unused resource is collected (default 1 minute) */ renderableGCMaxUnusedTime: 6e4,
    /** How often to run garbage collection in ms (default 30 seconds) */ renderableGCFrequency: 3e4
};
let $da1fc8bf86beb4d0$export$a2204aeb1cc3b5ea = $da1fc8bf86beb4d0$var$_RenderableGCSystem;

});

parcelRegister("715l6", function(module, exports) {

$parcel$export(module.exports, "TextureGCSystem", () => $46084eb7248788f0$export$a47b032752d8e393);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $46084eb7248788f0$var$_TextureGCSystem = class _TextureGCSystem {
    /**
   * Frame count since started.
   * @readonly
   * @deprecated since 8.15.0
   */ get count() {
        return this._renderer.tick;
    }
    /**
   * Frame count since last garbage collection.
   * @readonly
   * @deprecated since 8.15.0
   */ get checkCount() {
        return this._checkCount;
    }
    set checkCount(value) {
        (0, $6LhOA.deprecation)("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
        this._checkCount = value;
    }
    /**
   * Maximum idle frames before a texture is destroyed by garbage collection.
   * @see TextureGCSystem.defaultMaxIdle
   * @deprecated since 8.15.0
   */ get maxIdle() {
        return this._renderer.gc.maxUnusedTime / 1e3 * 60;
    }
    set maxIdle(value) {
        (0, $6LhOA.deprecation)("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
        this._renderer.gc.maxUnusedTime = value / 60 * 1e3;
    }
    /**
   * Frames between two garbage collections.
   * @see TextureGCSystem.defaultCheckCountMax
   * @deprecated since 8.15.0
   */ // eslint-disable-next-line dot-notation
    get checkCountMax() {
        return Math.floor(this._renderer.gc["_frequency"] / 1e3);
    }
    set checkCountMax(_value) {
        (0, $6LhOA.deprecation)("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
    }
    /**
   * Current garbage collection mode.
   * @see TextureGCSystem.defaultMode
   * @deprecated since 8.15.0
   */ get active() {
        return this._renderer.gc.enabled;
    }
    set active(value) {
        (0, $6LhOA.deprecation)("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
        this._renderer.gc.enabled = value;
    }
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this._renderer = renderer;
        this._checkCount = 0;
    }
    init(options) {
        if (options.textureGCActive !== _TextureGCSystem.defaultOptions.textureGCActive) this.active = options.textureGCActive;
        if (options.textureGCMaxIdle !== _TextureGCSystem.defaultOptions.textureGCMaxIdle) this.maxIdle = options.textureGCMaxIdle;
        if (options.textureGCCheckCountMax !== _TextureGCSystem.defaultOptions.textureGCCheckCountMax) this.checkCountMax = options.textureGCCheckCountMax;
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   * @deprecated since 8.15.0
   */ run() {
        (0, $6LhOA.deprecation)("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
        this._renderer.gc.run();
    }
    destroy() {
        this._renderer = null;
    }
};
/** @ignore */ $46084eb7248788f0$var$_TextureGCSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "textureGC"
};
/**
 * Default options for the TextureGCSystem
 * @deprecated since 8.15.0
 */ $46084eb7248788f0$var$_TextureGCSystem.defaultOptions = {
    /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */ textureGCActive: true,
    /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystemOptions.textureGCMaxIdle}
   */ textureGCAMaxIdle: null,
    /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */ textureGCMaxIdle: 3600,
    /**
   * Frames between two garbage collections.
   * @default 600
   */ textureGCCheckCountMax: 600
};
let $46084eb7248788f0$export$a47b032752d8e393 = $46084eb7248788f0$var$_TextureGCSystem;

});

parcelRegister("9QtIe", function(module, exports) {

$parcel$export(module.exports, "ViewSystem", () => $c45beb7d8450fe6b$export$6f21c3d5af6602af);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $ar2Ly = parcelRequire("ar2Ly");

var $6LhOA = parcelRequire("6LhOA");

var $l6xrO = parcelRequire("l6xrO");

var $5phlQ = parcelRequire("5phlQ");
"use strict";
const $c45beb7d8450fe6b$var$_ViewSystem = class _ViewSystem {
    /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @type {boolean}
   */ get autoDensity() {
        return this.texture.source.autoDensity;
    }
    set autoDensity(value) {
        this.texture.source.autoDensity = value;
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.texture.source._resolution;
    }
    set resolution(value) {
        this.texture.source.resize(this.texture.source.width, this.texture.source.height, value);
    }
    /**
   * initiates the view system
   * @param options - the options for the view
   */ init(options) {
        options = {
            ..._ViewSystem.defaultOptions,
            ...options
        };
        if (options.view) {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "ViewSystem.view has been renamed to ViewSystem.canvas");
            options.canvas = options.view;
        }
        this.screen = new (0, $ar2Ly.Rectangle)(0, 0, options.width, options.height);
        this.canvas = options.canvas || (0, $gLw46.DOMAdapter).get().createCanvas();
        this.antialias = !!options.antialias;
        this.texture = (0, $5phlQ.getCanvasTexture)(this.canvas, options);
        this.renderTarget = new (0, $l6xrO.RenderTarget)({
            colorTextures: [
                this.texture
            ],
            depth: !!options.depth,
            isRoot: true
        });
        this.texture.source.transparent = options.backgroundAlpha < 1;
        this.resolution = options.resolution;
    }
    /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        this.texture.source.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.screen.width = this.texture.frame.width;
        this.screen.height = this.texture.frame.height;
    }
    /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @example
   * viewSystem.destroy();
   * viewSystem.destroy(true);
   * viewSystem.destroy({ removeView: true });
   */ destroy(options = false) {
        const removeView = typeof options === "boolean" ? options : !!options?.removeView;
        if (removeView && this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
        this.texture.destroy();
    }
};
/** @ignore */ $c45beb7d8450fe6b$var$_ViewSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "view",
    priority: 0
};
/** The default options for the view system. */ $c45beb7d8450fe6b$var$_ViewSystem.defaultOptions = {
    /**
   * {@link WebGLOptions.width}
   * @default 800
   */ width: 800,
    /**
   * {@link WebGLOptions.height}
   * @default 600
   */ height: 600,
    /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */ autoDensity: false,
    /**
   * {@link WebGLOptions.antialias}
   * @default false
   */ antialias: false
};
let $c45beb7d8450fe6b$export$6f21c3d5af6602af = $c45beb7d8450fe6b$var$_ViewSystem;

});
parcelRegister("l6xrO", function(module, exports) {

$parcel$export(module.exports, "RenderTarget", () => $71ea457f1811d6bc$export$efcb1f8bf367cbfb);

var $1bMtF = parcelRequire("1bMtF");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $71ea457f1811d6bc$var$_RenderTarget = class _RenderTarget {
    /**
   * @param [descriptor] - Options for creating a render target.
   */ constructor(descriptor = {}){
        /** unique id for this render target */ this.uid = (0, $1bMtF.uid)("renderTarget");
        /**
     * An array of textures that can be written to by the GPU - mostly this has one texture in Pixi, but you could
     * write to multiple if required! (eg deferred lighting)
     */ this.colorTextures = [];
        this.dirtyId = 0;
        this.isRoot = false;
        this._size = new Float32Array(2);
        /** if true, then when the render target is destroyed, it will destroy all the textures that were created for it. */ this._managedColorTextures = false;
        descriptor = {
            ..._RenderTarget.defaultOptions,
            ...descriptor
        };
        this.stencil = descriptor.stencil;
        this.depth = descriptor.depth;
        this.isRoot = descriptor.isRoot;
        if (typeof descriptor.colorTextures === "number") {
            this._managedColorTextures = true;
            for(let i = 0; i < descriptor.colorTextures; i++)this.colorTextures.push(new (0, $gmQ4R.TextureSource)({
                width: descriptor.width,
                height: descriptor.height,
                resolution: descriptor.resolution,
                antialias: descriptor.antialias
            }));
        } else {
            this.colorTextures = [
                ...descriptor.colorTextures.map((texture)=>texture.source)
            ];
            const colorSource = this.colorTexture.source;
            this.resize(colorSource.width, colorSource.height, colorSource._resolution);
        }
        this.colorTexture.source.on("resize", this.onSourceResize, this);
        if (descriptor.depthStencilTexture || this.stencil) {
            if (descriptor.depthStencilTexture instanceof (0, $4iNSL.Texture) || descriptor.depthStencilTexture instanceof (0, $gmQ4R.TextureSource)) this.depthStencilTexture = descriptor.depthStencilTexture.source;
            else this.ensureDepthStencilTexture();
        }
    }
    get size() {
        const _size = this._size;
        _size[0] = this.pixelWidth;
        _size[1] = this.pixelHeight;
        return _size;
    }
    get width() {
        return this.colorTexture.source.width;
    }
    get height() {
        return this.colorTexture.source.height;
    }
    get pixelWidth() {
        return this.colorTexture.source.pixelWidth;
    }
    get pixelHeight() {
        return this.colorTexture.source.pixelHeight;
    }
    get resolution() {
        return this.colorTexture.source._resolution;
    }
    get colorTexture() {
        return this.colorTextures[0];
    }
    onSourceResize(source) {
        this.resize(source.width, source.height, source._resolution, true);
    }
    /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   */ ensureDepthStencilTexture() {
        if (!this.depthStencilTexture) this.depthStencilTexture = new (0, $gmQ4R.TextureSource)({
            width: this.width,
            height: this.height,
            resolution: this.resolution,
            format: "depth24plus-stencil8",
            autoGenerateMipmaps: false,
            antialias: false,
            mipLevelCount: 1
        });
    }
    resize(width, height, resolution = this.resolution, skipColorTexture = false) {
        this.dirtyId++;
        this.colorTextures.forEach((colorTexture, i)=>{
            if (skipColorTexture && i === 0) return;
            colorTexture.source.resize(width, height, resolution);
        });
        if (this.depthStencilTexture) this.depthStencilTexture.source.resize(width, height, resolution);
    }
    destroy() {
        this.colorTexture.source.off("resize", this.onSourceResize, this);
        if (this._managedColorTextures) this.colorTextures.forEach((texture)=>{
            texture.destroy();
        });
        if (this.depthStencilTexture) {
            this.depthStencilTexture.destroy();
            delete this.depthStencilTexture;
        }
    }
};
/** The default options for a render target */ $71ea457f1811d6bc$var$_RenderTarget.defaultOptions = {
    /** the width of the RenderTarget */ width: 0,
    /** the height of the RenderTarget */ height: 0,
    /** the resolution of the RenderTarget */ resolution: 1,
    /** an array of textures, or a number indicating how many color textures there should be */ colorTextures: 1,
    /** should this render target have a stencil buffer? */ stencil: false,
    /** should this render target have a depth buffer? */ depth: false,
    /** should this render target be antialiased? */ antialias: false,
    // save on perf by default!
    /** is this a root element, true if this is gl context owners render target */ isRoot: false
};
let $71ea457f1811d6bc$export$efcb1f8bf367cbfb = $71ea457f1811d6bc$var$_RenderTarget;

});

parcelRegister("5phlQ", function(module, exports) {

$parcel$export(module.exports, "getCanvasTexture", () => $a399230351a1e1e6$export$f2bcae39472d9516);
$parcel$export(module.exports, "hasCachedCanvasTexture", () => $a399230351a1e1e6$export$57935aeb65aa90cf);

var $fpmqC = parcelRequire("fpmqC");

var $egYi0 = parcelRequire("egYi0");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $a399230351a1e1e6$var$canvasCache = /* @__PURE__ */ new Map();
(0, $fpmqC.GlobalResourceRegistry).register($a399230351a1e1e6$var$canvasCache);
function $a399230351a1e1e6$export$f2bcae39472d9516(canvas, options) {
    if (!$a399230351a1e1e6$var$canvasCache.has(canvas)) {
        const texture = new (0, $4iNSL.Texture)({
            source: new (0, $egYi0.CanvasSource)({
                resource: canvas,
                ...options
            })
        });
        const onDestroy = ()=>{
            if ($a399230351a1e1e6$var$canvasCache.get(canvas) === texture) $a399230351a1e1e6$var$canvasCache.delete(canvas);
        };
        texture.once("destroy", onDestroy);
        texture.source.once("destroy", onDestroy);
        $a399230351a1e1e6$var$canvasCache.set(canvas, texture);
    }
    return $a399230351a1e1e6$var$canvasCache.get(canvas);
}
function $a399230351a1e1e6$export$57935aeb65aa90cf(canvas) {
    return $a399230351a1e1e6$var$canvasCache.has(canvas);
}

});



parcelRegister("gBwOb", function(module, exports) {

$parcel$export(module.exports, "CanvasContextSystem", () => $93a111614bda4893$export$737c87aba346ac3a);

var $dKHyW = parcelRequire("dKHyW");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $15FDP = parcelRequire("15FDP");
"use strict";
const $93a111614bda4893$var$tempMatrix = new (0, $5xi4h.Matrix)();
class $93a111614bda4893$export$737c87aba346ac3a {
    /**
   * @param renderer - The owning CanvasRenderer.
   */ constructor(renderer){
        /** Resolution of the active context. */ this.activeResolution = 1;
        /** The image smoothing property to toggle for this browser. */ this.smoothProperty = "imageSmoothingEnabled";
        /** Map of Pixi blend modes to canvas composite operations. */ this.blendModes = (0, $15FDP.mapCanvasBlendModesToPixi)();
        /** Current canvas blend mode. */ this._activeBlendMode = "normal";
        /** Optional projection transform for render targets. */ this._projTransform = null;
        /** True when external blend mode control is in use. */ this._outerBlend = false;
        /** Tracks unsupported blend mode warnings to avoid spam. */ this._warnedBlendModes = /* @__PURE__ */ new Set();
        this._renderer = renderer;
    }
    resolutionChange(resolution) {
        this.activeResolution = resolution;
    }
    /** Initializes the root context and smoothing flag selection. */ init() {
        const alpha = this._renderer.background.alpha < 1;
        this.rootContext = this._renderer.canvas.getContext("2d", {
            alpha: alpha
        });
        this.activeContext = this.rootContext;
        this.activeResolution = this._renderer.resolution;
        if (!this.rootContext.imageSmoothingEnabled) {
            const rc = this.rootContext;
            if (rc.webkitImageSmoothingEnabled) this.smoothProperty = "webkitImageSmoothingEnabled";
            else if (rc.mozImageSmoothingEnabled) this.smoothProperty = "mozImageSmoothingEnabled";
            else if (rc.oImageSmoothingEnabled) this.smoothProperty = "oImageSmoothingEnabled";
            else if (rc.msImageSmoothingEnabled) this.smoothProperty = "msImageSmoothingEnabled";
        }
    }
    /**
   * Sets the current transform on the active context.
   * @param transform - Transform to apply.
   * @param roundPixels - Whether to round translation to integers.
   * @param localResolution - Optional local resolution multiplier.
   * @param skipGlobalTransform - If true, skip applying the global world transform matrix.
   */ setContextTransform(transform, roundPixels, localResolution, skipGlobalTransform) {
        const globalTransform = skipGlobalTransform ? (0, $5xi4h.Matrix).IDENTITY : this._renderer.globalUniforms.globalUniformData?.worldTransformMatrix || (0, $5xi4h.Matrix).IDENTITY;
        let mat = $93a111614bda4893$var$tempMatrix;
        mat.copyFrom(globalTransform);
        mat.append(transform);
        const proj = this._projTransform;
        const contextResolution = this.activeResolution;
        localResolution = localResolution || contextResolution;
        if (proj) {
            const finalMat = (0, $5xi4h.Matrix).shared;
            finalMat.copyFrom(mat);
            finalMat.prepend(proj);
            mat = finalMat;
        }
        if (roundPixels) this.activeContext.setTransform(mat.a * localResolution, mat.b * localResolution, mat.c * localResolution, mat.d * localResolution, mat.tx * contextResolution | 0, mat.ty * contextResolution | 0);
        else this.activeContext.setTransform(mat.a * localResolution, mat.b * localResolution, mat.c * localResolution, mat.d * localResolution, mat.tx * contextResolution, mat.ty * contextResolution);
    }
    /**
   * Clears the current render target, optionally filling with a color.
   * @param clearColor - Color to fill after clearing.
   * @param alpha - Alpha override for the clear color.
   */ clear(clearColor, alpha) {
        const context = this.activeContext;
        const renderer = this._renderer;
        context.clearRect(0, 0, renderer.width, renderer.height);
        if (clearColor) {
            const color = (0, $dKHyW.Color).shared.setValue(clearColor);
            context.globalAlpha = alpha ?? color.alpha;
            context.fillStyle = color.toHex();
            context.fillRect(0, 0, renderer.width, renderer.height);
            context.globalAlpha = 1;
        }
    }
    /**
   * Sets the active blend mode.
   * @param blendMode - Pixi blend mode.
   */ setBlendMode(blendMode) {
        if (this._activeBlendMode === blendMode) return;
        this._activeBlendMode = blendMode;
        this._outerBlend = false;
        const mappedBlend = this.blendModes[blendMode];
        if (!mappedBlend) {
            if (!this._warnedBlendModes.has(blendMode)) {
                console.warn(`CanvasRenderer: blend mode "${blendMode}" is not supported in Canvas2D; falling back to "source-over".`);
                this._warnedBlendModes.add(blendMode);
            }
            this.activeContext.globalCompositeOperation = "source-over";
            return;
        }
        this.activeContext.globalCompositeOperation = mappedBlend;
    }
    /** Releases context references. */ destroy() {
        this.rootContext = null;
        this.activeContext = null;
        this._warnedBlendModes.clear();
    }
}
/** @ignore */ $93a111614bda4893$export$737c87aba346ac3a.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "canvasContext"
};

});
parcelRegister("15FDP", function(module, exports) {

$parcel$export(module.exports, "mapCanvasBlendModesToPixi", () => $27dcd0cdc788a073$export$ac1eb02d49251df5);

var $gfzpv = parcelRequire("gfzpv");
"use strict";
const $27dcd0cdc788a073$var$FALLBACK_BLEND = "source-over";
function $27dcd0cdc788a073$export$ac1eb02d49251df5() {
    const supportsAdvanced = (0, $gfzpv.canUseNewCanvasBlendModes)();
    const map = /* @__PURE__ */ Object.create(null);
    map.inherit = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.none = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.normal = "source-over";
    map.add = "lighter";
    map.multiply = supportsAdvanced ? "multiply" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.screen = supportsAdvanced ? "screen" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.overlay = supportsAdvanced ? "overlay" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.darken = supportsAdvanced ? "darken" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.lighten = supportsAdvanced ? "lighten" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["color-dodge"] = supportsAdvanced ? "color-dodge" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["color-burn"] = supportsAdvanced ? "color-burn" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["hard-light"] = supportsAdvanced ? "hard-light" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["soft-light"] = supportsAdvanced ? "soft-light" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.difference = supportsAdvanced ? "difference" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.exclusion = supportsAdvanced ? "exclusion" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.saturation = supportsAdvanced ? "saturation" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.color = supportsAdvanced ? "color" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.luminosity = supportsAdvanced ? "luminosity" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["linear-burn"] = supportsAdvanced ? "color-burn" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["linear-dodge"] = supportsAdvanced ? "color-dodge" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["linear-light"] = supportsAdvanced ? "hard-light" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["pin-light"] = supportsAdvanced ? "hard-light" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["vivid-light"] = supportsAdvanced ? "hard-light" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["hard-mix"] = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.negation = supportsAdvanced ? "difference" : $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map["normal-npm"] = map.normal;
    map["add-npm"] = map.add;
    map["screen-npm"] = map.screen;
    map.erase = "destination-out";
    map.subtract = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.divide = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.min = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    map.max = $27dcd0cdc788a073$var$FALLBACK_BLEND;
    return map;
}

});


parcelRegister("iZQJj", function(module, exports) {

$parcel$export(module.exports, "CanvasLimitsSystem", () => $eb2d20d0c1d995b4$export$66b19c2e4578a08);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $eb2d20d0c1d995b4$export$66b19c2e4578a08 {
    constructor(){
        this.maxTextures = 16;
        this.maxBatchableTextures = 16;
        this.maxUniformBindings = 0;
    }
    init() {}
}
/** @ignore */ $eb2d20d0c1d995b4$export$66b19c2e4578a08.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "limits"
};

});

parcelRegister("f4cmq", function(module, exports) {

$parcel$export(module.exports, "CanvasRenderTargetSystem", () => $68dfaf2a9458a656$export$fcddcad924ee1715);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2nO5l = parcelRequire("2nO5l");

var $2ScGl = parcelRequire("2ScGl");
"use strict";
class $68dfaf2a9458a656$export$fcddcad924ee1715 extends (0, $2nO5l.RenderTargetSystem) {
    constructor(renderer){
        super(renderer);
        this.adaptor = new (0, $2ScGl.CanvasRenderTargetAdaptor)();
        this.adaptor.init(renderer, this);
    }
}
/** @ignore */ $68dfaf2a9458a656$export$fcddcad924ee1715.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "renderTarget"
};

});
parcelRegister("2nO5l", function(module, exports) {

$parcel$export(module.exports, "RenderTargetSystem", () => $a802c127c33b7fdf$export$c555e722a4d2378a);

var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");

var $5Ac7T = parcelRequire("5Ac7T");

var $j5jxv = parcelRequire("j5jxv");

var $ljtep = parcelRequire("ljtep");

var $egYi0 = parcelRequire("egYi0");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");

var $5phlQ = parcelRequire("5phlQ");

var $axEIC = parcelRequire("axEIC");

var $l6xrO = parcelRequire("l6xrO");
"use strict";
class $a802c127c33b7fdf$export$c555e722a4d2378a {
    constructor(renderer){
        /** This is the root viewport for the render pass */ this.rootViewPort = new (0, $ar2Ly.Rectangle)();
        /** the current viewport that the gpu is using */ this.viewport = new (0, $ar2Ly.Rectangle)();
        /** the current mip level being rendered to (for texture subresources) */ this.mipLevel = 0;
        /** the current array layer being rendered to (for array-backed targets) */ this.layer = 0;
        /**
     * a runner that lets systems know if the active render target has changed.
     * Eg the Stencil System needs to know so it can manage the stencil buffer
     */ this.onRenderTargetChange = new (0, $ljtep.SystemRunner)("onRenderTargetChange");
        /** the projection matrix that is used by the shaders based on the active render target and the viewport */ this.projectionMatrix = new (0, $5xi4h.Matrix)();
        /** the default clear color for render targets */ this.defaultClearColor = [
            0,
            0,
            0,
            0
        ];
        /**
     * a hash that stores the render target for a given render surface. When you pass in a texture source,
     * a render target is created for it. This map stores and makes it easy to retrieve the render target
     */ this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map();
        /** A hash that stores a gpu render target for a given render target. */ this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
        /**
     * A stack that stores the render target and frame that is currently being rendered to.
     * When push is called, the current render target is stored in this stack.
     * When pop is called, the previous render target is restored.
     */ this._renderTargetStack = [];
        this._renderer = renderer;
        renderer.gc.addCollection(this, "_gpuRenderTargetHash", "hash");
    }
    /** called when dev wants to finish a render pass */ finishRenderPass() {
        this.adaptor.finishRenderPass(this.renderTarget);
    }
    /**
   * called when the renderer starts to render a scene.
   * @param options
   * @param options.target - the render target to render to
   * @param options.clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param options.clearColor - the color to clear to
   * @param options.frame - the frame to render to
   * @param options.mipLevel - the mip level to render to
   * @param options.layer - The layer of the render target to render to. Used for array or 3D textures, or when rendering
   * to a specific layer of a layered render target. Optional.
   */ renderStart({ target: target, clear: clear, clearColor: clearColor, frame: frame, mipLevel: mipLevel, layer: layer }) {
        this._renderTargetStack.length = 0;
        this.push(target, clear, clearColor, frame, mipLevel ?? 0, layer ?? 0);
        this.rootViewPort.copyFrom(this.viewport);
        this.rootRenderTarget = this.renderTarget;
        this.renderingToScreen = (0, $axEIC.isRenderingToScreen)(this.rootRenderTarget);
        this.adaptor.prerender?.(this.rootRenderTarget);
    }
    postrender() {
        this.adaptor.postrender?.(this.rootRenderTarget);
    }
    /**
   * Binding a render surface! This is the main function of the render target system.
   * It will take the RenderSurface (which can be a texture, canvas, or render target) and bind it to the renderer.
   * Once bound all draw calls will be rendered to the render surface.
   *
   * If a frame is not provided and the render surface is a {@link Texture}, the frame of the texture will be used.
   *
   * IMPORTANT:
   * - `frame` is treated as **base mip (mip 0) pixel space**.
   * - When `mipLevel > 0`, the viewport derived from `frame` is scaled by \(2^{mipLevel}\) and clamped to the
   *   mip dimensions. This keeps "render the same region" semantics consistent across mip levels.
   * - When `renderSurface` is a {@link Texture}, `renderer.render({ container, target: texture, mipLevel })` will
   *   render into
   *   the underlying {@link TextureSource} (Pixi will create/use a {@link RenderTarget} for the source) using the
   *   texture's frame to define the region (in mip 0 space).
   * @param renderSurface - the render surface to bind
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to render to
   * @param mipLevel - the mip level to render to
   * @param layer - the layer (or slice) of the render surface to render to. For array textures,
   * 3D textures, or cubemaps, this specifies the target layer or face. Defaults to 0 (the first layer/face).
   * Ignored for surfaces that do not support layers.
   * @returns the render target that was bound
   */ bind(renderSurface, clear = true, clearColor, frame, mipLevel = 0, layer = 0) {
        const renderTarget = this.getRenderTarget(renderSurface);
        const didChange = this.renderTarget !== renderTarget;
        this.renderTarget = renderTarget;
        this.renderSurface = renderSurface;
        const gpuRenderTarget = this.getGpuRenderTarget(renderTarget);
        if (renderTarget.pixelWidth !== gpuRenderTarget.width || renderTarget.pixelHeight !== gpuRenderTarget.height) {
            this.adaptor.resizeGpuRenderTarget(renderTarget);
            gpuRenderTarget.width = renderTarget.pixelWidth;
            gpuRenderTarget.height = renderTarget.pixelHeight;
        }
        const source = renderTarget.colorTexture;
        const viewport = this.viewport;
        const arrayLayerCount = source.arrayLayerCount || 1;
        if ((layer | 0) !== layer) layer |= 0;
        if (layer < 0 || layer >= arrayLayerCount) throw new Error(`[RenderTargetSystem] layer ${layer} is out of bounds (arrayLayerCount=${arrayLayerCount}).`);
        this.mipLevel = mipLevel | 0;
        this.layer = layer | 0;
        const pixelWidth = Math.max(source.pixelWidth >> mipLevel, 1);
        const pixelHeight = Math.max(source.pixelHeight >> mipLevel, 1);
        if (!frame && renderSurface instanceof (0, $4iNSL.Texture)) frame = renderSurface.frame;
        if (frame) {
            const resolution = source._resolution;
            const scale = 1 << Math.max(mipLevel | 0, 0);
            const baseX = frame.x * resolution + 0.5 | 0;
            const baseY = frame.y * resolution + 0.5 | 0;
            const baseW = frame.width * resolution + 0.5 | 0;
            const baseH = frame.height * resolution + 0.5 | 0;
            let x = Math.floor(baseX / scale);
            let y = Math.floor(baseY / scale);
            let w = Math.ceil(baseW / scale);
            let h = Math.ceil(baseH / scale);
            x = Math.min(Math.max(x, 0), pixelWidth - 1);
            y = Math.min(Math.max(y, 0), pixelHeight - 1);
            w = Math.min(Math.max(w, 1), pixelWidth - x);
            h = Math.min(Math.max(h, 1), pixelHeight - y);
            viewport.x = x;
            viewport.y = y;
            viewport.width = w;
            viewport.height = h;
        } else {
            viewport.x = 0;
            viewport.y = 0;
            viewport.width = pixelWidth;
            viewport.height = pixelHeight;
        }
        (0, $j5jxv.calculateProjection)(this.projectionMatrix, 0, 0, viewport.width / source.resolution, viewport.height / source.resolution, !renderTarget.isRoot);
        this.adaptor.startRenderPass(renderTarget, clear, clearColor, viewport, mipLevel, layer);
        if (didChange) this.onRenderTargetChange.emit(renderTarget);
        return renderTarget;
    }
    clear(target, clear = (0, $5Ac7T.CLEAR).ALL, clearColor, mipLevel = this.mipLevel, layer = this.layer) {
        if (!clear) return;
        if (target) target = this.getRenderTarget(target);
        this.adaptor.clear(target || this.renderTarget, clear, clearColor, this.viewport, mipLevel, layer);
    }
    contextChange() {
        this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
    }
    /**
   * Push a render surface to the renderer. This will bind the render surface to the renderer,
   * @param renderSurface - the render surface to push
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to use when rendering to the render surface
   * @param mipLevel - the mip level to render to
   * @param layer - The layer of the render surface to render to. For array textures or cube maps, this specifies
   * which layer or face to target. Defaults to 0 (the first layer).
   */ push(renderSurface, clear = (0, $5Ac7T.CLEAR).ALL, clearColor, frame, mipLevel = 0, layer = 0) {
        const renderTarget = this.bind(renderSurface, clear, clearColor, frame, mipLevel, layer);
        this._renderTargetStack.push({
            renderTarget: renderTarget,
            frame: frame,
            mipLevel: mipLevel,
            layer: layer
        });
        return renderTarget;
    }
    /** Pops the current render target from the renderer and restores the previous render target. */ pop() {
        this._renderTargetStack.pop();
        const currentRenderTargetData = this._renderTargetStack[this._renderTargetStack.length - 1];
        this.bind(currentRenderTargetData.renderTarget, false, null, currentRenderTargetData.frame, currentRenderTargetData.mipLevel, currentRenderTargetData.layer);
    }
    /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */ getRenderTarget(renderSurface) {
        if (renderSurface.isTexture) renderSurface = renderSurface.source;
        return this._renderSurfaceToRenderTargetHash.get(renderSurface) ?? this._initRenderTarget(renderSurface);
    }
    /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurfaceTexture - the render surface to copy from
   * @param {Texture} destinationTexture - the texture to copy to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */ copyToTexture(sourceRenderSurfaceTexture, destinationTexture, originSrc, size, originDest) {
        if (originSrc.x < 0) {
            size.width += originSrc.x;
            originDest.x -= originSrc.x;
            originSrc.x = 0;
        }
        if (originSrc.y < 0) {
            size.height += originSrc.y;
            originDest.y -= originSrc.y;
            originSrc.y = 0;
        }
        const { pixelWidth: pixelWidth, pixelHeight: pixelHeight } = sourceRenderSurfaceTexture;
        size.width = Math.min(size.width, pixelWidth - originSrc.x);
        size.height = Math.min(size.height, pixelHeight - originSrc.y);
        return this.adaptor.copyToTexture(sourceRenderSurfaceTexture, destinationTexture, originSrc, size, originDest);
    }
    /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */ ensureDepthStencil() {
        if (!this.renderTarget.stencil) {
            this.renderTarget.stencil = true;
            this.adaptor.startRenderPass(this.renderTarget, false, null, this.viewport, 0, this.layer);
        }
    }
    /** nukes the render target system */ destroy() {
        this._renderer = null;
        this._renderSurfaceToRenderTargetHash.forEach((renderTarget, key)=>{
            if (renderTarget !== key) renderTarget.destroy();
        });
        this._renderSurfaceToRenderTargetHash.clear();
        this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
    }
    _initRenderTarget(renderSurface) {
        let renderTarget = null;
        if ((0, $egYi0.CanvasSource).test(renderSurface)) renderSurface = (0, $5phlQ.getCanvasTexture)(renderSurface).source;
        if (renderSurface instanceof (0, $l6xrO.RenderTarget)) renderTarget = renderSurface;
        else if (renderSurface instanceof (0, $gmQ4R.TextureSource)) {
            renderTarget = new (0, $l6xrO.RenderTarget)({
                colorTextures: [
                    renderSurface
                ]
            });
            if (renderSurface.source instanceof (0, $egYi0.CanvasSource)) renderTarget.isRoot = true;
            renderSurface.once("destroy", ()=>{
                renderTarget.destroy();
                this._renderSurfaceToRenderTargetHash.delete(renderSurface);
                const gpuRenderTarget = this._gpuRenderTargetHash[renderTarget.uid];
                if (gpuRenderTarget) {
                    this._gpuRenderTargetHash[renderTarget.uid] = null;
                    this.adaptor.destroyGpuRenderTarget(gpuRenderTarget);
                }
            });
        }
        this._renderSurfaceToRenderTargetHash.set(renderSurface, renderTarget);
        return renderTarget;
    }
    getGpuRenderTarget(renderTarget) {
        return this._gpuRenderTargetHash[renderTarget.uid] || (this._gpuRenderTargetHash[renderTarget.uid] = this.adaptor.initGpuRenderTarget(renderTarget));
    }
    resetState() {
        this.renderTarget = null;
        this.renderSurface = null;
    }
}

});
parcelRegister("j5jxv", function(module, exports) {

$parcel$export(module.exports, "calculateProjection", () => $b4c5bb7f595144c9$export$fa0a4f720dae18a1);
"use strict";
function $b4c5bb7f595144c9$export$fa0a4f720dae18a1(pm, x, y, width, height, flipY) {
    const sign = flipY ? 1 : -1;
    pm.identity();
    pm.a = 1 / width * 2;
    pm.d = sign * (1 / height * 2);
    pm.tx = -1 - x * pm.a;
    pm.ty = -sign - y * pm.d;
    return pm;
}

});

parcelRegister("axEIC", function(module, exports) {

$parcel$export(module.exports, "isRenderingToScreen", () => $8196b29adfbb2b95$export$6eeeb7b7562073b1);
"use strict";
function $8196b29adfbb2b95$export$6eeeb7b7562073b1(renderTarget) {
    const resource = renderTarget.colorTexture.source.resource;
    return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement && document.body.contains(resource);
}

});


parcelRegister("2ScGl", function(module, exports) {

$parcel$export(module.exports, "CanvasRenderTargetAdaptor", () => $636edadf6fdf044d$export$f24b2f5a290b2e3d);

var $dKHyW = parcelRequire("dKHyW");

var $gLw46 = parcelRequire("gLw46");

var $egYi0 = parcelRequire("egYi0");
"use strict";
class $636edadf6fdf044d$export$f24b2f5a290b2e3d {
    /**
   * Initializes the adaptor.
   * @param renderer - Canvas renderer instance.
   * @param renderTargetSystem - The render target system.
   * @advanced
   */ init(renderer, renderTargetSystem) {
        this._renderer = renderer;
        this._renderTargetSystem = renderTargetSystem;
    }
    /**
   * Creates a GPU render target for canvas.
   * @param renderTarget - Render target to initialize.
   * @advanced
   */ initGpuRenderTarget(renderTarget) {
        const colorTexture = renderTarget.colorTexture;
        const { canvas: canvas, context: context } = this._ensureCanvas(colorTexture);
        return {
            canvas: canvas,
            context: context,
            width: canvas.width,
            height: canvas.height
        };
    }
    /**
   * Resizes the backing canvas for a render target.
   * @param renderTarget - Render target to resize.
   * @advanced
   */ resizeGpuRenderTarget(renderTarget) {
        const colorTexture = renderTarget.colorTexture;
        const { canvas: canvas } = this._ensureCanvas(colorTexture);
        canvas.width = renderTarget.pixelWidth;
        canvas.height = renderTarget.pixelHeight;
    }
    /**
   * Starts a render pass on the canvas target.
   * @param renderTarget - Target to render to.
   * @param clear - Clear mode.
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport.
   * @advanced
   */ startRenderPass(renderTarget, clear, clearColor, viewport) {
        const gpuRenderTarget = this._renderTargetSystem.getGpuRenderTarget(renderTarget);
        this._renderer.canvasContext.activeContext = gpuRenderTarget.context;
        this._renderer.canvasContext.activeResolution = renderTarget.resolution;
        if (clear) this.clear(renderTarget, clear, clearColor, viewport);
    }
    /**
   * Clears the render target.
   * @param renderTarget - Target to clear.
   * @param _clear - Clear mode (unused).
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport rectangle.
   * @advanced
   */ clear(renderTarget, _clear, clearColor, viewport) {
        const gpuRenderTarget = this._renderTargetSystem.getGpuRenderTarget(renderTarget);
        const context = gpuRenderTarget.context;
        const bounds = viewport || {
            x: 0,
            y: 0,
            width: renderTarget.pixelWidth,
            height: renderTarget.pixelHeight
        };
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(bounds.x, bounds.y, bounds.width, bounds.height);
        if (clearColor) {
            const color = (0, $dKHyW.Color).shared.setValue(clearColor);
            if (color.alpha > 0) {
                context.globalAlpha = color.alpha;
                context.fillStyle = color.toHex();
                context.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
                context.globalAlpha = 1;
            }
        }
    }
    /**
   * Finishes the render pass (no-op for canvas).
   * @advanced
   */ finishRenderPass() {}
    /**
   * Copies a render target into a texture source.
   * @param {RenderTarget} sourceRenderSurfaceTexture - Source render target.
   * @param {Texture} destinationTexture - Destination texture.
   * @param {object} originSrc - Source origin.
   * @param {number} originSrc.x - Source x origin.
   * @param {number} originSrc.y - Source y origin.
   * @param {object} size - Copy size.
   * @param {number} size.width - Copy width.
   * @param {number} size.height - Copy height.
   * @param {object} [originDest] - Destination origin.
   * @param {number} originDest.x - Destination x origin.
   * @param {number} originDest.y - Destination y origin.
   * @advanced
   */ copyToTexture(sourceRenderSurfaceTexture, destinationTexture, originSrc, size, originDest) {
        const sourceGpuTarget = this._renderTargetSystem.getGpuRenderTarget(sourceRenderSurfaceTexture);
        const sourceCanvas = sourceGpuTarget.canvas;
        const destSource = destinationTexture.source;
        const { context: context } = this._ensureCanvas(destSource);
        const dx = originDest?.x ?? 0;
        const dy = originDest?.y ?? 0;
        context.drawImage(sourceCanvas, originSrc.x, originSrc.y, size.width, size.height, dx, dy, size.width, size.height);
        destSource.update();
        return destinationTexture;
    }
    /**
   * Destroys a GPU render target (no-op for canvas).
   * @param _gpuRenderTarget - Target to destroy.
   * @advanced
   */ destroyGpuRenderTarget(_gpuRenderTarget) {}
    _ensureCanvas(source) {
        let canvas = source.resource;
        if (!canvas || !(0, $egYi0.CanvasSource).test(canvas)) {
            canvas = (0, $gLw46.DOMAdapter).get().createCanvas(source.pixelWidth, source.pixelHeight);
            source.resource = canvas;
        }
        if (canvas.width !== source.pixelWidth || canvas.height !== source.pixelHeight) {
            canvas.width = source.pixelWidth;
            canvas.height = source.pixelHeight;
        }
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
}

});


parcelRegister("dV9kF", function(module, exports) {

$parcel$export(module.exports, "CanvasTextureSystem", () => $3863a6c9ee83a066$export$3d6c52ccddda22b0);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2IIjX = parcelRequire("2IIjX");
"use strict";
class $3863a6c9ee83a066$export$3d6c52ccddda22b0 {
    /**
   * @param renderer - The owning CanvasRenderer.
   */ constructor(renderer){}
    /** Initializes the system (no-op for canvas). */ init() {}
    /**
   * Initializes a texture source (no-op for canvas).
   * @param _source - Texture source.
   */ initSource(_source) {}
    /**
   * Creates a canvas containing the texture's frame.
   * @param texture - Texture to render.
   */ generateCanvas(texture) {
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        const context = canvas.getContext("2d");
        const source = (0, $2IIjX.canvasUtils).getCanvasSource(texture);
        if (!source) return canvas;
        const frame = texture.frame;
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const sx = frame.x * resolution;
        const sy = frame.y * resolution;
        const sw = frame.width * resolution;
        const sh = frame.height * resolution;
        canvas.width = Math.ceil(sw);
        canvas.height = Math.ceil(sh);
        context.drawImage(source, sx, sy, sw, sh, 0, 0, sw, sh);
        return canvas;
    }
    /**
   * Reads pixel data from a texture.
   * @param texture - Texture to read.
   */ getPixels(texture) {
        const canvas = this.generateCanvas(texture);
        const context = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        return {
            pixels: imageData.data,
            width: canvas.width,
            height: canvas.height
        };
    }
    /** Destroys the system (no-op for canvas). */ destroy() {}
}
/** @ignore */ $3863a6c9ee83a066$export$3d6c52ccddda22b0.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "texture"
};

});


parcelRegister("5aJ4P", function(module, exports) {

$parcel$export(module.exports, "WebGLRenderer", () => $f52dc54b4fc19cb0$export$f6cc00ef28d7cf97);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $dUCZ0 = parcelRequire("dUCZ0");

var $5aREr = parcelRequire("5aREr");

var $7ogwP = parcelRequire("7ogwP");

var $7velr = parcelRequire("7velr");

var $g2d25 = parcelRequire("g2d25");

var $bfcaK = parcelRequire("bfcaK");

var $k0jeB = parcelRequire("k0jeB");

var $a66qS = parcelRequire("a66qS");

var $4gUjT = parcelRequire("4gUjT");

var $1k36i = parcelRequire("1k36i");

var $hqwGc = parcelRequire("hqwGc");

var $hJqSP = parcelRequire("hJqSP");

var $epQ0R = parcelRequire("epQ0R");

var $chYSB = parcelRequire("chYSB");

var $6FDbi = parcelRequire("6FDbi");

var $afkf3 = parcelRequire("afkf3");

var $6ZiIY = parcelRequire("6ZiIY");

var $iaA7Y = parcelRequire("iaA7Y");

var $71WMa = parcelRequire("71WMa");

var $lMeU5 = parcelRequire("lMeU5");
"use strict";
const $f52dc54b4fc19cb0$var$DefaultWebGLSystems = [
    ...(0, $g2d25.SharedSystems),
    (0, $6FDbi.GlUboSystem),
    (0, $1k36i.GlBackBufferSystem),
    (0, $a66qS.GlContextSystem),
    (0, $epQ0R.GlLimitsSystem),
    (0, $k0jeB.GlBufferSystem),
    (0, $lMeU5.GlTextureSystem),
    (0, $afkf3.GlRenderTargetSystem),
    (0, $4gUjT.GlGeometrySystem),
    (0, $iaA7Y.GlUniformGroupSystem),
    (0, $6ZiIY.GlShaderSystem),
    (0, $hJqSP.GlEncoderSystem),
    (0, $71WMa.GlStateSystem),
    (0, $chYSB.GlStencilSystem),
    (0, $hqwGc.GlColorMaskSystem)
];
const $f52dc54b4fc19cb0$var$DefaultWebGLPipes = [
    ...(0, $g2d25.SharedRenderPipes)
];
const $f52dc54b4fc19cb0$var$DefaultWebGLAdapters = [
    (0, $7ogwP.GlBatchAdaptor),
    (0, $5aREr.GlMeshAdaptor),
    (0, $dUCZ0.GlGraphicsAdaptor)
];
const $f52dc54b4fc19cb0$var$systems = [];
const $f52dc54b4fc19cb0$var$renderPipes = [];
const $f52dc54b4fc19cb0$var$renderPipeAdaptors = [];
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGLSystem, $f52dc54b4fc19cb0$var$systems);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGLPipes, $f52dc54b4fc19cb0$var$renderPipes);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGLPipesAdaptor, $f52dc54b4fc19cb0$var$renderPipeAdaptors);
(0, $aZ9ZN.extensions).add(...$f52dc54b4fc19cb0$var$DefaultWebGLSystems, ...$f52dc54b4fc19cb0$var$DefaultWebGLPipes, ...$f52dc54b4fc19cb0$var$DefaultWebGLAdapters);
class $f52dc54b4fc19cb0$export$f6cc00ef28d7cf97 extends (0, $7velr.AbstractRenderer) {
    constructor(){
        const systemConfig = {
            name: "webgl",
            type: (0, $bfcaK.RendererType).WEBGL,
            systems: $f52dc54b4fc19cb0$var$systems,
            renderPipes: $f52dc54b4fc19cb0$var$renderPipes,
            renderPipeAdaptors: $f52dc54b4fc19cb0$var$renderPipeAdaptors
        };
        super(systemConfig);
    }
}

});
parcelRegister("dUCZ0", function(module, exports) {

$parcel$export(module.exports, "GlGraphicsAdaptor", () => $6357f62a8068da33$export$973696ef22548d24);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $aYOxl = parcelRequire("aYOxl");

var $eGbby = parcelRequire("eGbby");

var $1I0Ex = parcelRequire("1I0Ex");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $foUHO = parcelRequire("foUHO");

var $7LCXQ = parcelRequire("7LCXQ");

var $aUxJK = parcelRequire("aUxJK");
"use strict";
class $6357f62a8068da33$export$973696ef22548d24 {
    contextChange(renderer) {
        const uniforms = new (0, $aUxJK.UniformGroup)({
            uColor: {
                value: new Float32Array([
                    1,
                    1,
                    1,
                    1
                ]),
                type: "vec4<f32>"
            },
            uTransformMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uRound: {
                value: 0,
                type: "f32"
            }
        });
        const maxTextures = renderer.limits.maxBatchableTextures;
        const glProgram = (0, $aYOxl.compileHighShaderGlProgram)({
            name: "graphics",
            bits: [
                (0, $eGbby.colorBitGl),
                (0, $1I0Ex.generateTextureBatchBitGl)(maxTextures),
                (0, $dKCGl.localUniformBitGl),
                (0, $gnlmr.roundPixelsBitGl)
            ]
        });
        this.shader = new (0, $7LCXQ.Shader)({
            glProgram: glProgram,
            resources: {
                localUniforms: uniforms,
                batchSamplers: (0, $foUHO.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
    execute(graphicsPipe, renderable) {
        const context = renderable.context;
        const shader = context.customShader || this.shader;
        const renderer = graphicsPipe.renderer;
        const contextSystem = renderer.graphicsContext;
        const { batcher: batcher, instructions: instructions } = contextSystem.getContextRenderData(context);
        shader.groups[0] = renderer.globalUniforms.bindGroup;
        renderer.state.set(graphicsPipe.state);
        renderer.shader.bind(shader);
        renderer.geometry.bind(batcher.geometry, shader.glProgram);
        const batches = instructions.instructions;
        for(let i = 0; i < instructions.instructionSize; i++){
            const batch = batches[i];
            if (batch.size) {
                for(let j = 0; j < batch.textures.count; j++)renderer.texture.bind(batch.textures.textures[j], j);
                renderer.geometry.draw(batch.topology, batch.size, batch.start);
            }
        }
    }
    destroy() {
        this.shader.destroy(true);
        this.shader = null;
    }
}
/** @ignore */ $6357f62a8068da33$export$973696ef22548d24.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipesAdaptor
    ],
    name: "graphics"
};

});
parcelRegister("dKCGl", function(module, exports) {

$parcel$export(module.exports, "localUniformBit", () => $40db54a36492971d$export$1723ac05bd5e9336);
$parcel$export(module.exports, "localUniformBitGroup2", () => $40db54a36492971d$export$adb0f80794f644d9);
$parcel$export(module.exports, "localUniformBitGl", () => $40db54a36492971d$export$36099520d0a716a);
"use strict";
const $40db54a36492971d$export$1723ac05bd5e9336 = {
    name: "local-uniform-bit",
    vertex: {
        header: /* wgsl */ `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `,
        main: /* wgsl */ `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `,
        end: /* wgsl */ `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    }
};
const $40db54a36492971d$export$adb0f80794f644d9 = {
    ...$40db54a36492971d$export$1723ac05bd5e9336,
    vertex: {
        ...$40db54a36492971d$export$1723ac05bd5e9336.vertex,
        // replace the group!
        header: $40db54a36492971d$export$1723ac05bd5e9336.vertex.header.replace("group(1)", "group(2)")
    }
};
const $40db54a36492971d$export$36099520d0a716a = {
    name: "local-uniform-bit",
    vertex: {
        header: /* glsl */ `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `,
        main: /* glsl */ `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `,
        end: /* glsl */ `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    }
};

});


parcelRegister("5aREr", function(module, exports) {

$parcel$export(module.exports, "GlMeshAdaptor", () => $25f420f490f77761$export$9d77a952b0b834a5);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $aYOxl = parcelRequire("aYOxl");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $7hkN8 = parcelRequire("7hkN8");

var $7LCXQ = parcelRequire("7LCXQ");

var $4iNSL = parcelRequire("4iNSL");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
class $25f420f490f77761$export$9d77a952b0b834a5 {
    init() {
        const glProgram = (0, $aYOxl.compileHighShaderGlProgram)({
            name: "mesh",
            bits: [
                (0, $dKCGl.localUniformBitGl),
                (0, $7hkN8.textureBitGl),
                (0, $gnlmr.roundPixelsBitGl)
            ]
        });
        this._shader = new (0, $7LCXQ.Shader)({
            glProgram: glProgram,
            resources: {
                uTexture: (0, $4iNSL.Texture).EMPTY.source,
                textureUniforms: {
                    uTextureMatrix: {
                        type: "mat3x3<f32>",
                        value: new (0, $5xi4h.Matrix)()
                    }
                }
            }
        });
    }
    execute(meshPipe, mesh) {
        const renderer = meshPipe.renderer;
        let shader = mesh._shader;
        if (!shader) {
            shader = this._shader;
            const texture = mesh.texture;
            const source = texture.source;
            shader.resources.uTexture = source;
            shader.resources.uSampler = source.style;
            shader.resources.textureUniforms.uniforms.uTextureMatrix = texture.textureMatrix.mapCoord;
        } else if (!shader.glProgram) {
            (0, $1RpxL.warn)("Mesh shader has no glProgram", mesh.shader);
            return;
        }
        shader.groups[100] = renderer.globalUniforms.bindGroup;
        shader.groups[101] = meshPipe.localUniformsBindGroup;
        renderer.encoder.draw({
            geometry: mesh._geometry,
            shader: shader,
            state: mesh.state
        });
    }
    destroy() {
        this._shader.destroy(true);
        this._shader = null;
    }
}
$25f420f490f77761$export$9d77a952b0b834a5.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipesAdaptor
    ],
    name: "mesh"
};

});
parcelRegister("7hkN8", function(module, exports) {

$parcel$export(module.exports, "textureBit", () => $11610874ebd40abe$export$db13c76603bca4d1);
$parcel$export(module.exports, "textureBitGl", () => $11610874ebd40abe$export$dfbe934dc5760b41);
"use strict";
const $11610874ebd40abe$export$db13c76603bca4d1 = {
    name: "texture-bit",
    vertex: {
        header: /* wgsl */ `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `,
        main: /* wgsl */ `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    },
    fragment: {
        header: /* wgsl */ `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;


        `,
        main: /* wgsl */ `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    }
};
const $11610874ebd40abe$export$dfbe934dc5760b41 = {
    name: "texture-bit",
    vertex: {
        header: /* glsl */ `
            uniform mat3 uTextureMatrix;
        `,
        main: /* glsl */ `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    },
    fragment: {
        header: /* glsl */ `
        uniform sampler2D uTexture;


        `,
        main: /* glsl */ `
            outColor = texture(uTexture, vUV);
        `
    }
};

});


parcelRegister("7ogwP", function(module, exports) {

$parcel$export(module.exports, "GlBatchAdaptor", () => $1fd9206e68522645$export$3a163a0d7700c616);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");
"use strict";
class $1fd9206e68522645$export$3a163a0d7700c616 {
    constructor(){
        this._tempState = (0, $fx0Zy.State).for2d();
        /**
     * We only want to sync the a batched shaders uniforms once on first use
     * this is a hash of shader uids to a boolean value.  When the shader is first bound
     * we set the value to true.  When the shader is bound again we check the value and
     * if it is true we know that the uniforms have already been synced and we skip it.
     */ this._didUploadHash = {};
    }
    init(batcherPipe) {
        batcherPipe.renderer.runners.contextChange.add(this);
    }
    contextChange() {
        this._didUploadHash = {};
    }
    start(batchPipe, geometry, shader) {
        const renderer = batchPipe.renderer;
        const didUpload = this._didUploadHash[shader.uid];
        renderer.shader.bind(shader, didUpload);
        if (!didUpload) this._didUploadHash[shader.uid] = true;
        renderer.shader.updateUniformGroup(renderer.globalUniforms.uniformGroup);
        renderer.geometry.bind(geometry, shader.glProgram);
    }
    execute(batchPipe, batch) {
        const renderer = batchPipe.renderer;
        this._tempState.blendMode = batch.blendMode;
        renderer.state.set(this._tempState);
        const textures = batch.textures.textures;
        for(let i = 0; i < batch.textures.count; i++)renderer.texture.bind(textures[i], i);
        renderer.geometry.draw(batch.topology, batch.size, batch.start);
    }
}
/** @ignore */ $1fd9206e68522645$export$3a163a0d7700c616.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipesAdaptor
    ],
    name: "batch"
};

});

parcelRegister("k0jeB", function(module, exports) {

$parcel$export(module.exports, "GlBufferSystem", () => $09a6fb5156c5d91d$export$e361bc2ee7fe27c6);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $1T7Iy = parcelRequire("1T7Iy");

var $7LyGy = parcelRequire("7LyGy");

var $8bVSg = parcelRequire("8bVSg");
"use strict";
class $09a6fb5156c5d91d$export$e361bc2ee7fe27c6 {
    /**
   * @param {Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        /** Cache keeping track of the base bound buffer bases */ this._boundBufferBases = /* @__PURE__ */ Object.create(null);
        this._minBaseLocation = 0;
        this._nextBindBaseIndex = this._minBaseLocation;
        this._bindCallId = 0;
        this._renderer = renderer;
        this._managedBuffers = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            onUnload: this.onBufferUnload.bind(this),
            name: "glBuffer"
        });
    }
    /** @ignore */ destroy() {
        this._managedBuffers.destroy();
        this._renderer = null;
        this._gl = null;
        this._boundBufferBases = {};
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this._gl = this._renderer.gl;
        this.destroyAll(true);
        this._maxBindings = this._renderer.limits.maxUniformBindings;
    }
    getGlBuffer(buffer) {
        buffer._gcLastUsed = this._renderer.gc.now;
        return buffer._gpuData[this._renderer.uid] || this.createGLBuffer(buffer);
    }
    /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */ bind(buffer) {
        const { _gl: gl } = this;
        const glBuffer = this.getGlBuffer(buffer);
        gl.bindBuffer(glBuffer.type, glBuffer.buffer);
    }
    /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */ bindBufferBase(glBuffer, index) {
        const { _gl: gl } = this;
        if (this._boundBufferBases[index] !== glBuffer) {
            this._boundBufferBases[index] = glBuffer;
            glBuffer._lastBindBaseLocation = index;
            gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    }
    nextBindBase(hasTransformFeedback) {
        this._bindCallId++;
        this._minBaseLocation = 0;
        if (hasTransformFeedback) {
            this._boundBufferBases[0] = null;
            this._minBaseLocation = 1;
            if (this._nextBindBaseIndex < 1) this._nextBindBaseIndex = 1;
        }
    }
    freeLocationForBufferBase(glBuffer) {
        let freeIndex = this.getLastBindBaseLocation(glBuffer);
        if (freeIndex >= this._minBaseLocation) {
            glBuffer._lastBindCallId = this._bindCallId;
            return freeIndex;
        }
        let loop = 0;
        let nextIndex = this._nextBindBaseIndex;
        while(loop < 2){
            if (nextIndex >= this._maxBindings) {
                nextIndex = this._minBaseLocation;
                loop++;
            }
            const curBuf = this._boundBufferBases[nextIndex];
            if (curBuf && curBuf._lastBindCallId === this._bindCallId) {
                nextIndex++;
                continue;
            }
            break;
        }
        freeIndex = nextIndex;
        this._nextBindBaseIndex = nextIndex + 1;
        if (loop >= 2) return -1;
        glBuffer._lastBindCallId = this._bindCallId;
        this._boundBufferBases[freeIndex] = null;
        return freeIndex;
    }
    getLastBindBaseLocation(glBuffer) {
        const index = glBuffer._lastBindBaseLocation;
        if (this._boundBufferBases[index] === glBuffer) return index;
        return -1;
    }
    /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */ bindBufferRange(glBuffer, index, offset, size) {
        const { _gl: gl } = this;
        offset || (offset = 0);
        index || (index = 0);
        this._boundBufferBases[index] = null;
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, size || 256);
    }
    /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */ updateBuffer(buffer) {
        const { _gl: gl } = this;
        const glBuffer = this.getGlBuffer(buffer);
        if (buffer._updateID === glBuffer.updateID) return glBuffer;
        glBuffer.updateID = buffer._updateID;
        gl.bindBuffer(glBuffer.type, glBuffer.buffer);
        const data = buffer.data;
        const drawType = buffer.descriptor.usage & (0, $1T7Iy.BufferUsage).STATIC ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
        if (data) {
            if (glBuffer.byteLength >= data.byteLength) gl.bufferSubData(glBuffer.type, 0, data, 0, buffer._updateSize / data.BYTES_PER_ELEMENT);
            else {
                glBuffer.byteLength = data.byteLength;
                gl.bufferData(glBuffer.type, data, drawType);
            }
        } else {
            glBuffer.byteLength = buffer.descriptor.size;
            gl.bufferData(glBuffer.type, glBuffer.byteLength, drawType);
        }
        return glBuffer;
    }
    /**
   * dispose all WebGL resources of all managed buffers
   * @param contextLost
   */ destroyAll(contextLost = false) {
        this._managedBuffers.removeAll(contextLost);
    }
    onBufferUnload(buffer, contextLost = false) {
        const glBuffer = buffer._gpuData[this._renderer.uid];
        if (!glBuffer) return;
        if (!contextLost) this._gl.deleteBuffer(glBuffer.buffer);
    }
    /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */ createGLBuffer(buffer) {
        const { _gl: gl } = this;
        let type = (0, $7LyGy.BUFFER_TYPE).ARRAY_BUFFER;
        if (buffer.descriptor.usage & (0, $1T7Iy.BufferUsage).INDEX) type = (0, $7LyGy.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        else if (buffer.descriptor.usage & (0, $1T7Iy.BufferUsage).UNIFORM) type = (0, $7LyGy.BUFFER_TYPE).UNIFORM_BUFFER;
        const glBuffer = new (0, $8bVSg.GlBuffer)(gl.createBuffer(), type);
        buffer._gpuData[this._renderer.uid] = glBuffer;
        this._managedBuffers.add(buffer);
        return glBuffer;
    }
    resetState() {
        this._boundBufferBases = /* @__PURE__ */ Object.create(null);
    }
}
/** @ignore */ $09a6fb5156c5d91d$export$e361bc2ee7fe27c6.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "buffer"
};

});
parcelRegister("7LyGy", function(module, exports) {

$parcel$export(module.exports, "BUFFER_TYPE", () => $9b39a96085f342c2$export$b595a7e482202b96);
"use strict";
var $9b39a96085f342c2$export$b595a7e482202b96 = /* @__PURE__ */ ((BUFFER_TYPE2)=>{
    BUFFER_TYPE2[BUFFER_TYPE2["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE2[BUFFER_TYPE2["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    BUFFER_TYPE2[BUFFER_TYPE2["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
    return BUFFER_TYPE2;
})($9b39a96085f342c2$export$b595a7e482202b96 || {});

});

parcelRegister("8bVSg", function(module, exports) {

$parcel$export(module.exports, "GlBuffer", () => $f62fe2206ccf7e73$export$e785124e31725f3f);
"use strict";
class $f62fe2206ccf7e73$export$e785124e31725f3f {
    constructor(buffer, type){
        this._lastBindBaseLocation = -1;
        this._lastBindCallId = -1;
        this.buffer = buffer || null;
        this.updateID = -1;
        this.byteLength = -1;
        this.type = type;
    }
    destroy() {
        this.buffer = null;
        this.updateID = -1;
        this.byteLength = -1;
        this.type = -1;
        this._lastBindBaseLocation = -1;
        this._lastBindCallId = -1;
    }
}

});


parcelRegister("a66qS", function(module, exports) {

$parcel$export(module.exports, "GlContextSystem", () => $c8759d3c1f825e77$export$6efe747e26df7565);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
const $c8759d3c1f825e77$var$_GlContextSystem = class _GlContextSystem {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        /**
     * Features supported by current renderer.
     * @type {object}
     * @readonly
     */ this.supports = {
            /** Support for 32-bit indices buffer. */ uint32Indices: true,
            /** Support for UniformBufferObjects */ uniformBufferObject: true,
            /** Support for VertexArrayObjects */ vertexArrayObject: true,
            /** Support for SRGB texture format */ srgbTextures: true,
            /** Support for wrapping modes if a texture is non-power of two */ nonPowOf2wrapping: true,
            /** Support for MSAA (antialiasing of dynamic textures) */ msaa: true,
            /** Support for mipmaps if a texture is non-power of two */ nonPowOf2mipmaps: true
        };
        this._renderer = renderer;
        this.extensions = /* @__PURE__ */ Object.create(null);
        this.handleContextLost = this.handleContextLost.bind(this);
        this.handleContextRestored = this.handleContextRestored.bind(this);
    }
    /**
   * `true` if the context is lost
   * @readonly
   */ get isLost() {
        return !this.gl || this.gl.isContextLost();
    }
    /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */ contextChange(gl) {
        this.gl = gl;
        this._renderer.gl = gl;
    }
    init(options) {
        options = {
            ..._GlContextSystem.defaultOptions,
            ...options
        };
        let multiView = this.multiView = options.multiView;
        if (options.context && multiView) {
            (0, $1RpxL.warn)("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together.");
            multiView = false;
        }
        if (multiView) this.canvas = (0, $gLw46.DOMAdapter).get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height);
        else this.canvas = this._renderer.view.canvas;
        if (options.context) this.initFromContext(options.context);
        else {
            const alpha = this._renderer.background.alpha < 1;
            const premultipliedAlpha = options.premultipliedAlpha ?? true;
            const antialias = options.antialias && !this._renderer.backBuffer.useBackBuffer;
            this.createContext(options.preferWebGLVersion, {
                alpha: alpha,
                premultipliedAlpha: premultipliedAlpha,
                antialias: antialias,
                stencil: true,
                preserveDrawingBuffer: options.preserveDrawingBuffer,
                powerPreference: options.powerPreference ?? "default"
            });
        }
    }
    ensureCanvasSize(targetCanvas) {
        if (!this.multiView) {
            if (targetCanvas !== this.canvas) (0, $1RpxL.warn)("multiView is disabled, but targetCanvas is not the main canvas");
            return;
        }
        const { canvas: canvas } = this;
        if (canvas.width < targetCanvas.width || canvas.height < targetCanvas.height) {
            canvas.width = Math.max(targetCanvas.width, targetCanvas.width);
            canvas.height = Math.max(targetCanvas.height, targetCanvas.height);
        }
    }
    /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */ initFromContext(gl) {
        this.gl = gl;
        this.webGLVersion = gl instanceof (0, $gLw46.DOMAdapter).get().getWebGLRenderingContext() ? 1 : 2;
        this.getExtensions();
        this.validateContext(gl);
        this._renderer.runners.contextChange.emit(gl);
        const element = this._renderer.view.canvas;
        element.addEventListener("webglcontextlost", this.handleContextLost, false);
        element.addEventListener("webglcontextrestored", this.handleContextRestored, false);
    }
    /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */ createContext(preferWebGLVersion, options) {
        let gl;
        const canvas = this.canvas;
        if (preferWebGLVersion === 2) gl = canvas.getContext("webgl2", options);
        if (!gl) {
            gl = canvas.getContext("webgl", options);
            if (!gl) throw new Error("This browser does not support WebGL. Try using the canvas renderer");
        }
        this.gl = gl;
        this.initFromContext(this.gl);
    }
    /** Auto-populate the {@link GlContextSystem.extensions extensions}. */ getExtensions() {
        const { gl: gl } = this;
        const common = {
            anisotropicFiltering: gl.getExtension("EXT_texture_filter_anisotropic"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            s3tc: gl.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: gl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            // eslint-disable-line camelcase
            etc: gl.getExtension("WEBGL_compressed_texture_etc"),
            etc1: gl.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: gl.getExtension("WEBGL_compressed_texture_atc"),
            astc: gl.getExtension("WEBGL_compressed_texture_astc"),
            bptc: gl.getExtension("EXT_texture_compression_bptc"),
            rgtc: gl.getExtension("EXT_texture_compression_rgtc"),
            loseContext: gl.getExtension("WEBGL_lose_context")
        };
        if (this.webGLVersion === 1) this.extensions = {
            ...common,
            drawBuffers: gl.getExtension("WEBGL_draw_buffers"),
            depthTexture: gl.getExtension("WEBGL_depth_texture"),
            vertexArrayObject: gl.getExtension("OES_vertex_array_object") || gl.getExtension("MOZ_OES_vertex_array_object") || gl.getExtension("WEBKIT_OES_vertex_array_object"),
            uint32ElementIndex: gl.getExtension("OES_element_index_uint"),
            // Floats and half-floats
            floatTexture: gl.getExtension("OES_texture_float"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            textureHalfFloat: gl.getExtension("OES_texture_half_float"),
            textureHalfFloatLinear: gl.getExtension("OES_texture_half_float_linear"),
            vertexAttribDivisorANGLE: gl.getExtension("ANGLE_instanced_arrays"),
            srgb: gl.getExtension("EXT_sRGB")
        };
        else {
            this.extensions = {
                ...common,
                colorBufferFloat: gl.getExtension("EXT_color_buffer_float")
            };
            const provokeExt = gl.getExtension("WEBGL_provoking_vertex");
            if (provokeExt) provokeExt.provokingVertexWEBGL(provokeExt.FIRST_VERTEX_CONVENTION_WEBGL);
        }
    }
    /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */ handleContextLost(event) {
        event.preventDefault();
        if (this._contextLossForced) {
            this._contextLossForced = false;
            setTimeout(()=>{
                if (this.gl.isContextLost()) this.extensions.loseContext?.restoreContext();
            }, 0);
        }
    }
    /** Handles a restored webgl context. */ handleContextRestored() {
        this.getExtensions();
        this._renderer.runners.contextChange.emit(this.gl);
    }
    destroy() {
        const element = this._renderer.view.canvas;
        this._renderer = null;
        element.removeEventListener("webglcontextlost", this.handleContextLost);
        element.removeEventListener("webglcontextrestored", this.handleContextRestored);
        this.gl.useProgram(null);
        this.extensions.loseContext?.loseContext();
    }
    /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */ forceContextLoss() {
        this.extensions.loseContext?.loseContext();
        this._contextLossForced = true;
    }
    /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */ validateContext(gl) {
        const attributes = gl.getContextAttributes();
        if (attributes && !attributes.stencil) (0, $1RpxL.warn)("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
        const supports = this.supports;
        const isWebGl2 = this.webGLVersion === 2;
        const extensions = this.extensions;
        supports.uint32Indices = isWebGl2 || !!extensions.uint32ElementIndex;
        supports.uniformBufferObject = isWebGl2;
        supports.vertexArrayObject = isWebGl2 || !!extensions.vertexArrayObject;
        supports.srgbTextures = isWebGl2 || !!extensions.srgb;
        supports.nonPowOf2wrapping = isWebGl2;
        supports.nonPowOf2mipmaps = isWebGl2;
        supports.msaa = isWebGl2;
        if (!supports.uint32Indices) (0, $1RpxL.warn)("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
    }
};
/** @ignore */ $c8759d3c1f825e77$var$_GlContextSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "context"
};
/** The default options for the system. */ $c8759d3c1f825e77$var$_GlContextSystem.defaultOptions = {
    /**
   * {@link WebGLOptions.context}
   * @default null
   */ context: null,
    /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */ premultipliedAlpha: true,
    /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */ preserveDrawingBuffer: false,
    /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */ powerPreference: void 0,
    /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */ preferWebGLVersion: 2,
    /**
   * {@link WebGLOptions.multiView}
   * @default false
   */ multiView: false
};
let $c8759d3c1f825e77$export$6efe747e26df7565 = $c8759d3c1f825e77$var$_GlContextSystem;

});

parcelRegister("4gUjT", function(module, exports) {

$parcel$export(module.exports, "GlGeometryGpuData", () => $7b3ddb34d38b75b9$export$eae033d33bf72519);
$parcel$export(module.exports, "GlGeometrySystem", () => $7b3ddb34d38b75b9$export$2ee3e1b0e7ef0cc8);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $eDWUK = parcelRequire("eDWUK");

var $5dp3e = parcelRequire("5dp3e");

var $4W7Q2 = parcelRequire("4W7Q2");
"use strict";
const $7b3ddb34d38b75b9$var$topologyToGlMap = {
    "point-list": 0,
    "line-list": 1,
    "line-strip": 3,
    "triangle-list": 4,
    "triangle-strip": 5
};
class $7b3ddb34d38b75b9$export$eae033d33bf72519 {
    constructor(){
        this.vaoCache = /* @__PURE__ */ Object.create(null);
    }
    destroy() {
        this.vaoCache = /* @__PURE__ */ Object.create(null);
    }
}
class $7b3ddb34d38b75b9$export$2ee3e1b0e7ef0cc8 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this._renderer = renderer;
        this._activeGeometry = null;
        this._activeVao = null;
        this.hasVao = true;
        this.hasInstance = true;
        this._managedGeometries = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            onUnload: this.onGeometryUnload.bind(this),
            name: "glGeometry"
        });
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        const gl = this.gl = this._renderer.gl;
        if (!this._renderer.context.supports.vertexArrayObject) throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
        this.destroyAll(true);
        const nativeVaoExtension = this._renderer.context.extensions.vertexArrayObject;
        if (nativeVaoExtension) {
            gl.createVertexArray = ()=>nativeVaoExtension.createVertexArrayOES();
            gl.bindVertexArray = (vao)=>nativeVaoExtension.bindVertexArrayOES(vao);
            gl.deleteVertexArray = (vao)=>nativeVaoExtension.deleteVertexArrayOES(vao);
        }
        const nativeInstancedExtension = this._renderer.context.extensions.vertexAttribDivisorANGLE;
        if (nativeInstancedExtension) {
            gl.drawArraysInstanced = (a, b, c, d)=>{
                nativeInstancedExtension.drawArraysInstancedANGLE(a, b, c, d);
            };
            gl.drawElementsInstanced = (a, b, c, d, e)=>{
                nativeInstancedExtension.drawElementsInstancedANGLE(a, b, c, d, e);
            };
            gl.vertexAttribDivisor = (a, b)=>nativeInstancedExtension.vertexAttribDivisorANGLE(a, b);
        }
        this._activeGeometry = null;
        this._activeVao = null;
    }
    /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */ bind(geometry, program) {
        const gl = this.gl;
        this._activeGeometry = geometry;
        const vao = this.getVao(geometry, program);
        if (this._activeVao !== vao) {
            this._activeVao = vao;
            gl.bindVertexArray(vao);
        }
        this.updateBuffers();
    }
    /** Reset and unbind any active VAO and geometry. */ resetState() {
        this.unbind();
    }
    /** Update buffers of the currently bound geometry. */ updateBuffers() {
        const geometry = this._activeGeometry;
        const bufferSystem = this._renderer.buffer;
        for(let i = 0; i < geometry.buffers.length; i++){
            const buffer = geometry.buffers[i];
            bufferSystem.updateBuffer(buffer);
        }
        geometry._gcLastUsed = this._renderer.gc.now;
    }
    /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */ checkCompatibility(geometry, program) {
        const geometryAttributes = geometry.attributes;
        const shaderAttributes = program._attributeData;
        for(const j in shaderAttributes){
            if (!geometryAttributes[j]) throw new Error(`shader and geometry incompatible, geometry missing the "${j}" attribute`);
        }
    }
    /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */ getSignature(geometry, program) {
        const attribs = geometry.attributes;
        const shaderAttributes = program._attributeData;
        const strings = [
            "g",
            geometry.uid
        ];
        for(const i in attribs)if (shaderAttributes[i]) strings.push(i, shaderAttributes[i].location);
        return strings.join("-");
    }
    getVao(geometry, program) {
        return geometry._gpuData[this._renderer.uid]?.vaoCache[program._key] || this.initGeometryVao(geometry, program);
    }
    /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */ initGeometryVao(geometry, program, _incRefCount = true) {
        const gl = this._renderer.gl;
        const bufferSystem = this._renderer.buffer;
        this._renderer.shader._getProgramData(program);
        this.checkCompatibility(geometry, program);
        const signature = this.getSignature(geometry, program);
        let gpuData = geometry._gpuData[this._renderer.uid];
        if (!gpuData) {
            gpuData = new $7b3ddb34d38b75b9$export$eae033d33bf72519();
            geometry._gpuData[this._renderer.uid] = gpuData;
            this._managedGeometries.add(geometry);
        }
        const vaoObjectHash = gpuData.vaoCache;
        let vao = vaoObjectHash[signature];
        if (vao) {
            vaoObjectHash[program._key] = vao;
            return vao;
        }
        (0, $5dp3e.ensureAttributes)(geometry, program._attributeData);
        const buffers = geometry.buffers;
        vao = gl.createVertexArray();
        gl.bindVertexArray(vao);
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            bufferSystem.bind(buffer);
        }
        this.activateVao(geometry, program);
        vaoObjectHash[program._key] = vao;
        vaoObjectHash[signature] = vao;
        gl.bindVertexArray(null);
        return vao;
    }
    onGeometryUnload(geometry, contextLost = false) {
        const gpuData = geometry._gpuData[this._renderer.uid];
        if (!gpuData) return;
        const vaoCache = gpuData.vaoCache;
        if (!contextLost) for(const i in vaoCache){
            if (this._activeVao !== vaoCache[i]) this.resetState();
            this.gl.deleteVertexArray(vaoCache[i]);
        }
    }
    /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ destroyAll(contextLost = false) {
        this._managedGeometries.removeAll(contextLost);
    }
    /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */ activateVao(geometry, program) {
        const gl = this._renderer.gl;
        const bufferSystem = this._renderer.buffer;
        const attributes = geometry.attributes;
        if (geometry.indexBuffer) bufferSystem.bind(geometry.indexBuffer);
        let lastBuffer = null;
        for(const j in attributes){
            const attribute = attributes[j];
            const buffer = attribute.buffer;
            const glBuffer = bufferSystem.getGlBuffer(buffer);
            const programAttrib = program._attributeData[j];
            if (programAttrib) {
                if (lastBuffer !== glBuffer) {
                    bufferSystem.bind(buffer);
                    lastBuffer = glBuffer;
                }
                const location = programAttrib.location;
                gl.enableVertexAttribArray(location);
                const attributeInfo = (0, $eDWUK.getAttributeInfoFromFormat)(attribute.format);
                const type = (0, $4W7Q2.getGlTypeFromFormat)(attribute.format);
                if (programAttrib.format?.substring(1, 4) === "int") gl.vertexAttribIPointer(location, attributeInfo.size, type, attribute.stride, attribute.offset);
                else gl.vertexAttribPointer(location, attributeInfo.size, type, attributeInfo.normalised, attribute.stride, attribute.offset);
                if (attribute.instance) {
                    if (this.hasInstance) {
                        const divisor = attribute.divisor ?? 1;
                        gl.vertexAttribDivisor(location, divisor);
                    } else throw new Error("geometry error, GPU Instancing is not supported on this device");
                }
            }
        }
    }
    /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   * @returns This instance of the geometry system.
   */ draw(topology, size, start, instanceCount) {
        const { gl: gl } = this._renderer;
        const geometry = this._activeGeometry;
        const glTopology = $7b3ddb34d38b75b9$var$topologyToGlMap[topology || geometry.topology];
        instanceCount ?? (instanceCount = geometry.instanceCount);
        if (geometry.indexBuffer) {
            const byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT;
            const glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            if (instanceCount !== 1) gl.drawElementsInstanced(glTopology, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount);
            else gl.drawElements(glTopology, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize);
        } else if (instanceCount !== 1) gl.drawArraysInstanced(glTopology, start || 0, size || geometry.getSize(), instanceCount);
        else gl.drawArrays(glTopology, start || 0, size || geometry.getSize());
        return this;
    }
    /** Unbind/reset everything. */ unbind() {
        this.gl.bindVertexArray(null);
        this._activeVao = null;
        this._activeGeometry = null;
    }
    destroy() {
        this._managedGeometries.destroy();
        this._renderer = null;
        this.gl = null;
        this._activeVao = null;
        this._activeGeometry = null;
    }
}
/** @ignore */ $7b3ddb34d38b75b9$export$2ee3e1b0e7ef0cc8.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "geometry"
};

});
parcelRegister("5dp3e", function(module, exports) {

$parcel$export(module.exports, "ensureAttributes", () => $fdd1e67cfa1634a7$export$abe4b4eea56679f6);

var $1RpxL = parcelRequire("1RpxL");

var $eDWUK = parcelRequire("eDWUK");
"use strict";
function $fdd1e67cfa1634a7$export$abe4b4eea56679f6(geometry, extractedData) {
    for(const i in geometry.attributes){
        const attribute = geometry.attributes[i];
        const attributeData = extractedData[i];
        if (attributeData) {
            attribute.format ?? (attribute.format = attributeData.format);
            attribute.offset ?? (attribute.offset = attributeData.offset);
            attribute.instance ?? (attribute.instance = attributeData.instance);
        } else (0, $1RpxL.warn)(`Attribute ${i} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
    }
    $fdd1e67cfa1634a7$var$ensureStartAndStride(geometry);
}
function $fdd1e67cfa1634a7$var$ensureStartAndStride(geometry) {
    const { buffers: buffers, attributes: attributes } = geometry;
    const tempStride = {};
    const tempStart = {};
    for(const j in buffers){
        const buffer = buffers[j];
        tempStride[buffer.uid] = 0;
        tempStart[buffer.uid] = 0;
    }
    for(const j in attributes){
        const attribute = attributes[j];
        tempStride[attribute.buffer.uid] += (0, $eDWUK.getAttributeInfoFromFormat)(attribute.format).stride;
    }
    for(const j in attributes){
        const attribute = attributes[j];
        attribute.stride ?? (attribute.stride = tempStride[attribute.buffer.uid]);
        attribute.start ?? (attribute.start = tempStart[attribute.buffer.uid]);
        tempStart[attribute.buffer.uid] += (0, $eDWUK.getAttributeInfoFromFormat)(attribute.format).stride;
    }
}

});

parcelRegister("4W7Q2", function(module, exports) {

$parcel$export(module.exports, "getGlTypeFromFormat", () => $d17256a30593f14a$export$7d188452319c78cb);

var $d0Wi0 = parcelRequire("d0Wi0");
"use strict";
const $d17256a30593f14a$var$infoMap = {
    uint8x2: (0, $d0Wi0.GL_TYPES).UNSIGNED_BYTE,
    uint8x4: (0, $d0Wi0.GL_TYPES).UNSIGNED_BYTE,
    sint8x2: (0, $d0Wi0.GL_TYPES).BYTE,
    sint8x4: (0, $d0Wi0.GL_TYPES).BYTE,
    unorm8x2: (0, $d0Wi0.GL_TYPES).UNSIGNED_BYTE,
    unorm8x4: (0, $d0Wi0.GL_TYPES).UNSIGNED_BYTE,
    snorm8x2: (0, $d0Wi0.GL_TYPES).BYTE,
    snorm8x4: (0, $d0Wi0.GL_TYPES).BYTE,
    uint16x2: (0, $d0Wi0.GL_TYPES).UNSIGNED_SHORT,
    uint16x4: (0, $d0Wi0.GL_TYPES).UNSIGNED_SHORT,
    sint16x2: (0, $d0Wi0.GL_TYPES).SHORT,
    sint16x4: (0, $d0Wi0.GL_TYPES).SHORT,
    unorm16x2: (0, $d0Wi0.GL_TYPES).UNSIGNED_SHORT,
    unorm16x4: (0, $d0Wi0.GL_TYPES).UNSIGNED_SHORT,
    snorm16x2: (0, $d0Wi0.GL_TYPES).SHORT,
    snorm16x4: (0, $d0Wi0.GL_TYPES).SHORT,
    float16x2: (0, $d0Wi0.GL_TYPES).HALF_FLOAT,
    float16x4: (0, $d0Wi0.GL_TYPES).HALF_FLOAT,
    float32: (0, $d0Wi0.GL_TYPES).FLOAT,
    float32x2: (0, $d0Wi0.GL_TYPES).FLOAT,
    float32x3: (0, $d0Wi0.GL_TYPES).FLOAT,
    float32x4: (0, $d0Wi0.GL_TYPES).FLOAT,
    uint32: (0, $d0Wi0.GL_TYPES).UNSIGNED_INT,
    uint32x2: (0, $d0Wi0.GL_TYPES).UNSIGNED_INT,
    uint32x3: (0, $d0Wi0.GL_TYPES).UNSIGNED_INT,
    uint32x4: (0, $d0Wi0.GL_TYPES).UNSIGNED_INT,
    sint32: (0, $d0Wi0.GL_TYPES).INT,
    sint32x2: (0, $d0Wi0.GL_TYPES).INT,
    sint32x3: (0, $d0Wi0.GL_TYPES).INT,
    sint32x4: (0, $d0Wi0.GL_TYPES).INT
};
function $d17256a30593f14a$export$7d188452319c78cb(format) {
    return $d17256a30593f14a$var$infoMap[format] ?? $d17256a30593f14a$var$infoMap.float32;
}

});
parcelRegister("d0Wi0", function(module, exports) {

$parcel$export(module.exports, "GL_FORMATS", () => $f0af636332ea158f$export$65676f49f82312ef);
$parcel$export(module.exports, "GL_TARGETS", () => $f0af636332ea158f$export$e58b55460af355b7);
$parcel$export(module.exports, "GL_WRAP_MODES", () => $f0af636332ea158f$export$78720182cc3ed053);
$parcel$export(module.exports, "GL_TYPES", () => $f0af636332ea158f$export$4d480d1b811469a7);
"use strict";
var $f0af636332ea158f$export$65676f49f82312ef = /* @__PURE__ */ ((GL_FORMATS2)=>{
    GL_FORMATS2[GL_FORMATS2["RGBA"] = 6408] = "RGBA";
    GL_FORMATS2[GL_FORMATS2["RGB"] = 6407] = "RGB";
    GL_FORMATS2[GL_FORMATS2["RG"] = 33319] = "RG";
    GL_FORMATS2[GL_FORMATS2["RED"] = 6403] = "RED";
    GL_FORMATS2[GL_FORMATS2["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RG_INTEGER"] = 33320] = "RG_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RED_INTEGER"] = 36244] = "RED_INTEGER";
    GL_FORMATS2[GL_FORMATS2["ALPHA"] = 6406] = "ALPHA";
    GL_FORMATS2[GL_FORMATS2["LUMINANCE"] = 6409] = "LUMINANCE";
    GL_FORMATS2[GL_FORMATS2["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    GL_FORMATS2[GL_FORMATS2["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    GL_FORMATS2[GL_FORMATS2["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
    return GL_FORMATS2;
})($f0af636332ea158f$export$65676f49f82312ef || {});
var $f0af636332ea158f$export$e58b55460af355b7 = /* @__PURE__ */ ((GL_TARGETS2)=>{
    GL_TARGETS2[GL_TARGETS2["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    GL_TARGETS2[GL_TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
    return GL_TARGETS2;
})($f0af636332ea158f$export$e58b55460af355b7 || {});
var $f0af636332ea158f$export$78720182cc3ed053 = /* @__PURE__ */ ((GL_WRAP_MODES2)=>{
    GL_WRAP_MODES2[GL_WRAP_MODES2["CLAMP"] = 33071] = "CLAMP";
    GL_WRAP_MODES2[GL_WRAP_MODES2["REPEAT"] = 10497] = "REPEAT";
    GL_WRAP_MODES2[GL_WRAP_MODES2["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
    return GL_WRAP_MODES2;
})($f0af636332ea158f$export$78720182cc3ed053 || {});
var $f0af636332ea158f$export$4d480d1b811469a7 = /* @__PURE__ */ ((GL_TYPES2)=>{
    GL_TYPES2[GL_TYPES2["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    GL_TYPES2[GL_TYPES2["BYTE"] = 5120] = "BYTE";
    GL_TYPES2[GL_TYPES2["SHORT"] = 5122] = "SHORT";
    GL_TYPES2[GL_TYPES2["INT"] = 5124] = "INT";
    GL_TYPES2[GL_TYPES2["FLOAT"] = 5126] = "FLOAT";
    GL_TYPES2[GL_TYPES2["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    GL_TYPES2[GL_TYPES2["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
    return GL_TYPES2;
})($f0af636332ea158f$export$4d480d1b811469a7 || {});

});



parcelRegister("1k36i", function(module, exports) {

$parcel$export(module.exports, "GlBackBufferSystem", () => $a5144dd2628ff513$export$b7a84fc7768ed0dc);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1RpxL = parcelRequire("1RpxL");

var $1T4Gr = parcelRequire("1T4Gr");

var $7LCXQ = parcelRequire("7LCXQ");

var $fx0Zy = parcelRequire("fx0Zy");

var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");

var $4kU4M = parcelRequire("4kU4M");
"use strict";
const $a5144dd2628ff513$var$bigTriangleGeometry = new (0, $1T4Gr.Geometry)({
    attributes: {
        aPosition: [
            -1,
            -1,
            // Bottom left corner
            3,
            -1,
            // Bottom right corner, extending beyond right edge
            -1,
            3
        ]
    }
});
const $a5144dd2628ff513$var$_GlBackBufferSystem = class _GlBackBufferSystem {
    constructor(renderer){
        /** if true, the back buffer is used */ this.useBackBuffer = false;
        this._useBackBufferThisRender = false;
        this._renderer = renderer;
    }
    init(options = {}) {
        const { useBackBuffer: useBackBuffer, antialias: antialias } = {
            ..._GlBackBufferSystem.defaultOptions,
            ...options
        };
        this.useBackBuffer = useBackBuffer;
        this._antialias = antialias;
        if (!this._renderer.context.supports.msaa) {
            (0, $1RpxL.warn)("antialiasing, is not supported on when using the back buffer");
            this._antialias = false;
        }
        this._state = (0, $fx0Zy.State).for2d();
        const bigTriangleProgram = new (0, $4kU4M.GlProgram)({
            vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
            fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
            name: "big-triangle"
        });
        this._bigTriangleShader = new (0, $7LCXQ.Shader)({
            glProgram: bigTriangleProgram,
            resources: {
                uTexture: (0, $4iNSL.Texture).WHITE.source
            }
        });
    }
    /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */ renderStart(options) {
        const renderTarget = this._renderer.renderTarget.getRenderTarget(options.target);
        this._useBackBufferThisRender = this.useBackBuffer && !!renderTarget.isRoot;
        if (this._useBackBufferThisRender) {
            const renderTarget2 = this._renderer.renderTarget.getRenderTarget(options.target);
            this._targetTexture = renderTarget2.colorTexture;
            options.target = this._getBackBufferTexture(renderTarget2.colorTexture);
        }
    }
    renderEnd() {
        this._presentBackBuffer();
    }
    _presentBackBuffer() {
        const renderer = this._renderer;
        renderer.renderTarget.finishRenderPass();
        if (!this._useBackBufferThisRender) return;
        renderer.renderTarget.bind(this._targetTexture, false);
        this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source;
        renderer.encoder.draw({
            geometry: $a5144dd2628ff513$var$bigTriangleGeometry,
            shader: this._bigTriangleShader,
            state: this._state
        });
    }
    _getBackBufferTexture(targetSourceTexture) {
        this._backBufferTexture = this._backBufferTexture || new (0, $4iNSL.Texture)({
            source: new (0, $gmQ4R.TextureSource)({
                width: targetSourceTexture.width,
                height: targetSourceTexture.height,
                resolution: targetSourceTexture._resolution,
                antialias: this._antialias
            })
        });
        this._backBufferTexture.source.resize(targetSourceTexture.width, targetSourceTexture.height, targetSourceTexture._resolution);
        return this._backBufferTexture;
    }
    /** destroys the back buffer */ destroy() {
        if (this._backBufferTexture) {
            this._backBufferTexture.destroy();
            this._backBufferTexture = null;
        }
    }
};
/** @ignore */ $a5144dd2628ff513$var$_GlBackBufferSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "backBuffer",
    priority: 1
};
/** default options for the back buffer system */ $a5144dd2628ff513$var$_GlBackBufferSystem.defaultOptions = {
    /** if true will use the back buffer where required */ useBackBuffer: false
};
let $a5144dd2628ff513$export$b7a84fc7768ed0dc = $a5144dd2628ff513$var$_GlBackBufferSystem;

});

parcelRegister("hqwGc", function(module, exports) {

$parcel$export(module.exports, "GlColorMaskSystem", () => $4076d082179270e1$export$a3d248296e259116);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $4076d082179270e1$export$a3d248296e259116 {
    constructor(renderer){
        this._colorMaskCache = 15;
        this._renderer = renderer;
    }
    setMask(colorMask) {
        if (this._colorMaskCache === colorMask) return;
        this._colorMaskCache = colorMask;
        this._renderer.gl.colorMask(!!(colorMask & 8), !!(colorMask & 4), !!(colorMask & 2), !!(colorMask & 1));
    }
}
/** @ignore */ $4076d082179270e1$export$a3d248296e259116.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "colorMask"
};

});

parcelRegister("hJqSP", function(module, exports) {

$parcel$export(module.exports, "GlEncoderSystem", () => $214ef775a259bf84$export$9b8b7836a27ecb86);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $214ef775a259bf84$export$9b8b7836a27ecb86 {
    constructor(renderer){
        this.commandFinished = Promise.resolve();
        this._renderer = renderer;
    }
    setGeometry(geometry, shader) {
        this._renderer.geometry.bind(geometry, shader.glProgram);
    }
    finishRenderPass() {}
    draw(options) {
        const renderer = this._renderer;
        const { geometry: geometry, shader: shader, state: state, skipSync: skipSync, topology: type, size: size, start: start, instanceCount: instanceCount } = options;
        renderer.shader.bind(shader, skipSync);
        renderer.geometry.bind(geometry, renderer.shader._activeProgram);
        if (state) renderer.state.set(state);
        renderer.geometry.draw(type, size, start, instanceCount ?? geometry.instanceCount);
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $214ef775a259bf84$export$9b8b7836a27ecb86.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "encoder"
};

});

parcelRegister("epQ0R", function(module, exports) {

$parcel$export(module.exports, "GlLimitsSystem", () => $821b80974badfc2d$export$6dd5586312634673);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $igOXQ = parcelRequire("igOXQ");
"use strict";
class $821b80974badfc2d$export$6dd5586312634673 {
    constructor(renderer){
        this._renderer = renderer;
    }
    contextChange() {
        const gl = this._renderer.gl;
        this.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.maxBatchableTextures = (0, $igOXQ.checkMaxIfStatementsInShader)(this.maxTextures, gl);
        const isWebGl2 = this._renderer.context.webGLVersion === 2;
        this.maxUniformBindings = isWebGl2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
    }
    destroy() {}
}
/** @ignore */ $821b80974badfc2d$export$6dd5586312634673.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "limits"
};

});

parcelRegister("chYSB", function(module, exports) {

$parcel$export(module.exports, "GlStencilSystem", () => $01ca9de94b69de3a$export$3846305e84de1078);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $kcEAx = parcelRequire("kcEAx");

var $fYoss = parcelRequire("fYoss");
"use strict";
class $01ca9de94b69de3a$export$3846305e84de1078 {
    constructor(renderer){
        this._stencilCache = {
            enabled: false,
            stencilReference: 0,
            stencilMode: (0, $fYoss.STENCIL_MODES).NONE
        };
        this._renderTargetStencilState = /* @__PURE__ */ Object.create(null);
        renderer.renderTarget.onRenderTargetChange.add(this);
    }
    contextChange(gl) {
        this._gl = gl;
        this._comparisonFuncMapping = {
            always: gl.ALWAYS,
            never: gl.NEVER,
            equal: gl.EQUAL,
            "not-equal": gl.NOTEQUAL,
            less: gl.LESS,
            "less-equal": gl.LEQUAL,
            greater: gl.GREATER,
            "greater-equal": gl.GEQUAL
        };
        this._stencilOpsMapping = {
            keep: gl.KEEP,
            zero: gl.ZERO,
            replace: gl.REPLACE,
            invert: gl.INVERT,
            "increment-clamp": gl.INCR,
            "decrement-clamp": gl.DECR,
            "increment-wrap": gl.INCR_WRAP,
            "decrement-wrap": gl.DECR_WRAP
        };
        this.resetState();
    }
    onRenderTargetChange(renderTarget) {
        if (this._activeRenderTarget === renderTarget) return;
        this._activeRenderTarget = renderTarget;
        let stencilState = this._renderTargetStencilState[renderTarget.uid];
        if (!stencilState) stencilState = this._renderTargetStencilState[renderTarget.uid] = {
            stencilMode: (0, $fYoss.STENCIL_MODES).DISABLED,
            stencilReference: 0
        };
        this.setStencilMode(stencilState.stencilMode, stencilState.stencilReference);
    }
    resetState() {
        this._stencilCache.enabled = false;
        this._stencilCache.stencilMode = (0, $fYoss.STENCIL_MODES).NONE;
        this._stencilCache.stencilReference = 0;
    }
    setStencilMode(stencilMode, stencilReference) {
        const stencilState = this._renderTargetStencilState[this._activeRenderTarget.uid];
        const gl = this._gl;
        const mode = (0, $kcEAx.GpuStencilModesToPixi)[stencilMode];
        const _stencilCache = this._stencilCache;
        stencilState.stencilMode = stencilMode;
        stencilState.stencilReference = stencilReference;
        if (stencilMode === (0, $fYoss.STENCIL_MODES).DISABLED) {
            if (this._stencilCache.enabled) {
                this._stencilCache.enabled = false;
                gl.disable(gl.STENCIL_TEST);
            }
            return;
        }
        if (!this._stencilCache.enabled) {
            this._stencilCache.enabled = true;
            gl.enable(gl.STENCIL_TEST);
        }
        if (stencilMode !== _stencilCache.stencilMode || _stencilCache.stencilReference !== stencilReference) {
            _stencilCache.stencilMode = stencilMode;
            _stencilCache.stencilReference = stencilReference;
            gl.stencilFunc(this._comparisonFuncMapping[mode.stencilBack.compare], stencilReference, 255);
            gl.stencilOp(gl.KEEP, gl.KEEP, this._stencilOpsMapping[mode.stencilBack.passOp]);
        }
    }
}
/** @ignore */ $01ca9de94b69de3a$export$3846305e84de1078.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "stencil"
};

});
parcelRegister("kcEAx", function(module, exports) {

$parcel$export(module.exports, "GpuStencilModesToPixi", () => $3e11a0703371bc0d$export$861c1bf8bb2cddc7);

var $fYoss = parcelRequire("fYoss");
"use strict";
const $3e11a0703371bc0d$export$861c1bf8bb2cddc7 = [];
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).NONE] = void 0;
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).DISABLED] = {
    stencilWriteMask: 0,
    stencilReadMask: 0
};
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).RENDERING_MASK_ADD] = {
    stencilFront: {
        compare: "equal",
        passOp: "increment-clamp"
    },
    stencilBack: {
        compare: "equal",
        passOp: "increment-clamp"
    }
};
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).RENDERING_MASK_REMOVE] = {
    stencilFront: {
        compare: "equal",
        passOp: "decrement-clamp"
    },
    stencilBack: {
        compare: "equal",
        passOp: "decrement-clamp"
    }
};
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).MASK_ACTIVE] = {
    stencilWriteMask: 0,
    stencilFront: {
        compare: "equal",
        passOp: "keep"
    },
    stencilBack: {
        compare: "equal",
        passOp: "keep"
    }
};
$3e11a0703371bc0d$export$861c1bf8bb2cddc7[(0, $fYoss.STENCIL_MODES).INVERSE_MASK_ACTIVE] = {
    stencilWriteMask: 0,
    stencilFront: {
        compare: "not-equal",
        passOp: "keep"
    },
    stencilBack: {
        compare: "not-equal",
        passOp: "keep"
    }
};

});


parcelRegister("6FDbi", function(module, exports) {

$parcel$export(module.exports, "GlUboSystem", () => $5f4aa65422014bcd$export$ed85354ffed1ae01);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jSrmW = parcelRequire("jSrmW");

var $9z8Ce = parcelRequire("9z8Ce");

var $ag5k6 = parcelRequire("ag5k6");
"use strict";
class $5f4aa65422014bcd$export$ed85354ffed1ae01 extends (0, $jSrmW.UboSystem) {
    constructor(){
        super({
            createUboElements: (0, $9z8Ce.createUboElementsSTD40),
            generateUboSync: (0, $ag5k6.createUboSyncFunctionSTD40)
        });
    }
}
/** @ignore */ $5f4aa65422014bcd$export$ed85354ffed1ae01.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "ubo"
};

});
parcelRegister("jSrmW", function(module, exports) {

$parcel$export(module.exports, "UboSystem", () => $1723fe4d9e16d623$export$649c859891b4f4a9);

var $p4165 = parcelRequire("p4165");

var $2bJdA = parcelRequire("2bJdA");

var $1T7Iy = parcelRequire("1T7Iy");
"use strict";
class $1723fe4d9e16d623$export$649c859891b4f4a9 {
    constructor(adaptor){
        /** Cache of uniform buffer layouts and sync functions, so we don't have to re-create them */ this._syncFunctionHash = /* @__PURE__ */ Object.create(null);
        this._adaptor = adaptor;
        this._systemCheck();
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */ _systemCheck() {
        if (!(0, $p4165.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    ensureUniformGroup(uniformGroup) {
        const uniformData = this.getUniformGroupData(uniformGroup);
        uniformGroup.buffer || (uniformGroup.buffer = new (0, $2bJdA.Buffer)({
            data: new Float32Array(uniformData.layout.size / 4),
            usage: (0, $1T7Iy.BufferUsage).UNIFORM | (0, $1T7Iy.BufferUsage).COPY_DST
        }));
    }
    getUniformGroupData(uniformGroup) {
        return this._syncFunctionHash[uniformGroup._signature] || this._initUniformGroup(uniformGroup);
    }
    _initUniformGroup(uniformGroup) {
        const uniformGroupSignature = uniformGroup._signature;
        let uniformData = this._syncFunctionHash[uniformGroupSignature];
        if (!uniformData) {
            const elements = Object.keys(uniformGroup.uniformStructures).map((i)=>uniformGroup.uniformStructures[i]);
            const layout = this._adaptor.createUboElements(elements);
            const syncFunction = this._generateUboSync(layout.uboElements);
            uniformData = this._syncFunctionHash[uniformGroupSignature] = {
                layout: layout,
                syncFunction: syncFunction
            };
        }
        return this._syncFunctionHash[uniformGroupSignature];
    }
    _generateUboSync(uboElements) {
        return this._adaptor.generateUboSync(uboElements);
    }
    syncUniformGroup(uniformGroup, data, offset) {
        const uniformGroupData = this.getUniformGroupData(uniformGroup);
        uniformGroup.buffer || (uniformGroup.buffer = new (0, $2bJdA.Buffer)({
            data: new Float32Array(uniformGroupData.layout.size / 4),
            usage: (0, $1T7Iy.BufferUsage).UNIFORM | (0, $1T7Iy.BufferUsage).COPY_DST
        }));
        let dataInt32 = null;
        if (!data) {
            data = uniformGroup.buffer.data;
            dataInt32 = uniformGroup.buffer.dataInt32;
        }
        offset || (offset = 0);
        uniformGroupData.syncFunction(uniformGroup.uniforms, data, dataInt32, offset);
        return true;
    }
    updateUniformGroup(uniformGroup) {
        if (uniformGroup.isStatic && !uniformGroup._dirtyId) return false;
        uniformGroup._dirtyId = 0;
        const synced = this.syncUniformGroup(uniformGroup);
        uniformGroup.buffer.update();
        return synced;
    }
    destroy() {
        this._syncFunctionHash = null;
    }
}

});

parcelRegister("9z8Ce", function(module, exports) {

$parcel$export(module.exports, "WGSL_TO_STD40_SIZE", () => $62d5b1520d193784$export$44caba1858fd4b77);
$parcel$export(module.exports, "createUboElementsSTD40", () => $62d5b1520d193784$export$aafd0047b5156d22);
"use strict";
const $62d5b1520d193784$export$44caba1858fd4b77 = {
    f32: 4,
    i32: 4,
    "vec2<f32>": 8,
    "vec3<f32>": 12,
    "vec4<f32>": 16,
    "vec2<i32>": 8,
    "vec3<i32>": 12,
    "vec4<i32>": 16,
    "mat2x2<f32>": 32,
    "mat3x3<f32>": 48,
    "mat4x4<f32>": 64
};
function $62d5b1520d193784$export$aafd0047b5156d22(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            size: 0
        }));
    const chunkSize = 16;
    let size = 0;
    let offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        size = $62d5b1520d193784$export$44caba1858fd4b77[uboElement.data.type];
        if (!size) throw new Error(`Unknown type ${uboElement.data.type}`);
        if (uboElement.data.size > 1) size = Math.max(size, chunkSize) * uboElement.data.size;
        const boundary = size === 12 ? 16 : size;
        uboElement.size = size;
        const curOffset = offset % chunkSize;
        if (curOffset > 0 && chunkSize - curOffset < boundary) offset += (chunkSize - curOffset) % 16;
        else offset += (size - curOffset % size) % size;
        uboElement.offset = offset;
        offset += size;
    }
    offset = Math.ceil(offset / 16) * 16;
    return {
        uboElements: uboElements,
        size: offset
    };
}

});

parcelRegister("ag5k6", function(module, exports) {

$parcel$export(module.exports, "createUboSyncFunctionSTD40", () => $0e1c2d382a7b065b$export$657524d36b99cfb7);

var $9dsH7 = parcelRequire("9dsH7");

var $ktXe2 = parcelRequire("ktXe2");

var $8Cr41 = parcelRequire("8Cr41");
"use strict";
function $0e1c2d382a7b065b$export$657524d36b99cfb7(uboElements) {
    return (0, $9dsH7.createUboSyncFunction)(uboElements, "uboStd40", (0, $8Cr41.generateArraySyncSTD40), (0, $ktXe2.uboSyncFunctionsSTD40));
}

});
parcelRegister("9dsH7", function(module, exports) {

$parcel$export(module.exports, "createUboSyncFunction", () => $1fc28b5b9cc5e421$export$d72cdd5376f8af8e);

var $1oQYm = parcelRequire("1oQYm");
"use strict";
function $1fc28b5b9cc5e421$export$d72cdd5376f8af8e(uboElements, parserCode, arrayGenerationFunction, singleSettersMap) {
    const funcFragments = [
        `
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `
    ];
    let prev = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        const name = uboElement.data.name;
        let parsed = false;
        let offset = 0;
        for(let j = 0; j < (0, $1oQYm.uniformParsers).length; j++){
            const uniformParser = (0, $1oQYm.uniformParsers)[j];
            if (uniformParser.test(uboElement.data)) {
                offset = uboElement.offset / 4;
                funcFragments.push(`name = "${name}";`, `offset += ${offset - prev};`, (0, $1oQYm.uniformParsers)[j][parserCode] || (0, $1oQYm.uniformParsers)[j].ubo);
                parsed = true;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                offset = uboElement.offset / 4;
                funcFragments.push(arrayGenerationFunction(uboElement, offset - prev));
            } else {
                const template = singleSettersMap[uboElement.data.type];
                offset = uboElement.offset / 4;
                funcFragments.push(/* wgsl */ `
                    v = uv.${name};
                    offset += ${offset - prev};
                    ${template};
                `);
            }
        }
        prev = offset;
    }
    const fragmentSrc = funcFragments.join("\n");
    return new Function("uv", "data", "dataInt32", "offset", fragmentSrc);
}

});
parcelRegister("1oQYm", function(module, exports) {

$parcel$export(module.exports, "uniformParsers", () => $623d541dc63c5600$export$cf9f41a7e506e2d2);
"use strict";
const $623d541dc63c5600$export$cf9f41a7e506e2d2 = [
    // uploading pixi matrix object to mat3
    {
        type: "mat3x3<f32>",
        test: (data)=>{
            const value = data.value;
            return value.a !== void 0;
        },
        ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
        uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
    },
    // uploading a pixi rectangle as a vec4
    {
        type: "vec4<f32>",
        test: (data)=>data.type === "vec4<f32>" && data.size === 1 && data.value.width !== void 0,
        ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
        uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
    },
    // uploading a pixi point as a vec2
    {
        type: "vec2<f32>",
        test: (data)=>data.type === "vec2<f32>" && data.size === 1 && data.value.x !== void 0,
        ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
        uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
    },
    // uploading a pixi color as a vec4
    {
        type: "vec4<f32>",
        test: (data)=>data.type === "vec4<f32>" && data.size === 1 && data.value.red !== void 0,
        ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
        uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
    },
    // uploading a pixi color as a vec3
    {
        type: "vec3<f32>",
        test: (data)=>data.type === "vec3<f32>" && data.size === 1 && data.value.red !== void 0,
        ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
        uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
    }
];

});


parcelRegister("ktXe2", function(module, exports) {

$parcel$export(module.exports, "uboSyncFunctionsSTD40", () => $d7dfc8984e07be6d$export$c761ef20854b0b5b);
$parcel$export(module.exports, "uboSyncFunctionsWGSL", () => $d7dfc8984e07be6d$export$53279b3783655315);
"use strict";
function $d7dfc8984e07be6d$var$loopMatrix(col, row) {
    const total = col * row;
    return `
        for (let i = 0; i < ${total}; i++) {
            data[offset + (((i / ${col})|0) * 4) + (i % ${col})] = v[i];
        }
    `;
}
const $d7dfc8984e07be6d$export$c761ef20854b0b5b = {
    f32: `
        data[offset] = v;`,
    i32: `
        dataInt32[offset] = v;`,
    "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
    "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
    "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
    "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
    "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
    "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
    "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
    "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
    "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
    "mat3x2<f32>": $d7dfc8984e07be6d$var$loopMatrix(3, 2),
    "mat4x2<f32>": $d7dfc8984e07be6d$var$loopMatrix(4, 2),
    "mat2x3<f32>": $d7dfc8984e07be6d$var$loopMatrix(2, 3),
    "mat4x3<f32>": $d7dfc8984e07be6d$var$loopMatrix(4, 3),
    "mat2x4<f32>": $d7dfc8984e07be6d$var$loopMatrix(2, 4),
    "mat3x4<f32>": $d7dfc8984e07be6d$var$loopMatrix(3, 4)
};
const $d7dfc8984e07be6d$export$53279b3783655315 = {
    ...$d7dfc8984e07be6d$export$c761ef20854b0b5b,
    "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};

});

parcelRegister("8Cr41", function(module, exports) {

$parcel$export(module.exports, "generateArraySyncSTD40", () => $0e264b747c31455b$export$9fb1ab94ee86ec60);

var $9z8Ce = parcelRequire("9z8Ce");
"use strict";
function $0e264b747c31455b$export$9fb1ab94ee86ec60(uboElement, offsetToAdd) {
    const rowSize = Math.max((0, $9z8Ce.WGSL_TO_STD40_SIZE)[uboElement.data.type] / 16, 1);
    const elementSize = uboElement.data.value.length / uboElement.data.size;
    const remainder = (4 - elementSize % 4) % 4;
    const data = uboElement.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
    return `
        v = uv.${uboElement.data.name};
        offset += ${offsetToAdd};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${uboElement.data.size * rowSize}; i++)
        {
            for(var j = 0; j < ${elementSize}; j++)
            {
                ${data}[arrayOffset++] = v[t++];
            }
            ${remainder !== 0 ? `arrayOffset += ${remainder};` : ""}
        }
    `;
}

});



parcelRegister("afkf3", function(module, exports) {

$parcel$export(module.exports, "GlRenderTargetSystem", () => $b5ea270abcc01a05$export$50389001704f1c6a);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2nO5l = parcelRequire("2nO5l");

var $5DCZv = parcelRequire("5DCZv");
"use strict";
class $b5ea270abcc01a05$export$50389001704f1c6a extends (0, $2nO5l.RenderTargetSystem) {
    constructor(renderer){
        super(renderer);
        this.adaptor = new (0, $5DCZv.GlRenderTargetAdaptor)();
        this.adaptor.init(renderer, this);
    }
}
/** @ignore */ $b5ea270abcc01a05$export$50389001704f1c6a.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "renderTarget"
};

});
parcelRegister("5DCZv", function(module, exports) {

$parcel$export(module.exports, "GlRenderTargetAdaptor", () => $921e757d5554674b$export$d4bf7cc1dbb946ef);

var $ar2Ly = parcelRequire("ar2Ly");

var $1RpxL = parcelRequire("1RpxL");

var $egYi0 = parcelRequire("egYi0");

var $5Ac7T = parcelRequire("5Ac7T");

var $X4HIt = parcelRequire("X4HIt");
"use strict";
class $921e757d5554674b$export$d4bf7cc1dbb946ef {
    constructor(){
        this._clearColorCache = [
            0,
            0,
            0,
            0
        ];
        this._viewPortCache = new (0, $ar2Ly.Rectangle)();
    }
    init(renderer, renderTargetSystem) {
        this._renderer = renderer;
        this._renderTargetSystem = renderTargetSystem;
        renderer.runners.contextChange.add(this);
    }
    contextChange() {
        this._clearColorCache = [
            0,
            0,
            0,
            0
        ];
        this._viewPortCache = new (0, $ar2Ly.Rectangle)();
        const gl = this._renderer.gl;
        this._drawBuffersCache = [];
        for(let i = 1; i <= 16; i++)this._drawBuffersCache[i] = Array.from({
            length: i
        }, (_, j)=>gl.COLOR_ATTACHMENT0 + j);
    }
    copyToTexture(sourceRenderSurfaceTexture, destinationTexture, originSrc, size, originDest) {
        const renderTargetSystem = this._renderTargetSystem;
        const renderer = this._renderer;
        const glRenderTarget = renderTargetSystem.getGpuRenderTarget(sourceRenderSurfaceTexture);
        const gl = renderer.gl;
        this.finishRenderPass(sourceRenderSurfaceTexture);
        gl.bindFramebuffer(gl.FRAMEBUFFER, glRenderTarget.resolveTargetFramebuffer);
        renderer.texture.bind(destinationTexture, 0);
        gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, originDest.x, originDest.y, originSrc.x, originSrc.y, size.width, size.height);
        return destinationTexture;
    }
    startRenderPass(renderTarget, clear = true, clearColor, viewport, mipLevel = 0, layer = 0) {
        const renderTargetSystem = this._renderTargetSystem;
        const source = renderTarget.colorTexture;
        const gpuRenderTarget = renderTargetSystem.getGpuRenderTarget(renderTarget);
        if (layer !== 0 && this._renderer.context.webGLVersion < 2) throw new Error("[RenderTargetSystem] Rendering to array layers requires WebGL2.");
        if (mipLevel > 0) {
            if (gpuRenderTarget.msaa) throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
            if (this._renderer.context.webGLVersion < 2) throw new Error("[RenderTargetSystem] Rendering to mip levels requires WebGL2.");
        }
        let viewPortY = viewport.y;
        if (renderTarget.isRoot) viewPortY = source.pixelHeight - viewport.height - viewport.y;
        renderTarget.colorTextures.forEach((texture)=>{
            this._renderer.texture.unbind(texture);
        });
        const gl = this._renderer.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, gpuRenderTarget.framebuffer);
        if (!renderTarget.isRoot && (gpuRenderTarget._attachedMipLevel !== mipLevel || gpuRenderTarget._attachedLayer !== layer)) {
            renderTarget.colorTextures.forEach((colorTexture, i)=>{
                const glSource = this._renderer.texture.getGlSource(colorTexture);
                if (glSource.target === gl.TEXTURE_2D) {
                    if (layer !== 0) throw new Error("[RenderTargetSystem] layer must be 0 when rendering to 2D textures in WebGL.");
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, glSource.texture, mipLevel);
                } else if (glSource.target === gl.TEXTURE_2D_ARRAY) {
                    if (this._renderer.context.webGLVersion < 2) throw new Error("[RenderTargetSystem] Rendering to 2D array textures requires WebGL2.");
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, glSource.texture, mipLevel, layer);
                } else if (glSource.target === gl.TEXTURE_CUBE_MAP) {
                    if (layer < 0 || layer > 5) throw new Error("[RenderTargetSystem] Cube map layer must be between 0 and 5.");
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_CUBE_MAP_POSITIVE_X + layer, glSource.texture, mipLevel);
                } else throw new Error("[RenderTargetSystem] Unsupported texture target for render-to-layer in WebGL.");
            });
            gpuRenderTarget._attachedMipLevel = mipLevel;
            gpuRenderTarget._attachedLayer = layer;
        }
        if (renderTarget.colorTextures.length > 1) this._setDrawBuffers(renderTarget, gl);
        const viewPortCache = this._viewPortCache;
        if (viewPortCache.x !== viewport.x || viewPortCache.y !== viewPortY || viewPortCache.width !== viewport.width || viewPortCache.height !== viewport.height) {
            viewPortCache.x = viewport.x;
            viewPortCache.y = viewPortY;
            viewPortCache.width = viewport.width;
            viewPortCache.height = viewport.height;
            gl.viewport(viewport.x, viewPortY, viewport.width, viewport.height);
        }
        if (!gpuRenderTarget.depthStencilRenderBuffer && (renderTarget.stencil || renderTarget.depth)) this._initStencil(gpuRenderTarget);
        this.clear(renderTarget, clear, clearColor);
    }
    finishRenderPass(renderTarget) {
        const renderTargetSystem = this._renderTargetSystem;
        const glRenderTarget = renderTargetSystem.getGpuRenderTarget(renderTarget);
        if (!glRenderTarget.msaa) return;
        const gl = this._renderer.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, glRenderTarget.resolveTargetFramebuffer);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, glRenderTarget.framebuffer);
        gl.blitFramebuffer(0, 0, glRenderTarget.width, glRenderTarget.height, 0, 0, glRenderTarget.width, glRenderTarget.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        gl.bindFramebuffer(gl.FRAMEBUFFER, glRenderTarget.framebuffer);
    }
    initGpuRenderTarget(renderTarget) {
        const renderer = this._renderer;
        const gl = renderer.gl;
        const glRenderTarget = new (0, $X4HIt.GlRenderTarget)();
        glRenderTarget._attachedMipLevel = 0;
        glRenderTarget._attachedLayer = 0;
        const colorTexture = renderTarget.colorTexture;
        if (colorTexture instanceof (0, $egYi0.CanvasSource)) {
            this._renderer.context.ensureCanvasSize(renderTarget.colorTexture.resource);
            glRenderTarget.framebuffer = null;
            return glRenderTarget;
        }
        this._initColor(renderTarget, glRenderTarget);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        return glRenderTarget;
    }
    destroyGpuRenderTarget(gpuRenderTarget) {
        const gl = this._renderer.gl;
        if (gpuRenderTarget.framebuffer) {
            gl.deleteFramebuffer(gpuRenderTarget.framebuffer);
            gpuRenderTarget.framebuffer = null;
        }
        if (gpuRenderTarget.resolveTargetFramebuffer) {
            gl.deleteFramebuffer(gpuRenderTarget.resolveTargetFramebuffer);
            gpuRenderTarget.resolveTargetFramebuffer = null;
        }
        if (gpuRenderTarget.depthStencilRenderBuffer) {
            gl.deleteRenderbuffer(gpuRenderTarget.depthStencilRenderBuffer);
            gpuRenderTarget.depthStencilRenderBuffer = null;
        }
        gpuRenderTarget.msaaRenderBuffer.forEach((renderBuffer)=>{
            gl.deleteRenderbuffer(renderBuffer);
        });
        gpuRenderTarget.msaaRenderBuffer = null;
    }
    clear(_renderTarget, clear, clearColor, _viewport, _mipLevel = 0, layer = 0) {
        if (!clear) return;
        if (layer !== 0) throw new Error("[RenderTargetSystem] Clearing array layers is not supported in WebGL renderer.");
        const renderTargetSystem = this._renderTargetSystem;
        if (typeof clear === "boolean") clear = clear ? (0, $5Ac7T.CLEAR).ALL : (0, $5Ac7T.CLEAR).NONE;
        const gl = this._renderer.gl;
        if (clear & (0, $5Ac7T.CLEAR).COLOR) {
            clearColor ?? (clearColor = renderTargetSystem.defaultClearColor);
            const clearColorCache = this._clearColorCache;
            const clearColorArray = clearColor;
            if (clearColorCache[0] !== clearColorArray[0] || clearColorCache[1] !== clearColorArray[1] || clearColorCache[2] !== clearColorArray[2] || clearColorCache[3] !== clearColorArray[3]) {
                clearColorCache[0] = clearColorArray[0];
                clearColorCache[1] = clearColorArray[1];
                clearColorCache[2] = clearColorArray[2];
                clearColorCache[3] = clearColorArray[3];
                gl.clearColor(clearColorArray[0], clearColorArray[1], clearColorArray[2], clearColorArray[3]);
            }
        }
        gl.clear(clear);
    }
    resizeGpuRenderTarget(renderTarget) {
        if (renderTarget.isRoot) return;
        const renderTargetSystem = this._renderTargetSystem;
        const glRenderTarget = renderTargetSystem.getGpuRenderTarget(renderTarget);
        this._resizeColor(renderTarget, glRenderTarget);
        if (renderTarget.stencil || renderTarget.depth) this._resizeStencil(glRenderTarget);
    }
    _initColor(renderTarget, glRenderTarget) {
        const renderer = this._renderer;
        const gl = renderer.gl;
        const resolveTargetFramebuffer = gl.createFramebuffer();
        glRenderTarget.resolveTargetFramebuffer = resolveTargetFramebuffer;
        gl.bindFramebuffer(gl.FRAMEBUFFER, resolveTargetFramebuffer);
        glRenderTarget.width = renderTarget.colorTexture.source.pixelWidth;
        glRenderTarget.height = renderTarget.colorTexture.source.pixelHeight;
        const colorTextures = renderTarget.colorTextures;
        colorTextures.forEach((colorTexture, i)=>{
            const source = colorTexture.source;
            if (source.antialias) {
                if (renderer.context.supports.msaa) glRenderTarget.msaa = true;
                else (0, $1RpxL.warn)("[RenderTexture] Antialiasing on textures is not supported in WebGL1");
            }
            renderer.texture.bindSource(source, 0);
            const glSource = renderer.texture.getGlSource(source);
            const glTexture = glSource.texture;
            if (glSource.target === gl.TEXTURE_2D) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, glTexture, 0);
            else if (glSource.target === gl.TEXTURE_2D_ARRAY) {
                if (renderer.context.webGLVersion < 2) throw new Error("[RenderTargetSystem] TEXTURE_2D_ARRAY requires WebGL2.");
                gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, glTexture, 0, 0);
            } else if (glSource.target === gl.TEXTURE_CUBE_MAP) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_CUBE_MAP_POSITIVE_X, glTexture, 0);
            else throw new Error("[RenderTargetSystem] Unsupported texture target for framebuffer attachment.");
        });
        if (glRenderTarget.msaa) {
            const viewFramebuffer = gl.createFramebuffer();
            glRenderTarget.framebuffer = viewFramebuffer;
            gl.bindFramebuffer(gl.FRAMEBUFFER, viewFramebuffer);
            renderTarget.colorTextures.forEach((_, i)=>{
                const msaaRenderBuffer = gl.createRenderbuffer();
                glRenderTarget.msaaRenderBuffer[i] = msaaRenderBuffer;
            });
        } else glRenderTarget.framebuffer = resolveTargetFramebuffer;
        this._resizeColor(renderTarget, glRenderTarget);
    }
    _resizeColor(renderTarget, glRenderTarget) {
        const source = renderTarget.colorTexture.source;
        glRenderTarget.width = source.pixelWidth;
        glRenderTarget.height = source.pixelHeight;
        glRenderTarget._attachedMipLevel = 0;
        glRenderTarget._attachedLayer = 0;
        renderTarget.colorTextures.forEach((colorTexture, i)=>{
            if (i === 0) return;
            colorTexture.source.resize(source.width, source.height, source._resolution);
        });
        if (glRenderTarget.msaa) {
            const renderer = this._renderer;
            const gl = renderer.gl;
            const viewFramebuffer = glRenderTarget.framebuffer;
            gl.bindFramebuffer(gl.FRAMEBUFFER, viewFramebuffer);
            renderTarget.colorTextures.forEach((colorTexture, i)=>{
                const source2 = colorTexture.source;
                renderer.texture.bindSource(source2, 0);
                const glSource = renderer.texture.getGlSource(source2);
                const glInternalFormat = glSource.internalFormat;
                const msaaRenderBuffer = glRenderTarget.msaaRenderBuffer[i];
                gl.bindRenderbuffer(gl.RENDERBUFFER, msaaRenderBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, 4, glInternalFormat, source2.pixelWidth, source2.pixelHeight);
                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderBuffer);
            });
        }
    }
    _initStencil(glRenderTarget) {
        if (glRenderTarget.framebuffer === null) return;
        const gl = this._renderer.gl;
        const depthStencilRenderBuffer = gl.createRenderbuffer();
        glRenderTarget.depthStencilRenderBuffer = depthStencilRenderBuffer;
        gl.bindRenderbuffer(gl.RENDERBUFFER, depthStencilRenderBuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, depthStencilRenderBuffer);
        this._resizeStencil(glRenderTarget);
    }
    _resizeStencil(glRenderTarget) {
        const gl = this._renderer.gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, glRenderTarget.depthStencilRenderBuffer);
        if (glRenderTarget.msaa) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, 4, gl.DEPTH24_STENCIL8, glRenderTarget.width, glRenderTarget.height);
        else gl.renderbufferStorage(gl.RENDERBUFFER, this._renderer.context.webGLVersion === 2 ? gl.DEPTH24_STENCIL8 : gl.DEPTH_STENCIL, glRenderTarget.width, glRenderTarget.height);
    }
    prerender(renderTarget) {
        const resource = renderTarget.colorTexture.resource;
        if (this._renderer.context.multiView && (0, $egYi0.CanvasSource).test(resource)) this._renderer.context.ensureCanvasSize(resource);
    }
    postrender(renderTarget) {
        if (!this._renderer.context.multiView) return;
        if ((0, $egYi0.CanvasSource).test(renderTarget.colorTexture.resource)) {
            const contextCanvas = this._renderer.context.canvas;
            const canvasSource = renderTarget.colorTexture;
            canvasSource.context2D.drawImage(contextCanvas, 0, canvasSource.pixelHeight - contextCanvas.height);
        }
    }
    _setDrawBuffers(renderTarget, gl) {
        const count = renderTarget.colorTextures.length;
        const bufferArray = this._drawBuffersCache[count];
        if (this._renderer.context.webGLVersion === 1) {
            const ext = this._renderer.context.extensions.drawBuffers;
            if (!ext) (0, $1RpxL.warn)("[RenderTexture] This WebGL1 context does not support rendering to multiple targets");
            else ext.drawBuffersWEBGL(bufferArray);
        } else gl.drawBuffers(bufferArray);
    }
}

});
parcelRegister("X4HIt", function(module, exports) {

$parcel$export(module.exports, "GlRenderTarget", () => $02c84b4ec2f5a36d$export$849d02ac5943b5e7);
"use strict";
class $02c84b4ec2f5a36d$export$849d02ac5943b5e7 {
    constructor(){
        this.width = -1;
        this.height = -1;
        this.msaa = false;
        /**
     * Tracks which mip level is currently attached to this render target's framebuffer.
     * This lets us skip redundant framebufferTexture2D calls on the common path.
     * @internal
     */ this._attachedMipLevel = 0;
        /**
     * Tracks which array layer (or cube face index) is currently attached to this render target's framebuffer.
     * For non-array 2D textures this will always be 0.
     * @internal
     */ this._attachedLayer = 0;
        this.msaaRenderBuffer = [];
    }
}

});



parcelRegister("6ZiIY", function(module, exports) {

$parcel$export(module.exports, "GlShaderSystem", () => $daab06a5aa38b74c$export$54fed9180ab691e4);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $Rm4fI = parcelRequire("Rm4fI");

var $8XSZ3 = parcelRequire("8XSZ3");
"use strict";
const $daab06a5aa38b74c$var$defaultSyncData = {
    textureCount: 0,
    blockIndex: 0
};
class $daab06a5aa38b74c$export$54fed9180ab691e4 {
    constructor(renderer){
        /** @internal */ this._activeProgram = null;
        this._programDataHash = /* @__PURE__ */ Object.create(null);
        this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
    }
    contextChange(gl) {
        this._gl = gl;
        this._programDataHash = /* @__PURE__ */ Object.create(null);
        this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null);
        this._activeProgram = null;
    }
    /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */ bind(shader, skipSync) {
        this._setProgram(shader.glProgram);
        if (skipSync) return;
        $daab06a5aa38b74c$var$defaultSyncData.textureCount = 0;
        $daab06a5aa38b74c$var$defaultSyncData.blockIndex = 0;
        let syncFunction = this._shaderSyncFunctions[shader.glProgram._key];
        if (!syncFunction) syncFunction = this._shaderSyncFunctions[shader.glProgram._key] = this._generateShaderSync(shader, this);
        this._renderer.buffer.nextBindBase(!!shader.glProgram.transformFeedbackVaryings);
        syncFunction(this._renderer, shader, $daab06a5aa38b74c$var$defaultSyncData);
    }
    /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */ updateUniformGroup(uniformGroup) {
        this._renderer.uniformGroup.updateUniformGroup(uniformGroup, this._activeProgram, $daab06a5aa38b74c$var$defaultSyncData);
    }
    /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */ bindUniformBlock(uniformGroup, name, index = 0) {
        const bufferSystem = this._renderer.buffer;
        const programData = this._getProgramData(this._activeProgram);
        const isBufferResource = uniformGroup._bufferResource;
        if (!isBufferResource) this._renderer.ubo.updateUniformGroup(uniformGroup);
        const buffer = uniformGroup.buffer;
        const glBuffer = bufferSystem.updateBuffer(buffer);
        const boundLocation = bufferSystem.freeLocationForBufferBase(glBuffer);
        if (isBufferResource) {
            const { offset: offset, size: size } = uniformGroup;
            if (offset === 0 && size === buffer.data.byteLength) bufferSystem.bindBufferBase(glBuffer, boundLocation);
            else bufferSystem.bindBufferRange(glBuffer, boundLocation, offset);
        } else if (bufferSystem.getLastBindBaseLocation(glBuffer) !== boundLocation) bufferSystem.bindBufferBase(glBuffer, boundLocation);
        const uniformBlockIndex = this._activeProgram._uniformBlockData[name].index;
        if (programData.uniformBlockBindings[index] === boundLocation) return;
        programData.uniformBlockBindings[index] = boundLocation;
        this._renderer.gl.uniformBlockBinding(programData.program, uniformBlockIndex, boundLocation);
    }
    _setProgram(program) {
        if (this._activeProgram === program) return;
        this._activeProgram = program;
        const programData = this._getProgramData(program);
        this._gl.useProgram(programData.program);
    }
    /**
   * @param program - the program to get the data for
   * @internal
   */ _getProgramData(program) {
        return this._programDataHash[program._key] || this._createProgramData(program);
    }
    _createProgramData(program) {
        const key = program._key;
        this._programDataHash[key] = (0, $8XSZ3.generateProgram)(this._gl, program);
        return this._programDataHash[key];
    }
    destroy() {
        for (const key of Object.keys(this._programDataHash))this._programDataHash[key].destroy();
        this._programDataHash = null;
        this._shaderSyncFunctions = null;
        this._activeProgram = null;
        this._renderer = null;
        this._gl = null;
    }
    /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */ _generateShaderSync(shader, shaderSystem) {
        return (0, $Rm4fI.generateShaderSyncCode)(shader, shaderSystem);
    }
    resetState() {
        this._activeProgram = null;
    }
}
/** @ignore */ $daab06a5aa38b74c$export$54fed9180ab691e4.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "shader"
};

});
parcelRegister("Rm4fI", function(module, exports) {

$parcel$export(module.exports, "generateShaderSyncCode", () => $9302a8d62fb92352$export$7b73f9835f0afdab);

var $9axq6 = parcelRequire("9axq6");

var $aUxJK = parcelRequire("aUxJK");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
function $9302a8d62fb92352$export$7b73f9835f0afdab(shader, shaderSystem) {
    const funcFragments = [];
    const headerFragments = [
        `
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `
    ];
    let addedTextreSystem = false;
    let textureCount = 0;
    const programData = shaderSystem._getProgramData(shader.glProgram);
    for(const i in shader.groups){
        const group = shader.groups[i];
        funcFragments.push(`
            resources = g[${i}].resources;
        `);
        for(const j in group.resources){
            const resource = group.resources[j];
            if (resource instanceof (0, $aUxJK.UniformGroup)) {
                if (resource.ubo) {
                    const resName = shader._uniformBindMap[i][Number(j)];
                    funcFragments.push(`
                        sS.bindUniformBlock(
                            resources[${j}],
                            '${resName}',
                            ${shader.glProgram._uniformBlockData[resName].index}
                        );
                    `);
                } else funcFragments.push(`
                        ugS.updateUniformGroup(resources[${j}], p, sD);
                    `);
            } else if (resource instanceof (0, $9axq6.BufferResource)) {
                const resName = shader._uniformBindMap[i][Number(j)];
                funcFragments.push(`
                    sS.bindUniformBlock(
                        resources[${j}],
                        '${resName}',
                        ${shader.glProgram._uniformBlockData[resName].index}
                    );
                `);
            } else if (resource instanceof (0, $gmQ4R.TextureSource)) {
                const uniformName = shader._uniformBindMap[i][j];
                const uniformData = programData.uniformData[uniformName];
                if (uniformData) {
                    if (!addedTextreSystem) {
                        addedTextreSystem = true;
                        headerFragments.push(`
                        var tS = r.texture;
                        `);
                    }
                    shaderSystem._gl.uniform1i(uniformData.location, textureCount);
                    funcFragments.push(`
                        tS.bind(resources[${j}], ${textureCount});
                    `);
                    textureCount++;
                }
            }
        }
    }
    const functionSource = [
        ...headerFragments,
        ...funcFragments
    ].join("\n");
    return new Function("r", "s", "sD", functionSource);
}

});
parcelRegister("9axq6", function(module, exports) {

$parcel$export(module.exports, "BufferResource", () => $1affd28fa669996a$export$a79ef781de624449);

var $6AQ4q = parcelRequire("6AQ4q");

var $1bMtF = parcelRequire("1bMtF");
"use strict";
class $1affd28fa669996a$export$a79ef781de624449 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */ constructor({ buffer: buffer, offset: offset, size: size }){
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /** a unique id for this uniform group used through the renderer */ this.uid = (0, $1bMtF.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "bufferResource";
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $1bMtF.uid)("resource");
        /**
     * A cheeky hint to the GL renderer to let it know this is a BufferResource
     * @internal
     */ this._bufferResource = true;
        /**
     * Has the Buffer resource been destroyed?
     * @readonly
     */ this.destroyed = false;
        this.buffer = buffer;
        this.offset = offset | 0;
        this.size = size;
        this.buffer.on("change", this.onBufferChange, this);
    }
    onBufferChange() {
        this._resourceId = (0, $1bMtF.uid)("resource");
        this.emit("change", this);
    }
    /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */ destroy(destroyBuffer = false) {
        this.destroyed = true;
        if (destroyBuffer) this.buffer.destroy();
        this.emit("change", this);
        this.buffer = null;
        this.removeAllListeners();
    }
}

});


parcelRegister("8XSZ3", function(module, exports) {

$parcel$export(module.exports, "generateProgram", () => $8682739ab785d755$export$44c84e8c8e54bce9);

var $1RpxL = parcelRequire("1RpxL");

var $lhx4E = parcelRequire("lhx4E");

var $9q9nW = parcelRequire("9q9nW");

var $ljCyn = parcelRequire("ljCyn");

var $kokDf = parcelRequire("kokDf");

var $623tj = parcelRequire("623tj");

var $e8SzA = parcelRequire("e8SzA");

var $jWjsq = parcelRequire("jWjsq");
"use strict";
function $8682739ab785d755$export$44c84e8c8e54bce9(gl, program) {
    const glVertShader = (0, $9q9nW.compileShader)(gl, gl.VERTEX_SHADER, program.vertex);
    const glFragShader = (0, $9q9nW.compileShader)(gl, gl.FRAGMENT_SHADER, program.fragment);
    const webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader);
    gl.attachShader(webGLProgram, glFragShader);
    const transformFeedbackVaryings = program.transformFeedbackVaryings;
    if (transformFeedbackVaryings) {
        if (typeof gl.transformFeedbackVaryings !== "function") (0, $1RpxL.warn)(`TransformFeedback is not supported but TransformFeedbackVaryings are given.`);
        else gl.transformFeedbackVaryings(webGLProgram, transformFeedbackVaryings.names, transformFeedbackVaryings.bufferMode === "separate" ? gl.SEPARATE_ATTRIBS : gl.INTERLEAVED_ATTRIBS);
    }
    gl.linkProgram(webGLProgram);
    if (!gl.getProgramParameter(webGLProgram, gl.LINK_STATUS)) (0, $jWjsq.logProgramError)(gl, webGLProgram, glVertShader, glFragShader);
    program._attributeData = (0, $kokDf.extractAttributesFromGlProgram)(webGLProgram, gl, !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertex));
    program._uniformData = (0, $e8SzA.getUniformData)(webGLProgram, gl);
    program._uniformBlockData = (0, $623tj.getUboData)(webGLProgram, gl);
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);
    const uniformData = {};
    for(const i in program._uniformData){
        const data = program._uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: (0, $ljCyn.defaultValue)(data.type, data.size)
        };
    }
    const glProgram = new (0, $lhx4E.GlProgramData)(webGLProgram, uniformData);
    return glProgram;
}

});
parcelRegister("lhx4E", function(module, exports) {

$parcel$export(module.exports, "IGLUniformData", () => $a5b8ed762799fde0$export$181be621ce68aec5);
$parcel$export(module.exports, "GlProgramData", () => $a5b8ed762799fde0$export$ed24f21e055efd10);
"use strict";
class $a5b8ed762799fde0$export$181be621ce68aec5 {
}
class $a5b8ed762799fde0$export$ed24f21e055efd10 {
    /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */ constructor(program, uniformData){
        this.program = program;
        this.uniformData = uniformData;
        this.uniformGroups = {};
        this.uniformDirtyGroups = {};
        this.uniformBlockBindings = {};
    }
    /** Destroys this program. */ destroy() {
        this.uniformData = null;
        this.uniformGroups = null;
        this.uniformDirtyGroups = null;
        this.uniformBlockBindings = null;
        this.program = null;
    }
}

});

parcelRegister("9q9nW", function(module, exports) {

$parcel$export(module.exports, "compileShader", () => $bbaf013990b557b1$export$9b5304f4eb007cf0);
"use strict";
function $bbaf013990b557b1$export$9b5304f4eb007cf0(gl, type, src) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    return shader;
}

});

parcelRegister("ljCyn", function(module, exports) {

$parcel$export(module.exports, "defaultValue", () => $5410e905ab5dc6b6$export$1a01ae0705bafd37);
"use strict";
function $5410e905ab5dc6b6$var$booleanArray(size) {
    const array = new Array(size);
    for(let i = 0; i < array.length; i++)array[i] = false;
    return array;
}
function $5410e905ab5dc6b6$export$1a01ae0705bafd37(type, size) {
    switch(type){
        case "float":
            return 0;
        case "vec2":
            return new Float32Array(2 * size);
        case "vec3":
            return new Float32Array(3 * size);
        case "vec4":
            return new Float32Array(4 * size);
        case "int":
        case "uint":
        case "sampler2D":
        case "sampler2DArray":
            return 0;
        case "ivec2":
            return new Int32Array(2 * size);
        case "ivec3":
            return new Int32Array(3 * size);
        case "ivec4":
            return new Int32Array(4 * size);
        case "uvec2":
            return new Uint32Array(2 * size);
        case "uvec3":
            return new Uint32Array(3 * size);
        case "uvec4":
            return new Uint32Array(4 * size);
        case "bool":
            return false;
        case "bvec2":
            return $5410e905ab5dc6b6$var$booleanArray(2 * size);
        case "bvec3":
            return $5410e905ab5dc6b6$var$booleanArray(3 * size);
        case "bvec4":
            return $5410e905ab5dc6b6$var$booleanArray(4 * size);
        case "mat2":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});

parcelRegister("kokDf", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGlProgram", () => $9750f5b4dde7b959$export$8c8c8d19aa26a952);

var $eDWUK = parcelRequire("eDWUK");

var $Y425I = parcelRequire("Y425I");
"use strict";
function $9750f5b4dde7b959$export$8c8c8d19aa26a952(program, gl, sortAttributes = false) {
    const attributes = {};
    const totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < totalAttributes; i++){
        const attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.startsWith("gl_")) continue;
        const format = (0, $Y425I.mapGlToVertexFormat)(gl, attribData.type);
        attributes[attribData.name] = {
            location: 0,
            format: // set further down..
            format,
            stride: (0, $eDWUK.getAttributeInfoFromFormat)(format).stride,
            offset: 0,
            instance: false,
            start: 0
        };
    }
    const keys = Object.keys(attributes);
    if (sortAttributes) {
        keys.sort((a, b)=>a > b ? 1 : -1);
        for(let i = 0; i < keys.length; i++){
            attributes[keys[i]].location = i;
            gl.bindAttribLocation(program, i, keys[i]);
        }
        gl.linkProgram(program);
    } else for(let i = 0; i < keys.length; i++)attributes[keys[i]].location = gl.getAttribLocation(program, keys[i]);
    return attributes;
}

});
parcelRegister("Y425I", function(module, exports) {

$parcel$export(module.exports, "mapType", () => $0cede020f0bbe5ad$export$4de3a94418d86ca7);
$parcel$export(module.exports, "mapGlToVertexFormat", () => $0cede020f0bbe5ad$export$7c31aa59606c890c);
"use strict";
let $0cede020f0bbe5ad$var$GL_TABLE = null;
const $0cede020f0bbe5ad$var$GL_TO_GLSL_TYPES = {
    FLOAT: "float",
    FLOAT_VEC2: "vec2",
    FLOAT_VEC3: "vec3",
    FLOAT_VEC4: "vec4",
    INT: "int",
    INT_VEC2: "ivec2",
    INT_VEC3: "ivec3",
    INT_VEC4: "ivec4",
    UNSIGNED_INT: "uint",
    UNSIGNED_INT_VEC2: "uvec2",
    UNSIGNED_INT_VEC3: "uvec3",
    UNSIGNED_INT_VEC4: "uvec4",
    BOOL: "bool",
    BOOL_VEC2: "bvec2",
    BOOL_VEC3: "bvec3",
    BOOL_VEC4: "bvec4",
    FLOAT_MAT2: "mat2",
    FLOAT_MAT3: "mat3",
    FLOAT_MAT4: "mat4",
    SAMPLER_2D: "sampler2D",
    INT_SAMPLER_2D: "sampler2D",
    UNSIGNED_INT_SAMPLER_2D: "sampler2D",
    SAMPLER_CUBE: "samplerCube",
    INT_SAMPLER_CUBE: "samplerCube",
    UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
    SAMPLER_2D_ARRAY: "sampler2DArray",
    INT_SAMPLER_2D_ARRAY: "sampler2DArray",
    UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
const $0cede020f0bbe5ad$var$GLSL_TO_VERTEX_TYPES = {
    float: "float32",
    vec2: "float32x2",
    vec3: "float32x3",
    vec4: "float32x4",
    int: "sint32",
    ivec2: "sint32x2",
    ivec3: "sint32x3",
    ivec4: "sint32x4",
    uint: "uint32",
    uvec2: "uint32x2",
    uvec3: "uint32x3",
    uvec4: "uint32x4",
    bool: "uint32",
    bvec2: "uint32x2",
    bvec3: "uint32x3",
    bvec4: "uint32x4"
};
function $0cede020f0bbe5ad$export$4de3a94418d86ca7(gl, type) {
    if (!$0cede020f0bbe5ad$var$GL_TABLE) {
        const typeNames = Object.keys($0cede020f0bbe5ad$var$GL_TO_GLSL_TYPES);
        $0cede020f0bbe5ad$var$GL_TABLE = {};
        for(let i = 0; i < typeNames.length; ++i){
            const tn = typeNames[i];
            $0cede020f0bbe5ad$var$GL_TABLE[gl[tn]] = $0cede020f0bbe5ad$var$GL_TO_GLSL_TYPES[tn];
        }
    }
    return $0cede020f0bbe5ad$var$GL_TABLE[type];
}
function $0cede020f0bbe5ad$export$7c31aa59606c890c(gl, type) {
    const typeValue = $0cede020f0bbe5ad$export$4de3a94418d86ca7(gl, type);
    return $0cede020f0bbe5ad$var$GLSL_TO_VERTEX_TYPES[typeValue] || "float32";
}

});


parcelRegister("623tj", function(module, exports) {

$parcel$export(module.exports, "getUboData", () => $a2deec6a96caa138$export$452e938e127b3a20);
"use strict";
function $a2deec6a96caa138$export$452e938e127b3a20(program, gl) {
    if (!gl.ACTIVE_UNIFORM_BLOCKS) return {};
    const uniformBlocks = {};
    const totalUniformsBlocks = gl.getProgramParameter(program, gl.ACTIVE_UNIFORM_BLOCKS);
    for(let i = 0; i < totalUniformsBlocks; i++){
        const name = gl.getActiveUniformBlockName(program, i);
        const uniformBlockIndex = gl.getUniformBlockIndex(program, name);
        const size = gl.getActiveUniformBlockParameter(program, i, gl.UNIFORM_BLOCK_DATA_SIZE);
        uniformBlocks[name] = {
            name: name,
            index: uniformBlockIndex,
            size: size
        };
    }
    return uniformBlocks;
}

});

parcelRegister("e8SzA", function(module, exports) {

$parcel$export(module.exports, "getUniformData", () => $5f32c1359e059fff$export$d38fd6033d9429a5);

var $ljCyn = parcelRequire("ljCyn");

var $Y425I = parcelRequire("Y425I");
"use strict";
function $5f32c1359e059fff$export$d38fd6033d9429a5(program, gl) {
    const uniforms = {};
    const totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < totalUniforms; i++){
        const uniformData = gl.getActiveUniform(program, i);
        const name = uniformData.name.replace(/\[.*?\]$/, "");
        const isArray = !!uniformData.name.match(/\[.*?\]$/);
        const type = (0, $Y425I.mapType)(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: (0, $ljCyn.defaultValue)(type, uniformData.size)
        };
    }
    return uniforms;
}

});

parcelRegister("jWjsq", function(module, exports) {

$parcel$export(module.exports, "logProgramError", () => $854dc881bd74e6aa$export$4b35d6c62dc992b0);
"use strict";
function $854dc881bd74e6aa$var$logPrettyShaderError(gl, shader) {
    const shaderSrc = gl.getShaderSource(shader).split("\n").map((line, index)=>`${index}: ${line}`);
    const shaderLog = gl.getShaderInfoLog(shader);
    const splitShader = shaderLog.split("\n");
    const dedupe = {};
    const lineNumbers = splitShader.map((line)=>parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((n)=>{
        if (n && !dedupe[n]) {
            dedupe[n] = true;
            return true;
        }
        return false;
    });
    const logArgs = [
        ""
    ];
    lineNumbers.forEach((number)=>{
        shaderSrc[number - 1] = `%c${shaderSrc[number - 1]}%c`;
        logArgs.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
    });
    const fragmentSourceToLog = shaderSrc.join("\n");
    logArgs[0] = fragmentSourceToLog;
    console.error(shaderLog);
    console.groupCollapsed("click to view full shader code");
    console.warn(...logArgs);
    console.groupEnd();
}
function $854dc881bd74e6aa$export$4b35d6c62dc992b0(gl, program, vertexShader, fragmentShader) {
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) $854dc881bd74e6aa$var$logPrettyShaderError(gl, vertexShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) $854dc881bd74e6aa$var$logPrettyShaderError(gl, fragmentShader);
        console.error("PixiJS Error: Could not initialize shader.");
        if (gl.getProgramInfoLog(program) !== "") console.warn("PixiJS Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(program));
    }
}

});



parcelRegister("iaA7Y", function(module, exports) {

$parcel$export(module.exports, "GlUniformGroupSystem", () => $1c838a7f4680f237$export$1dadd6b65a7ae71a);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $bq0o8 = parcelRequire("bq0o8");
"use strict";
class $1c838a7f4680f237$export$1dadd6b65a7ae71a {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        /** Cache to holds the generated functions. Stored against UniformObjects unique signature. */ this._cache = {};
        this._uniformGroupSyncHash = {};
        this._renderer = renderer;
        this.gl = null;
        this._cache = {};
    }
    contextChange(gl) {
        this.gl = gl;
    }
    /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */ updateUniformGroup(group, program, syncData) {
        const programData = this._renderer.shader._getProgramData(program);
        if (!group.isStatic || group._dirtyId !== programData.uniformDirtyGroups[group.uid]) {
            programData.uniformDirtyGroups[group.uid] = group._dirtyId;
            const syncFunc = this._getUniformSyncFunction(group, program);
            syncFunc(programData.uniformData, group.uniforms, this._renderer, syncData);
        }
    }
    /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */ _getUniformSyncFunction(group, program) {
        return this._uniformGroupSyncHash[group._signature]?.[program._key] || this._createUniformSyncFunction(group, program);
    }
    _createUniformSyncFunction(group, program) {
        const uniformGroupSyncHash = this._uniformGroupSyncHash[group._signature] || (this._uniformGroupSyncHash[group._signature] = {});
        const id = this._getSignature(group, program._uniformData, "u");
        if (!this._cache[id]) this._cache[id] = this._generateUniformsSync(group, program._uniformData);
        uniformGroupSyncHash[program._key] = this._cache[id];
        return uniformGroupSyncHash[program._key];
    }
    _generateUniformsSync(group, uniformData) {
        return (0, $bq0o8.generateUniformsSync)(group, uniformData);
    }
    /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */ _getSignature(group, uniformData, preFix) {
        const uniforms = group.uniforms;
        const strings = [
            `${preFix}-`
        ];
        for(const i in uniforms){
            strings.push(i);
            if (uniformData[i]) strings.push(uniformData[i].type);
        }
        return strings.join("-");
    }
    /** Destroys this System and removes all its textures. */ destroy() {
        this._renderer = null;
        this._cache = null;
    }
}
/** @ignore */ $1c838a7f4680f237$export$1dadd6b65a7ae71a.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "uniformGroup"
};

});
parcelRegister("bq0o8", function(module, exports) {

$parcel$export(module.exports, "generateUniformsSync", () => $273b225d44e450bf$export$20c95d1c2d5a6828);

var $9axq6 = parcelRequire("9axq6");

var $aUxJK = parcelRequire("aUxJK");

var $1oQYm = parcelRequire("1oQYm");

var $1I8G2 = parcelRequire("1I8G2");
"use strict";
function $273b225d44e450bf$export$20c95d1c2d5a6828(group, uniformData) {
    const funcFragments = [
        `
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `
    ];
    for(const i in group.uniforms){
        if (!uniformData[i]) {
            if (group.uniforms[i] instanceof (0, $aUxJK.UniformGroup)) {
                if (group.uniforms[i].ubo) funcFragments.push(`
                        renderer.shader.bindUniformBlock(uv.${i}, "${i}");
                    `);
                else funcFragments.push(`
                        renderer.shader.updateUniformGroup(uv.${i});
                    `);
            } else if (group.uniforms[i] instanceof (0, $9axq6.BufferResource)) funcFragments.push(`
                        renderer.shader.bindBufferResource(uv.${i}, "${i}");
                    `);
            continue;
        }
        const uniform = group.uniformStructures[i];
        let parsed = false;
        for(let j = 0; j < (0, $1oQYm.uniformParsers).length; j++){
            const parser = (0, $1oQYm.uniformParsers)[j];
            if (uniform.type === parser.type && parser.test(uniform)) {
                funcFragments.push(`name = "${i}";`, (0, $1oQYm.uniformParsers)[j].uniform);
                parsed = true;
                break;
            }
        }
        if (!parsed) {
            const templateType = uniform.size === 1 ? (0, $1I8G2.UNIFORM_TO_SINGLE_SETTERS) : (0, $1I8G2.UNIFORM_TO_ARRAY_SETTERS);
            const template = templateType[uniform.type].replace("location", `ud["${i}"].location`);
            funcFragments.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${template};`);
        }
    }
    return new Function("ud", "uv", "renderer", "syncData", funcFragments.join("\n"));
}

});
parcelRegister("1I8G2", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TO_SINGLE_SETTERS", () => $0b271dd3a18c5e86$export$2619e56ae9962898);
$parcel$export(module.exports, "UNIFORM_TO_ARRAY_SETTERS", () => $0b271dd3a18c5e86$export$ac1fb1a14f78b100);
"use strict";
const $0b271dd3a18c5e86$export$2619e56ae9962898 = {
    f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
    "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
    "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
    "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
    i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
    "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
    "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
    "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
    u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
    "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
    "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
    "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
    bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
    "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
    "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
    "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
    "mat2x2<f32>": `gl.uniformMatrix2fv(location, false, v);`,
    "mat3x3<f32>": `gl.uniformMatrix3fv(location, false, v);`,
    "mat4x4<f32>": `gl.uniformMatrix4fv(location, false, v);`
};
const $0b271dd3a18c5e86$export$ac1fb1a14f78b100 = {
    f32: `gl.uniform1fv(location, v);`,
    "vec2<f32>": `gl.uniform2fv(location, v);`,
    "vec3<f32>": `gl.uniform3fv(location, v);`,
    "vec4<f32>": `gl.uniform4fv(location, v);`,
    "mat2x2<f32>": `gl.uniformMatrix2fv(location, false, v);`,
    "mat3x3<f32>": `gl.uniformMatrix3fv(location, false, v);`,
    "mat4x4<f32>": `gl.uniformMatrix4fv(location, false, v);`,
    i32: `gl.uniform1iv(location, v);`,
    "vec2<i32>": `gl.uniform2iv(location, v);`,
    "vec3<i32>": `gl.uniform3iv(location, v);`,
    "vec4<i32>": `gl.uniform4iv(location, v);`,
    u32: `gl.uniform1iv(location, v);`,
    "vec2<u32>": `gl.uniform2iv(location, v);`,
    "vec3<u32>": `gl.uniform3iv(location, v);`,
    "vec4<u32>": `gl.uniform4iv(location, v);`,
    bool: `gl.uniform1iv(location, v);`,
    "vec2<bool>": `gl.uniform2iv(location, v);`,
    "vec3<bool>": `gl.uniform3iv(location, v);`,
    "vec4<bool>": `gl.uniform4iv(location, v);`
};

});



parcelRegister("71WMa", function(module, exports) {

$parcel$export(module.exports, "GlStateSystem", () => $37bb600b8d06f9a0$export$3ece59c346e5d37);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $cVY0I = parcelRequire("cVY0I");
"use strict";
const $37bb600b8d06f9a0$var$BLEND = 0;
const $37bb600b8d06f9a0$var$OFFSET = 1;
const $37bb600b8d06f9a0$var$CULLING = 2;
const $37bb600b8d06f9a0$var$DEPTH_TEST = 3;
const $37bb600b8d06f9a0$var$WINDING = 4;
const $37bb600b8d06f9a0$var$DEPTH_MASK = 5;
const $37bb600b8d06f9a0$var$_GlStateSystem = class _GlStateSystem {
    constructor(renderer){
        /**
     * Whether to invert the front face when rendering
     * This is used for render textures where the Y-coordinate is flipped
     * @default false
     */ this._invertFrontFace = false;
        this.gl = null;
        this.stateId = 0;
        this.polygonOffset = 0;
        this.blendMode = "none";
        this._blendEq = false;
        this.map = [];
        this.map[$37bb600b8d06f9a0$var$BLEND] = this.setBlend;
        this.map[$37bb600b8d06f9a0$var$OFFSET] = this.setOffset;
        this.map[$37bb600b8d06f9a0$var$CULLING] = this.setCullFace;
        this.map[$37bb600b8d06f9a0$var$DEPTH_TEST] = this.setDepthTest;
        this.map[$37bb600b8d06f9a0$var$WINDING] = this.setFrontFace;
        this.map[$37bb600b8d06f9a0$var$DEPTH_MASK] = this.setDepthMask;
        this.checks = [];
        this.defaultState = (0, $fx0Zy.State).for2d();
        renderer.renderTarget.onRenderTargetChange.add(this);
    }
    onRenderTargetChange(renderTarget) {
        this._invertFrontFace = !renderTarget.isRoot;
        if (this._cullFace) this.setFrontFace(this._frontFace);
        else this._frontFaceDirty = true;
    }
    contextChange(gl) {
        this.gl = gl;
        this.blendModesMap = (0, $cVY0I.mapWebGLBlendModesToPixi)(gl);
        this.resetState();
    }
    /**
   * Sets the current state
   * @param {*} state - The state to set.
   */ set(state) {
        state || (state = this.defaultState);
        if (this.stateId !== state.data) {
            let diff = this.stateId ^ state.data;
            let i = 0;
            while(diff){
                if (diff & 1) this.map[i].call(this, !!(state.data & 1 << i));
                diff >>= 1;
                i++;
            }
            this.stateId = state.data;
        }
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    }
    /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */ forceState(state) {
        state || (state = this.defaultState);
        for(let i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    }
    /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */ setBlend(value) {
        this._updateCheck(_GlStateSystem._checkBlendMode, value);
        this.gl[value ? "enable" : "disable"](this.gl.BLEND);
    }
    /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */ setOffset(value) {
        this._updateCheck(_GlStateSystem._checkPolygonOffset, value);
        this.gl[value ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }
    /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */ setDepthTest(value) {
        this.gl[value ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }
    /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */ setDepthMask(value) {
        this.gl.depthMask(value);
    }
    /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */ setCullFace(value) {
        this._cullFace = value;
        this.gl[value ? "enable" : "disable"](this.gl.CULL_FACE);
        if (this._cullFace && this._frontFaceDirty) this.setFrontFace(this._frontFace);
    }
    /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */ setFrontFace(value) {
        this._frontFace = value;
        this._frontFaceDirty = false;
        const faceMode = this._invertFrontFace ? !value : value;
        if (this._glFrontFace !== faceMode) {
            this._glFrontFace = faceMode;
            this.gl.frontFace(this.gl[faceMode ? "CW" : "CCW"]);
        }
    }
    /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */ setBlendMode(value) {
        if (!this.blendModesMap[value]) value = "normal";
        if (value === this.blendMode) return;
        this.blendMode = value;
        const mode = this.blendModesMap[value];
        const gl = this.gl;
        if (mode.length === 2) gl.blendFunc(mode[0], mode[1]);
        else gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        if (mode.length === 6) {
            this._blendEq = true;
            gl.blendEquationSeparate(mode[4], mode[5]);
        } else if (this._blendEq) {
            this._blendEq = false;
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
        }
    }
    /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */ setPolygonOffset(value, scale) {
        this.gl.polygonOffset(value, scale);
    }
    /** Resets all the logic and disables the VAOs. */ resetState() {
        this._glFrontFace = false;
        this._frontFace = false;
        this._cullFace = false;
        this._frontFaceDirty = false;
        this._invertFrontFace = false;
        this.gl.frontFace(this.gl.CCW);
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        this.forceState(this.defaultState);
        this._blendEq = true;
        this.blendMode = "";
        this.setBlendMode("normal");
    }
    /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */ _updateCheck(func, value) {
        const index = this.checks.indexOf(func);
        if (value && index === -1) this.checks.push(func);
        else if (!value && index !== -1) this.checks.splice(index, 1);
    }
    /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static _checkBlendMode(system, state) {
        system.setBlendMode(state.blendMode);
    }
    /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static _checkPolygonOffset(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    }
    /** @ignore */ destroy() {
        this.gl = null;
        this.checks.length = 0;
    }
};
/** @ignore */ $37bb600b8d06f9a0$var$_GlStateSystem.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "state"
};
let $37bb600b8d06f9a0$export$3ece59c346e5d37 = $37bb600b8d06f9a0$var$_GlStateSystem;

});
parcelRegister("cVY0I", function(module, exports) {

$parcel$export(module.exports, "mapWebGLBlendModesToPixi", () => $b180420e13b809c6$export$57ed86928a8d2aa1);

var $gLw46 = parcelRequire("gLw46");
"use strict";
function $b180420e13b809c6$export$57ed86928a8d2aa1(gl) {
    const blendMap = {};
    blendMap.normal = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    blendMap.add = [
        gl.ONE,
        gl.ONE
    ];
    blendMap.multiply = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    blendMap.screen = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    blendMap.none = [
        0,
        0
    ];
    blendMap["normal-npm"] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    blendMap["add-npm"] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ];
    blendMap["screen-npm"] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    blendMap.erase = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    const isWebGl2 = !(gl instanceof (0, $gLw46.DOMAdapter).get().getWebGLRenderingContext());
    if (isWebGl2) {
        blendMap.min = [
            gl.ONE,
            gl.ONE,
            gl.ONE,
            gl.ONE,
            gl.MIN,
            gl.MIN
        ];
        blendMap.max = [
            gl.ONE,
            gl.ONE,
            gl.ONE,
            gl.ONE,
            gl.MAX,
            gl.MAX
        ];
    } else {
        const ext = gl.getExtension("EXT_blend_minmax");
        if (ext) {
            blendMap.min = [
                gl.ONE,
                gl.ONE,
                gl.ONE,
                gl.ONE,
                ext.MIN_EXT,
                ext.MIN_EXT
            ];
            blendMap.max = [
                gl.ONE,
                gl.ONE,
                gl.ONE,
                gl.ONE,
                ext.MAX_EXT,
                ext.MAX_EXT
            ];
        }
    }
    return blendMap;
}

});


parcelRegister("lMeU5", function(module, exports) {

$parcel$export(module.exports, "GlTextureSystem", () => $56b9953cfc727ff4$export$a4a6f67fda81946a);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $4iNSL = parcelRequire("4iNSL");

var $2rkWb = parcelRequire("2rkWb");

var $cciod = parcelRequire("cciod");

var $ltjQZ = parcelRequire("ltjQZ");

var $hufwr = parcelRequire("hufwr");

var $hU0oy = parcelRequire("hU0oy");

var $5eCic = parcelRequire("5eCic");

var $iRWum = parcelRequire("iRWum");

var $5N2S9 = parcelRequire("5N2S9");

var $1cGmN = parcelRequire("1cGmN");

var $8LpWL = parcelRequire("8LpWL");

var $lh1dy = parcelRequire("lh1dy");

"use strict";
const $56b9953cfc727ff4$var$BYTES_PER_PIXEL = 4;
class $56b9953cfc727ff4$export$a4a6f67fda81946a {
    constructor(renderer){
        this._glSamplers = /* @__PURE__ */ Object.create(null);
        this._boundTextures = [];
        this._activeTextureLocation = -1;
        this._boundSamplers = /* @__PURE__ */ Object.create(null);
        this._premultiplyAlpha = false;
        // TODO - separate samplers will be a cool thing to add, but not right now!
        this._useSeparateSamplers = false;
        this._renderer = renderer;
        this._managedTextures = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            onUnload: this.onSourceUnload.bind(this),
            name: "glTexture"
        });
        const baseUploaders = {
            image: (0, $hU0oy.glUploadImageResource),
            buffer: (0, $cciod.glUploadBufferImageResource),
            video: (0, $5eCic.glUploadVideoResource),
            compressed: (0, $ltjQZ.glUploadCompressedTextureResource)
        };
        this._uploads = {
            ...baseUploaders,
            cube: (0, $hufwr.createGlUploadCubeTextureResource)(baseUploaders)
        };
    }
    /**
   * @deprecated since 8.15.0
   */ get managedTextures() {
        return Object.values(this._managedTextures.items);
    }
    contextChange(gl) {
        this._gl = gl;
        if (!this._mapFormatToInternalFormat) {
            this._mapFormatToInternalFormat = (0, $1cGmN.mapFormatToGlInternalFormat)(gl, this._renderer.context.extensions);
            this._mapFormatToType = (0, $8LpWL.mapFormatToGlType)(gl);
            this._mapFormatToFormat = (0, $5N2S9.mapFormatToGlFormat)(gl);
            this._mapViewDimensionToGlTarget = (0, $lh1dy.mapViewDimensionToGlTarget)(gl);
        }
        this._managedTextures.removeAll(true);
        this._glSamplers = /* @__PURE__ */ Object.create(null);
        this._boundSamplers = /* @__PURE__ */ Object.create(null);
        this._premultiplyAlpha = false;
        for(let i = 0; i < 16; i++)this.bind((0, $4iNSL.Texture).EMPTY, i);
    }
    /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */ initSource(source) {
        this.bind(source);
    }
    bind(texture, location = 0) {
        const source = texture.source;
        if (texture) {
            this.bindSource(source, location);
            if (this._useSeparateSamplers) this._bindSampler(source.style, location);
        } else {
            this.bindSource(null, location);
            if (this._useSeparateSamplers) this._bindSampler(null, location);
        }
    }
    bindSource(source, location = 0) {
        const gl = this._gl;
        source._gcLastUsed = this._renderer.gc.now;
        if (this._boundTextures[location] !== source) {
            this._boundTextures[location] = source;
            this._activateLocation(location);
            source || (source = (0, $4iNSL.Texture).EMPTY.source);
            const glTexture = this.getGlSource(source);
            gl.bindTexture(glTexture.target, glTexture.texture);
        }
    }
    _bindSampler(style, location = 0) {
        const gl = this._gl;
        if (!style) {
            this._boundSamplers[location] = null;
            gl.bindSampler(location, null);
            return;
        }
        const sampler = this._getGlSampler(style);
        if (this._boundSamplers[location] !== sampler) {
            this._boundSamplers[location] = sampler;
            gl.bindSampler(location, sampler);
        }
    }
    unbind(texture) {
        const source = texture.source;
        const boundTextures = this._boundTextures;
        const gl = this._gl;
        for(let i = 0; i < boundTextures.length; i++)if (boundTextures[i] === source) {
            this._activateLocation(i);
            const glTexture = this.getGlSource(source);
            gl.bindTexture(glTexture.target, null);
            boundTextures[i] = null;
        }
    }
    _activateLocation(location) {
        if (this._activeTextureLocation !== location) {
            this._activeTextureLocation = location;
            this._gl.activeTexture(this._gl.TEXTURE0 + location);
        }
    }
    _initSource(source) {
        const gl = this._gl;
        const glTexture = new (0, $2rkWb.GlTexture)(gl.createTexture());
        glTexture.type = this._mapFormatToType[source.format];
        glTexture.internalFormat = this._mapFormatToInternalFormat[source.format];
        glTexture.format = this._mapFormatToFormat[source.format];
        glTexture.target = this._mapViewDimensionToGlTarget[source.viewDimension];
        if (glTexture.target === null) throw new Error(`Unsupported view dimension: ${source.viewDimension} with this webgl version: ${this._renderer.context.webGLVersion}`);
        if (source.uploadMethodId === "cube") glTexture.target = gl.TEXTURE_CUBE_MAP;
        if (source.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || source.isPowerOfTwo)) {
            const biggestDimension = Math.max(source.width, source.height);
            source.mipLevelCount = Math.floor(Math.log2(biggestDimension)) + 1;
        }
        source._gpuData[this._renderer.uid] = glTexture;
        const added = this._managedTextures.add(source);
        if (added) {
            source.on("update", this.onSourceUpdate, this);
            source.on("resize", this.onSourceUpdate, this);
            source.on("styleChange", this.onStyleChange, this);
            source.on("updateMipmaps", this.onUpdateMipmaps, this);
        }
        this.onSourceUpdate(source);
        this.updateStyle(source, false);
        return glTexture;
    }
    onStyleChange(source) {
        this.updateStyle(source, false);
    }
    updateStyle(source, firstCreation) {
        const gl = this._gl;
        const glTexture = this.getGlSource(source);
        gl.bindTexture(glTexture.target, glTexture.texture);
        this._boundTextures[this._activeTextureLocation] = source;
        (0, $iRWum.applyStyleParams)(source.style, gl, source.mipLevelCount > 1, this._renderer.context.extensions.anisotropicFiltering, "texParameteri", glTexture.target, // will force a clamp to edge if the texture is not a power of two
        !this._renderer.context.supports.nonPowOf2wrapping && !source.isPowerOfTwo, firstCreation);
    }
    onSourceUnload(source, contextLost = false) {
        const glTexture = source._gpuData[this._renderer.uid];
        if (!glTexture) return;
        if (!contextLost) {
            this.unbind(source);
            this._gl.deleteTexture(glTexture.texture);
        }
        source.off("update", this.onSourceUpdate, this);
        source.off("resize", this.onSourceUpdate, this);
        source.off("styleChange", this.onStyleChange, this);
        source.off("updateMipmaps", this.onUpdateMipmaps, this);
    }
    onSourceUpdate(source) {
        const gl = this._gl;
        const glTexture = this.getGlSource(source);
        gl.bindTexture(glTexture.target, glTexture.texture);
        this._boundTextures[this._activeTextureLocation] = source;
        const premultipliedAlpha = source.alphaMode === "premultiply-alpha-on-upload";
        if (this._premultiplyAlpha !== premultipliedAlpha) {
            this._premultiplyAlpha = premultipliedAlpha;
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, premultipliedAlpha);
        }
        if (this._uploads[source.uploadMethodId]) this._uploads[source.uploadMethodId].upload(source, glTexture, gl, this._renderer.context.webGLVersion);
        else if (glTexture.target === gl.TEXTURE_2D) this._initEmptyTexture2D(glTexture, source);
        else if (glTexture.target === gl.TEXTURE_2D_ARRAY) this._initEmptyTexture2DArray(glTexture, source);
        else if (glTexture.target === gl.TEXTURE_CUBE_MAP) this._initEmptyTextureCube(glTexture, source);
        else throw new Error("[GlTextureSystem] Unsupported texture target for empty allocation.");
        this._applyMipRange(glTexture, source);
        if (source.autoGenerateMipmaps && source.mipLevelCount > 1) this.onUpdateMipmaps(source, false);
    }
    onUpdateMipmaps(source, bind = true) {
        if (bind) this.bindSource(source, 0);
        const glTexture = this.getGlSource(source);
        this._gl.generateMipmap(glTexture.target);
    }
    _initEmptyTexture2D(glTexture, source) {
        const gl = this._gl;
        gl.texImage2D(gl.TEXTURE_2D, 0, glTexture.internalFormat, source.pixelWidth, source.pixelHeight, 0, glTexture.format, glTexture.type, null);
        let w = Math.max(source.pixelWidth >> 1, 1);
        let h = Math.max(source.pixelHeight >> 1, 1);
        for(let level = 1; level < source.mipLevelCount; level++){
            gl.texImage2D(gl.TEXTURE_2D, level, glTexture.internalFormat, w, h, 0, glTexture.format, glTexture.type, null);
            w = Math.max(w >> 1, 1);
            h = Math.max(h >> 1, 1);
        }
    }
    _initEmptyTexture2DArray(glTexture, source) {
        if (this._renderer.context.webGLVersion !== 2) throw new Error("[GlTextureSystem] TEXTURE_2D_ARRAY requires WebGL2.");
        const gl2 = this._gl;
        const depth = Math.max(source.arrayLayerCount | 0, 1);
        gl2.texImage3D(gl2.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, source.pixelWidth, source.pixelHeight, depth, 0, glTexture.format, glTexture.type, null);
        let w = Math.max(source.pixelWidth >> 1, 1);
        let h = Math.max(source.pixelHeight >> 1, 1);
        for(let level = 1; level < source.mipLevelCount; level++){
            gl2.texImage3D(gl2.TEXTURE_2D_ARRAY, level, glTexture.internalFormat, w, h, depth, 0, glTexture.format, glTexture.type, null);
            w = Math.max(w >> 1, 1);
            h = Math.max(h >> 1, 1);
        }
    }
    _initEmptyTextureCube(glTexture, source) {
        const gl = this._gl;
        const totalCubeFaces = 6;
        for(let face = 0; face < totalCubeFaces; face++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, glTexture.internalFormat, source.pixelWidth, source.pixelHeight, 0, glTexture.format, glTexture.type, null);
        let w = Math.max(source.pixelWidth >> 1, 1);
        let h = Math.max(source.pixelHeight >> 1, 1);
        for(let level = 1; level < source.mipLevelCount; level++){
            for(let face = 0; face < totalCubeFaces; face++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, level, glTexture.internalFormat, w, h, 0, glTexture.format, glTexture.type, null);
            w = Math.max(w >> 1, 1);
            h = Math.max(h >> 1, 1);
        }
    }
    /**
   * Applies a mip range to the currently-bound texture so WebGL2 considers the texture "mipmap complete"
   * for the declared `mipLevelCount` (especially important for partial mip chains rendered via FBO).
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing mipLevelCount.
   */ _applyMipRange(glTexture, source) {
        if (this._renderer.context.webGLVersion !== 2) return;
        const gl = this._gl;
        const maxLevel = Math.max((source.mipLevelCount | 0) - 1, 0);
        gl.texParameteri(glTexture.target, gl.TEXTURE_BASE_LEVEL, 0);
        gl.texParameteri(glTexture.target, gl.TEXTURE_MAX_LEVEL, maxLevel);
    }
    _initSampler(style) {
        const gl = this._gl;
        const glSampler = this._gl.createSampler();
        this._glSamplers[style._resourceId] = glSampler;
        (0, $iRWum.applyStyleParams)(style, gl, this._boundTextures[this._activeTextureLocation].mipLevelCount > 1, this._renderer.context.extensions.anisotropicFiltering, "samplerParameteri", glSampler, false, true);
        return this._glSamplers[style._resourceId];
    }
    _getGlSampler(sampler) {
        return this._glSamplers[sampler._resourceId] || this._initSampler(sampler);
    }
    getGlSource(source) {
        source._gcLastUsed = this._renderer.gc.now;
        return source._gpuData[this._renderer.uid] || this._initSource(source);
    }
    generateCanvas(texture) {
        const { pixels: pixels, width: width, height: height } = this.getPixels(texture);
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
            const imageData = ctx.createImageData(width, height);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
        }
        return canvas;
    }
    getPixels(texture) {
        const resolution = texture.source.resolution;
        const frame = texture.frame;
        const width = Math.max(Math.round(frame.width * resolution), 1);
        const height = Math.max(Math.round(frame.height * resolution), 1);
        const pixels = new Uint8Array($56b9953cfc727ff4$var$BYTES_PER_PIXEL * width * height);
        const renderer = this._renderer;
        const renderTarget = renderer.renderTarget.getRenderTarget(texture);
        const glRenterTarget = renderer.renderTarget.getGpuRenderTarget(renderTarget);
        const gl = renderer.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, glRenterTarget.resolveTargetFramebuffer);
        gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        return {
            pixels: new Uint8ClampedArray(pixels.buffer),
            width: width,
            height: height
        };
    }
    destroy() {
        this._managedTextures.destroy();
        this._glSamplers = null;
        this._boundTextures = null;
        this._boundSamplers = null;
        this._mapFormatToInternalFormat = null;
        this._mapFormatToType = null;
        this._mapFormatToFormat = null;
        this._uploads = null;
        this._renderer = null;
    }
    resetState() {
        this._activeTextureLocation = -1;
        this._boundTextures.fill((0, $4iNSL.Texture).EMPTY.source);
        this._boundSamplers = /* @__PURE__ */ Object.create(null);
        const gl = this._gl;
        this._premultiplyAlpha = false;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
    }
}
/** @ignore */ $56b9953cfc727ff4$export$a4a6f67fda81946a.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem
    ],
    name: "texture"
};

});
parcelRegister("2rkWb", function(module, exports) {

$parcel$export(module.exports, "GlTexture", () => $208b2980b226d9e5$export$77c65e0fc65f3a30);

var $d0Wi0 = parcelRequire("d0Wi0");
"use strict";
class $208b2980b226d9e5$export$77c65e0fc65f3a30 {
    constructor(texture){
        this.target = (0, $d0Wi0.GL_TARGETS).TEXTURE_2D;
        /**
     * Bitmask tracking which array layers / sub-targets have been initialized at mip level 0.
     * Used by uploaders that need per-layer allocation semantics (e.g. cube faces).
     * @internal
     */ this._layerInitMask = 0;
        this.texture = texture;
        this.width = -1;
        this.height = -1;
        this.type = (0, $d0Wi0.GL_TYPES).UNSIGNED_BYTE;
        this.internalFormat = (0, $d0Wi0.GL_FORMATS).RGBA;
        this.format = (0, $d0Wi0.GL_FORMATS).RGBA;
        this.samplerType = 0;
    }
    destroy() {}
}

});

parcelRegister("cciod", function(module, exports) {

$parcel$export(module.exports, "glUploadBufferImageResource", () => $afa2900ddce0c039$export$aa4eec5aa64bfd28);
"use strict";
const $afa2900ddce0c039$export$aa4eec5aa64bfd28 = {
    id: "buffer",
    upload (source, glTexture, gl, _webGLVersion, targetOverride, forceAllocation = false) {
        const target = targetOverride || glTexture.target;
        if (!forceAllocation && glTexture.width === source.width && glTexture.height === source.height) gl.texSubImage2D(target, 0, 0, 0, source.width, source.height, glTexture.format, glTexture.type, source.resource);
        else gl.texImage2D(target, 0, glTexture.internalFormat, source.width, source.height, 0, glTexture.format, glTexture.type, source.resource);
        glTexture.width = source.width;
        glTexture.height = source.height;
    }
};

});

parcelRegister("ltjQZ", function(module, exports) {

$parcel$export(module.exports, "glUploadCompressedTextureResource", () => $ae1b6d1f18b6eed0$export$97d1715760cee374);
"use strict";
const $ae1b6d1f18b6eed0$var$compressedFormatMap = {
    "bc1-rgba-unorm": true,
    "bc1-rgba-unorm-srgb": true,
    "bc2-rgba-unorm": true,
    "bc2-rgba-unorm-srgb": true,
    "bc3-rgba-unorm": true,
    "bc3-rgba-unorm-srgb": true,
    "bc4-r-unorm": true,
    "bc4-r-snorm": true,
    "bc5-rg-unorm": true,
    "bc5-rg-snorm": true,
    "bc6h-rgb-ufloat": true,
    "bc6h-rgb-float": true,
    "bc7-rgba-unorm": true,
    "bc7-rgba-unorm-srgb": true,
    // ETC2 compressed formats usable if "texture-compression-etc2" is both
    // supported by the device/user agent and enabled in requestDevice.
    "etc2-rgb8unorm": true,
    "etc2-rgb8unorm-srgb": true,
    "etc2-rgb8a1unorm": true,
    "etc2-rgb8a1unorm-srgb": true,
    "etc2-rgba8unorm": true,
    "etc2-rgba8unorm-srgb": true,
    "eac-r11unorm": true,
    "eac-r11snorm": true,
    "eac-rg11unorm": true,
    "eac-rg11snorm": true,
    // ASTC compressed formats usable if "texture-compression-astc" is both
    // supported by the device/user agent and enabled in requestDevice.
    "astc-4x4-unorm": true,
    "astc-4x4-unorm-srgb": true,
    "astc-5x4-unorm": true,
    "astc-5x4-unorm-srgb": true,
    "astc-5x5-unorm": true,
    "astc-5x5-unorm-srgb": true,
    "astc-6x5-unorm": true,
    "astc-6x5-unorm-srgb": true,
    "astc-6x6-unorm": true,
    "astc-6x6-unorm-srgb": true,
    "astc-8x5-unorm": true,
    "astc-8x5-unorm-srgb": true,
    "astc-8x6-unorm": true,
    "astc-8x6-unorm-srgb": true,
    "astc-8x8-unorm": true,
    "astc-8x8-unorm-srgb": true,
    "astc-10x5-unorm": true,
    "astc-10x5-unorm-srgb": true,
    "astc-10x6-unorm": true,
    "astc-10x6-unorm-srgb": true,
    "astc-10x8-unorm": true,
    "astc-10x8-unorm-srgb": true,
    "astc-10x10-unorm": true,
    "astc-10x10-unorm-srgb": true,
    "astc-12x10-unorm": true,
    "astc-12x10-unorm-srgb": true,
    "astc-12x12-unorm": true,
    "astc-12x12-unorm-srgb": true
};
const $ae1b6d1f18b6eed0$export$97d1715760cee374 = {
    id: "compressed",
    upload (source, glTexture, gl, _webGLVersion, targetOverride, _forceAllocation) {
        const target = targetOverride ?? glTexture.target;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        let mipWidth = source.pixelWidth;
        let mipHeight = source.pixelHeight;
        const compressed = !!$ae1b6d1f18b6eed0$var$compressedFormatMap[source.format];
        for(let i = 0; i < source.resource.length; i++){
            const levelBuffer = source.resource[i];
            if (compressed) gl.compressedTexImage2D(target, i, glTexture.internalFormat, mipWidth, mipHeight, 0, levelBuffer);
            else gl.texImage2D(target, i, glTexture.internalFormat, mipWidth, mipHeight, 0, glTexture.format, glTexture.type, levelBuffer);
            mipWidth = Math.max(mipWidth >> 1, 1);
            mipHeight = Math.max(mipHeight >> 1, 1);
        }
    }
};

});

parcelRegister("hufwr", function(module, exports) {

$parcel$export(module.exports, "createGlUploadCubeTextureResource", () => $987a6bb7684933dc$export$f8043d6fe7872c3b);

var $d0Wi0 = parcelRequire("d0Wi0");
"use strict";
const $987a6bb7684933dc$var$FACE_ORDER = [
    "right",
    "left",
    "top",
    "bottom",
    "front",
    "back"
];
function $987a6bb7684933dc$export$f8043d6fe7872c3b(uploaders) {
    return {
        id: "cube",
        upload (source, glTexture, gl, webGLVersion) {
            const faces = source.faces;
            for(let faceIndex = 0; faceIndex < $987a6bb7684933dc$var$FACE_ORDER.length; faceIndex++){
                const key = $987a6bb7684933dc$var$FACE_ORDER[faceIndex];
                const face = faces[key];
                const uploader = uploaders[face.uploadMethodId] || uploaders.image;
                uploader.upload(face, glTexture, gl, webGLVersion, // Use the face target for the current face. cube faces ids go up 1 so
                // GL_TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + i addresses the i'th face target.
                (0, $d0Wi0.GL_TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, // Force allocation for the first upload of each face.
                (glTexture._layerInitMask & 1 << faceIndex) === 0);
                glTexture._layerInitMask |= 1 << faceIndex;
            }
            glTexture.width = source.pixelWidth;
            glTexture.height = source.pixelHeight;
        }
    };
}

});

parcelRegister("hU0oy", function(module, exports) {

$parcel$export(module.exports, "glUploadImageResource", () => $29b1744782b82ca2$export$3cfb43b040bc4df8);
"use strict";
const $29b1744782b82ca2$export$3cfb43b040bc4df8 = {
    id: "image",
    upload (source, glTexture, gl, webGLVersion, targetOverride, forceAllocation = false) {
        const target = targetOverride || glTexture.target;
        const textureWidth = source.pixelWidth;
        const textureHeight = source.pixelHeight;
        const resourceWidth = source.resourceWidth;
        const resourceHeight = source.resourceHeight;
        const isWebGL2 = webGLVersion === 2;
        const needsAllocation = forceAllocation || glTexture.width !== textureWidth || glTexture.height !== textureHeight;
        const resourceFitsTexture = resourceWidth >= textureWidth && resourceHeight >= textureHeight;
        const resource = source.resource;
        const uploadFunction = isWebGL2 ? $29b1744782b82ca2$var$uploadImageWebGL2 : $29b1744782b82ca2$var$uploadImageWebGL1;
        uploadFunction(gl, target, glTexture, textureWidth, textureHeight, resourceWidth, resourceHeight, resource, needsAllocation, resourceFitsTexture);
        glTexture.width = textureWidth;
        glTexture.height = textureHeight;
    }
};
function $29b1744782b82ca2$var$uploadImageWebGL2(gl, target, glTexture, textureWidth, textureHeight, resourceWidth, resourceHeight, resource, needsAllocation, resourceFitsTexture) {
    if (!resourceFitsTexture) {
        if (needsAllocation) gl.texImage2D(target, 0, glTexture.internalFormat, textureWidth, textureHeight, 0, glTexture.format, glTexture.type, null);
        gl.texSubImage2D(target, 0, 0, 0, resourceWidth, resourceHeight, glTexture.format, glTexture.type, resource);
        return;
    }
    if (!needsAllocation) {
        gl.texSubImage2D(target, 0, 0, 0, glTexture.format, glTexture.type, resource);
        return;
    }
    gl.texImage2D(target, 0, glTexture.internalFormat, textureWidth, textureHeight, 0, glTexture.format, glTexture.type, resource);
}
function $29b1744782b82ca2$var$uploadImageWebGL1(gl, target, glTexture, textureWidth, textureHeight, _resourceWidth, _resourceHeight, resource, needsAllocation, resourceFitsTexture) {
    if (!resourceFitsTexture) {
        if (needsAllocation) gl.texImage2D(target, 0, glTexture.internalFormat, textureWidth, textureHeight, 0, glTexture.format, glTexture.type, null);
        gl.texSubImage2D(target, 0, 0, 0, glTexture.format, glTexture.type, resource);
        return;
    }
    if (!needsAllocation) {
        gl.texSubImage2D(target, 0, 0, 0, glTexture.format, glTexture.type, resource);
        return;
    }
    gl.texImage2D(target, 0, glTexture.internalFormat, glTexture.format, glTexture.type, resource);
}

});

parcelRegister("5eCic", function(module, exports) {

$parcel$export(module.exports, "glUploadVideoResource", () => $865a3e2b5ea84d27$export$a442959494e20fc);

var $llcp4 = parcelRequire("llcp4");

var $hU0oy = parcelRequire("hU0oy");
"use strict";
const $865a3e2b5ea84d27$var$defaultForceAllocation = (0, $llcp4.isSafari)();
const $865a3e2b5ea84d27$export$a442959494e20fc = {
    id: "video",
    upload (source, glTexture, gl, webGLVersion, targetOverride, forceAllocation = $865a3e2b5ea84d27$var$defaultForceAllocation) {
        if (!source.isValid) {
            const target = targetOverride ?? glTexture.target;
            gl.texImage2D(target, 0, glTexture.internalFormat, 1, 1, 0, glTexture.format, glTexture.type, null);
            return;
        }
        (0, $hU0oy.glUploadImageResource).upload(source, glTexture, gl, webGLVersion, targetOverride, forceAllocation);
    }
};

});
parcelRegister("llcp4", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $8d5f8b203d261b12$export$95df08bae54cb4df);

var $gLw46 = parcelRequire("gLw46");
"use strict";
function $8d5f8b203d261b12$export$95df08bae54cb4df() {
    const { userAgent: userAgent } = (0, $gLw46.DOMAdapter).get().getNavigator();
    return /^((?!chrome|android).)*safari/i.test(userAgent);
}

});


parcelRegister("iRWum", function(module, exports) {

$parcel$export(module.exports, "applyStyleParams", () => $ddec7ad4d7b6edbe$export$7be2fbeda5b178b7);

var $gceSf = parcelRequire("gceSf");
"use strict";
function $ddec7ad4d7b6edbe$export$7be2fbeda5b178b7(style, gl, mipmaps, anisotropicExt, glFunctionName, firstParam, forceClamp, firstCreation) {
    const castParam = firstParam;
    if (!firstCreation || style.addressModeU !== "repeat" || style.addressModeV !== "repeat" || style.addressModeW !== "repeat") {
        const wrapModeS = (0, $gceSf.wrapModeToGlAddress)[forceClamp ? "clamp-to-edge" : style.addressModeU];
        const wrapModeT = (0, $gceSf.wrapModeToGlAddress)[forceClamp ? "clamp-to-edge" : style.addressModeV];
        const wrapModeR = (0, $gceSf.wrapModeToGlAddress)[forceClamp ? "clamp-to-edge" : style.addressModeW];
        gl[glFunctionName](castParam, gl.TEXTURE_WRAP_S, wrapModeS);
        gl[glFunctionName](castParam, gl.TEXTURE_WRAP_T, wrapModeT);
        if (gl.TEXTURE_WRAP_R) gl[glFunctionName](castParam, gl.TEXTURE_WRAP_R, wrapModeR);
    }
    if (!firstCreation || style.magFilter !== "linear") gl[glFunctionName](castParam, gl.TEXTURE_MAG_FILTER, (0, $gceSf.scaleModeToGlFilter)[style.magFilter]);
    if (mipmaps) {
        if (!firstCreation || style.mipmapFilter !== "linear") {
            const glFilterMode = (0, $gceSf.mipmapScaleModeToGlFilter)[style.minFilter][style.mipmapFilter];
            gl[glFunctionName](castParam, gl.TEXTURE_MIN_FILTER, glFilterMode);
        }
    } else gl[glFunctionName](castParam, gl.TEXTURE_MIN_FILTER, (0, $gceSf.scaleModeToGlFilter)[style.minFilter]);
    if (anisotropicExt && style.maxAnisotropy > 1) {
        const level = Math.min(style.maxAnisotropy, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
        gl[glFunctionName](castParam, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
    }
    if (style.compare) gl[glFunctionName](castParam, gl.TEXTURE_COMPARE_FUNC, (0, $gceSf.compareModeToGlCompare)[style.compare]);
}

});
parcelRegister("gceSf", function(module, exports) {

$parcel$export(module.exports, "scaleModeToGlFilter", () => $ab53ffd6ac75c681$export$801e6deda261184a);
$parcel$export(module.exports, "mipmapScaleModeToGlFilter", () => $ab53ffd6ac75c681$export$aba49ce9fa09b298);
$parcel$export(module.exports, "wrapModeToGlAddress", () => $ab53ffd6ac75c681$export$cc1c4e2fb99490bd);
$parcel$export(module.exports, "compareModeToGlCompare", () => $ab53ffd6ac75c681$export$4518bf8c33a3aebc);
"use strict";
const $ab53ffd6ac75c681$export$801e6deda261184a = {
    linear: 9729,
    nearest: 9728
};
const $ab53ffd6ac75c681$export$aba49ce9fa09b298 = {
    linear: {
        linear: 9987,
        nearest: 9985
    },
    nearest: {
        linear: 9986,
        nearest: 9984
    }
};
const $ab53ffd6ac75c681$export$cc1c4e2fb99490bd = {
    "clamp-to-edge": 33071,
    repeat: 10497,
    "mirror-repeat": 33648
};
const $ab53ffd6ac75c681$export$4518bf8c33a3aebc = {
    never: 512,
    less: 513,
    equal: 514,
    "less-equal": 515,
    greater: 516,
    "not-equal": 517,
    "greater-equal": 518,
    always: 519
};

});


parcelRegister("5N2S9", function(module, exports) {

$parcel$export(module.exports, "mapFormatToGlFormat", () => $1464d6762fcaffd0$export$42ed406df12ab342);
"use strict";
function $1464d6762fcaffd0$export$42ed406df12ab342(gl) {
    return {
        // 8-bit formats
        r8unorm: gl.RED,
        r8snorm: gl.RED,
        r8uint: gl.RED,
        r8sint: gl.RED,
        // 16-bit formats
        r16uint: gl.RED,
        r16sint: gl.RED,
        r16float: gl.RED,
        rg8unorm: gl.RG,
        rg8snorm: gl.RG,
        rg8uint: gl.RG,
        rg8sint: gl.RG,
        // 32-bit formats
        r32uint: gl.RED,
        r32sint: gl.RED,
        r32float: gl.RED,
        rg16uint: gl.RG,
        rg16sint: gl.RG,
        rg16float: gl.RG,
        rgba8unorm: gl.RGBA,
        "rgba8unorm-srgb": gl.RGBA,
        // Packed 32-bit formats
        rgba8snorm: gl.RGBA,
        rgba8uint: gl.RGBA,
        rgba8sint: gl.RGBA,
        bgra8unorm: gl.RGBA,
        "bgra8unorm-srgb": gl.RGBA,
        rgb9e5ufloat: gl.RGB,
        rgb10a2unorm: gl.RGBA,
        rg11b10ufloat: gl.RGB,
        // 64-bit formats
        rg32uint: gl.RG,
        rg32sint: gl.RG,
        rg32float: gl.RG,
        rgba16uint: gl.RGBA,
        rgba16sint: gl.RGBA,
        rgba16float: gl.RGBA,
        // 128-bit formats
        rgba32uint: gl.RGBA,
        rgba32sint: gl.RGBA,
        rgba32float: gl.RGBA,
        // Depth/stencil formats
        stencil8: gl.STENCIL_INDEX8,
        depth16unorm: gl.DEPTH_COMPONENT,
        depth24plus: gl.DEPTH_COMPONENT,
        "depth24plus-stencil8": gl.DEPTH_STENCIL,
        depth32float: gl.DEPTH_COMPONENT,
        "depth32float-stencil8": gl.DEPTH_STENCIL
    };
}

});

parcelRegister("1cGmN", function(module, exports) {

$parcel$export(module.exports, "mapFormatToGlInternalFormat", () => $8eda42d2a1a24a0f$export$555b87969daa38c6);

var $gLw46 = parcelRequire("gLw46");
"use strict";
function $8eda42d2a1a24a0f$export$555b87969daa38c6(gl, extensions) {
    let srgb = {};
    let bgra8unorm = gl.RGBA;
    if (!(gl instanceof (0, $gLw46.DOMAdapter).get().getWebGLRenderingContext())) {
        srgb = {
            "rgba8unorm-srgb": gl.SRGB8_ALPHA8,
            "bgra8unorm-srgb": gl.SRGB8_ALPHA8
        };
        bgra8unorm = gl.RGBA8;
    } else if (extensions.srgb) srgb = {
        "rgba8unorm-srgb": extensions.srgb.SRGB8_ALPHA8_EXT,
        "bgra8unorm-srgb": extensions.srgb.SRGB8_ALPHA8_EXT
    };
    return {
        // 8-bit formats
        r8unorm: gl.R8,
        r8snorm: gl.R8_SNORM,
        r8uint: gl.R8UI,
        r8sint: gl.R8I,
        // 16-bit formats
        r16uint: gl.R16UI,
        r16sint: gl.R16I,
        r16float: gl.R16F,
        rg8unorm: gl.RG8,
        rg8snorm: gl.RG8_SNORM,
        rg8uint: gl.RG8UI,
        rg8sint: gl.RG8I,
        // 32-bit formats
        r32uint: gl.R32UI,
        r32sint: gl.R32I,
        r32float: gl.R32F,
        rg16uint: gl.RG16UI,
        rg16sint: gl.RG16I,
        rg16float: gl.RG16F,
        rgba8unorm: gl.RGBA,
        ...srgb,
        // Packed 32-bit formats
        rgba8snorm: gl.RGBA8_SNORM,
        rgba8uint: gl.RGBA8UI,
        rgba8sint: gl.RGBA8I,
        bgra8unorm: bgra8unorm,
        rgb9e5ufloat: gl.RGB9_E5,
        rgb10a2unorm: gl.RGB10_A2,
        rg11b10ufloat: gl.R11F_G11F_B10F,
        // 64-bit formats
        rg32uint: gl.RG32UI,
        rg32sint: gl.RG32I,
        rg32float: gl.RG32F,
        rgba16uint: gl.RGBA16UI,
        rgba16sint: gl.RGBA16I,
        rgba16float: gl.RGBA16F,
        // 128-bit formats
        rgba32uint: gl.RGBA32UI,
        rgba32sint: gl.RGBA32I,
        rgba32float: gl.RGBA32F,
        // Depth/stencil formats
        stencil8: gl.STENCIL_INDEX8,
        depth16unorm: gl.DEPTH_COMPONENT16,
        depth24plus: gl.DEPTH_COMPONENT24,
        "depth24plus-stencil8": gl.DEPTH24_STENCIL8,
        depth32float: gl.DEPTH_COMPONENT32F,
        "depth32float-stencil8": gl.DEPTH32F_STENCIL8,
        // Compressed formats
        ...extensions.s3tc ? {
            "bc1-rgba-unorm": extensions.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
            "bc2-rgba-unorm": extensions.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
            "bc3-rgba-unorm": extensions.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
        } : {},
        ...extensions.s3tc_sRGB ? {
            "bc1-rgba-unorm-srgb": extensions.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
            "bc2-rgba-unorm-srgb": extensions.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
            "bc3-rgba-unorm-srgb": extensions.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
        } : {},
        ...extensions.rgtc ? {
            "bc4-r-unorm": extensions.rgtc.COMPRESSED_RED_RGTC1_EXT,
            "bc4-r-snorm": extensions.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
            "bc5-rg-unorm": extensions.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
            "bc5-rg-snorm": extensions.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
        } : {},
        ...extensions.bptc ? {
            "bc6h-rgb-float": extensions.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
            "bc6h-rgb-ufloat": extensions.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
            "bc7-rgba-unorm": extensions.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
            "bc7-rgba-unorm-srgb": extensions.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
        } : {},
        ...extensions.etc ? {
            "etc2-rgb8unorm": extensions.etc.COMPRESSED_RGB8_ETC2,
            "etc2-rgb8unorm-srgb": extensions.etc.COMPRESSED_SRGB8_ETC2,
            "etc2-rgb8a1unorm": extensions.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
            "etc2-rgb8a1unorm-srgb": extensions.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
            "etc2-rgba8unorm": extensions.etc.COMPRESSED_RGBA8_ETC2_EAC,
            "etc2-rgba8unorm-srgb": extensions.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
            "eac-r11unorm": extensions.etc.COMPRESSED_R11_EAC,
            // 'eac-r11snorm'
            "eac-rg11unorm": extensions.etc.COMPRESSED_SIGNED_RG11_EAC
        } : {},
        ...extensions.astc ? {
            "astc-4x4-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
            "astc-4x4-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
            "astc-5x4-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
            "astc-5x4-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
            "astc-5x5-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
            "astc-5x5-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
            "astc-6x5-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
            "astc-6x5-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
            "astc-6x6-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
            "astc-6x6-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
            "astc-8x5-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
            "astc-8x5-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
            "astc-8x6-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
            "astc-8x6-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
            "astc-8x8-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
            "astc-8x8-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
            "astc-10x5-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
            "astc-10x5-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
            "astc-10x6-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
            "astc-10x6-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
            "astc-10x8-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
            "astc-10x8-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
            "astc-10x10-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
            "astc-10x10-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
            "astc-12x10-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
            "astc-12x10-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
            "astc-12x12-unorm": extensions.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
            "astc-12x12-unorm-srgb": extensions.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
        } : {}
    };
}

});

parcelRegister("8LpWL", function(module, exports) {

$parcel$export(module.exports, "mapFormatToGlType", () => $aa73ee6aac21e24a$export$21c93d3b4ec1a2c2);
"use strict";
function $aa73ee6aac21e24a$export$21c93d3b4ec1a2c2(gl) {
    return {
        // 8-bit formats
        r8unorm: gl.UNSIGNED_BYTE,
        r8snorm: gl.BYTE,
        r8uint: gl.UNSIGNED_BYTE,
        r8sint: gl.BYTE,
        // 16-bit formats
        r16uint: gl.UNSIGNED_SHORT,
        r16sint: gl.SHORT,
        r16float: gl.HALF_FLOAT,
        rg8unorm: gl.UNSIGNED_BYTE,
        rg8snorm: gl.BYTE,
        rg8uint: gl.UNSIGNED_BYTE,
        rg8sint: gl.BYTE,
        // 32-bit formats
        r32uint: gl.UNSIGNED_INT,
        r32sint: gl.INT,
        r32float: gl.FLOAT,
        rg16uint: gl.UNSIGNED_SHORT,
        rg16sint: gl.SHORT,
        rg16float: gl.HALF_FLOAT,
        rgba8unorm: gl.UNSIGNED_BYTE,
        "rgba8unorm-srgb": gl.UNSIGNED_BYTE,
        // Packed 32-bit formats
        rgba8snorm: gl.BYTE,
        rgba8uint: gl.UNSIGNED_BYTE,
        rgba8sint: gl.BYTE,
        bgra8unorm: gl.UNSIGNED_BYTE,
        "bgra8unorm-srgb": gl.UNSIGNED_BYTE,
        rgb9e5ufloat: gl.UNSIGNED_INT_5_9_9_9_REV,
        rgb10a2unorm: gl.UNSIGNED_INT_2_10_10_10_REV,
        rg11b10ufloat: gl.UNSIGNED_INT_10F_11F_11F_REV,
        // 64-bit formats
        rg32uint: gl.UNSIGNED_INT,
        rg32sint: gl.INT,
        rg32float: gl.FLOAT,
        rgba16uint: gl.UNSIGNED_SHORT,
        rgba16sint: gl.SHORT,
        rgba16float: gl.HALF_FLOAT,
        // 128-bit formats
        rgba32uint: gl.UNSIGNED_INT,
        rgba32sint: gl.INT,
        rgba32float: gl.FLOAT,
        // Depth/stencil formats
        stencil8: gl.UNSIGNED_BYTE,
        depth16unorm: gl.UNSIGNED_SHORT,
        depth24plus: gl.UNSIGNED_INT,
        "depth24plus-stencil8": gl.UNSIGNED_INT_24_8,
        depth32float: gl.FLOAT,
        "depth32float-stencil8": gl.FLOAT_32_UNSIGNED_INT_24_8_REV
    };
}

});

parcelRegister("lh1dy", function(module, exports) {

$parcel$export(module.exports, "mapViewDimensionToGlTarget", () => $d0f3d52d6d744641$export$6d8a7b6824fbbc45);
"use strict";
function $d0f3d52d6d744641$export$6d8a7b6824fbbc45(gl) {
    return {
        "2d": gl.TEXTURE_2D,
        cube: gl.TEXTURE_CUBE_MAP,
        "1d": null,
        // WebGL2 only
        "3d": gl?.TEXTURE_3D || null,
        "2d-array": gl?.TEXTURE_2D_ARRAY || null,
        "cube-array": gl?.TEXTURE_CUBE_MAP_ARRAY || null
    };
}

});



parcelRegister("bCbWs", function(module, exports) {

$parcel$export(module.exports, "WebGPURenderer", () => $bc494178f7b690cb$export$19fd8015bd4822d4);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $j3dtG = parcelRequire("j3dtG");

var $4qqO8 = parcelRequire("4qqO8");

var $d0Ll5 = parcelRequire("d0Ll5");

var $7velr = parcelRequire("7velr");

var $g2d25 = parcelRequire("g2d25");

var $bfcaK = parcelRequire("bfcaK");

var $5mmZy = parcelRequire("5mmZy");

var $a7eRK = parcelRequire("a7eRK");

var $8KWmS = parcelRequire("8KWmS");

var $7nhp3 = parcelRequire("7nhp3");

var $cQMIy = parcelRequire("cQMIy");

var $k3sPs = parcelRequire("k3sPs");

var $4ilFQ = parcelRequire("4ilFQ");

var $epQzV = parcelRequire("epQzV");

var $fYxv0 = parcelRequire("fYxv0");

var $asuS1 = parcelRequire("asuS1");

var $9oWpi = parcelRequire("9oWpi");

var $7oXM7 = parcelRequire("7oXM7");

var $6v8M4 = parcelRequire("6v8M4");

var $h62oc = parcelRequire("h62oc");
"use strict";
const $bc494178f7b690cb$var$DefaultWebGPUSystems = [
    ...(0, $g2d25.SharedSystems),
    (0, $epQzV.GpuUboSystem),
    (0, $cQMIy.GpuEncoderSystem),
    (0, $7nhp3.GpuDeviceSystem),
    (0, $k3sPs.GpuLimitsSystem),
    (0, $a7eRK.GpuBufferSystem),
    (0, $h62oc.GpuTextureSystem),
    (0, $9oWpi.GpuRenderTargetSystem),
    (0, $7oXM7.GpuShaderSystem),
    (0, $6v8M4.GpuStateSystem),
    (0, $asuS1.PipelineSystem),
    (0, $8KWmS.GpuColorMaskSystem),
    (0, $4ilFQ.GpuStencilSystem),
    (0, $5mmZy.BindGroupSystem)
];
const $bc494178f7b690cb$var$DefaultWebGPUPipes = [
    ...(0, $g2d25.SharedRenderPipes),
    (0, $fYxv0.GpuUniformBatchPipe)
];
const $bc494178f7b690cb$var$DefaultWebGPUAdapters = [
    (0, $d0Ll5.GpuBatchAdaptor),
    (0, $4qqO8.GpuMeshAdapter),
    (0, $j3dtG.GpuGraphicsAdaptor)
];
const $bc494178f7b690cb$var$systems = [];
const $bc494178f7b690cb$var$renderPipes = [];
const $bc494178f7b690cb$var$renderPipeAdaptors = [];
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGPUSystem, $bc494178f7b690cb$var$systems);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGPUPipes, $bc494178f7b690cb$var$renderPipes);
(0, $aZ9ZN.extensions).handleByNamedList((0, $aZ9ZN.ExtensionType).WebGPUPipesAdaptor, $bc494178f7b690cb$var$renderPipeAdaptors);
(0, $aZ9ZN.extensions).add(...$bc494178f7b690cb$var$DefaultWebGPUSystems, ...$bc494178f7b690cb$var$DefaultWebGPUPipes, ...$bc494178f7b690cb$var$DefaultWebGPUAdapters);
class $bc494178f7b690cb$export$19fd8015bd4822d4 extends (0, $7velr.AbstractRenderer) {
    constructor(){
        const systemConfig = {
            name: "webgpu",
            type: (0, $bfcaK.RendererType).WEBGPU,
            systems: $bc494178f7b690cb$var$systems,
            renderPipes: $bc494178f7b690cb$var$renderPipes,
            renderPipeAdaptors: $bc494178f7b690cb$var$renderPipeAdaptors
        };
        super(systemConfig);
    }
}

});
parcelRegister("j3dtG", function(module, exports) {

$parcel$export(module.exports, "GpuGraphicsAdaptor", () => $7f3d8b2657d76313$export$b61c29b1374213f3);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $dGUqy = parcelRequire("dGUqy");

var $aYOxl = parcelRequire("aYOxl");

var $eGbby = parcelRequire("eGbby");

var $1I0Ex = parcelRequire("1I0Ex");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $7LCXQ = parcelRequire("7LCXQ");

var $aUxJK = parcelRequire("aUxJK");
"use strict";
class $7f3d8b2657d76313$export$b61c29b1374213f3 {
    constructor(){
        this._maxTextures = 0;
    }
    contextChange(renderer) {
        const localUniforms = new (0, $aUxJK.UniformGroup)({
            uTransformMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uColor: {
                value: new Float32Array([
                    1,
                    1,
                    1,
                    1
                ]),
                type: "vec4<f32>"
            },
            uRound: {
                value: 0,
                type: "f32"
            }
        });
        this._maxTextures = renderer.limits.maxBatchableTextures;
        const gpuProgram = (0, $aYOxl.compileHighShaderGpuProgram)({
            name: "graphics",
            bits: [
                (0, $eGbby.colorBit),
                (0, $1I0Ex.generateTextureBatchBit)(this._maxTextures),
                (0, $dKCGl.localUniformBitGroup2),
                (0, $gnlmr.roundPixelsBit)
            ]
        });
        this.shader = new (0, $7LCXQ.Shader)({
            gpuProgram: gpuProgram,
            resources: {
                localUniforms: // added on the fly!
                localUniforms
            }
        });
    }
    execute(graphicsPipe, renderable) {
        const context = renderable.context;
        const shader = context.customShader || this.shader;
        const renderer = graphicsPipe.renderer;
        const contextSystem = renderer.graphicsContext;
        const { batcher: batcher, instructions: instructions } = contextSystem.getContextRenderData(context);
        const encoder = renderer.encoder;
        encoder.setGeometry(batcher.geometry, shader.gpuProgram);
        const globalUniformsBindGroup = renderer.globalUniforms.bindGroup;
        encoder.setBindGroup(0, globalUniformsBindGroup, shader.gpuProgram);
        const localBindGroup = renderer.renderPipes.uniformBatch.getUniformBindGroup(shader.resources.localUniforms, true);
        encoder.setBindGroup(2, localBindGroup, shader.gpuProgram);
        const batches = instructions.instructions;
        let topology = null;
        for(let i = 0; i < instructions.instructionSize; i++){
            const batch = batches[i];
            if (batch.topology !== topology) {
                topology = batch.topology;
                encoder.setPipelineFromGeometryProgramAndState(batcher.geometry, shader.gpuProgram, graphicsPipe.state, batch.topology);
            }
            shader.groups[1] = batch.bindGroup;
            if (!batch.gpuBindGroup) {
                const textureBatch = batch.textures;
                batch.bindGroup = (0, $dGUqy.getTextureBatchBindGroup)(textureBatch.textures, textureBatch.count, this._maxTextures);
                batch.gpuBindGroup = renderer.bindGroup.getBindGroup(batch.bindGroup, shader.gpuProgram, 1);
            }
            encoder.setBindGroup(1, batch.bindGroup, shader.gpuProgram);
            encoder.renderPassEncoder.drawIndexed(batch.size, 1, batch.start);
        }
    }
    destroy() {
        this.shader.destroy(true);
        this.shader = null;
    }
}
/** @ignore */ $7f3d8b2657d76313$export$b61c29b1374213f3.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUPipesAdaptor
    ],
    name: "graphics"
};

});

parcelRegister("4qqO8", function(module, exports) {

$parcel$export(module.exports, "GpuMeshAdapter", () => $96648c44e7df8530$export$7d40d72054dce6b2);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $aYOxl = parcelRequire("aYOxl");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $7hkN8 = parcelRequire("7hkN8");

var $7LCXQ = parcelRequire("7LCXQ");

var $4iNSL = parcelRequire("4iNSL");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
class $96648c44e7df8530$export$7d40d72054dce6b2 {
    init() {
        const gpuProgram = (0, $aYOxl.compileHighShaderGpuProgram)({
            name: "mesh",
            bits: [
                (0, $dKCGl.localUniformBit),
                (0, $7hkN8.textureBit),
                (0, $gnlmr.roundPixelsBit)
            ]
        });
        this._shader = new (0, $7LCXQ.Shader)({
            gpuProgram: gpuProgram,
            resources: {
                uTexture: (0, $4iNSL.Texture).EMPTY._source,
                uSampler: (0, $4iNSL.Texture).EMPTY._source.style,
                textureUniforms: {
                    uTextureMatrix: {
                        type: "mat3x3<f32>",
                        value: new (0, $5xi4h.Matrix)()
                    }
                }
            }
        });
    }
    execute(meshPipe, mesh) {
        const renderer = meshPipe.renderer;
        let shader = mesh._shader;
        if (!shader) {
            shader = this._shader;
            shader.groups[2] = renderer.texture.getTextureBindGroup(mesh.texture);
        } else if (!shader.gpuProgram) {
            (0, $1RpxL.warn)("Mesh shader has no gpuProgram", mesh.shader);
            return;
        }
        const gpuProgram = shader.gpuProgram;
        if (gpuProgram.autoAssignGlobalUniforms) shader.groups[0] = renderer.globalUniforms.bindGroup;
        if (gpuProgram.autoAssignLocalUniforms) {
            const localUniforms = meshPipe.localUniforms;
            shader.groups[1] = renderer.renderPipes.uniformBatch.getUniformBindGroup(localUniforms, true);
        }
        renderer.encoder.draw({
            geometry: mesh._geometry,
            shader: shader,
            state: mesh.state
        });
    }
    destroy() {
        this._shader.destroy(true);
        this._shader = null;
    }
}
/** @ignore */ $96648c44e7df8530$export$7d40d72054dce6b2.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUPipesAdaptor
    ],
    name: "mesh"
};

});

parcelRegister("d0Ll5", function(module, exports) {

$parcel$export(module.exports, "GpuBatchAdaptor", () => $3b34abbe86e79016$export$c08527ba9d97e32e);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $dGUqy = parcelRequire("dGUqy");
"use strict";
const $3b34abbe86e79016$var$tempState = (0, $fx0Zy.State).for2d();
class $3b34abbe86e79016$export$c08527ba9d97e32e {
    start(batchPipe, geometry, shader) {
        const renderer = batchPipe.renderer;
        const encoder = renderer.encoder;
        const program = shader.gpuProgram;
        this._shader = shader;
        this._geometry = geometry;
        encoder.setGeometry(geometry, program);
        $3b34abbe86e79016$var$tempState.blendMode = "normal";
        renderer.pipeline.getPipeline(geometry, program, $3b34abbe86e79016$var$tempState);
        const globalUniformsBindGroup = renderer.globalUniforms.bindGroup;
        encoder.resetBindGroup(1);
        encoder.setBindGroup(0, globalUniformsBindGroup, program);
    }
    execute(batchPipe, batch) {
        const program = this._shader.gpuProgram;
        const renderer = batchPipe.renderer;
        const encoder = renderer.encoder;
        if (!batch.bindGroup) {
            const textureBatch = batch.textures;
            batch.bindGroup = (0, $dGUqy.getTextureBatchBindGroup)(textureBatch.textures, textureBatch.count, renderer.limits.maxBatchableTextures);
        }
        $3b34abbe86e79016$var$tempState.blendMode = batch.blendMode;
        const gpuBindGroup = renderer.bindGroup.getBindGroup(batch.bindGroup, program, 1);
        const pipeline = renderer.pipeline.getPipeline(this._geometry, program, $3b34abbe86e79016$var$tempState, batch.topology);
        batch.bindGroup._touch(renderer.gc.now, renderer.tick);
        encoder.setPipeline(pipeline);
        encoder.renderPassEncoder.setBindGroup(1, gpuBindGroup);
        encoder.renderPassEncoder.drawIndexed(batch.size, 1, batch.start);
    }
}
/** @ignore */ $3b34abbe86e79016$export$c08527ba9d97e32e.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUPipesAdaptor
    ],
    name: "batch"
};

});

parcelRegister("5mmZy", function(module, exports) {

$parcel$export(module.exports, "BindGroupSystem", () => $8ee49965fbe33dda$export$91ee423000797195);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $8ee49965fbe33dda$export$91ee423000797195 {
    constructor(renderer){
        this._hash = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
    }
    contextChange(gpu) {
        this._gpu = gpu;
    }
    getBindGroup(bindGroup, program, groupIndex) {
        bindGroup._updateKey();
        const gpuBindGroup = this._hash[bindGroup._key] || this._createBindGroup(bindGroup, program, groupIndex);
        return gpuBindGroup;
    }
    _createBindGroup(group, program, groupIndex) {
        const device = this._gpu.device;
        const groupLayout = program.layout[groupIndex];
        const entries = [];
        const renderer = this._renderer;
        for(const j in groupLayout){
            const resource = group.resources[j] ?? group.resources[groupLayout[j]];
            let gpuResource;
            if (resource._resourceType === "uniformGroup") {
                const uniformGroup = resource;
                renderer.ubo.updateUniformGroup(uniformGroup);
                const buffer = uniformGroup.buffer;
                gpuResource = {
                    buffer: renderer.buffer.getGPUBuffer(buffer),
                    offset: 0,
                    size: buffer.descriptor.size
                };
            } else if (resource._resourceType === "buffer") {
                const buffer = resource;
                gpuResource = {
                    buffer: renderer.buffer.getGPUBuffer(buffer),
                    offset: 0,
                    size: buffer.descriptor.size
                };
            } else if (resource._resourceType === "bufferResource") {
                const bufferResource = resource;
                gpuResource = {
                    buffer: renderer.buffer.getGPUBuffer(bufferResource.buffer),
                    offset: bufferResource.offset,
                    size: bufferResource.size
                };
            } else if (resource._resourceType === "textureSampler") {
                const sampler = resource;
                gpuResource = renderer.texture.getGpuSampler(sampler);
            } else if (resource._resourceType === "textureSource") {
                const texture = resource;
                gpuResource = renderer.texture.getTextureView(texture);
            }
            entries.push({
                binding: groupLayout[j],
                resource: gpuResource
            });
        }
        const layout = renderer.shader.getProgramData(program).bindGroups[groupIndex];
        const gpuBindGroup = device.createBindGroup({
            layout: layout,
            entries: entries
        });
        this._hash[group._key] = gpuBindGroup;
        return gpuBindGroup;
    }
    destroy() {
        this._hash = null;
        this._renderer = null;
    }
}
/** @ignore */ $8ee49965fbe33dda$export$91ee423000797195.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "bindGroup"
};

});

parcelRegister("a7eRK", function(module, exports) {

$parcel$export(module.exports, "GpuBufferData", () => $b20a3d38763c8137$export$e91cf4db05973d99);
$parcel$export(module.exports, "GpuBufferSystem", () => $b20a3d38763c8137$export$d5c22bf974706849);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $1bMtF = parcelRequire("1bMtF");

var $3hvSu = parcelRequire("3hvSu");
"use strict";
class $b20a3d38763c8137$export$e91cf4db05973d99 {
    constructor(gpuBuffer){
        this.gpuBuffer = gpuBuffer;
    }
    destroy() {
        this.gpuBuffer.destroy();
        this.gpuBuffer = null;
    }
}
class $b20a3d38763c8137$export$d5c22bf974706849 {
    constructor(renderer){
        this._renderer = renderer;
        this._managedBuffers = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            onUnload: this.onBufferUnload.bind(this),
            name: "gpuBuffer"
        });
    }
    contextChange(gpu) {
        this._gpu = gpu;
    }
    getGPUBuffer(buffer) {
        buffer._gcLastUsed = this._renderer.gc.now;
        return buffer._gpuData[this._renderer.uid]?.gpuBuffer || this.createGPUBuffer(buffer);
    }
    updateBuffer(buffer) {
        const gpuBuffer = this.getGPUBuffer(buffer);
        const data = buffer.data;
        if (buffer._updateID && data) {
            buffer._updateID = 0;
            this._gpu.device.queue.writeBuffer(gpuBuffer, 0, data.buffer, 0, // round to the nearest 4 bytes
            (buffer._updateSize || data.byteLength) + 3 & -4);
        }
        return gpuBuffer;
    }
    /** dispose all WebGL resources of all managed buffers */ destroyAll() {
        this._managedBuffers.removeAll();
    }
    onBufferUnload(buffer) {
        buffer.off("update", this.updateBuffer, this);
        buffer.off("change", this.onBufferChange, this);
    }
    createGPUBuffer(buffer) {
        const gpuBuffer = this._gpu.device.createBuffer(buffer.descriptor);
        buffer._updateID = 0;
        buffer._resourceId = (0, $1bMtF.uid)("resource");
        if (buffer.data) {
            (0, $3hvSu.fastCopy)(buffer.data.buffer, gpuBuffer.getMappedRange(), buffer.data.byteOffset, buffer.data.byteLength);
            gpuBuffer.unmap();
        }
        buffer._gpuData[this._renderer.uid] = new $b20a3d38763c8137$export$e91cf4db05973d99(gpuBuffer);
        if (this._managedBuffers.add(buffer)) {
            buffer.on("update", this.updateBuffer, this);
            buffer.on("change", this.onBufferChange, this);
        }
        return gpuBuffer;
    }
    onBufferChange(buffer) {
        this._managedBuffers.remove(buffer);
        buffer._updateID = 0;
        this.createGPUBuffer(buffer);
    }
    destroy() {
        this._managedBuffers.destroy();
        this._renderer = null;
        this._gpu = null;
    }
}
/** @ignore */ $b20a3d38763c8137$export$d5c22bf974706849.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "buffer"
};

});

parcelRegister("8KWmS", function(module, exports) {

$parcel$export(module.exports, "GpuColorMaskSystem", () => $deac791fc91e567f$export$f1d91b5b601f4b9f);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $deac791fc91e567f$export$f1d91b5b601f4b9f {
    constructor(renderer){
        this._colorMaskCache = 15;
        this._renderer = renderer;
    }
    setMask(colorMask) {
        if (this._colorMaskCache === colorMask) return;
        this._colorMaskCache = colorMask;
        this._renderer.pipeline.setColorMask(colorMask);
    }
    destroy() {
        this._renderer = null;
        this._colorMaskCache = null;
    }
}
/** @ignore */ $deac791fc91e567f$export$f1d91b5b601f4b9f.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "colorMask"
};

});

parcelRegister("7nhp3", function(module, exports) {

$parcel$export(module.exports, "GpuDeviceSystem", () => $3b1b8bcf525bdbfb$export$90d6353c0a496497);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $3b1b8bcf525bdbfb$export$90d6353c0a496497 {
    /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        this._renderer = renderer;
    }
    async init(options) {
        if (this._initPromise) return this._initPromise;
        this._initPromise = (options.gpu ? Promise.resolve(options.gpu) : this._createDeviceAndAdaptor(options)).then((gpu)=>{
            this.gpu = gpu;
            this._renderer.runners.contextChange.emit(this.gpu);
        });
        return this._initPromise;
    }
    /**
   * Handle the context change event
   * @param gpu
   */ contextChange(gpu) {
        this._renderer.gpu = gpu;
    }
    /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */ async _createDeviceAndAdaptor(options) {
        const adapter = await (0, $gLw46.DOMAdapter).get().getNavigator().gpu.requestAdapter({
            powerPreference: options.powerPreference,
            forceFallbackAdapter: options.forceFallbackAdapter
        });
        const requiredFeatures = [
            "texture-compression-bc",
            "texture-compression-astc",
            "texture-compression-etc2"
        ].filter((feature)=>adapter.features.has(feature));
        const device = await adapter.requestDevice({
            requiredFeatures: requiredFeatures
        });
        return {
            adapter: adapter,
            device: device
        };
    }
    destroy() {
        this.gpu = null;
        this._renderer = null;
    }
}
/** @ignore */ $3b1b8bcf525bdbfb$export$90d6353c0a496497.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "device"
};
/** The default options for the GpuDeviceSystem. */ $3b1b8bcf525bdbfb$export$90d6353c0a496497.defaultOptions = {
    /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */ powerPreference: void 0,
    /**
   * Force the use of the fallback adapter
   * @default false
   */ forceFallbackAdapter: false
};

});

parcelRegister("cQMIy", function(module, exports) {

$parcel$export(module.exports, "GpuEncoderSystem", () => $f26396b99d4f3ff0$export$177a3a525d0d5e59);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $f26396b99d4f3ff0$export$177a3a525d0d5e59 {
    constructor(renderer){
        this._boundBindGroup = /* @__PURE__ */ Object.create(null);
        this._boundVertexBuffer = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
    }
    renderStart() {
        this.commandFinished = new Promise((resolve)=>{
            this._resolveCommandFinished = resolve;
        });
        this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
    }
    beginRenderPass(gpuRenderTarget) {
        this.endRenderPass();
        this._clearCache();
        this.renderPassEncoder = this.commandEncoder.beginRenderPass(gpuRenderTarget.descriptor);
    }
    endRenderPass() {
        if (this.renderPassEncoder) this.renderPassEncoder.end();
        this.renderPassEncoder = null;
    }
    setViewport(viewport) {
        this.renderPassEncoder.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, 0, 1);
    }
    setPipelineFromGeometryProgramAndState(geometry, program, state, topology) {
        const pipeline = this._renderer.pipeline.getPipeline(geometry, program, state, topology);
        this.setPipeline(pipeline);
    }
    setPipeline(pipeline) {
        if (this._boundPipeline === pipeline) return;
        this._boundPipeline = pipeline;
        this.renderPassEncoder.setPipeline(pipeline);
    }
    _setVertexBuffer(index, buffer) {
        if (this._boundVertexBuffer[index] === buffer) return;
        this._boundVertexBuffer[index] = buffer;
        this.renderPassEncoder.setVertexBuffer(index, this._renderer.buffer.updateBuffer(buffer));
    }
    _setIndexBuffer(buffer) {
        if (this._boundIndexBuffer === buffer) return;
        this._boundIndexBuffer = buffer;
        const indexFormat = buffer.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
        this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(buffer), indexFormat);
    }
    resetBindGroup(index) {
        this._boundBindGroup[index] = null;
    }
    setBindGroup(index, bindGroup, program) {
        if (this._boundBindGroup[index] === bindGroup) return;
        this._boundBindGroup[index] = bindGroup;
        bindGroup._touch(this._renderer.gc.now, this._renderer.tick);
        const gpuBindGroup = this._renderer.bindGroup.getBindGroup(bindGroup, program, index);
        this.renderPassEncoder.setBindGroup(index, gpuBindGroup);
    }
    setGeometry(geometry, program) {
        const buffersToBind = this._renderer.pipeline.getBufferNamesToBind(geometry, program);
        for(const i in buffersToBind)this._setVertexBuffer(parseInt(i, 10), geometry.attributes[buffersToBind[i]].buffer);
        if (geometry.indexBuffer) this._setIndexBuffer(geometry.indexBuffer);
    }
    _setShaderBindGroups(shader, skipSync) {
        for(const i in shader.groups){
            const bindGroup = shader.groups[i];
            if (!skipSync) this._syncBindGroup(bindGroup);
            this.setBindGroup(i, bindGroup, shader.gpuProgram);
        }
    }
    _syncBindGroup(bindGroup) {
        for(const j in bindGroup.resources){
            const resource = bindGroup.resources[j];
            if (resource.isUniformGroup) this._renderer.ubo.updateUniformGroup(resource);
        }
    }
    draw(options) {
        const { geometry: geometry, shader: shader, state: state, topology: topology, size: size, start: start, instanceCount: instanceCount, skipSync: skipSync } = options;
        this.setPipelineFromGeometryProgramAndState(geometry, shader.gpuProgram, state, topology);
        this.setGeometry(geometry, shader.gpuProgram);
        this._setShaderBindGroups(shader, skipSync);
        if (geometry.indexBuffer) this.renderPassEncoder.drawIndexed(size || geometry.indexBuffer.data.length, instanceCount ?? geometry.instanceCount, start || 0);
        else this.renderPassEncoder.draw(size || geometry.getSize(), instanceCount ?? geometry.instanceCount, start || 0);
    }
    finishRenderPass() {
        if (this.renderPassEncoder) {
            this.renderPassEncoder.end();
            this.renderPassEncoder = null;
        }
    }
    postrender() {
        this.finishRenderPass();
        this._gpu.device.queue.submit([
            this.commandEncoder.finish()
        ]);
        this._resolveCommandFinished();
        this.commandEncoder = null;
    }
    // restores a render pass if finishRenderPass was called
    // not optimised as really used for debugging!
    // used when we want to stop drawing and log a texture..
    restoreRenderPass() {
        const descriptor = this._renderer.renderTarget.adaptor.getDescriptor(this._renderer.renderTarget.renderTarget, false, [
            0,
            0,
            0,
            1
        ], this._renderer.renderTarget.mipLevel, this._renderer.renderTarget.layer);
        this.renderPassEncoder = this.commandEncoder.beginRenderPass(descriptor);
        const boundPipeline = this._boundPipeline;
        const boundVertexBuffer = {
            ...this._boundVertexBuffer
        };
        const boundIndexBuffer = this._boundIndexBuffer;
        const boundBindGroup = {
            ...this._boundBindGroup
        };
        this._clearCache();
        const viewport = this._renderer.renderTarget.viewport;
        this.renderPassEncoder.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, 0, 1);
        this.setPipeline(boundPipeline);
        for(const i in boundVertexBuffer)this._setVertexBuffer(i, boundVertexBuffer[i]);
        for(const i in boundBindGroup)this.setBindGroup(i, boundBindGroup[i], null);
        this._setIndexBuffer(boundIndexBuffer);
    }
    _clearCache() {
        for(let i = 0; i < 16; i++){
            this._boundBindGroup[i] = null;
            this._boundVertexBuffer[i] = null;
        }
        this._boundIndexBuffer = null;
        this._boundPipeline = null;
    }
    destroy() {
        this._renderer = null;
        this._gpu = null;
        this._boundBindGroup = null;
        this._boundVertexBuffer = null;
        this._boundIndexBuffer = null;
        this._boundPipeline = null;
    }
    contextChange(gpu) {
        this._gpu = gpu;
    }
}
/** @ignore */ $f26396b99d4f3ff0$export$177a3a525d0d5e59.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "encoder",
    priority: 1
};

});

parcelRegister("k3sPs", function(module, exports) {

$parcel$export(module.exports, "GpuLimitsSystem", () => $a304a40b9d46cf37$export$9cf4f0eb9eaaf953);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $a304a40b9d46cf37$export$9cf4f0eb9eaaf953 {
    constructor(renderer){
        this._renderer = renderer;
    }
    contextChange() {
        this.maxTextures = this._renderer.device.gpu.device.limits.maxSampledTexturesPerShaderStage;
        this.maxBatchableTextures = this.maxTextures;
    }
    destroy() {}
}
/** @ignore */ $a304a40b9d46cf37$export$9cf4f0eb9eaaf953.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "limits"
};

});

parcelRegister("4ilFQ", function(module, exports) {

$parcel$export(module.exports, "GpuStencilSystem", () => $4400a3b034e2a8b3$export$113db01014ec903f);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fYoss = parcelRequire("fYoss");
"use strict";
class $4400a3b034e2a8b3$export$113db01014ec903f {
    constructor(renderer){
        this._renderTargetStencilState = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
        renderer.renderTarget.onRenderTargetChange.add(this);
    }
    onRenderTargetChange(renderTarget) {
        let stencilState = this._renderTargetStencilState[renderTarget.uid];
        if (!stencilState) stencilState = this._renderTargetStencilState[renderTarget.uid] = {
            stencilMode: (0, $fYoss.STENCIL_MODES).DISABLED,
            stencilReference: 0
        };
        this._activeRenderTarget = renderTarget;
        this.setStencilMode(stencilState.stencilMode, stencilState.stencilReference);
    }
    setStencilMode(stencilMode, stencilReference) {
        const stencilState = this._renderTargetStencilState[this._activeRenderTarget.uid];
        stencilState.stencilMode = stencilMode;
        stencilState.stencilReference = stencilReference;
        const renderer = this._renderer;
        renderer.pipeline.setStencilMode(stencilMode);
        renderer.encoder.renderPassEncoder.setStencilReference(stencilReference);
    }
    destroy() {
        this._renderer.renderTarget.onRenderTargetChange.remove(this);
        this._renderer = null;
        this._activeRenderTarget = null;
        this._renderTargetStencilState = null;
    }
}
/** @ignore */ $4400a3b034e2a8b3$export$113db01014ec903f.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "stencil"
};

});

parcelRegister("epQzV", function(module, exports) {

$parcel$export(module.exports, "GpuUboSystem", () => $a57920a569064420$export$5ea2b5ed88b4e26d);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $jSrmW = parcelRequire("jSrmW");

var $hXd8Z = parcelRequire("hXd8Z");

var $8346X = parcelRequire("8346X");
"use strict";
class $a57920a569064420$export$5ea2b5ed88b4e26d extends (0, $jSrmW.UboSystem) {
    constructor(){
        super({
            createUboElements: (0, $hXd8Z.createUboElementsWGSL),
            generateUboSync: (0, $8346X.createUboSyncFunctionWGSL)
        });
    }
}
/** @ignore */ $a57920a569064420$export$5ea2b5ed88b4e26d.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "ubo"
};

});
parcelRegister("hXd8Z", function(module, exports) {

$parcel$export(module.exports, "WGSL_ALIGN_SIZE_DATA", () => $7a4701bb78698fee$export$ed24ead4dd40bc67);
$parcel$export(module.exports, "createUboElementsWGSL", () => $7a4701bb78698fee$export$67f83dfc341942e5);
"use strict";
const $7a4701bb78698fee$export$ed24ead4dd40bc67 = {
    i32: {
        align: 4,
        size: 4
    },
    u32: {
        align: 4,
        size: 4
    },
    f32: {
        align: 4,
        size: 4
    },
    f16: {
        align: 2,
        size: 2
    },
    "vec2<i32>": {
        align: 8,
        size: 8
    },
    "vec2<u32>": {
        align: 8,
        size: 8
    },
    "vec2<f32>": {
        align: 8,
        size: 8
    },
    "vec2<f16>": {
        align: 4,
        size: 4
    },
    "vec3<i32>": {
        align: 16,
        size: 12
    },
    "vec3<u32>": {
        align: 16,
        size: 12
    },
    "vec3<f32>": {
        align: 16,
        size: 12
    },
    "vec3<f16>": {
        align: 8,
        size: 6
    },
    "vec4<i32>": {
        align: 16,
        size: 16
    },
    "vec4<u32>": {
        align: 16,
        size: 16
    },
    "vec4<f32>": {
        align: 16,
        size: 16
    },
    "vec4<f16>": {
        align: 8,
        size: 8
    },
    "mat2x2<f32>": {
        align: 8,
        size: 16
    },
    "mat2x2<f16>": {
        align: 4,
        size: 8
    },
    "mat3x2<f32>": {
        align: 8,
        size: 24
    },
    "mat3x2<f16>": {
        align: 4,
        size: 12
    },
    "mat4x2<f32>": {
        align: 8,
        size: 32
    },
    "mat4x2<f16>": {
        align: 4,
        size: 16
    },
    "mat2x3<f32>": {
        align: 16,
        size: 32
    },
    "mat2x3<f16>": {
        align: 8,
        size: 16
    },
    "mat3x3<f32>": {
        align: 16,
        size: 48
    },
    "mat3x3<f16>": {
        align: 8,
        size: 24
    },
    "mat4x3<f32>": {
        align: 16,
        size: 64
    },
    "mat4x3<f16>": {
        align: 8,
        size: 32
    },
    "mat2x4<f32>": {
        align: 16,
        size: 32
    },
    "mat2x4<f16>": {
        align: 8,
        size: 16
    },
    "mat3x4<f32>": {
        align: 16,
        size: 48
    },
    "mat3x4<f16>": {
        align: 8,
        size: 24
    },
    "mat4x4<f32>": {
        align: 16,
        size: 64
    },
    "mat4x4<f16>": {
        align: 8,
        size: 32
    }
};
function $7a4701bb78698fee$export$67f83dfc341942e5(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            size: 0
        }));
    let offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        let size = $7a4701bb78698fee$export$ed24ead4dd40bc67[uboElement.data.type].size;
        const align = $7a4701bb78698fee$export$ed24ead4dd40bc67[uboElement.data.type].align;
        if (!$7a4701bb78698fee$export$ed24ead4dd40bc67[uboElement.data.type]) throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${uboElement.data.type}`);
        if (uboElement.data.size > 1) size = Math.max(size, align) * uboElement.data.size;
        offset = Math.ceil(offset / align) * align;
        uboElement.size = size;
        uboElement.offset = offset;
        offset += size;
    }
    offset = Math.ceil(offset / 16) * 16;
    return {
        uboElements: uboElements,
        size: offset
    };
}

});

parcelRegister("8346X", function(module, exports) {

$parcel$export(module.exports, "createUboSyncFunctionWGSL", () => $ed14567e395b76fb$export$22c97551670f94ff);

var $9dsH7 = parcelRequire("9dsH7");

var $ktXe2 = parcelRequire("ktXe2");

var $9LA71 = parcelRequire("9LA71");
"use strict";
function $ed14567e395b76fb$export$22c97551670f94ff(uboElements) {
    return (0, $9dsH7.createUboSyncFunction)(uboElements, "uboWgsl", (0, $9LA71.generateArraySyncWGSL), (0, $ktXe2.uboSyncFunctionsWGSL));
}

});
parcelRegister("9LA71", function(module, exports) {

$parcel$export(module.exports, "generateArraySyncWGSL", () => $d7a4928e07e37def$export$a225b76cfac4c0af);

var $hXd8Z = parcelRequire("hXd8Z");
"use strict";
function $d7a4928e07e37def$export$a225b76cfac4c0af(uboElement, offsetToAdd) {
    const { size: size, align: align } = (0, $hXd8Z.WGSL_ALIGN_SIZE_DATA)[uboElement.data.type];
    const remainder = (align - size) / 4;
    const data = uboElement.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
    return `
         v = uv.${uboElement.data.name};
         ${offsetToAdd !== 0 ? `offset += ${offsetToAdd};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${uboElement.data.size * (size / 4)}; i++)
         {
             for(var j = 0; j < ${size / 4}; j++)
             {
                 ${data}[arrayOffset++] = v[t++];
             }
             ${remainder !== 0 ? `arrayOffset += ${remainder};` : ""}
         }
     `;
}

});



parcelRegister("fYxv0", function(module, exports) {

$parcel$export(module.exports, "GpuUniformBatchPipe", () => $36f3cb52c94b5d42$export$2cfd377d01248ea0);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2bJdA = parcelRequire("2bJdA");

var $9axq6 = parcelRequire("9axq6");

var $1T7Iy = parcelRequire("1T7Iy");

var $bcrPS = parcelRequire("bcrPS");

var $eK2sB = parcelRequire("eK2sB");
"use strict";
const $36f3cb52c94b5d42$var$minUniformOffsetAlignment = 128;
class $36f3cb52c94b5d42$export$2cfd377d01248ea0 {
    constructor(renderer){
        this._bindGroupHash = /* @__PURE__ */ Object.create(null);
        // number of buffers..
        this._buffers = [];
        this._bindGroups = [];
        this._bufferResources = [];
        this._renderer = renderer;
        this._batchBuffer = new (0, $bcrPS.UboBatch)({
            minUniformOffsetAlignment: $36f3cb52c94b5d42$var$minUniformOffsetAlignment
        });
        const totalBuffers = 256 / $36f3cb52c94b5d42$var$minUniformOffsetAlignment;
        for(let i = 0; i < totalBuffers; i++){
            let usage = (0, $1T7Iy.BufferUsage).UNIFORM | (0, $1T7Iy.BufferUsage).COPY_DST;
            if (i === 0) usage |= (0, $1T7Iy.BufferUsage).COPY_SRC;
            this._buffers.push(new (0, $2bJdA.Buffer)({
                data: this._batchBuffer.data,
                usage: usage
            }));
        }
    }
    renderEnd() {
        this._uploadBindGroups();
        this._resetBindGroups();
    }
    _resetBindGroups() {
        this._bindGroupHash = /* @__PURE__ */ Object.create(null);
        this._batchBuffer.clear();
    }
    // just works for single bind groups for now
    getUniformBindGroup(group, duplicate) {
        if (!duplicate && this._bindGroupHash[group.uid]) return this._bindGroupHash[group.uid];
        this._renderer.ubo.ensureUniformGroup(group);
        const data = group.buffer.data;
        const offset = this._batchBuffer.addEmptyGroup(data.length);
        this._renderer.ubo.syncUniformGroup(group, this._batchBuffer.data, offset / 4);
        this._bindGroupHash[group.uid] = this._getBindGroup(offset / $36f3cb52c94b5d42$var$minUniformOffsetAlignment);
        return this._bindGroupHash[group.uid];
    }
    getUboResource(group) {
        this._renderer.ubo.updateUniformGroup(group);
        const data = group.buffer.data;
        const offset = this._batchBuffer.addGroup(data);
        return this._getBufferResource(offset / $36f3cb52c94b5d42$var$minUniformOffsetAlignment);
    }
    getArrayBindGroup(data) {
        const offset = this._batchBuffer.addGroup(data);
        return this._getBindGroup(offset / $36f3cb52c94b5d42$var$minUniformOffsetAlignment);
    }
    getArrayBufferResource(data) {
        const offset = this._batchBuffer.addGroup(data);
        const index = offset / $36f3cb52c94b5d42$var$minUniformOffsetAlignment;
        return this._getBufferResource(index);
    }
    _getBufferResource(index) {
        if (!this._bufferResources[index]) {
            const buffer = this._buffers[index % 2];
            this._bufferResources[index] = new (0, $9axq6.BufferResource)({
                buffer: buffer,
                offset: (index / 2 | 0) * 256,
                size: $36f3cb52c94b5d42$var$minUniformOffsetAlignment
            });
        }
        return this._bufferResources[index];
    }
    _getBindGroup(index) {
        if (!this._bindGroups[index]) {
            const bindGroup = new (0, $eK2sB.BindGroup)({
                0: this._getBufferResource(index)
            });
            this._bindGroups[index] = bindGroup;
        }
        return this._bindGroups[index];
    }
    _uploadBindGroups() {
        const bufferSystem = this._renderer.buffer;
        const firstBuffer = this._buffers[0];
        firstBuffer.update(this._batchBuffer.byteIndex);
        bufferSystem.updateBuffer(firstBuffer);
        const commandEncoder = this._renderer.gpu.device.createCommandEncoder();
        for(let i = 1; i < this._buffers.length; i++){
            const buffer = this._buffers[i];
            commandEncoder.copyBufferToBuffer(bufferSystem.getGPUBuffer(firstBuffer), $36f3cb52c94b5d42$var$minUniformOffsetAlignment, bufferSystem.getGPUBuffer(buffer), 0, this._batchBuffer.byteIndex);
        }
        this._renderer.gpu.device.queue.submit([
            commandEncoder.finish()
        ]);
    }
    destroy() {
        for(let i = 0; i < this._bindGroups.length; i++)this._bindGroups[i]?.destroy();
        this._bindGroups = null;
        this._bindGroupHash = null;
        for(let i = 0; i < this._buffers.length; i++)this._buffers[i].destroy();
        this._buffers = null;
        for(let i = 0; i < this._bufferResources.length; i++)this._bufferResources[i].destroy();
        this._bufferResources = null;
        this._batchBuffer.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $36f3cb52c94b5d42$export$2cfd377d01248ea0.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "uniformBatch"
};

});
parcelRegister("bcrPS", function(module, exports) {

$parcel$export(module.exports, "UboBatch", () => $ee91e1ba0ed75d83$export$a2b8eb98de7ddf1c);
"use strict";
class $ee91e1ba0ed75d83$export$a2b8eb98de7ddf1c {
    constructor({ minUniformOffsetAlignment: minUniformOffsetAlignment }){
        this._minUniformOffsetAlignment = 256;
        this.byteIndex = 0;
        this._minUniformOffsetAlignment = minUniformOffsetAlignment;
        this.data = new Float32Array(65535);
    }
    clear() {
        this.byteIndex = 0;
    }
    addEmptyGroup(size) {
        if (size > this._minUniformOffsetAlignment / 4) throw new Error(`UniformBufferBatch: array is too large: ${size * 4}`);
        const start = this.byteIndex;
        let newSize = start + size * 4;
        newSize = Math.ceil(newSize / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment;
        if (newSize > this.data.length * 4) throw new Error("UniformBufferBatch: ubo batch got too big");
        this.byteIndex = newSize;
        return start;
    }
    addGroup(array) {
        const offset = this.addEmptyGroup(array.length);
        for(let i = 0; i < array.length; i++)this.data[offset / 4 + i] = array[i];
        return offset;
    }
    destroy() {
        this.data = null;
    }
}

});


parcelRegister("asuS1", function(module, exports) {

$parcel$export(module.exports, "PipelineSystem", () => $2f18da8dc4ab4dde$export$b111033e0fd27efe);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1RpxL = parcelRequire("1RpxL");

var $5dp3e = parcelRequire("5dp3e");

var $fYoss = parcelRequire("fYoss");

var $jpjFn = parcelRequire("jpjFn");

var $kcEAx = parcelRequire("kcEAx");
"use strict";
const $2f18da8dc4ab4dde$var$topologyStringToId = {
    "point-list": 0,
    "line-list": 1,
    "line-strip": 2,
    "triangle-list": 3,
    "triangle-strip": 4
};
function $2f18da8dc4ab4dde$var$getGraphicsStateKey(geometryLayout, shaderKey, state, blendMode, topology) {
    return geometryLayout << 24 | shaderKey << 16 | state << 10 | blendMode << 5 | topology;
}
function $2f18da8dc4ab4dde$var$getGlobalStateKey(stencilStateId, multiSampleCount, colorMask, renderTarget, colorTargetCount) {
    return colorMask << 8 | stencilStateId << 5 | renderTarget << 3 | colorTargetCount << 1 | multiSampleCount;
}
class $2f18da8dc4ab4dde$export$b111033e0fd27efe {
    constructor(renderer){
        this._moduleCache = /* @__PURE__ */ Object.create(null);
        this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null);
        this._bindingNamesCache = /* @__PURE__ */ Object.create(null);
        this._pipeCache = /* @__PURE__ */ Object.create(null);
        this._pipeStateCaches = /* @__PURE__ */ Object.create(null);
        this._colorMask = 15;
        this._multisampleCount = 1;
        this._colorTargetCount = 1;
        this._renderer = renderer;
    }
    contextChange(gpu) {
        this._gpu = gpu;
        this.setStencilMode((0, $fYoss.STENCIL_MODES).DISABLED);
        this._updatePipeHash();
    }
    setMultisampleCount(multisampleCount) {
        if (this._multisampleCount === multisampleCount) return;
        this._multisampleCount = multisampleCount;
        this._updatePipeHash();
    }
    setRenderTarget(renderTarget) {
        this._multisampleCount = renderTarget.msaaSamples;
        this._depthStencilAttachment = renderTarget.descriptor.depthStencilAttachment ? 1 : 0;
        this._colorTargetCount = renderTarget.colorTargetCount;
        this._updatePipeHash();
    }
    setColorMask(colorMask) {
        if (this._colorMask === colorMask) return;
        this._colorMask = colorMask;
        this._updatePipeHash();
    }
    setStencilMode(stencilMode) {
        if (this._stencilMode === stencilMode) return;
        this._stencilMode = stencilMode;
        this._stencilState = (0, $kcEAx.GpuStencilModesToPixi)[stencilMode];
        this._updatePipeHash();
    }
    setPipeline(geometry, program, state, passEncoder) {
        const pipeline = this.getPipeline(geometry, program, state);
        passEncoder.setPipeline(pipeline);
    }
    getPipeline(geometry, program, state, topology) {
        if (!geometry._layoutKey) {
            (0, $5dp3e.ensureAttributes)(geometry, program.attributeData);
            this._generateBufferKey(geometry);
        }
        topology || (topology = geometry.topology);
        const key = $2f18da8dc4ab4dde$var$getGraphicsStateKey(geometry._layoutKey, program._layoutKey, state.data, state._blendModeId, $2f18da8dc4ab4dde$var$topologyStringToId[topology]);
        if (this._pipeCache[key]) return this._pipeCache[key];
        this._pipeCache[key] = this._createPipeline(geometry, program, state, topology);
        return this._pipeCache[key];
    }
    _createPipeline(geometry, program, state, topology) {
        const device = this._gpu.device;
        const buffers = this._createVertexBufferLayouts(geometry, program);
        const blendModes = this._renderer.state.getColorTargets(state, this._colorTargetCount);
        const writeMask = this._stencilMode === (0, $fYoss.STENCIL_MODES).RENDERING_MASK_ADD ? 0 : this._colorMask;
        for(let i = 0; i < blendModes.length; i++)blendModes[i].writeMask = writeMask;
        const layout = this._renderer.shader.getProgramData(program).pipeline;
        const descriptor = {
            // TODO later check if its helpful to create..
            // layout,
            vertex: {
                module: this._getModule(program.vertex.source),
                entryPoint: program.vertex.entryPoint,
                buffers: // geometry..
                buffers
            },
            fragment: {
                module: this._getModule(program.fragment.source),
                entryPoint: program.fragment.entryPoint,
                targets: blendModes
            },
            primitive: {
                topology: topology,
                cullMode: state.cullMode
            },
            layout: layout,
            multisample: {
                count: this._multisampleCount
            },
            // depthStencil,
            label: `PIXI Pipeline`
        };
        if (this._depthStencilAttachment) descriptor.depthStencil = {
            ...this._stencilState,
            format: "depth24plus-stencil8",
            depthWriteEnabled: state.depthTest,
            depthCompare: state.depthTest ? "less" : "always"
        };
        const pipeline = device.createRenderPipeline(descriptor);
        return pipeline;
    }
    _getModule(code) {
        return this._moduleCache[code] || this._createModule(code);
    }
    _createModule(code) {
        const device = this._gpu.device;
        this._moduleCache[code] = device.createShaderModule({
            code: code
        });
        return this._moduleCache[code];
    }
    _generateBufferKey(geometry) {
        const keyGen = [];
        let index = 0;
        const attributeKeys = Object.keys(geometry.attributes).sort();
        for(let i = 0; i < attributeKeys.length; i++){
            const attribute = geometry.attributes[attributeKeys[i]];
            keyGen[index++] = attribute.offset;
            keyGen[index++] = attribute.format;
            keyGen[index++] = attribute.stride;
            keyGen[index++] = attribute.instance;
        }
        const stringKey = keyGen.join("|");
        geometry._layoutKey = (0, $jpjFn.createIdFromString)(stringKey, "geometry");
        return geometry._layoutKey;
    }
    _generateAttributeLocationsKey(program) {
        const keyGen = [];
        let index = 0;
        const attributeKeys = Object.keys(program.attributeData).sort();
        for(let i = 0; i < attributeKeys.length; i++){
            const attribute = program.attributeData[attributeKeys[i]];
            keyGen[index++] = attribute.location;
        }
        const stringKey = keyGen.join("|");
        program._attributeLocationsKey = (0, $jpjFn.createIdFromString)(stringKey, "programAttributes");
        return program._attributeLocationsKey;
    }
    /**
   * Returns a hash of buffer names mapped to bind locations.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns An object of buffer names mapped to the bind location.
   */ getBufferNamesToBind(geometry, program) {
        const key = geometry._layoutKey << 16 | program._attributeLocationsKey;
        if (this._bindingNamesCache[key]) return this._bindingNamesCache[key];
        const data = this._createVertexBufferLayouts(geometry, program);
        const bufferNamesToBind = /* @__PURE__ */ Object.create(null);
        const attributeData = program.attributeData;
        for(let i = 0; i < data.length; i++){
            const attributes = Object.values(data[i].attributes);
            const shaderLocation = attributes[0].shaderLocation;
            for(const j in attributeData)if (attributeData[j].location === shaderLocation) {
                bufferNamesToBind[i] = j;
                break;
            }
        }
        this._bindingNamesCache[key] = bufferNamesToBind;
        return bufferNamesToBind;
    }
    _createVertexBufferLayouts(geometry, program) {
        if (!program._attributeLocationsKey) this._generateAttributeLocationsKey(program);
        const key = geometry._layoutKey << 16 | program._attributeLocationsKey;
        if (this._bufferLayoutsCache[key]) return this._bufferLayoutsCache[key];
        const vertexBuffersLayout = [];
        geometry.buffers.forEach((buffer)=>{
            const bufferEntry = {
                arrayStride: 0,
                stepMode: "vertex",
                attributes: []
            };
            const bufferEntryAttributes = bufferEntry.attributes;
            for(const i in program.attributeData){
                const attribute = geometry.attributes[i];
                if ((attribute.divisor ?? 1) !== 1) (0, $1RpxL.warn)(`Attribute ${i} has an invalid divisor value of '${attribute.divisor}'. WebGPU only supports a divisor value of 1`);
                if (attribute.buffer === buffer) {
                    bufferEntry.arrayStride = attribute.stride;
                    bufferEntry.stepMode = attribute.instance ? "instance" : "vertex";
                    bufferEntryAttributes.push({
                        shaderLocation: program.attributeData[i].location,
                        offset: attribute.offset,
                        format: attribute.format
                    });
                }
            }
            if (bufferEntryAttributes.length) vertexBuffersLayout.push(bufferEntry);
        });
        this._bufferLayoutsCache[key] = vertexBuffersLayout;
        return vertexBuffersLayout;
    }
    _updatePipeHash() {
        const key = $2f18da8dc4ab4dde$var$getGlobalStateKey(this._stencilMode, this._multisampleCount, this._colorMask, this._depthStencilAttachment, this._colorTargetCount);
        if (!this._pipeStateCaches[key]) this._pipeStateCaches[key] = /* @__PURE__ */ Object.create(null);
        this._pipeCache = this._pipeStateCaches[key];
    }
    destroy() {
        this._renderer = null;
        this._bufferLayoutsCache = null;
    }
}
/** @ignore */ $2f18da8dc4ab4dde$export$b111033e0fd27efe.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "pipeline"
};

});

parcelRegister("9oWpi", function(module, exports) {

$parcel$export(module.exports, "GpuRenderTargetSystem", () => $4fbd0143c913f058$export$6e55abfc39d84e56);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $2nO5l = parcelRequire("2nO5l");

var $26lTw = parcelRequire("26lTw");
"use strict";
class $4fbd0143c913f058$export$6e55abfc39d84e56 extends (0, $2nO5l.RenderTargetSystem) {
    constructor(renderer){
        super(renderer);
        this.adaptor = new (0, $26lTw.GpuRenderTargetAdaptor)();
        this.adaptor.init(renderer, this);
    }
}
/** @ignore */ $4fbd0143c913f058$export$6e55abfc39d84e56.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "renderTarget"
};

});
parcelRegister("26lTw", function(module, exports) {

$parcel$export(module.exports, "GpuRenderTargetAdaptor", () => $95544060442384c6$export$93fddc6a511824d);

var $5Ac7T = parcelRequire("5Ac7T");

var $egYi0 = parcelRequire("egYi0");

var $gmQ4R = parcelRequire("gmQ4R");

var $iXZ4N = parcelRequire("iXZ4N");
"use strict";
class $95544060442384c6$export$93fddc6a511824d {
    init(renderer, renderTargetSystem) {
        this._renderer = renderer;
        this._renderTargetSystem = renderTargetSystem;
    }
    copyToTexture(sourceRenderSurfaceTexture, destinationTexture, originSrc, size, originDest) {
        const renderer = this._renderer;
        const baseGpuTexture = this._getGpuColorTexture(sourceRenderSurfaceTexture);
        const backGpuTexture = renderer.texture.getGpuSource(destinationTexture.source);
        renderer.encoder.commandEncoder.copyTextureToTexture({
            texture: baseGpuTexture,
            origin: originSrc
        }, {
            texture: backGpuTexture,
            origin: originDest
        }, size);
        return destinationTexture;
    }
    startRenderPass(renderTarget, clear = true, clearColor, viewport, mipLevel = 0, layer = 0) {
        const renderTargetSystem = this._renderTargetSystem;
        const gpuRenderTarget = renderTargetSystem.getGpuRenderTarget(renderTarget);
        if (layer !== 0 && gpuRenderTarget.msaaTextures?.length) throw new Error("[RenderTargetSystem] Rendering to array layers is not supported with MSAA render targets.");
        if (mipLevel > 0 && gpuRenderTarget.msaaTextures?.length) throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
        const descriptor = this.getDescriptor(renderTarget, clear, clearColor, mipLevel, layer);
        gpuRenderTarget.descriptor = descriptor;
        this._renderer.pipeline.setRenderTarget(gpuRenderTarget);
        this._renderer.encoder.beginRenderPass(gpuRenderTarget);
        this._renderer.encoder.setViewport(viewport);
    }
    finishRenderPass() {
        this._renderer.encoder.endRenderPass();
    }
    /**
   * returns the gpu texture for the first color texture in the render target
   * mainly used by the filter manager to get copy the texture for blending
   * @param renderTarget
   * @returns a gpu texture
   */ _getGpuColorTexture(renderTarget) {
        const gpuRenderTarget = this._renderTargetSystem.getGpuRenderTarget(renderTarget);
        if (gpuRenderTarget.contexts[0]) return gpuRenderTarget.contexts[0].getCurrentTexture();
        return this._renderer.texture.getGpuSource(renderTarget.colorTextures[0].source);
    }
    getDescriptor(renderTarget, clear, clearValue, mipLevel = 0, layer = 0) {
        if (typeof clear === "boolean") clear = clear ? (0, $5Ac7T.CLEAR).ALL : (0, $5Ac7T.CLEAR).NONE;
        const renderTargetSystem = this._renderTargetSystem;
        const gpuRenderTarget = renderTargetSystem.getGpuRenderTarget(renderTarget);
        const colorAttachments = renderTarget.colorTextures.map((texture, i)=>{
            const context = gpuRenderTarget.contexts[i];
            let view;
            let resolveTarget;
            if (context) {
                if (layer !== 0) throw new Error("[RenderTargetSystem] Rendering to array layers is not supported for canvas targets.");
                const currentTexture = context.getCurrentTexture();
                const canvasTextureView = currentTexture.createView();
                view = canvasTextureView;
            } else view = this._renderer.texture.getGpuSource(texture).createView({
                // Render attachments must be 2d views; for array/cube textures we select a single layer.
                dimension: "2d",
                baseMipLevel: mipLevel,
                mipLevelCount: 1,
                baseArrayLayer: layer,
                arrayLayerCount: 1
            });
            if (gpuRenderTarget.msaaTextures[i]) {
                resolveTarget = view;
                view = this._renderer.texture.getTextureView(gpuRenderTarget.msaaTextures[i]);
            }
            const loadOp = clear & (0, $5Ac7T.CLEAR).COLOR ? "clear" : "load";
            clearValue ?? (clearValue = renderTargetSystem.defaultClearColor);
            return {
                view: view,
                resolveTarget: resolveTarget,
                clearValue: clearValue,
                storeOp: "store",
                loadOp: loadOp
            };
        });
        let depthStencilAttachment;
        if ((renderTarget.stencil || renderTarget.depth) && !renderTarget.depthStencilTexture) {
            renderTarget.ensureDepthStencilTexture();
            renderTarget.depthStencilTexture.source.sampleCount = gpuRenderTarget.msaa ? 4 : 1;
        }
        if (renderTarget.depthStencilTexture) {
            const stencilLoadOp = clear & (0, $5Ac7T.CLEAR).STENCIL ? "clear" : "load";
            const depthLoadOp = clear & (0, $5Ac7T.CLEAR).DEPTH ? "clear" : "load";
            depthStencilAttachment = {
                view: this._renderer.texture.getGpuSource(renderTarget.depthStencilTexture.source).createView({
                    dimension: "2d",
                    baseMipLevel: mipLevel,
                    mipLevelCount: 1,
                    baseArrayLayer: layer,
                    arrayLayerCount: 1
                }),
                stencilStoreOp: "store",
                stencilLoadOp: stencilLoadOp,
                depthClearValue: 1,
                depthLoadOp: depthLoadOp,
                depthStoreOp: "store"
            };
        }
        const descriptor = {
            colorAttachments: colorAttachments,
            depthStencilAttachment: depthStencilAttachment
        };
        return descriptor;
    }
    clear(renderTarget, clear = true, clearColor, viewport, mipLevel = 0, layer = 0) {
        if (!clear) return;
        const { gpu: gpu, encoder: encoder } = this._renderer;
        const device = gpu.device;
        const standAlone = encoder.commandEncoder === null;
        if (standAlone) {
            const commandEncoder = device.createCommandEncoder();
            const renderPassDescriptor = this.getDescriptor(renderTarget, clear, clearColor, mipLevel, layer);
            const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
            passEncoder.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, 0, 1);
            passEncoder.end();
            const gpuCommands = commandEncoder.finish();
            device.queue.submit([
                gpuCommands
            ]);
        } else this.startRenderPass(renderTarget, clear, clearColor, viewport, mipLevel, layer);
    }
    initGpuRenderTarget(renderTarget) {
        renderTarget.isRoot = true;
        const gpuRenderTarget = new (0, $iXZ4N.GpuRenderTarget)();
        gpuRenderTarget.colorTargetCount = renderTarget.colorTextures.length;
        renderTarget.colorTextures.forEach((colorTexture, i)=>{
            if (colorTexture instanceof (0, $egYi0.CanvasSource)) {
                const context = colorTexture.resource.getContext("webgpu");
                const alphaMode = colorTexture.transparent ? "premultiplied" : "opaque";
                try {
                    context.configure({
                        device: this._renderer.gpu.device,
                        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
                        format: "bgra8unorm",
                        alphaMode: alphaMode
                    });
                } catch (e) {
                    console.error(e);
                }
                gpuRenderTarget.contexts[i] = context;
            }
            gpuRenderTarget.msaa = colorTexture.source.antialias;
            if (colorTexture.source.antialias) {
                const msaaTexture = new (0, $gmQ4R.TextureSource)({
                    width: 0,
                    height: 0,
                    sampleCount: 4,
                    arrayLayerCount: colorTexture.source.arrayLayerCount
                });
                gpuRenderTarget.msaaTextures[i] = msaaTexture;
            }
        });
        if (gpuRenderTarget.msaa) {
            gpuRenderTarget.msaaSamples = 4;
            if (renderTarget.depthStencilTexture) renderTarget.depthStencilTexture.source.sampleCount = 4;
        }
        return gpuRenderTarget;
    }
    destroyGpuRenderTarget(gpuRenderTarget) {
        gpuRenderTarget.contexts.forEach((context)=>{
            context.unconfigure();
        });
        gpuRenderTarget.msaaTextures.forEach((texture)=>{
            texture.destroy();
        });
        gpuRenderTarget.msaaTextures.length = 0;
        gpuRenderTarget.contexts.length = 0;
    }
    ensureDepthStencilTexture(renderTarget) {
        const gpuRenderTarget = this._renderTargetSystem.getGpuRenderTarget(renderTarget);
        if (renderTarget.depthStencilTexture && gpuRenderTarget.msaa) renderTarget.depthStencilTexture.source.sampleCount = 4;
    }
    resizeGpuRenderTarget(renderTarget) {
        const gpuRenderTarget = this._renderTargetSystem.getGpuRenderTarget(renderTarget);
        gpuRenderTarget.width = renderTarget.width;
        gpuRenderTarget.height = renderTarget.height;
        if (gpuRenderTarget.msaa) renderTarget.colorTextures.forEach((colorTexture, i)=>{
            const msaaTexture = gpuRenderTarget.msaaTextures[i];
            msaaTexture?.resize(colorTexture.source.width, colorTexture.source.height, colorTexture.source._resolution);
        });
    }
}

});
parcelRegister("iXZ4N", function(module, exports) {

$parcel$export(module.exports, "GpuRenderTarget", () => $5ceec540a7b22b1b$export$ea1fb918d2902221);
"use strict";
class $5ceec540a7b22b1b$export$ea1fb918d2902221 {
    constructor(){
        this.contexts = [];
        this.msaaTextures = [];
        this.msaaSamples = 1;
    }
}

});



parcelRegister("7oXM7", function(module, exports) {

$parcel$export(module.exports, "GpuShaderSystem", () => $82edb560a838b3c3$export$4626581e8811a5f0);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $82edb560a838b3c3$export$4626581e8811a5f0 {
    constructor(){
        this._gpuProgramData = /* @__PURE__ */ Object.create(null);
    }
    contextChange(gpu) {
        this._gpu = gpu;
    }
    getProgramData(program) {
        return this._gpuProgramData[program._layoutKey] || this._createGPUProgramData(program);
    }
    _createGPUProgramData(program) {
        const device = this._gpu.device;
        const bindGroups = program.gpuLayout.map((group)=>device.createBindGroupLayout({
                entries: group
            }));
        const pipelineLayoutDesc = {
            bindGroupLayouts: bindGroups
        };
        this._gpuProgramData[program._layoutKey] = {
            bindGroups: bindGroups,
            pipeline: device.createPipelineLayout(pipelineLayoutDesc)
        };
        return this._gpuProgramData[program._layoutKey];
    }
    destroy() {
        this._gpu = null;
        this._gpuProgramData = null;
    }
}
/** @ignore */ $82edb560a838b3c3$export$4626581e8811a5f0.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "shader"
};

});

parcelRegister("6v8M4", function(module, exports) {

$parcel$export(module.exports, "GpuStateSystem", () => $bfab96ea3fea77af$export$1fdae7a6d3bfd0f5);

var $aZ9ZN = parcelRequire("aZ9ZN");

var $fx0Zy = parcelRequire("fx0Zy");

var $fWGV5 = parcelRequire("fWGV5");
"use strict";
class $bfab96ea3fea77af$export$1fdae7a6d3bfd0f5 {
    constructor(){
        this.defaultState = new (0, $fx0Zy.State)();
        this.defaultState.blend = true;
    }
    contextChange(gpu) {
        this.gpu = gpu;
    }
    /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   * @param count - The number of color targets to create
   */ getColorTargets(state, count) {
        const blend = (0, $fWGV5.GpuBlendModesToPixi)[state.blendMode] || (0, $fWGV5.GpuBlendModesToPixi).normal;
        const targets = [];
        const target = {
            format: "bgra8unorm",
            writeMask: 0,
            blend: blend
        };
        for(let i = 0; i < count; i++)targets[i] = target;
        return targets;
    }
    destroy() {
        this.gpu = null;
    }
}
/** @ignore */ $bfab96ea3fea77af$export$1fdae7a6d3bfd0f5.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "state"
};

});
parcelRegister("fWGV5", function(module, exports) {

$parcel$export(module.exports, "GpuBlendModesToPixi", () => $b27890ab99f54f64$export$2b300199fb6aad0e);
"use strict";
const $b27890ab99f54f64$export$2b300199fb6aad0e = {};
$b27890ab99f54f64$export$2b300199fb6aad0e.normal = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.add = {
    alpha: {
        srcFactor: "src-alpha",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.multiply = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "dst",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.screen = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one-minus-src",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.overlay = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one-minus-src",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.none = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "zero",
        dstFactor: "zero",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e["normal-npm"] = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "src-alpha",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e["add-npm"] = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "add"
    },
    color: {
        srcFactor: "src-alpha",
        dstFactor: "one",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e["screen-npm"] = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "src-alpha",
        dstFactor: "one-minus-src",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.erase = {
    alpha: {
        srcFactor: "zero",
        dstFactor: "one-minus-src-alpha",
        operation: "add"
    },
    color: {
        srcFactor: "zero",
        dstFactor: "one-minus-src",
        operation: "add"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.min = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "min"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "min"
    }
};
$b27890ab99f54f64$export$2b300199fb6aad0e.max = {
    alpha: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "max"
    },
    color: {
        srcFactor: "one",
        dstFactor: "one",
        operation: "max"
    }
};

});


parcelRegister("h62oc", function(module, exports) {

$parcel$export(module.exports, "GPUTextureGpuData", () => $087caa0105314e63$export$f613aa0da77ec7b8);
$parcel$export(module.exports, "GpuTextureSystem", () => $087caa0105314e63$export$265a5eed50cc4928);

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $aUxJK = parcelRequire("aUxJK");

var $dDZJD = parcelRequire("dDZJD");

var $eK2sB = parcelRequire("eK2sB");

var $fruAx = parcelRequire("fruAx");

var $hrIct = parcelRequire("hrIct");

var $hKdsJ = parcelRequire("hKdsJ");

var $3vOQh = parcelRequire("3vOQh");

var $jQIsz = parcelRequire("jQIsz");

var $2jIR8 = parcelRequire("2jIR8");
"use strict";
class $087caa0105314e63$export$f613aa0da77ec7b8 {
    constructor(gpuTexture){
        this.textureView = null;
        this.gpuTexture = gpuTexture;
    }
    /** Destroys this GPU data instance. */ destroy() {
        this.gpuTexture.destroy();
        this.textureView = null;
        this.gpuTexture = null;
    }
}
class $087caa0105314e63$export$265a5eed50cc4928 {
    constructor(renderer){
        this._gpuSamplers = /* @__PURE__ */ Object.create(null);
        this._bindGroupHash = /* @__PURE__ */ Object.create(null);
        this._renderer = renderer;
        renderer.gc.addCollection(this, "_bindGroupHash", "hash");
        this._managedTextures = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            onUnload: this.onSourceUnload.bind(this),
            name: "gpuTextureSource"
        });
        const baseUploaders = {
            image: (0, $3vOQh.gpuUploadImageResource),
            buffer: (0, $fruAx.gpuUploadBufferImageResource),
            video: (0, $jQIsz.gpuUploadVideoResource),
            compressed: (0, $hrIct.gpuUploadCompressedTextureResource)
        };
        this._uploads = {
            ...baseUploaders,
            cube: (0, $hKdsJ.createGpuUploadCubeTextureResource)(baseUploaders)
        };
    }
    /**
   * @deprecated since 8.15.0
   */ get managedTextures() {
        return Object.values(this._managedTextures.items);
    }
    contextChange(gpu) {
        this._gpu = gpu;
    }
    /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */ initSource(source) {
        return source._gpuData[this._renderer.uid]?.gpuTexture || this._initSource(source);
    }
    _initSource(source) {
        if (source.autoGenerateMipmaps) {
            const biggestDimension = Math.max(source.pixelWidth, source.pixelHeight);
            source.mipLevelCount = Math.floor(Math.log2(biggestDimension)) + 1;
        }
        let usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
        if (source.uploadMethodId !== "compressed") {
            usage |= GPUTextureUsage.RENDER_ATTACHMENT;
            usage |= GPUTextureUsage.COPY_SRC;
        }
        const blockData = (0, $hrIct.blockDataMap)[source.format] || {
            blockBytes: 4,
            blockWidth: 1,
            blockHeight: 1
        };
        const width = Math.ceil(source.pixelWidth / blockData.blockWidth) * blockData.blockWidth;
        const height = Math.ceil(source.pixelHeight / blockData.blockHeight) * blockData.blockHeight;
        const textureDescriptor = {
            label: source.label,
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: source.arrayLayerCount
            },
            format: source.format,
            sampleCount: source.sampleCount,
            mipLevelCount: source.mipLevelCount,
            dimension: source.dimension,
            usage: usage
        };
        const gpuTexture = this._gpu.device.createTexture(textureDescriptor);
        source._gpuData[this._renderer.uid] = new $087caa0105314e63$export$f613aa0da77ec7b8(gpuTexture);
        const added = this._managedTextures.add(source);
        if (added) {
            source.on("update", this.onSourceUpdate, this);
            source.on("resize", this.onSourceResize, this);
            source.on("updateMipmaps", this.onUpdateMipmaps, this);
        }
        this.onSourceUpdate(source);
        return gpuTexture;
    }
    onSourceUpdate(source) {
        const gpuTexture = this.getGpuSource(source);
        if (!gpuTexture) return;
        if (this._uploads[source.uploadMethodId]) this._uploads[source.uploadMethodId].upload(source, gpuTexture, this._gpu);
        if (source.autoGenerateMipmaps && source.mipLevelCount > 1) this.onUpdateMipmaps(source);
    }
    onUpdateMipmaps(source) {
        if (!this._mipmapGenerator) this._mipmapGenerator = new (0, $2jIR8.GpuMipmapGenerator)(this._gpu.device);
        const gpuTexture = this.getGpuSource(source);
        this._mipmapGenerator.generateMipmap(gpuTexture);
    }
    onSourceUnload(source) {
        source.off("update", this.onSourceUpdate, this);
        source.off("resize", this.onSourceResize, this);
        source.off("updateMipmaps", this.onUpdateMipmaps, this);
    }
    onSourceResize(source) {
        source._gcLastUsed = this._renderer.gc.now;
        const gpuData = source._gpuData[this._renderer.uid];
        const gpuTexture = gpuData?.gpuTexture;
        if (!gpuTexture) this.initSource(source);
        else if (gpuTexture.width !== source.pixelWidth || gpuTexture.height !== source.pixelHeight) {
            gpuData.destroy();
            this._bindGroupHash[source.uid] = null;
            source._gpuData[this._renderer.uid] = null;
            this.initSource(source);
        }
    }
    _initSampler(sampler) {
        this._gpuSamplers[sampler._resourceId] = this._gpu.device.createSampler(sampler);
        return this._gpuSamplers[sampler._resourceId];
    }
    getGpuSampler(sampler) {
        return this._gpuSamplers[sampler._resourceId] || this._initSampler(sampler);
    }
    getGpuSource(source) {
        source._gcLastUsed = this._renderer.gc.now;
        return source._gpuData[this._renderer.uid]?.gpuTexture || this.initSource(source);
    }
    /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */ getTextureBindGroup(texture) {
        return this._bindGroupHash[texture.uid] || this._createTextureBindGroup(texture);
    }
    _createTextureBindGroup(texture) {
        const source = texture.source;
        this._bindGroupHash[texture.uid] = new (0, $eK2sB.BindGroup)({
            0: source,
            1: source.style,
            2: new (0, $aUxJK.UniformGroup)({
                uTextureMatrix: {
                    type: "mat3x3<f32>",
                    value: texture.textureMatrix.mapCoord
                }
            })
        });
        return this._bindGroupHash[texture.uid];
    }
    getTextureView(texture) {
        const source = texture.source;
        source._gcLastUsed = this._renderer.gc.now;
        let gpuData = source._gpuData[this._renderer.uid];
        if (!gpuData) {
            this.initSource(source);
            gpuData = source._gpuData[this._renderer.uid];
        }
        gpuData.textureView || (gpuData.textureView = gpuData.gpuTexture.createView({
            dimension: source.viewDimension
        }));
        return gpuData.textureView;
    }
    generateCanvas(texture) {
        const renderer = this._renderer;
        const commandEncoder = renderer.gpu.device.createCommandEncoder();
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        canvas.width = texture.source.pixelWidth;
        canvas.height = texture.source.pixelHeight;
        const context = canvas.getContext("webgpu");
        context.configure({
            device: renderer.gpu.device,
            usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
            format: (0, $gLw46.DOMAdapter).get().getNavigator().gpu.getPreferredCanvasFormat(),
            alphaMode: "premultiplied"
        });
        commandEncoder.copyTextureToTexture({
            texture: renderer.texture.getGpuSource(texture.source),
            origin: {
                x: 0,
                y: 0
            }
        }, {
            texture: context.getCurrentTexture()
        }, {
            width: canvas.width,
            height: canvas.height
        });
        renderer.gpu.device.queue.submit([
            commandEncoder.finish()
        ]);
        return canvas;
    }
    getPixels(texture) {
        const webGPUCanvas = this.generateCanvas(texture);
        const canvasAndContext = (0, $dDZJD.CanvasPool).getOptimalCanvasAndContext(webGPUCanvas.width, webGPUCanvas.height);
        const context = canvasAndContext.context;
        context.drawImage(webGPUCanvas, 0, 0);
        const { width: width, height: height } = webGPUCanvas;
        const imageData = context.getImageData(0, 0, width, height);
        const pixels = new Uint8ClampedArray(imageData.data.buffer);
        (0, $dDZJD.CanvasPool).returnCanvasAndContext(canvasAndContext);
        return {
            pixels: pixels,
            width: width,
            height: height
        };
    }
    destroy() {
        this._managedTextures.destroy();
        for (const k of Object.keys(this._bindGroupHash)){
            const key = Number(k);
            const bindGroup = this._bindGroupHash[key];
            bindGroup?.destroy();
        }
        this._renderer = null;
        this._gpu = null;
        this._mipmapGenerator = null;
        this._gpuSamplers = null;
        this._bindGroupHash = null;
    }
}
/** @ignore */ $087caa0105314e63$export$265a5eed50cc4928.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "texture"
};

});
parcelRegister("dDZJD", function(module, exports) {

$parcel$export(module.exports, "CanvasPoolClass", () => $e3442cb0d701b317$export$62d9f0b8aada09d7);
$parcel$export(module.exports, "CanvasPool", () => $e3442cb0d701b317$export$e56d0a06781accc9);

var $gLw46 = parcelRequire("gLw46");

var $fSIhN = parcelRequire("fSIhN");

var $fpmqC = parcelRequire("fpmqC");
"use strict";
class $e3442cb0d701b317$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $fSIhN.nextPow2)(minWidth);
        minHeight = (0, $fSIhN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $e3442cb0d701b317$export$e56d0a06781accc9 = new $e3442cb0d701b317$export$62d9f0b8aada09d7();
(0, $fpmqC.GlobalResourceRegistry).register($e3442cb0d701b317$export$e56d0a06781accc9);

});

parcelRegister("fruAx", function(module, exports) {

$parcel$export(module.exports, "gpuUploadBufferImageResource", () => $6ffa6a9095ab7135$export$741da5700bb05740);
"use strict";
const $6ffa6a9095ab7135$export$741da5700bb05740 = {
    type: "image",
    upload (source, gpuTexture, gpu, originZOverride = 0) {
        const resource = source.resource;
        const total = (source.pixelWidth | 0) * (source.pixelHeight | 0);
        const bytesPerPixel = resource.byteLength / total;
        gpu.device.queue.writeTexture({
            texture: gpuTexture,
            origin: {
                x: 0,
                y: 0,
                z: originZOverride
            }
        }, resource, {
            offset: 0,
            rowsPerImage: source.pixelHeight,
            bytesPerRow: source.pixelWidth * bytesPerPixel
        }, {
            width: source.pixelWidth,
            height: source.pixelHeight,
            depthOrArrayLayers: 1
        });
    }
};

});

parcelRegister("hrIct", function(module, exports) {

$parcel$export(module.exports, "blockDataMap", () => $c66c09ecc5d7baa2$export$143b117be43efecf);
$parcel$export(module.exports, "gpuUploadCompressedTextureResource", () => $c66c09ecc5d7baa2$export$b942a207c2b766cc);
"use strict";
const $c66c09ecc5d7baa2$export$143b117be43efecf = {
    "bc1-rgba-unorm": {
        blockBytes: 8,
        blockWidth: 4,
        blockHeight: 4
    },
    "bc2-rgba-unorm": {
        blockBytes: 16,
        blockWidth: 4,
        blockHeight: 4
    },
    "bc3-rgba-unorm": {
        blockBytes: 16,
        blockWidth: 4,
        blockHeight: 4
    },
    "bc7-rgba-unorm": {
        blockBytes: 16,
        blockWidth: 4,
        blockHeight: 4
    },
    "etc1-rgb-unorm": {
        blockBytes: 8,
        blockWidth: 4,
        blockHeight: 4
    },
    "etc2-rgba8unorm": {
        blockBytes: 16,
        blockWidth: 4,
        blockHeight: 4
    },
    "astc-4x4-unorm": {
        blockBytes: 16,
        blockWidth: 4,
        blockHeight: 4
    }
};
const $c66c09ecc5d7baa2$var$defaultBlockData = {
    blockBytes: 4,
    blockWidth: 1,
    blockHeight: 1
};
const $c66c09ecc5d7baa2$export$b942a207c2b766cc = {
    type: "compressed",
    upload (source, gpuTexture, gpu, originZOverride = 0) {
        let mipWidth = source.pixelWidth;
        let mipHeight = source.pixelHeight;
        const blockData = $c66c09ecc5d7baa2$export$143b117be43efecf[source.format] || $c66c09ecc5d7baa2$var$defaultBlockData;
        for(let i = 0; i < source.resource.length; i++){
            const levelBuffer = source.resource[i];
            const bytesPerRow = Math.ceil(mipWidth / blockData.blockWidth) * blockData.blockBytes;
            gpu.device.queue.writeTexture({
                texture: gpuTexture,
                mipLevel: i,
                origin: {
                    x: 0,
                    y: 0,
                    z: originZOverride
                }
            }, levelBuffer, {
                offset: 0,
                bytesPerRow: bytesPerRow
            }, {
                width: Math.ceil(mipWidth / blockData.blockWidth) * blockData.blockWidth,
                height: Math.ceil(mipHeight / blockData.blockHeight) * blockData.blockHeight,
                depthOrArrayLayers: 1
            });
            mipWidth = Math.max(mipWidth >> 1, 1);
            mipHeight = Math.max(mipHeight >> 1, 1);
        }
    }
};

});

parcelRegister("hKdsJ", function(module, exports) {

$parcel$export(module.exports, "createGpuUploadCubeTextureResource", () => $3c03299063241131$export$794a34a1ca363521);
"use strict";
const $3c03299063241131$var$FACE_ORDER = [
    "right",
    "left",
    "top",
    "bottom",
    "front",
    "back"
];
function $3c03299063241131$export$794a34a1ca363521(uploaders) {
    return {
        type: "cube",
        upload (source, gpuTexture, gpu) {
            const faces = source.faces;
            for(let i = 0; i < $3c03299063241131$var$FACE_ORDER.length; i++){
                const key = $3c03299063241131$var$FACE_ORDER[i];
                const face = faces[key];
                const uploader = uploaders[face.uploadMethodId] || uploaders.image;
                uploader.upload(face, gpuTexture, gpu, i);
            }
        }
    };
}

});

parcelRegister("3vOQh", function(module, exports) {

$parcel$export(module.exports, "gpuUploadImageResource", () => $df392bce0995a440$export$ef83f75eb98c2bbe);

var $gLw46 = parcelRequire("gLw46");

var $1RpxL = parcelRequire("1RpxL");
"use strict";
const $df392bce0995a440$export$ef83f75eb98c2bbe = {
    type: "image",
    upload (source, gpuTexture, gpu, originZOverride = 0) {
        const resource = source.resource;
        if (!resource) return;
        if (globalThis.HTMLImageElement && resource instanceof HTMLImageElement) {
            const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(resource.width, resource.height);
            const context = canvas.getContext("2d");
            context.drawImage(resource, 0, 0, resource.width, resource.height);
            source.resource = canvas;
            (0, $1RpxL.warn)("ImageSource: Image element passed, converting to canvas and replacing resource.");
        }
        const width = Math.min(gpuTexture.width, source.resourceWidth || source.pixelWidth);
        const height = Math.min(gpuTexture.height, source.resourceHeight || source.pixelHeight);
        const premultipliedAlpha = source.alphaMode === "premultiply-alpha-on-upload";
        gpu.device.queue.copyExternalImageToTexture({
            source: resource
        }, {
            texture: gpuTexture,
            origin: {
                x: 0,
                y: 0,
                z: originZOverride
            },
            premultipliedAlpha: premultipliedAlpha
        }, {
            width: width,
            height: height
        });
    }
};

});

parcelRegister("jQIsz", function(module, exports) {

$parcel$export(module.exports, "gpuUploadVideoResource", () => $ade794bbb0373798$export$fd4f6d89884aa2f7);

var $3vOQh = parcelRequire("3vOQh");
"use strict";
const $ade794bbb0373798$export$fd4f6d89884aa2f7 = {
    type: "video",
    upload (source, gpuTexture, gpu, originZOverride) {
        (0, $3vOQh.gpuUploadImageResource).upload(source, gpuTexture, gpu, originZOverride);
    }
};

});

parcelRegister("2jIR8", function(module, exports) {

$parcel$export(module.exports, "GpuMipmapGenerator", () => $92b799bee286a155$export$6a63de3a35cdf294);
"use strict";
class $92b799bee286a155$export$6a63de3a35cdf294 {
    constructor(device){
        this.device = device;
        this.sampler = device.createSampler({
            minFilter: "linear"
        });
        this.pipelines = {};
    }
    _getMipmapPipeline(format) {
        let pipeline = this.pipelines[format];
        if (!pipeline) {
            if (!this.mipmapShaderModule) this.mipmapShaderModule = this.device.createShaderModule({
                code: /* wgsl */ `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
            });
            pipeline = this.device.createRenderPipeline({
                layout: "auto",
                vertex: {
                    module: this.mipmapShaderModule,
                    entryPoint: "vertexMain"
                },
                fragment: {
                    module: this.mipmapShaderModule,
                    entryPoint: "fragmentMain",
                    targets: [
                        {
                            format: format
                        }
                    ]
                }
            });
            this.pipelines[format] = pipeline;
        }
        return pipeline;
    }
    /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */ generateMipmap(texture) {
        const pipeline = this._getMipmapPipeline(texture.format);
        if (texture.dimension === "3d" || texture.dimension === "1d") throw new Error("Generating mipmaps for non-2d textures is currently unsupported!");
        let mipTexture = texture;
        const arrayLayerCount = texture.depthOrArrayLayers || 1;
        const renderToSource = texture.usage & GPUTextureUsage.RENDER_ATTACHMENT;
        if (!renderToSource) {
            const mipTextureDescriptor = {
                size: {
                    width: Math.ceil(texture.width / 2),
                    height: Math.ceil(texture.height / 2),
                    depthOrArrayLayers: arrayLayerCount
                },
                format: texture.format,
                usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
                mipLevelCount: texture.mipLevelCount - 1
            };
            mipTexture = this.device.createTexture(mipTextureDescriptor);
        }
        const commandEncoder = this.device.createCommandEncoder({});
        const bindGroupLayout = pipeline.getBindGroupLayout(0);
        for(let arrayLayer = 0; arrayLayer < arrayLayerCount; ++arrayLayer){
            let srcView = texture.createView({
                baseMipLevel: 0,
                mipLevelCount: 1,
                dimension: "2d",
                baseArrayLayer: arrayLayer,
                arrayLayerCount: 1
            });
            let dstMipLevel = renderToSource ? 1 : 0;
            for(let i = 1; i < texture.mipLevelCount; ++i){
                const dstView = mipTexture.createView({
                    baseMipLevel: dstMipLevel++,
                    mipLevelCount: 1,
                    dimension: "2d",
                    baseArrayLayer: arrayLayer,
                    arrayLayerCount: 1
                });
                const passEncoder = commandEncoder.beginRenderPass({
                    colorAttachments: [
                        {
                            view: dstView,
                            storeOp: "store",
                            loadOp: "clear",
                            clearValue: {
                                r: 0,
                                g: 0,
                                b: 0,
                                a: 0
                            }
                        }
                    ]
                });
                const bindGroup = this.device.createBindGroup({
                    layout: bindGroupLayout,
                    entries: [
                        {
                            binding: 0,
                            resource: this.sampler
                        },
                        {
                            binding: 1,
                            resource: srcView
                        }
                    ]
                });
                passEncoder.setPipeline(pipeline);
                passEncoder.setBindGroup(0, bindGroup);
                passEncoder.draw(3, 1, 0, 0);
                passEncoder.end();
                srcView = dstView;
            }
        }
        if (!renderToSource) {
            const mipLevelSize = {
                width: Math.ceil(texture.width / 2),
                height: Math.ceil(texture.height / 2),
                depthOrArrayLayers: arrayLayerCount
            };
            for(let i = 1; i < texture.mipLevelCount; ++i){
                commandEncoder.copyTextureToTexture({
                    texture: mipTexture,
                    mipLevel: i - 1
                }, {
                    texture: texture,
                    mipLevel: i
                }, mipLevelSize);
                mipLevelSize.width = Math.ceil(mipLevelSize.width / 2);
                mipLevelSize.height = Math.ceil(mipLevelSize.height / 2);
            }
        }
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        if (!renderToSource) mipTexture.destroy();
        return texture;
    }
}

});



parcelRegister("2LjMw", function(module, exports) {

$parcel$export(module.exports, "BitmapFont", () => $1df2b45d48c61e67$export$17957a09927cadc7);

var $lHrjL = parcelRequire("lHrjL");

var $ar2Ly = parcelRequire("ar2Ly");

var $4iNSL = parcelRequire("4iNSL");

var $l918V = parcelRequire("l918V");

var $bJb7n = parcelRequire("bJb7n");
"use strict";
class $1df2b45d48c61e67$export$17957a09927cadc7 extends (0, $l918V.AbstractBitmapFont) {
    constructor(options, url){
        super();
        const { textures: textures, data: data } = options;
        Object.keys(data.pages).forEach((key)=>{
            const pageData = data.pages[parseInt(key, 10)];
            const texture = textures[pageData.id];
            this.pages.push({
                texture: texture
            });
        });
        Object.keys(data.chars).forEach((key)=>{
            const charData = data.chars[key];
            const { frame: textureFrame, source: textureSource, rotate: textureRotate } = textures[charData.page];
            const frame = (0, $lHrjL.groupD8).transformRectCoords(charData, textureFrame, textureRotate, new (0, $ar2Ly.Rectangle)());
            const texture = new (0, $4iNSL.Texture)({
                frame: frame,
                orig: new (0, $ar2Ly.Rectangle)(0, 0, charData.width, charData.height),
                source: textureSource,
                rotate: textureRotate
            });
            this.chars[key] = {
                id: key.codePointAt(0),
                xOffset: charData.xOffset,
                yOffset: charData.yOffset,
                xAdvance: charData.xAdvance,
                kerning: charData.kerning ?? {},
                texture: texture
            };
        });
        this.baseRenderedFontSize = data.fontSize;
        this.baseMeasurementFontSize = data.fontSize;
        this.fontMetrics = {
            ascent: 0,
            descent: 0,
            fontSize: data.fontSize
        };
        this.baseLineOffset = data.baseLineOffset;
        this.lineHeight = data.lineHeight;
        this.fontFamily = data.fontFamily;
        this.distanceField = data.distanceField ?? {
            type: "none",
            range: 0
        };
        this.url = url;
    }
    /** Destroys the BitmapFont object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { texture: texture } = this.pages[i];
            texture.destroy(true);
        }
        this.pages = null;
    }
    /**
   * Generates and installs a bitmap font with the specified options.
   * The font will be cached and available for use in BitmapText objects.
   * @param options - Setup options for font generation
   * @returns Installed font instance
   * @example
   * ```ts
   * // Install a basic font
   * BitmapFont.install({
   *     name: 'Title',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 32,
   *         fill: '#ffffff'
   *     }
   * });
   *
   * // Install with advanced options
   * BitmapFont.install({
   *     name: 'Custom',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 24,
   *         fill: '#00ff00',
   *         stroke: { color: '#000000', width: 2 }
   *     },
   *     chars: [['a', 'z'], ['A', 'Z'], ['0', '9']],
   *     resolution: 2,
   *     padding: 4,
   *     textureStyle: {
   *         scaleMode: 'nearest'
   *     }
   * });
   * ```
   */ static install(options) {
        (0, $bJb7n.BitmapFontManager).install(options);
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * This frees up memory and resources associated with the font.
   * @param name - The name of the bitmap font to uninstall
   * @example
   * ```ts
   * // Remove a font when it's no longer needed
   * BitmapFont.uninstall('MyCustomFont');
   *
   * // Clear multiple fonts
   * ['Title', 'Heading', 'Body'].forEach(BitmapFont.uninstall);
   * ```
   */ static uninstall(name) {
        (0, $bJb7n.BitmapFontManager).uninstall(name);
    }
}

});
parcelRegister("l918V", function(module, exports) {

$parcel$export(module.exports, "AbstractBitmapFont", () => $3b583dc2bd390cf4$export$70779aee6e4c1309);

var $6AQ4q = parcelRequire("6AQ4q");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
class $3b583dc2bd390cf4$export$70779aee6e4c1309 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(){
        super(...arguments);
        /** The map of characters by character code. */ this.chars = /* @__PURE__ */ Object.create(null);
        /**
     * The line-height of the font face in pixels.
     * @type {number}
     */ this.lineHeight = 0;
        /**
     * The name of the font face
     * @type {string}
     */ this.fontFamily = "";
        /** The metrics of the font face. */ this.fontMetrics = {
            fontSize: 0,
            ascent: 0,
            descent: 0
        };
        /**
     * The offset of the font face from the baseline.
     * @type {number}
     */ this.baseLineOffset = 0;
        /** The range and type of the distance field for this font. */ this.distanceField = {
            type: "none",
            range: 0
        };
        /** The map of base page textures (i.e., sheets of glyphs). */ this.pages = [];
        /** should the fill for this font be applied as a tint to the text. */ this.applyFillAsTint = true;
        /** The size of the font face in pixels. */ this.baseMeasurementFontSize = 100;
        this.baseRenderedFontSize = 100;
    }
    /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */ get font() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead.");
        return this.fontFamily;
    }
    /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */ get pageTextures() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */ get size() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead.");
        return this.fontMetrics.fontSize;
    }
    /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */ get distanceFieldRange() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead.");
        return this.distanceField.range;
    }
    /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */ get distanceFieldType() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead.");
        return this.distanceField.type;
    }
    destroy(destroyTextures = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        for(const i in this.chars)this.chars[i].texture?.destroy();
        this.chars = null;
        if (destroyTextures) {
            this.pages.forEach((page)=>page.texture.destroy(true));
            this.pages = null;
        }
    }
}

});

parcelRegister("bJb7n", function(module, exports) {

$parcel$export(module.exports, "BitmapFontManager", () => $2f847c366756ffab$export$d2ee57cdc0e1ed7f);

var $6LVZ7 = parcelRequire("6LVZ7");

var $h3cT0 = parcelRequire("h3cT0");

var $6LhOA = parcelRequire("6LhOA");

var $1RpxL = parcelRequire("1RpxL");

var $1i9ku = parcelRequire("1i9ku");

var $bFX43 = parcelRequire("bFX43");

var $a1eHr = parcelRequire("a1eHr");

var $dhjTN = parcelRequire("dhjTN");

var $3beWQ = parcelRequire("3beWQ");
"use strict";
let $2f847c366756ffab$var$fontCount = 0;
class $2f847c366756ffab$var$BitmapFontManagerClass {
    constructor(){
        /**
     * This character set includes all the letters in the alphabet (both lower- and upper- case).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.ALPHA })
     */ this.ALPHA = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            " "
        ];
        /**
     * This character set includes all decimal digits (from 0 to 9).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
     */ this.NUMERIC = [
            [
                "0",
                "9"
            ]
        ];
        /**
     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
     * @type {string[][]}
     */ this.ALPHANUMERIC = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            [
                "0",
                "9"
            ],
            " "
        ];
        /**
     * This character set consists of all the ASCII table.
     * @type {string[][]}
     * @see http://www.asciitable.com/
     */ this.ASCII = [
            [
                " ",
                "~"
            ]
        ];
        /** Default options for installing a new BitmapFont. */ this.defaultOptions = {
            chars: this.ALPHANUMERIC,
            resolution: 1,
            padding: 4,
            skipKerning: false,
            textureStyle: null
        };
        /** Cache for measured text layouts to avoid recalculating them multiple times. */ this.measureCache = (0, $6LVZ7.lru)(1e3);
    }
    /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */ getFont(text, style) {
        let fontFamilyKey = `${style.fontFamily}-bitmap`;
        let overrideFill = true;
        if (style._fill.fill && !style._stroke) {
            fontFamilyKey += style._fill.fill.styleKey;
            overrideFill = false;
        } else if (style._stroke || style.dropShadow) {
            fontFamilyKey = `${style.styleKey}-bitmap`;
            overrideFill = false;
        }
        if (!(0, $h3cT0.Cache).has(fontFamilyKey)) {
            const styleCopy = Object.create(style);
            styleCopy._lineHeight = 0;
            const fnt = new (0, $a1eHr.DynamicBitmapFont)({
                style: styleCopy,
                overrideFill: overrideFill,
                overrideSize: true,
                ...this.defaultOptions
            });
            $2f847c366756ffab$var$fontCount++;
            if ($2f847c366756ffab$var$fontCount > 50) (0, $1RpxL.warn)("BitmapText", `You have dynamically created ${$2f847c366756ffab$var$fontCount} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``);
            fnt.once("destroy", ()=>{
                $2f847c366756ffab$var$fontCount--;
                (0, $h3cT0.Cache).remove(fontFamilyKey);
            });
            (0, $h3cT0.Cache).set(fontFamilyKey, fnt);
        }
        const dynamicFont = (0, $h3cT0.Cache).get(fontFamilyKey);
        dynamicFont.ensureCharacters?.(text);
        return dynamicFont;
    }
    /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ getLayout(text, style, trimEnd = true) {
        const bitmapFont = this.getFont(text, style);
        const id = `${text}-${style.styleKey}-${trimEnd}`;
        if (this.measureCache.has(id)) return this.measureCache.get(id);
        const segments = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(text);
        const layoutData = (0, $dhjTN.getBitmapTextLayout)(segments, style, bitmapFont, trimEnd);
        this.measureCache.set(id, layoutData);
        return layoutData;
    }
    /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ measureText(text, style, trimEnd = true) {
        return this.getLayout(text, style, trimEnd);
    }
    // eslint-disable-next-line max-len
    install(...args) {
        let options = args[0];
        if (typeof options === "string") {
            options = {
                name: options,
                style: args[1],
                chars: args[2]?.chars,
                resolution: args[2]?.resolution,
                padding: args[2]?.padding,
                skipKerning: args[2]?.skipKerning
            };
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})");
        }
        const name = options?.name;
        if (!name) throw new Error("[BitmapFontManager] Property `name` is required.");
        options = {
            ...this.defaultOptions,
            ...options
        };
        const textStyle = options.style;
        const style = textStyle instanceof (0, $bFX43.TextStyle) ? textStyle : new (0, $bFX43.TextStyle)(textStyle);
        const overrideFill = options.dynamicFill ?? this._canUseTintForStyle(style);
        const font = new (0, $a1eHr.DynamicBitmapFont)({
            style: style,
            overrideFill: overrideFill,
            skipKerning: options.skipKerning,
            padding: options.padding,
            resolution: options.resolution,
            overrideSize: false,
            textureStyle: options.textureStyle
        });
        const flatChars = (0, $3beWQ.resolveCharacters)(options.chars);
        font.ensureCharacters(flatChars.join(""));
        (0, $h3cT0.Cache).set(`${name}-bitmap`, font);
        font.once("destroy", ()=>(0, $h3cT0.Cache).remove(`${name}-bitmap`));
        return font;
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */ uninstall(name) {
        const cacheKey = `${name}-bitmap`;
        const font = (0, $h3cT0.Cache).get(cacheKey);
        if (font) font.destroy();
    }
    /**
   * Determines if a style can use tinting instead of baking colors into the bitmap.
   * Tinting is more efficient as it allows reusing the same bitmap with different colors.
   * @param style - The text style to evaluate
   * @returns true if the style can use tinting, false if colors must be baked in
   * @private
   */ _canUseTintForStyle(style) {
        return !style._stroke && (!style.dropShadow || style.dropShadow.color === 0) && !style._fill.fill && style._fill.color === 16777215;
    }
}
const $2f847c366756ffab$export$d2ee57cdc0e1ed7f = new $2f847c366756ffab$var$BitmapFontManagerClass();

});
parcelRegister("6LVZ7", function(module, exports) {

$parcel$export(module.exports, "lru", () => $efe7ca9bd0d801a6$export$64e09406e6c5de88, (v) => $efe7ca9bd0d801a6$export$64e09406e6c5de88 = v);
/**
 * tiny-lru
 *
 * @copyright 2026 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 11.4.7
 */ var $efe7ca9bd0d801a6$export$ca3ab3d175dec122;
var $efe7ca9bd0d801a6$export$64e09406e6c5de88;
'use strict';
/**
 * A high-performance Least Recently Used (LRU) cache implementation with optional TTL support.
 * Items are automatically evicted when the cache reaches its maximum size,
 * removing the least recently used items first. All core operations (get, set, delete) are O(1).
 *
 * @class LRU
 * @example
 * // Create a cache with max 100 items
 * const cache = new LRU(100);
 * cache.set('key1', 'value1');
 * console.log(cache.get('key1')); // 'value1'
 *
 * @example
 * // Create a cache with TTL
 * const cache = new LRU(100, 5000); // 5 second TTL
 * cache.set('key1', 'value1');
 * // After 5 seconds, key1 will be expired
 */ class $efe7ca9bd0d801a6$var$LRU {
    /**
	 * Creates a new LRU cache instance.
	 * Note: Constructor does not validate parameters. Use lru() factory function for parameter validation.
	 *
	 * @constructor
	 * @param {number} [max=0] - Maximum number of items to store. 0 means unlimited.
	 * @param {number} [ttl=0] - Time to live in milliseconds. 0 means no expiration.
	 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
	 * @example
	 * const cache = new LRU(1000, 60000, true); // 1000 items, 1 minute TTL, reset on access
	 * @see {@link lru} For parameter validation
	 * @since 1.0.0
	 */ constructor(max = 0, ttl = 0, resetTtl = false){
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.max = max;
        this.resetTtl = resetTtl;
        this.size = 0;
        this.ttl = ttl;
    }
    /**
	 * Removes all items from the cache.
	 *
	 * @method clear
	 * @memberof LRU
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.clear();
	 * console.log(cache.size); // 0
	 * @since 1.0.0
	 */ clear() {
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.size = 0;
        return this;
    }
    /**
	 * Removes an item from the cache by key.
	 *
	 * @method delete
	 * @memberof LRU
	 * @param {string} key - The key of the item to delete.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1');
	 * cache.delete('key1');
	 * console.log(cache.has('key1')); // false
	 * @see {@link LRU#has}
	 * @see {@link LRU#clear}
	 * @since 1.0.0
	 */ delete(key) {
        if (this.has(key)) {
            const item = this.items[key];
            delete this.items[key];
            this.size--;
            if (item.prev !== null) item.prev.next = item.next;
            if (item.next !== null) item.next.prev = item.prev;
            if (this.first === item) this.first = item.next;
            if (this.last === item) this.last = item.prev;
        }
        return this;
    }
    /**
	 * Returns an array of [key, value] pairs for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method entries
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get entries for. Defaults to all keys.
	 * @returns {Array<Array<*>>} Array of [key, value] pairs in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.entries()); // [['a', 1], ['b', 2]]
	 * console.log(cache.entries(['a'])); // [['a', 1]]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#values}
	 * @since 11.1.0
	 */ entries(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            result[i] = [
                key,
                this.get(key)
            ];
        }
        return result;
    }
    /**
	 * Removes the least recently used item from the cache.
	 *
	 * @method evict
	 * @memberof LRU
	 * @param {boolean} [bypass=false] - Whether to force eviction even when cache is empty.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('old', 'value').set('new', 'value');
	 * cache.evict(); // Removes 'old' item
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ evict(bypass = false) {
        if (bypass || this.size > 0) {
            const item = this.first;
            delete this.items[item.key];
            if (--this.size === 0) {
                this.first = null;
                this.last = null;
            } else {
                this.first = item.next;
                this.first.prev = null;
            }
        }
        return this;
    }
    /**
	 * Returns the expiration timestamp for a given key.
	 *
	 * @method expiresAt
	 * @memberof LRU
	 * @param {string} key - The key to check expiration for.
	 * @returns {number|undefined} The expiration timestamp in milliseconds, or undefined if key doesn't exist.
	 * @example
	 * const cache = new LRU(100, 5000); // 5 second TTL
	 * cache.set('key1', 'value1');
	 * console.log(cache.expiresAt('key1')); // timestamp 5 seconds from now
	 * @see {@link LRU#get}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ expiresAt(key) {
        let result;
        if (this.has(key)) result = this.items[key].expiry;
        return result;
    }
    /**
	 * Retrieves a value from the cache by key. Updates the item's position to most recently used.
	 *
	 * @method get
	 * @memberof LRU
	 * @param {string} key - The key to retrieve.
	 * @returns {*} The value associated with the key, or undefined if not found or expired.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.get('key1')); // 'value1'
	 * console.log(cache.get('nonexistent')); // undefined
	 * @see {@link LRU#set}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ get(key) {
        const item = this.items[key];
        if (item !== undefined) {
            // Check TTL only if enabled to avoid unnecessary Date.now() calls
            if (this.ttl > 0) {
                if (item.expiry <= Date.now()) {
                    this.delete(key);
                    return undefined;
                }
            }
            // Fast LRU update without full set() overhead
            this.moveToEnd(item);
            return item.value;
        }
        return undefined;
    }
    /**
	 * Checks if a key exists in the cache.
	 *
	 * @method has
	 * @memberof LRU
	 * @param {string} key - The key to check for.
	 * @returns {boolean} True if the key exists, false otherwise.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.has('key1')); // true
	 * console.log(cache.has('nonexistent')); // false
	 * @see {@link LRU#get}
	 * @see {@link LRU#delete}
	 * @since 9.0.0
	 */ has(key) {
        return key in this.items;
    }
    /**
	 * Efficiently moves an item to the end of the LRU list (most recently used position).
	 * This is an internal optimization method that avoids the overhead of the full set() operation
	 * when only LRU position needs to be updated.
	 *
	 * @method moveToEnd
	 * @memberof LRU
	 * @param {Object} item - The cache item with prev/next pointers to reposition.
	 * @private
	 * @since 11.3.5
	 */ moveToEnd(item) {
        // If already at the end, nothing to do
        if (this.last === item) return;
        // Remove item from current position in the list
        if (item.prev !== null) item.prev.next = item.next;
        if (item.next !== null) item.next.prev = item.prev;
        // Update first pointer if this was the first item
        if (this.first === item) this.first = item.next;
        // Add item to the end
        item.prev = this.last;
        item.next = null;
        if (this.last !== null) this.last.next = item;
        this.last = item;
        // Handle edge case: if this was the only item, it's also first
        if (this.first === null) this.first = item;
    }
    /**
	 * Returns an array of all keys in the cache, ordered from least to most recently used.
	 *
	 * @method keys
	 * @memberof LRU
	 * @returns {string[]} Array of keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * cache.get('a'); // Move 'a' to most recent
	 * console.log(cache.keys()); // ['b', 'a']
	 * @see {@link LRU#values}
	 * @see {@link LRU#entries}
	 * @since 9.0.0
	 */ keys() {
        const result = new Array(this.size);
        let x = this.first;
        let i = 0;
        while(x !== null){
            result[i++] = x.key;
            x = x.next;
        }
        return result;
    }
    /**
	 * Sets a value in the cache and returns any evicted item.
	 *
	 * @method setWithEvicted
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {Object|null} The evicted item (if any) with shape {key, value, expiry, prev, next}, or null.
	 * @example
	 * const cache = new LRU(2);
	 * cache.set('a', 1).set('b', 2);
	 * const evicted = cache.setWithEvicted('c', 3); // evicted = {key: 'a', value: 1, ...}
	 * @see {@link LRU#set}
	 * @see {@link LRU#evict}
	 * @since 11.3.0
	 */ setWithEvicted(key, value, resetTtl = this.resetTtl) {
        let evicted = null;
        if (this.has(key)) this.set(key, value, true, resetTtl);
        else {
            if (this.max > 0 && this.size === this.max) {
                evicted = {
                    ...this.first
                };
                this.evict(true);
            }
            let item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return evicted;
    }
    /**
	 * Sets a value in the cache. Updates the item's position to most recently used.
	 *
	 * @method set
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [bypass=false] - Internal parameter for setWithEvicted method.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1')
	 *      .set('key2', 'value2')
	 *      .set('key3', 'value3');
	 * @see {@link LRU#get}
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ set(key, value, bypass = false, resetTtl = this.resetTtl) {
        let item = this.items[key];
        if (bypass || item !== undefined) {
            // Existing item: update value and position
            item.value = value;
            if (bypass === false && resetTtl) item.expiry = this.ttl > 0 ? Date.now() + this.ttl : this.ttl;
            // Always move to end, but the bypass parameter affects TTL reset behavior
            this.moveToEnd(item);
        } else {
            // New item: check for eviction and create
            if (this.max > 0 && this.size === this.max) this.evict(true);
            item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return this;
    }
    /**
	 * Returns an array of all values in the cache for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method values
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get values for. Defaults to all keys.
	 * @returns {Array<*>} Array of values corresponding to the keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.values()); // [1, 2]
	 * console.log(cache.values(['a'])); // [1]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#entries}
	 * @since 11.1.0
	 */ values(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++)result[i] = this.get(keys[i]);
        return result;
    }
}
/**
 * Factory function to create a new LRU cache instance with parameter validation.
 *
 * @function lru
 * @param {number} [max=1000] - Maximum number of items to store. Must be >= 0. Use 0 for unlimited size.
 * @param {number} [ttl=0] - Time to live in milliseconds. Must be >= 0. Use 0 for no expiration.
 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
 * @returns {LRU} A new LRU cache instance.
 * @throws {TypeError} When parameters are invalid (negative numbers or wrong types).
 * @example
 * // Create cache with factory function
 * const cache = lru(100, 5000, true);
 * cache.set('key', 'value');
 *
 * @example
 * // Error handling
 * try {
 *   const cache = lru(-1); // Invalid max
 * } catch (error) {
 *   console.error(error.message); // "Invalid max value"
 * }
 * @see {@link LRU}
 * @since 1.0.0
 */ function $efe7ca9bd0d801a6$var$lru(max = 1000, ttl = 0, resetTtl = false) {
    if (isNaN(max) || max < 0) throw new TypeError("Invalid max value");
    if (isNaN(ttl) || ttl < 0) throw new TypeError("Invalid ttl value");
    if (typeof resetTtl !== "boolean") throw new TypeError("Invalid resetTtl value");
    return new $efe7ca9bd0d801a6$var$LRU(max, ttl, resetTtl);
}
$efe7ca9bd0d801a6$export$ca3ab3d175dec122 = $efe7ca9bd0d801a6$var$LRU;
$efe7ca9bd0d801a6$export$64e09406e6c5de88 = $efe7ca9bd0d801a6$var$lru;

});

parcelRegister("1i9ku", function(module, exports) {

$parcel$export(module.exports, "CanvasTextMetrics", () => $8cc637509016c981$export$b12f6bdc825d944f);

var $6LVZ7 = parcelRequire("6LVZ7");

var $gLw46 = parcelRequire("gLw46");

var $io8hC = parcelRequire("io8hC");

var $8jcQu = parcelRequire("8jcQu");

var $gAfNu = parcelRequire("gAfNu");

var $4R0nM = parcelRequire("4R0nM");
"use strict";
const $8cc637509016c981$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $8cc637509016c981$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see CanvasTextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result === void 0) {
            const proto = (0, $gLw46.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param fontProperties - the font properties object from TextMetrics.measureFont
   * @param taggedData - optional object containing tagged text specific data
   * @param taggedData.runsByLine - per-line style runs for tagged text
   * @param taggedData.lineAscents - per-line ascent values for tagged text
   * @param taggedData.lineDescents - per-line descent values for tagged text
   * @param taggedData.lineHeights - per-line height values for tagged text
   * @param taggedData.hasDropShadow - whether any run has a drop shadow
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties, taggedData){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
        if (taggedData) {
            this.runsByLine = taggedData.runsByLine;
            this.lineAscents = taggedData.lineAscents;
            this.lineDescents = taggedData.lineDescents;
            this.lineHeights = taggedData.lineHeights;
            this.hasDropShadow = taggedData.hasDropShadow;
        }
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap2 = style.wordWrap) {
        const textKey = `${text}-${style.styleKey}-wordWrap-${wordWrap2}`;
        if (_CanvasTextMetrics._measurementCache.has(textKey)) return _CanvasTextMetrics._measurementCache.get(textKey);
        const isTagged = (0, $8jcQu.hasTagStyles)(style) && (0, $8jcQu.hasTagMarkup)(text);
        if (isTagged) {
            const result = (0, $io8hC.measureTaggedText)(text, style, wordWrap2, _CanvasTextMetrics._context, _CanvasTextMetrics._measureText, _CanvasTextMetrics.measureFont, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
            const measurements2 = new _CanvasTextMetrics(text, style, result.width, result.height, result.lines, result.lineWidths, result.lineHeight, result.maxLineWidth, result.fontProperties, {
                runsByLine: result.runsByLine,
                lineAscents: result.lineAscents,
                lineDescents: result.lineDescents,
                lineHeights: result.lineHeights,
                hasDropShadow: result.hasDropShadow
            });
            _CanvasTextMetrics._measurementCache.set(textKey, measurements2);
            return measurements2;
        }
        const font = style._fontString;
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
            fontProperties.descent = 0;
        }
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const outputText = wordWrap2 ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split((0, $gAfNu.NEWLINE_MATCH_REGEX));
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width ?? 0;
        const lineHeight = style.lineHeight || fontProperties.fontSize;
        const baseWidth = _CanvasTextMetrics._getAlignWidth(maxLineWidth, style, wordWrap2);
        const width = _CanvasTextMetrics._adjustWidthForStyle(baseWidth, style);
        const baseHeight = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
        const height = _CanvasTextMetrics._adjustHeightForStyle(baseHeight, style);
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        _CanvasTextMetrics._measurementCache.set(textKey, measurements);
        return measurements;
    }
    /**
   * Adjusts the measured width to account for stroke and drop shadow.
   * @param baseWidth - The base content width
   * @param style - The text style
   * @returns The adjusted width
   */ static _adjustWidthForStyle(baseWidth, style) {
        const strokeWidth = style._stroke?.width || 0;
        let width = baseWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        return width;
    }
    /**
   * Adjusts the measured height to account for drop shadow.
   * @param baseHeight - The base content height
   * @param style - The text style
   * @returns The adjusted height
   */ static _adjustHeightForStyle(baseHeight, style) {
        let height = baseHeight;
        if (style.dropShadow) height += style.dropShadow.distance;
        return height;
    }
    /**
   * Calculates the base width for alignment purposes.
   * When word wrap is enabled with center/right alignment, uses wordWrapWidth.
   * @param maxLineWidth - The maximum line width
   * @param style - The text style
   * @param wordWrapEnabled - Whether word wrap is enabled
   * @returns The width to use for alignment calculations
   */ static _getAlignWidth(maxLineWidth, style, wordWrapEnabled) {
        const useWrapWidth = wordWrapEnabled && style.align !== "left" && style.align !== "justify";
        return useWrapWidth ? Math.max(maxLineWidth, style.wordWrapWidth) : maxLineWidth;
    }
    /**
   * Measures the rendered width of a string, accounting for letter spacing and using the provided context.
   * @param text - The text to measure
   * @param letterSpacing - Letter spacing in pixels
   * @param context - Canvas 2D context
   * @returns The measured width of the text with spacing
   * @internal
   */ static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        const metrics = context.measureText(text);
        let metricWidth = metrics.width;
        const actualBoundingBoxLeft = -(metrics.actualBoundingBoxLeft ?? 0);
        const actualBoundingBoxRight = metrics.actualBoundingBoxRight ?? 0;
        let boundsWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
        if (metricWidth > 0) {
            if (useExperimentalLetterSpacing) {
                metricWidth -= letterSpacing;
                boundsWidth -= letterSpacing;
            } else {
                const val = (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
                metricWidth += val;
                boundsWidth += val;
            }
        }
        return Math.max(metricWidth, boundsWidth);
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        return (0, $4R0nM.wordWrap)(text, style, canvas, _CanvasTextMetrics._measureText, _CanvasTextMetrics.canBreakWords, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return (0, $gAfNu.isBreakingSpace)(char, _nextChar);
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const ascent = metrics.actualBoundingBoxAscent ?? 0;
        const descent = metrics.actualBoundingBoxDescent ?? 0;
        const properties = {
            ascent: ascent,
            descent: descent,
            fontSize: ascent + descent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $8cc637509016c981$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
            } catch (_cx) {
                canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $8cc637509016c981$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $8cc637509016c981$var$_CanvasTextMetrics.METRICS_STRING = "|\xC9q\xC5";
/** Baseline symbol for calculate font metrics. */ $8cc637509016c981$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $8cc637509016c981$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $8cc637509016c981$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $8cc637509016c981$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>{
            const segments = segmenter.segment(s);
            const result = [];
            let i = 0;
            for (const segment of segments)result[i++] = segment.segment;
            return result;
        };
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see CanvasTextMetrics.experimentalLetterSpacingSupported
 */ $8cc637509016c981$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@link TextMetrics.FontMetrics} objects. */ $8cc637509016c981$var$_CanvasTextMetrics._fonts = {};
/** Cache for measured text metrics */ $8cc637509016c981$var$_CanvasTextMetrics._measurementCache = (0, $6LVZ7.lru)(1e3);
let $8cc637509016c981$export$b12f6bdc825d944f = $8cc637509016c981$var$_CanvasTextMetrics;

});
parcelRegister("io8hC", function(module, exports) {

$parcel$export(module.exports, "measureTaggedText", () => $ec3326c7156957ee$export$2c4cb70a2097cfee);
$parcel$export(module.exports, "wordWrapTaggedLines", () => $ec3326c7156957ee$export$e01e4e8f2c8b304b);
$parcel$export(module.exports, "tokenizeTaggedRuns", () => $ec3326c7156957ee$export$7d01d70c6417df50);

var $8jcQu = parcelRequire("8jcQu");

var $gAfNu = parcelRequire("gAfNu");
"use strict";
const $ec3326c7156957ee$var$NEWLINE_TO_SPACE_REGEX = /\r\n|\r|\n/g;
function $ec3326c7156957ee$export$2c4cb70a2097cfee(text, style, wordWrap, context, measureTextFn, measureFontFn, canBreakCharsFn, wordWrapSplitFn) {
    const runs = (0, $8jcQu.parseTaggedText)(text, style);
    const shouldCollapseNewlines = (0, $gAfNu.collapseNewlines)(style.whiteSpace);
    if (shouldCollapseNewlines) for(let i = 0; i < runs.length; i++){
        const run = runs[i];
        runs[i] = {
            text: run.text.replace($ec3326c7156957ee$var$NEWLINE_TO_SPACE_REGEX, " "),
            style: run.style
        };
    }
    const runsByLine = [];
    let currentLineRuns = [];
    for (const run of runs){
        const parts = run.text.split((0, $gAfNu.NEWLINE_SPLIT_REGEX));
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            if (part === "\r\n" || part === "\r" || part === "\n") {
                runsByLine.push(currentLineRuns);
                currentLineRuns = [];
            } else if (part.length > 0) currentLineRuns.push({
                text: part,
                style: run.style
            });
        }
    }
    if (currentLineRuns.length > 0 || runsByLine.length === 0) runsByLine.push(currentLineRuns);
    const wrappedRunsByLine = wordWrap ? $ec3326c7156957ee$export$e01e4e8f2c8b304b(runsByLine, style, context, measureTextFn, canBreakCharsFn, wordWrapSplitFn) : runsByLine;
    const lineWidths = [];
    const lineAscents = [];
    const lineDescents = [];
    const lineHeightsArr = [];
    const lines = [];
    let maxLineWidth = 0;
    const baseFont = style._fontString;
    const baseFontProps = measureFontFn(baseFont);
    if (baseFontProps.fontSize === 0) {
        baseFontProps.fontSize = style.fontSize;
        baseFontProps.ascent = style.fontSize;
    }
    let lastFont = "";
    let hasDropShadow = !!style.dropShadow;
    for (const lineRuns of wrappedRunsByLine){
        let lineWidth = 0;
        let lineAscent = baseFontProps.ascent;
        let lineDescent = baseFontProps.descent;
        let lineText = "";
        for (const run of lineRuns){
            const runFont = run.style._fontString;
            const runFontProps = measureFontFn(runFont);
            if (runFont !== lastFont) {
                context.font = runFont;
                lastFont = runFont;
            }
            const runWidth = measureTextFn(run.text, run.style.letterSpacing, context);
            lineWidth += runWidth;
            lineAscent = Math.max(lineAscent, runFontProps.ascent);
            lineDescent = Math.max(lineDescent, runFontProps.descent);
            lineText += run.text;
            if (!hasDropShadow && run.style.dropShadow) hasDropShadow = true;
        }
        if (lineRuns.length === 0) {
            lineAscent = baseFontProps.ascent;
            lineDescent = baseFontProps.descent;
        }
        lineWidths.push(lineWidth);
        lineAscents.push(lineAscent);
        lineDescents.push(lineDescent);
        lines.push(lineText);
        const computedLineHeight = style.lineHeight || lineAscent + lineDescent;
        lineHeightsArr.push(computedLineHeight + style.leading);
        maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }
    const strokeWidth = style._stroke?.width || 0;
    const useWrapWidth = wordWrap && style.align !== "left" && style.align !== "justify";
    const alignWidth = useWrapWidth ? Math.max(maxLineWidth, style.wordWrapWidth) : maxLineWidth;
    const width = alignWidth + strokeWidth + (style.dropShadow ? style.dropShadow.distance : 0);
    let baseHeight = 0;
    for(let i = 0; i < lineHeightsArr.length; i++)baseHeight += lineHeightsArr[i];
    baseHeight = Math.max(baseHeight, lineHeightsArr[0] + strokeWidth);
    const height = baseHeight + (style.dropShadow ? style.dropShadow.distance : 0);
    const baseLineHeight = style.lineHeight || baseFontProps.fontSize;
    return {
        width: width,
        height: height,
        lines: lines,
        lineWidths: lineWidths,
        lineHeight: baseLineHeight + style.leading,
        maxLineWidth: maxLineWidth,
        fontProperties: baseFontProps,
        runsByLine: wrappedRunsByLine,
        lineAscents: lineAscents,
        lineDescents: lineDescents,
        lineHeights: lineHeightsArr,
        hasDropShadow: hasDropShadow
    };
}
function $ec3326c7156957ee$export$e01e4e8f2c8b304b(runsByLine, style, context, measureTextFn, canBreakCharsFn, wordWrapSplitFn) {
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace, wordWrapWidth: wordWrapWidth, breakWords: breakWords } = style;
    const shouldCollapseSpaces = (0, $gAfNu.collapseSpaces)(whiteSpace);
    const adjustedWrapWidth = wordWrapWidth + letterSpacing;
    const tokenWidthCache = {};
    let lastFont = "";
    const measureTokenWidth = (token, tokenStyle)=>{
        const cacheKey = `${token}|${tokenStyle.styleKey}`;
        let width = tokenWidthCache[cacheKey];
        if (width === void 0) {
            const font = tokenStyle._fontString;
            if (font !== lastFont) {
                context.font = font;
                lastFont = font;
            }
            width = measureTextFn(token, tokenStyle.letterSpacing, context) + tokenStyle.letterSpacing;
            tokenWidthCache[cacheKey] = width;
        }
        return width;
    };
    const result = [];
    for (const lineRuns of runsByLine){
        const styledTokens = $ec3326c7156957ee$export$7d01d70c6417df50(lineRuns);
        const resultStartLength = result.length;
        const getWordGroupWidth = (startIndex)=>{
            let totalWidth = 0;
            let j = startIndex;
            do {
                const { token: groupToken, style: groupStyle } = styledTokens[j];
                totalWidth += measureTokenWidth(groupToken, groupStyle);
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return totalWidth;
        };
        const getWordGroupTokens = (startIndex)=>{
            const tokens = [];
            let j = startIndex;
            do {
                tokens.push({
                    token: styledTokens[j].token,
                    style: styledTokens[j].style
                });
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return tokens;
        };
        let currentLineRuns = [];
        let currentWidth = 0;
        let canPrependSpaces = !shouldCollapseSpaces;
        let buildingRun = null;
        const flushBuildingRun = ()=>{
            if (buildingRun && buildingRun.text.length > 0) currentLineRuns.push(buildingRun);
            buildingRun = null;
        };
        const startNewLine = ()=>{
            flushBuildingRun();
            if (currentLineRuns.length > 0) {
                const lastRun = currentLineRuns[currentLineRuns.length - 1];
                lastRun.text = (0, $gAfNu.trimRight)(lastRun.text);
                if (lastRun.text.length === 0) currentLineRuns.pop();
            }
            result.push(currentLineRuns);
            currentLineRuns = [];
            currentWidth = 0;
            canPrependSpaces = false;
        };
        for(let i = 0; i < styledTokens.length; i++){
            const { token: token, style: tokenStyle, continuesFromPrevious: continuesFromPrevious } = styledTokens[i];
            const tokenWidth = measureTokenWidth(token, tokenStyle);
            if (shouldCollapseSpaces) {
                const currIsSpace = (0, $gAfNu.isBreakingSpace)(token);
                const lastChar = buildingRun?.text[buildingRun.text.length - 1] ?? currentLineRuns[currentLineRuns.length - 1]?.text.slice(-1) ?? "";
                const lastIsSpace = lastChar ? (0, $gAfNu.isBreakingSpace)(lastChar) : false;
                if (currIsSpace && lastIsSpace) continue;
            }
            const startsWordGroup = !continuesFromPrevious;
            const wordGroupWidth = startsWordGroup ? getWordGroupWidth(i) : tokenWidth;
            if (wordGroupWidth > adjustedWrapWidth && startsWordGroup) {
                if (currentWidth > 0) startNewLine();
                if (breakWords) {
                    const wordGroupTokens = getWordGroupTokens(i);
                    for(let g = 0; g < wordGroupTokens.length; g++){
                        const groupToken = wordGroupTokens[g].token;
                        const groupStyle = wordGroupTokens[g].style;
                        const charGroups = (0, $gAfNu.getCharacterGroups)(groupToken, breakWords, wordWrapSplitFn, canBreakCharsFn);
                        for (const char of charGroups){
                            const charWidth = measureTokenWidth(char, groupStyle);
                            if (charWidth + currentWidth > adjustedWrapWidth) startNewLine();
                            if (!buildingRun || buildingRun.style !== groupStyle) {
                                flushBuildingRun();
                                buildingRun = {
                                    text: char,
                                    style: groupStyle
                                };
                            } else buildingRun.text += char;
                            currentWidth += charWidth;
                        }
                    }
                    i += wordGroupTokens.length - 1;
                } else {
                    const wordGroupTokens = getWordGroupTokens(i);
                    flushBuildingRun();
                    result.push(wordGroupTokens.map((t)=>({
                            text: t.token,
                            style: t.style
                        })));
                    canPrependSpaces = false;
                    i += wordGroupTokens.length - 1;
                }
            } else if (wordGroupWidth + currentWidth > adjustedWrapWidth && startsWordGroup) {
                if ((0, $gAfNu.isBreakingSpace)(token)) {
                    canPrependSpaces = false;
                    continue;
                }
                startNewLine();
                buildingRun = {
                    text: token,
                    style: tokenStyle
                };
                currentWidth = tokenWidth;
            } else if (continuesFromPrevious && !breakWords) {
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            } else {
                const isSpace = (0, $gAfNu.isBreakingSpace)(token);
                if (currentWidth === 0 && isSpace && !canPrependSpaces) continue;
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            }
        }
        flushBuildingRun();
        if (currentLineRuns.length > 0) {
            const lastRun = currentLineRuns[currentLineRuns.length - 1];
            lastRun.text = (0, $gAfNu.trimRight)(lastRun.text);
            if (lastRun.text.length === 0) currentLineRuns.pop();
        }
        if (currentLineRuns.length > 0 || result.length === resultStartLength) result.push(currentLineRuns);
    }
    return result;
}
function $ec3326c7156957ee$export$7d01d70c6417df50(runs) {
    const styledTokens = [];
    let lastTokenWasWord = false;
    for (const run of runs){
        const tokens = (0, $gAfNu.tokenize)(run.text);
        let isFirstTokenInRun = true;
        for (const token of tokens){
            const isSpace = (0, $gAfNu.isBreakingSpace)(token) || (0, $gAfNu.isNewline)(token);
            const continuesFromPrevious = isFirstTokenInRun && lastTokenWasWord && !isSpace;
            styledTokens.push({
                token: token,
                style: run.style,
                continuesFromPrevious: continuesFromPrevious
            });
            lastTokenWasWord = !isSpace;
            isFirstTokenInRun = false;
        }
    }
    return styledTokens;
}

});
parcelRegister("8jcQu", function(module, exports) {

$parcel$export(module.exports, "hasTagStyles", () => $e27d0e223a3807b2$export$3c634ede7db41923);
$parcel$export(module.exports, "hasTagMarkup", () => $e27d0e223a3807b2$export$328893c99ad2af02);
$parcel$export(module.exports, "parseTaggedText", () => $e27d0e223a3807b2$export$9657ef3c3357e745);
$parcel$export(module.exports, "getPlainText", () => $e27d0e223a3807b2$export$1afb3864a65b041b);
"use strict";
function $e27d0e223a3807b2$export$3c634ede7db41923(style) {
    return !!style.tagStyles && Object.keys(style.tagStyles).length > 0;
}
function $e27d0e223a3807b2$export$328893c99ad2af02(text) {
    return text.includes("<");
}
function $e27d0e223a3807b2$var$createMergedStyle(baseStyle, overrides) {
    return baseStyle.clone().assign(overrides);
}
function $e27d0e223a3807b2$export$9657ef3c3357e745(text, style) {
    const runs = [];
    const tagStyles = style.tagStyles;
    if (!$e27d0e223a3807b2$export$3c634ede7db41923(style) || !$e27d0e223a3807b2$export$328893c99ad2af02(text)) {
        runs.push({
            text: text,
            style: style
        });
        return runs;
    }
    const styleStack = [
        style
    ];
    const tagStack = [];
    let currentText = "";
    let i = 0;
    while(i < text.length){
        const char = text[i];
        if (char === "<") {
            const closeIndex = text.indexOf(">", i);
            if (closeIndex === -1) {
                currentText += char;
                i++;
                continue;
            }
            const tagContent = text.slice(i + 1, closeIndex);
            if (tagContent.startsWith("/")) {
                const closingTagName = tagContent.slice(1).trim();
                if (tagStack.length > 0 && tagStack[tagStack.length - 1] === closingTagName) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    styleStack.pop();
                    tagStack.pop();
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            } else {
                const tagName = tagContent.trim();
                if (tagStyles[tagName]) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    const currentStyle = styleStack[styleStack.length - 1];
                    const mergedStyle = $e27d0e223a3807b2$var$createMergedStyle(currentStyle, tagStyles[tagName]);
                    styleStack.push(mergedStyle);
                    tagStack.push(tagName);
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            }
        } else {
            currentText += char;
            i++;
        }
    }
    if (currentText.length > 0) runs.push({
        text: currentText,
        style: styleStack[styleStack.length - 1]
    });
    return runs;
}
function $e27d0e223a3807b2$export$1afb3864a65b041b(text, style) {
    if (!$e27d0e223a3807b2$export$3c634ede7db41923(style) || !$e27d0e223a3807b2$export$328893c99ad2af02(text)) return text;
    const runs = $e27d0e223a3807b2$export$9657ef3c3357e745(text, style);
    return runs.map((run)=>run.text).join("");
}

});

parcelRegister("gAfNu", function(module, exports) {

$parcel$export(module.exports, "NEWLINES", () => $b07159e3b0cc1e1e$export$c5622f59bd0a84ab);
$parcel$export(module.exports, "NEWLINES_SET", () => $b07159e3b0cc1e1e$export$46828130f2642f37);
$parcel$export(module.exports, "BREAKING_SPACES", () => $b07159e3b0cc1e1e$export$82c4cde34833f6b6);
$parcel$export(module.exports, "BREAKING_SPACES_SET", () => $b07159e3b0cc1e1e$export$a7210490df44ebce);
$parcel$export(module.exports, "NEWLINE_SPLIT_REGEX", () => $b07159e3b0cc1e1e$export$b396c635f7504541);
$parcel$export(module.exports, "NEWLINE_MATCH_REGEX", () => $b07159e3b0cc1e1e$export$e943b22311785337);
$parcel$export(module.exports, "isNewline", () => $b07159e3b0cc1e1e$export$c6b40e80adfef3ae);
$parcel$export(module.exports, "isBreakingSpace", () => $b07159e3b0cc1e1e$export$40e905615472e8e0);
$parcel$export(module.exports, "collapseSpaces", () => $b07159e3b0cc1e1e$export$7070a8061037f71a);
$parcel$export(module.exports, "collapseNewlines", () => $b07159e3b0cc1e1e$export$368cf1740b390323);
$parcel$export(module.exports, "trimRight", () => $b07159e3b0cc1e1e$export$da8e5da96e287379);
$parcel$export(module.exports, "tokenize", () => $b07159e3b0cc1e1e$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "getCharacterGroups", () => $b07159e3b0cc1e1e$export$8398461ec76ab549);
"use strict";
const $b07159e3b0cc1e1e$export$c5622f59bd0a84ab = [
    10,
    // line feed
    13
];
const $b07159e3b0cc1e1e$export$46828130f2642f37 = new Set($b07159e3b0cc1e1e$export$c5622f59bd0a84ab);
const $b07159e3b0cc1e1e$export$82c4cde34833f6b6 = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
const $b07159e3b0cc1e1e$export$a7210490df44ebce = new Set($b07159e3b0cc1e1e$export$82c4cde34833f6b6);
const $b07159e3b0cc1e1e$export$b396c635f7504541 = /(\r\n|\r|\n)/;
const $b07159e3b0cc1e1e$export$e943b22311785337 = /(?:\r\n|\r|\n)/;
function $b07159e3b0cc1e1e$export$c6b40e80adfef3ae(char) {
    if (typeof char !== "string") return false;
    return $b07159e3b0cc1e1e$export$46828130f2642f37.has(char.charCodeAt(0));
}
function $b07159e3b0cc1e1e$export$40e905615472e8e0(char, _nextChar) {
    if (typeof char !== "string") return false;
    return $b07159e3b0cc1e1e$export$a7210490df44ebce.has(char.charCodeAt(0));
}
function $b07159e3b0cc1e1e$export$7070a8061037f71a(whiteSpace) {
    return whiteSpace === "normal" || whiteSpace === "pre-line";
}
function $b07159e3b0cc1e1e$export$368cf1740b390323(whiteSpace) {
    return whiteSpace === "normal";
}
function $b07159e3b0cc1e1e$export$da8e5da96e287379(text) {
    if (typeof text !== "string") return "";
    let i = text.length - 1;
    while(i >= 0 && $b07159e3b0cc1e1e$export$40e905615472e8e0(text[i]))i--;
    return i < text.length - 1 ? text.slice(0, i + 1) : text;
}
function $b07159e3b0cc1e1e$export$660b2ee2d4fb4eff(text) {
    const tokens = [];
    const tokenChars = [];
    if (typeof text !== "string") return tokens;
    for(let i = 0; i < text.length; i++){
        const char = text[i];
        const nextChar = text[i + 1];
        if ($b07159e3b0cc1e1e$export$40e905615472e8e0(char, nextChar) || $b07159e3b0cc1e1e$export$c6b40e80adfef3ae(char)) {
            if (tokenChars.length > 0) {
                tokens.push(tokenChars.join(""));
                tokenChars.length = 0;
            }
            if (char === "\r" && nextChar === "\n") {
                tokens.push("\r\n");
                i++;
            } else tokens.push(char);
            continue;
        }
        tokenChars.push(char);
    }
    if (tokenChars.length > 0) tokens.push(tokenChars.join(""));
    return tokens;
}
function $b07159e3b0cc1e1e$export$8398461ec76ab549(token, breakWords, splitFn, canBreakCharsFn) {
    const characters = splitFn(token);
    const groups = [];
    for(let j = 0; j < characters.length; j++){
        let char = characters[j];
        let lastChar = char;
        let k = 1;
        while(characters[j + k]){
            const nextChar = characters[j + k];
            if (!canBreakCharsFn(lastChar, nextChar, token, j, breakWords)) {
                char += nextChar;
                lastChar = nextChar;
                k++;
            } else break;
        }
        j += k - 1;
        groups.push(char);
    }
    return groups;
}

});


parcelRegister("4R0nM", function(module, exports) {

$parcel$export(module.exports, "wordWrap", () => $763bacf374c78d9e$export$dca3d8ad656c34d2);

var $gAfNu = parcelRequire("gAfNu");
"use strict";
const $763bacf374c78d9e$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
function $763bacf374c78d9e$var$getFromCache(key, letterSpacing, cache, context, measureTextFn) {
    let width = cache[key];
    if (typeof width !== "number") {
        width = measureTextFn(key, letterSpacing, context) + letterSpacing;
        cache[key] = width;
    }
    return width;
}
function $763bacf374c78d9e$export$dca3d8ad656c34d2(text, style, canvas, measureTextFn, canBreakWordsFn, canBreakCharsFn, wordWrapSplitFn) {
    const context = canvas.getContext("2d", $763bacf374c78d9e$var$contextSettings);
    context.font = style._fontString;
    let width = 0;
    let line = "";
    const linesArray = [];
    const cache = /* @__PURE__ */ Object.create(null);
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
    const shouldCollapseSpaces = (0, $gAfNu.collapseSpaces)(whiteSpace);
    const shouldCollapseNewlines = (0, $gAfNu.collapseNewlines)(whiteSpace);
    let canPrependSpaces = !shouldCollapseSpaces;
    const wordWrapWidth = style.wordWrapWidth + letterSpacing;
    const tokens = (0, $gAfNu.tokenize)(text);
    for(let i = 0; i < tokens.length; i++){
        let token = tokens[i];
        if ((0, $gAfNu.isNewline)(token)) {
            if (!shouldCollapseNewlines) {
                linesArray.push((0, $gAfNu.trimRight)(line));
                canPrependSpaces = !shouldCollapseSpaces;
                line = "";
                width = 0;
                continue;
            }
            token = " ";
        }
        if (shouldCollapseSpaces) {
            const currIsBreakingSpace = (0, $gAfNu.isBreakingSpace)(token);
            const lastIsBreakingSpace = (0, $gAfNu.isBreakingSpace)(line[line.length - 1]);
            if (currIsBreakingSpace && lastIsBreakingSpace) continue;
        }
        const tokenWidth = $763bacf374c78d9e$var$getFromCache(token, letterSpacing, cache, context, measureTextFn);
        if (tokenWidth > wordWrapWidth) {
            if (line !== "") {
                linesArray.push((0, $gAfNu.trimRight)(line));
                line = "";
                width = 0;
            }
            if (canBreakWordsFn(token, style.breakWords)) {
                const charGroups = (0, $gAfNu.getCharacterGroups)(token, style.breakWords, wordWrapSplitFn, canBreakCharsFn);
                for (const char of charGroups){
                    const characterWidth = $763bacf374c78d9e$var$getFromCache(char, letterSpacing, cache, context, measureTextFn);
                    if (characterWidth + width > wordWrapWidth) {
                        linesArray.push((0, $gAfNu.trimRight)(line));
                        canPrependSpaces = false;
                        line = "";
                        width = 0;
                    }
                    line += char;
                    width += characterWidth;
                }
            } else {
                if (line.length > 0) {
                    linesArray.push((0, $gAfNu.trimRight)(line));
                    line = "";
                    width = 0;
                }
                linesArray.push((0, $gAfNu.trimRight)(token));
                canPrependSpaces = false;
                line = "";
                width = 0;
            }
        } else {
            if (tokenWidth + width > wordWrapWidth) {
                canPrependSpaces = false;
                linesArray.push((0, $gAfNu.trimRight)(line));
                line = "";
                width = 0;
            }
            if (line.length > 0 || !(0, $gAfNu.isBreakingSpace)(token) || canPrependSpaces) {
                line += token;
                width += tokenWidth;
            }
        }
    }
    const trimmedLine = (0, $gAfNu.trimRight)(line);
    if (trimmedLine.length > 0) linesArray.push(trimmedLine);
    return linesArray.join("\n");
}

});


parcelRegister("bFX43", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $a32b3c558c1af2e1$export$1df879243bf2e42d);

var $6AQ4q = parcelRequire("6AQ4q");

var $dKHyW = parcelRequire("dKHyW");

var $1bMtF = parcelRequire("1bMtF");

var $6LhOA = parcelRequire("6LhOA");

var $1RpxL = parcelRequire("1RpxL");

var $hkzHY = parcelRequire("hkzHY");

var $bySfk = parcelRequire("bySfk");

var $7kRkZ = parcelRequire("7kRkZ");

var $bapDA = parcelRequire("bapDA");

var $3FldU = parcelRequire("3FldU");
"use strict";
const $a32b3c558c1af2e1$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(style = {}){
        super();
        /**
     * Unique identifier for the TextStyle class.
     * This is used to track instances and ensure uniqueness.
     * @internal
     */ this.uid = (0, $1bMtF.uid)("textStyle");
        /**
     * Internal tick counter used to track updates and changes.
     * This is incremented whenever the style is modified, allowing for efficient change detection.
     * @internal
     */ this._tick = 0;
        this._cachedFontString = null;
        $a32b3c558c1af2e1$var$convertV7Tov8Style(style);
        const isTextStyle = style instanceof _TextStyle;
        const existingStyle = style;
        if (isTextStyle) style = existingStyle._toObject();
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this._tagStyles = style.tagStyles ?? void 0;
        this.update();
        this._tick = 0;
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @type {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        if (this._align === value) return;
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        if (this._breakWords === value) return;
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (this._dropShadow === value) return;
        if (value !== null && typeof value === "object") this._dropShadow = this._createProxy({
            ..._TextStyle.defaultDropShadow,
            ...value
        });
        else this._dropShadow = value ? this._createProxy({
            ..._TextStyle.defaultDropShadow
        }) : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (this._fontSize === value) return;
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @type {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value.toLowerCase();
        this.update();
    }
    /**
   * The font variant.
   * @type {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        if (this._fontVariant === value) return;
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        if (this._leading === value) return;
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        if (this._letterSpacing === value) return;
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        if (this._lineHeight === value) return;
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   * > [!NOTE] This will NOT affect the positioning or bounds of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        if (this._padding === value) return;
        this._padding = value;
        this.update();
    }
    /**
   * An optional filter or array of filters to apply to the text, allowing for advanced visual effects.
   * These filters will be applied to the text as it is created, resulting in faster rendering for static text
   * compared to applying the filter directly to the text object (which would be applied at run time).
   * @default null
   */ get filters() {
        return this._filters;
    }
    set filters(value) {
        if (this._filters === value) return;
        this._filters = Object.freeze(value);
        this.update();
    }
    /**
   * Trim transparent borders from the text texture.
   * > [!IMPORTANT] PERFORMANCE WARNING:
   * > This is a costly operation as it requires scanning pixel alpha values.
   * > Avoid using `trim: true` for dynamic text, as it could significantly impact performance.
   */ get trim() {
        return this._trim;
    }
    set trim(value) {
        if (this._trim === value) return;
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        if (this._textBaseline === value) return;
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @type {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        if (this._whiteSpace === value) return;
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        if (this._wordWrap === value) return;
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        if (this._wordWrapWidth === value) return;
        this._wordWrapWidth = value;
        this.update();
    }
    /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        if (this._isFillStyle(value)) this._originalFill = this._createProxy({
            ...(0, $7kRkZ.GraphicsContext).defaultFillStyle,
            ...value
        }, ()=>{
            this._fill = (0, $bapDA.toFillStyle)({
                ...this._originalFill
            }, (0, $7kRkZ.GraphicsContext).defaultFillStyle);
        });
        this._fill = (0, $bapDA.toFillStyle)(value === 0 ? "black" : value, (0, $7kRkZ.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        if (this._isFillStyle(value)) this._originalStroke = this._createProxy({
            ...(0, $7kRkZ.GraphicsContext).defaultStrokeStyle,
            ...value
        }, ()=>{
            this._stroke = (0, $bapDA.toStrokeStyle)({
                ...this._originalStroke
            }, (0, $7kRkZ.GraphicsContext).defaultStrokeStyle);
        });
        this._stroke = (0, $bapDA.toStrokeStyle)(value, (0, $7kRkZ.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    /**
   * Custom styles to apply to specific tags within the text.
   * Allows for rich text formatting using simple tag markup like `<red>text</red>`.
   *
   * Tags are only parsed when this property has entries. If `tagStyles` is undefined,
   * `<` characters in text are treated as literal.
   * @example
   * ```ts
   * const text = new Text({
   *     text: '<red>Red</red>, <blue>Blue</blue>',
   *     style: {
   *         fill: 'white',
   *         tagStyles: {
   *             red: { fill: 'red' },
   *             blue: { fill: 'blue' }
   *         }
   *     }
   * });
   * ```
   */ get tagStyles() {
        return this._tagStyles;
    }
    set tagStyles(value) {
        if (this._tagStyles === value) return;
        this._tagStyles = value ?? void 0;
        this.update();
    }
    update() {
        this._tick++;
        this._cachedFontString = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    /**
   * Assigns partial style options to this TextStyle instance.
   * Uses public setters to ensure proper value transformation.
   * @param values - Partial style options to assign
   * @returns This TextStyle instance for chaining
   */ assign(values) {
        for(const key in values){
            const thisKey = key;
            this[thisKey] = values[key];
        }
        return this;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this.uid}-${this._tick}`;
    }
    /**
   * Returns the CSS font string for this style, cached for performance.
   * @internal
   * @returns CSS font string
   */ get _fontString() {
        if (this._cachedFontString === null) this._cachedFontString = (0, $3FldU.fontStringFromTextStyle)(this);
        return this._cachedFontString;
    }
    /**
   * Returns an object with the same values as this TextStyle instance.
   * @returns Object with the same values as this TextStyle instance
   * @example
   * ```ts
   * const style = new TextStyle({
   *     fontSize: 24,
   *     fill: 0xff0000,
   *     stroke: { color: 0x0000ff, width: 2 }
   * });
   * const object = style.toObject();
   * console.log(object);
   * // { fontSize: 24, fill: 0xff0000, stroke: { color: 0x0000ff, width: 2 } }
   * ```
   */ _toObject() {
        return {
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this._dropShadow ? {
                ...this._dropShadow
            } : null,
            fill: this._fill ? {
                ...this._fill
            } : void 0,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke ? {
                ...this._stroke
            } : void 0,
            textBaseline: this.textBaseline,
            trim: this.trim,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth,
            filters: this._filters ? [
                ...this._filters
            ] : void 0,
            tagStyles: this._tagStyles ? {
                ...this._tagStyles
            } : void 0
        };
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle(this._toObject());
    }
    /**
   * Returns the final padding for the text style, taking into account any filters applied.
   * Used internally for correct measurements
   * @internal
   * @returns {number} The final padding for the text style.
   */ _getFinalPadding() {
        let filterPadding = 0;
        if (this._filters) for(let i = 0; i < this._filters.length; i++)filterPadding += this._filters[i].padding;
        return Math.max(this._padding, filterPadding);
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroy the text style and its textures
   * textStyle.destroy({ texture: true, textureSource: true });
   * textStyle.destroy(true);
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
    _createProxy(value, cb) {
        return new Proxy(value, {
            set: (target, property, newValue)=>{
                if (target[property] === newValue) return true;
                target[property] = newValue;
                cb?.(property, newValue);
                this.update();
                return true;
            }
        });
    }
    _isFillStyle(value) {
        return (value ?? null) !== null && !((0, $dKHyW.Color).isColorLike(value) || value instanceof (0, $hkzHY.FillGradient) || value instanceof (0, $bySfk.FillPattern));
    }
};
/**
 * Default drop shadow settings used when enabling drop shadows on text.
 * These values are used as the base configuration when drop shadows are enabled without specific settings.
 * @example
 * ```ts
 * // Customize default settings globally
 * TextStyle.defaultDropShadow.alpha = 0.5;    // 50% opacity for all shadows
 * TextStyle.defaultDropShadow.blur = 2;       // 2px blur for all shadows
 * TextStyle.defaultDropShadow.color = 'blue'; // Blue shadows by default
 * ```
 */ $a32b3c558c1af2e1$var$_TextStyle.defaultDropShadow = {
    alpha: 1,
    angle: Math.PI / 6,
    blur: 0,
    color: "black",
    distance: 5
};
/**
 * Default text style settings used when creating new text objects.
 * These values serve as the base configuration and can be customized globally.
 * @example
 * ```ts
 * // Customize default text style globally
 * TextStyle.defaultTextStyle.fontSize = 16;
 * TextStyle.defaultTextStyle.fill = 0x333333;
 * TextStyle.defaultTextStyle.fontFamily = ['Arial', 'Helvetica', 'sans-serif'];
 * ```
 */ $a32b3c558c1af2e1$var$_TextStyle.defaultTextStyle = {
    align: "left",
    breakWords: false,
    dropShadow: null,
    fill: "black",
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    leading: 0,
    letterSpacing: 0,
    lineHeight: 0,
    padding: 0,
    stroke: null,
    textBaseline: "alphabetic",
    trim: false,
    whiteSpace: "pre",
    wordWrap: false,
    wordWrapWidth: 100
};
let $a32b3c558c1af2e1$export$1df879243bf2e42d = $a32b3c558c1af2e1$var$_TextStyle;
function $a32b3c558c1af2e1$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $a32b3c558c1af2e1$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        let obj = {};
        if ((0, $dKHyW.Color).isColorLike(color)) obj.color = color;
        else if (color instanceof (0, $hkzHY.FillGradient) || color instanceof (0, $bySfk.FillPattern)) obj.fill = color;
        else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) obj = color;
        else throw new Error("Invalid stroke value.");
        style.stroke = {
            ...obj,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fillGradientStops)) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        if (!Array.isArray(oldStyle.fill) || oldStyle.fill.length === 0) throw new Error("Invalid fill value. Expected an array of colors for gradient fill.");
        if (oldStyle.fill.length !== oldStyle.fillGradientStops.length) (0, $1RpxL.warn)("The number of fill colors must match the number of fill gradient stops.");
        const gradientFill = new (0, $hkzHY.FillGradient)({
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 1
            },
            textureSpace: "local"
        });
        const fillGradientStops = oldStyle.fillGradientStops.slice();
        const fills = oldStyle.fill.map((color)=>(0, $dKHyW.Color).shared.setValue(color).toNumber());
        fillGradientStops.forEach((stop, index)=>{
            gradientFill.addColorStop(stop, fills[index]);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}

});
parcelRegister("3FldU", function(module, exports) {

$parcel$export(module.exports, "fontStringFromTextStyle", () => $cf198e38a1a7ff7c$export$b7b5edb82ac3fc66);
"use strict";
const $cf198e38a1a7ff7c$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $cf198e38a1a7ff7c$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$cf198e38a1a7ff7c$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}

});


parcelRegister("a1eHr", function(module, exports) {

$parcel$export(module.exports, "DynamicBitmapFont", () => $11787021d96deaea$export$bce21273d0a2e6c7);

var $dKHyW = parcelRequire("dKHyW");

var $ar2Ly = parcelRequire("ar2Ly");

var $dDZJD = parcelRequire("dDZJD");

var $cVYNB = parcelRequire("cVYNB");

var $4iNSL = parcelRequire("4iNSL");

var $c8piJ = parcelRequire("c8piJ");

var $6LhOA = parcelRequire("6LhOA");

var $1i9ku = parcelRequire("1i9ku");

var $3FldU = parcelRequire("3FldU");

var $hFmvn = parcelRequire("hFmvn");

var $bFX43 = parcelRequire("bFX43");

var $l918V = parcelRequire("l918V");
"use strict";
const $11787021d96deaea$var$_DynamicBitmapFont = class _DynamicBitmapFont extends (0, $l918V.AbstractBitmapFont) {
    /**
   * @param options - The options for the dynamic bitmap font.
   */ constructor(options){
        super();
        /**
     * this is a resolution modifier for the font size..
     * texture resolution will also be used to scale texture according to its font size also
     */ this.resolution = 1;
        /** The pages of the font. */ this.pages = [];
        this._padding = 0;
        this._measureCache = /* @__PURE__ */ Object.create(null);
        this._currentChars = [];
        this._currentX = 0;
        this._currentY = 0;
        this._currentMaxCharHeight = 0;
        this._currentPageIndex = -1;
        this._skipKerning = false;
        const dynamicOptions = {
            ..._DynamicBitmapFont.defaultOptions,
            ...options
        };
        this._textureSize = dynamicOptions.textureSize;
        this._mipmap = dynamicOptions.mipmap;
        const style = dynamicOptions.style.clone();
        if (dynamicOptions.overrideFill) {
            style._fill.color = 16777215;
            style._fill.alpha = 1;
            style._fill.texture = (0, $4iNSL.Texture).WHITE;
            style._fill.fill = null;
        }
        this.applyFillAsTint = dynamicOptions.overrideFill;
        const requestedFontSize = style.fontSize;
        style.fontSize = this.baseMeasurementFontSize;
        const font = (0, $3FldU.fontStringFromTextStyle)(style);
        if (dynamicOptions.overrideSize) {
            if (style._stroke) style._stroke.width *= this.baseRenderedFontSize / requestedFontSize;
        } else style.fontSize = this.baseRenderedFontSize = requestedFontSize;
        this._style = style;
        this._skipKerning = dynamicOptions.skipKerning ?? false;
        this.resolution = dynamicOptions.resolution ?? 1;
        this._padding = dynamicOptions.padding ?? 4;
        if (dynamicOptions.textureStyle) this._textureStyle = dynamicOptions.textureStyle instanceof (0, $c8piJ.TextureStyle) ? dynamicOptions.textureStyle : new (0, $c8piJ.TextureStyle)(dynamicOptions.textureStyle);
        this.fontMetrics = (0, $1i9ku.CanvasTextMetrics).measureFont(font);
        this.lineHeight = style.lineHeight || this.fontMetrics.fontSize || style.fontSize;
    }
    ensureCharacters(chars) {
        const charList = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(chars).filter((char)=>!this._currentChars.includes(char)).filter((char, index, self)=>self.indexOf(char) === index);
        if (!charList.length) return;
        this._currentChars = [
            ...this._currentChars,
            ...charList
        ];
        let pageData;
        if (this._currentPageIndex === -1) pageData = this._nextPage();
        else pageData = this.pages[this._currentPageIndex];
        let { canvas: canvas, context: context } = pageData.canvasAndContext;
        let textureSource = pageData.texture.source;
        const style = this._style;
        let currentX = this._currentX;
        let currentY = this._currentY;
        let currentMaxCharHeight = this._currentMaxCharHeight;
        const fontScale = this.baseRenderedFontSize / this.baseMeasurementFontSize;
        const padding = this._padding * fontScale;
        let skipTexture = false;
        const maxTextureWidth = canvas.width / this.resolution;
        const maxTextureHeight = canvas.height / this.resolution;
        for(let i = 0; i < charList.length; i++){
            const char = charList[i];
            const metrics = (0, $1i9ku.CanvasTextMetrics).measureText(char, style, canvas, false);
            metrics.lineHeight = metrics.height;
            const width = metrics.width * fontScale;
            const textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            const height = metrics.height * fontScale;
            const paddedWidth = textureGlyphWidth + padding * 2;
            const paddedHeight = height + padding * 2;
            skipTexture = false;
            if (char !== "\n" && char !== "\r" && char !== "	" && char !== " ") {
                skipTexture = true;
                currentMaxCharHeight = Math.ceil(Math.max(paddedHeight, currentMaxCharHeight));
            }
            if (currentX + paddedWidth > maxTextureWidth) {
                currentY += currentMaxCharHeight;
                currentMaxCharHeight = paddedHeight;
                currentX = 0;
                if (currentY + currentMaxCharHeight > maxTextureHeight) {
                    textureSource.update();
                    const pageData2 = this._nextPage();
                    canvas = pageData2.canvasAndContext.canvas;
                    context = pageData2.canvasAndContext.context;
                    textureSource = pageData2.texture.source;
                    currentX = 0;
                    currentY = 0;
                    currentMaxCharHeight = 0;
                }
            }
            const xAdvance = width / fontScale - (style.dropShadow?.distance ?? 0) - (style._stroke?.width ?? 0);
            this.chars[char] = {
                id: char.codePointAt(0),
                xOffset: -this._padding,
                yOffset: -this._padding,
                xAdvance: xAdvance,
                kerning: {}
            };
            if (skipTexture) {
                this._drawGlyph(context, metrics, currentX + padding, currentY + padding, fontScale, style);
                const px = textureSource.width * fontScale;
                const py = textureSource.height * fontScale;
                const frame = new (0, $ar2Ly.Rectangle)(currentX / px * textureSource.width, currentY / py * textureSource.height, paddedWidth / px * textureSource.width, paddedHeight / py * textureSource.height);
                this.chars[char].texture = new (0, $4iNSL.Texture)({
                    source: textureSource,
                    frame: frame
                });
                currentX += Math.ceil(paddedWidth);
            }
        }
        textureSource.update();
        this._currentX = currentX;
        this._currentY = currentY;
        this._currentMaxCharHeight = currentMaxCharHeight;
        this._skipKerning && this._applyKerning(charList, context);
    }
    /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */ get pageTextures() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    _applyKerning(newChars, context) {
        const measureCache = this._measureCache;
        for(let i = 0; i < newChars.length; i++){
            const first = newChars[i];
            for(let j = 0; j < this._currentChars.length; j++){
                const second = this._currentChars[j];
                let c1 = measureCache[first];
                if (!c1) c1 = measureCache[first] = context.measureText(first).width;
                let c2 = measureCache[second];
                if (!c2) c2 = measureCache[second] = context.measureText(second).width;
                let total = context.measureText(first + second).width;
                let amount = total - (c1 + c2);
                if (amount) this.chars[first].kerning[second] = amount;
                total = context.measureText(first + second).width;
                amount = total - (c1 + c2);
                if (amount) this.chars[second].kerning[first] = amount;
            }
        }
    }
    _nextPage() {
        this._currentPageIndex++;
        const textureResolution = this.resolution;
        const canvasAndContext = (0, $dDZJD.CanvasPool).getOptimalCanvasAndContext(this._textureSize, this._textureSize, textureResolution);
        this._setupContext(canvasAndContext.context, this._style, textureResolution);
        const resolution = textureResolution * (this.baseRenderedFontSize / this.baseMeasurementFontSize);
        const texture = new (0, $4iNSL.Texture)({
            source: new (0, $cVYNB.ImageSource)({
                resource: canvasAndContext.canvas,
                resolution: resolution,
                alphaMode: "premultiply-alpha-on-upload",
                autoGenerateMipmaps: this._mipmap
            })
        });
        if (this._textureStyle) texture.source.style = this._textureStyle;
        const pageData = {
            canvasAndContext: canvasAndContext,
            texture: texture
        };
        this.pages[this._currentPageIndex] = pageData;
        return pageData;
    }
    // canvas style!
    _setupContext(context, style, resolution) {
        style.fontSize = this.baseRenderedFontSize;
        context.scale(resolution, resolution);
        context.font = (0, $3FldU.fontStringFromTextStyle)(style);
        style.fontSize = this.baseMeasurementFontSize;
        context.textBaseline = style.textBaseline;
        const stroke = style._stroke;
        const strokeThickness = stroke?.width ?? 0;
        if (stroke) {
            context.lineWidth = strokeThickness;
            context.lineJoin = stroke.join;
            context.miterLimit = stroke.miterLimit;
            context.strokeStyle = (0, $hFmvn.getCanvasFillStyle)(stroke, context);
        }
        if (style._fill) context.fillStyle = (0, $hFmvn.getCanvasFillStyle)(style._fill, context);
        if (style.dropShadow) {
            const shadowOptions = style.dropShadow;
            const rgb = (0, $dKHyW.Color).shared.setValue(shadowOptions.color).toArray();
            const dropShadowBlur = shadowOptions.blur * resolution;
            const dropShadowDistance = shadowOptions.distance * resolution;
            context.shadowColor = `rgba(${rgb[0] * 255},${rgb[1] * 255},${rgb[2] * 255},${shadowOptions.alpha})`;
            context.shadowBlur = dropShadowBlur;
            context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
            context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance;
        } else {
            context.shadowColor = "black";
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
    }
    _drawGlyph(context, metrics, x, y, fontScale, style) {
        const char = metrics.text;
        const fontProperties = metrics.fontProperties;
        const stroke = style._stroke;
        const strokeThickness = (stroke?.width ?? 0) * fontScale;
        const tx = x + strokeThickness / 2;
        const ty = y - strokeThickness / 2;
        const descent = fontProperties.descent * fontScale;
        const lineHeight = metrics.lineHeight * fontScale;
        let removeShadow = false;
        if (style.stroke && strokeThickness) {
            removeShadow = true;
            context.strokeText(char, tx, ty + lineHeight - descent);
        }
        const { shadowBlur: shadowBlur, shadowOffsetX: shadowOffsetX, shadowOffsetY: shadowOffsetY } = context;
        if (style._fill) {
            if (removeShadow) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            context.fillText(char, tx, ty + lineHeight - descent);
        }
        if (removeShadow) {
            context.shadowBlur = shadowBlur;
            context.shadowOffsetX = shadowOffsetX;
            context.shadowOffsetY = shadowOffsetY;
        }
    }
    destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { canvasAndContext: canvasAndContext, texture: texture } = this.pages[i];
            (0, $dDZJD.CanvasPool).returnCanvasAndContext(canvasAndContext);
            texture.destroy(true);
        }
        this.pages = null;
    }
};
$11787021d96deaea$var$_DynamicBitmapFont.defaultOptions = {
    textureSize: 512,
    style: new (0, $bFX43.TextStyle)(),
    mipmap: true
};
let $11787021d96deaea$export$bce21273d0a2e6c7 = $11787021d96deaea$var$_DynamicBitmapFont;

});
parcelRegister("hFmvn", function(module, exports) {

$parcel$export(module.exports, "getCanvasFillStyle", () => $0298d417054a0351$export$c31af9427fa8602b);

var $dKHyW = parcelRequire("dKHyW");

var $5xi4h = parcelRequire("5xi4h");

var $4iNSL = parcelRequire("4iNSL");

var $1RpxL = parcelRequire("1RpxL");

var $hkzHY = parcelRequire("hkzHY");

var $bySfk = parcelRequire("bySfk");
"use strict";
const $0298d417054a0351$var$PRECISION = 1e5;
function $0298d417054a0351$export$c31af9427fa8602b(fillStyle, context, textMetrics, padding = 0, offsetX = 0, offsetY = 0) {
    if (fillStyle.texture === (0, $4iNSL.Texture).WHITE && !fillStyle.fill) return (0, $dKHyW.Color).shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
    else if (!fillStyle.fill) {
        const pattern = context.createPattern(fillStyle.texture.source.resource, "repeat");
        const tempMatrix = fillStyle.matrix.copyTo((0, $5xi4h.Matrix).shared);
        tempMatrix.scale(fillStyle.texture.source.pixelWidth, fillStyle.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $bySfk.FillPattern)) {
        const fillPattern = fillStyle.fill;
        const pattern = context.createPattern(fillPattern.texture.source.resource, "repeat");
        const tempMatrix = fillPattern.transform.copyTo((0, $5xi4h.Matrix).shared);
        tempMatrix.scale(fillPattern.texture.source.pixelWidth, fillPattern.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $hkzHY.FillGradient)) {
        const fillGradient = fillStyle.fill;
        const isLinear = fillGradient.type === "linear";
        const isLocal = fillGradient.textureSpace === "local";
        let width = 1;
        let height = 1;
        if (isLocal && textMetrics) {
            width = textMetrics.width + padding;
            height = textMetrics.height + padding;
        }
        let gradient;
        let isNearlyVertical = false;
        if (isLinear) {
            const { start: start, end: end } = fillGradient;
            gradient = context.createLinearGradient(start.x * width + offsetX, start.y * height + offsetY, end.x * width + offsetX, end.y * height + offsetY);
            isNearlyVertical = Math.abs(end.x - start.x) < Math.abs((end.y - start.y) * 0.1);
        } else {
            const { center: center, innerRadius: innerRadius, outerCenter: outerCenter, outerRadius: outerRadius } = fillGradient;
            gradient = context.createRadialGradient(center.x * width + offsetX, center.y * height + offsetY, innerRadius * width, outerCenter.x * width + offsetX, outerCenter.y * height + offsetY, outerRadius * width);
        }
        if (isNearlyVertical && isLocal && textMetrics) {
            const ratio = textMetrics.lineHeight / height;
            for(let i = 0; i < textMetrics.lines.length; i++){
                const start = (i * textMetrics.lineHeight + padding / 2) / height;
                fillGradient.colorStops.forEach((stop)=>{
                    let globalStop = start + stop.offset * ratio;
                    globalStop = Math.max(0, Math.min(1, globalStop));
                    gradient.addColorStop(// fix to 5 decimal places to avoid floating point precision issues
                    Math.floor(globalStop * $0298d417054a0351$var$PRECISION) / $0298d417054a0351$var$PRECISION, (0, $dKHyW.Color).shared.setValue(stop.color).toHex());
                });
            }
        } else fillGradient.colorStops.forEach((stop)=>{
            gradient.addColorStop(stop.offset, (0, $dKHyW.Color).shared.setValue(stop.color).toHex());
        });
        return gradient;
    }
    (0, $1RpxL.warn)("FillStyle not recognised", fillStyle);
    return "red";
}

});


parcelRegister("dhjTN", function(module, exports) {

$parcel$export(module.exports, "getBitmapTextLayout", () => $3e5395c7406fd612$export$beeb37b3e20d3ee4);
"use strict";
function $3e5395c7406fd612$export$beeb37b3e20d3ee4(chars, style, font, trimEnd) {
    const layoutData = {
        width: 0,
        height: 0,
        offsetY: 0,
        scale: style.fontSize / font.baseMeasurementFontSize,
        lines: [
            {
                width: 0,
                charPositions: [],
                spaceWidth: 0,
                spacesIndex: [],
                chars: []
            }
        ]
    };
    layoutData.offsetY = font.baseLineOffset;
    let currentLine = layoutData.lines[0];
    let previousChar = null;
    let firstWord = true;
    const currentWord = {
        spaceWord: false,
        width: 0,
        start: 0,
        index: 0,
        // use index to not modify the array as we use it a lot!
        positions: [],
        chars: []
    };
    const scale = font.baseMeasurementFontSize / style.fontSize;
    const adjustedLetterSpacing = style.letterSpacing * scale;
    const adjustedWordWrapWidth = style.wordWrapWidth * scale;
    const adjustedLineHeight = style.lineHeight ? style.lineHeight * scale : font.lineHeight;
    const breakWords = style.wordWrap && style.breakWords;
    const nextWord = (word)=>{
        const start = currentLine.width;
        for(let j = 0; j < currentWord.index; j++){
            const position = word.positions[j];
            currentLine.chars.push(word.chars[j]);
            currentLine.charPositions.push(position + start);
        }
        currentLine.width += word.width;
        firstWord = false;
        currentWord.width = 0;
        currentWord.index = 0;
        currentWord.chars.length = 0;
    };
    const nextLine = ()=>{
        let index = currentLine.chars.length - 1;
        if (trimEnd) {
            let lastChar = currentLine.chars[index];
            while(lastChar === " "){
                currentLine.width -= font.chars[lastChar].xAdvance;
                lastChar = currentLine.chars[--index];
            }
        }
        layoutData.width = Math.max(layoutData.width, currentLine.width);
        currentLine = {
            width: 0,
            charPositions: [],
            chars: [],
            spaceWidth: 0,
            spacesIndex: []
        };
        firstWord = true;
        layoutData.lines.push(currentLine);
        layoutData.height += adjustedLineHeight;
    };
    const checkIsOverflow = (lineWidth)=>lineWidth - adjustedLetterSpacing > adjustedWordWrapWidth;
    for(let i = 0; i < chars.length + 1; i++){
        let char;
        const isEnd = i === chars.length;
        if (!isEnd) char = chars[i];
        const charData = font.chars[char] || font.chars[" "];
        const isSpace = /(?:\s)/.test(char);
        const isWordBreak = isSpace || char === "\r" || char === "\n" || isEnd;
        if (isWordBreak) {
            const addWordToNextLine = !firstWord && style.wordWrap && checkIsOverflow(currentLine.width + currentWord.width);
            if (addWordToNextLine) {
                nextLine();
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            } else {
                currentWord.start = currentLine.width;
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            }
            if (char === "\r" || char === "\n") nextLine();
            else if (!isEnd) {
                const spaceWidth = charData.xAdvance + (charData.kerning[previousChar] || 0) + adjustedLetterSpacing;
                currentLine.width += spaceWidth;
                currentLine.spaceWidth = spaceWidth;
                currentLine.spacesIndex.push(currentLine.charPositions.length);
                currentLine.chars.push(char);
            }
        } else {
            const kerning = charData.kerning[previousChar] || 0;
            const nextCharWidth = charData.xAdvance + kerning + adjustedLetterSpacing;
            const addWordToNextLine = breakWords && checkIsOverflow(currentLine.width + currentWord.width + nextCharWidth);
            if (addWordToNextLine) {
                nextWord(currentWord);
                nextLine();
            }
            currentWord.positions[currentWord.index++] = currentWord.width + kerning;
            currentWord.chars.push(char);
            currentWord.width += nextCharWidth;
        }
        previousChar = char;
    }
    nextLine();
    if (style.align === "center") $3e5395c7406fd612$var$alignCenter(layoutData);
    else if (style.align === "right") $3e5395c7406fd612$var$alignRight(layoutData);
    else if (style.align === "justify") $3e5395c7406fd612$var$alignJustify(layoutData);
    return layoutData;
}
function $3e5395c7406fd612$var$alignCenter(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width / 2 - line.width / 2;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $3e5395c7406fd612$var$alignRight(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width - line.width;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $3e5395c7406fd612$var$alignJustify(measurementData) {
    const width = measurementData.width;
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        let indy = 0;
        let spaceIndex = line.spacesIndex[indy++];
        let offset = 0;
        const totalSpaces = line.spacesIndex.length;
        const newSpaceWidth = (width - line.width) / totalSpaces;
        const spaceWidth = newSpaceWidth;
        for(let j = 0; j < line.charPositions.length; j++){
            if (j === spaceIndex) {
                spaceIndex = line.spacesIndex[indy++];
                offset += spaceWidth;
            }
            line.charPositions[j] += offset;
        }
    }
}

});

parcelRegister("3beWQ", function(module, exports) {

$parcel$export(module.exports, "resolveCharacters", () => $6be123efd339c0e8$export$221291e5031b03d8);
"use strict";
function $6be123efd339c0e8$export$221291e5031b03d8(chars) {
    if (chars === "") return [];
    if (typeof chars === "string") chars = [
        chars
    ];
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            if (item[0].length === 0 || item[1].length === 0) throw new Error("[BitmapFont]: Invalid character delimiter.");
            const startCode = item[0].charCodeAt(0);
            const endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...Array.from(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}

});



parcelRegister("itFHR", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $d73b496ea98a0aad$export$5f828d93ff035aa8, (v) => $d73b496ea98a0aad$export$5f828d93ff035aa8 = v);
// eslint-disable-next-line no-multi-assign
var $d73b496ea98a0aad$export$5f828d93ff035aa8;
var $d73b496ea98a0aad$export$cd94982b18c6332c;
var $d73b496ea98a0aad$export$1d518568e4f529b0;
var $d73b496ea98a0aad$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $d73b496ea98a0aad$export$2fb37efbf6ae0c0e;
var $d73b496ea98a0aad$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $d73b496ea98a0aad$export$da39cf97e1eb7c91;
var $d73b496ea98a0aad$export$52a9039d7177394f;
var $d73b496ea98a0aad$export$f7201db400317331;
var $d73b496ea98a0aad$export$448fa22aedc9dbca;
var $d73b496ea98a0aad$export$b80c7ba289c8fa56;
var $d73b496ea98a0aad$export$26e5786e8ac8e530;
var $d73b496ea98a0aad$export$bdd223f16383713e;
var $d73b496ea98a0aad$export$20533d26f07f1ee0;
var $d73b496ea98a0aad$export$2f64596b8cbf08b4;
var $d73b496ea98a0aad$export$2ce6d8d0e8b04e1a;
var $d73b496ea98a0aad$export$12ada9414fbc594c;
var $d73b496ea98a0aad$export$f5e7e39d57cd9700;
var $d73b496ea98a0aad$export$36b6d6ef312eab39;
var $d73b496ea98a0aad$export$58a258485f1e49f6;
var $d73b496ea98a0aad$export$dedd8dc3dc62b370;
var $d73b496ea98a0aad$export$971862a2fcb1bb40;
var $d73b496ea98a0aad$export$c6ff6a88acbeaf40;
var $d73b496ea98a0aad$export$fdc27893e98845cc;
var $d73b496ea98a0aad$export$6671fb9a1323bed;
var $d73b496ea98a0aad$export$d74daf141a551db;
var $d73b496ea98a0aad$export$45df7cae684751af;
var $d73b496ea98a0aad$export$1db683ad541682f6;
var $d73b496ea98a0aad$export$6f65485f87568e37;
var $d73b496ea98a0aad$export$91a8e56769aeb334;
var $d73b496ea98a0aad$export$2d4117e99c2179e4;
var $d73b496ea98a0aad$export$512823e338ddb1b7;
var $d73b496ea98a0aad$export$9d0e0c0c4a8d30f3;
var $d73b496ea98a0aad$export$b9d55ff329113abd;
var $d73b496ea98a0aad$export$7efb24e2fddf99b9;
var $d73b496ea98a0aad$export$bb1abf2ce84fc7e8;
var $d73b496ea98a0aad$export$2f7171e78e524d5e;
var $d73b496ea98a0aad$export$e1d879b482f37d98;
var $d73b496ea98a0aad$export$1a988e7317c65621;
'use strict';

$d73b496ea98a0aad$export$5f828d93ff035aa8 = $d73b496ea98a0aad$export$cd94982b18c6332c = $d73b496ea98a0aad$export$1d518568e4f529b0 = $d73b496ea98a0aad$export$5285b6d41c912b41 = (parcelRequire("4WS9C"));

$d73b496ea98a0aad$export$2fb37efbf6ae0c0e = $d73b496ea98a0aad$export$ab85ecd77ce6a5cd = (parcelRequire("7TQd3"));

$d73b496ea98a0aad$export$da39cf97e1eb7c91 = $d73b496ea98a0aad$export$52a9039d7177394f = (parcelRequire("4rFkN"));

var $45HRw = parcelRequire("45HRw");
var $d73b496ea98a0aad$var$algoKeys = Object.keys($45HRw);
var $d73b496ea98a0aad$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($d73b496ea98a0aad$var$algoKeys);
$d73b496ea98a0aad$export$f7201db400317331 = function() {
    return $d73b496ea98a0aad$var$hashes;
};

var $96GTd = parcelRequire("96GTd");
$d73b496ea98a0aad$export$448fa22aedc9dbca = $96GTd.pbkdf2;
$d73b496ea98a0aad$export$b80c7ba289c8fa56 = $96GTd.pbkdf2Sync;

var $go6LA = parcelRequire("go6LA");
$d73b496ea98a0aad$export$26e5786e8ac8e530 = $go6LA.Cipher;
$d73b496ea98a0aad$export$bdd223f16383713e = $go6LA.createCipher;
$d73b496ea98a0aad$export$20533d26f07f1ee0 = $go6LA.Cipheriv;
$d73b496ea98a0aad$export$2f64596b8cbf08b4 = $go6LA.createCipheriv;
$d73b496ea98a0aad$export$2ce6d8d0e8b04e1a = $go6LA.Decipher;
$d73b496ea98a0aad$export$12ada9414fbc594c = $go6LA.createDecipher;
$d73b496ea98a0aad$export$f5e7e39d57cd9700 = $go6LA.Decipheriv;
$d73b496ea98a0aad$export$36b6d6ef312eab39 = $go6LA.createDecipheriv;
$d73b496ea98a0aad$export$58a258485f1e49f6 = $go6LA.getCiphers;
$d73b496ea98a0aad$export$dedd8dc3dc62b370 = $go6LA.listCiphers;

var $4JeX9 = parcelRequire("4JeX9");
$d73b496ea98a0aad$export$971862a2fcb1bb40 = $4JeX9.DiffieHellmanGroup;
$d73b496ea98a0aad$export$c6ff6a88acbeaf40 = $4JeX9.createDiffieHellmanGroup;
$d73b496ea98a0aad$export$fdc27893e98845cc = $4JeX9.getDiffieHellman;
$d73b496ea98a0aad$export$6671fb9a1323bed = $4JeX9.createDiffieHellman;
$d73b496ea98a0aad$export$d74daf141a551db = $4JeX9.DiffieHellman;

var $4E2yv = parcelRequire("4E2yv");
$d73b496ea98a0aad$export$45df7cae684751af = $4E2yv.createSign;
$d73b496ea98a0aad$export$1db683ad541682f6 = $4E2yv.Sign;
$d73b496ea98a0aad$export$6f65485f87568e37 = $4E2yv.createVerify;
$d73b496ea98a0aad$export$91a8e56769aeb334 = $4E2yv.Verify;

$d73b496ea98a0aad$export$2d4117e99c2179e4 = (parcelRequire("gHlai"));

var $1e6mq = parcelRequire("1e6mq");
$d73b496ea98a0aad$export$512823e338ddb1b7 = $1e6mq.publicEncrypt;
$d73b496ea98a0aad$export$9d0e0c0c4a8d30f3 = $1e6mq.privateEncrypt;
$d73b496ea98a0aad$export$b9d55ff329113abd = $1e6mq.publicDecrypt;
$d73b496ea98a0aad$export$7efb24e2fddf99b9 = $1e6mq.privateDecrypt;

var $kfXIi = parcelRequire("kfXIi");
$d73b496ea98a0aad$export$bb1abf2ce84fc7e8 = $kfXIi.randomFill;
$d73b496ea98a0aad$export$2f7171e78e524d5e = $kfXIi.randomFillSync;
$d73b496ea98a0aad$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$d73b496ea98a0aad$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("4WS9C", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $39a69614c675aab1$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $39a69614c675aab1$var$MAX_UINT32 = 4294967295;
function $39a69614c675aab1$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $jcTxY = parcelRequire("jcTxY");
var $39a69614c675aab1$require$Buffer = $jcTxY.Buffer;
var $39a69614c675aab1$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($39a69614c675aab1$var$crypto && $39a69614c675aab1$var$crypto.getRandomValues) module.exports = $39a69614c675aab1$var$randomBytes;
else module.exports = $39a69614c675aab1$var$oldBrowser;
function $39a69614c675aab1$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $39a69614c675aab1$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $39a69614c675aab1$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $39a69614c675aab1$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $39a69614c675aab1$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $39a69614c675aab1$var$crypto.getRandomValues(bytes.slice(generated, generated + $39a69614c675aab1$var$MAX_BYTES));
        else $39a69614c675aab1$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4Jj9n.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jcTxY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $kFATv = parcelRequire("kFATv");
var $dfba39cd620cd3d7$var$Buffer = $kFATv.Buffer;
// alternative to using Object.keys for old browsers
function $dfba39cd620cd3d7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($dfba39cd620cd3d7$var$Buffer.from && $dfba39cd620cd3d7$var$Buffer.alloc && $dfba39cd620cd3d7$var$Buffer.allocUnsafe && $dfba39cd620cd3d7$var$Buffer.allocUnsafeSlow) module.exports = $kFATv;
else {
    // Copy properties from require('buffer')
    $dfba39cd620cd3d7$var$copyProps($kFATv, module.exports);
    module.exports.Buffer = $dfba39cd620cd3d7$var$SafeBuffer;
}
function $dfba39cd620cd3d7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
}
$dfba39cd620cd3d7$var$SafeBuffer.prototype = Object.create($dfba39cd620cd3d7$var$Buffer.prototype);
// Copy static methods from Buffer
$dfba39cd620cd3d7$var$copyProps($dfba39cd620cd3d7$var$Buffer, $dfba39cd620cd3d7$var$SafeBuffer);
$dfba39cd620cd3d7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
};
$dfba39cd620cd3d7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $dfba39cd620cd3d7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dfba39cd620cd3d7$var$Buffer(size);
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $kFATv.SlowBuffer(size);
};

});
parcelRegister("kFATv", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $f0c4416a745b85a1$export$a143d493d941bafc, (v) => $f0c4416a745b85a1$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $f0c4416a745b85a1$export$e4cf37d7f6fb9e0a, (v) => $f0c4416a745b85a1$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $f0c4416a745b85a1$export$f99ded8fe4b79145, (v) => $f0c4416a745b85a1$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $f0c4416a745b85a1$export$599f31c3813fae4d, (v) => $f0c4416a745b85a1$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f0c4416a745b85a1$export$a143d493d941bafc;
var $f0c4416a745b85a1$export$e4cf37d7f6fb9e0a;
var $f0c4416a745b85a1$export$f99ded8fe4b79145;
var $f0c4416a745b85a1$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
var $f0c4416a745b85a1$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f0c4416a745b85a1$export$a143d493d941bafc = $f0c4416a745b85a1$var$Buffer;
$f0c4416a745b85a1$export$e4cf37d7f6fb9e0a = $f0c4416a745b85a1$var$SlowBuffer;
$f0c4416a745b85a1$export$f99ded8fe4b79145 = 50;
var $f0c4416a745b85a1$var$K_MAX_LENGTH = 0x7fffffff;
$f0c4416a745b85a1$export$599f31c3813fae4d = $f0c4416a745b85a1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f0c4416a745b85a1$var$Buffer.TYPED_ARRAY_SUPPORT = $f0c4416a745b85a1$var$typedArraySupport();
if (!$f0c4416a745b85a1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f0c4416a745b85a1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f0c4416a745b85a1$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f0c4416a745b85a1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f0c4416a745b85a1$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f0c4416a745b85a1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f0c4416a745b85a1$var$createBuffer(length) {
    if (length > $f0c4416a745b85a1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f0c4416a745b85a1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f0c4416a745b85a1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f0c4416a745b85a1$var$allocUnsafe(arg);
    }
    return $f0c4416a745b85a1$var$from(arg, encodingOrOffset, length);
}
$f0c4416a745b85a1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f0c4416a745b85a1$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f0c4416a745b85a1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f0c4416a745b85a1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f0c4416a745b85a1$var$isInstance(value, ArrayBuffer) || value && $f0c4416a745b85a1$var$isInstance(value.buffer, ArrayBuffer)) return $f0c4416a745b85a1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f0c4416a745b85a1$var$isInstance(value, SharedArrayBuffer) || value && $f0c4416a745b85a1$var$isInstance(value.buffer, SharedArrayBuffer))) return $f0c4416a745b85a1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f0c4416a745b85a1$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f0c4416a745b85a1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f0c4416a745b85a1$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f0c4416a745b85a1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f0c4416a745b85a1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f0c4416a745b85a1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f0c4416a745b85a1$var$Buffer, Uint8Array);
function $f0c4416a745b85a1$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f0c4416a745b85a1$var$alloc(size, fill, encoding) {
    $f0c4416a745b85a1$var$assertSize(size);
    if (size <= 0) return $f0c4416a745b85a1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f0c4416a745b85a1$var$createBuffer(size).fill(fill, encoding) : $f0c4416a745b85a1$var$createBuffer(size).fill(fill);
    return $f0c4416a745b85a1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f0c4416a745b85a1$var$Buffer.alloc = function(size, fill, encoding) {
    return $f0c4416a745b85a1$var$alloc(size, fill, encoding);
};
function $f0c4416a745b85a1$var$allocUnsafe(size) {
    $f0c4416a745b85a1$var$assertSize(size);
    return $f0c4416a745b85a1$var$createBuffer(size < 0 ? 0 : $f0c4416a745b85a1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f0c4416a745b85a1$var$Buffer.allocUnsafe = function(size) {
    return $f0c4416a745b85a1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f0c4416a745b85a1$var$Buffer.allocUnsafeSlow = function(size) {
    return $f0c4416a745b85a1$var$allocUnsafe(size);
};
function $f0c4416a745b85a1$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f0c4416a745b85a1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f0c4416a745b85a1$var$byteLength(string, encoding) | 0;
    var buf = $f0c4416a745b85a1$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f0c4416a745b85a1$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f0c4416a745b85a1$var$checked(array.length) | 0;
    var buf = $f0c4416a745b85a1$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f0c4416a745b85a1$var$fromArrayView(arrayView) {
    if ($f0c4416a745b85a1$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f0c4416a745b85a1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f0c4416a745b85a1$var$fromArrayLike(arrayView);
}
function $f0c4416a745b85a1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f0c4416a745b85a1$var$Buffer.prototype);
    return buf;
}
function $f0c4416a745b85a1$var$fromObject(obj) {
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(obj)) {
        var len = $f0c4416a745b85a1$var$checked(obj.length) | 0;
        var buf = $f0c4416a745b85a1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f0c4416a745b85a1$var$numberIsNaN(obj.length)) return $f0c4416a745b85a1$var$createBuffer(0);
        return $f0c4416a745b85a1$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f0c4416a745b85a1$var$fromArrayLike(obj.data);
}
function $f0c4416a745b85a1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f0c4416a745b85a1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f0c4416a745b85a1$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f0c4416a745b85a1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f0c4416a745b85a1$var$Buffer.alloc(+length);
}
$f0c4416a745b85a1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f0c4416a745b85a1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f0c4416a745b85a1$var$Buffer.compare = function compare(a, b) {
    if ($f0c4416a745b85a1$var$isInstance(a, Uint8Array)) a = $f0c4416a745b85a1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f0c4416a745b85a1$var$isInstance(b, Uint8Array)) b = $f0c4416a745b85a1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(a) || !$f0c4416a745b85a1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f0c4416a745b85a1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f0c4416a745b85a1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f0c4416a745b85a1$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f0c4416a745b85a1$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f0c4416a745b85a1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $f0c4416a745b85a1$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f0c4416a745b85a1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f0c4416a745b85a1$var$byteLength(string, encoding) {
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f0c4416a745b85a1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f0c4416a745b85a1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f0c4416a745b85a1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f0c4416a745b85a1$var$Buffer.byteLength = $f0c4416a745b85a1$var$byteLength;
function $f0c4416a745b85a1$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f0c4416a745b85a1$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f0c4416a745b85a1$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f0c4416a745b85a1$var$latin1Slice(this, start, end);
        case 'base64':
            return $f0c4416a745b85a1$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f0c4416a745b85a1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f0c4416a745b85a1$var$Buffer.prototype._isBuffer = true;
function $f0c4416a745b85a1$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f0c4416a745b85a1$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f0c4416a745b85a1$var$swap(this, i, i + 1);
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f0c4416a745b85a1$var$swap(this, i, i + 3);
        $f0c4416a745b85a1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f0c4416a745b85a1$var$swap(this, i, i + 7);
        $f0c4416a745b85a1$var$swap(this, i + 1, i + 6);
        $f0c4416a745b85a1$var$swap(this, i + 2, i + 5);
        $f0c4416a745b85a1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f0c4416a745b85a1$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f0c4416a745b85a1$var$utf8Slice(this, 0, length);
    return $f0c4416a745b85a1$var$slowToString.apply(this, arguments);
};
$f0c4416a745b85a1$var$Buffer.prototype.toLocaleString = $f0c4416a745b85a1$var$Buffer.prototype.toString;
$f0c4416a745b85a1$var$Buffer.prototype.equals = function equals(b) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f0c4416a745b85a1$var$Buffer.compare(this, b) === 0;
};
$f0c4416a745b85a1$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f0c4416a745b85a1$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f0c4416a745b85a1$var$customInspectSymbol) $f0c4416a745b85a1$var$Buffer.prototype[$f0c4416a745b85a1$var$customInspectSymbol] = $f0c4416a745b85a1$var$Buffer.prototype.inspect;
$f0c4416a745b85a1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f0c4416a745b85a1$var$isInstance(target, Uint8Array)) target = $f0c4416a745b85a1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f0c4416a745b85a1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f0c4416a745b85a1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f0c4416a745b85a1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f0c4416a745b85a1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f0c4416a745b85a1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f0c4416a745b85a1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f0c4416a745b85a1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f0c4416a745b85a1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f0c4416a745b85a1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f0c4416a745b85a1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f0c4416a745b85a1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f0c4416a745b85a1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f0c4416a745b85a1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f0c4416a745b85a1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f0c4416a745b85a1$var$utf8Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f0c4416a745b85a1$var$asciiWrite(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$asciiToBytes(string), buf, offset, length);
}
function $f0c4416a745b85a1$var$base64Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$base64ToBytes(string), buf, offset, length);
}
function $f0c4416a745b85a1$var$ucs2Write(buf, string, offset, length) {
    return $f0c4416a745b85a1$var$blitBuffer($f0c4416a745b85a1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f0c4416a745b85a1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f0c4416a745b85a1$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f0c4416a745b85a1$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f0c4416a745b85a1$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f0c4416a745b85a1$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f0c4416a745b85a1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f0c4416a745b85a1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f0c4416a745b85a1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $f0c4416a745b85a1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f0c4416a745b85a1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f0c4416a745b85a1$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f0c4416a745b85a1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f0c4416a745b85a1$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f0c4416a745b85a1$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f0c4416a745b85a1$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f0c4416a745b85a1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f0c4416a745b85a1$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f0c4416a745b85a1$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f0c4416a745b85a1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f0c4416a745b85a1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f0c4416a745b85a1$var$Buffer.prototype.readUintLE = $f0c4416a745b85a1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUintBE = $f0c4416a745b85a1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint8 = $f0c4416a745b85a1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint16LE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint16BE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint32LE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f0c4416a745b85a1$var$Buffer.prototype.readUint32BE = $f0c4416a745b85a1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f0c4416a745b85a1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f0c4416a745b85a1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f0c4416a745b85a1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$f0c4416a745b85a1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$f0c4416a745b85a1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$f0c4416a745b85a1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $f0c4416a745b85a1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f0c4416a745b85a1$var$Buffer.prototype.writeUintLE = $f0c4416a745b85a1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUintBE = $f0c4416a745b85a1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint8 = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint16LE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint16BE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint32LE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeUint32BE = $f0c4416a745b85a1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f0c4416a745b85a1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f0c4416a745b85a1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f0c4416a745b85a1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f0c4416a745b85a1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeFloat(this, value, offset, true, noAssert);
};
$f0c4416a745b85a1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeFloat(this, value, offset, false, noAssert);
};
function $f0c4416a745b85a1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0c4416a745b85a1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f0c4416a745b85a1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeDouble(this, value, offset, true, noAssert);
};
$f0c4416a745b85a1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f0c4416a745b85a1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f0c4416a745b85a1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f0c4416a745b85a1$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f0c4416a745b85a1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f0c4416a745b85a1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f0c4416a745b85a1$var$Buffer.isBuffer(val) ? val : $f0c4416a745b85a1$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $f0c4416a745b85a1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f0c4416a745b85a1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f0c4416a745b85a1$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f0c4416a745b85a1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f0c4416a745b85a1$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f0c4416a745b85a1$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f0c4416a745b85a1$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($f0c4416a745b85a1$var$base64clean(str));
}
function $f0c4416a745b85a1$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f0c4416a745b85a1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f0c4416a745b85a1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f0c4416a745b85a1$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("7TQd3", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $gxyGg = parcelRequire("gxyGg");

var $ggr8j = parcelRequire("ggr8j");

var $gGO1L = parcelRequire("gGO1L");

var $hp0y4 = parcelRequire("hp0y4");
function $5c062b363e460261$var$Hash(hash) {
    $hp0y4.call(this, 'digest');
    this._hash = hash;
}
$9YOog($5c062b363e460261$var$Hash, $hp0y4);
$5c062b363e460261$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$5c062b363e460261$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $gxyGg();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $ggr8j();
    return new $5c062b363e460261$var$Hash($gGO1L(alg));
};

});
parcelRegister("9YOog", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("gxyGg", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $l3AJp = parcelRequire("l3AJp");

var $jcTxY = parcelRequire("jcTxY");
var $c0aaa14728394110$require$Buffer = $jcTxY.Buffer;
var $c0aaa14728394110$var$ARRAY16 = new Array(16);
function $c0aaa14728394110$var$MD5() {
    $l3AJp.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$9YOog($c0aaa14728394110$var$MD5, $l3AJp);
$c0aaa14728394110$var$MD5.prototype._update = function() {
    var M = $c0aaa14728394110$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $c0aaa14728394110$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $c0aaa14728394110$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $c0aaa14728394110$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $c0aaa14728394110$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $c0aaa14728394110$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $c0aaa14728394110$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $c0aaa14728394110$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $c0aaa14728394110$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $c0aaa14728394110$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $c0aaa14728394110$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $c0aaa14728394110$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $c0aaa14728394110$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $c0aaa14728394110$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $c0aaa14728394110$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $c0aaa14728394110$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $c0aaa14728394110$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $c0aaa14728394110$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $c0aaa14728394110$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $c0aaa14728394110$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $c0aaa14728394110$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $c0aaa14728394110$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $c0aaa14728394110$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $c0aaa14728394110$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $c0aaa14728394110$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $c0aaa14728394110$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $c0aaa14728394110$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $c0aaa14728394110$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $c0aaa14728394110$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $c0aaa14728394110$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $c0aaa14728394110$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $c0aaa14728394110$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $c0aaa14728394110$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $c0aaa14728394110$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $c0aaa14728394110$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $c0aaa14728394110$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $c0aaa14728394110$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $c0aaa14728394110$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $c0aaa14728394110$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $c0aaa14728394110$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $c0aaa14728394110$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $c0aaa14728394110$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $c0aaa14728394110$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $c0aaa14728394110$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $c0aaa14728394110$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $c0aaa14728394110$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $c0aaa14728394110$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $c0aaa14728394110$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $c0aaa14728394110$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $c0aaa14728394110$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $c0aaa14728394110$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $c0aaa14728394110$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $c0aaa14728394110$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $c0aaa14728394110$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $c0aaa14728394110$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $c0aaa14728394110$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $c0aaa14728394110$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $c0aaa14728394110$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $c0aaa14728394110$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $c0aaa14728394110$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $c0aaa14728394110$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $c0aaa14728394110$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $c0aaa14728394110$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $c0aaa14728394110$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $c0aaa14728394110$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$c0aaa14728394110$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $c0aaa14728394110$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $c0aaa14728394110$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $c0aaa14728394110$var$fnF(a, b, c, d, m, k, s) {
    return $c0aaa14728394110$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $c0aaa14728394110$var$fnG(a, b, c, d, m, k, s) {
    return $c0aaa14728394110$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $c0aaa14728394110$var$fnH(a, b, c, d, m, k, s) {
    return $c0aaa14728394110$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $c0aaa14728394110$var$fnI(a, b, c, d, m, k, s) {
    return $c0aaa14728394110$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $c0aaa14728394110$var$MD5;

});
parcelRegister("l3AJp", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $f5465edfaee91e7d$require$Buffer = $jcTxY.Buffer;

var $jssge = parcelRequire("jssge");
var $f5465edfaee91e7d$require$Transform = $jssge.Transform;

var $9YOog = parcelRequire("9YOog");
function $f5465edfaee91e7d$var$HashBase(blockSize) {
    $f5465edfaee91e7d$require$Transform.call(this);
    this._block = $f5465edfaee91e7d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$9YOog($f5465edfaee91e7d$var$HashBase, $f5465edfaee91e7d$require$Transform);
$f5465edfaee91e7d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$f5465edfaee91e7d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $f5465edfaee91e7d$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $f5465edfaee91e7d$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($f5465edfaee91e7d$require$Buffer.prototype instanceof Uint8Array || $f5465edfaee91e7d$require$Buffer.TYPED_ARRAY_SUPPORT);
function $f5465edfaee91e7d$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $f5465edfaee91e7d$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $f5465edfaee91e7d$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($f5465edfaee91e7d$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $f5465edfaee91e7d$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $f5465edfaee91e7d$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($f5465edfaee91e7d$var$useUint8Array && data instanceof Uint8Array) return $f5465edfaee91e7d$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($f5465edfaee91e7d$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $f5465edfaee91e7d$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$f5465edfaee91e7d$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $f5465edfaee91e7d$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$f5465edfaee91e7d$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$f5465edfaee91e7d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$f5465edfaee91e7d$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $f5465edfaee91e7d$var$HashBase;

});
parcelRegister("jssge", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $e2a68dd7b8e7177c$var$Stream;

var $9KgKE = parcelRequire("9KgKE");
var $e2a68dd7b8e7177c$require$EE = $9KgKE.EventEmitter;

var $9YOog = parcelRequire("9YOog");
$9YOog($e2a68dd7b8e7177c$var$Stream, $e2a68dd7b8e7177c$require$EE);

$e2a68dd7b8e7177c$var$Stream.Readable = (parcelRequire("ljYrj"));

$e2a68dd7b8e7177c$var$Stream.Writable = (parcelRequire("eAzUD"));

$e2a68dd7b8e7177c$var$Stream.Duplex = (parcelRequire("5PuTj"));

$e2a68dd7b8e7177c$var$Stream.Transform = (parcelRequire("9Pily"));

$e2a68dd7b8e7177c$var$Stream.PassThrough = (parcelRequire("euhdJ"));

$e2a68dd7b8e7177c$var$Stream.finished = (parcelRequire("iMJxh"));

$e2a68dd7b8e7177c$var$Stream.pipeline = (parcelRequire("atWzg"));
// Backwards-compat with node 0.4.x
$e2a68dd7b8e7177c$var$Stream.Stream = $e2a68dd7b8e7177c$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $e2a68dd7b8e7177c$var$Stream() {
    $e2a68dd7b8e7177c$require$EE.call(this);
}
$e2a68dd7b8e7177c$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e2a68dd7b8e7177c$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("9KgKE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $7185676dc7ed1f58$var$R = typeof Reflect === 'object' ? Reflect : null;
var $7185676dc7ed1f58$var$ReflectApply = $7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.apply === 'function' ? $7185676dc7ed1f58$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $7185676dc7ed1f58$var$ReflectOwnKeys;
if ($7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.ownKeys === 'function') $7185676dc7ed1f58$var$ReflectOwnKeys = $7185676dc7ed1f58$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $7185676dc7ed1f58$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $7185676dc7ed1f58$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $7185676dc7ed1f58$var$EventEmitter() {
    $7185676dc7ed1f58$var$EventEmitter.init.call(this);
}
module.exports = $7185676dc7ed1f58$var$EventEmitter;
module.exports.once = $7185676dc7ed1f58$var$once;
// Backwards-compat with node 0.10.x
$7185676dc7ed1f58$var$EventEmitter.EventEmitter = $7185676dc7ed1f58$var$EventEmitter;
$7185676dc7ed1f58$var$EventEmitter.prototype._events = undefined;
$7185676dc7ed1f58$var$EventEmitter.prototype._eventsCount = 0;
$7185676dc7ed1f58$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $7185676dc7ed1f58$var$defaultMaxListeners = 10;
function $7185676dc7ed1f58$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($7185676dc7ed1f58$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $7185676dc7ed1f58$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $7185676dc7ed1f58$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $7185676dc7ed1f58$var$defaultMaxListeners = arg;
    }
});
$7185676dc7ed1f58$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$7185676dc7ed1f58$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $7185676dc7ed1f58$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $7185676dc7ed1f58$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $7185676dc7ed1f58$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $7185676dc7ed1f58$var$_getMaxListeners(this);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $7185676dc7ed1f58$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $7185676dc7ed1f58$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$7185676dc7ed1f58$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $7185676dc7ed1f58$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $7185676dc7ed1f58$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $7185676dc7ed1f58$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, false);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.on = $7185676dc7ed1f58$var$EventEmitter.prototype.addListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, true);
};
function $7185676dc7ed1f58$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $7185676dc7ed1f58$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $7185676dc7ed1f58$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.once = function once(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.on(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.prependListener(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$7185676dc7ed1f58$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $7185676dc7ed1f58$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.off = $7185676dc7ed1f58$var$EventEmitter.prototype.removeListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $7185676dc7ed1f58$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $7185676dc7ed1f58$var$unwrapListeners(evlistener) : $7185676dc7ed1f58$var$arrayClone(evlistener, evlistener.length);
}
$7185676dc7ed1f58$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, true);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, false);
};
$7185676dc7ed1f58$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $7185676dc7ed1f58$var$listenerCount.call(emitter, type);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.listenerCount = $7185676dc7ed1f58$var$listenerCount;
function $7185676dc7ed1f58$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $7185676dc7ed1f58$var$ReflectOwnKeys(this._events) : [];
};
function $7185676dc7ed1f58$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $7185676dc7ed1f58$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $7185676dc7ed1f58$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $7185676dc7ed1f58$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("ljYrj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
module.exports = $f85a4157ed2cb813$var$Readable;
/*<replacement>*/ var $f85a4157ed2cb813$var$Duplex;
/*</replacement>*/ $f85a4157ed2cb813$var$Readable.ReadableState = $f85a4157ed2cb813$var$ReadableState;

var $9KgKE = parcelRequire("9KgKE");
var $f85a4157ed2cb813$require$EE = $9KgKE.EventEmitter;
var $f85a4157ed2cb813$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $3OcAH = parcelRequire("3OcAH");

var $kFATv = parcelRequire("kFATv");
var $f85a4157ed2cb813$require$Buffer = $kFATv.Buffer;
var $f85a4157ed2cb813$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f85a4157ed2cb813$var$_uint8ArrayToBuffer(chunk) {
    return $f85a4157ed2cb813$require$Buffer.from(chunk);
}
function $f85a4157ed2cb813$var$_isUint8Array(obj) {
    return $f85a4157ed2cb813$require$Buffer.isBuffer(obj) || obj instanceof $f85a4157ed2cb813$var$OurUint8Array;
}

var $1frus = parcelRequire("1frus");
var $f85a4157ed2cb813$var$debug;
if ($1frus && $1frus.debuglog) $f85a4157ed2cb813$var$debug = $1frus.debuglog('stream');
else $f85a4157ed2cb813$var$debug = function debug() {};

var $dOyg8 = parcelRequire("dOyg8");

var $bEUDG = parcelRequire("bEUDG");

var $1NzB0 = parcelRequire("1NzB0");
var $f85a4157ed2cb813$var$getHighWaterMark = $1NzB0.getHighWaterMark;

var $aQfo6 = parcelRequire("aQfo6");
var $f85a4157ed2cb813$require$_require$codes = $aQfo6.codes;
var $f85a4157ed2cb813$var$ERR_INVALID_ARG_TYPE = $f85a4157ed2cb813$require$_require$codes.ERR_INVALID_ARG_TYPE, $f85a4157ed2cb813$var$ERR_STREAM_PUSH_AFTER_EOF = $f85a4157ed2cb813$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $f85a4157ed2cb813$var$ERR_METHOD_NOT_IMPLEMENTED = $f85a4157ed2cb813$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f85a4157ed2cb813$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $f85a4157ed2cb813$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $f85a4157ed2cb813$var$StringDecoder;
var $f85a4157ed2cb813$var$createReadableStreamAsyncIterator;
var $f85a4157ed2cb813$var$from;

(parcelRequire("9YOog"))($f85a4157ed2cb813$var$Readable, $3OcAH);
var $f85a4157ed2cb813$var$errorOrDestroy = $bEUDG.errorOrDestroy;
var $f85a4157ed2cb813$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $f85a4157ed2cb813$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $f85a4157ed2cb813$var$ReadableState(options, stream, isDuplex) {
    $f85a4157ed2cb813$var$Duplex = $f85a4157ed2cb813$var$Duplex || (parcelRequire("5PuTj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f85a4157ed2cb813$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $f85a4157ed2cb813$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $dOyg8();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$f85a4157ed2cb813$var$StringDecoder) $f85a4157ed2cb813$var$StringDecoder = (parcelRequire("fr8tb")).StringDecoder;
        this.decoder = new $f85a4157ed2cb813$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f85a4157ed2cb813$var$Readable(options) {
    $f85a4157ed2cb813$var$Duplex = $f85a4157ed2cb813$var$Duplex || (parcelRequire("5PuTj"));
    if (!(this instanceof $f85a4157ed2cb813$var$Readable)) return new $f85a4157ed2cb813$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f85a4157ed2cb813$var$Duplex;
    this._readableState = new $f85a4157ed2cb813$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $3OcAH.call(this);
}
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$f85a4157ed2cb813$var$Readable.prototype.destroy = $bEUDG.destroy;
$f85a4157ed2cb813$var$Readable.prototype._undestroy = $bEUDG.undestroy;
$f85a4157ed2cb813$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f85a4157ed2cb813$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $f85a4157ed2cb813$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $f85a4157ed2cb813$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$f85a4157ed2cb813$var$Readable.prototype.unshift = function(chunk) {
    return $f85a4157ed2cb813$var$readableAddChunk(this, chunk, null, true, false);
};
function $f85a4157ed2cb813$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $f85a4157ed2cb813$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $f85a4157ed2cb813$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $f85a4157ed2cb813$var$chunkInvalid(state, chunk);
        if (er) $f85a4157ed2cb813$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $f85a4157ed2cb813$require$Buffer.prototype) chunk = $f85a4157ed2cb813$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $f85a4157ed2cb813$var$errorOrDestroy(stream, new $f85a4157ed2cb813$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $f85a4157ed2cb813$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $f85a4157ed2cb813$var$errorOrDestroy(stream, new $f85a4157ed2cb813$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $f85a4157ed2cb813$var$addChunk(stream, state, chunk, false);
                    else $f85a4157ed2cb813$var$maybeReadMore(stream, state);
                } else $f85a4157ed2cb813$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $f85a4157ed2cb813$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $f85a4157ed2cb813$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $f85a4157ed2cb813$var$emitReadable(stream);
    }
    $f85a4157ed2cb813$var$maybeReadMore(stream, state);
}
function $f85a4157ed2cb813$var$chunkInvalid(state, chunk) {
    var er;
    if (!$f85a4157ed2cb813$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $f85a4157ed2cb813$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$f85a4157ed2cb813$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$f85a4157ed2cb813$var$Readable.prototype.setEncoding = function(enc) {
    if (!$f85a4157ed2cb813$var$StringDecoder) $f85a4157ed2cb813$var$StringDecoder = (parcelRequire("fr8tb")).StringDecoder;
    var decoder = new $f85a4157ed2cb813$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $f85a4157ed2cb813$var$MAX_HWM = 0x40000000;
function $f85a4157ed2cb813$var$computeNewHighWaterMark(n) {
    if (n >= $f85a4157ed2cb813$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $f85a4157ed2cb813$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f85a4157ed2cb813$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f85a4157ed2cb813$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$f85a4157ed2cb813$var$Readable.prototype.read = function(n) {
    $f85a4157ed2cb813$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $f85a4157ed2cb813$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f85a4157ed2cb813$var$endReadable(this);
        else $f85a4157ed2cb813$var$emitReadable(this);
        return null;
    }
    n = $f85a4157ed2cb813$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f85a4157ed2cb813$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $f85a4157ed2cb813$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f85a4157ed2cb813$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $f85a4157ed2cb813$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $f85a4157ed2cb813$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f85a4157ed2cb813$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $f85a4157ed2cb813$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f85a4157ed2cb813$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $f85a4157ed2cb813$var$onEofChunk(stream, state) {
    $f85a4157ed2cb813$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $f85a4157ed2cb813$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $f85a4157ed2cb813$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f85a4157ed2cb813$var$emitReadable(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f85a4157ed2cb813$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$emitReadable_, stream);
    }
}
function $f85a4157ed2cb813$var$emitReadable_(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $f85a4157ed2cb813$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f85a4157ed2cb813$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$maybeReadMore_, stream, state);
    }
}
function $f85a4157ed2cb813$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $f85a4157ed2cb813$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f85a4157ed2cb813$var$Readable.prototype._read = function(n) {
    $f85a4157ed2cb813$var$errorOrDestroy(this, new $f85a4157ed2cb813$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$f85a4157ed2cb813$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $f85a4157ed2cb813$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4Jj9n.stdout && dest !== $4Jj9n.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4Jj9n.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f85a4157ed2cb813$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f85a4157ed2cb813$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $f85a4157ed2cb813$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $f85a4157ed2cb813$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $f85a4157ed2cb813$var$debug('ondata');
        var ret = dest.write(chunk);
        $f85a4157ed2cb813$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $f85a4157ed2cb813$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $f85a4157ed2cb813$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f85a4157ed2cb813$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($f85a4157ed2cb813$var$EElistenerCount(dest, 'error') === 0) $f85a4157ed2cb813$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $f85a4157ed2cb813$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f85a4157ed2cb813$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f85a4157ed2cb813$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $f85a4157ed2cb813$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f85a4157ed2cb813$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $f85a4157ed2cb813$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $f85a4157ed2cb813$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $f85a4157ed2cb813$var$flow(src);
        }
    };
}
$f85a4157ed2cb813$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $f85a4157ed2cb813$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$f85a4157ed2cb813$var$Readable.prototype.on = function(ev, fn) {
    var res = $3OcAH.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $f85a4157ed2cb813$var$debug('on readable', state.length, state.reading);
            if (state.length) $f85a4157ed2cb813$var$emitReadable(this);
            else if (!state.reading) $4Jj9n.nextTick($f85a4157ed2cb813$var$nReadingNextTick, this);
        }
    }
    return res;
};
$f85a4157ed2cb813$var$Readable.prototype.addListener = $f85a4157ed2cb813$var$Readable.prototype.on;
$f85a4157ed2cb813$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $3OcAH.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4Jj9n.nextTick($f85a4157ed2cb813$var$updateReadableListening, this);
    return res;
};
$f85a4157ed2cb813$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $3OcAH.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4Jj9n.nextTick($f85a4157ed2cb813$var$updateReadableListening, this);
    return res;
};
function $f85a4157ed2cb813$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $f85a4157ed2cb813$var$nReadingNextTick(self1) {
    $f85a4157ed2cb813$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f85a4157ed2cb813$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $f85a4157ed2cb813$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $f85a4157ed2cb813$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $f85a4157ed2cb813$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$resume_, stream, state);
    }
}
function $f85a4157ed2cb813$var$resume_(stream, state) {
    $f85a4157ed2cb813$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $f85a4157ed2cb813$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f85a4157ed2cb813$var$Readable.prototype.pause = function() {
    $f85a4157ed2cb813$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $f85a4157ed2cb813$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $f85a4157ed2cb813$var$flow(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f85a4157ed2cb813$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $f85a4157ed2cb813$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $f85a4157ed2cb813$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $f85a4157ed2cb813$var$kProxyEvents.length; n++)stream.on($f85a4157ed2cb813$var$kProxyEvents[n], this.emit.bind(this, $f85a4157ed2cb813$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $f85a4157ed2cb813$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $f85a4157ed2cb813$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($f85a4157ed2cb813$var$createReadableStreamAsyncIterator === undefined) $f85a4157ed2cb813$var$createReadableStreamAsyncIterator = (parcelRequire("g3g84"));
    return $f85a4157ed2cb813$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$f85a4157ed2cb813$var$Readable._fromList = $f85a4157ed2cb813$var$fromList;
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f85a4157ed2cb813$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $f85a4157ed2cb813$var$endReadable(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$endReadableNT, state, stream);
    }
}
function $f85a4157ed2cb813$var$endReadableNT(state, stream) {
    $f85a4157ed2cb813$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $f85a4157ed2cb813$var$Readable.from = function(iterable, opts) {
    if ($f85a4157ed2cb813$var$from === undefined) $f85a4157ed2cb813$var$from = (parcelRequire("fOGyj"));
    return $f85a4157ed2cb813$var$from($f85a4157ed2cb813$var$Readable, iterable, opts);
};
function $f85a4157ed2cb813$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("3OcAH", function(module, exports) {

module.exports = (parcelRequire("9KgKE")).EventEmitter;

});

parcelRegister("1frus", function(module, exports) {
"use strict";

});

parcelRegister("dOyg8", function(module, exports) {
'use strict';
function $a0ea850bae912876$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0ea850bae912876$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a0ea850bae912876$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a0ea850bae912876$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a0ea850bae912876$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0ea850bae912876$var$_defineProperty(obj, key, value) {
    key = $a0ea850bae912876$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0ea850bae912876$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ea850bae912876$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a0ea850bae912876$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a0ea850bae912876$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a0ea850bae912876$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a0ea850bae912876$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a0ea850bae912876$var$_toPropertyKey(arg) {
    var key = $a0ea850bae912876$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a0ea850bae912876$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $kFATv = parcelRequire("kFATv");
var $a0ea850bae912876$var$Buffer = $kFATv.Buffer;

var $1frus = parcelRequire("1frus");
var $a0ea850bae912876$var$inspect = $1frus.inspect;
var $a0ea850bae912876$var$custom = $a0ea850bae912876$var$inspect && $a0ea850bae912876$var$inspect.custom || 'inspect';
function $a0ea850bae912876$var$copyBuffer(src, target, offset) {
    $a0ea850bae912876$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $a0ea850bae912876$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $a0ea850bae912876$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $a0ea850bae912876$var$Buffer.alloc(0);
                var ret = $a0ea850bae912876$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $a0ea850bae912876$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $a0ea850bae912876$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $a0ea850bae912876$var$custom,
            value: function value(_, options) {
                return $a0ea850bae912876$var$inspect(this, $a0ea850bae912876$var$_objectSpread($a0ea850bae912876$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("bEUDG", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $87cf5d73f27e2302$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorAndCloseNT, _this, err);
            } else $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
        } else if (cb) {
            $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
            cb(err);
        } else $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
    });
    return this;
}
function $87cf5d73f27e2302$var$emitErrorAndCloseNT(self, err) {
    $87cf5d73f27e2302$var$emitErrorNT(self, err);
    $87cf5d73f27e2302$var$emitCloseNT(self);
}
function $87cf5d73f27e2302$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $87cf5d73f27e2302$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $87cf5d73f27e2302$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $87cf5d73f27e2302$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $87cf5d73f27e2302$var$destroy,
    undestroy: $87cf5d73f27e2302$var$undestroy,
    errorOrDestroy: $87cf5d73f27e2302$var$errorOrDestroy
};

});

parcelRegister("1NzB0", function(module, exports) {
'use strict';

var $14f5faa8afc5e2c0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("aQfo6")).codes.ERR_INVALID_OPT_VALUE;
function $14f5faa8afc5e2c0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $14f5faa8afc5e2c0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $14f5faa8afc5e2c0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $14f5faa8afc5e2c0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $14f5faa8afc5e2c0$var$getHighWaterMark
};

});
parcelRegister("aQfo6", function(module, exports) {

$parcel$export(module.exports, "codes", () => $7e4ab26389ebdc06$export$e45cb6485273080e, (v) => $7e4ab26389ebdc06$export$e45cb6485273080e = v);
var $7e4ab26389ebdc06$export$e45cb6485273080e;
'use strict';
function $7e4ab26389ebdc06$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7e4ab26389ebdc06$var$codes = {};
function $7e4ab26389ebdc06$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7e4ab26389ebdc06$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $7e4ab26389ebdc06$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7e4ab26389ebdc06$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7e4ab26389ebdc06$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7e4ab26389ebdc06$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7e4ab26389ebdc06$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7e4ab26389ebdc06$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7e4ab26389ebdc06$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7e4ab26389ebdc06$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7e4ab26389ebdc06$var$oneOf(expected, 'type'));
    else {
        var type = $7e4ab26389ebdc06$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7e4ab26389ebdc06$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$7e4ab26389ebdc06$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$7e4ab26389ebdc06$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$7e4ab26389ebdc06$export$e45cb6485273080e = $7e4ab26389ebdc06$var$codes;

});


parcelRegister("5PuTj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
/*<replacement>*/ var $43e9ad818277d33b$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $43e9ad818277d33b$var$Duplex;

var $ljYrj = parcelRequire("ljYrj");

var $eAzUD = parcelRequire("eAzUD");

(parcelRequire("9YOog"))($43e9ad818277d33b$var$Duplex, $ljYrj);
// Allow the keys array to be GC'ed.
var $43e9ad818277d33b$var$keys = $43e9ad818277d33b$var$objectKeys($eAzUD.prototype);
for(var $43e9ad818277d33b$var$v = 0; $43e9ad818277d33b$var$v < $43e9ad818277d33b$var$keys.length; $43e9ad818277d33b$var$v++){
    var $43e9ad818277d33b$var$method = $43e9ad818277d33b$var$keys[$43e9ad818277d33b$var$v];
    if (!$43e9ad818277d33b$var$Duplex.prototype[$43e9ad818277d33b$var$method]) $43e9ad818277d33b$var$Duplex.prototype[$43e9ad818277d33b$var$method] = $eAzUD.prototype[$43e9ad818277d33b$var$method];
}
function $43e9ad818277d33b$var$Duplex(options) {
    if (!(this instanceof $43e9ad818277d33b$var$Duplex)) return new $43e9ad818277d33b$var$Duplex(options);
    $ljYrj.call(this, options);
    $eAzUD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $43e9ad818277d33b$var$onend);
        }
    }
}
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $43e9ad818277d33b$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4Jj9n.nextTick($43e9ad818277d33b$var$onEndNT, this);
}
function $43e9ad818277d33b$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("eAzUD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
module.exports = $a9f048f123b6579e$var$Writable;
/* <replacement> */ function $a9f048f123b6579e$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $a9f048f123b6579e$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $a9f048f123b6579e$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $a9f048f123b6579e$var$Duplex;
/*</replacement>*/ $a9f048f123b6579e$var$Writable.WritableState = $a9f048f123b6579e$var$WritableState;

/*<replacement>*/ var $a9f048f123b6579e$var$internalUtil = {
    deprecate: (parcelRequire("hh1jD"))
};

var $3OcAH = parcelRequire("3OcAH");

var $kFATv = parcelRequire("kFATv");
var $a9f048f123b6579e$require$Buffer = $kFATv.Buffer;
var $a9f048f123b6579e$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $a9f048f123b6579e$var$_uint8ArrayToBuffer(chunk) {
    return $a9f048f123b6579e$require$Buffer.from(chunk);
}
function $a9f048f123b6579e$var$_isUint8Array(obj) {
    return $a9f048f123b6579e$require$Buffer.isBuffer(obj) || obj instanceof $a9f048f123b6579e$var$OurUint8Array;
}

var $bEUDG = parcelRequire("bEUDG");

var $1NzB0 = parcelRequire("1NzB0");
var $a9f048f123b6579e$var$getHighWaterMark = $1NzB0.getHighWaterMark;

var $aQfo6 = parcelRequire("aQfo6");
var $a9f048f123b6579e$require$_require$codes = $aQfo6.codes;
var $a9f048f123b6579e$var$ERR_INVALID_ARG_TYPE = $a9f048f123b6579e$require$_require$codes.ERR_INVALID_ARG_TYPE, $a9f048f123b6579e$var$ERR_METHOD_NOT_IMPLEMENTED = $a9f048f123b6579e$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a9f048f123b6579e$var$ERR_MULTIPLE_CALLBACK = $a9f048f123b6579e$require$_require$codes.ERR_MULTIPLE_CALLBACK, $a9f048f123b6579e$var$ERR_STREAM_CANNOT_PIPE = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $a9f048f123b6579e$var$ERR_STREAM_DESTROYED = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_DESTROYED, $a9f048f123b6579e$var$ERR_STREAM_NULL_VALUES = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_NULL_VALUES, $a9f048f123b6579e$var$ERR_STREAM_WRITE_AFTER_END = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $a9f048f123b6579e$var$ERR_UNKNOWN_ENCODING = $a9f048f123b6579e$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $a9f048f123b6579e$var$errorOrDestroy = $bEUDG.errorOrDestroy;

(parcelRequire("9YOog"))($a9f048f123b6579e$var$Writable, $3OcAH);
function $a9f048f123b6579e$var$nop() {}

function $a9f048f123b6579e$var$WritableState(options, stream, isDuplex) {
    $a9f048f123b6579e$var$Duplex = $a9f048f123b6579e$var$Duplex || (parcelRequire("5PuTj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $a9f048f123b6579e$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $a9f048f123b6579e$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $a9f048f123b6579e$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $a9f048f123b6579e$var$CorkedRequest(this);
}
$a9f048f123b6579e$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($a9f048f123b6579e$var$WritableState.prototype, 'buffer', {
            get: $a9f048f123b6579e$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $a9f048f123b6579e$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $a9f048f123b6579e$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($a9f048f123b6579e$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($a9f048f123b6579e$var$realHasInstance.call(this, object)) return true;
            if (this !== $a9f048f123b6579e$var$Writable) return false;
            return object && object._writableState instanceof $a9f048f123b6579e$var$WritableState;
        }
    });
} else $a9f048f123b6579e$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $a9f048f123b6579e$var$Writable(options) {
    $a9f048f123b6579e$var$Duplex = $a9f048f123b6579e$var$Duplex || (parcelRequire("5PuTj"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $a9f048f123b6579e$var$Duplex;
    if (!isDuplex && !$a9f048f123b6579e$var$realHasInstance.call($a9f048f123b6579e$var$Writable, this)) return new $a9f048f123b6579e$var$Writable(options);
    this._writableState = new $a9f048f123b6579e$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $3OcAH.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$a9f048f123b6579e$var$Writable.prototype.pipe = function() {
    $a9f048f123b6579e$var$errorOrDestroy(this, new $a9f048f123b6579e$var$ERR_STREAM_CANNOT_PIPE());
};
function $a9f048f123b6579e$var$writeAfterEnd(stream, cb) {
    var er = new $a9f048f123b6579e$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $a9f048f123b6579e$var$errorOrDestroy(stream, er);
    $4Jj9n.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $a9f048f123b6579e$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $a9f048f123b6579e$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $a9f048f123b6579e$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
        $4Jj9n.nextTick(cb, er);
        return false;
    }
    return true;
}
$a9f048f123b6579e$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $a9f048f123b6579e$var$_isUint8Array(chunk);
    if (isBuf && !$a9f048f123b6579e$require$Buffer.isBuffer(chunk)) chunk = $a9f048f123b6579e$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $a9f048f123b6579e$var$nop;
    if (state.ending) $a9f048f123b6579e$var$writeAfterEnd(this, cb);
    else if (isBuf || $a9f048f123b6579e$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $a9f048f123b6579e$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$a9f048f123b6579e$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a9f048f123b6579e$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a9f048f123b6579e$var$clearBuffer(this, state);
    }
};
$a9f048f123b6579e$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $a9f048f123b6579e$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $a9f048f123b6579e$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a9f048f123b6579e$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a9f048f123b6579e$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $a9f048f123b6579e$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $a9f048f123b6579e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $a9f048f123b6579e$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a9f048f123b6579e$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a9f048f123b6579e$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4Jj9n.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4Jj9n.nextTick($a9f048f123b6579e$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $a9f048f123b6579e$var$finishMaybe(stream, state);
    }
}
function $a9f048f123b6579e$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $a9f048f123b6579e$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $a9f048f123b6579e$var$ERR_MULTIPLE_CALLBACK();
    $a9f048f123b6579e$var$onwriteStateUpdate(state);
    if (er) $a9f048f123b6579e$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $a9f048f123b6579e$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a9f048f123b6579e$var$clearBuffer(stream, state);
        if (sync) $4Jj9n.nextTick($a9f048f123b6579e$var$afterWrite, stream, state, finished, cb);
        else $a9f048f123b6579e$var$afterWrite(stream, state, finished, cb);
    }
}
function $a9f048f123b6579e$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $a9f048f123b6579e$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $a9f048f123b6579e$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $a9f048f123b6579e$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $a9f048f123b6579e$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $a9f048f123b6579e$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $a9f048f123b6579e$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $a9f048f123b6579e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$a9f048f123b6579e$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $a9f048f123b6579e$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$a9f048f123b6579e$var$Writable.prototype._writev = null;
$a9f048f123b6579e$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $a9f048f123b6579e$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $a9f048f123b6579e$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $a9f048f123b6579e$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $a9f048f123b6579e$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $a9f048f123b6579e$var$finishMaybe(stream, state);
    });
}
function $a9f048f123b6579e$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4Jj9n.nextTick($a9f048f123b6579e$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a9f048f123b6579e$var$finishMaybe(stream, state) {
    var need = $a9f048f123b6579e$var$needFinish(state);
    if (need) {
        $a9f048f123b6579e$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $a9f048f123b6579e$var$endWritable(stream, state, cb) {
    state.ending = true;
    $a9f048f123b6579e$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4Jj9n.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $a9f048f123b6579e$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$a9f048f123b6579e$var$Writable.prototype.destroy = $bEUDG.destroy;
$a9f048f123b6579e$var$Writable.prototype._undestroy = $bEUDG.undestroy;
$a9f048f123b6579e$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("hh1jD", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $c9350b7e6b7672af$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $c9350b7e6b7672af$var$deprecate(fn, msg) {
    if ($c9350b7e6b7672af$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($c9350b7e6b7672af$var$config('throwDeprecation')) throw new Error(msg);
            else if ($c9350b7e6b7672af$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $c9350b7e6b7672af$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("fr8tb", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $b3cff28e2ef33ead$export$63a7aa211a91ed69, (v) => $b3cff28e2ef33ead$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $b3cff28e2ef33ead$export$63a7aa211a91ed69;
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $b3cff28e2ef33ead$require$Buffer = $jcTxY.Buffer;
/*</replacement>*/ var $b3cff28e2ef33ead$var$isEncoding = $b3cff28e2ef33ead$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $b3cff28e2ef33ead$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $b3cff28e2ef33ead$var$normalizeEncoding(enc) {
    var nenc = $b3cff28e2ef33ead$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($b3cff28e2ef33ead$require$Buffer.isEncoding === $b3cff28e2ef33ead$var$isEncoding || !$b3cff28e2ef33ead$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$b3cff28e2ef33ead$export$63a7aa211a91ed69 = $b3cff28e2ef33ead$var$StringDecoder;
function $b3cff28e2ef33ead$var$StringDecoder(encoding) {
    this.encoding = $b3cff28e2ef33ead$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $b3cff28e2ef33ead$var$utf16Text;
            this.end = $b3cff28e2ef33ead$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $b3cff28e2ef33ead$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $b3cff28e2ef33ead$var$base64Text;
            this.end = $b3cff28e2ef33ead$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $b3cff28e2ef33ead$var$simpleWrite;
            this.end = $b3cff28e2ef33ead$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $b3cff28e2ef33ead$require$Buffer.allocUnsafe(nb);
}
$b3cff28e2ef33ead$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$b3cff28e2ef33ead$var$StringDecoder.prototype.end = $b3cff28e2ef33ead$var$utf8End;
// Returns only complete characters in a Buffer
$b3cff28e2ef33ead$var$StringDecoder.prototype.text = $b3cff28e2ef33ead$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$b3cff28e2ef33ead$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $b3cff28e2ef33ead$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $b3cff28e2ef33ead$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $b3cff28e2ef33ead$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $b3cff28e2ef33ead$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $b3cff28e2ef33ead$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $b3cff28e2ef33ead$var$utf8Text(buf, i) {
    var total = $b3cff28e2ef33ead$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $b3cff28e2ef33ead$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $b3cff28e2ef33ead$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $b3cff28e2ef33ead$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $b3cff28e2ef33ead$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $b3cff28e2ef33ead$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $b3cff28e2ef33ead$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $b3cff28e2ef33ead$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("g3g84", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
var $baf970140daabb65$var$_Object$setPrototypeO;
function $baf970140daabb65$var$_defineProperty(obj, key, value) {
    key = $baf970140daabb65$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $baf970140daabb65$var$_toPropertyKey(arg) {
    var key = $baf970140daabb65$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $baf970140daabb65$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $iMJxh = parcelRequire("iMJxh");
var $baf970140daabb65$var$kLastResolve = Symbol('lastResolve');
var $baf970140daabb65$var$kLastReject = Symbol('lastReject');
var $baf970140daabb65$var$kError = Symbol('error');
var $baf970140daabb65$var$kEnded = Symbol('ended');
var $baf970140daabb65$var$kLastPromise = Symbol('lastPromise');
var $baf970140daabb65$var$kHandlePromise = Symbol('handlePromise');
var $baf970140daabb65$var$kStream = Symbol('stream');
function $baf970140daabb65$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $baf970140daabb65$var$readAndResolve(iter) {
    var resolve = iter[$baf970140daabb65$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$baf970140daabb65$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$baf970140daabb65$var$kLastPromise] = null;
            iter[$baf970140daabb65$var$kLastResolve] = null;
            iter[$baf970140daabb65$var$kLastReject] = null;
            resolve($baf970140daabb65$var$createIterResult(data, false));
        }
    }
}
function $baf970140daabb65$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4Jj9n.nextTick($baf970140daabb65$var$readAndResolve, iter);
}
function $baf970140daabb65$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$baf970140daabb65$var$kEnded]) {
                resolve($baf970140daabb65$var$createIterResult(undefined, true));
                return;
            }
            iter[$baf970140daabb65$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $baf970140daabb65$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $baf970140daabb65$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($baf970140daabb65$var$_Object$setPrototypeO = {
    get stream () {
        return this[$baf970140daabb65$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$baf970140daabb65$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$baf970140daabb65$var$kEnded]) return Promise.resolve($baf970140daabb65$var$createIterResult(undefined, true));
        if (this[$baf970140daabb65$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4Jj9n.nextTick(function() {
                if (_this[$baf970140daabb65$var$kError]) reject(_this[$baf970140daabb65$var$kError]);
                else resolve($baf970140daabb65$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$baf970140daabb65$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($baf970140daabb65$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$baf970140daabb65$var$kStream].read();
            if (data !== null) return Promise.resolve($baf970140daabb65$var$createIterResult(data, false));
            promise = new Promise(this[$baf970140daabb65$var$kHandlePromise]);
        }
        this[$baf970140daabb65$var$kLastPromise] = promise;
        return promise;
    }
}, $baf970140daabb65$var$_defineProperty($baf970140daabb65$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $baf970140daabb65$var$_defineProperty($baf970140daabb65$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$baf970140daabb65$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($baf970140daabb65$var$createIterResult(undefined, true));
        });
    });
}), $baf970140daabb65$var$_Object$setPrototypeO), $baf970140daabb65$var$AsyncIteratorPrototype);
var $baf970140daabb65$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($baf970140daabb65$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kStream, {
        value: stream,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kLastResolve, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kLastReject, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kError, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$baf970140daabb65$var$kStream].read();
            if (data) {
                iterator[$baf970140daabb65$var$kLastPromise] = null;
                iterator[$baf970140daabb65$var$kLastResolve] = null;
                iterator[$baf970140daabb65$var$kLastReject] = null;
                resolve($baf970140daabb65$var$createIterResult(data, false));
            } else {
                iterator[$baf970140daabb65$var$kLastResolve] = resolve;
                iterator[$baf970140daabb65$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$baf970140daabb65$var$kLastPromise] = null;
    $iMJxh(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$baf970140daabb65$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$baf970140daabb65$var$kLastPromise] = null;
                iterator[$baf970140daabb65$var$kLastResolve] = null;
                iterator[$baf970140daabb65$var$kLastReject] = null;
                reject(err);
            }
            iterator[$baf970140daabb65$var$kError] = err;
            return;
        }
        var resolve = iterator[$baf970140daabb65$var$kLastResolve];
        if (resolve !== null) {
            iterator[$baf970140daabb65$var$kLastPromise] = null;
            iterator[$baf970140daabb65$var$kLastResolve] = null;
            iterator[$baf970140daabb65$var$kLastReject] = null;
            resolve($baf970140daabb65$var$createIterResult(undefined, true));
        }
        iterator[$baf970140daabb65$var$kEnded] = true;
    });
    stream.on('readable', $baf970140daabb65$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $baf970140daabb65$var$createReadableStreamAsyncIterator;

});
parcelRegister("iMJxh", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("aQfo6")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $dad00820ab2d8972$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $dad00820ab2d8972$var$noop() {}
function $dad00820ab2d8972$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $dad00820ab2d8972$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $dad00820ab2d8972$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $dad00820ab2d8972$var$once(callback || $dad00820ab2d8972$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($dad00820ab2d8972$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $dad00820ab2d8972$var$eos;

});


parcelRegister("fOGyj", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("9Pily", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $72771bc24748289a$var$Transform;

var $aQfo6 = parcelRequire("aQfo6");
var $72771bc24748289a$require$_require$codes = $aQfo6.codes;
var $72771bc24748289a$var$ERR_METHOD_NOT_IMPLEMENTED = $72771bc24748289a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $72771bc24748289a$var$ERR_MULTIPLE_CALLBACK = $72771bc24748289a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $72771bc24748289a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $72771bc24748289a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $72771bc24748289a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $72771bc24748289a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $5PuTj = parcelRequire("5PuTj");

(parcelRequire("9YOog"))($72771bc24748289a$var$Transform, $5PuTj);
function $72771bc24748289a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $72771bc24748289a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $72771bc24748289a$var$Transform(options) {
    if (!(this instanceof $72771bc24748289a$var$Transform)) return new $72771bc24748289a$var$Transform(options);
    $5PuTj.call(this, options);
    this._transformState = {
        afterTransform: $72771bc24748289a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $72771bc24748289a$var$prefinish);
}
function $72771bc24748289a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $72771bc24748289a$var$done(_this, er, data);
    });
    else $72771bc24748289a$var$done(this, null, null);
}
$72771bc24748289a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $5PuTj.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$72771bc24748289a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $72771bc24748289a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$72771bc24748289a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$72771bc24748289a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$72771bc24748289a$var$Transform.prototype._destroy = function(err, cb) {
    $5PuTj.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $72771bc24748289a$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $72771bc24748289a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $72771bc24748289a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("euhdJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a8c139a7be2bd7f4$var$PassThrough;

var $9Pily = parcelRequire("9Pily");

(parcelRequire("9YOog"))($a8c139a7be2bd7f4$var$PassThrough, $9Pily);
function $a8c139a7be2bd7f4$var$PassThrough(options) {
    if (!(this instanceof $a8c139a7be2bd7f4$var$PassThrough)) return new $a8c139a7be2bd7f4$var$PassThrough(options);
    $9Pily.call(this, options);
}
$a8c139a7be2bd7f4$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("atWzg", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $7a1a0b285cb275ce$var$eos;
function $7a1a0b285cb275ce$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $aQfo6 = parcelRequire("aQfo6");
var $7a1a0b285cb275ce$require$_require$codes = $aQfo6.codes;
var $7a1a0b285cb275ce$var$ERR_MISSING_ARGS = $7a1a0b285cb275ce$require$_require$codes.ERR_MISSING_ARGS, $7a1a0b285cb275ce$var$ERR_STREAM_DESTROYED = $7a1a0b285cb275ce$require$_require$codes.ERR_STREAM_DESTROYED;
function $7a1a0b285cb275ce$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7a1a0b285cb275ce$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $7a1a0b285cb275ce$var$destroyer(stream, reading, writing, callback) {
    callback = $7a1a0b285cb275ce$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($7a1a0b285cb275ce$var$eos === undefined) $7a1a0b285cb275ce$var$eos = (parcelRequire("iMJxh"));
    $7a1a0b285cb275ce$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7a1a0b285cb275ce$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $7a1a0b285cb275ce$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $7a1a0b285cb275ce$var$call(fn) {
    fn();
}
function $7a1a0b285cb275ce$var$pipe(from, to) {
    return from.pipe(to);
}
function $7a1a0b285cb275ce$var$popCallback(streams) {
    if (!streams.length) return $7a1a0b285cb275ce$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $7a1a0b285cb275ce$var$noop;
    return streams.pop();
}
function $7a1a0b285cb275ce$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7a1a0b285cb275ce$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7a1a0b285cb275ce$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7a1a0b285cb275ce$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7a1a0b285cb275ce$var$call);
            if (reading) return;
            destroys.forEach($7a1a0b285cb275ce$var$call);
            callback(error);
        });
    });
    return streams.reduce($7a1a0b285cb275ce$var$pipe);
}
module.exports = $7a1a0b285cb275ce$var$pipeline;

});




parcelRegister("ggr8j", function(module, exports) {
'use strict';

var $kFATv = parcelRequire("kFATv");
var $bd733004861c395b$require$Buffer = $kFATv.Buffer;

var $9YOog = parcelRequire("9YOog");

var $aAOvO = parcelRequire("aAOvO");
var $bd733004861c395b$var$ARRAY16 = new Array(16);
var $bd733004861c395b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $bd733004861c395b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $bd733004861c395b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $bd733004861c395b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $bd733004861c395b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $bd733004861c395b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $bd733004861c395b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $bd733004861c395b$var$fn1(a, b, c, d, e, m, k, s) {
    return $bd733004861c395b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $bd733004861c395b$var$fn2(a, b, c, d, e, m, k, s) {
    return $bd733004861c395b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $bd733004861c395b$var$fn3(a, b, c, d, e, m, k, s) {
    return $bd733004861c395b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $bd733004861c395b$var$fn4(a, b, c, d, e, m, k, s) {
    return $bd733004861c395b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $bd733004861c395b$var$fn5(a, b, c, d, e, m, k, s) {
    return $bd733004861c395b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $bd733004861c395b$var$RIPEMD160() {
    $aAOvO.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$9YOog($bd733004861c395b$var$RIPEMD160, $aAOvO);
$bd733004861c395b$var$RIPEMD160.prototype._update = function() {
    var words = $bd733004861c395b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $bd733004861c395b$var$fn1(al, bl, cl, dl, el, words[$bd733004861c395b$var$zl[i]], $bd733004861c395b$var$hl[0], $bd733004861c395b$var$sl[i]);
            tr = $bd733004861c395b$var$fn5(ar, br, cr, dr, er, words[$bd733004861c395b$var$zr[i]], $bd733004861c395b$var$hr[0], $bd733004861c395b$var$sr[i]);
        } else if (i < 32) {
            tl = $bd733004861c395b$var$fn2(al, bl, cl, dl, el, words[$bd733004861c395b$var$zl[i]], $bd733004861c395b$var$hl[1], $bd733004861c395b$var$sl[i]);
            tr = $bd733004861c395b$var$fn4(ar, br, cr, dr, er, words[$bd733004861c395b$var$zr[i]], $bd733004861c395b$var$hr[1], $bd733004861c395b$var$sr[i]);
        } else if (i < 48) {
            tl = $bd733004861c395b$var$fn3(al, bl, cl, dl, el, words[$bd733004861c395b$var$zl[i]], $bd733004861c395b$var$hl[2], $bd733004861c395b$var$sl[i]);
            tr = $bd733004861c395b$var$fn3(ar, br, cr, dr, er, words[$bd733004861c395b$var$zr[i]], $bd733004861c395b$var$hr[2], $bd733004861c395b$var$sr[i]);
        } else if (i < 64) {
            tl = $bd733004861c395b$var$fn4(al, bl, cl, dl, el, words[$bd733004861c395b$var$zl[i]], $bd733004861c395b$var$hl[3], $bd733004861c395b$var$sl[i]);
            tr = $bd733004861c395b$var$fn2(ar, br, cr, dr, er, words[$bd733004861c395b$var$zr[i]], $bd733004861c395b$var$hr[3], $bd733004861c395b$var$sr[i]);
        } else {
            tl = $bd733004861c395b$var$fn5(al, bl, cl, dl, el, words[$bd733004861c395b$var$zl[i]], $bd733004861c395b$var$hl[4], $bd733004861c395b$var$sl[i]);
            tr = $bd733004861c395b$var$fn1(ar, br, cr, dr, er, words[$bd733004861c395b$var$zr[i]], $bd733004861c395b$var$hr[4], $bd733004861c395b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $bd733004861c395b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $bd733004861c395b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$bd733004861c395b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $bd733004861c395b$require$Buffer.alloc ? $bd733004861c395b$require$Buffer.alloc(20) : new $bd733004861c395b$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $bd733004861c395b$var$RIPEMD160;

});
parcelRegister("aAOvO", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $7b6472d9f24ac413$require$Buffer = $jcTxY.Buffer;

var $ehAqF = parcelRequire("ehAqF");

var $lLxrA = parcelRequire("lLxrA");
var $7b6472d9f24ac413$require$Transform = $lLxrA.Transform;

var $9YOog = parcelRequire("9YOog");
function $7b6472d9f24ac413$var$HashBase(blockSize) {
    $7b6472d9f24ac413$require$Transform.call(this);
    this._block = $7b6472d9f24ac413$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$9YOog($7b6472d9f24ac413$var$HashBase, $7b6472d9f24ac413$require$Transform);
$7b6472d9f24ac413$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$7b6472d9f24ac413$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$7b6472d9f24ac413$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $ehAqF(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$7b6472d9f24ac413$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$7b6472d9f24ac413$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$7b6472d9f24ac413$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $7b6472d9f24ac413$var$HashBase;

});
parcelRegister("ehAqF", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $a65ee94ec9f7e434$require$Buffer = $jcTxY.Buffer;

var $huTD8 = parcelRequire("huTD8");
var $a65ee94ec9f7e434$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $a65ee94ec9f7e434$var$useArrayBuffer = $a65ee94ec9f7e434$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $a65ee94ec9f7e434$var$isView = $a65ee94ec9f7e434$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $a65ee94ec9f7e434$require$Buffer.isBuffer(thing) || $a65ee94ec9f7e434$var$useUint8Array && thing instanceof Uint8Array || $a65ee94ec9f7e434$var$isView && $a65ee94ec9f7e434$var$isView(thing)) return $huTD8(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("huTD8", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $cbd063fdb3e6ca69$require$Buffer = $jcTxY.Buffer;

var $5JxkD = parcelRequire("5JxkD");

var $h2osw = parcelRequire("h2osw");
var $cbd063fdb3e6ca69$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $h2osw(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $cbd063fdb3e6ca69$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $cbd063fdb3e6ca69$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $cbd063fdb3e6ca69$var$useFromArrayBuffer = $cbd063fdb3e6ca69$var$useArrayBuffer && ($cbd063fdb3e6ca69$require$Buffer.prototype instanceof Uint8Array || $cbd063fdb3e6ca69$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($cbd063fdb3e6ca69$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $cbd063fdb3e6ca69$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $cbd063fdb3e6ca69$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($cbd063fdb3e6ca69$var$useArrayBuffer && $cbd063fdb3e6ca69$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $cbd063fdb3e6ca69$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($cbd063fdb3e6ca69$var$useFromArrayBuffer) {
            var res = $cbd063fdb3e6ca69$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $cbd063fdb3e6ca69$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($cbd063fdb3e6ca69$var$useUint8Array && data instanceof Uint8Array) return $cbd063fdb3e6ca69$require$Buffer.from(data);
    var isArr = $5JxkD(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $cbd063fdb3e6ca69$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $cbd063fdb3e6ca69$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5JxkD", function(module, exports) {
var $42cb02b8d969841b$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $42cb02b8d969841b$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("h2osw", function(module, exports) {
'use strict';

var $jQFIR = parcelRequire("jQFIR");

var $exvo0 = parcelRequire("exvo0");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $c675989cd1c8b083$var$$typedArrayBuffer = $exvo0('TypedArray.prototype.buffer', true);

var $2BlbL = parcelRequire("2BlbL");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $c675989cd1c8b083$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$2BlbL(x)) throw new $jQFIR('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("jQFIR", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("exvo0", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $lH1kJ = parcelRequire("lH1kJ");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a95c7e6883bd7de8$var$$indexOf = $lH1kJ([
    $4YUXM('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $4YUXM(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a95c7e6883bd7de8$var$$indexOf(name, '.prototype.') > -1) return $lH1kJ(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("4YUXM", function(module, exports) {
'use strict';
var $3a08f3b93b399588$var$undefined1;

var $aiQs8 = parcelRequire("aiQs8");

var $2DlCe = parcelRequire("2DlCe");

var $TtWO0 = parcelRequire("TtWO0");

var $aG0Ti = parcelRequire("aG0Ti");

var $cwaZa = parcelRequire("cwaZa");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $6Unty = parcelRequire("6Unty");

var $38UJ9 = parcelRequire("38UJ9");

var $iGzt4 = parcelRequire("iGzt4");

var $dWJBO = parcelRequire("dWJBO");

var $i9udS = parcelRequire("i9udS");

var $hE7Bh = parcelRequire("hE7Bh");

var $gJSpD = parcelRequire("gJSpD");

var $8xHx6 = parcelRequire("8xHx6");
var $3a08f3b93b399588$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3a08f3b93b399588$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3a08f3b93b399588$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $7SE9t = parcelRequire("7SE9t");

var $cILf7 = parcelRequire("cILf7");
var $3a08f3b93b399588$var$throwTypeError = function() {
    throw new $jQFIR();
};
var $3a08f3b93b399588$var$ThrowTypeError = $7SE9t ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3a08f3b93b399588$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7SE9t(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3a08f3b93b399588$var$throwTypeError;
        }
    }
}() : $3a08f3b93b399588$var$throwTypeError;

var $3a08f3b93b399588$var$hasSymbols = (parcelRequire("fa2Fq"))();

var $cKjXh = parcelRequire("cKjXh");

var $5O4uz = parcelRequire("5O4uz");

var $bOsTQ = parcelRequire("bOsTQ");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");
var $3a08f3b93b399588$var$needsEval = {};
var $3a08f3b93b399588$var$TypedArray = typeof Uint8Array === 'undefined' || !$cKjXh ? undefined : $cKjXh(Uint8Array);
var $3a08f3b93b399588$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGenerator%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncIteratorPrototype%': $3a08f3b93b399588$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $2DlCe,
    '%eval%': eval,
    '%EvalError%': $TtWO0,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3a08f3b93b399588$var$$Function,
    '%GeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh($cKjXh([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aiQs8,
    '%Object.getOwnPropertyDescriptor%': $7SE9t,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aG0Ti,
    '%ReferenceError%': $cwaZa,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3a08f3b93b399588$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1rcCL,
    '%ThrowTypeError%': $3a08f3b93b399588$var$ThrowTypeError,
    '%TypedArray%': $3a08f3b93b399588$var$TypedArray,
    '%TypeError%': $jQFIR,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6Unty,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9ttrx,
    '%Function.prototype.apply%': $4G4X6,
    '%Object.defineProperty%': $cILf7,
    '%Object.getPrototypeOf%': $5O4uz,
    '%Math.abs%': $38UJ9,
    '%Math.floor%': $iGzt4,
    '%Math.max%': $dWJBO,
    '%Math.min%': $i9udS,
    '%Math.pow%': $hE7Bh,
    '%Math.round%': $gJSpD,
    '%Math.sign%': $8xHx6,
    '%Reflect.getPrototypeOf%': $bOsTQ
};
if ($cKjXh) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3a08f3b93b399588$var$errorProto = $cKjXh($cKjXh(e));
    $3a08f3b93b399588$var$INTRINSICS['%Error.prototype%'] = $3a08f3b93b399588$var$errorProto;
}
var $3a08f3b93b399588$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $cKjXh) value = $cKjXh(gen.prototype);
    }
    $3a08f3b93b399588$var$INTRINSICS[name] = value;
    return value;
};
var $3a08f3b93b399588$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1rs7J = parcelRequire("1rs7J");

var $9VOPG = parcelRequire("9VOPG");
var $3a08f3b93b399588$var$$concat = $1rs7J.call($9ttrx, Array.prototype.concat);
var $3a08f3b93b399588$var$$spliceApply = $1rs7J.call($4G4X6, Array.prototype.splice);
var $3a08f3b93b399588$var$$replace = $1rs7J.call($9ttrx, String.prototype.replace);
var $3a08f3b93b399588$var$$strSlice = $1rs7J.call($9ttrx, String.prototype.slice);
var $3a08f3b93b399588$var$$exec = $1rs7J.call($9ttrx, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3a08f3b93b399588$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3a08f3b93b399588$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3a08f3b93b399588$var$stringToPath = function stringToPath(string) {
    var first = $3a08f3b93b399588$var$$strSlice(string, 0, 1);
    var last = $3a08f3b93b399588$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1rcCL('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1rcCL('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3a08f3b93b399588$var$$replace(string, $3a08f3b93b399588$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3a08f3b93b399588$var$$replace(subString, $3a08f3b93b399588$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3a08f3b93b399588$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9VOPG($3a08f3b93b399588$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3a08f3b93b399588$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($9VOPG($3a08f3b93b399588$var$INTRINSICS, intrinsicName)) {
        var value = $3a08f3b93b399588$var$INTRINSICS[intrinsicName];
        if (value === $3a08f3b93b399588$var$needsEval) value = $3a08f3b93b399588$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jQFIR('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1rcCL('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jQFIR('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jQFIR('"allowMissing" argument must be a boolean');
    if ($3a08f3b93b399588$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1rcCL('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3a08f3b93b399588$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3a08f3b93b399588$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3a08f3b93b399588$var$$spliceApply(parts, $3a08f3b93b399588$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3a08f3b93b399588$var$$strSlice(part, 0, 1);
        var last = $3a08f3b93b399588$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1rcCL('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($9VOPG($3a08f3b93b399588$var$INTRINSICS, intrinsicRealName)) value = $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jQFIR('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7SE9t && i + 1 >= parts.length) {
                var desc = $7SE9t(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9VOPG(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aiQs8", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("2DlCe", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("TtWO0", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aG0Ti", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cwaZa", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("1rcCL", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("6Unty", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("38UJ9", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iGzt4", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dWJBO", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("i9udS", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("hE7Bh", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gJSpD", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("8xHx6", function(module, exports) {
'use strict';

var $io64q = parcelRequire("io64q");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($io64q(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("io64q", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("7SE9t", function(module, exports) {
'use strict';

var $8rLHf = parcelRequire("8rLHf");
var $5bccb8dbb44f329c$require$$gOPD = $8rLHf;
if ($5bccb8dbb44f329c$require$$gOPD) try {
    $5bccb8dbb44f329c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5bccb8dbb44f329c$require$$gOPD = null;
}
module.exports = $5bccb8dbb44f329c$require$$gOPD;

});
parcelRegister("8rLHf", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("cILf7", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $942e3d902bcc477c$var$$defineProperty = Object.defineProperty || false;
if ($942e3d902bcc477c$var$$defineProperty) try {
    $942e3d902bcc477c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $942e3d902bcc477c$var$$defineProperty = false;
}
module.exports = $942e3d902bcc477c$var$$defineProperty;

});

parcelRegister("fa2Fq", function(module, exports) {
'use strict';
var $b099dbd68238d6ce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b099dbd68238d6ce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b099dbd68238d6ce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9VQ4N();
};

});
parcelRegister("9VQ4N", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("cKjXh", function(module, exports) {
'use strict';

var $bOsTQ = parcelRequire("bOsTQ");

var $5O4uz = parcelRequire("5O4uz");

var $dv9TT = parcelRequire("dv9TT");
/** @type {import('.')} */ module.exports = $bOsTQ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $bOsTQ(O);
} : $5O4uz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5O4uz(O);
} : $dv9TT ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dv9TT(O);
} : null;

});
parcelRegister("bOsTQ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("5O4uz", function(module, exports) {
'use strict';

var $aiQs8 = parcelRequire("aiQs8");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aiQs8.getPrototypeOf || null;

});

parcelRegister("dv9TT", function(module, exports) {
'use strict';

var $lH1kJ = parcelRequire("lH1kJ");

var $7SE9t = parcelRequire("7SE9t");
var $9d45d9abe8425603$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9d45d9abe8425603$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9d45d9abe8425603$var$desc = !!$9d45d9abe8425603$var$hasProtoAccessor && $7SE9t && $7SE9t(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9d45d9abe8425603$var$$Object = Object;
var $9d45d9abe8425603$var$$getPrototypeOf = $9d45d9abe8425603$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $9d45d9abe8425603$var$desc && typeof $9d45d9abe8425603$var$desc.get === 'function' ? $lH1kJ([
    $9d45d9abe8425603$var$desc.get
]) : typeof $9d45d9abe8425603$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9d45d9abe8425603$var$$getPrototypeOf(value == null ? value : $9d45d9abe8425603$var$$Object(value));
} : false;

});
parcelRegister("lH1kJ", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $jQFIR = parcelRequire("jQFIR");

var $9ttrx = parcelRequire("9ttrx");

var $9LBpG = parcelRequire("9LBpG");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $jQFIR('a function is required');
    return $9LBpG($1rs7J, $9ttrx, args);
};

});
parcelRegister("1rs7J", function(module, exports) {
'use strict';

var $eXzJr = parcelRequire("eXzJr");
module.exports = Function.prototype.bind || $eXzJr;

});
parcelRegister("eXzJr", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $ae424afb5f8fb4e2$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ae424afb5f8fb4e2$var$toStr = Object.prototype.toString;
var $ae424afb5f8fb4e2$var$max = Math.max;
var $ae424afb5f8fb4e2$var$funcType = '[object Function]';
var $ae424afb5f8fb4e2$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ae424afb5f8fb4e2$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ae424afb5f8fb4e2$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ae424afb5f8fb4e2$var$toStr.apply(target) !== $ae424afb5f8fb4e2$var$funcType) throw new TypeError($ae424afb5f8fb4e2$var$ERROR_MESSAGE + target);
    var args = $ae424afb5f8fb4e2$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ae424afb5f8fb4e2$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ae424afb5f8fb4e2$var$concatty(args, arguments));
    };
    var boundLength = $ae424afb5f8fb4e2$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ae424afb5f8fb4e2$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9ttrx", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("9LBpG", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");

var $4cvMh = parcelRequire("4cvMh");
/** @type {import('./actualApply')} */ module.exports = $4cvMh || $1rs7J.call($9ttrx, $4G4X6);

});
parcelRegister("4G4X6", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4cvMh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("9VOPG", function(module, exports) {
'use strict';
var $73b0de3d2e3453fc$var$call = Function.prototype.call;
var $73b0de3d2e3453fc$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1rs7J = parcelRequire("1rs7J");
/** @type {import('.')} */ module.exports = $1rs7J.call($73b0de3d2e3453fc$var$call, $73b0de3d2e3453fc$var$$hasOwn);

});



parcelRegister("2BlbL", function(module, exports) {
'use strict';

var $82kf0 = parcelRequire("82kf0");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$82kf0(value);
};

});
parcelRegister("82kf0", function(module, exports) {
'use strict';

var $8VxG3 = parcelRequire("8VxG3");

var $gEiH1 = parcelRequire("gEiH1");

var $6Qtg6 = parcelRequire("6Qtg6");

var $exvo0 = parcelRequire("exvo0");

var $7SE9t = parcelRequire("7SE9t");

var $cKjXh = parcelRequire("cKjXh");
var $5d9e36139148c689$var$$toString = $exvo0('Object.prototype.toString');

var $5d9e36139148c689$var$hasToStringTag = (parcelRequire("cJdfe"))();
var $5d9e36139148c689$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $5d9e36139148c689$var$typedArrays = $gEiH1();
var $5d9e36139148c689$var$$slice = $exvo0('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $5d9e36139148c689$var$$indexOf = $exvo0('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $5d9e36139148c689$var$cache = {
    __proto__: null
};
if ($5d9e36139148c689$var$hasToStringTag && $7SE9t && $cKjXh) $8VxG3($5d9e36139148c689$var$typedArrays, function(typedArray) {
    var arr = new $5d9e36139148c689$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $cKjXh) {
        var proto = $cKjXh(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $7SE9t(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $cKjXh(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $7SE9t(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $6Qtg6(descriptor.get);
            $5d9e36139148c689$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $8VxG3($5d9e36139148c689$var$typedArrays, function(typedArray) {
    var arr = new $5d9e36139148c689$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $6Qtg6(fn);
        $5d9e36139148c689$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $5d9e36139148c689$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $8VxG3(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $5d9e36139148c689$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $5d9e36139148c689$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $5d9e36139148c689$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $8VxG3(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $5d9e36139148c689$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $5d9e36139148c689$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$5d9e36139148c689$var$hasToStringTag) {
        /** @type {string} */ var tag = $5d9e36139148c689$var$$slice($5d9e36139148c689$var$$toString(value), 8, -1);
        if ($5d9e36139148c689$var$$indexOf($5d9e36139148c689$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $5d9e36139148c689$var$trySlices(value);
    }
    if (!$7SE9t) return null;
     // unknown engine
    return $5d9e36139148c689$var$tryTypedArrays(value);
};

});
parcelRegister("8VxG3", function(module, exports) {
'use strict';

var $9oota = parcelRequire("9oota");
var $67fdc52fb081d132$var$toStr = Object.prototype.toString;
var $67fdc52fb081d132$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($67fdc52fb081d132$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($67fdc52fb081d132$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $67fdc52fb081d132$var$isArray(x) {
    return $67fdc52fb081d132$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$9oota(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($67fdc52fb081d132$var$isArray(list)) $67fdc52fb081d132$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $67fdc52fb081d132$var$forEachString(list, iterator, receiver);
    else $67fdc52fb081d132$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("9oota", function(module, exports) {
'use strict';
var $6d69560fa6c74dba$var$fnToStr = Function.prototype.toString;
var $6d69560fa6c74dba$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $6d69560fa6c74dba$var$badArrayLike;
var $6d69560fa6c74dba$var$isCallableMarker;
if (typeof $6d69560fa6c74dba$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $6d69560fa6c74dba$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $6d69560fa6c74dba$var$isCallableMarker;
        }
    });
    $6d69560fa6c74dba$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $6d69560fa6c74dba$var$reflectApply(function() {
        throw 42;
    }, null, $6d69560fa6c74dba$var$badArrayLike);
} catch (_) {
    if (_ !== $6d69560fa6c74dba$var$isCallableMarker) $6d69560fa6c74dba$var$reflectApply = null;
}
else $6d69560fa6c74dba$var$reflectApply = null;
var $6d69560fa6c74dba$var$constructorRegex = /^\s*class\b/;
var $6d69560fa6c74dba$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $6d69560fa6c74dba$var$fnToStr.call(value);
        return $6d69560fa6c74dba$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $6d69560fa6c74dba$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
        $6d69560fa6c74dba$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $6d69560fa6c74dba$var$toStr = Object.prototype.toString;
var $6d69560fa6c74dba$var$objectClass = '[object Object]';
var $6d69560fa6c74dba$var$fnClass = '[object Function]';
var $6d69560fa6c74dba$var$genClass = '[object GeneratorFunction]';
var $6d69560fa6c74dba$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $6d69560fa6c74dba$var$ddaClass2 = '[object HTML document.all class]';
var $6d69560fa6c74dba$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $6d69560fa6c74dba$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $6d69560fa6c74dba$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $6d69560fa6c74dba$var$all = document.all;
    if ($6d69560fa6c74dba$var$toStr.call($6d69560fa6c74dba$var$all) === $6d69560fa6c74dba$var$toStr.call(document.all)) $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($6d69560fa6c74dba$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $6d69560fa6c74dba$var$toStr.call(value);
            return (str === $6d69560fa6c74dba$var$ddaClass || str === $6d69560fa6c74dba$var$ddaClass2 || str === $6d69560fa6c74dba$var$ddaClass3 // opera 12.16
             || str === $6d69560fa6c74dba$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $6d69560fa6c74dba$var$reflectApply ? function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $6d69560fa6c74dba$var$reflectApply(value, null, $6d69560fa6c74dba$var$badArrayLike);
    } catch (e) {
        if (e !== $6d69560fa6c74dba$var$isCallableMarker) return false;
    }
    return !$6d69560fa6c74dba$var$isES6ClassFn(value) && $6d69560fa6c74dba$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($6d69560fa6c74dba$var$hasToStringTag) return $6d69560fa6c74dba$var$tryFunctionObject(value);
    if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
    var strClass = $6d69560fa6c74dba$var$toStr.call(value);
    if (strClass !== $6d69560fa6c74dba$var$fnClass && strClass !== $6d69560fa6c74dba$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $6d69560fa6c74dba$var$tryFunctionObject(value);
};

});


parcelRegister("gEiH1", function(module, exports) {
'use strict';

var $hesUA = parcelRequire("hesUA");
var $c1eee1ce878a8295$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $hesUA.length; i++)if (typeof $c1eee1ce878a8295$var$g[$hesUA[i]] === 'function') // @ts-expect-error
    out[out.length] = $hesUA[i];
    return out;
};

});
parcelRegister("hesUA", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("6Qtg6", function(module, exports) {
'use strict';

var $djZMj = parcelRequire("djZMj");

var $cILf7 = parcelRequire("cILf7");

var $lH1kJ = parcelRequire("lH1kJ");

var $hS31d = parcelRequire("hS31d");
module.exports = function callBind(originalFunction) {
    var func = $lH1kJ(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $djZMj(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($cILf7) $cILf7(module.exports, 'apply', {
    value: $hS31d
});
else module.exports.apply = $hS31d;

});
parcelRegister("djZMj", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $6dipk = parcelRequire("6dipk");

var $9b2cf88ebf061dcb$var$hasDescriptors = (parcelRequire("dp7dD"))();

var $7SE9t = parcelRequire("7SE9t");

var $jQFIR = parcelRequire("jQFIR");
var $9b2cf88ebf061dcb$var$$floor = $4YUXM('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $jQFIR('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $9b2cf88ebf061dcb$var$$floor(length) !== length) throw new $jQFIR('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $7SE9t) {
        var desc = $7SE9t(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($9b2cf88ebf061dcb$var$hasDescriptors) $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("6dipk", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $7SE9t = parcelRequire("7SE9t");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $jQFIR('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $jQFIR('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $jQFIR('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $jQFIR('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $jQFIR('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $jQFIR('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$7SE9t && $7SE9t(obj, property);
    if ($cILf7) $cILf7(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $1rcCL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("dp7dD", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");
var $9c2335b3e3936cef$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$cILf7;
};
$9c2335b3e3936cef$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$cILf7) return null;
    try {
        return $cILf7([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9c2335b3e3936cef$var$hasPropertyDescriptors;

});


parcelRegister("hS31d", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9LBpG = parcelRequire("9LBpG");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9LBpG($1rs7J, $4G4X6, arguments);
};

});


parcelRegister("cJdfe", function(module, exports) {
'use strict';

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9VQ4N() && !!Symbol.toStringTag;
};

});






parcelRegister("lLxrA", function(module, exports) {

exports = module.exports = (parcelRequire("hBQe9"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("bn9dA"));

exports.Duplex = (parcelRequire("a017q"));

exports.Transform = (parcelRequire("erBgW"));

exports.PassThrough = (parcelRequire("8sQP7"));

});
parcelRegister("hBQe9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';

var $kq54V = parcelRequire("kq54V");
/*</replacement>*/ module.exports = $cd1e679acb045384$var$Readable;

var $7Df4d = parcelRequire("7Df4d");
/*</replacement>*/ /*<replacement>*/ var $cd1e679acb045384$var$Duplex;
/*</replacement>*/ $cd1e679acb045384$var$Readable.ReadableState = $cd1e679acb045384$var$ReadableState;

var $9KgKE = parcelRequire("9KgKE");
var $cd1e679acb045384$require$EE = $9KgKE.EventEmitter;
var $cd1e679acb045384$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $22QpT = parcelRequire("22QpT");

var $bF6OX = parcelRequire("bF6OX");
var $cd1e679acb045384$require$Buffer = $bF6OX.Buffer;
var $cd1e679acb045384$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $cd1e679acb045384$var$_uint8ArrayToBuffer(chunk) {
    return $cd1e679acb045384$require$Buffer.from(chunk);
}
function $cd1e679acb045384$var$_isUint8Array(obj) {
    return $cd1e679acb045384$require$Buffer.isBuffer(obj) || obj instanceof $cd1e679acb045384$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $cd1e679acb045384$var$util = Object.create((parcelRequire("jyUmD")));

$cd1e679acb045384$var$util.inherits = (parcelRequire("9YOog"));

var $1frus = parcelRequire("1frus");
var $cd1e679acb045384$var$debug = void 0;
if ($1frus && $1frus.debuglog) $cd1e679acb045384$var$debug = $1frus.debuglog('stream');
else $cd1e679acb045384$var$debug = function() {};

var $7TDMF = parcelRequire("7TDMF");

var $9ckpm = parcelRequire("9ckpm");
var $cd1e679acb045384$var$StringDecoder;
$cd1e679acb045384$var$util.inherits($cd1e679acb045384$var$Readable, $22QpT);
var $cd1e679acb045384$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $cd1e679acb045384$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7Df4d(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $cd1e679acb045384$var$ReadableState(options, stream) {
    $cd1e679acb045384$var$Duplex = $cd1e679acb045384$var$Duplex || (parcelRequire("a017q"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $cd1e679acb045384$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $7TDMF();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$cd1e679acb045384$var$StringDecoder) $cd1e679acb045384$var$StringDecoder = (parcelRequire("M6WP2")).StringDecoder;
        this.decoder = new $cd1e679acb045384$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $cd1e679acb045384$var$Readable(options) {
    $cd1e679acb045384$var$Duplex = $cd1e679acb045384$var$Duplex || (parcelRequire("a017q"));
    if (!(this instanceof $cd1e679acb045384$var$Readable)) return new $cd1e679acb045384$var$Readable(options);
    this._readableState = new $cd1e679acb045384$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $22QpT.call(this);
}
Object.defineProperty($cd1e679acb045384$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$cd1e679acb045384$var$Readable.prototype.destroy = $9ckpm.destroy;
$cd1e679acb045384$var$Readable.prototype._undestroy = $9ckpm.undestroy;
$cd1e679acb045384$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$cd1e679acb045384$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $cd1e679acb045384$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $cd1e679acb045384$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$cd1e679acb045384$var$Readable.prototype.unshift = function(chunk) {
    return $cd1e679acb045384$var$readableAddChunk(this, chunk, null, true, false);
};
function $cd1e679acb045384$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $cd1e679acb045384$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $cd1e679acb045384$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $cd1e679acb045384$require$Buffer.prototype) chunk = $cd1e679acb045384$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $cd1e679acb045384$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $cd1e679acb045384$var$addChunk(stream, state, chunk, false);
                    else $cd1e679acb045384$var$maybeReadMore(stream, state);
                } else $cd1e679acb045384$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $cd1e679acb045384$var$needMoreData(state);
}
function $cd1e679acb045384$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $cd1e679acb045384$var$emitReadable(stream);
    }
    $cd1e679acb045384$var$maybeReadMore(stream, state);
}
function $cd1e679acb045384$var$chunkInvalid(state, chunk) {
    var er;
    if (!$cd1e679acb045384$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $cd1e679acb045384$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$cd1e679acb045384$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$cd1e679acb045384$var$Readable.prototype.setEncoding = function(enc) {
    if (!$cd1e679acb045384$var$StringDecoder) $cd1e679acb045384$var$StringDecoder = (parcelRequire("M6WP2")).StringDecoder;
    this._readableState.decoder = new $cd1e679acb045384$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $cd1e679acb045384$var$MAX_HWM = 0x800000;
function $cd1e679acb045384$var$computeNewHighWaterMark(n) {
    if (n >= $cd1e679acb045384$var$MAX_HWM) n = $cd1e679acb045384$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cd1e679acb045384$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $cd1e679acb045384$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$cd1e679acb045384$var$Readable.prototype.read = function(n) {
    $cd1e679acb045384$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $cd1e679acb045384$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $cd1e679acb045384$var$endReadable(this);
        else $cd1e679acb045384$var$emitReadable(this);
        return null;
    }
    n = $cd1e679acb045384$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $cd1e679acb045384$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $cd1e679acb045384$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $cd1e679acb045384$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $cd1e679acb045384$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $cd1e679acb045384$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $cd1e679acb045384$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $cd1e679acb045384$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $cd1e679acb045384$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $cd1e679acb045384$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $cd1e679acb045384$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $cd1e679acb045384$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $cd1e679acb045384$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kq54V.nextTick($cd1e679acb045384$var$emitReadable_, stream);
        else $cd1e679acb045384$var$emitReadable_(stream);
    }
}
function $cd1e679acb045384$var$emitReadable_(stream) {
    $cd1e679acb045384$var$debug('emit readable');
    stream.emit('readable');
    $cd1e679acb045384$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $cd1e679acb045384$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kq54V.nextTick($cd1e679acb045384$var$maybeReadMore_, stream, state);
    }
}
function $cd1e679acb045384$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $cd1e679acb045384$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$cd1e679acb045384$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$cd1e679acb045384$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $cd1e679acb045384$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4Jj9n.stdout && dest !== $4Jj9n.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kq54V.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $cd1e679acb045384$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $cd1e679acb045384$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $cd1e679acb045384$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $cd1e679acb045384$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $cd1e679acb045384$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $cd1e679acb045384$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $cd1e679acb045384$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $cd1e679acb045384$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($cd1e679acb045384$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $cd1e679acb045384$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $cd1e679acb045384$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $cd1e679acb045384$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $cd1e679acb045384$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $cd1e679acb045384$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $cd1e679acb045384$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $cd1e679acb045384$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $cd1e679acb045384$var$flow(src);
        }
    };
}
$cd1e679acb045384$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $cd1e679acb045384$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$cd1e679acb045384$var$Readable.prototype.on = function(ev, fn) {
    var res = $22QpT.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kq54V.nextTick($cd1e679acb045384$var$nReadingNextTick, this);
            else if (state.length) $cd1e679acb045384$var$emitReadable(this);
        }
    }
    return res;
};
$cd1e679acb045384$var$Readable.prototype.addListener = $cd1e679acb045384$var$Readable.prototype.on;
function $cd1e679acb045384$var$nReadingNextTick(self1) {
    $cd1e679acb045384$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$cd1e679acb045384$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $cd1e679acb045384$var$debug('resume');
        state.flowing = true;
        $cd1e679acb045384$var$resume(this, state);
    }
    return this;
};
function $cd1e679acb045384$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kq54V.nextTick($cd1e679acb045384$var$resume_, stream, state);
    }
}
function $cd1e679acb045384$var$resume_(stream, state) {
    if (!state.reading) {
        $cd1e679acb045384$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $cd1e679acb045384$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$cd1e679acb045384$var$Readable.prototype.pause = function() {
    $cd1e679acb045384$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $cd1e679acb045384$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $cd1e679acb045384$var$flow(stream) {
    var state = stream._readableState;
    $cd1e679acb045384$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$cd1e679acb045384$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $cd1e679acb045384$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $cd1e679acb045384$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $cd1e679acb045384$var$kProxyEvents.length; n++)stream.on($cd1e679acb045384$var$kProxyEvents[n], this.emit.bind(this, $cd1e679acb045384$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $cd1e679acb045384$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($cd1e679acb045384$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$cd1e679acb045384$var$Readable._fromList = $cd1e679acb045384$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cd1e679acb045384$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $cd1e679acb045384$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cd1e679acb045384$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $cd1e679acb045384$var$copyFromBufferString(n, list) : $cd1e679acb045384$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cd1e679acb045384$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cd1e679acb045384$var$copyFromBuffer(n, list) {
    var ret = $cd1e679acb045384$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $cd1e679acb045384$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kq54V.nextTick($cd1e679acb045384$var$endReadableNT, state, stream);
    }
}
function $cd1e679acb045384$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $cd1e679acb045384$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kq54V", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
module.exports = {
    nextTick: $edda2cd9a8162b9a$var$nextTick
};
function $edda2cd9a8162b9a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4Jj9n.nextTick(fn);
        case 2:
            return $4Jj9n.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4Jj9n.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4Jj9n.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4Jj9n.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("7Df4d", function(module, exports) {
var $58e7dce48824b615$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $58e7dce48824b615$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("22QpT", function(module, exports) {

module.exports = (parcelRequire("9KgKE")).EventEmitter;

});

parcelRegister("bF6OX", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $kFATv = parcelRequire("kFATv");
var $87d8d08c71031911$var$Buffer = $kFATv.Buffer;
// alternative to using Object.keys for old browsers
function $87d8d08c71031911$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($87d8d08c71031911$var$Buffer.from && $87d8d08c71031911$var$Buffer.alloc && $87d8d08c71031911$var$Buffer.allocUnsafe && $87d8d08c71031911$var$Buffer.allocUnsafeSlow) module.exports = $kFATv;
else {
    // Copy properties from require('buffer')
    $87d8d08c71031911$var$copyProps($kFATv, module.exports);
    module.exports.Buffer = $87d8d08c71031911$var$SafeBuffer;
}
function $87d8d08c71031911$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $87d8d08c71031911$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$87d8d08c71031911$var$copyProps($87d8d08c71031911$var$Buffer, $87d8d08c71031911$var$SafeBuffer);
$87d8d08c71031911$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $87d8d08c71031911$var$Buffer(arg, encodingOrOffset, length);
};
$87d8d08c71031911$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $87d8d08c71031911$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$87d8d08c71031911$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $87d8d08c71031911$var$Buffer(size);
};
$87d8d08c71031911$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $kFATv.SlowBuffer(size);
};

});

parcelRegister("jyUmD", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $e3dcea0cbcfaf926$export$43bee75e5e14138e, (v) => $e3dcea0cbcfaf926$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $e3dcea0cbcfaf926$export$f9ce7b637dfbe238, (v) => $e3dcea0cbcfaf926$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $e3dcea0cbcfaf926$export$630801d484da15df, (v) => $e3dcea0cbcfaf926$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $e3dcea0cbcfaf926$export$bedb7023a7733221, (v) => $e3dcea0cbcfaf926$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $e3dcea0cbcfaf926$export$7e4aa119212bc614, (v) => $e3dcea0cbcfaf926$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $e3dcea0cbcfaf926$export$844ec244b1367d54, (v) => $e3dcea0cbcfaf926$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $e3dcea0cbcfaf926$export$a244864fd9645c7f, (v) => $e3dcea0cbcfaf926$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $e3dcea0cbcfaf926$export$fce6876652108ab, (v) => $e3dcea0cbcfaf926$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $e3dcea0cbcfaf926$export$49841c62b9eff15, (v) => $e3dcea0cbcfaf926$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $e3dcea0cbcfaf926$export$a6cdc56e425d0d0a, (v) => $e3dcea0cbcfaf926$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $e3dcea0cbcfaf926$export$871608497c498473, (v) => $e3dcea0cbcfaf926$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $e3dcea0cbcfaf926$export$e6127cc7fe7395c3, (v) => $e3dcea0cbcfaf926$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $e3dcea0cbcfaf926$export$f6e2535fb5126e54, (v) => $e3dcea0cbcfaf926$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $e3dcea0cbcfaf926$export$c3825b437cbdea5c, (v) => $e3dcea0cbcfaf926$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $e3dcea0cbcfaf926$export$a7884ebc965f8f54, (v) => $e3dcea0cbcfaf926$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $e3dcea0cbcfaf926$export$43bee75e5e14138e;
var $e3dcea0cbcfaf926$export$f9ce7b637dfbe238;
var $e3dcea0cbcfaf926$export$630801d484da15df;
var $e3dcea0cbcfaf926$export$bedb7023a7733221;
var $e3dcea0cbcfaf926$export$7e4aa119212bc614;
var $e3dcea0cbcfaf926$export$844ec244b1367d54;
var $e3dcea0cbcfaf926$export$a244864fd9645c7f;
var $e3dcea0cbcfaf926$export$fce6876652108ab;
var $e3dcea0cbcfaf926$export$49841c62b9eff15;
var $e3dcea0cbcfaf926$export$a6cdc56e425d0d0a;
var $e3dcea0cbcfaf926$export$871608497c498473;
var $e3dcea0cbcfaf926$export$e6127cc7fe7395c3;
var $e3dcea0cbcfaf926$export$f6e2535fb5126e54;
var $e3dcea0cbcfaf926$export$c3825b437cbdea5c;
var $e3dcea0cbcfaf926$export$a7884ebc965f8f54;
function $e3dcea0cbcfaf926$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $e3dcea0cbcfaf926$var$objectToString(arg) === '[object Array]';
}
$e3dcea0cbcfaf926$export$43bee75e5e14138e = $e3dcea0cbcfaf926$var$isArray;
function $e3dcea0cbcfaf926$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$e3dcea0cbcfaf926$export$f9ce7b637dfbe238 = $e3dcea0cbcfaf926$var$isBoolean;
function $e3dcea0cbcfaf926$var$isNull(arg) {
    return arg === null;
}
$e3dcea0cbcfaf926$export$630801d484da15df = $e3dcea0cbcfaf926$var$isNull;
function $e3dcea0cbcfaf926$var$isNullOrUndefined(arg) {
    return arg == null;
}
$e3dcea0cbcfaf926$export$bedb7023a7733221 = $e3dcea0cbcfaf926$var$isNullOrUndefined;
function $e3dcea0cbcfaf926$var$isNumber(arg) {
    return typeof arg === 'number';
}
$e3dcea0cbcfaf926$export$7e4aa119212bc614 = $e3dcea0cbcfaf926$var$isNumber;
function $e3dcea0cbcfaf926$var$isString(arg) {
    return typeof arg === 'string';
}
$e3dcea0cbcfaf926$export$844ec244b1367d54 = $e3dcea0cbcfaf926$var$isString;
function $e3dcea0cbcfaf926$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$e3dcea0cbcfaf926$export$a244864fd9645c7f = $e3dcea0cbcfaf926$var$isSymbol;
function $e3dcea0cbcfaf926$var$isUndefined(arg) {
    return arg === void 0;
}
$e3dcea0cbcfaf926$export$fce6876652108ab = $e3dcea0cbcfaf926$var$isUndefined;
function $e3dcea0cbcfaf926$var$isRegExp(re) {
    return $e3dcea0cbcfaf926$var$objectToString(re) === '[object RegExp]';
}
$e3dcea0cbcfaf926$export$49841c62b9eff15 = $e3dcea0cbcfaf926$var$isRegExp;
function $e3dcea0cbcfaf926$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$e3dcea0cbcfaf926$export$a6cdc56e425d0d0a = $e3dcea0cbcfaf926$var$isObject;
function $e3dcea0cbcfaf926$var$isDate(d) {
    return $e3dcea0cbcfaf926$var$objectToString(d) === '[object Date]';
}
$e3dcea0cbcfaf926$export$871608497c498473 = $e3dcea0cbcfaf926$var$isDate;
function $e3dcea0cbcfaf926$var$isError(e) {
    return $e3dcea0cbcfaf926$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$e3dcea0cbcfaf926$export$e6127cc7fe7395c3 = $e3dcea0cbcfaf926$var$isError;
function $e3dcea0cbcfaf926$var$isFunction(arg) {
    return typeof arg === 'function';
}
$e3dcea0cbcfaf926$export$f6e2535fb5126e54 = $e3dcea0cbcfaf926$var$isFunction;
function $e3dcea0cbcfaf926$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$e3dcea0cbcfaf926$export$c3825b437cbdea5c = $e3dcea0cbcfaf926$var$isPrimitive;

$e3dcea0cbcfaf926$export$a7884ebc965f8f54 = (parcelRequire("kFATv")).Buffer.isBuffer;
function $e3dcea0cbcfaf926$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("7TDMF", function(module, exports) {
'use strict';
function $5bfc87ba26813757$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $bF6OX = parcelRequire("bF6OX");
var $5bfc87ba26813757$require$Buffer = $bF6OX.Buffer;

var $1frus = parcelRequire("1frus");
function $5bfc87ba26813757$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $5bfc87ba26813757$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $5bfc87ba26813757$require$Buffer.alloc(0);
        var ret = $5bfc87ba26813757$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $5bfc87ba26813757$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($1frus && $1frus.inspect && $1frus.inspect.custom) module.exports.prototype[$1frus.inspect.custom] = function() {
    var obj = $1frus.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("9ckpm", function(module, exports) {
'use strict';

var $kq54V = parcelRequire("kq54V");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $6b2510ab85066973$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $kq54V.nextTick($6b2510ab85066973$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $kq54V.nextTick($6b2510ab85066973$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $kq54V.nextTick($6b2510ab85066973$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $kq54V.nextTick($6b2510ab85066973$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $6b2510ab85066973$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $6b2510ab85066973$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $6b2510ab85066973$var$destroy,
    undestroy: $6b2510ab85066973$var$undestroy
};

});

parcelRegister("a017q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $kq54V = parcelRequire("kq54V");
/*</replacement>*/ /*<replacement>*/ var $747ac59cde630568$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $747ac59cde630568$var$Duplex;

/*<replacement>*/ var $747ac59cde630568$var$util = Object.create((parcelRequire("jyUmD")));

$747ac59cde630568$var$util.inherits = (parcelRequire("9YOog"));

var $hBQe9 = parcelRequire("hBQe9");

var $bn9dA = parcelRequire("bn9dA");
$747ac59cde630568$var$util.inherits($747ac59cde630568$var$Duplex, $hBQe9);
// avoid scope creep, the keys array can then be collected
var $747ac59cde630568$var$keys = $747ac59cde630568$var$objectKeys($bn9dA.prototype);
for(var $747ac59cde630568$var$v = 0; $747ac59cde630568$var$v < $747ac59cde630568$var$keys.length; $747ac59cde630568$var$v++){
    var $747ac59cde630568$var$method = $747ac59cde630568$var$keys[$747ac59cde630568$var$v];
    if (!$747ac59cde630568$var$Duplex.prototype[$747ac59cde630568$var$method]) $747ac59cde630568$var$Duplex.prototype[$747ac59cde630568$var$method] = $bn9dA.prototype[$747ac59cde630568$var$method];
}
function $747ac59cde630568$var$Duplex(options) {
    if (!(this instanceof $747ac59cde630568$var$Duplex)) return new $747ac59cde630568$var$Duplex(options);
    $hBQe9.call(this, options);
    $bn9dA.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $747ac59cde630568$var$onend);
}
Object.defineProperty($747ac59cde630568$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $747ac59cde630568$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kq54V.nextTick($747ac59cde630568$var$onEndNT, this);
}
function $747ac59cde630568$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($747ac59cde630568$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$747ac59cde630568$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kq54V.nextTick(cb, err);
};

});
parcelRegister("bn9dA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $kq54V = parcelRequire("kq54V");
/*</replacement>*/ module.exports = $8478fe3d1891f135$var$Writable;
/* <replacement> */ function $8478fe3d1891f135$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8478fe3d1891f135$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8478fe3d1891f135$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8478fe3d1891f135$var$asyncWrite = (0, $kq54V.nextTick);
/*</replacement>*/ /*<replacement>*/ var $8478fe3d1891f135$var$Duplex;
/*</replacement>*/ $8478fe3d1891f135$var$Writable.WritableState = $8478fe3d1891f135$var$WritableState;

/*<replacement>*/ var $8478fe3d1891f135$var$util = Object.create((parcelRequire("jyUmD")));

$8478fe3d1891f135$var$util.inherits = (parcelRequire("9YOog"));

/*</replacement>*/ /*<replacement>*/ var $8478fe3d1891f135$var$internalUtil = {
    deprecate: (parcelRequire("hh1jD"))
};

var $22QpT = parcelRequire("22QpT");

var $bF6OX = parcelRequire("bF6OX");
var $8478fe3d1891f135$require$Buffer = $bF6OX.Buffer;
var $8478fe3d1891f135$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $8478fe3d1891f135$var$_uint8ArrayToBuffer(chunk) {
    return $8478fe3d1891f135$require$Buffer.from(chunk);
}
function $8478fe3d1891f135$var$_isUint8Array(obj) {
    return $8478fe3d1891f135$require$Buffer.isBuffer(obj) || obj instanceof $8478fe3d1891f135$var$OurUint8Array;
}

var $9ckpm = parcelRequire("9ckpm");
$8478fe3d1891f135$var$util.inherits($8478fe3d1891f135$var$Writable, $22QpT);
function $8478fe3d1891f135$var$nop() {}

function $8478fe3d1891f135$var$WritableState(options, stream) {
    $8478fe3d1891f135$var$Duplex = $8478fe3d1891f135$var$Duplex || (parcelRequire("a017q"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $8478fe3d1891f135$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8478fe3d1891f135$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8478fe3d1891f135$var$CorkedRequest(this);
}
$8478fe3d1891f135$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8478fe3d1891f135$var$WritableState.prototype, 'buffer', {
            get: $8478fe3d1891f135$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8478fe3d1891f135$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $8478fe3d1891f135$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8478fe3d1891f135$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($8478fe3d1891f135$var$realHasInstance.call(this, object)) return true;
            if (this !== $8478fe3d1891f135$var$Writable) return false;
            return object && object._writableState instanceof $8478fe3d1891f135$var$WritableState;
        }
    });
} else $8478fe3d1891f135$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $8478fe3d1891f135$var$Writable(options) {
    $8478fe3d1891f135$var$Duplex = $8478fe3d1891f135$var$Duplex || (parcelRequire("a017q"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$8478fe3d1891f135$var$realHasInstance.call($8478fe3d1891f135$var$Writable, this) && !(this instanceof $8478fe3d1891f135$var$Duplex)) return new $8478fe3d1891f135$var$Writable(options);
    this._writableState = new $8478fe3d1891f135$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $22QpT.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8478fe3d1891f135$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $8478fe3d1891f135$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $kq54V.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8478fe3d1891f135$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $kq54V.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$8478fe3d1891f135$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8478fe3d1891f135$var$_isUint8Array(chunk);
    if (isBuf && !$8478fe3d1891f135$require$Buffer.isBuffer(chunk)) chunk = $8478fe3d1891f135$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $8478fe3d1891f135$var$nop;
    if (state.ended) $8478fe3d1891f135$var$writeAfterEnd(this, cb);
    else if (isBuf || $8478fe3d1891f135$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8478fe3d1891f135$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8478fe3d1891f135$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$8478fe3d1891f135$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8478fe3d1891f135$var$clearBuffer(this, state);
    }
};
$8478fe3d1891f135$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $8478fe3d1891f135$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $8478fe3d1891f135$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8478fe3d1891f135$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8478fe3d1891f135$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8478fe3d1891f135$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8478fe3d1891f135$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8478fe3d1891f135$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8478fe3d1891f135$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kq54V.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kq54V.nextTick($8478fe3d1891f135$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $8478fe3d1891f135$var$finishMaybe(stream, state);
    }
}
function $8478fe3d1891f135$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8478fe3d1891f135$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $8478fe3d1891f135$var$onwriteStateUpdate(state);
    if (er) $8478fe3d1891f135$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8478fe3d1891f135$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8478fe3d1891f135$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $8478fe3d1891f135$var$asyncWrite($8478fe3d1891f135$var$afterWrite, stream, state, finished, cb);
        else $8478fe3d1891f135$var$afterWrite(stream, state, finished, cb);
    }
}
function $8478fe3d1891f135$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8478fe3d1891f135$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8478fe3d1891f135$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8478fe3d1891f135$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $8478fe3d1891f135$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8478fe3d1891f135$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8478fe3d1891f135$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8478fe3d1891f135$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8478fe3d1891f135$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$8478fe3d1891f135$var$Writable.prototype._writev = null;
$8478fe3d1891f135$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8478fe3d1891f135$var$endWritable(this, state, cb);
};
function $8478fe3d1891f135$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8478fe3d1891f135$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $8478fe3d1891f135$var$finishMaybe(stream, state);
    });
}
function $8478fe3d1891f135$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $kq54V.nextTick($8478fe3d1891f135$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $8478fe3d1891f135$var$finishMaybe(stream, state) {
    var need = $8478fe3d1891f135$var$needFinish(state);
    if (need) {
        $8478fe3d1891f135$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $8478fe3d1891f135$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8478fe3d1891f135$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kq54V.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8478fe3d1891f135$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8478fe3d1891f135$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8478fe3d1891f135$var$Writable.prototype.destroy = $9ckpm.destroy;
$8478fe3d1891f135$var$Writable.prototype._undestroy = $9ckpm.undestroy;
$8478fe3d1891f135$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("M6WP2", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $0909df7c93792f46$export$63a7aa211a91ed69, (v) => $0909df7c93792f46$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $0909df7c93792f46$export$63a7aa211a91ed69;
'use strict';

var $bF6OX = parcelRequire("bF6OX");
var $0909df7c93792f46$require$Buffer = $bF6OX.Buffer;
/*</replacement>*/ var $0909df7c93792f46$var$isEncoding = $0909df7c93792f46$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $0909df7c93792f46$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $0909df7c93792f46$var$normalizeEncoding(enc) {
    var nenc = $0909df7c93792f46$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($0909df7c93792f46$require$Buffer.isEncoding === $0909df7c93792f46$var$isEncoding || !$0909df7c93792f46$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$0909df7c93792f46$export$63a7aa211a91ed69 = $0909df7c93792f46$var$StringDecoder;
function $0909df7c93792f46$var$StringDecoder(encoding) {
    this.encoding = $0909df7c93792f46$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $0909df7c93792f46$var$utf16Text;
            this.end = $0909df7c93792f46$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $0909df7c93792f46$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $0909df7c93792f46$var$base64Text;
            this.end = $0909df7c93792f46$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $0909df7c93792f46$var$simpleWrite;
            this.end = $0909df7c93792f46$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $0909df7c93792f46$require$Buffer.allocUnsafe(nb);
}
$0909df7c93792f46$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$0909df7c93792f46$var$StringDecoder.prototype.end = $0909df7c93792f46$var$utf8End;
// Returns only complete characters in a Buffer
$0909df7c93792f46$var$StringDecoder.prototype.text = $0909df7c93792f46$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$0909df7c93792f46$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $0909df7c93792f46$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $0909df7c93792f46$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $0909df7c93792f46$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0909df7c93792f46$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $0909df7c93792f46$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $0909df7c93792f46$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $0909df7c93792f46$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $0909df7c93792f46$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $0909df7c93792f46$var$utf8Text(buf, i) {
    var total = $0909df7c93792f46$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $0909df7c93792f46$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $0909df7c93792f46$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $0909df7c93792f46$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $0909df7c93792f46$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $0909df7c93792f46$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $0909df7c93792f46$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $0909df7c93792f46$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("erBgW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $a8407fc5d7a0075f$var$Transform;

var $a017q = parcelRequire("a017q");

/*<replacement>*/ var $a8407fc5d7a0075f$var$util = Object.create((parcelRequire("jyUmD")));

$a8407fc5d7a0075f$var$util.inherits = (parcelRequire("9YOog"));
/*</replacement>*/ $a8407fc5d7a0075f$var$util.inherits($a8407fc5d7a0075f$var$Transform, $a017q);
function $a8407fc5d7a0075f$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $a8407fc5d7a0075f$var$Transform(options) {
    if (!(this instanceof $a8407fc5d7a0075f$var$Transform)) return new $a8407fc5d7a0075f$var$Transform(options);
    $a017q.call(this, options);
    this._transformState = {
        afterTransform: $a8407fc5d7a0075f$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $a8407fc5d7a0075f$var$prefinish);
}
function $a8407fc5d7a0075f$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $a8407fc5d7a0075f$var$done(_this, er, data);
    });
    else $a8407fc5d7a0075f$var$done(this, null, null);
}
$a8407fc5d7a0075f$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $a017q.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$a8407fc5d7a0075f$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$a8407fc5d7a0075f$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$a8407fc5d7a0075f$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$a8407fc5d7a0075f$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $a017q.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $a8407fc5d7a0075f$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("8sQP7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $6299e9e0efbe1521$var$PassThrough;

var $erBgW = parcelRequire("erBgW");

/*<replacement>*/ var $6299e9e0efbe1521$var$util = Object.create((parcelRequire("jyUmD")));

$6299e9e0efbe1521$var$util.inherits = (parcelRequire("9YOog"));
/*</replacement>*/ $6299e9e0efbe1521$var$util.inherits($6299e9e0efbe1521$var$PassThrough, $erBgW);
function $6299e9e0efbe1521$var$PassThrough(options) {
    if (!(this instanceof $6299e9e0efbe1521$var$PassThrough)) return new $6299e9e0efbe1521$var$PassThrough(options);
    $erBgW.call(this, options);
}
$6299e9e0efbe1521$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("gGO1L", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("10wDz"));

module.exports.sha1 = (parcelRequire("1UFFn"));

module.exports.sha224 = (parcelRequire("bBSMh"));

module.exports.sha256 = (parcelRequire("49uZJ"));

module.exports.sha384 = (parcelRequire("i4Fdl"));

module.exports.sha512 = (parcelRequire("WyXqt"));

});
parcelRegister("10wDz", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $0bbf1b9ddff9f4c3$require$Buffer = $jcTxY.Buffer;
var $0bbf1b9ddff9f4c3$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $0bbf1b9ddff9f4c3$var$W = new Array(80);
function $0bbf1b9ddff9f4c3$var$Sha() {
    this.init();
    this._w = $0bbf1b9ddff9f4c3$var$W;
    $a4jPh.call(this, 64, 56);
}
$9YOog($0bbf1b9ddff9f4c3$var$Sha, $a4jPh);
$0bbf1b9ddff9f4c3$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $0bbf1b9ddff9f4c3$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $0bbf1b9ddff9f4c3$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $0bbf1b9ddff9f4c3$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$0bbf1b9ddff9f4c3$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $0bbf1b9ddff9f4c3$var$rotl5(a) + $0bbf1b9ddff9f4c3$var$ft(s, b, c, d) + e + w[j] + $0bbf1b9ddff9f4c3$var$K[s] | 0;
        e = d;
        d = c;
        c = $0bbf1b9ddff9f4c3$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$0bbf1b9ddff9f4c3$var$Sha.prototype._hash = function() {
    var H = $0bbf1b9ddff9f4c3$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $0bbf1b9ddff9f4c3$var$Sha;

});
parcelRegister("a4jPh", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $7549a827cb60beaf$require$Buffer = $jcTxY.Buffer;

var $huTD8 = parcelRequire("huTD8");
// prototype class for hash functions
function $7549a827cb60beaf$var$Hash(blockSize, finalSize) {
    this._block = $7549a827cb60beaf$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$7549a827cb60beaf$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $huTD8(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$7549a827cb60beaf$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$7549a827cb60beaf$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $7549a827cb60beaf$var$Hash;

});


parcelRegister("1UFFn", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $164b5776d93c2b5f$require$Buffer = $jcTxY.Buffer;
var $164b5776d93c2b5f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $164b5776d93c2b5f$var$W = new Array(80);
function $164b5776d93c2b5f$var$Sha1() {
    this.init();
    this._w = $164b5776d93c2b5f$var$W;
    $a4jPh.call(this, 64, 56);
}
$9YOog($164b5776d93c2b5f$var$Sha1, $a4jPh);
$164b5776d93c2b5f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $164b5776d93c2b5f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $164b5776d93c2b5f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $164b5776d93c2b5f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $164b5776d93c2b5f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$164b5776d93c2b5f$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $164b5776d93c2b5f$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $164b5776d93c2b5f$var$rotl5(a) + $164b5776d93c2b5f$var$ft(s, b, c, d) + e + w[j] + $164b5776d93c2b5f$var$K[s] | 0;
        e = d;
        d = c;
        c = $164b5776d93c2b5f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$164b5776d93c2b5f$var$Sha1.prototype._hash = function() {
    var H = $164b5776d93c2b5f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $164b5776d93c2b5f$var$Sha1;

});

parcelRegister("bBSMh", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $49uZJ = parcelRequire("49uZJ");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $873da420e9b52322$require$Buffer = $jcTxY.Buffer;
var $873da420e9b52322$var$W = new Array(64);
function $873da420e9b52322$var$Sha224() {
    this.init();
    this._w = $873da420e9b52322$var$W; // new Array(64)
    $a4jPh.call(this, 64, 56);
}
$9YOog($873da420e9b52322$var$Sha224, $49uZJ);
$873da420e9b52322$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$873da420e9b52322$var$Sha224.prototype._hash = function() {
    var H = $873da420e9b52322$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $873da420e9b52322$var$Sha224;

});
parcelRegister("49uZJ", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $30600b936f50a9bf$require$Buffer = $jcTxY.Buffer;
var $30600b936f50a9bf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $30600b936f50a9bf$var$W = new Array(64);
function $30600b936f50a9bf$var$Sha256() {
    this.init();
    this._w = $30600b936f50a9bf$var$W; // new Array(64)
    $a4jPh.call(this, 64, 56);
}
$9YOog($30600b936f50a9bf$var$Sha256, $a4jPh);
$30600b936f50a9bf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $30600b936f50a9bf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $30600b936f50a9bf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $30600b936f50a9bf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $30600b936f50a9bf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $30600b936f50a9bf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $30600b936f50a9bf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$30600b936f50a9bf$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $30600b936f50a9bf$var$gamma1(w[i - 2]) + w[i - 7] + $30600b936f50a9bf$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $30600b936f50a9bf$var$sigma1(e) + $30600b936f50a9bf$var$ch(e, f, g) + $30600b936f50a9bf$var$K[j] + w[j] | 0;
        var T2 = $30600b936f50a9bf$var$sigma0(a) + $30600b936f50a9bf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$30600b936f50a9bf$var$Sha256.prototype._hash = function() {
    var H = $30600b936f50a9bf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $30600b936f50a9bf$var$Sha256;

});


parcelRegister("i4Fdl", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $WyXqt = parcelRequire("WyXqt");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $d28892058b432f3b$require$Buffer = $jcTxY.Buffer;
var $d28892058b432f3b$var$W = new Array(160);
function $d28892058b432f3b$var$Sha384() {
    this.init();
    this._w = $d28892058b432f3b$var$W;
    $a4jPh.call(this, 128, 112);
}
$9YOog($d28892058b432f3b$var$Sha384, $WyXqt);
$d28892058b432f3b$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$d28892058b432f3b$var$Sha384.prototype._hash = function() {
    var H = $d28892058b432f3b$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $d28892058b432f3b$var$Sha384;

});
parcelRegister("WyXqt", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $a4jPh = parcelRequire("a4jPh");

var $jcTxY = parcelRequire("jcTxY");
var $0b0088b8dac70761$require$Buffer = $jcTxY.Buffer;
var $0b0088b8dac70761$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $0b0088b8dac70761$var$W = new Array(160);
function $0b0088b8dac70761$var$Sha512() {
    this.init();
    this._w = $0b0088b8dac70761$var$W;
    $a4jPh.call(this, 128, 112);
}
$9YOog($0b0088b8dac70761$var$Sha512, $a4jPh);
$0b0088b8dac70761$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $0b0088b8dac70761$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $0b0088b8dac70761$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $0b0088b8dac70761$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $0b0088b8dac70761$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $0b0088b8dac70761$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $0b0088b8dac70761$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $0b0088b8dac70761$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $0b0088b8dac70761$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $0b0088b8dac70761$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$0b0088b8dac70761$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $0b0088b8dac70761$var$Gamma0(xh, xl);
        var gamma0l = $0b0088b8dac70761$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $0b0088b8dac70761$var$Gamma1(xh, xl);
        var gamma1l = $0b0088b8dac70761$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $0b0088b8dac70761$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $0b0088b8dac70761$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $0b0088b8dac70761$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $0b0088b8dac70761$var$maj(ah, bh, ch);
        var majl = $0b0088b8dac70761$var$maj(al, bl, cl);
        var sigma0h = $0b0088b8dac70761$var$sigma0(ah, al);
        var sigma0l = $0b0088b8dac70761$var$sigma0(al, ah);
        var sigma1h = $0b0088b8dac70761$var$sigma1(eh, el);
        var sigma1l = $0b0088b8dac70761$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $0b0088b8dac70761$var$K[j];
        var Kil = $0b0088b8dac70761$var$K[j + 1];
        var chh = $0b0088b8dac70761$var$Ch(eh, fh, gh);
        var chl = $0b0088b8dac70761$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $0b0088b8dac70761$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $0b0088b8dac70761$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $0b0088b8dac70761$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $0b0088b8dac70761$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $0b0088b8dac70761$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $0b0088b8dac70761$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $0b0088b8dac70761$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $0b0088b8dac70761$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $0b0088b8dac70761$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $0b0088b8dac70761$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $0b0088b8dac70761$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $0b0088b8dac70761$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $0b0088b8dac70761$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $0b0088b8dac70761$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $0b0088b8dac70761$var$getCarry(this._hl, hl) | 0;
};
$0b0088b8dac70761$var$Sha512.prototype._hash = function() {
    var H = $0b0088b8dac70761$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $0b0088b8dac70761$var$Sha512;

});



parcelRegister("hp0y4", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $cab53262547036ab$require$Buffer = $jcTxY.Buffer;

var $jssge = parcelRequire("jssge");
var $cab53262547036ab$require$Transform = $jssge.Transform;

var $fr8tb = parcelRequire("fr8tb");
var $cab53262547036ab$require$StringDecoder = $fr8tb.StringDecoder;

var $9YOog = parcelRequire("9YOog");

var $huTD8 = parcelRequire("huTD8");
function $cab53262547036ab$var$CipherBase(hashMode) {
    $cab53262547036ab$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$9YOog($cab53262547036ab$var$CipherBase, $cab53262547036ab$require$Transform);
$cab53262547036ab$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $huTD8(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$cab53262547036ab$var$CipherBase.prototype.setAutoPadding = function() {};
$cab53262547036ab$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$cab53262547036ab$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$cab53262547036ab$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$cab53262547036ab$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$cab53262547036ab$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$cab53262547036ab$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $cab53262547036ab$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$cab53262547036ab$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $cab53262547036ab$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $cab53262547036ab$var$CipherBase;

});


parcelRegister("4rFkN", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $5W1wp = parcelRequire("5W1wp");

var $hp0y4 = parcelRequire("hp0y4");

var $jcTxY = parcelRequire("jcTxY");
var $33c9bf34d1ac25fc$require$Buffer = $jcTxY.Buffer;

var $3AVW1 = parcelRequire("3AVW1");

var $ggr8j = parcelRequire("ggr8j");

var $gGO1L = parcelRequire("gGO1L");
var $33c9bf34d1ac25fc$var$ZEROS = $33c9bf34d1ac25fc$require$Buffer.alloc(128);
function $33c9bf34d1ac25fc$var$Hmac(alg, key) {
    $hp0y4.call(this, 'digest');
    if (typeof key === 'string') key = $33c9bf34d1ac25fc$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $ggr8j() : $gGO1L(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $33c9bf34d1ac25fc$require$Buffer.concat([
        key,
        $33c9bf34d1ac25fc$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $33c9bf34d1ac25fc$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $33c9bf34d1ac25fc$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $ggr8j() : $gGO1L(alg);
    this._hash.update(ipad);
}
$9YOog($33c9bf34d1ac25fc$var$Hmac, $hp0y4);
$33c9bf34d1ac25fc$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$33c9bf34d1ac25fc$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $ggr8j() : $gGO1L(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $33c9bf34d1ac25fc$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $5W1wp($3AVW1, key);
    return new $33c9bf34d1ac25fc$var$Hmac(alg, key);
};

});
parcelRegister("5W1wp", function(module, exports) {
'use strict';

var $9YOog = parcelRequire("9YOog");

var $jcTxY = parcelRequire("jcTxY");
var $45238cb5dbca45c1$require$Buffer = $jcTxY.Buffer;

var $hp0y4 = parcelRequire("hp0y4");
var $45238cb5dbca45c1$var$ZEROS = $45238cb5dbca45c1$require$Buffer.alloc(128);
var $45238cb5dbca45c1$var$blocksize = 64;
function $45238cb5dbca45c1$var$Hmac(alg, key) {
    $hp0y4.call(this, 'digest');
    if (typeof key === 'string') key = $45238cb5dbca45c1$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $45238cb5dbca45c1$var$blocksize) key = alg(key);
    else if (key.length < $45238cb5dbca45c1$var$blocksize) key = $45238cb5dbca45c1$require$Buffer.concat([
        key,
        $45238cb5dbca45c1$var$ZEROS
    ], $45238cb5dbca45c1$var$blocksize);
    var ipad = this._ipad = $45238cb5dbca45c1$require$Buffer.allocUnsafe($45238cb5dbca45c1$var$blocksize);
    var opad = this._opad = $45238cb5dbca45c1$require$Buffer.allocUnsafe($45238cb5dbca45c1$var$blocksize);
    for(var i = 0; i < $45238cb5dbca45c1$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$9YOog($45238cb5dbca45c1$var$Hmac, $hp0y4);
$45238cb5dbca45c1$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$45238cb5dbca45c1$var$Hmac.prototype._final = function() {
    var h = this._alg($45238cb5dbca45c1$require$Buffer.concat(this._hash));
    return this._alg($45238cb5dbca45c1$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $45238cb5dbca45c1$var$Hmac;

});

parcelRegister("3AVW1", function(module, exports) {

var $gxyGg = parcelRequire("gxyGg");
module.exports = function(buffer) {
    return new $gxyGg().update(buffer).digest();
};

});


parcelRegister("45HRw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("glb11"));

});
parcelRegister("glb11", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("96GTd", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $6a15f18c1e2b2c96$export$448fa22aedc9dbca, (v) => $6a15f18c1e2b2c96$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $6a15f18c1e2b2c96$export$b80c7ba289c8fa56, (v) => $6a15f18c1e2b2c96$export$b80c7ba289c8fa56 = v);
var $6a15f18c1e2b2c96$export$448fa22aedc9dbca;
var $6a15f18c1e2b2c96$export$b80c7ba289c8fa56;
'use strict';

$6a15f18c1e2b2c96$export$448fa22aedc9dbca = (parcelRequire("kN5Gs"));

$6a15f18c1e2b2c96$export$b80c7ba289c8fa56 = (parcelRequire("jCyi6"));

});
parcelRegister("kN5Gs", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $f22ccaec690f62b8$require$Buffer = $jcTxY.Buffer;

var $aY9BK = parcelRequire("aY9BK");

var $bNVwI = parcelRequire("bNVwI");

var $jCyi6 = parcelRequire("jCyi6");

var $iDf31 = parcelRequire("iDf31");
var $f22ccaec690f62b8$var$ZERO_BUF;
var $f22ccaec690f62b8$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $f22ccaec690f62b8$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $f22ccaec690f62b8$var$checks = [];
var $f22ccaec690f62b8$var$nextTick;
function $f22ccaec690f62b8$var$getNextTick() {
    if ($f22ccaec690f62b8$var$nextTick) return $f22ccaec690f62b8$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $f22ccaec690f62b8$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $f22ccaec690f62b8$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $f22ccaec690f62b8$var$nextTick = $parcel$global.setImmediate;
    else $f22ccaec690f62b8$var$nextTick = $parcel$global.setTimeout;
    return $f22ccaec690f62b8$var$nextTick;
}
function $f22ccaec690f62b8$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $f22ccaec690f62b8$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $f22ccaec690f62b8$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $f22ccaec690f62b8$require$Buffer.from(res);
    });
}
function $f22ccaec690f62b8$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$f22ccaec690f62b8$var$subtle || !$f22ccaec690f62b8$var$subtle.importKey || !$f22ccaec690f62b8$var$subtle.deriveBits) return Promise.resolve(false);
    if ($f22ccaec690f62b8$var$checks[algo] !== undefined) return $f22ccaec690f62b8$var$checks[algo];
    $f22ccaec690f62b8$var$ZERO_BUF = $f22ccaec690f62b8$var$ZERO_BUF || $f22ccaec690f62b8$require$Buffer.alloc(8);
    var prom = $f22ccaec690f62b8$var$browserPbkdf2($f22ccaec690f62b8$var$ZERO_BUF, $f22ccaec690f62b8$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $f22ccaec690f62b8$var$checks[algo] = prom;
    return prom;
}
function $f22ccaec690f62b8$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $f22ccaec690f62b8$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $f22ccaec690f62b8$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $aY9BK(iterations, keylen);
    password = $iDf31(password, $bNVwI, 'Password');
    salt = $iDf31(salt, $bNVwI, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $f22ccaec690f62b8$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $f22ccaec690f62b8$var$getNextTick()(function() {
            var out;
            try {
                out = $jCyi6(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $f22ccaec690f62b8$var$resolvePromise($f22ccaec690f62b8$var$checkNative(algo).then(function(resp) {
        if (resp) return $f22ccaec690f62b8$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $jCyi6(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("aY9BK", function(module, exports) {
'use strict';
var $7fc6f5e8cac54d2a$var$$isFinite = isFinite;
var $7fc6f5e8cac54d2a$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$7fc6f5e8cac54d2a$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $7fc6f5e8cac54d2a$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("bNVwI", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
var $8980e4e5eff96d80$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $8980e4e5eff96d80$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $8980e4e5eff96d80$var$pVersionMajor = parseInt($4Jj9n.version.split('.')[0].slice(1), 10);
    $8980e4e5eff96d80$var$defaultEncoding = $8980e4e5eff96d80$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $8980e4e5eff96d80$var$defaultEncoding = 'utf-8';
module.exports = $8980e4e5eff96d80$var$defaultEncoding;

});

parcelRegister("jCyi6", function(module, exports) {
'use strict';

var $3AVW1 = parcelRequire("3AVW1");

var $ggr8j = parcelRequire("ggr8j");

var $gGO1L = parcelRequire("gGO1L");

var $jcTxY = parcelRequire("jcTxY");
var $e48c2a6225832a4e$require$Buffer = $jcTxY.Buffer;

var $aY9BK = parcelRequire("aY9BK");

var $bNVwI = parcelRequire("bNVwI");

var $iDf31 = parcelRequire("iDf31");
var $e48c2a6225832a4e$var$ZEROS = $e48c2a6225832a4e$require$Buffer.alloc(128);
var $e48c2a6225832a4e$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $e48c2a6225832a4e$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $e48c2a6225832a4e$var$rmd160Func(data) {
    return new $ggr8j().update(data).digest();
}
function $e48c2a6225832a4e$var$getDigest(alg) {
    function shaFunc(data) {
        return $gGO1L(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $e48c2a6225832a4e$var$rmd160Func;
    if (alg === 'md5') return $3AVW1;
    return shaFunc;
}
function $e48c2a6225832a4e$var$Hmac(alg, key, saltLen) {
    var hash = $e48c2a6225832a4e$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $e48c2a6225832a4e$require$Buffer.concat([
        key,
        $e48c2a6225832a4e$var$ZEROS
    ], blocksize);
    var ipad = $e48c2a6225832a4e$require$Buffer.allocUnsafe(blocksize + $e48c2a6225832a4e$var$sizes[alg]);
    var opad = $e48c2a6225832a4e$require$Buffer.allocUnsafe(blocksize + $e48c2a6225832a4e$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $e48c2a6225832a4e$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $e48c2a6225832a4e$var$sizes[alg];
}
$e48c2a6225832a4e$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $e48c2a6225832a4e$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $aY9BK(iterations, keylen);
    password = $iDf31(password, $bNVwI, 'Password');
    salt = $iDf31(salt, $bNVwI, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $e48c2a6225832a4e$var$mapping[lowerDigest] || lowerDigest;
    var size = $e48c2a6225832a4e$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $e48c2a6225832a4e$var$Hmac(mappedDigest, password, salt.length);
    var DK = $e48c2a6225832a4e$require$Buffer.allocUnsafe(keylen);
    var block1 = $e48c2a6225832a4e$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $e48c2a6225832a4e$var$pbkdf2;

});
parcelRegister("iDf31", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $03801f23ccdc7a75$require$Buffer = $jcTxY.Buffer;

var $huTD8 = parcelRequire("huTD8");
var $03801f23ccdc7a75$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $03801f23ccdc7a75$var$useArrayBuffer = $03801f23ccdc7a75$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $03801f23ccdc7a75$var$isView = $03801f23ccdc7a75$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $03801f23ccdc7a75$require$Buffer.isBuffer(thing) || $03801f23ccdc7a75$var$useUint8Array && thing instanceof Uint8Array || $03801f23ccdc7a75$var$isView && $03801f23ccdc7a75$var$isView(thing)) return $huTD8(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("go6LA", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $bee422e8d87f7fe4$export$bdd223f16383713e, (v) => $bee422e8d87f7fe4$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $bee422e8d87f7fe4$export$26e5786e8ac8e530, (v) => $bee422e8d87f7fe4$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $bee422e8d87f7fe4$export$2f64596b8cbf08b4, (v) => $bee422e8d87f7fe4$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $bee422e8d87f7fe4$export$20533d26f07f1ee0, (v) => $bee422e8d87f7fe4$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $bee422e8d87f7fe4$export$12ada9414fbc594c, (v) => $bee422e8d87f7fe4$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $bee422e8d87f7fe4$export$2ce6d8d0e8b04e1a, (v) => $bee422e8d87f7fe4$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $bee422e8d87f7fe4$export$36b6d6ef312eab39, (v) => $bee422e8d87f7fe4$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $bee422e8d87f7fe4$export$f5e7e39d57cd9700, (v) => $bee422e8d87f7fe4$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $bee422e8d87f7fe4$export$dedd8dc3dc62b370, (v) => $bee422e8d87f7fe4$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $bee422e8d87f7fe4$export$58a258485f1e49f6, (v) => $bee422e8d87f7fe4$export$58a258485f1e49f6 = v);
var $bee422e8d87f7fe4$export$bdd223f16383713e;
var $bee422e8d87f7fe4$export$26e5786e8ac8e530;
var $bee422e8d87f7fe4$export$2f64596b8cbf08b4;
var $bee422e8d87f7fe4$export$20533d26f07f1ee0;
var $bee422e8d87f7fe4$export$12ada9414fbc594c;
var $bee422e8d87f7fe4$export$2ce6d8d0e8b04e1a;
var $bee422e8d87f7fe4$export$36b6d6ef312eab39;
var $bee422e8d87f7fe4$export$f5e7e39d57cd9700;
var $bee422e8d87f7fe4$export$dedd8dc3dc62b370;
var $bee422e8d87f7fe4$export$58a258485f1e49f6;

var $gwgL3 = parcelRequire("gwgL3");

var $BxYCC = parcelRequire("BxYCC");

var $6CiMW = parcelRequire("6CiMW");

var $kpwxT = parcelRequire("kpwxT");

var $5Gvmk = parcelRequire("5Gvmk");
function $bee422e8d87f7fe4$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6CiMW[suite]) {
        keyLen = $6CiMW[suite].key;
        ivLen = $6CiMW[suite].iv;
    } else if ($kpwxT[suite]) {
        keyLen = $kpwxT[suite].key * 8;
        ivLen = $kpwxT[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $5Gvmk(password, false, keyLen, ivLen);
    return $bee422e8d87f7fe4$var$createCipheriv(suite, keys.key, keys.iv);
}
function $bee422e8d87f7fe4$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($6CiMW[suite]) {
        keyLen = $6CiMW[suite].key;
        ivLen = $6CiMW[suite].iv;
    } else if ($kpwxT[suite]) {
        keyLen = $kpwxT[suite].key * 8;
        ivLen = $kpwxT[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $5Gvmk(password, false, keyLen, ivLen);
    return $bee422e8d87f7fe4$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $bee422e8d87f7fe4$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6CiMW[suite]) return $BxYCC.createCipheriv(suite, key, iv);
    if ($kpwxT[suite]) return new $gwgL3({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $bee422e8d87f7fe4$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($6CiMW[suite]) return $BxYCC.createDecipheriv(suite, key, iv);
    if ($kpwxT[suite]) return new $gwgL3({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $bee422e8d87f7fe4$var$getCiphers() {
    return Object.keys($kpwxT).concat($BxYCC.getCiphers());
}
$bee422e8d87f7fe4$export$bdd223f16383713e = $bee422e8d87f7fe4$export$26e5786e8ac8e530 = $bee422e8d87f7fe4$var$createCipher;
$bee422e8d87f7fe4$export$2f64596b8cbf08b4 = $bee422e8d87f7fe4$export$20533d26f07f1ee0 = $bee422e8d87f7fe4$var$createCipheriv;
$bee422e8d87f7fe4$export$12ada9414fbc594c = $bee422e8d87f7fe4$export$2ce6d8d0e8b04e1a = $bee422e8d87f7fe4$var$createDecipher;
$bee422e8d87f7fe4$export$36b6d6ef312eab39 = $bee422e8d87f7fe4$export$f5e7e39d57cd9700 = $bee422e8d87f7fe4$var$createDecipheriv;
$bee422e8d87f7fe4$export$dedd8dc3dc62b370 = $bee422e8d87f7fe4$export$58a258485f1e49f6 = $bee422e8d87f7fe4$var$getCiphers;

});
parcelRegister("gwgL3", function(module, exports) {

var $hp0y4 = parcelRequire("hp0y4");

var $3t6MD = parcelRequire("3t6MD");

var $9YOog = parcelRequire("9YOog");

var $jcTxY = parcelRequire("jcTxY");
var $c06ca24a7dfb15a4$require$Buffer = $jcTxY.Buffer;
var $c06ca24a7dfb15a4$var$modes = {
    'des-ede3-cbc': $3t6MD.CBC.instantiate($3t6MD.EDE),
    'des-ede3': $3t6MD.EDE,
    'des-ede-cbc': $3t6MD.CBC.instantiate($3t6MD.EDE),
    'des-ede': $3t6MD.EDE,
    'des-cbc': $3t6MD.CBC.instantiate($3t6MD.DES),
    'des-ecb': $3t6MD.DES
};
$c06ca24a7dfb15a4$var$modes.des = $c06ca24a7dfb15a4$var$modes['des-cbc'];
$c06ca24a7dfb15a4$var$modes.des3 = $c06ca24a7dfb15a4$var$modes['des-ede3-cbc'];
module.exports = $c06ca24a7dfb15a4$var$DES;
$9YOog($c06ca24a7dfb15a4$var$DES, $hp0y4);
function $c06ca24a7dfb15a4$var$DES(opts) {
    $hp0y4.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $c06ca24a7dfb15a4$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$c06ca24a7dfb15a4$require$Buffer.isBuffer(key)) key = $c06ca24a7dfb15a4$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $c06ca24a7dfb15a4$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$c06ca24a7dfb15a4$require$Buffer.isBuffer(iv)) iv = $c06ca24a7dfb15a4$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$c06ca24a7dfb15a4$var$DES.prototype._update = function(data) {
    return $c06ca24a7dfb15a4$require$Buffer.from(this._des.update(data));
};
$c06ca24a7dfb15a4$var$DES.prototype._final = function() {
    return $c06ca24a7dfb15a4$require$Buffer.from(this._des.final());
};

});
parcelRegister("3t6MD", function(module, exports) {

$parcel$export(module.exports, "DES", () => $286957924457d65e$export$cc8859615686b300, (v) => $286957924457d65e$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $286957924457d65e$export$8ad3f227af08fcc5, (v) => $286957924457d65e$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $286957924457d65e$export$947646e34766044f, (v) => $286957924457d65e$export$947646e34766044f = v);
var $286957924457d65e$export$eab97d15b1788b8d;
var $286957924457d65e$export$26e5786e8ac8e530;
var $286957924457d65e$export$cc8859615686b300;
var $286957924457d65e$export$8ad3f227af08fcc5;
var $286957924457d65e$export$947646e34766044f;
'use strict';

$286957924457d65e$export$eab97d15b1788b8d = (parcelRequire("aQiCw"));

$286957924457d65e$export$26e5786e8ac8e530 = (parcelRequire("lBvlt"));

$286957924457d65e$export$cc8859615686b300 = (parcelRequire("64Wrq"));

$286957924457d65e$export$8ad3f227af08fcc5 = (parcelRequire("fZgap"));

$286957924457d65e$export$947646e34766044f = (parcelRequire("4Pmey"));

});
parcelRegister("aQiCw", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $7e4d3450c11ec802$export$cfaef8ed399428b0, (v) => $7e4d3450c11ec802$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $7e4d3450c11ec802$export$a80c7deaea7cbd80, (v) => $7e4d3450c11ec802$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $7e4d3450c11ec802$export$ed7577ae6e1cd0ef, (v) => $7e4d3450c11ec802$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $7e4d3450c11ec802$export$5dcbef3aa594f567, (v) => $7e4d3450c11ec802$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $7e4d3450c11ec802$export$5bc8001ca71ed9c5, (v) => $7e4d3450c11ec802$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $7e4d3450c11ec802$export$3e714e2c5d5d8cb2, (v) => $7e4d3450c11ec802$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $7e4d3450c11ec802$export$94c3e544fd062b7f, (v) => $7e4d3450c11ec802$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $7e4d3450c11ec802$export$9f77e0932fb78f72, (v) => $7e4d3450c11ec802$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $7e4d3450c11ec802$export$d865ce2836f5927f, (v) => $7e4d3450c11ec802$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $7e4d3450c11ec802$export$95e62ad65da8b7d2, (v) => $7e4d3450c11ec802$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $7e4d3450c11ec802$export$209139ff098c441a, (v) => $7e4d3450c11ec802$export$209139ff098c441a = v);
var $7e4d3450c11ec802$export$cfaef8ed399428b0;
var $7e4d3450c11ec802$export$a80c7deaea7cbd80;
var $7e4d3450c11ec802$export$ed7577ae6e1cd0ef;
var $7e4d3450c11ec802$export$5dcbef3aa594f567;
var $7e4d3450c11ec802$export$5bc8001ca71ed9c5;
var $7e4d3450c11ec802$export$3e714e2c5d5d8cb2;
var $7e4d3450c11ec802$export$94c3e544fd062b7f;
var $7e4d3450c11ec802$export$9f77e0932fb78f72;
var $7e4d3450c11ec802$export$d865ce2836f5927f;
var $7e4d3450c11ec802$export$95e62ad65da8b7d2;
var $7e4d3450c11ec802$export$209139ff098c441a;
'use strict';
$7e4d3450c11ec802$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7e4d3450c11ec802$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7e4d3450c11ec802$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7e4d3450c11ec802$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7e4d3450c11ec802$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7e4d3450c11ec802$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7e4d3450c11ec802$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7e4d3450c11ec802$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7e4d3450c11ec802$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7e4d3450c11ec802$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7e4d3450c11ec802$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7e4d3450c11ec802$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7e4d3450c11ec802$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7e4d3450c11ec802$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7e4d3450c11ec802$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7e4d3450c11ec802$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7e4d3450c11ec802$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7e4d3450c11ec802$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7e4d3450c11ec802$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7e4d3450c11ec802$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7e4d3450c11ec802$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7e4d3450c11ec802$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("lBvlt", function(module, exports) {
'use strict';

var $cRsPH = parcelRequire("cRsPH");
function $fba55e33427ff3ae$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $fba55e33427ff3ae$var$Cipher;
$fba55e33427ff3ae$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$fba55e33427ff3ae$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$fba55e33427ff3ae$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$fba55e33427ff3ae$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$fba55e33427ff3ae$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$fba55e33427ff3ae$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$fba55e33427ff3ae$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$fba55e33427ff3ae$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$fba55e33427ff3ae$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$fba55e33427ff3ae$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$fba55e33427ff3ae$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $cRsPH.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("cRsPH", function(module, exports) {
module.exports = $95d0ccddc4bd4924$var$assert;
function $95d0ccddc4bd4924$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$95d0ccddc4bd4924$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("64Wrq", function(module, exports) {
'use strict';

var $cRsPH = parcelRequire("cRsPH");

var $9YOog = parcelRequire("9YOog");

var $aQiCw = parcelRequire("aQiCw");

var $lBvlt = parcelRequire("lBvlt");
function $46d0730617403202$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $46d0730617403202$var$DES(options) {
    $lBvlt.call(this, options);
    var state = new $46d0730617403202$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$9YOog($46d0730617403202$var$DES, $lBvlt);
module.exports = $46d0730617403202$var$DES;
$46d0730617403202$var$DES.create = function create(options) {
    return new $46d0730617403202$var$DES(options);
};
var $46d0730617403202$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$46d0730617403202$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $cRsPH.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aQiCw.readUInt32BE(key, 0);
    var kR = $aQiCw.readUInt32BE(key, 4);
    $aQiCw.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $46d0730617403202$var$shiftTable[i >>> 1];
        kL = $aQiCw.r28shl(kL, shift);
        kR = $aQiCw.r28shl(kR, shift);
        $aQiCw.pc2(kL, kR, state.keys, i);
    }
};
$46d0730617403202$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aQiCw.readUInt32BE(inp, inOff);
    var r = $aQiCw.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aQiCw.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aQiCw.writeUInt32BE(out, l, outOff);
    $aQiCw.writeUInt32BE(out, r, outOff + 4);
};
$46d0730617403202$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$46d0730617403202$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$cRsPH.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$46d0730617403202$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aQiCw.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aQiCw.substitute(keyL, keyR);
        var f = $aQiCw.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aQiCw.rip(r, l, out, off);
};
$46d0730617403202$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aQiCw.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aQiCw.substitute(keyL, keyR);
        var f = $aQiCw.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aQiCw.rip(l, r, out, off);
};

});

parcelRegister("fZgap", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $ba3917e8ed248099$export$f9bb8d20ccc7477a, (v) => $ba3917e8ed248099$export$f9bb8d20ccc7477a = v);
var $ba3917e8ed248099$export$f9bb8d20ccc7477a;
'use strict';

var $cRsPH = parcelRequire("cRsPH");

var $9YOog = parcelRequire("9YOog");
var $ba3917e8ed248099$var$proto = {};
function $ba3917e8ed248099$var$CBCState(iv) {
    $cRsPH.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $ba3917e8ed248099$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $9YOog(CBC, Base);
    var keys = Object.keys($ba3917e8ed248099$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $ba3917e8ed248099$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$ba3917e8ed248099$export$f9bb8d20ccc7477a = $ba3917e8ed248099$var$instantiate;
$ba3917e8ed248099$var$proto._cbcInit = function _cbcInit() {
    var state = new $ba3917e8ed248099$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$ba3917e8ed248099$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("4Pmey", function(module, exports) {
'use strict';

var $cRsPH = parcelRequire("cRsPH");

var $9YOog = parcelRequire("9YOog");

var $lBvlt = parcelRequire("lBvlt");

var $64Wrq = parcelRequire("64Wrq");
function $383d2bfef5ef2e0c$var$EDEState(type, key) {
    $cRsPH.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $64Wrq.create({
            type: 'encrypt',
            key: k1
        }),
        $64Wrq.create({
            type: 'decrypt',
            key: k2
        }),
        $64Wrq.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $64Wrq.create({
            type: 'decrypt',
            key: k3
        }),
        $64Wrq.create({
            type: 'encrypt',
            key: k2
        }),
        $64Wrq.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $383d2bfef5ef2e0c$var$EDE(options) {
    $lBvlt.call(this, options);
    var state = new $383d2bfef5ef2e0c$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$9YOog($383d2bfef5ef2e0c$var$EDE, $lBvlt);
module.exports = $383d2bfef5ef2e0c$var$EDE;
$383d2bfef5ef2e0c$var$EDE.create = function create(options) {
    return new $383d2bfef5ef2e0c$var$EDE(options);
};
$383d2bfef5ef2e0c$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$383d2bfef5ef2e0c$var$EDE.prototype._pad = $64Wrq.prototype._pad;
$383d2bfef5ef2e0c$var$EDE.prototype._unpad = $64Wrq.prototype._unpad;

});



parcelRegister("BxYCC", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $070dcfe546d7807b$export$2f64596b8cbf08b4, (v) => $070dcfe546d7807b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $070dcfe546d7807b$export$36b6d6ef312eab39, (v) => $070dcfe546d7807b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $070dcfe546d7807b$export$58a258485f1e49f6, (v) => $070dcfe546d7807b$export$58a258485f1e49f6 = v);
var $070dcfe546d7807b$export$bdd223f16383713e;
var $070dcfe546d7807b$export$26e5786e8ac8e530;
var $070dcfe546d7807b$export$2f64596b8cbf08b4;
var $070dcfe546d7807b$export$20533d26f07f1ee0;
var $070dcfe546d7807b$export$12ada9414fbc594c;
var $070dcfe546d7807b$export$2ce6d8d0e8b04e1a;
var $070dcfe546d7807b$export$36b6d6ef312eab39;
var $070dcfe546d7807b$export$f5e7e39d57cd9700;
var $070dcfe546d7807b$export$dedd8dc3dc62b370;
var $070dcfe546d7807b$export$58a258485f1e49f6;

var $4oOVm = parcelRequire("4oOVm");

var $hjpuy = parcelRequire("hjpuy");

var $6Gscd = parcelRequire("6Gscd");
function $070dcfe546d7807b$var$getCiphers() {
    return Object.keys($6Gscd);
}
$070dcfe546d7807b$export$bdd223f16383713e = $070dcfe546d7807b$export$26e5786e8ac8e530 = $4oOVm.createCipher;
$070dcfe546d7807b$export$2f64596b8cbf08b4 = $070dcfe546d7807b$export$20533d26f07f1ee0 = $4oOVm.createCipheriv;
$070dcfe546d7807b$export$12ada9414fbc594c = $070dcfe546d7807b$export$2ce6d8d0e8b04e1a = $hjpuy.createDecipher;
$070dcfe546d7807b$export$36b6d6ef312eab39 = $070dcfe546d7807b$export$f5e7e39d57cd9700 = $hjpuy.createDecipheriv;
$070dcfe546d7807b$export$dedd8dc3dc62b370 = $070dcfe546d7807b$export$58a258485f1e49f6 = $070dcfe546d7807b$var$getCiphers;

});
parcelRegister("4oOVm", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $3340e7c62c4ffe87$export$2f64596b8cbf08b4, (v) => $3340e7c62c4ffe87$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $3340e7c62c4ffe87$export$bdd223f16383713e, (v) => $3340e7c62c4ffe87$export$bdd223f16383713e = v);
var $3340e7c62c4ffe87$export$2f64596b8cbf08b4;
var $3340e7c62c4ffe87$export$bdd223f16383713e;

var $6CiMW = parcelRequire("6CiMW");

var $9xftu = parcelRequire("9xftu");

var $jcTxY = parcelRequire("jcTxY");
var $3340e7c62c4ffe87$require$Buffer = $jcTxY.Buffer;

var $bN4t1 = parcelRequire("bN4t1");

var $hp0y4 = parcelRequire("hp0y4");

var $lWgaG = parcelRequire("lWgaG");

var $5Gvmk = parcelRequire("5Gvmk");

var $9YOog = parcelRequire("9YOog");
function $3340e7c62c4ffe87$var$Cipher(mode, key, iv) {
    $hp0y4.call(this);
    this._cache = new $3340e7c62c4ffe87$var$Splitter();
    this._cipher = new $lWgaG.AES(key);
    this._prev = $3340e7c62c4ffe87$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$9YOog($3340e7c62c4ffe87$var$Cipher, $hp0y4);
$3340e7c62c4ffe87$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3340e7c62c4ffe87$require$Buffer.concat(out);
};
var $3340e7c62c4ffe87$var$PADDING = $3340e7c62c4ffe87$require$Buffer.alloc(16, 0x10);
$3340e7c62c4ffe87$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3340e7c62c4ffe87$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$3340e7c62c4ffe87$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3340e7c62c4ffe87$var$Splitter() {
    this.cache = $3340e7c62c4ffe87$require$Buffer.allocUnsafe(0);
}
$3340e7c62c4ffe87$var$Splitter.prototype.add = function(data) {
    this.cache = $3340e7c62c4ffe87$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3340e7c62c4ffe87$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3340e7c62c4ffe87$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3340e7c62c4ffe87$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3340e7c62c4ffe87$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3340e7c62c4ffe87$var$createCipheriv(suite, password, iv) {
    var config = $6CiMW[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $3340e7c62c4ffe87$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $3340e7c62c4ffe87$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $bN4t1(config.module, password, iv);
    else if (config.type === 'auth') return new $9xftu(config.module, password, iv);
    return new $3340e7c62c4ffe87$var$Cipher(config.module, password, iv);
}
function $3340e7c62c4ffe87$var$createCipher(suite, password) {
    var config = $6CiMW[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $5Gvmk(password, false, config.key, config.iv);
    return $3340e7c62c4ffe87$var$createCipheriv(suite, keys.key, keys.iv);
}
$3340e7c62c4ffe87$export$2f64596b8cbf08b4 = $3340e7c62c4ffe87$var$createCipheriv;
$3340e7c62c4ffe87$export$bdd223f16383713e = $3340e7c62c4ffe87$var$createCipher;

});
parcelRegister("6CiMW", function(module, exports) {








var $4d14ddadb9384bca$var$modeModules = {
    ECB: (parcelRequire("bD4Ih")),
    CBC: (parcelRequire("kOjSz")),
    CFB: (parcelRequire("1Yt5u")),
    CFB8: (parcelRequire("5eZuP")),
    CFB1: (parcelRequire("4fdVK")),
    OFB: (parcelRequire("hLFcM")),
    CTR: (parcelRequire("3jYkz")),
    GCM: (parcelRequire("3jYkz"))
};

var $6Gscd = parcelRequire("6Gscd");
for(var $4d14ddadb9384bca$var$key in $6Gscd)$6Gscd[$4d14ddadb9384bca$var$key].module = $4d14ddadb9384bca$var$modeModules[$6Gscd[$4d14ddadb9384bca$var$key].mode];
module.exports = $6Gscd;

});
parcelRegister("bD4Ih", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $8776fe2fc26dd54a$export$5b0f6292f11d1d18, (v) => $8776fe2fc26dd54a$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $8776fe2fc26dd54a$export$e85a0c9a1067c5d3, (v) => $8776fe2fc26dd54a$export$e85a0c9a1067c5d3 = v);
var $8776fe2fc26dd54a$export$5b0f6292f11d1d18;
var $8776fe2fc26dd54a$export$e85a0c9a1067c5d3;
$8776fe2fc26dd54a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$8776fe2fc26dd54a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("kOjSz", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $f267e5c017a162b3$export$5b0f6292f11d1d18, (v) => $f267e5c017a162b3$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $f267e5c017a162b3$export$e85a0c9a1067c5d3, (v) => $f267e5c017a162b3$export$e85a0c9a1067c5d3 = v);
var $f267e5c017a162b3$export$5b0f6292f11d1d18;
var $f267e5c017a162b3$export$e85a0c9a1067c5d3;

var $aHAzP = parcelRequire("aHAzP");
$f267e5c017a162b3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $aHAzP(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$f267e5c017a162b3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $aHAzP(out, pad);
};

});
parcelRegister("aHAzP", function(module, exports) {

var $kFATv = parcelRequire("kFATv");
var $7caa4af27e2b76e8$require$Buffer = $kFATv.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $7caa4af27e2b76e8$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("1Yt5u", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $1701f53878cc1acd$export$5b0f6292f11d1d18, (v) => $1701f53878cc1acd$export$5b0f6292f11d1d18 = v);
var $1701f53878cc1acd$export$5b0f6292f11d1d18;

var $jcTxY = parcelRequire("jcTxY");
var $1701f53878cc1acd$require$Buffer = $jcTxY.Buffer;

var $aHAzP = parcelRequire("aHAzP");
function $1701f53878cc1acd$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $aHAzP(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $1701f53878cc1acd$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$1701f53878cc1acd$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $1701f53878cc1acd$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $1701f53878cc1acd$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $1701f53878cc1acd$require$Buffer.concat([
                out,
                $1701f53878cc1acd$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $1701f53878cc1acd$require$Buffer.concat([
                out,
                $1701f53878cc1acd$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("5eZuP", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $3d0df66740aa0a53$export$5b0f6292f11d1d18, (v) => $3d0df66740aa0a53$export$5b0f6292f11d1d18 = v);
var $3d0df66740aa0a53$export$5b0f6292f11d1d18;

var $jcTxY = parcelRequire("jcTxY");
var $3d0df66740aa0a53$require$Buffer = $jcTxY.Buffer;
function $3d0df66740aa0a53$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $3d0df66740aa0a53$require$Buffer.concat([
        self._prev.slice(1),
        $3d0df66740aa0a53$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$3d0df66740aa0a53$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $3d0df66740aa0a53$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $3d0df66740aa0a53$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("4fdVK", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $31735e6c39b411b5$export$5b0f6292f11d1d18, (v) => $31735e6c39b411b5$export$5b0f6292f11d1d18 = v);
var $31735e6c39b411b5$export$5b0f6292f11d1d18;

var $jcTxY = parcelRequire("jcTxY");
var $31735e6c39b411b5$require$Buffer = $jcTxY.Buffer;
function $31735e6c39b411b5$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $31735e6c39b411b5$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $31735e6c39b411b5$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $31735e6c39b411b5$require$Buffer.allocUnsafe(buffer.length);
    buffer = $31735e6c39b411b5$require$Buffer.concat([
        buffer,
        $31735e6c39b411b5$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$31735e6c39b411b5$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $31735e6c39b411b5$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $31735e6c39b411b5$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("hLFcM", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $cef6c9efca519990$export$5b0f6292f11d1d18, (v) => $cef6c9efca519990$export$5b0f6292f11d1d18 = v);
var $cef6c9efca519990$export$5b0f6292f11d1d18;

var $kFATv = parcelRequire("kFATv");
var $cef6c9efca519990$require$Buffer = $kFATv.Buffer;

var $aHAzP = parcelRequire("aHAzP");
function $cef6c9efca519990$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$cef6c9efca519990$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $cef6c9efca519990$require$Buffer.concat([
        self._cache,
        $cef6c9efca519990$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $aHAzP(chunk, pad);
};

});

parcelRegister("3jYkz", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $26b1f1db6bb980f6$export$5b0f6292f11d1d18, (v) => $26b1f1db6bb980f6$export$5b0f6292f11d1d18 = v);
var $26b1f1db6bb980f6$export$5b0f6292f11d1d18;

var $aHAzP = parcelRequire("aHAzP");

var $jcTxY = parcelRequire("jcTxY");
var $26b1f1db6bb980f6$require$Buffer = $jcTxY.Buffer;

var $9SIH2 = parcelRequire("9SIH2");
function $26b1f1db6bb980f6$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $9SIH2(self._prev);
    return out;
}
var $26b1f1db6bb980f6$var$blockSize = 16;
$26b1f1db6bb980f6$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $26b1f1db6bb980f6$var$blockSize);
    var start = self._cache.length;
    self._cache = $26b1f1db6bb980f6$require$Buffer.concat([
        self._cache,
        $26b1f1db6bb980f6$require$Buffer.allocUnsafe(chunkNum * $26b1f1db6bb980f6$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $26b1f1db6bb980f6$var$getBlock(self);
        var offset = start + i * $26b1f1db6bb980f6$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $aHAzP(chunk, pad);
};

});
parcelRegister("9SIH2", function(module, exports) {
function $731bd35064ab84ca$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $731bd35064ab84ca$var$incr32;

});


parcelRegister("6Gscd", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("9xftu", function(module, exports) {

var $lWgaG = parcelRequire("lWgaG");

var $jcTxY = parcelRequire("jcTxY");
var $6f13330cc4262852$require$Buffer = $jcTxY.Buffer;

var $hp0y4 = parcelRequire("hp0y4");

var $9YOog = parcelRequire("9YOog");

var $4pdhZ = parcelRequire("4pdhZ");

var $aHAzP = parcelRequire("aHAzP");

var $9SIH2 = parcelRequire("9SIH2");
function $6f13330cc4262852$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $6f13330cc4262852$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $6f13330cc4262852$require$Buffer.concat([
            iv,
            $6f13330cc4262852$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $6f13330cc4262852$require$Buffer.concat([
            iv,
            $6f13330cc4262852$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $4pdhZ(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($6f13330cc4262852$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($6f13330cc4262852$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $6f13330cc4262852$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $6f13330cc4262852$require$Buffer.from(self._finID);
    $9SIH2(out);
    return out;
}
function $6f13330cc4262852$var$StreamCipher(mode, key, iv, decrypt) {
    $hp0y4.call(this);
    var h = $6f13330cc4262852$require$Buffer.alloc(4, 0);
    this._cipher = new $lWgaG.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $4pdhZ(ck);
    iv = $6f13330cc4262852$var$calcIv(this, iv, ck);
    this._prev = $6f13330cc4262852$require$Buffer.from(iv);
    this._cache = $6f13330cc4262852$require$Buffer.allocUnsafe(0);
    this._secCache = $6f13330cc4262852$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$9YOog($6f13330cc4262852$var$StreamCipher, $hp0y4);
$6f13330cc4262852$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $6f13330cc4262852$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$6f13330cc4262852$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $aHAzP(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $6f13330cc4262852$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$6f13330cc4262852$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$6f13330cc4262852$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$6f13330cc4262852$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$6f13330cc4262852$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $6f13330cc4262852$var$StreamCipher;

});
parcelRegister("lWgaG", function(module, exports) {

$parcel$export(module.exports, "AES", () => $ff8b8f0f9d306e46$export$b80fbe1c3a2b92b5, (v) => $ff8b8f0f9d306e46$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $ff8b8f0f9d306e46$export$b80fbe1c3a2b92b5;

var $jcTxY = parcelRequire("jcTxY");
var $ff8b8f0f9d306e46$require$Buffer = $jcTxY.Buffer;
function $ff8b8f0f9d306e46$var$asUInt32Array(buf) {
    if (!$ff8b8f0f9d306e46$require$Buffer.isBuffer(buf)) buf = $ff8b8f0f9d306e46$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $ff8b8f0f9d306e46$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $ff8b8f0f9d306e46$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $ff8b8f0f9d306e46$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $ff8b8f0f9d306e46$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $ff8b8f0f9d306e46$var$AES(key) {
    this._key = $ff8b8f0f9d306e46$var$asUInt32Array(key);
    this._reset();
}
$ff8b8f0f9d306e46$var$AES.blockSize = 16;
$ff8b8f0f9d306e46$var$AES.keySize = 32;
$ff8b8f0f9d306e46$var$AES.prototype.blockSize = $ff8b8f0f9d306e46$var$AES.blockSize;
$ff8b8f0f9d306e46$var$AES.prototype.keySize = $ff8b8f0f9d306e46$var$AES.keySize;
$ff8b8f0f9d306e46$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $ff8b8f0f9d306e46$var$G.SBOX[t >>> 24] << 24 | $ff8b8f0f9d306e46$var$G.SBOX[t >>> 16 & 0xff] << 16 | $ff8b8f0f9d306e46$var$G.SBOX[t >>> 8 & 0xff] << 8 | $ff8b8f0f9d306e46$var$G.SBOX[t & 0xff];
            t ^= $ff8b8f0f9d306e46$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $ff8b8f0f9d306e46$var$G.SBOX[t >>> 24] << 24 | $ff8b8f0f9d306e46$var$G.SBOX[t >>> 16 & 0xff] << 16 | $ff8b8f0f9d306e46$var$G.SBOX[t >>> 8 & 0xff] << 8 | $ff8b8f0f9d306e46$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $ff8b8f0f9d306e46$var$G.INV_SUB_MIX[0][$ff8b8f0f9d306e46$var$G.SBOX[tt >>> 24]] ^ $ff8b8f0f9d306e46$var$G.INV_SUB_MIX[1][$ff8b8f0f9d306e46$var$G.SBOX[tt >>> 16 & 0xff]] ^ $ff8b8f0f9d306e46$var$G.INV_SUB_MIX[2][$ff8b8f0f9d306e46$var$G.SBOX[tt >>> 8 & 0xff]] ^ $ff8b8f0f9d306e46$var$G.INV_SUB_MIX[3][$ff8b8f0f9d306e46$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$ff8b8f0f9d306e46$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $ff8b8f0f9d306e46$var$asUInt32Array(M);
    return $ff8b8f0f9d306e46$var$cryptBlock(M, this._keySchedule, $ff8b8f0f9d306e46$var$G.SUB_MIX, $ff8b8f0f9d306e46$var$G.SBOX, this._nRounds);
};
$ff8b8f0f9d306e46$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $ff8b8f0f9d306e46$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$ff8b8f0f9d306e46$var$AES.prototype.decryptBlock = function(M) {
    M = $ff8b8f0f9d306e46$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $ff8b8f0f9d306e46$var$cryptBlock(M, this._invKeySchedule, $ff8b8f0f9d306e46$var$G.INV_SUB_MIX, $ff8b8f0f9d306e46$var$G.INV_SBOX, this._nRounds);
    var buf = $ff8b8f0f9d306e46$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$ff8b8f0f9d306e46$var$AES.prototype.scrub = function() {
    $ff8b8f0f9d306e46$var$scrubVec(this._keySchedule);
    $ff8b8f0f9d306e46$var$scrubVec(this._invKeySchedule);
    $ff8b8f0f9d306e46$var$scrubVec(this._key);
};
$ff8b8f0f9d306e46$export$b80fbe1c3a2b92b5 = $ff8b8f0f9d306e46$var$AES;

});

parcelRegister("4pdhZ", function(module, exports) {

var $jcTxY = parcelRequire("jcTxY");
var $3353ce2cd666f775$require$Buffer = $jcTxY.Buffer;
var $3353ce2cd666f775$var$ZEROES = $3353ce2cd666f775$require$Buffer.alloc(16, 0);
function $3353ce2cd666f775$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $3353ce2cd666f775$var$fromArray(out) {
    var buf = $3353ce2cd666f775$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $3353ce2cd666f775$var$GHASH(key) {
    this.h = key;
    this.state = $3353ce2cd666f775$require$Buffer.alloc(16, 0);
    this.cache = $3353ce2cd666f775$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$3353ce2cd666f775$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$3353ce2cd666f775$var$GHASH.prototype._multiply = function() {
    var Vi = $3353ce2cd666f775$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $3353ce2cd666f775$var$fromArray(Zi);
};
$3353ce2cd666f775$var$GHASH.prototype.update = function(buf) {
    this.cache = $3353ce2cd666f775$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$3353ce2cd666f775$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($3353ce2cd666f775$require$Buffer.concat([
        this.cache,
        $3353ce2cd666f775$var$ZEROES
    ], 16));
    this.ghash($3353ce2cd666f775$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $3353ce2cd666f775$var$GHASH;

});


parcelRegister("bN4t1", function(module, exports) {

var $lWgaG = parcelRequire("lWgaG");

var $jcTxY = parcelRequire("jcTxY");
var $8957bc62928969f7$require$Buffer = $jcTxY.Buffer;

var $hp0y4 = parcelRequire("hp0y4");

var $9YOog = parcelRequire("9YOog");
function $8957bc62928969f7$var$StreamCipher(mode, key, iv, decrypt) {
    $hp0y4.call(this);
    this._cipher = new $lWgaG.AES(key);
    this._prev = $8957bc62928969f7$require$Buffer.from(iv);
    this._cache = $8957bc62928969f7$require$Buffer.allocUnsafe(0);
    this._secCache = $8957bc62928969f7$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$9YOog($8957bc62928969f7$var$StreamCipher, $hp0y4);
$8957bc62928969f7$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$8957bc62928969f7$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $8957bc62928969f7$var$StreamCipher;

});

parcelRegister("5Gvmk", function(module, exports) {

var $jcTxY = parcelRequire("jcTxY");
var $4239333e5f212f19$require$Buffer = $jcTxY.Buffer;

var $gxyGg = parcelRequire("gxyGg");
/* eslint-disable camelcase */ function $4239333e5f212f19$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$4239333e5f212f19$require$Buffer.isBuffer(password)) password = $4239333e5f212f19$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$4239333e5f212f19$require$Buffer.isBuffer(salt)) salt = $4239333e5f212f19$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $4239333e5f212f19$require$Buffer.alloc(keyLen);
    var iv = $4239333e5f212f19$require$Buffer.alloc(ivLen || 0);
    var tmp = $4239333e5f212f19$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $gxyGg();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $4239333e5f212f19$var$EVP_BytesToKey;

});


parcelRegister("hjpuy", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $c9a7fc2ed49463e5$export$12ada9414fbc594c, (v) => $c9a7fc2ed49463e5$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $c9a7fc2ed49463e5$export$36b6d6ef312eab39, (v) => $c9a7fc2ed49463e5$export$36b6d6ef312eab39 = v);
var $c9a7fc2ed49463e5$export$12ada9414fbc594c;
var $c9a7fc2ed49463e5$export$36b6d6ef312eab39;

var $9xftu = parcelRequire("9xftu");

var $jcTxY = parcelRequire("jcTxY");
var $c9a7fc2ed49463e5$require$Buffer = $jcTxY.Buffer;

var $6CiMW = parcelRequire("6CiMW");

var $bN4t1 = parcelRequire("bN4t1");

var $hp0y4 = parcelRequire("hp0y4");

var $lWgaG = parcelRequire("lWgaG");

var $5Gvmk = parcelRequire("5Gvmk");

var $9YOog = parcelRequire("9YOog");
function $c9a7fc2ed49463e5$var$Decipher(mode, key, iv) {
    $hp0y4.call(this);
    this._cache = new $c9a7fc2ed49463e5$var$Splitter();
    this._last = void 0;
    this._cipher = new $lWgaG.AES(key);
    this._prev = $c9a7fc2ed49463e5$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$9YOog($c9a7fc2ed49463e5$var$Decipher, $hp0y4);
$c9a7fc2ed49463e5$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $c9a7fc2ed49463e5$require$Buffer.concat(out);
};
$c9a7fc2ed49463e5$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $c9a7fc2ed49463e5$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$c9a7fc2ed49463e5$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $c9a7fc2ed49463e5$var$Splitter() {
    this.cache = $c9a7fc2ed49463e5$require$Buffer.allocUnsafe(0);
}
$c9a7fc2ed49463e5$var$Splitter.prototype.add = function(data) {
    this.cache = $c9a7fc2ed49463e5$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$c9a7fc2ed49463e5$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$c9a7fc2ed49463e5$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $c9a7fc2ed49463e5$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $c9a7fc2ed49463e5$var$createDecipheriv(suite, password, iv) {
    var config = $6CiMW[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $c9a7fc2ed49463e5$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $c9a7fc2ed49463e5$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $bN4t1(config.module, password, iv, true);
    else if (config.type === 'auth') return new $9xftu(config.module, password, iv, true);
    return new $c9a7fc2ed49463e5$var$Decipher(config.module, password, iv);
}
function $c9a7fc2ed49463e5$var$createDecipher(suite, password) {
    var config = $6CiMW[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $5Gvmk(password, false, config.key, config.iv);
    return $c9a7fc2ed49463e5$var$createDecipheriv(suite, keys.key, keys.iv);
}
$c9a7fc2ed49463e5$export$12ada9414fbc594c = $c9a7fc2ed49463e5$var$createDecipher;
$c9a7fc2ed49463e5$export$36b6d6ef312eab39 = $c9a7fc2ed49463e5$var$createDecipheriv;

});


parcelRegister("kpwxT", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $edbf635cef394f10$export$116f8a5cee447347, (v) => $edbf635cef394f10$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $edbf635cef394f10$export$7483c4066bfb7ae9, (v) => $edbf635cef394f10$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $edbf635cef394f10$export$e7a565d2e588bb06, (v) => $edbf635cef394f10$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $edbf635cef394f10$export$aaa2f54a426f3eb8, (v) => $edbf635cef394f10$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $edbf635cef394f10$export$eba20568dde4ada, (v) => $edbf635cef394f10$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $edbf635cef394f10$export$d3b5e5996938f5ae, (v) => $edbf635cef394f10$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $edbf635cef394f10$export$57c08356130bc99b, (v) => $edbf635cef394f10$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $edbf635cef394f10$export$c7169791d5c1e65d, (v) => $edbf635cef394f10$export$c7169791d5c1e65d = v);
var $edbf635cef394f10$export$116f8a5cee447347;
var $edbf635cef394f10$export$7483c4066bfb7ae9;
var $edbf635cef394f10$export$e7a565d2e588bb06;
var $edbf635cef394f10$export$aaa2f54a426f3eb8;
var $edbf635cef394f10$export$eba20568dde4ada;
var $edbf635cef394f10$export$d3b5e5996938f5ae;
var $edbf635cef394f10$export$57c08356130bc99b;
var $edbf635cef394f10$export$c7169791d5c1e65d;
$edbf635cef394f10$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$edbf635cef394f10$export$7483c4066bfb7ae9 = $edbf635cef394f10$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$edbf635cef394f10$export$aaa2f54a426f3eb8 = $edbf635cef394f10$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$edbf635cef394f10$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$edbf635cef394f10$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$edbf635cef394f10$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("4JeX9", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $3716f6c5cac6e992$export$971862a2fcb1bb40, (v) => $3716f6c5cac6e992$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $3716f6c5cac6e992$export$c6ff6a88acbeaf40, (v) => $3716f6c5cac6e992$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $3716f6c5cac6e992$export$fdc27893e98845cc, (v) => $3716f6c5cac6e992$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $3716f6c5cac6e992$export$6671fb9a1323bed, (v) => $3716f6c5cac6e992$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $3716f6c5cac6e992$export$d74daf141a551db, (v) => $3716f6c5cac6e992$export$d74daf141a551db = v);
var $3716f6c5cac6e992$export$971862a2fcb1bb40;
var $3716f6c5cac6e992$export$c6ff6a88acbeaf40;
var $3716f6c5cac6e992$export$fdc27893e98845cc;
var $3716f6c5cac6e992$export$6671fb9a1323bed;
var $3716f6c5cac6e992$export$d74daf141a551db;

var $kFATv = parcelRequire("kFATv");
var $3716f6c5cac6e992$require$Buffer = $kFATv.Buffer;

var $gITR2 = parcelRequire("gITR2");

var $dgWII = parcelRequire("dgWII");

var $hFp8o = parcelRequire("hFp8o");
function $3716f6c5cac6e992$var$getDiffieHellman(mod) {
    var prime = new $3716f6c5cac6e992$require$Buffer($dgWII[mod].prime, 'hex');
    var gen = new $3716f6c5cac6e992$require$Buffer($dgWII[mod].gen, 'hex');
    return new $hFp8o(prime, gen);
}
var $3716f6c5cac6e992$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $3716f6c5cac6e992$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3716f6c5cac6e992$require$Buffer.isBuffer(enc) || $3716f6c5cac6e992$var$ENCODINGS[enc] === undefined) return $3716f6c5cac6e992$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $3716f6c5cac6e992$require$Buffer([
        2
    ]);
    if (!$3716f6c5cac6e992$require$Buffer.isBuffer(generator)) generator = new $3716f6c5cac6e992$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $hFp8o($gITR2(prime, generator), generator, true);
    if (!$3716f6c5cac6e992$require$Buffer.isBuffer(prime)) prime = new $3716f6c5cac6e992$require$Buffer(prime, enc);
    return new $hFp8o(prime, generator, true);
}
$3716f6c5cac6e992$export$971862a2fcb1bb40 = $3716f6c5cac6e992$export$c6ff6a88acbeaf40 = $3716f6c5cac6e992$export$fdc27893e98845cc = $3716f6c5cac6e992$var$getDiffieHellman;
$3716f6c5cac6e992$export$6671fb9a1323bed = $3716f6c5cac6e992$export$d74daf141a551db = $3716f6c5cac6e992$var$createDiffieHellman;

});
parcelRegister("gITR2", function(module, exports) {

var $4WS9C = parcelRequire("4WS9C");
module.exports = $c2cc14e8dcbc9f8f$var$findPrime;
$c2cc14e8dcbc9f8f$var$findPrime.simpleSieve = $c2cc14e8dcbc9f8f$var$simpleSieve;
$c2cc14e8dcbc9f8f$var$findPrime.fermatTest = $c2cc14e8dcbc9f8f$var$fermatTest;

var $anLPs = parcelRequire("anLPs");
var $c2cc14e8dcbc9f8f$var$TWENTYFOUR = new $anLPs(24);

var $afnxx = parcelRequire("afnxx");
var $c2cc14e8dcbc9f8f$var$millerRabin = new $afnxx();
var $c2cc14e8dcbc9f8f$var$ONE = new $anLPs(1);
var $c2cc14e8dcbc9f8f$var$TWO = new $anLPs(2);
var $c2cc14e8dcbc9f8f$var$FIVE = new $anLPs(5);
var $c2cc14e8dcbc9f8f$var$SIXTEEN = new $anLPs(16);
var $c2cc14e8dcbc9f8f$var$EIGHT = new $anLPs(8);
var $c2cc14e8dcbc9f8f$var$TEN = new $anLPs(10);
var $c2cc14e8dcbc9f8f$var$THREE = new $anLPs(3);
var $c2cc14e8dcbc9f8f$var$SEVEN = new $anLPs(7);
var $c2cc14e8dcbc9f8f$var$ELEVEN = new $anLPs(11);
var $c2cc14e8dcbc9f8f$var$FOUR = new $anLPs(4);
var $c2cc14e8dcbc9f8f$var$TWELVE = new $anLPs(12);
var $c2cc14e8dcbc9f8f$var$primes = null;
function $c2cc14e8dcbc9f8f$var$_getPrimes() {
    if ($c2cc14e8dcbc9f8f$var$primes !== null) return $c2cc14e8dcbc9f8f$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $c2cc14e8dcbc9f8f$var$primes = res;
    return res;
}
function $c2cc14e8dcbc9f8f$var$simpleSieve(p) {
    var primes = $c2cc14e8dcbc9f8f$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $c2cc14e8dcbc9f8f$var$fermatTest(p) {
    var red = $anLPs.mont(p);
    return $c2cc14e8dcbc9f8f$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $c2cc14e8dcbc9f8f$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $anLPs([
            0x8c,
            0x7b
        ]);
        else return new $anLPs([
            0x8c,
            0x27
        ]);
    }
    gen = new $anLPs(gen);
    var num, n2;
    while(true){
        num = new $anLPs($4WS9C(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($c2cc14e8dcbc9f8f$var$ONE);
        if (!num.testn(1)) num.iadd($c2cc14e8dcbc9f8f$var$TWO);
        if (!gen.cmp($c2cc14e8dcbc9f8f$var$TWO)) while(num.mod($c2cc14e8dcbc9f8f$var$TWENTYFOUR).cmp($c2cc14e8dcbc9f8f$var$ELEVEN))num.iadd($c2cc14e8dcbc9f8f$var$FOUR);
        else if (!gen.cmp($c2cc14e8dcbc9f8f$var$FIVE)) while(num.mod($c2cc14e8dcbc9f8f$var$TEN).cmp($c2cc14e8dcbc9f8f$var$THREE))num.iadd($c2cc14e8dcbc9f8f$var$FOUR);
        n2 = num.shrn(1);
        if ($c2cc14e8dcbc9f8f$var$simpleSieve(n2) && $c2cc14e8dcbc9f8f$var$simpleSieve(num) && $c2cc14e8dcbc9f8f$var$fermatTest(n2) && $c2cc14e8dcbc9f8f$var$fermatTest(num) && $c2cc14e8dcbc9f8f$var$millerRabin.test(n2) && $c2cc14e8dcbc9f8f$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("anLPs", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("1frus")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("afnxx", function(module, exports) {

var $anLPs = parcelRequire("anLPs");

var $efv6w = parcelRequire("efv6w");
function $775d90a5f5bb882e$var$MillerRabin(rand) {
    this.rand = rand || new $efv6w.Rand();
}
module.exports = $775d90a5f5bb882e$var$MillerRabin;
$775d90a5f5bb882e$var$MillerRabin.create = function create(rand) {
    return new $775d90a5f5bb882e$var$MillerRabin(rand);
};
$775d90a5f5bb882e$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $anLPs(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$775d90a5f5bb882e$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$775d90a5f5bb882e$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $anLPs.mont(n);
    var rone = new $anLPs(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $anLPs(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$775d90a5f5bb882e$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $anLPs.mont(n);
    var rone = new $anLPs(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $anLPs(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("efv6w", function(module, exports) {
var $a5fa980c37b087bb$var$r;
module.exports = function rand(len) {
    if (!$a5fa980c37b087bb$var$r) $a5fa980c37b087bb$var$r = new $a5fa980c37b087bb$var$Rand(null);
    return $a5fa980c37b087bb$var$r.generate(len);
};
function $a5fa980c37b087bb$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $a5fa980c37b087bb$var$Rand;
$a5fa980c37b087bb$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$a5fa980c37b087bb$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $a5fa980c37b087bb$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $a5fa980c37b087bb$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $a5fa980c37b087bb$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $a5fa980c37b087bb$var$crypto = (parcelRequire("1frus"));
    if (typeof $a5fa980c37b087bb$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $a5fa980c37b087bb$var$Rand.prototype._rand = function _rand(n) {
        return $a5fa980c37b087bb$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("dgWII", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("hFp8o", function(module, exports) {

var $kFATv = parcelRequire("kFATv");
var $cdc9c325e2951cfb$require$Buffer = $kFATv.Buffer;

var $anLPs = parcelRequire("anLPs");

var $afnxx = parcelRequire("afnxx");
var $cdc9c325e2951cfb$var$millerRabin = new $afnxx();
var $cdc9c325e2951cfb$var$TWENTYFOUR = new $anLPs(24);
var $cdc9c325e2951cfb$var$ELEVEN = new $anLPs(11);
var $cdc9c325e2951cfb$var$TEN = new $anLPs(10);
var $cdc9c325e2951cfb$var$THREE = new $anLPs(3);
var $cdc9c325e2951cfb$var$SEVEN = new $anLPs(7);

var $gITR2 = parcelRequire("gITR2");

var $4WS9C = parcelRequire("4WS9C");
module.exports = $cdc9c325e2951cfb$var$DH;
function $cdc9c325e2951cfb$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$cdc9c325e2951cfb$require$Buffer.isBuffer(pub)) pub = new $cdc9c325e2951cfb$require$Buffer(pub, enc);
    this._pub = new $anLPs(pub);
    return this;
}
function $cdc9c325e2951cfb$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$cdc9c325e2951cfb$require$Buffer.isBuffer(priv)) priv = new $cdc9c325e2951cfb$require$Buffer(priv, enc);
    this._priv = new $anLPs(priv);
    return this;
}
var $cdc9c325e2951cfb$var$primeCache = {};
function $cdc9c325e2951cfb$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $cdc9c325e2951cfb$var$primeCache) return $cdc9c325e2951cfb$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$gITR2.simpleSieve || !$gITR2.fermatTest(prime) || !$cdc9c325e2951cfb$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $cdc9c325e2951cfb$var$primeCache[hex] = error;
        return error;
    }
    if (!$cdc9c325e2951cfb$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($cdc9c325e2951cfb$var$TWENTYFOUR).cmp($cdc9c325e2951cfb$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($cdc9c325e2951cfb$var$TEN);
            if (rem.cmp($cdc9c325e2951cfb$var$THREE) && rem.cmp($cdc9c325e2951cfb$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $cdc9c325e2951cfb$var$primeCache[hex] = error;
    return error;
}
function $cdc9c325e2951cfb$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $anLPs(prime);
    this._prime = $anLPs.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $cdc9c325e2951cfb$var$setPublicKey;
        this.setPrivateKey = $cdc9c325e2951cfb$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($cdc9c325e2951cfb$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $cdc9c325e2951cfb$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$cdc9c325e2951cfb$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $anLPs($4WS9C(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$cdc9c325e2951cfb$var$DH.prototype.computeSecret = function(other) {
    other = new $anLPs(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $cdc9c325e2951cfb$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $cdc9c325e2951cfb$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $cdc9c325e2951cfb$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$cdc9c325e2951cfb$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $cdc9c325e2951cfb$var$formatReturnValue(this._pub, enc);
};
$cdc9c325e2951cfb$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $cdc9c325e2951cfb$var$formatReturnValue(this._priv, enc);
};
$cdc9c325e2951cfb$var$DH.prototype.getPrime = function(enc) {
    return $cdc9c325e2951cfb$var$formatReturnValue(this.__prime, enc);
};
$cdc9c325e2951cfb$var$DH.prototype.getGenerator = function(enc) {
    return $cdc9c325e2951cfb$var$formatReturnValue(this._gen, enc);
};
$cdc9c325e2951cfb$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$cdc9c325e2951cfb$require$Buffer.isBuffer(gen)) gen = new $cdc9c325e2951cfb$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $anLPs(gen);
    return this;
};
function $cdc9c325e2951cfb$var$formatReturnValue(bn, enc) {
    var buf = new $cdc9c325e2951cfb$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4E2yv", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $361ce152fb3144f4$require$Buffer = $jcTxY.Buffer;

var $7TQd3 = parcelRequire("7TQd3");

var $lLxrA = parcelRequire("lLxrA");

var $9YOog = parcelRequire("9YOog");

var $1R86F = parcelRequire("1R86F");

var $7rRmj = parcelRequire("7rRmj");

var $glb11 = parcelRequire("glb11");
Object.keys($glb11).forEach(function(key) {
    $glb11[key].id = $361ce152fb3144f4$require$Buffer.from($glb11[key].id, 'hex');
    $glb11[key.toLowerCase()] = $glb11[key];
});
function $361ce152fb3144f4$var$Sign(algorithm) {
    $lLxrA.Writable.call(this);
    var data = $glb11[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $7TQd3(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$9YOog($361ce152fb3144f4$var$Sign, $lLxrA.Writable);
$361ce152fb3144f4$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$361ce152fb3144f4$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $361ce152fb3144f4$require$Buffer.from(data, enc) : data);
    return this;
};
$361ce152fb3144f4$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $1R86F(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $361ce152fb3144f4$var$Verify(algorithm) {
    $lLxrA.Writable.call(this);
    var data = $glb11[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $7TQd3(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$9YOog($361ce152fb3144f4$var$Verify, $lLxrA.Writable);
$361ce152fb3144f4$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$361ce152fb3144f4$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $361ce152fb3144f4$require$Buffer.from(data, enc) : data);
    return this;
};
$361ce152fb3144f4$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $361ce152fb3144f4$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $7rRmj(sigBuffer, hash, key, this._signType, this._tag);
};
function $361ce152fb3144f4$var$createSign(algorithm) {
    return new $361ce152fb3144f4$var$Sign(algorithm);
}
function $361ce152fb3144f4$var$createVerify(algorithm) {
    return new $361ce152fb3144f4$var$Verify(algorithm);
}
module.exports = {
    Sign: $361ce152fb3144f4$var$createSign,
    Verify: $361ce152fb3144f4$var$createVerify,
    createSign: $361ce152fb3144f4$var$createSign,
    createVerify: $361ce152fb3144f4$var$createVerify
};

});
parcelRegister("1R86F", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $15a10773a02e1a72$require$Buffer = $jcTxY.Buffer;

var $4rFkN = parcelRequire("4rFkN");

var $73LXI = parcelRequire("73LXI");

var $9XWzf = parcelRequire("9XWzf");
var $15a10773a02e1a72$require$EC = $9XWzf.ec;

var $iogP6 = parcelRequire("iogP6");

var $1mhER = parcelRequire("1mhER");

var $81ACA = parcelRequire("81ACA");
var $15a10773a02e1a72$var$RSA_PKCS1_PADDING = 1;
function $15a10773a02e1a72$var$sign(hash, key, hashType, signType, tag) {
    var priv = $1mhER(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $15a10773a02e1a72$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $15a10773a02e1a72$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $15a10773a02e1a72$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $15a10773a02e1a72$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $73LXI(pad, priv);
    return out;
}
function $15a10773a02e1a72$var$ecSign(hash, priv) {
    var curveId = $81ACA[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $15a10773a02e1a72$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $15a10773a02e1a72$require$Buffer.from(out.toDER());
}
function $15a10773a02e1a72$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $iogP6(0);
    var k;
    var H = $15a10773a02e1a72$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $15a10773a02e1a72$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $15a10773a02e1a72$var$makeKey(q, kv, algo);
        r = $15a10773a02e1a72$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $iogP6(0);
        }
    }
    return $15a10773a02e1a72$var$toDER(r, s);
}
function $15a10773a02e1a72$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $15a10773a02e1a72$require$Buffer.from(res);
}
function $15a10773a02e1a72$var$getKey(x, q, hash, algo) {
    x = $15a10773a02e1a72$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $15a10773a02e1a72$require$Buffer.alloc(q.byteLength() - x.length);
        x = $15a10773a02e1a72$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $15a10773a02e1a72$var$bits2octets(hash, q);
    var v = $15a10773a02e1a72$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $15a10773a02e1a72$require$Buffer.alloc(hlen);
    k = $4rFkN(algo, k).update(v).update($15a10773a02e1a72$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $4rFkN(algo, k).update(v).digest();
    k = $4rFkN(algo, k).update(v).update($15a10773a02e1a72$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $4rFkN(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $15a10773a02e1a72$var$bits2int(obits, q) {
    var bits = new $iogP6(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $15a10773a02e1a72$var$bits2octets(bits, q) {
    bits = $15a10773a02e1a72$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $15a10773a02e1a72$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $15a10773a02e1a72$require$Buffer.alloc(q.byteLength() - out.length);
        out = $15a10773a02e1a72$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $15a10773a02e1a72$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $15a10773a02e1a72$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $4rFkN(algo, kv.k).update(kv.v).digest();
            t = $15a10773a02e1a72$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $15a10773a02e1a72$var$bits2int(t, q);
        kv.k = $4rFkN(algo, kv.k).update(kv.v).update($15a10773a02e1a72$require$Buffer.from([
            0
        ])).digest();
        kv.v = $4rFkN(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $15a10773a02e1a72$var$makeR(g, k, p, q) {
    return g.toRed($iogP6.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $15a10773a02e1a72$var$sign;
module.exports.getKey = $15a10773a02e1a72$var$getKey;
module.exports.makeKey = $15a10773a02e1a72$var$makeKey;

});
parcelRegister("73LXI", function(module, exports) {
'use strict';

var $iogP6 = parcelRequire("iogP6");

var $4WS9C = parcelRequire("4WS9C");

var $jcTxY = parcelRequire("jcTxY");
var $523e048457443bed$require$Buffer = $jcTxY.Buffer;
function $523e048457443bed$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $iogP6($4WS9C(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $523e048457443bed$var$blind(priv) {
    var r = $523e048457443bed$var$getr(priv);
    var blinder = r.toRed($iogP6.mont(priv.modulus)).redPow(new $iogP6(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $523e048457443bed$var$crt(msg, priv) {
    var blinds = $523e048457443bed$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $iogP6(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($iogP6.mont(priv.prime1));
    var c2 = blinded.toRed($iogP6.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($523e048457443bed$require$Buffer, 'be', len);
}
$523e048457443bed$var$crt.getr = $523e048457443bed$var$getr;
module.exports = $523e048457443bed$var$crt;

});
parcelRegister("iogP6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("1frus")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("9XWzf", function(module, exports) {
'use strict';
var $74170e0514ffe964$var$elliptic = module.exports;

$74170e0514ffe964$var$elliptic.version = (parcelRequire("77gKB")).version;

$74170e0514ffe964$var$elliptic.utils = (parcelRequire("fiDc2"));

$74170e0514ffe964$var$elliptic.rand = (parcelRequire("efv6w"));

$74170e0514ffe964$var$elliptic.curve = (parcelRequire("dDmoe"));

$74170e0514ffe964$var$elliptic.curves = (parcelRequire("3ZXqy"));

// Protocols
$74170e0514ffe964$var$elliptic.ec = (parcelRequire("aEMDP"));

$74170e0514ffe964$var$elliptic.eddsa = (parcelRequire("ksKr1"));

});
parcelRegister("77gKB", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("fiDc2", function(module, exports) {
'use strict';
var $b236f06aaf116c5f$var$utils = module.exports;

var $anLPs = parcelRequire("anLPs");

var $cRsPH = parcelRequire("cRsPH");

var $47iwF = parcelRequire("47iwF");
$b236f06aaf116c5f$var$utils.assert = $cRsPH;
$b236f06aaf116c5f$var$utils.toArray = $47iwF.toArray;
$b236f06aaf116c5f$var$utils.zero2 = $47iwF.zero2;
$b236f06aaf116c5f$var$utils.toHex = $47iwF.toHex;
$b236f06aaf116c5f$var$utils.encode = $47iwF.encode;
// Represent num in a w-NAF form
function $b236f06aaf116c5f$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$b236f06aaf116c5f$var$utils.getNAF = $b236f06aaf116c5f$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $b236f06aaf116c5f$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$b236f06aaf116c5f$var$utils.getJSF = $b236f06aaf116c5f$var$getJSF;
function $b236f06aaf116c5f$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$b236f06aaf116c5f$var$utils.cachedProperty = $b236f06aaf116c5f$var$cachedProperty;
function $b236f06aaf116c5f$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $b236f06aaf116c5f$var$utils.toArray(bytes, 'hex') : bytes;
}
$b236f06aaf116c5f$var$utils.parseBytes = $b236f06aaf116c5f$var$parseBytes;
function $b236f06aaf116c5f$var$intFromLE(bytes) {
    return new $anLPs(bytes, 'hex', 'le');
}
$b236f06aaf116c5f$var$utils.intFromLE = $b236f06aaf116c5f$var$intFromLE;

});
parcelRegister("47iwF", function(module, exports) {
'use strict';
var $2ff62fbab508c7b3$var$utils = module.exports;
function $2ff62fbab508c7b3$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$2ff62fbab508c7b3$var$utils.toArray = $2ff62fbab508c7b3$var$toArray;
function $2ff62fbab508c7b3$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$2ff62fbab508c7b3$var$utils.zero2 = $2ff62fbab508c7b3$var$zero2;
function $2ff62fbab508c7b3$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $2ff62fbab508c7b3$var$zero2(msg[i].toString(16));
    return res;
}
$2ff62fbab508c7b3$var$utils.toHex = $2ff62fbab508c7b3$var$toHex;
$2ff62fbab508c7b3$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $2ff62fbab508c7b3$var$toHex(arr);
    else return arr;
};

});


parcelRegister("dDmoe", function(module, exports) {
'use strict';
var $9ed0490e8c4f8cdd$var$curve = module.exports;

$9ed0490e8c4f8cdd$var$curve.base = (parcelRequire("fBexa"));

$9ed0490e8c4f8cdd$var$curve.short = (parcelRequire("2mNK7"));

$9ed0490e8c4f8cdd$var$curve.mont = (parcelRequire("1EKN7"));

$9ed0490e8c4f8cdd$var$curve.edwards = (parcelRequire("fXIa4"));

});
parcelRegister("fBexa", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $fiDc2 = parcelRequire("fiDc2");
var $b5b595e165f4ff63$var$getNAF = $fiDc2.getNAF;
var $b5b595e165f4ff63$var$getJSF = $fiDc2.getJSF;
var $b5b595e165f4ff63$var$assert = $fiDc2.assert;
function $b5b595e165f4ff63$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $anLPs(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $anLPs.red(conf.prime) : $anLPs.mont(this.p);
    // Useful for many curves
    this.zero = new $anLPs(0).toRed(this.red);
    this.one = new $anLPs(1).toRed(this.red);
    this.two = new $anLPs(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $anLPs(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $b5b595e165f4ff63$var$BaseCurve;
$b5b595e165f4ff63$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$b5b595e165f4ff63$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$b5b595e165f4ff63$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $b5b595e165f4ff63$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $b5b595e165f4ff63$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$b5b595e165f4ff63$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $b5b595e165f4ff63$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $b5b595e165f4ff63$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$b5b595e165f4ff63$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $b5b595e165f4ff63$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $b5b595e165f4ff63$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $b5b595e165f4ff63$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $b5b595e165f4ff63$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$b5b595e165f4ff63$var$BaseCurve.BasePoint = $b5b595e165f4ff63$var$BasePoint;
$b5b595e165f4ff63$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$b5b595e165f4ff63$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$b5b595e165f4ff63$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $fiDc2.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $b5b595e165f4ff63$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $b5b595e165f4ff63$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$b5b595e165f4ff63$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$b5b595e165f4ff63$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$b5b595e165f4ff63$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $fiDc2.encode(this._encode(compact), enc);
};
$b5b595e165f4ff63$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$b5b595e165f4ff63$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$b5b595e165f4ff63$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$b5b595e165f4ff63$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$b5b595e165f4ff63$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$b5b595e165f4ff63$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("2mNK7", function(module, exports) {
'use strict';

var $fiDc2 = parcelRequire("fiDc2");

var $anLPs = parcelRequire("anLPs");

var $9YOog = parcelRequire("9YOog");

var $fBexa = parcelRequire("fBexa");
var $1b9438badff5aaad$var$assert = $fiDc2.assert;
function $1b9438badff5aaad$var$ShortCurve(conf) {
    $fBexa.call(this, 'short', conf);
    this.a = new $anLPs(conf.a, 16).toRed(this.red);
    this.b = new $anLPs(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$9YOog($1b9438badff5aaad$var$ShortCurve, $fBexa);
module.exports = $1b9438badff5aaad$var$ShortCurve;
$1b9438badff5aaad$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $anLPs(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $anLPs(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $1b9438badff5aaad$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $anLPs(vec.a, 16),
            b: new $anLPs(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$1b9438badff5aaad$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $anLPs.mont(num);
    var tinv = new $anLPs(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $anLPs(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$1b9438badff5aaad$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $anLPs(1);
    var y1 = new $anLPs(0);
    var x2 = new $anLPs(0);
    var y2 = new $anLPs(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$1b9438badff5aaad$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$1b9438badff5aaad$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $anLPs(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$1b9438badff5aaad$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$1b9438badff5aaad$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $1b9438badff5aaad$var$Point(curve, x, y, isRed) {
    $fBexa.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $anLPs(x, 16);
        this.y = new $anLPs(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$9YOog($1b9438badff5aaad$var$Point, $fBexa.BasePoint);
$1b9438badff5aaad$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $1b9438badff5aaad$var$Point(this, x, y, isRed);
};
$1b9438badff5aaad$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $1b9438badff5aaad$var$Point.fromJSON(this, obj, red);
};
$1b9438badff5aaad$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$1b9438badff5aaad$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$1b9438badff5aaad$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$1b9438badff5aaad$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$1b9438badff5aaad$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$1b9438badff5aaad$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1b9438badff5aaad$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1b9438badff5aaad$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$1b9438badff5aaad$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$1b9438badff5aaad$var$Point.prototype.mul = function mul(k) {
    k = new $anLPs(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$1b9438badff5aaad$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$1b9438badff5aaad$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$1b9438badff5aaad$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$1b9438badff5aaad$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$1b9438badff5aaad$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $1b9438badff5aaad$var$JPoint(curve, x, y, z) {
    $fBexa.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $anLPs(0);
    } else {
        this.x = new $anLPs(x, 16);
        this.y = new $anLPs(y, 16);
        this.z = new $anLPs(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$9YOog($1b9438badff5aaad$var$JPoint, $fBexa.BasePoint);
$1b9438badff5aaad$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $1b9438badff5aaad$var$JPoint(this, x, y, z);
};
$1b9438badff5aaad$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$1b9438badff5aaad$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$1b9438badff5aaad$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$1b9438badff5aaad$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$1b9438badff5aaad$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$1b9438badff5aaad$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $anLPs(k, kbase);
    return this.curve._wnafMul(this, k);
};
$1b9438badff5aaad$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$1b9438badff5aaad$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$1b9438badff5aaad$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$1b9438badff5aaad$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("1EKN7", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $9YOog = parcelRequire("9YOog");

var $fBexa = parcelRequire("fBexa");

var $fiDc2 = parcelRequire("fiDc2");
function $134dd29edeefe80d$var$MontCurve(conf) {
    $fBexa.call(this, 'mont', conf);
    this.a = new $anLPs(conf.a, 16).toRed(this.red);
    this.b = new $anLPs(conf.b, 16).toRed(this.red);
    this.i4 = new $anLPs(4).toRed(this.red).redInvm();
    this.two = new $anLPs(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$9YOog($134dd29edeefe80d$var$MontCurve, $fBexa);
module.exports = $134dd29edeefe80d$var$MontCurve;
$134dd29edeefe80d$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $134dd29edeefe80d$var$Point(curve, x, z) {
    $fBexa.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $anLPs(x, 16);
        this.z = new $anLPs(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$9YOog($134dd29edeefe80d$var$Point, $fBexa.BasePoint);
$134dd29edeefe80d$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($fiDc2.toArray(bytes, enc), 1);
};
$134dd29edeefe80d$var$MontCurve.prototype.point = function point(x, z) {
    return new $134dd29edeefe80d$var$Point(this, x, z);
};
$134dd29edeefe80d$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $134dd29edeefe80d$var$Point.fromJSON(this, obj);
};
$134dd29edeefe80d$var$Point.prototype.precompute = function precompute() {
// No-op
};
$134dd29edeefe80d$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$134dd29edeefe80d$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $134dd29edeefe80d$var$Point(curve, obj[0], obj[1] || curve.one);
};
$134dd29edeefe80d$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$134dd29edeefe80d$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$134dd29edeefe80d$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$134dd29edeefe80d$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$134dd29edeefe80d$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$134dd29edeefe80d$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$134dd29edeefe80d$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$134dd29edeefe80d$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$134dd29edeefe80d$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$134dd29edeefe80d$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$134dd29edeefe80d$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("fXIa4", function(module, exports) {
'use strict';

var $fiDc2 = parcelRequire("fiDc2");

var $anLPs = parcelRequire("anLPs");

var $9YOog = parcelRequire("9YOog");

var $fBexa = parcelRequire("fBexa");
var $b9ee9f38ca344a58$var$assert = $fiDc2.assert;
function $b9ee9f38ca344a58$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $fBexa.call(this, 'edwards', conf);
    this.a = new $anLPs(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $anLPs(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $anLPs(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $b9ee9f38ca344a58$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$9YOog($b9ee9f38ca344a58$var$EdwardsCurve, $fBexa);
module.exports = $b9ee9f38ca344a58$var$EdwardsCurve;
$b9ee9f38ca344a58$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$b9ee9f38ca344a58$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $anLPs(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $anLPs(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $b9ee9f38ca344a58$var$Point(curve, x, y, z, t) {
    $fBexa.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $anLPs(x, 16);
        this.y = new $anLPs(y, 16);
        this.z = z ? new $anLPs(z, 16) : this.curve.one;
        this.t = t && new $anLPs(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$9YOog($b9ee9f38ca344a58$var$Point, $fBexa.BasePoint);
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $b9ee9f38ca344a58$var$Point.fromJSON(this, obj);
};
$b9ee9f38ca344a58$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $b9ee9f38ca344a58$var$Point(this, x, y, z, t);
};
$b9ee9f38ca344a58$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $b9ee9f38ca344a58$var$Point(curve, obj[0], obj[1], obj[2]);
};
$b9ee9f38ca344a58$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$b9ee9f38ca344a58$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$b9ee9f38ca344a58$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$b9ee9f38ca344a58$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$b9ee9f38ca344a58$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$b9ee9f38ca344a58$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$b9ee9f38ca344a58$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$b9ee9f38ca344a58$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$b9ee9f38ca344a58$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$b9ee9f38ca344a58$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$b9ee9f38ca344a58$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$b9ee9f38ca344a58$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$b9ee9f38ca344a58$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$b9ee9f38ca344a58$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$b9ee9f38ca344a58$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$b9ee9f38ca344a58$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$b9ee9f38ca344a58$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$b9ee9f38ca344a58$var$Point.prototype.toP = $b9ee9f38ca344a58$var$Point.prototype.normalize;
$b9ee9f38ca344a58$var$Point.prototype.mixedAdd = $b9ee9f38ca344a58$var$Point.prototype.add;

});


parcelRegister("3ZXqy", function(module, exports) {
'use strict';
var $2e952aa094acf2c9$var$curves = module.exports;

var $joeYQ = parcelRequire("joeYQ");

var $dDmoe = parcelRequire("dDmoe");

var $fiDc2 = parcelRequire("fiDc2");
var $2e952aa094acf2c9$var$assert = $fiDc2.assert;
function $2e952aa094acf2c9$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $dDmoe.short(options);
    else if (options.type === 'edwards') this.curve = new $dDmoe.edwards(options);
    else this.curve = new $dDmoe.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $2e952aa094acf2c9$var$assert(this.g.validate(), 'Invalid curve');
    $2e952aa094acf2c9$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$2e952aa094acf2c9$var$curves.PresetCurve = $2e952aa094acf2c9$var$PresetCurve;
function $2e952aa094acf2c9$var$defineCurve(name, options) {
    Object.defineProperty($2e952aa094acf2c9$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $2e952aa094acf2c9$var$PresetCurve(options);
            Object.defineProperty($2e952aa094acf2c9$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$2e952aa094acf2c9$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $joeYQ.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$2e952aa094acf2c9$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $joeYQ.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$2e952aa094acf2c9$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $joeYQ.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$2e952aa094acf2c9$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $joeYQ.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$2e952aa094acf2c9$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $joeYQ.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$2e952aa094acf2c9$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $joeYQ.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$2e952aa094acf2c9$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $joeYQ.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $2e952aa094acf2c9$var$pre;

try {
    $2e952aa094acf2c9$var$pre = (parcelRequire("8uqTa"));
} catch (e) {
    $2e952aa094acf2c9$var$pre = undefined;
}
$2e952aa094acf2c9$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $joeYQ.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $2e952aa094acf2c9$var$pre
    ]
});

});
parcelRegister("joeYQ", function(module, exports) {
var $e1dbe0fde7ee6811$var$hash = module.exports;

$e1dbe0fde7ee6811$var$hash.utils = (parcelRequire("aYhtf"));

$e1dbe0fde7ee6811$var$hash.common = (parcelRequire("bvPfH"));

$e1dbe0fde7ee6811$var$hash.sha = (parcelRequire("5aKTR"));

$e1dbe0fde7ee6811$var$hash.ripemd = (parcelRequire("dUANg"));

$e1dbe0fde7ee6811$var$hash.hmac = (parcelRequire("cF3J2"));
// Proxy hash functions to the main object
$e1dbe0fde7ee6811$var$hash.sha1 = $e1dbe0fde7ee6811$var$hash.sha.sha1;
$e1dbe0fde7ee6811$var$hash.sha256 = $e1dbe0fde7ee6811$var$hash.sha.sha256;
$e1dbe0fde7ee6811$var$hash.sha224 = $e1dbe0fde7ee6811$var$hash.sha.sha224;
$e1dbe0fde7ee6811$var$hash.sha384 = $e1dbe0fde7ee6811$var$hash.sha.sha384;
$e1dbe0fde7ee6811$var$hash.sha512 = $e1dbe0fde7ee6811$var$hash.sha.sha512;
$e1dbe0fde7ee6811$var$hash.ripemd160 = $e1dbe0fde7ee6811$var$hash.ripemd.ripemd160;

});
parcelRegister("aYhtf", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $7fcd0f4b6e31118d$export$69f1b2dcda23c5f8, (v) => $7fcd0f4b6e31118d$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $7fcd0f4b6e31118d$export$45b10814cc054894, (v) => $7fcd0f4b6e31118d$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $7fcd0f4b6e31118d$export$7ea66e3774a60b67, (v) => $7fcd0f4b6e31118d$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $7fcd0f4b6e31118d$export$34a52f00f601f6f1, (v) => $7fcd0f4b6e31118d$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $7fcd0f4b6e31118d$export$812b0cbd5e8a72ab, (v) => $7fcd0f4b6e31118d$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $7fcd0f4b6e31118d$export$f24f9e11d63bb314, (v) => $7fcd0f4b6e31118d$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $7fcd0f4b6e31118d$export$b71357c7e07ca1f1, (v) => $7fcd0f4b6e31118d$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $7fcd0f4b6e31118d$export$2e58a4b541fdcbe8, (v) => $7fcd0f4b6e31118d$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $7fcd0f4b6e31118d$export$183b950bde9faab8, (v) => $7fcd0f4b6e31118d$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $7fcd0f4b6e31118d$export$4785c77169fea59e, (v) => $7fcd0f4b6e31118d$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $7fcd0f4b6e31118d$export$242a185dfcffac5b, (v) => $7fcd0f4b6e31118d$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $7fcd0f4b6e31118d$export$58c04ae0ae31877d, (v) => $7fcd0f4b6e31118d$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $7fcd0f4b6e31118d$export$d058ca695f8c6f11, (v) => $7fcd0f4b6e31118d$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $7fcd0f4b6e31118d$export$a1efd7fc3e986367, (v) => $7fcd0f4b6e31118d$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $7fcd0f4b6e31118d$export$bbfea4a2b5abaab4, (v) => $7fcd0f4b6e31118d$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $7fcd0f4b6e31118d$export$97ad4afc7de86152, (v) => $7fcd0f4b6e31118d$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $7fcd0f4b6e31118d$export$ce4673d9a79f6a4b, (v) => $7fcd0f4b6e31118d$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $7fcd0f4b6e31118d$export$786cc99fc6eedc0b, (v) => $7fcd0f4b6e31118d$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $7fcd0f4b6e31118d$export$45c59b9a1848dd0, (v) => $7fcd0f4b6e31118d$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $7fcd0f4b6e31118d$export$50d8f613e76d3034, (v) => $7fcd0f4b6e31118d$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $7fcd0f4b6e31118d$export$b8e83683c60ee162, (v) => $7fcd0f4b6e31118d$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $7fcd0f4b6e31118d$export$aeeb51790d1bcc4a, (v) => $7fcd0f4b6e31118d$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $7fcd0f4b6e31118d$export$bb7c616f719ad9c, (v) => $7fcd0f4b6e31118d$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $7fcd0f4b6e31118d$export$4d63290824f9d7df, (v) => $7fcd0f4b6e31118d$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $7fcd0f4b6e31118d$export$2f64ceb90ef28ea1, (v) => $7fcd0f4b6e31118d$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $7fcd0f4b6e31118d$export$8d2089d465f6d10d, (v) => $7fcd0f4b6e31118d$export$8d2089d465f6d10d = v);
var $7fcd0f4b6e31118d$export$69f1b2dcda23c5f8;
var $7fcd0f4b6e31118d$export$45b10814cc054894;
var $7fcd0f4b6e31118d$export$7ea66e3774a60b67;
var $7fcd0f4b6e31118d$export$34a52f00f601f6f1;
var $7fcd0f4b6e31118d$export$812b0cbd5e8a72ab;
var $7fcd0f4b6e31118d$export$f24f9e11d63bb314;
var $7fcd0f4b6e31118d$export$b71357c7e07ca1f1;
var $7fcd0f4b6e31118d$export$2e58a4b541fdcbe8;
var $7fcd0f4b6e31118d$export$183b950bde9faab8;
var $7fcd0f4b6e31118d$export$4785c77169fea59e;
var $7fcd0f4b6e31118d$export$242a185dfcffac5b;
var $7fcd0f4b6e31118d$export$58c04ae0ae31877d;
var $7fcd0f4b6e31118d$export$d058ca695f8c6f11;
var $7fcd0f4b6e31118d$export$a1efd7fc3e986367;
var $7fcd0f4b6e31118d$export$bbfea4a2b5abaab4;
var $7fcd0f4b6e31118d$export$97ad4afc7de86152;
var $7fcd0f4b6e31118d$export$ce4673d9a79f6a4b;
var $7fcd0f4b6e31118d$export$786cc99fc6eedc0b;
var $7fcd0f4b6e31118d$export$45c59b9a1848dd0;
var $7fcd0f4b6e31118d$export$50d8f613e76d3034;
var $7fcd0f4b6e31118d$export$b8e83683c60ee162;
var $7fcd0f4b6e31118d$export$aeeb51790d1bcc4a;
var $7fcd0f4b6e31118d$export$bb7c616f719ad9c;
var $7fcd0f4b6e31118d$export$4d63290824f9d7df;
var $7fcd0f4b6e31118d$export$2f64ceb90ef28ea1;
var $7fcd0f4b6e31118d$export$8d2089d465f6d10d;
'use strict';

var $cRsPH = parcelRequire("cRsPH");

var $9YOog = parcelRequire("9YOog");
$7fcd0f4b6e31118d$export$69f1b2dcda23c5f8 = $9YOog;
function $7fcd0f4b6e31118d$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $7fcd0f4b6e31118d$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($7fcd0f4b6e31118d$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$7fcd0f4b6e31118d$export$45b10814cc054894 = $7fcd0f4b6e31118d$var$toArray;
function $7fcd0f4b6e31118d$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $7fcd0f4b6e31118d$var$zero2(msg[i].toString(16));
    return res;
}
$7fcd0f4b6e31118d$export$7ea66e3774a60b67 = $7fcd0f4b6e31118d$var$toHex;
function $7fcd0f4b6e31118d$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$7fcd0f4b6e31118d$export$34a52f00f601f6f1 = $7fcd0f4b6e31118d$var$htonl;
function $7fcd0f4b6e31118d$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $7fcd0f4b6e31118d$var$htonl(w);
        res += $7fcd0f4b6e31118d$var$zero8(w.toString(16));
    }
    return res;
}
$7fcd0f4b6e31118d$export$812b0cbd5e8a72ab = $7fcd0f4b6e31118d$var$toHex32;
function $7fcd0f4b6e31118d$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$7fcd0f4b6e31118d$export$f24f9e11d63bb314 = $7fcd0f4b6e31118d$var$zero2;
function $7fcd0f4b6e31118d$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$7fcd0f4b6e31118d$export$b71357c7e07ca1f1 = $7fcd0f4b6e31118d$var$zero8;
function $7fcd0f4b6e31118d$var$join32(msg, start, end, endian) {
    var len = end - start;
    $cRsPH(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$7fcd0f4b6e31118d$export$2e58a4b541fdcbe8 = $7fcd0f4b6e31118d$var$join32;
function $7fcd0f4b6e31118d$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$7fcd0f4b6e31118d$export$183b950bde9faab8 = $7fcd0f4b6e31118d$var$split32;
function $7fcd0f4b6e31118d$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$7fcd0f4b6e31118d$export$4785c77169fea59e = $7fcd0f4b6e31118d$var$rotr32;
function $7fcd0f4b6e31118d$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$7fcd0f4b6e31118d$export$242a185dfcffac5b = $7fcd0f4b6e31118d$var$rotl32;
function $7fcd0f4b6e31118d$var$sum32(a, b) {
    return a + b >>> 0;
}
$7fcd0f4b6e31118d$export$58c04ae0ae31877d = $7fcd0f4b6e31118d$var$sum32;
function $7fcd0f4b6e31118d$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$7fcd0f4b6e31118d$export$d058ca695f8c6f11 = $7fcd0f4b6e31118d$var$sum32_3;
function $7fcd0f4b6e31118d$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$7fcd0f4b6e31118d$export$a1efd7fc3e986367 = $7fcd0f4b6e31118d$var$sum32_4;
function $7fcd0f4b6e31118d$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$7fcd0f4b6e31118d$export$bbfea4a2b5abaab4 = $7fcd0f4b6e31118d$var$sum32_5;
function $7fcd0f4b6e31118d$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$7fcd0f4b6e31118d$export$97ad4afc7de86152 = $7fcd0f4b6e31118d$var$sum64;
function $7fcd0f4b6e31118d$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$7fcd0f4b6e31118d$export$ce4673d9a79f6a4b = $7fcd0f4b6e31118d$var$sum64_hi;
function $7fcd0f4b6e31118d$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$7fcd0f4b6e31118d$export$786cc99fc6eedc0b = $7fcd0f4b6e31118d$var$sum64_lo;
function $7fcd0f4b6e31118d$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$7fcd0f4b6e31118d$export$45c59b9a1848dd0 = $7fcd0f4b6e31118d$var$sum64_4_hi;
function $7fcd0f4b6e31118d$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$7fcd0f4b6e31118d$export$50d8f613e76d3034 = $7fcd0f4b6e31118d$var$sum64_4_lo;
function $7fcd0f4b6e31118d$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$7fcd0f4b6e31118d$export$b8e83683c60ee162 = $7fcd0f4b6e31118d$var$sum64_5_hi;
function $7fcd0f4b6e31118d$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$7fcd0f4b6e31118d$export$aeeb51790d1bcc4a = $7fcd0f4b6e31118d$var$sum64_5_lo;
function $7fcd0f4b6e31118d$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$7fcd0f4b6e31118d$export$bb7c616f719ad9c = $7fcd0f4b6e31118d$var$rotr64_hi;
function $7fcd0f4b6e31118d$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$7fcd0f4b6e31118d$export$4d63290824f9d7df = $7fcd0f4b6e31118d$var$rotr64_lo;
function $7fcd0f4b6e31118d$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$7fcd0f4b6e31118d$export$2f64ceb90ef28ea1 = $7fcd0f4b6e31118d$var$shr64_hi;
function $7fcd0f4b6e31118d$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$7fcd0f4b6e31118d$export$8d2089d465f6d10d = $7fcd0f4b6e31118d$var$shr64_lo;

});

parcelRegister("bvPfH", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $861a58944be76a4a$export$8687658379b577e6, (v) => $861a58944be76a4a$export$8687658379b577e6 = v);
var $861a58944be76a4a$export$8687658379b577e6;
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $cRsPH = parcelRequire("cRsPH");
function $861a58944be76a4a$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$861a58944be76a4a$export$8687658379b577e6 = $861a58944be76a4a$var$BlockHash;
$861a58944be76a4a$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $aYhtf.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $aYhtf.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$861a58944be76a4a$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $cRsPH(this.pending === null);
    return this._digest(enc);
};
$861a58944be76a4a$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("5aKTR", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $3c42444818600e12$export$5091bdda49ba90f5, (v) => $3c42444818600e12$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $3c42444818600e12$export$97b70509d4e397ea, (v) => $3c42444818600e12$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $3c42444818600e12$export$bced8d2aada2d1c9, (v) => $3c42444818600e12$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $3c42444818600e12$export$612d47d55dedde45, (v) => $3c42444818600e12$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $3c42444818600e12$export$a888d2532e6dc7bb, (v) => $3c42444818600e12$export$a888d2532e6dc7bb = v);
var $3c42444818600e12$export$5091bdda49ba90f5;
var $3c42444818600e12$export$97b70509d4e397ea;
var $3c42444818600e12$export$bced8d2aada2d1c9;
var $3c42444818600e12$export$612d47d55dedde45;
var $3c42444818600e12$export$a888d2532e6dc7bb;
'use strict';

$3c42444818600e12$export$5091bdda49ba90f5 = (parcelRequire("6LB4y"));

$3c42444818600e12$export$97b70509d4e397ea = (parcelRequire("6KyLi"));

$3c42444818600e12$export$bced8d2aada2d1c9 = (parcelRequire("qCgUk"));

$3c42444818600e12$export$612d47d55dedde45 = (parcelRequire("cHHHv"));

$3c42444818600e12$export$a888d2532e6dc7bb = (parcelRequire("6i3wx"));

});
parcelRegister("6LB4y", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $bvPfH = parcelRequire("bvPfH");

var $9U4MD = parcelRequire("9U4MD");
var $4ed3e3b06203800b$var$rotl32 = $aYhtf.rotl32;
var $4ed3e3b06203800b$var$sum32 = $aYhtf.sum32;
var $4ed3e3b06203800b$var$sum32_5 = $aYhtf.sum32_5;
var $4ed3e3b06203800b$var$ft_1 = $9U4MD.ft_1;
var $4ed3e3b06203800b$var$BlockHash = $bvPfH.BlockHash;
var $4ed3e3b06203800b$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $4ed3e3b06203800b$var$SHA1() {
    if (!(this instanceof $4ed3e3b06203800b$var$SHA1)) return new $4ed3e3b06203800b$var$SHA1();
    $4ed3e3b06203800b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$aYhtf.inherits($4ed3e3b06203800b$var$SHA1, $4ed3e3b06203800b$var$BlockHash);
module.exports = $4ed3e3b06203800b$var$SHA1;
$4ed3e3b06203800b$var$SHA1.blockSize = 512;
$4ed3e3b06203800b$var$SHA1.outSize = 160;
$4ed3e3b06203800b$var$SHA1.hmacStrength = 80;
$4ed3e3b06203800b$var$SHA1.padLength = 64;
$4ed3e3b06203800b$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4ed3e3b06203800b$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $4ed3e3b06203800b$var$sum32_5($4ed3e3b06203800b$var$rotl32(a, 5), $4ed3e3b06203800b$var$ft_1(s, b, c, d), e, W[i], $4ed3e3b06203800b$var$sha1_K[s]);
        e = d;
        d = c;
        c = $4ed3e3b06203800b$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $4ed3e3b06203800b$var$sum32(this.h[0], a);
    this.h[1] = $4ed3e3b06203800b$var$sum32(this.h[1], b);
    this.h[2] = $4ed3e3b06203800b$var$sum32(this.h[2], c);
    this.h[3] = $4ed3e3b06203800b$var$sum32(this.h[3], d);
    this.h[4] = $4ed3e3b06203800b$var$sum32(this.h[4], e);
};
$4ed3e3b06203800b$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aYhtf.toHex32(this.h, 'big');
    else return $aYhtf.split32(this.h, 'big');
};

});
parcelRegister("9U4MD", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $735d0de70f2ce65d$export$5a92649d7ddb9f63, (v) => $735d0de70f2ce65d$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $735d0de70f2ce65d$export$c6d0d020c3a6269, (v) => $735d0de70f2ce65d$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $735d0de70f2ce65d$export$eb90c27fca05f956, (v) => $735d0de70f2ce65d$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $735d0de70f2ce65d$export$14a4a98e063b1999, (v) => $735d0de70f2ce65d$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $735d0de70f2ce65d$export$d20cecfa1564c686, (v) => $735d0de70f2ce65d$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $735d0de70f2ce65d$export$44fd472a12fc6db, (v) => $735d0de70f2ce65d$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $735d0de70f2ce65d$export$1ed238bb6ea1dd47, (v) => $735d0de70f2ce65d$export$1ed238bb6ea1dd47 = v);
var $735d0de70f2ce65d$export$5a92649d7ddb9f63;
var $735d0de70f2ce65d$export$c6d0d020c3a6269;
var $735d0de70f2ce65d$export$eb90c27fca05f956;
var $735d0de70f2ce65d$export$cc992891a14496a1;
var $735d0de70f2ce65d$export$14a4a98e063b1999;
var $735d0de70f2ce65d$export$d20cecfa1564c686;
var $735d0de70f2ce65d$export$44fd472a12fc6db;
var $735d0de70f2ce65d$export$1ed238bb6ea1dd47;
'use strict';

var $aYhtf = parcelRequire("aYhtf");
var $735d0de70f2ce65d$var$rotr32 = $aYhtf.rotr32;
function $735d0de70f2ce65d$var$ft_1(s, x, y, z) {
    if (s === 0) return $735d0de70f2ce65d$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $735d0de70f2ce65d$var$p32(x, y, z);
    if (s === 2) return $735d0de70f2ce65d$var$maj32(x, y, z);
}
$735d0de70f2ce65d$export$5a92649d7ddb9f63 = $735d0de70f2ce65d$var$ft_1;
function $735d0de70f2ce65d$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$735d0de70f2ce65d$export$c6d0d020c3a6269 = $735d0de70f2ce65d$var$ch32;
function $735d0de70f2ce65d$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$735d0de70f2ce65d$export$eb90c27fca05f956 = $735d0de70f2ce65d$var$maj32;
function $735d0de70f2ce65d$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$735d0de70f2ce65d$export$cc992891a14496a1 = $735d0de70f2ce65d$var$p32;
function $735d0de70f2ce65d$var$s0_256(x) {
    return $735d0de70f2ce65d$var$rotr32(x, 2) ^ $735d0de70f2ce65d$var$rotr32(x, 13) ^ $735d0de70f2ce65d$var$rotr32(x, 22);
}
$735d0de70f2ce65d$export$14a4a98e063b1999 = $735d0de70f2ce65d$var$s0_256;
function $735d0de70f2ce65d$var$s1_256(x) {
    return $735d0de70f2ce65d$var$rotr32(x, 6) ^ $735d0de70f2ce65d$var$rotr32(x, 11) ^ $735d0de70f2ce65d$var$rotr32(x, 25);
}
$735d0de70f2ce65d$export$d20cecfa1564c686 = $735d0de70f2ce65d$var$s1_256;
function $735d0de70f2ce65d$var$g0_256(x) {
    return $735d0de70f2ce65d$var$rotr32(x, 7) ^ $735d0de70f2ce65d$var$rotr32(x, 18) ^ x >>> 3;
}
$735d0de70f2ce65d$export$44fd472a12fc6db = $735d0de70f2ce65d$var$g0_256;
function $735d0de70f2ce65d$var$g1_256(x) {
    return $735d0de70f2ce65d$var$rotr32(x, 17) ^ $735d0de70f2ce65d$var$rotr32(x, 19) ^ x >>> 10;
}
$735d0de70f2ce65d$export$1ed238bb6ea1dd47 = $735d0de70f2ce65d$var$g1_256;

});


parcelRegister("6KyLi", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $qCgUk = parcelRequire("qCgUk");
function $4ea200f04c3f2b3b$var$SHA224() {
    if (!(this instanceof $4ea200f04c3f2b3b$var$SHA224)) return new $4ea200f04c3f2b3b$var$SHA224();
    $qCgUk.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$aYhtf.inherits($4ea200f04c3f2b3b$var$SHA224, $qCgUk);
module.exports = $4ea200f04c3f2b3b$var$SHA224;
$4ea200f04c3f2b3b$var$SHA224.blockSize = 512;
$4ea200f04c3f2b3b$var$SHA224.outSize = 224;
$4ea200f04c3f2b3b$var$SHA224.hmacStrength = 192;
$4ea200f04c3f2b3b$var$SHA224.padLength = 64;
$4ea200f04c3f2b3b$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $aYhtf.toHex32(this.h.slice(0, 7), 'big');
    else return $aYhtf.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("qCgUk", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $bvPfH = parcelRequire("bvPfH");

var $9U4MD = parcelRequire("9U4MD");

var $cRsPH = parcelRequire("cRsPH");
var $05001dc907eff15b$var$sum32 = $aYhtf.sum32;
var $05001dc907eff15b$var$sum32_4 = $aYhtf.sum32_4;
var $05001dc907eff15b$var$sum32_5 = $aYhtf.sum32_5;
var $05001dc907eff15b$var$ch32 = $9U4MD.ch32;
var $05001dc907eff15b$var$maj32 = $9U4MD.maj32;
var $05001dc907eff15b$var$s0_256 = $9U4MD.s0_256;
var $05001dc907eff15b$var$s1_256 = $9U4MD.s1_256;
var $05001dc907eff15b$var$g0_256 = $9U4MD.g0_256;
var $05001dc907eff15b$var$g1_256 = $9U4MD.g1_256;
var $05001dc907eff15b$var$BlockHash = $bvPfH.BlockHash;
var $05001dc907eff15b$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $05001dc907eff15b$var$SHA256() {
    if (!(this instanceof $05001dc907eff15b$var$SHA256)) return new $05001dc907eff15b$var$SHA256();
    $05001dc907eff15b$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $05001dc907eff15b$var$sha256_K;
    this.W = new Array(64);
}
$aYhtf.inherits($05001dc907eff15b$var$SHA256, $05001dc907eff15b$var$BlockHash);
module.exports = $05001dc907eff15b$var$SHA256;
$05001dc907eff15b$var$SHA256.blockSize = 512;
$05001dc907eff15b$var$SHA256.outSize = 256;
$05001dc907eff15b$var$SHA256.hmacStrength = 192;
$05001dc907eff15b$var$SHA256.padLength = 64;
$05001dc907eff15b$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $05001dc907eff15b$var$sum32_4($05001dc907eff15b$var$g1_256(W[i - 2]), W[i - 7], $05001dc907eff15b$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $cRsPH(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $05001dc907eff15b$var$sum32_5(h, $05001dc907eff15b$var$s1_256(e), $05001dc907eff15b$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $05001dc907eff15b$var$sum32($05001dc907eff15b$var$s0_256(a), $05001dc907eff15b$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $05001dc907eff15b$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $05001dc907eff15b$var$sum32(T1, T2);
    }
    this.h[0] = $05001dc907eff15b$var$sum32(this.h[0], a);
    this.h[1] = $05001dc907eff15b$var$sum32(this.h[1], b);
    this.h[2] = $05001dc907eff15b$var$sum32(this.h[2], c);
    this.h[3] = $05001dc907eff15b$var$sum32(this.h[3], d);
    this.h[4] = $05001dc907eff15b$var$sum32(this.h[4], e);
    this.h[5] = $05001dc907eff15b$var$sum32(this.h[5], f);
    this.h[6] = $05001dc907eff15b$var$sum32(this.h[6], g);
    this.h[7] = $05001dc907eff15b$var$sum32(this.h[7], h);
};
$05001dc907eff15b$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aYhtf.toHex32(this.h, 'big');
    else return $aYhtf.split32(this.h, 'big');
};

});


parcelRegister("cHHHv", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $6i3wx = parcelRequire("6i3wx");
function $93fb663c3283f7d9$var$SHA384() {
    if (!(this instanceof $93fb663c3283f7d9$var$SHA384)) return new $93fb663c3283f7d9$var$SHA384();
    $6i3wx.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$aYhtf.inherits($93fb663c3283f7d9$var$SHA384, $6i3wx);
module.exports = $93fb663c3283f7d9$var$SHA384;
$93fb663c3283f7d9$var$SHA384.blockSize = 1024;
$93fb663c3283f7d9$var$SHA384.outSize = 384;
$93fb663c3283f7d9$var$SHA384.hmacStrength = 192;
$93fb663c3283f7d9$var$SHA384.padLength = 128;
$93fb663c3283f7d9$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aYhtf.toHex32(this.h.slice(0, 12), 'big');
    else return $aYhtf.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("6i3wx", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $bvPfH = parcelRequire("bvPfH");

var $cRsPH = parcelRequire("cRsPH");
var $494728429e4d46b1$var$rotr64_hi = $aYhtf.rotr64_hi;
var $494728429e4d46b1$var$rotr64_lo = $aYhtf.rotr64_lo;
var $494728429e4d46b1$var$shr64_hi = $aYhtf.shr64_hi;
var $494728429e4d46b1$var$shr64_lo = $aYhtf.shr64_lo;
var $494728429e4d46b1$var$sum64 = $aYhtf.sum64;
var $494728429e4d46b1$var$sum64_hi = $aYhtf.sum64_hi;
var $494728429e4d46b1$var$sum64_lo = $aYhtf.sum64_lo;
var $494728429e4d46b1$var$sum64_4_hi = $aYhtf.sum64_4_hi;
var $494728429e4d46b1$var$sum64_4_lo = $aYhtf.sum64_4_lo;
var $494728429e4d46b1$var$sum64_5_hi = $aYhtf.sum64_5_hi;
var $494728429e4d46b1$var$sum64_5_lo = $aYhtf.sum64_5_lo;
var $494728429e4d46b1$var$BlockHash = $bvPfH.BlockHash;
var $494728429e4d46b1$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $494728429e4d46b1$var$SHA512() {
    if (!(this instanceof $494728429e4d46b1$var$SHA512)) return new $494728429e4d46b1$var$SHA512();
    $494728429e4d46b1$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $494728429e4d46b1$var$sha512_K;
    this.W = new Array(160);
}
$aYhtf.inherits($494728429e4d46b1$var$SHA512, $494728429e4d46b1$var$BlockHash);
module.exports = $494728429e4d46b1$var$SHA512;
$494728429e4d46b1$var$SHA512.blockSize = 1024;
$494728429e4d46b1$var$SHA512.outSize = 512;
$494728429e4d46b1$var$SHA512.hmacStrength = 192;
$494728429e4d46b1$var$SHA512.padLength = 128;
$494728429e4d46b1$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $494728429e4d46b1$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $494728429e4d46b1$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $494728429e4d46b1$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $494728429e4d46b1$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $494728429e4d46b1$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $494728429e4d46b1$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$494728429e4d46b1$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $cRsPH(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $494728429e4d46b1$var$s1_512_hi(eh, el);
        var c1_lo = $494728429e4d46b1$var$s1_512_lo(eh, el);
        var c2_hi = $494728429e4d46b1$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $494728429e4d46b1$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $494728429e4d46b1$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $494728429e4d46b1$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $494728429e4d46b1$var$s0_512_hi(ah, al);
        c0_lo = $494728429e4d46b1$var$s0_512_lo(ah, al);
        c1_hi = $494728429e4d46b1$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $494728429e4d46b1$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $494728429e4d46b1$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $494728429e4d46b1$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $494728429e4d46b1$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $494728429e4d46b1$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $494728429e4d46b1$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $494728429e4d46b1$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $494728429e4d46b1$var$sum64(this.h, 0, ah, al);
    $494728429e4d46b1$var$sum64(this.h, 2, bh, bl);
    $494728429e4d46b1$var$sum64(this.h, 4, ch, cl);
    $494728429e4d46b1$var$sum64(this.h, 6, dh, dl);
    $494728429e4d46b1$var$sum64(this.h, 8, eh, el);
    $494728429e4d46b1$var$sum64(this.h, 10, fh, fl);
    $494728429e4d46b1$var$sum64(this.h, 12, gh, gl);
    $494728429e4d46b1$var$sum64(this.h, 14, hh, hl);
};
$494728429e4d46b1$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aYhtf.toHex32(this.h, 'big');
    else return $aYhtf.split32(this.h, 'big');
};
function $494728429e4d46b1$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$s0_512_hi(xh, xl) {
    var c0_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $494728429e4d46b1$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $494728429e4d46b1$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$s0_512_lo(xh, xl) {
    var c0_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $494728429e4d46b1$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $494728429e4d46b1$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$s1_512_hi(xh, xl) {
    var c0_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $494728429e4d46b1$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$s1_512_lo(xh, xl) {
    var c0_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $494728429e4d46b1$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$g0_512_hi(xh, xl) {
    var c0_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $494728429e4d46b1$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$g0_512_lo(xh, xl) {
    var c0_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $494728429e4d46b1$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$g1_512_hi(xh, xl) {
    var c0_hi = $494728429e4d46b1$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $494728429e4d46b1$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $494728429e4d46b1$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $494728429e4d46b1$var$g1_512_lo(xh, xl) {
    var c0_lo = $494728429e4d46b1$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $494728429e4d46b1$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $494728429e4d46b1$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("dUANg", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $a20d0bc3a4af4abb$export$d1cea0ee4e3f0d3e, (v) => $a20d0bc3a4af4abb$export$d1cea0ee4e3f0d3e = v);
var $a20d0bc3a4af4abb$export$d1cea0ee4e3f0d3e;
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $bvPfH = parcelRequire("bvPfH");
var $a20d0bc3a4af4abb$var$rotl32 = $aYhtf.rotl32;
var $a20d0bc3a4af4abb$var$sum32 = $aYhtf.sum32;
var $a20d0bc3a4af4abb$var$sum32_3 = $aYhtf.sum32_3;
var $a20d0bc3a4af4abb$var$sum32_4 = $aYhtf.sum32_4;
var $a20d0bc3a4af4abb$var$BlockHash = $bvPfH.BlockHash;
function $a20d0bc3a4af4abb$var$RIPEMD160() {
    if (!(this instanceof $a20d0bc3a4af4abb$var$RIPEMD160)) return new $a20d0bc3a4af4abb$var$RIPEMD160();
    $a20d0bc3a4af4abb$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$aYhtf.inherits($a20d0bc3a4af4abb$var$RIPEMD160, $a20d0bc3a4af4abb$var$BlockHash);
$a20d0bc3a4af4abb$export$d1cea0ee4e3f0d3e = $a20d0bc3a4af4abb$var$RIPEMD160;
$a20d0bc3a4af4abb$var$RIPEMD160.blockSize = 512;
$a20d0bc3a4af4abb$var$RIPEMD160.outSize = 160;
$a20d0bc3a4af4abb$var$RIPEMD160.hmacStrength = 192;
$a20d0bc3a4af4abb$var$RIPEMD160.padLength = 64;
$a20d0bc3a4af4abb$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $a20d0bc3a4af4abb$var$sum32($a20d0bc3a4af4abb$var$rotl32($a20d0bc3a4af4abb$var$sum32_4(A, $a20d0bc3a4af4abb$var$f(j, B, C, D), msg[$a20d0bc3a4af4abb$var$r[j] + start], $a20d0bc3a4af4abb$var$K(j)), $a20d0bc3a4af4abb$var$s[j]), E);
        A = E;
        E = D;
        D = $a20d0bc3a4af4abb$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $a20d0bc3a4af4abb$var$sum32($a20d0bc3a4af4abb$var$rotl32($a20d0bc3a4af4abb$var$sum32_4(Ah, $a20d0bc3a4af4abb$var$f(79 - j, Bh, Ch, Dh), msg[$a20d0bc3a4af4abb$var$rh[j] + start], $a20d0bc3a4af4abb$var$Kh(j)), $a20d0bc3a4af4abb$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $a20d0bc3a4af4abb$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $a20d0bc3a4af4abb$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $a20d0bc3a4af4abb$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $a20d0bc3a4af4abb$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $a20d0bc3a4af4abb$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $a20d0bc3a4af4abb$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$a20d0bc3a4af4abb$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aYhtf.toHex32(this.h, 'little');
    else return $aYhtf.split32(this.h, 'little');
};
function $a20d0bc3a4af4abb$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $a20d0bc3a4af4abb$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $a20d0bc3a4af4abb$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $a20d0bc3a4af4abb$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $a20d0bc3a4af4abb$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $a20d0bc3a4af4abb$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $a20d0bc3a4af4abb$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("cF3J2", function(module, exports) {
'use strict';

var $aYhtf = parcelRequire("aYhtf");

var $cRsPH = parcelRequire("cRsPH");
function $937c342f52045eae$var$Hmac(hash, key, enc) {
    if (!(this instanceof $937c342f52045eae$var$Hmac)) return new $937c342f52045eae$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($aYhtf.toArray(key, enc));
}
module.exports = $937c342f52045eae$var$Hmac;
$937c342f52045eae$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $cRsPH(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$937c342f52045eae$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$937c342f52045eae$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("8uqTa", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("aEMDP", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $jjdzw = parcelRequire("jjdzw");

var $fiDc2 = parcelRequire("fiDc2");

var $3ZXqy = parcelRequire("3ZXqy");

var $efv6w = parcelRequire("efv6w");
var $7c235ef99bb146cd$var$assert = $fiDc2.assert;

var $ajyKJ = parcelRequire("ajyKJ");

var $lOeMz = parcelRequire("lOeMz");
function $7c235ef99bb146cd$var$EC(options) {
    if (!(this instanceof $7c235ef99bb146cd$var$EC)) return new $7c235ef99bb146cd$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $7c235ef99bb146cd$var$assert(Object.prototype.hasOwnProperty.call($3ZXqy, options), 'Unknown curve ' + options);
        options = $3ZXqy[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $3ZXqy.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $7c235ef99bb146cd$var$EC;
$7c235ef99bb146cd$var$EC.prototype.keyPair = function keyPair(options) {
    return new $ajyKJ(this, options);
};
$7c235ef99bb146cd$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $ajyKJ.fromPrivate(this, priv, enc);
};
$7c235ef99bb146cd$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $ajyKJ.fromPublic(this, pub, enc);
};
$7c235ef99bb146cd$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $jjdzw({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $efv6w(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $anLPs(2));
    for(;;){
        var priv = new $anLPs(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$7c235ef99bb146cd$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($anLPs.isBN(msg) || typeof msg === 'number') {
        msg = new $anLPs(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $anLPs(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $anLPs(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$7c235ef99bb146cd$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$anLPs.isBN(msg)) {
        $7c235ef99bb146cd$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $7c235ef99bb146cd$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$7c235ef99bb146cd$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $7c235ef99bb146cd$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $7c235ef99bb146cd$var$assert(new $anLPs(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $jjdzw({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $anLPs(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $anLPs(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $lOeMz({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$7c235ef99bb146cd$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $lOeMz(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$7c235ef99bb146cd$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $7c235ef99bb146cd$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $lOeMz(signature, enc);
    var n = this.n;
    var e = new $anLPs(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$7c235ef99bb146cd$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $lOeMz(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("jjdzw", function(module, exports) {
'use strict';

var $joeYQ = parcelRequire("joeYQ");

var $47iwF = parcelRequire("47iwF");

var $cRsPH = parcelRequire("cRsPH");
function $e0ea51bfc32bb4ae$var$HmacDRBG(options) {
    if (!(this instanceof $e0ea51bfc32bb4ae$var$HmacDRBG)) return new $e0ea51bfc32bb4ae$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $47iwF.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $47iwF.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $47iwF.toArray(options.pers, options.persEnc || 'hex');
    $cRsPH(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $e0ea51bfc32bb4ae$var$HmacDRBG;
$e0ea51bfc32bb4ae$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$e0ea51bfc32bb4ae$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $joeYQ.hmac(this.hash, this.K);
};
$e0ea51bfc32bb4ae$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$e0ea51bfc32bb4ae$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $47iwF.toArray(entropy, entropyEnc);
    add = $47iwF.toArray(add, addEnc);
    $cRsPH(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$e0ea51bfc32bb4ae$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $47iwF.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $47iwF.encode(res, enc);
};

});

parcelRegister("ajyKJ", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $fiDc2 = parcelRequire("fiDc2");
var $7826a2e809300b04$var$assert = $fiDc2.assert;
function $7826a2e809300b04$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $7826a2e809300b04$var$KeyPair;
$7826a2e809300b04$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $7826a2e809300b04$var$KeyPair) return pub;
    return new $7826a2e809300b04$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$7826a2e809300b04$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $7826a2e809300b04$var$KeyPair) return priv;
    return new $7826a2e809300b04$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$7826a2e809300b04$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$7826a2e809300b04$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$7826a2e809300b04$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$7826a2e809300b04$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $anLPs(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$7826a2e809300b04$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $7826a2e809300b04$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $7826a2e809300b04$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$7826a2e809300b04$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $7826a2e809300b04$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$7826a2e809300b04$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$7826a2e809300b04$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$7826a2e809300b04$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("lOeMz", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $fiDc2 = parcelRequire("fiDc2");
var $fe09bbf2ade8153b$var$assert = $fiDc2.assert;
function $fe09bbf2ade8153b$var$Signature(options, enc) {
    if (options instanceof $fe09bbf2ade8153b$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $fe09bbf2ade8153b$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $anLPs(options.r, 16);
    this.s = new $anLPs(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $fe09bbf2ade8153b$var$Signature;
function $fe09bbf2ade8153b$var$Position() {
    this.place = 0;
}
function $fe09bbf2ade8153b$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $fe09bbf2ade8153b$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$fe09bbf2ade8153b$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $fiDc2.toArray(data, enc);
    var p = new $fe09bbf2ade8153b$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $fe09bbf2ade8153b$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $fe09bbf2ade8153b$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $fe09bbf2ade8153b$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $anLPs(r);
    this.s = new $anLPs(s);
    this.recoveryParam = null;
    return true;
};
function $fe09bbf2ade8153b$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$fe09bbf2ade8153b$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $fe09bbf2ade8153b$var$rmPadding(r);
    s = $fe09bbf2ade8153b$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $fe09bbf2ade8153b$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $fe09bbf2ade8153b$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $fe09bbf2ade8153b$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $fiDc2.encode(res, enc);
};

});


parcelRegister("ksKr1", function(module, exports) {
'use strict';

var $joeYQ = parcelRequire("joeYQ");

var $3ZXqy = parcelRequire("3ZXqy");

var $fiDc2 = parcelRequire("fiDc2");
var $ee5a71272ac2672d$var$assert = $fiDc2.assert;
var $ee5a71272ac2672d$var$parseBytes = $fiDc2.parseBytes;

var $76bip = parcelRequire("76bip");

var $i0DVx = parcelRequire("i0DVx");
function $ee5a71272ac2672d$var$EDDSA(curve) {
    $ee5a71272ac2672d$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $ee5a71272ac2672d$var$EDDSA)) return new $ee5a71272ac2672d$var$EDDSA(curve);
    curve = $3ZXqy[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $joeYQ.sha512;
}
module.exports = $ee5a71272ac2672d$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $ee5a71272ac2672d$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $ee5a71272ac2672d$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $ee5a71272ac2672d$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $ee5a71272ac2672d$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$ee5a71272ac2672d$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $fiDc2.intFromLE(hash.digest()).umod(this.curve.n);
};
$ee5a71272ac2672d$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $76bip.fromPublic(this, pub);
};
$ee5a71272ac2672d$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $76bip.fromSecret(this, secret);
};
$ee5a71272ac2672d$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $i0DVx) return sig;
    return new $i0DVx(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $ee5a71272ac2672d$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$ee5a71272ac2672d$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $fiDc2.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $fiDc2.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$ee5a71272ac2672d$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$ee5a71272ac2672d$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $fiDc2.intFromLE(bytes);
};
$ee5a71272ac2672d$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("76bip", function(module, exports) {
'use strict';

var $fiDc2 = parcelRequire("fiDc2");
var $52b1db190a3bf259$var$assert = $fiDc2.assert;
var $52b1db190a3bf259$var$parseBytes = $fiDc2.parseBytes;
var $52b1db190a3bf259$var$cachedProperty = $fiDc2.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $52b1db190a3bf259$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $52b1db190a3bf259$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $52b1db190a3bf259$var$parseBytes(params.pub);
}
$52b1db190a3bf259$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $52b1db190a3bf259$var$KeyPair) return pub;
    return new $52b1db190a3bf259$var$KeyPair(eddsa, {
        pub: pub
    });
};
$52b1db190a3bf259$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $52b1db190a3bf259$var$KeyPair) return secret;
    return new $52b1db190a3bf259$var$KeyPair(eddsa, {
        secret: secret
    });
};
$52b1db190a3bf259$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$52b1db190a3bf259$var$cachedProperty($52b1db190a3bf259$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$52b1db190a3bf259$var$KeyPair.prototype.sign = function sign(message) {
    $52b1db190a3bf259$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$52b1db190a3bf259$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$52b1db190a3bf259$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $52b1db190a3bf259$var$assert(this._secret, 'KeyPair is public only');
    return $fiDc2.encode(this.secret(), enc);
};
$52b1db190a3bf259$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $fiDc2.encode(this.pubBytes(), enc);
};
module.exports = $52b1db190a3bf259$var$KeyPair;

});

parcelRegister("i0DVx", function(module, exports) {
'use strict';

var $anLPs = parcelRequire("anLPs");

var $fiDc2 = parcelRequire("fiDc2");
var $d1c732bf71e19cb9$var$assert = $fiDc2.assert;
var $d1c732bf71e19cb9$var$cachedProperty = $fiDc2.cachedProperty;
var $d1c732bf71e19cb9$var$parseBytes = $fiDc2.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $d1c732bf71e19cb9$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $d1c732bf71e19cb9$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $d1c732bf71e19cb9$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $d1c732bf71e19cb9$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $anLPs) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$d1c732bf71e19cb9$var$cachedProperty($d1c732bf71e19cb9$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$d1c732bf71e19cb9$var$cachedProperty($d1c732bf71e19cb9$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$d1c732bf71e19cb9$var$cachedProperty($d1c732bf71e19cb9$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$d1c732bf71e19cb9$var$cachedProperty($d1c732bf71e19cb9$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$d1c732bf71e19cb9$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$d1c732bf71e19cb9$var$Signature.prototype.toHex = function toHex() {
    return $fiDc2.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $d1c732bf71e19cb9$var$Signature;

});



parcelRegister("1mhER", function(module, exports) {
'use strict';

var $jbPnX = parcelRequire("jbPnX");

var $apxiG = parcelRequire("apxiG");

var $4kqhh = parcelRequire("4kqhh");

var $BxYCC = parcelRequire("BxYCC");

var $96GTd = parcelRequire("96GTd");
var $0fd58b073c5ed080$require$pbkdf2Sync = $96GTd.pbkdf2Sync;

var $jcTxY = parcelRequire("jcTxY");
var $0fd58b073c5ed080$require$Buffer = $jcTxY.Buffer;
function $0fd58b073c5ed080$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $apxiG[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $0fd58b073c5ed080$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $BxYCC.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $0fd58b073c5ed080$require$Buffer.concat(out);
}
function $0fd58b073c5ed080$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$0fd58b073c5ed080$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $0fd58b073c5ed080$require$Buffer.from(buffer);
    var stripped = $4kqhh(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $jbPnX.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $jbPnX.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $jbPnX.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $jbPnX.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $jbPnX.EncryptedPrivateKey.decode(data, 'der');
            data = $0fd58b073c5ed080$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $jbPnX.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $jbPnX.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $jbPnX.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $jbPnX.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $jbPnX.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $jbPnX.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $jbPnX.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $jbPnX.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$0fd58b073c5ed080$var$parseKeys.signature = $jbPnX.signature;
module.exports = $0fd58b073c5ed080$var$parseKeys;

});
parcelRegister("jbPnX", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $df86e77556b80d53$export$c98397a6eb8d0678, (v) => $df86e77556b80d53$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $df86e77556b80d53$export$f4aab6816f64fa6b, (v) => $df86e77556b80d53$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $df86e77556b80d53$export$4471f5c65d097c11, (v) => $df86e77556b80d53$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $df86e77556b80d53$export$ca8b6604d6ce14de, (v) => $df86e77556b80d53$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $df86e77556b80d53$export$8f54525b330fd87b, (v) => $df86e77556b80d53$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $df86e77556b80d53$export$23cd2842b44ca3e7, (v) => $df86e77556b80d53$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $df86e77556b80d53$export$245c9aaa9f5ce4ce, (v) => $df86e77556b80d53$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $df86e77556b80d53$export$8ad762e3e6399afe, (v) => $df86e77556b80d53$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $df86e77556b80d53$export$32ef6f92e22c6ab0, (v) => $df86e77556b80d53$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $df86e77556b80d53$export$c9cd164b539ebb63, (v) => $df86e77556b80d53$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $df86e77556b80d53$export$c98397a6eb8d0678;
var $df86e77556b80d53$export$f4aab6816f64fa6b;
var $df86e77556b80d53$export$4471f5c65d097c11;
var $df86e77556b80d53$export$ca8b6604d6ce14de;
var $df86e77556b80d53$export$8f54525b330fd87b;
var $df86e77556b80d53$export$23cd2842b44ca3e7;
var $df86e77556b80d53$export$245c9aaa9f5ce4ce;
var $df86e77556b80d53$export$8ad762e3e6399afe;
var $df86e77556b80d53$export$32ef6f92e22c6ab0;
var $df86e77556b80d53$export$c9cd164b539ebb63;
'use strict';

var $jyn4R = parcelRequire("jyn4R");

$df86e77556b80d53$export$c98397a6eb8d0678 = (parcelRequire("j14yn"));
var $df86e77556b80d53$var$RSAPrivateKey = $jyn4R.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$df86e77556b80d53$export$f4aab6816f64fa6b = $df86e77556b80d53$var$RSAPrivateKey;
var $df86e77556b80d53$var$RSAPublicKey = $jyn4R.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$df86e77556b80d53$export$4471f5c65d097c11 = $df86e77556b80d53$var$RSAPublicKey;
var $df86e77556b80d53$var$AlgorithmIdentifier = $jyn4R.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $df86e77556b80d53$var$PublicKey = $jyn4R.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($df86e77556b80d53$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$df86e77556b80d53$export$ca8b6604d6ce14de = $df86e77556b80d53$var$PublicKey;
var $df86e77556b80d53$var$PrivateKeyInfo = $jyn4R.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($df86e77556b80d53$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$df86e77556b80d53$export$8f54525b330fd87b = $df86e77556b80d53$var$PrivateKeyInfo;
var $df86e77556b80d53$var$EncryptedPrivateKeyInfo = $jyn4R.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$df86e77556b80d53$export$23cd2842b44ca3e7 = $df86e77556b80d53$var$EncryptedPrivateKeyInfo;
var $df86e77556b80d53$var$DSAPrivateKey = $jyn4R.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$df86e77556b80d53$export$245c9aaa9f5ce4ce = $df86e77556b80d53$var$DSAPrivateKey;
$df86e77556b80d53$export$8ad762e3e6399afe = $jyn4R.define('DSAparam', function() {
    this['int']();
});
var $df86e77556b80d53$var$ECParameters = $jyn4R.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $df86e77556b80d53$var$ECPrivateKey = $jyn4R.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($df86e77556b80d53$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$df86e77556b80d53$export$32ef6f92e22c6ab0 = $df86e77556b80d53$var$ECPrivateKey;
$df86e77556b80d53$export$c9cd164b539ebb63 = $jyn4R.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("jyn4R", function(module, exports) {
var $e3c317f8a4fee596$var$asn1 = module.exports;

$e3c317f8a4fee596$var$asn1.bignum = (parcelRequire("anLPs"));

$e3c317f8a4fee596$var$asn1.define = (parcelRequire("8Cpoj")).define;

$e3c317f8a4fee596$var$asn1.base = (parcelRequire("DLnw6"));

$e3c317f8a4fee596$var$asn1.constants = (parcelRequire("5tCRQ"));

$e3c317f8a4fee596$var$asn1.decoders = (parcelRequire("7XPpr"));

$e3c317f8a4fee596$var$asn1.encoders = (parcelRequire("6QUqI"));

});
parcelRegister("8Cpoj", function(module, exports) {

var $jyn4R = parcelRequire("jyn4R");

var $9YOog = parcelRequire("9YOog");
var $6465917a201178cb$var$api = module.exports;
$6465917a201178cb$var$api.define = function define(name, body) {
    return new $6465917a201178cb$var$Entity(name, body);
};
function $6465917a201178cb$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$6465917a201178cb$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("3Ey7e")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $9YOog(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$6465917a201178cb$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($jyn4R.decoders[enc]);
    return this.decoders[enc];
};
$6465917a201178cb$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$6465917a201178cb$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($jyn4R.encoders[enc]);
    return this.encoders[enc];
};
$6465917a201178cb$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("3Ey7e", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("DLnw6", function(module, exports) {
var $077864fa377f860f$var$base = module.exports;

$077864fa377f860f$var$base.Reporter = (parcelRequire("4aS2I")).Reporter;

$077864fa377f860f$var$base.DecoderBuffer = (parcelRequire("ivLC5")).DecoderBuffer;

$077864fa377f860f$var$base.EncoderBuffer = (parcelRequire("ivLC5")).EncoderBuffer;

$077864fa377f860f$var$base.Node = (parcelRequire("eKwXc"));

});
parcelRegister("4aS2I", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $30a2045f40c9b7ef$export$957313a2f485e5ed, (v) => $30a2045f40c9b7ef$export$957313a2f485e5ed = v);
var $30a2045f40c9b7ef$export$957313a2f485e5ed;

var $9YOog = parcelRequire("9YOog");
function $30a2045f40c9b7ef$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$30a2045f40c9b7ef$export$957313a2f485e5ed = $30a2045f40c9b7ef$var$Reporter;
$30a2045f40c9b7ef$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $30a2045f40c9b7ef$var$ReporterError;
};
$30a2045f40c9b7ef$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$30a2045f40c9b7ef$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$30a2045f40c9b7ef$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$30a2045f40c9b7ef$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$30a2045f40c9b7ef$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$30a2045f40c9b7ef$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$30a2045f40c9b7ef$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$30a2045f40c9b7ef$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$30a2045f40c9b7ef$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $30a2045f40c9b7ef$var$ReporterError;
    if (inherited) err = msg;
    else err = new $30a2045f40c9b7ef$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$30a2045f40c9b7ef$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $30a2045f40c9b7ef$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$9YOog($30a2045f40c9b7ef$var$ReporterError, Error);
$30a2045f40c9b7ef$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $30a2045f40c9b7ef$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("ivLC5", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $d7a00e3f971b0fa9$export$bf9f79cdc4a49163, (v) => $d7a00e3f971b0fa9$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $d7a00e3f971b0fa9$export$8ff24f7760c7a78e, (v) => $d7a00e3f971b0fa9$export$8ff24f7760c7a78e = v);
var $d7a00e3f971b0fa9$export$bf9f79cdc4a49163;
var $d7a00e3f971b0fa9$export$8ff24f7760c7a78e;

var $9YOog = parcelRequire("9YOog");

var $DLnw6 = parcelRequire("DLnw6");
var $d7a00e3f971b0fa9$require$Reporter = $DLnw6.Reporter;

var $kFATv = parcelRequire("kFATv");
var $d7a00e3f971b0fa9$require$Buffer = $kFATv.Buffer;
function $d7a00e3f971b0fa9$var$DecoderBuffer(base, options) {
    $d7a00e3f971b0fa9$require$Reporter.call(this, options);
    if (!$d7a00e3f971b0fa9$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$9YOog($d7a00e3f971b0fa9$var$DecoderBuffer, $d7a00e3f971b0fa9$require$Reporter);
$d7a00e3f971b0fa9$export$bf9f79cdc4a49163 = $d7a00e3f971b0fa9$var$DecoderBuffer;
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $d7a00e3f971b0fa9$require$Reporter.prototype.save.call(this)
    };
};
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $d7a00e3f971b0fa9$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $d7a00e3f971b0fa9$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $d7a00e3f971b0fa9$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$d7a00e3f971b0fa9$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $d7a00e3f971b0fa9$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $d7a00e3f971b0fa9$var$EncoderBuffer)) item = new $d7a00e3f971b0fa9$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $d7a00e3f971b0fa9$require$Buffer.byteLength(value);
    } else if ($d7a00e3f971b0fa9$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$d7a00e3f971b0fa9$export$8ff24f7760c7a78e = $d7a00e3f971b0fa9$var$EncoderBuffer;
$d7a00e3f971b0fa9$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $d7a00e3f971b0fa9$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($d7a00e3f971b0fa9$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("eKwXc", function(module, exports) {

var $DLnw6 = parcelRequire("DLnw6");
var $abceec8852fc42f9$require$Reporter = $DLnw6.Reporter;

var $DLnw6 = parcelRequire("DLnw6");
var $abceec8852fc42f9$require$EncoderBuffer = $DLnw6.EncoderBuffer;

var $DLnw6 = parcelRequire("DLnw6");
var $abceec8852fc42f9$require$DecoderBuffer = $DLnw6.DecoderBuffer;

var $cRsPH = parcelRequire("cRsPH");
// Supported tags
var $abceec8852fc42f9$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $abceec8852fc42f9$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($abceec8852fc42f9$var$tags);
// Overrided methods list
var $abceec8852fc42f9$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $abceec8852fc42f9$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $abceec8852fc42f9$var$Node;
var $abceec8852fc42f9$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$abceec8852fc42f9$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $abceec8852fc42f9$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$abceec8852fc42f9$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $abceec8852fc42f9$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$abceec8852fc42f9$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $cRsPH(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $cRsPH.equal(state.children.length, 1, 'Root node can have only one child');
};
$abceec8852fc42f9$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $cRsPH(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $cRsPH(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$abceec8852fc42f9$var$overrided.forEach(function(method) {
    $abceec8852fc42f9$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$abceec8852fc42f9$var$tags.forEach(function(tag) {
    $abceec8852fc42f9$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $cRsPH(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$abceec8852fc42f9$var$Node.prototype.use = function use(item) {
    $cRsPH(item);
    var state = this._baseState;
    $cRsPH(state.use === null);
    state.use = item;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $cRsPH(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $cRsPH(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $cRsPH(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$abceec8852fc42f9$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $cRsPH(state.key === null);
    state.key = newKey;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$abceec8852fc42f9$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $cRsPH(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$abceec8852fc42f9$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $cRsPH(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$abceec8852fc42f9$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $abceec8852fc42f9$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$abceec8852fc42f9$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$abceec8852fc42f9$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $cRsPH(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$abceec8852fc42f9$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$abceec8852fc42f9$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $abceec8852fc42f9$require$EncoderBuffer(data, this.reporter);
};
$abceec8852fc42f9$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$abceec8852fc42f9$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $abceec8852fc42f9$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$abceec8852fc42f9$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $cRsPH(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$abceec8852fc42f9$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$abceec8852fc42f9$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$abceec8852fc42f9$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("5tCRQ", function(module, exports) {
var $3fcdcf7066230011$var$constants = module.exports;
// Helper
$3fcdcf7066230011$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$3fcdcf7066230011$var$constants.der = (parcelRequire("fPkhJ"));

});
parcelRegister("fPkhJ", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $b85b5a9723bc8e08$export$3584c46ed60baee8, (v) => $b85b5a9723bc8e08$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $b85b5a9723bc8e08$export$f18596ef8d632e49, (v) => $b85b5a9723bc8e08$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $b85b5a9723bc8e08$export$2b067c6666111485, (v) => $b85b5a9723bc8e08$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $b85b5a9723bc8e08$export$f17df38a421ab9e3, (v) => $b85b5a9723bc8e08$export$f17df38a421ab9e3 = v);
var $b85b5a9723bc8e08$export$3584c46ed60baee8;
var $b85b5a9723bc8e08$export$f18596ef8d632e49;
var $b85b5a9723bc8e08$export$2b067c6666111485;
var $b85b5a9723bc8e08$export$f17df38a421ab9e3;

var $5tCRQ = parcelRequire("5tCRQ");
$b85b5a9723bc8e08$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$b85b5a9723bc8e08$export$f18596ef8d632e49 = $5tCRQ._reverse($b85b5a9723bc8e08$export$3584c46ed60baee8);
$b85b5a9723bc8e08$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$b85b5a9723bc8e08$export$f17df38a421ab9e3 = $5tCRQ._reverse($b85b5a9723bc8e08$export$2b067c6666111485);

});


parcelRegister("7XPpr", function(module, exports) {
var $5cc5ebeb320c4171$var$decoders = module.exports;

$5cc5ebeb320c4171$var$decoders.der = (parcelRequire("18vuM"));

$5cc5ebeb320c4171$var$decoders.pem = (parcelRequire("hLJ43"));

});
parcelRegister("18vuM", function(module, exports) {

var $9YOog = parcelRequire("9YOog");

var $jyn4R = parcelRequire("jyn4R");
var $0d3ef825f8d1f5dd$var$base = $jyn4R.base;
var $0d3ef825f8d1f5dd$var$bignum = $jyn4R.bignum;
// Import DER constants
var $0d3ef825f8d1f5dd$var$der = $jyn4R.constants.der;
function $0d3ef825f8d1f5dd$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $0d3ef825f8d1f5dd$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $0d3ef825f8d1f5dd$var$DERDecoder;
$0d3ef825f8d1f5dd$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $0d3ef825f8d1f5dd$var$base.DecoderBuffer)) data = new $0d3ef825f8d1f5dd$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $0d3ef825f8d1f5dd$var$DERNode(parent) {
    $0d3ef825f8d1f5dd$var$base.Node.call(this, 'der', parent);
}
$9YOog($0d3ef825f8d1f5dd$var$DERNode, $0d3ef825f8d1f5dd$var$base.Node);
$0d3ef825f8d1f5dd$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $0d3ef825f8d1f5dd$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $0d3ef825f8d1f5dd$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $0d3ef825f8d1f5dd$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $0d3ef825f8d1f5dd$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $0d3ef825f8d1f5dd$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $0d3ef825f8d1f5dd$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$0d3ef825f8d1f5dd$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $0d3ef825f8d1f5dd$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $0d3ef825f8d1f5dd$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $0d3ef825f8d1f5dd$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $0d3ef825f8d1f5dd$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("hLJ43", function(module, exports) {

var $9YOog = parcelRequire("9YOog");

var $kFATv = parcelRequire("kFATv");
var $cef9c84cf70b5f5a$require$Buffer = $kFATv.Buffer;

var $18vuM = parcelRequire("18vuM");
function $cef9c84cf70b5f5a$var$PEMDecoder(entity) {
    $18vuM.call(this, entity);
    this.enc = 'pem';
}
$9YOog($cef9c84cf70b5f5a$var$PEMDecoder, $18vuM);
module.exports = $cef9c84cf70b5f5a$var$PEMDecoder;
$cef9c84cf70b5f5a$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $cef9c84cf70b5f5a$require$Buffer(base64, 'base64');
    return $18vuM.prototype.decode.call(this, input, options);
};

});


parcelRegister("6QUqI", function(module, exports) {
var $4fd35f3b7efc4362$var$encoders = module.exports;

$4fd35f3b7efc4362$var$encoders.der = (parcelRequire("eh9lx"));

$4fd35f3b7efc4362$var$encoders.pem = (parcelRequire("7zAQz"));

});
parcelRegister("eh9lx", function(module, exports) {

var $9YOog = parcelRequire("9YOog");

var $kFATv = parcelRequire("kFATv");
var $a649e733fc0594bf$require$Buffer = $kFATv.Buffer;

var $jyn4R = parcelRequire("jyn4R");
var $a649e733fc0594bf$var$base = $jyn4R.base;
// Import DER constants
var $a649e733fc0594bf$var$der = $jyn4R.constants.der;
function $a649e733fc0594bf$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $a649e733fc0594bf$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $a649e733fc0594bf$var$DEREncoder;
$a649e733fc0594bf$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $a649e733fc0594bf$var$DERNode(parent) {
    $a649e733fc0594bf$var$base.Node.call(this, 'der', parent);
}
$9YOog($a649e733fc0594bf$var$DERNode, $a649e733fc0594bf$var$base.Node);
$a649e733fc0594bf$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $a649e733fc0594bf$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $a649e733fc0594bf$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $a649e733fc0594bf$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$a649e733fc0594bf$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $a649e733fc0594bf$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$a649e733fc0594bf$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $a649e733fc0594bf$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $a649e733fc0594bf$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$a649e733fc0594bf$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $a649e733fc0594bf$var$two(date.getFullYear()),
        $a649e733fc0594bf$var$two(date.getUTCMonth() + 1),
        $a649e733fc0594bf$var$two(date.getUTCDate()),
        $a649e733fc0594bf$var$two(date.getUTCHours()),
        $a649e733fc0594bf$var$two(date.getUTCMinutes()),
        $a649e733fc0594bf$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $a649e733fc0594bf$var$two(date.getFullYear() % 100),
        $a649e733fc0594bf$var$two(date.getUTCMonth() + 1),
        $a649e733fc0594bf$var$two(date.getUTCDate()),
        $a649e733fc0594bf$var$two(date.getUTCHours()),
        $a649e733fc0594bf$var$two(date.getUTCMinutes()),
        $a649e733fc0594bf$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$a649e733fc0594bf$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$a649e733fc0594bf$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$a649e733fc0594bf$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $a649e733fc0594bf$require$Buffer(numArray);
    }
    if ($a649e733fc0594bf$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $a649e733fc0594bf$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $a649e733fc0594bf$require$Buffer(out));
};
$a649e733fc0594bf$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$a649e733fc0594bf$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$a649e733fc0594bf$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $a649e733fc0594bf$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($a649e733fc0594bf$var$der.tagByName.hasOwnProperty(tag)) res = $a649e733fc0594bf$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $a649e733fc0594bf$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("7zAQz", function(module, exports) {

var $9YOog = parcelRequire("9YOog");

var $eh9lx = parcelRequire("eh9lx");
function $58386256f6f1dec3$var$PEMEncoder(entity) {
    $eh9lx.call(this, entity);
    this.enc = 'pem';
}
$9YOog($58386256f6f1dec3$var$PEMEncoder, $eh9lx);
module.exports = $58386256f6f1dec3$var$PEMEncoder;
$58386256f6f1dec3$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $eh9lx.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("j14yn", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $jyn4R = parcelRequire("jyn4R");
var $03929b6d970879be$var$Time = $jyn4R.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $03929b6d970879be$var$AttributeTypeValue = $jyn4R.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $03929b6d970879be$var$AlgorithmIdentifier = $jyn4R.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $03929b6d970879be$var$SubjectPublicKeyInfo = $jyn4R.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($03929b6d970879be$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $03929b6d970879be$var$RelativeDistinguishedName = $jyn4R.define('RelativeDistinguishedName', function() {
    this.setof($03929b6d970879be$var$AttributeTypeValue);
});
var $03929b6d970879be$var$RDNSequence = $jyn4R.define('RDNSequence', function() {
    this.seqof($03929b6d970879be$var$RelativeDistinguishedName);
});
var $03929b6d970879be$var$Name = $jyn4R.define('Name', function() {
    this.choice({
        rdnSequence: this.use($03929b6d970879be$var$RDNSequence)
    });
});
var $03929b6d970879be$var$Validity = $jyn4R.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($03929b6d970879be$var$Time), this.key('notAfter').use($03929b6d970879be$var$Time));
});
var $03929b6d970879be$var$Extension = $jyn4R.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $03929b6d970879be$var$TBSCertificate = $jyn4R.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($03929b6d970879be$var$AlgorithmIdentifier), this.key('issuer').use($03929b6d970879be$var$Name), this.key('validity').use($03929b6d970879be$var$Validity), this.key('subject').use($03929b6d970879be$var$Name), this.key('subjectPublicKeyInfo').use($03929b6d970879be$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($03929b6d970879be$var$Extension).optional());
});
var $03929b6d970879be$var$X509Certificate = $jyn4R.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($03929b6d970879be$var$TBSCertificate), this.key('signatureAlgorithm').use($03929b6d970879be$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $03929b6d970879be$var$X509Certificate;

});


parcelRegister("apxiG", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("4kqhh", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $326d69dce7eb6787$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $326d69dce7eb6787$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $326d69dce7eb6787$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $5Gvmk = parcelRequire("5Gvmk");

var $BxYCC = parcelRequire("BxYCC");

var $jcTxY = parcelRequire("jcTxY");
var $326d69dce7eb6787$require$Buffer = $jcTxY.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($326d69dce7eb6787$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($326d69dce7eb6787$var$fullRegex);
        decrypted = $326d69dce7eb6787$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $326d69dce7eb6787$require$Buffer.from(match[2], 'hex');
        var cipherText = $326d69dce7eb6787$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $5Gvmk(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $BxYCC.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $326d69dce7eb6787$require$Buffer.concat(out);
    }
    var tag = key.match($326d69dce7eb6787$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("81ACA", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("7rRmj", function(module, exports) {
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $56c471fcf97d00e0$require$Buffer = $jcTxY.Buffer;

var $iogP6 = parcelRequire("iogP6");

var $9XWzf = parcelRequire("9XWzf");
var $56c471fcf97d00e0$require$EC = $9XWzf.ec;

var $1mhER = parcelRequire("1mhER");

var $81ACA = parcelRequire("81ACA");
function $56c471fcf97d00e0$var$verify(sig, hash, key, signType, tag) {
    var pub = $1mhER(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $56c471fcf97d00e0$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $56c471fcf97d00e0$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $56c471fcf97d00e0$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $56c471fcf97d00e0$require$Buffer.from(pad);
    var red = $iogP6.mont(pub.modulus);
    sig = new $iogP6(sig).toRed(red);
    sig = sig.redPow(new $iogP6(pub.publicExponent));
    sig = $56c471fcf97d00e0$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $56c471fcf97d00e0$var$ecVerify(sig, hash, pub) {
    var curveId = $81ACA[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $56c471fcf97d00e0$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $56c471fcf97d00e0$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $1mhER.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $56c471fcf97d00e0$var$checkValue(s, q);
    $56c471fcf97d00e0$var$checkValue(r, q);
    var montp = $iogP6.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $iogP6(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $56c471fcf97d00e0$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $56c471fcf97d00e0$var$verify;

});


parcelRegister("gHlai", function(module, exports) {

var $kFATv = parcelRequire("kFATv");
var $c281146ab88214c9$require$Buffer = $kFATv.Buffer;

var $9XWzf = parcelRequire("9XWzf");

var $anLPs = parcelRequire("anLPs");
module.exports = function createECDH(curve) {
    return new $c281146ab88214c9$var$ECDH(curve);
};
var $c281146ab88214c9$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$c281146ab88214c9$var$aliases.p224 = $c281146ab88214c9$var$aliases.secp224r1;
$c281146ab88214c9$var$aliases.p256 = $c281146ab88214c9$var$aliases.secp256r1 = $c281146ab88214c9$var$aliases.prime256v1;
$c281146ab88214c9$var$aliases.p192 = $c281146ab88214c9$var$aliases.secp192r1 = $c281146ab88214c9$var$aliases.prime192v1;
$c281146ab88214c9$var$aliases.p384 = $c281146ab88214c9$var$aliases.secp384r1;
$c281146ab88214c9$var$aliases.p521 = $c281146ab88214c9$var$aliases.secp521r1;
function $c281146ab88214c9$var$ECDH(curve) {
    this.curveType = $c281146ab88214c9$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $9XWzf.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$c281146ab88214c9$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$c281146ab88214c9$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$c281146ab88214c9$require$Buffer.isBuffer(other)) other = new $c281146ab88214c9$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $c281146ab88214c9$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$c281146ab88214c9$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $c281146ab88214c9$var$formatReturnValue(key, enc);
};
$c281146ab88214c9$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $c281146ab88214c9$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$c281146ab88214c9$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$c281146ab88214c9$require$Buffer.isBuffer(pub)) pub = new $c281146ab88214c9$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$c281146ab88214c9$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$c281146ab88214c9$require$Buffer.isBuffer(priv)) priv = new $c281146ab88214c9$require$Buffer(priv, enc);
    var _priv = new $anLPs(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $c281146ab88214c9$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $c281146ab88214c9$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $c281146ab88214c9$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $c281146ab88214c9$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("1e6mq", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $0e4c0855746f772b$export$512823e338ddb1b7, (v) => $0e4c0855746f772b$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $0e4c0855746f772b$export$7efb24e2fddf99b9, (v) => $0e4c0855746f772b$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $0e4c0855746f772b$export$9d0e0c0c4a8d30f3, (v) => $0e4c0855746f772b$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $0e4c0855746f772b$export$b9d55ff329113abd, (v) => $0e4c0855746f772b$export$b9d55ff329113abd = v);
var $0e4c0855746f772b$export$512823e338ddb1b7;
var $0e4c0855746f772b$export$7efb24e2fddf99b9;
var $0e4c0855746f772b$export$9d0e0c0c4a8d30f3;
var $0e4c0855746f772b$export$b9d55ff329113abd;

$0e4c0855746f772b$export$512823e338ddb1b7 = (parcelRequire("61CSG"));

$0e4c0855746f772b$export$7efb24e2fddf99b9 = (parcelRequire("DPRko"));
$0e4c0855746f772b$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $0e4c0855746f772b$export$512823e338ddb1b7(key, buf, true);
};
$0e4c0855746f772b$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $0e4c0855746f772b$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("61CSG", function(module, exports) {

var $1mhER = parcelRequire("1mhER");

var $4WS9C = parcelRequire("4WS9C");

var $7TQd3 = parcelRequire("7TQd3");

var $5wiZq = parcelRequire("5wiZq");

var $a0DEi = parcelRequire("a0DEi");

var $anLPs = parcelRequire("anLPs");

var $fTU8a = parcelRequire("fTU8a");

var $73LXI = parcelRequire("73LXI");

var $jcTxY = parcelRequire("jcTxY");
var $4630ff07e5ba4ab1$require$Buffer = $jcTxY.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $1mhER(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $4630ff07e5ba4ab1$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $4630ff07e5ba4ab1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $anLPs(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $73LXI(paddedMsg, key);
    else return $fTU8a(paddedMsg, key);
};
function $4630ff07e5ba4ab1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $7TQd3('sha1').update($4630ff07e5ba4ab1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $4630ff07e5ba4ab1$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $4WS9C(hLen);
    var maskedDb = $a0DEi($4630ff07e5ba4ab1$require$Buffer.concat([
        iHash,
        ps,
        $4630ff07e5ba4ab1$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5wiZq(seed, dblen));
    var maskedSeed = $a0DEi(seed, $5wiZq(maskedDb, hLen));
    return new $anLPs($4630ff07e5ba4ab1$require$Buffer.concat([
        $4630ff07e5ba4ab1$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $4630ff07e5ba4ab1$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $4630ff07e5ba4ab1$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $4630ff07e5ba4ab1$var$nonZero(k - mLen - 3);
    return new $anLPs($4630ff07e5ba4ab1$require$Buffer.concat([
        $4630ff07e5ba4ab1$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $4630ff07e5ba4ab1$require$Buffer.alloc(1),
        msg
    ], k));
}
function $4630ff07e5ba4ab1$var$nonZero(len) {
    var out = $4630ff07e5ba4ab1$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $4WS9C(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $4WS9C(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5wiZq", function(module, exports) {

var $7TQd3 = parcelRequire("7TQd3");

var $jcTxY = parcelRequire("jcTxY");
var $404eabd9f6840139$require$Buffer = $jcTxY.Buffer;
module.exports = function(seed, len) {
    var t = $404eabd9f6840139$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $404eabd9f6840139$var$i2ops(i++);
        t = $404eabd9f6840139$require$Buffer.concat([
            t,
            $7TQd3('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $404eabd9f6840139$var$i2ops(c) {
    var out = $404eabd9f6840139$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("a0DEi", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("fTU8a", function(module, exports) {

var $anLPs = parcelRequire("anLPs");

var $jcTxY = parcelRequire("jcTxY");
var $b9378874d529e50e$require$Buffer = $jcTxY.Buffer;
function $b9378874d529e50e$var$withPublic(paddedMsg, key) {
    return $b9378874d529e50e$require$Buffer.from(paddedMsg.toRed($anLPs.mont(key.modulus)).redPow(new $anLPs(key.publicExponent)).fromRed().toArray());
}
module.exports = $b9378874d529e50e$var$withPublic;

});


parcelRegister("DPRko", function(module, exports) {

var $1mhER = parcelRequire("1mhER");

var $5wiZq = parcelRequire("5wiZq");

var $a0DEi = parcelRequire("a0DEi");

var $anLPs = parcelRequire("anLPs");

var $73LXI = parcelRequire("73LXI");

var $7TQd3 = parcelRequire("7TQd3");

var $fTU8a = parcelRequire("fTU8a");

var $jcTxY = parcelRequire("jcTxY");
var $077bdec672feeb70$require$Buffer = $jcTxY.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $1mhER(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $anLPs(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $fTU8a(new $anLPs(enc), key);
    else msg = $73LXI(enc, key);
    var zBuffer = $077bdec672feeb70$require$Buffer.alloc(k - msg.length);
    msg = $077bdec672feeb70$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $077bdec672feeb70$var$oaep(key, msg);
    else if (padding === 1) return $077bdec672feeb70$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $077bdec672feeb70$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $7TQd3('sha1').update($077bdec672feeb70$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $a0DEi(maskedSeed, $5wiZq(maskedDb, hLen));
    var db = $a0DEi(maskedDb, $5wiZq(seed, k - hLen - 1));
    if ($077bdec672feeb70$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $077bdec672feeb70$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $077bdec672feeb70$var$compare(a, b) {
    a = $077bdec672feeb70$require$Buffer.from(a);
    b = $077bdec672feeb70$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("kfXIi", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $ebf38735300f857d$export$bb1abf2ce84fc7e8, (v) => $ebf38735300f857d$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $ebf38735300f857d$export$2f7171e78e524d5e, (v) => $ebf38735300f857d$export$2f7171e78e524d5e = v);
var $ebf38735300f857d$export$bb1abf2ce84fc7e8;
var $ebf38735300f857d$export$2f7171e78e524d5e;

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
function $ebf38735300f857d$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $jcTxY = parcelRequire("jcTxY");

var $4WS9C = parcelRequire("4WS9C");
var $ebf38735300f857d$var$Buffer = $jcTxY.Buffer;
var $ebf38735300f857d$var$kBufferMaxLength = $jcTxY.kMaxLength;
var $ebf38735300f857d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $ebf38735300f857d$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $ebf38735300f857d$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $ebf38735300f857d$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $ebf38735300f857d$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $ebf38735300f857d$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $ebf38735300f857d$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $ebf38735300f857d$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($ebf38735300f857d$var$crypto && $ebf38735300f857d$var$crypto.getRandomValues || false) {
    $ebf38735300f857d$export$bb1abf2ce84fc7e8 = $ebf38735300f857d$var$randomFill;
    $ebf38735300f857d$export$2f7171e78e524d5e = $ebf38735300f857d$var$randomFillSync;
} else {
    $ebf38735300f857d$export$bb1abf2ce84fc7e8 = $ebf38735300f857d$var$oldBrowser;
    $ebf38735300f857d$export$2f7171e78e524d5e = $ebf38735300f857d$var$oldBrowser;
}
function $ebf38735300f857d$var$randomFill(buf, offset, size, cb) {
    if (!$ebf38735300f857d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $ebf38735300f857d$var$assertOffset(offset, buf.length);
    $ebf38735300f857d$var$assertSize(size, offset, buf.length);
    return $ebf38735300f857d$var$actualFill(buf, offset, size, cb);
}
function $ebf38735300f857d$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $ebf38735300f857d$var$crypto.getRandomValues(uint);
    if (cb) {
        $4Jj9n.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $4WS9C(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $4WS9C(size);
    bytes.copy(buf, offset);
    return buf;
}
function $ebf38735300f857d$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$ebf38735300f857d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $ebf38735300f857d$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $ebf38735300f857d$var$assertSize(size, offset, buf.length);
    return $ebf38735300f857d$var$actualFill(buf, offset, size);
}

});


parcelRegister("7ns3U", function(module, exports) {

$parcel$export(module.exports, "unpremultiplyAlpha", () => $7744ce05d7e29f01$export$6349ddffc05fd439);
"use strict";
function $7744ce05d7e29f01$export$6349ddffc05fd439(pixels) {
    if (pixels instanceof Uint8ClampedArray) pixels = new Uint8Array(pixels.buffer);
    const n = pixels.length;
    for(let i = 0; i < n; i += 4){
        const alpha = pixels[i + 3];
        if (alpha !== 0) {
            const a = 255.001 / alpha;
            pixels[i] = pixels[i] * a + 0.5;
            pixels[i + 1] = pixels[i + 1] * a + 0.5;
            pixels[i + 2] = pixels[i + 2] * a + 0.5;
        }
    }
}

});

function $5b55f105e5908397$export$2fa8eca08cbceec1(color) {
    return '#' + color.toString(16).padStart(6, '0');
}
function $5b55f105e5908397$export$91a2ac4f9fa96416(colorObject) {
    return Object.entries(colorObject).map(([key, value])=>`${key}:${value.toString(16).padStart(6, '0')}`).join(',');
}
function $5b55f105e5908397$export$7d9c4f234b98dca0(input) {
    let result = {
        ...$5b55f105e5908397$export$164de7ab8df77ef0
    };
    input.split(',').forEach((pair)=>{
        let [name, value] = pair.split(':');
        result[name] = parseInt(value, 16);
    });
    return result;
}
const $5b55f105e5908397$export$164de7ab8df77ef0 = {
    background: 0x1a2634,
    rail: 0x8b9caa,
    railInner: 0x2d3d4d,
    pavement: 0x8b9caa,
    asphalt: 0x2d3d4d,
    departure: 0x4a5568,
    switch: 0xf0f4f8,
    switchHover: 0xb8c9d9,
    switchOutline: 0xe2e8f0,
    scoreBackground: 0x2d3d4d,
    switchWithTrain: 0x1a2634,
    switchHoverWithTrain: 0x1a2634
};
function $5b55f105e5908397$export$b0a42032b873dec8(colorList) {
    return colorList.map((c)=>c.toString(16).padStart(6, '0')).join(',');
}
function $5b55f105e5908397$export$96196a8e448d793b(input) {
    return input.split(',').map((w)=>parseInt(w, 16));
}
const $5b55f105e5908397$export$b908c818a29fc662 = [
    0x2563eb,
    0xdc2626,
    0x16a34a,
    0xfbbf24,
    0x9333ea,
    0xf97316,
    0x06b6d4,
    0xdb2777,
    0x65a30d,
    0x7c3aed,
    0xea580c,
    0x0891b2,
    0xbe185d,
    0x4f46e5,
    0x15803d
];
const $5b55f105e5908397$export$27e9c595c4937462 = [
    'solid',
    'stripe',
    'dot',
    'ring',
    'diamond',
    'cross',
    'triangle',
    'square'
];
function $5b55f105e5908397$export$c37ddd467bda1a75(colorIndex) {
    // Use patterns to further differentiate at higher levels
    // First 8 colors use solid, then patterns cycle
    if (colorIndex < 8) return 'solid';
    return $5b55f105e5908397$export$27e9c595c4937462[(colorIndex - 8) % $5b55f105e5908397$export$27e9c595c4937462.length];
}
function $5b55f105e5908397$export$1b0ed88187e4090f(colorIndex, colorList) {
    return colorList[colorIndex % colorList.length];
}
function $5b55f105e5908397$export$b71c93f469694483(colorIndex, colorList) {
    // Return null for single-color mode (all items single color)
    return null;
}
function $5b55f105e5908397$export$5931e35698b46017(a, z) {
    return (progress)=>{
        const ar = a >> 16 & 0xff;
        const ag = a >> 8 & 0xff;
        const ab = a & 0xff;
        const zr = z >> 16 & 0xff;
        const zg = z >> 8 & 0xff;
        const zb = z & 0xff;
        const r = Math.round(ar + (zr - ar) * progress);
        const g = Math.round(ag + (zg - ag) * progress);
        const b = Math.round(ab + (zb - ab) * progress);
        return r << 16 | g << 8 | b;
    };
}



var $37w0r = parcelRequire("37w0r");
var $30d7d246c5e7cd93$exports = {};

$parcel$export($30d7d246c5e7cd93$exports, "ExtensionType", () => (parcelRequire("aZ9ZN")).ExtensionType);
$parcel$export($30d7d246c5e7cd93$exports, "normalizeExtensionPriority", () => (parcelRequire("aZ9ZN")).normalizeExtensionPriority);
$parcel$export($30d7d246c5e7cd93$exports, "AccessibilitySystem", () => (parcelRequire("gpiLJ")).AccessibilitySystem);
$parcel$export($30d7d246c5e7cd93$exports, "accessibilityTarget", () => (parcelRequire("2ibqd")).accessibilityTarget);
$parcel$export($30d7d246c5e7cd93$exports, "ColorBlend", () => $816918268500e9d0$export$49c26a8a00b47001);
$parcel$export($30d7d246c5e7cd93$exports, "ColorBurnBlend", () => $90e4bb198698b2e8$export$f87c9ea9a6bd644d);
$parcel$export($30d7d246c5e7cd93$exports, "ColorDodgeBlend", () => $1af95aa9b908da2b$export$b605c157b8288ca9);
$parcel$export($30d7d246c5e7cd93$exports, "DarkenBlend", () => $acdfeed811f24d96$export$b302ffff58558dd3);
$parcel$export($30d7d246c5e7cd93$exports, "DifferenceBlend", () => $d20df28c80e8871a$export$8f916080f74b48a1);
$parcel$export($30d7d246c5e7cd93$exports, "DivideBlend", () => $192d4c3ae64f40ca$export$c7d2adb912a7c5cf);
$parcel$export($30d7d246c5e7cd93$exports, "ExclusionBlend", () => $0827e74b8293f309$export$48a32c81b020da81);
$parcel$export($30d7d246c5e7cd93$exports, "HardLightBlend", () => $e737b7f7bb358c78$export$deee7bfa3f7add03);
$parcel$export($30d7d246c5e7cd93$exports, "HardMixBlend", () => $478e85dab1990f9b$export$a68bc3d7fee45c17);
$parcel$export($30d7d246c5e7cd93$exports, "LightenBlend", () => $c587432b4fa227ad$export$3a7888367c013d84);
$parcel$export($30d7d246c5e7cd93$exports, "LinearBurnBlend", () => $16266803e35a0220$export$aba7fe3f2b545692);
$parcel$export($30d7d246c5e7cd93$exports, "LinearDodgeBlend", () => $e880cfa70bb3466f$export$9b6f3185f95ef996);
$parcel$export($30d7d246c5e7cd93$exports, "LinearLightBlend", () => $4f42df1a04121c46$export$1aba5746b48d52f9);
$parcel$export($30d7d246c5e7cd93$exports, "LuminosityBlend", () => $08f2512fad92af25$export$d9933ad71d16767e);
$parcel$export($30d7d246c5e7cd93$exports, "NegationBlend", () => $9db4b4958f0a9c9a$export$75fc806a9eca252d);
$parcel$export($30d7d246c5e7cd93$exports, "OverlayBlend", () => $7ee63075806ba048$export$c318b05471430745);
$parcel$export($30d7d246c5e7cd93$exports, "PinLightBlend", () => $a275f9f9dc1245ed$export$3e2f910ab14d190b);
$parcel$export($30d7d246c5e7cd93$exports, "SaturationBlend", () => $81579094a71b1ff6$export$62883fb5bda5d60a);
$parcel$export($30d7d246c5e7cd93$exports, "SoftLightBlend", () => $d3fad48146de4efa$export$db64d53ebdd21cf0);
$parcel$export($30d7d246c5e7cd93$exports, "SubtractBlend", () => $903c88123932eb20$export$e15549b41fdb45a2);
$parcel$export($30d7d246c5e7cd93$exports, "VividLightBlend", () => $ca6cf0806514c5c0$export$5860dee37348cea9);
$parcel$export($30d7d246c5e7cd93$exports, "Application", () => $4626b74171df28b3$export$16975c34e60e1e61);
$parcel$export($30d7d246c5e7cd93$exports, "ResizePlugin", () => $c7c8a973586e3a0e$export$6453cd852defe94a);
$parcel$export($30d7d246c5e7cd93$exports, "TickerPlugin", () => $8bf065aef63e1225$export$50c361ceb4e2f4f0);
$parcel$export($30d7d246c5e7cd93$exports, "Assets", () => $751ce026a38dc015$export$c8eca95e306f7116);
$parcel$export($30d7d246c5e7cd93$exports, "AssetsClass", () => $751ce026a38dc015$export$137d4dd907afac85);
$parcel$export($30d7d246c5e7cd93$exports, "BackgroundLoader", () => $6d818aba51088bb4$export$1949379a83b843d5);
$parcel$export($30d7d246c5e7cd93$exports, "Cache", () => (parcelRequire("h3cT0")).Cache);
$parcel$export($30d7d246c5e7cd93$exports, "cacheTextureArray", () => $ee99ec759734d21a$export$407b4625a915919d);
$parcel$export($30d7d246c5e7cd93$exports, "detectAvif", () => $a731aeae60a36915$export$a60d2d4a3c570783);
$parcel$export($30d7d246c5e7cd93$exports, "detectDefaults", () => $7ae4808924cd4c1a$export$b106d7c2de3b4d89);
$parcel$export($30d7d246c5e7cd93$exports, "detectMp4", () => $7748aa8b5cfd2b6b$export$7726d83fee274e25);
$parcel$export($30d7d246c5e7cd93$exports, "detectOgv", () => $32601ac990b07974$export$5a1da481121f806a);
$parcel$export($30d7d246c5e7cd93$exports, "detectWebm", () => $203ca28464480688$export$a041d698a1896657);
$parcel$export($30d7d246c5e7cd93$exports, "detectWebp", () => $b1f07772206d4732$export$d19529a9ed9823d4);
$parcel$export($30d7d246c5e7cd93$exports, "testImageFormat", () => $f9a551de8879104d$export$7c459e568e7cea2c);
$parcel$export($30d7d246c5e7cd93$exports, "testVideoFormat", () => $1bfab03a55c6b4c2$export$7a571c147b03abb1);
$parcel$export($30d7d246c5e7cd93$exports, "Loader", () => $a780a988a4a41ac9$export$3b0d6d7590275603);
$parcel$export($30d7d246c5e7cd93$exports, "LoaderParserPriority", () => (parcelRequire("8nmJS")).LoaderParserPriority);
$parcel$export($30d7d246c5e7cd93$exports, "loadJson", () => $b1848d8e49e2cd02$export$e7c8553478f3aac7);
$parcel$export($30d7d246c5e7cd93$exports, "loadTxt", () => $db58d3b1af59b4a5$export$3835b7ee6dbebde8);
$parcel$export($30d7d246c5e7cd93$exports, "getFontFamilyName", () => $568e7f5570577c0e$export$c461ca8f39d93d9b);
$parcel$export($30d7d246c5e7cd93$exports, "loadWebFont", () => $568e7f5570577c0e$export$129ed93ad26b0298);
$parcel$export($30d7d246c5e7cd93$exports, "loadSvg", () => $da6615954e48760f$export$b6a2e78b63791dfa);
$parcel$export($30d7d246c5e7cd93$exports, "loadImageBitmap", () => $99578192368a5e1c$export$c614e6247302006d);
$parcel$export($30d7d246c5e7cd93$exports, "loadTextures", () => $99578192368a5e1c$export$897b113ee8307cd0);
$parcel$export($30d7d246c5e7cd93$exports, "crossOrigin", () => $48904b1a9f5881c8$export$c47cb7c63271266e);
$parcel$export($30d7d246c5e7cd93$exports, "determineCrossOrigin", () => $48904b1a9f5881c8$export$292083da55c5b406);
$parcel$export($30d7d246c5e7cd93$exports, "loadVideoTextures", () => $48904b1a9f5881c8$export$68fa0976ba667d63);
$parcel$export($30d7d246c5e7cd93$exports, "preloadVideo", () => $48904b1a9f5881c8$export$856bfbe81968ff62);
$parcel$export($30d7d246c5e7cd93$exports, "createTexture", () => $9a5eddce1cc0cd00$export$37b981a8c575f415);
$parcel$export($30d7d246c5e7cd93$exports, "WorkerManager", () => $0815e342356fde47$export$bcff6015853c67ce);
$parcel$export($30d7d246c5e7cd93$exports, "resolveJsonUrl", () => $c6d26013fe76af62$export$2b5cca0b89cb089c);
$parcel$export($30d7d246c5e7cd93$exports, "resolveTextureUrl", () => $741a25985f8cb683$export$cc356fa83de02bea);
$parcel$export($30d7d246c5e7cd93$exports, "Resolver", () => (parcelRequire("eFUj8")).Resolver);
$parcel$export($30d7d246c5e7cd93$exports, "getUrlExtension", () => (parcelRequire("eFUj8")).getUrlExtension);
$parcel$export($30d7d246c5e7cd93$exports, "checkDataUrl", () => $6e8add647376da4b$export$7ff8b059fb914323);
$parcel$export($30d7d246c5e7cd93$exports, "checkExtension", () => $1e9f9ec9061a32ce$export$fd0180357b95b812);
$parcel$export($30d7d246c5e7cd93$exports, "convertToList", () => (parcelRequire("bkziv")).convertToList);
$parcel$export($30d7d246c5e7cd93$exports, "copySearchParams", () => (parcelRequire("h8sEz")).copySearchParams);
$parcel$export($30d7d246c5e7cd93$exports, "createStringVariations", () => (parcelRequire("25zMj")).createStringVariations);
$parcel$export($30d7d246c5e7cd93$exports, "isSingleItem", () => (parcelRequire("4Kkng")).isSingleItem);
$parcel$export($30d7d246c5e7cd93$exports, "Color", () => (parcelRequire("dKHyW")).Color);
$parcel$export($30d7d246c5e7cd93$exports, "detectBasis", () => $86b85541141d61ae$export$66983304f23bcc54);
$parcel$export($30d7d246c5e7cd93$exports, "loadBasis", () => $05c3a1709fd63e32$export$91ba277d70f60d23);
$parcel$export($30d7d246c5e7cd93$exports, "createLevelBuffers", () => $7d357efb2a35a30c$export$eb3a94025cbc6da1);
$parcel$export($30d7d246c5e7cd93$exports, "gpuFormatToBasisTranscoderFormat", () => $3cbed1529610ad78$export$faeb23e37b1607d4);
$parcel$export($30d7d246c5e7cd93$exports, "basisTranscoderUrls", () => $a676848eb08cd831$export$371f717dace32803);
$parcel$export($30d7d246c5e7cd93$exports, "setBasisTranscoderPath", () => $a676848eb08cd831$export$4c72d3e163ed69c9);
$parcel$export($30d7d246c5e7cd93$exports, "loadBasisOnWorker", () => $802602d567ebfdd5$export$da1e3219cba22f0);
$parcel$export($30d7d246c5e7cd93$exports, "D3D10_RESOURCE_DIMENSION", () => $9e04c0e82ea22f13$export$3ccf46595e182c3);
$parcel$export($30d7d246c5e7cd93$exports, "D3DFMT", () => $9e04c0e82ea22f13$export$880df6e30a43b81e);
$parcel$export($30d7d246c5e7cd93$exports, "DDS", () => $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f);
$parcel$export($30d7d246c5e7cd93$exports, "DXGI_FORMAT", () => $9e04c0e82ea22f13$export$63577c11dea0d1a7);
$parcel$export($30d7d246c5e7cd93$exports, "DXGI_TO_TEXTURE_FORMAT", () => $9e04c0e82ea22f13$export$29d7d78292b12a5a);
$parcel$export($30d7d246c5e7cd93$exports, "FOURCC_TO_TEXTURE_FORMAT", () => $9e04c0e82ea22f13$export$645d02aa74a9eea1);
$parcel$export($30d7d246c5e7cd93$exports, "TEXTURE_FORMAT_BLOCK_SIZE", () => $9e04c0e82ea22f13$export$1a937d351642c109);
$parcel$export($30d7d246c5e7cd93$exports, "loadDDS", () => $86e900f693d9ceb2$export$20ea358dd867fe3e);
$parcel$export($30d7d246c5e7cd93$exports, "parseDDS", () => $26d6dd59db82a2cd$export$cddc4925efe88ac);
$parcel$export($30d7d246c5e7cd93$exports, "loadKTX", () => $eaadb6d761c04f3d$export$e59f5413434dd0e3);
$parcel$export($30d7d246c5e7cd93$exports, "parseKTX", () => $1b31128f1a8a0394$export$58a6abed7fd55190);
$parcel$export($30d7d246c5e7cd93$exports, "GL_INTERNAL_FORMAT", () => $afa636417037c4e5$export$99fd6651d3c0e2bf);
$parcel$export($30d7d246c5e7cd93$exports, "KTX", () => $afa636417037c4e5$export$6f3d89c89e56fc17);
$parcel$export($30d7d246c5e7cd93$exports, "loadKTX2", () => $4cf0b3d12f1cb8e3$export$67592f5acb5b952a);
$parcel$export($30d7d246c5e7cd93$exports, "convertFormatIfRequired", () => $d97f957c7515ad3d$export$33843d4b2509fc41);
$parcel$export($30d7d246c5e7cd93$exports, "createLevelBuffersFromKTX", () => $9e3805bd147529fb$export$d4d75f0f7ccae646);
$parcel$export($30d7d246c5e7cd93$exports, "getTextureFormatFromKTXTexture", () => $c737d87c089682f2$export$8a8b4bdf7e5c4619);
$parcel$export($30d7d246c5e7cd93$exports, "glFormatToGPUFormat", () => $b5e9aec945f2870b$export$1a3e159e1a978397);
$parcel$export($30d7d246c5e7cd93$exports, "gpuFormatToKTXBasisTranscoderFormat", () => $8670cca3281e639a$export$63f8e57fd99f8e74);
$parcel$export($30d7d246c5e7cd93$exports, "ktxTranscoderUrls", () => $df122bf9926813fb$export$677fabc1bfa370dc);
$parcel$export($30d7d246c5e7cd93$exports, "setKTXTranscoderPath", () => $df122bf9926813fb$export$72825d91e2d412c7);
$parcel$export($30d7d246c5e7cd93$exports, "vkFormatToGPUFormat", () => $3fffb15b2559fb32$export$9615ed8c1038d56d);
$parcel$export($30d7d246c5e7cd93$exports, "loadKTX2onWorker", () => $293c52f0569ea79c$export$9cce919f1112b5d1);
$parcel$export($30d7d246c5e7cd93$exports, "detectCompressed", () => $5b34ebeab99570a4$export$c937cb7fa9e5fb43);
$parcel$export($30d7d246c5e7cd93$exports, "resolveCompressedTextureUrl", () => $6edde5168f999a27$export$513de45dc484f3ba);
$parcel$export($30d7d246c5e7cd93$exports, "validFormats", () => $6edde5168f999a27$export$dd825767c4f099d9);
$parcel$export($30d7d246c5e7cd93$exports, "Culler", () => $c275ccea7f4c9f90$export$94aad65d79f82fc9);
$parcel$export($30d7d246c5e7cd93$exports, "CullerPlugin", () => $212fae6962c0570c$export$759b1da6ba5ab1e0);
$parcel$export($30d7d246c5e7cd93$exports, "cullingMixin", () => (parcelRequire("cunnl")).cullingMixin);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasObserver", () => (parcelRequire("g3seW")).CanvasObserver);
$parcel$export($30d7d246c5e7cd93$exports, "DOMContainer", () => $c7cfeeefcf1aa19a$export$7ebec4545203b0c8);
$parcel$export($30d7d246c5e7cd93$exports, "DOMPipe", () => $91ce62935e4f5f3d$export$ee59129a62c98408);
$parcel$export($30d7d246c5e7cd93$exports, "DOMAdapter", () => (parcelRequire("gLw46")).DOMAdapter);
$parcel$export($30d7d246c5e7cd93$exports, "autoDetectEnvironment", () => (parcelRequire("l8aZL")).autoDetectEnvironment);
$parcel$export($30d7d246c5e7cd93$exports, "loadEnvironmentExtensions", () => (parcelRequire("l8aZL")).loadEnvironmentExtensions);
$parcel$export($30d7d246c5e7cd93$exports, "BrowserAdapter", () => (parcelRequire("6OcRC")).BrowserAdapter);
$parcel$export($30d7d246c5e7cd93$exports, "WebWorkerAdapter", () => $fa81e2e0e0fc7316$export$5735016b32ac3391);
$parcel$export($30d7d246c5e7cd93$exports, "EventBoundary", () => (parcelRequire("fit0D")).EventBoundary);
$parcel$export($30d7d246c5e7cd93$exports, "EventSystem", () => (parcelRequire("jzHBA")).EventSystem);
$parcel$export($30d7d246c5e7cd93$exports, "EventsTicker", () => (parcelRequire("jpWqm")).EventsTicker);
$parcel$export($30d7d246c5e7cd93$exports, "FederatedEvent", () => (parcelRequire("bG9BA")).FederatedEvent);
$parcel$export($30d7d246c5e7cd93$exports, "FederatedContainer", () => (parcelRequire("5vwBy")).FederatedContainer);
$parcel$export($30d7d246c5e7cd93$exports, "FederatedMouseEvent", () => (parcelRequire("ZTBXt")).FederatedMouseEvent);
$parcel$export($30d7d246c5e7cd93$exports, "FederatedPointerEvent", () => (parcelRequire("3QWP0")).FederatedPointerEvent);
$parcel$export($30d7d246c5e7cd93$exports, "FederatedWheelEvent", () => (parcelRequire("a4OU2")).FederatedWheelEvent);
$parcel$export($30d7d246c5e7cd93$exports, "blendTemplateFrag", () => $56628c8f18c4feab$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "blendTemplateVert", () => $c4e1726121ebd0f9$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "blendTemplateWgsl", () => $d9c83817d08f41f4$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "hslWgsl", () => $fec77ece77700f4a$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "alphaFrag", () => $41fefffb163f8023$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "alphaWgsl", () => $a5672269fab11bef$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "blurTemplateWgsl", () => $cf7e6f7129d47fc2$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "colorMatrixFilterFrag", () => $bfe7c65ef8bc5e43$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "colorMatrixFilterWgsl", () => $ab75df4ff3fc796a$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "defaultFilterVert", () => (parcelRequire("hK31P")).default);
$parcel$export($30d7d246c5e7cd93$exports, "displacementFrag", () => $a7ecc11f5b04f50c$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "displacementVert", () => $317a3adc740807ea$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "displacementWgsl", () => $b4717776ee2d1620$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "noiseFrag", () => $f051f0eca3077c3a$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "noiseWgsl", () => $02f175dd3c54583e$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "passthroughFrag", () => (parcelRequire("ejyqD")).default);
$parcel$export($30d7d246c5e7cd93$exports, "passthroughWgsl", () => (parcelRequire("dm63u")).default);
$parcel$export($30d7d246c5e7cd93$exports, "maskFrag", () => (parcelRequire("7DmEj")).default);
$parcel$export($30d7d246c5e7cd93$exports, "maskVert", () => (parcelRequire("7EiHV")).default);
$parcel$export($30d7d246c5e7cd93$exports, "maskWgsl", () => (parcelRequire("3Go5s")).default);
$parcel$export($30d7d246c5e7cd93$exports, "BlendModeFilter", () => $1d60510dca4ba264$export$45a84b7faa1bbfad);
$parcel$export($30d7d246c5e7cd93$exports, "hslgl", () => $eeb80ce5e84eb3ea$export$8f2fe8e50ec495a4);
$parcel$export($30d7d246c5e7cd93$exports, "hslgpu", () => $39f7e2b517ebb999$export$ba4975f4e0685bad);
$parcel$export($30d7d246c5e7cd93$exports, "AlphaFilter", () => $93040cbce99221cc$export$adbaa0de008b0d7a);
$parcel$export($30d7d246c5e7cd93$exports, "BlurFilter", () => $f71b4e41c428ae4e$export$424348d09d827f49);
$parcel$export($30d7d246c5e7cd93$exports, "BlurFilterPass", () => $af2a5e86ce27dcf5$export$b100a8e8116621cf);
$parcel$export($30d7d246c5e7cd93$exports, "GAUSSIAN_VALUES", () => $7e23f300d702b6d0$export$62963d757c50e400);
$parcel$export($30d7d246c5e7cd93$exports, "generateBlurFragSource", () => $f18201acb1d246c1$export$1b0dcf101eb6a1c9);
$parcel$export($30d7d246c5e7cd93$exports, "generateBlurGlProgram", () => $3e59dc05357355e0$export$fa4adee1a7bc708);
$parcel$export($30d7d246c5e7cd93$exports, "generateBlurVertSource", () => $23f966071940a41b$export$7a7fb9d9d09c33af);
$parcel$export($30d7d246c5e7cd93$exports, "generateBlurProgram", () => $c80fdd4da83c4d4c$export$96d9b45e64338908);
$parcel$export($30d7d246c5e7cd93$exports, "ColorMatrixFilter", () => $a5eba8e2f0b91898$export$6547db23997fcec5);
$parcel$export($30d7d246c5e7cd93$exports, "DisplacementFilter", () => $ed5f2584b4d2c501$export$8ebf3229158e2895);
$parcel$export($30d7d246c5e7cd93$exports, "NoiseFilter", () => $5200480fbbf9bd48$export$2d7a5b72233a5183);
$parcel$export($30d7d246c5e7cd93$exports, "PassthroughFilter", () => (parcelRequire("Rua5B")).PassthroughFilter);
$parcel$export($30d7d246c5e7cd93$exports, "Filter", () => (parcelRequire("lWXRl")).Filter);
$parcel$export($30d7d246c5e7cd93$exports, "FilterEffect", () => (parcelRequire("jMFz3")).FilterEffect);
$parcel$export($30d7d246c5e7cd93$exports, "FilterPipe", () => (parcelRequire("2mfWS")).FilterPipe);
$parcel$export($30d7d246c5e7cd93$exports, "FilterSystem", () => (parcelRequire("dPCQ1")).FilterSystem);
$parcel$export($30d7d246c5e7cd93$exports, "MaskFilter", () => (parcelRequire("dyeaT")).MaskFilter);
$parcel$export($30d7d246c5e7cd93$exports, "groupD8", () => (parcelRequire("lHrjL")).groupD8);
$parcel$export($30d7d246c5e7cd93$exports, "Matrix", () => (parcelRequire("5xi4h")).Matrix);
$parcel$export($30d7d246c5e7cd93$exports, "DEG_TO_RAD", () => (parcelRequire("hEz4p")).DEG_TO_RAD);
$parcel$export($30d7d246c5e7cd93$exports, "PI_2", () => (parcelRequire("hEz4p")).PI_2);
$parcel$export($30d7d246c5e7cd93$exports, "RAD_TO_DEG", () => (parcelRequire("hEz4p")).RAD_TO_DEG);
$parcel$export($30d7d246c5e7cd93$exports, "isPow2", () => (parcelRequire("fSIhN")).isPow2);
$parcel$export($30d7d246c5e7cd93$exports, "log2", () => (parcelRequire("fSIhN")).log2);
$parcel$export($30d7d246c5e7cd93$exports, "nextPow2", () => (parcelRequire("fSIhN")).nextPow2);
$parcel$export($30d7d246c5e7cd93$exports, "squaredDistanceToLineSegment", () => (parcelRequire("hASMp")).squaredDistanceToLineSegment);
$parcel$export($30d7d246c5e7cd93$exports, "ObservablePoint", () => (parcelRequire("jZ66T")).ObservablePoint);
$parcel$export($30d7d246c5e7cd93$exports, "Point", () => (parcelRequire("ds7Xo")).Point);
$parcel$export($30d7d246c5e7cd93$exports, "pointInTriangle", () => $0ec92952cf900ab8$export$b0d8d777b5def172);
$parcel$export($30d7d246c5e7cd93$exports, "Circle", () => (parcelRequire("1lNph")).Circle);
$parcel$export($30d7d246c5e7cd93$exports, "Ellipse", () => (parcelRequire("8UvIh")).Ellipse);
$parcel$export($30d7d246c5e7cd93$exports, "Polygon", () => (parcelRequire("7r8vL")).Polygon);
$parcel$export($30d7d246c5e7cd93$exports, "Rectangle", () => (parcelRequire("ar2Ly")).Rectangle);
$parcel$export($30d7d246c5e7cd93$exports, "RoundedRectangle", () => (parcelRequire("fVN7W")).RoundedRectangle);
$parcel$export($30d7d246c5e7cd93$exports, "Triangle", () => $8364dac7c350a6ae$export$5a465592bfe74b48);
$parcel$export($30d7d246c5e7cd93$exports, "PrepareBase", () => $174d20ff26f1de6e$export$5f24f1af732279b7);
$parcel$export($30d7d246c5e7cd93$exports, "PrepareQueue", () => $0d30f8725cec24cc$export$c4920d5f3c7b8959);
$parcel$export($30d7d246c5e7cd93$exports, "PrepareSystem", () => $cbb4326a63b0dae2$export$9c030b3792ef41b6);
$parcel$export($30d7d246c5e7cd93$exports, "PrepareUpload", () => $243fa1c02dacb515$export$a98d473d4c3e7e4b);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasBatchAdaptor", () => (parcelRequire("928ng")).CanvasBatchAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "GlBatchAdaptor", () => (parcelRequire("7ogwP")).GlBatchAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "checkMaxIfStatementsInShader", () => (parcelRequire("igOXQ")).checkMaxIfStatementsInShader);
$parcel$export($30d7d246c5e7cd93$exports, "getMaxTexturesPerBatch", () => (parcelRequire("kqE0J")).getMaxTexturesPerBatch);
$parcel$export($30d7d246c5e7cd93$exports, "generateGPULayout", () => $4a8dc7521903eb7c$export$e04e512f21f419b6);
$parcel$export($30d7d246c5e7cd93$exports, "generateLayout", () => $b20a4cfe0004842a$export$e6a9d79fae156af6);
$parcel$export($30d7d246c5e7cd93$exports, "getTextureBatchBindGroup", () => (parcelRequire("dGUqy")).getTextureBatchBindGroup);
$parcel$export($30d7d246c5e7cd93$exports, "GpuBatchAdaptor", () => (parcelRequire("d0Ll5")).GpuBatchAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "Batch", () => (parcelRequire("J0JR5")).Batch);
$parcel$export($30d7d246c5e7cd93$exports, "Batcher", () => (parcelRequire("J0JR5")).Batcher);
$parcel$export($30d7d246c5e7cd93$exports, "BatcherPipe", () => (parcelRequire("jDoUt")).BatcherPipe);
$parcel$export($30d7d246c5e7cd93$exports, "BatchGeometry", () => (parcelRequire("2RTgk")).BatchGeometry);
$parcel$export($30d7d246c5e7cd93$exports, "BatchTextureArray", () => (parcelRequire("bc7uw")).BatchTextureArray);
$parcel$export($30d7d246c5e7cd93$exports, "DefaultBatcher", () => (parcelRequire("gjENK")).DefaultBatcher);
$parcel$export($30d7d246c5e7cd93$exports, "DefaultShader", () => (parcelRequire("4Af3A")).DefaultShader);
$parcel$export($30d7d246c5e7cd93$exports, "compileHighShaderGlProgram", () => (parcelRequire("aYOxl")).compileHighShaderGlProgram);
$parcel$export($30d7d246c5e7cd93$exports, "compileHighShaderGpuProgram", () => (parcelRequire("aYOxl")).compileHighShaderGpuProgram);
$parcel$export($30d7d246c5e7cd93$exports, "compileHighShader", () => (parcelRequire("bhlBQ")).compileHighShader);
$parcel$export($30d7d246c5e7cd93$exports, "compileHighShaderGl", () => (parcelRequire("bhlBQ")).compileHighShaderGl);
$parcel$export($30d7d246c5e7cd93$exports, "addBits", () => (parcelRequire("iioxo")).addBits);
$parcel$export($30d7d246c5e7cd93$exports, "compileHooks", () => (parcelRequire("CEJ1P")).compileHooks);
$parcel$export($30d7d246c5e7cd93$exports, "compileInputs", () => (parcelRequire("6iet8")).compileInputs);
$parcel$export($30d7d246c5e7cd93$exports, "compileOutputs", () => (parcelRequire("8cyng")).compileOutputs);
$parcel$export($30d7d246c5e7cd93$exports, "formatShader", () => $1d34a18505b19a00$export$14e97d6d2d36f381);
$parcel$export($30d7d246c5e7cd93$exports, "injectBits", () => (parcelRequire("4gc0T")).injectBits);
$parcel$export($30d7d246c5e7cd93$exports, "fragmentGPUTemplate", () => (parcelRequire("a8QIF")).fragmentGPUTemplate);
$parcel$export($30d7d246c5e7cd93$exports, "fragmentGlTemplate", () => (parcelRequire("a8QIF")).fragmentGlTemplate);
$parcel$export($30d7d246c5e7cd93$exports, "vertexGPUTemplate", () => (parcelRequire("a8QIF")).vertexGPUTemplate);
$parcel$export($30d7d246c5e7cd93$exports, "vertexGlTemplate", () => (parcelRequire("a8QIF")).vertexGlTemplate);
$parcel$export($30d7d246c5e7cd93$exports, "colorBit", () => (parcelRequire("eGbby")).colorBit);
$parcel$export($30d7d246c5e7cd93$exports, "colorBitGl", () => (parcelRequire("eGbby")).colorBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "generateTextureBatchBit", () => (parcelRequire("1I0Ex")).generateTextureBatchBit);
$parcel$export($30d7d246c5e7cd93$exports, "generateTextureBatchBitGl", () => (parcelRequire("1I0Ex")).generateTextureBatchBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "globalUniformsBit", () => (parcelRequire("bxcOr")).globalUniformsBit);
$parcel$export($30d7d246c5e7cd93$exports, "globalUniformsBitGl", () => (parcelRequire("bxcOr")).globalUniformsBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "globalUniformsUBOBitGl", () => (parcelRequire("bxcOr")).globalUniformsUBOBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "localUniformBit", () => (parcelRequire("dKCGl")).localUniformBit);
$parcel$export($30d7d246c5e7cd93$exports, "localUniformBitGl", () => (parcelRequire("dKCGl")).localUniformBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "localUniformBitGroup2", () => (parcelRequire("dKCGl")).localUniformBitGroup2);
$parcel$export($30d7d246c5e7cd93$exports, "roundPixelsBit", () => (parcelRequire("gnlmr")).roundPixelsBit);
$parcel$export($30d7d246c5e7cd93$exports, "roundPixelsBitGl", () => (parcelRequire("gnlmr")).roundPixelsBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "textureBit", () => (parcelRequire("7hkN8")).textureBit);
$parcel$export($30d7d246c5e7cd93$exports, "textureBitGl", () => (parcelRequire("7hkN8")).textureBitGl);
$parcel$export($30d7d246c5e7cd93$exports, "AlphaMask", () => (parcelRequire("28ThD")).AlphaMask);
$parcel$export($30d7d246c5e7cd93$exports, "AlphaMaskPipe", () => (parcelRequire("gNCRL")).AlphaMaskPipe);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasColorMaskPipe", () => (parcelRequire("kF9p5")).CanvasColorMaskPipe);
$parcel$export($30d7d246c5e7cd93$exports, "ColorMask", () => (parcelRequire("4DqO3")).ColorMask);
$parcel$export($30d7d246c5e7cd93$exports, "ColorMaskPipe", () => (parcelRequire("lNC5O")).ColorMaskPipe);
$parcel$export($30d7d246c5e7cd93$exports, "MaskEffectManager", () => (parcelRequire("gzffs")).MaskEffectManager);
$parcel$export($30d7d246c5e7cd93$exports, "MaskEffectManagerClass", () => (parcelRequire("gzffs")).MaskEffectManagerClass);
$parcel$export($30d7d246c5e7cd93$exports, "ScissorMask", () => $4dea72e4ea6eb54a$export$d3b30572aa9f34ed);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasStencilMaskPipe", () => (parcelRequire("8uCJE")).CanvasStencilMaskPipe);
$parcel$export($30d7d246c5e7cd93$exports, "StencilMask", () => (parcelRequire("issq5")).StencilMask);
$parcel$export($30d7d246c5e7cd93$exports, "StencilMaskPipe", () => (parcelRequire("yJ7KI")).StencilMaskPipe);
$parcel$export($30d7d246c5e7cd93$exports, "addMaskBounds", () => (parcelRequire("PVSNp")).addMaskBounds);
$parcel$export($30d7d246c5e7cd93$exports, "addMaskLocalBounds", () => (parcelRequire("25uEm")).addMaskLocalBounds);
$parcel$export($30d7d246c5e7cd93$exports, "autoDetectRenderer", () => $1c523be2a547c961$export$3583b92ab8150eb6);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasContextSystem", () => (parcelRequire("gBwOb")).CanvasContextSystem);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasFilterSystem", () => $9f91e5b1ed9b97a7$export$79609693985adbca);
$parcel$export($30d7d246c5e7cd93$exports, "isCanvasFilterCapable", () => $9f91e5b1ed9b97a7$export$11b4d03fcc98aa40);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasLimitsSystem", () => (parcelRequire("iZQJj")).CanvasLimitsSystem);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasRenderer", () => (parcelRequire("lFL21")).CanvasRenderer);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasRenderTargetAdaptor", () => (parcelRequire("2ScGl")).CanvasRenderTargetAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasRenderTargetSystem", () => (parcelRequire("f4cmq")).CanvasRenderTargetSystem);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTextureSystem", () => (parcelRequire("dV9kF")).CanvasTextureSystem);
$parcel$export($30d7d246c5e7cd93$exports, "canUseNewCanvasBlendModes", () => (parcelRequire("gfzpv")).canUseNewCanvasBlendModes);
$parcel$export($30d7d246c5e7cd93$exports, "canvasUtils", () => (parcelRequire("2IIjX")).canvasUtils);
$parcel$export($30d7d246c5e7cd93$exports, "mapCanvasBlendModesToPixi", () => (parcelRequire("15FDP")).mapCanvasBlendModesToPixi);
$parcel$export($30d7d246c5e7cd93$exports, "BUFFER_TYPE", () => (parcelRequire("7LyGy")).BUFFER_TYPE);
$parcel$export($30d7d246c5e7cd93$exports, "GlBuffer", () => (parcelRequire("8bVSg")).GlBuffer);
$parcel$export($30d7d246c5e7cd93$exports, "GlBufferSystem", () => (parcelRequire("k0jeB")).GlBufferSystem);
$parcel$export($30d7d246c5e7cd93$exports, "CLEAR", () => (parcelRequire("5Ac7T")).CLEAR);
$parcel$export($30d7d246c5e7cd93$exports, "GlContextSystem", () => (parcelRequire("a66qS")).GlContextSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlGeometryGpuData", () => (parcelRequire("4gUjT")).GlGeometryGpuData);
$parcel$export($30d7d246c5e7cd93$exports, "GlGeometrySystem", () => (parcelRequire("4gUjT")).GlGeometrySystem);
$parcel$export($30d7d246c5e7cd93$exports, "getGlTypeFromFormat", () => (parcelRequire("4W7Q2")).getGlTypeFromFormat);
$parcel$export($30d7d246c5e7cd93$exports, "GlBackBufferSystem", () => (parcelRequire("1k36i")).GlBackBufferSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlColorMaskSystem", () => (parcelRequire("hqwGc")).GlColorMaskSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlEncoderSystem", () => (parcelRequire("hJqSP")).GlEncoderSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlLimitsSystem", () => (parcelRequire("epQ0R")).GlLimitsSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlRenderTarget", () => (parcelRequire("X4HIt")).GlRenderTarget);
$parcel$export($30d7d246c5e7cd93$exports, "GlStencilSystem", () => (parcelRequire("chYSB")).GlStencilSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlUboSystem", () => (parcelRequire("6FDbi")).GlUboSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlRenderTargetAdaptor", () => (parcelRequire("5DCZv")).GlRenderTargetAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "GlRenderTargetSystem", () => (parcelRequire("afkf3")).GlRenderTargetSystem);
$parcel$export($30d7d246c5e7cd93$exports, "generateShaderSyncCode", () => (parcelRequire("Rm4fI")).generateShaderSyncCode);
$parcel$export($30d7d246c5e7cd93$exports, "getBatchSamplersUniformGroup", () => (parcelRequire("foUHO")).getBatchSamplersUniformGroup);
$parcel$export($30d7d246c5e7cd93$exports, "GlProgram", () => (parcelRequire("4kU4M")).GlProgram);
$parcel$export($30d7d246c5e7cd93$exports, "GlProgramData", () => (parcelRequire("lhx4E")).GlProgramData);
$parcel$export($30d7d246c5e7cd93$exports, "IGLUniformData", () => (parcelRequire("lhx4E")).IGLUniformData);
$parcel$export($30d7d246c5e7cd93$exports, "GlShaderSystem", () => (parcelRequire("6ZiIY")).GlShaderSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GlUniformGroupSystem", () => (parcelRequire("iaA7Y")).GlUniformGroupSystem);
$parcel$export($30d7d246c5e7cd93$exports, "migrateFragmentFromV7toV8", () => $9f076e2344748696$export$e65570829deefc5);
$parcel$export($30d7d246c5e7cd93$exports, "compileShader", () => (parcelRequire("9q9nW")).compileShader);
$parcel$export($30d7d246c5e7cd93$exports, "defaultValue", () => (parcelRequire("ljCyn")).defaultValue);
$parcel$export($30d7d246c5e7cd93$exports, "ensureAttributes", () => (parcelRequire("5dp3e")).ensureAttributes);
$parcel$export($30d7d246c5e7cd93$exports, "extractAttributesFromGlProgram", () => (parcelRequire("kokDf")).extractAttributesFromGlProgram);
$parcel$export($30d7d246c5e7cd93$exports, "generateProgram", () => (parcelRequire("8XSZ3")).generateProgram);
$parcel$export($30d7d246c5e7cd93$exports, "getMaxFragmentPrecision", () => (parcelRequire("PoGJg")).getMaxFragmentPrecision);
$parcel$export($30d7d246c5e7cd93$exports, "getTestContext", () => (parcelRequire("2sz3b")).getTestContext);
$parcel$export($30d7d246c5e7cd93$exports, "getUboData", () => (parcelRequire("623tj")).getUboData);
$parcel$export($30d7d246c5e7cd93$exports, "getUniformData", () => (parcelRequire("e8SzA")).getUniformData);
$parcel$export($30d7d246c5e7cd93$exports, "logProgramError", () => (parcelRequire("jWjsq")).logProgramError);
$parcel$export($30d7d246c5e7cd93$exports, "mapSize", () => $183cd7d651459f4b$export$50ee69a11aa2abdb);
$parcel$export($30d7d246c5e7cd93$exports, "mapGlToVertexFormat", () => (parcelRequire("Y425I")).mapGlToVertexFormat);
$parcel$export($30d7d246c5e7cd93$exports, "mapType", () => (parcelRequire("Y425I")).mapType);
$parcel$export($30d7d246c5e7cd93$exports, "addProgramDefines", () => (parcelRequire("hAD1m")).addProgramDefines);
$parcel$export($30d7d246c5e7cd93$exports, "ensurePrecision", () => (parcelRequire("1ZdMF")).ensurePrecision);
$parcel$export($30d7d246c5e7cd93$exports, "insertVersion", () => (parcelRequire("1EMZg")).insertVersion);
$parcel$export($30d7d246c5e7cd93$exports, "setProgramName", () => (parcelRequire("4IUGf")).setProgramName);
$parcel$export($30d7d246c5e7cd93$exports, "stripVersion", () => (parcelRequire("kQYzC")).stripVersion);
$parcel$export($30d7d246c5e7cd93$exports, "WGSL_TO_STD40_SIZE", () => (parcelRequire("9z8Ce")).WGSL_TO_STD40_SIZE);
$parcel$export($30d7d246c5e7cd93$exports, "createUboElementsSTD40", () => (parcelRequire("9z8Ce")).createUboElementsSTD40);
$parcel$export($30d7d246c5e7cd93$exports, "createUboSyncFunctionSTD40", () => (parcelRequire("ag5k6")).createUboSyncFunctionSTD40);
$parcel$export($30d7d246c5e7cd93$exports, "generateArraySyncSTD40", () => (parcelRequire("8Cr41")).generateArraySyncSTD40);
$parcel$export($30d7d246c5e7cd93$exports, "generateUniformsSync", () => (parcelRequire("bq0o8")).generateUniformsSync);
$parcel$export($30d7d246c5e7cd93$exports, "UNIFORM_TO_ARRAY_SETTERS", () => (parcelRequire("1I8G2")).UNIFORM_TO_ARRAY_SETTERS);
$parcel$export($30d7d246c5e7cd93$exports, "UNIFORM_TO_SINGLE_SETTERS", () => (parcelRequire("1I8G2")).UNIFORM_TO_SINGLE_SETTERS);
$parcel$export($30d7d246c5e7cd93$exports, "GlStateSystem", () => (parcelRequire("71WMa")).GlStateSystem);
$parcel$export($30d7d246c5e7cd93$exports, "mapWebGLBlendModesToPixi", () => (parcelRequire("cVY0I")).mapWebGLBlendModesToPixi);
$parcel$export($30d7d246c5e7cd93$exports, "GL_FORMATS", () => (parcelRequire("d0Wi0")).GL_FORMATS);
$parcel$export($30d7d246c5e7cd93$exports, "GL_TARGETS", () => (parcelRequire("d0Wi0")).GL_TARGETS);
$parcel$export($30d7d246c5e7cd93$exports, "GL_TYPES", () => (parcelRequire("d0Wi0")).GL_TYPES);
$parcel$export($30d7d246c5e7cd93$exports, "GL_WRAP_MODES", () => (parcelRequire("d0Wi0")).GL_WRAP_MODES);
$parcel$export($30d7d246c5e7cd93$exports, "GlTexture", () => (parcelRequire("2rkWb")).GlTexture);
$parcel$export($30d7d246c5e7cd93$exports, "GlTextureSystem", () => (parcelRequire("lMeU5")).GlTextureSystem);
$parcel$export($30d7d246c5e7cd93$exports, "glUploadBufferImageResource", () => (parcelRequire("cciod")).glUploadBufferImageResource);
$parcel$export($30d7d246c5e7cd93$exports, "glUploadCompressedTextureResource", () => (parcelRequire("ltjQZ")).glUploadCompressedTextureResource);
$parcel$export($30d7d246c5e7cd93$exports, "createGlUploadCubeTextureResource", () => (parcelRequire("hufwr")).createGlUploadCubeTextureResource);
$parcel$export($30d7d246c5e7cd93$exports, "glUploadImageResource", () => (parcelRequire("hU0oy")).glUploadImageResource);
$parcel$export($30d7d246c5e7cd93$exports, "glUploadVideoResource", () => (parcelRequire("5eCic")).glUploadVideoResource);
$parcel$export($30d7d246c5e7cd93$exports, "applyStyleParams", () => (parcelRequire("iRWum")).applyStyleParams);
$parcel$export($30d7d246c5e7cd93$exports, "getSupportedGlCompressedTextureFormats", () => $65cbc8dc9ca11748$export$53ee2d058bf32643);
$parcel$export($30d7d246c5e7cd93$exports, "mapFormatToGlFormat", () => (parcelRequire("5N2S9")).mapFormatToGlFormat);
$parcel$export($30d7d246c5e7cd93$exports, "mapFormatToGlInternalFormat", () => (parcelRequire("1cGmN")).mapFormatToGlInternalFormat);
$parcel$export($30d7d246c5e7cd93$exports, "mapFormatToGlType", () => (parcelRequire("8LpWL")).mapFormatToGlType);
$parcel$export($30d7d246c5e7cd93$exports, "mapViewDimensionToGlTarget", () => (parcelRequire("lh1dy")).mapViewDimensionToGlTarget);
$parcel$export($30d7d246c5e7cd93$exports, "compareModeToGlCompare", () => (parcelRequire("gceSf")).compareModeToGlCompare);
$parcel$export($30d7d246c5e7cd93$exports, "mipmapScaleModeToGlFilter", () => (parcelRequire("gceSf")).mipmapScaleModeToGlFilter);
$parcel$export($30d7d246c5e7cd93$exports, "scaleModeToGlFilter", () => (parcelRequire("gceSf")).scaleModeToGlFilter);
$parcel$export($30d7d246c5e7cd93$exports, "wrapModeToGlAddress", () => (parcelRequire("gceSf")).wrapModeToGlAddress);
$parcel$export($30d7d246c5e7cd93$exports, "unpremultiplyAlpha", () => (parcelRequire("7ns3U")).unpremultiplyAlpha);
$parcel$export($30d7d246c5e7cd93$exports, "WebGLRenderer", () => (parcelRequire("5aJ4P")).WebGLRenderer);
$parcel$export($30d7d246c5e7cd93$exports, "BindGroupSystem", () => (parcelRequire("5mmZy")).BindGroupSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuBufferData", () => (parcelRequire("a7eRK")).GpuBufferData);
$parcel$export($30d7d246c5e7cd93$exports, "GpuBufferSystem", () => (parcelRequire("a7eRK")).GpuBufferSystem);
$parcel$export($30d7d246c5e7cd93$exports, "UboBatch", () => (parcelRequire("bcrPS")).UboBatch);
$parcel$export($30d7d246c5e7cd93$exports, "GpuColorMaskSystem", () => (parcelRequire("8KWmS")).GpuColorMaskSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuDeviceSystem", () => (parcelRequire("7nhp3")).GpuDeviceSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuEncoderSystem", () => (parcelRequire("cQMIy")).GpuEncoderSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuLimitsSystem", () => (parcelRequire("k3sPs")).GpuLimitsSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuStencilSystem", () => (parcelRequire("4ilFQ")).GpuStencilSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuUboSystem", () => (parcelRequire("epQzV")).GpuUboSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuUniformBatchPipe", () => (parcelRequire("fYxv0")).GpuUniformBatchPipe);
$parcel$export($30d7d246c5e7cd93$exports, "PipelineSystem", () => (parcelRequire("asuS1")).PipelineSystem);
$parcel$export($30d7d246c5e7cd93$exports, "calculateProjection", () => (parcelRequire("j5jxv")).calculateProjection);
$parcel$export($30d7d246c5e7cd93$exports, "GpuRenderTarget", () => (parcelRequire("iXZ4N")).GpuRenderTarget);
$parcel$export($30d7d246c5e7cd93$exports, "GpuRenderTargetAdaptor", () => (parcelRequire("26lTw")).GpuRenderTargetAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "GpuRenderTargetSystem", () => (parcelRequire("9oWpi")).GpuRenderTargetSystem);
$parcel$export($30d7d246c5e7cd93$exports, "BindGroup", () => (parcelRequire("eK2sB")).BindGroup);
$parcel$export($30d7d246c5e7cd93$exports, "GpuProgram", () => (parcelRequire("bEdxc")).GpuProgram);
$parcel$export($30d7d246c5e7cd93$exports, "GpuShaderSystem", () => (parcelRequire("7oXM7")).GpuShaderSystem);
$parcel$export($30d7d246c5e7cd93$exports, "WGSL_ALIGN_SIZE_DATA", () => (parcelRequire("hXd8Z")).WGSL_ALIGN_SIZE_DATA);
$parcel$export($30d7d246c5e7cd93$exports, "createUboElementsWGSL", () => (parcelRequire("hXd8Z")).createUboElementsWGSL);
$parcel$export($30d7d246c5e7cd93$exports, "createUboSyncFunctionWGSL", () => (parcelRequire("8346X")).createUboSyncFunctionWGSL);
$parcel$export($30d7d246c5e7cd93$exports, "extractAttributesFromGpuProgram", () => (parcelRequire("jqzau")).extractAttributesFromGpuProgram);
$parcel$export($30d7d246c5e7cd93$exports, "extractStructAndGroups", () => (parcelRequire("gKvt3")).extractStructAndGroups);
$parcel$export($30d7d246c5e7cd93$exports, "generateArraySyncWGSL", () => (parcelRequire("9LA71")).generateArraySyncWGSL);
$parcel$export($30d7d246c5e7cd93$exports, "generateGpuLayoutGroups", () => (parcelRequire("5UqCH")).generateGpuLayoutGroups);
$parcel$export($30d7d246c5e7cd93$exports, "generateLayoutHash", () => (parcelRequire("8RSuU")).generateLayoutHash);
$parcel$export($30d7d246c5e7cd93$exports, "removeStructAndGroupDuplicates", () => (parcelRequire("5WpII")).removeStructAndGroupDuplicates);
$parcel$export($30d7d246c5e7cd93$exports, "GpuBlendModesToPixi", () => (parcelRequire("fWGV5")).GpuBlendModesToPixi);
$parcel$export($30d7d246c5e7cd93$exports, "GpuStateSystem", () => (parcelRequire("6v8M4")).GpuStateSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GpuStencilModesToPixi", () => (parcelRequire("kcEAx")).GpuStencilModesToPixi);
$parcel$export($30d7d246c5e7cd93$exports, "GPUTextureGpuData", () => (parcelRequire("h62oc")).GPUTextureGpuData);
$parcel$export($30d7d246c5e7cd93$exports, "GpuTextureSystem", () => (parcelRequire("h62oc")).GpuTextureSystem);
$parcel$export($30d7d246c5e7cd93$exports, "gpuUploadBufferImageResource", () => (parcelRequire("fruAx")).gpuUploadBufferImageResource);
$parcel$export($30d7d246c5e7cd93$exports, "blockDataMap", () => (parcelRequire("hrIct")).blockDataMap);
$parcel$export($30d7d246c5e7cd93$exports, "gpuUploadCompressedTextureResource", () => (parcelRequire("hrIct")).gpuUploadCompressedTextureResource);
$parcel$export($30d7d246c5e7cd93$exports, "createGpuUploadCubeTextureResource", () => (parcelRequire("hKdsJ")).createGpuUploadCubeTextureResource);
$parcel$export($30d7d246c5e7cd93$exports, "gpuUploadImageResource", () => (parcelRequire("3vOQh")).gpuUploadImageResource);
$parcel$export($30d7d246c5e7cd93$exports, "gpuUploadVideoResource", () => (parcelRequire("jQIsz")).gpuUploadVideoResource);
$parcel$export($30d7d246c5e7cd93$exports, "getSupportedGPUCompressedTextureFormats", () => $fa377c1fb1c5e3b5$export$ca1c48b0705b3068);
$parcel$export($30d7d246c5e7cd93$exports, "GpuMipmapGenerator", () => (parcelRequire("2jIR8")).GpuMipmapGenerator);
$parcel$export($30d7d246c5e7cd93$exports, "WebGPURenderer", () => (parcelRequire("bCbWs")).WebGPURenderer);
$parcel$export($30d7d246c5e7cd93$exports, "BackgroundSystem", () => (parcelRequire("9UEzW")).BackgroundSystem);
$parcel$export($30d7d246c5e7cd93$exports, "BlendModePipe", () => (parcelRequire("4PjrR")).BlendModePipe);
$parcel$export($30d7d246c5e7cd93$exports, "Buffer", () => (parcelRequire("2bJdA")).Buffer);
$parcel$export($30d7d246c5e7cd93$exports, "BufferResource", () => (parcelRequire("9axq6")).BufferResource);
$parcel$export($30d7d246c5e7cd93$exports, "BufferUsage", () => (parcelRequire("1T7Iy")).BufferUsage);
$parcel$export($30d7d246c5e7cd93$exports, "fastCopy", () => (parcelRequire("3hvSu")).fastCopy);
$parcel$export($30d7d246c5e7cd93$exports, "ExtractSystem", () => (parcelRequire("57WMt")).ExtractSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GenerateTextureSystem", () => (parcelRequire("7fOUA")).GenerateTextureSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GCSystem", () => (parcelRequire("7bRdE")).GCSystem);
$parcel$export($30d7d246c5e7cd93$exports, "DRAW_MODES", () => $17e5637b80de6878$export$91100badd8469338);
$parcel$export($30d7d246c5e7cd93$exports, "Geometry", () => (parcelRequire("1T4Gr")).Geometry);
$parcel$export($30d7d246c5e7cd93$exports, "buildSimpleUvs", () => (parcelRequire("6WSe9")).buildSimpleUvs);
$parcel$export($30d7d246c5e7cd93$exports, "buildUvs", () => (parcelRequire("6WSe9")).buildUvs);
$parcel$export($30d7d246c5e7cd93$exports, "ensureIsBuffer", () => (parcelRequire("nCv4H")).ensureIsBuffer);
$parcel$export($30d7d246c5e7cd93$exports, "getAttributeInfoFromFormat", () => (parcelRequire("eDWUK")).getAttributeInfoFromFormat);
$parcel$export($30d7d246c5e7cd93$exports, "getGeometryBounds", () => (parcelRequire("bzZoS")).getGeometryBounds);
$parcel$export($30d7d246c5e7cd93$exports, "transformVertices", () => (parcelRequire("iWOpI")).transformVertices);
$parcel$export($30d7d246c5e7cd93$exports, "InstructionSet", () => (parcelRequire("1oPFv")).InstructionSet);
$parcel$export($30d7d246c5e7cd93$exports, "GlobalUniformSystem", () => (parcelRequire("cVsmc")).GlobalUniformSystem);
$parcel$export($30d7d246c5e7cd93$exports, "isRenderingToScreen", () => (parcelRequire("axEIC")).isRenderingToScreen);
$parcel$export($30d7d246c5e7cd93$exports, "RenderTarget", () => (parcelRequire("l6xrO")).RenderTarget);
$parcel$export($30d7d246c5e7cd93$exports, "RenderTargetSystem", () => (parcelRequire("2nO5l")).RenderTargetSystem);
$parcel$export($30d7d246c5e7cd93$exports, "SchedulerSystem", () => (parcelRequire("iifuN")).SchedulerSystem);
$parcel$export($30d7d246c5e7cd93$exports, "ShaderStage", () => (parcelRequire("kqAKw")).ShaderStage);
$parcel$export($30d7d246c5e7cd93$exports, "Shader", () => (parcelRequire("7LCXQ")).Shader);
$parcel$export($30d7d246c5e7cd93$exports, "UNIFORM_TYPES_MAP", () => (parcelRequire("fC2kJ")).UNIFORM_TYPES_MAP);
$parcel$export($30d7d246c5e7cd93$exports, "UNIFORM_TYPES_VALUES", () => (parcelRequire("fC2kJ")).UNIFORM_TYPES_VALUES);
$parcel$export($30d7d246c5e7cd93$exports, "UboSystem", () => (parcelRequire("jSrmW")).UboSystem);
$parcel$export($30d7d246c5e7cd93$exports, "UniformGroup", () => (parcelRequire("aUxJK")).UniformGroup);
$parcel$export($30d7d246c5e7cd93$exports, "createUboSyncFunction", () => (parcelRequire("9dsH7")).createUboSyncFunction);
$parcel$export($30d7d246c5e7cd93$exports, "getDefaultUniformValue", () => (parcelRequire("9wfqV")).getDefaultUniformValue);
$parcel$export($30d7d246c5e7cd93$exports, "uboSyncFunctionsSTD40", () => (parcelRequire("ktXe2")).uboSyncFunctionsSTD40);
$parcel$export($30d7d246c5e7cd93$exports, "uboSyncFunctionsWGSL", () => (parcelRequire("ktXe2")).uboSyncFunctionsWGSL);
$parcel$export($30d7d246c5e7cd93$exports, "uniformParsers", () => (parcelRequire("1oQYm")).uniformParsers);
$parcel$export($30d7d246c5e7cd93$exports, "HelloSystem", () => (parcelRequire("eHpUP")).HelloSystem);
$parcel$export($30d7d246c5e7cd93$exports, "BLEND_TO_NPM", () => (parcelRequire("fYoss")).BLEND_TO_NPM);
$parcel$export($30d7d246c5e7cd93$exports, "STENCIL_MODES", () => (parcelRequire("fYoss")).STENCIL_MODES);
$parcel$export($30d7d246c5e7cd93$exports, "getAdjustedBlendModeBlend", () => (parcelRequire("fy1Tx")).getAdjustedBlendModeBlend);
$parcel$export($30d7d246c5e7cd93$exports, "State", () => (parcelRequire("fx0Zy")).State);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractRenderer", () => (parcelRequire("7velr")).AbstractRenderer);
$parcel$export($30d7d246c5e7cd93$exports, "SharedRenderPipes", () => (parcelRequire("g2d25")).SharedRenderPipes);
$parcel$export($30d7d246c5e7cd93$exports, "SharedSystems", () => (parcelRequire("g2d25")).SharedSystems);
$parcel$export($30d7d246c5e7cd93$exports, "SystemRunner", () => (parcelRequire("ljtep")).SystemRunner);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasPool", () => (parcelRequire("dDZJD")).CanvasPool);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasPoolClass", () => (parcelRequire("dDZJD")).CanvasPoolClass);
$parcel$export($30d7d246c5e7cd93$exports, "DEPRECATED_SCALE_MODES", () => $8198d5846d96f1d9$export$b7a14fee0d1d75cf);
$parcel$export($30d7d246c5e7cd93$exports, "DEPRECATED_WRAP_MODES", () => $8198d5846d96f1d9$export$11e7818b66cb6578);
$parcel$export($30d7d246c5e7cd93$exports, "SCALE_MODES", () => $8198d5846d96f1d9$export$6b734c6a0bba8473);
$parcel$export($30d7d246c5e7cd93$exports, "WRAP_MODES", () => $8198d5846d96f1d9$export$2ab395cfb0dd2f0f);
$parcel$export($30d7d246c5e7cd93$exports, "CubeTexture", () => $aa195e943239a125$export$ee2e5a18258a4049);
$parcel$export($30d7d246c5e7cd93$exports, "RenderableGCSystem", () => (parcelRequire("9JGFp")).RenderableGCSystem);
$parcel$export($30d7d246c5e7cd93$exports, "RenderTexture", () => (parcelRequire("jH853")).RenderTexture);
$parcel$export($30d7d246c5e7cd93$exports, "BufferImageSource", () => (parcelRequire("hk1vi")).BufferImageSource);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasSource", () => (parcelRequire("egYi0")).CanvasSource);
$parcel$export($30d7d246c5e7cd93$exports, "CompressedSource", () => $81ada49b5e64f85d$export$19b6a4fc54276638);
$parcel$export($30d7d246c5e7cd93$exports, "CubeTextureSource", () => $410bf5be1058f2d9$export$44fad16177a84e21);
$parcel$export($30d7d246c5e7cd93$exports, "ExternalSource", () => $16b1fac55f292e16$export$ffc19e40a21f08eb);
$parcel$export($30d7d246c5e7cd93$exports, "ImageSource", () => (parcelRequire("cVYNB")).ImageSource);
$parcel$export($30d7d246c5e7cd93$exports, "TextureSource", () => (parcelRequire("gmQ4R")).TextureSource);
$parcel$export($30d7d246c5e7cd93$exports, "VideoSource", () => (parcelRequire("dvpBJ")).VideoSource);
$parcel$export($30d7d246c5e7cd93$exports, "Texture", () => (parcelRequire("4iNSL")).Texture);
$parcel$export($30d7d246c5e7cd93$exports, "TextureGCSystem", () => (parcelRequire("715l6")).TextureGCSystem);
$parcel$export($30d7d246c5e7cd93$exports, "TextureMatrix", () => (parcelRequire("eVE7u")).TextureMatrix);
$parcel$export($30d7d246c5e7cd93$exports, "TexturePool", () => (parcelRequire("5NyEC")).TexturePool);
$parcel$export($30d7d246c5e7cd93$exports, "TexturePoolClass", () => (parcelRequire("5NyEC")).TexturePoolClass);
$parcel$export($30d7d246c5e7cd93$exports, "TextureStyle", () => (parcelRequire("c8piJ")).TextureStyle);
$parcel$export($30d7d246c5e7cd93$exports, "TextureUvs", () => $95db4b95deb39174$export$4efdf5c542d7171e);
$parcel$export($30d7d246c5e7cd93$exports, "getCanvasTexture", () => (parcelRequire("5phlQ")).getCanvasTexture);
$parcel$export($30d7d246c5e7cd93$exports, "hasCachedCanvasTexture", () => (parcelRequire("5phlQ")).hasCachedCanvasTexture);
$parcel$export($30d7d246c5e7cd93$exports, "getSupportedCompressedTextureFormats", () => $41d1bec41d2744d8$export$6ac497591fea8412);
$parcel$export($30d7d246c5e7cd93$exports, "getSupportedTextureFormats", () => $06cbf1322a912ae5$export$6ce110edff12c69);
$parcel$export($30d7d246c5e7cd93$exports, "nonCompressedFormats", () => $06cbf1322a912ae5$export$faa476df535f4e2e);
$parcel$export($30d7d246c5e7cd93$exports, "autoDetectSource", () => (parcelRequire("hlucP")).autoDetectSource);
$parcel$export($30d7d246c5e7cd93$exports, "resourceToTexture", () => (parcelRequire("hlucP")).resourceToTexture);
$parcel$export($30d7d246c5e7cd93$exports, "textureFrom", () => (parcelRequire("hlucP")).textureFrom);
$parcel$export($30d7d246c5e7cd93$exports, "createIdFromString", () => (parcelRequire("jpjFn")).createIdFromString);
$parcel$export($30d7d246c5e7cd93$exports, "parseFunctionBody", () => $b1ff82aba3984b26$export$50f85c246417e18);
$parcel$export($30d7d246c5e7cd93$exports, "ViewSystem", () => (parcelRequire("9QtIe")).ViewSystem);
$parcel$export($30d7d246c5e7cd93$exports, "RendererType", () => (parcelRequire("bfcaK")).RendererType);
$parcel$export($30d7d246c5e7cd93$exports, "particlesFrag", () => $ac40a2fe3413b26e$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "particlesVert", () => $0f262301bdbdd53a$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "particlesWgsl", () => $f43e622d8c5f5566$export$2e2bcd8739ae039);
$parcel$export($30d7d246c5e7cd93$exports, "Bounds", () => (parcelRequire("esrbs")).Bounds);
$parcel$export($30d7d246c5e7cd93$exports, "getFastGlobalBounds", () => $510c26f251d4332c$export$ec3cb2102fa5391a);
$parcel$export($30d7d246c5e7cd93$exports, "getGlobalBounds", () => (parcelRequire("dJAmK")).getGlobalBounds);
$parcel$export($30d7d246c5e7cd93$exports, "updateTransformBackwards", () => (parcelRequire("dJAmK")).updateTransformBackwards);
$parcel$export($30d7d246c5e7cd93$exports, "getLocalBounds", () => (parcelRequire("7pBMy")).getLocalBounds);
$parcel$export($30d7d246c5e7cd93$exports, "getGlobalRenderableBounds", () => (parcelRequire("iqHv9")).getGlobalRenderableBounds);
$parcel$export($30d7d246c5e7cd93$exports, "boundsPool", () => (parcelRequire("gMrCM")).boundsPool);
$parcel$export($30d7d246c5e7cd93$exports, "matrixPool", () => (parcelRequire("gMrCM")).matrixPool);
$parcel$export($30d7d246c5e7cd93$exports, "cacheAsTextureMixin", () => (parcelRequire("b68Xy")).cacheAsTextureMixin);
$parcel$export($30d7d246c5e7cd93$exports, "childrenHelperMixin", () => (parcelRequire("cSba6")).childrenHelperMixin);
$parcel$export($30d7d246c5e7cd93$exports, "collectRenderablesMixin", () => (parcelRequire("iKlbs")).collectRenderablesMixin);
$parcel$export($30d7d246c5e7cd93$exports, "effectsMixin", () => (parcelRequire("R6gKP")).effectsMixin);
$parcel$export($30d7d246c5e7cd93$exports, "findMixin", () => (parcelRequire("6BXvq")).findMixin);
$parcel$export($30d7d246c5e7cd93$exports, "getFastGlobalBoundsMixin", () => (parcelRequire("7sEYV")).getFastGlobalBoundsMixin);
$parcel$export($30d7d246c5e7cd93$exports, "bgr2rgb", () => (parcelRequire("3qOui")).bgr2rgb);
$parcel$export($30d7d246c5e7cd93$exports, "getGlobalMixin", () => (parcelRequire("3qOui")).getGlobalMixin);
$parcel$export($30d7d246c5e7cd93$exports, "measureMixin", () => (parcelRequire("lDlzV")).measureMixin);
$parcel$export($30d7d246c5e7cd93$exports, "onRenderMixin", () => (parcelRequire("cN0Qi")).onRenderMixin);
$parcel$export($30d7d246c5e7cd93$exports, "sortMixin", () => (parcelRequire("1ylTw")).sortMixin);
$parcel$export($30d7d246c5e7cd93$exports, "toLocalGlobalMixin", () => (parcelRequire("5yHc8")).toLocalGlobalMixin);
$parcel$export($30d7d246c5e7cd93$exports, "Container", () => (parcelRequire("2vcTO")).Container);
$parcel$export($30d7d246c5e7cd93$exports, "UPDATE_BLEND", () => (parcelRequire("2vcTO")).UPDATE_BLEND);
$parcel$export($30d7d246c5e7cd93$exports, "UPDATE_COLOR", () => (parcelRequire("2vcTO")).UPDATE_COLOR);
$parcel$export($30d7d246c5e7cd93$exports, "UPDATE_TRANSFORM", () => (parcelRequire("2vcTO")).UPDATE_TRANSFORM);
$parcel$export($30d7d246c5e7cd93$exports, "UPDATE_VISIBLE", () => (parcelRequire("2vcTO")).UPDATE_VISIBLE);
$parcel$export($30d7d246c5e7cd93$exports, "CustomRenderPipe", () => (parcelRequire("1SYU5")).CustomRenderPipe);
$parcel$export($30d7d246c5e7cd93$exports, "RenderContainer", () => $f6986ed9f6d390ba$export$b0ee01c674e36513);
$parcel$export($30d7d246c5e7cd93$exports, "RenderGroup", () => (parcelRequire("k0xIU")).RenderGroup);
$parcel$export($30d7d246c5e7cd93$exports, "RenderGroupPipe", () => (parcelRequire("lGOq2")).RenderGroupPipe);
$parcel$export($30d7d246c5e7cd93$exports, "RenderGroupSystem", () => (parcelRequire("kixfr")).RenderGroupSystem);
$parcel$export($30d7d246c5e7cd93$exports, "assignWithIgnore", () => (parcelRequire("7lfy2")).assignWithIgnore);
$parcel$export($30d7d246c5e7cd93$exports, "checkChildrenDidChange", () => (parcelRequire("6h57y")).checkChildrenDidChange);
$parcel$export($30d7d246c5e7cd93$exports, "clearList", () => (parcelRequire("6IFWH")).clearList);
$parcel$export($30d7d246c5e7cd93$exports, "collectAllRenderables", () => $708f1b1a5870cc2f$export$d0ce49decf05e61d);
$parcel$export($30d7d246c5e7cd93$exports, "definedProps", () => (parcelRequire("cebhF")).definedProps);
$parcel$export($30d7d246c5e7cd93$exports, "executeInstructions", () => (parcelRequire("7QtNh")).executeInstructions);
$parcel$export($30d7d246c5e7cd93$exports, "multiplyColors", () => (parcelRequire("25Amh")).multiplyColors);
$parcel$export($30d7d246c5e7cd93$exports, "multiplyHexColors", () => (parcelRequire("5nS5O")).multiplyHexColors);
$parcel$export($30d7d246c5e7cd93$exports, "updateLocalTransform", () => $49c91a129609eb76$export$4dde168b0f6e77cb);
$parcel$export($30d7d246c5e7cd93$exports, "updateRenderGroupTransform", () => (parcelRequire("eDAcM")).updateRenderGroupTransform);
$parcel$export($30d7d246c5e7cd93$exports, "updateRenderGroupTransforms", () => (parcelRequire("eDAcM")).updateRenderGroupTransforms);
$parcel$export($30d7d246c5e7cd93$exports, "updateTransformAndChildren", () => (parcelRequire("eDAcM")).updateTransformAndChildren);
$parcel$export($30d7d246c5e7cd93$exports, "updateWorldTransform", () => $38059b353e48819d$export$ee945abfaa59934a);
$parcel$export($30d7d246c5e7cd93$exports, "validateRenderables", () => (parcelRequire("38HAG")).validateRenderables);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasGraphicsAdaptor", () => (parcelRequire("1sJn2")).CanvasGraphicsAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasGraphicsContextSystem", () => (parcelRequire("761XJ")).CanvasGraphicsContextSystem);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasGraphicsPipe", () => (parcelRequire("2gsFh")).CanvasGraphicsPipe);
$parcel$export($30d7d246c5e7cd93$exports, "GlGraphicsAdaptor", () => (parcelRequire("dUCZ0")).GlGraphicsAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "color32BitToUniform", () => (parcelRequire("id0ju")).color32BitToUniform);
$parcel$export($30d7d246c5e7cd93$exports, "colorToUniform", () => (parcelRequire("id0ju")).colorToUniform);
$parcel$export($30d7d246c5e7cd93$exports, "GpuGraphicsAdaptor", () => (parcelRequire("j3dtG")).GpuGraphicsAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "BatchableGraphics", () => (parcelRequire("arDaU")).BatchableGraphics);
$parcel$export($30d7d246c5e7cd93$exports, "buildAdaptiveBezier", () => (parcelRequire("kpMZU")).buildAdaptiveBezier);
$parcel$export($30d7d246c5e7cd93$exports, "buildAdaptiveQuadratic", () => (parcelRequire("bB0KA")).buildAdaptiveQuadratic);
$parcel$export($30d7d246c5e7cd93$exports, "buildArc", () => (parcelRequire("dP0DE")).buildArc);
$parcel$export($30d7d246c5e7cd93$exports, "buildArcTo", () => (parcelRequire("ipEz7")).buildArcTo);
$parcel$export($30d7d246c5e7cd93$exports, "buildArcToSvg", () => (parcelRequire("4VZYJ")).buildArcToSvg);
$parcel$export($30d7d246c5e7cd93$exports, "buildCircle", () => (parcelRequire("7p3VJ")).buildCircle);
$parcel$export($30d7d246c5e7cd93$exports, "buildEllipse", () => (parcelRequire("7p3VJ")).buildEllipse);
$parcel$export($30d7d246c5e7cd93$exports, "buildRoundedRectangle", () => (parcelRequire("7p3VJ")).buildRoundedRectangle);
$parcel$export($30d7d246c5e7cd93$exports, "buildLine", () => (parcelRequire("9kFG0")).buildLine);
$parcel$export($30d7d246c5e7cd93$exports, "buildPixelLine", () => (parcelRequire("iS417")).buildPixelLine);
$parcel$export($30d7d246c5e7cd93$exports, "buildPolygon", () => (parcelRequire("ctmiq")).buildPolygon);
$parcel$export($30d7d246c5e7cd93$exports, "buildRectangle", () => (parcelRequire("6F4Y7")).buildRectangle);
$parcel$export($30d7d246c5e7cd93$exports, "buildTriangle", () => (parcelRequire("dWsyQ")).buildTriangle);
$parcel$export($30d7d246c5e7cd93$exports, "closePointEps", () => (parcelRequire("6yC9w")).closePointEps);
$parcel$export($30d7d246c5e7cd93$exports, "curveEps", () => (parcelRequire("6yC9w")).curveEps);
$parcel$export($30d7d246c5e7cd93$exports, "FillGradient", () => (parcelRequire("hkzHY")).FillGradient);
$parcel$export($30d7d246c5e7cd93$exports, "FillPattern", () => (parcelRequire("bySfk")).FillPattern);
$parcel$export($30d7d246c5e7cd93$exports, "Graphics", () => (parcelRequire("iNnKd")).Graphics);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsContext", () => (parcelRequire("7kRkZ")).GraphicsContext);
$parcel$export($30d7d246c5e7cd93$exports, "GpuGraphicsContext", () => (parcelRequire("aDQkb")).GpuGraphicsContext);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsContextRenderData", () => (parcelRequire("aDQkb")).GraphicsContextRenderData);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsContextSystem", () => (parcelRequire("aDQkb")).GraphicsContextSystem);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsGpuData", () => (parcelRequire("cFO33")).GraphicsGpuData);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsPipe", () => (parcelRequire("cFO33")).GraphicsPipe);
$parcel$export($30d7d246c5e7cd93$exports, "GraphicsPath", () => (parcelRequire("1roql")).GraphicsPath);
$parcel$export($30d7d246c5e7cd93$exports, "roundedShapeArc", () => (parcelRequire("2NHgj")).roundedShapeArc);
$parcel$export($30d7d246c5e7cd93$exports, "roundedShapeQuadraticCurve", () => (parcelRequire("2NHgj")).roundedShapeQuadraticCurve);
$parcel$export($30d7d246c5e7cd93$exports, "ShapePath", () => (parcelRequire("4uUVY")).ShapePath);
$parcel$export($30d7d246c5e7cd93$exports, "parseSVGDefinitions", () => (parcelRequire("5QkPm")).parseSVGDefinitions);
$parcel$export($30d7d246c5e7cd93$exports, "parseSVGFloatAttribute", () => (parcelRequire("fUc8w")).parseSVGFloatAttribute);
$parcel$export($30d7d246c5e7cd93$exports, "parseSVGPath", () => (parcelRequire("2eMBY")).parseSVGPath);
$parcel$export($30d7d246c5e7cd93$exports, "parseSVGStyle", () => (parcelRequire("1crrD")).parseSVGStyle);
$parcel$export($30d7d246c5e7cd93$exports, "styleAttributes", () => (parcelRequire("1crrD")).styleAttributes);
$parcel$export($30d7d246c5e7cd93$exports, "SVGParser", () => (parcelRequire("dfSnn")).SVGParser);
$parcel$export($30d7d246c5e7cd93$exports, "extractSvgUrlId", () => (parcelRequire("5dXd8")).extractSvgUrlId);
$parcel$export($30d7d246c5e7cd93$exports, "checkForNestedPattern", () => (parcelRequire("2gf0f")).checkForNestedPattern);
$parcel$export($30d7d246c5e7cd93$exports, "getFillInstructionData", () => (parcelRequire("2gf0f")).getFillInstructionData);
$parcel$export($30d7d246c5e7cd93$exports, "appendSVGPath", () => (parcelRequire("9IHrN")).appendSVGPath);
$parcel$export($30d7d246c5e7cd93$exports, "calculatePathArea", () => (parcelRequire("9IHrN")).calculatePathArea);
$parcel$export($30d7d246c5e7cd93$exports, "extractSubpaths", () => (parcelRequire("9IHrN")).extractSubpaths);
$parcel$export($30d7d246c5e7cd93$exports, "buildContextBatches", () => (parcelRequire("j9D8w")).buildContextBatches);
$parcel$export($30d7d246c5e7cd93$exports, "shapeBuilders", () => (parcelRequire("j9D8w")).shapeBuilders);
$parcel$export($30d7d246c5e7cd93$exports, "buildGeometryFromPath", () => $11b737b4f4cd6617$export$d969b6f872d1065e);
$parcel$export($30d7d246c5e7cd93$exports, "toFillStyle", () => (parcelRequire("bapDA")).toFillStyle);
$parcel$export($30d7d246c5e7cd93$exports, "toStrokeStyle", () => (parcelRequire("bapDA")).toStrokeStyle);
$parcel$export($30d7d246c5e7cd93$exports, "generateTextureMatrix", () => (parcelRequire("kOp0T")).generateTextureMatrix);
$parcel$export($30d7d246c5e7cd93$exports, "getOrientationOfPoints", () => (parcelRequire("1g5QY")).getOrientationOfPoints);
$parcel$export($30d7d246c5e7cd93$exports, "triangulateWithHoles", () => (parcelRequire("lToNE")).triangulateWithHoles);
$parcel$export($30d7d246c5e7cd93$exports, "RenderLayer", () => $df6a549e19fc436b$export$cd6265b069888eed);
$parcel$export($30d7d246c5e7cd93$exports, "PerspectiveMesh", () => $1d2406d066ca89ec$export$a90764ab6a097dae);
$parcel$export($30d7d246c5e7cd93$exports, "PerspectivePlaneGeometry", () => $9557cb3bb5e61ab8$export$bfcdbe435a9b9701);
$parcel$export($30d7d246c5e7cd93$exports, "applyProjectiveTransformationToPlane", () => $07f415105e910815$export$3e2874e086963700);
$parcel$export($30d7d246c5e7cd93$exports, "compute2DProjection", () => $e871c9741565c5be$export$f1fdc06d58105ddd);
$parcel$export($30d7d246c5e7cd93$exports, "MeshPlane", () => $99d32c6eff6b4be4$export$738b1f28beade2a2);
$parcel$export($30d7d246c5e7cd93$exports, "PlaneGeometry", () => $a8d07342c65f7a94$export$967d831af31f69ce);
$parcel$export($30d7d246c5e7cd93$exports, "MeshRope", () => $a6f64a325f703271$export$2b0fdd9d3f905472);
$parcel$export($30d7d246c5e7cd93$exports, "MeshSimple", () => $54d9ee77c32be21f$export$fe1197d66f13b411);
$parcel$export($30d7d246c5e7cd93$exports, "RopeGeometry", () => $2cf6b77e8eb872cb$export$6a9827483976bf64);
$parcel$export($30d7d246c5e7cd93$exports, "GlMeshAdaptor", () => (parcelRequire("5aREr")).GlMeshAdaptor);
$parcel$export($30d7d246c5e7cd93$exports, "GpuMeshAdapter", () => (parcelRequire("4qqO8")).GpuMeshAdapter);
$parcel$export($30d7d246c5e7cd93$exports, "BatchableMesh", () => $1ad5fe12a59ec279$export$2fa0f0ec877329e3);
$parcel$export($30d7d246c5e7cd93$exports, "getTextureDefaultMatrix", () => $c9337d37651d9de5$export$195521b29bc6b458);
$parcel$export($30d7d246c5e7cd93$exports, "Mesh", () => $0ac2d29ab0a78f0e$export$e176487c05830cc5);
$parcel$export($30d7d246c5e7cd93$exports, "MeshGeometry", () => $b964c6f5532210d5$export$8d075a36a73d54bc);
$parcel$export($30d7d246c5e7cd93$exports, "MeshGpuData", () => $5b23daca5bad9047$export$9a0f2e45e685fe64);
$parcel$export($30d7d246c5e7cd93$exports, "MeshPipe", () => $5b23daca5bad9047$export$ec121977b4273ffd);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasParticleContainerAdaptor", () => $2c9c9711d691bf5f$export$a3bb3b18d3c0fa86);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasParticleContainerPipe", () => $e0e9d170a309bccc$export$577397794ae005cf);
$parcel$export($30d7d246c5e7cd93$exports, "GlParticleContainerAdaptor", () => $2f85d4b28425827c$export$46c725f3fa23723f);
$parcel$export($30d7d246c5e7cd93$exports, "GlParticleContainerPipe", () => $0c24f2e0964b9661$export$265dc7019ac9a69c);
$parcel$export($30d7d246c5e7cd93$exports, "GpuParticleContainerAdaptor", () => $24feddf41ac2de81$export$b05a5c43c842f66d);
$parcel$export($30d7d246c5e7cd93$exports, "GpuParticleContainerPipe", () => $9654d61a4f2746ae$export$1097a2b67474552c);
$parcel$export($30d7d246c5e7cd93$exports, "Particle", () => $b970650e5099956d$export$c36c68baa13912a5);
$parcel$export($30d7d246c5e7cd93$exports, "ParticleBuffer", () => $ee0dcefac4ec7731$export$ef6bb3c375ab2229);
$parcel$export($30d7d246c5e7cd93$exports, "ParticleContainer", () => $08fe00dcac11569d$export$e63bf72b2cfda112);
$parcel$export($30d7d246c5e7cd93$exports, "ParticleContainerPipe", () => $06aa82a812b671ea$export$bd0cb1ddce5f75fc);
$parcel$export($30d7d246c5e7cd93$exports, "particleData", () => $b7e6978beec43255$export$a7ffd1f9edff60c0);
$parcel$export($30d7d246c5e7cd93$exports, "ParticleShader", () => $038ce5b3d8323f15$export$aff9903e2c89709e);
$parcel$export($30d7d246c5e7cd93$exports, "createIndicesForQuads", () => $1cab0da29803566c$export$c56148e1bec42281);
$parcel$export($30d7d246c5e7cd93$exports, "generateParticleUpdateFunction", () => $9ecf074a252a4b08$export$f240bbaff81b32e9);
$parcel$export($30d7d246c5e7cd93$exports, "AnimatedSprite", () => $10731efba8cacc0d$export$dae599798687ad3c);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasNineSliceSpritePipe", () => $02b35d0f8344dd2b$export$e1f940f0a61daa3c);
$parcel$export($30d7d246c5e7cd93$exports, "NineSliceGeometry", () => $2cb7f5d5e3b00a06$export$a1f405faf7381142);
$parcel$export($30d7d246c5e7cd93$exports, "NineSlicePlane", () => $c6ed24e9ca2410f2$export$acdf4cb3f489544e);
$parcel$export($30d7d246c5e7cd93$exports, "NineSliceSprite", () => $c6ed24e9ca2410f2$export$ea7c4e309714d712);
$parcel$export($30d7d246c5e7cd93$exports, "NineSliceSpriteGpuData", () => $f661dd646069ac6f$export$33a15b7a67fcc678);
$parcel$export($30d7d246c5e7cd93$exports, "NineSliceSpritePipe", () => $f661dd646069ac6f$export$69030e8b070eaa80);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTilingSpritePipe", () => $936bb8c91af7c8af$export$3c03e9c29c63a3e);
$parcel$export($30d7d246c5e7cd93$exports, "tilingBit", () => $6eac24ae08973551$export$7551c6773b6af70d);
$parcel$export($30d7d246c5e7cd93$exports, "tilingBitGl", () => $6eac24ae08973551$export$a104558c66046525);
$parcel$export($30d7d246c5e7cd93$exports, "TilingSpriteShader", () => $0f7a0e3ea53c5cf5$export$d1a26cc57b383809);
$parcel$export($30d7d246c5e7cd93$exports, "TilingSprite", () => $35a7b8f9b04fc055$export$db8370cd1ebcc819);
$parcel$export($30d7d246c5e7cd93$exports, "TilingSpriteGpuData", () => $3869af071e31b3e5$export$885407fa78df5856);
$parcel$export($30d7d246c5e7cd93$exports, "TilingSpritePipe", () => $3869af071e31b3e5$export$b56051ebf906ec5d);
$parcel$export($30d7d246c5e7cd93$exports, "applyMatrix", () => $c71258507d8b5aba$export$8e14504c3429ee65);
$parcel$export($30d7d246c5e7cd93$exports, "QuadGeometry", () => $eb432fb3b2929fc1$export$d27e254c8c1b5a0e);
$parcel$export($30d7d246c5e7cd93$exports, "setPositions", () => $ec148d7b76e35c4c$export$7d390d1e3efa819a);
$parcel$export($30d7d246c5e7cd93$exports, "setUvs", () => $198813f83dc3f3a5$export$f99a1f47283a6d20);
$parcel$export($30d7d246c5e7cd93$exports, "BatchableSprite", () => (parcelRequire("hAzG5")).BatchableSprite);
$parcel$export($30d7d246c5e7cd93$exports, "Sprite", () => (parcelRequire("7ScuH")).Sprite);
$parcel$export($30d7d246c5e7cd93$exports, "SpritePipe", () => (parcelRequire("hzr7O")).SpritePipe);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractBitmapFont", () => (parcelRequire("l918V")).AbstractBitmapFont);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractBitmapTextPipe", () => $89d14507916ac1b3$export$118d8a6c6e22af34);
$parcel$export($30d7d246c5e7cd93$exports, "BitmapTextGraphics", () => $89d14507916ac1b3$export$b542b9239140e808);
$parcel$export($30d7d246c5e7cd93$exports, "bitmapFontTextParser", () => $3aae6b476bc8fa85$export$4c1815a0944ccac0);
$parcel$export($30d7d246c5e7cd93$exports, "bitmapFontXMLParser", () => $a6cdb2f3a10e5da2$export$7a7adbcafc5cf8e3);
$parcel$export($30d7d246c5e7cd93$exports, "bitmapFontXMLStringParser", () => $b4a97e4df8c1119e$export$bfc0a19e2e2cc16);
$parcel$export($30d7d246c5e7cd93$exports, "bitmapFontCachePlugin", () => $f6b7037dbc64186a$export$778a313228f06f6c);
$parcel$export($30d7d246c5e7cd93$exports, "loadBitmapFont", () => $f6b7037dbc64186a$export$402edee29ac8bed4);
$parcel$export($30d7d246c5e7cd93$exports, "BitmapFont", () => (parcelRequire("2LjMw")).BitmapFont);
$parcel$export($30d7d246c5e7cd93$exports, "BitmapFontManager", () => (parcelRequire("bJb7n")).BitmapFontManager);
$parcel$export($30d7d246c5e7cd93$exports, "BitmapText", () => $8095d93ccaec0291$export$ae0da96467efdba0);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasBitmapTextPipe", () => $694fa538d077b9a9$export$b4c52e42ab5b7d0c);
$parcel$export($30d7d246c5e7cd93$exports, "DynamicBitmapFont", () => (parcelRequire("a1eHr")).DynamicBitmapFont);
$parcel$export($30d7d246c5e7cd93$exports, "BitmapTextPipe", () => $bb6ebcf248784864$export$83d8b05a29a5f8ed);
$parcel$export($30d7d246c5e7cd93$exports, "bitmapTextSplit", () => $e342fc99cef084de$export$c4baeb8ec88b443);
$parcel$export($30d7d246c5e7cd93$exports, "getBitmapTextLayout", () => (parcelRequire("dhjTN")).getBitmapTextLayout);
$parcel$export($30d7d246c5e7cd93$exports, "resolveCharacters", () => (parcelRequire("3beWQ")).resolveCharacters);
$parcel$export($30d7d246c5e7cd93$exports, "BatchableHTMLText", () => $ce192bc6bd66ff16$export$26955126a6f3eb07);
$parcel$export($30d7d246c5e7cd93$exports, "HTMLText", () => $afdf916a562c9b1a$export$4b42bbc5a42896a1);
$parcel$export($30d7d246c5e7cd93$exports, "HTMLTextPipe", () => $87b4b1c9de8cb92c$export$ffcef6958193be1c);
$parcel$export($30d7d246c5e7cd93$exports, "HTMLTextRenderData", () => $3381da3d2cc4661b$export$47ab50939402e24e);
$parcel$export($30d7d246c5e7cd93$exports, "HTMLTextStyle", () => $8411904bd7736fea$export$a2664b42ece43c6c);
$parcel$export($30d7d246c5e7cd93$exports, "HTMLTextSystem", () => $9567781f44a66438$export$f1b82676a746d8e9);
$parcel$export($30d7d246c5e7cd93$exports, "extractFontFamilies", () => $b99c776ac89ff53d$export$464e4dcbf779d16c);
$parcel$export($30d7d246c5e7cd93$exports, "FontStylePromiseCache", () => $e1534842bcbeada5$export$9b6075a0351ad0f8);
$parcel$export($30d7d246c5e7cd93$exports, "getFontCss", () => $e1534842bcbeada5$export$634b39f5e6e8534d);
$parcel$export($30d7d246c5e7cd93$exports, "getSVGUrl", () => $8bc72fb7e7e66925$export$98b744dca5b9429f);
$parcel$export($30d7d246c5e7cd93$exports, "getTemporaryCanvasFromImage", () => $612f403d91c42bd4$export$d871fed544c30b4e);
$parcel$export($30d7d246c5e7cd93$exports, "loadFontAsBase64", () => $42a73d1f584b97e5$export$21404a5ba2126552);
$parcel$export($30d7d246c5e7cd93$exports, "loadFontCSS", () => $2b4d0af1bd73729f$export$d5a8e182a5491db2);
$parcel$export($30d7d246c5e7cd93$exports, "loadSVGImage", () => $3c5dfa3f7ca908c5$export$31cf685397f1a12a);
$parcel$export($30d7d246c5e7cd93$exports, "measureHtmlText", () => $441b7620e17c1dbf$export$9df7f2a259800030);
$parcel$export($30d7d246c5e7cd93$exports, "textStyleToCSS", () => $4c5ff8dee5feaab1$export$8daecfbc002513c1);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractSplitText", () => $f11d0ef2e560b73e$export$1a3cb0bc6a690913);
$parcel$export($30d7d246c5e7cd93$exports, "SplitBitmapText", () => $a2e15b36e18ce720$export$d99c5cc46c9929e3);
$parcel$export($30d7d246c5e7cd93$exports, "SplitText", () => $798014962b0dedae$export$bd0fa428528371b2);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractText", () => $19c3827930a6b92b$export$daf74670712de91);
$parcel$export($30d7d246c5e7cd93$exports, "ensureTextOptions", () => $19c3827930a6b92b$export$8ddfb4f614f8ed86);
$parcel$export($30d7d246c5e7cd93$exports, "BatchableText", () => $b54349231d10c4ee$export$f986f9176e9ba9b4);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTextGenerator", () => $7a49002c4353b76b$export$bb54b62b519176d5);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTextMetrics", () => (parcelRequire("1i9ku")).CanvasTextMetrics);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTextPipe", () => $1f4c37bef686d7d6$export$ed0d779e44b53050);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasRendererTextSystem", () => $20ef9ba315f69cd0$export$b13c6e11d8ae9690);
$parcel$export($30d7d246c5e7cd93$exports, "fontStringFromTextStyle", () => (parcelRequire("3FldU")).fontStringFromTextStyle);
$parcel$export($30d7d246c5e7cd93$exports, "getCanvasFillStyle", () => (parcelRequire("hFmvn")).getCanvasFillStyle);
$parcel$export($30d7d246c5e7cd93$exports, "measureTaggedText", () => (parcelRequire("io8hC")).measureTaggedText);
$parcel$export($30d7d246c5e7cd93$exports, "tokenizeTaggedRuns", () => (parcelRequire("io8hC")).tokenizeTaggedRuns);
$parcel$export($30d7d246c5e7cd93$exports, "wordWrapTaggedLines", () => (parcelRequire("io8hC")).wordWrapTaggedLines);
$parcel$export($30d7d246c5e7cd93$exports, "getPlainText", () => (parcelRequire("8jcQu")).getPlainText);
$parcel$export($30d7d246c5e7cd93$exports, "hasTagMarkup", () => (parcelRequire("8jcQu")).hasTagMarkup);
$parcel$export($30d7d246c5e7cd93$exports, "hasTagStyles", () => (parcelRequire("8jcQu")).hasTagStyles);
$parcel$export($30d7d246c5e7cd93$exports, "parseTaggedText", () => (parcelRequire("8jcQu")).parseTaggedText);
$parcel$export($30d7d246c5e7cd93$exports, "BREAKING_SPACES", () => (parcelRequire("gAfNu")).BREAKING_SPACES);
$parcel$export($30d7d246c5e7cd93$exports, "BREAKING_SPACES_SET", () => (parcelRequire("gAfNu")).BREAKING_SPACES_SET);
$parcel$export($30d7d246c5e7cd93$exports, "NEWLINES", () => (parcelRequire("gAfNu")).NEWLINES);
$parcel$export($30d7d246c5e7cd93$exports, "NEWLINES_SET", () => (parcelRequire("gAfNu")).NEWLINES_SET);
$parcel$export($30d7d246c5e7cd93$exports, "NEWLINE_MATCH_REGEX", () => (parcelRequire("gAfNu")).NEWLINE_MATCH_REGEX);
$parcel$export($30d7d246c5e7cd93$exports, "NEWLINE_SPLIT_REGEX", () => (parcelRequire("gAfNu")).NEWLINE_SPLIT_REGEX);
$parcel$export($30d7d246c5e7cd93$exports, "collapseNewlines", () => (parcelRequire("gAfNu")).collapseNewlines);
$parcel$export($30d7d246c5e7cd93$exports, "collapseSpaces", () => (parcelRequire("gAfNu")).collapseSpaces);
$parcel$export($30d7d246c5e7cd93$exports, "getCharacterGroups", () => (parcelRequire("gAfNu")).getCharacterGroups);
$parcel$export($30d7d246c5e7cd93$exports, "isBreakingSpace", () => (parcelRequire("gAfNu")).isBreakingSpace);
$parcel$export($30d7d246c5e7cd93$exports, "isNewline", () => (parcelRequire("gAfNu")).isNewline);
$parcel$export($30d7d246c5e7cd93$exports, "tokenize", () => (parcelRequire("gAfNu")).tokenize);
$parcel$export($30d7d246c5e7cd93$exports, "trimRight", () => (parcelRequire("gAfNu")).trimRight);
$parcel$export($30d7d246c5e7cd93$exports, "wordWrap", () => (parcelRequire("4R0nM")).wordWrap);
$parcel$export($30d7d246c5e7cd93$exports, "SdfShader", () => $85ac083d6329aa18$export$f19b070f8409d54d);
$parcel$export($30d7d246c5e7cd93$exports, "localUniformMSDFBit", () => $8e85dd50ed90c849$export$95191d1d81ffe694);
$parcel$export($30d7d246c5e7cd93$exports, "localUniformMSDFBitGl", () => $8e85dd50ed90c849$export$7542046ad25e8068);
$parcel$export($30d7d246c5e7cd93$exports, "mSDFBit", () => $1a81017f17414849$export$382a0eb192cd0a47);
$parcel$export($30d7d246c5e7cd93$exports, "mSDFBitGl", () => $1a81017f17414849$export$52c5bf2a8ebe1f2a);
$parcel$export($30d7d246c5e7cd93$exports, "AbstractTextSystem", () => $e75bb7ab0a8a8ef1$export$1f58c6bd1c266764);
$parcel$export($30d7d246c5e7cd93$exports, "CanvasTextSystem", () => $da83de7193beb062$export$56e4907c2e518abc);
$parcel$export($30d7d246c5e7cd93$exports, "Text", () => $f3e48f5b83971e92$export$5f1af8db9871e1d6);
$parcel$export($30d7d246c5e7cd93$exports, "TextStyle", () => (parcelRequire("bFX43")).TextStyle);
$parcel$export($30d7d246c5e7cd93$exports, "canvasTextSplit", () => $85f5f6adfc6fb403$export$12b1923ae80376f9);
$parcel$export($30d7d246c5e7cd93$exports, "generateTextStyleKey", () => $194697e15c8b47d8$export$8a3681e2b47964bb);
$parcel$export($30d7d246c5e7cd93$exports, "getPo2TextureFromSource", () => $fb2e0fd15e1bae74$export$80c61c6b7fb407a3);
$parcel$export($30d7d246c5e7cd93$exports, "updateTextBounds", () => $7df15e8bdde60348$export$cd6ce24a38c376aa);
$parcel$export($30d7d246c5e7cd93$exports, "ViewContainer", () => (parcelRequire("9FmI1")).ViewContainer);
$parcel$export($30d7d246c5e7cd93$exports, "Spritesheet", () => (parcelRequire("bbFev")).Spritesheet);
$parcel$export($30d7d246c5e7cd93$exports, "spritesheetAsset", () => (parcelRequire("7oygg")).spritesheetAsset);
$parcel$export($30d7d246c5e7cd93$exports, "UPDATE_PRIORITY", () => (parcelRequire("2HyEq")).UPDATE_PRIORITY);
$parcel$export($30d7d246c5e7cd93$exports, "Ticker", () => (parcelRequire("jM8Go")).Ticker);
$parcel$export($30d7d246c5e7cd93$exports, "TickerListener", () => (parcelRequire("92Lva")).TickerListener);
$parcel$export($30d7d246c5e7cd93$exports, "detectVideoAlphaMode", () => (parcelRequire("7X2qc")).detectVideoAlphaMode);
$parcel$export($30d7d246c5e7cd93$exports, "isMobile", () => (parcelRequire("c6cSg")).isMobile);
$parcel$export($30d7d246c5e7cd93$exports, "isSafari", () => (parcelRequire("llcp4")).isSafari);
$parcel$export($30d7d246c5e7cd93$exports, "isWebGLSupported", () => $61b81e90b77f0603$export$83dc396b76015322);
$parcel$export($30d7d246c5e7cd93$exports, "isWebGPUSupported", () => $bc01c1fc77b347f9$export$216169f30082c873);
$parcel$export($30d7d246c5e7cd93$exports, "unsafeEvalSupported", () => (parcelRequire("p4165")).unsafeEvalSupported);
$parcel$export($30d7d246c5e7cd93$exports, "getCanvasBoundingBox", () => $39709c41b8535a9b$export$550eedf6c679837d);
$parcel$export($30d7d246c5e7cd93$exports, "DATA_URI", () => (parcelRequire("7UNC6")).DATA_URI);
$parcel$export($30d7d246c5e7cd93$exports, "VERSION", () => (parcelRequire("7UNC6")).VERSION);
$parcel$export($30d7d246c5e7cd93$exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6AQ4q")))));
$parcel$export($30d7d246c5e7cd93$exports, "cleanArray", () => (parcelRequire("2H4Cq")).cleanArray);
$parcel$export($30d7d246c5e7cd93$exports, "cleanHash", () => (parcelRequire("2H4Cq")).cleanHash);
$parcel$export($30d7d246c5e7cd93$exports, "GCManagedHash", () => (parcelRequire("6tS7R")).GCManagedHash);
$parcel$export($30d7d246c5e7cd93$exports, "removeItems", () => (parcelRequire("02QFP")).removeItems);
$parcel$export($30d7d246c5e7cd93$exports, "resetUids", () => (parcelRequire("1bMtF")).resetUids);
$parcel$export($30d7d246c5e7cd93$exports, "uid", () => (parcelRequire("1bMtF")).uid);
$parcel$export($30d7d246c5e7cd93$exports, "updateQuadBounds", () => (parcelRequire("4ZJmt")).updateQuadBounds);
$parcel$export($30d7d246c5e7cd93$exports, "ViewableBuffer", () => (parcelRequire("4SZYy")).ViewableBuffer);
$parcel$export($30d7d246c5e7cd93$exports, "ApplicationInitHook", () => (parcelRequire("2xyZ0")).ApplicationInitHook);
$parcel$export($30d7d246c5e7cd93$exports, "RendererInitHook", () => (parcelRequire("2xyZ0")).RendererInitHook);
$parcel$export($30d7d246c5e7cd93$exports, "deprecation", () => (parcelRequire("6LhOA")).deprecation);
$parcel$export($30d7d246c5e7cd93$exports, "v8_0_0", () => (parcelRequire("6LhOA")).v8_0_0);
$parcel$export($30d7d246c5e7cd93$exports, "v8_3_4", () => (parcelRequire("6LhOA")).v8_3_4);
$parcel$export($30d7d246c5e7cd93$exports, "logDebugTexture", () => $304da01ea80e745d$export$3fe20a7807b0d5f6);
$parcel$export($30d7d246c5e7cd93$exports, "logRenderGroupScene", () => $991d162da29ea311$export$996a4ef50286b42b);
$parcel$export($30d7d246c5e7cd93$exports, "logScene", () => $991d162da29ea311$export$db44722c32b78b1e);
$parcel$export($30d7d246c5e7cd93$exports, "warn", () => (parcelRequire("1RpxL")).warn);
$parcel$export($30d7d246c5e7cd93$exports, "NOOP", () => (parcelRequire("cH88K")).NOOP);
$parcel$export($30d7d246c5e7cd93$exports, "Transform", () => $e1fb66846f7a0916$export$563a914cafbdc389);
$parcel$export($30d7d246c5e7cd93$exports, "getResolutionOfUrl", () => $9325343e1cf12602$export$8695ab2f322d2637);
$parcel$export($30d7d246c5e7cd93$exports, "path", () => (parcelRequire("208Yz")).path);
$parcel$export($30d7d246c5e7cd93$exports, "GlobalResourceRegistry", () => (parcelRequire("fpmqC")).GlobalResourceRegistry);
$parcel$export($30d7d246c5e7cd93$exports, "Pool", () => (parcelRequire("jsdyy")).Pool);
$parcel$export($30d7d246c5e7cd93$exports, "BigPool", () => (parcelRequire("dokhj")).BigPool);
$parcel$export($30d7d246c5e7cd93$exports, "PoolGroupClass", () => (parcelRequire("dokhj")).PoolGroupClass);
$parcel$export($30d7d246c5e7cd93$exports, "sayHello", () => (parcelRequire("kbFTd")).sayHello);
$parcel$export($30d7d246c5e7cd93$exports, "earcut", () => (parcelRequire("eyVYu")).earcut);
$parcel$export($30d7d246c5e7cd93$exports, "browserExt", () => $eba5d1440b0da934$export$a6aad6334ef58a1c);
$parcel$export($30d7d246c5e7cd93$exports, "extensions", () => (parcelRequire("aZ9ZN")).extensions);
$parcel$export($30d7d246c5e7cd93$exports, "webworkerExt", () => $91e6560b74ff6b18$export$ee43dd1acddf6cf8);

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";

const $eba5d1440b0da934$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("2ruNw"));
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";

const $91e6560b74ff6b18$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("d9Psw"));
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");
parcelRequire("ib6XS");
parcelRequire("kDNfq");






















var $gpiLJ = parcelRequire("gpiLJ");

var $2ibqd = parcelRequire("2ibqd");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $4iNSL = parcelRequire("4iNSL");

var $lWXRl = parcelRequire("lWXRl");
var $56628c8f18c4feab$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nin vec4 vColor;\n\nout vec4 finalColor;\n\nuniform float uBlend;\n\nuniform sampler2D uTexture;\nuniform sampler2D uBackTexture;\n\n{FUNCTIONS}\n\nvoid main()\n{ \n    vec4 back = texture(uBackTexture, vTextureCoord);\n    vec4 front = texture(uTexture, vTextureCoord);\n    float blendedAlpha = front.a + back.a * (1.0 - front.a);\n    \n    {MAIN}\n}\n";


var $c4e1726121ebd0f9$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\nout vec2 backgroundUv;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


var $d9c83817d08f41f4$export$2e2bcd8739ae039 = "\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct BlendUniforms {\n  uBlend:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n@group(0) @binding(3) var uBackTexture: texture_2d<f32>;\n\n@group(1) @binding(0) var<uniform> blendUniforms : BlendUniforms;\n\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}\n\n{FUNCTIONS}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>\n) -> @location(0) vec4<f32> {\n\n\n   var back =  textureSample(uBackTexture, uSampler, uv);\n   var front = textureSample(uTexture, uSampler, uv);\n   var blendedAlpha = front.a + back.a * (1.0 - front.a);\n   \n   var out = vec4<f32>(0.0,0.0,0.0,0.0);\n\n   {MAIN}\n\n   return out;\n}";


"use strict";
class $1d60510dca4ba264$export$45a84b7faa1bbfad extends (0, $lWXRl.Filter) {
    constructor(options){
        const gpuOptions = options.gpu;
        const gpuSource = $1d60510dca4ba264$var$compileBlendModeShader({
            source: (0, $d9c83817d08f41f4$export$2e2bcd8739ae039),
            ...gpuOptions
        });
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: gpuSource,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: gpuSource,
                entryPoint: "mainFragment"
            }
        });
        const glOptions = options.gl;
        const glSource = $1d60510dca4ba264$var$compileBlendModeShader({
            source: (0, $56628c8f18c4feab$export$2e2bcd8739ae039),
            ...glOptions
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: (0, $c4e1726121ebd0f9$export$2e2bcd8739ae039),
            fragment: glSource
        });
        const uniformGroup = new (0, $aUxJK.UniformGroup)({
            uBlend: {
                value: 1,
                type: "f32"
            }
        });
        super({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            blendRequired: true,
            resources: {
                blendUniforms: uniformGroup,
                uBackTexture: (0, $4iNSL.Texture).EMPTY
            }
        });
    }
}
function $1d60510dca4ba264$var$compileBlendModeShader(options) {
    const { source: source, functions: functions, main: main } = options;
    return source.replace("{FUNCTIONS}", functions).replace("{MAIN}", main);
}


"use strict";
const $eeb80ce5e84eb3ea$export$8f2fe8e50ec495a4 = `
	float getLuminosity(vec3 c) {
		return 0.3 * c.r + 0.59 * c.g + 0.11 * c.b;
	}

	vec3 setLuminosity(vec3 c, float lum) {
		float modLum = lum - getLuminosity(c);
		vec3 color = c.rgb + vec3(modLum);

		// clip back into legal range
		modLum = getLuminosity(color);
		vec3 modLumVec = vec3(modLum);

		float cMin = min(color.r, min(color.g, color.b));
		float cMax = max(color.r, max(color.g, color.b));

		if(cMin < 0.0) {
			color = mix(modLumVec, color, modLum / (modLum - cMin));
		}

		if(cMax > 1.0) {
			color = mix(modLumVec, color, (1.0 - modLum) / (cMax - modLum));
		}

		return color;
	}

	float getSaturation(vec3 c) {
		return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));
	}

	vec3 setSaturationMinMidMax(vec3 cSorted, float s) {
		vec3 colorSorted = cSorted;

		if(colorSorted.z > colorSorted.x) {
			colorSorted.y = (((colorSorted.y - colorSorted.x) * s) / (colorSorted.z - colorSorted.x));
			colorSorted.z = s;
		}
		else {
			colorSorted.y = 0.0;
			colorSorted.z = 0.0;
		}

		colorSorted.x = 0.0;

		return colorSorted;
	}

	vec3 setSaturation(vec3 c, float s) {
		vec3 color = c;

		if(color.r <= color.g && color.r <= color.b) {
			if(color.g <= color.b) {
				color = setSaturationMinMidMax(color.rgb, s).rgb;
			}
			else {
				color = setSaturationMinMidMax(color.rbg, s).rbg;
			}
		}
		else if(color.g <= color.r && color.g <= color.b) {
			if(color.r <= color.b) {
				color = setSaturationMinMidMax(color.grb, s).grb;
			}
			else {
				color = setSaturationMinMidMax(color.gbr, s).gbr;
			}
		}
		else {
			// Using bgr for both fixes part of hue
			if(color.r <= color.g) {
				color = setSaturationMinMidMax(color.brg, s).brg;
			}
			else {
				color = setSaturationMinMidMax(color.bgr, s).bgr;
			}
		}

		return color;
	}
    `;


"use strict";
const $39f7e2b517ebb999$export$ba4975f4e0685bad = `
	fn getLuminosity(c: vec3<f32>) -> f32
	{
		return 0.3*c.r + 0.59*c.g + 0.11*c.b;
	}

	fn setLuminosity(c: vec3<f32>, lum: f32) -> vec3<f32>
	{
		var modLum: f32 = lum - getLuminosity(c);
		var color: vec3<f32> = c.rgb + modLum;

		// clip back into legal range
		modLum = getLuminosity(color);
		let modLumVec = vec3<f32>(modLum);

		let cMin: f32 = min(color.r, min(color.g, color.b));
		let cMax: f32 = max(color.r, max(color.g, color.b));

		if(cMin < 0.0)
		{
			color = mix(modLumVec, color, modLum / (modLum - cMin));
		}

		if(cMax > 1.0)
		{
			color = mix(modLumVec, color, (1 - modLum) / (cMax - modLum));
		}

		return color;
	}

	fn getSaturation(c: vec3<f32>) -> f32
	{
		return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));
	}

	fn setSaturationMinMidMax(cSorted: vec3<f32>, s: f32) -> vec3<f32>
	{
		var colorSorted = cSorted;

		if(colorSorted.z > colorSorted.x)
		{
			colorSorted.y = (((colorSorted.y - colorSorted.x) * s) / (colorSorted.z - colorSorted.x));
			colorSorted.z = s;
		}
		else
		{
			colorSorted.y = 0;
			colorSorted.z = 0;
		}

		colorSorted.x = 0;

		return colorSorted;
	}

	fn setSaturation(c: vec3<f32>, s: f32) -> vec3<f32>
	{
		var color = c;

		if (color.r <= color.g && color.r <= color.b)
		{
			if (color.g <= color.b)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.rgb, s)).rgb;
			}
			else
			{
				color = vec3<f32>(setSaturationMinMidMax(color.rbg, s)).rbg;
			}
		}
		else if (color.g <= color.r && color.g <= color.b)
		{
			if (color.r <= color.b)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.grb, s)).grb;
			}
			else
			{
				color = vec3<f32>(setSaturationMinMidMax(color.gbr, s)).gbr;
			}
		}
		else
		{
			// Using bgr for both fixes part of hue
			if (color.r <= color.g)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.brg, s)).brg;
			}
			else
			{
				color  = vec3<f32>(setSaturationMinMidMax(color.bgr, s)).bgr;
			}
		}

		return color;
	}
	`;


"use strict";
class $816918268500e9d0$export$49c26a8a00b47001 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                ${(0, $eeb80ce5e84eb3ea$export$8f2fe8e50ec495a4)}

                vec3 blendColor(vec3 base, vec3 blend,  float opacity)
                {
                    return (setLuminosity(blend, getLuminosity(base)) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendColor(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                ${(0, $39f7e2b517ebb999$export$ba4975f4e0685bad)}

                fn blendColorOpacity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (setLuminosity(blend, getLuminosity(base)) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendColorOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $816918268500e9d0$export$49c26a8a00b47001.extension = {
    name: "color",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $90e4bb198698b2e8$export$f87c9ea9a6bd644d extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float colorBurn(float base, float blend)
                {
                    return max((1.0 - ((1.0 - base) / blend)), 0.0);
                }

                vec3 blendColorBurn(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        colorBurn(base.r, blend.r),
                        colorBurn(base.g, blend.g),
                        colorBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendColorBurn(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                fn colorBurn(base:f32, blend:f32) -> f32
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                fn blendColorBurn(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        colorBurn(base.r, blend.r),
                        colorBurn(base.g, blend.g),
                        colorBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendColorBurn(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $90e4bb198698b2e8$export$f87c9ea9a6bd644d.extension = {
    name: "color-burn",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $1af95aa9b908da2b$export$b605c157b8288ca9 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float colorDodge(float base, float blend)
                {
                    return base / (1.0 - blend);
                }

                vec3 blendColorDodge(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        colorDodge(base.r, blend.r),
                        colorDodge(base.g, blend.g),
                        colorDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendColorDodge(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn colorDodge(base: f32, blend: f32) -> f32
                {
                    return base / (1.0 - blend);
                }

                fn blendColorDodge(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        colorDodge(base.r, blend.r),
                        colorDodge(base.g, blend.g),
                        colorDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                    out = vec4<f32>(blendColorDodge(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $1af95aa9b908da2b$export$b605c157b8288ca9.extension = {
    name: "color-dodge",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $acdfeed811f24d96$export$b302ffff58558dd3 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                vec3 blendDarken(vec3 base, vec3 blend, float opacity)
                {
                    return (min(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendDarken(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn blendDarken(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (min(blend,base) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendDarken(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $acdfeed811f24d96$export$b302ffff58558dd3.extension = {
    name: "darken",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $d20df28c80e8871a$export$8f916080f74b48a1 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                vec3 blendDifference(vec3 base, vec3 blend,  float opacity)
                {
                    return (abs(blend - base) * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendDifference(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                fn blendDifference(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (abs(blend - base) * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendDifference(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $d20df28c80e8871a$export$8f916080f74b48a1.extension = {
    name: "difference",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $192d4c3ae64f40ca$export$c7d2adb912a7c5cf extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float divide(float base, float blend)
                {
                    return (blend > 0.0) ? clamp(base / blend, 0.0, 1.0) : 1.0;
                }

                vec3 blendDivide(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        divide(base.r, blend.r),
                        divide(base.g, blend.g),
                        divide(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendDivide(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn divide(base: f32, blend: f32) -> f32
                {
                    return select(1.0, clamp(base / blend, 0.0, 1.0), blend > 0.0);
                }

                fn blendDivide(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        divide(base.r, blend.r),
                        divide(base.g, blend.g),
                        divide(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendDivide(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $192d4c3ae64f40ca$export$c7d2adb912a7c5cf.extension = {
    name: "divide",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $0827e74b8293f309$export$48a32c81b020da81 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                vec3 exclusion(vec3 base, vec3 blend)
                {
                    return base + blend - 2.0 * base * blend;
                }

                vec3 blendExclusion(vec3 base, vec3 blend, float opacity)
                {
                    return (exclusion(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendExclusion(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn exclusion(base: vec3<f32>, blend: vec3<f32>) -> vec3<f32>
                {
                    return base+blend-2.0*base*blend;
                }

                fn blendExclusion(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    return (exclusion(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendExclusion(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $0827e74b8293f309$export$48a32c81b020da81.extension = {
    name: "exclusion",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $e737b7f7bb358c78$export$deee7bfa3f7add03 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float hardLight(float base, float blend)
                {
                    return (blend < 0.5) ? 2.0 * base * blend : 1.0 - 2.0 * (1.0 - base) * (1.0 - blend);
                }

                vec3 blendHardLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        hardLight(base.r, blend.r),
                        hardLight(base.g, blend.g),
                        hardLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendHardLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                fn hardLight(base: f32, blend: f32) -> f32
                {
                    return select(1.0 - 2.0 * (1.0 - base) * (1.0 - blend), 2.0 * base * blend, blend < 0.5);
                }

                fn blendHardLight(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        hardLight(base.r, blend.r),
                        hardLight(base.g, blend.g),
                        hardLight(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendHardLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $e737b7f7bb358c78$export$deee7bfa3f7add03.extension = {
    name: "hard-light",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $478e85dab1990f9b$export$a68bc3d7fee45c17 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float hardMix(float base, float blend)
                {
                    return (base + blend >= 1.0) ? 1.0 : 0.0;
                }

                vec3 blendHardMix(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blended = vec3(
                        hardMix(base.r, blend.r),
                        hardMix(base.g, blend.g),
                        hardMix(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendHardMix(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                fn hardMix(base: f32, blend: f32) -> f32
                {
                    return select(0.0, 1.0, base + blend >= 1.0);
                }

                fn blendHardMix(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        hardMix(base.r, blend.r),
                        hardMix(base.g, blend.g),
                        hardMix(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendHardMix(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $478e85dab1990f9b$export$a68bc3d7fee45c17.extension = {
    name: "hard-mix",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $c587432b4fa227ad$export$3a7888367c013d84 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                vec3 blendLighten(vec3 base, vec3 blend, float opacity)
                {
                    return (max(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendLighten(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn blendLighten(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (max(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendLighten(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $c587432b4fa227ad$export$3a7888367c013d84.extension = {
    name: "lighten",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $16266803e35a0220$export$aba7fe3f2b545692 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float linearBurn(float base, float blend)
                {
                    return max(0.0, base + blend - 1.0);
                }

                vec3 blendLinearBurn(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        linearBurn(base.r, blend.r),
                        linearBurn(base.g, blend.g),
                        linearBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendLinearBurn(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn linearBurn(base: f32, blend: f32) -> f32
                {
                    return max(0.0, base + blend - 1.0);
                }

                fn blendLinearBurn(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearBurn(base.r, blend.r),
                        linearBurn(base.g, blend.g),
                        linearBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendLinearBurn(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $16266803e35a0220$export$aba7fe3f2b545692.extension = {
    name: "linear-burn",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $e880cfa70bb3466f$export$9b6f3185f95ef996 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float linearDodge(float base, float blend) {
                    return min(1.0, base + blend);
                }

                vec3 blendLinearDodge(vec3 base, vec3 blend, float opacity) {
                    vec3 blended = vec3(
                        linearDodge(base.r, blend.r),
                        linearDodge(base.g, blend.g),
                        linearDodge(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendLinearDodge(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn linearDodge(base: f32, blend: f32) -> f32
                {
                    return min(1, base + blend);
                }

                fn blendLinearDodge(base:vec3<f32>, blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearDodge(base.r, blend.r),
                        linearDodge(base.g, blend.g),
                        linearDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendLinearDodge(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $e880cfa70bb3466f$export$9b6f3185f95ef996.extension = {
    name: "linear-dodge",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $4f42df1a04121c46$export$1aba5746b48d52f9 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float linearBurn(float base, float blend) {
                    return max(0.0, base + blend - 1.0);
                }

                float linearDodge(float base, float blend) {
                    return min(1.0, base + blend);
                }

                float linearLight(float base, float blend) {
                    return (blend <= 0.5) ? linearBurn(base,2.0*blend) : linearBurn(base,2.0*(blend-0.5));
                }

                vec3 blendLinearLight(vec3 base, vec3 blend, float opacity) {
                    vec3 blended = vec3(
                        linearLight(base.r, blend.r),
                        linearLight(base.g, blend.g),
                        linearLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendLinearLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn linearBurn(base: f32, blend: f32) -> f32
                {
                    return max(0.0, base + blend - 1.0);
                }

                fn linearDodge(base: f32, blend: f32) -> f32
                {
                    return min(1.0, base + blend);
                }

                fn linearLight(base: f32, blend: f32) -> f32
                {
                    return select(linearBurn(base,2.0*(blend-0.5)), linearBurn(base,2.0*blend), blend <= 0.5);
                }

                fn blendLinearLightOpacity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearLight(base.r, blend.r),
                        linearLight(base.g, blend.g),
                        linearLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendLinearLightOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $4f42df1a04121c46$export$1aba5746b48d52f9.extension = {
    name: "linear-light",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");



"use strict";
class $08f2512fad92af25$export$d9933ad71d16767e extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                ${(0, $eeb80ce5e84eb3ea$export$8f2fe8e50ec495a4)}

                vec3 blendLuminosity(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blendLuminosity = setLuminosity(base, getLuminosity(blend));
                    return (blendLuminosity * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendLuminosity(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                ${(0, $39f7e2b517ebb999$export$ba4975f4e0685bad)}

                fn blendLuminosity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blendLuminosity: vec3<f32> = setLuminosity(base, getLuminosity(blend));
                    return (blendLuminosity * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendLuminosity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $08f2512fad92af25$export$d9933ad71d16767e.extension = {
    name: "luminosity",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $9db4b4958f0a9c9a$export$75fc806a9eca252d extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                vec3 negation(vec3 base, vec3 blend)
                {
                    return 1.0-abs(1.0-base-blend);
                }

                vec3 blendNegation(vec3 base, vec3 blend, float opacity)
                {
                    return (negation(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendNegation(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn blendNegation(base: vec3<f32>, blend: vec3<f32>) -> vec3<f32>
                {
                    return 1.0-abs(1.0-base-blend);
                }

                fn blendNegationOpacity(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    return (blendNegation(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendNegationOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $9db4b4958f0a9c9a$export$75fc806a9eca252d.extension = {
    name: "negation",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $7ee63075806ba048$export$c318b05471430745 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float overlay(float base, float blend)
                {
                    return (base < 0.5) ? (2.0*base*blend) : (1.0-2.0*(1.0-base)*(1.0-blend));
                }

                vec3 blendOverlay(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        overlay(base.r, blend.r),
                        overlay(base.g, blend.g),
                        overlay(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendOverlay(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn overlay(base: f32, blend: f32) -> f32
                {
                    return select((1.0-2.0*(1.0-base)*(1.0-blend)), (2.0*base*blend), base < 0.5);
                }

                fn blendOverlay(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        overlay(base.r, blend.r),
                        overlay(base.g, blend.g),
                        overlay(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendOverlay(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $7ee63075806ba048$export$c318b05471430745.extension = {
    name: "overlay",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $a275f9f9dc1245ed$export$3e2f910ab14d190b extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float pinLight(float base, float blend)
                {
                    return (blend <= 0.5) ? min(base, 2.0 * blend) : max(base, 2.0 * (blend - 0.5));
                }

                vec3 blendPinLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        pinLight(base.r, blend.r),
                        pinLight(base.g, blend.g),
                        pinLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendPinLight(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn pinLight(base: f32, blend: f32) -> f32
                {
                    return select(max(base,2.0*(blend-0.5)), min(base,2.0*blend), blend <= 0.5);
                }

                fn blendPinLight(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        pinLight(base.r, blend.r),
                        pinLight(base.g, blend.g),
                        pinLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendPinLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $a275f9f9dc1245ed$export$3e2f910ab14d190b.extension = {
    name: "pin-light",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");



"use strict";
class $81579094a71b1ff6$export$62883fb5bda5d60a extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                ${(0, $eeb80ce5e84eb3ea$export$8f2fe8e50ec495a4)}

                vec3 blendSaturation(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blendSaturation = setLuminosity(setSaturation(base, getSaturation(blend)), getLuminosity(base));
                    return (blendSaturation * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendSaturation(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                ${(0, $39f7e2b517ebb999$export$ba4975f4e0685bad)}

                fn blendSaturation(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blendSaturation = setLuminosity(setSaturation(base, getSaturation(blend)), getLuminosity(base));
                    return (blendSaturation * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                out = vec4<f32>(blendSaturation(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
            }
        });
    }
}
/** @ignore */ $81579094a71b1ff6$export$62883fb5bda5d60a.extension = {
    name: "saturation",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $d3fad48146de4efa$export$db64d53ebdd21cf0 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float softLight(float base, float blend)
                {
                    return (blend < 0.5) ? (2.0 * base * blend + base * base * (1.0 - 2.0 * blend)) : (sqrt(base) * (2.0 * blend - 1.0) + 2.0 * base * (1.0 - blend));
                }

                vec3 blendSoftLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        softLight(base.r, blend.r),
                        softLight(base.g, blend.g),
                        softLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendSoftLight(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn softLight(base: f32, blend: f32) -> f32
                {
                    return select(2.0 * base * blend + base * base * (1.0 - 2.0 * blend), sqrt(base) * (2.0 * blend - 1.0) + 2.0 * base * (1.0 - blend), blend < 0.5);
                }

                fn blendSoftLight(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        softLight(base.r, blend.r),
                        softLight(base.g, blend.g),
                        softLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendSoftLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $d3fad48146de4efa$export$db64d53ebdd21cf0.extension = {
    name: "soft-light",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $903c88123932eb20$export$e15549b41fdb45a2 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float subtract(float base, float blend)
                {
                    return max(0.0, base - blend);
                }

                vec3 blendSubtract(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        subtract(base.r, blend.r),
                        subtract(base.g, blend.g),
                        subtract(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                finalColor = vec4(blendSubtract(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
            },
            gpu: {
                functions: `
                fn subtract(base: f32, blend: f32) -> f32
                {
                    return max(0, base - blend);
                }

                fn blendSubtract(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        subtract(base.r, blend.r),
                        subtract(base.g, blend.g),
                        subtract(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendSubtract(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $903c88123932eb20$export$e15549b41fdb45a2.extension = {
    name: "subtract",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $ca6cf0806514c5c0$export$5860dee37348cea9 extends (0, $1d60510dca4ba264$export$45a84b7faa1bbfad) {
    constructor(){
        super({
            gl: {
                functions: `
                float colorBurn(float base, float blend)
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                float colorDodge(float base, float blend)
                {
                    return min(1.0, base / (1.0-blend));
                }

                float vividLight(float base, float blend)
                {
                    return (blend < 0.5) ? colorBurn(base,(2.0*blend)) : colorDodge(base,(2.0*(blend-0.5)));
                }

                vec3 blendVividLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        vividLight(base.r, blend.r),
                        vividLight(base.g, blend.g),
                        vividLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
                main: `
                finalColor = vec4(blendVividLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
            },
            gpu: {
                functions: `
                fn colorBurn(base:f32, blend:f32) -> f32
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                fn colorDodge(base: f32, blend: f32) -> f32
                {
                    return min(1.0, base / (1.0-blend));
                }

                fn vividLight(base: f32, blend: f32) -> f32
                {
                    return select(colorDodge(base,(2.0*(blend-0.5))), colorBurn(base,(2.0*blend)), blend<0.5);
                }

                fn blendVividLight(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        vividLight(base.r, blend.r),
                        vividLight(base.g, blend.g),
                        vividLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
                main: `
                out = vec4<f32>(blendVividLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
            }
        });
    }
}
/** @ignore */ $ca6cf0806514c5c0$export$5860dee37348cea9.extension = {
    name: "vivid-light",
    type: (0, $aZ9ZN.ExtensionType).BlendMode
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $gLw46 = parcelRequire("gLw46");

var $7velr = parcelRequire("7velr");
"use strict";
let $61b81e90b77f0603$var$_isWebGLSupported;
function $61b81e90b77f0603$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($61b81e90b77f0603$var$_isWebGLSupported !== void 0) return $61b81e90b77f0603$var$_isWebGLSupported;
    $61b81e90b77f0603$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $7velr.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $gLw46.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $gLw46.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $61b81e90b77f0603$var$_isWebGLSupported;
}



var $gLw46 = parcelRequire("gLw46");
"use strict";
let $bc01c1fc77b347f9$var$_isWebGPUSupported;
async function $bc01c1fc77b347f9$export$216169f30082c873(options = {}) {
    if ($bc01c1fc77b347f9$var$_isWebGPUSupported !== void 0) return $bc01c1fc77b347f9$var$_isWebGPUSupported;
    $bc01c1fc77b347f9$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $gLw46.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $bc01c1fc77b347f9$var$_isWebGPUSupported;
}



var $7velr = parcelRequire("7velr");
"use strict";
const $1c523be2a547c961$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];



async function $1c523be2a547c961$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $1c523be2a547c961$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $1c523be2a547c961$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $bc01c1fc77b347f9$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await Promise.resolve((parcelRequire("bCbWs")));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $61b81e90b77f0603$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $7velr.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await Promise.resolve((parcelRequire("5aJ4P")));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            const { CanvasRenderer: CanvasRenderer } = await Promise.resolve((parcelRequire("lFL21")));
            RendererClass = CanvasRenderer;
            finalOptions = {
                ...options,
                ...options.canvasOptions
            };
            break;
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    delete finalOptions.canvasOptions;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $2vcTO = parcelRequire("2vcTO");

var $2xyZ0 = parcelRequire("2xyZ0");

var $6LhOA = parcelRequire("6LhOA");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
class $c7c8a973586e3a0e$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", {
            configurable: true,
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    globalThis.addEventListener("resize", this.queueResize);
                    this.resize();
                }
            },
            get () {
                return this._resizeTo;
            }
        });
        this.queueResize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            this._resizeId = requestAnimationFrame(()=>this.resize());
        };
        this._cancelResize = ()=>{
            if (this._resizeId) {
                cancelAnimationFrame(this._resizeId);
                this._resizeId = null;
            }
        };
        this.resize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            let width;
            let height;
            if (this._resizeTo === globalThis.window) {
                width = globalThis.innerWidth;
                height = globalThis.innerHeight;
            } else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth;
                height = clientHeight;
            }
            this.renderer.resize(width, height);
            this.render();
        };
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize);
        this._cancelResize();
        this._cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    }
}
/** @ignore */ $c7c8a973586e3a0e$export$6453cd852defe94a.extension = (0, $aZ9ZN.ExtensionType).Application;



var $aZ9ZN = parcelRequire("aZ9ZN");

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");
"use strict";
class $8bf065aef63e1225$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        Object.defineProperty(this, "ticker", {
            configurable: true,
            set (ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, (0, $2HyEq.UPDATE_PRIORITY).LOW);
            },
            get () {
                return this._ticker;
            }
        });
        this.stop = ()=>{
            this._ticker.stop();
        };
        this.start = ()=>{
            this._ticker.start();
        };
        this._ticker = null;
        this.ticker = options.sharedTicker ? (0, $jM8Go.Ticker).shared : new (0, $jM8Go.Ticker)();
        if (options.autoStart) this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    }
}
/** @ignore */ $8bf065aef63e1225$export$50c361ceb4e2f4f0.extension = (0, $aZ9ZN.ExtensionType).Application;


"use strict";
(0, $aZ9ZN.extensions).add((0, $c7c8a973586e3a0e$export$6453cd852defe94a));
(0, $aZ9ZN.extensions).add((0, $8bf065aef63e1225$export$50c361ceb4e2f4f0));


"use strict";
const $4626b74171df28b3$var$_Application = class _Application {
    constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $2vcTO.Container)();
        if (args[0] !== void 0) (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.stage || (this.stage = new (0, $2vcTO.Container)());
        this.renderer = await (0, $1c523be2a547c961$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $4626b74171df28b3$var$_Application._plugins = [];
let $4626b74171df28b3$export$16975c34e60e1e61 = $4626b74171df28b3$var$_Application;
(0, $aZ9ZN.extensions).handleByList((0, $aZ9ZN.ExtensionType).Application, $4626b74171df28b3$export$16975c34e60e1e61._plugins);
(0, $aZ9ZN.extensions).add((0, $2xyZ0.ApplicationInitHook));





var $aZ9ZN = parcelRequire("aZ9ZN");

var $8nmJS = parcelRequire("8nmJS");

var $h8sEz = parcelRequire("h8sEz");

var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $208Yz = parcelRequire("208Yz");
"use strict";
const $3aae6b476bc8fa85$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};



var $gLw46 = parcelRequire("gLw46");
"use strict";
const $a6cdb2f3a10e5da2$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};


"use strict";
const $b4a97e4df8c1119e$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.match(/<font(\s|>)/)) return (0, $a6cdb2f3a10e5da2$export$7a7adbcafc5cf8e3).test((0, $gLw46.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $a6cdb2f3a10e5da2$export$7a7adbcafc5cf8e3).parse((0, $gLw46.DOMAdapter).get().parseXML(data));
    }
};


"use strict";
const $f6b7037dbc64186a$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $f6b7037dbc64186a$export$778a313228f06f6c = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>!!asset?.pages && !!asset?.chars && typeof asset?.fontFamily === "string",
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};

const $f6b7037dbc64186a$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).Normal
    },
    /** used for deprecation purposes */ name: "loadBitmapFont",
    id: "bitmap-font",
    test (url) {
        return $f6b7037dbc64186a$var$validExtensions.includes((0, $208Yz.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $3aae6b476bc8fa85$export$4c1815a0944ccac0).test(data) || (0, $b4a97e4df8c1119e$export$bfc0a19e2e2cc16).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $3aae6b476bc8fa85$export$4c1815a0944ccac0).test(asset) ? (0, $3aae6b476bc8fa85$export$4c1815a0944ccac0).parse(asset) : (0, $b4a97e4df8c1119e$export$bfc0a19e2e2cc16).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $208Yz.path).join((0, $208Yz.path).dirname(src), pageFile);
            imagePath = (0, $h8sEz.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const [loadedTextures, { BitmapFont: BitmapFont }] = await Promise.all([
            loader.load(textureUrls),
            Promise.resolve((parcelRequire("2LjMw")))
        ]);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new BitmapFont({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};



var $1RpxL = parcelRequire("1RpxL");
"use strict";
class $6d818aba51088bb4$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}



var $h3cT0 = parcelRequire("h3cT0");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $ee99ec759734d21a$export$407b4625a915919d = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $4iNSL.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
async function $f9a551de8879104d$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (_e) {
            return false;
        }
        return true;
    }
    return false;
}


"use strict";
const $a731aeae60a36915$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $f9a551de8879104d$export$7c459e568e7cea2c)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};



var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $7ae4808924cd4c1a$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $7ae4808924cd4c1a$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$7ae4808924cd4c1a$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$7ae4808924cd4c1a$var$imageFormats.includes(f))
};



var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $1bfab03a55c6b4c2$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $1bfab03a55c6b4c2$export$7a571c147b03abb1(mimeType) {
    if ($1bfab03a55c6b4c2$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}


"use strict";
const $7748aa8b5cfd2b6b$export$7726d83fee274e25 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $1bfab03a55c6b4c2$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
const $32601ac990b07974$export$5a1da481121f806a = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $1bfab03a55c6b4c2$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
const $203ca28464480688$export$a041d698a1896657 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $1bfab03a55c6b4c2$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
const $b1f07772206d4732$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $f9a551de8879104d$export$7c459e568e7cea2c)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};



var $1RpxL = parcelRequire("1RpxL");

var $208Yz = parcelRequire("208Yz");

var $bkziv = parcelRequire("bkziv");

var $4Kkng = parcelRequire("4Kkng");
"use strict";
const $a780a988a4a41ac9$var$_Loader = class _Loader {
    constructor(){
        /**
     * Options for loading assets with the loader.
     * These options will be used as defaults for all load calls made with this loader instance.
     * They can be overridden by passing options directly to the load method.
     * @example
     * ```ts
     * // Create a loader with custom default options
     * const loader = new Loader();
     * loader.loadOptions = {
     *   strategy: 'skip', // Default strategy to 'skip'
     *   retryCount: 5,   // Default retry count to 5
     *   retryDelay: 500, // Default retry delay to 500ms
     * };
     *
     * // This load call will use the loader's default options
     * await loader.load('image1.png');
     */ this.loadOptions = {
            ..._Loader.defaultOptions
        };
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.parser || data.loadParser) {
                parser = this._parserHash[data.parser || data.loadParser];
                if (data.loadParser) (0, $1RpxL.warn)(`[Assets] "loadParser" is deprecated, use "parser" instead for ${url}`);
                if (!parser) (0, $1RpxL.warn)(`[Assets] specified load parser "${data.parser || data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $1RpxL.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgressOrOptions) {
        if (!this._parsersValidated) this._validateParsers();
        const options = typeof onProgressOrOptions === "function" ? {
            ..._Loader.defaultOptions,
            ...this.loadOptions,
            onProgress: onProgressOrOptions
        } : {
            ..._Loader.defaultOptions,
            ...this.loadOptions,
            ...onProgressOrOptions || {}
        };
        const { onProgress: onProgress, onError: onError, strategy: strategy, retryCount: retryCount, retryDelay: retryDelay } = options;
        let count = 0;
        const assets = {};
        const singleAsset = (0, $4Kkng.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $bkziv.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.reduce((sum, asset)=>sum + (asset.progressSize || 1), 0);
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $208Yz.path).toAbsolute(asset.src);
            if (assets[asset.src]) return;
            await this._loadAssetWithRetry(url, asset, {
                onProgress: onProgress,
                onError: onError,
                strategy: strategy,
                retryCount: retryCount,
                retryDelay: retryDelay
            }, assets);
            count += asset.progressSize || 1;
            if (onProgress) onProgress(count / total);
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $bkziv.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $208Yz.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name || parser.id).reduce((hash, parser)=>{
            if (!parser.name && !parser.id) (0, $1RpxL.warn)(`[Assets] parser should have an id`);
            else if (hash[parser.name] || hash[parser.id]) (0, $1RpxL.warn)(`[Assets] parser id conflict "${parser.id}"`);
            hash[parser.name] = parser;
            if (parser.id) hash[parser.id] = parser;
            return hash;
        }, {});
    }
    async _loadAssetWithRetry(url, asset, options, assets) {
        let attempt = 0;
        const { onError: onError, strategy: strategy, retryCount: retryCount, retryDelay: retryDelay } = options;
        const wait = (ms)=>new Promise((r)=>setTimeout(r, ms));
        while(true)try {
            if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
            assets[asset.src] = await this.promiseCache[url].promise;
            return;
        } catch (e) {
            delete this.promiseCache[url];
            delete assets[asset.src];
            attempt++;
            const isLast = strategy !== "retry" || attempt > retryCount;
            if (strategy === "retry" && !isLast) {
                if (onError) onError(e, asset);
                await wait(retryDelay);
                continue;
            }
            if (strategy === "skip") {
                if (onError) onError(e, asset);
                return;
            }
            if (onError) onError(e, asset);
            const error = new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            if (e instanceof Error && e.stack) error.stack = e.stack;
            throw error;
        }
    }
};
/**
 * Default options for loading assets
 * @example
 * ```ts
 * // Change default load options globally
 * Loader.defaultOptions = {
 *   strategy: 'skip', // Change default strategy to 'skip'
 *   retryCount: 5,   // Change default retry count to 5
 *   retryDelay: 500, // Change default retry delay to 500ms
 * };
 * ```
 */ $a780a988a4a41ac9$var$_Loader.defaultOptions = {
    onProgress: void 0,
    onError: void 0,
    strategy: "throw",
    retryCount: 3,
    retryDelay: 250
};
let $a780a988a4a41ac9$export$3b0d6d7590275603 = $a780a988a4a41ac9$var$_Loader;



var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
function $6e8add647376da4b$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}



var $208Yz = parcelRequire("208Yz");
"use strict";
function $1e9f9ec9061a32ce$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $208Yz.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}



var $8nmJS = parcelRequire("8nmJS");
"use strict";
const $b1848d8e49e2cd02$var$validJSONExtension = ".json";
const $b1848d8e49e2cd02$var$validJSONMIME = "application/json";
const $b1848d8e49e2cd02$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadJson",
    id: "json",
    test (url) {
        return (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $b1848d8e49e2cd02$var$validJSONMIME) || (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $b1848d8e49e2cd02$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};



var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");



var $8nmJS = parcelRequire("8nmJS");
"use strict";
const $db58d3b1af59b4a5$var$validTXTExtension = ".txt";
const $db58d3b1af59b4a5$var$validTXTMIME = "text/plain";
const $db58d3b1af59b4a5$export$3835b7ee6dbebde8 = {
    /** used for deprecation purposes */ name: "loadTxt",
    id: "text",
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $db58d3b1af59b4a5$var$validTXTMIME) || (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $db58d3b1af59b4a5$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};



var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $1RpxL = parcelRequire("1RpxL");

var $208Yz = parcelRequire("208Yz");

var $h3cT0 = parcelRequire("h3cT0");



var $8nmJS = parcelRequire("8nmJS");
"use strict";
const $568e7f5570577c0e$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $568e7f5570577c0e$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $568e7f5570577c0e$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $568e7f5570577c0e$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $568e7f5570577c0e$export$c461ca8f39d93d9b(url) {
    const ext = (0, $208Yz.path).extname(url);
    const name = (0, $208Yz.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($568e7f5570577c0e$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $568e7f5570577c0e$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $568e7f5570577c0e$var$encodeURIWhenNeeded(uri) {
    if ($568e7f5570577c0e$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $568e7f5570577c0e$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadWebFont",
    id: "web-font",
    test (url) {
        return (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $568e7f5570577c0e$var$validFontMIMEs) || (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $568e7f5570577c0e$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $gLw46.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $568e7f5570577c0e$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$568e7f5570577c0e$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$568e7f5570577c0e$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            if ((0, $h3cT0.Cache).has(`${name}-and-url`)) {
                const cached = (0, $h3cT0.Cache).get(`${name}-and-url`);
                cached.entries.push({
                    url: url,
                    faces: fontFaces
                });
            } else (0, $h3cT0.Cache).set(`${name}-and-url`, {
                entries: [
                    {
                        url: url,
                        faces: fontFaces
                    }
                ]
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $1RpxL.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        const fonts = Array.isArray(font) ? font : [
            font
        ];
        const fontFamily = fonts[0].family;
        const cached = (0, $h3cT0.Cache).get(`${fontFamily}-and-url`);
        const entry = cached.entries.find((f)=>f.faces.some((t)=>fonts.indexOf(t) !== -1));
        entry.faces = entry.faces.filter((f)=>fonts.indexOf(f) === -1);
        if (entry.faces.length === 0) cached.entries = cached.entries.filter((f)=>f !== entry);
        fonts.forEach((t)=>{
            (0, $gLw46.DOMAdapter).get().getFontFaceSet().delete(t);
        });
        if (cached.entries.length === 0) (0, $h3cT0.Cache).remove(`${fontFamily}-and-url`);
    }
};



var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $cVYNB = parcelRequire("cVYNB");

var $7kRkZ = parcelRequire("7kRkZ");

var $eFUj8 = parcelRequire("eFUj8");
"use strict";
function $9325343e1cf12602$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $eFUj8.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}





var $8nmJS = parcelRequire("8nmJS");

var $4iNSL = parcelRequire("4iNSL");

var $1RpxL = parcelRequire("1RpxL");

var $h3cT0 = parcelRequire("h3cT0");
"use strict";
function $9a5eddce1cc0cd00$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $4iNSL.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $h3cT0.Cache).has(url)) (0, $h3cT0.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $1RpxL.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $1RpxL.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}


"use strict";
const $da6615954e48760f$var$validSVGExtension = ".svg";
const $da6615954e48760f$var$validSVGMIME = "image/svg+xml";
const $da6615954e48760f$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    /** used for deprecation purposes */ name: "loadSVG",
    id: "svg",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $da6615954e48760f$var$validSVGMIME) || (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $da6615954e48760f$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $da6615954e48760f$var$loadAsGraphics(url);
        return $da6615954e48760f$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $da6615954e48760f$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
    const image = (0, $gLw46.DOMAdapter).get().createImage();
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(await response.text())}`;
    image.crossOrigin = crossOrigin;
    await image.decode();
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    const resolution = asset.data?.resolution || (0, $9325343e1cf12602$export$8695ab2f322d2637)(url);
    const canvasWidth = Math.ceil(width * resolution);
    const canvasHeight = Math.ceil(height * resolution);
    const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(canvasWidth, canvasHeight);
    const context = canvas.getContext("2d");
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
    const base = new (0, $cVYNB.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(base, loader, url);
}
async function $da6615954e48760f$var$loadAsGraphics(url) {
    const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $7kRkZ.GraphicsContext)();
    context.svg(svgSource);
    return context;
}



var $gLw46 = parcelRequire("gLw46");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $cVYNB = parcelRequire("cVYNB");



const $aadc8b4d3f82d52e$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const WHITE_PNG = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=\";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== \"function\") return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (_e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n";
let $aadc8b4d3f82d52e$var$WORKER_URL = null;
class $aadc8b4d3f82d52e$export$2e2bcd8739ae039 {
    constructor(){
        if (!$aadc8b4d3f82d52e$var$WORKER_URL) $aadc8b4d3f82d52e$var$WORKER_URL = URL.createObjectURL(new Blob([
            $aadc8b4d3f82d52e$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($aadc8b4d3f82d52e$var$WORKER_URL);
    }
}
$aadc8b4d3f82d52e$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($aadc8b4d3f82d52e$var$WORKER_URL) {
        URL.revokeObjectURL($aadc8b4d3f82d52e$var$WORKER_URL);
        $aadc8b4d3f82d52e$var$WORKER_URL = null;
    }
};


const $b68db0ee9b6e6485$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === \"premultiplied-alpha\" ? createImageBitmap(imageBlob, { premultiplyAlpha: \"none\" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $b68db0ee9b6e6485$var$WORKER_URL = null;
class $b68db0ee9b6e6485$export$2e2bcd8739ae039 {
    constructor(){
        if (!$b68db0ee9b6e6485$var$WORKER_URL) $b68db0ee9b6e6485$var$WORKER_URL = URL.createObjectURL(new Blob([
            $b68db0ee9b6e6485$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($b68db0ee9b6e6485$var$WORKER_URL);
    }
}
$b68db0ee9b6e6485$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($b68db0ee9b6e6485$var$WORKER_URL) {
        URL.revokeObjectURL($b68db0ee9b6e6485$var$WORKER_URL);
        $b68db0ee9b6e6485$var$WORKER_URL = null;
    }
};


"use strict";
let $0815e342356fde47$var$UUID = 0;
let $0815e342356fde47$var$MAX_WORKERS;
class $0815e342356fde47$var$WorkerManagerClass {
    constructor(){
        /** Whether the worker manager has been initialized */ this._initialized = false;
        /** Current number of created workers (used to enforce MAX_WORKERS limit) */ this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    /**
   * Checks if ImageBitmap is supported in the current environment.
   *
   * This method uses a dedicated worker to test ImageBitmap support
   * and caches the result for subsequent calls.
   * @returns Promise that resolves to true if ImageBitmap is supported, false otherwise
   */ isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $aadc8b4d3f82d52e$export$2e2bcd8739ae039)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $aadc8b4d3f82d52e$export$2e2bcd8739ae039).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    /**
   * Loads an image as an ImageBitmap using a web worker.
   * @param src - The source URL or path of the image to load
   * @param asset - Optional resolved asset containing additional texture source options
   * @returns Promise that resolves to the loaded ImageBitmap
   * @example
   * ```typescript
   * const bitmap = await WorkerManager.loadImageBitmap('image.png');
   * const bitmapWithOptions = await WorkerManager.loadImageBitmap('image.png', asset);
   * ```
   */ loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    /**
   * Initializes the worker pool if not already initialized.
   * Currently a no-op but reserved for future initialization logic.
   */ async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    /**
   * Gets an available worker from the pool or creates a new one if needed.
   *
   * Workers are created up to the MAX_WORKERS limit (based on navigator.hardwareConcurrency).
   * Each worker is configured with a message handler for processing results.
   * @returns Available worker or undefined if pool is at capacity and no workers are free
   */ _getWorker() {
        if ($0815e342356fde47$var$MAX_WORKERS === void 0) $0815e342356fde47$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $0815e342356fde47$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $b68db0ee9b6e6485$export$2e2bcd8739ae039)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    /**
   * Returns a worker to the pool after completing a task.
   * @param worker - The worker to return to the pool
   */ _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    /**
   * Handles completion of a worker task by resolving or rejecting the corresponding promise.
   * @param data - Result data from the worker containing uuid, data, and optional error
   */ _complete(data) {
        if (!this._resolveHash[data.uuid]) return;
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        delete this._resolveHash[data.uuid];
    }
    /**
   * Executes a task using the worker pool system.
   *
   * Queues the task and processes it when a worker becomes available.
   * @param id - Identifier for the type of task to run
   * @param args - Arguments to pass to the worker
   * @returns Promise that resolves with the worker's result
   */ async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    /**
   * Processes the next item in the queue if workers are available.
   *
   * This method is called after worker initialization and when workers
   * complete tasks to continue processing the queue.
   */ _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$0815e342356fde47$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $0815e342356fde47$var$UUID++,
            id: id
        });
    }
    /**
   * Resets the worker manager, terminating all workers and clearing the queue.
   *
   * This method:
   * - Terminates all active workers
   * - Rejects all pending promises with an error
   * - Clears all internal state
   * - Resets initialization flags
   *
   * This should be called when the worker manager is no longer needed
   * to prevent memory leaks and ensure proper cleanup.
   * @example
   * ```typescript
   * // Clean up when shutting down
   * WorkerManager.reset();
   * ```
   */ reset() {
        this._workerPool.forEach((worker)=>worker.terminate());
        this._workerPool.length = 0;
        Object.values(this._resolveHash).forEach(({ reject: reject })=>{
            reject?.(new Error("WorkerManager has been reset before completion"));
        });
        this._resolveHash = {};
        this._queue.length = 0;
        this._initialized = false;
        this._createdWorkers = 0;
    }
}
const $0815e342356fde47$export$bcff6015853c67ce = new $0815e342356fde47$var$WorkerManagerClass();



var $8nmJS = parcelRequire("8nmJS");

"use strict";
const $99578192368a5e1c$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $99578192368a5e1c$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $99578192368a5e1c$export$c614e6247302006d(url, asset) {
    const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $99578192368a5e1c$export$897b113ee8307cd0 = {
    /** used for deprecation purposes */ name: "loadTextures",
    id: "texture",
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $99578192368a5e1c$var$validImageMIMEs) || (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $99578192368a5e1c$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $0815e342356fde47$export$bcff6015853c67ce).isImageBitmapSupported()) src = await (0, $0815e342356fde47$export$bcff6015853c67ce).loadImageBitmap(url, asset);
            else src = await $99578192368a5e1c$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve, reject)=>{
            src = (0, $gLw46.DOMAdapter).get().createImage();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else {
                src.onload = ()=>{
                    resolve(src);
                };
                src.onerror = reject;
            }
        });
        const base = new (0, $cVYNB.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $9325343e1cf12602$export$8695ab2f322d2637)(url),
            ...asset.data
        });
        return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $dvpBJ = parcelRequire("dvpBJ");

var $7X2qc = parcelRequire("7X2qc");





"use strict";
const $48904b1a9f5881c8$var$potentialVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
let $48904b1a9f5881c8$var$validVideoExtensions;
let $48904b1a9f5881c8$var$validVideoMIMEs;
function $48904b1a9f5881c8$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $48904b1a9f5881c8$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $48904b1a9f5881c8$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $48904b1a9f5881c8$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc || (loc = globalThis.location);
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
function $48904b1a9f5881c8$var$getBrowserSupportedVideoExtensions() {
    const supportedExtensions = [];
    const supportedMimes = [];
    for (const ext of $48904b1a9f5881c8$var$potentialVideoExtensions){
        const mimeType = (0, $dvpBJ.VideoSource).MIME_TYPES[ext.substring(1)] || `video/${ext.substring(1)}`;
        if ((0, $1bfab03a55c6b4c2$export$7a571c147b03abb1)(mimeType)) {
            supportedExtensions.push(ext);
            if (!supportedMimes.includes(mimeType)) supportedMimes.push(mimeType);
        }
    }
    return {
        validVideoExtensions: supportedExtensions,
        validVideoMime: supportedMimes
    };
}
const $48904b1a9f5881c8$export$68fa0976ba667d63 = {
    /** used for deprecation purposes */ name: "loadVideo",
    id: "video",
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        if (!$48904b1a9f5881c8$var$validVideoExtensions || !$48904b1a9f5881c8$var$validVideoMIMEs) {
            const { validVideoExtensions: ve, validVideoMime: vm } = $48904b1a9f5881c8$var$getBrowserSupportedVideoExtensions();
            $48904b1a9f5881c8$var$validVideoExtensions = ve;
            $48904b1a9f5881c8$var$validVideoMIMEs = vm;
        }
        const isValidDataUrl = (0, $6e8add647376da4b$export$7ff8b059fb914323)(url, $48904b1a9f5881c8$var$validVideoMIMEs);
        const isValidExtension = (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, $48904b1a9f5881c8$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $dvpBJ.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $9325343e1cf12602$export$8695ab2f322d2637)(url),
            alphaMode: asset.data?.alphaMode || await (0, $7X2qc.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $48904b1a9f5881c8$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (options.mime) mime = options.mime;
        else if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $dvpBJ.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve, reject)=>{
            if (options.preload && !options.autoPlay) videoElement.load();
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.addEventListener("error", onError);
            sourceElement.addEventListener("error", onError);
            videoElement.appendChild(sourceElement);
            async function onCanPlay() {
                const base = new (0, $dvpBJ.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                cleanup();
                if (asset.data.preload) await $48904b1a9f5881c8$export$856bfbe81968ff62(videoElement);
                resolve((0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(base, loader, url));
            }
            function onError(event) {
                cleanup();
                reject(event);
            }
            function cleanup() {
                videoElement.removeEventListener("canplay", onCanPlay);
                videoElement.removeEventListener("error", onError);
                sourceElement.removeEventListener("error", onError);
            }
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $eFUj8 = parcelRequire("eFUj8");

var $aZ9ZN = parcelRequire("aZ9ZN");


var $eFUj8 = parcelRequire("eFUj8");
"use strict";
const $741a25985f8cb683$export$cc356fa83de02bea = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $99578192368a5e1c$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $eFUj8.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};


"use strict";
const $c6d26013fe76af62$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $eFUj8.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $741a25985f8cb683$export$cc356fa83de02bea).parse
};




var $eFUj8 = parcelRequire("eFUj8");

var $bkziv = parcelRequire("bkziv");

var $4Kkng = parcelRequire("4Kkng");
"use strict";
class $751ce026a38dc015$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $eFUj8.Resolver)();
        this.loader = new (0, $a780a988a4a41ac9$export$3b0d6d7590275603)();
        this.cache = (0, $h3cT0.Cache);
        this._backgroundLoader = new (0, $6d818aba51088bb4$export$1949379a83b843d5)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $1RpxL.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
        if (options.loadOptions) this.loader.loadOptions = {
            ...this.loader.loadOptions,
            ...options.loadOptions
        };
    }
    /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $4Kkng.isSingleItem)(urls);
        const urlArray = (0, $bkziv.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let total = 0;
        const counts = [];
        const _onProgress = ()=>{
            onProgress?.(counts.reduce((a, b)=>a + b, 0) / total);
        };
        const promises = keys.map((bundleId, i)=>{
            const resolveResult = resolveResults[bundleId];
            const values = Object.values(resolveResult);
            const totalAssetsToLoad = [
                ...new Set(values.flat())
            ];
            const progressSize = totalAssetsToLoad.reduce((sum, asset)=>sum + (asset.progressSize || 1), 0);
            counts.push(0);
            total += progressSize;
            return this._mapLoadToResolve(resolveResult, (e)=>{
                counts[i] = e * progressSize;
                _onProgress();
            }).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $h3cT0.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $h3cT0.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param progressOrLoadOptions - the progress callback or load options
   */ async _mapLoadToResolve(resolveResults, progressOrLoadOptions) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, progressOrLoadOptions);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $h3cT0.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $bkziv.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $bkziv.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $h3cT0.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */ get detections() {
        return this._detections;
    }
    /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $751ce026a38dc015$export$c8eca95e306f7116 = new $751ce026a38dc015$export$137d4dd907afac85();
(0, $aZ9ZN.extensions).handleByList((0, $aZ9ZN.ExtensionType).LoadParser, $751ce026a38dc015$export$c8eca95e306f7116.loader.parsers).handleByList((0, $aZ9ZN.ExtensionType).ResolveParser, $751ce026a38dc015$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $aZ9ZN.ExtensionType).CacheParser, $751ce026a38dc015$export$c8eca95e306f7116.cache.parsers).handleByList((0, $aZ9ZN.ExtensionType).DetectionParser, $751ce026a38dc015$export$c8eca95e306f7116.detections);
(0, $aZ9ZN.extensions).add((0, $ee99ec759734d21a$export$407b4625a915919d), (0, $7ae4808924cd4c1a$export$b106d7c2de3b4d89), (0, $a731aeae60a36915$export$a60d2d4a3c570783), (0, $b1f07772206d4732$export$d19529a9ed9823d4), (0, $7748aa8b5cfd2b6b$export$7726d83fee274e25), (0, $32601ac990b07974$export$5a1da481121f806a), (0, $203ca28464480688$export$a041d698a1896657), (0, $b1848d8e49e2cd02$export$e7c8553478f3aac7), (0, $db58d3b1af59b4a5$export$3835b7ee6dbebde8), (0, $568e7f5570577c0e$export$129ed93ad26b0298), (0, $da6615954e48760f$export$b6a2e78b63791dfa), (0, $99578192368a5e1c$export$897b113ee8307cd0), (0, $48904b1a9f5881c8$export$68fa0976ba667d63), (0, $f6b7037dbc64186a$export$402edee29ac8bed4), (0, $f6b7037dbc64186a$export$778a313228f06f6c), (0, $741a25985f8cb683$export$cc356fa83de02bea), (0, $c6d26013fe76af62$export$2b5cca0b89cb089c));
const $751ce026a38dc015$var$assetKeyMap = {
    loader: (0, $aZ9ZN.ExtensionType).LoadParser,
    resolver: (0, $aZ9ZN.ExtensionType).ResolveParser,
    cache: (0, $aZ9ZN.ExtensionType).CacheParser,
    detection: (0, $aZ9ZN.ExtensionType).DetectionParser
};
(0, $aZ9ZN.extensions).handle((0, $aZ9ZN.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($751ce026a38dc015$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $aZ9ZN.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($751ce026a38dc015$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $aZ9ZN.extensions).remove(ref[key]));
});




var $h3cT0 = parcelRequire("h3cT0");











var $8nmJS = parcelRequire("8nmJS");











var $eFUj8 = parcelRequire("eFUj8");



var $bkziv = parcelRequire("bkziv");

var $h8sEz = parcelRequire("h8sEz");

var $25zMj = parcelRequire("25zMj");

var $4Kkng = parcelRequire("4Kkng");

var $dKHyW = parcelRequire("dKHyW");

var $aZ9ZN = parcelRequire("aZ9ZN");


"use strict";
const $86b85541141d61ae$export$66983304f23bcc54 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 3
    },
    test: async ()=>{
        if (await (0, $bc01c1fc77b347f9$export$216169f30082c873)()) return true;
        if ((0, $61b81e90b77f0603$export$83dc396b76015322)()) return true;
        return false;
    },
    add: async (formats)=>[
            ...formats,
            "basis"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "basis")
};



var $8nmJS = parcelRequire("8nmJS");



var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
class $81ada49b5e64f85d$export$19b6a4fc54276638 extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        super({
            ...options,
            mipLevelCount: options.resource.length
        });
        this.uploadMethodId = "compressed";
    }
}





var $gLw46 = parcelRequire("gLw46");
"use strict";
let $65cbc8dc9ca11748$var$supportedGLCompressedTextureFormats;
function $65cbc8dc9ca11748$export$53ee2d058bf32643() {
    if ($65cbc8dc9ca11748$var$supportedGLCompressedTextureFormats) return $65cbc8dc9ca11748$var$supportedGLCompressedTextureFormats;
    const canvas = (0, $gLw46.DOMAdapter).get().createCanvas(1, 1);
    const gl = canvas.getContext("webgl");
    if (!gl) return [];
    $65cbc8dc9ca11748$var$supportedGLCompressedTextureFormats = [
        // BC compressed formats usable if "texture-compression-bc" is both
        // supported by the device/user agent and enabled in requestDevice.
        // 'bc6h-rgb-ufloat'
        // 'bc6h-rgb-float'
        // 'bc7-rgba-unorm',
        // 'bc7-rgba-unorm-srgb',
        ...gl.getExtension("EXT_texture_compression_bptc") ? [
            "bc6h-rgb-ufloat",
            "bc6h-rgb-float",
            "bc7-rgba-unorm",
            "bc7-rgba-unorm-srgb"
        ] : [],
        // BC compressed formats usable if "texture-compression-bc" is both
        // supported by the device/user agent and enabled in requestDevice.
        // 'bc1-rgba-unorm',
        // 'bc1-rgba-unorm-srgb',
        // 'bc4-r-unorm'
        // 'bc4-r-snorm'
        // 'bc5-rg-unorm'
        // 'bc5-rg-snorm'
        ...gl.getExtension("WEBGL_compressed_texture_s3tc") ? [
            "bc1-rgba-unorm",
            "bc2-rgba-unorm",
            "bc3-rgba-unorm"
        ] : [],
        ...gl.getExtension("WEBGL_compressed_texture_s3tc_srgb") ? [
            "bc1-rgba-unorm-srgb",
            "bc2-rgba-unorm-srgb",
            "bc3-rgba-unorm-srgb"
        ] : [],
        ...gl.getExtension("EXT_texture_compression_rgtc") ? [
            "bc4-r-unorm",
            "bc4-r-snorm",
            "bc5-rg-unorm",
            "bc5-rg-snorm"
        ] : [],
        // ETC2 compressed formats usable if "texture-compression-etc2" is both
        // supported by the device/user agent and enabled in requestDevice.
        ...gl.getExtension("WEBGL_compressed_texture_etc") ? [
            "etc2-rgb8unorm",
            "etc2-rgb8unorm-srgb",
            "etc2-rgba8unorm",
            "etc2-rgba8unorm-srgb",
            "etc2-rgb8a1unorm",
            "etc2-rgb8a1unorm-srgb",
            "eac-r11unorm",
            "eac-rg11unorm"
        ] : [],
        // 'eac-r11snorm',
        // 'eac-rg11snorm',
        // ASTC compressed formats usable if "texture-compression-astc" is both
        // supported by the device/user agent and enabled in requestDevice.
        ...gl.getExtension("WEBGL_compressed_texture_astc") ? [
            "astc-4x4-unorm",
            "astc-4x4-unorm-srgb",
            "astc-5x4-unorm",
            "astc-5x4-unorm-srgb",
            "astc-5x5-unorm",
            "astc-5x5-unorm-srgb",
            "astc-6x5-unorm",
            "astc-6x5-unorm-srgb",
            "astc-6x6-unorm",
            "astc-6x6-unorm-srgb",
            "astc-8x5-unorm",
            "astc-8x5-unorm-srgb",
            "astc-8x6-unorm",
            "astc-8x6-unorm-srgb",
            "astc-8x8-unorm",
            "astc-8x8-unorm-srgb",
            "astc-10x5-unorm",
            "astc-10x5-unorm-srgb",
            "astc-10x6-unorm",
            "astc-10x6-unorm-srgb",
            "astc-10x8-unorm",
            "astc-10x8-unorm-srgb",
            "astc-10x10-unorm",
            "astc-10x10-unorm-srgb",
            "astc-12x10-unorm",
            "astc-12x10-unorm-srgb",
            "astc-12x12-unorm",
            "astc-12x12-unorm-srgb"
        ] : []
    ];
    return $65cbc8dc9ca11748$var$supportedGLCompressedTextureFormats;
}



var $gLw46 = parcelRequire("gLw46");
"use strict";
let $fa377c1fb1c5e3b5$var$supportedGPUCompressedTextureFormats;
async function $fa377c1fb1c5e3b5$export$ca1c48b0705b3068() {
    if ($fa377c1fb1c5e3b5$var$supportedGPUCompressedTextureFormats) return $fa377c1fb1c5e3b5$var$supportedGPUCompressedTextureFormats;
    const adapter = await (0, $gLw46.DOMAdapter).get().getNavigator().gpu.requestAdapter();
    $fa377c1fb1c5e3b5$var$supportedGPUCompressedTextureFormats = [
        ...adapter.features.has("texture-compression-bc") ? [
            // BC compressed formats usable if "texture-compression-bc" is both
            // supported by the device/user agent and enabled in requestDevice.
            "bc1-rgba-unorm",
            "bc1-rgba-unorm-srgb",
            "bc2-rgba-unorm",
            "bc2-rgba-unorm-srgb",
            "bc3-rgba-unorm",
            "bc3-rgba-unorm-srgb",
            "bc4-r-unorm",
            "bc4-r-snorm",
            "bc5-rg-unorm",
            "bc5-rg-snorm",
            "bc6h-rgb-ufloat",
            "bc6h-rgb-float",
            "bc7-rgba-unorm",
            "bc7-rgba-unorm-srgb"
        ] : [],
        ...adapter.features.has("texture-compression-etc2") ? [
            // ETC2 compressed formats usable if "texture-compression-etc2" is both
            // supported by the device/user agent and enabled in requestDevice.
            "etc2-rgb8unorm",
            "etc2-rgb8unorm-srgb",
            "etc2-rgb8a1unorm",
            "etc2-rgb8a1unorm-srgb",
            "etc2-rgba8unorm",
            "etc2-rgba8unorm-srgb",
            "eac-r11unorm",
            "eac-r11snorm",
            "eac-rg11unorm",
            "eac-rg11snorm"
        ] : [],
        ...adapter.features.has("texture-compression-astc") ? [
            // ASTC compressed formats usable if "texture-compression-astc" is both
            // supported by the device/user agent and enabled in requestDevice.
            "astc-4x4-unorm",
            "astc-4x4-unorm-srgb",
            "astc-5x4-unorm",
            "astc-5x4-unorm-srgb",
            "astc-5x5-unorm",
            "astc-5x5-unorm-srgb",
            "astc-6x5-unorm",
            "astc-6x5-unorm-srgb",
            "astc-6x6-unorm",
            "astc-6x6-unorm-srgb",
            "astc-8x5-unorm",
            "astc-8x5-unorm-srgb",
            "astc-8x6-unorm",
            "astc-8x6-unorm-srgb",
            "astc-8x8-unorm",
            "astc-8x8-unorm-srgb",
            "astc-10x5-unorm",
            "astc-10x5-unorm-srgb",
            "astc-10x6-unorm",
            "astc-10x6-unorm-srgb",
            "astc-10x8-unorm",
            "astc-10x8-unorm-srgb",
            "astc-10x10-unorm",
            "astc-10x10-unorm-srgb",
            "astc-12x10-unorm",
            "astc-12x10-unorm-srgb",
            "astc-12x12-unorm",
            "astc-12x12-unorm-srgb"
        ] : []
    ];
    return $fa377c1fb1c5e3b5$var$supportedGPUCompressedTextureFormats;
}


"use strict";
let $41d1bec41d2744d8$var$supportedCompressedTextureFormats;
async function $41d1bec41d2744d8$export$6ac497591fea8412() {
    if ($41d1bec41d2744d8$var$supportedCompressedTextureFormats !== void 0) return $41d1bec41d2744d8$var$supportedCompressedTextureFormats;
    $41d1bec41d2744d8$var$supportedCompressedTextureFormats = await (async ()=>{
        const _isWebGPUSupported = await (0, $bc01c1fc77b347f9$export$216169f30082c873)();
        const _isWebGLSupported = (0, $61b81e90b77f0603$export$83dc396b76015322)();
        if (_isWebGPUSupported && _isWebGLSupported) {
            const gpuTextureFormats = await (0, $fa377c1fb1c5e3b5$export$ca1c48b0705b3068)();
            const glTextureFormats = (0, $65cbc8dc9ca11748$export$53ee2d058bf32643)();
            return gpuTextureFormats.filter((format)=>glTextureFormats.includes(format));
        } else if (_isWebGPUSupported) return await (0, $fa377c1fb1c5e3b5$export$ca1c48b0705b3068)();
        else if (_isWebGLSupported) return (0, $65cbc8dc9ca11748$export$53ee2d058bf32643)();
        return [];
    })();
    return $41d1bec41d2744d8$var$supportedCompressedTextureFormats;
}


"use strict";
const $06cbf1322a912ae5$export$faa476df535f4e2e = [
    // 8-bit formats
    "r8unorm",
    "r8snorm",
    "r8uint",
    "r8sint",
    // 16-bit formats
    "r16uint",
    "r16sint",
    "r16float",
    "rg8unorm",
    "rg8snorm",
    "rg8uint",
    "rg8sint",
    // 32-bit formats
    "r32uint",
    "r32sint",
    "r32float",
    "rg16uint",
    "rg16sint",
    "rg16float",
    "rgba8unorm",
    "rgba8unorm-srgb",
    "rgba8snorm",
    "rgba8uint",
    "rgba8sint",
    "bgra8unorm",
    "bgra8unorm-srgb",
    // Packed 32-bit formats
    "rgb9e5ufloat",
    "rgb10a2unorm",
    "rg11b10ufloat",
    // 64-bit formats
    "rg32uint",
    "rg32sint",
    "rg32float",
    "rgba16uint",
    "rgba16sint",
    "rgba16float",
    // 128-bit formats
    "rgba32uint",
    "rgba32sint",
    "rgba32float",
    // Depth/stencil formats
    "stencil8",
    "depth16unorm",
    "depth24plus",
    "depth24plus-stencil8",
    "depth32float",
    // "depth32float-stencil8" feature
    "depth32float-stencil8"
];
let $06cbf1322a912ae5$var$supportedTextureFormats;
async function $06cbf1322a912ae5$export$6ce110edff12c69() {
    if ($06cbf1322a912ae5$var$supportedTextureFormats !== void 0) return $06cbf1322a912ae5$var$supportedTextureFormats;
    const compressedTextureFormats = await (0, $41d1bec41d2744d8$export$6ac497591fea8412)();
    $06cbf1322a912ae5$var$supportedTextureFormats = [
        ...$06cbf1322a912ae5$export$faa476df535f4e2e,
        ...compressedTextureFormats
    ];
    return $06cbf1322a912ae5$var$supportedTextureFormats;
}


const $75e8b5242e436057$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    function createLevelBuffers(basisTexture, basisTranscoderFormat) {\n      const images = basisTexture.getNumImages();\n      const levels = basisTexture.getNumLevels(0);\n      const success = basisTexture.startTranscoding();\n      if (!success) {\n        throw new Error(\"startTranscoding failed\");\n      }\n      const levelBuffers = [];\n      for (let levelIndex = 0; levelIndex < levels; ++levelIndex) {\n        for (let sliceIndex = 0; sliceIndex < images; ++sliceIndex) {\n          const transcodeSize = basisTexture.getImageTranscodedSizeInBytes(sliceIndex, levelIndex, basisTranscoderFormat);\n          const levelBuffer = new Uint8Array(transcodeSize);\n          const success2 = basisTexture.transcodeImage(levelBuffer, sliceIndex, levelIndex, basisTranscoderFormat, 1, 0);\n          if (!success2) {\n            throw new Error(\"transcodeImage failed\");\n          }\n          levelBuffers.push(levelBuffer);\n        }\n      }\n      return levelBuffers;\n    }\n\n    const gpuFormatToBasisTranscoderFormatMap = {\n      \"bc3-rgba-unorm\": 3,\n      // cTFBC3_RGBA\n      \"bc7-rgba-unorm\": 6,\n      // cTFBC7_RGBA,\n      \"etc2-rgba8unorm\": 1,\n      // cTFETC2_RGBA,\n      \"astc-4x4-unorm\": 10,\n      // cTFASTC_4x4_RGBA,\n      // Uncompressed\n      rgba8unorm: 13,\n      // cTFRGBA32,\n      rgba4unorm: 16\n      // cTFRGBA4444,\n    };\n    function gpuFormatToBasisTranscoderFormat(transcoderFormat) {\n      const format = gpuFormatToBasisTranscoderFormatMap[transcoderFormat];\n      if (format) {\n        return format;\n      }\n      throw new Error(`Unsupported transcoderFormat: ${transcoderFormat}`);\n    }\n\n    const settings = {\n      jsUrl: \"basis/basis_transcoder.js\",\n      wasmUrl: \"basis/basis_transcoder.wasm\"\n    };\n    let basisTranscoderFormat;\n    let basisTranscodedTextureFormat;\n    let basisPromise;\n    async function getBasis() {\n      if (!basisPromise) {\n        const absoluteJsUrl = new URL(settings.jsUrl, location.origin).href;\n        const absoluteWasmUrl = new URL(settings.wasmUrl, location.origin).href;\n        importScripts(absoluteJsUrl);\n        basisPromise = new Promise((resolve) => {\n          BASIS({\n            locateFile: (_file) => absoluteWasmUrl\n          }).then((module) => {\n            module.initializeBasis();\n            resolve(module.BasisFile);\n          });\n        });\n      }\n      return basisPromise;\n    }\n    async function fetchBasisTexture(url, BasisTexture) {\n      const basisResponse = await fetch(url);\n      if (basisResponse.ok) {\n        const basisArrayBuffer = await basisResponse.arrayBuffer();\n        return new BasisTexture(new Uint8Array(basisArrayBuffer));\n      }\n      throw new Error(`Failed to load Basis texture: ${url}`);\n    }\n    const preferredTranscodedFormat = [\n      \"bc7-rgba-unorm\",\n      \"astc-4x4-unorm\",\n      \"etc2-rgba8unorm\",\n      \"bc3-rgba-unorm\",\n      \"rgba8unorm\"\n    ];\n    async function load(url) {\n      const BasisTexture = await getBasis();\n      const basisTexture = await fetchBasisTexture(url, BasisTexture);\n      const levelBuffers = createLevelBuffers(basisTexture, basisTranscoderFormat);\n      return {\n        width: basisTexture.getImageWidth(0, 0),\n        height: basisTexture.getImageHeight(0, 0),\n        format: basisTranscodedTextureFormat,\n        resource: levelBuffers,\n        alphaMode: \"no-premultiply-alpha\"\n      };\n    }\n    async function init(jsUrl, wasmUrl, supportedTextures) {\n      if (jsUrl) settings.jsUrl = jsUrl;\n      if (wasmUrl) settings.wasmUrl = wasmUrl;\n      basisTranscodedTextureFormat = preferredTranscodedFormat.filter((format) => supportedTextures.includes(format))[0];\n      basisTranscoderFormat = gpuFormatToBasisTranscoderFormat(basisTranscodedTextureFormat);\n      await getBasis();\n    }\n    const messageHandlers = {\n      init: async (data) => {\n        const { jsUrl, wasmUrl, supportedTextures } = data;\n        await init(jsUrl, wasmUrl, supportedTextures);\n      },\n      load: async (data) => {\n        try {\n          const textureOptions = await load(data.url);\n          return {\n            type: \"load\",\n            url: data.url,\n            success: true,\n            textureOptions,\n            transferables: textureOptions.resource?.map((arr) => arr.buffer)\n          };\n        } catch (e) {\n          throw e;\n        }\n      }\n    };\n    self.onmessage = (async (messageEvent) => {\n      const message = messageEvent.data;\n      const response = await messageHandlers[message.type](message);\n      if (response) {\n        self.postMessage(response, response.transferables);\n      }\n    });\n\n})();\n";
let $75e8b5242e436057$var$WORKER_URL = null;
class $75e8b5242e436057$export$2e2bcd8739ae039 {
    constructor(){
        if (!$75e8b5242e436057$var$WORKER_URL) $75e8b5242e436057$var$WORKER_URL = URL.createObjectURL(new Blob([
            $75e8b5242e436057$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($75e8b5242e436057$var$WORKER_URL);
    }
}
$75e8b5242e436057$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($75e8b5242e436057$var$WORKER_URL) {
        URL.revokeObjectURL($75e8b5242e436057$var$WORKER_URL);
        $75e8b5242e436057$var$WORKER_URL = null;
    }
};


"use strict";
const $a676848eb08cd831$export$371f717dace32803 = {
    jsUrl: "https://cdn.jsdelivr.net/npm/pixi.js/transcoders/basis/basis_transcoder.js",
    wasmUrl: "https://cdn.jsdelivr.net/npm/pixi.js/transcoders/basis/basis_transcoder.wasm"
};
function $a676848eb08cd831$export$4c72d3e163ed69c9(config) {
    Object.assign($a676848eb08cd831$export$371f717dace32803, config);
}


"use strict";
let $802602d567ebfdd5$var$basisWorker;
const $802602d567ebfdd5$var$urlHash = {};
function $802602d567ebfdd5$var$getBasisWorker(supportedTextures) {
    if (!$802602d567ebfdd5$var$basisWorker) {
        $802602d567ebfdd5$var$basisWorker = new (0, $75e8b5242e436057$export$2e2bcd8739ae039)().worker;
        $802602d567ebfdd5$var$basisWorker.onmessage = (messageEvent)=>{
            const { success: success, url: url, textureOptions: textureOptions } = messageEvent.data;
            if (!success) console.warn("Failed to load Basis texture", url);
            $802602d567ebfdd5$var$urlHash[url](textureOptions);
        };
        $802602d567ebfdd5$var$basisWorker.postMessage({
            type: "init",
            jsUrl: (0, $a676848eb08cd831$export$371f717dace32803).jsUrl,
            wasmUrl: (0, $a676848eb08cd831$export$371f717dace32803).wasmUrl,
            supportedTextures: supportedTextures
        });
    }
    return $802602d567ebfdd5$var$basisWorker;
}
function $802602d567ebfdd5$export$da1e3219cba22f0(url, supportedTextures) {
    const ktxWorker = $802602d567ebfdd5$var$getBasisWorker(supportedTextures);
    return new Promise((resolve)=>{
        $802602d567ebfdd5$var$urlHash[url] = resolve;
        ktxWorker.postMessage({
            type: "load",
            url: url
        });
    });
}


"use strict";
const $05c3a1709fd63e32$export$91ba277d70f60d23 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).High,
        name: "loadBasis"
    },
    /** used for deprecation purposes */ name: "loadBasis",
    id: "basis",
    test (url) {
        return (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, [
            ".basis"
        ]);
    },
    async load (url, _asset, loader) {
        const supportedTextures = await (0, $06cbf1322a912ae5$export$6ce110edff12c69)();
        const textureOptions = await (0, $802602d567ebfdd5$export$da1e3219cba22f0)(url, supportedTextures);
        const compressedTextureSource = new (0, $81ada49b5e64f85d$export$19b6a4fc54276638)(textureOptions);
        return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(compressedTextureSource, loader, url);
    },
    unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};


"use strict";
function $7d357efb2a35a30c$export$eb3a94025cbc6da1(basisTexture, basisTranscoderFormat) {
    const images = basisTexture.getNumImages();
    const levels = basisTexture.getNumLevels(0);
    const success = basisTexture.startTranscoding();
    if (!success) throw new Error("startTranscoding failed");
    const levelBuffers = [];
    for(let levelIndex = 0; levelIndex < levels; ++levelIndex)for(let sliceIndex = 0; sliceIndex < images; ++sliceIndex){
        const transcodeSize = basisTexture.getImageTranscodedSizeInBytes(sliceIndex, levelIndex, basisTranscoderFormat);
        const levelBuffer = new Uint8Array(transcodeSize);
        const success2 = basisTexture.transcodeImage(levelBuffer, sliceIndex, levelIndex, basisTranscoderFormat, 1, 0);
        if (!success2) throw new Error("transcodeImage failed");
        levelBuffers.push(levelBuffer);
    }
    return levelBuffers;
}


"use strict";
const $3cbed1529610ad78$var$gpuFormatToBasisTranscoderFormatMap = {
    "bc3-rgba-unorm": 3,
    // cTFBC3_RGBA
    "bc7-rgba-unorm": 6,
    // cTFBC7_RGBA,
    "etc2-rgba8unorm": 1,
    // cTFETC2_RGBA,
    "astc-4x4-unorm": 10,
    // cTFASTC_4x4_RGBA,
    // Uncompressed
    rgba8unorm: 13,
    // cTFRGBA32,
    rgba4unorm: 16
};
function $3cbed1529610ad78$export$faeb23e37b1607d4(transcoderFormat) {
    const format = $3cbed1529610ad78$var$gpuFormatToBasisTranscoderFormatMap[transcoderFormat];
    if (format) return format;
    throw new Error(`Unsupported transcoderFormat: ${transcoderFormat}`);
}




"use strict";
const $9e04c0e82ea22f13$var$DDS_HEADER_FIELDS = {
    MAGIC: 0,
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19,
    PF_FLAGS: 20,
    FOURCC: 21,
    RGB_BITCOUNT: 22,
    R_BIT_MASK: 23,
    G_BIT_MASK: 24,
    B_BIT_MASK: 25,
    A_BIT_MASK: 26
};
const $9e04c0e82ea22f13$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
};
var $9e04c0e82ea22f13$export$63577c11dea0d1a7 = /* @__PURE__ */ ((DXGI_FORMAT2)=>{
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_UNKNOWN"] = 0] = "DXGI_FORMAT_UNKNOWN";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_TYPELESS"] = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_FLOAT"] = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_UINT"] = 3] = "DXGI_FORMAT_R32G32B32A32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_SINT"] = 4] = "DXGI_FORMAT_R32G32B32A32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_TYPELESS"] = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_FLOAT"] = 6] = "DXGI_FORMAT_R32G32B32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_UINT"] = 7] = "DXGI_FORMAT_R32G32B32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_SINT"] = 8] = "DXGI_FORMAT_R32G32B32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_TYPELESS"] = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_FLOAT"] = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_UNORM"] = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_UINT"] = 12] = "DXGI_FORMAT_R16G16B16A16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_SNORM"] = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_SINT"] = 14] = "DXGI_FORMAT_R16G16B16A16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_TYPELESS"] = 15] = "DXGI_FORMAT_R32G32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_FLOAT"] = 16] = "DXGI_FORMAT_R32G32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_UINT"] = 17] = "DXGI_FORMAT_R32G32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_SINT"] = 18] = "DXGI_FORMAT_R32G32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G8X24_TYPELESS"] = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D32_FLOAT_S8X24_UINT"] = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS"] = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_X32_TYPELESS_G8X24_UINT"] = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_TYPELESS"] = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_UNORM"] = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_UINT"] = 25] = "DXGI_FORMAT_R10G10B10A2_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R11G11B10_FLOAT"] = 26] = "DXGI_FORMAT_R11G11B10_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_TYPELESS"] = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UNORM"] = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UNORM_SRGB"] = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UINT"] = 30] = "DXGI_FORMAT_R8G8B8A8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_SNORM"] = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_SINT"] = 32] = "DXGI_FORMAT_R8G8B8A8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_TYPELESS"] = 33] = "DXGI_FORMAT_R16G16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_FLOAT"] = 34] = "DXGI_FORMAT_R16G16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_UNORM"] = 35] = "DXGI_FORMAT_R16G16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_UINT"] = 36] = "DXGI_FORMAT_R16G16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_SNORM"] = 37] = "DXGI_FORMAT_R16G16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_SINT"] = 38] = "DXGI_FORMAT_R16G16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_TYPELESS"] = 39] = "DXGI_FORMAT_R32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D32_FLOAT"] = 40] = "DXGI_FORMAT_D32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_FLOAT"] = 41] = "DXGI_FORMAT_R32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_UINT"] = 42] = "DXGI_FORMAT_R32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_SINT"] = 43] = "DXGI_FORMAT_R32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R24G8_TYPELESS"] = 44] = "DXGI_FORMAT_R24G8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D24_UNORM_S8_UINT"] = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R24_UNORM_X8_TYPELESS"] = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_X24_TYPELESS_G8_UINT"] = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_TYPELESS"] = 48] = "DXGI_FORMAT_R8G8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_UNORM"] = 49] = "DXGI_FORMAT_R8G8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_UINT"] = 50] = "DXGI_FORMAT_R8G8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_SNORM"] = 51] = "DXGI_FORMAT_R8G8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_SINT"] = 52] = "DXGI_FORMAT_R8G8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_TYPELESS"] = 53] = "DXGI_FORMAT_R16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_FLOAT"] = 54] = "DXGI_FORMAT_R16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D16_UNORM"] = 55] = "DXGI_FORMAT_D16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_UNORM"] = 56] = "DXGI_FORMAT_R16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_UINT"] = 57] = "DXGI_FORMAT_R16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_SNORM"] = 58] = "DXGI_FORMAT_R16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_SINT"] = 59] = "DXGI_FORMAT_R16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_TYPELESS"] = 60] = "DXGI_FORMAT_R8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_UNORM"] = 61] = "DXGI_FORMAT_R8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_UINT"] = 62] = "DXGI_FORMAT_R8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_SNORM"] = 63] = "DXGI_FORMAT_R8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_SINT"] = 64] = "DXGI_FORMAT_R8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_A8_UNORM"] = 65] = "DXGI_FORMAT_A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R1_UNORM"] = 66] = "DXGI_FORMAT_R1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R9G9B9E5_SHAREDEXP"] = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_B8G8_UNORM"] = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_G8R8_G8B8_UNORM"] = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_TYPELESS"] = 70] = "DXGI_FORMAT_BC1_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_UNORM"] = 71] = "DXGI_FORMAT_BC1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_UNORM_SRGB"] = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_TYPELESS"] = 73] = "DXGI_FORMAT_BC2_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_UNORM"] = 74] = "DXGI_FORMAT_BC2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_UNORM_SRGB"] = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_TYPELESS"] = 76] = "DXGI_FORMAT_BC3_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_UNORM"] = 77] = "DXGI_FORMAT_BC3_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_UNORM_SRGB"] = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_TYPELESS"] = 79] = "DXGI_FORMAT_BC4_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_UNORM"] = 80] = "DXGI_FORMAT_BC4_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_SNORM"] = 81] = "DXGI_FORMAT_BC4_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_TYPELESS"] = 82] = "DXGI_FORMAT_BC5_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_UNORM"] = 83] = "DXGI_FORMAT_BC5_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_SNORM"] = 84] = "DXGI_FORMAT_BC5_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B5G6R5_UNORM"] = 85] = "DXGI_FORMAT_B5G6R5_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B5G5R5A1_UNORM"] = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_UNORM"] = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_UNORM"] = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM"] = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_TYPELESS"] = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_UNORM_SRGB"] = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_TYPELESS"] = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_UNORM_SRGB"] = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_TYPELESS"] = 94] = "DXGI_FORMAT_BC6H_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_UF16"] = 95] = "DXGI_FORMAT_BC6H_UF16";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_SF16"] = 96] = "DXGI_FORMAT_BC6H_SF16";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_TYPELESS"] = 97] = "DXGI_FORMAT_BC7_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_UNORM"] = 98] = "DXGI_FORMAT_BC7_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_UNORM_SRGB"] = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_AYUV"] = 100] = "DXGI_FORMAT_AYUV";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y410"] = 101] = "DXGI_FORMAT_Y410";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y416"] = 102] = "DXGI_FORMAT_Y416";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_NV12"] = 103] = "DXGI_FORMAT_NV12";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P010"] = 104] = "DXGI_FORMAT_P010";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P016"] = 105] = "DXGI_FORMAT_P016";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_420_OPAQUE"] = 106] = "DXGI_FORMAT_420_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_YUY2"] = 107] = "DXGI_FORMAT_YUY2";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y210"] = 108] = "DXGI_FORMAT_Y210";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y216"] = 109] = "DXGI_FORMAT_Y216";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_NV11"] = 110] = "DXGI_FORMAT_NV11";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_AI44"] = 111] = "DXGI_FORMAT_AI44";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_IA44"] = 112] = "DXGI_FORMAT_IA44";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P8"] = 113] = "DXGI_FORMAT_P8";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_A8P8"] = 114] = "DXGI_FORMAT_A8P8";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B4G4R4A4_UNORM"] = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P208"] = 116] = "DXGI_FORMAT_P208";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_V208"] = 117] = "DXGI_FORMAT_V208";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_V408"] = 118] = "DXGI_FORMAT_V408";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE"] = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE"] = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_FORCE_UINT"] = 121] = "DXGI_FORMAT_FORCE_UINT";
    return DXGI_FORMAT2;
})($9e04c0e82ea22f13$export$63577c11dea0d1a7 || {});
var $9e04c0e82ea22f13$export$3ccf46595e182c3 = /* @__PURE__ */ ((D3D10_RESOURCE_DIMENSION2)=>{
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE1D"] = 2] = "DDS_DIMENSION_TEXTURE1D";
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE2D"] = 3] = "DDS_DIMENSION_TEXTURE2D";
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE3D"] = 6] = "DDS_DIMENSION_TEXTURE3D";
    return D3D10_RESOURCE_DIMENSION2;
})($9e04c0e82ea22f13$export$3ccf46595e182c3 || {});
function $9e04c0e82ea22f13$var$fourCCToInt32(value) {
    return value.charCodeAt(0) + (value.charCodeAt(1) << 8) + (value.charCodeAt(2) << 16) + (value.charCodeAt(3) << 24);
}
var $9e04c0e82ea22f13$export$880df6e30a43b81e = ((D3DFMT2)=>{
    D3DFMT2[D3DFMT2["UNKNOWN"] = 0] = "UNKNOWN";
    D3DFMT2[D3DFMT2["R8G8B8"] = 20] = "R8G8B8";
    D3DFMT2[D3DFMT2["A8R8G8B8"] = 21] = "A8R8G8B8";
    D3DFMT2[D3DFMT2["X8R8G8B8"] = 22] = "X8R8G8B8";
    D3DFMT2[D3DFMT2["R5G6B5"] = 23] = "R5G6B5";
    D3DFMT2[D3DFMT2["X1R5G5B5"] = 24] = "X1R5G5B5";
    D3DFMT2[D3DFMT2["A1R5G5B5"] = 25] = "A1R5G5B5";
    D3DFMT2[D3DFMT2["A4R4G4B4"] = 26] = "A4R4G4B4";
    D3DFMT2[D3DFMT2["R3G3B2"] = 27] = "R3G3B2";
    D3DFMT2[D3DFMT2["A8"] = 28] = "A8";
    D3DFMT2[D3DFMT2["A8R3G3B2"] = 29] = "A8R3G3B2";
    D3DFMT2[D3DFMT2["X4R4G4B4"] = 30] = "X4R4G4B4";
    D3DFMT2[D3DFMT2["A2B10G10R10"] = 31] = "A2B10G10R10";
    D3DFMT2[D3DFMT2["A8B8G8R8"] = 32] = "A8B8G8R8";
    D3DFMT2[D3DFMT2["X8B8G8R8"] = 33] = "X8B8G8R8";
    D3DFMT2[D3DFMT2["G16R16"] = 34] = "G16R16";
    D3DFMT2[D3DFMT2["A2R10G10B10"] = 35] = "A2R10G10B10";
    D3DFMT2[D3DFMT2["A16B16G16R16"] = 36] = "A16B16G16R16";
    D3DFMT2[D3DFMT2["A8P8"] = 40] = "A8P8";
    D3DFMT2[D3DFMT2["P8"] = 41] = "P8";
    D3DFMT2[D3DFMT2["L8"] = 50] = "L8";
    D3DFMT2[D3DFMT2["A8L8"] = 51] = "A8L8";
    D3DFMT2[D3DFMT2["A4L4"] = 52] = "A4L4";
    D3DFMT2[D3DFMT2["V8U8"] = 60] = "V8U8";
    D3DFMT2[D3DFMT2["L6V5U5"] = 61] = "L6V5U5";
    D3DFMT2[D3DFMT2["X8L8V8U8"] = 62] = "X8L8V8U8";
    D3DFMT2[D3DFMT2["Q8W8V8U8"] = 63] = "Q8W8V8U8";
    D3DFMT2[D3DFMT2["V16U16"] = 64] = "V16U16";
    D3DFMT2[D3DFMT2["A2W10V10U10"] = 67] = "A2W10V10U10";
    D3DFMT2[D3DFMT2["Q16W16V16U16"] = 110] = "Q16W16V16U16";
    D3DFMT2[D3DFMT2["R16F"] = 111] = "R16F";
    D3DFMT2[D3DFMT2["G16R16F"] = 112] = "G16R16F";
    D3DFMT2[D3DFMT2["A16B16G16R16F"] = 113] = "A16B16G16R16F";
    D3DFMT2[D3DFMT2["R32F"] = 114] = "R32F";
    D3DFMT2[D3DFMT2["G32R32F"] = 115] = "G32R32F";
    D3DFMT2[D3DFMT2["A32B32G32R32F"] = 116] = "A32B32G32R32F";
    D3DFMT2[D3DFMT2["UYVY"] = $9e04c0e82ea22f13$var$fourCCToInt32("UYVY")] = "UYVY";
    D3DFMT2[D3DFMT2["R8G8_B8G8"] = $9e04c0e82ea22f13$var$fourCCToInt32("RGBG")] = "R8G8_B8G8";
    D3DFMT2[D3DFMT2["YUY2"] = $9e04c0e82ea22f13$var$fourCCToInt32("YUY2")] = "YUY2";
    D3DFMT2[D3DFMT2["D3DFMT_G8R8_G8B8"] = $9e04c0e82ea22f13$var$fourCCToInt32("GRGB")] = "D3DFMT_G8R8_G8B8";
    D3DFMT2[D3DFMT2["DXT1"] = $9e04c0e82ea22f13$var$fourCCToInt32("DXT1")] = "DXT1";
    D3DFMT2[D3DFMT2["DXT2"] = $9e04c0e82ea22f13$var$fourCCToInt32("DXT2")] = "DXT2";
    D3DFMT2[D3DFMT2["DXT3"] = $9e04c0e82ea22f13$var$fourCCToInt32("DXT3")] = "DXT3";
    D3DFMT2[D3DFMT2["DXT4"] = $9e04c0e82ea22f13$var$fourCCToInt32("DXT4")] = "DXT4";
    D3DFMT2[D3DFMT2["DXT5"] = $9e04c0e82ea22f13$var$fourCCToInt32("DXT5")] = "DXT5";
    D3DFMT2[D3DFMT2["ATI1"] = $9e04c0e82ea22f13$var$fourCCToInt32("ATI1")] = "ATI1";
    D3DFMT2[D3DFMT2["AT1N"] = $9e04c0e82ea22f13$var$fourCCToInt32("AT1N")] = "AT1N";
    D3DFMT2[D3DFMT2["ATI2"] = $9e04c0e82ea22f13$var$fourCCToInt32("ATI2")] = "ATI2";
    D3DFMT2[D3DFMT2["AT2N"] = $9e04c0e82ea22f13$var$fourCCToInt32("AT2N")] = "AT2N";
    D3DFMT2[D3DFMT2["BC4U"] = $9e04c0e82ea22f13$var$fourCCToInt32("BC4U")] = "BC4U";
    D3DFMT2[D3DFMT2["BC4S"] = $9e04c0e82ea22f13$var$fourCCToInt32("BC4S")] = "BC4S";
    D3DFMT2[D3DFMT2["BC5U"] = $9e04c0e82ea22f13$var$fourCCToInt32("BC5U")] = "BC5U";
    D3DFMT2[D3DFMT2["BC5S"] = $9e04c0e82ea22f13$var$fourCCToInt32("BC5S")] = "BC5S";
    D3DFMT2[D3DFMT2["DX10"] = $9e04c0e82ea22f13$var$fourCCToInt32("DX10")] = "DX10";
    return D3DFMT2;
})($9e04c0e82ea22f13$export$880df6e30a43b81e || {});
const $9e04c0e82ea22f13$export$645d02aa74a9eea1 = {
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.DXT1]: "bc1-rgba-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.DXT2]: "bc2-rgba-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.DXT3]: "bc2-rgba-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.DXT4]: "bc3-rgba-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.DXT5]: "bc3-rgba-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.ATI1]: "bc4-r-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.BC4U]: "bc4-r-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.BC4S]: "bc4-r-snorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.ATI2]: "bc5-rg-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.BC5U]: "bc5-rg-unorm",
    [$9e04c0e82ea22f13$export$880df6e30a43b81e.BC5S]: "bc5-rg-snorm",
    [36 /* A16B16G16R16 */ ]: "rgba16uint",
    [110 /* Q16W16V16U16 */ ]: "rgba16sint",
    [111 /* R16F */ ]: "r16float",
    [112 /* G16R16F */ ]: "rg16float",
    [113 /* A16B16G16R16F */ ]: "rgba16float",
    [114 /* R32F */ ]: "r32float",
    [115 /* G32R32F */ ]: "rg32float",
    [116 /* A32B32G32R32F */ ]: "rgba32float"
};
const $9e04c0e82ea22f13$export$29d7d78292b12a5a = {
    [70 /* DXGI_FORMAT_BC1_TYPELESS */ ]: "bc1-rgba-unorm",
    [71 /* DXGI_FORMAT_BC1_UNORM */ ]: "bc1-rgba-unorm",
    [72 /* DXGI_FORMAT_BC1_UNORM_SRGB */ ]: "bc1-rgba-unorm-srgb",
    [73 /* DXGI_FORMAT_BC2_TYPELESS */ ]: "bc2-rgba-unorm",
    [74 /* DXGI_FORMAT_BC2_UNORM */ ]: "bc2-rgba-unorm",
    [75 /* DXGI_FORMAT_BC2_UNORM_SRGB */ ]: "bc2-rgba-unorm-srgb",
    [76 /* DXGI_FORMAT_BC3_TYPELESS */ ]: "bc3-rgba-unorm",
    [77 /* DXGI_FORMAT_BC3_UNORM */ ]: "bc3-rgba-unorm",
    [78 /* DXGI_FORMAT_BC3_UNORM_SRGB */ ]: "bc3-rgba-unorm-srgb",
    [79 /* DXGI_FORMAT_BC4_TYPELESS */ ]: "bc4-r-unorm",
    [80 /* DXGI_FORMAT_BC4_UNORM */ ]: "bc4-r-unorm",
    [81 /* DXGI_FORMAT_BC4_SNORM */ ]: "bc4-r-snorm",
    [82 /* DXGI_FORMAT_BC5_TYPELESS */ ]: "bc5-rg-unorm",
    [83 /* DXGI_FORMAT_BC5_UNORM */ ]: "bc5-rg-unorm",
    [84 /* DXGI_FORMAT_BC5_SNORM */ ]: "bc5-rg-snorm",
    [94 /* DXGI_FORMAT_BC6H_TYPELESS */ ]: "bc6h-rgb-ufloat",
    [95 /* DXGI_FORMAT_BC6H_UF16 */ ]: "bc6h-rgb-ufloat",
    [96 /* DXGI_FORMAT_BC6H_SF16 */ ]: "bc6h-rgb-float",
    [97 /* DXGI_FORMAT_BC7_TYPELESS */ ]: "bc7-rgba-unorm",
    [98 /* DXGI_FORMAT_BC7_UNORM */ ]: "bc7-rgba-unorm",
    [99 /* DXGI_FORMAT_BC7_UNORM_SRGB */ ]: "bc7-rgba-unorm-srgb",
    [28 /* DXGI_FORMAT_R8G8B8A8_UNORM */ ]: "rgba8unorm",
    [29 /* DXGI_FORMAT_R8G8B8A8_UNORM_SRGB */ ]: "rgba8unorm-srgb",
    [87 /* DXGI_FORMAT_B8G8R8A8_UNORM */ ]: "bgra8unorm",
    [91 /* DXGI_FORMAT_B8G8R8A8_UNORM_SRGB */ ]: "bgra8unorm-srgb",
    [41 /* DXGI_FORMAT_R32_FLOAT */ ]: "r32float",
    [49 /* DXGI_FORMAT_R8G8_UNORM */ ]: "rg8unorm",
    [56 /* DXGI_FORMAT_R16_UNORM */ ]: "r16uint",
    [61 /* DXGI_FORMAT_R8_UNORM */ ]: "r8unorm",
    [24 /* DXGI_FORMAT_R10G10B10A2_UNORM */ ]: "rgb10a2unorm",
    [11 /* DXGI_FORMAT_R16G16B16A16_UNORM */ ]: "rgba16uint",
    [13 /* DXGI_FORMAT_R16G16B16A16_SNORM */ ]: "rgba16sint",
    [10 /* DXGI_FORMAT_R16G16B16A16_FLOAT */ ]: "rgba16float",
    [54 /* DXGI_FORMAT_R16_FLOAT */ ]: "r16float",
    [34 /* DXGI_FORMAT_R16G16_FLOAT */ ]: "rg16float",
    [16 /* DXGI_FORMAT_R32G32_FLOAT */ ]: "rg32float",
    [2 /* DXGI_FORMAT_R32G32B32A32_FLOAT */ ]: "rgba32float"
};
const $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f = {
    MAGIC_VALUE: 542327876,
    MAGIC_SIZE: 4,
    HEADER_SIZE: 124,
    HEADER_DX10_SIZE: 20,
    PIXEL_FORMAT_FLAGS: {
        // PIXEL_FORMAT flags
        // https://github.com/Microsoft/DirectXTex/blob/main/DirectXTex/DDS.h
        // https://learn.microsoft.com/en-us/windows/win32/direct3ddds/dds-pixelformat
        ALPHAPIXELS: 1,
        ALPHA: 2,
        FOURCC: 4,
        RGB: 64,
        RGBA: 65,
        YUV: 512,
        LUMINANCE: 131072,
        LUMINANCEA: 131073
    },
    RESOURCE_MISC_TEXTURECUBE: 4,
    HEADER_FIELDS: $9e04c0e82ea22f13$var$DDS_HEADER_FIELDS,
    HEADER_DX10_FIELDS: $9e04c0e82ea22f13$var$DDS_DX10_FIELDS,
    DXGI_FORMAT: $9e04c0e82ea22f13$export$63577c11dea0d1a7,
    D3D10_RESOURCE_DIMENSION: $9e04c0e82ea22f13$export$3ccf46595e182c3,
    D3DFMT: $9e04c0e82ea22f13$export$880df6e30a43b81e
};
const $9e04c0e82ea22f13$export$1a937d351642c109 = {
    "bc1-rgba-unorm": 8,
    "bc1-rgba-unorm-srgb": 8,
    "bc2-rgba-unorm": 16,
    "bc2-rgba-unorm-srgb": 16,
    "bc3-rgba-unorm": 16,
    "bc3-rgba-unorm-srgb": 16,
    "bc4-r-unorm": 8,
    "bc4-r-snorm": 8,
    "bc5-rg-unorm": 16,
    "bc5-rg-snorm": 16,
    "bc6h-rgb-ufloat": 16,
    "bc6h-rgb-float": 16,
    "bc7-rgba-unorm": 16,
    "bc7-rgba-unorm-srgb": 16
};



var $8nmJS = parcelRequire("8nmJS");



var $aZ9ZN = parcelRequire("aZ9ZN");



"use strict";
function $26d6dd59db82a2cd$export$cddc4925efe88ac(arrayBuffer, supportedFormats) {
    const { format: format, fourCC: fourCC, width: width, height: height, dataOffset: dataOffset, mipmapCount: mipmapCount } = $26d6dd59db82a2cd$var$parseDDSHeader(arrayBuffer);
    if (!supportedFormats.includes(format)) throw new Error(`Unsupported texture format: ${fourCC} ${format}, supported: ${supportedFormats}`);
    if (mipmapCount <= 1) return {
        format: format,
        width: width,
        height: height,
        resource: [
            new Uint8Array(arrayBuffer, dataOffset)
        ],
        alphaMode: "no-premultiply-alpha"
    };
    const levelBuffers = $26d6dd59db82a2cd$var$getMipmapLevelBuffers(format, width, height, dataOffset, mipmapCount, arrayBuffer);
    const textureOptions = {
        format: format,
        width: width,
        height: height,
        resource: levelBuffers,
        alphaMode: "no-premultiply-alpha"
    };
    return textureOptions;
}
function $26d6dd59db82a2cd$var$getMipmapLevelBuffers(format, width, height, dataOffset, mipmapCount, arrayBuffer) {
    const levelBuffers = [];
    const blockBytes = (0, $9e04c0e82ea22f13$export$1a937d351642c109)[format];
    let mipWidth = width;
    let mipHeight = height;
    let offset = dataOffset;
    for(let level = 0; level < mipmapCount; ++level){
        const alignedWidth = Math.ceil(Math.max(4, mipWidth) / 4) * 4;
        const alignedHeight = Math.ceil(Math.max(4, mipHeight) / 4) * 4;
        const byteLength = blockBytes ? alignedWidth / 4 * alignedHeight / 4 * blockBytes : mipWidth * mipHeight * 4;
        const levelBuffer = new Uint8Array(arrayBuffer, offset, byteLength);
        levelBuffers.push(levelBuffer);
        offset += byteLength;
        mipWidth = Math.max(mipWidth >> 1, 1);
        mipHeight = Math.max(mipHeight >> 1, 1);
    }
    return levelBuffers;
}
function $26d6dd59db82a2cd$var$parseDDSHeader(buffer) {
    const header = new Uint32Array(buffer, 0, (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT);
    if (header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.MAGIC] !== (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).MAGIC_VALUE) throw new Error("Invalid magic number in DDS header");
    const height = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.HEIGHT];
    const width = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.WIDTH];
    const mipmapCount = Math.max(1, header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.MIPMAP_COUNT]);
    const flags = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.PF_FLAGS];
    const fourCC = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.FOURCC];
    const format = $26d6dd59db82a2cd$var$getTextureFormat(header, flags, fourCC, buffer);
    const dataOffset = (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).MAGIC_SIZE + (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_SIZE + (fourCC === (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).D3DFMT.DX10 ? (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_DX10_SIZE : 0);
    return {
        format: format,
        fourCC: fourCC,
        width: width,
        height: height,
        dataOffset: dataOffset,
        mipmapCount: mipmapCount
    };
}
function $26d6dd59db82a2cd$var$getTextureFormat(header, flags, fourCC, buffer) {
    if (flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.FOURCC) {
        if (fourCC === (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).D3DFMT.DX10) {
            const dx10Header = new Uint32Array(buffer, (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).MAGIC_SIZE + (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_SIZE, // there is a 20-byte DDS_HEADER_DX10 after DDS_HEADER
            (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT);
            const miscFlag = dx10Header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_DX10_FIELDS.MISC_FLAG];
            if (miscFlag === (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).RESOURCE_MISC_TEXTURECUBE) throw new Error("DDSParser does not support cubemap textures");
            const resourceDimension = dx10Header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_DX10_FIELDS.RESOURCE_DIMENSION];
            if (resourceDimension === (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).D3D10_RESOURCE_DIMENSION.DDS_DIMENSION_TEXTURE3D) throw new Error("DDSParser does not supported 3D texture data");
            const dxgiFormat = dx10Header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_DX10_FIELDS.DXGI_FORMAT];
            if (dxgiFormat in (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[dxgiFormat];
            throw new Error(`DDSParser cannot parse texture data with DXGI format ${dxgiFormat}`);
        }
        if (fourCC in (0, $9e04c0e82ea22f13$export$645d02aa74a9eea1)) return (0, $9e04c0e82ea22f13$export$645d02aa74a9eea1)[fourCC];
        throw new Error(`DDSParser cannot parse texture data with fourCC format ${fourCC}`);
    }
    if (flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.RGB || flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.RGBA) return $26d6dd59db82a2cd$var$getUncompressedTextureFormat(header);
    if (flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.YUV) throw new Error("DDSParser does not supported YUV uncompressed texture data.");
    if (flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.LUMINANCE || flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.LUMINANCEA) throw new Error("DDSParser does not support single-channel (lumninance) texture data!");
    if (flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.ALPHA || flags & (0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).PIXEL_FORMAT_FLAGS.ALPHAPIXELS) throw new Error("DDSParser does not support single-channel (alpha) texture data!");
    throw new Error("DDSParser failed to load a texture file due to an unknown reason!");
}
function $26d6dd59db82a2cd$var$getUncompressedTextureFormat(header) {
    const bitCount = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.RGB_BITCOUNT];
    const rBitMask = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.R_BIT_MASK];
    const gBitMask = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.G_BIT_MASK];
    const bBitMask = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.B_BIT_MASK];
    const aBitMask = header[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).HEADER_FIELDS.A_BIT_MASK];
    switch(bitCount){
        case 32:
            if (rBitMask === 255 && gBitMask === 65280 && bBitMask === 16711680 && aBitMask === 4278190080) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R8G8B8A8_UNORM];
            if (rBitMask === 16711680 && gBitMask === 65280 && bBitMask === 255 && aBitMask === 4278190080) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_B8G8R8A8_UNORM];
            if (rBitMask === 1072693248 && gBitMask === 1047552 && bBitMask === 1023 && aBitMask === 3221225472) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R10G10B10A2_UNORM];
            if (rBitMask === 65535 && gBitMask === 4294901760 && bBitMask === 0 && aBitMask === 0) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R16G16_UNORM];
            if (rBitMask === 4294967295 && gBitMask === 0 && bBitMask === 0 && aBitMask === 0) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R32_FLOAT];
            break;
        case 24:
            rBitMask === 16711680 && gBitMask === 65280 && bBitMask === 255 && aBitMask;
            break;
        case 16:
            if (rBitMask === 31744 && gBitMask === 992 && bBitMask === 31 && aBitMask === 32768) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_B5G5R5A1_UNORM];
            if (rBitMask === 63488 && gBitMask === 2016 && bBitMask === 31 && aBitMask === 0) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_B5G6R5_UNORM];
            if (rBitMask === 3840 && gBitMask === 240 && bBitMask === 15 && aBitMask === 61440) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_B4G4R4A4_UNORM];
            if (rBitMask === 255 && gBitMask === 0 && bBitMask === 0 && aBitMask === 65280) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R8G8_UNORM];
            if (rBitMask === 65535 && gBitMask === 0 && bBitMask === 0 && aBitMask === 0) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R16_UNORM];
            break;
        case 8:
            if (rBitMask === 255 && gBitMask === 0 && bBitMask === 0 && aBitMask === 0) return (0, $9e04c0e82ea22f13$export$29d7d78292b12a5a)[(0, $9e04c0e82ea22f13$export$dc59dbc3f53e2d2f).DXGI_FORMAT.DXGI_FORMAT_R8_UNORM];
            break;
    }
    throw new Error(`DDSParser does not support uncompressed texture with configuration:
                bitCount = ${bitCount}, rBitMask = ${rBitMask}, gBitMask = ${gBitMask}, aBitMask = ${aBitMask}`);
}


"use strict";
const $86e900f693d9ceb2$export$20ea358dd867fe3e = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).High,
        name: "loadDDS"
    },
    /** used for deprecation purposes */ name: "loadDDS",
    id: "dds",
    test (url) {
        return (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, [
            ".dds"
        ]);
    },
    async load (url, _asset, loader) {
        const supportedTextures = await (0, $06cbf1322a912ae5$export$6ce110edff12c69)();
        const ddsResponse = await fetch(url);
        const ddsArrayBuffer = await ddsResponse.arrayBuffer();
        const textureOptions = (0, $26d6dd59db82a2cd$export$cddc4925efe88ac)(ddsArrayBuffer, supportedTextures);
        const compressedTextureSource = new (0, $81ada49b5e64f85d$export$19b6a4fc54276638)(textureOptions);
        return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(compressedTextureSource, loader, url);
    },
    unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};




var $8nmJS = parcelRequire("8nmJS");



var $aZ9ZN = parcelRequire("aZ9ZN");


"use strict";
var $afa636417037c4e5$export$99fd6651d3c0e2bf = /* @__PURE__ */ ((GL_INTERNAL_FORMAT2)=>{
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["RGBA8_SNORM"] = 36759] = "RGBA8_SNORM";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["RGBA"] = 6408] = "RGBA";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["RGBA8UI"] = 36220] = "RGBA8UI";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["SRGB8_ALPHA8"] = 35907] = "SRGB8_ALPHA8";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["RGBA8I"] = 36238] = "RGBA8I";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["RGBA8"] = 32856] = "RGBA8";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RED_RGTC1_EXT"] = 36283] = "COMPRESSED_RED_RGTC1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SIGNED_RED_RGTC1_EXT"] = 36284] = "COMPRESSED_SIGNED_RED_RGTC1_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RED_GREEN_RGTC2_EXT"] = 36285] = "COMPRESSED_RED_GREEN_RGTC2_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT"] = 36286] = "COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ETC2"] = 37493] = "COMPRESSED_SRGB8_ETC2";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_4x4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_5x4_KHR"] = 37809] = "COMPRESSED_RGBA_ASTC_5x4_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_5x5_KHR"] = 37810] = "COMPRESSED_RGBA_ASTC_5x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_6x5_KHR"] = 37811] = "COMPRESSED_RGBA_ASTC_6x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_6x6_KHR"] = 37812] = "COMPRESSED_RGBA_ASTC_6x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_8x5_KHR"] = 37813] = "COMPRESSED_RGBA_ASTC_8x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_8x6_KHR"] = 37814] = "COMPRESSED_RGBA_ASTC_8x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_8x8_KHR"] = 37815] = "COMPRESSED_RGBA_ASTC_8x8_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_10x5_KHR"] = 37816] = "COMPRESSED_RGBA_ASTC_10x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_10x6_KHR"] = 37817] = "COMPRESSED_RGBA_ASTC_10x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_10x8_KHR"] = 37818] = "COMPRESSED_RGBA_ASTC_10x8_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_10x10_KHR"] = 37819] = "COMPRESSED_RGBA_ASTC_10x10_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_12x10_KHR"] = 37820] = "COMPRESSED_RGBA_ASTC_12x10_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_ASTC_12x12_KHR"] = 37821] = "COMPRESSED_RGBA_ASTC_12x12_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR"] = 37840] = "COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR"] = 37841] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR"] = 37842] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR"] = 37843] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR"] = 37844] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR"] = 37845] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR"] = 37846] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR"] = 37847] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR"] = 37848] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR"] = 37849] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR"] = 37850] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR"] = 37851] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR"] = 37852] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR"] = 37853] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGBA_BPTC_UNORM_EXT"] = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT"] = 36493] = "COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT"] = 36494] = "COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT";
    GL_INTERNAL_FORMAT2[GL_INTERNAL_FORMAT2["COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT"] = 36495] = "COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT";
    return GL_INTERNAL_FORMAT2;
})($afa636417037c4e5$export$99fd6651d3c0e2bf || {});
var $afa636417037c4e5$var$GL_FORMATS = /* @__PURE__ */ ((GL_FORMATS2)=>{
    GL_FORMATS2[GL_FORMATS2["RGBA"] = 6408] = "RGBA";
    GL_FORMATS2[GL_FORMATS2["RGB"] = 6407] = "RGB";
    GL_FORMATS2[GL_FORMATS2["RG"] = 33319] = "RG";
    GL_FORMATS2[GL_FORMATS2["RED"] = 6403] = "RED";
    GL_FORMATS2[GL_FORMATS2["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RG_INTEGER"] = 33320] = "RG_INTEGER";
    GL_FORMATS2[GL_FORMATS2["RED_INTEGER"] = 36244] = "RED_INTEGER";
    GL_FORMATS2[GL_FORMATS2["ALPHA"] = 6406] = "ALPHA";
    GL_FORMATS2[GL_FORMATS2["LUMINANCE"] = 6409] = "LUMINANCE";
    GL_FORMATS2[GL_FORMATS2["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    GL_FORMATS2[GL_FORMATS2["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    GL_FORMATS2[GL_FORMATS2["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
    return GL_FORMATS2;
})($afa636417037c4e5$var$GL_FORMATS || {});
var $afa636417037c4e5$var$GL_TYPES = /* @__PURE__ */ ((GL_TYPES2)=>{
    GL_TYPES2[GL_TYPES2["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    GL_TYPES2[GL_TYPES2["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    GL_TYPES2[GL_TYPES2["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    GL_TYPES2[GL_TYPES2["BYTE"] = 5120] = "BYTE";
    GL_TYPES2[GL_TYPES2["SHORT"] = 5122] = "SHORT";
    GL_TYPES2[GL_TYPES2["INT"] = 5124] = "INT";
    GL_TYPES2[GL_TYPES2["FLOAT"] = 5126] = "FLOAT";
    GL_TYPES2[GL_TYPES2["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    GL_TYPES2[GL_TYPES2["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
    return GL_TYPES2;
})($afa636417037c4e5$var$GL_TYPES || {});
const $afa636417037c4e5$var$INTERNAL_FORMAT_TO_TEXTURE_FORMATS = {
    [33776 /* COMPRESSED_RGB_S3TC_DXT1_EXT */ ]: "bc1-rgba-unorm",
    // TODO: ???
    [33777 /* COMPRESSED_RGBA_S3TC_DXT1_EXT */ ]: "bc1-rgba-unorm",
    [33778 /* COMPRESSED_RGBA_S3TC_DXT3_EXT */ ]: "bc2-rgba-unorm",
    [33779 /* COMPRESSED_RGBA_S3TC_DXT5_EXT */ ]: "bc3-rgba-unorm",
    [35916 /* COMPRESSED_SRGB_S3TC_DXT1_EXT */ ]: "bc1-rgba-unorm-srgb",
    // TODO: ???
    [35917 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT */ ]: "bc1-rgba-unorm-srgb",
    [35918 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT */ ]: "bc2-rgba-unorm-srgb",
    [35919 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT */ ]: "bc3-rgba-unorm-srgb",
    [36283 /* COMPRESSED_RED_RGTC1_EXT */ ]: "bc4-r-unorm",
    [36284 /* COMPRESSED_SIGNED_RED_RGTC1_EXT */ ]: "bc4-r-snorm",
    [36285 /* COMPRESSED_RED_GREEN_RGTC2_EXT */ ]: "bc5-rg-unorm",
    [36286 /* COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT */ ]: "bc5-rg-snorm",
    [37488 /* COMPRESSED_R11_EAC */ ]: "eac-r11unorm",
    // [GL_INTERNAL_FORMAT.COMPRESSED_SIGNED_R11_EAC]: 'eac-r11snorm',
    [37490 /* COMPRESSED_RG11_EAC */ ]: "eac-rg11snorm",
    // [GL_INTERNAL_FORMAT.COMPRESSED_SIGNED_RG11_EAC]: 'eac-rg11unorm',
    [37492 /* COMPRESSED_RGB8_ETC2 */ ]: "etc2-rgb8unorm",
    [37496 /* COMPRESSED_RGBA8_ETC2_EAC */ ]: "etc2-rgba8unorm",
    [37493 /* COMPRESSED_SRGB8_ETC2 */ ]: "etc2-rgb8unorm-srgb",
    [37497 /* COMPRESSED_SRGB8_ALPHA8_ETC2_EAC */ ]: "etc2-rgba8unorm-srgb",
    [37494 /* COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: "etc2-rgb8a1unorm",
    [37495 /* COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: "etc2-rgb8a1unorm-srgb",
    [37808 /* COMPRESSED_RGBA_ASTC_4x4_KHR */ ]: "astc-4x4-unorm",
    [37840 /* COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR */ ]: "astc-4x4-unorm-srgb",
    [37809 /* COMPRESSED_RGBA_ASTC_5x4_KHR */ ]: "astc-5x4-unorm",
    [37841 /* COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR */ ]: "astc-5x4-unorm-srgb",
    [37810 /* COMPRESSED_RGBA_ASTC_5x5_KHR */ ]: "astc-5x5-unorm",
    [37842 /* COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR */ ]: "astc-5x5-unorm-srgb",
    [37811 /* COMPRESSED_RGBA_ASTC_6x5_KHR */ ]: "astc-6x5-unorm",
    [37843 /* COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR */ ]: "astc-6x5-unorm-srgb",
    [37812 /* COMPRESSED_RGBA_ASTC_6x6_KHR */ ]: "astc-6x6-unorm",
    [37844 /* COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR */ ]: "astc-6x6-unorm-srgb",
    [37813 /* COMPRESSED_RGBA_ASTC_8x5_KHR */ ]: "astc-8x5-unorm",
    [37845 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR */ ]: "astc-8x5-unorm-srgb",
    [37814 /* COMPRESSED_RGBA_ASTC_8x6_KHR */ ]: "astc-8x6-unorm",
    [37846 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR */ ]: "astc-8x6-unorm-srgb",
    [37815 /* COMPRESSED_RGBA_ASTC_8x8_KHR */ ]: "astc-8x8-unorm",
    [37847 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR */ ]: "astc-8x8-unorm-srgb",
    [37816 /* COMPRESSED_RGBA_ASTC_10x5_KHR */ ]: "astc-10x5-unorm",
    [37848 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR */ ]: "astc-10x5-unorm-srgb",
    [37817 /* COMPRESSED_RGBA_ASTC_10x6_KHR */ ]: "astc-10x6-unorm",
    [37849 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR */ ]: "astc-10x6-unorm-srgb",
    [37818 /* COMPRESSED_RGBA_ASTC_10x8_KHR */ ]: "astc-10x8-unorm",
    [37850 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR */ ]: "astc-10x8-unorm-srgb",
    [37819 /* COMPRESSED_RGBA_ASTC_10x10_KHR */ ]: "astc-10x10-unorm",
    [37851 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR */ ]: "astc-10x10-unorm-srgb",
    [37820 /* COMPRESSED_RGBA_ASTC_12x10_KHR */ ]: "astc-12x10-unorm",
    [37852 /* COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR */ ]: "astc-12x10-unorm-srgb",
    [37821 /* COMPRESSED_RGBA_ASTC_12x12_KHR */ ]: "astc-12x12-unorm",
    [37853 /* COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR */ ]: "astc-12x12-unorm-srgb",
    [36492 /* COMPRESSED_RGBA_BPTC_UNORM_EXT */ ]: "bc7-rgba-unorm",
    [36493 /* COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT */ ]: "bc7-rgba-unorm-srgb",
    [36494 /* COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT */ ]: "bc6h-rgb-float",
    [36495 /* COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT */ ]: "bc6h-rgb-ufloat",
    [35907 /* SRGB8_ALPHA8 */ ]: "rgba8unorm-srgb",
    [36759 /* RGBA8_SNORM */ ]: "rgba8snorm",
    [36220 /* RGBA8UI */ ]: "rgba8uint",
    [36238 /* RGBA8I */ ]: "rgba8sint",
    [6408 /* RGBA */ ]: "rgba8unorm"
};
const $afa636417037c4e5$var$FILE_IDENTIFIER = [
    171,
    75,
    84,
    88,
    32,
    49,
    49,
    187,
    13,
    10,
    26,
    10
];
const $afa636417037c4e5$var$FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
};
const $afa636417037c4e5$var$FILE_HEADER_SIZE = 64;
const $afa636417037c4e5$var$ENDIANNESS = 67305985;
const $afa636417037c4e5$var$TYPES_TO_BYTES_PER_COMPONENT = {
    [5121 /* UNSIGNED_BYTE */ ]: 1,
    [5123 /* UNSIGNED_SHORT */ ]: 2,
    [5124 /* INT */ ]: 4,
    [5125 /* UNSIGNED_INT */ ]: 4,
    [5126 /* FLOAT */ ]: 4,
    [36193 /* HALF_FLOAT */ ]: 8
};
const $afa636417037c4e5$var$FORMATS_TO_COMPONENTS = {
    [6408 /* RGBA */ ]: 4,
    [6407 /* RGB */ ]: 3,
    [33319 /* RG */ ]: 2,
    [6403 /* RED */ ]: 1,
    [6409 /* LUMINANCE */ ]: 1,
    [6410 /* LUMINANCE_ALPHA */ ]: 2,
    [6406 /* ALPHA */ ]: 1
};
const $afa636417037c4e5$var$TYPES_TO_BYTES_PER_PIXEL = {
    [32819 /* UNSIGNED_SHORT_4_4_4_4 */ ]: 2,
    [32820 /* UNSIGNED_SHORT_5_5_5_1 */ ]: 2,
    [33635 /* UNSIGNED_SHORT_5_6_5 */ ]: 2
};
const $afa636417037c4e5$var$INTERNAL_FORMAT_TO_BYTES_PER_PIXEL = {
    [33776 /* COMPRESSED_RGB_S3TC_DXT1_EXT */ ]: 0.5,
    [33777 /* COMPRESSED_RGBA_S3TC_DXT1_EXT */ ]: 0.5,
    [33778 /* COMPRESSED_RGBA_S3TC_DXT3_EXT */ ]: 1,
    [33779 /* COMPRESSED_RGBA_S3TC_DXT5_EXT */ ]: 1,
    [35916 /* COMPRESSED_SRGB_S3TC_DXT1_EXT */ ]: 0.5,
    [35917 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT */ ]: 0.5,
    [35918 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT */ ]: 1,
    [35919 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT */ ]: 1,
    [36283 /* COMPRESSED_RED_RGTC1_EXT */ ]: 0.5,
    [36284 /* COMPRESSED_SIGNED_RED_RGTC1_EXT */ ]: 0.5,
    [36285 /* COMPRESSED_RED_GREEN_RGTC2_EXT */ ]: 1,
    [36286 /* COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT */ ]: 1,
    [37488 /* COMPRESSED_R11_EAC */ ]: 0.5,
    [37489 /* COMPRESSED_SIGNED_R11_EAC */ ]: 0.5,
    [37490 /* COMPRESSED_RG11_EAC */ ]: 1,
    [37491 /* COMPRESSED_SIGNED_RG11_EAC */ ]: 1,
    [37492 /* COMPRESSED_RGB8_ETC2 */ ]: 0.5,
    [37496 /* COMPRESSED_RGBA8_ETC2_EAC */ ]: 1,
    [37493 /* COMPRESSED_SRGB8_ETC2 */ ]: 0.5,
    [37497 /* COMPRESSED_SRGB8_ALPHA8_ETC2_EAC */ ]: 1,
    [37494 /* COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: 0.5,
    [37495 /* COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: 0.5,
    [37808 /* COMPRESSED_RGBA_ASTC_4x4_KHR */ ]: 1,
    [37840 /* COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR */ ]: 1,
    [37809 /* COMPRESSED_RGBA_ASTC_5x4_KHR */ ]: 0.8,
    [37841 /* COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR */ ]: 0.8,
    [37810 /* COMPRESSED_RGBA_ASTC_5x5_KHR */ ]: 0.64,
    [37842 /* COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR */ ]: 0.64,
    [37811 /* COMPRESSED_RGBA_ASTC_6x5_KHR */ ]: 0.53375,
    [37843 /* COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR */ ]: 0.53375,
    [37812 /* COMPRESSED_RGBA_ASTC_6x6_KHR */ ]: 0.445,
    [37844 /* COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR */ ]: 0.445,
    [37813 /* COMPRESSED_RGBA_ASTC_8x5_KHR */ ]: 0.4,
    [37845 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR */ ]: 0.4,
    [37814 /* COMPRESSED_RGBA_ASTC_8x6_KHR */ ]: 0.33375,
    [37846 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR */ ]: 0.33375,
    [37815 /* COMPRESSED_RGBA_ASTC_8x8_KHR */ ]: 0.25,
    [37847 /* COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR */ ]: 0.25,
    [37816 /* COMPRESSED_RGBA_ASTC_10x5_KHR */ ]: 0.32,
    [37848 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR */ ]: 0.32,
    [37817 /* COMPRESSED_RGBA_ASTC_10x6_KHR */ ]: 0.26625,
    [37849 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR */ ]: 0.26625,
    [37818 /* COMPRESSED_RGBA_ASTC_10x8_KHR */ ]: 0.2,
    [37850 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR */ ]: 0.2,
    [37819 /* COMPRESSED_RGBA_ASTC_10x10_KHR */ ]: 0.16,
    [37851 /* COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR */ ]: 0.16,
    [37820 /* COMPRESSED_RGBA_ASTC_12x10_KHR */ ]: 0.13375,
    [37852 /* COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR */ ]: 0.13375,
    [37821 /* COMPRESSED_RGBA_ASTC_12x12_KHR */ ]: 0.11125,
    [37853 /* COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR */ ]: 0.11125,
    [36492 /* COMPRESSED_RGBA_BPTC_UNORM_EXT */ ]: 1,
    [36493 /* COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT */ ]: 1,
    [36494 /* COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT */ ]: 1,
    [36495 /* COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT */ ]: 1
};
const $afa636417037c4e5$export$6f3d89c89e56fc17 = {
    FILE_HEADER_SIZE: $afa636417037c4e5$var$FILE_HEADER_SIZE,
    FILE_IDENTIFIER: $afa636417037c4e5$var$FILE_IDENTIFIER,
    FORMATS_TO_COMPONENTS: $afa636417037c4e5$var$FORMATS_TO_COMPONENTS,
    INTERNAL_FORMAT_TO_BYTES_PER_PIXEL: $afa636417037c4e5$var$INTERNAL_FORMAT_TO_BYTES_PER_PIXEL,
    INTERNAL_FORMAT_TO_TEXTURE_FORMATS: $afa636417037c4e5$var$INTERNAL_FORMAT_TO_TEXTURE_FORMATS,
    FIELDS: $afa636417037c4e5$var$FIELDS,
    TYPES_TO_BYTES_PER_COMPONENT: $afa636417037c4e5$var$TYPES_TO_BYTES_PER_COMPONENT,
    TYPES_TO_BYTES_PER_PIXEL: $afa636417037c4e5$var$TYPES_TO_BYTES_PER_PIXEL,
    ENDIANNESS: $afa636417037c4e5$var$ENDIANNESS
};


"use strict";
function $1b31128f1a8a0394$export$58a6abed7fd55190(arrayBuffer, supportedFormats) {
    const dataView = new DataView(arrayBuffer);
    if (!$1b31128f1a8a0394$var$validate(dataView)) throw new Error("Invalid KTX identifier in header");
    const { littleEndian: littleEndian, glType: glType, glFormat: glFormat, glInternalFormat: glInternalFormat, pixelWidth: pixelWidth, pixelHeight: pixelHeight, numberOfMipmapLevels: numberOfMipmapLevels, offset: offset } = $1b31128f1a8a0394$var$parseKTXHeader(dataView);
    const textureFormat = (0, $afa636417037c4e5$export$6f3d89c89e56fc17).INTERNAL_FORMAT_TO_TEXTURE_FORMATS[glInternalFormat];
    if (!textureFormat) throw new Error(`Unknown texture format ${glInternalFormat}`);
    if (!supportedFormats.includes(textureFormat)) throw new Error(`Unsupported texture format: ${textureFormat}, supportedFormats: ${supportedFormats}`);
    const imagePixelByteSize = $1b31128f1a8a0394$var$getImagePixelByteSize(glType, glFormat, glInternalFormat);
    const imageBuffers = $1b31128f1a8a0394$var$getImageBuffers(dataView, glType, imagePixelByteSize, pixelWidth, pixelHeight, offset, numberOfMipmapLevels, littleEndian);
    return {
        format: textureFormat,
        width: pixelWidth,
        height: pixelHeight,
        resource: imageBuffers,
        alphaMode: "no-premultiply-alpha"
    };
}
function $1b31128f1a8a0394$var$getImageBuffers(dataView, glType, imagePixelByteSize, pixelWidth, pixelHeight, offset, numberOfMipmapLevels, littleEndian) {
    const alignedWidth = pixelWidth + 3 & -4;
    const alignedHeight = pixelHeight + 3 & -4;
    let imagePixels = pixelWidth * pixelHeight;
    if (glType === 0) imagePixels = alignedWidth * alignedHeight;
    let mipByteSize = imagePixels * imagePixelByteSize;
    let mipWidth = pixelWidth;
    let mipHeight = pixelHeight;
    let alignedMipWidth = alignedWidth;
    let alignedMipHeight = alignedHeight;
    let imageOffset = offset;
    const imageBuffers = new Array(numberOfMipmapLevels);
    for(let mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
        const imageSize = dataView.getUint32(imageOffset, littleEndian);
        let elementOffset = imageOffset + 4;
        imageBuffers[mipmapLevel] = new Uint8Array(dataView.buffer, elementOffset, mipByteSize);
        elementOffset += mipByteSize;
        imageOffset += imageSize + 4;
        imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset;
        mipWidth = mipWidth >> 1 || 1;
        mipHeight = mipHeight >> 1 || 1;
        alignedMipWidth = mipWidth + 4 - 1 & -4;
        alignedMipHeight = mipHeight + 4 - 1 & -4;
        mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
    }
    return imageBuffers;
}
function $1b31128f1a8a0394$var$getImagePixelByteSize(glType, glFormat, glInternalFormat) {
    let imagePixelByteSize = (0, $afa636417037c4e5$export$6f3d89c89e56fc17).INTERNAL_FORMAT_TO_BYTES_PER_PIXEL[glInternalFormat];
    if (glType !== 0) {
        if ((0, $afa636417037c4e5$export$6f3d89c89e56fc17).TYPES_TO_BYTES_PER_COMPONENT[glType]) imagePixelByteSize = (0, $afa636417037c4e5$export$6f3d89c89e56fc17).TYPES_TO_BYTES_PER_COMPONENT[glType] * (0, $afa636417037c4e5$export$6f3d89c89e56fc17).FORMATS_TO_COMPONENTS[glFormat];
        else imagePixelByteSize = (0, $afa636417037c4e5$export$6f3d89c89e56fc17).TYPES_TO_BYTES_PER_PIXEL[glType];
    }
    if (imagePixelByteSize === void 0) throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
    return imagePixelByteSize;
}
function $1b31128f1a8a0394$var$parseKTXHeader(dataView) {
    const littleEndian = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.ENDIANNESS, true) === (0, $afa636417037c4e5$export$6f3d89c89e56fc17).ENDIANNESS;
    const glType = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.GL_TYPE, littleEndian);
    const glFormat = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.GL_FORMAT, littleEndian);
    const glInternalFormat = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.GL_INTERNAL_FORMAT, littleEndian);
    const pixelWidth = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.PIXEL_WIDTH, littleEndian);
    const pixelHeight = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.PIXEL_HEIGHT, littleEndian) || 1;
    const pixelDepth = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.PIXEL_DEPTH, littleEndian) || 1;
    const numberOfArrayElements = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1;
    const numberOfFaces = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.NUMBER_OF_FACES, littleEndian);
    const numberOfMipmapLevels = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian);
    const bytesOfKeyValueData = dataView.getUint32((0, $afa636417037c4e5$export$6f3d89c89e56fc17).FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
    if (pixelHeight === 0 || pixelDepth !== 1) throw new Error("Only 2D textures are supported");
    if (numberOfFaces !== 1) throw new Error("CubeTextures are not supported by KTXLoader yet!");
    if (numberOfArrayElements !== 1) throw new Error("WebGL does not support array textures");
    return {
        littleEndian: littleEndian,
        glType: glType,
        glFormat: glFormat,
        glInternalFormat: glInternalFormat,
        pixelWidth: pixelWidth,
        pixelHeight: pixelHeight,
        numberOfMipmapLevels: numberOfMipmapLevels,
        offset: (0, $afa636417037c4e5$export$6f3d89c89e56fc17).FILE_HEADER_SIZE + bytesOfKeyValueData
    };
}
function $1b31128f1a8a0394$var$validate(dataView) {
    for(let i = 0; i < (0, $afa636417037c4e5$export$6f3d89c89e56fc17).FILE_IDENTIFIER.length; i++){
        if (dataView.getUint8(i) !== (0, $afa636417037c4e5$export$6f3d89c89e56fc17).FILE_IDENTIFIER[i]) return false;
    }
    return true;
}


"use strict";
const $eaadb6d761c04f3d$export$e59f5413434dd0e3 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).High,
        name: "loadKTX"
    },
    /** used for deprecation purposes */ name: "loadKTX",
    id: "ktx",
    test (url) {
        return (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, ".ktx");
    },
    async load (url, _asset, loader) {
        const supportedTextures = await (0, $06cbf1322a912ae5$export$6ce110edff12c69)();
        const ktxResponse = await fetch(url);
        const ktxArrayBuffer = await ktxResponse.arrayBuffer();
        const textureOptions = (0, $1b31128f1a8a0394$export$58a6abed7fd55190)(ktxArrayBuffer, supportedTextures);
        const compressedTextureSource = new (0, $81ada49b5e64f85d$export$19b6a4fc54276638)(textureOptions);
        return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(compressedTextureSource, loader, url);
    },
    unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};





var $8nmJS = parcelRequire("8nmJS");



var $aZ9ZN = parcelRequire("aZ9ZN");


const $955296bf2716fe7e$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const converters = {\n      rgb8unorm: {\n        convertedFormat: \"rgba8unorm\",\n        convertFunction: convertRGBtoRGBA\n      },\n      \"rgb8unorm-srgb\": {\n        convertedFormat: \"rgba8unorm-srgb\",\n        convertFunction: convertRGBtoRGBA\n      }\n    };\n    function convertFormatIfRequired(textureOptions) {\n      const format = textureOptions.format;\n      if (converters[format]) {\n        const convertFunction = converters[format].convertFunction;\n        const levelBuffers = textureOptions.resource;\n        for (let i = 0; i < levelBuffers.length; i++) {\n          levelBuffers[i] = convertFunction(levelBuffers[i]);\n        }\n        textureOptions.format = converters[format].convertedFormat;\n      }\n    }\n    function convertRGBtoRGBA(levelBuffer) {\n      const pixelCount = levelBuffer.byteLength / 3;\n      const levelBufferWithAlpha = new Uint32Array(pixelCount);\n      for (let i = 0; i < pixelCount; ++i) {\n        levelBufferWithAlpha[i] = levelBuffer[i * 3] + (levelBuffer[i * 3 + 1] << 8) + (levelBuffer[i * 3 + 2] << 16) + 4278190080;\n      }\n      return new Uint8Array(levelBufferWithAlpha.buffer);\n    }\n\n    function createLevelBuffersFromKTX(ktxTexture) {\n      const levelBuffers = [];\n      for (let i = 0; i < ktxTexture.numLevels; i++) {\n        const imageData = ktxTexture.getImageData(i, 0, 0);\n        const levelBuffer = new Uint8Array(imageData.byteLength);\n        levelBuffer.set(imageData);\n        levelBuffers.push(levelBuffer);\n      }\n      return levelBuffers;\n    }\n\n    const glFormatToGPUFormatMap = {\n      6408: \"rgba8unorm\",\n      32856: \"bgra8unorm\",\n      //\n      32857: \"rgb10a2unorm\",\n      33189: \"depth16unorm\",\n      33190: \"depth24plus\",\n      33321: \"r8unorm\",\n      33323: \"rg8unorm\",\n      33325: \"r16float\",\n      33326: \"r32float\",\n      33327: \"rg16float\",\n      33328: \"rg32float\",\n      33329: \"r8sint\",\n      33330: \"r8uint\",\n      33331: \"r16sint\",\n      33332: \"r16uint\",\n      33333: \"r32sint\",\n      33334: \"r32uint\",\n      33335: \"rg8sint\",\n      33336: \"rg8uint\",\n      33337: \"rg16sint\",\n      33338: \"rg16uint\",\n      33339: \"rg32sint\",\n      33340: \"rg32uint\",\n      33778: \"bc2-rgba-unorm\",\n      33779: \"bc3-rgba-unorm\",\n      34836: \"rgba32float\",\n      34842: \"rgba16float\",\n      35056: \"depth24plus-stencil8\",\n      35898: \"rg11b10ufloat\",\n      35901: \"rgb9e5ufloat\",\n      35907: \"rgba8unorm-srgb\",\n      // bgra8unorm-srgb\n      36012: \"depth32float\",\n      36013: \"depth32float-stencil8\",\n      36168: \"stencil8\",\n      36208: \"rgba32uint\",\n      36214: \"rgba16uint\",\n      36220: \"rgba8uint\",\n      36226: \"rgba32sint\",\n      36232: \"rgba16sint\",\n      36238: \"rgba8sint\",\n      36492: \"bc7-rgba-unorm\",\n      36756: \"r8snorm\",\n      36757: \"rg8snorm\",\n      36759: \"rgba8snorm\",\n      37496: \"etc2-rgba8unorm\",\n      37808: \"astc-4x4-unorm\"\n    };\n    function glFormatToGPUFormat(glInternalFormat) {\n      const format = glFormatToGPUFormatMap[glInternalFormat];\n      if (format) {\n        return format;\n      }\n      throw new Error(`Unsupported glInternalFormat: ${glInternalFormat}`);\n    }\n\n    const vkFormatToGPUFormatMap = {\n      23: \"rgb8unorm\",\n      // VK_FORMAT_R8G8B8_UNORM\n      37: \"rgba8unorm\",\n      // VK_FORMAT_R8G8B8A8_UNORM\n      43: \"rgba8unorm-srgb\"\n      // VK_FORMAT_R8G8B8A8_SRGB\n      // TODO add more!\n    };\n    function vkFormatToGPUFormat(vkFormat) {\n      const format = vkFormatToGPUFormatMap[vkFormat];\n      if (format) {\n        return format;\n      }\n      throw new Error(`Unsupported VkFormat: ${vkFormat}`);\n    }\n\n    function getTextureFormatFromKTXTexture(ktxTexture) {\n      if (ktxTexture.classId === 2) {\n        return vkFormatToGPUFormat(ktxTexture.vkFormat);\n      }\n      return glFormatToGPUFormat(ktxTexture.glInternalformat);\n    }\n\n    const gpuFormatToBasisTranscoderFormatMap = {\n      \"bc3-rgba-unorm\": \"BC3_RGBA\",\n      \"bc7-rgba-unorm\": \"BC7_M5_RGBA\",\n      \"etc2-rgba8unorm\": \"ETC2_RGBA\",\n      \"astc-4x4-unorm\": \"ASTC_4x4_RGBA\",\n      // Uncompressed\n      rgba8unorm: \"RGBA32\",\n      rg11b10ufloat: \"R11F_G11F_B10F\"\n    };\n    function gpuFormatToKTXBasisTranscoderFormat(transcoderFormat) {\n      const format = gpuFormatToBasisTranscoderFormatMap[transcoderFormat];\n      if (format) {\n        return format;\n      }\n      throw new Error(`Unsupported transcoderFormat: ${transcoderFormat}`);\n    }\n\n    const settings = {\n      jsUrl: \"\",\n      wasmUrl: \"\"\n    };\n    let basisTranscoderFormat;\n    let basisTranscodedTextureFormat;\n    let ktxPromise;\n    async function getKTX() {\n      if (!ktxPromise) {\n        const absoluteJsUrl = new URL(settings.jsUrl, location.origin).href;\n        const absoluteWasmUrl = new URL(settings.wasmUrl, location.origin).href;\n        importScripts(absoluteJsUrl);\n        ktxPromise = new Promise((resolve) => {\n          LIBKTX({\n            locateFile: (_file) => absoluteWasmUrl\n          }).then((libktx) => {\n            resolve(libktx);\n          });\n        });\n      }\n      return ktxPromise;\n    }\n    async function fetchKTXTexture(url, ktx) {\n      const ktx2Response = await fetch(url);\n      if (ktx2Response.ok) {\n        const ktx2ArrayBuffer = await ktx2Response.arrayBuffer();\n        return new ktx.ktxTexture(new Uint8Array(ktx2ArrayBuffer));\n      }\n      throw new Error(`Failed to load KTX(2) texture: ${url}`);\n    }\n    const preferredTranscodedFormat = [\n      \"bc7-rgba-unorm\",\n      \"astc-4x4-unorm\",\n      \"etc2-rgba8unorm\",\n      \"bc3-rgba-unorm\",\n      \"rgba8unorm\"\n    ];\n    async function load(url) {\n      const ktx = await getKTX();\n      const ktxTexture = await fetchKTXTexture(url, ktx);\n      let format;\n      if (ktxTexture.needsTranscoding) {\n        format = basisTranscodedTextureFormat;\n        const transcodeFormat = ktx.TranscodeTarget[basisTranscoderFormat];\n        const result = ktxTexture.transcodeBasis(transcodeFormat, 0);\n        if (result !== ktx.ErrorCode.SUCCESS) {\n          throw new Error(\"Unable to transcode basis texture.\");\n        }\n      } else {\n        format = getTextureFormatFromKTXTexture(ktxTexture);\n      }\n      const levelBuffers = createLevelBuffersFromKTX(ktxTexture);\n      const textureOptions = {\n        width: ktxTexture.baseWidth,\n        height: ktxTexture.baseHeight,\n        format,\n        mipLevelCount: ktxTexture.numLevels,\n        resource: levelBuffers,\n        alphaMode: \"no-premultiply-alpha\"\n      };\n      convertFormatIfRequired(textureOptions);\n      return textureOptions;\n    }\n    async function init(jsUrl, wasmUrl, supportedTextures) {\n      if (jsUrl) settings.jsUrl = jsUrl;\n      if (wasmUrl) settings.wasmUrl = wasmUrl;\n      basisTranscodedTextureFormat = preferredTranscodedFormat.filter((format) => supportedTextures.includes(format))[0];\n      basisTranscoderFormat = gpuFormatToKTXBasisTranscoderFormat(basisTranscodedTextureFormat);\n      await getKTX();\n    }\n    const messageHandlers = {\n      init: async (data) => {\n        const { jsUrl, wasmUrl, supportedTextures } = data;\n        await init(jsUrl, wasmUrl, supportedTextures);\n      },\n      load: async (data) => {\n        try {\n          const textureOptions = await load(data.url);\n          return {\n            type: \"load\",\n            url: data.url,\n            success: true,\n            textureOptions,\n            transferables: textureOptions.resource?.map((arr) => arr.buffer)\n          };\n        } catch (e) {\n          throw e;\n        }\n      }\n    };\n    self.onmessage = (async (messageEvent) => {\n      const message = messageEvent.data;\n      try {\n        const response = await messageHandlers[message.type]?.(message);\n        if (response) {\n          self.postMessage(response, response.transferables);\n        }\n      } catch (err) {\n        self.postMessage({\n          type: \"error\",\n          err,\n          url: message.url\n        });\n      }\n    });\n\n})();\n";
let $955296bf2716fe7e$var$WORKER_URL = null;
class $955296bf2716fe7e$export$2e2bcd8739ae039 {
    constructor(){
        if (!$955296bf2716fe7e$var$WORKER_URL) $955296bf2716fe7e$var$WORKER_URL = URL.createObjectURL(new Blob([
            $955296bf2716fe7e$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($955296bf2716fe7e$var$WORKER_URL);
    }
}
$955296bf2716fe7e$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($955296bf2716fe7e$var$WORKER_URL) {
        URL.revokeObjectURL($955296bf2716fe7e$var$WORKER_URL);
        $955296bf2716fe7e$var$WORKER_URL = null;
    }
};


"use strict";
const $df122bf9926813fb$export$677fabc1bfa370dc = {
    jsUrl: "https://cdn.jsdelivr.net/npm/pixi.js/transcoders/ktx/libktx.js",
    wasmUrl: "https://cdn.jsdelivr.net/npm/pixi.js/transcoders/ktx/libktx.wasm"
};
function $df122bf9926813fb$export$72825d91e2d412c7(config) {
    Object.assign($df122bf9926813fb$export$677fabc1bfa370dc, config);
}


"use strict";
let $293c52f0569ea79c$var$ktxWorker;
const $293c52f0569ea79c$var$urlHash = {};
const $293c52f0569ea79c$var$errorHash = {};
function $293c52f0569ea79c$var$getKTX2Worker(supportedTextures) {
    if (!$293c52f0569ea79c$var$ktxWorker) {
        $293c52f0569ea79c$var$ktxWorker = new (0, $955296bf2716fe7e$export$2e2bcd8739ae039)().worker;
        $293c52f0569ea79c$var$ktxWorker.onmessage = (messageEvent)=>{
            const { err: err, success: success, url: url, textureOptions: textureOptions } = messageEvent.data;
            if (err) {
                $293c52f0569ea79c$var$errorHash[url](err);
                return;
            }
            if (!success) console.warn("Failed to load KTX texture", url);
            $293c52f0569ea79c$var$urlHash[url](textureOptions);
        };
        $293c52f0569ea79c$var$ktxWorker.postMessage({
            type: "init",
            jsUrl: (0, $df122bf9926813fb$export$677fabc1bfa370dc).jsUrl,
            wasmUrl: (0, $df122bf9926813fb$export$677fabc1bfa370dc).wasmUrl,
            supportedTextures: supportedTextures
        });
    }
    return $293c52f0569ea79c$var$ktxWorker;
}
function $293c52f0569ea79c$export$9cce919f1112b5d1(url, supportedTextures) {
    const ktxWorker2 = $293c52f0569ea79c$var$getKTX2Worker(supportedTextures);
    return new Promise((resolve, reject)=>{
        $293c52f0569ea79c$var$urlHash[url] = resolve;
        $293c52f0569ea79c$var$errorHash[url] = reject;
        ktxWorker2.postMessage({
            type: "load",
            url: url
        });
    });
}


"use strict";
const $4cf0b3d12f1cb8e3$export$67592f5acb5b952a = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).LoadParser,
        priority: (0, $8nmJS.LoaderParserPriority).High,
        name: "loadKTX2"
    },
    /** used for deprecation purposes */ name: "loadKTX2",
    id: "ktx2",
    test (url) {
        return (0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(url, ".ktx2");
    },
    async load (url, _asset, loader) {
        const supportedTextures = await (0, $06cbf1322a912ae5$export$6ce110edff12c69)();
        const textureOptions = await (0, $293c52f0569ea79c$export$9cce919f1112b5d1)(url, supportedTextures);
        const compressedTextureSource = new (0, $81ada49b5e64f85d$export$19b6a4fc54276638)(textureOptions);
        return (0, $9a5eddce1cc0cd00$export$37b981a8c575f415)(compressedTextureSource, loader, url);
    },
    async unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};


"use strict";
const $d97f957c7515ad3d$var$converters = {
    rgb8unorm: {
        convertedFormat: "rgba8unorm",
        convertFunction: $d97f957c7515ad3d$var$convertRGBtoRGBA
    },
    "rgb8unorm-srgb": {
        convertedFormat: "rgba8unorm-srgb",
        convertFunction: $d97f957c7515ad3d$var$convertRGBtoRGBA
    }
};
function $d97f957c7515ad3d$export$33843d4b2509fc41(textureOptions) {
    const format = textureOptions.format;
    if ($d97f957c7515ad3d$var$converters[format]) {
        const convertFunction = $d97f957c7515ad3d$var$converters[format].convertFunction;
        const levelBuffers = textureOptions.resource;
        for(let i = 0; i < levelBuffers.length; i++)levelBuffers[i] = convertFunction(levelBuffers[i]);
        textureOptions.format = $d97f957c7515ad3d$var$converters[format].convertedFormat;
    }
}
function $d97f957c7515ad3d$var$convertRGBtoRGBA(levelBuffer) {
    const pixelCount = levelBuffer.byteLength / 3;
    const levelBufferWithAlpha = new Uint32Array(pixelCount);
    for(let i = 0; i < pixelCount; ++i)levelBufferWithAlpha[i] = levelBuffer[i * 3] + (levelBuffer[i * 3 + 1] << 8) + (levelBuffer[i * 3 + 2] << 16) + 4278190080;
    return new Uint8Array(levelBufferWithAlpha.buffer);
}


"use strict";
function $9e3805bd147529fb$export$d4d75f0f7ccae646(ktxTexture) {
    const levelBuffers = [];
    for(let i = 0; i < ktxTexture.numLevels; i++){
        const imageData = ktxTexture.getImageData(i, 0, 0);
        const levelBuffer = new Uint8Array(imageData.byteLength);
        levelBuffer.set(imageData);
        levelBuffers.push(levelBuffer);
    }
    return levelBuffers;
}


"use strict";
const $b5e9aec945f2870b$var$glFormatToGPUFormatMap = {
    6408: "rgba8unorm",
    32856: "bgra8unorm",
    //
    32857: "rgb10a2unorm",
    33189: "depth16unorm",
    33190: "depth24plus",
    33321: "r8unorm",
    33323: "rg8unorm",
    33325: "r16float",
    33326: "r32float",
    33327: "rg16float",
    33328: "rg32float",
    33329: "r8sint",
    33330: "r8uint",
    33331: "r16sint",
    33332: "r16uint",
    33333: "r32sint",
    33334: "r32uint",
    33335: "rg8sint",
    33336: "rg8uint",
    33337: "rg16sint",
    33338: "rg16uint",
    33339: "rg32sint",
    33340: "rg32uint",
    33778: "bc2-rgba-unorm",
    33779: "bc3-rgba-unorm",
    34836: "rgba32float",
    34842: "rgba16float",
    35056: "depth24plus-stencil8",
    35898: "rg11b10ufloat",
    35901: "rgb9e5ufloat",
    35907: "rgba8unorm-srgb",
    // bgra8unorm-srgb
    36012: "depth32float",
    36013: "depth32float-stencil8",
    36168: "stencil8",
    36208: "rgba32uint",
    36214: "rgba16uint",
    36220: "rgba8uint",
    36226: "rgba32sint",
    36232: "rgba16sint",
    36238: "rgba8sint",
    36492: "bc7-rgba-unorm",
    36756: "r8snorm",
    36757: "rg8snorm",
    36759: "rgba8snorm",
    37496: "etc2-rgba8unorm",
    37808: "astc-4x4-unorm"
};
function $b5e9aec945f2870b$export$1a3e159e1a978397(glInternalFormat) {
    const format = $b5e9aec945f2870b$var$glFormatToGPUFormatMap[glInternalFormat];
    if (format) return format;
    throw new Error(`Unsupported glInternalFormat: ${glInternalFormat}`);
}


"use strict";
const $3fffb15b2559fb32$var$vkFormatToGPUFormatMap = {
    23: "rgb8unorm",
    // VK_FORMAT_R8G8B8_UNORM
    37: "rgba8unorm",
    // VK_FORMAT_R8G8B8A8_UNORM
    43: "rgba8unorm-srgb"
};
function $3fffb15b2559fb32$export$9615ed8c1038d56d(vkFormat) {
    const format = $3fffb15b2559fb32$var$vkFormatToGPUFormatMap[vkFormat];
    if (format) return format;
    throw new Error(`Unsupported VkFormat: ${vkFormat}`);
}


"use strict";
function $c737d87c089682f2$export$8a8b4bdf7e5c4619(ktxTexture) {
    if (ktxTexture.classId === 2) return (0, $3fffb15b2559fb32$export$9615ed8c1038d56d)(ktxTexture.vkFormat);
    return (0, $b5e9aec945f2870b$export$1a3e159e1a978397)(ktxTexture.glInternalformat);
}



"use strict";
const $8670cca3281e639a$var$gpuFormatToBasisTranscoderFormatMap = {
    "bc3-rgba-unorm": "BC3_RGBA",
    "bc7-rgba-unorm": "BC7_M5_RGBA",
    "etc2-rgba8unorm": "ETC2_RGBA",
    "astc-4x4-unorm": "ASTC_4x4_RGBA",
    // Uncompressed
    rgba8unorm: "RGBA32",
    rg11b10ufloat: "R11F_G11F_B10F"
};
function $8670cca3281e639a$export$63f8e57fd99f8e74(transcoderFormat) {
    const format = $8670cca3281e639a$var$gpuFormatToBasisTranscoderFormatMap[transcoderFormat];
    if (format) return format;
    throw new Error(`Unsupported transcoderFormat: ${transcoderFormat}`);
}






var $aZ9ZN = parcelRequire("aZ9ZN");




var $eFUj8 = parcelRequire("eFUj8");


var $aZ9ZN = parcelRequire("aZ9ZN");
"use strict";
const $6edde5168f999a27$export$dd825767c4f099d9 = [
    "basis",
    "bc7",
    "bc6h",
    "astc",
    "etc2",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac"
];
const $6edde5168f999a27$export$513de45dc484f3ba = {
    extension: (0, $aZ9ZN.ExtensionType).ResolveParser,
    test: (value)=>(0, $1e9f9ec9061a32ce$export$fd0180357b95b812)(value, [
            ".ktx",
            ".ktx2",
            ".dds"
        ]),
    parse: (value)=>{
        let format;
        const splitValue = value.split(".");
        if (splitValue.length > 2) {
            const newFormat = splitValue[splitValue.length - 2];
            if ($6edde5168f999a27$export$dd825767c4f099d9.includes(newFormat)) format = newFormat;
        } else format = splitValue[splitValue.length - 1];
        return {
            resolution: parseFloat((0, $eFUj8.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: format,
            src: value
        };
    }
};


"use strict";
let $5b34ebeab99570a4$var$compressedTextureExtensions;
const $5b34ebeab99570a4$export$c937cb7fa9e5fb43 = {
    extension: {
        type: (0, $aZ9ZN.ExtensionType).DetectionParser,
        priority: 2
    },
    test: async ()=>{
        if (await (0, $bc01c1fc77b347f9$export$216169f30082c873)()) return true;
        if ((0, $61b81e90b77f0603$export$83dc396b76015322)()) return true;
        return false;
    },
    add: async (formats)=>{
        const supportedCompressedTextureFormats = await (0, $41d1bec41d2744d8$export$6ac497591fea8412)();
        $5b34ebeab99570a4$var$compressedTextureExtensions = $5b34ebeab99570a4$var$extractExtensionsForCompressedTextureFormats(supportedCompressedTextureFormats);
        return [
            ...$5b34ebeab99570a4$var$compressedTextureExtensions,
            ...formats
        ];
    },
    remove: async (formats)=>{
        if ($5b34ebeab99570a4$var$compressedTextureExtensions) return formats.filter((f)=>!(f in $5b34ebeab99570a4$var$compressedTextureExtensions));
        return formats;
    }
};
function $5b34ebeab99570a4$var$extractExtensionsForCompressedTextureFormats(formats) {
    const extensions = [
        "basis"
    ];
    const dupeMap = {};
    formats.forEach((format)=>{
        const extension = format.split("-")[0];
        if (extension && !dupeMap[extension]) {
            dupeMap[extension] = true;
            extensions.push(extension);
        }
    });
    extensions.sort((a, b)=>{
        const aIndex = (0, $6edde5168f999a27$export$dd825767c4f099d9).indexOf(a);
        const bIndex = (0, $6edde5168f999a27$export$dd825767c4f099d9).indexOf(b);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
    });
    return extensions;
}




var $5xi4h = parcelRequire("5xi4h");

var $ar2Ly = parcelRequire("ar2Ly");

var $esrbs = parcelRequire("esrbs");

var $dJAmK = parcelRequire("dJAmK");
"use strict";
const $c275ccea7f4c9f90$var$tempBounds = new (0, $esrbs.Bounds)();
const $c275ccea7f4c9f90$var$tempMatrix = new (0, $5xi4h.Matrix)();
const $c275ccea7f4c9f90$var$tempRectangle = new (0, $ar2Ly.Rectangle)();
const $c275ccea7f4c9f90$var$_Culler = class _Culler {
    /**
   * Culls the children of a specific container based on the given view rectangle.
   * This determines which objects should be rendered and which can be skipped.
   * @param container - The container to cull. Must be a Container instance.
   * @param view - The view rectangle that defines the visible area
   * @param skipUpdateTransform - Whether to skip updating transforms for better performance
   * @example
   * ```ts
   * // Basic culling with view bounds
   * const culler = new Culler();
   * culler.cull(stage, {
   *     x: 0,
   *     y: 0,
   *     width: 800,
   *     height: 600
   * });
   *
   * // Culling to renderer screen
   * culler.cull(stage, renderer.screen, false);
   * ```
   * @remarks
   * - Recursively processes all cullable children
   * - Uses cullArea if defined, otherwise calculates bounds
   * - Performance depends on scene complexity
   * @see {@link CullingMixinConstructor.cullable} For enabling culling on objects
   * @see {@link CullingMixinConstructor.cullArea} For custom culling boundaries
   */ cull(container, view, skipUpdateTransform = true) {
        this._cullRecursive(container, view, skipUpdateTransform);
    }
    _cullRecursive(container, view, skipUpdateTransform = true) {
        if (container.cullable && container.measurable && container.includeInBuild) {
            if (container.cullArea) {
                $c275ccea7f4c9f90$var$tempRectangle.x = view.x;
                $c275ccea7f4c9f90$var$tempRectangle.y = view.y;
                $c275ccea7f4c9f90$var$tempRectangle.width = view.width;
                $c275ccea7f4c9f90$var$tempRectangle.height = view.height;
                const transform = skipUpdateTransform ? container.worldTransform : container.getGlobalTransform($c275ccea7f4c9f90$var$tempMatrix, skipUpdateTransform);
                container.culled = !$c275ccea7f4c9f90$var$tempRectangle.intersects(container.cullArea, transform);
            } else {
                const bounds = (0, $dJAmK.getGlobalBounds)(container, skipUpdateTransform, $c275ccea7f4c9f90$var$tempBounds);
                container.culled = bounds.x >= view.x + view.width || bounds.y >= view.y + view.height || bounds.x + bounds.width <= view.x || bounds.y + bounds.height <= view.y;
            }
        } else container.culled = false;
        if (!container.cullableChildren || container.culled || !container.renderable || !container.measurable || !container.includeInBuild) return;
        for(let i = 0; i < container.children.length; i++)this._cullRecursive(container.children[i], view, skipUpdateTransform);
    }
};
/**
 * A shared instance of the Culler class. Provides a global culler instance for convenience.
 * @example
 * ```ts
 * // Use the shared instance instead of creating a new one
 * Culler.shared.cull(stage, {
 *     x: 0,
 *     y: 0,
 *     width: 800,
 *     height: 600
 * });
 * ```
 * @see {@link CullerPlugin} For automatic culling using this instance
 */ $c275ccea7f4c9f90$var$_Culler.shared = new $c275ccea7f4c9f90$var$_Culler();
let $c275ccea7f4c9f90$export$94aad65d79f82fc9 = $c275ccea7f4c9f90$var$_Culler;



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $212fae6962c0570c$export$759b1da6ba5ab1e0 {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        this._renderRef = this.render.bind(this);
        this.render = ()=>{
            const updateTransform = options?.culler?.updateTransform !== true;
            (0, $c275ccea7f4c9f90$export$94aad65d79f82fc9).shared.cull(this.stage, this.renderer.screen, updateTransform);
            this.renderer.render({
                container: this.stage
            });
        };
    }
    /** @internal */ static destroy() {
        this.render = this._renderRef;
    }
}
/** @ignore */ $212fae6962c0570c$export$759b1da6ba5ab1e0.extension = {
    priority: 10,
    type: (0, $aZ9ZN.ExtensionType).Application,
    name: "culler"
};



var $cunnl = parcelRequire("cunnl");

var $g3seW = parcelRequire("g3seW");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $ds7Xo = parcelRequire("ds7Xo");

var $9FmI1 = parcelRequire("9FmI1");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $g3seW = parcelRequire("g3seW");
"use strict";
class $91ce62935e4f5f3d$export$ee59129a62c98408 {
    /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */ constructor(renderer){
        /** Array to keep track of attached DOM elements */ this._attachedDomElements = [];
        this._renderer = renderer;
        this._renderer.runners.postrender.add(this);
        this._renderer.runners.init.add(this);
        this._domElement = document.createElement("div");
        this._domElement.style.position = "absolute";
        this._domElement.style.top = "0";
        this._domElement.style.left = "0";
        this._domElement.style.pointerEvents = "none";
        this._domElement.style.zIndex = "1000";
    }
    /** Initializes the DOMPipe, setting up the main DOM element and adding it to the document body. */ init() {
        this._canvasObserver = new (0, $g3seW.CanvasObserver)({
            domElement: this._domElement,
            renderer: this._renderer
        });
    }
    /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */ addRenderable(domContainer, _instructionSet) {
        if (!this._attachedDomElements.includes(domContainer)) this._attachedDomElements.push(domContainer);
    }
    /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */ updateRenderable(_domContainer) {}
    /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */ validateRenderable(_domContainer) {
        return true;
    }
    /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */ postrender() {
        const attachedDomElements = this._attachedDomElements;
        if (attachedDomElements.length === 0) {
            this._domElement.remove();
            return;
        }
        this._canvasObserver.ensureAttached();
        for(let i = 0; i < attachedDomElements.length; i++){
            const domContainer = attachedDomElements[i];
            const element = domContainer.element;
            if (!domContainer.parent || domContainer.globalDisplayStatus < 7) {
                element?.remove();
                attachedDomElements.splice(i, 1);
                i--;
            } else {
                if (!this._domElement.contains(element)) {
                    element.style.position = "absolute";
                    element.style.pointerEvents = "auto";
                    this._domElement.appendChild(element);
                }
                const wt = domContainer.worldTransform;
                const anchor = domContainer._anchor;
                const ax = domContainer.width * anchor.x;
                const ay = domContainer.height * anchor.y;
                element.style.transformOrigin = `${ax}px ${ay}px`;
                element.style.transform = `matrix(${wt.a}, ${wt.b}, ${wt.c}, ${wt.d}, ${wt.tx - ax}, ${wt.ty - ay})`;
                element.style.opacity = domContainer.groupAlpha.toString();
            }
        }
    }
    /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */ destroy() {
        this._renderer.runners.postrender.remove(this);
        for(let i = 0; i < this._attachedDomElements.length; i++){
            const domContainer = this._attachedDomElements[i];
            domContainer.element?.remove();
        }
        this._attachedDomElements.length = 0;
        this._domElement.remove();
        this._canvasObserver.destroy();
        this._renderer = null;
    }
}
/**
 * Static property defining the extension type and name for the DOMPipe.
 * This is used to register the DOMPipe with different rendering pipelines.
 */ $91ce62935e4f5f3d$export$ee59129a62c98408.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "dom"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $91ce62935e4f5f3d$export$ee59129a62c98408));
class $c7cfeeefcf1aa19a$export$7ebec4545203b0c8 extends (0, $9FmI1.ViewContainer) {
    /**
   * @param options - The options for creating the DOM container.
   */ constructor(options = {}){
        const { element: element, anchor: anchor, ...rest } = options;
        super({
            label: "DOMContainer",
            ...rest
        });
        /** @internal */ this.renderPipeId = "dom";
        /** @internal */ this.batched = false;
        this._anchor = new (0, $ds7Xo.Point)(0, 0);
        if (anchor) this.anchor = anchor;
        this.element = options.element || document.createElement("div");
    }
    /**
   * The anchor sets the origin point of the container.
   * Controls the relative positioning of the DOM element.
   *
   * The default is `(0,0)`, this means the container's origin is the top left.
   * Setting the anchor to `(0.5,0.5)` means the container's origin is centered.
   * Setting the anchor to `(1,1)` would mean the container's origin point will be the bottom right corner.
   * @example
   * ```ts
   * const container = new DOMContainer();
   *
   * // Set anchor to center (shorthand)
   * container.anchor = 0.5;
   *
   * // Set anchor to bottom-right
   * container.anchor = { x: 1, y: 1 };
   *
   * // Set anchor to custom position
   * container.anchor = new Point(0.3, 0.7);
   * ```
   */ get anchor() {
        return this._anchor;
    }
    /**
   * Sets the anchor point of the container.
   * @param value - New anchor value:
   * - number: Sets both x and y to same value
   * - PointData: Sets x and y separately
   */ set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * Sets the DOM element for this container.
   * This will replace the current element and update the view.
   * @param value - The new DOM element to use
   * @example
   * ```ts
   * const domContainer = new DOMContainer();
   * domContainer.element = document.createElement('input');
   * ```
   */ set element(value) {
        if (this._element === value) return;
        this._element = value;
        this.onViewUpdate();
    }
    /**
   * The DOM element associated with this container.
   * @example
   * ```ts
   * const domContainer = new DOMContainer();
   * domContainer.element.innerHTML = 'Hello World!';
   * document.body.appendChild(domContainer.element);
   * ```
   */ get element() {
        return this._element;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const element = this._element;
        if (!element) {
            bounds.minX = 0;
            bounds.minY = 0;
            bounds.maxX = 0;
            bounds.maxY = 0;
            return;
        }
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
        bounds.minX = 0;
        bounds.maxX = offsetWidth;
        bounds.minY = 0;
        bounds.maxY = offsetHeight;
    }
    /**
   * Destroys this DOM container.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that
   * @example
   * domContainer.destroy();
   * domContainer.destroy(true);
   */ destroy(options = false) {
        super.destroy(options);
        this._element?.parentNode?.removeChild(this._element);
        this._element = null;
        this._anchor = null;
    }
}




var $gLw46 = parcelRequire("gLw46");

var $l8aZL = parcelRequire("l8aZL");

var $6OcRC = parcelRequire("6OcRC");
var $d744984b09e705ac$export$455426655eab1d48;
var $d744984b09e705ac$export$64f0bed4ae6f0f24;
var $d744984b09e705ac$export$1059c6e7d2ce5669;

var $agg8Z = parcelRequire("agg8Z");
$d744984b09e705ac$export$455426655eab1d48 = $agg8Z.DOMImplementation;
$d744984b09e705ac$export$64f0bed4ae6f0f24 = $agg8Z.XMLSerializer;

$d744984b09e705ac$export$1059c6e7d2ce5669 = (parcelRequire("hSVNL")).DOMParser;


"use strict";
const $fa81e2e0e0fc7316$export$5735016b32ac3391 = {
    createCanvas: (width, height)=>new OffscreenCanvas(width ?? 0, height ?? 0),
    createImage: ()=>new Image(),
    getCanvasRenderingContext2D: ()=>OffscreenCanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>globalThis.location.href,
    getFontFaceSet: ()=>globalThis.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new (0, $d744984b09e705ac$export$1059c6e7d2ce5669)();
        return parser.parseFromString(xml, "text/xml");
    }
};



var $fit0D = parcelRequire("fit0D");

var $jzHBA = parcelRequire("jzHBA");

var $jpWqm = parcelRequire("jpWqm");

var $bG9BA = parcelRequire("bG9BA");

var $5vwBy = parcelRequire("5vwBy");

var $ZTBXt = parcelRequire("ZTBXt");

var $3QWP0 = parcelRequire("3QWP0");

var $a4OU2 = parcelRequire("a4OU2");



var $fec77ece77700f4a$export$2e2bcd8739ae039 = "fn getLuminosity(c: vec3<f32>) -> f32 {\n  return 0.3 * c.r + 0.59 * c.g + 0.11 * c.b;\n}\n\nfn setLuminosity(c: vec3<f32>, lum: f32) -> vec3<f32> {\n  let d: f32 = lum - getLuminosity(c);\n  let newColor: vec3<f32> = c.rgb + vec3<f32>(d, d, d);\n\n  // clip back into legal range\n  let newLum: f32 = getLuminosity(newColor);\n  let cMin: f32 = min(newColor.r, min(newColor.g, newColor.b));\n  let cMax: f32 = max(newColor.r, max(newColor.g, newColor.b));\n\n  let t1: f32 = newLum / (newLum - cMin);\n  let t2: f32 = (1.0 - newLum) / (cMax - newLum);\n\n  let finalColor = mix(vec3<f32>(newLum, newLum, newLum), newColor, select(select(1.0, t2, cMax > 1.0), t1, cMin < 0.0));\n\n  return finalColor;\n}\n\nfn getSaturation(c: vec3<f32>) -> f32 {\n  return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));\n}\n\n// Set saturation if color components are sorted in ascending order.\nfn setSaturationMinMidMax(cSorted: vec3<f32>, s: f32) -> vec3<f32> {\n  var result: vec3<f32>;\n  if (cSorted.z > cSorted.x) {\n    let newY = (((cSorted.y - cSorted.x) * s) / (cSorted.z - cSorted.x));\n    result = vec3<f32>(0.0, newY, s);\n  } else {\n    result = vec3<f32>(0.0, 0.0, 0.0);\n  }\n  return vec3<f32>(result.x, result.y, result.z);\n}\n\nfn setSaturation(c: vec3<f32>, s: f32) -> vec3<f32> {\n    var result: vec3<f32> = c;\n\n    if (c.r <= c.g && c.r <= c.b) {\n        if (c.g <= c.b) {\n            result = setSaturationMinMidMax(result, s);\n        } else {\n            var temp: vec3<f32> = vec3<f32>(result.r, result.b, result.g);\n            temp = setSaturationMinMidMax(temp, s);\n            result = vec3<f32>(temp.r, temp.b, temp.g);\n        }\n    } else if (c.g <= c.r && c.g <= c.b) {\n        if (c.r <= c.b) {\n            var temp: vec3<f32> = vec3<f32>(result.g, result.r, result.b);\n            temp = setSaturationMinMidMax(temp, s);\n            result = vec3<f32>(temp.g, temp.r, temp.b);\n        } else {\n            var temp: vec3<f32> = vec3<f32>(result.g, result.b, result.r);\n            temp = setSaturationMinMidMax(temp, s);\n            result = vec3<f32>(temp.g, temp.b, temp.r);\n        }\n    } else {\n        if (c.r <= c.g) {\n            var temp: vec3<f32> = vec3<f32>(result.b, result.r, result.g);\n            temp = setSaturationMinMidMax(temp, s);\n            result = vec3<f32>(temp.b, temp.r, temp.g);\n        } else {\n            var temp: vec3<f32> = vec3<f32>(result.b, result.g, result.r);\n            temp = setSaturationMinMidMax(temp, s);\n            result = vec3<f32>(temp.b, temp.g, temp.r);\n        }\n    }\n\n    return result;\n}";


var $41fefffb163f8023$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\n\nout vec4 finalColor;\n\nuniform float uAlpha;\nuniform sampler2D uTexture;\n\nvoid main()\n{\n    finalColor =  texture(uTexture, vTextureCoord) * uAlpha;\n}\n";


var $a5672269fab11bef$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct AlphaUniforms {\n  uAlpha:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> alphaUniforms : AlphaUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n \n    var sample = textureSample(uTexture, uSampler, uv);\n    \n    return sample * alphaUniforms.uAlpha;\n}";


var $cf7e6f7129d47fc2$export$2e2bcd8739ae039 = "\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct BlurUniforms {\n  uStrength:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> blurUniforms : BlurUniforms;\n\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    %blur-struct%\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n\n  let filteredCord = filterTextureCoord(aPosition);\n\n  let pixelStrength = gfu.uInputSize.%dimension% * blurUniforms.uStrength;\n\n  return VSOutput(\n   filterVertexPosition(aPosition),\n    %blur-vertex-out%\n  );\n}\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  %blur-fragment-in%\n) -> @location(0) vec4<f32> {\n\n    var   finalColor = vec4(0.0);\n\n    %blur-sampling%\n\n    return finalColor;\n}";


var $bfe7c65ef8bc5e43$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nin vec4 vColor;\n\nout vec4 finalColor;\n\nuniform float uColorMatrix[20];\nuniform float uAlpha;\n\nuniform sampler2D uTexture;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * 0.2);\n    float diff = (randomValue - 0.5) *  0.5;\n\n    if (uAlpha == 0.0) {\n        finalColor = color;\n        return;\n    }\n\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    vec4 result;\n\n    result.r = (uColorMatrix[0] * color.r);\n        result.r += (uColorMatrix[1] * color.g);\n        result.r += (uColorMatrix[2] * color.b);\n        result.r += (uColorMatrix[3] * color.a);\n        result.r += uColorMatrix[4];\n\n    result.g = (uColorMatrix[5] * color.r);\n        result.g += (uColorMatrix[6] * color.g);\n        result.g += (uColorMatrix[7] * color.b);\n        result.g += (uColorMatrix[8] * color.a);\n        result.g += uColorMatrix[9];\n\n    result.b = (uColorMatrix[10] * color.r);\n       result.b += (uColorMatrix[11] * color.g);\n       result.b += (uColorMatrix[12] * color.b);\n       result.b += (uColorMatrix[13] * color.a);\n       result.b += uColorMatrix[14];\n\n    result.a = (uColorMatrix[15] * color.r);\n       result.a += (uColorMatrix[16] * color.g);\n       result.a += (uColorMatrix[17] * color.b);\n       result.a += (uColorMatrix[18] * color.a);\n       result.a += uColorMatrix[19];\n\n    vec3 rgb = mix(color.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    finalColor = vec4(rgb, result.a);\n}\n";


var $ab75df4ff3fc796a$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct ColorMatrixUniforms {\n  uColorMatrix:array<vec4<f32>, 5>,\n  uAlpha:f32,\n};\n\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n@group(1) @binding(0) var<uniform> colorMatrixUniforms : ColorMatrixUniforms;\n\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n  };\n  \nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition),\n  );\n}\n\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n) -> @location(0) vec4<f32> {\n\n\n  var c = textureSample(uTexture, uSampler, uv);\n  \n  if (colorMatrixUniforms.uAlpha == 0.0) {\n    return c;\n  }\n\n \n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.r /= c.a;\n      c.g /= c.a;\n      c.b /= c.a;\n    }\n\n    var cm = colorMatrixUniforms.uColorMatrix;\n\n\n    var result = vec4<f32>(0.);\n\n    result.r = (cm[0][0] * c.r);\n    result.r += (cm[0][1] * c.g);\n    result.r += (cm[0][2] * c.b);\n    result.r += (cm[0][3] * c.a);\n    result.r += cm[1][0];\n\n    result.g = (cm[1][1] * c.r);\n    result.g += (cm[1][2] * c.g);\n    result.g += (cm[1][3] * c.b);\n    result.g += (cm[2][0] * c.a);\n    result.g += cm[2][1];\n\n    result.b = (cm[2][2] * c.r);\n    result.b += (cm[2][3] * c.g);\n    result.b += (cm[3][0] * c.b);\n    result.b += (cm[3][1] * c.a);\n    result.b += cm[3][2];\n\n    result.a = (cm[3][3] * c.r);\n    result.a += (cm[4][0] * c.g);\n    result.a += (cm[4][1] * c.b);\n    result.a += (cm[4][2] * c.a);\n    result.a += cm[4][3];\n\n    var rgb = mix(c.rgb, result.rgb, colorMatrixUniforms.uAlpha);\n\n    rgb.r *= result.a;\n    rgb.g *= result.a;\n    rgb.b *= result.a;\n\n    return vec4(rgb, result.a);\n}";



var $hK31P = parcelRequire("hK31P");
var $a7ecc11f5b04f50c$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nin vec2 vFilterUv;\n\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform sampler2D uMapTexture;\n\nuniform vec4 uInputClamp;\nuniform highp vec4 uInputSize;\nuniform mat2 uRotation;\nuniform vec2 uScale;\n\nvoid main()\n{\n    vec4 map = texture(uMapTexture, vFilterUv);\n    \n    vec2 offset = uInputSize.zw * (uRotation * (map.xy - 0.5)) * uScale; \n\n    finalColor = texture(uTexture, clamp(vTextureCoord + offset, uInputClamp.xy, uInputClamp.zw));\n}\n";


var $317a3adc740807ea$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\nout vec2 vFilterUv;\n\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nuniform mat3 uFilterMatrix;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvec2 getFilterCoord( void )\n{\n  return ( uFilterMatrix * vec3( filterTextureCoord(), 1.0)  ).xy;\n}\n\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n    vFilterUv = getFilterCoord();\n}\n";


var $b4717776ee2d1620$export$2e2bcd8739ae039 = "\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct DisplacementUniforms {\n  uFilterMatrix:mat3x3<f32>,\n  uScale:vec2<f32>,\n  uRotation:mat2x2<f32>\n};\n\n\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> filterUniforms : DisplacementUniforms;\n@group(1) @binding(1) var uMapTexture: texture_2d<f32>;\n@group(1) @binding(2) var uMapSampler : sampler;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n    @location(1) filterUv : vec2<f32>,\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;\n}\n\nfn getSize() -> vec2<f32>\n{\n\n  \n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition),\n   getFilterCoord(aPosition)\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @location(1) filterUv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n\n    var map = textureSample(uMapTexture, uMapSampler, filterUv);\n\n    var offset =  gfu.uInputSize.zw * (filterUniforms.uRotation * (map.xy - 0.5)) * filterUniforms.uScale; \n   \n    return textureSample(uTexture, uSampler, clamp(uv + offset, gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n}";


var $f051f0eca3077c3a$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nin vec4 vColor;\n\nout vec4 finalColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uTexture;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) *  uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    finalColor = color;\n}\n";


var $02f175dd3c54583e$export$2e2bcd8739ae039 = "\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct NoiseUniforms {\n  uNoise:f32,\n  uSeed:f32,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n\n@group(1) @binding(0) var<uniform> noiseUniforms : NoiseUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}\n\nfn rand(co:vec2<f32>) -> f32\n{\n  return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\n\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @builtin(position) position: vec4<f32>\n) -> @location(0) vec4<f32> {\n\n    var pixelPosition =  globalTextureCoord(position.xy);// / (getSize());//-  gfu.uOutputFrame.xy);\n  \n    \n    var sample = textureSample(uTexture, uSampler, uv);\n    var randomValue =  rand(pixelPosition.xy * noiseUniforms.uSeed);\n    var diff = (randomValue - 0.5) * noiseUniforms.uNoise;\n  \n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (sample.a > 0.0) {\n      sample.r /= sample.a;\n      sample.g /= sample.a;\n      sample.b /= sample.a;\n    }\n\n    sample.r += diff;\n    sample.g += diff;\n    sample.b += diff;\n\n    // Premultiply alpha again.\n    sample.r *= sample.a;\n    sample.g *= sample.a;\n    sample.b *= sample.a;\n    \n    return sample;\n}";



var $ejyqD = parcelRequire("ejyqD");

var $dm63u = parcelRequire("dm63u");

var $7DmEj = parcelRequire("7DmEj");

var $7EiHV = parcelRequire("7EiHV");

var $3Go5s = parcelRequire("3Go5s");




var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $lWXRl = parcelRequire("lWXRl");

var $hK31P = parcelRequire("hK31P");


"use strict";
const $93040cbce99221cc$var$_AlphaFilter = class _AlphaFilter extends (0, $lWXRl.Filter) {
    constructor(options){
        options = {
            ..._AlphaFilter.defaultOptions,
            ...options
        };
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $a5672269fab11bef$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $a5672269fab11bef$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $hK31P.default,
            fragment: $41fefffb163f8023$export$2e2bcd8739ae039,
            name: "alpha-filter"
        });
        const { alpha: alpha, ...rest } = options;
        const alphaUniforms = new (0, $aUxJK.UniformGroup)({
            uAlpha: {
                value: alpha,
                type: "f32"
            }
        });
        super({
            ...rest,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                alphaUniforms: alphaUniforms
            }
        });
    }
    /**
   * The alpha value of the filter.
   * Controls the transparency of the filtered display object.
   * @example
   * ```ts
   * // Create filter with initial alpha
   * const filter = new AlphaFilter({ alpha: 0.5 });
   *
   * // Update alpha value dynamically
   * filter.alpha = 0.8;
   * ```
   * @default 1
   * @remarks
   * - 0 = fully transparent
   * - 1 = fully opaque
   * - Values are clamped between 0 and 1
   */ get alpha() {
        return this.resources.alphaUniforms.uniforms.uAlpha;
    }
    set alpha(value) {
        this.resources.alphaUniforms.uniforms.uAlpha = value;
    }
};
/**
 * Default options for the AlphaFilter.
 * @example
 * ```ts
 * AlphaFilter.defaultOptions = {
 *     alpha: 0.5, // Default alpha value
 * };
 * // Use default options
 * const filter = new AlphaFilter(); // Uses default alpha of 0.5
 * ```
 */ $93040cbce99221cc$var$_AlphaFilter.defaultOptions = {
    /**
   * Amount of alpha transparency to apply.
   * - 0 = fully transparent
   * - 1 = fully opaque (default)
   * @default 1
   */ alpha: 1
};
let $93040cbce99221cc$export$adbaa0de008b0d7a = $93040cbce99221cc$var$_AlphaFilter;



var $5NyEC = parcelRequire("5NyEC");

var $bfcaK = parcelRequire("bfcaK");

var $6LhOA = parcelRequire("6LhOA");

var $lWXRl = parcelRequire("lWXRl");

var $5NyEC = parcelRequire("5NyEC");

var $bfcaK = parcelRequire("bfcaK");

var $lWXRl = parcelRequire("lWXRl");

var $4kU4M = parcelRequire("4kU4M");
"use strict";
const $7e23f300d702b6d0$export$62963d757c50e400 = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};


"use strict";
const $f18201acb1d246c1$var$fragTemplate = [
    "in vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uTexture;",
    "out vec4 finalColor;",
    "void main(void)",
    "{",
    "    finalColor = vec4(0.0);",
    "    %blur%",
    "}"
].join("\n");
function $f18201acb1d246c1$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = (0, $7e23f300d702b6d0$export$62963d757c50e400)[kernelSize];
    const halfLength = kernel.length;
    let fragSource = $f18201acb1d246c1$var$fragTemplate;
    let blurLoop = "";
    const template = "finalColor += texture(uTexture, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace("%value%", kernel[value].toString());
        blurLoop += blur;
        blurLoop += "\n";
    }
    fragSource = fragSource.replace("%blur%", blurLoop);
    fragSource = fragSource.replace("%size%", kernelSize.toString());
    return fragSource;
}


"use strict";
const $23f966071940a41b$var$vertTemplate = `
    in vec2 aPosition;

    uniform float uStrength;

    out vec2 vBlurTexCoords[%size%];

    uniform vec4 uInputSize;
    uniform vec4 uOutputFrame;
    uniform vec4 uOutputTexture;

    vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;

    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

    vec2 filterTextureCoord( void )
    {
        return aPosition * (uOutputFrame.zw * uInputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        float pixelStrength = uInputSize.%dimension% * uStrength;

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $23f966071940a41b$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $23f966071940a41b$var$vertTemplate;
    let blurLoop = "";
    let template;
    if (x) template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * pixelStrength, 0.0);";
    else template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * pixelStrength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`);
        blurLoop += blur;
        blurLoop += "\n";
    }
    vertSource = vertSource.replace("%blur%", blurLoop);
    vertSource = vertSource.replace("%size%", kernelSize.toString());
    vertSource = vertSource.replace("%dimension%", x ? "z" : "w");
    return vertSource;
}


"use strict";
function $3e59dc05357355e0$export$fa4adee1a7bc708(horizontal, kernelSize) {
    const vertex = (0, $23f966071940a41b$export$7a7fb9d9d09c33af)(kernelSize, horizontal);
    const fragment = (0, $f18201acb1d246c1$export$1b0dcf101eb6a1c9)(kernelSize);
    return (0, $4kU4M.GlProgram).from({
        vertex: vertex,
        fragment: fragment,
        name: `blur-${horizontal ? "horizontal" : "vertical"}-pass-filter`
    });
}



var $bEdxc = parcelRequire("bEdxc");


"use strict";
function $c80fdd4da83c4d4c$export$96d9b45e64338908(horizontal, kernelSize) {
    const kernel = (0, $7e23f300d702b6d0$export$62963d757c50e400)[kernelSize];
    const halfLength = kernel.length;
    const blurStructSource = [];
    const blurOutSource = [];
    const blurSamplingSource = [];
    for(let i = 0; i < kernelSize; i++){
        blurStructSource[i] = `@location(${i}) offset${i}: vec2<f32>,`;
        if (horizontal) blurOutSource[i] = `filteredCord + vec2(${i - halfLength + 1} * pixelStrength, 0.0),`;
        else blurOutSource[i] = `filteredCord + vec2(0.0, ${i - halfLength + 1} * pixelStrength),`;
        const kernelIndex = i < halfLength ? i : kernelSize - i - 1;
        const kernelValue = kernel[kernelIndex].toString();
        blurSamplingSource[i] = `finalColor += textureSample(uTexture, uSampler, offset${i}) * ${kernelValue};`;
    }
    const blurStruct = blurStructSource.join("\n");
    const blurOut = blurOutSource.join("\n");
    const blurSampling = blurSamplingSource.join("\n");
    const finalSource = (0, $cf7e6f7129d47fc2$export$2e2bcd8739ae039).replace("%blur-struct%", blurStruct).replace("%blur-vertex-out%", blurOut).replace("%blur-fragment-in%", blurStruct).replace("%blur-sampling%", blurSampling).replace("%dimension%", horizontal ? "z" : "w");
    return (0, $bEdxc.GpuProgram).from({
        vertex: {
            source: finalSource,
            entryPoint: "mainVertex"
        },
        fragment: {
            source: finalSource,
            entryPoint: "mainFragment"
        }
    });
}


"use strict";
const $af2a5e86ce27dcf5$var$_BlurFilterPass = class _BlurFilterPass extends (0, $lWXRl.Filter) {
    /**
   * @param options
   * @param options.horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param options.strength - The strength of the blur filter.
   * @param options.quality - The quality of the blur filter.
   * @param options.kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(options){
        options = {
            ..._BlurFilterPass.defaultOptions,
            ...options
        };
        const glProgram = (0, $3e59dc05357355e0$export$fa4adee1a7bc708)(options.horizontal, options.kernelSize);
        const gpuProgram = (0, $c80fdd4da83c4d4c$export$96d9b45e64338908)(options.horizontal, options.kernelSize);
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                blurUniforms: {
                    uStrength: {
                        value: 0,
                        type: "f32"
                    }
                }
            },
            ...options
        });
        this.horizontal = options.horizontal;
        this._quality = 0;
        this.quality = options.quality;
        this.blur = options.strength;
        this._uniforms = this.resources.blurUniforms.uniforms;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        this._uniforms.uStrength = this.strength / this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const tempTexture = (0, $5NyEC.TexturePool).getSameSizeTexture(input);
            let flip = input;
            let flop = tempTexture;
            this._state.blend = false;
            const shouldClear = filterManager.renderer.type === (0, $bfcaK.RendererType).WEBGPU;
            for(let i = 0; i < this.passes - 1; i++){
                filterManager.applyFilter(this, flip, flop, i === 0 ? true : shouldClear);
                const temp = flop;
                flop = flip;
                flip = temp;
            }
            this._state.blend = true;
            filterManager.applyFilter(this, flip, output, clearMode);
            (0, $5NyEC.TexturePool).returnTexture(tempTexture);
        }
    }
    /**
   * Sets the strength of both the blur.
   * @default 16
   */ get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2;
        this.strength = value;
    }
    /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality blurring but the lower the performance.
   * @default 4
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value;
        this.passes = value;
    }
};
/** Default blur filter pass options */ $af2a5e86ce27dcf5$var$_BlurFilterPass.defaultOptions = {
    /** The strength of the blur filter. */ strength: 8,
    /** The quality of the blur filter. */ quality: 4,
    /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */ kernelSize: 5
};
let $af2a5e86ce27dcf5$export$b100a8e8116621cf = $af2a5e86ce27dcf5$var$_BlurFilterPass;


"use strict";
class $f71b4e41c428ae4e$export$424348d09d827f49 extends (0, $lWXRl.Filter) {
    constructor(...args){
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "BlurFilter constructor params are now options object. See params: { strength, quality, resolution, kernelSize }");
            options = {
                strength: options
            };
            if (args[1] !== void 0) options.quality = args[1];
            if (args[2] !== void 0) options.resolution = args[2] || "inherit";
            if (args[3] !== void 0) options.kernelSize = args[3];
        }
        options = {
            ...(0, $af2a5e86ce27dcf5$export$b100a8e8116621cf).defaultOptions,
            ...options
        };
        const { strength: strength, strengthX: strengthX, strengthY: strengthY, quality: quality, ...rest } = options;
        super({
            ...rest,
            compatibleRenderers: (0, $bfcaK.RendererType).BOTH,
            resources: {}
        });
        this._repeatEdgePixels = false;
        this.blurXFilter = new (0, $af2a5e86ce27dcf5$export$b100a8e8116621cf)({
            horizontal: true,
            ...options
        });
        this.blurYFilter = new (0, $af2a5e86ce27dcf5$export$b100a8e8116621cf)({
            horizontal: false,
            ...options
        });
        this.quality = quality;
        this.strengthX = strengthX ?? strength;
        this.strengthY = strengthY ?? strength;
        this.repeatEdgePixels = false;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   * @advanced
   */ apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength);
        const yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const tempTexture = (0, $5NyEC.TexturePool).getSameSizeTexture(input);
            this.blurXFilter.blendMode = "normal";
            this.blurXFilter.apply(filterManager, input, tempTexture, true);
            this.blurYFilter.blendMode = this.blendMode;
            this.blurYFilter.apply(filterManager, tempTexture, output, clearMode);
            (0, $5NyEC.TexturePool).returnTexture(tempTexture);
        } else if (yStrength) {
            this.blurYFilter.blendMode = this.blendMode;
            this.blurYFilter.apply(filterManager, input, output, clearMode);
        } else {
            this.blurXFilter.blendMode = this.blendMode;
            this.blurXFilter.apply(filterManager, input, output, clearMode);
        }
    }
    updatePadding() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.blur), Math.abs(this.blurYFilter.blur)) * 2;
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously.
   * Controls the overall intensity of the Gaussian blur effect.
   * @example
   * ```ts
   * // Set equal blur strength for both axes
   * filter.strength = 8;
   *
   * // Will throw error if X and Y are different
   * filter.strengthX = 4;
   * filter.strengthY = 8;
   * filter.strength; // Error: BlurFilter's strengthX and strengthY are different
   * ```
   * @default 8
   * @throws {Error} If strengthX and strengthY are different values
   */ get strength() {
        if (this.strengthX !== this.strengthY) throw new Error("BlurFilter's strengthX and strengthY are different");
        return this.strengthX;
    }
    set strength(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the number of passes for blur. More passes means higher quality blurring.
   * Controls the precision and smoothness of the blur effect at the cost of performance.
   * @example
   * ```ts
   * // High quality blur (slower)
   * filter.quality = 8;
   *
   * // Low quality blur (faster)
   * filter.quality = 2;
   * ```
   * @default 4
   * @remarks Higher values produce better quality but impact performance
   */ get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    /**
   * Sets the strength of horizontal blur.
   * Controls the blur intensity along the x-axis independently.
   * @example
   * ```ts
   * // Apply horizontal-only blur
   * filter.strengthX = 8;
   * filter.strengthY = 0;
   *
   * // Create motion blur effect
   * filter.strengthX = 16;
   * filter.strengthY = 2;
   * ```
   * @default 8
   */ get strengthX() {
        return this.blurXFilter.blur;
    }
    set strengthX(value) {
        this.blurXFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the strength of the vertical blur.
   * Controls the blur intensity along the y-axis independently.
   * @example
   * ```ts
   * // Apply vertical-only blur
   * filter.strengthX = 0;
   * filter.strengthY = 8;
   *
   * // Create radial blur effect
   * filter.strengthX = 8;
   * filter.strengthY = 8;
   * ```
   * @default 8
   */ get strengthY() {
        return this.blurYFilter.blur;
    }
    set strengthY(value) {
        this.blurYFilter.blur = value;
        this.updatePadding();
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strength
   */ get blur() {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blur is deprecated, please use BlurFilter.strength instead.");
        return this.strength;
    }
    set blur(value) {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blur is deprecated, please use BlurFilter.strength instead.");
        this.strength = value;
    }
    /**
   * Sets the strength of the blurX property
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strengthX
   */ get blurX() {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blurX is deprecated, please use BlurFilter.strengthX instead.");
        return this.strengthX;
    }
    set blurX(value) {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blurX is deprecated, please use BlurFilter.strengthX instead.");
        this.strengthX = value;
    }
    /**
   * Sets the strength of the blurY property
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strengthY
   */ get blurY() {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blurY is deprecated, please use BlurFilter.strengthY instead.");
        return this.strengthY;
    }
    set blurY(value) {
        (0, $6LhOA.deprecation)("8.3.0", "BlurFilter.blurY is deprecated, please use BlurFilter.strengthY instead.");
        this.strengthY = value;
    }
    /**
   * If set to true the edge of the target will be clamped
   * @default false
   */ get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value;
        this.updatePadding();
    }
}
/**
 * Default blur filter options
 * @example
 * ```ts
 * // Set default options for all BlurFilters
 * BlurFilter.defaultOptions = {
 *     strength: 10,       // Default blur strength
 *     quality: 2,        // Default blur quality
 *     kernelSize: 7      // Default kernel size
 * };
 * // Create a filter with these defaults
 * const filter = new BlurFilter(); // Uses default options
 * ```
 * @remarks
 * - These options are used when creating a new BlurFilter without specific parameters
 * - Can be overridden by passing options to the constructor
 * - Useful for setting global defaults for all blur filters in your application
 * @see {@link BlurFilterOptions} For detailed options
 * @see {@link BlurFilter} The filter that uses these options
 */ $f71b4e41c428ae4e$export$424348d09d827f49.defaultOptions = {
    /** The strength of the blur filter. */ strength: 8,
    /** The quality of the blur filter. */ quality: 4,
    /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */ kernelSize: 5
};









var $dKHyW = parcelRequire("dKHyW");

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $lWXRl = parcelRequire("lWXRl");

var $hK31P = parcelRequire("hK31P");


"use strict";
class $a5eba8e2f0b91898$export$6547db23997fcec5 extends (0, $lWXRl.Filter) {
    constructor(options = {}){
        const colorMatrixUniforms = new (0, $aUxJK.UniformGroup)({
            uColorMatrix: {
                value: [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ],
                type: "f32",
                size: 20
            },
            uAlpha: {
                value: 1,
                type: "f32"
            }
        });
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $ab75df4ff3fc796a$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $ab75df4ff3fc796a$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $hK31P.default,
            fragment: $bfe7c65ef8bc5e43$export$2e2bcd8739ae039,
            name: "color-matrix-filter"
        });
        super({
            ...options,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                colorMatrixUniforms: colorMatrixUniforms
            }
        });
        this.alpha = 1;
    }
    /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   */ _loadMatrix(matrix, multiply = false) {
        let newMatrix = matrix;
        if (multiply) {
            this._multiply(newMatrix, this.matrix, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }
        this.resources.colorMatrixUniforms.uniforms.uColorMatrix = newMatrix;
        this.resources.colorMatrixUniforms.update();
    }
    /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */ _multiply(out, a, b) {
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
        return out;
    }
    /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */ _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;
        return m;
    }
    /**
   * Adjusts the brightness of a display object.
   *
   * The brightness adjustment works by multiplying the RGB channels by a scalar value while keeping
   * the alpha channel unchanged. Values below 1 darken the image, while values above 1 brighten it.
   * @param b - The brightness multiplier to apply. Values between 0-1 darken the image (0 being black),
   *           while values > 1 brighten it (2.0 would make it twice as bright)
   * @param multiply - When true, the new matrix is multiplied with the current one instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * // Create a new color matrix filter
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Darken the image to 50% brightness
   * colorMatrix.brightness(0.5, false);
   *
   * // Chain with other effects by using multiply
   * colorMatrix
   *     .brightness(1.2, true)  // Brighten by 20%
   *     .saturate(1.1, true);   // Increase saturation by 10%
   * ```
   */ brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sets each channel on the diagonal of the color matrix to apply a color tint.
   *
   * This method provides a way to tint display objects using the color matrix filter, similar to
   * the tint property available on Sprites and other display objects. The tint is applied by
   * scaling the RGB channels of each pixel.
   * @param color - The color to use for tinting, this can be any valid color source.
   * @param multiply - When true, the new tint matrix is multiplied with the current matrix instead
   *                  of replacing it. This allows for combining tints with other color effects.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply a red tint
   * colorMatrix.tint(0xff0000);
   *
   * // Layer a green tint on top of existing effects
   * colorMatrix.tint('green', true);
   *
   * // Chain with other color adjustments
   * colorMatrix
   *     .tint('blue')       // Blue tint
   *     .brightness(1.2, true) // Increase brightness
   * ```
   */ tint(color, multiply) {
        const [r, g, b] = (0, $dKHyW.Color).shared.setValue(color).toArray();
        const matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Converts the display object to greyscale by applying a weighted matrix transformation.
   *
   * The greyscale effect works by setting equal RGB values for each pixel based on the scale parameter,
   * effectively removing color information while preserving luminance.
   * @param scale - The intensity of the greyscale effect. Value between 0-1, where:
   *               - 0 produces black
   *               - 0.5 produces 50% grey
   *               - 1 produces white
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to 50% grey
   * colorMatrix.greyscale(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .greyscale(0.6, true)    // Add grey tint
   *     .brightness(1.2, true);   // Brighten the result
   * ```
   */ greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Converts the display object to grayscale by applying a weighted matrix transformation.
   *
   * The grayscale effect works by setting equal RGB values for each pixel based on the scale parameter,
   * effectively removing color information while preserving luminance.
   * @param scale - The intensity of the grayscale effect. Value between 0-1, where:
   *               - 0 produces black
   *               - 0.5 produces 50% grey
   *               - 1 produces white
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to 50% grey
   * colorMatrix.grayscale(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .grayscale(0.6, true)    // Add grey tint
   *     .brightness(1.2, true);   // Brighten the result
   * ```
   */ grayscale(scale, multiply) {
        this.greyscale(scale, multiply);
    }
    /**
   * Converts the display object to pure black and white using a luminance-based threshold.
   *
   * This method applies a matrix transformation that removes all color information and reduces
   * the image to just black and white values based on the luminance of each pixel. The transformation
   * uses standard luminance weightings: 30% red, 60% green, and 10% blue.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to black and white
   * colorMatrix.blackAndWhite(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .blackAndWhite(true)     // Apply B&W effect
   *     .brightness(1.2, true);   // Then increase brightness
   * ```
   */ blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the hue of the display object by rotating the color values around the color wheel.
   *
   * This method uses an optimized matrix transformation that accurately rotates the RGB color space
   * around its luminance axis. The implementation is based on RGB cube rotation in 3D space, providing
   * better results than traditional matrices with magic luminance constants.
   * @param rotation - The angle of rotation in degrees around the color wheel:
   *                  - 0 = no change
   *                  - 90 = rotate colors 90° clockwise
   *                  - 180 = invert all colors
   *                  - 270 = rotate colors 90° counter-clockwise
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Rotate hue by 90 degrees
   * colorMatrix.hue(90, false);
   *
   * // Chain multiple color adjustments
   * colorMatrix
   *     .hue(45, true)          // Rotate colors by 45°
   *     .saturate(1.2, true)    // Increase saturation
   *     .brightness(1.1, true); // Slightly brighten
   * ```
   */ hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation);
        const sinR = Math.sin(rotation);
        const sqrt = Math.sqrt;
        const w = 1 / 3;
        const sqrW = sqrt(w);
        const a00 = cosR + (1 - cosR) * w;
        const a01 = w * (1 - cosR) - sqrW * sinR;
        const a02 = w * (1 - cosR) + sqrW * sinR;
        const a10 = w * (1 - cosR) + sqrW * sinR;
        const a11 = cosR + w * (1 - cosR);
        const a12 = w * (1 - cosR) - sqrW * sinR;
        const a20 = w * (1 - cosR) - sqrW * sinR;
        const a21 = w * (1 - cosR) + sqrW * sinR;
        const a22 = cosR + w * (1 - cosR);
        const matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the contrast of the display object by modifying the separation between dark and bright values.
   *
   * This method applies a matrix transformation that affects the difference between dark and light areas
   * in the image. Increasing contrast makes shadows darker and highlights brighter, while decreasing
   * contrast brings shadows up and highlights down, reducing the overall dynamic range.
   * @param amount - The contrast adjustment value. Range is 0 to 1, where:
   *                - 0 represents minimum contrast (flat gray)
   *                - 0.5 represents normal contrast
   *                - 1 represents maximum contrast
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Increase contrast by 50%
   * colorMatrix.contrast(0.75, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .contrast(0.6, true)     // Boost contrast
   *     .brightness(1.1, true)   // Slightly brighten
   *     .saturate(1.2, true);    // Increase color intensity
   * ```
   */ contrast(amount, multiply) {
        const v = (amount || 0) + 1;
        const o = -0.5 * (v - 1);
        const matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the saturation of the display object by modifying color separation.
   *
   * This method applies a matrix transformation that affects the intensity of colors.
   * Increasing saturation makes colors more vivid and intense, while decreasing saturation
   * moves colors toward grayscale.
   * @param amount - The saturation adjustment value. Range is -1 to 1, where:
   *                - -1 produces grayscale
   *                - 0 represents no change
   *                - 1 produces maximum saturation
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Double the saturation
   * colorMatrix.saturate(1, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .saturate(0.5, true)     // Increase saturation by 50%
   *     .brightness(1.1, true)    // Slightly brighten
   *     .contrast(0.8, true);     // Reduce contrast
   * ```
   */ saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1;
        const y = (x - 1) * -0.5;
        const matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Completely removes color information from the display object, creating a grayscale version.
   *
   * This is a convenience method that calls `saturate(-1)` internally. The transformation preserves
   * the luminance of the original image while removing all color information.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert image to grayscale
   * colorMatrix.desaturate();
   *
   * // Can be chained with other effects
   * colorMatrix
   *     .desaturate()         // Remove all color
   *     .brightness(1.2);     // Then increase brightness
   * ```
   */ desaturate() {
        this.saturate(-1);
    }
    /**
   * Creates a negative effect by inverting all colors in the display object.
   *
   * This method applies a matrix transformation that inverts the RGB values of each pixel
   * while preserving the alpha channel. The result is similar to a photographic negative.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Create negative effect
   * colorMatrix.negative(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .negative(true)       // Apply negative effect
   *     .brightness(1.2, true) // Increase brightness
   *     .contrast(0.8, true);  // Reduce contrast
   * ```
   */ negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a sepia tone effect to the display object, creating a warm brown tint reminiscent of vintage photographs.
   *
   * This method applies a matrix transformation that converts colors to various shades of brown while
   * preserving the original luminance values.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply sepia effect
   * colorMatrix.sepia(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .sepia(true)           // Add sepia tone
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(0.9, true);   // Reduce contrast
   * ```
   */ sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a Technicolor-style effect that simulates the early color motion picture process.
   *
   * This method applies a matrix transformation that recreates the distinctive look of the
   * Technicolor process. The effect produces highly
   * saturated colors with a particular emphasis on reds, greens, and blues.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Technicolor effect
   * colorMatrix.technicolor(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .technicolor(true)      // Add Technicolor effect
   *     .contrast(1.1, true)    // Boost contrast
   *     .brightness(0.9, true); // Slightly darken
   * ```
   */ technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a vintage Polaroid camera effect to the display object.
   *
   * This method applies a matrix transformation that simulates the distinctive look of
   * Polaroid instant photographs, characterized by slightly enhanced contrast, subtle color shifts,
   * and a warm overall tone.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Polaroid effect
   * colorMatrix.polaroid(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .polaroid(true)         // Add Polaroid effect
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(1.1, true);   // Boost contrast
   * ```
   */ polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Swaps the red and blue color channels in the display object.
   *
   * This method applies a matrix transformation that exchanges the red and blue color values
   * while keeping the green channel and alpha unchanged.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Swap red and blue channels
   * colorMatrix.toBGR(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .toBGR(true)           // Swap R and B channels
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(0.9, true);   // Reduce contrast
   * ```
   */ toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a Kodachrome color effect that simulates the iconic film stock.
   *
   * This method applies a matrix transformation that recreates the distinctive look of Kodachrome film,
   * known for its rich, vibrant colors and excellent image preservation qualities. The effect emphasizes
   * reds and blues while producing deep, true blacks.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Kodachrome effect
   * colorMatrix.kodachrome(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .kodachrome(true)       // Add Kodachrome effect
   *     .contrast(1.1, true)    // Boost contrast
   *     .brightness(0.9, true); // Slightly darken
   * ```
   */ kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a stylized brown-tinted effect to the display object.
   *
   * This method applies a matrix transformation that creates a rich, warm brown tone
   * with enhanced contrast and subtle color shifts.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply browni effect
   * colorMatrix.browni(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .browni(true)          // Add brown tint
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(1.2, true);   // Boost contrast
   * ```
   */ browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a vintage photo effect that simulates old photography techniques.
   *
   * This method applies a matrix transformation that creates a nostalgic, aged look
   * with muted colors, enhanced warmth, and subtle vignetting.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply vintage effect
   * colorMatrix.vintage(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .vintage(true)          // Add vintage look
   *     .brightness(0.9, true)  // Slightly darken
   *     .contrast(1.1, true);   // Boost contrast
   * ```
   */ vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Create sepia-like effect with custom colors
   * colorMatrix.colorTone(
   *     0.3,        // Moderate desaturation
   *     0.2,        // Moderate toning
   *     0xFFE580,   // Warm highlight color
   *     0x338000,   // Dark green shadows
   *     false
   * );
   *
   * // Chain with other effects
   * colorMatrix
   *     .colorTone(0.2, 0.15, 0xFFE580, 0x338000, true)
   *     .brightness(1.1, true);  // Slightly brighten
   * ```
   */ colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation || (desaturation = 0.2);
        toned || (toned = 0.15);
        lightColor || (lightColor = 16770432);
        darkColor || (darkColor = 3375104);
        const temp = (0, $dKHyW.Color).shared;
        const [lR, lG, lB] = temp.setValue(lightColor).toArray();
        const [dR, dG, dB] = temp.setValue(darkColor).toArray();
        const matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a night vision effect to the display object.
   *
   * This method applies a matrix transformation that simulates night vision by enhancing
   * certain color channels while suppressing others, creating a green-tinted effect
   * similar to night vision goggles.
   * @param intensity - The intensity of the night effect (0-1):
   *                   - 0 produces no effect
   *                   - 0.1 produces a subtle night vision effect (default)
   *                   - 1 produces maximum night vision effect
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply night vision effect
   * colorMatrix.night(0.3, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .night(0.2, true)        // Add night vision
   *     .brightness(1.1, true)    // Slightly brighten
   *     .contrast(1.2, true);     // Boost contrast
   * ```
   */ night(intensity, multiply) {
        intensity || (intensity = 0.1);
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Predator effect
   *
   * Erase the current matrix by setting a new independent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply thermal vision effect
   * colorMatrix.predator(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .predator(0.3, true)      // Add thermal effect
   *     .contrast(1.2, true)      // Boost contrast
   *     .brightness(1.1, true);   // Slightly brighten
   * ```
   */ predator(amount, multiply) {
        const matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a psychedelic color effect that creates dramatic color shifts.
   *
   * This method applies a matrix transformation that produces vibrant colors
   * through channel mixing and amplification. Creates an effect reminiscent of
   * color distortions in psychedelic art.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply psychedelic effect
   * colorMatrix.lsd(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .lsd(true)             // Add color distortion
   *     .brightness(0.9, true)  // Slightly darken
   *     .contrast(1.2, true);   // Boost contrast
   * ```
   */ lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Resets the color matrix filter to its default state.
   *
   * This method resets all color transformations by setting the matrix back to its identity state.
   * The identity matrix leaves colors unchanged, effectively removing all previously applied effects.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply some effects
   * colorMatrix
   *     .sepia(true)
   *     .brightness(1.2, true);
   *
   * // Reset back to original colors
   * colorMatrix.reset();
   * ```
   */ reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, false);
    }
    /**
   * The current color transformation matrix of the filter.
   *
   * This 5x4 matrix transforms RGBA color and alpha values of each pixel. The matrix is stored
   * as a 20-element array in row-major order.
   * @type {ColorMatrix}
   * @default [
   *     1, 0, 0, 0, 0,  // Red channel
   *     0, 1, 0, 0, 0,  // Green channel
   *     0, 0, 1, 0, 0,  // Blue channel
   *     0, 0, 0, 1, 0   // Alpha channel
   * ]
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   * // Get the current color matrix
   * const currentMatrix = colorMatrix.matrix;
   * // Modify the matrix
   * colorMatrix.matrix = [
   *     1, 0, 0, 0, 0,
   *     0, 1, 0, 0, 0,
   *     0, 0, 1, 0, 0,
   *     0, 0, 0, 1, 0
   * ];
   */ get matrix() {
        return this.resources.colorMatrixUniforms.uniforms.uColorMatrix;
    }
    set matrix(value) {
        this.resources.colorMatrixUniforms.uniforms.uColorMatrix = value;
    }
    /**
   * The opacity value used to blend between the original and transformed colors.
   *
   * This value controls how much of the color transformation is applied:
   * - 0 = Original color only (no effect)
   * - 0.5 = 50% blend of original and transformed colors
   * - 1 = Fully transformed color (default)
   * @default 1
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply sepia at 50% strength
   * colorMatrix.sepia(false);
   * colorMatrix.alpha = 0.5;
   *
   * // Fade between effects
   * colorMatrix
   *     .saturate(1.5)      // Increase saturation
   *     .contrast(1.2);     // Boost contrast
   * colorMatrix.alpha = 0.7; // Apply at 70% strength
   * ```
   */ get alpha() {
        return this.resources.colorMatrixUniforms.uniforms.uAlpha;
    }
    set alpha(value) {
        this.resources.colorMatrixUniforms.uniforms.uAlpha = value;
    }
}



var $5xi4h = parcelRequire("5xi4h");

var $ds7Xo = parcelRequire("ds7Xo");

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $7ScuH = parcelRequire("7ScuH");

var $6LhOA = parcelRequire("6LhOA");

var $lWXRl = parcelRequire("lWXRl");



"use strict";
class $ed5f2584b4d2c501$export$8ebf3229158e2895 extends (0, $lWXRl.Filter) {
    constructor(...args){
        let options = args[0];
        if (options instanceof (0, $7ScuH.Sprite)) {
            if (args[1]) (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "DisplacementFilter now uses options object instead of params. {sprite, scale}");
            options = {
                sprite: options,
                scale: args[1]
            };
        }
        const { sprite: sprite, scale: scaleOption, ...rest } = options;
        let scale = scaleOption ?? 20;
        if (typeof scale === "number") scale = new (0, $ds7Xo.Point)(scale, scale);
        const filterUniforms = new (0, $aUxJK.UniformGroup)({
            uFilterMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uScale: {
                value: scale,
                type: "vec2<f32>"
            },
            uRotation: {
                value: new Float32Array([
                    0,
                    0,
                    0,
                    0
                ]),
                type: "mat2x2<f32>"
            }
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $317a3adc740807ea$export$2e2bcd8739ae039,
            fragment: $a7ecc11f5b04f50c$export$2e2bcd8739ae039,
            name: "displacement-filter"
        });
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $b4717776ee2d1620$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $b4717776ee2d1620$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const textureSource = sprite.texture.source;
        super({
            ...rest,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                filterUniforms: filterUniforms,
                uMapTexture: textureSource,
                uMapSampler: textureSource.style
            }
        });
        this._sprite = options.sprite;
        this._sprite.renderable = false;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   * @advanced
   */ apply(filterManager, input, output, clearMode) {
        const uniforms = this.resources.filterUniforms.uniforms;
        filterManager.calculateSpriteMatrix(uniforms.uFilterMatrix, this._sprite);
        const wt = this._sprite.worldTransform;
        const lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b);
        const lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        if (lenX !== 0 && lenY !== 0) {
            uniforms.uRotation[0] = wt.a / lenX;
            uniforms.uRotation[1] = wt.b / lenX;
            uniforms.uRotation[2] = wt.c / lenY;
            uniforms.uRotation[3] = wt.d / lenY;
        }
        this.resources.uMapTexture = this._sprite.texture.source;
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * The scale of the displacement effect.
   *
   * Gets the current x and y scaling values used for the displacement mapping.
   * - x: Horizontal displacement scale
   * - y: Vertical displacement scale
   * @returns {Point} The current scale as a Point object
   * @example
   * ```ts
   * const filter = new DisplacementFilter({ sprite });
   *
   * // Get current scale
   * console.log(filter.scale.x, filter.scale.y);
   *
   * // Update scale
   * filter.scale.x = 100;
   * filter.scale.y = 50;
   * ```
   */ get scale() {
        return this.resources.filterUniforms.uniforms.uScale;
    }
}



var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $aUxJK = parcelRequire("aUxJK");

var $lWXRl = parcelRequire("lWXRl");

var $hK31P = parcelRequire("hK31P");


"use strict";
const $5200480fbbf9bd48$var$_NoiseFilter = class _NoiseFilter extends (0, $lWXRl.Filter) {
    /**
   * @param options - The options of the noise filter.
   */ constructor(options = {}){
        options = {
            ..._NoiseFilter.defaultOptions,
            ...options
        };
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            vertex: {
                source: $02f175dd3c54583e$export$2e2bcd8739ae039,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $02f175dd3c54583e$export$2e2bcd8739ae039,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $hK31P.default,
            fragment: $f051f0eca3077c3a$export$2e2bcd8739ae039,
            name: "noise-filter"
        });
        const { noise: noise, seed: seed, ...rest } = options;
        super({
            ...rest,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                noiseUniforms: new (0, $aUxJK.UniformGroup)({
                    uNoise: {
                        value: 1,
                        type: "f32"
                    },
                    uSeed: {
                        value: 1,
                        type: "f32"
                    }
                })
            }
        });
        this.noise = noise;
        this.seed = seed ?? Math.random();
    }
    /**
   * The amount of noise to apply to the filtered content.
   *
   * This value controls the intensity of the random noise effect:
   * - Values close to 0 produce subtle noise
   * - Values around 0.5 produce moderate noise
   * - Values close to 1 produce strong noise
   * @default 0.5
   * @example
   * ```ts
   * const noiseFilter = new NoiseFilter();
   *
   * // Set to subtle noise
   * noiseFilter.noise = 0.2;
   *
   * // Set to maximum noise
   * noiseFilter.noise = 1.0;
   * ```
   */ get noise() {
        return this.resources.noiseUniforms.uniforms.uNoise;
    }
    set noise(value) {
        this.resources.noiseUniforms.uniforms.uNoise = value;
    }
    /**
   * The seed value used for random noise generation.
   *
   * This value determines the noise pattern:
   * - Using the same seed will generate identical noise patterns
   * - Different seeds produce different but consistent patterns
   * - `Math.random()` can be used for random patterns
   * @default Math.random()
   * @example
   * ```ts
   * const noiseFilter = new NoiseFilter();
   *
   * // Use a fixed seed for consistent noise
   * noiseFilter.seed = 12345;
   *
   * // Generate new random pattern
   * noiseFilter.seed = Math.random();
   * ```
   */ get seed() {
        return this.resources.noiseUniforms.uniforms.uSeed;
    }
    set seed(value) {
        this.resources.noiseUniforms.uniforms.uSeed = value;
    }
};
/**
 * The default configuration options for the NoiseFilter.
 *
 * These values will be used when no specific options are provided to the constructor.
 * You can override any of these values by passing your own options object.
 * @example
 * ```ts
 * NoiseFilter.defaultOptions.noise = 0.7; // Change default noise to 0.7
 * const filter = new NoiseFilter(); // Will use noise 0.7 by default
 * ```
 */ $5200480fbbf9bd48$var$_NoiseFilter.defaultOptions = {
    noise: 0.5
};
let $5200480fbbf9bd48$export$2d7a5b72233a5183 = $5200480fbbf9bd48$var$_NoiseFilter;



var $Rua5B = parcelRequire("Rua5B");

var $lWXRl = parcelRequire("lWXRl");

var $jMFz3 = parcelRequire("jMFz3");

var $2mfWS = parcelRequire("2mfWS");

var $dPCQ1 = parcelRequire("dPCQ1");

var $dyeaT = parcelRequire("dyeaT");

var $lHrjL = parcelRequire("lHrjL");

var $5xi4h = parcelRequire("5xi4h");

var $hEz4p = parcelRequire("hEz4p");

var $fSIhN = parcelRequire("fSIhN");

var $hASMp = parcelRequire("hASMp");

var $jZ66T = parcelRequire("jZ66T");

var $ds7Xo = parcelRequire("ds7Xo");
"use strict";
function $0ec92952cf900ab8$export$b0d8d777b5def172(px, py, x1, y1, x2, y2, x3, y3) {
    const v2x = x3 - x1;
    const v2y = y3 - y1;
    const v1x = x2 - x1;
    const v1y = y2 - y1;
    const v0x = px - x1;
    const v0y = py - y1;
    const dot00 = v2x * v2x + v2y * v2y;
    const dot01 = v2x * v1x + v2y * v1y;
    const dot02 = v2x * v0x + v2y * v0y;
    const dot11 = v1x * v1x + v1y * v1y;
    const dot12 = v1x * v0x + v1y * v0y;
    const invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
    const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return u >= 0 && v >= 0 && u + v < 1;
}



var $1lNph = parcelRequire("1lNph");

var $8UvIh = parcelRequire("8UvIh");

var $7r8vL = parcelRequire("7r8vL");

var $ar2Ly = parcelRequire("ar2Ly");

var $fVN7W = parcelRequire("fVN7W");

var $hASMp = parcelRequire("hASMp");

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
class $8364dac7c350a6ae$export$5a465592bfe74b48 {
    /**
   * @param x - The X coord of the first point.
   * @param y - The Y coord of the first point.
   * @param x2 - The X coord of the second point.
   * @param y2 - The Y coord of the second point.
   * @param x3 - The X coord of the third point.
   * @param y3 - The Y coord of the third point.
   */ constructor(x = 0, y = 0, x2 = 0, y2 = 0, x3 = 0, y3 = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Triangle(0, 0, 100, 0, 50, 100);
     * console.log(shape.type); // 'triangle'
     *
     * // Use in type guards
     * if (shape.type === 'triangle') {
     *     console.log(shape.x2, shape.y2);
     * }
     * ```
     * @readonly
     * @default 'triangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "triangle";
        this.x = x;
        this.y = y;
        this.x2 = x2;
        this.y2 = y2;
        this.x3 = x3;
        this.y3 = y3;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this triangle
   * @example
   * ```ts
   * // Basic containment check
   * const triangle = new Triangle(0, 0, 100, 0, 50, 100);
   * const isInside = triangle.contains(25, 25); // true
   * ```
   * @remarks
   * - Uses barycentric coordinate system
   * - Works with any triangle shape
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Triangle
   * @see {@link Triangle.strokeContains} For checking stroke intersection
   * @see {@link Triangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        const s = (this.x - this.x3) * (y - this.y3) - (this.y - this.y3) * (x - this.x3);
        const t = (this.x2 - this.x) * (y - this.y) - (this.y2 - this.y) * (x - this.x);
        if (s < 0 !== t < 0 && s !== 0 && t !== 0) return false;
        const d = (this.x3 - this.x2) * (y - this.y2) - (this.y3 - this.y2) * (x - this.x2);
        return d === 0 || d < 0 === s + t <= 0;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this triangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const triangle = new Triangle(0, 0, 100, 0, 50, 100);
   * const isOnStroke = triangle.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = triangle.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = triangle.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = triangle.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param pointX - The X coordinate of the point to test
   * @param pointY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param _alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this triangle's stroke
   * @see {@link Triangle.contains} For checking fill containment
   * @see {@link Triangle.getBounds} For getting stroke bounds
   */ strokeContains(pointX, pointY, strokeWidth, _alignment = 0.5) {
        const halfStrokeWidth = strokeWidth / 2;
        const halfStrokeWidthSquared = halfStrokeWidth * halfStrokeWidth;
        const { x: x, x2: x2, x3: x3, y: y, y2: y2, y3: y3 } = this;
        if ((0, $hASMp.squaredDistanceToLineSegment)(pointX, pointY, x, y, x2, y3) <= halfStrokeWidthSquared || (0, $hASMp.squaredDistanceToLineSegment)(pointX, pointY, x2, y2, x3, y3) <= halfStrokeWidthSquared || (0, $hASMp.squaredDistanceToLineSegment)(pointX, pointY, x3, y3, x, y) <= halfStrokeWidthSquared) return true;
        return false;
    }
    /**
   * Creates a clone of this Triangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Triangle(0, 0, 100, 0, 50, 100);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.x3 = 75;
   * modified.y3 = 150;
   *
   * // Verify independence
   * console.log(original.y3);  // 100
   * console.log(modified.y3);  // 150
   * ```
   * @returns A copy of the triangle
   * @see {@link Triangle.copyFrom} For copying into existing triangle
   * @see {@link Triangle.copyTo} For copying to another triangle
   */ clone() {
        const triangle = new $8364dac7c350a6ae$export$5a465592bfe74b48(this.x, this.y, this.x2, this.y2, this.x3, this.y3);
        return triangle;
    }
    /**
   * Copies another triangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Triangle(0, 0, 100, 0, 50, 100);
   * const target = new Triangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const triangle = new Triangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param triangle - The triangle to copy from
   * @returns Returns itself
   * @see {@link Triangle.copyTo} For copying to another triangle
   * @see {@link Triangle.clone} For creating new triangle copy
   */ copyFrom(triangle) {
        this.x = triangle.x;
        this.y = triangle.y;
        this.x2 = triangle.x2;
        this.y2 = triangle.y2;
        this.x3 = triangle.x3;
        this.y3 = triangle.y3;
        return this;
    }
    /**
   * Copies this triangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Triangle(0, 0, 100, 0, 50, 100);
   * const target = new Triangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Triangle())
   *     .getBounds();
   * ```
   * @remarks
   * - Updates target triangle values
   * - Copies all point coordinates
   * - Returns target for chaining
   * - More efficient than clone()
   * @param triangle - The triangle to copy to
   * @returns Returns given parameter
   * @see {@link Triangle.copyFrom} For copying from another triangle
   * @see {@link Triangle.clone} For creating new triangle copy
   */ copyTo(triangle) {
        triangle.copyFrom(this);
        return triangle;
    }
    /**
   * Returns the framing rectangle of the triangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const triangle = new Triangle(0, 0, 100, 0, 50, 100);
   * const bounds = triangle.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * triangle.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Triangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $ar2Ly.Rectangle)());
        const minX = Math.min(this.x, this.x2, this.x3);
        const maxX = Math.max(this.x, this.x2, this.x3);
        const minY = Math.min(this.y, this.y2, this.y3);
        const maxY = Math.max(this.y, this.y2, this.y3);
        out.x = minX;
        out.y = minY;
        out.width = maxX - minX;
        out.height = maxY - minY;
        return out;
    }
}



var $2vcTO = parcelRequire("2vcTO");

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");
"use strict";
const $174d20ff26f1de6e$var$_PrepareBase = class _PrepareBase {
    /**
   * @param {Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        /** called per frame by the ticker, defer processing to next tick */ this._tick = ()=>{
            if (this._destroyed) return;
            this.timeout = setTimeout(this._processQueue, 0);
        };
        /** process the queue up to max item limit per frame */ this._processQueue = ()=>{
            if (this._destroyed) return;
            const { queue: queue } = this;
            let itemsProcessed = 0;
            while(queue.length && itemsProcessed < _PrepareBase.uploadsPerFrame){
                const queueItem = queue.shift();
                this.uploadQueueItem(queueItem);
                itemsProcessed++;
            }
            if (queue.length) (0, $jM8Go.Ticker).system.addOnce(this._tick, this, (0, $2HyEq.UPDATE_PRIORITY).UTILITY);
            else this._resolve();
        };
        this.renderer = renderer;
        this.queue = [];
        this.resolves = [];
    }
    /**
   * Return a copy of the queue
   * @returns {PrepareQueueItem[]} The queue
   */ getQueue() {
        return [
            ...this.queue
        ];
    }
    /**
   * Add a textures or graphics resource to the queue
   * @param {PrepareSourceItem | PrepareSourceItem[]} resource
   */ add(resource) {
        const resourceArray = Array.isArray(resource) ? resource : [
            resource
        ];
        for (const resourceItem of resourceArray)if (resourceItem instanceof (0, $2vcTO.Container)) this._addContainer(resourceItem);
        else this.resolveQueueItem(resourceItem, this.queue);
        return this;
    }
    /**
   * Recursively add a container and its children to the queue
   * @param {Container} container - The container to add to the queue
   */ _addContainer(container) {
        this.resolveQueueItem(container, this.queue);
        for (const child of container.children)this._addContainer(child);
    }
    /**
   * Upload all the textures and graphics to the GPU (optionally add more resources to the queue first)
   * @param {PrepareSourceItem | PrepareSourceItem[] | undefined} resource
   */ upload(resource) {
        if (resource) this.add(resource);
        return new Promise((resolve)=>{
            if (this.queue.length) {
                this.resolves.push(resolve);
                this.dedupeQueue();
                (0, $jM8Go.Ticker).system.addOnce(this._tick, this, (0, $2HyEq.UPDATE_PRIORITY).UTILITY);
            } else resolve();
        });
    }
    /** eliminate duplicates before processing */ dedupeQueue() {
        const hash = /* @__PURE__ */ Object.create(null);
        let nextUnique = 0;
        for(let i = 0; i < this.queue.length; i++){
            const current = this.queue[i];
            if (!hash[current.uid]) {
                hash[current.uid] = true;
                this.queue[nextUnique++] = current;
            }
        }
        this.queue.length = nextUnique;
    }
    destroy() {
        this._destroyed = true;
        clearTimeout(this.timeout);
    }
    /** Call all the resolve callbacks */ _resolve() {
        const { resolves: resolves } = this;
        const array = resolves.slice(0);
        resolves.length = 0;
        for (const resolve of array)resolve();
    }
};
/** The number of uploads to process per frame */ $174d20ff26f1de6e$var$_PrepareBase.uploadsPerFrame = 4;
let $174d20ff26f1de6e$export$5f24f1af732279b7 = $174d20ff26f1de6e$var$_PrepareBase;



var $gmQ4R = parcelRequire("gmQ4R");

var $4iNSL = parcelRequire("4iNSL");

var $2vcTO = parcelRequire("2vcTO");

var $iNnKd = parcelRequire("iNnKd");

var $7kRkZ = parcelRequire("7kRkZ");


var $1T4Gr = parcelRequire("1T4Gr");

var $fx0Zy = parcelRequire("fx0Zy");

var $4iNSL = parcelRequire("4iNSL");

var $6LhOA = parcelRequire("6LhOA");

var $9FmI1 = parcelRequire("9FmI1");

var $2bJdA = parcelRequire("2bJdA");

var $1T7Iy = parcelRequire("1T7Iy");

var $1T4Gr = parcelRequire("1T4Gr");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $b964c6f5532210d5$var$_MeshGeometry = class _MeshGeometry extends (0, $1T4Gr.Geometry) {
    constructor(...args){
        let options = args[0] ?? {};
        if (options instanceof Float32Array) {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "use new MeshGeometry({ positions, uvs, indices }) instead");
            options = {
                positions: options,
                uvs: args[1],
                indices: args[2]
            };
        }
        options = {
            ..._MeshGeometry.defaultOptions,
            ...options
        };
        const positions = options.positions || new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]);
        let uvs = options.uvs;
        if (!uvs) {
            if (options.positions) uvs = new Float32Array(positions.length);
            else uvs = new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]);
        }
        const indices = options.indices || new Uint32Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        const shrinkToFit = options.shrinkBuffersToFit;
        const positionBuffer = new (0, $2bJdA.Buffer)({
            data: positions,
            label: "attribute-mesh-positions",
            shrinkToFit: shrinkToFit,
            usage: (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST
        });
        const uvBuffer = new (0, $2bJdA.Buffer)({
            data: uvs,
            label: "attribute-mesh-uvs",
            shrinkToFit: shrinkToFit,
            usage: (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST
        });
        const indexBuffer = new (0, $2bJdA.Buffer)({
            data: indices,
            label: "index-mesh-buffer",
            shrinkToFit: shrinkToFit,
            usage: (0, $1T7Iy.BufferUsage).INDEX | (0, $1T7Iy.BufferUsage).COPY_DST
        });
        super({
            attributes: {
                aPosition: {
                    buffer: positionBuffer,
                    format: "float32x2",
                    stride: 8,
                    offset: 0
                },
                aUV: {
                    buffer: uvBuffer,
                    format: "float32x2",
                    stride: 8,
                    offset: 0
                }
            },
            indexBuffer: indexBuffer,
            topology: options.topology
        });
        this.batchMode = "auto";
    }
    /** The positions of the mesh. */ get positions() {
        return this.attributes.aPosition.buffer.data;
    }
    /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */ set positions(value) {
        this.attributes.aPosition.buffer.data = value;
    }
    /** The UVs of the mesh. */ get uvs() {
        return this.attributes.aUV.buffer.data;
    }
    /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */ set uvs(value) {
        this.attributes.aUV.buffer.data = value;
    }
    /** The indices of the mesh. */ get indices() {
        return this.indexBuffer.data;
    }
    set indices(value) {
        this.indexBuffer.data = value;
    }
};
$b964c6f5532210d5$var$_MeshGeometry.defaultOptions = {
    topology: "triangle-list",
    shrinkBuffersToFit: false
};
let $b964c6f5532210d5$export$8d075a36a73d54bc = $b964c6f5532210d5$var$_MeshGeometry;



var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $eK2sB = parcelRequire("eK2sB");

var $aUxJK = parcelRequire("aUxJK");

var $fy1Tx = parcelRequire("fy1Tx");

var $id0ju = parcelRequire("id0ju");
"use strict";
class $1ad5fe12a59ec279$export$2fa0f0ec877329e3 {
    constructor(){
        this.batcherName = "default";
        this.packAsQuad = false;
        this.indexOffset = 0;
        this.attributeOffset = 0;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
        this._textureMatrixUpdateId = -1;
        this._uvUpdateId = -1;
    }
    get blendMode() {
        return this.renderable.groupBlendMode;
    }
    get topology() {
        return this._topology || this.geometry.topology;
    }
    set topology(value) {
        this._topology = value;
    }
    reset() {
        this.renderable = null;
        this.texture = null;
        this._batcher = null;
        this._batch = null;
        this.geometry = null;
        this._uvUpdateId = -1;
        this._textureMatrixUpdateId = -1;
    }
    /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */ setTexture(value) {
        if (this.texture === value) return;
        this.texture = value;
        this._textureMatrixUpdateId = -1;
    }
    get uvs() {
        const geometry = this.geometry;
        const uvBuffer = geometry.getBuffer("aUV");
        const uvs = uvBuffer.data;
        let transformedUvs = uvs;
        const textureMatrix = this.texture.textureMatrix;
        if (!textureMatrix.isSimple) {
            transformedUvs = this._transformedUvs;
            if (this._textureMatrixUpdateId !== textureMatrix._updateID || this._uvUpdateId !== uvBuffer._updateID) {
                if (!transformedUvs || transformedUvs.length < uvs.length) transformedUvs = this._transformedUvs = new Float32Array(uvs.length);
                this._textureMatrixUpdateId = textureMatrix._updateID;
                this._uvUpdateId = uvBuffer._updateID;
                textureMatrix.multiplyUvs(uvs, transformedUvs);
            }
        }
        return transformedUvs;
    }
    get positions() {
        return this.geometry.positions;
    }
    get indices() {
        return this.geometry.indices;
    }
    get color() {
        return this.renderable.groupColorAlpha;
    }
    get groupTransform() {
        return this.renderable.groupTransform;
    }
    get attributeSize() {
        return this.geometry.positions.length / 2;
    }
    get indexSize() {
        return this.geometry.indices.length;
    }
}


"use strict";
class $5b23daca5bad9047$export$9a0f2e45e685fe64 {
    destroy() {}
}
class $5b23daca5bad9047$export$ec121977b4273ffd {
    constructor(renderer, adaptor){
        this.localUniforms = new (0, $aUxJK.UniformGroup)({
            uTransformMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uColor: {
                value: new Float32Array([
                    1,
                    1,
                    1,
                    1
                ]),
                type: "vec4<f32>"
            },
            uRound: {
                value: 0,
                type: "f32"
            }
        });
        this.localUniformsBindGroup = new (0, $eK2sB.BindGroup)({
            0: this.localUniforms
        });
        this.renderer = renderer;
        this._adaptor = adaptor;
        this._adaptor.init();
    }
    validateRenderable(mesh) {
        const meshData = this._getMeshData(mesh);
        const wasBatched = meshData.batched;
        const isBatched = mesh.batched;
        meshData.batched = isBatched;
        if (wasBatched !== isBatched) return true;
        else if (isBatched) {
            const geometry = mesh._geometry;
            if (geometry.indices.length !== meshData.indexSize || geometry.positions.length !== meshData.vertexSize) {
                meshData.indexSize = geometry.indices.length;
                meshData.vertexSize = geometry.positions.length;
                return true;
            }
            const batchableMesh = this._getBatchableMesh(mesh);
            if (batchableMesh.texture.uid !== mesh._texture.uid) batchableMesh._textureMatrixUpdateId = -1;
            return !batchableMesh._batcher.checkAndUpdateTexture(batchableMesh, mesh._texture);
        }
        return false;
    }
    addRenderable(mesh, instructionSet) {
        const batcher = this.renderer.renderPipes.batch;
        const meshData = this._getMeshData(mesh);
        if (mesh.didViewUpdate) {
            meshData.indexSize = mesh._geometry.indices?.length;
            meshData.vertexSize = mesh._geometry.positions?.length;
        }
        if (meshData.batched) {
            const gpuBatchableMesh = this._getBatchableMesh(mesh);
            gpuBatchableMesh.setTexture(mesh._texture);
            gpuBatchableMesh.geometry = mesh._geometry;
            batcher.addToBatch(gpuBatchableMesh, instructionSet);
        } else {
            batcher.break(instructionSet);
            instructionSet.add(mesh);
        }
    }
    updateRenderable(mesh) {
        if (mesh.batched) {
            const gpuBatchableMesh = this._getBatchableMesh(mesh);
            gpuBatchableMesh.setTexture(mesh._texture);
            gpuBatchableMesh.geometry = mesh._geometry;
            gpuBatchableMesh._batcher.updateElement(gpuBatchableMesh);
        }
    }
    execute(mesh) {
        if (!mesh.isRenderable) return;
        mesh.state.blendMode = (0, $fy1Tx.getAdjustedBlendModeBlend)(mesh.groupBlendMode, mesh.texture._source);
        const localUniforms = this.localUniforms;
        localUniforms.uniforms.uTransformMatrix = mesh.groupTransform;
        localUniforms.uniforms.uRound = this.renderer._roundPixels | mesh._roundPixels;
        localUniforms.update();
        (0, $id0ju.color32BitToUniform)(mesh.groupColorAlpha, localUniforms.uniforms.uColor, 0);
        this._adaptor.execute(this, mesh);
    }
    _getMeshData(mesh) {
        var _a, _b;
        (_a = mesh._gpuData)[_b = this.renderer.uid] || (_a[_b] = new $5b23daca5bad9047$export$9a0f2e45e685fe64());
        return mesh._gpuData[this.renderer.uid].meshData || this._initMeshData(mesh);
    }
    _initMeshData(mesh) {
        mesh._gpuData[this.renderer.uid].meshData = {
            batched: mesh.batched,
            indexSize: 0,
            vertexSize: 0
        };
        return mesh._gpuData[this.renderer.uid].meshData;
    }
    _getBatchableMesh(mesh) {
        var _a, _b;
        (_a = mesh._gpuData)[_b = this.renderer.uid] || (_a[_b] = new $5b23daca5bad9047$export$9a0f2e45e685fe64());
        return mesh._gpuData[this.renderer.uid].batchableMesh || this._initBatchableMesh(mesh);
    }
    _initBatchableMesh(mesh) {
        const gpuMesh = new (0, $1ad5fe12a59ec279$export$2fa0f0ec877329e3)();
        gpuMesh.renderable = mesh;
        gpuMesh.setTexture(mesh._texture);
        gpuMesh.transform = mesh.groupTransform;
        gpuMesh.roundPixels = this.renderer._roundPixels | mesh._roundPixels;
        mesh._gpuData[this.renderer.uid].batchableMesh = gpuMesh;
        return gpuMesh;
    }
    destroy() {
        this.localUniforms = null;
        this.localUniformsBindGroup = null;
        this._adaptor.destroy();
        this._adaptor = null;
        this.renderer = null;
    }
}
/** @ignore */ $5b23daca5bad9047$export$ec121977b4273ffd.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "mesh"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $5b23daca5bad9047$export$ec121977b4273ffd));


"use strict";
class $0ac2d29ab0a78f0e$export$e176487c05830cc5 extends (0, $9FmI1.ViewContainer) {
    constructor(...args){
        let options = args[0];
        if (options instanceof (0, $1T4Gr.Geometry)) {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Mesh: use new Mesh({ geometry, shader }) instead");
            options = {
                geometry: options,
                shader: args[1]
            };
            if (args[3]) {
                (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "Mesh: drawMode argument has been removed, use geometry.topology instead");
                options.geometry.topology = args[3];
            }
        }
        const { geometry: geometry, shader: shader, texture: texture, roundPixels: roundPixels, state: state, ...rest } = options;
        super({
            label: "Mesh",
            ...rest
        });
        /** @internal */ this.renderPipeId = "mesh";
        /** @internal */ this._shader = null;
        this.allowChildren = false;
        this.shader = shader ?? null;
        this.texture = texture ?? shader?.texture ?? (0, $4iNSL.Texture).WHITE;
        this.state = state ?? (0, $fx0Zy.State).for2d();
        this._geometry = geometry;
        this._geometry.on("update", this.onViewUpdate, this);
        this.roundPixels = roundPixels ?? false;
    }
    /** Alias for {@link Mesh#shader}. */ get material() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "mesh.material property has been removed, use mesh.shader instead");
        return this._shader;
    }
    /**
   * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
   * Can be shared between multiple Mesh objects.
   */ set shader(value) {
        if (this._shader === value) return;
        this._shader = value;
        this.onViewUpdate();
    }
    get shader() {
        return this._shader;
    }
    /**
   * Includes vertex positions, face indices, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */ set geometry(value) {
        if (this._geometry === value) return;
        this._geometry?.off("update", this.onViewUpdate, this);
        value.on("update", this.onViewUpdate, this);
        this._geometry = value;
        this.onViewUpdate();
    }
    get geometry() {
        return this._geometry;
    }
    /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */ set texture(value) {
        value || (value = (0, $4iNSL.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        if (this.shader) this.shader.texture = value;
        this._texture = value;
        this.onViewUpdate();
    }
    get texture() {
        return this._texture;
    }
    get batched() {
        if (this._shader) return false;
        if ((this.state.data & 12) !== 0) return false;
        if (this._geometry instanceof (0, $b964c6f5532210d5$export$8d075a36a73d54bc)) {
            if (this._geometry.batchMode === "auto") return this._geometry.positions.length / 2 <= 100;
            return this._geometry.batchMode === "batch";
        }
        return false;
    }
    /**
   * The local bounds of the mesh.
   * @type {Bounds}
   */ get bounds() {
        return this._geometry.bounds;
    }
    /**
   * Update local bounds of the mesh.
   * @private
   */ updateBounds() {
        this._bounds = this._geometry.bounds;
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const { x: x, y: y } = point;
        if (!this.bounds.containsPoint(x, y)) return false;
        const vertices = this.geometry.getBuffer("aPosition").data;
        const step = this.geometry.topology === "triangle-strip" ? 3 : 1;
        if (this.geometry.getIndex()) {
            const indices = this.geometry.getIndex().data;
            const len = indices.length;
            for(let i = 0; i + 2 < len; i += step){
                const ind0 = indices[i] * 2;
                const ind1 = indices[i + 1] * 2;
                const ind2 = indices[i + 2] * 2;
                if ((0, $0ec92952cf900ab8$export$b0d8d777b5def172)(x, y, vertices[ind0], vertices[ind0 + 1], vertices[ind1], vertices[ind1 + 1], vertices[ind2], vertices[ind2 + 1])) return true;
            }
        } else {
            const len = vertices.length / 2;
            for(let i = 0; i + 2 < len; i += step){
                const ind0 = i * 2;
                const ind1 = (i + 1) * 2;
                const ind2 = (i + 2) * 2;
                if ((0, $0ec92952cf900ab8$export$b0d8d777b5def172)(x, y, vertices[ind0], vertices[ind0 + 1], vertices[ind1], vertices[ind1 + 1], vertices[ind2], vertices[ind2 + 1])) return true;
            }
        }
        return false;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * mesh.destroy();
   * mesh.destroy(true);
   * mesh.destroy({ texture: true, textureSource: true });
   */ destroy(options) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._geometry?.off("update", this.onViewUpdate, this);
        this._texture = null;
        this._geometry = null;
        this._shader = null;
    }
}



var $7ScuH = parcelRequire("7ScuH");

var $4iNSL = parcelRequire("4iNSL");

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");

var $7ScuH = parcelRequire("7ScuH");
"use strict";
class $10731efba8cacc0d$export$dae599798687ad3c extends (0, $7ScuH.Sprite) {
    constructor(...args){
        let options = args[0];
        if (Array.isArray(args[0])) options = {
            textures: args[0],
            autoUpdate: args[1]
        };
        const { animationSpeed: animationSpeed = 1, autoPlay: autoPlay = false, autoUpdate: autoUpdate = true, loop: loop = true, onComplete: onComplete = null, onFrameChange: onFrameChange = null, onLoop: onLoop = null, textures: textures, updateAnchor: updateAnchor = false, ...rest } = options;
        const [firstFrame] = textures;
        super({
            ...rest,
            texture: firstFrame instanceof (0, $4iNSL.Texture) ? firstFrame : firstFrame.texture
        });
        this._textures = null;
        this._durations = null;
        this._autoUpdate = autoUpdate;
        this._isConnectedToTicker = false;
        this.animationSpeed = animationSpeed;
        this.loop = loop;
        this.updateAnchor = updateAnchor;
        this.onComplete = onComplete;
        this.onFrameChange = onFrameChange;
        this.onLoop = onLoop;
        this._currentTime = 0;
        this._playing = false;
        this._previousFrame = null;
        this.textures = textures;
        if (autoPlay) this.play();
    }
    /**
   * Stops the animation playback and freezes the current frame.
   * Does not reset the current frame or animation progress.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png')
   *     ],
   *     autoPlay: true
   * });
   *
   * // Stop at current frame
   * sprite.stop();
   *
   * // Stop at specific frame
   * sprite.gotoAndStop(1); // Stops at second frame
   *
   * // Stop and reset
   * sprite.stop();
   * sprite.currentFrame = 0;
   *
   * // Stop with completion check
   * if (sprite.playing) {
   *     sprite.stop();
   *     sprite.onComplete?.();
   * }
   * ```
   * @see {@link AnimatedSprite#play} For starting playback
   * @see {@link AnimatedSprite#gotoAndStop} For stopping at a specific frame
   * @see {@link AnimatedSprite#playing} For checking play state
   */ stop() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $jM8Go.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    }
    /**
   * Starts or resumes the animation playback.
   * If the animation was previously stopped, it will continue from where it left off.
   * @example
   * ```ts
   * // Basic playback
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *     ],
   *     autoPlay: false
   * });
   * sprite.play();
   *
   * // Play after stopping
   * sprite.stop();
   * sprite.currentFrame = 0; // Reset to start
   * sprite.play(); // Play from beginning
   *
   * // Play with auto-update disabled
   * sprite.autoUpdate = false;
   * sprite.play();
   * app.ticker.add(() => {
   *     sprite.update(app.ticker); // Manual updates
   * });
   * ```
   * @see {@link AnimatedSprite#stop} For stopping playback
   * @see {@link AnimatedSprite#gotoAndPlay} For playing from a specific frame
   * @see {@link AnimatedSprite#playing} For checking play state
   */ play() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $jM8Go.Ticker).shared.add(this.update, this, (0, $2HyEq.UPDATE_PRIORITY).HIGH);
            this._isConnectedToTicker = true;
        }
    }
    /**
   * Stops the AnimatedSprite and sets it to a specific frame.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png'),
   *     ]
   * });
   *
   * // Go to specific frames
   * sprite.gotoAndStop(0);  // First frame
   * sprite.gotoAndStop(2);  // Third frame
   *
   * // Jump to last frame
   * sprite.gotoAndStop(sprite.totalFrames - 1);
   * ```
   * @param frameNumber - Frame index to stop at (0-based)
   * @throws {Error} If frameNumber is out of bounds
   * @see {@link AnimatedSprite#gotoAndPlay} For going to a frame and playing
   * @see {@link AnimatedSprite#currentFrame} For getting/setting current frame
   * @see {@link AnimatedSprite#totalFrames} For total number of frames
   */ gotoAndStop(frameNumber) {
        this.stop();
        this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite from that point.
   * Combines frame navigation and playback start in one operation.
   * @example
   * ```ts
   * // Start from specific frame
   * sprite.gotoAndPlay(1); // Starts playing from second frame
   * ```
   * @param frameNumber - Frame index to start playing from (0-based)
   * @throws {Error} If frameNumber is out of bounds
   * @see {@link AnimatedSprite#gotoAndStop} For going to a frame without playing
   * @see {@link AnimatedSprite#play} For playing from current frame
   * @see {@link AnimatedSprite#currentFrame} For getting/setting current frame
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber;
        this.play();
    }
    /**
   * Updates the object transform for rendering. This method handles animation timing, frame updates,
   * and manages looping behavior.
   * @example
   * ```ts
   * // Create an animated sprite with manual updates
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('frame1.png'),
   *         Texture.from('frame2.png'),
   *         Texture.from('frame3.png')
   *     ],
   *     autoUpdate: false // Disable automatic updates
   * });
   *
   * // Manual update with app ticker
   * app.ticker.add((ticker) => {
   *     sprite.update(ticker);
   * });
   * ```
   * @param ticker - The ticker to use for updating the animation timing
   * @see {@link AnimatedSprite#autoUpdate} For controlling automatic updates
   * @see {@link AnimatedSprite#animationSpeed} For controlling animation speed
   * @see {@link Ticker} For timing system details
   */ update(ticker) {
        if (!this._playing) return;
        const deltaTime = ticker.deltaTime;
        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1e3;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this._updateTexture();
        }
    }
    /** Updates the displayed texture to match the current frame index. */ _updateTexture() {
        const currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this.texture = this._textures[currentFrame];
        if (this.updateAnchor && this.texture.defaultAnchor) this.anchor.copyFrom(this.texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    }
    /**
   * Stops the AnimatedSprite and destroys it.
   * This method stops the animation playback, removes it from the ticker,
   * and cleans up any resources associated with the sprite.
   * @param options - Options for destroying the sprite, such as whether to remove from parent
   * @example
   * ```ts
   * // Destroy the sprite when done
   * sprite.destroy();
   * // Or with options
   * sprite.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._textures.forEach((texture)=>{
                if (this.texture !== texture) texture.destroy(destroyTextureSource);
            });
        }
        this._textures = [];
        this._durations = null;
        this.stop();
        super.destroy(options);
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * Uses texture frames from the cache to create an animation sequence.
   * @example
   * ```ts
   * // Create from frame IDs
   * const frameIds = [
   *     'walk_001.png',
   *     'walk_002.png',
   *     'walk_003.png'
   * ];
   *
   * const walkingAnimation = AnimatedSprite.fromFrames(frameIds);
   * walkingAnimation.play();
   * ```
   * @param frames - The array of frame ids to use for the animation
   * @returns A new animated sprite using the frames
   * @see {@link Texture.from} For texture creation from frames
   * @see {@link Spritesheet} For loading spritesheets
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $4iNSL.Texture).from(frames[i]));
        return new $10731efba8cacc0d$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image urls.
   * Each image will be used as a frame in the animation.
   * @example
   * ```ts
   * // Create from image URLs
   * const images = [
   *     'assets/walk1.png',
   *     'assets/walk2.png',
   *     'assets/walk3.png'
   * ];
   *
   * const walkingSprite = AnimatedSprite.fromImages(images);
   * walkingSprite.play();
   * ```
   * @param images - The array of image urls to use as frames
   * @returns A new animated sprite using the images as frames
   * @see {@link Assets} For asset loading and management
   * @see {@link Texture.from} For texture creation from images
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $4iNSL.Texture).from(images[i]));
        return new $10731efba8cacc0d$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('frame1.png'),
   *         Texture.from('frame2.png'),
   *         Texture.from('frame3.png')
   *     ]
   * });
   *
   * // Get total frames
   * console.log(sprite.totalFrames); // Outputs: 3
   *
   * // Use with frame navigation
   * sprite.gotoAndStop(sprite.totalFrames - 1); // Go to last frame
   * ```
   * @readonly
   * @see {@link AnimatedSprite#currentFrame} For the current frame index
   * @see {@link AnimatedSprite#textures} For the array of textures
   * @returns {number} The total number of frames
   */ get totalFrames() {
        return this._textures.length;
    }
    /**
   * The array of textures or frame objects used for the animation sequence.
   * Can be set to either an array of Textures or an array of FrameObjects with custom timing.
   * @example
   * ```ts
   * // Update textures at runtime
   * sprite.textures = [
   *     Texture.from('run1.png'),
   *     Texture.from('run2.png')
   * ];
   *
   * // Use custom frame timing
   * sprite.textures = [
   *     { texture: Texture.from('explosion1.png'), time: 100 },
   *     { texture: Texture.from('explosion2.png'), time: 200 },
   *     { texture: Texture.from('explosion3.png'), time: 300 }
   * ];
   *
   * // Use with spritesheet
   * const sheet = await Assets.load('animations.json');
   * sprite.textures = sheet.animations['walk'];
   * ```
   * @type {AnimatedSpriteFrames}
   * @see {@link FrameObject} For frame timing options
   * @see {@link Spritesheet} For loading from spritesheets
   */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $4iNSL.Texture)) {
            this._textures = value;
            this._durations = null;
        } else {
            this._textures = [];
            this._durations = [];
            for(let i = 0; i < value.length; i++){
                this._textures.push(value[i].texture);
                this._durations.push(value[i].time);
            }
        }
        this._previousFrame = null;
        this.gotoAndStop(0);
        this._updateTexture();
    }
    /**
   * Gets or sets the current frame index of the animation.
   * When setting, the value will be clamped between 0 and totalFrames - 1.
   * @example
   * ```ts
   * // Create an animated sprite
   * const sprite = new AnimatedSprite({
   *     textures: [
   *         Texture.from('walk1.png'),
   *         Texture.from('walk2.png'),
   *         Texture.from('walk3.png')
   *     ]
   * });
   *
   * // Get current frame
   * console.log(sprite.currentFrame); // 0
   *
   * // Set specific frame
   * sprite.currentFrame = 1; // Show second frame
   *
   * // Use with frame callbacks
   * sprite.onFrameChange = (frame) => {
   *     console.log(`Now showing frame: ${frame}`);
   * };
   * sprite.currentFrame = 2;
   * ```
   * @throws {Error} If attempting to set a frame index out of bounds
   * @see {@link AnimatedSprite#totalFrames} For the total number of frames
   * @see {@link AnimatedSprite#gotoAndPlay} For playing from a specific frame
   * @see {@link AnimatedSprite#gotoAndStop} For stopping at a specific frame
   */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        if (currentFrame < 0) currentFrame += this._textures.length;
        return currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value;
        if (previousFrame !== this.currentFrame) this._updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * This is a read-only property that reflects the current playback state.
   * @example
   * ```ts
   * // Check if animation is playing
   * console.log('Playing:', sprite.playing); // true
   *
   * // Use with play control
   * if (!sprite.playing) {
   *     sprite.play();
   * }
   * ```
   * @readonly
   * @returns {boolean} True if the animation is currently playing
   * @see {@link AnimatedSprite#play} For starting playback
   * @see {@link AnimatedSprite#stop} For stopping playback
   * @see {@link AnimatedSprite#loop} For controlling looping behavior
   */ get playing() {
        return this._playing;
    }
    /**
   * Controls whether the animation automatically updates using the shared ticker.
   * When enabled, the animation will update on each frame. When disabled, you must
   * manually call update() to advance the animation.
   * @example
   * ```ts
   * // Create sprite with auto-update disabled
   * const sprite = new AnimatedSprite({
   *     textures: [],
   *     autoUpdate: false
   * });
   *
   * // Manual update with app ticker
   * app.ticker.add((ticker) => {
   *     sprite.update(ticker);
   * });
   *
   * // Enable auto-update later
   * sprite.autoUpdate = true;
   * ```
   * @default true
   * @see {@link AnimatedSprite#update} For manual animation updates
   * @see {@link Ticker} For the timing system
   */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            if (!this._autoUpdate && this._isConnectedToTicker) {
                (0, $jM8Go.Ticker).shared.remove(this.update, this);
                this._isConnectedToTicker = false;
            } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                (0, $jM8Go.Ticker).shared.add(this.update, this);
                this._isConnectedToTicker = true;
            }
        }
    }
}



var $h3cT0 = parcelRequire("h3cT0");

var $jZ66T = parcelRequire("jZ66T");

var $4iNSL = parcelRequire("4iNSL");

var $6LhOA = parcelRequire("6LhOA");

var $5xi4h = parcelRequire("5xi4h");

var $jZ66T = parcelRequire("jZ66T");
"use strict";
class $e1fb66846f7a0916$export$563a914cafbdc389 {
    /**
   * @param options - Options for the transform.
   * @param options.matrix - The matrix to use.
   * @param options.observer - The observer to use.
   */ constructor({ matrix: matrix, observer: observer } = {}){
        this.dirty = true;
        this._matrix = matrix ?? new (0, $5xi4h.Matrix)();
        this.observer = observer;
        this.position = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        this.scale = new (0, $jZ66T.ObservablePoint)(this, 1, 1);
        this.pivot = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        this.skew = new (0, $jZ66T.ObservablePoint)(this, 0, 0);
        this._rotation = 0;
        this._cx = 1;
        this._sx = 0;
        this._cy = 0;
        this._sy = 1;
    }
    /**
   * The transformation matrix computed from the transform's properties.
   * Combines position, scale, rotation, skew, and pivot into a single matrix.
   * @example
   * ```ts
   * // Get current matrix
   * const matrix = transform.matrix;
   * console.log(matrix.toString());
   * ```
   * @readonly
   * @see {@link Matrix} For matrix operations
   * @see {@link Transform.setFromMatrix} For setting transform from matrix
   */ get matrix() {
        const lt = this._matrix;
        if (!this.dirty) return lt;
        lt.a = this._cx * this.scale.x;
        lt.b = this._sx * this.scale.x;
        lt.c = this._cy * this.scale.y;
        lt.d = this._sy * this.scale.y;
        lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
        lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
        this.dirty = false;
        return lt;
    }
    /**
   * Called when a value changes.
   * @param point
   * @internal
   */ _onUpdate(point) {
        this.dirty = true;
        if (point === this.skew) this.updateSkew();
        this.observer?._onUpdate(this);
    }
    /** Called when the skew or the rotation changes. */ updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y);
        this._sx = Math.sin(this._rotation + this.skew.y);
        this._cy = -Math.sin(this._rotation - this.skew.x);
        this._sy = Math.cos(this._rotation - this.skew.x);
        this.dirty = true;
    }
    toString() {
        return `[pixi.js/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
    }
    /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @example
   * ```ts
   * // Basic matrix decomposition
   * const transform = new Transform();
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * transform.setFromMatrix(matrix);
   * console.log(transform.position.x); // 100
   * console.log(transform.rotation); // ~0.785 (π/4)
   * ```
   * @param matrix - The matrix to decompose
   * @see {@link Matrix#decompose} For the decomposition logic
   * @see {@link Transform#matrix} For getting the current matrix
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
        this.dirty = true;
    }
    /**
   * The rotation of the object in radians.
   * @example
   * ```ts
   * // Basic rotation
   * transform.rotation = Math.PI / 4; // 45 degrees
   *
   * // Rotate around pivot point
   * transform.pivot.set(50, 50);
   * transform.rotation = Math.PI; // 180 degrees around pivot
   *
   * // Animate rotation
   * app.ticker.add(() => {
   *     transform.rotation += 0.1;
   * });
   * ```
   * @see {@link Transform#pivot} For rotation point
   * @see {@link Transform#skew} For skew effects
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this.skew);
        }
    }
}



var $9FmI1 = parcelRequire("9FmI1");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $ds7Xo = parcelRequire("ds7Xo");

var $2IIjX = parcelRequire("2IIjX");

var $3qOui = parcelRequire("3qOui");

var $5nS5O = parcelRequire("5nS5O");
"use strict";
const $936bb8c91af7c8af$var$worldMatrix = new (0, $5xi4h.Matrix)();
const $936bb8c91af7c8af$var$patternMatrix = new (0, $5xi4h.Matrix)();
const $936bb8c91af7c8af$var$patternRect = [
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)(),
    new (0, $ds7Xo.Point)()
];
class $936bb8c91af7c8af$export$3c03e9c29c63a3e {
    constructor(renderer){
        this._renderer = renderer;
    }
    validateRenderable(_renderable) {
        return false;
    }
    addRenderable(tilingSprite, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(tilingSprite);
    }
    updateRenderable(_tilingSprite) {}
    execute(tilingSprite) {
        const renderer = this._renderer;
        const contextSystem = renderer.canvasContext;
        const context = contextSystem.activeContext;
        context.save();
        contextSystem.setBlendMode(tilingSprite.groupBlendMode);
        const globalColor = renderer.globalUniforms.globalUniformData?.worldColor ?? 4294967295;
        const groupColorAlpha = tilingSprite.groupColorAlpha;
        const globalAlpha = (globalColor >>> 24 & 255) / 255;
        const groupAlphaValue = (groupColorAlpha >>> 24 & 255) / 255;
        const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
        const alpha = globalAlpha * groupAlphaValue * filterAlpha;
        if (alpha <= 0) {
            context.restore();
            return;
        }
        context.globalAlpha = alpha;
        const globalTint = globalColor & 16777215;
        const groupTintBGR = groupColorAlpha & 16777215;
        const tint = (0, $3qOui.bgr2rgb)((0, $5nS5O.multiplyHexColors)(groupTintBGR, globalTint));
        const texture = tilingSprite.texture;
        const pattern = (0, $2IIjX.canvasUtils).getTintedPattern(texture, tint);
        const width = tilingSprite.width;
        const height = tilingSprite.height;
        const transform = tilingSprite.groupTransform;
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        $936bb8c91af7c8af$var$patternMatrix.copyFrom(tilingSprite._tileTransform.matrix);
        if (!tilingSprite.applyAnchorToTexture) $936bb8c91af7c8af$var$patternMatrix.translate(-tilingSprite.anchor.x * width, -tilingSprite.anchor.y * height);
        $936bb8c91af7c8af$var$patternMatrix.scale(1 / resolution, 1 / resolution);
        $936bb8c91af7c8af$var$worldMatrix.identity();
        $936bb8c91af7c8af$var$worldMatrix.prepend($936bb8c91af7c8af$var$patternMatrix);
        $936bb8c91af7c8af$var$worldMatrix.prepend(transform);
        const roundPixels = renderer._roundPixels | tilingSprite._roundPixels;
        contextSystem.setContextTransform($936bb8c91af7c8af$var$worldMatrix, roundPixels === 1);
        context.fillStyle = pattern;
        const lx = tilingSprite.anchor.x * -width;
        const ly = tilingSprite.anchor.y * -height;
        $936bb8c91af7c8af$var$patternRect[0].set(lx, ly);
        $936bb8c91af7c8af$var$patternRect[1].set(lx + width, ly);
        $936bb8c91af7c8af$var$patternRect[2].set(lx + width, ly + height);
        $936bb8c91af7c8af$var$patternRect[3].set(lx, ly + height);
        for(let i = 0; i < 4; i++)$936bb8c91af7c8af$var$patternMatrix.applyInverse($936bb8c91af7c8af$var$patternRect[i], $936bb8c91af7c8af$var$patternRect[i]);
        context.beginPath();
        context.moveTo($936bb8c91af7c8af$var$patternRect[0].x, $936bb8c91af7c8af$var$patternRect[0].y);
        for(let i = 1; i < 4; i++)context.lineTo($936bb8c91af7c8af$var$patternRect[i].x, $936bb8c91af7c8af$var$patternRect[i].y);
        context.closePath();
        context.fill();
        context.restore();
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $936bb8c91af7c8af$export$3c03e9c29c63a3e.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "tilingSprite"
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $fy1Tx = parcelRequire("fy1Tx");

var $fx0Zy = parcelRequire("fx0Zy");

var $bfcaK = parcelRequire("bfcaK");

var $6tS7R = parcelRequire("6tS7R");

var $id0ju = parcelRequire("id0ju");



var $5xi4h = parcelRequire("5xi4h");

var $aYOxl = parcelRequire("aYOxl");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $7LCXQ = parcelRequire("7LCXQ");

var $aUxJK = parcelRequire("aUxJK");

var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $6eac24ae08973551$export$7551c6773b6af70d = {
    name: "tiling-bit",
    vertex: {
        header: /* wgsl */ `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `,
        main: /* wgsl */ `
            uv = (tilingUniforms.uTextureTransform * vec3(uv, 1.0)).xy;

            position = (position - tilingUniforms.uSizeAnchor.zw) * tilingUniforms.uSizeAnchor.xy;
        `
    },
    fragment: {
        header: /* wgsl */ `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `,
        main: /* wgsl */ `

            var coord = vUV + ceil(tilingUniforms.uClampOffset - vUV);
            coord = (tilingUniforms.uMapCoord * vec3(coord, 1.0)).xy;
            var unclamped = coord;
            coord = clamp(coord, tilingUniforms.uClampFrame.xy, tilingUniforms.uClampFrame.zw);

            var bias = 0.;

            if(unclamped.x == coord.x && unclamped.y == coord.y)
            {
                bias = -32.;
            }

            outColor = textureSampleBias(uTexture, uSampler, coord, bias);
        `
    }
};
const $6eac24ae08973551$export$a104558c66046525 = {
    name: "tiling-bit",
    vertex: {
        header: /* glsl */ `
            uniform mat3 uTextureTransform;
            uniform vec4 uSizeAnchor;

        `,
        main: /* glsl */ `
            uv = (uTextureTransform * vec3(aUV, 1.0)).xy;

            position = (position - uSizeAnchor.zw) * uSizeAnchor.xy;
        `
    },
    fragment: {
        header: /* glsl */ `
            uniform sampler2D uTexture;
            uniform mat3 uMapCoord;
            uniform vec4 uClampFrame;
            uniform vec2 uClampOffset;
        `,
        main: /* glsl */ `

        vec2 coord = vUV + ceil(uClampOffset - vUV);
        coord = (uMapCoord * vec3(coord, 1.0)).xy;
        vec2 unclamped = coord;
        coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

        outColor = texture(uTexture, coord, unclamped == coord ? 0.0 : -32.0);// lod-bias very negative to force lod 0

        `
    }
};


"use strict";
let $0f7a0e3ea53c5cf5$var$gpuProgram;
let $0f7a0e3ea53c5cf5$var$glProgram;
class $0f7a0e3ea53c5cf5$export$d1a26cc57b383809 extends (0, $7LCXQ.Shader) {
    constructor(){
        $0f7a0e3ea53c5cf5$var$gpuProgram ?? ($0f7a0e3ea53c5cf5$var$gpuProgram = (0, $aYOxl.compileHighShaderGpuProgram)({
            name: "tiling-sprite-shader",
            bits: [
                (0, $dKCGl.localUniformBit),
                (0, $6eac24ae08973551$export$7551c6773b6af70d),
                (0, $gnlmr.roundPixelsBit)
            ]
        }));
        $0f7a0e3ea53c5cf5$var$glProgram ?? ($0f7a0e3ea53c5cf5$var$glProgram = (0, $aYOxl.compileHighShaderGlProgram)({
            name: "tiling-sprite-shader",
            bits: [
                (0, $dKCGl.localUniformBitGl),
                (0, $6eac24ae08973551$export$a104558c66046525),
                (0, $gnlmr.roundPixelsBitGl)
            ]
        }));
        const tilingUniforms = new (0, $aUxJK.UniformGroup)({
            uMapCoord: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uClampFrame: {
                value: new Float32Array([
                    0,
                    0,
                    1,
                    1
                ]),
                type: "vec4<f32>"
            },
            uClampOffset: {
                value: new Float32Array([
                    0,
                    0
                ]),
                type: "vec2<f32>"
            },
            uTextureTransform: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uSizeAnchor: {
                value: new Float32Array([
                    100,
                    100,
                    0.5,
                    0.5
                ]),
                type: "vec4<f32>"
            }
        });
        super({
            glProgram: $0f7a0e3ea53c5cf5$var$glProgram,
            gpuProgram: $0f7a0e3ea53c5cf5$var$gpuProgram,
            resources: {
                localUniforms: new (0, $aUxJK.UniformGroup)({
                    uTransformMatrix: {
                        value: new (0, $5xi4h.Matrix)(),
                        type: "mat3x3<f32>"
                    },
                    uColor: {
                        value: new Float32Array([
                            1,
                            1,
                            1,
                            1
                        ]),
                        type: "vec4<f32>"
                    },
                    uRound: {
                        value: 0,
                        type: "f32"
                    }
                }),
                tilingUniforms: tilingUniforms,
                uTexture: (0, $4iNSL.Texture).EMPTY.source,
                uSampler: (0, $4iNSL.Texture).EMPTY.source.style
            }
        });
    }
    updateUniforms(width, height, matrix, anchorX, anchorY, texture) {
        const tilingUniforms = this.resources.tilingUniforms;
        const textureWidth = texture.width;
        const textureHeight = texture.height;
        const textureMatrix = texture.textureMatrix;
        const uTextureTransform = tilingUniforms.uniforms.uTextureTransform;
        uTextureTransform.set(matrix.a * textureWidth / width, matrix.b * textureWidth / height, matrix.c * textureHeight / width, matrix.d * textureHeight / height, matrix.tx / width, matrix.ty / height);
        uTextureTransform.invert();
        tilingUniforms.uniforms.uMapCoord = textureMatrix.mapCoord;
        tilingUniforms.uniforms.uClampFrame = textureMatrix.uClampFrame;
        tilingUniforms.uniforms.uClampOffset = textureMatrix.uClampOffset;
        tilingUniforms.uniforms.uTextureTransform = uTextureTransform;
        tilingUniforms.uniforms.uSizeAnchor[0] = width;
        tilingUniforms.uniforms.uSizeAnchor[1] = height;
        tilingUniforms.uniforms.uSizeAnchor[2] = anchorX;
        tilingUniforms.uniforms.uSizeAnchor[3] = anchorY;
        if (texture) {
            this.resources.uTexture = texture.source;
            this.resources.uSampler = texture.source.style;
        }
    }
}



"use strict";
class $eb432fb3b2929fc1$export$d27e254c8c1b5a0e extends (0, $b964c6f5532210d5$export$8d075a36a73d54bc) {
    constructor(){
        super({
            positions: new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]),
            uvs: new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]),
            indices: new Uint32Array([
                0,
                1,
                2,
                0,
                2,
                3
            ])
        });
    }
}


"use strict";
function $ec148d7b76e35c4c$export$7d390d1e3efa819a(tilingSprite, positions) {
    const anchorX = tilingSprite.anchor.x;
    const anchorY = tilingSprite.anchor.y;
    positions[0] = -anchorX * tilingSprite.width;
    positions[1] = -anchorY * tilingSprite.height;
    positions[2] = (1 - anchorX) * tilingSprite.width;
    positions[3] = -anchorY * tilingSprite.height;
    positions[4] = (1 - anchorX) * tilingSprite.width;
    positions[5] = (1 - anchorY) * tilingSprite.height;
    positions[6] = -anchorX * tilingSprite.width;
    positions[7] = (1 - anchorY) * tilingSprite.height;
}



var $5xi4h = parcelRequire("5xi4h");
"use strict";
function $c71258507d8b5aba$export$8e14504c3429ee65(array, stride, offset, matrix) {
    let index = 0;
    const size = array.length / (stride || 2);
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    offset *= stride;
    while(index < size){
        const x = array[offset];
        const y = array[offset + 1];
        array[offset] = a * x + c * y + tx;
        array[offset + 1] = b * x + d * y + ty;
        offset += stride;
        index++;
    }
}


"use strict";
function $198813f83dc3f3a5$export$f99a1f47283a6d20(tilingSprite, uvs) {
    const texture = tilingSprite.texture;
    const width = texture.frame.width;
    const height = texture.frame.height;
    let anchorX = 0;
    let anchorY = 0;
    if (tilingSprite.applyAnchorToTexture) {
        anchorX = tilingSprite.anchor.x;
        anchorY = tilingSprite.anchor.y;
    }
    uvs[0] = uvs[6] = -anchorX;
    uvs[2] = uvs[4] = 1 - anchorX;
    uvs[1] = uvs[3] = -anchorY;
    uvs[5] = uvs[7] = 1 - anchorY;
    const textureMatrix = (0, $5xi4h.Matrix).shared;
    textureMatrix.copyFrom(tilingSprite._tileTransform.matrix);
    textureMatrix.tx /= tilingSprite.width;
    textureMatrix.ty /= tilingSprite.height;
    textureMatrix.invert();
    textureMatrix.scale(tilingSprite.width / width, tilingSprite.height / height);
    (0, $c71258507d8b5aba$export$8e14504c3429ee65)(uvs, 2, 0, textureMatrix);
}


"use strict";
const $3869af071e31b3e5$var$sharedQuad = new (0, $eb432fb3b2929fc1$export$d27e254c8c1b5a0e)();
class $3869af071e31b3e5$export$885407fa78df5856 {
    constructor(){
        this.canBatch = true;
        this.geometry = new (0, $b964c6f5532210d5$export$8d075a36a73d54bc)({
            indices: $3869af071e31b3e5$var$sharedQuad.indices.slice(),
            positions: $3869af071e31b3e5$var$sharedQuad.positions.slice(),
            uvs: $3869af071e31b3e5$var$sharedQuad.uvs.slice()
        });
    }
    destroy() {
        this.geometry.destroy();
        this.shader?.destroy();
    }
}
class $3869af071e31b3e5$export$b56051ebf906ec5d {
    constructor(renderer){
        this._state = (0, $fx0Zy.State).default2d;
        this._renderer = renderer;
        this._managedTilingSprites = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            name: "tilingSprite"
        });
    }
    validateRenderable(renderable) {
        const tilingSpriteData = this._getTilingSpriteData(renderable);
        const couldBatch = tilingSpriteData.canBatch;
        this._updateCanBatch(renderable);
        const canBatch = tilingSpriteData.canBatch;
        if (canBatch && canBatch === couldBatch) {
            const { batchableMesh: batchableMesh } = tilingSpriteData;
            return !batchableMesh._batcher.checkAndUpdateTexture(batchableMesh, renderable.texture);
        }
        return couldBatch !== canBatch;
    }
    addRenderable(tilingSprite, instructionSet) {
        const batcher = this._renderer.renderPipes.batch;
        this._updateCanBatch(tilingSprite);
        const tilingSpriteData = this._getTilingSpriteData(tilingSprite);
        const { geometry: geometry, canBatch: canBatch } = tilingSpriteData;
        if (canBatch) {
            tilingSpriteData.batchableMesh || (tilingSpriteData.batchableMesh = new (0, $1ad5fe12a59ec279$export$2fa0f0ec877329e3)());
            const batchableMesh = tilingSpriteData.batchableMesh;
            if (tilingSprite.didViewUpdate) {
                this._updateBatchableMesh(tilingSprite);
                batchableMesh.geometry = geometry;
                batchableMesh.renderable = tilingSprite;
                batchableMesh.transform = tilingSprite.groupTransform;
                batchableMesh.setTexture(tilingSprite._texture);
            }
            batchableMesh.roundPixels = this._renderer._roundPixels | tilingSprite._roundPixels;
            batcher.addToBatch(batchableMesh, instructionSet);
        } else {
            batcher.break(instructionSet);
            tilingSpriteData.shader || (tilingSpriteData.shader = new (0, $0f7a0e3ea53c5cf5$export$d1a26cc57b383809)());
            this.updateRenderable(tilingSprite);
            instructionSet.add(tilingSprite);
        }
    }
    execute(tilingSprite) {
        const renderer = this._renderer;
        const { shader: shader } = this._getTilingSpriteData(tilingSprite);
        shader.groups[0] = renderer.globalUniforms.bindGroup;
        const localUniforms = shader.resources.localUniforms.uniforms;
        localUniforms.uTransformMatrix = tilingSprite.groupTransform;
        localUniforms.uRound = renderer._roundPixels | tilingSprite._roundPixels;
        (0, $id0ju.color32BitToUniform)(tilingSprite.groupColorAlpha, localUniforms.uColor, 0);
        this._state.blendMode = (0, $fy1Tx.getAdjustedBlendModeBlend)(tilingSprite.groupBlendMode, tilingSprite.texture._source);
        renderer.encoder.draw({
            geometry: $3869af071e31b3e5$var$sharedQuad,
            shader: shader,
            state: this._state
        });
    }
    updateRenderable(tilingSprite) {
        const tilingSpriteData = this._getTilingSpriteData(tilingSprite);
        const { canBatch: canBatch } = tilingSpriteData;
        if (canBatch) {
            const { batchableMesh: batchableMesh } = tilingSpriteData;
            if (tilingSprite.didViewUpdate) this._updateBatchableMesh(tilingSprite);
            batchableMesh._batcher.updateElement(batchableMesh);
        } else if (tilingSprite.didViewUpdate) {
            const { shader: shader } = tilingSpriteData;
            shader.updateUniforms(tilingSprite.width, tilingSprite.height, tilingSprite._tileTransform.matrix, tilingSprite.anchor.x, tilingSprite.anchor.y, tilingSprite.texture);
        }
    }
    _getTilingSpriteData(renderable) {
        return renderable._gpuData[this._renderer.uid] || this._initTilingSpriteData(renderable);
    }
    _initTilingSpriteData(tilingSprite) {
        const gpuData = new $3869af071e31b3e5$export$885407fa78df5856();
        gpuData.renderable = tilingSprite;
        tilingSprite._gpuData[this._renderer.uid] = gpuData;
        this._managedTilingSprites.add(tilingSprite);
        return gpuData;
    }
    _updateBatchableMesh(tilingSprite) {
        const renderableData = this._getTilingSpriteData(tilingSprite);
        const { geometry: geometry } = renderableData;
        const style = tilingSprite.texture.source.style;
        if (style.addressMode !== "repeat") {
            style.addressMode = "repeat";
            style.update();
        }
        (0, $198813f83dc3f3a5$export$f99a1f47283a6d20)(tilingSprite, geometry.uvs);
        (0, $ec148d7b76e35c4c$export$7d390d1e3efa819a)(tilingSprite, geometry.positions);
    }
    destroy() {
        this._managedTilingSprites.destroy();
        this._renderer = null;
    }
    _updateCanBatch(tilingSprite) {
        const renderableData = this._getTilingSpriteData(tilingSprite);
        const texture = tilingSprite.texture;
        let _nonPowOf2wrapping = true;
        if (this._renderer.type === (0, $bfcaK.RendererType).WEBGL) _nonPowOf2wrapping = this._renderer.context.supports.nonPowOf2wrapping;
        renderableData.canBatch = texture.textureMatrix.isSimple && (_nonPowOf2wrapping || texture.source.isPowerOfTwo);
        return renderableData.canBatch;
    }
}
/** @ignore */ $3869af071e31b3e5$export$b56051ebf906ec5d.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "tilingSprite"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $936bb8c91af7c8af$export$3c03e9c29c63a3e));
(0, $aZ9ZN.extensions).add((0, $3869af071e31b3e5$export$b56051ebf906ec5d));


"use strict";
const $35a7b8f9b04fc055$var$_TilingSprite = class _TilingSprite extends (0, $9FmI1.ViewContainer) {
    constructor(...args){
        let options = args[0] || {};
        if (options instanceof (0, $4iNSL.Texture)) options = {
            texture: options
        };
        if (args.length > 1) {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "use new TilingSprite({ texture, width:100, height:100 }) instead");
            options.width = args[1];
            options.height = args[2];
        }
        options = {
            ..._TilingSprite.defaultOptions,
            ...options
        };
        const { texture: texture, anchor: anchor, tilePosition: tilePosition, tileScale: tileScale, tileRotation: tileRotation, width: width, height: height, applyAnchorToTexture: applyAnchorToTexture, roundPixels: roundPixels, ...rest } = options ?? {};
        super({
            label: "TilingSprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "tilingSprite";
        /** @advanced */ this.batched = true;
        this.allowChildren = false;
        this._anchor = new (0, $jZ66T.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        this.applyAnchorToTexture = applyAnchorToTexture;
        this.texture = texture;
        this._width = width ?? texture.width;
        this._height = height ?? texture.height;
        this._tileTransform = new (0, $e1fb66846f7a0916$export$563a914cafbdc389)({
            observer: {
                _onUpdate: ()=>this.onViewUpdate()
            }
        });
        if (anchor) this.anchor = anchor;
        this.tilePosition = tilePosition;
        this.tileScale = tileScale;
        this.tileRotation = tileRotation;
        this.roundPixels = roundPixels ?? false;
    }
    /**
   * Creates a new tiling sprite based on a source texture or image path.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create a new tiling sprite from an image path
   * const pattern = TilingSprite.from('pattern.png');
   * pattern.width = 300; // Set the width of the tiling area
   * pattern.height = 200; // Set the height of the tiling area
   *
   * // Create from options
   * const texture = Texture.from('pattern.png');
   * const pattern = TilingSprite.from(texture, {
   *     width: 300,
   *     height: 200,
   *     tileScale: { x: 0.5, y: 0.5 }
   * });
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image or a texture
   * @param options - Additional options for the tiling sprite
   * @returns A new tiling sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, options = {}) {
        if (typeof source === "string") return new _TilingSprite({
            texture: (0, $h3cT0.Cache).get(source),
            ...options
        });
        return new _TilingSprite({
            texture: source,
            ...options
        });
    }
    /**
   * @see {@link TilingSpriteOptions.applyAnchorToTexture}
   * @deprecated since 8.0.0
   * @advanced
   */ get uvRespectAnchor() {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "uvRespectAnchor is deprecated, please use applyAnchorToTexture instead");
        return this.applyAnchorToTexture;
    }
    /** @advanced */ set uvRespectAnchor(value) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "uvRespectAnchor is deprecated, please use applyAnchorToTexture instead");
        this.applyAnchorToTexture = value;
    }
    /**
   * Changes frame clamping in corresponding textureMatrix
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @type {number}
   * @advanced
   */ get clampMargin() {
        return this._texture.textureMatrix.clampMargin;
    }
    /** @advanced */ set clampMargin(value) {
        this._texture.textureMatrix.clampMargin = value;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The offset of the tiling texture.
   * Used to scroll or position the repeated pattern.
   * @example
   * ```ts
   * // Offset the tiling pattern by 100 pixels in both x and y directions
   * tilingSprite.tilePosition = { x: 100, y: 100 };
   * ```
   * @default {x: 0, y: 0}
   */ get tilePosition() {
        return this._tileTransform.position;
    }
    set tilePosition(value) {
        this._tileTransform.position.copyFrom(value);
    }
    /**
   * Scale of the tiling texture.
   * Affects the size of each repeated instance of the texture.
   * @example
   * ```ts
   * // Scale the texture by 1.5 in both x and y directions
   * tilingSprite.tileScale = { x: 1.5, y: 1.5 };
   * ```
   * @default {x: 1, y: 1}
   */ get tileScale() {
        return this._tileTransform.scale;
    }
    set tileScale(value) {
        typeof value === "number" ? this._tileTransform.scale.set(value) : this._tileTransform.scale.copyFrom(value);
    }
    set tileRotation(value) {
        this._tileTransform.rotation = value;
    }
    /**
   * Rotation of the tiling texture in radians.
   * This controls the rotation applied to the texture before tiling.
   * @example
   * ```ts
   * // Rotate the texture by 45 degrees (in radians)
   * tilingSprite.tileRotation = Math.PI / 4; // 45 degrees
   * ```
   * @default 0
   */ get tileRotation() {
        return this._tileTransform.rotation;
    }
    /**
   * The transform object that controls the tiling texture's position, scale, and rotation.
   * This transform is independent of the sprite's own transform properties.
   * @example
   * ```ts
   * // Access transform properties directly
   * sprite.tileTransform.position.set(100, 50);
   * sprite.tileTransform.scale.set(2);
   * sprite.tileTransform.rotation = Math.PI / 4;
   *
   * // Create smooth scrolling animation
   * app.ticker.add(() => {
   *     sprite.tileTransform.position.x += 1;
   *     sprite.tileTransform.rotation += 0.01;
   * });
   *
   * // Reset transform
   * sprite.tileTransform.position.set(0);
   * sprite.tileTransform.scale.set(1);
   * sprite.tileTransform.rotation = 0;
   * ```
   * @returns {Transform} The transform object for the tiling texture
   * @see {@link Transform} For transform operations
   * @see {@link TilingSprite#tilePosition} For position control
   * @see {@link TilingSprite#tileScale} For scale control
   * @see {@link TilingSprite#tileRotation} For rotation control
   * @advanced
   */ get tileTransform() {
        return this._tileTransform;
    }
    set texture(value) {
        value || (value = (0, $4iNSL.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /**
   * The texture to use for tiling.
   * This is the image that will be repeated across the sprite.
   * @example
   * ```ts
   * // Use a texture from the asset cache
   * tilingSprite.texture = Texture.from('assets/pattern.png');
   * ```
   * @default Texture.WHITE
   */ get texture() {
        return this._texture;
    }
    /**
   * The width of the tiling area. This defines how wide the area is that the texture will be tiled across.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 500,
   *     height: 300
   * });
   *
   * // Adjust width dynamically
   * sprite.width = 800; // Expands tiling area
   *
   * // Update on resize
   * window.addEventListener('resize', () => {
   *     sprite.width = app.screen.width;
   * });
   * ```
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   * @see {@link TilingSprite#height} For setting height
   */ set width(value) {
        this._width = value;
        this.onViewUpdate();
    }
    get width() {
        return this._width;
    }
    set height(value) {
        this._height = value;
        this.onViewUpdate();
    }
    /**
   * The height of the tiling area. This defines how tall the area is that the texture will be tiled across.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 500,
   *     height: 300
   * });
   *
   * // Adjust width dynamically
   * sprite.height = 800; // Expands tiling area
   *
   * // Update on resize
   * window.addEventListener('resize', () => {
   *     sprite.height = app.screen.height;
   * });
   * ```
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   * @see {@link TilingSprite#width} For setting width
   */ get height() {
        return this._height;
    }
    /**
   * Sets the size of the TilingSprite to the specified width and height.
   * This is faster than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set specific dimensions
   * sprite.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size (square)
   * sprite.setSize(400); // Width: 400, Height: 400
   *
   * // Set size using object
   * sprite.setSize({
   *     width: 500,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number for uniform sizing or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link TilingSprite#width} For setting width only
   * @see {@link TilingSprite#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        }
        this._width = value;
        this._height = height ?? value;
        this.onViewUpdate();
    }
    /**
   * Retrieves the size of the TilingSprite as a {@link Size} object.
   * This method is more efficient than getting width and height separately as it only allocates one object.
   * @example
   * ```ts
   * // Get basic size
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the TilingSprite
   * @see {@link TilingSprite#width} For getting just the width
   * @see {@link TilingSprite#height} For getting just the height
   * @see {@link TilingSprite#setSize} For setting both width and height efficiently
   */ getSize(out) {
        out || (out = {});
        out.width = this._width;
        out.height = this._height;
        return out;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const width = this._width;
        const height = this._height;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Takes into account the anchor offset when determining boundaries.
   * @example
   * ```ts
   * // Create a tiling sprite
   * const sprite = new TilingSprite({
   *     texture: Texture.from('pattern.png'),
   *     width: 200,
   *     height: 100,
   *     anchor: 0.5 // Center anchor
   * });
   *
   * // Basic point check
   * const contains = sprite.containsPoint({ x: 50, y: 25 });
   * console.log('Point is inside:', contains);
   *
   * // Check with different anchors
   * sprite.anchor.set(0); // Top-left anchor
   * console.log('Contains point:', sprite.containsPoint({ x: 150, y: 75 }));
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the sprite's bounds
   * @see {@link TilingSprite#toLocal} For converting global coordinates to local
   * @see {@link TilingSprite#anchor} For understanding boundary calculations
   */ containsPoint(point) {
        const width = this._width;
        const height = this._height;
        const x1 = -width * this._anchor._x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this._anchor._y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * tilingSprite.destroy();
   * tilingSprite.destroy(true);
   * tilingSprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        this._anchor = null;
        this._tileTransform = null;
        this._bounds = null;
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
    }
};
/**
 * Default options used when creating a TilingSprite instance.
 * These values are used as fallbacks when specific options are not provided.
 * @example
 * ```ts
 * // Override default options globally
 * TilingSprite.defaultOptions.texture = Texture.from('defaultPattern.png');
 * TilingSprite.defaultOptions.tileScale = { x: 2, y: 2 };
 *
 * // Create sprite using default options
 * const sprite = new TilingSprite();
 * // Will use defaultPattern.png and scale 2x
 * ```
 * @type {TilingSpriteOptions}
 * @see {@link TilingSpriteOptions} For all available options
 * @see {@link TilingSprite.from} For creating sprites with custom options
 * @see {@link Texture.EMPTY} For the default empty texture
 */ $35a7b8f9b04fc055$var$_TilingSprite.defaultOptions = {
    /** The texture to use for the sprite. */ texture: (0, $4iNSL.Texture).EMPTY,
    /** The anchor point of the sprite */ anchor: {
        x: 0,
        y: 0
    },
    /** The offset of the image that is being tiled. */ tilePosition: {
        x: 0,
        y: 0
    },
    /** Scaling of the image that is being tiled. */ tileScale: {
        x: 1,
        y: 1
    },
    /** The rotation of the image that is being tiled. */ tileRotation: 0,
    /**
   * Flags whether the tiling pattern should originate from the origin instead of the top-left corner in
   * local space.
   *
   * This will make the texture coordinates assigned to each vertex dependent on the value of the anchor. Without
   * this, the top-left corner always gets the (0, 0) texture coordinate.
   * @default false
   */ applyAnchorToTexture: false
};
let $35a7b8f9b04fc055$export$db8370cd1ebcc819 = $35a7b8f9b04fc055$var$_TilingSprite;



var $c8piJ = parcelRequire("c8piJ");

var $jZ66T = parcelRequire("jZ66T");

var $6LhOA = parcelRequire("6LhOA");

var $9FmI1 = parcelRequire("9FmI1");
"use strict";
class $19c3827930a6b92b$export$daf74670712de91 extends (0, $9FmI1.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $jZ66T.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this._text}:${this._style.styleKey}:${this._resolution}`;
    }
}
function $19c3827930a6b92b$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}



var $dKHyW = parcelRequire("dKHyW");

var $ar2Ly = parcelRequire("ar2Ly");

var $dDZJD = parcelRequire("dDZJD");

var $gLw46 = parcelRequire("gLw46");

var $fSIhN = parcelRequire("fSIhN");

var $ar2Ly = parcelRequire("ar2Ly");
"use strict";
let $39709c41b8535a9b$var$_internalCanvas = null;
let $39709c41b8535a9b$var$_internalContext = null;
function $39709c41b8535a9b$var$ensureInternalCanvas(width, height) {
    if (!$39709c41b8535a9b$var$_internalCanvas) {
        $39709c41b8535a9b$var$_internalCanvas = (0, $gLw46.DOMAdapter).get().createCanvas(256, 128);
        $39709c41b8535a9b$var$_internalContext = $39709c41b8535a9b$var$_internalCanvas.getContext("2d", {
            willReadFrequently: true
        });
        $39709c41b8535a9b$var$_internalContext.globalCompositeOperation = "copy";
        $39709c41b8535a9b$var$_internalContext.globalAlpha = 1;
    }
    if ($39709c41b8535a9b$var$_internalCanvas.width < width || $39709c41b8535a9b$var$_internalCanvas.height < height) {
        $39709c41b8535a9b$var$_internalCanvas.width = (0, $fSIhN.nextPow2)(width);
        $39709c41b8535a9b$var$_internalCanvas.height = (0, $fSIhN.nextPow2)(height);
    }
}
function $39709c41b8535a9b$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $39709c41b8535a9b$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $39709c41b8535a9b$export$550eedf6c679837d(...args) {
    let options = args[0];
    if (!options.canvas) options = {
        canvas: args[0],
        resolution: args[1]
    };
    const { canvas: canvas } = options;
    const resolution = Math.min(options.resolution ?? 1, 1);
    const width = options.width ?? canvas.width;
    const height = options.height ?? canvas.height;
    let output = options.output;
    $39709c41b8535a9b$var$ensureInternalCanvas(width, height);
    if (!$39709c41b8535a9b$var$_internalContext) throw new TypeError("Failed to get canvas 2D context");
    $39709c41b8535a9b$var$_internalContext.drawImage(canvas, 0, 0, width, height, 0, 0, width * resolution, height * resolution);
    const imageData = $39709c41b8535a9b$var$_internalContext.getImageData(0, 0, width, height);
    const data = imageData.data;
    let left = 0;
    let top = 0;
    let right = width - 1;
    let bottom = height - 1;
    while(top < height && $39709c41b8535a9b$var$checkRow(data, width, top))++top;
    if (top === height) return (0, $ar2Ly.Rectangle).EMPTY;
    while($39709c41b8535a9b$var$checkRow(data, width, bottom))--bottom;
    while($39709c41b8535a9b$var$checkColumn(data, width, left, top, bottom))++left;
    while($39709c41b8535a9b$var$checkColumn(data, width, right, top, bottom))--right;
    ++right;
    ++bottom;
    $39709c41b8535a9b$var$_internalContext.globalCompositeOperation = "source-over";
    $39709c41b8535a9b$var$_internalContext.strokeRect(left, top, right - left, bottom - top);
    $39709c41b8535a9b$var$_internalContext.globalCompositeOperation = "copy";
    output ?? (output = new (0, $ar2Ly.Rectangle)());
    output.set(left / resolution, top / resolution, (right - left) / resolution, (bottom - top) / resolution);
    return output;
}



var $1i9ku = parcelRequire("1i9ku");

var $3FldU = parcelRequire("3FldU");

var $hFmvn = parcelRequire("hFmvn");
"use strict";
const $7a49002c4353b76b$var$tempRect = new (0, $ar2Ly.Rectangle)();
class $7a49002c4353b76b$var$CanvasTextGeneratorClass {
    /**
   * Creates a canvas with the specified text rendered to it.
   *
   * Generates a canvas of appropriate size, renders the text with the provided style,
   * and returns both the canvas/context and a Rectangle representing the text bounds.
   *
   * When trim is enabled in the style, the frame will represent the bounds of the
   * non-transparent pixels, which can be smaller than the full canvas.
   * @param options - The options for generating the text canvas
   * @param options.text - The text to render
   * @param options.style - The style to apply to the text
   * @param options.resolution - The resolution of the canvas (defaults to 1)
   * @param options.padding
   * @returns An object containing the canvas/context and the frame (bounds) of the text
   */ getCanvasAndContext(options) {
        const { text: text, style: style, resolution: resolution = 1 } = options;
        const padding = style._getFinalPadding();
        const measured = (0, $1i9ku.CanvasTextMetrics).measureText(text || " ", style);
        const width = Math.ceil(Math.ceil(Math.max(1, measured.width) + padding * 2) * resolution);
        const height = Math.ceil(Math.ceil(Math.max(1, measured.height) + padding * 2) * resolution);
        const canvasAndContext = (0, $dDZJD.CanvasPool).getOptimalCanvasAndContext(width, height);
        this._renderTextToCanvas(style, padding, resolution, canvasAndContext, measured);
        const frame = style.trim ? (0, $39709c41b8535a9b$export$550eedf6c679837d)({
            canvas: canvasAndContext.canvas,
            width: width,
            height: height,
            resolution: 1,
            output: $7a49002c4353b76b$var$tempRect
        }) : $7a49002c4353b76b$var$tempRect.set(0, 0, width, height);
        return {
            canvasAndContext: canvasAndContext,
            frame: frame
        };
    }
    /**
   * Returns a canvas and context to the pool.
   *
   * This should be called when you're done with the canvas to allow reuse
   * and prevent memory leaks.
   * @param canvasAndContext - The canvas and context to return to the pool
   */ returnCanvasAndContext(canvasAndContext) {
        (0, $dDZJD.CanvasPool).returnCanvasAndContext(canvasAndContext);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @param style - The style of the text
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render the text to
   * @param measured - Pre-measured text metrics to avoid duplicate measurement
   */ _renderTextToCanvas(style, padding, resolution, canvasAndContext, measured) {
        if (measured.runsByLine && measured.runsByLine.length > 0) {
            this._renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext);
            return;
        }
        const { canvas: canvas, context: context } = canvasAndContext;
        const font = (0, $3FldU.fontStringFromTextStyle)(style);
        const lines = measured.lines;
        const lineHeight = measured.lineHeight;
        const lineWidths = measured.lineWidths;
        const maxLineWidth = measured.maxLineWidth;
        const fontProperties = measured.fontProperties;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        if (style._stroke?.width) {
            const strokeStyle = style._stroke;
            context.lineWidth = strokeStyle.width;
            context.miterLimit = strokeStyle.miterLimit;
            context.lineJoin = strokeStyle.join;
            context.lineCap = strokeStyle.cap;
        }
        context.font = font;
        let linePositionX;
        let linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        const alignWidth = style.wordWrap ? style.wordWrapWidth : maxLineWidth;
        const strokeWidth = style._stroke?.width ?? 0;
        const halfStroke = strokeWidth / 2;
        let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
        if (lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (isShadowPass) this._setupDropShadow(context, style, resolution, dsOffsetShadow);
            else {
                const gradientBounds = style._gradientBounds;
                const gradientOffset = style._gradientOffset;
                if (gradientBounds) {
                    const gradientMetrics = {
                        width: gradientBounds.width,
                        height: gradientBounds.height,
                        lineHeight: gradientBounds.height,
                        lines: measured.lines
                    };
                    this._setFillAndStrokeStyles(context, style, gradientMetrics, padding, halfStroke, gradientOffset?.x ?? 0, gradientOffset?.y ?? 0);
                } else if (gradientOffset) this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke, gradientOffset.x, gradientOffset.y);
                else this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke);
                context.shadowColor = "black";
            }
            for(let j = 0; j < lines.length; j++){
                linePositionX = halfStroke;
                linePositionY = halfStroke + j * lineHeight + fontProperties.ascent + linePositionYShift;
                linePositionX += this._getAlignmentOffset(lineWidths[j], alignWidth, style.align);
                if (style._stroke?.width) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, true);
                if (style._fill !== void 0) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText);
            }
        }
    }
    /**
   * Renders tagged text (with per-run styles) to canvas.
   * @param measured - The measured text metrics containing runsByLine
   * @param style - The base text style
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render to
   */ _renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext) {
        const { canvas: canvas, context: context } = canvasAndContext;
        const { runsByLine: runsByLine, lineWidths: lineWidths, maxLineWidth: maxLineWidth, lineAscents: lineAscents, lineHeights: lineHeights, hasDropShadow: hasDropShadow } = measured;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        const passesCount = hasDropShadow ? 2 : 1;
        const alignWidth = style.wordWrap ? style.wordWrapWidth : maxLineWidth;
        const strokeWidth = style._stroke?.width ?? 0;
        const halfStroke = strokeWidth / 2;
        const runDataByLine = [];
        for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
            const lineRuns = runsByLine[lineIndex];
            const runData = [];
            for (const run of lineRuns){
                const font = (0, $3FldU.fontStringFromTextStyle)(run.style);
                context.font = font;
                runData.push({
                    width: (0, $1i9ku.CanvasTextMetrics)._measureText(run.text, run.style.letterSpacing, context),
                    font: font
                });
            }
            runDataByLine.push(runData);
        }
        for(let pass = 0; pass < passesCount; ++pass){
            const isShadowPass = hasDropShadow && pass === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (!isShadowPass) context.shadowColor = "black";
            let currentY = halfStroke;
            for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
                const lineRuns = runsByLine[lineIndex];
                const lineWidth = lineWidths[lineIndex];
                const lineAscent = lineAscents[lineIndex];
                const currentLineHeight = lineHeights[lineIndex];
                const lineRunData = runDataByLine[lineIndex];
                let linePositionX = halfStroke;
                linePositionX += this._getAlignmentOffset(lineWidth, alignWidth, style.align);
                const linePositionY = currentY + lineAscent;
                let runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._stroke?.width) {
                        const runStroke = run.style._stroke;
                        context.lineWidth = runStroke.width;
                        context.miterLimit = runStroke.miterLimit;
                        context.lineJoin = runStroke.join;
                        context.lineCap = runStroke.cap;
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                runX += runWidth;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $1i9ku.CanvasTextMetrics).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.strokeStyle = (0, $hFmvn.getCanvasFillStyle)(runStroke, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, true);
                    }
                    runX += runWidth;
                }
                runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._fill !== void 0) {
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                runX += runWidth;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $1i9ku.CanvasTextMetrics).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.fillStyle = (0, $hFmvn.getCanvasFillStyle)(run.style._fill, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, false);
                    }
                    runX += runWidth;
                }
                currentY += currentLineHeight;
            }
        }
    }
    /**
   * Sets fill and stroke styles on the canvas context for text rendering.
   * @param context - The canvas context
   * @param style - The text style
   * @param metrics - The text metrics for gradient calculation
   * @param padding - The padding value
   * @param halfStroke - Half the stroke width
   * @param offsetX - X offset for gradient positioning
   * @param offsetY - Y offset for gradient positioning
   */ _setFillAndStrokeStyles(context, style, metrics, padding, halfStroke, offsetX = 0, offsetY = 0) {
        context.fillStyle = style._fill ? (0, $hFmvn.getCanvasFillStyle)(style._fill, context, metrics, padding * 2, offsetX, offsetY) : null;
        if (style._stroke?.width) {
            const strokePadding = halfStroke + padding * 2;
            context.strokeStyle = (0, $hFmvn.getCanvasFillStyle)(style._stroke, context, metrics, strokePadding, offsetX, offsetY);
        }
    }
    /**
   * Sets up the canvas context for drop shadow rendering.
   * @param context - The canvas context
   * @param style - The text style containing drop shadow options
   * @param resolution - The resolution multiplier
   * @param dsOffsetShadow - The shadow Y offset
   */ _setupDropShadow(context, style, resolution, dsOffsetShadow) {
        context.fillStyle = "black";
        context.strokeStyle = "black";
        const shadowOptions = style.dropShadow;
        const dropShadowColor = shadowOptions.color;
        const dropShadowAlpha = shadowOptions.alpha;
        context.shadowColor = (0, $dKHyW.Color).shared.setValue(dropShadowColor).setAlpha(dropShadowAlpha).toRgbaString();
        const dropShadowBlur = shadowOptions.blur * resolution;
        const dropShadowDistance = shadowOptions.distance * resolution;
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance + dsOffsetShadow;
    }
    /**
   * Calculates the X offset for text alignment.
   * @param lineWidth - The width of the current line
   * @param alignWidth - The width to align against (maxLineWidth or wordWrapWidth)
   * @param align - The text alignment
   * @returns The X offset for this line
   */ _getAlignmentOffset(lineWidth, alignWidth, align) {
        if (align === "right") return alignWidth - lineWidth;
        else if (align === "center") return (alignWidth - lineWidth) / 2;
        return 0;
    }
    /**
   * Render the text with letter-spacing.
   *
   * This method handles rendering text with the correct letter spacing, using either:
   * 1. Native letter spacing if supported by the browser
   * 2. Manual letter spacing calculation if not natively supported
   *
   * For manual letter spacing, it calculates the position of each character
   * based on its width and the desired spacing.
   * @param text - The text to draw
   * @param style - The text style to apply
   * @param canvasAndContext - The canvas and context to draw to
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Whether to render the stroke (true) or fill (false)
   * @private
   */ _drawLetterSpacing(text, style, canvasAndContext, x, y, isStroke = false) {
        const { context: context } = canvasAndContext;
        const letterSpacing = style.letterSpacing;
        let useExperimentalLetterSpacing = false;
        if ((0, $1i9ku.CanvasTextMetrics).experimentalLetterSpacingSupported) {
            if ((0, $1i9ku.CanvasTextMetrics).experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        if (letterSpacing === 0 || useExperimentalLetterSpacing) {
            if (isStroke) context.strokeText(text, x, y);
            else context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(text);
        let previousWidth = context.measureText(text).width;
        let currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            if (isStroke) context.strokeText(currentChar, currentPosition, y);
            else context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    }
}
const $7a49002c4353b76b$export$bb54b62b519176d5 = new $7a49002c4353b76b$var$CanvasTextGeneratorClass();



var $1i9ku = parcelRequire("1i9ku");

var $bFX43 = parcelRequire("bFX43");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");

var $4ZJmt = parcelRequire("4ZJmt");
"use strict";
function $7df15e8bdde60348$export$cd6ce24a38c376aa(batchableSprite, text) {
    const { texture: texture, bounds: bounds } = batchableSprite;
    const padding = text._style._getFinalPadding();
    (0, $4ZJmt.updateQuadBounds)(bounds, text._anchor, texture);
    const paddingOffset = text._anchor._x * padding * 2;
    const paddingOffsetY = text._anchor._y * padding * 2;
    bounds.minX -= padding - paddingOffset;
    bounds.minY -= padding - paddingOffsetY;
    bounds.maxX -= padding - paddingOffset;
    bounds.maxY -= padding - paddingOffsetY;
}



var $hAzG5 = parcelRequire("hAzG5");
"use strict";
class $b54349231d10c4ee$export$f986f9176e9ba9b4 extends (0, $hAzG5.BatchableSprite) {
}


"use strict";
class $1f4c37bef686d7d6$export$ed0d779e44b53050 {
    constructor(renderer){
        this._renderer = renderer;
        renderer.runners.resolutionChange.add(this);
        this._managedTexts = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            onUnload: this.onTextUnload.bind(this),
            name: "canvasText"
        });
    }
    resolutionChange() {
        for(const key in this._managedTexts.items){
            const text = this._managedTexts.items[key];
            if (text?._autoResolution) text.onViewUpdate();
        }
    }
    validateRenderable(text) {
        const gpuText = this._getGpuText(text);
        const newKey = text.styleKey;
        if (gpuText.currentKey !== newKey) return true;
        return text._didTextUpdate;
    }
    addRenderable(text, instructionSet) {
        const batchableText = this._getGpuText(text);
        if (text._didTextUpdate) {
            const resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
            if (batchableText.currentKey !== text.styleKey || text._resolution !== resolution) this._updateGpuText(text);
            text._didTextUpdate = false;
            (0, $7df15e8bdde60348$export$cd6ce24a38c376aa)(batchableText, text);
        }
        this._renderer.renderPipes.batch.addToBatch(batchableText, instructionSet);
    }
    updateRenderable(text) {
        const batchableText = this._getGpuText(text);
        batchableText._batcher.updateElement(batchableText);
    }
    _updateGpuText(text) {
        const batchableText = this._getGpuText(text);
        if (batchableText.texture) this._renderer.canvasText.decreaseReferenceCount(batchableText.currentKey);
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        batchableText.texture = this._renderer.canvasText.getManagedTexture(text);
        batchableText.currentKey = text.styleKey;
    }
    _getGpuText(text) {
        return text._gpuData[this._renderer.uid] || this.initGpuText(text);
    }
    initGpuText(text) {
        const batchableText = new (0, $b54349231d10c4ee$export$f986f9176e9ba9b4)();
        batchableText.currentKey = "--";
        batchableText.renderable = text;
        batchableText.transform = text.groupTransform;
        batchableText.bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        batchableText.roundPixels = this._renderer._roundPixels | text._roundPixels;
        text._gpuData[this._renderer.uid] = batchableText;
        this._managedTexts.add(text);
        return batchableText;
    }
    onTextUnload(text) {
        const gpuData = text._gpuData[this._renderer.uid];
        if (!gpuData) return;
        const { canvasText: canvasText } = this._renderer;
        const refCount = canvasText.getReferenceCount(gpuData.currentKey);
        if (refCount > 0) canvasText.decreaseReferenceCount(gpuData.currentKey);
        else if (gpuData.texture) canvasText.returnTexture(gpuData.texture);
    }
    destroy() {
        this._managedTexts.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $1f4c37bef686d7d6$export$ed0d779e44b53050.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "text"
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $5NyEC = parcelRequire("5NyEC");

var $c8piJ = parcelRequire("c8piJ");

var $6LhOA = parcelRequire("6LhOA");


var $bFX43 = parcelRequire("bFX43");

var $5NyEC = parcelRequire("5NyEC");

var $esrbs = parcelRequire("esrbs");
"use strict";
const $fb2e0fd15e1bae74$var$tempBounds = new (0, $esrbs.Bounds)();
function $fb2e0fd15e1bae74$export$80c61c6b7fb407a3(image, width, height, resolution) {
    const bounds = $fb2e0fd15e1bae74$var$tempBounds;
    bounds.minX = 0;
    bounds.minY = 0;
    bounds.maxX = image.width / resolution | 0;
    bounds.maxY = image.height / resolution | 0;
    const texture = (0, $5NyEC.TexturePool).getOptimalTexture(bounds.width, bounds.height, resolution, false);
    texture.source.uploadMethodId = "image";
    texture.source.resource = image;
    texture.source.alphaMode = "premultiply-alpha-on-upload";
    texture.frame.width = width / resolution;
    texture.frame.height = height / resolution;
    texture.source.emit("update", texture.source);
    texture.updateUvs();
    return texture;
}


"use strict";
class $e75bb7ab0a8a8ef1$export$1f58c6bd1c266764 {
    constructor(renderer, retainCanvasContext){
        this._activeTextures = {};
        this._renderer = renderer;
        this._retainCanvasContext = retainCanvasContext;
    }
    getTexture(options, _resolution, _style, _textKey) {
        if (typeof options === "string") {
            (0, $6LhOA.deprecation)("8.0.0", "CanvasTextSystem.getTexture: Use object TextOptions instead of separate arguments");
            options = {
                text: options,
                style: _style,
                resolution: _resolution
            };
        }
        if (!(options.style instanceof (0, $bFX43.TextStyle))) options.style = new (0, $bFX43.TextStyle)(options.style);
        if (!(options.textureStyle instanceof (0, $c8piJ.TextureStyle))) options.textureStyle = new (0, $c8piJ.TextureStyle)(options.textureStyle);
        if (typeof options.text !== "string") options.text = options.text.toString();
        const { text: text, style: style, textureStyle: textureStyle } = options;
        const resolution = options.resolution ?? this._renderer.resolution;
        const { frame: frame, canvasAndContext: canvasAndContext } = (0, $7a49002c4353b76b$export$bb54b62b519176d5).getCanvasAndContext({
            text: text,
            style: style,
            resolution: resolution
        });
        const texture = (0, $fb2e0fd15e1bae74$export$80c61c6b7fb407a3)(canvasAndContext.canvas, frame.width, frame.height, resolution);
        if (textureStyle) texture.source.style = textureStyle;
        if (style.trim) {
            frame.pad(style.padding);
            texture.frame.copyFrom(frame);
            texture.frame.scale(1 / resolution);
            texture.updateUvs();
        }
        if (style.filters) {
            const filteredTexture = this._applyFilters(texture, style.filters);
            this.returnTexture(texture);
            (0, $7a49002c4353b76b$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            return filteredTexture;
        }
        this._renderer.texture.initSource(texture._source);
        if (!this._retainCanvasContext) (0, $7a49002c4353b76b$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
        return texture;
    }
    /**
   * Returns a texture that was created wit the above `getTexture` function.
   * Handy if you are done with a texture and want to return it to the pool.
   * @param texture - The texture to be returned.
   */ returnTexture(texture) {
        const source = texture.source;
        const resource = source.resource;
        if (this._retainCanvasContext && resource?.getContext) {
            const context = resource.getContext("2d");
            if (context) (0, $7a49002c4353b76b$export$bb54b62b519176d5).returnCanvasAndContext({
                canvas: resource,
                context: context
            });
        }
        source.resource = null;
        source.uploadMethodId = "unknown";
        source.alphaMode = "no-premultiply-alpha";
        (0, $5NyEC.TexturePool).returnTexture(texture, true);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @deprecated since 8.10.0
   */ renderTextToCanvas() {
        (0, $6LhOA.deprecation)("8.10.0", "CanvasTextSystem.renderTextToCanvas: no longer supported, use CanvasTextSystem.getTexture instead");
    }
    /**
   * Gets or creates a managed texture for a Text object. This method handles texture reuse and reference counting.
   * @param text - The Text object that needs a texture
   * @returns A Texture instance that represents the rendered text
   * @remarks
   * This method performs the following:
   * 1. Sets the appropriate resolution based on auto-resolution settings
   * 2. Checks if a texture already exists for the text's style
   * 3. Creates a new texture if needed or returns an existing one
   * 4. Manages reference counting for texture reuse
   */ getManagedTexture(text) {
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        const textKey = text.styleKey;
        if (this._activeTextures[textKey]) {
            this._increaseReferenceCount(textKey);
            return this._activeTextures[textKey].texture;
        }
        const texture = this.getTexture({
            text: text.text,
            style: text.style,
            resolution: text._resolution,
            textureStyle: text.textureStyle
        });
        this._activeTextures[textKey] = {
            texture: texture,
            usageCount: 1
        };
        return texture;
    }
    /**
   * Decreases the reference count for a texture associated with a text key.
   * When the reference count reaches zero, the texture is returned to the pool.
   * @param textKey - The unique key identifying the text style configuration
   * @remarks
   * This method is crucial for memory management, ensuring textures are properly
   * cleaned up when they are no longer needed by any Text instances.
   */ decreaseReferenceCount(textKey) {
        const activeTexture = this._activeTextures[textKey];
        if (!activeTexture) return;
        activeTexture.usageCount--;
        if (activeTexture.usageCount === 0) {
            this.returnTexture(activeTexture.texture);
            this._activeTextures[textKey] = null;
        }
    }
    /**
   * Gets the current reference count for a texture associated with a text key.
   * @param textKey - The unique key identifying the text style configuration
   * @returns The number of Text instances currently using this texture
   */ getReferenceCount(textKey) {
        return this._activeTextures[textKey]?.usageCount ?? 0;
    }
    _increaseReferenceCount(textKey) {
        this._activeTextures[textKey].usageCount++;
    }
    /**
   * Applies the specified filters to the given texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture. It also ensures that the alpha mode of the resulting
   * texture is set to 'premultiplied-alpha'.
   * @param {Texture} texture - The texture to which the filters will be applied.
   * @param {Filter[]} filters - The filters to apply to the texture.
   * @returns {Texture} The resulting texture after all filters have been applied.
   */ _applyFilters(texture, filters) {
        const currentRenderTarget = this._renderer.renderTarget.renderTarget;
        const resultTexture = this._renderer.filter.generateFilteredTexture({
            texture: texture,
            filters: filters
        });
        this._renderer.renderTarget.bind(currentRenderTarget, false);
        return resultTexture;
    }
    destroy() {
        this._renderer = null;
        for(const key in this._activeTextures)if (this._activeTextures[key]) this.returnTexture(this._activeTextures[key].texture);
        this._activeTextures = null;
    }
}


"use strict";
class $20ef9ba315f69cd0$export$b13c6e11d8ae9690 extends (0, $e75bb7ab0a8a8ef1$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, true);
    }
}
/** @ignore */ $20ef9ba315f69cd0$export$b13c6e11d8ae9690.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "canvasText"
};



var $aZ9ZN = parcelRequire("aZ9ZN");

"use strict";
class $da83de7193beb062$export$56e4907c2e518abc extends (0, $e75bb7ab0a8a8ef1$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, false);
    }
}
/** @ignore */ $da83de7193beb062$export$56e4907c2e518abc.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "canvasText"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $20ef9ba315f69cd0$export$b13c6e11d8ae9690));
(0, $aZ9ZN.extensions).add((0, $da83de7193beb062$export$56e4907c2e518abc));
(0, $aZ9ZN.extensions).add((0, $1f4c37bef686d7d6$export$ed0d779e44b53050));


"use strict";
class $f3e48f5b83971e92$export$5f1af8db9871e1d6 extends (0, $19c3827930a6b92b$export$daf74670712de91) {
    constructor(...args){
        const options = (0, $19c3827930a6b92b$export$8ddfb4f614f8ed86)(args, "Text");
        super(options, (0, $bFX43.TextStyle));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $c8piJ.TextureStyle) ? options.textureStyle : new (0, $c8piJ.TextureStyle)(options.textureStyle);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $7a49002c4353b76b$export$bb54b62b519176d5).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $7a49002c4353b76b$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $1i9ku.CanvasTextMetrics).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}



"use strict";
class $0d30f8725cec24cc$export$c4920d5f3c7b8959 extends (0, $174d20ff26f1de6e$export$5f24f1af732279b7) {
    /**
   * Resolve the given resource type and return an item for the queue
   * @param source
   * @param queue
   */ resolveQueueItem(source, queue) {
        if (source instanceof (0, $2vcTO.Container)) this.resolveContainerQueueItem(source, queue);
        else if (source instanceof (0, $gmQ4R.TextureSource) || source instanceof (0, $4iNSL.Texture)) queue.push(source.source);
        else if (source instanceof (0, $7kRkZ.GraphicsContext)) queue.push(source);
        return null;
    }
    /**
   * Resolve the given container and return an item for the queue
   * @param container
   * @param queue
   */ resolveContainerQueueItem(container, queue) {
        if (container instanceof (0, $7ScuH.Sprite) || container instanceof (0, $35a7b8f9b04fc055$export$db8370cd1ebcc819) || container instanceof (0, $0ac2d29ab0a78f0e$export$e176487c05830cc5)) queue.push(container.texture.source);
        else if (container instanceof (0, $f3e48f5b83971e92$export$5f1af8db9871e1d6)) queue.push(container);
        else if (container instanceof (0, $iNnKd.Graphics)) queue.push(container.context);
        else if (container instanceof (0, $10731efba8cacc0d$export$dae599798687ad3c)) container.textures.forEach((textureOrFrame)=>{
            if (textureOrFrame.source) queue.push(textureOrFrame.source);
            else queue.push(textureOrFrame.texture.source);
        });
    }
    /**
   * Resolve the given graphics context and return an item for the queue
   * @param graphicsContext
   */ resolveGraphicsContextQueueItem(graphicsContext) {
        this.renderer.graphicsContext.getGpuContext(graphicsContext);
        const { instructions: instructions } = graphicsContext;
        for (const instruction of instructions){
            if (instruction.action === "texture") {
                const { image: image } = instruction.data;
                return image.source;
            } else if (instruction.action === "fill") {
                const { texture: texture } = instruction.data.style;
                return texture.source;
            }
        }
        return null;
    }
}



var $aZ9ZN = parcelRequire("aZ9ZN");

var $gmQ4R = parcelRequire("gmQ4R");

var $7kRkZ = parcelRequire("7kRkZ");


var $1RpxL = parcelRequire("1RpxL");


var $bFX43 = parcelRequire("bFX43");

var $bJb7n = parcelRequire("bJb7n");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $h3cT0 = parcelRequire("h3cT0");

var $6tS7R = parcelRequire("6tS7R");

var $iNnKd = parcelRequire("iNnKd");

var $1i9ku = parcelRequire("1i9ku");

var $bJb7n = parcelRequire("bJb7n");

var $dhjTN = parcelRequire("dhjTN");
"use strict";
class $89d14507916ac1b3$export$b542b9239140e808 extends (0, $iNnKd.Graphics) {
    destroy() {
        if (this.context.customShader) this.context.customShader.destroy();
        super.destroy();
    }
}
class $89d14507916ac1b3$export$118d8a6c6e22af34 {
    constructor(renderer){
        this._renderer = renderer;
        this._managedBitmapTexts = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -2,
            name: "bitmapText"
        });
    }
    validateRenderable(bitmapText) {
        const graphicsRenderable = this._getGpuBitmapText(bitmapText);
        return this._renderer.renderPipes.graphics.validateRenderable(graphicsRenderable);
    }
    addRenderable(bitmapText, instructionSet) {
        const graphicsRenderable = this._getGpuBitmapText(bitmapText);
        $89d14507916ac1b3$var$syncWithProxy(bitmapText, graphicsRenderable);
        if (bitmapText._didTextUpdate) {
            bitmapText._didTextUpdate = false;
            this._updateContext(bitmapText, graphicsRenderable);
        }
        this._renderer.renderPipes.graphics.addRenderable(graphicsRenderable, instructionSet);
        if (graphicsRenderable.context.customShader) this._updateDistanceField(bitmapText);
    }
    updateRenderable(bitmapText) {
        const graphicsRenderable = this._getGpuBitmapText(bitmapText);
        $89d14507916ac1b3$var$syncWithProxy(bitmapText, graphicsRenderable);
        this._renderer.renderPipes.graphics.updateRenderable(graphicsRenderable);
        if (graphicsRenderable.context.customShader) this._updateDistanceField(bitmapText);
    }
    _updateContext(bitmapText, proxyGraphics) {
        const { context: context } = proxyGraphics;
        const bitmapFont = (0, $bJb7n.BitmapFontManager).getFont(bitmapText.text, bitmapText._style);
        context.clear();
        if (bitmapFont.distanceField.type !== "none") {
            const sdfShader = this.getSdfShader();
            if (sdfShader) {
                if (!context.customShader) context.customShader = sdfShader;
            }
        }
        const chars = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(bitmapText.text);
        const style = bitmapText._style;
        let currentY = bitmapFont.baseLineOffset;
        const bitmapTextLayout = (0, $dhjTN.getBitmapTextLayout)(chars, style, bitmapFont, true);
        const padding = style.padding;
        const scale = bitmapTextLayout.scale;
        let tx = bitmapTextLayout.width;
        let ty = bitmapTextLayout.height + bitmapTextLayout.offsetY;
        if (style._stroke) {
            tx += style._stroke.width / scale;
            ty += style._stroke.width / scale;
        }
        context.translate(-bitmapText._anchor._x * tx - padding, -bitmapText._anchor._y * ty - padding).scale(scale, scale);
        const tint = bitmapFont.applyFillAsTint ? style._fill.color : 16777215;
        let fontSize = bitmapFont.fontMetrics.fontSize;
        let lineHeight = bitmapFont.lineHeight;
        if (style.lineHeight) {
            fontSize = style.fontSize / scale;
            lineHeight = style.lineHeight / scale;
        }
        let linePositionYShift = (lineHeight - fontSize) / 2;
        if (linePositionYShift - bitmapFont.baseLineOffset < 0) linePositionYShift = 0;
        for(let i = 0; i < bitmapTextLayout.lines.length; i++){
            const line = bitmapTextLayout.lines[i];
            for(let j = 0; j < line.charPositions.length; j++){
                const char = line.chars[j];
                const charData = bitmapFont.chars[char];
                if (charData?.texture) {
                    const texture = charData.texture;
                    context.texture(texture, tint, Math.round(line.charPositions[j] + charData.xOffset), Math.round(currentY + charData.yOffset + linePositionYShift), texture.orig.width, texture.orig.height);
                }
            }
            currentY += lineHeight;
        }
    }
    _getGpuBitmapText(bitmapText) {
        return bitmapText._gpuData[this._renderer.uid] || this.initGpuText(bitmapText);
    }
    initGpuText(bitmapText) {
        const proxyRenderable = new $89d14507916ac1b3$export$b542b9239140e808();
        bitmapText._gpuData[this._renderer.uid] = proxyRenderable;
        this._updateContext(bitmapText, proxyRenderable);
        this._managedBitmapTexts.add(bitmapText);
        return proxyRenderable;
    }
    _updateDistanceField(bitmapText) {
        const context = this._getGpuBitmapText(bitmapText).context;
        const fontFamily = bitmapText._style.fontFamily;
        const dynamicFont = (0, $h3cT0.Cache).get(`${fontFamily}-bitmap`);
        const { a: a, b: b, c: c, d: d } = bitmapText.groupTransform;
        const dx = Math.sqrt(a * a + b * b);
        const dy = Math.sqrt(c * c + d * d);
        const worldScale = (Math.abs(dx) + Math.abs(dy)) / 2;
        const fontScale = dynamicFont.baseRenderedFontSize / bitmapText._style.fontSize;
        const distance = worldScale * dynamicFont.distanceField.range * (1 / fontScale);
        context.customShader.resources.localUniforms.uniforms.uDistance = distance;
    }
    destroy() {
        this._managedBitmapTexts.destroy();
        this._renderer = null;
        this._managedBitmapTexts = null;
    }
}
function $89d14507916ac1b3$var$syncWithProxy(container, proxy) {
    proxy.groupTransform = container.groupTransform;
    proxy.groupColorAlpha = container.groupColorAlpha;
    proxy.groupColor = container.groupColor;
    proxy.groupBlendMode = container.groupBlendMode;
    proxy.globalDisplayStatus = container.globalDisplayStatus;
    proxy.groupTransform = container.groupTransform;
    proxy.localDisplayStatus = container.localDisplayStatus;
    proxy.groupAlpha = container.groupAlpha;
    proxy._roundPixels = container._roundPixels;
}


"use strict";
class $694fa538d077b9a9$export$b4c52e42ab5b7d0c extends (0, $89d14507916ac1b3$export$118d8a6c6e22af34) {
    getSdfShader() {
        return null;
    }
}
/** @ignore */ $694fa538d077b9a9$export$b4c52e42ab5b7d0c.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "bitmapText"
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $aYOxl = parcelRequire("aYOxl");

var $eGbby = parcelRequire("eGbby");

var $1I0Ex = parcelRequire("1I0Ex");

var $gnlmr = parcelRequire("gnlmr");

var $foUHO = parcelRequire("foUHO");

var $7LCXQ = parcelRequire("7LCXQ");

var $aUxJK = parcelRequire("aUxJK");
"use strict";
const $8e85dd50ed90c849$export$95191d1d81ffe694 = {
    name: "local-uniform-msdf-bit",
    vertex: {
        header: /* wgsl */ `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32,
                uRound:f32,
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `,
        main: /* wgsl */ `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `,
        end: /* wgsl */ `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    },
    fragment: {
        header: /* wgsl */ `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
         `,
        main: /* wgsl */ `
            outColor = vec4<f32>(calculateMSDFAlpha(outColor, vColor, localUniforms.uDistance));
        `
    }
};
const $8e85dd50ed90c849$export$7542046ad25e8068 = {
    name: "local-uniform-msdf-bit",
    vertex: {
        header: /* glsl */ `
            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `,
        main: /* glsl */ `
            vColor *= uColor;
            modelMatrix *= uTransformMatrix;
        `,
        end: /* glsl */ `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    },
    fragment: {
        header: /* glsl */ `
            uniform float uDistance;
         `,
        main: /* glsl */ `
            outColor = vec4(calculateMSDFAlpha(outColor, vColor, uDistance));
        `
    }
};


"use strict";
const $1a81017f17414849$export$382a0eb192cd0a47 = {
    name: "msdf-bit",
    fragment: {
        header: /* wgsl */ `
            fn calculateMSDFAlpha(msdfColor:vec4<f32>, shapeColor:vec4<f32>, distance:f32) -> f32 {

                // MSDF
                var median = msdfColor.r + msdfColor.g + msdfColor.b -
                    min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                    max(msdfColor.r, max(msdfColor.g, msdfColor.b));

                // SDF
                median = min(median, msdfColor.a);

                var screenPxDistance = distance * (median - 0.5);
                var alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);
                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                var luma: f32 = dot(shapeColor.rgb, vec3<f32>(0.299, 0.587, 0.114));
                var gamma: f32 = mix(1.0, 1.0 / 2.2, luma);
                var coverage: f32 = pow(shapeColor.a * alpha, gamma);

                return coverage;

            }
        `
    }
};
const $1a81017f17414849$export$52c5bf2a8ebe1f2a = {
    name: "msdf-bit",
    fragment: {
        header: /* glsl */ `
            float calculateMSDFAlpha(vec4 msdfColor, vec4 shapeColor, float distance) {

                // MSDF
                float median = msdfColor.r + msdfColor.g + msdfColor.b -
                                min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                                max(msdfColor.r, max(msdfColor.g, msdfColor.b));

                // SDF
                median = min(median, msdfColor.a);

                float screenPxDistance = distance * (median - 0.5);
                float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);

                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                float luma = dot(shapeColor.rgb, vec3(0.299, 0.587, 0.114));
                float gamma = mix(1.0, 1.0 / 2.2, luma);
                float coverage = pow(shapeColor.a * alpha, gamma);

                return coverage;
            }
        `
    }
};


"use strict";
let $85ac083d6329aa18$var$gpuProgram;
let $85ac083d6329aa18$var$glProgram;
class $85ac083d6329aa18$export$f19b070f8409d54d extends (0, $7LCXQ.Shader) {
    constructor(maxTextures){
        const uniforms = new (0, $aUxJK.UniformGroup)({
            uColor: {
                value: new Float32Array([
                    1,
                    1,
                    1,
                    1
                ]),
                type: "vec4<f32>"
            },
            uTransformMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uDistance: {
                value: 4,
                type: "f32"
            },
            uRound: {
                value: 0,
                type: "f32"
            }
        });
        $85ac083d6329aa18$var$gpuProgram ?? ($85ac083d6329aa18$var$gpuProgram = (0, $aYOxl.compileHighShaderGpuProgram)({
            name: "sdf-shader",
            bits: [
                (0, $eGbby.colorBit),
                (0, $1I0Ex.generateTextureBatchBit)(maxTextures),
                (0, $8e85dd50ed90c849$export$95191d1d81ffe694),
                (0, $1a81017f17414849$export$382a0eb192cd0a47),
                (0, $gnlmr.roundPixelsBit)
            ]
        }));
        $85ac083d6329aa18$var$glProgram ?? ($85ac083d6329aa18$var$glProgram = (0, $aYOxl.compileHighShaderGlProgram)({
            name: "sdf-shader",
            bits: [
                (0, $eGbby.colorBitGl),
                (0, $1I0Ex.generateTextureBatchBitGl)(maxTextures),
                (0, $8e85dd50ed90c849$export$7542046ad25e8068),
                (0, $1a81017f17414849$export$52c5bf2a8ebe1f2a),
                (0, $gnlmr.roundPixelsBitGl)
            ]
        }));
        super({
            glProgram: $85ac083d6329aa18$var$glProgram,
            gpuProgram: $85ac083d6329aa18$var$gpuProgram,
            resources: {
                localUniforms: uniforms,
                batchSamplers: (0, $foUHO.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
}



"use strict";
class $bb6ebcf248784864$export$83d8b05a29a5f8ed extends (0, $89d14507916ac1b3$export$118d8a6c6e22af34) {
    getSdfShader() {
        return new (0, $85ac083d6329aa18$export$f19b070f8409d54d)(this._renderer.limits.maxBatchableTextures);
    }
}
/** @ignore */ $bb6ebcf248784864$export$83d8b05a29a5f8ed.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "bitmapText"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $694fa538d077b9a9$export$b4c52e42ab5b7d0c));
(0, $aZ9ZN.extensions).add((0, $bb6ebcf248784864$export$83d8b05a29a5f8ed));


"use strict";
class $8095d93ccaec0291$export$ae0da96467efdba0 extends (0, $19c3827930a6b92b$export$daf74670712de91) {
    constructor(...args){
        var _a;
        const options = (0, $19c3827930a6b92b$export$8ddfb4f614f8ed86)(args, "BitmapText");
        options.style ?? (options.style = options.style || {});
        (_a = options.style).fill ?? (_a.fill = 16777215);
        super(options, (0, $bFX43.TextStyle));
        /** @internal */ this.renderPipeId = "bitmapText";
    }
    /**
   * @param now - The current time in milliseconds.
   * @internal
   */ _onTouch(now) {
        this._gcLastUsed = now;
        for(const key in this._gpuData)this._gpuData[key]?._onTouch(now);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const bitmapMeasurement = (0, $bJb7n.BitmapFontManager).measureText(this.text, this._style);
        const scale = bitmapMeasurement.scale;
        const offset = bitmapMeasurement.offsetY * scale;
        let width = bitmapMeasurement.width * scale;
        let height = bitmapMeasurement.height * scale;
        const stroke = this._style._stroke;
        if (stroke) {
            width += stroke.width;
            height += stroke.width;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * (height + offset);
        bounds.maxY = bounds.minY + height;
    }
    /**
   * The resolution / device pixel ratio for text rendering.
   * Unlike other text types, BitmapText resolution is managed by the BitmapFont.
   * Individual resolution changes are not supported.
   * @example
   * ```ts
   * // ❌ Incorrect: Setting resolution directly (will trigger warning)
   * const text = new BitmapText({
   *     text: 'Hello',
   *     resolution: 2 // This will be ignored
   * });
   *
   * // ✅ Correct: Set resolution when installing the font
   * BitmapFont.install({
   *     name: 'MyFont',
   *     style: {
   *         fontFamily: 'Arial',
   *     },
   *     resolution: 2 // Resolution is set here
   * });
   *
   * const text = new BitmapText({
   *     text: 'Hello',
   *     style: {
   *         fontFamily: 'MyFont' // Uses font's resolution
   *     }
   * });
   * ```
   * @default 1
   * @see {@link BitmapFont.install} For setting font resolution
   * @throws {Warning} When attempting to change resolution directly
   * @readonly
   */ set resolution(value) {
        if (value !== null) (0, $1RpxL.warn)(// eslint-disable-next-line max-len
        "[BitmapText] dynamically updating the resolution is not supported. Resolution should be managed by the BitmapFont.");
    }
    get resolution() {
        return this._resolution;
    }
}



var $c8piJ = parcelRequire("c8piJ");


var $1RpxL = parcelRequire("1RpxL");

var $bFX43 = parcelRequire("bFX43");

var $dKHyW = parcelRequire("dKHyW");

var $bFX43 = parcelRequire("bFX43");
"use strict";
function $4c5ff8dee5feaab1$export$8daecfbc002513c1(style) {
    const stroke = style._stroke;
    const fill = style._fill;
    const color = (0, $dKHyW.Color).shared.setValue(fill.color).setAlpha(fill.alpha ?? 1).toHexa();
    const cssStyleString = [
        `color: ${color}`,
        `font-size: ${style.fontSize}px`,
        `font-family: ${style.fontFamily}`,
        `font-weight: ${style.fontWeight}`,
        `font-style: ${style.fontStyle}`,
        `font-variant: ${style.fontVariant}`,
        `letter-spacing: ${style.letterSpacing}px`,
        `text-align: ${style.align}`,
        `padding: ${style.padding}px`,
        `white-space: ${style.whiteSpace === "pre" && style.wordWrap ? "pre-wrap" : style.whiteSpace}`,
        ...style.lineHeight ? [
            `line-height: ${style.lineHeight}px`
        ] : [],
        ...style.wordWrap ? [
            `word-break: ${style.breakWords ? "break-all" : "normal"}`,
            `max-width: ${style.wordWrapWidth}px`
        ] : [],
        ...stroke ? [
            $4c5ff8dee5feaab1$var$strokeToCSS(stroke)
        ] : [],
        ...style.dropShadow ? [
            $4c5ff8dee5feaab1$var$dropShadowToCSS(style.dropShadow)
        ] : [],
        ...style.cssOverrides
    ].join(";");
    const cssStyles = [
        `div { ${cssStyleString} }`
    ];
    $4c5ff8dee5feaab1$var$tagStyleToCSS(style.tagStyles, cssStyles);
    return cssStyles.join(" ");
}
function $4c5ff8dee5feaab1$var$dropShadowToCSS(dropShadowStyle) {
    const dropshadowStyle = {
        ...dropShadowStyle
    };
    const color = (0, $dKHyW.Color).shared.setValue(dropshadowStyle.color).setAlpha(dropshadowStyle.alpha ?? 1).toHexa();
    const x = Math.round(Math.cos(dropshadowStyle.angle) * dropshadowStyle.distance);
    const y = Math.round(Math.sin(dropshadowStyle.angle) * dropshadowStyle.distance);
    const position = `${x}px ${y}px`;
    if (dropshadowStyle.blur > 0) return `text-shadow: ${position} ${dropshadowStyle.blur}px ${color}`;
    return `text-shadow: ${position} ${color}`;
}
function $4c5ff8dee5feaab1$var$strokeToCSS(stroke) {
    const color = (0, $dKHyW.Color).shared.setValue(stroke.color).setAlpha(stroke.alpha ?? 1).toHexa();
    return [
        `-webkit-text-stroke-width: ${stroke.width}px`,
        `-webkit-text-stroke-color: ${color}`,
        `text-stroke-width: ${stroke.width}px`,
        `text-stroke-color: ${color}`,
        "paint-order: stroke"
    ].join(";");
}
const $4c5ff8dee5feaab1$var$templates = {
    fontSize: `font-size: {{VALUE}}px`,
    fontFamily: `font-family: {{VALUE}}`,
    fontWeight: `font-weight: {{VALUE}}`,
    fontStyle: `font-style: {{VALUE}}`,
    fontVariant: `font-variant: {{VALUE}}`,
    letterSpacing: `letter-spacing: {{VALUE}}px`,
    align: `text-align: {{VALUE}}`,
    padding: `padding: {{VALUE}}px`,
    whiteSpace: `white-space: {{VALUE}}`,
    lineHeight: `line-height: {{VALUE}}px`,
    wordWrapWidth: `max-width: {{VALUE}}px`
};
const $4c5ff8dee5feaab1$var$transform = {
    fill: (value)=>`color: ${(0, $dKHyW.Color).shared.setValue(value).toHexa()}`,
    breakWords: (value)=>`word-break: ${value ? "break-all" : "normal"}`,
    stroke: $4c5ff8dee5feaab1$var$strokeToCSS,
    dropShadow: (value)=>{
        if (value === true) return $4c5ff8dee5feaab1$var$dropShadowToCSS((0, $bFX43.TextStyle).defaultDropShadow);
        if (value && typeof value === "object") return $4c5ff8dee5feaab1$var$dropShadowToCSS({
            ...(0, $bFX43.TextStyle).defaultDropShadow,
            ...value
        });
        return "";
    }
};
function $4c5ff8dee5feaab1$var$tagStyleToCSS(tagStyles, out) {
    for(const i in tagStyles){
        const tagStyle = tagStyles[i];
        const cssTagStyle = [];
        for(const j in tagStyle){
            if ($4c5ff8dee5feaab1$var$transform[j]) cssTagStyle.push($4c5ff8dee5feaab1$var$transform[j](tagStyle[j]));
            else if ($4c5ff8dee5feaab1$var$templates[j]) cssTagStyle.push($4c5ff8dee5feaab1$var$templates[j].replace("{{VALUE}}", tagStyle[j]));
        }
        out.push(`${i} { ${cssTagStyle.join(";")} }`);
    }
}


"use strict";
class $8411904bd7736fea$export$a2664b42ece43c6c extends (0, $bFX43.TextStyle) {
    constructor(options = {}){
        super(options);
        this._cssOverrides = [];
        this.cssOverrides = options.cssOverrides ?? [];
        this.tagStyles = options.tagStyles ?? {};
    }
    /**
   * Custom styles to apply to specific HTML tags.
   * Allows for consistent styling of custom elements without CSS overrides.
   * @example
   * ```ts
   * const text = new HTMLText({
   *     text: '<red>Red</red>, <blue>Blue</blue>, <green>Green</green>',
   *     style: {
   *         tagStyles: {
   *             red: { fill: 'red' },
   *             blue: { fill: 'blue' },
   *             green: { fill: 'green' },
   *         }
   *     }
   * });
   * ```
   * @standard
   */ get tagStyles() {
        return this._tagStyles;
    }
    /** @standard */ set tagStyles(value) {
        if (this._tagStyles === value) return;
        this._tagStyles = value ?? {};
        this.update();
    }
    /**
   * List of CSS style overrides to apply to the HTML text.
   * These styles are added after the built-in styles and can override any default styling.
   * @advanced
   */ set cssOverrides(value) {
        this._cssOverrides = value instanceof Array ? value : [
            value
        ];
        this.update();
    }
    /** @advanced */ get cssOverrides() {
        return this._cssOverrides;
    }
    /**
   * Updates the text style and triggers a refresh of the CSS style cache.
   * This method is called automatically when style properties are changed.
   * @example
   * ```ts
   * // Update after multiple changes
   * const text = new HTMLText({
   *     text: 'Hello World',
   *     style
   * });
   *
   * style.fontSize = 32;
   * style.fill = '#00ff00';
   * style.fontFamily = 'Arial';
   * style.update(); // Apply all changes at once
   * ```
   * @advanced
   * @see {@link HTMLTextStyle#cssStyle} For accessing the generated CSS
   * @see {@link HTMLTextStyle#cssOverrides} For managing CSS overrides
   */ update() {
        this._cssStyle = null;
        super.update();
    }
    /**
   * Creates a new HTMLTextStyle object with the same values as this one.
   * This creates a deep copy of all style properties, including dropShadow and tag styles.
   * @example
   * ```ts
   * // Create original style
   * const originalStyle = new HTMLTextStyle({
   *     fontSize: 24,
   *     fill: '#ff0000',
   *     tagStyles: {
   *         header: { fontSize: 32, fill: '#00ff00' }
   *     }
   * });
   *
   * // Clone the style
   * const clonedStyle = originalStyle.clone();
   *
   * // Modify cloned style independently
   * clonedStyle.fontSize = 36;
   * clonedStyle.fill = '#0000ff';
   *
   * // Original style remains unchanged
   * console.log(originalStyle.fontSize); // Still 24
   * console.log(originalStyle.fill); // Still '#ff0000'
   * ```
   *
   * Properties that are cloned:
   * - Basic text properties (fontSize, fontFamily, etc.)
   * - Fill and stroke styles
   * - Drop shadow configuration
   * - CSS overrides
   * - Tag styles (deep copied)
   * - Word wrap settings
   * - Alignment and spacing
   * @returns {HTMLTextStyle} A new HTMLTextStyle instance with the same properties
   * @see {@link HTMLTextStyle} For available style properties
   * @see {@link HTMLTextStyle#cssOverrides} For CSS override handling
   * @see {@link HTMLTextStyle#tagStyles} For tag style configuration
   * @standard
   */ clone() {
        return new $8411904bd7736fea$export$a2664b42ece43c6c({
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this.dropShadow ? {
                ...this.dropShadow
            } : null,
            fill: this._fill,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth,
            cssOverrides: this.cssOverrides,
            tagStyles: {
                ...this.tagStyles
            }
        });
    }
    /**
   * The CSS style string that will be applied to the HTML text.
   * @advanced
   */ get cssStyle() {
        if (!this._cssStyle) this._cssStyle = (0, $4c5ff8dee5feaab1$export$8daecfbc002513c1)(this);
        return this._cssStyle;
    }
    /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   * @advanced
   */ addOverride(...value) {
        const toAdd = value.filter((v)=>!this.cssOverrides.includes(v));
        if (toAdd.length > 0) {
            this.cssOverrides.push(...toAdd);
            this.update();
        }
    }
    /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   * @advanced
   */ removeOverride(...value) {
        const toRemove = value.filter((v)=>this.cssOverrides.includes(v));
        if (toRemove.length > 0) {
            this.cssOverrides = this.cssOverrides.filter((v)=>!toRemove.includes(v));
            this.update();
        }
    }
    /**
   * Sets the fill style for the text. HTML text only supports color fills (string or number values).
   * Texture fills are not supported and will trigger a warning in debug mode.
   * @example
   * ```ts
   * // Using hex colors
   * const text = new HTMLText({
   *     text: 'Colored Text',
   *     style: {
   *         fill: 0xff0000 // Red color
   *     }
   * });
   *
   * // Using CSS color strings
   * text.style.fill = '#00ff00';     // Hex string (Green)
   * text.style.fill = 'blue';        // Named color
   * text.style.fill = 'rgb(255,0,0)' // RGB
   * text.style.fill = '#f0f';        // Short hex
   *
   * // Invalid usage (will trigger warning in debug)
   * text.style.fill = {
   *     type: 'pattern',
   *     texture: Texture.from('pattern.png')
   * }; // Not supported, falls back to default
   * ```
   * @param value - The fill color to use. Must be a string or number.
   * @throws {Warning} In debug mode when attempting to use unsupported fill types
   * @see {@link TextStyle#fill} For full fill options in canvas text
   * @standard
   */ set fill(value) {
        if (typeof value !== "string" && typeof value !== "number") (0, $1RpxL.warn)("[HTMLTextStyle] only color fill is not supported by HTMLText");
        super.fill = value;
    }
    /**
   * Sets the stroke style for the text. HTML text only supports color strokes (string or number values).
   * Texture strokes are not supported and will trigger a warning in debug mode.
   * @example
   * ```ts
   * // Using hex colors
   * const text = new HTMLText({
   *     text: 'Outlined Text',
   *     style: {
   *         stroke: 0xff0000 // Red outline
   *     }
   * });
   *
   * // Using CSS color strings
   * text.style.stroke = '#00ff00';     // Hex string (Green)
   * text.style.stroke = 'blue';        // Named color
   * text.style.stroke = 'rgb(255,0,0)' // RGB
   * text.style.stroke = '#f0f';        // Short hex
   *
   * // Using stroke width
   * text.style = {
   *     stroke: {
   *         color: '#ff0000',
   *         width: 2
   *     }
   * };
   *
   * // Remove stroke
   * text.style.stroke = null;
   *
   * // Invalid usage (will trigger warning in debug)
   * text.style.stroke = {
   *     type: 'pattern',
   *     texture: Texture.from('pattern.png')
   * }; // Not supported, falls back to default
   * ```
   * @param value - The stroke style to use. Must be a string, number, or stroke configuration object
   * @throws {Warning} In debug mode when attempting to use unsupported stroke types
   * @see {@link TextStyle#stroke} For full stroke options in canvas text
   * @standard
   */ set stroke(value) {
        if (value && typeof value !== "string" && typeof value !== "number") (0, $1RpxL.warn)("[HTMLTextStyle] only color stroke is not supported by HTMLText");
        super.stroke = value;
    }
}



var $gLw46 = parcelRequire("gLw46");
"use strict";
const $3381da3d2cc4661b$var$nssvg = "http://www.w3.org/2000/svg";
const $3381da3d2cc4661b$var$nsxhtml = "http://www.w3.org/1999/xhtml";
class $3381da3d2cc4661b$export$47ab50939402e24e {
    constructor(){
        this.svgRoot = document.createElementNS($3381da3d2cc4661b$var$nssvg, "svg");
        this.foreignObject = document.createElementNS($3381da3d2cc4661b$var$nssvg, "foreignObject");
        this.domElement = document.createElementNS($3381da3d2cc4661b$var$nsxhtml, "div");
        this.styleElement = document.createElementNS($3381da3d2cc4661b$var$nsxhtml, "style");
        const { foreignObject: foreignObject, svgRoot: svgRoot, styleElement: styleElement, domElement: domElement } = this;
        foreignObject.setAttribute("width", "10000");
        foreignObject.setAttribute("height", "10000");
        foreignObject.style.overflow = "hidden";
        svgRoot.appendChild(foreignObject);
        foreignObject.appendChild(styleElement);
        foreignObject.appendChild(domElement);
        this.image = (0, $gLw46.DOMAdapter).get().createImage();
    }
    destroy() {
        this.svgRoot.remove();
        this.foreignObject.remove();
        this.styleElement.remove();
        this.domElement.remove();
        this.image.src = "";
        this.image.remove();
        this.svgRoot = null;
        this.foreignObject = null;
        this.styleElement = null;
        this.domElement = null;
        this.image = null;
        this.canvasAndContext = null;
    }
}


"use strict";
let $441b7620e17c1dbf$var$tempHTMLTextRenderData;
function $441b7620e17c1dbf$export$9df7f2a259800030(text, style, fontStyleCSS, htmlTextRenderData) {
    htmlTextRenderData || (htmlTextRenderData = $441b7620e17c1dbf$var$tempHTMLTextRenderData || ($441b7620e17c1dbf$var$tempHTMLTextRenderData = new (0, $3381da3d2cc4661b$export$47ab50939402e24e)()));
    const { domElement: domElement, styleElement: styleElement, svgRoot: svgRoot } = htmlTextRenderData;
    domElement.innerHTML = `<style>${style.cssStyle};</style><div style='padding:0'>${text}</div>`;
    domElement.setAttribute("style", "transform-origin: top left; display: inline-block");
    if (fontStyleCSS) styleElement.textContent = fontStyleCSS;
    document.body.appendChild(svgRoot);
    let contentWidth = domElement.scrollWidth;
    let contentHeight = domElement.scrollHeight;
    svgRoot.remove();
    if (style.dropShadow) {
        const { distance: distance, angle: angle, blur: blur } = style.dropShadow;
        const shadowOffsetX = Math.abs(Math.round(Math.cos(angle) * distance));
        const shadowOffsetY = Math.abs(Math.round(Math.sin(angle) * distance));
        contentWidth += shadowOffsetX + blur;
        contentHeight += shadowOffsetY + blur;
    }
    const doublePadding = style.padding * 2;
    return {
        width: contentWidth - doublePadding,
        height: contentHeight - doublePadding
    };
}



var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $4iNSL = parcelRequire("4iNSL");

var $6tS7R = parcelRequire("6tS7R");


var $hAzG5 = parcelRequire("hAzG5");
"use strict";
class $ce192bc6bd66ff16$export$26955126a6f3eb07 extends (0, $hAzG5.BatchableSprite) {
    constructor(){
        super(...arguments);
        this.generatingTexture = false;
        this.currentKey = "--";
    }
    /** Destroys the BatchableHTMLText instance. Returns the texture promise to the renderer and cleans up references. */ destroy() {
        this.texturePromise = null;
        this.generatingTexture = false;
        this.currentKey = "--";
        super.destroy();
    }
}


"use strict";
class $87b4b1c9de8cb92c$export$ffcef6958193be1c {
    constructor(renderer){
        this._renderer = renderer;
        renderer.runners.resolutionChange.add(this);
        this._managedTexts = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            onUnload: this.onTextUnload.bind(this),
            name: "htmlText"
        });
    }
    resolutionChange() {
        for(const key in this._managedTexts.items){
            const text = this._managedTexts.items[key];
            if (text?._autoResolution) text.onViewUpdate();
        }
    }
    validateRenderable(htmlText) {
        const gpuText = this._getGpuText(htmlText);
        const newKey = htmlText.styleKey;
        if (gpuText.currentKey !== newKey) return true;
        return false;
    }
    addRenderable(htmlText, instructionSet) {
        const batchableHTMLText = this._getGpuText(htmlText);
        if (htmlText._didTextUpdate) {
            const resolution = htmlText._autoResolution ? this._renderer.resolution : htmlText.resolution;
            if (batchableHTMLText.currentKey !== htmlText.styleKey || htmlText.resolution !== resolution) this._updateGpuText(htmlText).catch((e)=>{
                console.error(e);
            });
            htmlText._didTextUpdate = false;
            (0, $7df15e8bdde60348$export$cd6ce24a38c376aa)(batchableHTMLText, htmlText);
        }
        this._renderer.renderPipes.batch.addToBatch(batchableHTMLText, instructionSet);
    }
    updateRenderable(htmlText) {
        const batchableHTMLText = this._getGpuText(htmlText);
        batchableHTMLText._batcher.updateElement(batchableHTMLText);
    }
    async _updateGpuText(htmlText) {
        htmlText._didTextUpdate = false;
        const batchableHTMLText = this._getGpuText(htmlText);
        if (batchableHTMLText.generatingTexture) return;
        const oldTexturePromise = batchableHTMLText.texturePromise;
        batchableHTMLText.texturePromise = null;
        batchableHTMLText.generatingTexture = true;
        htmlText._resolution = htmlText._autoResolution ? this._renderer.resolution : htmlText.resolution;
        let texturePromise = this._renderer.htmlText.getTexturePromise(htmlText);
        if (oldTexturePromise) texturePromise = texturePromise.finally(()=>{
            this._renderer.htmlText.decreaseReferenceCount(batchableHTMLText.currentKey);
            this._renderer.htmlText.returnTexturePromise(oldTexturePromise);
        });
        batchableHTMLText.texturePromise = texturePromise;
        batchableHTMLText.currentKey = htmlText.styleKey;
        batchableHTMLText.texture = await texturePromise;
        const renderGroup = htmlText.renderGroup || htmlText.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        batchableHTMLText.generatingTexture = false;
        (0, $7df15e8bdde60348$export$cd6ce24a38c376aa)(batchableHTMLText, htmlText);
    }
    _getGpuText(htmlText) {
        return htmlText._gpuData[this._renderer.uid] || this.initGpuText(htmlText);
    }
    initGpuText(htmlText) {
        const batchableHTMLText = new (0, $ce192bc6bd66ff16$export$26955126a6f3eb07)();
        batchableHTMLText.renderable = htmlText;
        batchableHTMLText.transform = htmlText.groupTransform;
        batchableHTMLText.texture = (0, $4iNSL.Texture).EMPTY;
        batchableHTMLText.bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        batchableHTMLText.roundPixels = this._renderer._roundPixels | htmlText._roundPixels;
        htmlText._resolution = htmlText._autoResolution ? this._renderer.resolution : htmlText.resolution;
        htmlText._gpuData[this._renderer.uid] = batchableHTMLText;
        this._managedTexts.add(htmlText);
        return batchableHTMLText;
    }
    onTextUnload(text) {
        const gpuData = text._gpuData[this._renderer.uid];
        if (!gpuData) return;
        const { htmlText: htmlText } = this._renderer;
        htmlText.getReferenceCount(gpuData.currentKey) === null ? htmlText.returnTexturePromise(gpuData.texturePromise) : htmlText.decreaseReferenceCount(gpuData.currentKey);
    }
    destroy() {
        this._managedTexts.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $87b4b1c9de8cb92c$export$ffcef6958193be1c.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes,
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "htmlText"
};



var $aZ9ZN = parcelRequire("aZ9ZN");

var $dDZJD = parcelRequire("dDZJD");

var $5NyEC = parcelRequire("5NyEC");

var $bfcaK = parcelRequire("bfcaK");

var $llcp4 = parcelRequire("llcp4");

var $1RpxL = parcelRequire("1RpxL");

var $dokhj = parcelRequire("dokhj");


"use strict";
function $b99c776ac89ff53d$export$464e4dcbf779d16c(text, style) {
    const fontFamily = style.fontFamily;
    const fontFamilies = [];
    const dedupe = {};
    const regex = /font-family:([^;"\s]+)/g;
    const matches = text.match(regex);
    function addFontFamily(fontFamily2) {
        if (!dedupe[fontFamily2]) {
            fontFamilies.push(fontFamily2);
            dedupe[fontFamily2] = true;
        }
    }
    if (Array.isArray(fontFamily)) for(let i = 0; i < fontFamily.length; i++)addFontFamily(fontFamily[i]);
    else addFontFamily(fontFamily);
    if (matches) matches.forEach((match)=>{
        const fontFamily2 = match.split(":")[1].trim();
        addFontFamily(fontFamily2);
    });
    for(const i in style.tagStyles){
        const fontFamily2 = style.tagStyles[i].fontFamily;
        addFontFamily(fontFamily2);
    }
    return fontFamilies;
}



var $h3cT0 = parcelRequire("h3cT0");

var $gLw46 = parcelRequire("gLw46");
"use strict";
async function $42a73d1f584b97e5$export$21404a5ba2126552(url) {
    const response = await (0, $gLw46.DOMAdapter).get().fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    const dataSrc = await new Promise((resolve, reject)=>{
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    return dataSrc;
}


"use strict";
async function $2b4d0af1bd73729f$export$d5a8e182a5491db2(style, url) {
    const dataSrc = await (0, $42a73d1f584b97e5$export$21404a5ba2126552)(url);
    return `@font-face {
        font-family: "${style.fontFamily}";
        font-weight: ${style.fontWeight};
        font-style: ${style.fontStyle};
        src: url('${dataSrc}');
    }`;
}


"use strict";
const $e1534842bcbeada5$export$9b6075a0351ad0f8 = /* @__PURE__ */ new Map();
async function $e1534842bcbeada5$export$634b39f5e6e8534d(fontFamilies) {
    const fontPromises = fontFamilies.filter((fontFamily)=>(0, $h3cT0.Cache).has(`${fontFamily}-and-url`)).map((fontFamily)=>{
        if (!$e1534842bcbeada5$export$9b6075a0351ad0f8.has(fontFamily)) {
            const { entries: entries } = (0, $h3cT0.Cache).get(`${fontFamily}-and-url`);
            const promises = [];
            entries.forEach((entry)=>{
                const url = entry.url;
                const faces = entry.faces;
                const out = faces.map((face)=>({
                        weight: face.weight,
                        style: face.style
                    }));
                promises.push(...out.map((style)=>(0, $2b4d0af1bd73729f$export$d5a8e182a5491db2)({
                        fontWeight: style.weight,
                        fontStyle: style.style,
                        fontFamily: fontFamily
                    }, url)));
            });
            $e1534842bcbeada5$export$9b6075a0351ad0f8.set(fontFamily, Promise.all(promises).then((css)=>css.join("\n")));
        }
        return $e1534842bcbeada5$export$9b6075a0351ad0f8.get(fontFamily);
    });
    return (await Promise.all(fontPromises)).join("\n");
}


"use strict";
function $8bc72fb7e7e66925$export$98b744dca5b9429f(text, style, resolution, fontCSS, htmlTextData) {
    const { domElement: domElement, styleElement: styleElement, svgRoot: svgRoot } = htmlTextData;
    domElement.innerHTML = `<style>${style.cssStyle}</style><div style='padding:0;'>${text}</div>`;
    domElement.setAttribute("style", `transform: scale(${resolution});transform-origin: top left; display: inline-block`);
    styleElement.textContent = fontCSS;
    const { width: width, height: height } = htmlTextData.image;
    svgRoot.setAttribute("width", width.toString());
    svgRoot.setAttribute("height", height.toString());
    return new XMLSerializer().serializeToString(svgRoot);
}



var $dDZJD = parcelRequire("dDZJD");
"use strict";
function $612f403d91c42bd4$export$d871fed544c30b4e(image, resolution) {
    const canvasAndContext = (0, $dDZJD.CanvasPool).getOptimalCanvasAndContext(image.width, image.height, resolution);
    const { context: context } = canvasAndContext;
    context.clearRect(0, 0, image.width, image.height);
    context.drawImage(image, 0, 0);
    return canvasAndContext;
}


"use strict";
function $3c5dfa3f7ca908c5$export$31cf685397f1a12a(image, url, delay) {
    return new Promise(async (resolve)=>{
        if (delay) await new Promise((resolve2)=>setTimeout(resolve2, 100));
        image.onload = ()=>{
            resolve();
        };
        image.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(url)}`;
        image.crossOrigin = "anonymous";
    });
}



"use strict";
class $9567781f44a66438$export$f1b82676a746d8e9 {
    constructor(renderer){
        this._activeTextures = {};
        this._renderer = renderer;
        this._createCanvas = renderer.type === (0, $bfcaK.RendererType).WEBGPU;
    }
    /**
   * @param options
   * @deprecated Use getTexturePromise instead
   */ getTexture(options) {
        return this.getTexturePromise(options);
    }
    /**
   * Increases the reference count for a texture.
   * @param text - The HTMLText instance associated with the texture.
   */ getManagedTexture(text) {
        const textKey = text.styleKey;
        if (this._activeTextures[textKey]) {
            this._increaseReferenceCount(textKey);
            return this._activeTextures[textKey].promise;
        }
        const promise = this._buildTexturePromise(text).then((texture)=>{
            this._activeTextures[textKey].texture = texture;
            return texture;
        });
        this._activeTextures[textKey] = {
            texture: null,
            promise: promise,
            usageCount: 1
        };
        return promise;
    }
    /**
   * Gets the current reference count for a texture associated with a text key.
   * @param textKey - The unique key identifying the text style configuration
   * @returns The number of Text instances currently using this texture
   */ getReferenceCount(textKey) {
        return this._activeTextures[textKey]?.usageCount ?? null;
    }
    _increaseReferenceCount(textKey) {
        this._activeTextures[textKey].usageCount++;
    }
    /**
   * Decreases the reference count for a texture.
   * If the count reaches zero, the texture is cleaned up.
   * @param textKey - The key associated with the HTMLText instance.
   */ decreaseReferenceCount(textKey) {
        const activeTexture = this._activeTextures[textKey];
        if (!activeTexture) return;
        activeTexture.usageCount--;
        if (activeTexture.usageCount === 0) {
            if (activeTexture.texture) this._cleanUp(activeTexture.texture);
            else activeTexture.promise.then((texture)=>{
                activeTexture.texture = texture;
                this._cleanUp(activeTexture.texture);
            }).catch(()=>{
                (0, $1RpxL.warn)("HTMLTextSystem: Failed to clean texture");
            });
            this._activeTextures[textKey] = null;
        }
    }
    /**
   * Returns a promise that resolves to a texture for the given HTMLText options.
   * @param options - The options for the HTMLText.
   * @returns A promise that resolves to a Texture.
   */ getTexturePromise(options) {
        return this._buildTexturePromise(options);
    }
    async _buildTexturePromise(options) {
        const { text: text, style: style, resolution: resolution, textureStyle: textureStyle } = options;
        const htmlTextData = (0, $dokhj.BigPool).get((0, $3381da3d2cc4661b$export$47ab50939402e24e));
        const fontFamilies = (0, $b99c776ac89ff53d$export$464e4dcbf779d16c)(text, style);
        const fontCSS = await (0, $e1534842bcbeada5$export$634b39f5e6e8534d)(fontFamilies);
        const measured = (0, $441b7620e17c1dbf$export$9df7f2a259800030)(text, style, fontCSS, htmlTextData);
        const width = Math.ceil(Math.ceil(Math.max(1, measured.width) + style.padding * 2) * resolution);
        const height = Math.ceil(Math.ceil(Math.max(1, measured.height) + style.padding * 2) * resolution);
        const image = htmlTextData.image;
        const uvSafeOffset = 2;
        image.width = (width | 0) + uvSafeOffset;
        image.height = (height | 0) + uvSafeOffset;
        const svgURL = (0, $8bc72fb7e7e66925$export$98b744dca5b9429f)(text, style, resolution, fontCSS, htmlTextData);
        await (0, $3c5dfa3f7ca908c5$export$31cf685397f1a12a)(image, svgURL, (0, $llcp4.isSafari)() && fontFamilies.length > 0);
        const resource = image;
        let canvasAndContext;
        if (this._createCanvas) canvasAndContext = (0, $612f403d91c42bd4$export$d871fed544c30b4e)(image, resolution);
        const texture = (0, $fb2e0fd15e1bae74$export$80c61c6b7fb407a3)(canvasAndContext ? canvasAndContext.canvas : resource, image.width - uvSafeOffset, image.height - uvSafeOffset, resolution);
        if (textureStyle) texture.source.style = textureStyle;
        if (this._createCanvas) {
            this._renderer.texture.initSource(texture.source);
            (0, $dDZJD.CanvasPool).returnCanvasAndContext(canvasAndContext);
        }
        (0, $dokhj.BigPool).return(htmlTextData);
        return texture;
    }
    returnTexturePromise(texturePromise) {
        texturePromise.then((texture)=>{
            this._cleanUp(texture);
        }).catch(()=>{
            (0, $1RpxL.warn)("HTMLTextSystem: Failed to clean texture");
        });
    }
    _cleanUp(texture) {
        (0, $5NyEC.TexturePool).returnTexture(texture, true);
        texture.source.resource = null;
        texture.source.uploadMethodId = "unknown";
    }
    destroy() {
        this._renderer = null;
        for(const key in this._activeTextures)if (this._activeTextures[key]) this.returnTexturePromise(this._activeTextures[key].promise);
        this._activeTextures = null;
    }
}
/** @ignore */ $9567781f44a66438$export$f1b82676a746d8e9.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem,
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "htmlText"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $9567781f44a66438$export$f1b82676a746d8e9));
(0, $aZ9ZN.extensions).add((0, $87b4b1c9de8cb92c$export$ffcef6958193be1c));


"use strict";
class $afdf916a562c9b1a$export$4b42bbc5a42896a1 extends (0, $19c3827930a6b92b$export$daf74670712de91) {
    constructor(...args){
        const options = (0, $19c3827930a6b92b$export$8ddfb4f614f8ed86)(args, "HtmlText");
        super(options, (0, $8411904bd7736fea$export$a2664b42ece43c6c));
        /** @internal */ this.renderPipeId = "htmlText";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $c8piJ.TextureStyle) ? options.textureStyle : new (0, $c8piJ.TextureStyle)(options.textureStyle);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const htmlMeasurement = (0, $441b7620e17c1dbf$export$9df7f2a259800030)(this.text, this._style);
        const { width: width, height: height } = htmlMeasurement;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    get text() {
        return this._text;
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new HTMLText({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new HTMLText({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new HTMLText({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new HTMLText({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(text) {
        const sanitisedText = this._sanitiseText(text.toString());
        super.text = sanitisedText;
    }
    /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */ _sanitiseText(text) {
        return this._removeInvalidHtmlTags(text.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;"));
    }
    _removeInvalidHtmlTags(input) {
        const brokenTagPattern = /<[^>]*?(?=<|$)/g;
        return input.replace(brokenTagPattern, "");
    }
}



"use strict";
class $243fa1c02dacb515$export$a98d473d4c3e7e4b extends (0, $0d30f8725cec24cc$export$c4920d5f3c7b8959) {
    /**
   * Upload the given queue item
   * @param item
   */ uploadQueueItem(item) {
        if (item instanceof (0, $gmQ4R.TextureSource)) this.uploadTextureSource(item);
        else if (item instanceof (0, $f3e48f5b83971e92$export$5f1af8db9871e1d6)) this.uploadText(item);
        else if (item instanceof (0, $afdf916a562c9b1a$export$4b42bbc5a42896a1)) this.uploadHTMLText(item);
        else if (item instanceof (0, $8095d93ccaec0291$export$ae0da96467efdba0)) this.uploadBitmapText(item);
        else if (item instanceof (0, $7kRkZ.GraphicsContext)) this.uploadGraphicsContext(item);
    }
    uploadTextureSource(textureSource) {
        this.renderer.texture.initSource(textureSource);
    }
    uploadText(_text) {
        this.renderer.renderPipes.text.initGpuText(_text);
    }
    uploadBitmapText(_text) {
        this.renderer.renderPipes.bitmapText.initGpuText(_text);
    }
    uploadHTMLText(_text) {
        this.renderer.renderPipes.htmlText.initGpuText(_text);
    }
    /**
   * Resolve the given graphics context and return an item for the queue
   * @param graphicsContext
   */ uploadGraphicsContext(graphicsContext) {
        this.renderer.graphicsContext.getGpuContext(graphicsContext);
        const { instructions: instructions } = graphicsContext;
        for (const instruction of instructions){
            if (instruction.action === "texture") {
                const { image: image } = instruction.data;
                this.uploadTextureSource(image.source);
            } else if (instruction.action === "fill") {
                const { texture: texture } = instruction.data.style;
                this.uploadTextureSource(texture.source);
            }
        }
        return null;
    }
}


"use strict";
class $cbb4326a63b0dae2$export$9c030b3792ef41b6 extends (0, $243fa1c02dacb515$export$a98d473d4c3e7e4b) {
    /** Destroys the plugin, don't use after this. */ destroy() {
        super.destroy();
        clearTimeout(this.timeout);
        this.renderer = null;
        this.queue = null;
        this.resolves = null;
    }
}
/** @ignore */ $cbb4326a63b0dae2$export$9c030b3792ef41b6.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLSystem,
        (0, $aZ9ZN.ExtensionType).WebGPUSystem
    ],
    name: "prepare"
};




var $928ng = parcelRequire("928ng");

var $7ogwP = parcelRequire("7ogwP");

var $igOXQ = parcelRequire("igOXQ");

var $kqE0J = parcelRequire("kqE0J");
"use strict";
function $4a8dc7521903eb7c$export$e04e512f21f419b6(maxTextures) {
    const gpuLayout = [];
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        gpuLayout[bindIndex] = {
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            },
            binding: bindIndex,
            visibility: GPUShaderStage.FRAGMENT
        };
        bindIndex++;
        gpuLayout[bindIndex] = {
            sampler: {
                type: "filtering"
            },
            binding: bindIndex,
            visibility: GPUShaderStage.FRAGMENT
        };
        bindIndex++;
    }
    return gpuLayout;
}


"use strict";
function $b20a4cfe0004842a$export$e6a9d79fae156af6(maxTextures) {
    const layout = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        layout[`textureSource${i + 1}`] = bindIndex++;
        layout[`textureSampler${i + 1}`] = bindIndex++;
    }
    return layout;
}



var $dGUqy = parcelRequire("dGUqy");

var $d0Ll5 = parcelRequire("d0Ll5");

var $J0JR5 = parcelRequire("J0JR5");

var $jDoUt = parcelRequire("jDoUt");

var $2RTgk = parcelRequire("2RTgk");

var $bc7uw = parcelRequire("bc7uw");

var $gjENK = parcelRequire("gjENK");

var $4Af3A = parcelRequire("4Af3A");

var $aYOxl = parcelRequire("aYOxl");

var $bhlBQ = parcelRequire("bhlBQ");

var $iioxo = parcelRequire("iioxo");

var $CEJ1P = parcelRequire("CEJ1P");

var $6iet8 = parcelRequire("6iet8");

var $8cyng = parcelRequire("8cyng");
"use strict";
function $1d34a18505b19a00$export$14e97d6d2d36f381(shader) {
    const spl = shader.split(/([\n{}])/g).map((a)=>a.trim()).filter((a)=>a.length);
    let indent = "";
    const formatted = spl.map((a)=>{
        let indentedLine = indent + a;
        if (a === "{") indent += "    ";
        else if (a === "}") {
            indent = indent.substr(0, indent.length - 4);
            indentedLine = indent + a;
        }
        return indentedLine;
    }).join("\n");
    return formatted;
}



var $4gc0T = parcelRequire("4gc0T");

var $a8QIF = parcelRequire("a8QIF");

var $eGbby = parcelRequire("eGbby");

var $1I0Ex = parcelRequire("1I0Ex");

var $bxcOr = parcelRequire("bxcOr");

var $dKCGl = parcelRequire("dKCGl");

var $gnlmr = parcelRequire("gnlmr");

var $7hkN8 = parcelRequire("7hkN8");

var $28ThD = parcelRequire("28ThD");

var $gNCRL = parcelRequire("gNCRL");

var $kF9p5 = parcelRequire("kF9p5");

var $4DqO3 = parcelRequire("4DqO3");

var $lNC5O = parcelRequire("lNC5O");

var $gzffs = parcelRequire("gzffs");

var $PVSNp = parcelRequire("PVSNp");

var $25uEm = parcelRequire("25uEm");
"use strict";
class $4dea72e4ea6eb54a$export$d3b30572aa9f34ed {
    constructor(mask){
        this.priority = 0;
        this.pipe = "scissorMask";
        this.mask = mask;
        this.mask.renderable = false;
        this.mask.measurable = false;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $PVSNp.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $25uEm.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask = null;
    }
    destroy() {
        this.reset();
    }
}



var $8uCJE = parcelRequire("8uCJE");

var $issq5 = parcelRequire("issq5");

var $yJ7KI = parcelRequire("yJ7KI");

var $PVSNp = parcelRequire("PVSNp");

var $25uEm = parcelRequire("25uEm");


var $gBwOb = parcelRequire("gBwOb");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $esrbs = parcelRequire("esrbs");

var $iqHv9 = parcelRequire("iqHv9");


var $dDZJD = parcelRequire("dDZJD");

var $2IIjX = parcelRequire("2IIjX");
"use strict";
function $9f91e5b1ed9b97a7$export$11b4d03fcc98aa40(filter) {
    return typeof filter.getCanvasFilterString === "function";
}
class $9f91e5b1ed9b97a7$var$CanvasFilterFrame {
    constructor(){
        this.skip = false;
        this.useClip = false;
        this.filters = null;
        this.container = null;
        this.bounds = new (0, $esrbs.Bounds)();
        this.cssFilterString = "";
    }
}
class $9f91e5b1ed9b97a7$export$79609693985adbca {
    /**
   * @param renderer - The Canvas renderer
   * @param renderer.canvasContext
   * @param renderer.canvasContext.activeContext
   * @param renderer.canvasContext.activeResolution
   */ constructor(renderer){
        this._filterStack = [];
        this._filterStackIndex = 0;
        this._savedStates = [];
        this._alphaMultiplier = 1;
        this._warnedFilterTypes = /* @__PURE__ */ new Set();
        this.renderer = renderer;
    }
    /**
   * Push a filter instruction onto the stack.
   * Called when entering a filtered container.
   * @param instruction - The filter instruction from FilterPipe
   */ push(instruction) {
        const filterFrame = this._pushFilterFrame();
        const filters = instruction.filterEffect.filters;
        filterFrame.skip = false;
        filterFrame.useClip = false;
        filterFrame.filters = filters;
        filterFrame.container = instruction.container;
        filterFrame.cssFilterString = "";
        if (filters.every((filter)=>!filter.enabled)) {
            filterFrame.skip = true;
            return;
        }
        const cssFilters = [];
        const alphaMultiplier = 1;
        for (const filter of filters){
            if (!filter.enabled) continue;
            if (!$9f91e5b1ed9b97a7$export$11b4d03fcc98aa40(filter)) {
                this._warnUnsupportedFilter(filter);
                continue;
            }
            const cssString = filter.getCanvasFilterString();
            if (cssString === null) {
                this._warnUnsupportedFilter(filter);
                continue;
            }
            if (cssString) cssFilters.push(cssString);
        }
        if (cssFilters.length === 0 && alphaMultiplier === 1) {
            filterFrame.skip = true;
            return;
        }
        filterFrame.cssFilterString = cssFilters.join(" ");
        this._calculateFilterArea(instruction, filterFrame.bounds);
        filterFrame.useClip = !!instruction.filterEffect.filterArea;
        const context = this.renderer.canvasContext.activeContext;
        const previousFilter = context.filter || "none";
        this._savedStates.push({
            filter: previousFilter,
            alphaMultiplier: this._alphaMultiplier
        });
        if (filterFrame.useClip && Number.isFinite(filterFrame.bounds.width) && Number.isFinite(filterFrame.bounds.height) && filterFrame.bounds.width > 0 && filterFrame.bounds.height > 0) {
            const resolution = this.renderer.canvasContext.activeResolution || 1;
            context.save();
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.beginPath();
            context.rect(filterFrame.bounds.x * resolution, filterFrame.bounds.y * resolution, filterFrame.bounds.width * resolution, filterFrame.bounds.height * resolution);
            context.clip();
        } else filterFrame.useClip = false;
        if (alphaMultiplier !== 1) this._alphaMultiplier *= alphaMultiplier;
        if (filterFrame.cssFilterString) context.filter = previousFilter !== "none" ? `${previousFilter} ${filterFrame.cssFilterString}` : filterFrame.cssFilterString;
    }
    /** Pop a filter from the stack. Called when exiting a filtered container. */ pop() {
        const filterFrame = this._popFilterFrame();
        if (filterFrame.skip) return;
        const savedState = this._savedStates.pop();
        if (!savedState) return;
        const context = this.renderer.canvasContext.activeContext;
        if (filterFrame.useClip) context.restore();
        else context.filter = savedState.filter;
        this._alphaMultiplier = savedState.alphaMultiplier;
    }
    /**
   * Applies supported filters to a texture and returns a new texture.
   * Unsupported filters are skipped with a warn-once message.
   * @param params - The parameters for applying filters.
   * @param params.texture
   * @param params.filters
   * @returns The resulting texture after filters are applied.
   */ generateFilteredTexture({ texture: texture, filters: filters }) {
        if (!filters?.length || filters.every((filter)=>!filter.enabled)) return texture;
        const cssFilters = [];
        const alphaMultiplier = 1;
        for (const filter of filters){
            if (!filter.enabled) continue;
            if (!$9f91e5b1ed9b97a7$export$11b4d03fcc98aa40(filter)) {
                this._warnUnsupportedFilter(filter);
                continue;
            }
            const cssString = filter.getCanvasFilterString();
            if (cssString === null) {
                this._warnUnsupportedFilter(filter);
                continue;
            }
            if (cssString) cssFilters.push(cssString);
        }
        if (cssFilters.length === 0 && alphaMultiplier === 1) return texture;
        const source = (0, $2IIjX.canvasUtils).getCanvasSource(texture);
        if (!source) return texture;
        const frame = texture.frame;
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        const width = frame.width;
        const height = frame.height;
        const canvasAndContext = (0, $dDZJD.CanvasPool).getOptimalCanvasAndContext(width, height, resolution);
        const { canvas: canvas, context: context } = canvasAndContext;
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);
        if (cssFilters.length) context.filter = cssFilters.join(" ");
        if (alphaMultiplier !== 1) context.globalAlpha = alphaMultiplier;
        const sx = frame.x * resolution;
        const sy = frame.y * resolution;
        const sw = width * resolution;
        const sh = height * resolution;
        context.drawImage(source, sx, sy, sw, sh, 0, 0, sw, sh);
        context.filter = "none";
        context.globalAlpha = 1;
        return (0, $fb2e0fd15e1bae74$export$80c61c6b7fb407a3)(canvas, width, height, resolution);
    }
    /**
   * Calculate the filter area bounds.
   * @param instruction - Filter instruction
   * @param bounds - Bounds object to populate
   */ _calculateFilterArea(instruction, bounds) {
        if (instruction.renderables) (0, $iqHv9.getGlobalRenderableBounds)(instruction.renderables, bounds);
        else if (instruction.filterEffect.filterArea) {
            bounds.clear();
            bounds.addRect(instruction.filterEffect.filterArea);
            bounds.applyMatrix(instruction.container.worldTransform);
        } else instruction.container.getFastGlobalBounds(true, bounds);
        if (instruction.container) {
            const renderGroup = instruction.container.renderGroup || instruction.container.parentRenderGroup;
            const filterFrameTransform = renderGroup?.cacheToLocalTransform;
            if (filterFrameTransform) bounds.applyMatrix(filterFrameTransform);
        }
    }
    _warnUnsupportedFilter(filter) {
        const filterName = filter?.constructor?.name || "Filter";
        if (this._warnedFilterTypes.has(filterName)) return;
        this._warnedFilterTypes.add(filterName);
        console.warn(`CanvasRenderer: filter "${filterName}" is not supported in Canvas2D and will be skipped.`);
    }
    get alphaMultiplier() {
        return this._alphaMultiplier;
    }
    _pushFilterFrame() {
        let filterFrame = this._filterStack[this._filterStackIndex];
        if (!filterFrame) filterFrame = this._filterStack[this._filterStackIndex] = new $9f91e5b1ed9b97a7$var$CanvasFilterFrame();
        this._filterStackIndex++;
        return filterFrame;
    }
    _popFilterFrame() {
        if (this._filterStackIndex <= 0) return this._filterStack[0];
        this._filterStackIndex--;
        return this._filterStack[this._filterStackIndex];
    }
    /** Destroys the system */ destroy() {
        this._filterStack = null;
        this._savedStates = null;
        this._warnedFilterTypes = null;
        this._alphaMultiplier = 1;
    }
}
/** @ignore */ $9f91e5b1ed9b97a7$export$79609693985adbca.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasSystem
    ],
    name: "filter"
};
(0, $aZ9ZN.extensions).add($9f91e5b1ed9b97a7$export$79609693985adbca);



var $iZQJj = parcelRequire("iZQJj");

var $lFL21 = parcelRequire("lFL21");

var $2ScGl = parcelRequire("2ScGl");

var $f4cmq = parcelRequire("f4cmq");

var $dV9kF = parcelRequire("dV9kF");

var $gfzpv = parcelRequire("gfzpv");

var $2IIjX = parcelRequire("2IIjX");

var $15FDP = parcelRequire("15FDP");

var $7LyGy = parcelRequire("7LyGy");

var $8bVSg = parcelRequire("8bVSg");

var $k0jeB = parcelRequire("k0jeB");

var $5Ac7T = parcelRequire("5Ac7T");

var $a66qS = parcelRequire("a66qS");

var $4gUjT = parcelRequire("4gUjT");

var $4W7Q2 = parcelRequire("4W7Q2");

var $1k36i = parcelRequire("1k36i");

var $hqwGc = parcelRequire("hqwGc");

var $hJqSP = parcelRequire("hJqSP");

var $epQ0R = parcelRequire("epQ0R");

var $X4HIt = parcelRequire("X4HIt");

var $chYSB = parcelRequire("chYSB");

var $6FDbi = parcelRequire("6FDbi");

var $5DCZv = parcelRequire("5DCZv");

var $afkf3 = parcelRequire("afkf3");

var $Rm4fI = parcelRequire("Rm4fI");

var $foUHO = parcelRequire("foUHO");

var $4kU4M = parcelRequire("4kU4M");

var $lhx4E = parcelRequire("lhx4E");

var $6ZiIY = parcelRequire("6ZiIY");

var $iaA7Y = parcelRequire("iaA7Y");
"use strict";
function $9f076e2344748696$export$e65570829deefc5(fragmentShader) {
    fragmentShader = fragmentShader.replaceAll("texture2D", "texture").replaceAll("gl_FragColor", "finalColor").replaceAll("varying", "in");
    fragmentShader = `
        out vec4 finalColor;
    ${fragmentShader}
    `;
    return fragmentShader;
}



var $9q9nW = parcelRequire("9q9nW");

var $ljCyn = parcelRequire("ljCyn");

var $5dp3e = parcelRequire("5dp3e");

var $kokDf = parcelRequire("kokDf");

var $8XSZ3 = parcelRequire("8XSZ3");

var $PoGJg = parcelRequire("PoGJg");

var $2sz3b = parcelRequire("2sz3b");

var $623tj = parcelRequire("623tj");

var $e8SzA = parcelRequire("e8SzA");

var $jWjsq = parcelRequire("jWjsq");
"use strict";
const $183cd7d651459f4b$var$GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
function $183cd7d651459f4b$export$50ee69a11aa2abdb(type) {
    return $183cd7d651459f4b$var$GLSL_TO_SIZE[type];
}



var $Y425I = parcelRequire("Y425I");

var $hAD1m = parcelRequire("hAD1m");

var $1ZdMF = parcelRequire("1ZdMF");

var $1EMZg = parcelRequire("1EMZg");

var $4IUGf = parcelRequire("4IUGf");

var $kQYzC = parcelRequire("kQYzC");

var $9z8Ce = parcelRequire("9z8Ce");

var $ag5k6 = parcelRequire("ag5k6");

var $8Cr41 = parcelRequire("8Cr41");

var $bq0o8 = parcelRequire("bq0o8");

var $1I8G2 = parcelRequire("1I8G2");

var $71WMa = parcelRequire("71WMa");

var $cVY0I = parcelRequire("cVY0I");

var $d0Wi0 = parcelRequire("d0Wi0");

var $2rkWb = parcelRequire("2rkWb");

var $lMeU5 = parcelRequire("lMeU5");

var $cciod = parcelRequire("cciod");

var $ltjQZ = parcelRequire("ltjQZ");

var $hufwr = parcelRequire("hufwr");

var $hU0oy = parcelRequire("hU0oy");

var $5eCic = parcelRequire("5eCic");

var $iRWum = parcelRequire("iRWum");


var $5N2S9 = parcelRequire("5N2S9");

var $1cGmN = parcelRequire("1cGmN");

var $8LpWL = parcelRequire("8LpWL");

var $lh1dy = parcelRequire("lh1dy");

var $gceSf = parcelRequire("gceSf");

var $7ns3U = parcelRequire("7ns3U");

var $5aJ4P = parcelRequire("5aJ4P");

var $5mmZy = parcelRequire("5mmZy");

var $a7eRK = parcelRequire("a7eRK");

var $bcrPS = parcelRequire("bcrPS");

var $8KWmS = parcelRequire("8KWmS");

var $7nhp3 = parcelRequire("7nhp3");

var $cQMIy = parcelRequire("cQMIy");

var $k3sPs = parcelRequire("k3sPs");

var $4ilFQ = parcelRequire("4ilFQ");

var $epQzV = parcelRequire("epQzV");

var $fYxv0 = parcelRequire("fYxv0");

var $asuS1 = parcelRequire("asuS1");

var $j5jxv = parcelRequire("j5jxv");

var $iXZ4N = parcelRequire("iXZ4N");

var $26lTw = parcelRequire("26lTw");

var $9oWpi = parcelRequire("9oWpi");

var $eK2sB = parcelRequire("eK2sB");

var $bEdxc = parcelRequire("bEdxc");

var $7oXM7 = parcelRequire("7oXM7");

var $hXd8Z = parcelRequire("hXd8Z");

var $8346X = parcelRequire("8346X");

var $jqzau = parcelRequire("jqzau");

var $gKvt3 = parcelRequire("gKvt3");

var $9LA71 = parcelRequire("9LA71");

var $5UqCH = parcelRequire("5UqCH");

var $8RSuU = parcelRequire("8RSuU");

var $5WpII = parcelRequire("5WpII");

var $fWGV5 = parcelRequire("fWGV5");

var $6v8M4 = parcelRequire("6v8M4");

var $kcEAx = parcelRequire("kcEAx");

var $h62oc = parcelRequire("h62oc");

var $fruAx = parcelRequire("fruAx");

var $hrIct = parcelRequire("hrIct");

var $hKdsJ = parcelRequire("hKdsJ");

var $3vOQh = parcelRequire("3vOQh");

var $jQIsz = parcelRequire("jQIsz");


var $2jIR8 = parcelRequire("2jIR8");

var $bCbWs = parcelRequire("bCbWs");

var $9UEzW = parcelRequire("9UEzW");

var $4PjrR = parcelRequire("4PjrR");

var $2bJdA = parcelRequire("2bJdA");

var $9axq6 = parcelRequire("9axq6");

var $1T7Iy = parcelRequire("1T7Iy");

var $3hvSu = parcelRequire("3hvSu");

var $57WMt = parcelRequire("57WMt");

var $7fOUA = parcelRequire("7fOUA");

var $7bRdE = parcelRequire("7bRdE");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
const $17e5637b80de6878$var$DEPRECATED_DRAW_MODES = {
    POINTS: "point-list",
    LINES: "line-list",
    LINE_STRIP: "line-strip",
    TRIANGLES: "triangle-list",
    TRIANGLE_STRIP: "triangle-strip"
};
const $17e5637b80de6878$export$91100badd8469338 = new Proxy($17e5637b80de6878$var$DEPRECATED_DRAW_MODES, {
    get (target, prop) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), `DRAW_MODES.${prop} is deprecated, use '${$17e5637b80de6878$var$DEPRECATED_DRAW_MODES[prop]}' instead`);
        return target[prop];
    }
});



var $1T4Gr = parcelRequire("1T4Gr");

var $6WSe9 = parcelRequire("6WSe9");

var $nCv4H = parcelRequire("nCv4H");

var $eDWUK = parcelRequire("eDWUK");

var $bzZoS = parcelRequire("bzZoS");

var $iWOpI = parcelRequire("iWOpI");

var $1oPFv = parcelRequire("1oPFv");

var $cVsmc = parcelRequire("cVsmc");

var $axEIC = parcelRequire("axEIC");

var $l6xrO = parcelRequire("l6xrO");

var $2nO5l = parcelRequire("2nO5l");

var $iifuN = parcelRequire("iifuN");

var $kqAKw = parcelRequire("kqAKw");

var $7LCXQ = parcelRequire("7LCXQ");

var $fC2kJ = parcelRequire("fC2kJ");

var $jSrmW = parcelRequire("jSrmW");

var $aUxJK = parcelRequire("aUxJK");

var $9dsH7 = parcelRequire("9dsH7");

var $9wfqV = parcelRequire("9wfqV");

var $ktXe2 = parcelRequire("ktXe2");

var $1oQYm = parcelRequire("1oQYm");

var $eHpUP = parcelRequire("eHpUP");

var $fYoss = parcelRequire("fYoss");

var $fy1Tx = parcelRequire("fy1Tx");

var $fx0Zy = parcelRequire("fx0Zy");

var $7velr = parcelRequire("7velr");

var $g2d25 = parcelRequire("g2d25");

var $ljtep = parcelRequire("ljtep");

var $dDZJD = parcelRequire("dDZJD");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
var $8198d5846d96f1d9$export$11e7818b66cb6578 = /* @__PURE__ */ ((DEPRECATED_WRAP_MODES2)=>{
    DEPRECATED_WRAP_MODES2["CLAMP"] = "clamp-to-edge";
    DEPRECATED_WRAP_MODES2["REPEAT"] = "repeat";
    DEPRECATED_WRAP_MODES2["MIRRORED_REPEAT"] = "mirror-repeat";
    return DEPRECATED_WRAP_MODES2;
})($8198d5846d96f1d9$export$11e7818b66cb6578 || {});
const $8198d5846d96f1d9$export$2ab395cfb0dd2f0f = new Proxy($8198d5846d96f1d9$export$11e7818b66cb6578, {
    get (target, prop) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), `DRAW_MODES.${prop} is deprecated, use '${$8198d5846d96f1d9$export$11e7818b66cb6578[prop]}' instead`);
        return target[prop];
    }
});
var $8198d5846d96f1d9$export$b7a14fee0d1d75cf = /* @__PURE__ */ ((DEPRECATED_SCALE_MODES2)=>{
    DEPRECATED_SCALE_MODES2["NEAREST"] = "nearest";
    DEPRECATED_SCALE_MODES2["LINEAR"] = "linear";
    return DEPRECATED_SCALE_MODES2;
})($8198d5846d96f1d9$export$b7a14fee0d1d75cf || {});
const $8198d5846d96f1d9$export$6b734c6a0bba8473 = new Proxy($8198d5846d96f1d9$export$b7a14fee0d1d75cf, {
    get (target, prop) {
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), `DRAW_MODES.${prop} is deprecated, use '${$8198d5846d96f1d9$export$b7a14fee0d1d75cf[prop]}' instead`);
        return target[prop];
    }
});



var $6AQ4q = parcelRequire("6AQ4q");

var $h3cT0 = parcelRequire("h3cT0");

var $1bMtF = parcelRequire("1bMtF");

var $1RpxL = parcelRequire("1RpxL");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
class $410bf5be1058f2d9$export$44fad16177a84e21 extends (0, $gmQ4R.TextureSource) {
    constructor(options){
        const { faces: faces, ...rest } = options;
        $410bf5be1058f2d9$export$44fad16177a84e21._validateFaces(faces);
        const first = faces.right;
        const derivedResolution = first.resolution;
        const derivedFormat = first.format;
        const derivedAlphaMode = first.alphaMode;
        const ignoredKeys = [
            "resolution",
            "format",
            "alphaMode",
            "dimensions",
            "viewDimension"
        ].filter((key)=>rest[key] !== void 0);
        if (ignoredKeys.length) (0, $1RpxL.warn)(`[CubeTextureSource] Ignoring option(s) [${ignoredKeys.join(", ")}]; these are derived from face sources.`);
        super({
            ...rest,
            resource: faces,
            // Keep these aligned with the face sources so any code that reads width/height works.
            width: first.width,
            height: first.height,
            dimensions: "2d",
            viewDimension: "cube",
            arrayLayerCount: 6,
            resolution: derivedResolution,
            format: derivedFormat,
            alphaMode: derivedAlphaMode
        });
        /** @internal */ this.uploadMethodId = "cube";
        this.faces = faces;
        for (const key of Object.keys(faces)){
            const face = faces[key];
            face.on("update", this._onFaceUpdate, this);
            face.on("resize", this._onFaceResize, this);
            face.on("unload", this._onFaceUpdate, this);
        }
    }
    destroy() {
        const faces = this.faces;
        if (faces) for (const key of Object.keys(faces)){
            const face = faces[key];
            face.off("update", this._onFaceUpdate, this);
            face.off("resize", this._onFaceResize, this);
            face.off("unload", this._onFaceUpdate, this);
        }
        super.destroy();
    }
    _onFaceUpdate() {
        this.emit("update", this);
    }
    _onFaceResize(face) {
        $410bf5be1058f2d9$export$44fad16177a84e21._validateFaces(this.faces);
        this.resize(face.width, face.height, face.resolution);
    }
    static _validateFaces(faces) {
        if (!faces.right || !faces.left || !faces.top || !faces.bottom || !faces.front || !faces.back) throw new Error("[CubeTextureSource] Requires { left, right, top, bottom, front, back } faces.");
        const first = faces.right;
        const expectedPixelWidth = first.pixelWidth;
        const expectedPixelHeight = first.pixelHeight;
        const expectedFormat = first.format;
        const expectedAlphaMode = first.alphaMode;
        const expectedResolution = first.resolution;
        for (const key of Object.keys(faces)){
            const face = faces[key];
            if (face.pixelWidth !== expectedPixelWidth || face.pixelHeight !== expectedPixelHeight) throw new Error(`[CubeTextureSource] Face '${String(key)}' has a different size. All faces must match.`);
            if (face.format !== expectedFormat) throw new Error(`[CubeTextureSource] Face '${String(key)}' has a different format. All faces must match.`);
            if (face.alphaMode !== expectedAlphaMode) throw new Error(`[CubeTextureSource] Face '${String(key)}' has a different alphaMode. All faces must match.`);
            if (face.resolution !== expectedResolution) throw new Error(`[CubeTextureSource] Face '${String(key)}' has a different resolution. All faces must match.`);
        }
    }
}



var $4iNSL = parcelRequire("4iNSL");
"use strict";
const $aa195e943239a125$var$faceKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "front",
    "back"
];
function $aa195e943239a125$var$getCubeCacheKey(faceIds, options) {
    const opts = options ? {
        ...options
    } : {};
    delete opts.label;
    const optKeys = Object.keys(opts).sort();
    const optPart = optKeys.length ? `|${optKeys.map((k)=>`${k}=${String(opts[k])}`).join("&")}` : "";
    const facesPart = $aa195e943239a125$var$faceKeys.map((k)=>faceIds[k]).join(",");
    return `cube:${facesPart}${optPart}`;
}
class $aa195e943239a125$export$ee2e5a18258a4049 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(options){
        super();
        /** unique id for this cube texture */ this.uid = (0, $1bMtF.uid)("cubeTexture");
        /** Has the texture been destroyed? */ this.destroyed = false;
        const { label: label, source: source } = options;
        this.label = label;
        this.source = source;
        this.source.label = this.label ?? this.source.label;
    }
    static from(options, skipCache = false) {
        if (options instanceof (0, $410bf5be1058f2d9$export$44fad16177a84e21)) return new $aa195e943239a125$export$ee2e5a18258a4049({
            source: options
        });
        const { faces: faces, ...sourceOptions } = options;
        let cacheKey = null;
        const isFaceIds = $aa195e943239a125$var$faceKeys.every((key)=>typeof faces[key] === "string");
        if (!skipCache && isFaceIds) {
            cacheKey = $aa195e943239a125$var$getCubeCacheKey(faces, sourceOptions);
            if ((0, $h3cT0.Cache).has(cacheKey)) return (0, $h3cT0.Cache).get(cacheKey);
        }
        const toTexture = (input)=>{
            if (input.isTexture) return input;
            return (0, $4iNSL.Texture).from(input);
        };
        const faceSources = {};
        for (const key of $aa195e943239a125$var$faceKeys)faceSources[key] = toTexture(faces[key]).source;
        const cubeTexture = new $aa195e943239a125$export$ee2e5a18258a4049({
            source: new (0, $410bf5be1058f2d9$export$44fad16177a84e21)({
                ...sourceOptions,
                faces: faceSources
            }),
            label: sourceOptions.label
        });
        if (cacheKey) {
            (0, $h3cT0.Cache).set(cacheKey, cubeTexture);
            cubeTexture.once("destroy", ()=>{
                if ((0, $h3cT0.Cache).has(cacheKey)) (0, $h3cT0.Cache).remove(cacheKey);
            });
        }
        return cubeTexture;
    }
    /**
   * Destroy this CubeTexture.
   * @param destroySource - If true, destroys the underlying {@link CubeTextureSource}.
   */ destroy(destroySource = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        if (destroySource) this.source.destroy();
        this.emit("destroy", this);
        this.removeAllListeners();
    }
}



var $9JGFp = parcelRequire("9JGFp");

var $jH853 = parcelRequire("jH853");

var $hk1vi = parcelRequire("hk1vi");

var $egYi0 = parcelRequire("egYi0");



var $2rkWb = parcelRequire("2rkWb");

var $h62oc = parcelRequire("h62oc");

var $bfcaK = parcelRequire("bfcaK");

var $gmQ4R = parcelRequire("gmQ4R");
"use strict";
const $16b1fac55f292e16$var$placeholderGl = /* @__PURE__ */ Object.create(null);
const $16b1fac55f292e16$var$placeholderGpu = /* @__PURE__ */ Object.create(null);
function $16b1fac55f292e16$var$getPlaceholder(renderer) {
    var _a;
    if (renderer.type === (0, $bfcaK.RendererType).WEBGPU) {
        $16b1fac55f292e16$var$placeholderGpu[_a = renderer.uid] || ($16b1fac55f292e16$var$placeholderGpu[_a] = renderer.gpu.device.createTexture({
            label: "ExternalSource placeholder",
            size: {
                width: 1,
                height: 1
            },
            format: "rgba8unorm",
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST
        }));
        return $16b1fac55f292e16$var$placeholderGpu[renderer.uid];
    }
    if (!$16b1fac55f292e16$var$placeholderGl[renderer.uid]) {
        const gl = renderer.gl;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        $16b1fac55f292e16$var$placeholderGl[renderer.uid] = texture;
    }
    return $16b1fac55f292e16$var$placeholderGl[renderer.uid];
}
class $16b1fac55f292e16$export$ffc19e40a21f08eb extends (0, $gmQ4R.TextureSource) {
    constructor({ resource: resource, renderer: renderer, label: label, width: width, height: height }){
        resource || (resource = $16b1fac55f292e16$var$getPlaceholder(renderer));
        width || (width = width ?? resource?.width ?? 1);
        height || (height = height ?? resource?.height ?? 1);
        super({
            resource: resource,
            width: width,
            height: height,
            label: label,
            // External textures shouldn't be garbage collected - the external library owns them
            autoGarbageCollect: false
        });
        this._renderer = renderer;
        this._initGpuData(resource);
    }
    /**
   * Test if a resource is a valid external GPU texture.
   * @param resource - The resource to test
   * @returns True if the resource is a GPUTexture or WebGLTexture
   */ static test(resource) {
        return globalThis.GPUTexture && resource instanceof GPUTexture || globalThis.WebGLTexture && resource instanceof WebGLTexture;
    }
    _validateTexture(resource) {
        const renderer = this._renderer;
        const isWebGPU = !!renderer.gpu;
        const isGPUTexture = globalThis.GPUTexture && resource instanceof GPUTexture;
        const isWebGLTexture = globalThis.WebGLTexture && resource instanceof WebGLTexture;
        if (isWebGPU && isWebGLTexture) throw new Error("Cannot use WebGLTexture with a WebGPU renderer");
        if (!isWebGPU && isGPUTexture) throw new Error("Cannot use GPUTexture with a WebGL renderer");
        if (!isWebGPU) {
            const gl = renderer.gl;
            if (gl && !gl.isTexture(resource)) throw new Error("WebGLTexture does not belong to this renderer's WebGL context");
        }
    }
    _initGpuData(resource) {
        const renderer = this._renderer;
        this._validateTexture(resource);
        if (renderer.gpu) this._gpuData[renderer.uid] = new (0, $h62oc.GPUTextureGpuData)(resource);
        else this._gpuData[renderer.uid] = new (0, $2rkWb.GlTexture)(resource);
    }
    /**
   * Update the external GPU texture reference.
   * Call this when the external library provides a new texture.
   * @param gpuTexture - The new GPU texture
   * @param width - New width (required for WebGLTexture, auto-detected for GPUTexture)
   * @param height - New height (required for WebGLTexture, auto-detected for GPUTexture)
   */ updateGPUTexture(gpuTexture, width, height) {
        const renderer = this._renderer;
        const gpuData = this._gpuData[renderer.uid];
        this.resource = gpuTexture;
        if (renderer.gpu) {
            this._validateTexture(gpuTexture);
            const data = gpuData;
            if (data.gpuTexture !== gpuTexture) {
                data.gpuTexture = gpuTexture;
                data.textureView = null;
                const textureSystem = renderer.texture;
                if (textureSystem?._bindGroupHash) textureSystem._bindGroupHash[this.uid] = null;
            }
            const newWidth = width ?? gpuTexture.width;
            const newHeight = height ?? gpuTexture.height;
            this.resize(newWidth, newHeight);
        } else {
            this._validateTexture(gpuTexture);
            const data = gpuData;
            data.texture = gpuTexture;
            if (width !== void 0 && height !== void 0) this.resize(width, height);
        }
        this.emit("update", this);
    }
    destroy() {
        const renderer = this._renderer;
        delete this._gpuData[renderer.uid];
        super.destroy();
    }
}



var $cVYNB = parcelRequire("cVYNB");

var $gmQ4R = parcelRequire("gmQ4R");

var $dvpBJ = parcelRequire("dvpBJ");

var $4iNSL = parcelRequire("4iNSL");

var $715l6 = parcelRequire("715l6");

var $eVE7u = parcelRequire("eVE7u");

var $5NyEC = parcelRequire("5NyEC");

var $c8piJ = parcelRequire("c8piJ");

var $lHrjL = parcelRequire("lHrjL");
"use strict";
class $95db4b95deb39174$export$4efdf5c542d7171e {
    constructor(){
        this.x0 = 0;
        this.y0 = 0;
        this.x1 = 1;
        this.y1 = 0;
        this.x2 = 1;
        this.y2 = 1;
        this.x3 = 0;
        this.y3 = 1;
        this.uvsFloat32 = new Float32Array(8);
    }
    /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link groupD8}
   */ set(frame, baseFrame, rotate) {
        const tw = baseFrame.width;
        const th = baseFrame.height;
        if (rotate) {
            const w2 = frame.width / 2 / tw;
            const h2 = frame.height / 2 / th;
            const cX = frame.x / tw + w2;
            const cY = frame.y / th + h2;
            rotate = (0, $lHrjL.groupD8).add(rotate, (0, $lHrjL.groupD8).NW);
            this.x0 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            this.y0 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            this.x1 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            this.y1 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            this.x2 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            this.y2 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
            rotate = (0, $lHrjL.groupD8).add(rotate, 2);
            this.x3 = cX + w2 * (0, $lHrjL.groupD8).uX(rotate);
            this.y3 = cY + h2 * (0, $lHrjL.groupD8).uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;
            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;
            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;
            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }
        this.uvsFloat32[0] = this.x0;
        this.uvsFloat32[1] = this.y0;
        this.uvsFloat32[2] = this.x1;
        this.uvsFloat32[3] = this.y1;
        this.uvsFloat32[4] = this.x2;
        this.uvsFloat32[5] = this.y2;
        this.uvsFloat32[6] = this.x3;
        this.uvsFloat32[7] = this.y3;
    }
    toString() {
        return `[pixi.js/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
    }
}



var $5phlQ = parcelRequire("5phlQ");



var $hlucP = parcelRequire("hlucP");

var $jpjFn = parcelRequire("jpjFn");
"use strict";
function $b1ff82aba3984b26$export$50f85c246417e18(fn) {
    const fnStr = fn.toString();
    const bodyStart = fnStr.indexOf("{");
    const bodyEnd = fnStr.lastIndexOf("}");
    if (bodyStart === -1 || bodyEnd === -1) throw new Error("getFunctionBody: No body found in function definition");
    return fnStr.slice(bodyStart + 1, bodyEnd).trim();
}



var $9QtIe = parcelRequire("9QtIe");

var $bfcaK = parcelRequire("bfcaK");
var $ac40a2fe3413b26e$export$2e2bcd8739ae039 = "varying vec2 vUV;\nvarying vec4 vColor;\n\nuniform sampler2D uTexture;\n\nvoid main(void){\n    vec4 color = texture2D(uTexture, vUV) * vColor;\n    gl_FragColor = color;\n}";


var $0f262301bdbdd53a$export$2e2bcd8739ae039 = "attribute vec2 aVertex;\nattribute vec2 aUV;\nattribute vec4 aColor;\n\nattribute vec2 aPosition;\nattribute float aRotation;\n\nuniform mat3 uTranslationMatrix;\nuniform float uRound;\nuniform vec2 uResolution;\nuniform vec4 uColor;\n\nvarying vec2 vUV;\nvarying vec4 vColor;\n\nvec2 roundPixels(vec2 position, vec2 targetSize)\n{       \n    return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;\n}\n\nvoid main(void){\n    float cosRotation = cos(aRotation);\n    float sinRotation = sin(aRotation);\n    float x = aVertex.x * cosRotation - aVertex.y * sinRotation;\n    float y = aVertex.x * sinRotation + aVertex.y * cosRotation;\n\n    vec2 v = vec2(x, y);\n    v = v + aPosition;\n\n    gl_Position = vec4((uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    if(uRound == 1.0)\n    {\n        gl_Position.xy = roundPixels(gl_Position.xy, uResolution);\n    }\n\n    vUV = aUV;\n    vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uColor;\n}\n";


var $f43e622d8c5f5566$export$2e2bcd8739ae039 = "\nstruct ParticleUniforms {\n  uTranslationMatrix:mat3x3<f32>,\n  uColor:vec4<f32>,\n  uRound:f32,\n  uResolution:vec2<f32>,\n};\n\nfn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>\n{\n  return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;\n}\n\n@group(0) @binding(0) var<uniform> uniforms: ParticleUniforms;\n\n@group(1) @binding(0) var uTexture: texture_2d<f32>;\n@group(1) @binding(1) var uSampler : sampler;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n    @location(1) color : vec4<f32>,\n  };\n@vertex\nfn mainVertex(\n  @location(0) aVertex: vec2<f32>,\n  @location(1) aPosition: vec2<f32>,\n  @location(2) aUV: vec2<f32>,\n  @location(3) aColor: vec4<f32>,\n  @location(4) aRotation: f32,\n) -> VSOutput {\n  \n   let v = vec2(\n       aVertex.x * cos(aRotation) - aVertex.y * sin(aRotation),\n       aVertex.x * sin(aRotation) + aVertex.y * cos(aRotation)\n   ) + aPosition;\n\n   var position = vec4((uniforms.uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n   if(uniforms.uRound == 1.0) {\n       position = vec4(roundPixels(position.xy, uniforms.uResolution), position.zw);\n   }\n\n    let vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uniforms.uColor;\n\n  return VSOutput(\n   position,\n   aUV,\n   vColor,\n  );\n}\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n  @location(1) color: vec4<f32>,\n  @builtin(position) position: vec4<f32>,\n) -> @location(0) vec4<f32> {\n\n    var sample = textureSample(uTexture, uSampler, uv) * color;\n   \n    return sample;\n}";



var $esrbs = parcelRequire("esrbs");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
function $510c26f251d4332c$export$ec3cb2102fa5391a(target, bounds) {
    (0, $6LhOA.deprecation)("8.7.0", "Use container.getFastGlobalBounds() instead");
    return target.getFastGlobalBounds(true, bounds);
}



var $dJAmK = parcelRequire("dJAmK");

var $7pBMy = parcelRequire("7pBMy");

var $iqHv9 = parcelRequire("iqHv9");

var $gMrCM = parcelRequire("gMrCM");

var $b68Xy = parcelRequire("b68Xy");

var $cSba6 = parcelRequire("cSba6");

var $iKlbs = parcelRequire("iKlbs");

var $R6gKP = parcelRequire("R6gKP");

var $6BXvq = parcelRequire("6BXvq");

var $7sEYV = parcelRequire("7sEYV");

var $3qOui = parcelRequire("3qOui");

var $lDlzV = parcelRequire("lDlzV");

var $cN0Qi = parcelRequire("cN0Qi");

var $1ylTw = parcelRequire("1ylTw");

var $5yHc8 = parcelRequire("5yHc8");

var $2vcTO = parcelRequire("2vcTO");

var $1SYU5 = parcelRequire("1SYU5");

var $9FmI1 = parcelRequire("9FmI1");
"use strict";
class $f6986ed9f6d390ba$export$b0ee01c674e36513 extends (0, $9FmI1.ViewContainer) {
    /**
   * @param options - The options for the container.
   */ constructor(options){
        if (typeof options === "function") options = {
            render: options
        };
        const { render: render, ...rest } = options;
        super({
            label: "RenderContainer",
            ...rest
        });
        /** @internal */ this.renderPipeId = "customRender";
        /** @internal */ this.batched = false;
        if (render) this.render = render;
        this.containsPoint = options.containsPoint ?? (()=>false);
        this.addBounds = options.addBounds ?? (()=>false);
    }
    /** @private */ updateBounds() {
        this._bounds.clear();
        this.addBounds(this._bounds);
    }
    /**
   * An overridable function that can be used to render the object using the current renderer.
   * @param _renderer - The current renderer
   */ render(_renderer) {}
}



var $k0xIU = parcelRequire("k0xIU");

var $lGOq2 = parcelRequire("lGOq2");

var $kixfr = parcelRequire("kixfr");

var $7lfy2 = parcelRequire("7lfy2");

var $6h57y = parcelRequire("6h57y");

var $6IFWH = parcelRequire("6IFWH");

var $6LhOA = parcelRequire("6LhOA");
"use strict";
function $708f1b1a5870cc2f$export$d0ce49decf05e61d(container, instructionSet, rendererOrPipes) {
    (0, $6LhOA.deprecation)("8.7.0", "Please use container.collectRenderables instead.");
    const renderer = rendererOrPipes.renderPipes ? rendererOrPipes : rendererOrPipes.batch.renderer;
    return container.collectRenderables(instructionSet, renderer, null);
}



var $cebhF = parcelRequire("cebhF");

var $7QtNh = parcelRequire("7QtNh");

var $25Amh = parcelRequire("25Amh");

var $5nS5O = parcelRequire("5nS5O");
"use strict";
function $49c91a129609eb76$export$4dde168b0f6e77cb(lt, container) {
    const scale = container._scale;
    const pivot = container._pivot;
    const position = container._position;
    const sx = scale._x;
    const sy = scale._y;
    const px = pivot._x;
    const py = pivot._y;
    lt.a = container._cx * sx;
    lt.b = container._sx * sx;
    lt.c = container._cy * sy;
    lt.d = container._sy * sy;
    lt.tx = position._x - (px * lt.a + py * lt.c);
    lt.ty = position._y - (px * lt.b + py * lt.d);
}



var $eDAcM = parcelRequire("eDAcM");
"use strict";
function $38059b353e48819d$export$ee945abfaa59934a(local, parent, world) {
    const lta = local.a;
    const ltb = local.b;
    const ltc = local.c;
    const ltd = local.d;
    const lttx = local.tx;
    const ltty = local.ty;
    const pta = parent.a;
    const ptb = parent.b;
    const ptc = parent.c;
    const ptd = parent.d;
    world.a = lta * pta + ltb * ptc;
    world.b = lta * ptb + ltb * ptd;
    world.c = ltc * pta + ltd * ptc;
    world.d = ltc * ptb + ltd * ptd;
    world.tx = lttx * pta + ltty * ptc + parent.tx;
    world.ty = lttx * ptb + ltty * ptd + parent.ty;
}



var $38HAG = parcelRequire("38HAG");

var $1sJn2 = parcelRequire("1sJn2");

var $761XJ = parcelRequire("761XJ");

var $2gsFh = parcelRequire("2gsFh");

var $dUCZ0 = parcelRequire("dUCZ0");

var $id0ju = parcelRequire("id0ju");

var $j3dtG = parcelRequire("j3dtG");

var $arDaU = parcelRequire("arDaU");

var $kpMZU = parcelRequire("kpMZU");

var $bB0KA = parcelRequire("bB0KA");

var $dP0DE = parcelRequire("dP0DE");

var $ipEz7 = parcelRequire("ipEz7");

var $4VZYJ = parcelRequire("4VZYJ");

var $7p3VJ = parcelRequire("7p3VJ");

var $9kFG0 = parcelRequire("9kFG0");

var $iS417 = parcelRequire("iS417");

var $ctmiq = parcelRequire("ctmiq");

var $6F4Y7 = parcelRequire("6F4Y7");

var $dWsyQ = parcelRequire("dWsyQ");

var $6yC9w = parcelRequire("6yC9w");

var $hkzHY = parcelRequire("hkzHY");

var $bySfk = parcelRequire("bySfk");

var $iNnKd = parcelRequire("iNnKd");

var $7kRkZ = parcelRequire("7kRkZ");

var $aDQkb = parcelRequire("aDQkb");

var $cFO33 = parcelRequire("cFO33");

var $1roql = parcelRequire("1roql");

var $2NHgj = parcelRequire("2NHgj");

var $4uUVY = parcelRequire("4uUVY");

var $5QkPm = parcelRequire("5QkPm");

var $fUc8w = parcelRequire("fUc8w");

var $2eMBY = parcelRequire("2eMBY");

var $1crrD = parcelRequire("1crrD");

var $dfSnn = parcelRequire("dfSnn");

var $5dXd8 = parcelRequire("5dXd8");

var $2gf0f = parcelRequire("2gf0f");

var $9IHrN = parcelRequire("9IHrN");

var $j9D8w = parcelRequire("j9D8w");

var $6WSe9 = parcelRequire("6WSe9");

var $iWOpI = parcelRequire("iWOpI");


var $1roql = parcelRequire("1roql");

var $j9D8w = parcelRequire("j9D8w");
"use strict";
function $11b737b4f4cd6617$export$d969b6f872d1065e(options) {
    if (options instanceof (0, $1roql.GraphicsPath)) options = {
        path: options,
        textureMatrix: null,
        out: null
    };
    const vertices = [];
    const uvs = [];
    const indices = [];
    const shapePath = options.path.shapePath;
    const textureMatrix = options.textureMatrix;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix })=>{
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        const points = [];
        const build = (0, $j9D8w.shapeBuilders)[shape.type];
        build.build(shape, points);
        if (matrix) (0, $iWOpI.transformVertices)(points, matrix);
        build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        const uvsOffset = uvs.length / 2;
        if (textureMatrix) {
            if (matrix) textureMatrix.append(matrix.clone().invert());
            (0, $6WSe9.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $6WSe9.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
    });
    const out = options.out;
    if (out) {
        out.positions = new Float32Array(vertices);
        out.uvs = new Float32Array(uvs);
        out.indices = new Uint32Array(indices);
        return out;
    }
    const geometry = new (0, $b964c6f5532210d5$export$8d075a36a73d54bc)({
        positions: new Float32Array(vertices),
        uvs: new Float32Array(uvs),
        indices: new Uint32Array(indices)
    });
    return geometry;
}



var $bapDA = parcelRequire("bapDA");

var $kOp0T = parcelRequire("kOp0T");

var $1g5QY = parcelRequire("1g5QY");

var $lToNE = parcelRequire("lToNE");

var $1RpxL = parcelRequire("1RpxL");

var $2vcTO = parcelRequire("2vcTO");
"use strict";
const $df6a549e19fc436b$var$_RenderLayer = class _RenderLayer extends (0, $2vcTO.Container) {
    /**
   * Creates a new RenderLayer instance
   * @param options - Configuration options for the RenderLayer
   * @param {boolean} [options.sortableChildren=false] - If true, layer children will be automatically sorted each render
   * @param {Function} [options.sortFunction] - Custom function to sort layer children. Default sorts by zIndex
   */ constructor(options = {}){
        options = {
            ..._RenderLayer.defaultOptions,
            ...options
        };
        super();
        /**
     * The list of objects that this layer is responsible for rendering. Objects in this list maintain
     * their original parent in the scene graph but are rendered as part of this layer.
     * @example
     * ```ts
     * const layer = new RenderLayer();
     * const sprite = new Sprite(texture);
     *
     * // Add sprite to scene graph for transforms
     * container.addChild(sprite);
     *
     * // Add to layer for render order control
     * layer.attach(sprite);
     * console.log(layer.renderLayerChildren.length); // 1
     *
     * // Access objects in the layer
     * layer.renderLayerChildren.forEach(child => {
     *     console.log('Layer child:', child);
     * });
     *
     * // Check if object is in layer
     * const isInLayer = layer.renderLayerChildren.includes(sprite);
     *
     * // Clear all objects from layer
     * layer.detachAll();
     * console.log(layer.renderLayerChildren.length); // 0
     * ```
     * @readonly
     * @see {@link RenderLayer#attach} For adding objects to the layer
     * @see {@link RenderLayer#detach} For removing objects from the layer
     * @see {@link RenderLayer#detachAll} For removing all objects from the layer
     */ this.renderLayerChildren = [];
        this.sortableChildren = options.sortableChildren;
        this.sortFunction = options.sortFunction;
    }
    /**
   * Adds one or more Containers to this render layer. The Containers will be rendered as part of this layer
   * while maintaining their original parent in the scene graph.
   *
   * If the Container already belongs to a layer, it will be removed from the old layer before being added to this one.
   * @example
   * ```ts
   * const layer = new RenderLayer();
   * const container = new Container();
   * const sprite1 = new Sprite(texture1);
   * const sprite2 = new Sprite(texture2);
   *
   * // Add sprites to scene graph for transforms
   * container.addChild(sprite1, sprite2);
   *
   * // Add sprites to layer for render order control
   * layer.attach(sprite1, sprite2);
   *
   * // Add single sprite with type checking
   * const typedSprite = layer.attach<Sprite>(new Sprite(texture3));
   * typedSprite.tint = 'red';
   *
   * // Automatically removes from previous layer if needed
   * const otherLayer = new RenderLayer();
   * otherLayer.attach(sprite1); // Removes from previous layer
   * ```
   * @param children - The Container(s) to add to this layer. Can be any Container or array of Containers.
   * @returns The first child that was added, for method chaining
   * @see {@link RenderLayer#detach} For removing objects from the layer
   * @see {@link RenderLayer#detachAll} For removing all objects from the layer
   * @see {@link Container#addChild} For adding to scene graph hierarchy
   */ attach(...children) {
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.parentRenderLayer) {
                if (child.parentRenderLayer === this) continue;
                child.parentRenderLayer.detach(child);
            }
            this.renderLayerChildren.push(child);
            child.parentRenderLayer = this;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.structureDidChange = true;
        }
        return children[0];
    }
    /**
   * Removes one or more Containers from this render layer. The Containers will maintain their
   * original parent in the scene graph but will no longer be rendered as part of this layer.
   * @example
   * ```ts
   * const layer = new RenderLayer();
   * const container = new Container();
   * const sprite1 = new Sprite(texture1);
   * const sprite2 = new Sprite(texture2);
   *
   * // Add sprites to scene graph and layer
   * container.addChild(sprite1, sprite2);
   * layer.attach(sprite1, sprite2);
   *
   * // Remove single sprite from layer
   * layer.detach(sprite1);
   * // sprite1 is still child of container but not rendered in layer
   *
   * // Remove multiple sprites at once
   * const otherLayer = new RenderLayer();
   * otherLayer.attach(sprite3, sprite4);
   * otherLayer.detach(sprite3, sprite4);
   *
   * // Type-safe detachment
   * const typedSprite = layer.detach<Sprite>(spriteInLayer);
   * typedSprite.texture = newTexture; // TypeScript knows this is a Sprite
   * ```
   * @param children - The Container(s) to remove from this layer
   * @returns The first child that was removed, for method chaining
   * @see {@link RenderLayer#attach} For adding objects to the layer
   * @see {@link RenderLayer#detachAll} For removing all objects from the layer
   * @see {@link Container#removeChild} For removing from scene graph hierarchy
   */ detach(...children) {
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            const index = this.renderLayerChildren.indexOf(child);
            if (index !== -1) this.renderLayerChildren.splice(index, 1);
            child.parentRenderLayer = null;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.structureDidChange = true;
        }
        return children[0];
    }
    /**
   * Removes all objects from this render layer. Objects will maintain their
   * original parent in the scene graph but will no longer be rendered as part of this layer.
   * @example
   * ```ts
   * const layer = new RenderLayer();
   * const container = new Container();
   *
   * // Add multiple sprites to scene graph and layer
   * const sprites = [
   *     new Sprite(texture1),
   *     new Sprite(texture2),
   *     new Sprite(texture3)
   * ];
   *
   * container.addChild(...sprites);  // Add to scene graph
   * layer.attach(...sprites);       // Add to render layer
   *
   * // Later, remove all sprites from layer at once
   * layer.detachAll();
   * console.log(layer.renderLayerChildren.length); // 0
   * console.log(container.children.length);        // 3 (still in scene graph)
   * ```
   * @returns The RenderLayer instance for method chaining
   * @see {@link RenderLayer#attach} For adding objects to the layer
   * @see {@link RenderLayer#detach} For removing individual objects
   * @see {@link Container#removeChildren} For removing from scene graph
   */ detachAll() {
        const layerChildren = this.renderLayerChildren;
        for(let i = 0; i < layerChildren.length; i++)layerChildren[i].parentRenderLayer = null;
        this.renderLayerChildren.length = 0;
    }
    /**
   * Collects renderables for this layer and its children.
   * This method is called by the renderer to gather all objects that should be rendered in this layer.
   * @param instructionSet - The set of instructions to collect renderables into.
   * @param renderer - The renderer that is collecting renderables.
   * @param _currentLayer - The current render layer being processed.
   * @internal
   */ collectRenderables(instructionSet, renderer, _currentLayer) {
        const layerChildren = this.renderLayerChildren;
        const length = layerChildren.length;
        if (this.sortableChildren) this.sortRenderLayerChildren();
        for(let i = 0; i < length; i++){
            if (!layerChildren[i].parent) (0, $1RpxL.warn)("Container must be added to both layer and scene graph. Layers only handle render order - the scene graph is required for transforms (addChild)", layerChildren[i]);
            layerChildren[i].collectRenderables(instructionSet, renderer, this);
        }
    }
    /**
   * Sort the layer's children using the defined sort function. This method allows manual sorting
   * of layer children and is automatically called during rendering if sortableChildren is true.
   * @example
   * ```ts
   * const layer = new RenderLayer();
   *
   * // Add multiple sprites at different depths
   * const sprite1 = new Sprite(texture);
   * const sprite2 = new Sprite(texture);
   * const sprite3 = new Sprite(texture);
   *
   * sprite1.zIndex = 3;
   * sprite2.zIndex = 1;
   * sprite3.zIndex = 2;
   *
   * layer.attach(sprite1, sprite2, sprite3);
   *
   * // Manual sorting with default zIndex sort
   * layer.sortRenderLayerChildren();
   * // Order is now: sprite2 (1), sprite3 (2), sprite1 (3)
   *
   * // Custom sort by y position
   * layer.sortFunction = (a, b) => a.y - b.y;
   * layer.sortRenderLayerChildren();
   *
   * // Automatic sorting
   * layer.sortableChildren = true; // Will sort each render
   * ```
   * @returns The RenderLayer instance for method chaining
   * @see {@link RenderLayer#sortableChildren} For enabling automatic sorting
   * @see {@link RenderLayer#sortFunction} For customizing the sort logic
   */ sortRenderLayerChildren() {
        this.renderLayerChildren.sort(this.sortFunction);
    }
    /**
   * Recursively calculates the global bounds of this RenderLayer and its children.
   * @param factorRenderLayers
   * @param bounds
   * @param _currentLayer
   * @internal
   */ _getGlobalBoundsRecursive(factorRenderLayers, bounds, _currentLayer) {
        if (!factorRenderLayers) return;
        const children = this.renderLayerChildren;
        for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(true, bounds, this);
    }
    /**
   * @inheritdoc
   * @internal
   */ getFastGlobalBounds(factorRenderLayers, bounds) {
        return super.getFastGlobalBounds(factorRenderLayers, bounds);
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error. Please use `RenderLayer.attach()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChild(..._children) {
        throw new Error("RenderLayer.addChild() is not available. Please use RenderLayer.attach()");
    }
    /**
   * This method is not available in RenderLayer.
   * Calling this method will throw an error. Please use `RenderLayer.detach()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChild(..._children) {
        throw new Error("RenderLayer.removeChild() is not available. Please use RenderLayer.detach()");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error. Please use `RenderLayer.detach()` instead.
   * @param {number} [_beginIndex]
   * @param {number} [_endIndex]
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildren(_beginIndex, _endIndex) {
        throw new Error("RenderLayer.removeChildren() is not available. Please use RenderLayer.detach()");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildAt(_index) {
        throw new Error("RenderLayer.removeChildAt() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildAt(_index) {
        throw new Error("RenderLayer.getChildAt() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {Container} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ setChildIndex(_child, _index) {
        throw new Error("RenderLayer.setChildIndex() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {Container} _child
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildIndex(_child) {
        throw new Error("RenderLayer.getChildIndex() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {Container} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChildAt(_child, _index) {
        throw new Error("RenderLayer.addChildAt() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param {Container} _child
   * @param {Container} _child2
   * @ignore
   */ swapChildren(_child, _child2) {
        throw new Error("RenderLayer.swapChildren() is not available");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChild(..._child) {
        throw new Error("RenderLayer.reparentChild() is not available with the render layer");
    }
    /**
   * This method is not available in RenderLayer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @param _index - The index to reparent the child to
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChildAt(_child, _index) {
        throw new Error("RenderLayer.reparentChildAt() is not available with the render layer");
    }
};
/**
 * Default options for RenderLayer instances. These options control the sorting behavior
 * of objects within the render layer.
 * @example
 * ```ts
 * // Create a custom render layer with modified default options
 * RenderLayer.defaultOptions = {
 *     sortableChildren: true,
 *     sortFunction: (a, b) => a.y - b.y // Sort by vertical position
 * };
 *
 * // All new render layers will use these defaults
 * const layer1 = new RenderLayer();
 * // layer1 will have sortableChildren = true
 * ```
 * @property {boolean} sortableChildren -
 * @property {Function} sortFunction -
 * @see {@link RenderLayer} For the main render layer class
 * @see {@link Container#zIndex} For the default sort property
 * @see {@link RenderLayer#sortRenderLayerChildren} For manual sorting
 */ $df6a549e19fc436b$var$_RenderLayer.defaultOptions = {
    /** If true, layer children will be automatically sorted each render. Default is false. */ sortableChildren: false,
    /**
   * Function used to sort layer children.
   * Default sorts by zIndex. Accepts two Container objects and returns
   * a number indicating their relative order.
   * @param a - First container to compare
   * @param b - Second container to compare
   * @returns Negative if a should render before b, positive if b should render before a
   */ sortFunction: (a, b)=>a.zIndex - b.zIndex
};
let $df6a549e19fc436b$export$cd6265b069888eed = $df6a549e19fc436b$var$_RenderLayer;



var $4iNSL = parcelRequire("4iNSL");

var $cebhF = parcelRequire("cebhF");


var $6LhOA = parcelRequire("6LhOA");

"use strict";
const $a8d07342c65f7a94$var$_PlaneGeometry = class _PlaneGeometry extends (0, $b964c6f5532210d5$export$8d075a36a73d54bc) {
    constructor(...args){
        super({});
        let options = args[0] ?? {};
        if (typeof options === "number") {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead");
            options = {
                width: options,
                height: args[1],
                verticesX: args[2],
                verticesY: args[3]
            };
        }
        this.build(options);
    }
    /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */ build(options) {
        options = {
            ..._PlaneGeometry.defaultOptions,
            ...options
        };
        this.verticesX = this.verticesX ?? options.verticesX;
        this.verticesY = this.verticesY ?? options.verticesY;
        this.width = this.width ?? options.width;
        this.height = this.height ?? options.height;
        const total = this.verticesX * this.verticesY;
        const verts = [];
        const uvs = [];
        const indices = [];
        const verticesX = this.verticesX - 1;
        const verticesY = this.verticesY - 1;
        const sizeX = this.width / verticesX;
        const sizeY = this.height / verticesY;
        for(let i = 0; i < total; i++){
            const x = i % this.verticesX;
            const y = i / this.verticesX | 0;
            verts.push(x * sizeX, y * sizeY);
            uvs.push(x / verticesX, y / verticesY);
        }
        const totalSub = verticesX * verticesY;
        for(let i = 0; i < totalSub; i++){
            const xpos = i % verticesX;
            const ypos = i / verticesX | 0;
            const value = ypos * this.verticesX + xpos;
            const value2 = ypos * this.verticesX + xpos + 1;
            const value3 = (ypos + 1) * this.verticesX + xpos;
            const value4 = (ypos + 1) * this.verticesX + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts);
        this.buffers[1].data = new Float32Array(uvs);
        this.indexBuffer.data = new Uint32Array(indices);
        this.buffers[0].update();
        this.buffers[1].update();
        this.indexBuffer.update();
    }
};
$a8d07342c65f7a94$var$_PlaneGeometry.defaultOptions = {
    width: 100,
    height: 100,
    verticesX: 10,
    verticesY: 10
};
let $a8d07342c65f7a94$export$967d831af31f69ce = $a8d07342c65f7a94$var$_PlaneGeometry;


"use strict";
function $07f415105e910815$export$3e2874e086963700(width, height, geometry, transformationMatrix) {
    const buffer = geometry.buffers[0];
    const vertices = buffer.data;
    const { verticesX: verticesX, verticesY: verticesY } = geometry;
    const sizeX = width / (verticesX - 1);
    const sizeY = height / (verticesY - 1);
    let index = 0;
    const a00 = transformationMatrix[0];
    const a01 = transformationMatrix[1];
    const a02 = transformationMatrix[2];
    const a10 = transformationMatrix[3];
    const a11 = transformationMatrix[4];
    const a12 = transformationMatrix[5];
    const a20 = transformationMatrix[6];
    const a21 = transformationMatrix[7];
    const a22 = transformationMatrix[8];
    for(let i = 0; i < vertices.length; i += 2){
        const x = index % verticesX * sizeX;
        const y = (index / verticesX | 0) * sizeY;
        const newX = a00 * x + a01 * y + a02;
        const newY = a10 * x + a11 * y + a12;
        const w = a20 * x + a21 * y + a22;
        vertices[i] = newX / w;
        vertices[i + 1] = newY / w;
        index++;
    }
    buffer.update();
}


"use strict";
function $e871c9741565c5be$var$computeAdjugate(out, matrix) {
    const a00 = matrix[0];
    const a01 = matrix[1];
    const a02 = matrix[2];
    const a10 = matrix[3];
    const a11 = matrix[4];
    const a12 = matrix[5];
    const a20 = matrix[6];
    const a21 = matrix[7];
    const a22 = matrix[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $e871c9741565c5be$var$multiplyMatrix3x3(out, a, b) {
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a10 = a[3];
    const a11 = a[4];
    const a12 = a[5];
    const a20 = a[6];
    const a21 = a[7];
    const a22 = a[8];
    const b00 = b[0];
    const b01 = b[1];
    const b02 = b[2];
    const b10 = b[3];
    const b11 = b[4];
    const b12 = b[5];
    const b20 = b[6];
    const b21 = b[7];
    const b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $e871c9741565c5be$var$multiplyMatrixAndVector(out, m, v) {
    const x = v[0];
    const y = v[1];
    const z = v[2];
    out[0] = m[0] * x + m[1] * y + m[2] * z;
    out[1] = m[3] * x + m[4] * y + m[5] * z;
    out[2] = m[6] * x + m[7] * y + m[8] * z;
    return out;
}
const $e871c9741565c5be$var$tempMatrix = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
const $e871c9741565c5be$var$tempVec = [
    0,
    0,
    0
];
const $e871c9741565c5be$var$tempVec2 = [
    0,
    0,
    0
];
function $e871c9741565c5be$var$generateBasisToPointsMatrix(out, x1, y1, x2, y2, x3, y3, x4, y4) {
    const m = $e871c9741565c5be$var$tempMatrix;
    m[0] = x1;
    m[1] = x2;
    m[2] = x3;
    m[3] = y1;
    m[4] = y2;
    m[5] = y3;
    m[6] = 1;
    m[7] = 1;
    m[8] = 1;
    const adjugateM = $e871c9741565c5be$var$computeAdjugate(out, // reusing out as adjugateM is only used once
    m);
    $e871c9741565c5be$var$tempVec2[0] = x4;
    $e871c9741565c5be$var$tempVec2[1] = y4;
    $e871c9741565c5be$var$tempVec2[2] = 1;
    const v = $e871c9741565c5be$var$multiplyMatrixAndVector($e871c9741565c5be$var$tempVec, adjugateM, $e871c9741565c5be$var$tempVec2);
    const diagonalMatrix = out;
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = v[2];
    return $e871c9741565c5be$var$multiplyMatrix3x3(out, diagonalMatrix, m);
}
const $e871c9741565c5be$var$tempSourceMatrix = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
const $e871c9741565c5be$var$tempDestinationMatrix = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
function $e871c9741565c5be$export$f1fdc06d58105ddd(out, x1s, y1s, x1d, y1d, x2s, y2s, x2d, y2d, x3s, y3s, x3d, y3d, x4s, y4s, x4d, y4d) {
    const sourceMatrix = $e871c9741565c5be$var$generateBasisToPointsMatrix($e871c9741565c5be$var$tempSourceMatrix, x1s, y1s, x2s, y2s, x3s, y3s, x4s, y4s);
    const destinationMatrix = $e871c9741565c5be$var$generateBasisToPointsMatrix($e871c9741565c5be$var$tempDestinationMatrix, x1d, y1d, x2d, y2d, x3d, y3d, x4d, y4d);
    return $e871c9741565c5be$var$multiplyMatrix3x3(out, $e871c9741565c5be$var$computeAdjugate(sourceMatrix, sourceMatrix), destinationMatrix);
}


"use strict";
class $9557cb3bb5e61ab8$export$bfcdbe435a9b9701 extends (0, $a8d07342c65f7a94$export$967d831af31f69ce) {
    /**
   * @param options - Options to be applied to MeshPlane
   * @param options.width - The width of the plane
   * @param options.height - The height of the plane
   * @param options.verticesX - The amount of vertices on the x axis
   * @param options.verticesY - The amount of vertices on the y axis
   */ constructor(options){
        super(options);
        this._projectionMatrix = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        const { width: width, height: height } = options;
        this.corners = [
            0,
            0,
            width,
            0,
            width,
            height,
            0,
            height
        ];
    }
    /**
   * Will set the corners of the quad to the given coordinates
   * Calculating the perspective so it looks correct!
   * @param x0 - x coordinate of the first corner
   * @param y0 - y coordinate of the first corner
   * @param x1 - x coordinate of the second corner
   * @param y1 - y coordinate of the second corner
   * @param x2 - x coordinate of the third corner
   * @param y2 - y coordinate of the third corner
   * @param x3 - x coordinate of the fourth corner
   * @param y3 - y coordinate of the fourth corner
   */ setCorners(x0, y0, x1, y1, x2, y2, x3, y3) {
        const corners = this.corners;
        corners[0] = x0;
        corners[1] = y0;
        corners[2] = x1;
        corners[3] = y1;
        corners[4] = x2;
        corners[5] = y2;
        corners[6] = x3;
        corners[7] = y3;
        this.updateProjection();
    }
    /** Update the projection matrix based on the corners */ updateProjection() {
        const { width: width, height: height } = this;
        const corners = this.corners;
        const projectionMatrix = (0, $e871c9741565c5be$export$f1fdc06d58105ddd)(this._projectionMatrix, 0, 0, // top-left source
        corners[0], corners[1], // top-left dest
        width, 0, // top-right source
        corners[2], corners[3], // top-right dest
        width, height, // bottom-right source
        corners[4], corners[5], // bottom-right dest
        0, height, // bottom-left source
        corners[6], corners[7]);
        (0, $07f415105e910815$export$3e2874e086963700)(width, height, this, projectionMatrix);
    }
}


"use strict";
const $1d2406d066ca89ec$var$_PerspectiveMesh = class _PerspectiveMesh extends (0, $0ac2d29ab0a78f0e$export$e176487c05830cc5) {
    /**
   * @param options - Options to be applied to PerspectiveMesh
   */ constructor(options){
        options = {
            ..._PerspectiveMesh.defaultOptions,
            ...options
        };
        const { texture: texture, verticesX: verticesX, verticesY: verticesY, ...rest } = options;
        const planeGeometry = new (0, $9557cb3bb5e61ab8$export$bfcdbe435a9b9701)((0, $cebhF.definedProps)({
            width: texture.width,
            height: texture.height,
            verticesX: verticesX,
            verticesY: verticesY
        }));
        super((0, $cebhF.definedProps)({
            ...rest,
            geometry: planeGeometry
        }));
        this._texture = texture;
        this.geometry.setCorners(options.x0, options.y0, options.x1, options.y1, options.x2, options.y2, options.x3, options.y3);
    }
    /** Update the geometry when the texture is updated */ textureUpdated() {
        const geometry = this.geometry;
        if (!geometry) return;
        const { width: width, height: height } = this.texture;
        if (geometry.width !== width || geometry.height !== height) {
            geometry.width = width;
            geometry.height = height;
            geometry.updateProjection();
        }
    }
    set texture(value) {
        if (this._texture === value) return;
        super.texture = value;
        this.textureUpdated();
    }
    /**
   * The texture that the mesh uses for rendering. When changed, automatically updates
   * the geometry to match the new texture dimensions.
   * @example
   * ```ts
   * const mesh = new PerspectiveMesh({
   *     texture: Texture.from('initial.png'),
   * });
   *
   * // Update texture and maintain perspective
   * mesh.texture = Texture.from('newImage.png');
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link PerspectiveMesh#setCorners} For adjusting the mesh perspective
   */ get texture() {
        return this._texture;
    }
    /**
   * Sets the corners of the mesh to create a perspective transformation. The corners should be
   * specified in clockwise order starting from the top-left.
   *
   * The mesh automatically recalculates the UV coordinates to create the perspective effect.
   * @example
   * ```ts
   * const mesh = new PerspectiveMesh({
   *     texture: Texture.from('myImage.png'),
   * });
   *
   * // Create a basic perspective tilt
   * mesh.setCorners(
   *     0, 0,      // Top-left
   *     100, 20,   // Top-right (raised)
   *     100, 100,  // Bottom-right
   *     0, 80      // Bottom-left
   * );
   *
   * // Create a skewed billboard effect
   * mesh.setCorners(
   *     0, 30,     // Top-left (shifted down)
   *     128, 0,    // Top-right (raised)
   *     128, 128,  // Bottom-right
   *     0, 98      // Bottom-left (shifted up)
   * );
   *
   * // Animate perspective
   * app.ticker.add((delta) => {
   *     const time = performance.now() / 1000;
   *     const wave = Math.sin(time) * 20;
   *
   *     mesh.setCorners(
   *         0, wave,      // Top-left
   *         100, -wave,   // Top-right
   *         100, 100,     // Bottom-right
   *         0, 100        // Bottom-left
   *     );
   * });
   * ```
   * @param x0 - x-coordinate of the top-left corner
   * @param y0 - y-coordinate of the top-left corner
   * @param x1 - x-coordinate of the top-right corner
   * @param y1 - y-coordinate of the top-right corner
   * @param x2 - x-coordinate of the bottom-right corner
   * @param y2 - y-coordinate of the bottom-right corner
   * @param x3 - x-coordinate of the bottom-left corner
   * @param y3 - y-coordinate of the bottom-left corner
   * @returns The PerspectiveMesh instance for method chaining
   * @see {@link PerspectivePlaneGeometry} For the underlying geometry calculations
   */ setCorners(x0, y0, x1, y1, x2, y2, x3, y3) {
        this.geometry.setCorners(x0, y0, x1, y1, x2, y2, x3, y3);
    }
};
/**
 * Default options for creating a PerspectiveMesh instance.
 *
 * Creates a 100x100 pixel square mesh
 * with a white texture and 10x10 vertex grid for the perspective calculations.
 * @example
 * ```ts
 * // Change defaults globally
 * PerspectiveMesh.defaultOptions = {
 *     ...PerspectiveMesh.defaultOptions,
 *     verticesX: 15,
 *     verticesY: 15,
 *     // Move top edge up for default skew
 *     y0: -20,
 *     y1: -20
 * };
 * ```
 * @see {@link PerspectivePlaneOptions} For all available options
 * @see {@link PerspectivePlaneGeometry} For how vertices affect perspective quality
 */ $1d2406d066ca89ec$var$_PerspectiveMesh.defaultOptions = {
    texture: (0, $4iNSL.Texture).WHITE,
    verticesX: 10,
    verticesY: 10,
    x0: 0,
    y0: 0,
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 100,
    x3: 0,
    y3: 100
};
let $1d2406d066ca89ec$export$a90764ab6a097dae = $1d2406d066ca89ec$var$_PerspectiveMesh;






var $cebhF = parcelRequire("cebhF");


"use strict";
class $99d32c6eff6b4be4$export$738b1f28beade2a2 extends (0, $0ac2d29ab0a78f0e$export$e176487c05830cc5) {
    /**
   * @param options - Options to be applied to MeshPlane
   */ constructor(options){
        const { texture: texture, verticesX: verticesX, verticesY: verticesY, ...rest } = options;
        const planeGeometry = new (0, $a8d07342c65f7a94$export$967d831af31f69ce)((0, $cebhF.definedProps)({
            width: texture.width,
            height: texture.height,
            verticesX: verticesX,
            verticesY: verticesY
        }));
        super((0, $cebhF.definedProps)({
            ...rest,
            geometry: planeGeometry,
            texture: texture
        }));
        this.texture = texture;
        this.autoResize = true;
    }
    /**
   * Method used for overrides, to do something in case texture frame was changed.
   * Meshes based on plane can override it and change more details based on texture.
   * @internal
   */ textureUpdated() {
        const geometry = this.geometry;
        const { width: width, height: height } = this.texture;
        if (this.autoResize && (geometry.width !== width || geometry.height !== height)) {
            geometry.width = width;
            geometry.height = height;
            geometry.build({});
        }
    }
    set texture(value) {
        this._texture?.off("update", this.textureUpdated, this);
        super.texture = value;
        value.on("update", this.textureUpdated, this);
        this.textureUpdated();
    }
    /**
   * The texture that the mesh plane uses for rendering. When changed, automatically updates
   * geometry dimensions if autoResize is true and manages texture update event listeners.
   * @example
   * ```ts
   * const plane = new MeshPlane({
   *     texture: Assets.get('initial.png'),
   *     verticesX: 10,
   *     verticesY: 10
   * });
   *
   * // Update texture and auto-resize geometry
   * plane.texture = Assets.get('larger.png');
   * ```
   * @see {@link MeshPlane#autoResize} For controlling automatic geometry updates
   * @see {@link PlaneGeometry} For manual geometry updates
   * @see {@link Texture} For texture creation and management
   */ get texture() {
        return this._texture;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * meshPlane.destroy();
   * meshPlane.destroy(true);
   * meshPlane.destroy({ texture: true, textureSource: true });
   */ destroy(options) {
        this.texture.off("update", this.textureUpdated, this);
        super.destroy(options);
    }
}




var $cebhF = parcelRequire("cebhF");


"use strict";
const $2cf6b77e8eb872cb$var$_RopeGeometry = class _RopeGeometry extends (0, $b964c6f5532210d5$export$8d075a36a73d54bc) {
    /**
   * @param options - Options to be applied to rope geometry
   */ constructor(options){
        const { width: width, points: points, textureScale: textureScale } = {
            ..._RopeGeometry.defaultOptions,
            ...options
        };
        super({
            positions: new Float32Array(points.length * 4),
            uvs: new Float32Array(points.length * 4),
            indices: new Uint32Array((points.length - 1) * 6)
        });
        this.points = points;
        this._width = width;
        this.textureScale = textureScale;
        this._build();
    }
    /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */ get width() {
        return this._width;
    }
    /** Refreshes Rope indices and uvs */ _build() {
        const points = this.points;
        if (!points) return;
        const vertexBuffer = this.getBuffer("aPosition");
        const uvBuffer = this.getBuffer("aUV");
        const indexBuffer = this.getIndex();
        if (points.length < 1) return;
        if (vertexBuffer.data.length / 4 !== points.length) {
            vertexBuffer.data = new Float32Array(points.length * 4);
            uvBuffer.data = new Float32Array(points.length * 4);
            indexBuffer.data = new Uint16Array((points.length - 1) * 6);
        }
        const uvs = uvBuffer.data;
        const indices = indexBuffer.data;
        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;
        let amount = 0;
        let prev = points[0];
        const textureWidth = this._width * this.textureScale;
        const total = points.length;
        for(let i = 0; i < total; i++){
            const index = i * 4;
            if (this.textureScale > 0) {
                const dx = prev.x - points[i].x;
                const dy = prev.y - points[i].y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i];
                amount += distance / textureWidth;
            } else amount = i / (total - 1);
            uvs[index] = amount;
            uvs[index + 1] = 0;
            uvs[index + 2] = amount;
            uvs[index + 3] = 1;
        }
        let indexCount = 0;
        for(let i = 0; i < total - 1; i++){
            const index = i * 2;
            indices[indexCount++] = index;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 3;
        }
        uvBuffer.update();
        indexBuffer.update();
        this.updateVertices();
    }
    /** refreshes vertices of Rope mesh */ updateVertices() {
        const points = this.points;
        if (points.length < 1) return;
        let lastPoint = points[0];
        let nextPoint;
        let perpX = 0;
        let perpY = 0;
        const vertices = this.buffers[0].data;
        const total = points.length;
        const halfWidth = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
        for(let i = 0; i < total; i++){
            const point = points[i];
            const index = i * 4;
            if (i < points.length - 1) nextPoint = points[i + 1];
            else nextPoint = point;
            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;
            let ratio = (1 - i / (total - 1)) * 10;
            if (ratio > 1) ratio = 1;
            const perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            if (perpLength < 1e-6) {
                perpX = 0;
                perpY = 0;
            } else {
                perpX /= perpLength;
                perpY /= perpLength;
                perpX *= halfWidth;
                perpY *= halfWidth;
            }
            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;
            lastPoint = point;
        }
        this.buffers[0].update();
    }
    /** Refreshes Rope indices and uvs */ update() {
        if (this.textureScale > 0) this._build();
        else this.updateVertices();
    }
};
/** Default options for RopeGeometry constructor. */ $2cf6b77e8eb872cb$var$_RopeGeometry.defaultOptions = {
    /** The width (i.e., thickness) of the rope. */ width: 200,
    /** An array of points that determine the rope. */ points: [],
    /** Rope texture scale, if zero then the rope texture is stretched. */ textureScale: 0
};
let $2cf6b77e8eb872cb$export$6a9827483976bf64 = $2cf6b77e8eb872cb$var$_RopeGeometry;


"use strict";
const $a6f64a325f703271$var$_MeshRope = class _MeshRope extends (0, $0ac2d29ab0a78f0e$export$e176487c05830cc5) {
    /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param options
   * @param options.texture - The texture to use on the rope.
   * @param options.points - An array of {@link math.Point} objects to construct this rope.
   * @param {number} options.textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */ constructor(options){
        const { texture: texture, points: points, textureScale: textureScale, ...rest } = {
            ..._MeshRope.defaultOptions,
            ...options
        };
        const ropeGeometry = new (0, $2cf6b77e8eb872cb$export$6a9827483976bf64)((0, $cebhF.definedProps)({
            width: texture.height,
            points: points,
            textureScale: textureScale
        }));
        if (textureScale > 0) texture.source.style.addressMode = "repeat";
        super((0, $cebhF.definedProps)({
            ...rest,
            texture: texture,
            geometry: ropeGeometry
        }));
        this.autoUpdate = true;
        this.onRender = this._render;
    }
    _render() {
        const geometry = this.geometry;
        if (this.autoUpdate || geometry._width !== this.texture.height) {
            geometry._width = this.texture.height;
            geometry.update();
        }
    }
};
/**
 * Default options for creating a MeshRope instance. These values are used when specific
 * options aren't provided in the constructor.
 * @example
 * ```ts
 * // Use default options globally
 * MeshRope.defaultOptions = {
 *     textureScale: 0.5  // Set higher quality texture scaling
 * };
 *
 * // Create rope with modified defaults
 * const rope = new MeshRope({
 *     texture: Texture.from('rope.png'),
 *     points: [
 *         new Point(0, 0),
 *         new Point(100, 0)
 *     ]
 * }); // Will use textureScale: 0.5
 * ```
 * @property {number} textureScale - Controls texture scaling along the rope (0 = stretch)
 * @see {@link MeshRopeOptions} For all available options
 */ $a6f64a325f703271$var$_MeshRope.defaultOptions = {
    textureScale: 0
};
let $a6f64a325f703271$export$2b0fdd9d3f905472 = $a6f64a325f703271$var$_MeshRope;



var $cebhF = parcelRequire("cebhF");


"use strict";
class $54d9ee77c32be21f$export$fe1197d66f13b411 extends (0, $0ac2d29ab0a78f0e$export$e176487c05830cc5) {
    /**
   * @param options - Options to be used for construction
   */ constructor(options){
        const { texture: texture, vertices: vertices, uvs: uvs, indices: indices, topology: topology, ...rest } = options;
        const geometry = new (0, $b964c6f5532210d5$export$8d075a36a73d54bc)((0, $cebhF.definedProps)({
            positions: vertices,
            uvs: uvs,
            indices: indices,
            topology: topology
        }));
        super((0, $cebhF.definedProps)({
            ...rest,
            texture: texture,
            geometry: geometry
        }));
        this.autoUpdate = true;
        this.onRender = this._render;
    }
    /**
   * The vertex positions of the mesh as a TypedArray. Each vertex is represented by two
   * consecutive values (x, y) in the array. Changes to these values will update the mesh's shape.
   * @example
   * ```ts
   * // Read vertex positions
   * const vertices = mesh.vertices;
   * console.log('First vertex:', vertices[0], vertices[1]);
   *
   * // Modify vertices directly
   * vertices[0] += 10;  // Move first vertex right
   * vertices[1] -= 20;  // Move first vertex up
   *
   * // Animate vertices
   * app.ticker.add(() => {
   *     const time = performance.now() / 1000;
   *     const vertices = mesh.vertices;
   *
   *     // Wave motion
   *     for (let i = 0; i < vertices.length; i += 2) {
   *         vertices[i + 1] = Math.sin(time + i * 0.5) * 20;
   *     }
   * });
   * ```
   * @see {@link MeshSimple#autoUpdate} For controlling vertex buffer updates
   * @see {@link MeshGeometry#getBuffer} For direct buffer access
   */ get vertices() {
        return this.geometry.getBuffer("aPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aPosition").data = value;
    }
    _render() {
        if (this.autoUpdate) this.geometry.getBuffer("aPosition").update();
    }
}




var $5aREr = parcelRequire("5aREr");

var $4qqO8 = parcelRequire("4qqO8");

"use strict";
function $c9337d37651d9de5$export$195521b29bc6b458(texture, out) {
    const { width: width, height: height } = texture.frame;
    out.scale(1 / width, 1 / height);
    return out;
}






var $2IIjX = parcelRequire("2IIjX");
"use strict";
class $2c9c9711d691bf5f$export$a3bb3b18d3c0fa86 {
    execute(particleContainerPipe, container) {
        const renderer = particleContainerPipe.renderer;
        const context = renderer.canvasContext.activeContext;
        const children = container.particleChildren;
        const texture = container.texture;
        context.save();
        renderer.canvasContext.setContextTransform(container.worldTransform, container.roundPixels);
        renderer.canvasContext.setBlendMode(container.groupBlendMode);
        const groupColorAlpha = container.groupColorAlpha;
        const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
        const groupAlpha = (groupColorAlpha >>> 24 & 255) / 255 * filterAlpha;
        for(let i = 0; i < children.length; i++){
            const particle = children[i];
            const pTexture = particle.texture || texture;
            if (!pTexture?.source?.resource) continue;
            const color = particle.color;
            const alpha = (color >>> 24 & 255) / 255 * groupAlpha;
            if (alpha <= 0) continue;
            const bgr = color & 16777215;
            const tint = ((bgr & 255) << 16) + (bgr & 65280) + (bgr >> 16 & 255);
            let drawSource = pTexture.source.resource;
            if (tint !== 16777215) drawSource = (0, $2IIjX.canvasUtils).getTintedCanvas({
                texture: pTexture
            }, tint);
            const frame = pTexture.frame;
            const resolution = pTexture.source.resolution;
            const sx = frame.x * resolution;
            const sy = frame.y * resolution;
            const sw = frame.width * resolution;
            const sh = frame.height * resolution;
            context.globalAlpha = alpha;
            const dx = -particle.anchorX * frame.width;
            const dy = -particle.anchorY * frame.height;
            if (particle.rotation !== 0 || particle.scaleX !== 1 || particle.scaleY !== 1) {
                context.save();
                context.translate(particle.x, particle.y);
                context.rotate(particle.rotation);
                context.scale(particle.scaleX, particle.scaleY);
                context.drawImage(drawSource, sx, sy, sw, sh, dx, dy, frame.width, frame.height);
                context.restore();
            } else context.drawImage(drawSource, sx, sy, sw, sh, particle.x + dx, particle.y + dy, frame.width, frame.height);
        }
        context.restore();
    }
}



var $aZ9ZN = parcelRequire("aZ9ZN");

var $aZ9ZN = parcelRequire("aZ9ZN");

var $5xi4h = parcelRequire("5xi4h");

var $aUxJK = parcelRequire("aUxJK");

var $fy1Tx = parcelRequire("fy1Tx");

var $fx0Zy = parcelRequire("fx0Zy");

var $6tS7R = parcelRequire("6tS7R");

var $id0ju = parcelRequire("id0ju");

var $2bJdA = parcelRequire("2bJdA");

var $1T7Iy = parcelRequire("1T7Iy");

var $1T4Gr = parcelRequire("1T4Gr");

var $eDWUK = parcelRequire("eDWUK");

var $4SZYy = parcelRequire("4SZYy");
"use strict";
function $1cab0da29803566c$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    if (totalIndices > 65535) outBuffer || (outBuffer = new Uint32Array(totalIndices));
    else outBuffer || (outBuffer = new Uint16Array(totalIndices));
    if (outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4){
        outBuffer[i + 0] = j + 0;
        outBuffer[i + 1] = j + 1;
        outBuffer[i + 2] = j + 2;
        outBuffer[i + 3] = j + 0;
        outBuffer[i + 4] = j + 2;
        outBuffer[i + 5] = j + 3;
    }
    return outBuffer;
}



var $eDWUK = parcelRequire("eDWUK");
"use strict";
function $9ecf074a252a4b08$export$f240bbaff81b32e9(properties) {
    return {
        dynamicUpdate: $9ecf074a252a4b08$var$generateUpdateFunction(properties, true),
        staticUpdate: $9ecf074a252a4b08$var$generateUpdateFunction(properties, false)
    };
}
function $9ecf074a252a4b08$var$generateUpdateFunction(properties, dynamic) {
    const funcFragments = [];
    funcFragments.push(`

        var index = 0;

        for (let i = 0; i < ps.length; ++i)
        {
            const p = ps[i];

            `);
    let offset = 0;
    for(const i in properties){
        const property = properties[i];
        if (dynamic !== property.dynamic) continue;
        funcFragments.push(`offset = index + ${offset}`);
        funcFragments.push(property.code);
        const attributeInfo = (0, $eDWUK.getAttributeInfoFromFormat)(property.format);
        offset += attributeInfo.stride / 4;
    }
    funcFragments.push(`
            index += stride * 4;
        }
    `);
    funcFragments.unshift(`
        var stride = ${offset};
    `);
    const functionSource = funcFragments.join("\n");
    return new Function("ps", "f32v", "u32v", functionSource);
}


"use strict";
class $ee0dcefac4ec7731$export$ef6bb3c375ab2229 {
    constructor(options){
        this._size = 0;
        this._generateParticleUpdateCache = {};
        const size = this._size = options.size ?? 1e3;
        const properties = options.properties;
        let staticVertexSize = 0;
        let dynamicVertexSize = 0;
        for(const i in properties){
            const property = properties[i];
            const attributeInfo = (0, $eDWUK.getAttributeInfoFromFormat)(property.format);
            if (property.dynamic) dynamicVertexSize += attributeInfo.stride;
            else staticVertexSize += attributeInfo.stride;
        }
        this._dynamicStride = dynamicVertexSize / 4;
        this._staticStride = staticVertexSize / 4;
        this.staticAttributeBuffer = new (0, $4SZYy.ViewableBuffer)(size * 4 * staticVertexSize);
        this.dynamicAttributeBuffer = new (0, $4SZYy.ViewableBuffer)(size * 4 * dynamicVertexSize);
        this.indexBuffer = (0, $1cab0da29803566c$export$c56148e1bec42281)(size);
        const geometry = new (0, $1T4Gr.Geometry)();
        let dynamicOffset = 0;
        let staticOffset = 0;
        this._staticBuffer = new (0, $2bJdA.Buffer)({
            data: new Float32Array(1),
            label: "static-particle-buffer",
            shrinkToFit: false,
            usage: (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST
        });
        this._dynamicBuffer = new (0, $2bJdA.Buffer)({
            data: new Float32Array(1),
            label: "dynamic-particle-buffer",
            shrinkToFit: false,
            usage: (0, $1T7Iy.BufferUsage).VERTEX | (0, $1T7Iy.BufferUsage).COPY_DST
        });
        for(const i in properties){
            const property = properties[i];
            const attributeInfo = (0, $eDWUK.getAttributeInfoFromFormat)(property.format);
            if (property.dynamic) {
                geometry.addAttribute(property.attributeName, {
                    buffer: this._dynamicBuffer,
                    stride: this._dynamicStride * 4,
                    offset: dynamicOffset * 4,
                    format: property.format
                });
                dynamicOffset += attributeInfo.size;
            } else {
                geometry.addAttribute(property.attributeName, {
                    buffer: this._staticBuffer,
                    stride: this._staticStride * 4,
                    offset: staticOffset * 4,
                    format: property.format
                });
                staticOffset += attributeInfo.size;
            }
        }
        geometry.addIndex(this.indexBuffer);
        const uploadFunction = this.getParticleUpdate(properties);
        this._dynamicUpload = uploadFunction.dynamicUpdate;
        this._staticUpload = uploadFunction.staticUpdate;
        this.geometry = geometry;
    }
    getParticleUpdate(properties) {
        const key = $ee0dcefac4ec7731$var$getParticleSyncKey(properties);
        if (this._generateParticleUpdateCache[key]) return this._generateParticleUpdateCache[key];
        this._generateParticleUpdateCache[key] = this.generateParticleUpdate(properties);
        return this._generateParticleUpdateCache[key];
    }
    generateParticleUpdate(properties) {
        return (0, $9ecf074a252a4b08$export$f240bbaff81b32e9)(properties);
    }
    update(particles, uploadStatic) {
        if (particles.length > this._size) {
            uploadStatic = true;
            this._size = Math.max(particles.length, this._size * 1.5 | 0);
            this.staticAttributeBuffer = new (0, $4SZYy.ViewableBuffer)(this._size * this._staticStride * 16);
            this.dynamicAttributeBuffer = new (0, $4SZYy.ViewableBuffer)(this._size * this._dynamicStride * 16);
            this.indexBuffer = (0, $1cab0da29803566c$export$c56148e1bec42281)(this._size);
            this.geometry.indexBuffer.setDataWithSize(this.indexBuffer, this.indexBuffer.byteLength, true);
        }
        const dynamicAttributeBuffer = this.dynamicAttributeBuffer;
        this._dynamicUpload(particles, dynamicAttributeBuffer.float32View, dynamicAttributeBuffer.uint32View);
        this._dynamicBuffer.setDataWithSize(this.dynamicAttributeBuffer.float32View, particles.length * this._dynamicStride * 4, true);
        if (uploadStatic) {
            const staticAttributeBuffer = this.staticAttributeBuffer;
            this._staticUpload(particles, staticAttributeBuffer.float32View, staticAttributeBuffer.uint32View);
            this._staticBuffer.setDataWithSize(staticAttributeBuffer.float32View, particles.length * this._staticStride * 4, true);
        }
    }
    destroy() {
        this._staticBuffer.destroy();
        this._dynamicBuffer.destroy();
        this.geometry.destroy();
    }
}
function $ee0dcefac4ec7731$var$getParticleSyncKey(properties) {
    const keyGen = [];
    for(const key in properties){
        const property = properties[key];
        keyGen.push(key, property.code, property.dynamic ? "d" : "s");
    }
    return keyGen.join("_");
}



var $dKHyW = parcelRequire("dKHyW");

var $5xi4h = parcelRequire("5xi4h");

var $4kU4M = parcelRequire("4kU4M");

var $bEdxc = parcelRequire("bEdxc");

var $7LCXQ = parcelRequire("7LCXQ");

var $4iNSL = parcelRequire("4iNSL");

var $c8piJ = parcelRequire("c8piJ");



"use strict";
class $038ce5b3d8323f15$export$aff9903e2c89709e extends (0, $7LCXQ.Shader) {
    constructor(){
        const glProgram = (0, $4kU4M.GlProgram).from({
            vertex: $0f262301bdbdd53a$export$2e2bcd8739ae039,
            fragment: $ac40a2fe3413b26e$export$2e2bcd8739ae039
        });
        const gpuProgram = (0, $bEdxc.GpuProgram).from({
            fragment: {
                source: (0, $f43e622d8c5f5566$export$2e2bcd8739ae039),
                entryPoint: "mainFragment"
            },
            vertex: {
                source: (0, $f43e622d8c5f5566$export$2e2bcd8739ae039),
                entryPoint: "mainVertex"
            }
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                // this will be replaced with the texture from the particle container
                uTexture: (0, $4iNSL.Texture).WHITE.source,
                // this will be replaced with the texture style from the particle container
                uSampler: new (0, $c8piJ.TextureStyle)({}),
                // this will be replaced with the local uniforms from the particle container
                uniforms: {
                    uTranslationMatrix: {
                        value: new (0, $5xi4h.Matrix)(),
                        type: "mat3x3<f32>"
                    },
                    uColor: {
                        value: new (0, $dKHyW.Color)(16777215),
                        type: "vec4<f32>"
                    },
                    uRound: {
                        value: 1,
                        type: "f32"
                    },
                    uResolution: {
                        value: [
                            0,
                            0
                        ],
                        type: "vec2<f32>"
                    }
                }
            }
        });
    }
}


"use strict";
class $06aa82a812b671ea$export$bd0cb1ddce5f75fc {
    /**
   * @param renderer - The renderer this sprite batch works for.
   * @param adaptor
   */ constructor(renderer, adaptor){
        /** @internal */ this.state = (0, $fx0Zy.State).for2d();
        /** Local uniforms that are used for rendering particles. */ this.localUniforms = new (0, $aUxJK.UniformGroup)({
            uTranslationMatrix: {
                value: new (0, $5xi4h.Matrix)(),
                type: "mat3x3<f32>"
            },
            uColor: {
                value: new Float32Array(4),
                type: "vec4<f32>"
            },
            uRound: {
                value: 1,
                type: "f32"
            },
            uResolution: {
                value: [
                    0,
                    0
                ],
                type: "vec2<f32>"
            }
        });
        this.renderer = renderer;
        this.adaptor = adaptor;
        this.defaultShader = new (0, $038ce5b3d8323f15$export$aff9903e2c89709e)();
        this.state = (0, $fx0Zy.State).for2d();
        this._managedContainers = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            name: "particleContainer"
        });
    }
    validateRenderable(_renderable) {
        return false;
    }
    addRenderable(renderable, instructionSet) {
        this.renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(renderable);
    }
    getBuffers(renderable) {
        return renderable._gpuData[this.renderer.uid] || this._initBuffer(renderable);
    }
    _initBuffer(renderable) {
        renderable._gpuData[this.renderer.uid] = new (0, $ee0dcefac4ec7731$export$ef6bb3c375ab2229)({
            size: renderable.particleChildren.length,
            properties: renderable._properties
        });
        this._managedContainers.add(renderable);
        return renderable._gpuData[this.renderer.uid];
    }
    updateRenderable(_renderable) {}
    execute(container) {
        const children = container.particleChildren;
        if (children.length === 0) return;
        const renderer = this.renderer;
        const buffer = this.getBuffers(container);
        container.texture || (container.texture = children[0].texture);
        const state = this.state;
        buffer.update(children, container._childrenDirty);
        container._childrenDirty = false;
        state.blendMode = (0, $fy1Tx.getAdjustedBlendModeBlend)(container.blendMode, container.texture._source);
        const uniforms = this.localUniforms.uniforms;
        const transformationMatrix = uniforms.uTranslationMatrix;
        container.worldTransform.copyTo(transformationMatrix);
        transformationMatrix.prepend(renderer.globalUniforms.globalUniformData.projectionMatrix);
        uniforms.uResolution = renderer.globalUniforms.globalUniformData.resolution;
        uniforms.uRound = renderer._roundPixels | container._roundPixels;
        (0, $id0ju.color32BitToUniform)(container.groupColorAlpha, uniforms.uColor, 0);
        this.adaptor.execute(this, container);
    }
    /** Destroys the ParticleRenderer. */ destroy() {
        this._managedContainers.destroy();
        this.renderer = null;
        if (this.defaultShader) {
            this.defaultShader.destroy();
            this.defaultShader = null;
        }
    }
}
/** @ignore */ $06aa82a812b671ea$export$bd0cb1ddce5f75fc.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "particle"
};



"use strict";
class $e0e9d170a309bccc$export$577397794ae005cf extends (0, $06aa82a812b671ea$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $2c9c9711d691bf5f$export$a3bb3b18d3c0fa86)());
    }
}
/** @ignore */ $e0e9d170a309bccc$export$577397794ae005cf.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "particle"
};


"use strict";
class $2f85d4b28425827c$export$46c725f3fa23723f {
    execute(particleContainerPipe, container) {
        const state = particleContainerPipe.state;
        const renderer = particleContainerPipe.renderer;
        const shader = container.shader || particleContainerPipe.defaultShader;
        shader.resources.uTexture = container.texture._source;
        shader.resources.uniforms = particleContainerPipe.localUniforms;
        const gl = renderer.gl;
        const buffer = particleContainerPipe.getBuffers(container);
        renderer.shader.bind(shader);
        renderer.state.set(state);
        renderer.geometry.bind(buffer.geometry, shader.glProgram);
        const byteSize = buffer.geometry.indexBuffer.data.BYTES_PER_ELEMENT;
        const glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
        gl.drawElements(gl.TRIANGLES, container.particleChildren.length * 6, glType, 0);
    }
}



var $aZ9ZN = parcelRequire("aZ9ZN");


"use strict";
class $0c24f2e0964b9661$export$265dc7019ac9a69c extends (0, $06aa82a812b671ea$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $2f85d4b28425827c$export$46c725f3fa23723f)());
    }
}
/** @ignore */ $0c24f2e0964b9661$export$265dc7019ac9a69c.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes
    ],
    name: "particle"
};


"use strict";
class $24feddf41ac2de81$export$b05a5c43c842f66d {
    execute(particleContainerPipe, container) {
        const renderer = particleContainerPipe.renderer;
        const shader = container.shader || particleContainerPipe.defaultShader;
        shader.groups[0] = renderer.renderPipes.uniformBatch.getUniformBindGroup(particleContainerPipe.localUniforms, true);
        shader.groups[1] = renderer.texture.getTextureBindGroup(container.texture);
        const state = particleContainerPipe.state;
        const buffer = particleContainerPipe.getBuffers(container);
        renderer.encoder.draw({
            geometry: buffer.geometry,
            shader: container.shader || particleContainerPipe.defaultShader,
            state: state,
            size: container.particleChildren.length * 6
        });
    }
}



var $aZ9ZN = parcelRequire("aZ9ZN");


"use strict";
class $9654d61a4f2746ae$export$1097a2b67474552c extends (0, $06aa82a812b671ea$export$bd0cb1ddce5f75fc) {
    constructor(renderer){
        super(renderer, new (0, $24feddf41ac2de81$export$b05a5c43c842f66d)());
    }
}
/** @ignore */ $9654d61a4f2746ae$export$1097a2b67474552c.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "particle"
};



var $dKHyW = parcelRequire("dKHyW");

var $4iNSL = parcelRequire("4iNSL");

var $3qOui = parcelRequire("3qOui");

var $7lfy2 = parcelRequire("7lfy2");
"use strict";
const $b970650e5099956d$var$_Particle = class _Particle {
    constructor(options){
        if (options instanceof (0, $4iNSL.Texture)) {
            this.texture = options;
            (0, $7lfy2.assignWithIgnore)(this, _Particle.defaultOptions, {});
        } else {
            const combined = {
                ..._Particle.defaultOptions,
                ...options
            };
            (0, $7lfy2.assignWithIgnore)(this, combined, {});
        }
    }
    /**
   * The transparency of the particle. Values range from 0 (fully transparent)
   * to 1 (fully opaque). Values outside this range are clamped.
   * @example
   * ```ts
   * // Create a semi-transparent particle
   * const particle = new Particle({
   *     texture: Texture.from('particle.png'),
   *     alpha: 0.5
   * });
   *
   * // Fade out
   * particle.alpha *= 0.9;
   *
   * // Fade in
   * particle.alpha = Math.min(particle.alpha + 0.1, 1);
   *
   * // Values are clamped to valid range
   * particle.alpha = 1.5; // Becomes 1.0
   * particle.alpha = -0.5; // Becomes 0.0
   *
   * // Animate transparency
   * app.ticker.add((delta) => {
   *     const time = performance.now() / 1000;
   *     particle.alpha = 0.5 + Math.sin(time) * 0.5; // Pulse between 0-1
   * });
   * ```
   * @default 1
   * @see {@link Particle#tint} For controlling particle color
   * @see {@link Particle#color} For the combined color and alpha value
   */ get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        this._alpha = Math.min(Math.max(value, 0), 1);
        this._updateColor();
    }
    /**
   * The tint color of the particle. Can be set using hex numbers or CSS color strings.
   * The tint is multiplied with the texture color to create the final particle color.
   * @example
   * ```ts
   * // Create a red particle
   * const particle = new Particle({
   *     texture: Texture.from('particle.png'),
   *     tint: 0xff0000
   * });
   *
   * // Use CSS color strings
   * particle.tint = '#00ff00';  // Green
   * particle.tint = 'blue';     // Blue
   *
   * // Animate tint color
   * app.ticker.add(() => {
   *     const time = performance.now() / 1000;
   *
   *     // Cycle through hues
   *     const hue = (time * 50) % 360;
   *     particle.tint = `hsl(${hue}, 100%, 50%)`;
   * });
   *
   * // Reset to white (no tint)
   * particle.tint = 0xffffff;
   * ```
   * @type {ColorSource} Hex number or CSS color string
   * @default 0xffffff
   * @see {@link Particle#alpha} For controlling transparency
   * @see {@link Particle#color} For the combined color and alpha value
   * @see {@link Color} For supported color formats
   */ get tint() {
        return (0, $3qOui.bgr2rgb)(this._tint);
    }
    set tint(value) {
        this._tint = (0, $dKHyW.Color).shared.setValue(value ?? 16777215).toBgrNumber();
        this._updateColor();
    }
    _updateColor() {
        this.color = this._tint + ((this._alpha * 255 | 0) << 24);
    }
};
/**
 * Default options used when creating new particles. These values are applied when specific
 * options aren't provided in the constructor.
 * @example
 * ```ts
 * // Override defaults globally
 * Particle.defaultOptions = {
 *     ...Particle.defaultOptions,
 *     anchorX: 0.5,
 *     anchorY: 0.5,
 *     alpha: 0.8
 * };
 *
 * // New particles use modified defaults
 * const centeredParticle = new Particle(texture);
 * console.log(centeredParticle.anchorX); // 0.5
 * console.log(centeredParticle.alpha); // 0.8
 * ```
 * @see {@link ParticleOptions} For all available options
 * @see {@link Particle} For the particle implementation
 */ $b970650e5099956d$var$_Particle.defaultOptions = {
    anchorX: 0,
    anchorY: 0,
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
    rotation: 0,
    tint: 16777215,
    alpha: 1
};
let $b970650e5099956d$export$c36c68baa13912a5 = $b970650e5099956d$var$_Particle;




var $esrbs = parcelRequire("esrbs");

var $9FmI1 = parcelRequire("9FmI1");
"use strict";
const $b7e6978beec43255$export$a7ffd1f9edff60c0 = {
    vertex: {
        attributeName: "aVertex",
        format: "float32x2",
        code: `
            const texture = p.texture;
            const sx = p.scaleX;
            const sy = p.scaleY;
            const ax = p.anchorX;
            const ay = p.anchorY;
            const trim = texture.trim;
            const orig = texture.orig;

            if (trim)
            {
                w1 = trim.x - (ax * orig.width);
                w0 = w1 + trim.width;

                h1 = trim.y - (ay * orig.height);
                h0 = h1 + trim.height;
            }
            else
            {
                w1 = -ax * (orig.width);
                w0 = w1 + orig.width;

                h1 = -ay * (orig.height);
                h0 = h1 + orig.height;
            }

            f32v[offset] = w1 * sx;
            f32v[offset + 1] = h1 * sy;

            f32v[offset + stride] = w0 * sx;
            f32v[offset + stride + 1] = h1 * sy;

            f32v[offset + (stride * 2)] = w0 * sx;
            f32v[offset + (stride * 2) + 1] = h0 * sy;

            f32v[offset + (stride * 3)] = w1 * sx;
            f32v[offset + (stride * 3) + 1] = h0 * sy;
        `,
        dynamic: false
    },
    // positionData
    position: {
        attributeName: "aPosition",
        format: "float32x2",
        code: `
            var x = p.x;
            var y = p.y;

            f32v[offset] = x;
            f32v[offset + 1] = y;

            f32v[offset + stride] = x;
            f32v[offset + stride + 1] = y;

            f32v[offset + (stride * 2)] = x;
            f32v[offset + (stride * 2) + 1] = y;

            f32v[offset + (stride * 3)] = x;
            f32v[offset + (stride * 3) + 1] = y;
        `,
        dynamic: true
    },
    // rotationData
    rotation: {
        attributeName: "aRotation",
        format: "float32",
        code: `
            var rotation = p.rotation;

            f32v[offset] = rotation;
            f32v[offset + stride] = rotation;
            f32v[offset + (stride * 2)] = rotation;
            f32v[offset + (stride * 3)] = rotation;
        `,
        dynamic: false
    },
    // uvsData
    uvs: {
        attributeName: "aUV",
        format: "float32x2",
        code: `
            var uvs = p.texture.uvs;

            f32v[offset] = uvs.x0;
            f32v[offset + 1] = uvs.y0;

            f32v[offset + stride] = uvs.x1;
            f32v[offset + stride + 1] = uvs.y1;

            f32v[offset + (stride * 2)] = uvs.x2;
            f32v[offset + (stride * 2) + 1] = uvs.y2;

            f32v[offset + (stride * 3)] = uvs.x3;
            f32v[offset + (stride * 3) + 1] = uvs.y3;
        `,
        dynamic: false
    },
    // tintData
    color: {
        attributeName: "aColor",
        format: "unorm8x4",
        code: `
            const c = p.color;

            u32v[offset] = c;
            u32v[offset + stride] = c;
            u32v[offset + (stride * 2)] = c;
            u32v[offset + (stride * 3)] = c;
        `,
        dynamic: false
    }
};



var $aZ9ZN = parcelRequire("aZ9ZN");



"use strict";
(0, $aZ9ZN.extensions).add((0, $0c24f2e0964b9661$export$265dc7019ac9a69c));
(0, $aZ9ZN.extensions).add((0, $9654d61a4f2746ae$export$1097a2b67474552c));
(0, $aZ9ZN.extensions).add((0, $e0e9d170a309bccc$export$577397794ae005cf));


"use strict";
const $08fe00dcac11569d$var$emptyBounds = new (0, $esrbs.Bounds)(0, 0, 0, 0);
const $08fe00dcac11569d$var$_ParticleContainer = class _ParticleContainer extends (0, $9FmI1.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = {}){
        options = {
            ..._ParticleContainer.defaultOptions,
            ...options,
            dynamicProperties: {
                ..._ParticleContainer.defaultOptions.dynamicProperties,
                ...options?.dynamicProperties
            }
        };
        const { dynamicProperties: dynamicProperties, shader: shader, roundPixels: roundPixels, texture: texture, particles: particles, ...rest } = options;
        super({
            label: "ParticleContainer",
            ...rest
        });
        /**
     * The unique identifier for the render pipe of this ParticleContainer.
     * @internal
     */ this.renderPipeId = "particle";
        /** @internal */ this.batched = false;
        /**
     * Indicates if the children of this ParticleContainer have changed and need to be updated.
     * @internal
     */ this._childrenDirty = false;
        this.texture = texture || null;
        this.shader = shader;
        this._properties = {};
        for(const key in 0, $b7e6978beec43255$export$a7ffd1f9edff60c0){
            const property = (0, $b7e6978beec43255$export$a7ffd1f9edff60c0)[key];
            const dynamic = dynamicProperties[key];
            this._properties[key] = {
                ...property,
                dynamic: dynamic
            };
        }
        this.allowChildren = true;
        this.roundPixels = roundPixels ?? false;
        this.particleChildren = particles ?? [];
    }
    /**
   * Adds one or more particles to the container. The particles will be rendered using the container's shared texture
   * and properties. When adding multiple particles, they must all share the same base texture.
   * @example
   * ```ts
   * const container = new ParticleContainer();
   *
   * // Add a single particle
   * const particle = new Particle(Assets.get('particleTexture'));
   * container.addParticle(particle);
   *
   * // Add multiple particles at once
   * const particles = [
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture')),
   *     new Particle(Assets.get('particleTexture'))
   * ];
   *
   * container.addParticle(...particles);
   * ```
   * @param children - The Particle(s) to add to the container
   * @returns The first particle that was added, for method chaining
   * @see {@link ParticleContainer#texture} For setting the shared texture
   * @see {@link ParticleContainer#update} For updating after modifications
   */ addParticle(...children) {
        for(let i = 0; i < children.length; i++)this.particleChildren.push(children[i]);
        this.onViewUpdate();
        return children[0];
    }
    /**
   * Removes one or more particles from the container. The particles must already be children
   * of this container to be removed.
   * @example
   * ```ts
   * // Remove a single particle
   * container.removeParticle(particle1);
   *
   * // Remove multiple particles at once
   * container.removeParticle(particle2, particle3);
   * ```
   * @param children - The Particle(s) to remove from the container
   * @returns The first particle that was removed, for method chaining
   * @see {@link ParticleContainer#particleChildren} For accessing all particles
   * @see {@link ParticleContainer#removeParticles} For removing particles by index
   * @see {@link ParticleContainer#removeParticleAt} For removing a particle at a specific index
   */ removeParticle(...children) {
        let didRemove = false;
        for(let i = 0; i < children.length; i++){
            const index = this.particleChildren.indexOf(children[i]);
            if (index > -1) {
                this.particleChildren.splice(index, 1);
                didRemove = true;
            }
        }
        if (didRemove) this.onViewUpdate();
        return children[0];
    }
    /**
   * Updates the particle container's internal state. Call this method after manually modifying
   * the particleChildren array or when changing static properties of particles.
   * @example
   * ```ts
   * // Batch modify particles
   * container.particleChildren.push(...particles);
   * container.update(); // Required after direct array modification
   *
   * // Update static properties
   * container.particleChildren.forEach(particle => {
   *     particle.position.set(
   *         Math.random() * 800,
   *         Math.random() * 600
   *     );
   * });
   * container.update(); // Required after changing static positions
   * ```
   * @see {@link ParticleProperties} For configuring dynamic vs static properties
   * @see {@link ParticleContainer#particleChildren} For direct array access
   */ update() {
        this._childrenDirty = true;
    }
    onViewUpdate() {
        this._childrenDirty = true;
        super.onViewUpdate();
    }
    /**
   * Returns a static empty bounds object since ParticleContainer does not calculate bounds automatically
   * for performance reasons. Use the `boundsArea` property to manually set container bounds.
   * @example
   * ```ts
   * const container = new ParticleContainer({
   *     texture: Texture.from('particle.png')
   * });
   *
   * // Default bounds are empty
   * console.log(container.bounds); // Bounds(0, 0, 0, 0)
   *
   * // Set manual bounds for the particle area
   * container.boundsArea = {
   *     minX: 0,
   *     minY: 0,
   *     maxX: 800,
   *     maxY: 600
   * };
   * ```
   * @readonly
   * @returns {Bounds} An empty bounds object (0,0,0,0)
   * @see {@link Container#boundsArea} For manually setting container bounds
   * @see {@link Bounds} For bounds object structure
   */ get bounds() {
        return $08fe00dcac11569d$var$emptyBounds;
    }
    /** @private */ updateBounds() {}
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * particleContainer.destroy();
   * particleContainer.destroy(true);
   * particleContainer.destroy({ texture: true, textureSource: true, children: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            const texture = this.texture ?? this.particleChildren[0]?.texture;
            if (texture) texture.destroy(destroyTextureSource);
        }
        this.texture = null;
        this.shader?.destroy();
    }
    /**
   * Removes all particles from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed particles
   */ removeParticles(beginIndex, endIndex) {
        beginIndex ?? (beginIndex = 0);
        endIndex ?? (endIndex = this.particleChildren.length);
        const children = this.particleChildren.splice(beginIndex, endIndex - beginIndex);
        this.onViewUpdate();
        return children;
    }
    /**
   * Removes a particle from the specified index position.
   * @param index - The index to get the particle from
   * @returns The particle that was removed.
   */ removeParticleAt(index) {
        const child = this.particleChildren.splice(index, 1);
        this.onViewUpdate();
        return child[0];
    }
    /**
   * Adds a particle to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the particle is already in this container, it will be moved to the specified index.
   * @param {Container} child - The particle to add.
   * @param {number} index - The absolute index where the particle will be positioned at the end of the operation.
   * @returns {Container} The particle that was added.
   */ addParticleAt(child, index) {
        this.particleChildren.splice(index, 0, child);
        this.onViewUpdate();
        return child;
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChild(..._children) {
        throw new Error("ParticleContainer.addChild() is not available. Please use ParticleContainer.addParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChild(..._children) {
        throw new Error("ParticleContainer.removeChild() is not available. Please use ParticleContainer.removeParticle()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticles()` instead.
   * @param {number} [_beginIndex]
   * @param {number} [_endIndex]
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildren(_beginIndex, _endIndex) {
        throw new Error("ParticleContainer.removeChildren() is not available. Please use ParticleContainer.removeParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ removeChildAt(_index) {
        throw new Error("ParticleContainer.removeChildAt() is not available. Please use ParticleContainer.removeParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildAt(_index) {
        throw new Error("ParticleContainer.getChildAt() is not available. Please use ParticleContainer.getParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.setParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ setChildIndex(_child, _index) {
        throw new Error("ParticleContainer.setChildIndex() is not available. Please use ParticleContainer.setParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ getChildIndex(_child) {
        throw new Error("ParticleContainer.getChildIndex() is not available. Please use ParticleContainer.getParticleIndex()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticleAt()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ addChildAt(_child, _index) {
        throw new Error("ParticleContainer.addChildAt() is not available. Please use ParticleContainer.addParticleAt()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.swapParticles()` instead.
   * @param {ContainerChild} _child
   * @param {ContainerChild} _child2
   * @ignore
   */ swapChildren(_child, _child2) {
        throw new Error("ParticleContainer.swapChildren() is not available. Please use ParticleContainer.swapParticles()");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChild(..._child) {
        throw new Error("ParticleContainer.reparentChild() is not available with the particle container");
    }
    /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @param _index - The index to reparent the child to
   * @throws {Error} Always throws an error as this method is not available.
   * @ignore
   */ reparentChildAt(_child, _index) {
        throw new Error("ParticleContainer.reparentChildAt() is not available with the particle container");
    }
};
/**
 * Defines the default options for creating a ParticleContainer.
 * @example
 * ```ts
 * // Change defaults globally
 * ParticleContainer.defaultOptions = {
 *     dynamicProperties: {
 *         position: true,  // Update positions each frame
 *         rotation: true,  // Update rotations each frame
 *         vertex: false,   // Static vertices
 *         uvs: false,      // Static texture coordinates
 *         color: false     // Static colors
 *     },
 *     roundPixels: true // Enable pixel rounding for crisp rendering
 * };
 * ```
 * @property {Record<string, boolean>} dynamicProperties - Specifies which properties are dynamic.
 * @property {boolean} roundPixels - Indicates if pixels should be rounded.
 */ $08fe00dcac11569d$var$_ParticleContainer.defaultOptions = {
    /** Specifies which properties are dynamic. */ dynamicProperties: {
        /** Indicates if vertex positions are dynamic. */ vertex: false,
        /** Indicates if particle positions are dynamic. */ position: true,
        /** Indicates if particle rotations are dynamic. */ rotation: false,
        /** Indicates if UV coordinates are dynamic. */ uvs: false,
        /** Indicates if particle colors are dynamic. */ color: false
    },
    /** Indicates if pixels should be rounded for rendering. */ roundPixels: false
};
let $08fe00dcac11569d$export$e63bf72b2cfda112 = $08fe00dcac11569d$var$_ParticleContainer;









var $aZ9ZN = parcelRequire("aZ9ZN");

var $2IIjX = parcelRequire("2IIjX");

var $3qOui = parcelRequire("3qOui");

var $5nS5O = parcelRequire("5nS5O");
"use strict";
class $02b35d0f8344dd2b$export$e1f940f0a61daa3c {
    constructor(renderer){
        this._renderer = renderer;
    }
    validateRenderable(_sprite) {
        return false;
    }
    addRenderable(sprite, instructionSet) {
        this._renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(sprite);
    }
    updateRenderable(_sprite) {}
    execute(sprite) {
        const renderer = this._renderer;
        const contextSystem = renderer.canvasContext;
        const context = contextSystem.activeContext;
        context.save();
        const transform = sprite.groupTransform;
        const roundPixels = renderer._roundPixels | sprite._roundPixels;
        contextSystem.setContextTransform(transform, roundPixels === 1);
        contextSystem.setBlendMode(sprite.groupBlendMode);
        const globalColor = renderer.globalUniforms.globalUniformData?.worldColor ?? 4294967295;
        const groupColorAlpha = sprite.groupColorAlpha;
        const globalAlpha = (globalColor >>> 24 & 255) / 255;
        const groupAlphaValue = (groupColorAlpha >>> 24 & 255) / 255;
        const filterAlpha = renderer.filter?.alphaMultiplier ?? 1;
        const alpha = globalAlpha * groupAlphaValue * filterAlpha;
        if (alpha <= 0) {
            context.restore();
            return;
        }
        context.globalAlpha = alpha;
        const globalTint = globalColor & 16777215;
        const groupTintBGR = groupColorAlpha & 16777215;
        const tint = (0, $3qOui.bgr2rgb)((0, $5nS5O.multiplyHexColors)(groupTintBGR, globalTint));
        const texture = sprite.texture;
        const drawSource = (0, $2IIjX.canvasUtils).getCanvasSource(texture);
        if (!drawSource) {
            context.restore();
            return;
        }
        const smoothProperty = contextSystem.smoothProperty;
        const shouldSmooth = texture.source.style.scaleMode !== "nearest";
        if (context[smoothProperty] !== shouldSmooth) context[smoothProperty] = shouldSmooth;
        const needsProcessing = tint !== 16777215 || texture.rotate !== 0;
        const finalSource = needsProcessing ? (0, $2IIjX.canvasUtils).getTintedCanvas({
            texture: texture
        }, tint) : drawSource;
        const { leftWidth: leftWidth, topHeight: topHeight, rightWidth: rightWidth, bottomHeight: bottomHeight, width: width, height: height } = sprite;
        const totalBorderWidth = leftWidth + rightWidth;
        const totalBorderHeight = topHeight + bottomHeight;
        const scale = Math.min(totalBorderWidth > width ? width / totalBorderWidth : 1, totalBorderHeight > height ? height / totalBorderHeight : 1, 1);
        const destLeftWidth = leftWidth * scale;
        const destRightWidth = rightWidth * scale;
        const destTopHeight = topHeight * scale;
        const destBottomHeight = bottomHeight * scale;
        const destCenterWidth = Math.max(0, width - destLeftWidth - destRightWidth);
        const destCenterHeight = Math.max(0, height - destTopHeight - destBottomHeight);
        const anchor = sprite.anchor;
        const resolution = texture.source._resolution ?? texture.source.resolution ?? 1;
        let sx = texture.frame.x * resolution;
        let sy = texture.frame.y * resolution;
        const dx = -anchor.x * width;
        const dy = -anchor.y * height;
        const lw = leftWidth * resolution;
        const tw = topHeight * resolution;
        const rw = rightWidth * resolution;
        const bw = bottomHeight * resolution;
        let sw = texture.frame.width * resolution;
        let sh = texture.frame.height * resolution;
        if (needsProcessing) {
            sx = 0;
            sy = 0;
            sw = finalSource.width;
            sh = finalSource.height;
        }
        context.drawImage(finalSource, sx, sy, lw, tw, dx, dy, destLeftWidth, destTopHeight);
        context.drawImage(finalSource, sx + lw, sy, sw - lw - rw, tw, dx + destLeftWidth, dy, destCenterWidth, destTopHeight);
        context.drawImage(finalSource, sx + sw - rw, sy, rw, tw, dx + width - destRightWidth, dy, destRightWidth, destTopHeight);
        context.drawImage(finalSource, sx, sy + tw, lw, sh - tw - bw, dx, dy + destTopHeight, destLeftWidth, destCenterHeight);
        context.drawImage(finalSource, sx + lw, sy + tw, sw - lw - rw, sh - tw - bw, dx + destLeftWidth, dy + destTopHeight, destCenterWidth, destCenterHeight);
        context.drawImage(finalSource, sx + sw - rw, sy + tw, rw, sh - tw - bw, dx + width - destRightWidth, dy + destTopHeight, destRightWidth, destCenterHeight);
        context.drawImage(finalSource, sx, sy + sh - bw, lw, bw, dx, dy + height - destBottomHeight, destLeftWidth, destBottomHeight);
        context.drawImage(finalSource, sx + lw, sy + sh - bw, sw - lw - rw, bw, dx + destLeftWidth, dy + height - destBottomHeight, destCenterWidth, destBottomHeight);
        context.drawImage(finalSource, sx + sw - rw, sy + sh - bw, rw, bw, dx + width - destRightWidth, dy + height - destBottomHeight, destRightWidth, destBottomHeight);
        context.restore();
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $02b35d0f8344dd2b$export$e1f940f0a61daa3c.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).CanvasPipes
    ],
    name: "nineSliceSprite"
};



"use strict";
const $2cb7f5d5e3b00a06$var$_NineSliceGeometry = class _NineSliceGeometry extends (0, $a8d07342c65f7a94$export$967d831af31f69ce) {
    constructor(options = {}){
        options = {
            ..._NineSliceGeometry.defaultOptions,
            ...options
        };
        super({
            width: options.width,
            height: options.height,
            verticesX: 4,
            verticesY: 4
        });
        this.update(options);
    }
    /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */ update(options) {
        this.width = options.width ?? this.width;
        this.height = options.height ?? this.height;
        this._originalWidth = options.originalWidth ?? this._originalWidth;
        this._originalHeight = options.originalHeight ?? this._originalHeight;
        this._leftWidth = options.leftWidth ?? this._leftWidth;
        this._rightWidth = options.rightWidth ?? this._rightWidth;
        this._topHeight = options.topHeight ?? this._topHeight;
        this._bottomHeight = options.bottomHeight ?? this._bottomHeight;
        this._anchorX = options.anchor?.x;
        this._anchorY = options.anchor?.y;
        this.updateUvs();
        this.updatePositions();
    }
    /** Updates the positions of the vertices. */ updatePositions() {
        const p = this.positions;
        const { width: width, height: height, _leftWidth: _leftWidth, _rightWidth: _rightWidth, _topHeight: _topHeight, _bottomHeight: _bottomHeight, _anchorX: _anchorX, _anchorY: _anchorY } = this;
        const w = _leftWidth + _rightWidth;
        const scaleW = width > w ? 1 : width / w;
        const h = _topHeight + _bottomHeight;
        const scaleH = height > h ? 1 : height / h;
        const scale = Math.min(scaleW, scaleH);
        const anchorOffsetX = _anchorX * width;
        const anchorOffsetY = _anchorY * height;
        p[0] = p[8] = p[16] = p[24] = -anchorOffsetX;
        p[2] = p[10] = p[18] = p[26] = _leftWidth * scale - anchorOffsetX;
        p[4] = p[12] = p[20] = p[28] = width - _rightWidth * scale - anchorOffsetX;
        p[6] = p[14] = p[22] = p[30] = width - anchorOffsetX;
        p[1] = p[3] = p[5] = p[7] = -anchorOffsetY;
        p[9] = p[11] = p[13] = p[15] = _topHeight * scale - anchorOffsetY;
        p[17] = p[19] = p[21] = p[23] = height - _bottomHeight * scale - anchorOffsetY;
        p[25] = p[27] = p[29] = p[31] = height - anchorOffsetY;
        this.getBuffer("aPosition").update();
    }
    /** Updates the UVs of the vertices. */ updateUvs() {
        const uvs = this.uvs;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
        const _uvw = 1 / this._originalWidth;
        const _uvh = 1 / this._originalHeight;
        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
        this.getBuffer("aUV").update();
    }
};
/** The default options for the NineSliceGeometry. */ $2cb7f5d5e3b00a06$var$_NineSliceGeometry.defaultOptions = {
    /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ width: 100,
    /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ height: 100,
    /** The width of the left column. */ leftWidth: 10,
    /** The height of the top row. */ topHeight: 10,
    /** The width of the right column. */ rightWidth: 10,
    /** The height of the bottom row. */ bottomHeight: 10,
    /** The original width of the texture */ originalWidth: 100,
    /** The original height of the texture */ originalHeight: 100
};
let $2cb7f5d5e3b00a06$export$a1f405faf7381142 = $2cb7f5d5e3b00a06$var$_NineSliceGeometry;



var $jZ66T = parcelRequire("jZ66T");

var $4iNSL = parcelRequire("4iNSL");

var $6LhOA = parcelRequire("6LhOA");

var $9FmI1 = parcelRequire("9FmI1");


var $aZ9ZN = parcelRequire("aZ9ZN");


var $aZ9ZN = parcelRequire("aZ9ZN");

var $6tS7R = parcelRequire("6tS7R");


"use strict";
class $f661dd646069ac6f$export$33a15b7a67fcc678 extends (0, $1ad5fe12a59ec279$export$2fa0f0ec877329e3) {
    constructor(){
        super();
        this.geometry = new (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142)();
    }
    destroy() {
        this.geometry.destroy();
    }
}
class $f661dd646069ac6f$export$69030e8b070eaa80 {
    constructor(renderer){
        this._renderer = renderer;
        this._managedSprites = new (0, $6tS7R.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            name: "nineSliceSprite"
        });
    }
    addRenderable(sprite, instructionSet) {
        const gpuSprite = this._getGpuSprite(sprite);
        if (sprite.didViewUpdate) this._updateBatchableSprite(sprite, gpuSprite);
        this._renderer.renderPipes.batch.addToBatch(gpuSprite, instructionSet);
    }
    updateRenderable(sprite) {
        const gpuSprite = this._getGpuSprite(sprite);
        if (sprite.didViewUpdate) this._updateBatchableSprite(sprite, gpuSprite);
        gpuSprite._batcher.updateElement(gpuSprite);
    }
    validateRenderable(sprite) {
        const gpuSprite = this._getGpuSprite(sprite);
        return !gpuSprite._batcher.checkAndUpdateTexture(gpuSprite, sprite._texture);
    }
    _updateBatchableSprite(sprite, batchableSprite) {
        batchableSprite.geometry.update(sprite);
        batchableSprite.setTexture(sprite._texture);
    }
    _getGpuSprite(sprite) {
        return sprite._gpuData[this._renderer.uid] || this._initGPUSprite(sprite);
    }
    _initGPUSprite(sprite) {
        const gpuData = sprite._gpuData[this._renderer.uid] = new $f661dd646069ac6f$export$33a15b7a67fcc678();
        const batchableMesh = gpuData;
        batchableMesh.renderable = sprite;
        batchableMesh.transform = sprite.groupTransform;
        batchableMesh.texture = sprite._texture;
        batchableMesh.roundPixels = this._renderer._roundPixels | sprite._roundPixels;
        this._managedSprites.add(sprite);
        if (!sprite.didViewUpdate) this._updateBatchableSprite(sprite, batchableMesh);
        return gpuData;
    }
    destroy() {
        this._managedSprites.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $f661dd646069ac6f$export$69030e8b070eaa80.extension = {
    type: [
        (0, $aZ9ZN.ExtensionType).WebGLPipes,
        (0, $aZ9ZN.ExtensionType).WebGPUPipes
    ],
    name: "nineSliceSprite"
};


"use strict";
(0, $aZ9ZN.extensions).add((0, $02b35d0f8344dd2b$export$e1f940f0a61daa3c));
(0, $aZ9ZN.extensions).add((0, $f661dd646069ac6f$export$69030e8b070eaa80));


"use strict";
const $c6ed24e9ca2410f2$var$_NineSliceSprite = class _NineSliceSprite extends (0, $9FmI1.ViewContainer) {
    constructor(options){
        if (options instanceof (0, $4iNSL.Texture)) options = {
            texture: options
        };
        const { width: width, height: height, anchor: anchor, leftWidth: leftWidth, rightWidth: rightWidth, topHeight: topHeight, bottomHeight: bottomHeight, texture: texture, roundPixels: roundPixels, ...rest } = options;
        super({
            label: "NineSliceSprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "nineSliceSprite";
        /** @internal */ this.batched = true;
        this._leftWidth = leftWidth ?? texture?.defaultBorders?.left ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.leftWidth;
        this._topHeight = topHeight ?? texture?.defaultBorders?.top ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.topHeight;
        this._rightWidth = rightWidth ?? texture?.defaultBorders?.right ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.rightWidth;
        this._bottomHeight = bottomHeight ?? texture?.defaultBorders?.bottom ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.bottomHeight;
        this._width = width ?? texture.width ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.width;
        this._height = height ?? texture.height ?? (0, $2cb7f5d5e3b00a06$export$a1f405faf7381142).defaultOptions.height;
        this.allowChildren = false;
        this.texture = texture ?? _NineSliceSprite.defaultOptions.texture;
        this.roundPixels = roundPixels ?? false;
        this._anchor = new (0, $jZ66T.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (this.texture.defaultAnchor) this.anchor = this.texture.defaultAnchor;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this.onViewUpdate();
    }
    /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this.onViewUpdate();
    }
    /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        }
        this._width = value;
        this._height = height ?? value;
        this.onViewUpdate();
    }
    /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */ getSize(out) {
        out || (out = {});
        out.width = this._width;
        out.height = this._height;
        return out;
    }
    /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value;
        this.onViewUpdate();
    }
    /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value;
        this.onViewUpdate();
    }
    /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */ get texture() {
        return this._texture;
    }
    set texture(value) {
        value || (value = (0, $4iNSL.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */ get originalWidth() {
        return this._texture.width;
    }
    /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */ get originalHeight() {
        return this._texture.height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */ destroy(options) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const width = this._width;
        const height = this._height;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
};
/**
 * The default options used to override initial values of any options passed in the constructor.
 * These values are used as fallbacks when specific options are not provided.
 * @example
 * ```ts
 * // Override default options globally
 * NineSliceSprite.defaultOptions.texture = Texture.from('defaultButton.png');
 * // Create sprite with default texture
 * const sprite = new NineSliceSprite({...});
 * // sprite will use 'defaultButton.png' as its texture
 *
 * // Reset to empty texture
 * NineSliceSprite.defaultOptions.texture = Texture.EMPTY;
 * ```
 * @type {NineSliceSpriteOptions}
 * @see {@link NineSliceSpriteOptions} For all available options
 * @see {@link Texture#defaultBorders} For texture-level border settings
 */ $c6ed24e9ca2410f2$var$_NineSliceSprite.defaultOptions = {
    /** @default Texture.EMPTY */ texture: (0, $4iNSL.Texture).EMPTY
};
let $c6ed24e9ca2410f2$export$ea7c4e309714d712 = $c6ed24e9ca2410f2$var$_NineSliceSprite;
class $c6ed24e9ca2410f2$export$acdf4cb3f489544e extends $c6ed24e9ca2410f2$export$ea7c4e309714d712 {
    constructor(...args){
        let options = args[0];
        if (options instanceof (0, $4iNSL.Texture)) {
            (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "NineSlicePlane now uses the options object {texture, leftWidth, rightWidth, topHeight, bottomHeight}");
            options = {
                texture: options,
                leftWidth: args[1],
                topHeight: args[2],
                rightWidth: args[3],
                bottomHeight: args[4]
            };
        }
        (0, $6LhOA.deprecation)((0, $6LhOA.v8_0_0), "NineSlicePlane is deprecated. Use NineSliceSprite instead.");
        super(options);
    }
}













var $hAzG5 = parcelRequire("hAzG5");

var $7ScuH = parcelRequire("7ScuH");

var $hzr7O = parcelRequire("hzr7O");

var $l918V = parcelRequire("l918V");






var $2LjMw = parcelRequire("2LjMw");

var $bJb7n = parcelRequire("bJb7n");



var $a1eHr = parcelRequire("a1eHr");


var $2vcTO = parcelRequire("2vcTO");

var $1i9ku = parcelRequire("1i9ku");

var $bJb7n = parcelRequire("bJb7n");


var $dhjTN = parcelRequire("dhjTN");
"use strict";
function $e342fc99cef084de$export$c4baeb8ec88b443(options) {
    const { text: text, style: style, chars: existingChars } = options;
    const textStyle = style;
    const font = (0, $bJb7n.BitmapFontManager).getFont(text, textStyle);
    const segments = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(text);
    const layout = (0, $dhjTN.getBitmapTextLayout)(segments, textStyle, font, true);
    const scale = layout.scale;
    const chars = [];
    const words = [];
    const lines = [];
    const lineHeight = style.lineHeight ? style.lineHeight : font.lineHeight * scale;
    let yOffset = 0;
    for (const line of layout.lines){
        if (line.chars.length === 0) continue;
        const lineContainer = new (0, $2vcTO.Container)({
            label: "line"
        });
        lineContainer.y = yOffset;
        lines.push(lineContainer);
        let currentWordContainer = new (0, $2vcTO.Container)({
            label: "word"
        });
        let currentWordStartIndex = 0;
        for(let i = 0; i < line.chars.length; i++){
            const char = line.chars[i];
            if (!char) continue;
            const charData = font.chars[char];
            if (!charData) continue;
            const isSpace = char === " ";
            const isLastChar = i === line.chars.length - 1;
            let charInstance;
            if (existingChars.length > 0) {
                charInstance = existingChars.shift();
                charInstance.text = char;
                charInstance.style = textStyle;
                charInstance.label = `char-${char}`;
                charInstance.x = line.charPositions[i] * scale - line.charPositions[currentWordStartIndex] * scale;
            } else charInstance = new (0, $8095d93ccaec0291$export$ae0da96467efdba0)({
                text: char,
                style: textStyle,
                label: `char-${char}`,
                x: line.charPositions[i] * scale - line.charPositions[currentWordStartIndex] * scale
            });
            if (!isSpace) {
                chars.push(charInstance);
                currentWordContainer.addChild(charInstance);
            }
            if (isSpace || isLastChar) {
                if (currentWordContainer.children.length > 0) {
                    currentWordContainer.x = line.charPositions[currentWordStartIndex] * scale;
                    words.push(currentWordContainer);
                    lineContainer.addChild(currentWordContainer);
                    currentWordContainer = new (0, $2vcTO.Container)({
                        label: "word"
                    });
                    currentWordStartIndex = i + 1;
                }
            }
        }
        yOffset += lineHeight;
    }
    return {
        chars: chars,
        lines: lines,
        words: words
    };
}



var $dhjTN = parcelRequire("dhjTN");

var $3beWQ = parcelRequire("3beWQ");
















var $2vcTO = parcelRequire("2vcTO");

var $bFX43 = parcelRequire("bFX43");
"use strict";
class $f11d0ef2e560b73e$export$1a3cb0bc6a690913 extends (0, $2vcTO.Container) {
    constructor(config){
        const { text: text, style: style, autoSplit: autoSplit, lineAnchor: lineAnchor, wordAnchor: wordAnchor, charAnchor: charAnchor, ...options } = config;
        super(options);
        this._dirty = false;
        this._canReuseChars = false;
        this.chars = [];
        this.words = [];
        this.lines = [];
        this._originalText = text;
        this._autoSplit = autoSplit;
        this._lineAnchor = lineAnchor;
        this._wordAnchor = wordAnchor;
        this._charAnchor = charAnchor;
        this.style = style;
    }
    /**
   * Splits the text into lines, words, and characters.
   * Call this manually when autoSplit is false.
   * @example Manual Splitting
   * ```ts
   * const text = new SplitText({
   *   text: 'Manual Update',
   *   autoSplit: false
   * });
   *
   * text.text = 'New Content';
   * text.style = { fontSize: 32 };
   * text.split(); // Apply changes
   * ```
   */ split() {
        const res = this.splitFn();
        this.chars = res.chars;
        this.words = res.words;
        this.lines = res.lines;
        this.addChild(...this.lines);
        this.charAnchor = this._charAnchor;
        this.wordAnchor = this._wordAnchor;
        this.lineAnchor = this._lineAnchor;
        this._dirty = false;
        this._canReuseChars = true;
    }
    get text() {
        return this._originalText;
    }
    /**
   * Gets or sets the text content.
   * Setting new text triggers splitting if autoSplit is true.
   * > [!NOTE] Setting this frequently can have a performance impact, especially with large texts and canvas text.
   * @example Dynamic Text Updates
   * ```ts
   * const text = new SplitText({
   *   text: 'Original',
   *   autoSplit: true
   * });
   *
   * // Auto-splits on change
   * text.text = 'Updated Content';
   *
   * // Manual update
   * text.autoSplit = false;
   * text.text = 'Manual Update';
   * text.split();
   * ```
   */ set text(value) {
        this._originalText = value;
        this.lines.forEach((line)=>line.destroy({
                children: true
            }));
        this.lines.length = 0;
        this.words.length = 0;
        this.chars.length = 0;
        this._canReuseChars = false;
        this.onTextUpdate();
    }
    _setOrigin(value, elements, property) {
        let originPoint;
        if (typeof value === "number") originPoint = {
            x: value,
            y: value
        };
        else originPoint = {
            x: value.x,
            y: value.y
        };
        elements.forEach((element)=>{
            const localBounds = element.getLocalBounds();
            const originX = localBounds.minX + localBounds.width * originPoint.x;
            const originY = localBounds.minY + localBounds.height * originPoint.y;
            element.origin.set(originX, originY);
        });
        this[property] = value;
    }
    /**
   * Gets or sets the transform anchor for line segments.
   * The anchor point determines the center of rotation and scaling for each line.
   * @example Setting Line Anchors
   * ```ts
   * // Center rotation/scaling
   * text.lineAnchor = 0.5;
   *
   * // Rotate/scale from top-right corner
   * text.lineAnchor = { x: 1, y: 0 };
   *
   * // Custom anchor point
   * text.lineAnchor = {
   *   x: 0.2, // 20% from left
   *   y: 0.8  // 80% from top
   * };
   * ```
   */ get lineAnchor() {
        return this._lineAnchor;
    }
    set lineAnchor(value) {
        this._setOrigin(value, this.lines, "_lineAnchor");
    }
    /**
   * Gets or sets the transform anchor for word segments.
   * The anchor point determines the center of rotation and scaling for each word.
   * @example
   * ```ts
   * // Center each word
   * text.wordAnchor = 0.5;
   *
   * // Scale from bottom-left
   * text.wordAnchor = { x: 0, y: 1 };
   *
   * // Rotate around custom point
   * text.wordAnchor = {
   *   x: 0.75,  // 75% from left
   *   y: 0.5    // Middle vertically
   * };
   * ```
   */ get wordAnchor() {
        return this._wordAnchor;
    }
    set wordAnchor(value) {
        this._setOrigin(value, this.words, "_wordAnchor");
    }
    /**
   * Gets or sets the transform anchor for character segments.
   * The anchor point determines the center of rotation and scaling for each character.
   * @example Setting Character Anchors
   * ```ts
   * // Center each character
   * text.charAnchor = 0.5;
   *
   * // Rotate from top-center
   * text.charAnchor = { x: 0.5, y: 0 };
   *
   * // Scale from bottom-right
   * text.charAnchor = { x: 1, y: 1 };
   * ```
   * @example Animation with Anchors
   * ```ts
   * // Rotate characters around their centers
   * text.charAnchor = 0.5;
   * text.chars.forEach((char, i) => {
   *   gsap.to(char, {
   *     rotation: Math.PI * 2,
   *     duration: 1,
   *     delay: i * 0.1,
   *     repeat: -1
   *   });
   * });
   * ```
   */ get charAnchor() {
        return this._charAnchor;
    }
    set charAnchor(value) {
        this._setOrigin(value, this.chars, "_charAnchor");
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style = new (0, $bFX43.TextStyle)(style);
        this.styleChanged();
    }
    /**
   * Used to notify the text that the style has changed.
   * This will re-split the text and re-apply the style.
   * @example
   * ```ts
   * text.style.fontSize = 32;
   * text.styleChanged();
   * ```
   */ styleChanged() {
        this.words.forEach((word)=>word.destroy());
        this.words.length = 0;
        this.lines.forEach((line)=>line.destroy());
        this.lines.length = 0;
        this._canReuseChars = true;
        this.onTextUpdate();
    }
    onTextUpdate() {
        this._dirty = true;
        if (this._autoSplit) this.split();
    }
    /**
   * Destroys the SplitText instance and all its resources.
   * Cleans up all segment arrays, event listeners, and optionally the text style.
   * @param options - Destroy configuration options
   * @example
   * ```ts
   * // Clean up everything
   * text.destroy({ children: true, texture: true, style: true });
   *
   * // Remove from parent but keep style
   * text.destroy({ children: true, style: false });
   * ```
   */ destroy(options) {
        super.destroy(options);
        this.chars = [];
        this.words = [];
        this.lines = [];
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._originalText = "";
    }
}



var $bFX43 = parcelRequire("bFX43");


"use strict";
const $a2e15b36e18ce720$var$_SplitBitmapText = class _SplitBitmapText extends (0, $f11d0ef2e560b73e$export$1a3cb0bc6a690913) {
    constructor(config){
        var _a;
        const completeOptions = {
            ..._SplitBitmapText.defaultOptions,
            ...config
        };
        completeOptions.style ?? (completeOptions.style = {});
        (_a = completeOptions.style).fill ?? (_a.fill = 16777215);
        super(completeOptions);
    }
    /**
   * Creates a SplitBitmapText instance from an existing text object.
   * Useful for converting standard Text or BitmapText objects into segmented versions.
   * @param text - The source text object to convert
   * @param options - Additional splitting options
   * @returns A new SplitBitmapText instance
   * @example
   * ```ts
   * const bitmapText = new BitmapText({
   *   text: 'Bitmap Text',
   *   style: { fontFamily: 'Arial' }
   * });
   *
   * const segmented = SplitBitmapText.from(bitmapText);
   *
   * // with additional options
   * const segmentedWithOptions = SplitBitmapText.from(bitmapText, {
   *   autoSplit: false,
   *   lineAnchor: 0.5,
   *   wordAnchor: { x: 0, y: 0.5 },
   * })
   * ```
   */ static from(text, options) {
        const completeOptions = {
            ..._SplitBitmapText.defaultOptions,
            ...options,
            text: text.text,
            style: new (0, $bFX43.TextStyle)(text.style)
        };
        const splitText = new _SplitBitmapText({
            ...completeOptions
        });
        const anchor = text.anchor;
        if (anchor.x !== 0 || anchor.y !== 0) splitText.pivot.set(splitText.width * anchor.x, splitText.height * anchor.y);
        return splitText;
    }
    splitFn() {
        return (0, $e342fc99cef084de$export$c4baeb8ec88b443)({
            text: this._originalText,
            style: this._style,
            chars: this._canReuseChars ? this.chars : []
        });
    }
};
/**
 * Default configuration options for SplitBitmapText instances.
 * @example
 * ```ts
 * // Override defaults globally
 * SplitBitmapText.defaultOptions = {
 *   autoSplit: false,
 *   lineAnchor: 0.5,  // Center alignment
 *   wordAnchor: { x: 0, y: 0.5 },  // Left-center
 *   charAnchor: { x: 0.5, y: 1 }   // Bottom-center
 * };
 * ```
 */ $a2e15b36e18ce720$var$_SplitBitmapText.defaultOptions = {
    autoSplit: true,
    // Auto-update on text/style changes
    lineAnchor: 0,
    // Top-left alignment
    wordAnchor: 0,
    // Top-left alignment
    charAnchor: 0
};
let $a2e15b36e18ce720$export$d99c5cc46c9929e3 = $a2e15b36e18ce720$var$_SplitBitmapText;



var $bFX43 = parcelRequire("bFX43");

var $5xi4h = parcelRequire("5xi4h");

var $2vcTO = parcelRequire("2vcTO");

var $hkzHY = parcelRequire("hkzHY");


var $1i9ku = parcelRequire("1i9ku");

"use strict";
function $85f5f6adfc6fb403$var$getAlignmentOffset(alignment, lineWidth, largestLine) {
    switch(alignment){
        case "center":
            return (largestLine - lineWidth) / 2;
        case "right":
            return largestLine - lineWidth;
        case "left":
        default:
            return 0;
    }
}
function $85f5f6adfc6fb403$var$isNewlineCharacter(char) {
    return char === "\r" || char === "\n" || char === "\r\n";
}
function $85f5f6adfc6fb403$var$groupTextSegments(segments, measuredText, textStyle) {
    const groupedSegments = [];
    let currentLine = measuredText.lines[0];
    let matchedLine = "";
    let chars = [];
    let lineCount = 0;
    textStyle.wordWrap = false;
    segments.forEach((segment)=>{
        const isWhitespace = /^\s*$/.test(segment);
        const isNewline = $85f5f6adfc6fb403$var$isNewlineCharacter(segment);
        const isSpaceAtStart = matchedLine.length === 0 && isWhitespace;
        if (isWhitespace && !isNewline && isSpaceAtStart) return;
        if (!isNewline) matchedLine += segment;
        const metric = (0, $1i9ku.CanvasTextMetrics).measureText(segment, textStyle);
        chars.push({
            char: segment,
            metric: metric
        });
        if (matchedLine.length >= currentLine.length) {
            groupedSegments.push({
                line: matchedLine,
                chars: chars,
                width: chars.reduce((acc, seg)=>acc + seg.metric.width, 0)
            });
            chars = [];
            matchedLine = "";
            lineCount++;
            currentLine = measuredText.lines[lineCount];
        }
    });
    return groupedSegments;
}
function $85f5f6adfc6fb403$export$12b1923ae80376f9(options) {
    const { text: text, style: style, chars: existingChars } = options;
    const textStyle = style;
    const measuredText = (0, $1i9ku.CanvasTextMetrics).measureText(text, textStyle);
    const segments = (0, $1i9ku.CanvasTextMetrics).graphemeSegmenter(text);
    const groupedSegments = $85f5f6adfc6fb403$var$groupTextSegments(segments, measuredText, textStyle.clone());
    const alignment = textStyle.align;
    const maxLineWidth = measuredText.lineWidths.reduce((max, line)=>Math.max(max, line), 0);
    const isSingleLine = measuredText.lines.length === 1;
    const useWordWrapWidth = !isSingleLine && textStyle.wordWrap;
    const alignWidth = useWordWrapWidth ? textStyle.wordWrapWidth : maxLineWidth;
    const fillGradient = textStyle._fill?.fill;
    const strokeGradient = textStyle._stroke?.fill;
    const hasFillGradient = fillGradient instanceof (0, $hkzHY.FillGradient);
    const hasStrokeGradient = strokeGradient instanceof (0, $hkzHY.FillGradient);
    const hasGradient = hasFillGradient || hasStrokeGradient;
    const hasLocalGradient = hasFillGradient && fillGradient.textureSpace === "local" || hasStrokeGradient && strokeGradient.textureSpace === "local";
    const fullTextWidth = measuredText.width;
    const fullTextHeight = measuredText.height;
    const baseCharStyle = textStyle.clone();
    baseCharStyle.align = "left";
    let trimOffsetX = 0;
    let trimOffsetY = 0;
    if (baseCharStyle.trim) {
        const { frame: frame, canvasAndContext: canvasAndContext } = (0, $7a49002c4353b76b$export$bb54b62b519176d5).getCanvasAndContext({
            text: text,
            style: textStyle,
            resolution: 1
        });
        (0, $7a49002c4353b76b$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
        trimOffsetX = -frame.x;
        trimOffsetY = -frame.y;
        baseCharStyle.trim = false;
    }
    const chars = [];
    const lineContainers = [];
    const wordContainers = [];
    let yOffset = 0;
    const strokeWidth = textStyle._stroke?.width || 0;
    const dropShadowDistance = textStyle.dropShadow?.distance || 0;
    groupedSegments.forEach((group, lineIndex)=>{
        const lineContainer = new (0, $2vcTO.Container)({
            label: `line-${lineIndex}`
        });
        lineContainer.y = yOffset + trimOffsetY;
        lineContainers.push(lineContainer);
        const lineWidth = measuredText.lineWidths[lineIndex];
        let xOffset = $85f5f6adfc6fb403$var$getAlignmentOffset(alignment, lineWidth, alignWidth);
        let currentWordContainer = new (0, $2vcTO.Container)({
            label: "word"
        });
        currentWordContainer.x = xOffset + trimOffsetX;
        group.chars.forEach((segment, charIndex)=>{
            if (segment.metric.width === 0) return;
            if ($85f5f6adfc6fb403$var$isNewlineCharacter(segment.char)) {
                xOffset += segment.metric.width - strokeWidth;
                return;
            }
            if (segment.char === " ") {
                if (currentWordContainer.children.length > 0) {
                    wordContainers.push(currentWordContainer);
                    lineContainer.addChild(currentWordContainer);
                }
                xOffset += segment.metric.width + textStyle.letterSpacing - strokeWidth;
                currentWordContainer = new (0, $2vcTO.Container)({
                    label: "word"
                });
                currentWordContainer.x = xOffset + trimOffsetX;
            } else {
                let charStyle = baseCharStyle;
                if (hasGradient) {
                    charStyle = baseCharStyle.clone();
                    charStyle._gradientOffset = {
                        x: -xOffset,
                        y: -yOffset
                    };
                    if (hasLocalGradient) charStyle._gradientBounds = {
                        width: fullTextWidth,
                        height: fullTextHeight
                    };
                }
                let char;
                if (existingChars.length > 0) {
                    char = existingChars.shift();
                    char.text = segment.char;
                    char.style = charStyle;
                    char.setFromMatrix((0, $5xi4h.Matrix).IDENTITY);
                    char.x = xOffset - currentWordContainer.x + trimOffsetX - dropShadowDistance * charIndex;
                } else char = new (0, $f3e48f5b83971e92$export$5f1af8db9871e1d6)({
                    text: segment.char,
                    style: charStyle,
                    x: xOffset - currentWordContainer.x + trimOffsetX - dropShadowDistance * charIndex
                });
                chars.push(char);
                currentWordContainer.addChild(char);
                xOffset += segment.metric.width + textStyle.letterSpacing - strokeWidth;
            }
        });
        if (currentWordContainer.children.length > 0) {
            wordContainers.push(currentWordContainer);
            lineContainer.addChild(currentWordContainer);
        }
        yOffset += measuredText.lineHeight;
    });
    return {
        chars: chars,
        lines: lineContainers,
        words: wordContainers
    };
}



"use strict";
const $798014962b0dedae$var$_SplitText = class _SplitText extends (0, $f11d0ef2e560b73e$export$1a3cb0bc6a690913) {
    constructor(config){
        const completeOptions = {
            ..._SplitText.defaultOptions,
            ...config
        };
        super(completeOptions);
    }
    /**
   * Creates a SplitText instance from an existing text object.
   * Useful for converting standard Text or Text objects into segmented versions.
   * @param text - The source text object to convert
   * @param options - Additional splitting options
   * @returns A new SplitText instance
   * @example
   * ```ts
   * const text = new Text({
   *   text: 'Bitmap Text',
   *   style: { fontFamily: 'Arial' }
   * });
   *
   * const segmented = SplitText.from(text);
   *
   * // with additional options
   * const segmentedWithOptions = SplitText.from(text, {
   *   autoSplit: false,
   *   lineAnchor: 0.5,
   *   wordAnchor: { x: 0, y: 0.5 },
   * })
   * ```
   */ static from(text, options) {
        const completeOptions = {
            ..._SplitText.defaultOptions,
            ...options,
            text: text.text,
            style: new (0, $bFX43.TextStyle)(text.style)
        };
        const splitText = new _SplitText({
            ...completeOptions
        });
        const anchor = text.anchor;
        if (anchor.x !== 0 || anchor.y !== 0) splitText.pivot.set(splitText.width * anchor.x, splitText.height * anchor.y);
        return splitText;
    }
    splitFn() {
        return (0, $85f5f6adfc6fb403$export$12b1923ae80376f9)({
            text: this._originalText,
            style: this._style,
            chars: this._canReuseChars ? this.chars : []
        });
    }
};
/**
 * Default configuration options for SplitText instances.
 * @example
 * ```ts
 * // Override defaults globally
 * SplitText.defaultOptions = {
 *   autoSplit: false,
 *   lineAnchor: 0.5,  // Center alignment
 *   wordAnchor: { x: 0, y: 0.5 },  // Left-center
 *   charAnchor: { x: 0.5, y: 1 }   // Bottom-center
 * };
 * ```
 */ $798014962b0dedae$var$_SplitText.defaultOptions = {
    autoSplit: true,
    // Auto-update on text/style changes
    lineAnchor: 0,
    // Top-left alignment
    wordAnchor: 0,
    // Top-left alignment
    charAnchor: 0
};
let $798014962b0dedae$export$bd0fa428528371b2 = $798014962b0dedae$var$_SplitText;






var $1i9ku = parcelRequire("1i9ku");



var $3FldU = parcelRequire("3FldU");

var $hFmvn = parcelRequire("hFmvn");

var $io8hC = parcelRequire("io8hC");

var $8jcQu = parcelRequire("8jcQu");

var $gAfNu = parcelRequire("gAfNu");

var $4R0nM = parcelRequire("4R0nM");







var $bFX43 = parcelRequire("bFX43");


var $dKHyW = parcelRequire("dKHyW");
"use strict";
const $194697e15c8b47d8$var$valuesToIterateForKeys = [
    "align",
    "breakWords",
    "cssOverrides",
    "fontVariant",
    "fontWeight",
    "leading",
    "letterSpacing",
    "lineHeight",
    "padding",
    "textBaseline",
    "trim",
    "whiteSpace",
    "wordWrap",
    "wordWrapWidth",
    "fontFamily",
    "fontStyle",
    "fontSize"
];
function $194697e15c8b47d8$export$8a3681e2b47964bb(style) {
    const key = [];
    let index = 0;
    for(let i = 0; i < $194697e15c8b47d8$var$valuesToIterateForKeys.length; i++){
        const prop = `_${$194697e15c8b47d8$var$valuesToIterateForKeys[i]}`;
        key[index++] = style[prop];
    }
    index = $194697e15c8b47d8$var$addFillStyleKey(style._fill, key, index);
    index = $194697e15c8b47d8$var$addStokeStyleKey(style._stroke, key, index);
    index = $194697e15c8b47d8$var$addDropShadowKey(style.dropShadow, key, index);
    index = $194697e15c8b47d8$var$addFiltersKey(style.filters, key, index);
    return key.join("-");
}
function $194697e15c8b47d8$var$addFiltersKey(filters, key, index) {
    if (!filters) return index;
    for (const filter of filters)key[index++] = filter.uid;
    return index;
}
function $194697e15c8b47d8$var$addFillStyleKey(fillStyle, key, index) {
    if (!fillStyle) return index;
    key[index++] = fillStyle.color;
    key[index++] = fillStyle.alpha;
    key[index++] = fillStyle.fill?.styleKey;
    return index;
}
function $194697e15c8b47d8$var$addStokeStyleKey(strokeStyle, key, index) {
    if (!strokeStyle) return index;
    index = $194697e15c8b47d8$var$addFillStyleKey(strokeStyle, key, index);
    key[index++] = strokeStyle.width;
    key[index++] = strokeStyle.alignment;
    key[index++] = strokeStyle.cap;
    key[index++] = strokeStyle.join;
    key[index++] = strokeStyle.miterLimit;
    return index;
}
function $194697e15c8b47d8$var$addDropShadowKey(dropShadow, key, index) {
    if (!dropShadow) return index;
    key[index++] = dropShadow.alpha;
    key[index++] = dropShadow.angle;
    key[index++] = dropShadow.blur;
    key[index++] = dropShadow.distance;
    key[index++] = (0, $dKHyW.Color).shared.setValue(dropShadow.color).toNumber();
    return index;
}





var $9FmI1 = parcelRequire("9FmI1");

var $bbFev = parcelRequire("bbFev");

var $7oygg = parcelRequire("7oygg");

var $2HyEq = parcelRequire("2HyEq");

var $jM8Go = parcelRequire("jM8Go");

var $92Lva = parcelRequire("92Lva");

var $7X2qc = parcelRequire("7X2qc");

var $c6cSg = parcelRequire("c6cSg");

var $llcp4 = parcelRequire("llcp4");



var $p4165 = parcelRequire("p4165");


var $7UNC6 = parcelRequire("7UNC6");

var $6AQ4q = parcelRequire("6AQ4q");

var $2H4Cq = parcelRequire("2H4Cq");

var $6tS7R = parcelRequire("6tS7R");

var $02QFP = parcelRequire("02QFP");

var $1bMtF = parcelRequire("1bMtF");

var $4ZJmt = parcelRequire("4ZJmt");

var $4SZYy = parcelRequire("4SZYy");

var $2xyZ0 = parcelRequire("2xyZ0");

var $6LhOA = parcelRequire("6LhOA");

var $bfcaK = parcelRequire("bfcaK");
"use strict";
async function $304da01ea80e745d$export$3fe20a7807b0d5f6(texture, renderer, size = 200) {
    const base64 = await renderer.extract.base64(texture);
    if (renderer.type !== (0, $bfcaK.RendererType).CANVAS) await renderer.encoder.commandFinished;
    const width = size;
    console.log(`logging texture ${texture.source.width}px ${texture.source.height}px`);
    const style = [
        "font-size: 1px;",
        `padding: ${width}px ${300}px;`,
        `background: url(${base64}) no-repeat;`,
        "background-size: contain;"
    ].join(" ");
    console.log("%c ", style);
}



var $7ScuH = parcelRequire("7ScuH");
"use strict";
const $991d162da29ea311$var$colors = [
    "#000080",
    // Navy Blue
    "#228B22",
    // Forest Green
    "#8B0000",
    // Dark Red
    "#4169E1",
    // Royal Blue
    "#008080",
    // Teal
    "#800000",
    // Maroon
    "#9400D3",
    // Dark Violet
    "#FF8C00",
    // Dark Orange
    "#556B2F",
    // Olive Green
    "#8B008B"
];
let $991d162da29ea311$var$colorTick = 0;
function $991d162da29ea311$export$db44722c32b78b1e(container, depth = 0, data = {
    color: "#000000"
}) {
    if (container.renderGroup) data.color = $991d162da29ea311$var$colors[$991d162da29ea311$var$colorTick++];
    let spaces = "";
    for(let i = 0; i < depth; i++)spaces += "    ";
    let label = container.label;
    if (!label && container instanceof (0, $7ScuH.Sprite)) label = `sprite:${container.texture.label}`;
    let output = `%c ${spaces}|- ${label} (worldX:${container.worldTransform.tx}, relativeRenderX:${container.relativeGroupTransform.tx}, renderX:${container.groupTransform.tx}, localX:${container.x})`;
    if (container.renderGroup) output += " (RenderGroup)";
    if (container.filters) output += "(*filters)";
    console.log(output, `color:${data.color}; font-weight:bold;`);
    depth++;
    for(let i = 0; i < container.children.length; i++){
        const child = container.children[i];
        $991d162da29ea311$export$db44722c32b78b1e(child, depth, {
            ...data
        });
    }
}
function $991d162da29ea311$export$996a4ef50286b42b(renderGroup, depth = 0, data = {
    index: 0,
    color: "#000000"
}) {
    let spaces = "";
    for(let i = 0; i < depth; i++)spaces += "    ";
    const output = `%c ${spaces}- ${data.index}: ${renderGroup.root.label} worldX:${renderGroup.worldTransform.tx}`;
    console.log(output, `color:${data.color}; font-weight:bold;`);
    depth++;
    for(let i = 0; i < renderGroup.renderGroupChildren.length; i++){
        const child = renderGroup.renderGroupChildren[i];
        $991d162da29ea311$export$996a4ef50286b42b(child, depth, {
            ...data,
            index: i
        });
    }
}



var $1RpxL = parcelRequire("1RpxL");

var $cH88K = parcelRequire("cH88K");



var $208Yz = parcelRequire("208Yz");

var $fpmqC = parcelRequire("fpmqC");

var $jsdyy = parcelRequire("jsdyy");

var $dokhj = parcelRequire("dokhj");

var $kbFTd = parcelRequire("kbFTd");

var $eyVYu = parcelRequire("eyVYu");
"use strict";
(0, $aZ9ZN.extensions).add((0, $eba5d1440b0da934$export$a6aad6334ef58a1c), (0, $91e6560b74ff6b18$export$ee43dd1acddf6cf8));


var $0384f65d82dc5c27$exports = {};

$parcel$export($0384f65d82dc5c27$exports, "int32", () => $0384f65d82dc5c27$export$1d95835383bb05a);
$parcel$export($0384f65d82dc5c27$exports, "int53", () => $0384f65d82dc5c27$export$19ee924d4eeaa52);
$parcel$export($0384f65d82dc5c27$exports, "int53Full", () => $0384f65d82dc5c27$export$f9ddb966c7d7fb1b);
$parcel$export($0384f65d82dc5c27$exports, "uint32", () => $0384f65d82dc5c27$export$de9ffb9418dd7d0d);
$parcel$export($0384f65d82dc5c27$exports, "uint53", () => $0384f65d82dc5c27$export$6bf94e3d82617e4e);
$parcel$export($0384f65d82dc5c27$exports, "uint53Full", () => $0384f65d82dc5c27$export$1eac5f65f624910c);
$parcel$export($0384f65d82dc5c27$exports, "integer", () => $0384f65d82dc5c27$export$32744b5b3bba4764);
$parcel$export($0384f65d82dc5c27$exports, "bool", () => $0384f65d82dc5c27$export$87b259aa03e3d267);
$parcel$export($0384f65d82dc5c27$exports, "date", () => $0384f65d82dc5c27$export$324d90190a8b822a);
$parcel$export($0384f65d82dc5c27$exports, "die", () => $0384f65d82dc5c27$export$1a64584e86ab64a2);
$parcel$export($0384f65d82dc5c27$exports, "dice", () => $0384f65d82dc5c27$export$19a18205b2511a55);
$parcel$export($0384f65d82dc5c27$exports, "string", () => $0384f65d82dc5c27$export$22b082955e083ec3);
$parcel$export($0384f65d82dc5c27$exports, "hex", () => $0384f65d82dc5c27$export$834dfc94dde4b3d8);
$parcel$export($0384f65d82dc5c27$exports, "pick", () => $0384f65d82dc5c27$export$357523c63a2253b9);
$parcel$export($0384f65d82dc5c27$exports, "realZeroToOneExclusive", () => $0384f65d82dc5c27$export$62dc36fcdd132955);
$parcel$export($0384f65d82dc5c27$exports, "realZeroToOneInclusive", () => $0384f65d82dc5c27$export$2326f868411f3bcb);
$parcel$export($0384f65d82dc5c27$exports, "real", () => $0384f65d82dc5c27$export$9fc57fb453bdbd67);
$parcel$export($0384f65d82dc5c27$exports, "shuffle", () => $0384f65d82dc5c27$export$448332262467e042);
$parcel$export($0384f65d82dc5c27$exports, "sample", () => $0384f65d82dc5c27$export$4812e460280c6ef2);
$parcel$export($0384f65d82dc5c27$exports, "uuid4", () => $0384f65d82dc5c27$export$19f53698e68b2496);
$parcel$export($0384f65d82dc5c27$exports, "nativeMath", () => $0384f65d82dc5c27$export$4cfa9414948deaef);
$parcel$export($0384f65d82dc5c27$exports, "Random", () => $0384f65d82dc5c27$export$a92776769f460054);
$parcel$export($0384f65d82dc5c27$exports, "browserCrypto", () => $0384f65d82dc5c27$export$c330f985105d70e2);
$parcel$export($0384f65d82dc5c27$exports, "createEntropy", () => $0384f65d82dc5c27$export$751d251274833ff);
$parcel$export($0384f65d82dc5c27$exports, "MersenneTwister19937", () => $0384f65d82dc5c27$export$b73f0219bb70a91f);
$parcel$export($0384f65d82dc5c27$exports, "nodeCrypto", () => $0384f65d82dc5c27$export$f46970436a81fadf);
$parcel$export($0384f65d82dc5c27$exports, "picker", () => $0384f65d82dc5c27$export$86410c4345f8840e);
const $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER = 0x20000000000000;
const $0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER = $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER - 1;
const $0384f65d82dc5c27$var$UINT32_MAX = 4294967295;
const $0384f65d82dc5c27$var$UINT32_SIZE = $0384f65d82dc5c27$var$UINT32_MAX + 1;
const $0384f65d82dc5c27$var$INT32_SIZE = $0384f65d82dc5c27$var$UINT32_SIZE / 2;
const $0384f65d82dc5c27$var$INT32_MAX = $0384f65d82dc5c27$var$INT32_SIZE - 1;
const $0384f65d82dc5c27$var$UINT21_SIZE = 2097152;
const $0384f65d82dc5c27$var$UINT21_MAX = $0384f65d82dc5c27$var$UINT21_SIZE - 1;
/**
 * Returns a value within [-0x80000000, 0x7fffffff]
 */ function $0384f65d82dc5c27$export$1d95835383bb05a(engine) {
    return engine.next() | 0;
}
function $0384f65d82dc5c27$var$add(distribution, addend) {
    if (addend === 0) return distribution;
    else return (engine)=>distribution(engine) + addend;
}
/**
 * Returns a value within [-0x20000000000000, 0x1fffffffffffff]
 */ function $0384f65d82dc5c27$export$19ee924d4eeaa52(engine) {
    const high = engine.next() | 0;
    const low = engine.next() >>> 0;
    return (high & $0384f65d82dc5c27$var$UINT21_MAX) * $0384f65d82dc5c27$var$UINT32_SIZE + low + (high & $0384f65d82dc5c27$var$UINT21_SIZE ? -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER : 0);
}
/**
 * Returns a value within [-0x20000000000000, 0x20000000000000]
 */ function $0384f65d82dc5c27$export$f9ddb966c7d7fb1b(engine) {
    while(true){
        const high = engine.next() | 0;
        if (high & 0x400000) {
            if ((high & 0x7fffff) === 0x400000 && (engine.next() | 0) === 0) return $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER;
        } else {
            const low = engine.next() >>> 0;
            return (high & $0384f65d82dc5c27$var$UINT21_MAX) * $0384f65d82dc5c27$var$UINT32_SIZE + low + (high & $0384f65d82dc5c27$var$UINT21_SIZE ? -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER : 0);
        }
    }
}
/**
 * Returns a value within [0, 0xffffffff]
 */ function $0384f65d82dc5c27$export$de9ffb9418dd7d0d(engine) {
    return engine.next() >>> 0;
}
/**
 * Returns a value within [0, 0x1fffffffffffff]
 */ function $0384f65d82dc5c27$export$6bf94e3d82617e4e(engine) {
    const high = engine.next() & $0384f65d82dc5c27$var$UINT21_MAX;
    const low = engine.next() >>> 0;
    return high * $0384f65d82dc5c27$var$UINT32_SIZE + low;
}
/**
 * Returns a value within [0, 0x20000000000000]
 */ function $0384f65d82dc5c27$export$1eac5f65f624910c(engine) {
    while(true){
        const high = engine.next() | 0;
        if (high & $0384f65d82dc5c27$var$UINT21_SIZE) {
            if ((high & $0384f65d82dc5c27$var$UINT21_MAX) === 0 && (engine.next() | 0) === 0) return $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER;
        } else {
            const low = engine.next() >>> 0;
            return (high & $0384f65d82dc5c27$var$UINT21_MAX) * $0384f65d82dc5c27$var$UINT32_SIZE + low;
        }
    }
}
function $0384f65d82dc5c27$var$isPowerOfTwoMinusOne(value) {
    return (value + 1 & value) === 0;
}
function $0384f65d82dc5c27$var$bitmask(masking) {
    return (engine)=>engine.next() & masking;
}
function $0384f65d82dc5c27$var$downscaleToLoopCheckedRange(range) {
    const extendedRange = range + 1;
    const maximum = extendedRange * Math.floor($0384f65d82dc5c27$var$UINT32_SIZE / extendedRange);
    return (engine)=>{
        let value = 0;
        do value = engine.next() >>> 0;
        while (value >= maximum);
        return value % extendedRange;
    };
}
function $0384f65d82dc5c27$var$downscaleToRange(range) {
    if ($0384f65d82dc5c27$var$isPowerOfTwoMinusOne(range)) return $0384f65d82dc5c27$var$bitmask(range);
    else return $0384f65d82dc5c27$var$downscaleToLoopCheckedRange(range);
}
function $0384f65d82dc5c27$var$isEvenlyDivisibleByMaxInt32(value) {
    return (value | 0) === 0;
}
function $0384f65d82dc5c27$var$upscaleWithHighMasking(masking) {
    return (engine)=>{
        const high = engine.next() & masking;
        const low = engine.next() >>> 0;
        return high * $0384f65d82dc5c27$var$UINT32_SIZE + low;
    };
}
function $0384f65d82dc5c27$var$upscaleToLoopCheckedRange(extendedRange) {
    const maximum = extendedRange * Math.floor($0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER / extendedRange);
    return (engine)=>{
        let ret = 0;
        do {
            const high = engine.next() & $0384f65d82dc5c27$var$UINT21_MAX;
            const low = engine.next() >>> 0;
            ret = high * $0384f65d82dc5c27$var$UINT32_SIZE + low;
        }while (ret >= maximum);
        return ret % extendedRange;
    };
}
function $0384f65d82dc5c27$var$upscaleWithinU53(range) {
    const extendedRange = range + 1;
    if ($0384f65d82dc5c27$var$isEvenlyDivisibleByMaxInt32(extendedRange)) {
        const highRange = (extendedRange / $0384f65d82dc5c27$var$UINT32_SIZE | 0) - 1;
        if ($0384f65d82dc5c27$var$isPowerOfTwoMinusOne(highRange)) return $0384f65d82dc5c27$var$upscaleWithHighMasking(highRange);
    }
    return $0384f65d82dc5c27$var$upscaleToLoopCheckedRange(extendedRange);
}
function $0384f65d82dc5c27$var$upscaleWithinI53AndLoopCheck(min, max) {
    return (engine)=>{
        let ret = 0;
        do {
            const high = engine.next() | 0;
            const low = engine.next() >>> 0;
            ret = (high & $0384f65d82dc5c27$var$UINT21_MAX) * $0384f65d82dc5c27$var$UINT32_SIZE + low + (high & $0384f65d82dc5c27$var$UINT21_SIZE ? -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER : 0);
        }while (ret < min || ret > max);
        return ret;
    };
}
/**
 * Returns a Distribution to return a value within [min, max]
 * @param min The minimum integer value, inclusive. No less than -0x20000000000000.
 * @param max The maximum integer value, inclusive. No greater than 0x20000000000000.
 */ function $0384f65d82dc5c27$export$32744b5b3bba4764(min, max) {
    min = Math.floor(min);
    max = Math.floor(max);
    if (min < -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER || !isFinite(min)) throw new RangeError(`Expected min to be at least ${-$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER}`);
    else if (max > $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER || !isFinite(max)) throw new RangeError(`Expected max to be at most ${$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER}`);
    const range = max - min;
    if (range <= 0 || !isFinite(range)) return ()=>min;
    else if (range === $0384f65d82dc5c27$var$UINT32_MAX) {
        if (min === 0) return $0384f65d82dc5c27$export$de9ffb9418dd7d0d;
        else return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$export$1d95835383bb05a, min + $0384f65d82dc5c27$var$INT32_SIZE);
    } else if (range < $0384f65d82dc5c27$var$UINT32_MAX) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$var$downscaleToRange(range), min);
    else if (range === $0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$export$6bf94e3d82617e4e, min);
    else if (range < $0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$var$upscaleWithinU53(range), min);
    else if (max - 1 - min === $0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$export$1eac5f65f624910c, min);
    else if (min === -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER && max === $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER) return $0384f65d82dc5c27$export$f9ddb966c7d7fb1b;
    else if (min === -$0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER && max === $0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER) return $0384f65d82dc5c27$export$19ee924d4eeaa52;
    else if (min === -$0384f65d82dc5c27$var$LARGEST_SAFE_INTEGER && max === $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$export$19ee924d4eeaa52, 1);
    else if (max === $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER) return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$var$upscaleWithinI53AndLoopCheck(min - 1, max - 1), 1);
    else return $0384f65d82dc5c27$var$upscaleWithinI53AndLoopCheck(min, max);
}
function $0384f65d82dc5c27$var$isLeastBitTrue(engine) {
    return (engine.next() & 1) === 1;
}
function $0384f65d82dc5c27$var$lessThan(distribution, value) {
    return (engine)=>distribution(engine) < value;
}
function $0384f65d82dc5c27$var$probability(percentage) {
    if (percentage <= 0) return ()=>false;
    else if (percentage >= 1) return ()=>true;
    else {
        const scaled = percentage * $0384f65d82dc5c27$var$UINT32_SIZE;
        if (scaled % 1 === 0) return $0384f65d82dc5c27$var$lessThan($0384f65d82dc5c27$export$1d95835383bb05a, scaled - $0384f65d82dc5c27$var$INT32_SIZE | 0);
        else return $0384f65d82dc5c27$var$lessThan($0384f65d82dc5c27$export$6bf94e3d82617e4e, Math.round(percentage * $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER));
    }
}
function $0384f65d82dc5c27$export$87b259aa03e3d267(numerator, denominator) {
    if (denominator == null) {
        if (numerator == null) return $0384f65d82dc5c27$var$isLeastBitTrue;
        return $0384f65d82dc5c27$var$probability(numerator);
    } else {
        if (numerator <= 0) return ()=>false;
        else if (numerator >= denominator) return ()=>true;
        return $0384f65d82dc5c27$var$lessThan($0384f65d82dc5c27$export$32744b5b3bba4764(0, denominator - 1), numerator);
    }
}
/**
 * Returns a Distribution that returns a random `Date` within the inclusive
 * range of [`start`, `end`].
 * @param start The minimum `Date`
 * @param end The maximum `Date`
 */ function $0384f65d82dc5c27$export$324d90190a8b822a(start, end) {
    const distribution = $0384f65d82dc5c27$export$32744b5b3bba4764(+start, +end);
    return (engine)=>new Date(distribution(engine));
}
/**
 * Returns a Distribution to return a value within [1, sideCount]
 * @param sideCount The number of sides of the die
 */ function $0384f65d82dc5c27$export$1a64584e86ab64a2(sideCount) {
    return $0384f65d82dc5c27$export$32744b5b3bba4764(1, sideCount);
}
/**
 * Returns a distribution that returns an array of length `dieCount` of values
 * within [1, `sideCount`]
 * @param sideCount The number of sides of each die
 * @param dieCount The number of dice
 */ function $0384f65d82dc5c27$export$19a18205b2511a55(sideCount, dieCount) {
    const distribution = $0384f65d82dc5c27$export$1a64584e86ab64a2(sideCount);
    return (engine)=>{
        const result = [];
        for(let i = 0; i < dieCount; ++i)result.push(distribution(engine));
        return result;
    };
}
// tslint:disable:unified-signatures
// has 2**x chars, for faster uniform distribution
const $0384f65d82dc5c27$var$DEFAULT_STRING_POOL = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-";
function $0384f65d82dc5c27$export$22b082955e083ec3(pool = $0384f65d82dc5c27$var$DEFAULT_STRING_POOL) {
    const poolLength = pool.length;
    if (!poolLength) throw new Error("Expected pool not to be an empty string");
    const distribution = $0384f65d82dc5c27$export$32744b5b3bba4764(0, poolLength - 1);
    return (engine, length)=>{
        let result = "";
        for(let i = 0; i < length; ++i){
            const j = distribution(engine);
            result += pool.charAt(j);
        }
        return result;
    };
}
const $0384f65d82dc5c27$var$LOWER_HEX_POOL = "0123456789abcdef";
const $0384f65d82dc5c27$var$lowerHex = $0384f65d82dc5c27$export$22b082955e083ec3($0384f65d82dc5c27$var$LOWER_HEX_POOL);
const $0384f65d82dc5c27$var$upperHex = $0384f65d82dc5c27$export$22b082955e083ec3($0384f65d82dc5c27$var$LOWER_HEX_POOL.toUpperCase());
/**
 * Returns a Distribution that returns a random string comprised of numbers
 * or the characters `abcdef` (or `ABCDEF`) of length `length`.
 * @param length Length of the result string
 * @param uppercase Whether the string should use `ABCDEF` instead of `abcdef`
 */ function $0384f65d82dc5c27$export$834dfc94dde4b3d8(uppercase) {
    if (uppercase) return $0384f65d82dc5c27$var$upperHex;
    else return $0384f65d82dc5c27$var$lowerHex;
}
function $0384f65d82dc5c27$var$convertSliceArgument(value, length) {
    if (value < 0) return Math.max(value + length, 0);
    else return Math.min(value, length);
}
function $0384f65d82dc5c27$var$toInteger(value) {
    const num = +value;
    if (num < 0) return Math.ceil(num);
    else return Math.floor(num);
}
/**
 * Returns a random value within the provided `source` within the sliced
 * bounds of `begin` and `end`.
 * @param source an array of items to pick from
 * @param begin the beginning slice index (defaults to `0`)
 * @param end the ending slice index (defaults to `source.length`)
 */ function $0384f65d82dc5c27$export$357523c63a2253b9(engine, source, begin, end) {
    const length = source.length;
    if (length === 0) throw new RangeError("Cannot pick from an empty array");
    const start = begin == null ? 0 : $0384f65d82dc5c27$var$convertSliceArgument($0384f65d82dc5c27$var$toInteger(begin), length);
    const finish = end === void 0 ? length : $0384f65d82dc5c27$var$convertSliceArgument($0384f65d82dc5c27$var$toInteger(end), length);
    if (start >= finish) throw new RangeError(`Cannot pick between bounds ${start} and ${finish}`);
    const distribution = $0384f65d82dc5c27$export$32744b5b3bba4764(start, finish - 1);
    return source[distribution(engine)];
}
function $0384f65d82dc5c27$var$multiply(distribution, multiplier) {
    if (multiplier === 1) return distribution;
    else if (multiplier === 0) return ()=>0;
    else return (engine)=>distribution(engine) * multiplier;
}
/**
 * Returns a floating-point value within [0.0, 1.0)
 */ function $0384f65d82dc5c27$export$62dc36fcdd132955(engine) {
    return $0384f65d82dc5c27$export$6bf94e3d82617e4e(engine) / $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER;
}
/**
 * Returns a floating-point value within [0.0, 1.0]
 */ function $0384f65d82dc5c27$export$2326f868411f3bcb(engine) {
    return $0384f65d82dc5c27$export$1eac5f65f624910c(engine) / $0384f65d82dc5c27$var$SMALLEST_UNSAFE_INTEGER;
}
/**
 * Returns a floating-point value within [min, max) or [min, max]
 * @param min The minimum floating-point value, inclusive.
 * @param max The maximum floating-point value.
 * @param inclusive If true, `max` will be inclusive.
 */ function $0384f65d82dc5c27$export$9fc57fb453bdbd67(min, max, inclusive = false) {
    if (!isFinite(min)) throw new RangeError("Expected min to be a finite number");
    else if (!isFinite(max)) throw new RangeError("Expected max to be a finite number");
    return $0384f65d82dc5c27$var$add($0384f65d82dc5c27$var$multiply(inclusive ? $0384f65d82dc5c27$export$2326f868411f3bcb : $0384f65d82dc5c27$export$62dc36fcdd132955, max - min), min);
}
const $0384f65d82dc5c27$var$sliceArray = Array.prototype.slice;
/**
 * Shuffles an array in-place
 * @param engine The Engine to use when choosing random values
 * @param array The array to shuffle
 * @param downTo minimum index to shuffle. Only used internally.
 */ function $0384f65d82dc5c27$export$448332262467e042(engine, array, downTo = 0) {
    const length = array.length;
    if (length) for(let i = length - 1 >>> 0; i > downTo; --i){
        const distribution = $0384f65d82dc5c27$export$32744b5b3bba4764(0, i);
        const j = distribution(engine);
        if (i !== j) {
            const tmp = array[i];
            array[i] = array[j];
            array[j] = tmp;
        }
    }
    return array;
}
/**
 * From the population array, produce an array with sampleSize elements that
 * are randomly chosen without repeats.
 * @param engine The Engine to use when choosing random values
 * @param population An array that has items to choose a sample from
 * @param sampleSize The size of the result array
 */ function $0384f65d82dc5c27$export$4812e460280c6ef2(engine, population, sampleSize) {
    if (sampleSize < 0 || sampleSize > population.length || !isFinite(sampleSize)) throw new RangeError("Expected sampleSize to be within 0 and the length of the population");
    if (sampleSize === 0) return [];
    const clone = $0384f65d82dc5c27$var$sliceArray.call(population);
    const length = clone.length;
    if (length === sampleSize) return $0384f65d82dc5c27$export$448332262467e042(engine, clone, 0);
    const tailLength = length - sampleSize;
    return $0384f65d82dc5c27$export$448332262467e042(engine, clone, tailLength - 1).slice(tailLength);
}
const $0384f65d82dc5c27$var$stringRepeat = (()=>{
    try {
        if ("x".repeat(3) === "xxx") return (pattern, count)=>pattern.repeat(count);
    } catch (_) {
    // nothing to do here
    }
    return (pattern, count)=>{
        let result = "";
        while(count > 0){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result;
    };
})();
function $0384f65d82dc5c27$var$zeroPad(text, zeroCount) {
    return $0384f65d82dc5c27$var$stringRepeat("0", zeroCount - text.length) + text;
}
/**
 * Returns a Universally Unique Identifier Version 4.
 *
 * See http://en.wikipedia.org/wiki/Universally_unique_identifier
 */ function $0384f65d82dc5c27$export$19f53698e68b2496(engine) {
    const a = engine.next() >>> 0;
    const b = engine.next() | 0;
    const c = engine.next() | 0;
    const d = engine.next() >>> 0;
    return $0384f65d82dc5c27$var$zeroPad(a.toString(16), 8) + "-" + $0384f65d82dc5c27$var$zeroPad((b & 0xffff).toString(16), 4) + "-" + $0384f65d82dc5c27$var$zeroPad((b >> 4 & 0x0fff | 0x4000).toString(16), 4) + "-" + $0384f65d82dc5c27$var$zeroPad((c & 0x3fff | 0x8000).toString(16), 4) + "-" + $0384f65d82dc5c27$var$zeroPad((c >> 4 & 0xffff).toString(16), 4) + $0384f65d82dc5c27$var$zeroPad(d.toString(16), 8);
}
/**
 * An int32-producing Engine that uses `Math.random()`
 */ const $0384f65d82dc5c27$export$4cfa9414948deaef = {
    next () {
        return Math.random() * $0384f65d82dc5c27$var$UINT32_SIZE | 0;
    }
};
// tslint:disable:unified-signatures
/**
 * A wrapper around an Engine that provides easy-to-use methods for
 * producing values based on known distributions
 */ class $0384f65d82dc5c27$export$a92776769f460054 {
    /**
     * Creates a new Random wrapper
     * @param engine The engine to use (defaults to a `Math.random`-based implementation)
     */ constructor(engine = $0384f65d82dc5c27$export$4cfa9414948deaef){
        this.engine = engine;
    }
    /**
     * Returns a value within [-0x80000000, 0x7fffffff]
     */ int32() {
        return $0384f65d82dc5c27$export$1d95835383bb05a(this.engine);
    }
    /**
     * Returns a value within [0, 0xffffffff]
     */ uint32() {
        return $0384f65d82dc5c27$export$de9ffb9418dd7d0d(this.engine);
    }
    /**
     * Returns a value within [0, 0x1fffffffffffff]
     */ uint53() {
        return $0384f65d82dc5c27$export$6bf94e3d82617e4e(this.engine);
    }
    /**
     * Returns a value within [0, 0x20000000000000]
     */ uint53Full() {
        return $0384f65d82dc5c27$export$1eac5f65f624910c(this.engine);
    }
    /**
     * Returns a value within [-0x20000000000000, 0x1fffffffffffff]
     */ int53() {
        return $0384f65d82dc5c27$export$19ee924d4eeaa52(this.engine);
    }
    /**
     * Returns a value within [-0x20000000000000, 0x20000000000000]
     */ int53Full() {
        return $0384f65d82dc5c27$export$f9ddb966c7d7fb1b(this.engine);
    }
    /**
     * Returns a value within [min, max]
     * @param min The minimum integer value, inclusive. No less than -0x20000000000000.
     * @param max The maximum integer value, inclusive. No greater than 0x20000000000000.
     */ integer(min, max) {
        return $0384f65d82dc5c27$export$32744b5b3bba4764(min, max)(this.engine);
    }
    /**
     * Returns a floating-point value within [0.0, 1.0]
     */ realZeroToOneInclusive() {
        return $0384f65d82dc5c27$export$2326f868411f3bcb(this.engine);
    }
    /**
     * Returns a floating-point value within [0.0, 1.0)
     */ realZeroToOneExclusive() {
        return $0384f65d82dc5c27$export$62dc36fcdd132955(this.engine);
    }
    /**
     * Returns a floating-point value within [min, max) or [min, max]
     * @param min The minimum floating-point value, inclusive.
     * @param max The maximum floating-point value.
     * @param inclusive If true, `max` will be inclusive.
     */ real(min, max, inclusive = false) {
        return $0384f65d82dc5c27$export$9fc57fb453bdbd67(min, max, inclusive)(this.engine);
    }
    bool(numerator, denominator) {
        return $0384f65d82dc5c27$export$87b259aa03e3d267(numerator, denominator)(this.engine);
    }
    /**
     * Return a random value within the provided `source` within the sliced
     * bounds of `begin` and `end`.
     * @param source an array of items to pick from
     * @param begin the beginning slice index (defaults to `0`)
     * @param end the ending slice index (defaults to `source.length`)
     */ pick(source, begin, end) {
        return $0384f65d82dc5c27$export$357523c63a2253b9(this.engine, source, begin, end);
    }
    /**
     * Shuffles an array in-place
     * @param array The array to shuffle
     */ shuffle(array) {
        return $0384f65d82dc5c27$export$448332262467e042(this.engine, array);
    }
    /**
     * From the population array, returns an array with sampleSize elements that
     * are randomly chosen without repeats.
     * @param population An array that has items to choose a sample from
     * @param sampleSize The size of the result array
     */ sample(population, sampleSize) {
        return $0384f65d82dc5c27$export$4812e460280c6ef2(this.engine, population, sampleSize);
    }
    /**
     * Returns a value within [1, sideCount]
     * @param sideCount The number of sides of the die
     */ die(sideCount) {
        return $0384f65d82dc5c27$export$1a64584e86ab64a2(sideCount)(this.engine);
    }
    /**
     * Returns an array of length `dieCount` of values within [1, sideCount]
     * @param sideCount The number of sides of each die
     * @param dieCount The number of dice
     */ dice(sideCount, dieCount) {
        return $0384f65d82dc5c27$export$19a18205b2511a55(sideCount, dieCount)(this.engine);
    }
    /**
     * Returns a Universally Unique Identifier Version 4.
     *
     * See http://en.wikipedia.org/wiki/Universally_unique_identifier
     */ uuid4() {
        return $0384f65d82dc5c27$export$19f53698e68b2496(this.engine);
    }
    string(length, pool) {
        return $0384f65d82dc5c27$export$22b082955e083ec3(pool)(this.engine, length);
    }
    /**
     * Returns a random string comprised of numbers or the characters `abcdef`
     * (or `ABCDEF`) of length `length`.
     * @param length Length of the result string
     * @param uppercase Whether the string should use `ABCDEF` instead of `abcdef`
     */ hex(length, uppercase) {
        return $0384f65d82dc5c27$export$834dfc94dde4b3d8(uppercase)(this.engine, length);
    }
    /**
     * Returns a random `Date` within the inclusive range of [`start`, `end`].
     * @param start The minimum `Date`
     * @param end The maximum `Date`
     */ date(start, end) {
        return $0384f65d82dc5c27$export$324d90190a8b822a(start, end)(this.engine);
    }
}
/**
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Int32Array
 */ const $0384f65d82dc5c27$var$I32Array = (()=>{
    try {
        const buffer = new ArrayBuffer(4);
        const view = new Int32Array(buffer);
        view[0] = $0384f65d82dc5c27$var$INT32_SIZE;
        if (view[0] === -$0384f65d82dc5c27$var$INT32_SIZE) return Int32Array;
    } catch (_) {
    // nothing to do here
    }
    return Array;
})();
let $0384f65d82dc5c27$var$data = null;
const $0384f65d82dc5c27$var$COUNT = 128;
let $0384f65d82dc5c27$var$index = $0384f65d82dc5c27$var$COUNT;
/**
 * An Engine that relies on the globally-available `crypto.getRandomValues`,
 * which is typically available in modern browsers.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
 *
 * If unavailable or otherwise non-functioning, then `browserCrypto` will
 * likely `throw` on the first call to `next()`.
 */ const $0384f65d82dc5c27$export$c330f985105d70e2 = {
    next () {
        if ($0384f65d82dc5c27$var$index >= $0384f65d82dc5c27$var$COUNT) {
            if ($0384f65d82dc5c27$var$data === null) $0384f65d82dc5c27$var$data = new $0384f65d82dc5c27$var$I32Array($0384f65d82dc5c27$var$COUNT);
            crypto.getRandomValues($0384f65d82dc5c27$var$data);
            $0384f65d82dc5c27$var$index = 0;
        }
        return $0384f65d82dc5c27$var$data[$0384f65d82dc5c27$var$index++] | 0;
    }
};
/**
 * Returns an array of random int32 values, based on current time
 * and a random number engine
 *
 * @param engine an Engine to pull random values from, default `nativeMath`
 * @param length the length of the Array, minimum 1, default 16
 */ function $0384f65d82dc5c27$export$751d251274833ff(engine = $0384f65d82dc5c27$export$4cfa9414948deaef, length = 16) {
    const array = [];
    array.push(new Date().getTime() | 0);
    for(let i = 1; i < length; ++i)array[i] = engine.next() | 0;
    return array;
}
/**
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
 */ const $0384f65d82dc5c27$var$imul = (()=>{
    try {
        if (Math.imul($0384f65d82dc5c27$var$UINT32_MAX, 5) === -5) return Math.imul;
    } catch (_) {
    // nothing to do here
    }
    const UINT16_MAX = 0xffff;
    return (a, b)=>{
        const ah = a >>> 16 & UINT16_MAX;
        const al = a & UINT16_MAX;
        const bh = b >>> 16 & UINT16_MAX;
        const bl = b & UINT16_MAX;
        // the shift by 0 fixes the sign on the high part
        // the final |0 converts the unsigned value into a signed value
        return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
    };
})();
const $0384f65d82dc5c27$var$ARRAY_SIZE = 624;
const $0384f65d82dc5c27$var$ARRAY_MAX = $0384f65d82dc5c27$var$ARRAY_SIZE - 1;
const $0384f65d82dc5c27$var$M = 397;
const $0384f65d82dc5c27$var$ARRAY_SIZE_MINUS_M = $0384f65d82dc5c27$var$ARRAY_SIZE - $0384f65d82dc5c27$var$M;
const $0384f65d82dc5c27$var$A = 0x9908b0df;
/**
 * An Engine that is a pseudorandom number generator using the Mersenne
 * Twister algorithm based on the prime 2**19937 − 1
 *
 * See http://en.wikipedia.org/wiki/Mersenne_twister
 */ class $0384f65d82dc5c27$export$b73f0219bb70a91f {
    /**
     * MersenneTwister19937 should not be instantiated directly.
     * Instead, use the static methods `seed`, `seedWithArray`, or `autoSeed`.
     */ constructor(){
        this.data = new $0384f65d82dc5c27$var$I32Array($0384f65d82dc5c27$var$ARRAY_SIZE);
        this.index = 0; // integer within [0, 624]
        this.uses = 0;
    }
    /**
     * Returns a MersenneTwister19937 seeded with an initial int32 value
     * @param initial the initial seed value
     */ static seed(initial) {
        return new $0384f65d82dc5c27$export$b73f0219bb70a91f().seed(initial);
    }
    /**
     * Returns a MersenneTwister19937 seeded with zero or more int32 values
     * @param source A series of int32 values
     */ static seedWithArray(source) {
        return new $0384f65d82dc5c27$export$b73f0219bb70a91f().seedWithArray(source);
    }
    /**
     * Returns a MersenneTwister19937 seeded with the current time and
     * a series of natively-generated random values
     */ static autoSeed() {
        return $0384f65d82dc5c27$export$b73f0219bb70a91f.seedWithArray($0384f65d82dc5c27$export$751d251274833ff());
    }
    /**
     * Returns the next int32 value of the sequence
     */ next() {
        if ((this.index | 0) >= $0384f65d82dc5c27$var$ARRAY_SIZE) {
            $0384f65d82dc5c27$var$refreshData(this.data);
            this.index = 0;
        }
        const value = this.data[this.index];
        this.index = this.index + 1 | 0;
        this.uses += 1;
        return $0384f65d82dc5c27$var$temper(value) | 0;
    }
    /**
     * Returns the number of times that the Engine has been used.
     *
     * This can be provided to an unused MersenneTwister19937 with the same
     * seed, bringing it to the exact point that was left off.
     */ getUseCount() {
        return this.uses;
    }
    /**
     * Discards one or more items from the engine
     * @param count The count of items to discard
     */ discard(count) {
        if (count <= 0) return this;
        this.uses += count;
        if ((this.index | 0) >= $0384f65d82dc5c27$var$ARRAY_SIZE) {
            $0384f65d82dc5c27$var$refreshData(this.data);
            this.index = 0;
        }
        while(count + this.index > $0384f65d82dc5c27$var$ARRAY_SIZE){
            count -= $0384f65d82dc5c27$var$ARRAY_SIZE - this.index;
            $0384f65d82dc5c27$var$refreshData(this.data);
            this.index = 0;
        }
        this.index = this.index + count | 0;
        return this;
    }
    seed(initial) {
        let previous = 0;
        this.data[0] = previous = initial | 0;
        for(let i = 1; i < $0384f65d82dc5c27$var$ARRAY_SIZE; i = i + 1 | 0)this.data[i] = previous = $0384f65d82dc5c27$var$imul(previous ^ previous >>> 30, 0x6c078965) + i | 0;
        this.index = $0384f65d82dc5c27$var$ARRAY_SIZE;
        this.uses = 0;
        return this;
    }
    seedWithArray(source) {
        this.seed(0x012bd6aa);
        $0384f65d82dc5c27$var$seedWithArray(this.data, source);
        return this;
    }
}
function $0384f65d82dc5c27$var$refreshData(data) {
    let k = 0;
    let tmp = 0;
    for(; (k | 0) < $0384f65d82dc5c27$var$ARRAY_SIZE_MINUS_M; k = k + 1 | 0){
        tmp = data[k] & $0384f65d82dc5c27$var$INT32_SIZE | data[k + 1 | 0] & $0384f65d82dc5c27$var$INT32_MAX;
        data[k] = data[k + $0384f65d82dc5c27$var$M | 0] ^ tmp >>> 1 ^ (tmp & 0x1 ? $0384f65d82dc5c27$var$A : 0);
    }
    for(; (k | 0) < $0384f65d82dc5c27$var$ARRAY_MAX; k = k + 1 | 0){
        tmp = data[k] & $0384f65d82dc5c27$var$INT32_SIZE | data[k + 1 | 0] & $0384f65d82dc5c27$var$INT32_MAX;
        data[k] = data[k - $0384f65d82dc5c27$var$ARRAY_SIZE_MINUS_M | 0] ^ tmp >>> 1 ^ (tmp & 0x1 ? $0384f65d82dc5c27$var$A : 0);
    }
    tmp = data[$0384f65d82dc5c27$var$ARRAY_MAX] & $0384f65d82dc5c27$var$INT32_SIZE | data[0] & $0384f65d82dc5c27$var$INT32_MAX;
    data[$0384f65d82dc5c27$var$ARRAY_MAX] = data[$0384f65d82dc5c27$var$M - 1] ^ tmp >>> 1 ^ (tmp & 0x1 ? $0384f65d82dc5c27$var$A : 0);
}
function $0384f65d82dc5c27$var$temper(value) {
    value ^= value >>> 11;
    value ^= value << 7 & 0x9d2c5680;
    value ^= value << 15 & 0xefc60000;
    return value ^ value >>> 18;
}
function $0384f65d82dc5c27$var$seedWithArray(data, source) {
    let i = 1;
    let j = 0;
    const sourceLength = source.length;
    let k = Math.max(sourceLength, $0384f65d82dc5c27$var$ARRAY_SIZE) | 0;
    let previous = data[0] | 0;
    for(; (k | 0) > 0; --k){
        data[i] = previous = (data[i] ^ $0384f65d82dc5c27$var$imul(previous ^ previous >>> 30, 0x0019660d)) + (source[j] | 0) + (j | 0) | 0;
        i = i + 1 | 0;
        ++j;
        if ((i | 0) > $0384f65d82dc5c27$var$ARRAY_MAX) {
            data[0] = data[$0384f65d82dc5c27$var$ARRAY_MAX];
            i = 1;
        }
        if (j >= sourceLength) j = 0;
    }
    for(k = $0384f65d82dc5c27$var$ARRAY_MAX; (k | 0) > 0; --k){
        data[i] = previous = (data[i] ^ $0384f65d82dc5c27$var$imul(previous ^ previous >>> 30, 0x5d588b65)) - i | 0;
        i = i + 1 | 0;
        if ((i | 0) > $0384f65d82dc5c27$var$ARRAY_MAX) {
            data[0] = data[$0384f65d82dc5c27$var$ARRAY_MAX];
            i = 1;
        }
    }
    data[0] = $0384f65d82dc5c27$var$INT32_SIZE;
}
let $0384f65d82dc5c27$var$data$1 = null;
const $0384f65d82dc5c27$var$COUNT$1 = 128;
let $0384f65d82dc5c27$var$index$1 = $0384f65d82dc5c27$var$COUNT$1;

/**
 * An Engine that relies on the node-available
 * `require('crypto').randomBytes`, which has been available since 0.58.
 *
 * See https://nodejs.org/api/crypto.html#crypto_crypto_randombytes_size_callback
 *
 * If unavailable or otherwise non-functioning, then `nodeCrypto` will
 * likely `throw` on the first call to `next()`.
 */ const $0384f65d82dc5c27$export$f46970436a81fadf = {
    next () {
        if ($0384f65d82dc5c27$var$index$1 >= $0384f65d82dc5c27$var$COUNT$1) {
            $0384f65d82dc5c27$var$data$1 = new Int32Array(new Int8Array((parcelRequire("itFHR")).randomBytes(4 * $0384f65d82dc5c27$var$COUNT$1)).buffer);
            $0384f65d82dc5c27$var$index$1 = 0;
        }
        return $0384f65d82dc5c27$var$data$1[$0384f65d82dc5c27$var$index$1++] | 0;
    }
};
/**
 * Returns a Distribution to random value within the provided `source`
 * within the sliced bounds of `begin` and `end`.
 * @param source an array of items to pick from
 * @param begin the beginning slice index (defaults to `0`)
 * @param end the ending slice index (defaults to `source.length`)
 */ function $0384f65d82dc5c27$export$86410c4345f8840e(source, begin, end) {
    const clone = $0384f65d82dc5c27$var$sliceArray.call(source, begin, end);
    if (clone.length === 0) throw new RangeError(`Cannot pick from a source with no items`);
    const distribution = $0384f65d82dc5c27$export$32744b5b3bba4764(0, clone.length - 1);
    return (engine)=>clone[distribution(engine)];
}




var $ecd30b899b74d380$exports = {};
$ecd30b899b74d380$exports = import.meta.resolve("1l4LQ");


var $0a1d76ded2090bdf$exports = {};
$0a1d76ded2090bdf$exports = import.meta.resolve("9jvnl");


// Global sound enabled state
let $bf97b3c0e18cf780$var$soundEnabled = true;
const $bf97b3c0e18cf780$export$21b6365147580583 = (enabled)=>{
    $bf97b3c0e18cf780$var$soundEnabled = enabled;
};
const $bf97b3c0e18cf780$export$809af548198681a4 = ()=>$bf97b3c0e18cf780$var$soundEnabled;
let $bf97b3c0e18cf780$var$createAudioManager = (url)=>{
    let audioArray = Array.from({
        length: 10
    }, ()=>new Audio(url));
    let k = 0;
    return {
        play: ()=>{
            if (!$bf97b3c0e18cf780$var$soundEnabled) return;
            audioArray[k].play();
            k = (k + 1) % audioArray.length;
        }
    };
};
const $bf97b3c0e18cf780$export$8defdeb8759b748d = $bf97b3c0e18cf780$var$createAudioManager((0, (/*@__PURE__*/$parcel$interopDefault($ecd30b899b74d380$exports))));
const $bf97b3c0e18cf780$export$75e3a4949d9ff972 = $bf97b3c0e18cf780$var$createAudioManager((0, (/*@__PURE__*/$parcel$interopDefault($0a1d76ded2090bdf$exports))));




var $37w0r = parcelRequire("37w0r");
class $e840f4281277d93c$export$a01a2a1bdde03bdc extends Error {
}


function $1b9c19121388f259$export$805779a38e4672f2(size) {
    return Array.from({
        length: size.height
    }, ()=>Array.from({
            length: size.width
        }, ()=>null));
}
let $1b9c19121388f259$export$85a47b3ccce199ed = (level, size)=>{
    let { departure: departure, railArray: railArray, destinationArray: destinationArray } = level;
    let grid = $1b9c19121388f259$export$805779a38e4672f2(size);
    grid[departure.y][departure.x] = departure;
    railArray.forEach((track)=>{
        grid[track.y][track.x] = track;
    });
    destinationArray.forEach((station)=>{
        grid[station.y][station.x] = station;
    });
    return grid;
};


function $b262fbf37af6c22b$var$pairToPosition([x, y]) {
    return {
        x: x,
        y: y
    };
}
function $b262fbf37af6c22b$var$addPosition(a) {
    return (b)=>({
            x: a.x + b.x,
            y: a.y + b.y
        });
}
const $b262fbf37af6c22b$var$SURROUNDING_FOUR = [
    [
        0,
        1
    ],
    [
        0,
        -1
    ],
    [
        1,
        0
    ],
    [
        -1,
        0
    ]
].map($b262fbf37af6c22b$var$pairToPosition);
const $b262fbf37af6c22b$var$SURROUNDING_FIVE = [
    {
        x: 0,
        y: 0
    },
    ...$b262fbf37af6c22b$var$SURROUNDING_FOUR
];
const $b262fbf37af6c22b$var$SURROUNDING_NINE = [
    ...$b262fbf37af6c22b$var$SURROUNDING_FIVE,
    ...[
        [
            1,
            1
        ],
        [
            1,
            -1
        ],
        [
            -1,
            1
        ],
        [
            -1,
            -1
        ]
    ].map($b262fbf37af6c22b$var$pairToPosition)
];
const $b262fbf37af6c22b$var$SURROUNDING_THIRTEEN = [
    ...$b262fbf37af6c22b$var$SURROUNDING_NINE,
    ...[
        [
            0,
            2
        ],
        [
            0,
            -2
        ],
        [
            2,
            0
        ],
        [
            -2,
            0
        ]
    ].map($b262fbf37af6c22b$var$pairToPosition)
];
function $b262fbf37af6c22b$export$9f17032d917177de(a, b) {
    return $b262fbf37af6c22b$export$ef42b5d37a2a9552(a, b) ** 0.5;
}
function $b262fbf37af6c22b$export$ef42b5d37a2a9552(a, b) {
    return (a.x - b.x) ** 2 + (a.y - b.y) ** 2;
}
function $b262fbf37af6c22b$export$d52d88a0691b49e(a, b) {
    return a.x === b.x && a.y === b.y;
}
function $b262fbf37af6c22b$export$acaf96a27438246b(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $b262fbf37af6c22b$export$651728981d951bb8(a) {
    return $b262fbf37af6c22b$var$SURROUNDING_FOUR.map($b262fbf37af6c22b$var$addPosition(a));
}
function $b262fbf37af6c22b$export$d034c99cd24acbe3(a) {
    return $b262fbf37af6c22b$var$SURROUNDING_FIVE.map($b262fbf37af6c22b$var$addPosition(a));
}
function $b262fbf37af6c22b$export$deb047a2cb0a2bf(a) {
    return $b262fbf37af6c22b$var$SURROUNDING_NINE.map($b262fbf37af6c22b$var$addPosition(a));
}
function $b262fbf37af6c22b$export$8cbcbbef6932853(a) {
    return $b262fbf37af6c22b$var$SURROUNDING_THIRTEEN.map($b262fbf37af6c22b$var$addPosition(a));
}
function $b262fbf37af6c22b$export$f26f48d00f1a61e9(radius, a) {
    let result = [];
    Array.from({
        length: 2 * radius - 1
    }, (_, by)=>{
        let y = by - radius;
        Array.from({
            length: 2 * radius - 1
        }, (_, bx)=>{
            let x = bx - radius;
            result.push({
                x: x + a.x,
                y: y + a.y
            });
        });
    });
    return result;
}
function $b262fbf37af6c22b$export$dc2f9d039d8268b4(radius, a) {
    return $b262fbf37af6c22b$export$f26f48d00f1a61e9(radius, a).filter(({ x: x, y: y })=>Math.abs(x - a.x) + Math.abs(y - a.y) <= radius);
}


const $d94f34763c85c462$export$b0bfb3932759ed72 = [
    'bottom',
    'left',
    'right',
    'top'
];
function $d94f34763c85c462$export$2905201efabb3a51(direction) {
    return ({
        bottom: 'top',
        left: 'right',
        right: 'left',
        top: 'bottom'
    })[direction];
}
function $d94f34763c85c462$export$73e05133afc82669(direction) {
    return ({
        bottom: {
            dx: 0,
            dy: 1
        },
        left: {
            dx: -1,
            dy: 0
        },
        right: {
            dx: 1,
            dy: 0
        },
        top: {
            dx: 0,
            dy: -1
        }
    })[direction];
}
let $d94f34763c85c462$export$2965c0931506931a = (a, b)=>{
    let [c, d] = [
        a,
        b
    ].sort();
    let e = c + d;
    return e === 'bottomtop' || e === 'leftright';
};
function $d94f34763c85c462$export$8d942df1146c39df(from, to) {
    const vector = (0, $b262fbf37af6c22b$export$acaf96a27438246b)(to, from);
    let directionArray = [];
    const topBottom = ()=>{
        if (vector.y <= 0) directionArray.push('top');
        if (vector.y >= 0) directionArray.push('bottom');
    };
    const leftRight = ()=>{
        if (vector.x <= 0) directionArray.push('left');
        if (vector.x >= 0) directionArray.push('right');
    };
    if (Math.abs(vector.y) >= Math.abs(vector.x)) {
        topBottom();
        leftRight();
    } else {
        leftRight();
        topBottom();
    }
    return directionArray;
}




function $0b6d13e2cc0f6f62$export$e638f0174b6c6089(tile, direction, grid) {
    let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(direction);
    let next = grid[tile.y + dy][tile.x + dx];
    if (!next) throw new Error('never, null tile');
    return next;
}


function $ff5f9e9ea249a819$export$bd44396c5113d95(a) {
    return [
        'departure',
        'destination'
    ].includes(a?.type ?? '');
}
function $ff5f9e9ea249a819$export$b04d5c035b174df8(a) {
    return [
        'track',
        'switch'
    ].includes(a?.type ?? '');
}


function $c0776774dfd77332$export$77af05dc6c2068a9(departure, grid, maximumTrackLength) {
    let tile = (0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(departure, departure.exit, grid);
    if (!(0, $ff5f9e9ea249a819$export$b04d5c035b174df8)(tile)) throw new Error('never, not rail tile');
    return $c0776774dfd77332$var$longestTrack(tile, grid) > maximumTrackLength;
}
function $c0776774dfd77332$var$longestTrack(tile, grid) {
    if (!(0, $ff5f9e9ea249a819$export$b04d5c035b174df8)(tile)) return 0;
    if (tile.type === 'track') return 1 + $c0776774dfd77332$var$longestTrack((0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(tile, tile.exit, grid), grid);
    return 1 + Math.max($c0776774dfd77332$var$longestTrack((0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(tile, tile.exit, grid), grid), $c0776774dfd77332$var$longestTrack((0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(tile, tile.otherExit, grid), grid));
}


/**
 * connector, walk through a grid to connect one location to anther
 */ 


function $de0028cfb4a5e1fe$var$isDirectionValid(grid, cursor, target, track) {
    return (direction)=>{
        if (direction === track?.exit) return false;
        let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(direction);
        let tile = grid[cursor.y + dy]?.[cursor.x + dx];
        if (cursor.x + dx === target.x && cursor.y + dy === target.y) return true;
        if (tile === undefined) // we are outside of the grid
        return false;
        if (tile === null || tile.type === 'track') return true // break out of bestMoveDirectionArray().some
        ;
        return false;
    };
}
function $de0028cfb4a5e1fe$export$cb7230339929944e(grid, start, destination) {
    let railway = [];
    let entrance = '<direction to be determined>';
    let cursor = {
        x: destination.x,
        y: destination.y
    };
    let target = {
        x: start.x,
        y: start.y
    };
    let track = null;
    const CURSOR_LOOP_LIMIT = 100 + grid.length + grid[0].length;
    for(let k = 0; k < CURSOR_LOOP_LIMIT; k++){
        // determine a valid direction
        let [direction] = (0, $d94f34763c85c462$export$8d942df1146c39df)(cursor, target).filter($de0028cfb4a5e1fe$var$isDirectionValid(grid, cursor, target, track));
        if (direction === undefined) throw new (0, $e840f4281277d93c$export$a01a2a1bdde03bdc)('cannot find a direction to continue the track');
        // write the entrance of the current track, before switching to the next tile
        if (k > 0) railway.slice(-1)[0].entrance = direction;
        else entrance = direction;
        // move the cursor
        let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(direction);
        cursor.x += dx;
        cursor.y += dy;
        if ((0, $b262fbf37af6c22b$export$d52d88a0691b49e)(cursor, target) || grid[cursor.y][cursor.x]?.type === 'track') return {
            railway: railway,
            entrance: entrance,
            exit: (0, $d94f34763c85c462$export$2905201efabb3a51)(direction)
        };
        // add the rail
        track = {
            type: 'track',
            entrance: '<direction to be determined>',
            exit: (0, $d94f34763c85c462$export$2905201efabb3a51)(direction),
            x: cursor.x,
            y: cursor.y
        };
        railway.push(track);
    }
    throw new Error('reached the loop limit while connecting a station to the railway');
}


function $28384e0759aee39b$var$randomDeparture(config) {
    const x = (0, $0384f65d82dc5c27$exports).picker([
        0,
        config.gridSize.width - 1
    ])(config.randomEngine);
    const y = (0, $0384f65d82dc5c27$exports).picker([
        1,
        config.gridSize.height - 2
    ])(config.randomEngine);
    return {
        type: 'departure',
        x: x,
        y: y,
        exit: '<direction to be determined>'
    };
}
function $28384e0759aee39b$export$80d376111cc09ad7(config) {
    for(let k = 0;; k++)try {
        console.log('generating level');
        return $28384e0759aee39b$var$coreGenerate(config);
    } catch (e) {
        if (e instanceof (0, $e840f4281277d93c$export$a01a2a1bdde03bdc) && k < config.retryCount) continue;
        throw e;
    }
}
function $28384e0759aee39b$var$isInGridBound(size) {
    return ({ x: x, y: y })=>0 <= x && x < size.width && 0 <= y && y < size.height;
}
function $28384e0759aee39b$var$coreGenerate(config) {
    const { randomEngine: randomEngine, gridSize: gridSize, stationCount: stationCount } = config;
    // create an empty grid
    const grid = (0, $1b9c19121388f259$export$805779a38e4672f2)(gridSize);
    let departure = $28384e0759aee39b$var$randomDeparture(config);
    let destinationArray = [];
    let railArray = [];
    // Compute the base available options where we can place stations
    let optionCount = gridSize.width * gridSize.height;
    let optionArray = Array.from({
        length: optionCount
    }, (_, k)=>k);
    let betterOptionArray = [];
    // we make the borders more likely to be picked as station position
    optionArray.forEach((positionNumber)=>{
        let x = positionNumber % gridSize.width;
        let y = Math.floor(positionNumber / gridSize.width);
        if (x === 0 || x === gridSize.width - 1 || y === 0 || y === gridSize.height - 1) betterOptionArray.push(positionNumber);
    });
    optionArray.push(...betterOptionArray, ...betterOptionArray);
    // we remove all the positions too close from the start
    let startSurrounding = (0, $b262fbf37af6c22b$export$f26f48d00f1a61e9)(config.departureClearance + 1, departure).filter($28384e0759aee39b$var$isInGridBound(config.gridSize));
    (0, $37w0r).pull(optionArray, ...startSurrounding.map(({ x: x, y: y })=>y * gridSize.width + x));
    // Place `stationCount` stations, one after the other
    for(let k = 0; k < stationCount; k++){
        const positionNumber = (0, $0384f65d82dc5c27$exports).picker(optionArray)(randomEngine);
        (0, $37w0r).pull(optionArray, positionNumber);
        let x = positionNumber % gridSize.width;
        let y = Math.floor(positionNumber / gridSize.width);
        let entrance = '<direction to be determined>';
        const destination = {
            type: 'destination',
            colorIndex: k,
            x: x,
            y: y,
            entrance: entrance
        };
        grid[y][x] = destination;
        destinationArray.push(destination);
    }
    const addRailway = (railway)=>{
        railArray.push(...railway);
        railway.forEach((rail)=>{
            grid[rail.y][rail.x] = rail;
        });
    };
    // For the first destination station, create the track needed to connect it to the departure station
    let { railway: railway, exit: exit, entrance: entrance } = (0, $de0028cfb4a5e1fe$export$cb7230339929944e)(grid, departure, destinationArray[0]);
    addRailway(railway);
    destinationArray[0].entrance = entrance;
    departure.exit = exit;
    // Then for each remaining station, add the tracks and switches needed to connect it to the railway
    for (let destination of destinationArray.slice(1)){
        // Determine the set of rail tiles that we are allowed to connect to
        let reachableRailArray = railArray.filter((rail)=>rail.type === 'track' && (0, $b262fbf37af6c22b$export$9f17032d917177de)(rail, departure) >= config.departureClearance);
        if (reachableRailArray.length < 1) throw new (0, $e840f4281277d93c$export$a01a2a1bdde03bdc)('no reachable rail');
        let closestRail = (0, $37w0r).minBy(reachableRailArray, (track)=>(0, $b262fbf37af6c22b$export$ef42b5d37a2a9552)(track, destination) + (0, $0384f65d82dc5c27$exports).real(0, 1)(randomEngine));
        let { railway: railway, exit: exit, entrance: entrance } = (0, $de0028cfb4a5e1fe$export$cb7230339929944e)(grid, closestRail, destination);
        addRailway(railway);
        destination.entrance = entrance;
        // transform the junction point from track to switch
        let { x: x, y: y, entrance: e } = [
            destination,
            ...railway
        ].slice(-1)[0];
        let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(e);
        let junction = grid[y + dy][x + dx];
        if ((0, $b262fbf37af6c22b$export$9f17032d917177de)(junction, departure) < config.departureClearance) throw new (0, $e840f4281277d93c$export$a01a2a1bdde03bdc)('switch too close to the start station');
        junction.type = 'switch';
        junction.trainArray = [];
        junction.otherExit = exit;
        junction.mouseIsOver = false;
    }
    if ((0, $c0776774dfd77332$export$77af05dc6c2068a9)(departure, grid, gridSize.width + gridSize.height - 3)) throw new (0, $e840f4281277d93c$export$a01a2a1bdde03bdc)('track is too linear');
    return {
        departure: departure,
        destinationArray: destinationArray,
        railArray: railArray
    };
}



function $6a503b568a4879f2$export$7cc549dee4733a24(info) {
    let result = {};
    let resolver = {};
    Object.keys(info).forEach((key)=>{
        resolver[key] = ()=>{
            let [obtain, postprocess = (x)=>x] = info[key];
            let value = postprocess(obtain(resolver));
            resolver[key] = ()=>value;
            return value;
        };
    });
    Object.keys(info).forEach((key)=>{
        result[key] = resolver[key]();
    });
    return result;
}


const $f82b67f096a9a947$export$4ee0f12d42ee245b = {
    squareWidth: [
        ()=>128
    ],
    sw: [
        ({ squareWidth: squareWidth })=>squareWidth()
    ],
    stationBorder: [
        ({ sw: sw })=>sw() / 24
    ],
    stationMargin: [
        ({ sw: sw })=>sw() / 6
    ],
    squareBorder: [
        ({ sw: sw })=>sw() / 16
    ],
    roadWidth: [
        ({ sw: sw })=>sw() * 3 / 10
    ],
    interiorRoadWidth: [
        ({ sw: sw })=>sw() * 2 / 10
    ],
    roadHole: [
        ({ sw: sw, roadWidth: roadWidth })=>(sw() - roadWidth()) / 2
    ],
    roadBorder: [
        ({ roadWidth: roadWidth, interiorRoadWidth: interiorRoadWidth })=>(roadWidth() - interiorRoadWidth()) / 2
    ],
    scoreHeight: [
        ()=>50
    ],
    switchOutlineWidth: [
        ()=>2
    ],
    switchRadius: [
        ({ sw: sw })=>sw() / 3
    ]
};
function $f82b67f096a9a947$export$32990855c7ccb10d(layout) {
    return Object.entries(layout).map(([key, value])=>`${key}:${value}`).join(',');
}
function $f82b67f096a9a947$export$16ed0dd2ce1347c(input) {
    let infoObject = {
        ...$f82b67f096a9a947$export$4ee0f12d42ee245b
    };
    if (input) input.split(',').forEach((pair)=>{
        let [name, value] = pair.split(':');
        infoObject[name] = [
            ()=>+value
        ];
    });
    return (0, $6a503b568a4879f2$export$7cc549dee4733a24)(infoObject);
}
const $f82b67f096a9a947$export$2303d2bd9eeff99a = $f82b67f096a9a947$export$16ed0dd2ce1347c('');
const $f82b67f096a9a947$export$2cf2f492412181c4 = $f82b67f096a9a947$export$16ed0dd2ce1347c('squareWidth:60');


let $5110f33f67e7638b$export$185802fd694ee1f5 = (name, attribute = {}, children = [])=>{
    // Create element
    let elem = document.createElement(name);
    // Copy each attribute
    Object.entries(attribute).forEach(([name, value])=>{
        if (name === 'style') {
            Object.entries(value).forEach(([k, v])=>{
                elem.style[k] = v;
            });
            return;
        }
        if (elem[name] !== undefined) elem[name] = value;
        else elem.setAttribute(name, value);
    });
    // Insert each child
    children.forEach((child)=>{
        elem.appendChild(child);
    });
    return elem;
};


function $d7c47304def68957$export$bfab3f324e8bcfbb(container, layout, theme, timeLimit) {
    let totalCount = 0;
    let goodCount = 0;
    let remainingTime = timeLimit;
    let timerInterval = null;
    let onTimeUp = null;
    const getScoreText = ()=>{
        return `${goodCount} correct`;
    };
    const getTimerText = ()=>{
        const minutes = Math.floor(remainingTime / 60);
        const seconds = remainingTime % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };
    const getAssessment = ()=>{
        let assessment = '';
        if (goodCount === totalCount && totalCount > 0) assessment = `Perfect score!`;
        else if (goodCount >= totalCount * 0.8) assessment = `Great job!`;
        else if (goodCount >= totalCount * 0.5) assessment = `Good effort!`;
        else assessment = `Keep practicing!`;
        return assessment;
    };
    // Score display
    let scoreSpan = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('span', {
        style: {
            position: 'fixed',
            padding: '8px 20px',
            height: `${layout.scoreHeight}px`,
            backgroundColor: 'rgba(45, 61, 77, 0.9)',
            fontSize: `${layout.scoreHeight * 0.7}px`,
            fontWeight: '500',
            userSelect: 'none',
            borderRadius: '0 0 12px 0',
            color: '#f0f4f8',
            fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, Arial, sans-serif",
            letterSpacing: '0.5px'
        },
        textContent: getScoreText()
    });
    // Timer display
    let timerSpan = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('span', {
        style: {
            position: 'fixed',
            right: '0',
            padding: '8px 20px',
            height: `${layout.scoreHeight}px`,
            backgroundColor: 'rgba(45, 61, 77, 0.9)',
            fontSize: `${layout.scoreHeight * 0.7}px`,
            fontWeight: '600',
            userSelect: 'none',
            borderRadius: '0 0 0 12px',
            color: '#f0f4f8',
            fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, Arial, sans-serif",
            letterSpacing: '0.5px'
        },
        textContent: getTimerText()
    });
    container.appendChild(scoreSpan);
    container.appendChild(timerSpan);
    // Start the timer
    const startTimer = ()=>{
        timerInterval = window.setInterval(()=>{
            remainingTime--;
            timerSpan.textContent = getTimerText();
            // Change color when time is low
            if (remainingTime <= 10) {
                timerSpan.style.color = '#ef4444';
                timerSpan.style.fontWeight = '700';
            } else if (remainingTime <= 30) timerSpan.style.color = '#f59e0b';
            if (remainingTime <= 0) {
                stopTimer();
                if (onTimeUp) onTimeUp();
            }
        }, 1000);
    };
    const stopTimer = ()=>{
        if (timerInterval !== null) {
            clearInterval(timerInterval);
            timerInterval = null;
        }
    };
    return {
        startTimer: startTimer,
        stopTimer: stopTimer,
        setOnTimeUp: (callback)=>{
            onTimeUp = callback;
        },
        // Show that we're waiting for remaining trains
        showWaitingForTrains: ()=>{
            timerSpan.textContent = '0:00';
            timerSpan.style.color = '#f59e0b';
        },
        // Update the display to show remaining trains
        updateRemainingTrains: (count)=>{
            if (count > 0) {
                timerSpan.textContent = `${count} train${count > 1 ? 's' : ''} left`;
                timerSpan.style.color = '#f59e0b';
            }
        },
        // Show score to the user
        showScore: (isTimeUp = false)=>{
            stopTimer();
            container.appendChild((0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                style: {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '60px',
                    textAlign: 'center',
                    padding: '30px 60px',
                    backgroundColor: 'rgba(45, 61, 77, 0.95)',
                    borderRadius: '20px',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.4)',
                    userSelect: 'none',
                    color: '#f0f4f8',
                    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, Arial, sans-serif",
                    zIndex: '1000'
                }
            }, [
                (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                    textContent: 'Game Complete!',
                    style: {
                        fontSize: '36px',
                        fontWeight: '300',
                        marginBottom: '10px',
                        color: '#94a3b8'
                    }
                }),
                (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                    textContent: `${goodCount}`,
                    style: {
                        fontSize: '80px',
                        fontWeight: '700',
                        marginBottom: '5px',
                        color: '#22c55e'
                    }
                }),
                (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                    textContent: `trains delivered correctly`,
                    style: {
                        fontSize: '20px',
                        fontWeight: '400',
                        marginBottom: '15px',
                        color: '#94a3b8'
                    }
                }),
                (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                    textContent: `${totalCount - goodCount} wrong`,
                    style: {
                        fontSize: '24px',
                        fontWeight: '400',
                        marginBottom: '10px',
                        color: totalCount - goodCount > 0 ? '#ef4444' : '#22c55e'
                    }
                }),
                (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
                    textContent: getAssessment(),
                    style: {
                        fontSize: '28px',
                        fontWeight: '500',
                        color: '#60a5fa',
                        marginTop: '10px'
                    }
                })
            ]));
        },
        scoreEvent (isGoodEvent) {
            totalCount += 1;
            if (isGoodEvent) goodCount += 1;
            scoreSpan.textContent = getScoreText();
        },
        getGoodCount: ()=>goodCount,
        getTotalCount: ()=>totalCount
    };
}




const $95c1e97c8d1548a3$var$STORAGE_KEY = 'trainGameSettings';
function $95c1e97c8d1548a3$export$54453bb1ffd2fd71() {
    try {
        const stored = localStorage.getItem($95c1e97c8d1548a3$var$STORAGE_KEY);
        if (stored) return JSON.parse(stored);
    } catch (e) {
        console.warn('Failed to load settings from localStorage', e);
    }
    return {};
}
// Save settings to localStorage
function $95c1e97c8d1548a3$var$saveSettings(settings) {
    try {
        localStorage.setItem($95c1e97c8d1548a3$var$STORAGE_KEY, JSON.stringify(settings));
    } catch (e) {
        console.warn('Failed to save settings to localStorage', e);
    }
}
function $95c1e97c8d1548a3$export$ebcadcac8f38e10f(container, callbacks, initialState) {
    let isOpen = false;
    // Load saved settings and merge with initial state
    const savedSettings = $95c1e97c8d1548a3$export$54453bb1ffd2fd71();
    let trainInterval = savedSettings.trainInterval ?? initialState.trainInterval;
    // Apply saved sound setting
    if (savedSettings.soundEnabled !== undefined) (0, $bf97b3c0e18cf780$export$21b6365147580583)(savedSettings.soundEnabled);
    // Settings button (gear icon)
    const settingsBtn = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
        className: 'settings-btn',
        innerHTML: "\u2699\uFE0F",
        title: 'Settings',
        onclick: ()=>toggleSettings()
    });
    // Settings panel
    const settingsPanel = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'settings-panel',
        style: {
            display: 'none'
        }
    });
    // Panel header
    const header = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'settings-header'
    }, [
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('span', {
            textContent: 'Settings'
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
            className: 'settings-close',
            textContent: "\xd7",
            onclick: ()=>toggleSettings()
        })
    ]);
    // Helper to save current settings
    const persistSettings = ()=>{
        $95c1e97c8d1548a3$var$saveSettings({
            trainInterval: trainInterval,
            soundEnabled: (0, $bf97b3c0e18cf780$export$809af548198681a4)()
        });
    };
    // Sound toggle
    const soundRow = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'settings-row'
    }, [
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('span', {
            textContent: 'Sound Effects'
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
            className: `settings-toggle ${(0, $bf97b3c0e18cf780$export$809af548198681a4)() ? 'active' : ''}`,
            textContent: (0, $bf97b3c0e18cf780$export$809af548198681a4)() ? 'ON' : 'OFF',
            onclick: (e)=>{
                const btn = e.target;
                const newState = !(0, $bf97b3c0e18cf780$export$809af548198681a4)();
                (0, $bf97b3c0e18cf780$export$21b6365147580583)(newState);
                btn.textContent = newState ? 'ON' : 'OFF';
                btn.className = `settings-toggle ${newState ? 'active' : ''}`;
                persistSettings();
            }
        })
    ]);
    // Train interval slider
    const intervalRow = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'settings-row settings-row-vertical'
    }, [
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('span', {
            textContent: `Train Interval: ${trainInterval.toFixed(1)}s`
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('input', {
            type: 'range',
            min: '0.5',
            max: '5',
            step: '0.5',
            value: String(trainInterval),
            className: 'settings-slider',
            oninput: (e)=>{
                const input = e.target;
                trainInterval = parseFloat(input.value);
                const label = intervalRow.querySelector('span');
                label.textContent = `Train Interval: ${trainInterval.toFixed(1)}s`;
                callbacks.onTrainIntervalChange(trainInterval);
                persistSettings();
            }
        })
    ]);
    // Action buttons
    const actionsRow = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'settings-actions'
    }, [
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
            className: 'settings-action-btn restart-btn',
            textContent: "\uD83D\uDD04 Restart",
            onclick: ()=>{
                toggleSettings();
                callbacks.onRestart();
            }
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
            className: 'settings-action-btn menu-btn',
            textContent: "\uD83C\uDFE0 Menu",
            onclick: ()=>{
                toggleSettings();
                callbacks.onMenu();
            }
        })
    ]);
    settingsPanel.appendChild(header);
    settingsPanel.appendChild(soundRow);
    settingsPanel.appendChild(intervalRow);
    settingsPanel.appendChild(actionsRow);
    container.appendChild(settingsBtn);
    container.appendChild(settingsPanel);
    function toggleSettings() {
        isOpen = !isOpen;
        settingsPanel.style.display = isOpen ? 'flex' : 'none';
        settingsBtn.style.display = isOpen ? 'none' : 'block';
    }
    return {
        destroy: ()=>{
            settingsBtn.remove();
            settingsPanel.remove();
        },
        close: ()=>{
            if (isOpen) toggleSettings();
        },
        getTrainInterval: ()=>trainInterval
    };
}





function $2e8e7818b49400c8$export$ec0f151edeb35b7a(layout, theme, showColorIndices) {
    const text = (textContent, fontSize)=>{
        return new (0, $30d7d246c5e7cd93$exports).Text(textContent, {
            fontFamily: 'Arial',
            fontSize: fontSize,
            fill: 0xffffff
        });
    };
    const roadTurn = ()=>{
        let g = new (0, $30d7d246c5e7cd93$exports).Graphics();
        // interior road hole
        const hole = ()=>{
            g.moveTo(0, 0);
            g.arc(0, 0, layout.roadHole, 0, Math.PI / 2 - 0.0001, false);
            g.cut();
        };
        // road turn exterior
        g.moveTo(0, 0);
        g.arc(0, 0, layout.roadHole + layout.roadWidth, 0, (0, $30d7d246c5e7cd93$exports).PI_2 / 4, false);
        g.fill(theme.rail);
        hole();
        // road turn center
        g.moveTo(0, 0);
        g.arc(0, 0, layout.roadHole + layout.roadBorder + layout.interiorRoadWidth, 0, (0, $30d7d246c5e7cd93$exports).PI_2 / 4, false);
        g.fill(theme.railInner);
        hole();
        // road turn interior
        g.moveTo(0, 0);
        g.arc(0, 0, layout.roadHole + layout.roadBorder, 0, (0, $30d7d246c5e7cd93$exports).PI_2 / 4, false);
        g.fill(theme.rail);
        hole();
        return g;
    };
    const road = ()=>{
        let g = new (0, $30d7d246c5e7cd93$exports).Graphics();
        // road exterior
        g.moveTo(0, 0);
        g.rect(0, layout.roadHole, layout.squareWidth, layout.roadWidth);
        g.fill(theme.rail);
        // road interior
        g.moveTo(0, 0);
        g.rect(0, layout.roadHole + layout.roadBorder, layout.squareWidth, layout.interiorRoadWidth);
        g.fill(theme.railInner);
        return g;
    };
    // Draw a pattern marker to help distinguish colors at higher levels
    const drawPatternMarker = (g, cx, cy, markerSize, pattern)=>{
        const markerColor = 0xffffff;
        const s = markerSize;
        switch(pattern){
            case 'stripe':
                // Horizontal stripe
                g.roundRect(cx - s * 0.8, cy - s * 0.15, s * 1.6, s * 0.3, s * 0.1);
                g.fill(markerColor);
                break;
            case 'dot':
                // Center dot
                g.circle(cx, cy, s * 0.35);
                g.fill(markerColor);
                break;
            case 'ring':
                // Ring outline
                g.circle(cx, cy, s * 0.5);
                g.fill(markerColor);
                g.circle(cx, cy, s * 0.3);
                g.cut();
                break;
            case 'diamond':
                // Diamond shape
                g.moveTo(cx, cy - s * 0.5);
                g.lineTo(cx + s * 0.4, cy);
                g.lineTo(cx, cy + s * 0.5);
                g.lineTo(cx - s * 0.4, cy);
                g.closePath();
                g.fill(markerColor);
                break;
            case 'cross':
                // Cross/plus
                g.roundRect(cx - s * 0.12, cy - s * 0.5, s * 0.24, s * 1.0, s * 0.05);
                g.fill(markerColor);
                g.roundRect(cx - s * 0.5, cy - s * 0.12, s * 1.0, s * 0.24, s * 0.05);
                g.fill(markerColor);
                break;
            case 'triangle':
                // Triangle marker
                g.moveTo(cx, cy - s * 0.45);
                g.lineTo(cx + s * 0.4, cy + s * 0.35);
                g.lineTo(cx - s * 0.4, cy + s * 0.35);
                g.closePath();
                g.fill(markerColor);
                break;
            case 'square':
                // Square marker
                g.roundRect(cx - s * 0.35, cy - s * 0.35, s * 0.7, s * 0.7, s * 0.08);
                g.fill(markerColor);
                break;
        }
    };
    // Draw a house icon for stations (destinations)
    const drawHouse = (g, cx, cy, size, primaryColor, secondaryColor, isDeparture, colorIndex)=>{
        const houseWidth = size * 0.75;
        const houseHeight = size * 0.5;
        const roofHeight = size * 0.35;
        // House body (rectangle)
        const bodyLeft = cx - houseWidth / 2;
        const bodyTop = cy - houseHeight / 2 + roofHeight / 2;
        const bodyBottom = cy + houseHeight / 2 + roofHeight / 2;
        // Draw house body with rounded corners
        g.roundRect(bodyLeft, bodyTop, houseWidth, houseHeight, size * 0.05);
        g.fill(primaryColor);
        // Draw roof (triangle)
        const roofTop = cy - houseHeight / 2 - roofHeight / 2 + roofHeight / 4;
        const roofLeft = cx - houseWidth / 2 - size * 0.08;
        const roofRight = cx + houseWidth / 2 + size * 0.08;
        g.moveTo(cx, roofTop);
        g.lineTo(roofRight, bodyTop + size * 0.02);
        g.lineTo(roofLeft, bodyTop + size * 0.02);
        g.closePath();
        g.fill(secondaryColor !== null ? secondaryColor : $2e8e7818b49400c8$var$darkenColor(primaryColor, 0.15));
        // Draw door (only for non-departure)
        if (!isDeparture) {
            const doorWidth = houseWidth * 0.25;
            const doorHeight = houseHeight * 0.5;
            const doorLeft = cx - doorWidth / 2;
            const doorTop = bodyBottom - doorHeight;
            g.roundRect(doorLeft, doorTop, doorWidth, doorHeight, size * 0.02);
            g.fill($2e8e7818b49400c8$var$darkenColor(primaryColor, 0.3));
        }
        // Draw pattern marker for higher color indices (helps distinguish similar colors)
        const pattern = (0, $5b55f105e5908397$export$c37ddd467bda1a75)(colorIndex);
        if (pattern !== 'solid' && !isDeparture) {
            const markerCx = cx;
            const markerCy = bodyTop + houseHeight * 0.35;
            drawPatternMarker(g, markerCx, markerCy, size * 0.25, pattern);
        }
    };
    const station = (stationData, colorIndex, colorList)=>{
        let direction;
        let isDeparture = stationData.type === 'departure';
        if (stationData.type === 'departure') direction = stationData.exit;
        else direction = stationData.entrance;
        let { squareWidth: squareWidth, stationMargin: stationMargin } = layout;
        let g = new (0, $30d7d246c5e7cd93$exports).Graphics();
        const cx = squareWidth / 2;
        const cy = squareWidth / 2;
        const size = squareWidth - 2 * stationMargin;
        const primaryColor = (0, $5b55f105e5908397$export$1b0ed88187e4090f)(colorIndex, colorList);
        // For destinations, check if we should use dual colors
        const secondaryColor = !isDeparture && colorIndex > 0 ? (0, $5b55f105e5908397$export$b71c93f469694483)(colorIndex, colorList) : null;
        // Draw white background circle/base
        g.circle(cx, cy, size / 2 + 4);
        g.fill(0xffffff);
        // Draw the house
        drawHouse(g, cx, cy, size, primaryColor, secondaryColor, isDeparture, colorIndex);
        let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(direction);
        let h = new (0, $30d7d246c5e7cd93$exports).Container();
        h.x += stationMargin * dx;
        h.y += stationMargin * dy;
        h.addChild(g);
        if (showColorIndices) {
            let textContent = colorIndex.toString(16).toUpperCase();
            let j = text(textContent, squareWidth / 4);
            j.x += 0.52 * squareWidth - 0.08 * squareWidth * textContent.length;
            j.y += 0.38 * squareWidth;
            h.addChild(j);
        }
        return h;
    };
    // Draw a train icon
    const drawTrainIcon = (g, cx, cy, size, primaryColor, secondaryColor, colorIndex)=>{
        const trainWidth = size * 0.7;
        const trainHeight = size * 0.45;
        // Train body (rounded rectangle)
        const bodyLeft = cx - trainWidth / 2;
        const bodyTop = cy - trainHeight / 2;
        // Main train body
        g.roundRect(bodyLeft, bodyTop, trainWidth, trainHeight, size * 0.12);
        g.fill(primaryColor);
        // Train front (locomotive nose)
        const noseWidth = trainWidth * 0.15;
        g.roundRect(bodyLeft + trainWidth - size * 0.02, bodyTop + trainHeight * 0.15, noseWidth, trainHeight * 0.7, size * 0.05);
        g.fill(primaryColor);
        // Windows (lighter area at top)
        const windowHeight = trainHeight * 0.35;
        const windowTop = bodyTop + trainHeight * 0.12;
        const windowMargin = trainWidth * 0.1;
        if (secondaryColor !== null) {
            // Double color: use secondary color for window area
            g.roundRect(bodyLeft + windowMargin, windowTop, trainWidth - 2 * windowMargin, windowHeight, size * 0.05);
            g.fill(secondaryColor);
        } else {
            // Single color: lighter windows
            g.roundRect(bodyLeft + windowMargin, windowTop, trainWidth - 2 * windowMargin, windowHeight, size * 0.05);
            g.fill($2e8e7818b49400c8$var$lightenColor(primaryColor, 0.4));
        }
        // Wheels
        const wheelRadius = size * 0.08;
        const wheelY = cy + trainHeight / 2 - wheelRadius * 0.3;
        g.circle(cx - trainWidth * 0.25, wheelY, wheelRadius);
        g.fill(0x333333);
        g.circle(cx + trainWidth * 0.1, wheelY, wheelRadius);
        g.fill(0x333333);
        g.circle(cx + trainWidth * 0.35, wheelY, wheelRadius);
        g.fill(0x333333);
        // Chimney/smokestack
        const chimneyWidth = size * 0.1;
        const chimneyHeight = size * 0.15;
        g.roundRect(cx - trainWidth * 0.15, bodyTop - chimneyHeight + size * 0.02, chimneyWidth, chimneyHeight, size * 0.02);
        g.fill($2e8e7818b49400c8$var$darkenColor(primaryColor, 0.2));
        // Draw pattern marker for higher color indices
        const pattern = (0, $5b55f105e5908397$export$c37ddd467bda1a75)(colorIndex);
        if (pattern !== 'solid') {
            const markerCx = cx - trainWidth * 0.05;
            const markerCy = cy + trainHeight * 0.05;
            drawPatternMarker(g, markerCx, markerCy, size * 0.2, pattern);
        }
    };
    const train = (colorIndex, colorList)=>{
        let { squareWidth: squareWidth } = layout;
        let g = new (0, $30d7d246c5e7cd93$exports).Graphics();
        const cx = squareWidth / 2;
        const cy = squareWidth / 2;
        const size = layout.roadWidth * 1.8;
        const primaryColor = (0, $5b55f105e5908397$export$1b0ed88187e4090f)(colorIndex, colorList);
        const secondaryColor = (0, $5b55f105e5908397$export$b71c93f469694483)(colorIndex, colorList);
        // Draw white outline/background
        g.circle(cx, cy, size / 2 + 3);
        g.fill(0xffffff);
        // Draw the train icon
        drawTrainIcon(g, cx, cy, size, primaryColor, secondaryColor, colorIndex);
        let h = new (0, $30d7d246c5e7cd93$exports).Container();
        h.addChild(g);
        if (showColorIndices) {
            let textContent = colorIndex.toString(16).toUpperCase();
            let j = text(textContent, squareWidth / 7);
            j.x += 0.53 * squareWidth - 0.06 * squareWidth * textContent.length;
            j.y += 0.42 * squareWidth;
            h.addChild(j);
        }
        return h;
    };
    const switchCircle = (g, circleColor)=>{
        g.clear();
        g.circle(layout.squareWidth / 2, layout.squareWidth / 2, layout.switchRadius);
        g.fill(theme.switchOutline);
        g.circle(layout.squareWidth / 2, layout.squareWidth / 2, layout.switchRadius - layout.switchOutlineWidth);
        g.fill(circleColor);
    };
    return {
        roadTurn: roadTurn,
        road: road,
        station: station,
        train: train,
        switchCircle: switchCircle
    };
}
// Helper function to darken a color
function $2e8e7818b49400c8$var$darkenColor(color, amount) {
    const r = Math.max(0, (color >> 16 & 0xff) * (1 - amount));
    const g = Math.max(0, (color >> 8 & 0xff) * (1 - amount));
    const b = Math.max(0, (color & 0xff) * (1 - amount));
    return Math.round(r) << 16 | Math.round(g) << 8 | Math.round(b);
}
// Helper function to lighten a color
function $2e8e7818b49400c8$var$lightenColor(color, amount) {
    const r = Math.min(255, (color >> 16 & 0xff) + (255 - (color >> 16 & 0xff)) * amount);
    const g = Math.min(255, (color >> 8 & 0xff) + (255 - (color >> 8 & 0xff)) * amount);
    const b = Math.min(255, (color & 0xff) + (255 - (color & 0xff)) * amount);
    return Math.round(r) << 16 | Math.round(g) << 8 | Math.round(b);
}





function $9263e1f9c327953f$export$912f7d81ef407298(config, level, grid) {
    let switchGrid = (0, $1b9c19121388f259$export$805779a38e4672f2)({
        width: config.gridWidth,
        height: config.gridHeight
    });
    const addColor = (dest)=>{
        let lastTile = dest;
        for(let k = 0, tile = (0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(dest, dest.entrance, grid); tile.type !== 'departure'; k++, lastTile = tile, tile = (0, $0b6d13e2cc0f6f62$export$e638f0174b6c6089)(tile, tile.entrance, grid)){
            if (tile.type === 'switch') {
                let smartSwitch = switchGrid[tile.y][tile.x] ?? {
                    ...tile,
                    colorIndexArray: [],
                    colorIndexOtherArray: []
                };
                switchGrid[tile.y][tile.x] = smartSwitch;
                if ((0, $d94f34763c85c462$export$2905201efabb3a51)(lastTile.entrance) === smartSwitch.exit) smartSwitch.colorIndexArray.push(dest.colorIndex);
                else if ((0, $d94f34763c85c462$export$2905201efabb3a51)(lastTile.entrance) === smartSwitch.otherExit) smartSwitch.colorIndexOtherArray.push(dest.colorIndex);
                else console.error('mismatch between track entraces and switch exits');
            }
            if (k > 999) {
                console.error('infite loop (>999) while trying to add smart switch color', dest);
                break;
            }
        }
    };
    level.destinationArray.forEach(addColor);
    return switchGrid;
}





function $b3f2fa3180e1dfe4$export$1f0c7cba16503310(param) {
    const { colorList: colorList, config: config, container: container, departure: departure, destinationArray: destinationArray, grid: grid, layout: layout, randomEngine: randomEngine, score: score, sketch: sketch, updateSwitchColor: updateSwitchColor, smartSwitchGrid: smartSwitchGrid, graphicalGrid: graphicalGrid, toggleSwitch: toggleSwitch, getTrainInterval: getTrainInterval } = param;
    let trainArray = [];
    let trainTime = 0;
    let spawningEnabled = true;
    const addTrain = ()=>{
        // Don't spawn new trains if spawning is disabled (timer ended)
        if (!spawningEnabled) return;
        // Spawn a new train when enough time has passed
        const trainPeriod = getTrainInterval();
        while(trainTime >= trainPeriod){
            trainTime -= trainPeriod;
            let train = $b3f2fa3180e1dfe4$export$119217a08ea4e5d8({
                autoPlayOnEntry: config.autoPlayOnEntry,
                autoPlayOnExit: config.autoPlayOnExit,
                colorIndex: (0, $0384f65d82dc5c27$exports).pick(randomEngine, destinationArray).colorIndex,
                colorList: colorList,
                gamePlay: config.gamePlay,
                graphicalGrid: graphicalGrid,
                grid: grid,
                layout: layout,
                position: departure,
                score: score,
                sketch: sketch,
                smartSwitchGrid: smartSwitchGrid,
                toggleSwitch: toggleSwitch,
                updateSwitchColor: updateSwitchColor
            });
            container.addChild(train.g);
            trainArray.push(train);
            train.progress += trainTime;
        }
    };
    return {
        update (timeStep) {
            trainTime += timeStep / 60;
            addTrain();
            // remove the trains which have reached a station
            trainArray = trainArray.filter((train)=>{
                if (!train.running) {
                    if (config.gamePlay === 'station') score.scoreEvent(train.colorMatchesStation());
                    container.removeChild(train.g);
                    train.g.destroy();
                    return false;
                }
                return true;
            });
            // update the trains
            trainArray.forEach((train)=>{
                train.update(timeStep);
            });
        },
        // Stop spawning new trains (called when timer ends)
        stopSpawning () {
            spawningEnabled = false;
        },
        // Check if all trains have finished (reached stations)
        allTrainsFinished () {
            return !spawningEnabled && trainArray.length === 0;
        },
        // Get count of remaining trains
        getRemainingTrainCount () {
            return trainArray.length;
        }
    };
}
function $b3f2fa3180e1dfe4$export$119217a08ea4e5d8(param) {
    let position = {
        ...param.position
    };
    let { autoPlayOnEntry: autoPlayOnEntry, autoPlayOnExit: autoPlayOnExit, colorIndex: colorIndex, colorList: colorList, gamePlay: gamePlay, graphicalGrid: graphicalGrid, grid: grid, layout: layout, score: score, sketch: sketch, smartSwitchGrid: smartSwitchGrid, toggleSwitch: toggleSwitch, updateSwitchColor: updateSwitchColor } = param;
    let g = sketch.train(colorIndex, colorList);
    const addTrainToSwitch = (tile, x, y)=>{
        tile.trainArray.push(me);
        updateSwitchColor(x, y);
    };
    const removeTrainFromSwitch = (tile, x, y)=>{
        tile.trainArray.splice(tile.trainArray.indexOf(me), 1);
        updateSwitchColor(x, y);
    };
    // Smooth easing function for more natural movement
    const easeInOutQuad = (t)=>{
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    };
    const update = (timeStep)=>{
        let { x: x, y: y } = position;
        let tile = grid[y][x];
        let tileIsSwitch = tile?.type === 'switch';
        const next = ()=>{
            if (!tile) throw new Error(`encountered a null entry in the grid, at ${y}:${x}`);
            if (tile.type === 'destination') throw new Error('never, destination');
            let { dx: dx, dy: dy } = (0, $d94f34763c85c462$export$73e05133afc82669)(tile.exit);
            position.x += dx;
            position.y += dy;
            ({ x: x, y: y } = position);
            tile = grid[y][x];
            tileIsSwitch = tile?.type === 'switch';
        };
        // Smoother movement with smaller time step divisor
        me.progress += timeStep / 90;
        if (me.progress > 1) {
            // Only auto-switch in autoPlay modes (not in normal station mode)
            if (autoPlayOnExit) setSwitch();
            if (tileIsSwitch) removeTrainFromSwitch(tile, x, y);
            while(me.progress > 1){
                next();
                me.progress -= 1;
            }
            if (tileIsSwitch) addTrainToSwitch(tile, x, y);
            if (autoPlayOnEntry) {
                // we've just arrived on the tile, so we aren't in a hurry to set it to
                // the right direction, so use the weak mode so that if there is already
                // a train on the switch, the switch won't be toggled.
                let weak = true;
                setSwitch(weak);
            }
        }
        if (tileIsSwitch) updateSwitchColor(x, y);
        updatePosition();
        if (grid[position.y][position.x]?.type === 'destination' && me.progress >= 0.5) me.running = false;
    };
    // in autoplay mode, toggle the switch if necessary for the train to reach its
    // destination
    const setSwitch = (weak = false)=>{
        let { x: x, y: y } = position;
        let tile = grid[y][x];
        if (tile?.type === 'switch') {
            if (weak && tile.trainArray.length > 1) return;
            let smartSwitch = smartSwitchGrid[y][x];
            let colorArray = tile.state === 'initial' ? smartSwitch.colorIndexArray : smartSwitch.colorIndexOtherArray;
            let changeSwitch = colorArray.includes(me.colorIndex);
            if (changeSwitch) {
                let g = graphicalGrid[y][x];
                toggleSwitch(g, tile);
            }
            return changeSwitch;
        }
    };
    // Helper to get rotation angle for a direction
    const directionToAngle = (dir)=>{
        switch(dir){
            case 'right':
                return 0;
            case 'bottom':
                return Math.PI / 2;
            case 'left':
                return Math.PI;
            case 'top':
                return -Math.PI / 2;
        }
    };
    const updatePosition = ()=>{
        let tile = grid[position.y][position.x];
        let entrance;
        let exit;
        if ((0, $ff5f9e9ea249a819$export$b04d5c035b174df8)(tile)) ({ entrance: entrance, exit: exit } = tile);
        else if (tile.type === 'departure') {
            ({ exit: exit } = tile);
            entrance = (0, $d94f34763c85c462$export$2905201efabb3a51)(exit);
        } else if (tile.type === 'destination') {
            ({ entrance: entrance } = tile);
            exit = (0, $d94f34763c85c462$export$2905201efabb3a51)(entrance);
        } else throw new Error('never');
        // Apply smooth easing to the progress for visual smoothness
        const smoothProgress = easeInOutQuad(me.progress);
        // Calculate base position (center of tile)
        let baseX = layout.squareWidth * position.x + layout.squareWidth / 2;
        let baseY = layout.squareWidth * position.y + layout.squareWidth / 2;
        // Calculate offset based on movement
        let offsetX = 0;
        let offsetY = 0;
        // Get start and end angles for rotation interpolation
        // The train enters from 'entrance' direction, so it's facing opposite of entrance
        const startAngle = directionToAngle((0, $d94f34763c85c462$export$2905201efabb3a51)(entrance));
        const endAngle = directionToAngle(exit);
        if ((0, $d94f34763c85c462$export$2965c0931506931a)(entrance, exit)) {
            if (exit === 'right') offsetX = (smoothProgress - 0.5) * layout.squareWidth;
            else if (exit === 'left') offsetX = (0.5 - smoothProgress) * layout.squareWidth;
            else if (exit === 'bottom') offsetY = (smoothProgress - 0.5) * layout.squareWidth;
            else if (exit === 'top') offsetY = (0.5 - smoothProgress) * layout.squareWidth;
            // For straight paths, rotation stays constant
            g.rotation = endAngle;
        } else {
            // Smoother curve movement using eased progress
            let from = (Math.sin(smoothProgress * Math.PI / 2) - 1) * layout.squareWidth / 2;
            let to = (Math.cos(smoothProgress * Math.PI / 2) - 1) * layout.squareWidth / 2;
            if (entrance === 'top') offsetY += from;
            if (entrance === 'left') offsetX += from;
            if (entrance === 'right') offsetX -= from;
            if (entrance === 'bottom') offsetY -= from;
            if (exit === 'top') offsetY += to;
            if (exit === 'left') offsetX += to;
            if (exit === 'right') offsetX -= to;
            if (exit === 'bottom') offsetY -= to;
            // For curves, smoothly interpolate the rotation
            // Need to handle angle wrapping (e.g., from PI to -PI/2)
            let angleDiff = endAngle - startAngle;
            // Normalize angle difference to [-PI, PI] for shortest path
            while(angleDiff > Math.PI)angleDiff -= 2 * Math.PI;
            while(angleDiff < -Math.PI)angleDiff += 2 * Math.PI;
            g.rotation = startAngle + angleDiff * smoothProgress;
        }
        // Set pivot to center for proper rotation
        g.pivot.set(layout.squareWidth / 2, layout.squareWidth / 2);
        // Apply final position
        g.x = baseX + offsetX;
        g.y = baseY + offsetY;
    };
    const colorMatchesStation = ()=>{
        let s = grid[position.y][position.x];
        if (!s || !(0, $ff5f9e9ea249a819$export$bd44396c5113d95)(s)) throw new Error('train is not at a station');
        return me.colorIndex === s.colorIndex;
    };
    let me = {
        g: g,
        running: true,
        progress: 0.5,
        colorIndex: colorIndex,
        update: update,
        colorMatchesStation: colorMatchesStation
    };
    update(0);
    return me;
}



// Cleanup function to destroy previous game
let $e46db5192eb49d53$var$cleanupCurrentGame = null;
function $e46db5192eb49d53$export$b4a118ab4fbc6f5e() {
    if ($e46db5192eb49d53$var$cleanupCurrentGame) {
        $e46db5192eb49d53$var$cleanupCurrentGame();
        $e46db5192eb49d53$var$cleanupCurrentGame = null;
    }
}
async function $e46db5192eb49d53$export$77de8d36f99a553b(config, onRestart, onMenu) {
    // Cleanup previous game if exists
    $e46db5192eb49d53$export$b4a118ab4fbc6f5e();
    const layout = (0, $f82b67f096a9a947$export$16ed0dd2ce1347c)(config.layout);
    console.info('layout', layout);
    document.body.classList.add('gamemode');
    const sketch = (0, $2e8e7818b49400c8$export$ec0f151edeb35b7a)(layout, config.theme, config.showColorIndices);
    const colorList = (0, $5b55f105e5908397$export$96196a8e448d793b)(config.colorList);
    const colorListBaseLength = colorList.length;
    if (colorList.length < config.stationCount) {
        const colorSet = new Set(colorList);
        (0, $5b55f105e5908397$export$b908c818a29fc662).forEach((color)=>{
            if (!colorSet.has(color)) {
                colorList.push(color);
                colorSet.add(color);
            }
        });
        console.warn("There's not enough colors in the list for the number of stations");
        if (colorList.length > colorListBaseLength) console.warn('Colors from the default set have been added');
    }
    const level = (0, $28384e0759aee39b$export$80d376111cc09ad7)({
        gridSize: {
            height: config.gridHeight,
            width: config.gridWidth
        },
        randomEngine: (0, $0384f65d82dc5c27$exports).MersenneTwister19937.seed(config.stationSeed),
        stationCount: config.stationCount,
        retryCount: config.generateRetryCount,
        departureClearance: config.departureClearance
    });
    console.info('level', level);
    console.info(`&seed=${config.seed}`);
    const grid = (0, $1b9c19121388f259$export$85a47b3ccce199ed)(level, {
        width: config.gridWidth,
        height: config.gridHeight
    });
    let gameOver = false;
    let timerEnded = false;
    let trainManager = null;
    const onGameEnd = ()=>{
        if (gameOver) return;
        gameOver = true;
        interativeGraphicalSwitchArray.forEach((g)=>{
            g.interactive = false;
            g.eventMode = 'none';
        });
        score.showScore(true);
    };
    // Called when timer reaches zero - stop spawning but don't end game yet
    const onTimerEnd = ()=>{
        if (timerEnded) return;
        timerEnded = true;
        if (trainManager) trainManager.stopSpawning();
        // Update score display to show waiting for trains
        score.showWaitingForTrains();
    };
    const score = (0, $d7c47304def68957$export$bfab3f324e8bcfbb)(document.body, layout, config.theme, config.timeLimit);
    // Set up timer callback
    score.setOnTimeUp(()=>{
        onTimerEnd();
    });
    const graphicalGrid = (0, $1b9c19121388f259$export$805779a38e4672f2)({
        width: config.gridWidth,
        height: config.gridHeight
    });
    const smartSwitchGrid = (0, $9263e1f9c327953f$export$912f7d81ef407298)(config, level, grid);
    let app = new (0, $30d7d246c5e7cd93$exports).Application();
    await app.init({
        antialias: true,
        resizeTo: window,
        background: config.theme.background
    });
    let canvas = app.view;
    setTimeout(()=>{
        canvas.classList.add('visible');
    });
    document.body.appendChild(canvas);
    let gameContainer = new (0, $30d7d246c5e7cd93$exports).Container();
    let railContainer = new (0, $30d7d246c5e7cd93$exports).Container();
    let trainContainer = new (0, $30d7d246c5e7cd93$exports).Container();
    let stationContainer = new (0, $30d7d246c5e7cd93$exports).Container();
    gameContainer.y += layout.scoreHeight + 6;
    const addPosition = (g, position)=>{
        g.x += layout.squareWidth * position.x;
        g.y += layout.squareWidth * position.y;
        return g;
    };
    // Draw Start
    let g = sketch.station(level.departure, 0, [
        config.theme.departure
    ]);
    addPosition(g, level.departure);
    stationContainer.addChild(g);
    graphicalGrid[level.departure.y][level.departure.x] = g;
    // Draw destination stations
    level.destinationArray.forEach((station, k)=>{
        let colorIndex = k;
        let g = sketch.station(station, colorIndex, colorList);
        addPosition(g, station);
        graphicalGrid[station.y][station.x] = g;
        stationContainer.addChild(g);
    });
    // Make switches interactive and draw tracks
    const drawTrack = (start, end)=>{
        if (start === end) throw new Error(`encountered equal start and end (${start})`);
        if ((0, $d94f34763c85c462$export$2965c0931506931a)(start, end)) {
            let result = sketch.road();
            if ([
                start,
                end
            ].includes('top')) {
                result.rotation = Math.PI / 2;
                result.x += layout.squareWidth;
            }
            return result;
        } else {
            let turn = sketch.roadTurn();
            let [c, d] = [
                start,
                end
            ].sort();
            if (c + d === 'righttop') {
                turn.rotation = Math.PI / 2;
                turn.x += layout.squareWidth;
            } else if (c + d === 'bottomright') {
                turn.rotation = Math.PI;
                turn.x += layout.squareWidth;
                turn.y += layout.squareWidth;
            } else if (c + d === 'bottomleft') {
                turn.rotation = -Math.PI / 2;
                turn.y += layout.squareWidth;
            }
            return turn;
        }
    };
    let drawSwitch = (track)=>{
        let result = new (0, $30d7d246c5e7cd93$exports).Container();
        result.addChild(drawTrack(track.entrance, track.otherExit));
        let g = new (0, $30d7d246c5e7cd93$exports).Graphics();
        sketch.switchCircle(g, config.theme.switch);
        result.addChild(g);
        result.addChild(drawTrack(track.entrance, track.exit));
        return result;
    };
    const toggleSwitch = (g, rail)=>{
        rail.state = rail.state === 'initial' ? 'swapped' : 'initial';
        [rail.exit, rail.otherExit] = [
            rail.otherExit,
            rail.exit
        ];
        let h = g;
        [h.children[0], h.children[2]] = [
            h.children[2],
            h.children[0]
        ];
        (0, $bf97b3c0e18cf780$export$8defdeb8759b748d).play();
    };
    const getSwitchColor = (0, $5b55f105e5908397$export$5931e35698b46017)(config.theme.switch, config.theme.switchWithTrain);
    const getSwitchHoverColor = (0, $5b55f105e5908397$export$5931e35698b46017)(config.theme.switchHover, config.theme.switchHoverWithTrain);
    const updateSwitchColor = (x, y)=>{
        let rail = grid[y][x];
        if (rail?.type !== 'switch') throw new Error('never, switch');
        let bestTrainProgress = rail.trainArray.reduce((best, train)=>{
            return Math.max(best, train.progress);
        }, 0);
        let color = (rail.mouseIsOver ? getSwitchHoverColor : getSwitchColor)(bestTrainProgress);
        let g = graphicalGrid[y][x];
        sketch.switchCircle(g?.children[1], color);
    };
    let interativeGraphicalSwitchArray = [];
    const makeSwitchInteractive = (g, rail)=>{
        g.interactive = true;
        g.eventMode = 'static' // PixiJS 8 requires eventMode
        ;
        interativeGraphicalSwitchArray.push(g);
        g.hitArea = new (0, $30d7d246c5e7cd93$exports).Circle(layout.squareWidth / 2, layout.squareWidth / 2, layout.squareWidth / 2);
        let toggle = ()=>{
            console.log('Switch toggled at', rail.x, rail.y);
            toggleSwitch(g, rail);
        };
        // Use only pointerdown to avoid double-toggle (pointerdown + pointertap both fire on click)
        g.on('pointerdown', toggle);
        g.on('pointerover', ()=>{
            canvas.style.cursor = 'pointer';
            rail.mouseIsOver = true;
            updateSwitchColor(rail.x, rail.y);
        });
        g.on('pointerout', ()=>{
            canvas.style.cursor = 'inherit';
            rail.mouseIsOver = false;
            updateSwitchColor(rail.x, rail.y);
        });
    };
    level.railArray.map((track)=>{
        let g;
        if (track.type === 'switch') {
            g = drawSwitch(track);
            makeSwitchInteractive(g, track);
        } else g = drawTrack(track.entrance, track.exit);
        addPosition(g, track);
        graphicalGrid[track.y][track.x] = g;
        railContainer.addChild(g);
    });
    // Manage the update speed
    let speedFactor = 1;
    window.addEventListener('keydown', (event)=>{
        if (event.key === ' ') speedFactor = 3;
    });
    window.addEventListener('keyup', (event)=>{
        if (event.key === ' ') speedFactor = 1;
    });
    app.stage.addChild(gameContainer);
    gameContainer.addChild(railContainer);
    gameContainer.addChild(trainContainer);
    gameContainer.addChild(stationContainer);
    // Default train interval in seconds (overridable by saved settings)
    const defaultTrainInterval = 3.0;
    const savedSettings = (0, $95c1e97c8d1548a3$export$54453bb1ffd2fd71)();
    let currentTrainInterval = savedSettings.trainInterval ?? defaultTrainInterval;
    // Assign to the trainManager variable declared earlier
    trainManager = (0, $b3f2fa3180e1dfe4$export$1f0c7cba16503310)({
        colorList: colorList,
        config: config,
        container: trainContainer,
        departure: level.departure,
        destinationArray: level.destinationArray,
        graphicalGrid: graphicalGrid,
        grid: grid,
        layout: layout,
        randomEngine: (0, $0384f65d82dc5c27$exports).MersenneTwister19937.seed(config.trainSeed),
        score: score,
        sketch: sketch,
        smartSwitchGrid: smartSwitchGrid,
        toggleSwitch: toggleSwitch,
        updateSwitchColor: updateSwitchColor,
        getTrainInterval: ()=>currentTrainInterval
    });
    // Create settings UI
    const settingsUI = (0, $95c1e97c8d1548a3$export$ebcadcac8f38e10f)(document.body, {
        onRestart: ()=>{
            if (onRestart) onRestart();
        },
        onMenu: ()=>{
            if (onMenu) onMenu();
        },
        onTrainIntervalChange: (interval)=>{
            currentTrainInterval = interval;
        }
    }, {
        trainInterval: currentTrainInterval,
        soundEnabled: true
    });
    // Start the game timer
    score.startTimer();
    let lastTime = Date.now();
    let animationId;
    const loop = ()=>{
        // Don't update if game is over
        if (gameOver) return;
        let elapsedTime = Date.now() - lastTime;
        lastTime += elapsedTime;
        // We limit the time value to avoid issues where the tab is no longer
        // visible and thus requestAnimationFrame stops firing, but performance.now()
        // keeps increasing
        let clampedTime = Math.min(1, elapsedTime / 20);
        trainManager.update(speedFactor * clampedTime);
        // Check if all trains have finished after timer ended
        if (timerEnded && trainManager.allTrainsFinished()) {
            onGameEnd();
            return;
        }
        // Update remaining train count display
        if (timerEnded) score.updateRemainingTrains(trainManager.getRemainingTrainCount());
        animationId = requestAnimationFrame(loop);
    };
    loop();
    // Set up cleanup function for this game instance
    $e46db5192eb49d53$var$cleanupCurrentGame = ()=>{
        gameOver = true;
        cancelAnimationFrame(animationId);
        score.stopTimer();
        settingsUI.destroy();
        app.destroy(true, {
            children: true,
            texture: true
        });
        canvas.remove();
        // Remove score elements
        document.querySelectorAll('body > span').forEach((el)=>el.remove());
        document.querySelectorAll('body > div:not(.levelSelectionDiv)').forEach((el)=>el.remove());
        document.body.classList.remove('gamemode');
    };
}





let $9b2e7c34f0903b4d$export$f892abe152aaa81d = (location)=>{
    let spaceLessURL = location.href.replace(/ |%20/g, '');
    if (location.href !== spaceLessURL) location.replace(spaceLessURL);
};
let $9b2e7c34f0903b4d$export$860e15e8501eb34 = (location, defaultConfig)=>{
    let infoObject = {
        ...defaultConfig
    };
    // populate config with keys and key-value pairs from the URL
    location.hash.split('#').slice(1).forEach((piece)=>{
        let key;
        let valueList;
        let value;
        if (piece.includes('=')) {
            [key, ...valueList] = piece.split('=');
            value = valueList.join('=');
            if (!isNaN(value)) value = +value;
        } else {
            key = piece;
            value = true;
        }
        infoObject[key] = [
            ()=>value,
            infoObject[key][1]
        ];
    });
    return (0, $6a503b568a4879f2$export$7cc549dee4733a24)(infoObject);
};
let $9b2e7c34f0903b4d$export$9a0601f225751ab3 = (location, defaultConfig)=>{
    let infoObject = {
        ...defaultConfig
    };
    let search = new URLSearchParams(location.search);
    [
        ...search.entries()
    ].forEach(([key, value])=>{
        if (!infoObject[key]) return;
        if (value === '') value = true;
        else if (!isNaN(value)) value = +value;
        infoObject[key] = [
            ()=>value,
            infoObject[key][1]
        ];
    });
    return (0, $6a503b568a4879f2$export$7cc549dee4733a24)(infoObject);
};


function $71d070514c30252e$export$d0a8044dce8ff2fc() {
    let check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}


function $ad2bcec7a0192558$var$randomSeed() {
    return Math.floor(Math.random() * 2 ** 32);
}
function $ad2bcec7a0192558$var$levelInfo(level, device) {
    level = Math.max(level, 3);
    let trainCount = 14 + 3 * level;
    let stationCount = level;
    let big = 8 + Math.max(0, Math.floor(+(level - 11) / 2));
    let small = 6;
    if (device === 'detect') device = (0, $71d070514c30252e$export$d0a8044dce8ff2fc)() ? 'phone' : 'desktop';
    if (device === 'phone') return {
        device: 'phone',
        gridHeight: big,
        gridWidth: small,
        trainCount: trainCount,
        stationCount: stationCount
    };
    return {
        device: 'desktop',
        gridHeight: small,
        gridWidth: big,
        trainCount: trainCount,
        stationCount: stationCount
    };
}
function $ad2bcec7a0192558$var$getConfig(location1) {
    return (0, $9b2e7c34f0903b4d$export$9a0601f225751ab3)(location1, {
        autoPlay: [
            ()=>false
        ],
        autoPlayOnEntry: [
            ({ autoPlay: autoPlay })=>autoPlay()
        ],
        autoPlayOnExit: [
            ({ autoPlay: autoPlay })=>autoPlay()
        ],
        colorList: [
            ()=>(0, $5b55f105e5908397$export$b0a42032b873dec8)((0, $5b55f105e5908397$export$b908c818a29fc662))
        ],
        departureClearance: [
            ()=>3
        ],
        device: [
            ()=>'detect'
        ],
        duration: [
            ()=>100
        ],
        gamePlay: [
            ()=>'station'
        ],
        generateRetryCount: [
            ()=>200000
        ],
        gridHeight: [
            ({ level: level, device: device })=>$ad2bcec7a0192558$var$levelInfo(level(), device()).gridHeight
        ],
        gridWidth: [
            ({ level: level, device: device })=>$ad2bcec7a0192558$var$levelInfo(level(), device()).gridWidth
        ],
        layout: [
            ({ device: device })=>(0, $f82b67f096a9a947$export$32990855c7ccb10d)($ad2bcec7a0192558$var$levelInfo(-1, device()).device === 'phone' ? (0, $f82b67f096a9a947$export$2cf2f492412181c4) : (0, $f82b67f096a9a947$export$2303d2bd9eeff99a))
        ],
        level: [
            ()=>0
        ],
        seed: [
            ()=>$ad2bcec7a0192558$var$randomSeed()
        ],
        stationSeed: [
            ({ seed: seed })=>seed()
        ],
        trainSeed: [
            ({ seed: seed })=>seed()
        ],
        showColorIndices: [
            ()=>false
        ],
        stationCount: [
            ({ level: level })=>$ad2bcec7a0192558$var$levelInfo(level(), '').stationCount
        ],
        theme: [
            ()=>(0, $5b55f105e5908397$export$91a2ac4f9fa96416)((0, $5b55f105e5908397$export$164de7ab8df77ef0)),
            (0, $5b55f105e5908397$export$7d9c4f234b98dca0)
        ],
        trainCount: [
            ({ level: level })=>$ad2bcec7a0192558$var$levelInfo(level(), '').trainCount
        ],
        timeLimit: [
            ()=>60
        ]
    });
}
// Store current level for restart
let $ad2bcec7a0192558$var$currentLevel = 0;
function $ad2bcec7a0192558$var$showLevelSelection() {
    // Cleanup any existing game
    (0, $e46db5192eb49d53$export$b4a118ab4fbc6f5e)();
    // Clear any remaining game elements
    document.querySelectorAll('body > canvas').forEach((el)=>el.remove());
    document.querySelectorAll('body > span').forEach((el)=>el.remove());
    document.querySelectorAll('body > div:not(.levelSelectionDiv)').forEach((el)=>el.remove());
    document.querySelectorAll('.settings-btn, .settings-panel').forEach((el)=>el.remove());
    document.body.classList.remove('gamemode');
    // Remove existing level selection if any
    document.querySelectorAll('.levelSelectionDiv').forEach((el)=>el.remove());
    let levelSelectionDiv = (0, $5110f33f67e7638b$export$185802fd694ee1f5)('div', {
        className: 'levelSelectionDiv'
    }, [
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('h1', {
            textContent: 'Train of Thought'
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('p', {
            textContent: 'Route trains to matching colored houses!',
            style: {
                textAlign: 'center',
                marginBottom: '20px',
                color: '#94a3b8'
            }
        }),
        (0, $5110f33f67e7638b$export$185802fd694ee1f5)('h2', {
            textContent: 'Select a level',
            style: {
                fontWeight: '400',
                fontSize: '1.5rem',
                textAlign: 'center',
                marginBottom: '20px'
            }
        })
    ]);
    document.body.appendChild(levelSelectionDiv);
    Array.from({
        length: 12
    }, (_, k)=>{
        let levelNumber = `${k + 3}`;
        levelSelectionDiv.appendChild((0, $5110f33f67e7638b$export$185802fd694ee1f5)('button', {
            textContent: levelNumber,
            className: 'levelSelectionButton',
            onclick: ()=>{
                levelSelectionDiv.style.opacity = '0%';
                // Use once option to prevent multiple triggers
                levelSelectionDiv.addEventListener('transitionend', ()=>{
                    levelSelectionDiv.remove();
                    $ad2bcec7a0192558$var$startGame(parseInt(levelNumber));
                }, {
                    once: true
                });
            }
        }));
    });
}
function $ad2bcec7a0192558$var$startGame(level) {
    $ad2bcec7a0192558$var$currentLevel = level;
    // Update URL
    let search = new URLSearchParams(location.search);
    search.set('level', String(level));
    // Generate new seed for each game
    search.set('seed', String(Math.floor(Math.random() * 2 ** 32)));
    history.pushState({}, '', '?' + search);
    const config = $ad2bcec7a0192558$var$getConfig(location);
    // Set up restart and menu callbacks
    const onRestart = ()=>{
        $ad2bcec7a0192558$var$startGame($ad2bcec7a0192558$var$currentLevel);
    };
    const onMenu = ()=>{
        // Clear URL level param
        let search = new URLSearchParams(location.search);
        search.delete('level');
        search.delete('seed');
        history.pushState({}, '', search.toString() ? '?' + search : location.pathname);
        $ad2bcec7a0192558$var$showLevelSelection();
    };
    (0, $e46db5192eb49d53$export$77de8d36f99a553b)(config, onRestart, onMenu);
}
function $ad2bcec7a0192558$var$main() {
    const config = $ad2bcec7a0192558$var$getConfig(location);
    console.info(`&seed=${config.seed}`);
    console.info('config', config);
    console.info('theme', config.theme);
    document.documentElement.style.backgroundColor = (0, $5b55f105e5908397$export$2fa8eca08cbceec1)(config.theme.background);
    if (config.level > 0) {
        $ad2bcec7a0192558$var$currentLevel = config.level;
        const onRestart = ()=>$ad2bcec7a0192558$var$startGame($ad2bcec7a0192558$var$currentLevel);
        const onMenu = ()=>{
            let search = new URLSearchParams(location.search);
            search.delete('level');
            search.delete('seed');
            history.pushState({}, '', search.toString() ? '?' + search : location.pathname);
            $ad2bcec7a0192558$var$showLevelSelection();
        };
        (0, $e46db5192eb49d53$export$77de8d36f99a553b)(config, onRestart, onMenu);
    } else $ad2bcec7a0192558$var$showLevelSelection();
}
$ad2bcec7a0192558$var$main();


//# sourceMappingURL=train.9747037c.js.map
